webpackJsonp([1],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	
	
	window.main = true;
	
	if (!window.prefetch) {
	    window.beacon('info', ['angular_bootstrap_start']);
	    angular.bootstrap(document.body, ['app']);
	    window.beacon('info', ['angular_bootstrap_end']);
	    __webpack_require__("./js/app.js");
	}

/***/ },

/***/ "./..":
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/index.js!./styles.less", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/index.js!./styles.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "./css/app.less":
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./css/app.less");
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/index.js!./app.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./css/app.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select>span{padding:7px 30px 7px 13px;background-position:right -7px top -1178px}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;line-height:1.2em}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#loginSection .wallet_vprop_img{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png\") 0 0 no-repeat;height:104px}#loginSection .inline-prop{font-size:.85em}#loginSection .trayInner{margin:0 0 25px;padding:0}#loginSection #forgotPasswordSection{margin:16px auto 19px;padding-bottom:5px}#loginSection .alpha{margin-top:0}#loginSection .pr{position:relative;padding-top:25px}#loginSection .pr.hasError{margin-top:0}#loginSection .loginBtn{margin-top:5px}#loginSection .msgPage{padding:15px 0 5px}#loginSection .row-fluid>.span10{float:right}.login.guestBtnOnTop #loginSection .pr{padding-top:0}.login .infoLoader{position:fixed;top:0;left:0;background:#fff;width:100%;height:100%}.login .infoLoader .logo_wrapper{position:relative;display:inline-block;width:100%;height:40px;margin:70px 0 30px}.login .infoLoader .logo_wrapper .partner_logo{position:absolute;left:50%;margin-left:-48px;width:97px;height:40px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2.png\");background-repeat:no-repeat;background-position:-10px -10px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.login .infoLoader .logo_wrapper .partner_logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2_2x.png\");background-size:119px 243px}}.onboardingSection .inline-prop{font-size:.85em;text-align:center;margin-top:10px}.onboardingSection .guestHeading{position:relative}.onboardingSection .orSeparator{height:auto;border-top:1px solid #ccc;text-align:center;margin:25px 0 5px}.onboardingSection .orSeparator .textInDivider{background-color:#fff;color:#6c7378;display:inline-block;padding:0 .5em;position:relative;top:-.7em}.noscript{margin:0;padding:30px;width:58%;border:3px solid red;position:absolute;top:95px;left:20%;display:block;z-index:1001;background:#fff;font-size:18px;text-align:center}.login .span14.trayInner{padding:20px 0 15px}.capeRedirect{height:300px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){#loginSection .wallet_vprop_img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v2_2x.png\");background-size:195px 104px}}@media (min-width:0) and (max-width:30em){#loginSection .pr{margin-top:0}#loginSection .trayInner{margin:0 0 20px}}.trayOpen #main{float:right;margin-right:-320px;width:100%;border-left:1px solid #ddd;min-height:500px}.trayOpen .maskMember .trayViewMask{width:100%;height:170%;position:absolute;top:-85px;left:-30px;z-index:6;cursor:pointer;background-color:#edf2f5;-webkit-opacity:.5;-moz-opacity:.5;opacity:.5;min-height:550px}.trayOpen .justMember,.trayOpen .paypalHeaderWrapper{opacity:.5}.trayOpen .reviewButton{display:none}.asideContent{overflow-y:auto;overflow-x:hidden}.sidebar{position:absolute;left:-351px;top:-80px;width:320px}.sidebar .asideContent{overflow-y:auto;overflow-x:hidden}@media (max-width:41.25em){.trayOpen #main{margin-right:-295px}.trayOpen .sidebar{left:-295px;top:-65px;width:295px}.trayOpen .minibrowser #main{min-height:535px;margin-right:-320px}.trayOpen .minibrowser .sidebar{left:-320px;top:-75px;width:320px}.trayOpen .maskMember .trayViewMask{top:-80px;left:0}}.sidePageOpen .outerWrapper.tokenization{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.sidePageOpen .spinner .spinWrap{left:150%}.sidePageOpen.sidepageAddCardOpen .outerWrapper.tokenization{-webkit-transform:translateY(-100%);transform:translateY(-100%)}.outerWrapper.tokenization{-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.outerWrapper.tokenization #sliding-area{overflow:visible}.header{border-bottom:1px solid #ddd}.tokenization .frontArrow{top:0;left:auto;right:0;width:10px;height:18px;background:none}.tokenization .frontArrow:before{content:\"\";width:10px;height:18px;display:inline-block;background-size:119px 209px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2.png\");background-repeat:no-repeat;background-position:-67px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.tokenization .frontArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2_2x.png\");background-size:119px 243px}}.tokenization .spinner .spinWrap{position:fixed}.tokenization:not(.topup) .footer{display:none}.tokenization .aside .leftIcon{position:absolute;top:17px;left:25px;width:12px;height:22px;padding:5px;border-radius:3px}.tokenization .aside .leftIcon:before{position:absolute;content:\"\";width:12px;height:22px;display:inline-block;background-size:119px 209px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2.png\");background-repeat:no-repeat;background-position:-66px -123px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.tokenization .aside .leftIcon:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2_2x.png\");background-size:119px 243px}}.tokenization .aside .primaryHeader .rightIcon{position:absolute;top:16px;right:25px;width:24px;height:24px;padding:5px;border-radius:3px}.tokenization .aside .primaryHeader .rightIcon:before{content:\"\";position:absolute;display:inline-block;width:24px;height:24px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2.png\");background-repeat:no-repeat;background-position:-65px -152px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.tokenization .aside .primaryHeader .rightIcon:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2_2x.png\");background-size:119px 243px}}.sidepage{position:fixed;top:0;left:100%;width:100%;height:100vh;background:#fff;display:flex;flex-direction:column}.sidepage.noSlide{left:0;overflow:auto}.sidepage.noSlide .content{padding:5px 15px}.sidepage.noSlide #addBillingAddress{overflow:auto}.sidepage.noSlide #proceedButton{margin-bottom:60px}.sidepage .content{padding:20px 30px;flex:1 1 auto}.sidepage .aside .header{padding:20px 30px}.sidepage #sidepageAddCard{position:absolute;top:0;background-color:#fff;min-height:100%;width:100%;-webkit-transform:translateY(100%);transform:translateY(100%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.sidepage #sidepageAddCard.noSlide{-webkit-transform:translateY(0);transform:translateY(0)}.sidepage #sidepageAddCard.slideLeft{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.sidepage #sidepageAddCard .content{padding:5px 15px}.sidepage #sidepageAddCard .dropdown.billingAddress{margin-bottom:20px}.sidepage #sidepageAddCard #proceedButton{float:none}.sidepage #sidepageAddCard .linkButton{margin-top:25px;text-align:center}.sidepage #sidepageAddCard #addBillingAddress{position:fixed;top:0;left:0;background:#fff;width:100vw;height:100vh;transform:translateX(100%)}.sidepage #sidepageAddCard #addBillingAddress .container{padding:20px 30px}.sidepage #sidepageAddCard #addBillingAddress .container #proceedButton{width:100%}.sidepage #sidepageAddCard #addBillingAddress .leftIcon{position:absolute;top:17px;left:25px;width:12px;height:22px;padding:5px;border-radius:3px}.sidepage #sidepageAddCard #addBillingAddress .leftIcon:before{position:absolute;content:\"\";width:12px;height:22px;display:inline-block;background-size:119px 209px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2.png\");background-repeat:no-repeat;background-position:-66px -123px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.sidepage #sidepageAddCard #addBillingAddress .leftIcon:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2_2x.png\");background-size:119px 243px}}.sidepage #sidepageAddCard.sidepageAddCardOpen{-webkit-transform:translateY(0);transform:translateY(0)}.sidepage #sidepageAddCard.sidepageAddCardOpen.slideLeft{-webkit-transform:translateX(-100%);transform:translateX(-100%)}@media (max-width:41.25em){.tokenization.topup .footer{margin:2px auto;border-top:none;padding:5px 30px}.tokenization.topup .footer .cancelUrl{display:none}}#fundingInstrumentList.fundingInstrumentList{width:100%;top:0;left:0;position:relative;z-index:1;background:#fff;border-bottom:1px solid #999}#fundingInstrumentList.fundingInstrumentList ul{margin:0;list-style-type:none;overflow:hidden}#fundingInstrumentList.fundingInstrumentList ul li{position:relative;width:50%;height:90px;float:left;color:#fff;background:#008bdf;cursor:pointer;text-align:center}#fundingInstrumentList.fundingInstrumentList ul li .icon{width:30px;height:25px;margin:0 auto;padding:0;vertical-align:middle;text-align:center}#fundingInstrumentList.fundingInstrumentList ul li .description,#fundingInstrumentList.fundingInstrumentList ul li .icon{display:block}#fundingInstrumentList.fundingInstrumentList ul li .description{margin-top:7px;vertical-align:middle}#fundingInstrumentList.fundingInstrumentList ul li.bank .icon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_icon_addFI_white_2x.png\") 0 -49px no-repeat;background-size:29px}#fundingInstrumentList.fundingInstrumentList ul li.cards .icon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_icon_addFI_white_2x.png\") 0 5px no-repeat;background-size:29px}#fundingInstrumentList.fundingInstrumentList ul li:hover{background:#0079c1;color:#fff}#fundingInstrumentList.fundingInstrumentList ul li a{position:relative;display:inline-block;width:100%;height:100%;-ms-box-sizing:border-box;box-sizing:border-box;padding:10px 15px;color:#fff;text-decoration:none}li.fundingsource{overflow:hidden}.allFundingInstrumentsList{margin:0;padding:0}.allFundingInstrumentsList li{width:99.8%;list-style:none;margin:0;padding:0;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out;border-bottom:1px solid #e3e3e3}.allFundingInstrumentsList li a:hover{background-color:#f7f9fa}.allFundingInstrumentsList li a.source{display:block;min-height:70px;padding:0;position:relative;text-decoration:none;color:#000;border:2px solid transparent}.allFundingInstrumentsList li a.source:focus{border:2px solid #009cde}.allFundingInstrumentsList li div.source{display:block;min-height:70px;padding:0;position:relative;text-decoration:none;color:#000}.allFundingInstrumentsList li div.source:focus{border:2px solid #009cde}.allFundingInstrumentsList li .fsIcon{margin:18px 10px 0 15px;top:0;left:0}.allFundingInstrumentsList li .fsIcon.pinlessIcon{left:-10px}.allFundingInstrumentsList li .fsdetails{width:210px;overflow:hidden;text-overflow:ellipsis;margin:0;padding:15px 0 0;position:relative}.allFundingInstrumentsList li .fsdetails span{display:block;margin-bottom:1px;text-overflow:ellipsis;overflow:hidden}.allFundingInstrumentsList li .fsdetails span.amount,.allFundingInstrumentsList li .fsdetails span.lastdigits{color:#6c7378;font-size:.85em}.allFundingInstrumentsList li .fsdetails span.subtype{display:inline;color:#2c2e2f}.allPlanList,.allPlanList li{margin:0;padding:0}.allPlanList li{width:99.8%;list-style:none;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}.allPlanList li.plusLink{border-bottom:0}.allPlanList li.plusLink a:hover{background-color:transparent}.allPlanList li a:hover{background-color:#f7f9fa}.allPlanList li a.source{display:block;min-height:70px;padding:3px 0;position:relative;text-decoration:none;color:#000;border:2px solid transparent}.allPlanList li a.source:focus{border:2px solid #009cde}.allPlanList li div.source{display:block;min-height:70px;padding:0;position:relative;text-decoration:none;color:#000}.allPlanList li div.source:focus{border:2px solid #009cde}.allPlanList li .fsIcon{margin:0 3px 0 0;top:0;left:-2px}.allPlanList li .fsIcon.pinlessIcon{left:-10px;top:-7px;margin-left:-10px;margin-top:-5px;margin-right:10px}.allPlanList li .fsdetails{width:230px;overflow:hidden;text-overflow:ellipsis;margin:0;padding:0 3px;position:relative;font-size:15px;display:block}.allPlanList li .fsdetails span.amount{font-weight:500}.instrumentContainer{margin:15px 0 15px 10px}.singleInstrumentContainer{padding-top:9px}.disallowedContainer{margin:10px 0 10px 10px;padding-top:8px;opacity:.5}.bmlDetailsWalletTerms{margin-top:-20px}.fundingOverlay{width:100%;display:block;z-index:3;position:absolute;left:0;top:64px;bottom:0;border-radius:0 0 5px 5px;background-clip:padding-box}.disabledCardOpacity{opacity:.6;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=60)\"}.disabledCardOpacity.balance{opacity:1;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\"}.disabledReasonContainer{-webkit-transition:all 1s ease-in-out;transition:all 1s ease-in-out}.disabledMessage{width:50%;opacity:1;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";transition:opacity .8s linear;-webkit-transition:opacity .8s linear;-webkit-backface-visibility:hidden}.disabledReason{float:right;display:inline-block;position:absolute;bottom:50px;width:80%;word-wrap:break-word;padding-bottom:9px;font-size:.85em}.expiredMsg{color:red;display:inline-block;position:relative;top:5px;padding-left:6px}.expired{border:1px solid #de746a}.checkIcon{width:24px;height:17px;display:inline-block;position:absolute;top:24px;right:17px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-192px -2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoMsg{max-height:0;padding:0 10px}.showMsg .infoMsg{-webkit-transition:all .5s ease;transition:all .5s ease;max-height:100px;margin:10px 0;width:80%}@media (min-width:0) and (max-width:30em){.allFundingInstrumentsList li .fsdetails,.allPlanList li .fsdetails{width:200px}}.subHeader .leftIcon{display:inline-block;float:left;width:10px;height:10px;margin:4px 6px 0 0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-180px -180px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.subHeader .leftIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.subHeader .leftIcon:focus,.subHeader .leftIcon:hover{background-position:-180px -200px}.subHeader .rightIcon{float:right;width:6px;height:10px;margin:4px 0 0 6px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-200px -180px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.subHeader .rightIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.subHeader .rightIcon:focus,.subHeader .rightIcon:hover{background-position:-200px -200px}.review{min-height:250px}.review .textLink{font-weight:700}.review .paypalPoliciesLink{color:#2c2e2f}.review .paypalPoliciesLink.disclaimer{font-size:.85em}.review .selectedCreditDesc{margin:2px 0 0;font-weight:400;font-size:.85em;line-height:1.35em}.review .span10{margin-left:4%}.review .editable{cursor:pointer}.review .unconfirmedUpopMsg{color:#6c7378;font-size:.85em;line-height:1.35em}.review .redeemGC{margin-top:10px;font-size:.85em}.review .userEmail{margin-top:15px;padding-bottom:15px;font-size:.85em}.review .span14.trayInner{padding:0 0 15px}.review .reviewButton{margin-bottom:2px}.review .reviewLaterContainer{margin:10px 0 0}.review .topupMsg{padding-bottom:30px;margin-top:20px}.review .reviews{padding:10px 0;border-top:1px solid #e3e3e3}.review .reviews:first-child{padding-top:0;border-top:0}.review .reviews .msg-info{background-color:transparent;border:none}.review .reviews .msg-info ul li{background-color:transparent;color:#6c7378}.review .reviews .msg-info .icon{background-position:-139px -1px}.review .reviews .focusable{margin:-10px;padding:10px}.review .reviews .focusable:focus{outline:2px solid #009cde}.review .authUserNotify{margin:10px 0 10px 35px;font-size:.65em}.review .authUserContent{line-height:1.254em;margin-bottom:15px;font-size:.85em}.review .authUserContent+.authUserContent{margin-bottom:0}.review #authMsg .buttons{margin-top:0}.review .bmlPopupOpen .bmlPopup{margin-left:0}.review .bmlCtaWrap{padding:15px;margin-bottom:25px;background-color:#f7f9fa;position:relative;border-radius:5px;background-clip:padding-box}.review .bmlCtaWrap p{width:80%;margin-bottom:5px}.review .bmlCtaWrap .bmlApplyLink{cursor:pointer;position:absolute;top:0;right:0;font-size:.85em}.review .bmlCtaWrap .bmlSeeTerms{width:80%;color:#6c7378;margin-bottom:0}.review .bmlCtaWrap .bmlSeeTerms .seeTermsLink{display:inline-block;margin-top:10px}.review .bmlCtaWrap .trayInner{position:relative;margin:0;padding:0;background-color:transparent}.review .bmlCtaWrap .headerText{margin-left:35px}.review .bmlCtaWrap .plccAddNowLink{cursor:pointer;position:absolute;top:0;right:0;font-size:.85em}.review .bmlCtaWrap .plccOfferDesc{font-size:.68em;color:#6c7378;margin-left:35px}.review .bmlCtaWrap .fsIcon{float:left;position:inherit}.review .rtrWrap{padding:15px;margin-bottom:25px;background-color:#f7f9fa;position:relative;border-radius:5px;background-clip:padding-box;font-size:.87em;line-height:1.15em;color:#6c7378}.review .frame{position:fixed;left:0;bottom:0;width:100%;background-color:#fff}.review .frameborder{width:100%;margin:0;border:0;height:3px;background:-webkit-linear-gradient(#fff,#dbdbdb);background:linear-gradient(#fff,#dbdbdb);background:-webkit-gradient(linear,top,bottom,#fff,#dbdbdb);background:-ms-linear-gradient(top,#fff,#dbdbdb)}.review .fixed{padding:10px 0;margin:0 20px}.review .disclaimer a{font-weight:700}.review #creditExampleUK{margin-top:10px;border-top:1px solid #e3e3e3}.review .representativeEx td,.review .representativeEx th{border:0}.review .representativeEx td{padding:.1em}.review .preferredLabel{color:#6c7378;font-size:.85em;line-height:1em}#memberReview .reviews .trayInner{padding:10px 0}#memberReview .reviews .edits{font-size:.85em;padding:7px 10px 4px;position:absolute;top:4px;right:0;color:#0070ba;cursor:pointer}#memberReview .reviews .creditEdit{top:-7px}#memberReview #installmentPlanInfo{position:relative}#memberReview .adr{margin:2px 0 0;font-weight:400;width:85%;line-height:1.35em}#memberReview .billingAddressConsent p{margin-bottom:0}#memberReview .emailOptin{width:100%;border:1px solid #ccc;border-radius:5px;position:relative;padding:20px 15px;box-sizing:border-box;margin-top:35px;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;letter-spacing:.2px}#memberReview .emailOptin span.optinFloatingName{position:absolute;top:-11px;font-size:13px;color:#2c2e2f;background-color:#fff;padding:0 5px;left:10px}#memberReview .emailOptin label{line-height:1.5;font-size:11px;color:#6c7378}#memberReview #pay-with-credit .trayInner .decreasedWidth{width:80%}#memberReview #pay-with-credit .trayInner .decreasedWidth p{width:100%}.reviewTopup{display:flex;flex-direction:column}.topupError{padding:15px 0;color:#c72e2e}.topupErrorIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat;background-size:21px;width:21px;height:21px;top:5px;display:inline-block;position:relative}.fillflex{flex:1 1 auto}@media (min-width:0) and (max-width:30em){#memberReview .edits,#shippingAddress .edits{right:0}}#bmlHardDeclineModal,#bmlSuccessModal{display:none}.bmlModal{overflow:hidden}.bmlModal h2{margin:0 0 1em}.bmlModal .modal-wrap,.bmlModalDialog .modal-wrap{z-index:150;border-radius:5px;background-clip:padding-box;display:block;height:auto;padding:30px;position:absolute;left:50%;top:45%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:360px}.bmlModal .modal-wrap #decline-modal-title,.bmlModalDialog .modal-wrap #decline-modal-title{line-height:1.154em;margin-bottom:20px}.bmlModal .modal-wrap .alpha,.bmlModalDialog .modal-wrap .alpha{margin-top:0}.bmlModal .modal-wrap #cancelContinue,.bmlModalDialog .modal-wrap #cancelContinue{display:block}.bmlModal .chkbx,.bmlModalDialog .chkbx,.bmlModalDialog h2,.bmlModalDialog p,.bmlModal h2,.bmlModal p{margin-bottom:20px}.bmlModal .chkbxLabel,.bmlModalDialog .chkbxLabel{-ms-box-sizing:border-box;box-sizing:border-box;display:inline-block;margin-top:1em}.bmlModal .chkbx,.bmlModalDialog .chkbx{vertical-align:top;width:6%}.bmlModal .chkbxLabel,.bmlModalDialog .chkbxLabel{width:92%}.bmlModal .checkbox .chkbxLabel,.bmlModalDialog .checkbox .chkbxLabel{height:auto;margin-bottom:1em;margin-top:0}.bmlModal .close,.bmlModalDialog .close{-webkit-tap-highlight-color:rgba(0,0,0,.2);-webkit-appearance:none;background:transparent url(\"https://www.paypalobjects.com/webstatic/checkout/hermes/flat/hermes_window_sprite_v5_2x.png\") no-repeat 100% 0;background-repeat:no-repeat;background-size:250px 215px;background-position:-218px 0;border:0;cursor:pointer;height:22px;padding:0;position:absolute;right:15px;top:17px;text-indent:-999em;width:25px}.bmlModal .cancelUrl,.bmlModalDialog .cancelUrl{width:100%}@media (max-width:41.25em) and (min-width:0){.bmlModal .modal-wrap,.bmlModalDialog .modal-wrap{padding:20px;width:80%;margin:0}}.modal-open #main,.modal-open.largeScreen #wrapper{position:static}.incontext .modal-open .outerWrapper,.minibrowser .modal-open .outerWrapper{position:relative}.incontext .modal-open .bmlModal,.minibrowser .modal-open .bmlModal{background-color:hsla(0,0%,100%,.85);border-radius:0 0 6px 6px;background-clip:padding-box;position:absolute}.incontext .modal-open .modal-backdrop,.minibrowser .modal-open .modal-backdrop{display:none}.button-spacing{margin-bottom:12px}.merchantMsg{margin-top:10px;word-wrap:break-word;padding-bottom:10px}.messengerBAHeader{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter}.messengerBAPlugin{border-top:1px solid #e3e3e3}.messengerBAPlugin .paymentsHeader{padding-top:10px}.messengerBANotnow{text-align:center;padding:10px}.messengerLegalTxt{font-size:11px;line-height:1.3em;color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;padding-left:12px;padding-bottom:10px}#banner-switch{position:absolute;right:0;top:0;padding-top:20px;margin-right:5px}.oneTouchBanner{position:relative;border-top:1px solid #e3e3e3;border-bottom:1px solid #e3e3e3;font-family:HelveticaNeue;font-size:13px;font-weight:400;font-style:normal;font-stretch:normal;text-align:left;color:#2c2e2f}.oneTouchBanner p{margin-bottom:0}@keyframes leave{0%{opacity:1}to{opacity:0}}.leave_animation{overflow:visible;animation:leave 1.5s linear;-moz-animation:leave 1.5s linear;-webkit-animation:leave 1.5s linear;-o-animation:leave 1.5s linear;-ms-animation:leave 1.5s linear}.oneTouchTerms{margin-bottom:1em;margin-right:75px;min-height:15px;font-family:HelveticaNeue;font-weight:400;font-style:normal;font-stretch:normal;text-align:left}.oneTouchTerms .oneTouchTermsText{padding-top:15px}.oneTouchTerms .bold{font-weight:700}.oneTouchTerms .enable_auto_login{margin-top:15px}.oneTouchTerms .securityInfo{font-size:11px;line-height:1.36;color:#6c7378}.oneTouchTerms .securityInfo a{font-weight:700;color:#0070ba}.oneTouchTerms .expanded{margin-bottom:1em;font-size:13px;line-height:1.38;color:#2c2e2f}.oneTouchTerms .expanded br{margin:35px 0;line-height:35px}.highlight_bar{position:absolute;height:100%;width:4px;background-color:#00cf92}@media screen and (min-width:661px){.highlight_bar{margin-left:-30px}}@media screen and (max-width:660px){.highlight_bar{margin-left:-20px}}#addCard .firstname{float:left;width:48.15%;padding:0}#addCard .lastname{float:right;width:48.15%;padding:0}#addCard .replaced{position:relative;z-index:8;width:100%;height:44px;border:0;line-height:2}#addCard #billingAddress{clear:both;width:100%;margin-top:8px}#addCard .dropdown .billingAddress{margin:5px 0 10px}#addCard .addNewBillingAddress{float:right}#addCard #proceedButton.full{float:none}#addCard .linkButton{margin-top:25px;text-align:center}@media (-ms-high-contrast:none),(screen\\0),screen and (-ms-high-contrast:active){#shippingAddressForm .inputField.noFloatingLabel label{pointer-events:auto}}section#addCard h1{margin-bottom:0}section#addCard .prop-img{height:92px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#addCard .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags_2x.png\");background-size:206px 92px}}.addNewBillingAddress{float:right}#billingAddressUpdatedMsg #notifications{padding:0;width:100%;box-sizing:border-box;margin:0 0 5px;line-height:1.3em}.userEmail{margin:15px 0 0;font-size:.85em}.addressLabel{display:none}@media (min-width:0) and (max-width:30em){section#addCard #notifications,section#updateCard #notifications{margin-top:10px}}#addPhone .phoneTypeContainer{width:34%;padding-right:10px;float:left;-ms-box-sizing:border-box;box-sizing:border-box}#addPhone .telephoneField{width:62%;padding:0;float:right}#addPhone .countryCodeSelect .phoneTypeContainer{width:50%;padding:0 10px 10px 0;float:left;-ms-box-sizing:border-box;box-sizing:border-box}#addPhone .countryCodeSelect .phoneCodeContainer{width:50%;float:right}#addPhone .countryCodeSelect .telephoneField{width:100%;padding:0;float:right}.addFi .form-tabs{color:#6c7378;margin:auto 0 10px;list-style:none;border-bottom:1px solid #dbdbdb}.addFi .form-tabs>li{width:49%;text-align:center;display:inline-block;margin-right:0}.addFi .form-tabs>li.bankTab{cursor:pointer}.addFi .form-tabs>li.cardTab{float:right;cursor:pointer}.addFi .form-tabs>li{padding:0;font-weight:700;cursor:pointer}.addFi .form-tabs>li:focus,.addFi .form-tabs>li:hover{border-color:#ccc #ccc #ddd}.addFi .form-tabs>li a{display:inline-block;width:100%;line-height:40px;color:#666;text-decoration:none}.addFi .form-tabs>li.active{cursor:default;color:#fff;margin-right:0;border-bottom:2px solid #009cde}.addFi .form-tabs>li.active a{color:#2c2e2f}.addFi .container{padding:10px 0}.addFi .fieldLegend{margin-bottom:4px;padding-bottom:0;font-size:inherit}.addFi .inputField input[readonly=readonly],.addFi input[readonly=readonly]{background:#f5f5f5;color:#a8a8a8}.addFi .billingAddress{clear:both;margin:10px 0 15px}.addFi #sepaMandate .btn-secondary{display:none}.addFi .addressLabel{display:block;margin:10px 0}.pageSepaMandate .span14{width:100%}.pageSepaMandate .span10{display:none}#soldOut{width:50%;min-width:320px}#soldOut,#soldOut #soldouticon{text-align:center;margin:0 auto;position:relative}#soldOut #soldouticon{display:inline-block;margin-top:47%}#soldOut .left_section{width:40px;height:44px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v14.png\");background-position:-160px -252px;background-repeat:no-repeat;background-color:#fff;float:left}#soldOut .text_lines{float:left;border-top:2px solid #c72e2e;border-bottom:2px solid #c72e2e;box-sizing:border-box;line-height:39px}#soldOut #text{font-family:HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:18px;color:#c72f2e;white-space:nowrap}#soldOut #rightSection{float:left}#soldOut .shape-right{display:inline-block;width:14px;height:45px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v14.png\");background-position:-187px -306px;background-repeat:no-repeat;background-color:#fff}#soldOut .soldOutMessage{width:343px;height:auto;font-family:HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:24px;color:#2c2e2f;line-height:normal;margin-top:20px;float:left;max-width:290px;margin-left:10%;overflow-wrap:break-word}#soldOut #Continue-Shopping{margin-top:60px;margin-bottom:150px;max-width:345px}#soldOut #Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}@media (min-width:0) and (max-width:21em){#soldOut #soldouticon{margin-right:10%}#soldOut .left_section{margin-left:inherit}#soldOut .soldOutMessage{margin-left:0;margin-bottom:30px;max-width:280px}#soldOut #Continue-Shopping{margin:40px 10% 40px 0;max-width:280px}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}@media (min-width:21em) and (max-width:23.438em){#soldOut .left_section{margin-left:inherit}#soldOut #Continue-Shopping{margin:40px 10%;max-width:280px}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#soldOut .soldOutMessage{margin:20px 10% 30px;max-width:280px}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}@media (min-width:23.438em) and (max-width:27.188em){#soldOut .left_section{margin-left:inherit}#soldOut #Continue-Shopping{margin:40px 5%;max-width:280px}#Continue-Shopping:focus,#soldOut #Continue-Shopping:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#soldOut .soldOutMessage{margin:20px 5% 30px;max-width:280px}.footer{margin-top:25%}.props,header{display:BLOCK;transform:translateY(25%)}}#xoSelectFi .paymentsHeader{margin-top:0}#xoSelectFi .reviewButton{margin-top:10px}#xoSelectFi .reviews_first{padding-top:0;border-top:0}#xoSelectFi .reviews .trayInner:first-child{padding-top:10px}#shippingAddress{position:relative}#shippingAddress:focus{outline:0}#shippingAddress .editable{cursor:pointer}#shippingAddress .addressDisplay{margin-top:10px;word-wrap:break-word;line-height:1.2em}#shippingAddress .addressDisplay .check{padding-left:20px;background:url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet.png) no-repeat 0 2px}#shippingAddress .changeShipping{cursor:pointer}#shippingAddress .frontArrow{top:8px;right:0}#shippingAddress .frontArrow.disabled,#shippingAddress .frontArrow.disabled:focus,#shippingAddress .frontArrow.disabled:hover{background-position:-161px -177px}#shippingAddress .edits{padding:7px 10px 4px;position:absolute;top:4px;right:0;color:#0070ba}#shippingAddress .edits.disabled,#shippingAddress .edits.disabled:focus,#shippingAddress .edits.disabled:hover{color:#6c7378;text-decoration:none}#shippingAddress .edits:focus,#shippingAddress .edits:hover{text-decoration:underline;color:#005ea6}#shippingAddress .merchantReq{margin-top:3px;color:#6c7378;font-size:.85em;width:90%;line-height:1.3em;display:block}.reviewPreferredShipping{margin:5px 0 15px}[dir=rtl] .paywith .charges li.fsicon-margin{margin-left:0;margin-right:42px}.paywith #paymentMethod{position:relative}.paywith #paymentMethod:focus{outline:0}.paywith .charges{display:table;width:100%;margin:10px 0 0}.paywith .charges a#msbToolTipClose,.paywith .charges a.msbDetails{cursor:pointer}.paywith .charges li{list-style:none;margin-bottom:7px}.paywith .charges li .disclaimer{display:inline-block;padding-left:41px}.paywith .charges li.backupFunding{margin-bottom:7px;margin-top:-1em;font-size:.85em;line-height:1em;color:#6c7378;padding-left:43px}.paywith .charges li.fsicon-margin{margin-left:42px}.paywith .charges li.fsicon-margin>.disclaimer{display:block;padding-top:5px}.paywith .charges li.nbr-line{font-size:.85em;line-height:1em}.paywith .charges li.nbr-line .currencyCode{font-size:.85em}.paywith .charges li.reviewEnterCvvContainer{margin-bottom:0;cursor:auto;padding-bottom:20px;padding-top:15px}.paywith .charges li.reviewEnterCvvContainer .reviewEnterCvv{float:right;width:calc(100% - 42px);border-top:1px solid #e3e3e3;border-bottom:1px solid #e3e3e3;padding-top:10px;padding-bottom:10px;text-align:right}.paywith .charges li.reviewEnterCvvContainer .reviewEnterCvv .enterCvvPrompt{font-size:.85em;display:inline-block;width:calc(100% - 132px);vertical-align:middle}.paywith .charges li.reviewEnterCvvContainer .reviewEnterCvv .xo-cvv-wrapper{display:inline-block;width:125px;margin-left:2px;vertical-align:middle}.paywith .charges li.reviewEnterCvvContainer .reviewEnterCvv .xo-cvv-wrapper .cvvField .cvvSecurityCode input,.paywith .charges li:last-child{margin-bottom:0}.paywith .methodAmount{float:right;margin-bottom:-1em}.paywith .methodAmount .currencyCode{font-size:.75em;display:block;text-align:right;line-height:1.4em;color:#6c7378;margin-top:0}.paywith .AMEX .name{margin-left:-10px}.paywith .method{text-overflow:ellipsis;width:75%;float:left;line-height:1.25em}.paywith .method .name{display:inline-block;vertical-align:top;width:73%;margin-bottom:10px}.paywith .method .name .txt,.paywith .method .name a{vertical-align:inherit}.paywith .method .name .txt{font-size:.85em;white-space:nowrap}.paywith .method .fsname,.paywith .method .fsNamePinlessDebit{vertical-align:top;overflow:hidden;text-overflow:ellipsis;max-width:54%;display:inline-block;white-space:nowrap}.paywith .method .fslastdigits,.paywith .method .fsLastDigitsPinlessDebit{vertical-align:top;white-space:nowrap}.paywith .method.DELAYED_TRANSFER .fsname{max-width:54%}.paywith .method.DELAYED_TRANSFER .fsname.DE{max-width:34%}.paywith .method.check{padding-left:20px;background:url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet.png) no-repeat 0 2px}.paywith .method.pad{display:inline-block;max-width:72%}.paywith .method #padHelp{font-weight:700}.paywith .installments .method{width:56%}.paywith .frontArrow{top:8px;right:0}.paywith #paymentMethod .edits{padding:7px 10px 4px;position:absolute;top:3px;right:0;color:#0070ba}.paywith #paymentMethod .edits:focus,.paywith #paymentMethod .edits:hover{text-decoration:underline;color:#005ea6}.paywith .INCENTIVE+.methodAmount .amountFormatted{color:#56aa47}.paywith .conversion{display:table;width:100%;text-align:right;color:#757575;font-size:.88em}.paywith .cibTextBox{position:relative;z-index:1}.paywith .cibBillingTxt{margin-top:13px;font-size:.85em;line-height:1.25em}.paywith .billingTxt{margin-top:13px;font-size:.85em;text-align:left;line-height:1.2em}.paywith .getInstallments{background-color:#fff;border:1px solid #c5ccd1;float:right}.paywith .getInstallments,.paywith .getInstallmentsError{margin-bottom:10px;font-weight:400;text-align:start;padding:0 10px}.paywith .getInstallmentsError{border:1px solid #c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.paywith a.getInstallments.btn-secondary:focus,.paywith a.getInstallments.btn-secondary:hover,.paywith a.getInstallmentsError.btn-secondary:focus,.paywith a.getInstallmentsError.btn-secondary:hover{background-color:transparent;text-decoration:none}.paywith a.getInstallments.btn-secondary:focus span:first-child,.paywith a.getInstallments.btn-secondary:hover span:first-child,.paywith a.getInstallmentsError.btn-secondary:focus span:first-child,.paywith a.getInstallmentsError.btn-secondary:hover span:first-child{text-decoration:underline}.paywith a.popup{font-weight:700}.paywith .raq{display:inline-block;margin:5px 0 0 5px;width:12px;height:10px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-23px 2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paywith .raq{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paywith .authUserNotify{margin:10px 0 0 5px;padding-left:30px}.paywith .padHelpToolTip .bul a,.paywith .padHelpToolTip .padHeader,.paywith .tipDesc a{font-weight:700}.paywith .padHelpToolTip .toolTip.balloon{line-height:1.35em}.paywith .padHelpToolTip p{margin-bottom:0}.paywith .padHelpToolTip ul{margin:8px 0}.paywith .padHelpToolTip ul li{margin:0}.paywith .bmlDetails{display:block!important;color:#6c7378;font-size:.85em;padding:0;width:100%;margin-bottom:0}.paywith .directDebitAgreement{margin-top:25px;margin-bottom:0}.paywith .multipleFi .charges{margin-top:15px}.paywith .multipleFi .fundingsource{margin-bottom:20px}.paywith .multipleFi .singleInstrumentContainer{padding:0}.paywith .multipleFi .fsdetails{margin-left:12px;width:210px;overflow:hidden;text-overflow:ellipsis;display:inline-block;vertical-align:top}.paywith .multipleFi .fsdetails span{display:inline;text-overflow:ellipsis;overflow:hidden}.paywith .multipleFi .fsdetails span.amount,.paywith .multipleFi .fsdetails span.lastdigits{color:#6c7378;font-size:.85em}.paywith .multipleFi .fsdetails span.subtype{display:inline;color:#2c2e2f}.paywith .multipleFi .bmlDetails{padding-left:40px}.paywith .multipleFi .fsSubdetails{margin-left:40px}.paywith .multipleFi .fsIcon{float:left!important;position:inherit!important;margin-top:2px;margin-left:2px}.paywith .multipleFi.addCard{position:relative;margin-top:25px}.paywith .multipleFi .plusicon{left:4px;top:0}.paywith .multipleFi .addOption{padding:0 0 0 35px;margin:0;font-size:1em}.row-fluid>.bmlPopup{box-sizing:border-box;margin-left:0;padding:40px 0}#memberReview .multipleFi.addCard{margin-bottom:10px}@media (min-width:0) and (max-width:30em){.paywith .cibBillingTxt{margin-top:13px;font-size:.75em;line-height:1.35em;text-align:justify;border:0;padding:0}}.padToggle{padding-top:15px;padding-left:43px;font-size:13px}.padToggle .padToggleSection{font-size:13px;line-height:1.4}.padToggle .padToggleSection p{margin:0}.padToggle .padToggleSection>p{margin-left:35px}.padToggle .padToggleSectionTitle{font-weight:700;padding-left:15px}.padToggle .padToggleSectionOffInfoText{padding-top:5px}.padToggle .padToggleSectionOnInfoText{padding-top:7px}.padToggle .padToggleSectionOnBalanceText{padding-top:15px;padding-left:35px}.padToggle .padToggleSectionOnBalanceText .balanceMsgIcon{width:20px;height:20px;display:inline-block;float:left;margin-right:10px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-139px -1px;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.padToggle .padToggleSectionOnBalanceText .balanceMsgIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.padToggle .padToggleSectionOnBalanceText .balanceMsg{display:inline-block;width:85%}.padToggleHelpToolTip{font-size:13px;color:#2c2e2f;line-height:1.4}.padToggleHelpToolTip .toolTip.balloon{line-height:1.35em}.padToggleHelpToolTip p{margin:0}.padToggleHelpToolTip .padToggleHelpToolTipHeader{font-weight:700}.padToggleHelpToolTip .padToggleHelpToolTipText{padding-top:10px}.adr{margin-top:3px;color:#6c7378;font-size:.85em;width:90%}.adr .adr-break{display:block}.adr .country,.adr .singleline{display:none}.adr .preferred{margin:15px 0 7px}.adr .preferred span{padding:5px 10px;background-color:#eaf7e9;color:#2a5327;font-size:1em}.addressDisplay .adr .streets{display:inline;white-space:normal}.addressDisplay .adr .adr-break,.addressDisplay .adr .postal-code,.addressDisplay .adr .singleline,.addressDisplay .adr .streets,.addressDisplay .adr .streets+div{display:inline}.FR .cvv input{padding-left:6px}#addCard .msg-error{position:relative;margin-top:20px}#addCard #addressAddedToolTip{margin:-10px 0 7px;border:1px solid #7cda7a;background-image:linear-gradient(180deg,#f9fcfa,#f1f8f2);min-height:17px;border-radius:3px}#addCard .addNewBillingAddress{font-size:.85em;margin-top:2px}#addCard xo-phone-input .inputField{padding:0;float:none}#addCard .otpVerification{margin-bottom:10px;color:#7b8388;font-size:.87em;line-height:1.3em}#addCard .btn{margin-top:10px}#addCard.aside #notifications{padding:0 15px;width:100%;box-sizing:border-box;margin:0 0 5px}#addCard.aside #billingAddressUpdatedMsg #notifications{padding:0}#addCard.aside .msg-error{padding:0;margin-bottom:20px;margin-top:10px}#addCard.aside .btn{margin-top:10px;margin-bottom:15px}#addCard.aside #billingAddressForm .btn{margin-top:0}.creditCardInput .plccCardNumberTitle{margin-bottom:5px}.creditCardInput .cardIconsGroup{padding:10px 13px;height:20px}.creditCardInput .cardIconsGroup,.creditCardInput .debitAndCreditIconsGroup{background-color:#f2f3f4;border:1px solid #e3e3e3;border-radius:4px;margin-bottom:10px}.creditCardInput .debitAndCreditIconsGroup{padding:10px 4px;overflow:auto}.creditCardInput .cardIconTitle{border-bottom:1px solid #dcd9d9;font-size:13px;padding-bottom:10px;margin-bottom:10px}.creditCardInput .creditIconLabel{color:#7b8388;font-size:11px;margin:-5px 0 5px}.creditCardInput .debitIconLabel{color:#7b8388;font-size:11px;margin:5px 0 2px}.creditCardInput .cardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_1x.png\") no-repeat 0 100px;height:22px;float:left;width:32px;padding:0 4px 0 0}.creditCardInput .cardIcon.ELO{background-position:0 -713px}.creditCardInput .cardIcon.CUP{background-position:0 -837px}.creditCardInput .cardIcon.VISA{background-position:0 -31px}.creditCardInput .cardIcon.MASTERCARD{background-position:0 -62px}.creditCardInput .cardIcon.HIPER{background-position:0 -682px}.creditCardInput .cardIcon.HIPERCARD{background-position:0 -744px}.creditCardInput .cardIcon.AMEX{background-position:0 -93px;margin-right:-10px}.creditCardInput .cardIcon.JCB{background-position:0 -527px}.creditCardInput .cardIcon.ELECTRON{background-position:0 -217px}.creditCardInput .cardIcon.MAESTRO,.creditCardInput .cardIcon.SWITCH{background-position:0 -248px}.creditCardInput .cardIcon.DISCOVER{background-position:0 -124px}.creditCardInput .cardIcon.CBNATIONALE{background-position:0 -310px}.creditCardInput .cardIcon.CETELEM{background-position:0 -465px}.creditCardInput .cardIcon.COFIDIS{background-position:0 -651px;margin-right:-10px}.creditCardInput .cardIcon.COFINOGA{background-position:0 -341px}.creditCardInput .cardIcon.QIWI{background-position:0 -806px;width:30px}.creditCardInput .debitcardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_bank_mx.png\") no-repeat 0 100px;height:21px;float:left;width:68px;padding:0 2px 0 0;margin-top:3px}.creditCardInput .debitcardIcon.BANAMEX{background-position:0 0;clear:both}.creditCardInput .debitcardIcon.BANCOARFACA{background-position:0 -22px}.creditCardInput .debitcardIcon.BBVA{background-position:0 -44px}.creditCardInput .debitcardIcon.BANORTE{background-position:0 -66px}.creditCardInput .debitcardIcon.HSBC{background-position:0 -88px}.creditCardInput .debitcardIcon.INBURSA{background-position:0 -110px}.creditCardInput .debitcardIcon.SANTANDER{background-position:0 -132px}.creditCardInput .cardType{clear:both;display:block;margin-bottom:10px}.creditCardInput #cardIssueInfo{display:block}.creditCardInput #expiration{min-height:80px}.creditCardInput .expires{position:relative;display:block;top:auto;left:auto;color:#2c2e2f;margin-bottom:5px}.creditCardInput .expirationField{width:48%;float:left;min-height:70px}.creditCardInput #expiration label,.creditCardInput label.cvv{margin-bottom:5px}.creditCardInput .expmonth{float:left;width:50%}.creditCardInput .expmonth .custom-select>span{border-radius:5px 0 0 5px;padding-right:30px}.creditCardInput .expmonth.BR .custom-select>span{padding-right:28px!important}.creditCardInput .expyear{float:left;width:50%}.creditCardInput .expyear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.creditCardInput .expyear .custom-select.active>span{border-left:1px solid #009cde}.creditCardInput .replaced{position:relative;z-index:8;width:100%;line-height:2}.creditCardInput .cvv{position:relative;top:auto;left:auto}.creditCardInput .cvvField{width:48%;float:right}.creditCardInput .cardNumber{clear:both}.creditCardInput .cardNumber input[aria-invalid=true]~xo-tooltip .toolTip{padding:0;border:none}.creditCardInput .cardNumber input[aria-invalid=true]~xo-tooltip .toolTip .tipCreditCard{display:none}.guestWithSignup .creditCardInput .debitAndCreditIconsGroup{padding:0 0 15px}.guestWithSignup .creditCardInput .cardIconTitle{padding:15px 15px 10px}.guestWithSignup .creditCardInput .cardIconsSection{padding:5px 15px 15px}.validated .ng-invalid~#creditCard,.validated input.ng-invalid:active~#creditCard,.validated input.ng-invalid:focus~#creditCard,input.backendError~#creditCard{display:none}.inputField.error #cvv,.validated .inputField input.ng-invalid#cvv{background:none}#securityCode.creditCard,.ccard,.creditCardField .creditCard{position:absolute;right:4px;/*!@replace: 100%;white-space: nowrap;overflow: hidden;left: 8px;*/text-indent:-500em;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_1x.png\") no-repeat 0 100px;height:22px;width:40px;top:12px}#securityCode.creditCard.VISA,.ccard.VISA,.creditCardField .creditCard.VISA{background-position:0 -31px}#securityCode.creditCard.MASTERCARD,.ccard.MASTERCARD,.creditCardField .creditCard.MASTERCARD{background-position:0 -62px}#securityCode.creditCard.AMEX,.ccard.AMEX,.creditCardField .creditCard.AMEX{background-position:0 -93px;margin-right:-10px}#securityCode.creditCard.DINERSCLUB,#securityCode.creditCard.DISCOVER,.ccard.DINERSCLUB,.ccard.DISCOVER,.creditCardField .creditCard.DINERSCLUB,.creditCardField .creditCard.DISCOVER{background-position:0 -124px}#securityCode.creditCard.JCB,.ccard.JCB,.creditCardField .creditCard.JCB{background-position:0 -527px}#securityCode.creditCard.ccback,#securityCode.creditCard.three,.ccard.ccback,.ccard.three,.creditCardField .creditCard.ccback,.creditCardField .creditCard.three{background-position:0 -589px}#securityCode.creditCard.four,#securityCode.creditCard.front,.ccard.four,.ccard.front,.creditCardField .creditCard.four,.creditCardField .creditCard.front{background-position:0 -620px}#securityCode.creditCard.ELECTRON,.ccard.ELECTRON,.creditCardField .creditCard.ELECTRON{background-position:0 -217px}#securityCode.creditCard.MAESTRO,#securityCode.creditCard.SWITCH,.ccard.MAESTRO,.ccard.SWITCH,.creditCardField .creditCard.MAESTRO,.creditCardField .creditCard.SWITCH{background-position:0 -248px}#securityCode.creditCard.ELO,.ccard.ELO,.creditCardField .creditCard.ELO{background-position:0 -713px}#securityCode.creditCard.CUP,.ccard.CUP,.creditCardField .creditCard.CUP{background-position:0 -837px}#securityCode.creditCard.HIPER,.ccard.HIPER,.creditCardField .creditCard.HIPER{background-position:0 -682px}#securityCode.creditCard.HIPERCARD,.ccard.HIPERCARD,.creditCardField .creditCard.HIPERCARD{background-position:0 -744px}#securityCode.creditCard.CBNATIONALE,.ccard.CBNATIONALE,.creditCardField .creditCard.CBNATIONALE{background-position:0 -310px}#securityCode.creditCard.CETELEM,.ccard.CETELEM,.creditCardField .creditCard.CETELEM{background-position:0 -465px}#securityCode.creditCard.COFIDIS,.ccard.COFIDIS,.creditCardField .creditCard.COFIDIS{background-position:0 -651px;margin-right:-10px}#securityCode.creditCard.COFINOGA,.ccard.COFINOGA,.creditCardField .creditCard.COFINOGA{background-position:0 -341px}#securityCode.creditCard.VISA.QIWI,.ccard.VISA.QIWI,.creditCardField .creditCard.VISA.QIWI{background-position:0 -806px;width:30px}#securityCode.creditCard{/*!@replace: inherit; left: 8px;*/right:4px;height:21px;width:40px;top:12px;background-position:0 -589px;-webkit-transition:background-position .3s ease;transition:background-position .3s ease}#securityCode.creditCard.four{background-position:0 -620px}.de_DE #securityCode.creditCard{background-position:5px -606px}.de_DE #securityCode.creditCard.four{background-position:5px -693px}@media only screen and (max-device-width:480px){#editCard .disc,#editCard .discover{background-position:0 -585px}#securityCode.creditCard{background-position:0 -608px}#securityCode.creditCard.four{background-position:0 -695px}#editCard .mastercard,#editCard .mcard{background-position:0 -196px}#editCard visa{background-position:0 -96px}#editCard amex{background-position:0 -295px}#editCard maestro{background-position:0 -978px}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.creditCardInput .cardIconsGroup{padding:10px 15px;height:20px}.creditCardInput .cardIconsGroup,.creditCardInput .debitAndCreditIconsGroup{background-color:#f2f3f4;border:1px solid #e3e3e3;border-radius:4px;margin-bottom:10px}.creditCardInput .debitAndCreditIconsGroup{padding:10px 4px;overflow:auto}.creditCardInput .cardIconTitle{border-bottom:1px solid #dcd9d9;font-size:13px;padding-bottom:10px;margin-bottom:10px}.creditCardInput .creditIconLabel{color:#7b8388;font-size:11px;margin:-5px 0 5px}.creditCardInput .debitIconLabel{color:#7b8388;font-size:11px;margin:5px 0 2px}.creditCardInput .cardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_2x.png\") no-repeat 0 100px;background-size:31px;height:22px;float:left;width:32px;padding:0 4px 0 0}.creditCardInput .cardIcon.ELO{background-position:0 -713px}.creditCardInput .cardIcon.CUP{background-position:0 -837px}.creditCardInput .cardIcon.VISA{background-position:0 -31px}.creditCardInput .cardIcon.MASTERCARD{background-position:0 -62px}.creditCardInput .cardIcon.HIPER{background-position:0 -682px}.creditCardInput .cardIcon.HIPERCARD{background-position:0 -744px}.creditCardInput .cardIcon.AMEX{background-position:0 -93px;margin-right:-10px}.creditCardInput .cardIcon.JCB{background-position:0 -527px}.creditCardInput .cardIcon.ELECTRON{background-position:0 -217px}.creditCardInput .cardIcon.MAESTRO,.creditCardInput .cardIcon.SWITCH{background-position:0 -248px}.creditCardInput .cardIcon.DISCOVER{background-position:0 -124px}.creditCardInput .cardIcon.CBNATIONALE{background-position:0 -310px}.creditCardInput .cardIcon.CETELEM{background-position:0 -465px}.creditCardInput .cardIcon.COFIDIS{background-position:0 -651px;margin-right:-10px}.creditCardInput .cardIcon.COFINOGA{background-position:0 -341px}.creditCardInput .cardIconVISA.QIWI{background-position:0 -806px;width:30px}.creditCardInput .debitcardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_bank_mx_2x.png\") no-repeat 0 100px;background-size:66px;height:21px;float:left;width:68px;padding:0 2px 0 0;margin-top:3px}.creditCardInput .debitcardIcon.BANAMEX{background-position:0 0;clear:both}.creditCardInput .debitcardIcon.BANCOARFACA{background-position:0 -22px}.creditCardInput .debitcardIcon.BBVA{background-position:0 -44px}.creditCardInput .debitcardIcon.BANORTE{background-position:0 -66px}.creditCardInput .debitcardIcon.HSBC{background-position:0 -88px}.creditCardInput .debitcardIcon.INBURSA{background-position:0 -110px}.creditCardInput .debitcardIcon.SANTANDER{background-position:0 -132px}.creditCardInput .cardType{clear:both;display:block;margin-bottom:10px}.guestWithSignup .creditCardInput .debitAndCreditIconsGroup{padding:0 0 15px}.guestWithSignup .creditCardInput .cardIconTitle{padding:15px 15px 10px}.guestWithSignup .creditCardInput .cardIconsSection{padding:5px 15px 15px}#securityCode.creditCard,.ccard,.creditCardField .creditCard{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_2x.png\") no-repeat 0 100px;background-size:31px;height:22px;width:32px;top:11px;right:9px}#securityCode.creditCard.VISA,#securityCode.creditCard.visa,.ccard.VISA,.ccard.visa,.creditCardField .creditCard.VISA,.creditCardField .creditCard.visa{background-position:0 -31px}#securityCode.creditCard.MASTERCARD,#securityCode.creditCard.MCARD,#securityCode.creditCard.mcard,.ccard.MASTERCARD,.ccard.MCARD,.ccard.mcard,.creditCardField .creditCard.MASTERCARD,.creditCardField .creditCard.MCARD,.creditCardField .creditCard.mcard{background-position:0 -62px}#securityCode.creditCard.AMEX,#securityCode.creditCard.amex,.ccard.AMEX,.ccard.amex,.creditCardField .creditCard.AMEX,.creditCardField .creditCard.amex{background-position:0 -93px;margin-right:-10px}#securityCode.creditCard.dinersclub,#securityCode.creditCard.DINERSCLUB,#securityCode.creditCard.disc,#securityCode.creditCard.DISC,#securityCode.creditCard.DISCOVER,.ccard.DINERSCLUB,.ccard.dinersclub,.ccard.DISC,.ccard.disc,.ccard.DISCOVER,.creditCardField .creditCard.DINERSCLUB,.creditCardField .creditCard.dinersclub,.creditCardField .creditCard.disc,.creditCardField .creditCard.DISC,.creditCardField .creditCard.DISCOVER{background-position:0 -124px}#securityCode.creditCard.JCB #securityCode.creditCard.jcb,#securityCode.creditCard.JCB .ccard.jcb,#securityCode.creditCard.JCB .creditCardField .creditCard.jcb,.ccard.JCB #securityCode.creditCard.jcb,.ccard.JCB .ccard.jcb,.ccard.JCB .creditCardField .creditCard.jcb,.creditCardField .creditCard.JCB #securityCode.creditCard.jcb,.creditCardField .creditCard.JCB .ccard.jcb,.creditCardField .creditCard.JCB .creditCardField .creditCard.jcb{background-position:0 -527px}#securityCode.creditCard.ccback,#securityCode.creditCard.three,.ccard.ccback,.ccard.three,.creditCardField .creditCard.ccback,.creditCardField .creditCard.three{background-position:0 -589px}#securityCode.creditCard.four,#securityCode.creditCard.front,.ccard.four,.ccard.front,.creditCardField .creditCard.four,.creditCardField .creditCard.front{background-position:0 -620px}#securityCode.creditCard.split,.ccard.split,.creditCardField .creditCard.split{width:60%;float:left}#securityCode.creditCard.ELECTRON,#securityCode.creditCard.electron,.ccard.ELECTRON,.ccard.electron,.creditCardField .creditCard.ELECTRON,.creditCardField .creditCard.electron{background-position:0 -217px}#securityCode.creditCard.MAESTRO,#securityCode.creditCard.maestro,#securityCode.creditCard.mstro,#securityCode.creditCard.MSTRO,#securityCode.creditCard.SWITCH,.ccard.maestro,.ccard.MAESTRO,.ccard.MSTRO,.ccard.mstro,.ccard.SWITCH,.creditCardField .creditCard.MAESTRO,.creditCardField .creditCard.maestro,.creditCardField .creditCard.mstro,.creditCardField .creditCard.MSTRO,.creditCardField .creditCard.SWITCH{background-position:0 -248px}#securityCode.creditCard.ELO,.ccard.ELO,.creditCardField .creditCard.ELO{background-position:0 -713px}#securityCode.creditCard.CUP,.ccard.CUP,.creditCardField .creditCard.CUP{background-position:0 -837px}#securityCode.creditCard.HIPER,.ccard.HIPER,.creditCardField .creditCard.HIPER{background-position:0 -682px}#securityCode.creditCard.HIPERCARD,.ccard.HIPERCARD,.creditCardField .creditCard.HIPERCARD{background-position:0 -744px}#securityCode.creditCard.cbn,#securityCode.creditCard.CBN,#securityCode.creditCard.CBNATIONALE,.ccard.cbn,.ccard.CBN,.ccard.CBNATIONALE,.creditCardField .creditCard.cbn,.creditCardField .creditCard.CBN,.creditCardField .creditCard.CBNATIONALE{background-position:0 -310px}#securityCode.creditCard.celem,#securityCode.creditCard.CELEM,#securityCode.creditCard.CETELEM,.ccard.celem,.ccard.CELEM,.ccard.CETELEM,.creditCardField .creditCard.celem,.creditCardField .creditCard.CELEM,.creditCardField .creditCard.CETELEM{background-position:0 -465px}#securityCode.creditCard.COFID,#securityCode.creditCard.cofid,#securityCode.creditCard.COFIDIS,.ccard.cofid,.ccard.COFID,.ccard.COFIDIS,.creditCardField .creditCard.cofid,.creditCardField .creditCard.COFID,.creditCardField .creditCard.COFIDIS{background-position:0 -651px;margin-right:-10px}#securityCode.creditCard.COFINOGA,#securityCode.creditCard.conf,#securityCode.creditCard.CONF,.ccard.COFINOGA,.ccard.conf,.ccard.CONF,.creditCardField .creditCard.COFINOGA,.creditCardField .creditCard.conf,.creditCardField .creditCard.CONF{background-position:0 -341px}#securityCode.creditCard.VISA.QIWI,.ccard.VISA.QIWI,.creditCardField .creditCard.VISA.QIWI{background-position:0 -806px;width:30px}#securityCode.creditCard{height:21px;width:32px;background-size:31px;background-position:0 -589px}#securityCode.creditCard.four{background-position:0 -620px}}.ccard{width:100%;position:relative;margin-bottom:17px;padding-top:3px;padding-left:50px;height:25px;text-indent:0}.clearfix.hide{display:none}.issueNo .toolTip{right:0;text-align:right;width:auto}#addCard .tipDesc.tipStartDate{left:0;top:50px}#addCard .tipDesc.tipStartDate .tipDescArrowBack,#addCard .tipDesc.tipStartDate .tipDescArrowFront{left:70px}#addCard .tipDesc.tipIssueNo{left:-140px;top:50px;width:230px}#addCard .tipDesc.tipIssueNo .tipDescArrowBack,#addCard .tipDesc.tipIssueNo .tipDescArrowFront{left:160px}#addCard .tipDesc.tipOptionalCsc{left:-100px;top:50px;width:215px}#addCard .tipDesc.tipOptionalCsc .tipDescArrowBack,#addCard .tipDesc.tipOptionalCsc .tipDescArrowFront{left:160px}#ccFields input[type=text]::-ms-clear{display:none}#ccFields .tipDesc.tipCreditCard{top:42px;left:0;width:100%}#ccFields .tipDesc.tipCreditCard .tipDescText{background-color:#828a8d;font-size:13px}.cardType.show{display:block;margin-bottom:10px}#issueNo{padding-left:5px}.mxCardIconGroup{margin-bottom:5px}@media (max-width:40em) and (orientation:landscape),only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:0) and (max-width:25em){#securityCode.creditCard{background-position:0 -589px}#securityCode.creditCard.four{background-position:0 -620px}}@media (min-width:0) and (max-width:30em){.header{margin-bottom:15px}}#selectCardType .allFundingInstrumentsList li .fsdetails{width:226px;padding:18px 0 18px 25px;margin-top:.5px}#selectCardType .allFundingInstrumentsList li:first-of-type .fsIcon{width:40px;height:30px;background-size:33px;top:15px;background-position:0 -349px;border-radius:2px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v4.png\")}#selectCardType .allFundingInstrumentsList li:first-of-type .fsdetails{top:7px}#selectCardType .forwardIcon{transform:scaleX(-1);width:24px;height:18px;display:inline-block;position:absolute;top:24px;right:17px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectCardType .forwardIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectCardType .plccIcon{display:block;position:absolute;width:30px;height:20px;left:15px;top:20px}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#selectCardType .allFundingInstrumentsList li .fsdetails{width:190px}}.sidebar .addBillingTitle{position:absolute;top:-6px;background:#fff;left:45px;font-size:1.44em;width:230px}@media (min-width:0) and (max-width:30em){.sidebar .addBillingTitle{width:215px;top:-4px;left:40px}}.addressForm.TR{margin-top:3.5%}.addressForm.BR .streetNumber{width:31.15%;padding-right:0;float:left}.addressForm.BR .line1{width:66.15%;margin-right:2.7%;padding-right:0;float:left}.addressForm.BR .city{width:48.15%;margin-right:3.7%;padding-right:0;float:left}.addressForm.BR .state{width:48.15%;margin-right:0;padding-right:0;float:right}.addressForm.MX .state,.addressForm.RU .state,.addressForm.US .state{width:48.15%;margin-right:3.7%;padding-right:0;float:left}.addressForm.MX .postalCode,.addressForm.RU .postalCode,.addressForm.US .postalCode{padding-right:0;margin-right:0;width:48.15%;float:left}.addressForm.ES .state{margin-bottom:10px;clear:both}.addressForm.ES .postalCode{display:block;width:49%;float:left}.addressForm.ES .city{width:48%;float:right}.addressForm.GB .state{float:left;width:62%;margin:0 0 10px}.addressForm.GB .postalCode{float:right;width:35.3%}.addressForm.GB .lookupZip{width:100%;margin:0 10px 10px 0;float:none}.addressForm.GB .lookupHeading{margin:15px 0 10px}.addressForm.GB .lookupTitle{font-weight:700}.addressForm.GB .addressLookup{position:relative}.addressForm.GB .lookupFailureMsg{margin:5px 0 8px}.addressForm.GB .singleAddress{border:1px solid #c5ccd1;margin:10px 0;padding:13px;border-radius:4px;line-height:1.35em}.addressForm.BG .city,.addressForm.BG .postalCode,.addressForm.CZ .city,.addressForm.CZ .postalCode,.addressForm.DK .city,.addressForm.DK .postalCode,.addressForm.FI .city,.addressForm.FI .postalCode,.addressForm.FR .city,.addressForm.FR .postalCode,.addressForm.GR .city,.addressForm.GR .postalCode,.addressForm.HU .city,.addressForm.HU .postalCode,.addressForm.LU .city,.addressForm.LU .postalCode,.addressForm.NO .city,.addressForm.NO .postalCode,.addressForm.RO .city,.addressForm.RO .postalCode,.addressForm.TR .city,.addressForm.TR .postalCode,.addressForm.UA .city,.addressForm.UA .postalCode{width:100%}.addressForm.PT #shippingPostalCode{width:103%}.addressForm.EE .state.half,.addressForm.HR .state.half,.addressForm.LT .state.half,.addressForm.LV .state.half,.addressForm.SI .state.half{width:55%}.addressForm.EE .postalCode.half,.addressForm.HR .postalCode.half,.addressForm.LT .postalCode.half,.addressForm.LV .postalCode.half,.addressForm.SI .postalCode.half{width:41%}.addressForm.KR .fieldGroup .inputField,.addressForm.TH .fieldGroup .inputField{padding:0}.addressForm.KR .postalCode,.addressForm.KR .state{width:100%}.addressForm .editAddress{position:absolute;font-size:.85em;top:2px;right:0;color:#0070ba;cursor:pointer}.addressForm .btn{margin-bottom:15px}.addressForm #findAddressButton.processing{vertical-align:middle;font-size:32px}.addressForm #findAddressButton.processing .loader,.addressForm #findAddressButton.processing .spinner{height:25px;width:25px;position:static;display:inline-block}.addressForm #findAddressButton.processing .loader{margin:0;padding:0;background-color:transparent;border-left:2px solid rgba(0,0,0,.2);border-right:2px solid rgba(0,0,0,.2);border-width:1.5px;border-style:solid;border-color:#2180c0 #fff #fff}.addressForm #lookedupDropDown{margin-bottom:20px}.addressForm .addPreferredShipping{margin:0 0 15px}@media screen{.addressForm .buttons{margin-top:0}.TR .city{margin:0 0 10px}}#upopConfirmation .modalMask,#upopConfirmation .modalWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}#upopConfirmation .close{position:absolute;top:20px;right:20px;width:19px;height:19px;padding:5px;border-radius:3px}#upopConfirmation .close:before{content:\"\";position:absolute;width:19px;height:19px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .close:focus:before,#upopConfirmation .close:hover:before{background-position:-223px -22px}#upopConfirmation .modalMask{background:#cbd2d6;opacity:.7}#upopConfirmation .modalWrapperAnimation{-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}#upopConfirmation .modalWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:80px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}#upopConfirmation .modalWrapper .logo{position:relative;margin-top:-60px;width:25px;height:30px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .modalWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .modalContainer{min-height:99%;width:380px;display:block}#upopConfirmation .modalContainer .pushlogo{height:90px}#upopConfirmation .processing input{background-color:#f2f3f4}#upopConfirmation .upopOpen .modalWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}#upopConfirmation .upopConfirm .header{border-bottom:none}#upopConfirmation .upopConfirm .timingFields{padding-bottom:35px}#upopConfirmation .upopConfirm .counter{float:left}#upopConfirmation .upopConfirm a.resendCode{float:right}#upopConfirmation .upopConfirm #notifications{padding:0 0 5px}#upopConfirmation .expiration{display:inline-flex}#upopConfirmation .expiration .expires{position:relative;top:auto;left:auto}#upopConfirmation .expiration .expirationField{margin-right:10px}#upopConfirmation .expiration input.ng-invalid{padding-right:13px}#upopConfirmation .expiration label{margin-bottom:5px;color:#000}#upopConfirmation .telephoneField{clear:both;padding:0;float:none}#upopConfirmation .heading{margin:5px 0 10px;font-size:1.6em;font-family:HelveticaNeue-Light,Helvetica Neue Light,Helvetica,Arial,sans-serif}#upopConfirmation .timer{margin-bottom:20px}#upopConfirmation .timeLeft{margin-left:5px;font-weight:700}#upopConfirmation .confirmMsg{color:#6c7378;margin-bottom:20px}#upopConfirmation .resendLink{font-size:.85em}#upopConfirmation .btn{margin-top:10px}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#upopConfirmation .modalWrapper{width:100%;padding:60px 15px 0}#upopConfirmation .modalWrapper .modalContainer{width:auto}}#addCard.aside #upopConfirmation #notifications{padding:0 0 5px;margin-bottom:0}#selectShipping .xo-adr{width:85%}#selectShipping .items{margin:0;width:100%;list-style:none}#selectShipping .address{margin:0;padding:0;position:relative;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out;cursor:pointer}#selectShipping .address a{border:2px solid transparent}#selectShipping .address a:hover{background-color:#f7f9fa}#selectShipping .address a:focus{border:2px solid #009cde}#selectShipping .address .fullName{word-break:break-all;line-height:1.35em}#selectShipping .address .msgPage{border-left-width:0;border-top-width:0}#selectShipping .address .msgPage ul li{margin-top:0}#selectShipping .disabled .shippingBlk{cursor:default;color:#d3d3d3}#selectShipping .disabled .adr{color:#d3d3d3}#selectShipping .disabled:focus,#selectShipping .disabled:hover{background-color:#fff}#selectShipping .items .addBtnItem{margin:0;padding:0;border-bottom:1px solid #e3e3e3}#selectShipping .items .addBtnItem:focus,#selectShipping .items .addBtnItem:hover{background-color:#f7f9fa}#selectShipping .address:after{content:\"\";width:100%;display:block;position:absolute;bottom:-2px;left:0}#selectShipping .addrHd{margin-bottom:10px;padding:0 15px;border:none}#selectShipping .backArrowContainer{margin-left:41px}#selectShipping .display .adr{margin-top:3px;color:#6c7378;font-weight:lighter;font-size:.85em;width:90%}#selectShipping .phone{clear:both}#selectShipping .phone form{overflow:hidden}#selectShipping .secondHalf{float:right}#selectShipping .review{float:left;width:65%}#selectShipping .editCard{font-size:1em}#selectShipping .add{padding:25px 20px;cursor:pointer;display:block}#selectShipping .add:hover{text-decoration:none}#selectShipping .add .btn{display:inline-block;vertical-align:middle;width:29px;height:29px;background:url(https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_flat.png) 7px -895px no-repeat}#selectShipping .checkIcon{width:24px;height:17px;display:inline-block;position:absolute;top:40%;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-192px -2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectShipping .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectShipping .addAddressContent{width:73%;display:inline-block;vertical-align:middle;color:#0070ba;font-weight:400;margin-left:5px;font-size:.85em}#selectShipping .addAddressContent:focus,#selectShipping .addAddressContent:hover{text-decoration:underline}#selectShipping li a{display:block;padding:17.5px 15px;text-decoration:none;color:#292929}#selectShipping li xo-message .msgPage{padding:15px 20px}#selectShipping li xo-message .msgPage ul li{margin-left:0}#selectShipping li xo-message .msgPage .icon{left:20px}#selectShipping .addIcon{display:inline-block;width:20px;height:20px;margin-left:5px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectShipping .addIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectShipping .header{padding:15px 15px 10px}#selectShipping .subHeader .leftIcon{display:inline-block;float:left;width:10px;height:10px;margin:4px 6px 0 0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-180px -180px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectShipping .subHeader .leftIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectShipping .subHeader .leftIcon:focus,#selectShipping .subHeader .leftIcon:hover{background-position:-180px -200px}#selectShipping .subHeader .rightIcon{float:right;width:6px;height:10px;margin:4px 0 0 6px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-200px -180px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectShipping .subHeader .rightIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectShipping .subHeader .rightIcon:focus,#selectShipping .subHeader .rightIcon:hover{background-position:-200px -200px}#shippingAddressForm .country{margin-bottom:10px}#shippingAddressForm .reversefirstname{float:right;width:48.15%;padding:0}#shippingAddressForm .firstname,#shippingAddressForm .reverselastname{float:left;width:48.15%;margin-right:3%;padding:0}#shippingAddressForm .lastname{float:right;width:48.15%;padding:0}#shippingAddressForm .buttons{margin-top:0}.fullpage .container{padding:20px 0}#addShipping.fullpage div.container h1.gamma{margin-bottom:8px}#deleteShipping .items{margin:0;width:100%;list-style:none}#deleteShipping .item{margin:0;position:relative;max-height:200px;overflow:hidden;border-bottom:1px solid #e3e3e3;-webkit-transition:max-height .5s ease;transition:max-height .5s ease}#deleteShipping .item.collapse{max-height:0}#deleteShipping .itemInner{padding:17.5px 15px}#deleteShipping .address{display:inline-block;width:70%;-webkit-transform:translate(0);transform:translate(0);-webkit-transition:-webkit-transform .5s ease;transition:transform .5s ease}#deleteShipping .address .fullName{word-break:break-all;line-height:1.35em}#deleteShipping .address.slide{-webkit-transform:translate(-32%);transform:translate(-32%)}#deleteShipping .address.slideFast{transition:transform .1s}#deleteShipping .item:after{content:\"\";width:100%;display:block;position:absolute;bottom:-2px;left:0}#deleteShipping .backArrowContainer{margin-left:41px}#deleteShipping .adr{margin-top:3px;color:#6c7378;font-size:.85em;width:inherit}#deleteShipping li{display:block;text-decoration:none;color:#292929}#deleteShipping .notDeletable .adr,#deleteShipping .notDeletable .fullName{color:#cbd2d6}#deleteShipping .msgIcon{width:20px;height:20px;display:inline-block;position:absolute;top:35%;right:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-139px -1px;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#deleteShipping .msgIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#deleteShipping .delete{font-size:.85em;display:inline-flex;position:absolute;height:100%;top:0;right:0;padding:0 15px;text-align:center;align-items:center;overflow:hidden;-webkit-transform:translate(0);transform:translate(0)}#deleteShipping .delete.slideOut{-webkit-transform:translate(102%);transform:translate(102%)}#deleteShipping .show{display:inline-flex}#deleteShipping .confirm{background-color:#009cde;cursor:pointer;-webkit-transform:translate(102%);transform:translate(102%);-webkit-transition:-webkit-transform .5s ease;transition:transform .5s ease}#deleteShipping .confirm a{font-weight:700;color:#fff;text-decoration:none}#deleteShipping .confirm.slidein{-webkit-transform:translate(0);transform:translate(0)}#deleteShipping .msg-inline{font-size:.85em;max-height:0;overflow:hidden;-webkit-transition:max-height .5s ease;transition:max-height .5s ease}#deleteShipping .msg-inline.expand{max-height:100px}#deleteShipping .msg-inlineInner{padding:12px 0 0}#deleteShipping .msg-error .icon{position:relative;float:left}#deleteShipping .msg-error .content{margin-left:29px;color:#c72e2e}#deleteShipping .header .backArrow{left:15px}#selectShippingCountry .disabled,#selectShippingCountry .disabled .custom-select>span,#selectShippingCountry .disabled span{color:#d3d3d3;margin-top:3px}#selectShippingCountry .disabled.country{min-height:53px}#selectShippingMethod #selectShippingMethodContainer{margin-top:-10px;padding-bottom:10px}#selectShippingMethod .shippingText{line-height:1.2em}#selectShippingMethod .shipTo{font-size:1.3em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;padding-top:10px;font-weight:lighter}#selectShippingMethod .storeLocation{margin-top:10px;word-wrap:break-word;line-height:1.2em}#selectShippingMethod .storeLocationInfo{margin-top:1%;color:#6c7378;font-size:.85em;width:90%;line-height:1.3em}#selectShippingMethod .changeInsurance,#selectShippingMethod .changeShippingMethod{cursor:pointer}#selectShippingMethod .noInsuranceOption,#selectShippingMethod .selectedShippingMethod{font-weight:500;margin-left:0;vertical-align:top;max-width:50%;overflow:hidden;text-overflow:ellipsis;display:inline-block;white-space:nowrap;-webkit-font-smoothing:antialiased;text-decoration:inherit}#selectShippingMethod #shippingInformation,#selectShippingMethod .insuranceOfferedInOption{display:inline-block}#selectShippingMethod #insuranceInfo,#selectShippingMethod #methodCharges{margin-left:-10px;padding-left:10px;padding-right:10px}#selectShippingMethod .shippingAmt{font-weight:700;-webkit-font-smoothing:antialiased}#selectShippingMethod .noHighlight{background-color:#fff}#selectShippingMethod .highlight,#selectShippingMethod .noHighlight{-webkit-transition:background-color .4s linear;transition:background-color .4s linear}#selectShippingMethod .highlight{background-color:#eaf7e9}#selectShippingMethod .lightHR{border:none;height:1px;color:#e3e3e3;background-color:#e3e3e3;margin-bottom:10px;margin-top:10px}#selectShippingMethod .frontArrow{top:2px;right:-1px}#selectShippingMethod .modal-content{width:450px;height:95%;top:50%;position:fixed;overflow-y:scroll}#selectShippingMethod .modal-content>div{min-height:95%;position:relative}@media (min-width:0) and (max-width:30em){#selectShippingMethod .modal-content{width:100%}#selectShippingMethod .selectedShippingMethod{max-width:30%}}@media (max-width:40em) and (orientation:landscape){#selectShippingMethod .modal-content{width:100%}#selectShippingMethod .selectedShippingMethod{max-width:30%}}#selectShippingMethod .methodContents{margin-left:0}#selectShippingMethod .shippingOptions{padding-left:2px;padding-right:2px}#selectShippingMethod .shippingMethodsContainer{position:relative;min-height:95%;background-color:#fff;margin-top:40px;margin-left:30px;margin-right:30px}#selectShippingMethod .closeModal{position:fixed;margin-top:25px;margin-right:20px}#selectShippingMethod .logo{position:absolute;z-index:1;bottom:10px;left:0;right:0;width:29px;height:29px;background-position:0 -47px}#selectShippingMethod .shippingHeader{font-size:1.6em;color:#2c2e2f;font-weight:400;line-height:22px}#selectShippingMethod .gamma{font-size:13px;margin-top:5px;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#6c7378;font-weight:lighter;display:block;line-height:1.3em}#selectShippingMethod hr{width:100%;margin-top:20px;margin-bottom:20px;border-top:0 solid #dbdbdb}#selectShippingMethod .shippingCharge{font-weight:700;-webkit-font-smoothing:antialiased}#selectShippingMethod .methodName{font-weight:400;-webkit-font-smoothing:antialiased}#selectShippingMethod .deliveryTime{margin-left:0;color:#2c2e2f}#selectShippingMethod .deliveryTime,#selectShippingMethod .description{display:block;font-size:13px;line-height:1.3em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}#selectShippingMethod .description{margin-top:7.8px;color:#6c7378;font-weight:lighter}#selectShippingMethod .animate-show{max-height:100px;-webkit-transition:max-height .5s ease;transition:max-height .5s ease}#selectShippingMethod .animate-show.ng-hide{max-height:0;display:block!important;overflow:hidden}#selectShippingMethod div{margin-left:auto;margin-right:auto}#selectShippingMethod .confirmation{font-size:1.5em;text-align:center;color:#2c2e2f}#selectShippingMethod .btn{height:44px;margin-bottom:130px;margin-top:30px;border:1px solid #0070ba;background-color:#0070ba;border-radius:5px;display:inline-block;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased;text-rendering:auto;letter-spacing:normal;word-spacing:normal;text-transform:none;text-indent:0;text-shadow:none;-webkit-writing-mode:horizontal-tb;width:100%}#selectShippingMethod .btn:focus,#selectShippingMethod .btn:hover{text-decoration:underline;background-color:#005ea6;border-color:#005ea6}#selectShippingMethod .formatCurrency{font-weight:700;-webkit-font-smoothing:antialiased;text-decoration:inherit}#selectShippingMethod .formatCurrency .currencyCode{font-size:1em}#selectShippingMethod .modal-dialog{overflow-y:hidden;overflow-x:hidden}#selectFunding.asideContent{clear:both}#selectFunding .items{margin:0;width:100%;list-style:none}#selectFunding .items .addBtnItem{margin:0;padding:20px 10px;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}#selectFunding .items .addBtnItem:focus,#selectFunding .items .addBtnItem:hover{background-color:#f7f9fa}#selectFunding .address:after{content:\"\";width:100%;display:block;position:absolute;bottom:-2px;left:0}#selectFunding .backArrowContainer{margin-left:41px}#selectFunding .display .adr{margin-top:3px;color:#6c7378;font-weight:lighter;font-size:.85em;width:90%}#selectFunding .secondHalf{float:right}#selectFunding .review{float:left;width:65%}#selectFunding .editCard{font-size:1em}#selectFunding .add{cursor:pointer;display:block}#selectFunding .add:hover{text-decoration:none}#selectFunding .add .btn{display:inline-block;vertical-align:middle;width:29px;height:29px;background:url(https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_flat.png) 7px -895px no-repeat}#selectFunding .fundingContainerPAD .name{color:#6c7378;font-size:.85em;margin-bottom:0}#selectFunding .checkIcon{width:24px;height:17px;display:inline-block;position:absolute;top:40%;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-192px -2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectFunding .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectFunding .addAddressContent{width:73%;display:inline-block;vertical-align:middle;color:#0070ba;font-weight:400}#selectFunding .addAddressContent:focus,#selectFunding .addAddressContent:hover{text-decoration:underline}#selectFunding .addIcon{display:inline-block;width:20px;height:20px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectFunding .addIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectFunding .bmlAsideOffer{padding:15px 10px}#selectFunding .offerTile{background-color:#f7f9fa}#selectFunding .fundingContainerBmlOffer{font-size:.7em;line-height:1.15em;padding:0;display:block}#selectFunding .fundingContainerBmlOffer .seeTermsLink{margin-top:5px}#selectFunding .fundingContainerPlcc{cursor:pointer;position:relative;min-height:35px}#selectFunding .fundingContainerPlcc .p{margin-left:30px}#selectFunding .redeemGC{margin-top:0;cursor:pointer}#selectFunding .bmlTermsLink{color:#0079ad}#selectFunding .bmlTermsLink:focus,#selectFunding .bmlTermsLink:hover{text-decoration:underline;background-color:transparent}#selectFunding .bmlDetails{display:inline-block;width:100%;font-size:.85em;padding-top:0}#selectFunding .plccAddNowLink{cursor:pointer;position:absolute;top:2px;right:0;font-size:.85em}#selectFunding .plccOfferDesc{margin-top:3px;font-size:.68em;color:#666}#selectFunding .headerText,#selectFunding .plccOfferDesc{margin-left:40px;margin-bottom:0}#selectFunding .fsIcon{float:left;position:inherit}#selectFunding .plccInstIcon{float:left;display:inline-block;height:20px;top:22px;left:15px;background:none;width:25px}#selectFunding .fsIcon.PLCC{background-image:none}#selectFunding #bmlApplyLink{line-height:1.75em}#addBank .fieldLegend{margin-bottom:4px;padding-bottom:0;font-size:inherit}#addBank .inputField input[readonly=readonly],#addBank input[readonly=readonly]{background:#f5f5f5;color:#a8a8a8}#sepaMandate .span{width:31%;float:none;display:inline-block;vertical-align:top}#sepaMandate span.col1{font-weight:700;vertical-align:top}#sepaMandate span.col1,#sepaMandate span.col2{display:block;word-wrap:break-word}#sepaMandate .asideContent p{font-size:.8em}#sepaMandate .asideContent span.col1{display:inline-block;width:30%}#sepaMandate .asideContent span.col2{display:inline-block;width:65%;margin-left:3%}#sepaMandate .asideContent .span{width:100%}#sepaMandate .creditorId{word-wrap:break-word}#sepaMandate .buttons{padding:0}#sepaMandate #cancelBtn{margin-top:10px}.conversionoptions{list-style:none;margin:0}.conversionoptions p{margin:0;padding:0}.conversionoptions label{font-weight:700}.conversionoptions ul{margin:0 0 0 30px;overflow-y:hidden}.conversionoptions .conversion{margin:3px 0 4px 35px}.conversionoptions input[name=ppconversion]{margin-bottom:5px;margin-right:5px;vertical-align:middle}.conversionoptions .conversionCC{margin-top:20px}.conversionoptions li{margin-bottom:5px;margin-left:5px;font-size:.92em}.conversionoptions .radioButton input[type=radio]~label{line-height:1.35em}.conversionoptions li:last-child .radioButton{margin:5px 0}.currencyConversion{overflow-y:auto;overflow-x:hidden;height:470px}#largeScreenDirectDebitAgreement_DE #proceedButton,#largeScreenSEPADirectDebit_DE #proceedButton,#sepaAgreementContingency #proceedButton,#sepaMandateContingency #proceedButton{float:none}#largeScreenDirectDebitAgreement_DE .de.cityPostalCode .city,#largeScreenSEPADirectDebit_DE .de.cityPostalCode .city,#sepaAgreementContingency .de.cityPostalCode .city,#sepaMandateContingency .de.cityPostalCode .city{width:56%}#largeScreenDirectDebitAgreement_DE .countryList .list,#largeScreenSEPADirectDebit_DE .countryList .list,#sepaAgreementContingency .countryList .list,#sepaMandateContingency .countryList .list{width:230px}#largeScreenDirectDebitAgreement_DE .button-as-link,#largeScreenSEPADirectDebit_DE .button-as-link,#sepaAgreementContingency .button-as-link,#sepaMandateContingency .button-as-link{font-size:1em}#largeScreenSEPADirectDebit_DE .sepaInfo,#sepaMandateContingency .sepaInfo{margin-bottom:10px}#largeScreenSEPADirectDebit_DE .sepaInfo .span,#sepaMandateContingency .sepaInfo .span{width:30%;float:none;display:inline-block;vertical-align:top}#largeScreenSEPADirectDebit_DE .sepaInfo p,#sepaMandateContingency .sepaInfo p{margin:0}#largeScreenSEPADirectDebit_DE .sepaInfo p.marginTop,#sepaMandateContingency .sepaInfo p.marginTop{margin-top:10px}#largeScreenSEPADirectDebit_DE .bankDetails,#largeScreenSEPADirectDebit_DE .personalInfo,#sepaMandateContingency .bankDetails,#sepaMandateContingency .personalInfo{word-break:break-all}#largeScreenSEPADirectDebit_DE .sepaInfo{margin:25px 0}#largeScreenSEPADirectDebit_DE .trayInner{padding:0 0 20px}@media (max-width:41.3125em){#largeScreenSEPADirectDebit_DE .trayInner{margin:0}.mobile .largeScreenSEPADirectDebitDE .centerTray{padding:0}.largeScreenSEPADirectDebitDE{margin:15px 25px 0}}.rightLink{float:right}.entryToggleLinks{margin-bottom:4px}.dateLocationMarker{color:#6c7378}.adr .darker{color:#2c2e2f}#meftDeclineAddCard #billingAddress .custom-select-container{margin-top:10px}#meftDeclineAddCard .useMeftInstead{margin-top:28px}#meftDeclineAddCard .cardImg{height:122px;margin-bottom:18px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_add_card.png\") no-repeat top}.incontext .useMeftInstead{margin-top:2px;margin-bottom:2px;font-size:77%}@media (max-width:30em) and (min-width:0){#largeScreenSEPADirectDebit_DE .sepaInfo .span,#sepaMandateContingency .sepaInfo .span{width:100%;margin:5px 0}#meftDeclineAddCard .trayInner{margin:15px 0 0}}.installmentOptions{height:400px;margin-left:-8px;margin-top:-8px}.installmentOptions .cardInfo{background-color:#f7f9fa;padding:15px 0 10px 20px;border-bottom:2px solid #e3e3e3;margin-top:0}.installmentOptions .cardInfo .ccard{background-size:31px;top:-2px;padding-left:48px;padding-bottom:3px;padding-top:0;right:-3px}.installmentOptions .cardInfo .installmentText{color:#6c7378;font-size:15px}.installmentOptions .items{margin:0;padding-left:7px;list-style:none}.installmentOptions .term{float:left}.installmentOptions .display{margin-left:0}.installmentOptions .display .total{margin-top:4px;color:#6c7378;font-size:.85em;width:90%}.installmentOptions .display .total .save{color:#2a5327;background-color:#eaf7e9;padding:4px;display:block;max-width:55%;margin-top:3px}.installmentOptions .installment{margin:0;padding:18px;position:relative;border-bottom:1px solid #e3e3e3;cursor:pointer;width:96%}.installmentOptions .installment:focus,.installmentOptions .installment:hover{background-color:#f7f9fa}.installmentOptions li a{text-decoration:none;color:#292929}.installmentOptions .installment:after{content:\"\";width:96%;display:block;position:absolute;bottom:-2px;left:0}.installmentOptions .asideContent{overflow-y:auto;overflow-x:hidden;height:400px}.MX .installmentOptions{height:1000px}.guestWithSignup .installmentOptions .asideContent{height:auto}@media (min-width:0) and (max-width:30em){.signupflow{margin-left:15px;margin-top:-12px}.installmentOptions .cardInfo,.signupflow .cardInfo{margin-top:5px}.header{margin-bottom:0}}#addressNormalization .addrRadio{position:relative}#addressNormalization .addrLabel{display:inline-block;padding-left:5px;vertical-align:top;width:75%}#addressNormalization .normalizedAdrSection{margin-bottom:10px}#addressNormalization .adr{margin-top:-2px;margin-left:10px}#addressNormalization .subContainer{border-top:none}#addressNormalization #fullContinue{width:100%}@media (min-width:0) and (max-width:30em){#addressNormalization .addrRadio{position:relative;float:left}#addressNormalization .adr{margin-top:-2px;margin-left:20px}#addressNormalization .buttons{margin-top:-5px;overflow:visible}#addressNormalization .subContainer{border-top:none;margin-top:-10px}#addressNormalization .row-fluid>[class*=span]{width:auto}}#taxIdForm .taxIdHead{font-size:14px}#travelRuleForm .nolap{margin-top:15px;margin-bottom:20px}#travelRuleForm .address p{margin-top:21px;margin-bottom:21px}@media (min-width:41.3125em){section#genericError .container{width:400px}.genericError.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericError.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericError{height:450px;background:none}section#genericError .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericError .title{font-size:1.5em;margin-bottom:15px;line-height:1.2}section#genericError .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericError .secondaryMessage{color:#979797;line-height:20px}section#genericError .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericError .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericError .cancelLink{margin-top:20px}section#genericError .full{padding-left:20px;padding-right:20px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}@media (min-width:41.3125em){section#genericMessage .container{width:400px}.genericMessage.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericMessage.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericMessage{height:450px;background:none}section#genericMessage .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericMessage .title{font-size:1.5em;margin-bottom:15px}section#genericMessage .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericMessage .secondaryMessage{color:#979797;line-height:20px}section#genericMessage .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericMessage .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericMessage .cancelLink{margin-top:20px}.overlayMask,.overlayWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}.overlayMask{background:#cbd2d6;opacity:.7}.overlayWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:90px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.overlayWrapper .logo{position:relative;width:29px;height:29px;margin:0 auto;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.overlayWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.overlayContainer{width:380px;display:block;min-height:100%;height:auto!important;height:100%;margin:0 auto -50px}.overlayContainer .pushLogo{height:50px}.overlayOpen .overlayWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}.pageOverlay #spinner{top:0;left:0}body.loading .pageOverlay .aside{opacity:.1}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.overlayWrapper{width:100%;padding:30px 15px 0}.overlayWrapper .overlayContainer{width:auto}}.installmentInfo{padding-bottom:10px}.terms{font-size:.85em}.signupbml .title{margin-bottom:12px}.signupbml .adr{font-weight:400}.signupbml .bmlRow{border-top:1px solid #e3e3e3;margin-top:0;margin-bottom:0;padding:25px 0 0}.signupbml .bmlSeeTerms{font-size:13px;color:#666;line-height:1.35em}.signupbml .payInFullLink{font-weight:700}.signupbml .billingAddressRow{margin-bottom:15px}.signupbml .changeBillingAddress{float:right;margin-top:4px;cursor:pointer}.signupbml .sameLine{display:inline}.signupbml .bmlMargin{margin-top:15px}.signupbml .inputField input{height:44px}.signupbml .billingName{margin-bottom:0}.signupbml .fidobMonth{width:35%;float:left}.signupbml .fidobMonth .custom-select>span{border-radius:5px 0 0 5px;border-right:1px solid #fff}.signupbml .fidobDay{width:30%;float:left}.signupbml .fidobDay .custom-select>span{border-radius:0 0 0 0;border-right:1px solid rgba(0,0,0,.2)}.signupbml .fidobYear{width:35%;float:left}.signupbml .fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:1px solid #fff}.signupbml .custom-select.active>span{border:1px solid #009cde;outline:0}.signupbml .dobNatlIdGroup{margin-top:15px;margin-bottom:20px}.signupbml .dobNatlIdGroup input{margin-bottom:0}.signupbml .dobNatlIdGroup .inputField{-ms-box-sizing:border-box;box-sizing:border-box;padding:0}.signupbml .dobNatlIdGroup .toolTip{white-space:nowrap;right:0;position:absolute;margin-top:4px}.signupbml .dob,.signupbml .nationalId{width:68%;position:relative;padding:0}.signupbml .dob legend,.signupbml .nationalId label.topLabel{color:inherit;display:block;left:inherit;margin:0;padding-bottom:5px;position:relative;top:inherit}.signupbml .nationalId label.placeholder{top:32px;display:none}.signupbml .dob{float:left}.signupbml .dob legend{font-size:inherit}.signupbml .dob.fullWidth{width:100%}.signupbml .dob.fullWidth .custom-select-container{width:33.33%}.signupbml .nationalId{padding-right:0;width:29.5%}.signupbml .nationalId.inputField label.topLabel{left:0;top:0;white-space:nowrap}.signupbml .fieldGroup .nationalId{float:right;height:20px;margin-top:25px}.signupbml .verifyHelp{display:inline-block;height:18px;width:19px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-164px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.signupbml .verifyHelp{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.signupbml .postal-code.adr-break{display:inline}.signupbml .piHeight{height:25px}.signupbml .toolTip{font-size:12px;position:relative}@media (max-width:41.3125em){#bmlApplyEdu{display:none}.addPhone,.bmlSeeTerms,.city,.dobNatlIdGroup,.line1,.line2,.state,.zip{font-size:.95em}.toolTip{font-size:12px}}.mobile #applyForBml .tipNationalId{width:317px}.mobile #applyForBml .custom-select>span{padding:5px}.mobile .toolTip{font-size:12px}@media (min-width:30.0625em) and (max-width:41.25em){#bmlApplyEdu{display:none}.addPhone,.bmlSeeTerms,.city,.dobNatlIdGroup,.line1,.line2,.postalCode,.state{font-size:.95em}.toolTip{font-size:12px}}@media (min-width:0) and (max-width:40em){#bmlApplyEdu{display:none}.addPhone,.bmlSeeTerms,.city,.dobNatlIdGroup,.line1,.line2,.postalCode,.state{font-size:.95em}.toolTip{font-size:12px}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#bmlApplyEdu{display:none}.addPhone,.bmlSeeTerms,.city,.dobNatlIdGroup,.line1,.line2,.postalCode,.state{font-size:.95em}.toolTip{font-size:12px}}#bmlModal .chkbxLabel{line-height:inherit}#continueBml{margin-bottom:12px}.headerBar{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.bmlSignature .bmlSeeTerms{font-size:.68em;color:#666}.bmlSignature .sameLine{display:inline}.bmlSignature .bmlMargin{margin-top:15px}.bmlSignature .content{line-height:1.35em}.bmlSignature .agree{position:relative}.bmlSignature #confirmationMessage{line-height:1.2em}.bmlSignature .validated input[type=checkbox].ng-invalid+.errorTooltipRuleSpecific{width:300px;font-size:12px;top:30px;left:0;line-height:1.2em;width:275px}.bmlSignature .buttons{margin-top:20px}#bmlTermsAndConditions .trayInner{clear:both;padding:0 0 20px}#bmlTermsAndConditions .trayPaymentPlanDetails{padding:25px 0 15px;margin:0;border-top:none}#bmlTermsAndConditions .trayPaymentPlanDetails h2{margin-bottom:10px}#bmlTermsAndConditions .trayPaymentPlanDetails p{margin:0}#bmlTermsAndConditions .bmlTermsHeader{margin:20px 0 0}#bmlTermsAndConditions .bmlTermsInnerWrap{overflow:hidden;position:relative;height:450px}#bmlTermsAndConditions .bmlTermsHead{float:left}#bmlTermsAndConditions .printContent{float:right}#bmlTermsAndConditions .bmlTermsBody{overflow:auto;height:400px;clear:both;border:1px solid #dbdbdb}#bmlTermsAndConditions .bmlTermsBody iframe{height:99%;width:100%;overflow:scroll;-ms-box-sizing:border-box;box-sizing:border-box;border:none}#bmlTermsAndConditions .bmlTermsDirections,#bmlTermsAndConditions .bmlTermsFooter{background-color:#f1f4f5}#bmlTermsAndConditions .bmlTermsDirections{float:right;font-weight:700}#bmlTermsAndConditions .bmlTermsDirections p{margin:0}#bmlTermsAndConditions .bmlTermsDirections p.first{margin:8px 5px 0 0}#bmlTermsAndConditions .bmlAgreeToTerms{min-width:60%}#bmlTermsAndConditions #bmlAgreeToTermsSubmit{float:left;min-width:50%;margin:2px 0 0}#bmlTermsAndConditions .bmlTermsFooter{position:static;margin:0;padding:15px 20px;top:auto;bottom:0;position:absolute;left:0;width:100%;min-height:70px;border-radius:0 0 5px 5px;background-clip:padding-box;-ms-box-sizing:border-box;box-sizing:border-box}#bmlTermsAndConditions .trayInner{position:relative}#bmlTermsAndConditions .btn.disabled,#bmlTermsAndConditions .btn[disabled]{opacity:.35}#bmlTermsAndConditions #creditConfirmation{display:block}#bmlTermsAndConditions #creditConfirmation .modal-wrap{margin:0;padding:0;width:440px;border-radius:0}#bmlTermsAndConditions #creditConfirmation .close:hover{background-position:-218px -22px}#bmlTermsAndConditions #creditConfirmation .paypalHeaderWrapper{padding:30px}#bmlTermsAndConditions #creditConfirmation .paypalHeaderWrapper .logo{margin:0 auto;float:none}#bmlTermsAndConditions #creditConfirmation .paypalHeaderWrapper .close{top:36px;right:30px}#bmlTermsAndConditions #creditConfirmation .confirmationPopupContent{background-color:#f7f9fa;padding:20px 30px}#bmlTermsAndConditions #creditConfirmation .confirmationPopupContent h2{font-size:1.5em;text-align:center;color:#2c2e2f}#bmlTermsAndConditions #creditConfirmation .confirmationPopupContent ul{margin:1em}#bmlTermsAndConditions #creditConfirmation .confirmationPopupContent ul li{margin-bottom:20px}#bmlTermsAndConditions #creditConfirmation .cancelApplicationBlock{padding:15px;text-align:center}.largeScreen.pageBmlTermsAndConditions .cartVerB #main .logo{display:none}.largeScreen.pageBmlTermsAndConditions .cartVerB #main .cartContainer{margin:0 0 30px;position:relative;right:0;top:0}.largeScreen.pageBmlTermsAndConditions .cartVerB #main .cartContainer .transctionCartDetails{z-index:2}.largeScreen.pageBmlTermsAndConditions .cartVerB #main .cartContainer .transctionCartDetails .details{margin:10px 15px 10px 10px}.mobile.pageBmlTermsAndConditions #bmlTermsAndConditions .bmlTermsBody,.mobile.pageBmlTermsAndConditions #bmlTermsAndConditions .bmlTermsInnerWrap,.pageBmlTermsAndConditions #bmlTermsAndConditions.mobile .bmlTermsBody,.pageBmlTermsAndConditions #bmlTermsAndConditions.mobile .bmlTermsInnerWrap{height:auto}@media (min-width:30.0625em) and (max-width:41.25em){#bmlTermsAndConditions .bmlTermsInnerWrap{height:450px}#bmlTermsAndConditions #bmlAgreeToTermsSubmit{margin:0 30px 20px 0;float:none}#bmlTermsAndConditions .bmlTermsDirections{float:none;margin-bottom:10px}#bmlTermsAndConditions .printContent{float:none;margin-top:10px}.bmlTermsAndConditions #contents{padding:0}}@media (max-width:41.25em) and (min-width:0){#bmlTermsAndConditions #creditConfirmation .modal-wrap{padding:20px;width:80%;margin:0}}@media (min-width:30em) and (max-width:35em){.largeScreen.pageBmlTermsAndConditions .footer{padding:30px 5px 0}}@media (min-width:0) and (max-width:40em){.largeScreen.bmlTermsAndConditions .cancelUrl{display:none}.largeScreen.bmlTermsAndConditions .trayInner{padding:25px 30px}#bmlTermsAndConditions header{position:fixed;top:0;left:0;width:100%;z-index:3}#bmlTermsAndConditions .cancelLink{margin:0 0 20px;font-size:.86em}#bmlTermsAndConditions .printContent{float:none;margin-top:10px}#bmlTermsAndConditions .bmlTermsBody{height:auto;border:none;-webkit-overflow-scrolling:touch}#bmlTermsAndConditions .bmlTermsBody iframe{min-height:350px}#bmlTermsAndConditions h2{margin:0}#bmlTermsAndConditions .trayInner{padding:0;box-shadow:none}#bmlTermsAndConditions .trayInner.trayPaymentPlanDetails,#bmlTermsAndConditions .trayInner.trayTerms{padding:0}#bmlTermsAndConditions .bmlTermsHead{float:none;font-size:1.25em}#bmlTermsAndConditions .bmlTermsInnerWrap{height:auto}#bmlTermsAndConditions .bmlTermsHeader{margin:25px 0 0}#bmlTermsAndConditions .bmlTermsFooter{position:fixed;top:auto;bottom:-100%;min-height:0;padding:15px}#bmlTermsAndConditions .bmlTermsFooter.bmlFooterShow{bottom:0;transition:bottom .7s,0s ease}#bmlTermsAndConditions .bmlTermsFooter .bmlTermsDirections{width:100%;padding:0}#bmlTermsAndConditions .bmlTermsFooter .bmlTermsDirections p{margin:5px 0;text-align:center;line-height:1em;font-size:.8em}#bmlTermsAndConditions .bmlTermsFooter #bmlAgreeToTerms{width:100%;float:none;margin:0;display:none}#bmlTermsAndConditions .bmlTermsFooter.enabled{padding:10px}#bmlTermsAndConditions .bmlTermsFooter.enabled .bmlTermsDirections{display:none}#bmlTermsAndConditions .bmlTermsFooter.enabled #bmlAgreeToTerms{display:block}#bmlTermsAndConditions .bmlTermsBody,#bmlTermsAndConditions .trayPaymentPlanDetails{border:none}#bmlTermsAndConditions .termsTable{font-size:.9em}#bmlTermsAndConditions .learnMore{font-size:.8em}#bmlTermsAndConditions .trayInner{margin:0}#bmlTermsAndConditions .footer.inside,#bmlTermsAndConditions .footer.outside{display:none}}@media (min-width:41.3125em){.pageBmlTermsAndConditions .mobile .bmlTermsDirections{display:none}}.minibrowser .pageBmlTermsAndConditions #bmlTermsAndConditions .bmlTermsBody{margin:0}#creditoffer .cycoHeader{margin-bottom:5px}#creditoffer .mainDescription{color:#6c7378}#creditoffer .inputField input{height:40px}#creditoffer p{margin-bottom:5px}#creditoffer .ukOfferDescription{width:90%}#creditoffer .offerTitle{font-weight:700}#creditoffer .offerSmallText{width:100%;margin-bottom:0;font-size:1em}#creditoffer .moreInfoLink{padding:7px 33px 4px 18px;position:absolute;top:12px;right:0;color:#0070ba;cursor:pointer;font-weight:500}#creditoffer .noMargin{top:2px}#creditoffer .down{background-position:-219px -234px}#creditoffer .up{background-position:-219px -219px}#creditoffer .frontArrow{top:10px;right:0;width:22px}#creditoffer .bmlLender{font-size:.75em;margin-top:10px;color:#6c7378}#creditoffer .bmlMargin{margin-top:15px}#creditoffer .sameLine{display:inline}#creditoffer .payInFullLink{font-weight:700}#creditoffer .payInFullText{color:#6c7378}#creditoffer .buttons{width:100%;margin-top:10px;-ms-box-sizing:border-box;box-sizing:border-box;bottom:0}#creditoffer .btn{width:100%}#creditoffer .smallText{padding:3px 35px 0;font-size:.75em}#creditoffer .extendedOfferContent{display:inline-block;width:75%;padding:10px 0}#creditoffer .chooseOffer,#creditoffer .ukChooseOffer{width:25%;font-size:1em;display:inline-block;float:right;margin-bottom:0}#creditoffer .ukChooseOffer{margin-top:0}#creditoffer .terms{font-size:.85em;margin:0;font-weight:700}#creditoffer .installmentOfferWrapper,#creditoffer .sacOfferWrapper{margin-bottom:15px;margin-top:20px}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .installmentOfferWrapper .extendedSacCtaWrap,#creditoffer .installmentOfferWrapper .installmentCtaWrap,#creditoffer .installmentOfferWrapper .sacCtaWrap,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .sacOfferWrapper .extendedSacCtaWrap,#creditoffer .sacOfferWrapper .installmentCtaWrap,#creditoffer .sacOfferWrapper .sacCtaWrap{padding:20px;background-color:#f7f9fa;position:relative;border-radius:5px;background-clip:padding-box}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .extendedSacCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .installmentCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .sacCtaWrap .trayInner,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap .trayInner,#creditoffer .sacOfferWrapper .extendedSacCtaWrap .trayInner,#creditoffer .sacOfferWrapper .installmentCtaWrap .trayInner,#creditoffer .sacOfferWrapper .sacCtaWrap .trayInner{position:relative;margin:0;padding:0;background-color:transparent;overflow:hidden}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap{padding:0}#creditoffer .installmentOfferWrapper .extended,#creditoffer .sacOfferWrapper .extended{background-color:#fff;color:#6c7378;border:1px solid #e1e7eb}#creditoffer .installmentOfferWrapper .seeTermsWrap,#creditoffer .sacOfferWrapper .seeTermsWrap{padding:10px 0 10px 20px}#creditoffer .installmentOfferWrapper #extendedInstallmentOffer,#creditoffer .installmentOfferWrapper #extendedSacOffer,#creditoffer .sacOfferWrapper #extendedInstallmentOffer,#creditoffer .sacOfferWrapper #extendedSacOffer{margin-top:5px}#creditoffer .reverseOrder{display:table;width:100%}#creditoffer .reverseOrder .sacOfferWrapper{display:table-footer-group}#creditoffer .gceOffers .row-fluid .span12{width:49.9%}#creditoffer .gceOffers .row-fluid .span8{width:33.1%}#creditoffer .gceOffers .row-fluid .span6{width:24.8%}#creditoffer .gceOffers .row-fluid [class*=span]{margin-left:0}#creditoffer .gceOffers .postScriptCondition{clear:both;padding:10px 0 0;font-size:.73em}#creditoffer .gceOffers .span12.singleOffer{float:none}#creditoffer .gceOffers ul.installmentOptionsB{overflow:hidden;white-space:nowrap;border-radius:5px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner{padding:0;margin:0;background-color:#f7f9fa}#creditoffer .gceOffers ul.installmentOptionsB.trayInner.fullPageOffer{padding-bottom:20px;background-color:transparent}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .sacOffer{box-sizing:border-box;float:left;line-height:1.154em;list-style:outside none none;padding:20px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer{float:left;list-style:none;border-right:3px solid #fff;-ms-box-sizing:border-box;box-sizing:border-box;padding:15px 15px 0;line-height:1.154em}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form{position:relative;min-height:230px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.en{min-height:250px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.es,#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.fr,#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.zh{min-height:278px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer:last-child{border-right:none}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections{white-space:normal;margin:0;padding-bottom:10px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections li{list-style:none}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections li.offerHeading1{padding:0 0 5px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .theta{font-size:.85em}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .smallText{padding:3px 16px 0;font-size:.75em}#creditoffer .gceOffers .offerAmount{display:block;font-weight:700}#creditoffer .gceOffers .totalInstallment{margin:0 0 10px}#creditoffer .gceOffers .offerDetails{width:75%;white-space:normal;padding:10px 0 0}#creditoffer #creditExampleUK{margin:30px 0}#creditoffer #creditExampleUK .creditWorksTitle{margin-bottom:5px;color:#2c2e2f}#creditoffer #creditExampleUK .creditWorksDescription{color:#6c7378}#creditoffer #creditExampleUK .representativeExKey{font-size:.85em}#creditoffer #creditExampleUK .representativeExHeader{margin-top:-10px}#creditoffer #creditExampleUK .span6{text-align:center;margin:0}#creditoffer #creditExampleUK .representativeEx{margin:0 0 20px;list-style:none;padding:0;background:none;border-top:7px solid #e3e3e3;border-bottom:1px solid #e3e3e3}#creditoffer #creditExampleUK .representativeEx .creditExHeading{color:#6c7378}#creditoffer #creditExampleUK .representativeEx li{padding:10px 30px;vertical-align:middle;border-right:1px solid #e3e3e3;width:175px}#creditoffer #creditExampleUK .representativeEx li p{margin-bottom:5px}#creditoffer #creditExampleUK .representativeEx li .representativeExampleAPRAmount{margin:2px 0 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:700}#creditoffer #creditExampleUK .representativeEx li:last-child{border-right:none}#creditoffer .faq{text-align:center}@media (min-width:0) and (max-width:50em){#creditoffer .installmentOfferWrapper .installmentCtaWrap p,#creditoffer .installmentOfferWrapper .sacCtaWrap p,#creditoffer .sacOfferWrapper .installmentCtaWrap p,#creditoffer .sacOfferWrapper .sacCtaWrap p{width:52%}#creditoffer .buttons{position:absolute;top:40%;right:0;width:16px;height:16px;box-shadow:none;text-shadow:none;border:none;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -168px;text-indent:-200px;width:9px;height:18px}#creditoffer .buttons .btn{display:none}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span6,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span8,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span12,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span6,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span8,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span12{width:100%;border-right:none;border-bottom:1px solid #fff}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.trayInner li.offer,#creditoffer .gceOffers ul.installmentOptionsB.trayInner li.offer{padding:20px;border-bottom:5px solid #fff}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.trayInner li.offer form,#creditoffer .gceOffers ul.installmentOptionsB.trayInner li.offer form{min-height:0}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB ul.subSections,#creditoffer .gceOffers ul.installmentOptionsB ul.subSections{width:auto}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB ul.subSections:last-of-type,#creditoffer .gceOffers ul.installmentOptionsB ul.subSections:last-of-type{padding-bottom:0}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span6,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span8,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span12,#creditoffer .gceOffers ul.installmentOptionsB .span6,#creditoffer .gceOffers ul.installmentOptionsB .span8,#creditoffer .gceOffers ul.installmentOptionsB .span12{position:relative}#creditoffer .fourOffers .gceOffers .offerAmount,#creditoffer .gceOffers .offerAmount{display:inline}#creditoffer .fourOffers .gceOffers .offerDetails,#creditoffer .gceOffers .offerDetails{display:block;width:auto}#creditoffer #creditExampleUK .representativeEx li{padding:10px 30px 10px 0;vertical-align:middle;border-right:1px solid #e3e3e3;width:100%}}@media (min-width:0) and (max-width:50em) and only screen and (-webkit-min-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min--moz-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min-resolution:2dppx),(min-width:0) and (max-width:50em) and only screen and (min-resolution:192dpi){#creditoffer .buttons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.kmliCheckboxLabel{display:table-cell!important}.kmliHelpIcon{display:table-cell;vertical-align:top;padding:5px 0 0 5px}.inline-prop a{font-weight:700}.riskyTitle h1{max-width:inherit!important}.riskySubtitle p{color:#6c7378;font-size:15px!important}.singlePagePaymentForm .nationalID{width:100%!important;float:none}.singlePagePaymentForm .nationalID .custom-select>span{border-right:1px solid #c5ccd1;border-radius:5px 5px 5px 5px!important}.singlePagePaymentForm .nationalID .custom-select.active>span{border-right:1px solid #009cde}.singlePagePaymentForm .nationalIDValue{width:100%;float:none}.singlePagePaymentForm .additionalIDBox{border-radius:5px 5px 5px 5px!important}.nationalID{width:40%!important;float:left}.nationalID .custom-select>span{border-right:0;border-radius:5px 0 0 5px!important}.nationalID .custom-select.active>span{border-right:0}.nationalIDValue{width:60%;float:right}.additionalID{width:26%;float:left}.additionalID .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.additionalIDValue{width:74%;float:right}.additionalIDBox{border-radius:0 5px 5px 0!important;border-left:1px}.additionalIdHelper{position:relative;margin-left:5px;float:right}.additionalIdHelper .verifyHelp{display:inline-block;height:20px;width:20px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-164px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.additionalIdHelper .verifyHelp{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.additionalIdHelper:focus{background-position:-164px -44px}.lineSpacing{margin-top:10px}.xo-done #header,.xo-done #wrapper{max-width:480px}.xo-done #defaultCancelLink{width:0;height:0}.xo-done #stm-upsell-content{padding-bottom:10px}.xo-done .item-options{font-size:13px}.xo-done .item-selections{font-size:13px;color:#6c7378}.xo-done .item-selections .item-selection-name{font-weight:700}.xo-done .item-selections .item-selection-value{padding-right:1em}.xo-done .item-number-container{font-size:13px;margin-bottom:10px;color:#6c7378}.xo-done .item-number-container .item-number{word-wrap:break-word}.xo-done #transactionCart{display:none}.xo-done #contents{padding:0}.xo-done #circle{top:15px;right:-5px;margin:0 auto 30px;position:relative;width:90px;height:90px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/animation-checkmark.gif\");background-repeat:no-repeat;background-size:90px 90px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.xo-done #circle{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/animation-checkmark.gif\");background-size:90px 90px}}.xo-done #merchantReturnBtn{margin-top:10px}.xo-done #details-text{text-align:center;position:relative;z-index:1;font-size:15px;margin-top:16px;bottom:5px;color:#0070ba}.xo-done .receipt.basics{height:220px;width:auto;text-align:center;margin-bottom:-27.5px}.xo-done .receipt.basics #paid-text{text-align:center;font-size:24px;margin-bottom:10px;line-height:1.35}.xo-done .receipt.basics #merchant-text{text-align:center;font-size:13px}.xo-done .receipt.statement{font-size:10px}.xo-done .receipt.title{font-weight:700;margin-bottom:10px;margin-top:25px}.xo-done .row .currencyCode{font-size:11px;font-weight:400}.xo-done .essentials{margin:38px 30px 0}.xo-done .essentials.autoReturnSection{text-align:center;margin-bottom:38px}.xo-done .row{margin-bottom:10px}.xo-done .row div{margin-top:5px}.xo-done .amount{float:right;font-weight:500}.xo-done hr{height:1px}.xo-done .text div{margin-bottom:5px}.xo-done #receiptNumber{margin:10px 0}.xo-done .alert{color:#8a6d3b;background-color:#fcf8e3;margin:20px 10px;padding:5px;border:solid transparent;border-radius:4px}.xo-done .details-expand{margin-top:60px;margin-bottom:-57px;padding-bottom:1px;background:#f7f9fa;width:auto;max-height:0;overflow:hidden}.xo-done .details-expand,.xo-done .details-expand.expansion{-webkit-transition:max-height .5s ease-in;transition:max-height .5s ease-in}.xo-done .details-expand .grouping{border-bottom:1px double;border-color:#e3e3e3;padding:15px 0 5px}.xo-done .details-expand .totalAmount{border-bottom:20px transparent;margin:15px 0 20px}.xo-done .splash-receipt{padding-left:30px;padding-right:30px;margin-left:-30px;margin-right:-30px;margin-top:-1px;background-color:#f7f9fa;border-top:1px solid #e3e3e3;border-bottom:1px solid #e3e3e3}.xo-done .splash-receipt #details-button{margin:18px auto 0;position:relative;background:#f7f9fa;width:39px;height:39px;text-align:center;border-radius:100%;background-clip:padding-box;border-bottom:1px solid #e3e3e3;top:18px}.xo-done .splash-receipt #details-button .arrow{width:20px;height:16px;display:inline-block;position:absolute;top:17px;right:10px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.xo-done .splash-receipt #details-button .arrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.xo-done .splash-receipt #details-button .arrow.expand{background-position:-174px -144px}.xo-done .splash-receipt #details-button .arrow.collapse{background-position:-174px -156px}.xo-done .msg-warning .icon{background-position:-89px -22px;left:7px}.xo-done .footer{max-width:480px}@media (max-width:41.25em){.xo-done .splash-receipt{margin-left:0;margin-right:0}}@media (max-width:41.25em) and (min-width:30.0625em){.xo-done .merchantHeader,.xo-done header{display:block}.xo-done #wrapper{margin:0 auto;border:1px solid #e3e3e3}.xo-done .essentials{margin:38px 15px 0}.xo-done .essentials.autoReturnSection{text-align:center;margin-bottom:38px}.xo-done .copyright{float:none;width:auto}.xo-done .footerLinks{float:none;width:auto;text-align:center}.xo-done .footer{border:none;margin-top:0;padding-top:0}}[dir=rtl] .xo-done .amount{float:left}[dir=rtl] .xo-done .money-source{float:right}[dir=rtl] .xo-done #paid-text b{direction:ltr;unicode-bidi:bidi-override}.offerSmallText{line-height:1.35em;font-size:.75em}.bmlOfferText{font-size:1.15em}.seeTermsLink{margin-top:10px}.bmlTermsLink,.seeTermsLink a{font-weight:700}.bmlTermsLink{white-space:nowrap}.frontArrow{top:8px;right:0}.bmlChangeLink{position:absolute;top:0;right:0;font-size:.85em;cursor:pointer}.bmlExistingOfferText{font-size:medium;color:#2c2e2f;line-height:1.2em}.creditIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;min-width:65px;width:65px;height:37px;padding-right:5px;background-position:-25px -129px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.creditIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.cycoApplyLink{cursor:pointer;position:absolute;top:-9px;right:0;padding:7px 10px 4px;font-size:.85em}.installmentDescription{width:70%!important}.nowrap{white-space:nowrap}#bmlAcqOfferProminent .bmlApplyLink,#bmlAcqOfferProminent .bmlChangeLink,#bmlExistingOfferProminent .bmlApplyLink,#bmlExistingOfferProminent .bmlChangeLink{position:static;float:right}#bmlAcqOfferProminent .acquisitionBannerLeft{display:inline-block}#bmlAcqOfferProminent .acquisitionBannerRight .bmlOfferTitle{max-width:100%;margin-right:0;margin-bottom:0}#bmlAcqOfferProminent .seeTermsLink{margin-top:0}@media (max-width:850px){.prominentBanner .acquisitionBannerRight .bmlOfferTitle{max-width:250px}}.prominentBanner .bmlOfferText{display:none}.prominentBanner .acquisitionBannerRight .bmlOfferTitle{width:auto;margin-right:80px}.prominentBanner .prominentBannerIcon{display:inline-block}.prominentBanner .prominentBannerIcon img{width:70px;height:auto}.prominentBanner .prominentBannerSeparator{display:block;text-align:center;color:#6c7378;font-size:14px;line-height:14px;position:relative;margin-bottom:20px}.prominentBanner .prominentBannerSeparator .prominentBannerSeparatorLine{height:1px;width:100%;background-color:#dbdbdb;position:absolute;left:0;padding:0;top:50%;z-index:-1}.prominentBanner .prominentBannerSeparator .prominentBannerSeparatorWord{background:#fff;padding:0 20px}#installmentOffer{background-color:#f5f7fa;padding:10px;overflow:hidden}#installmentOffer .acquisitionBannerLeft{float:left;width:50%}#installmentOffer .acquisitionBannerLeft .creditIcon{bottom:0;right:0}#installmentOffer .offerText{position:inherit;font-size:13px;padding-left:5px}#installmentOffer .offerText p{width:90%}#bmlOffer .acquisitionBannerSeparator{display:none}#bmlOffer .acquisitionBannerRight .bmlOfferTitle{width:auto;margin-right:80px}#bmlOffer .creditIcon{bottom:0;right:0}#bmlOffer .offerText{position:inherit;font-size:13px;padding-left:5px}#bmlOffer .offerText p{width:90%}.passiveBanner .payWithOptionIcon{background:none}.payWithOption{position:relative}.payWithOption:last-child{margin-bottom:20px}.payWithOption a{cursor:pointer}.payWithOption .plusicon{top:0;left:4px;cursor:pointer}.payWithOption .plusicon:hover+div .name{text-decoration:underline}.payWithOption .payWithOptionBody{padding-left:35px;display:table}.payWithOption .payWithOptionBody>*{display:table-cell;vertical-align:top}.payWithOption .payWithOptionIcon{width:33px;cursor:pointer}.payWithOption .payWithOptionIcon:hover+div .name{text-decoration:underline}.payWithOption .payWithOptionIcon .fsIcon{position:static;margin-left:2px}.payWithOption .payWithOptionIcon img{width:32px;height:auto;margin-left:2px}.payWithOption .payWithOptionContent{padding-left:12px}.payWithOption .payWithOptionContent>*{line-height:normal}.payWithOption .payWithOptionDetails{font-size:.85em;color:#6c7378;text-decoration:none}.payWithOption .payWithOptionTerms{font-size:.75em;color:#6c7378;text-decoration:none}.payWithOption .payWithOptionTermsLink{font-weight:700;font-size:.75em}#selectFunding #bmlReuseOfferInfo{margin-left:40px}#selectFunding #bmlReuseOfferInfo .seeTermsLink{display:none}#bmlReuseOfferInfo{font-size:.85em;line-height:1em}.multipleFi #bmlReuseOfferInfo{margin-left:46px}.singleFi #bmlReuseOfferInfo{margin-left:41px}#bmlReuseOfferInfo .offerInfo{color:#6c7378}#bmlReuseOfferInfo .seeTermsLink{color:#0070ba;font-weight:700}#xoSelectFi .creditBanner{margin-top:20px;margin-bottom:0}#xoSelectFi .creditBanner .bmlCtaWrap{margin-bottom:0}.light-box-3ds .light-box{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}.light-box-3ds .light-box-header{font-size:24px;font-weight:lighter;font-family:HelveticaNeue-Light,arial,sans-serif;line-height:1.2em;margin-top:40px}.light-box-3ds .close{top:20px;right:20px;font-size:0}.light-box-3ds .close:hover{background-position:-223px -22px;text-decoration:none}.light-box-3ds .light-box.mask{background:#cbd2d6;opacity:.7}.light-box-3ds .light-box-iframe{height:450px;width:450px;border:1px solid #999;border-radius:5px;background-clip:padding-box;border-radius:0}.light-box-3ds .light-box.wrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:90px 85px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.light-box-3ds .light-box.wrapper .logo{margin:30px auto;width:29px;height:29px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.light-box-3ds .light-box.wrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.light-box-3ds .light-box-container{width:450px;display:block}.light-box-3ds .light-box.open .light-box.wrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}.light-box-3ds body.loading .light-box .aside{opacity:.1}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.light-box-3ds .light-box.wrapper{width:100%;padding:0 15px}.light-box-3ds .light-box.wrapper .light-box.container{width:auto;margin-top:30px}}@media only screen and (max-width:480px){.light-box-3ds .light-box-container,.light-box-3ds .light-box-iframe{width:100%}}.upsellMask,.upsellWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}.upsellMask_white{background:#fff;opacity:.7}.upsellMask{background:#cbd2d6;opacity:.7}.whiteNoBlur{background:#fff;width:620px}.whiteNoBlur .cancel{margin-top:35px}.whiteWithBlur{background:#f7f9fa;width:100%}.whiteWithBlur .fill{min-height:125px;width:375px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/Static_OT_Interstitial_grey@1x.png\") no-repeat}.whiteWithBlur .cancel{margin-top:35px}.blackWithBlur{background:#555;width:100%;color:#fff}.blackWithBlur .fill{min-height:125px;width:375px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/Static_OT_Interstitial_darkgrey@1x.png\") no-repeat}.blackWithBlur .cancel{padding-top:13px;padding-bottom:13px;border-radius:4px;border:1px solid #979797;margin-top:15px}.blackWithBlur .cancel>a{color:#fff}.blackWithBlur #pp_min_logo{position:relative;width:29px;height:29px;margin:0 auto;background-position:0 0;background-size:29px 29px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/PayPal_Mark_Rev_White@1x.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.blackWithBlur #pp_min_logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/PayPal_Mark_Rev_White@2x.png\");background-size:21px 25px}}.upsellWrapper{-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:90px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.upsellWrapper .logo{position:relative;width:29px;height:29px;margin:0 auto;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.upsellWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.upsellContainer{width:380px;display:block;min-height:100%;height:auto!important;height:100%;margin:0 auto -50px}.upsellContainer .pushLogo{height:60px}.upsellContainer .promoHeading{line-height:1.28;font-size:1.2em;margin-left:25px;margin-right:25px}.upsellContainer .cancel{text-align:center}.upsellContainer .buttons{margin-top:35px}.upsellContainer .promo{margin-top:25px;margin-left:25px;margin-right:25px;line-height:17px}.upsellContainer .promo .text{margin-left:74px;font-size:.86em}.upsellContainer .promo .icon.password:before{position:absolute;content:\"\";width:46px;height:19px;margin-top:18px;line-height:1.31em;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1.png\");background-repeat:no-repeat;background-position:-128px -82px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.upsellContainer .promo .icon.password:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1_2x.png\");background-size:257px 209px}}.upsellContainer .promo .icon.merchants:before{position:absolute;content:\"\";width:37px;height:34px;margin:5px 0 0 5px;line-height:1.31em;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1.png\");background-repeat:no-repeat;background-position:-129px -111px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.upsellContainer .promo .icon.merchants:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1_2x.png\");background-size:257px 209px}}.upsellContainer .promo .icon.secure:before{position:absolute;content:\"\";width:27px;height:39px;margin:5px 0 0 11px;line-height:1.31em;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1.png\");background-repeat:no-repeat;background-position:-128px -155px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.upsellContainer .promo .icon.secure:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1_2x.png\");background-size:257px 209px}}.upsellContainer .leftIcon:before{position:absolute;content:\"\";width:12px;height:22px;display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1.png\");background-repeat:no-repeat;background-position:-66px -123px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.upsellContainer .leftIcon:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_hermes_icons_v1_2x.png\");background-size:257px 209px}}.upsellOpen .upsellWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}.kmliUpsell #spinner{top:0;left:0}body.loading.kmliUpsellActive #main{opacity:1}body.loading.kmliUpsellActive .kmliUpsell .aside{opacity:.1}@media (max-width:41.25em) and (orientation:landscape),(min-width:0) and (max-width:30em){.upsellWrapper{width:100%;padding:0 25px}.upsellWrapper .upsellContainer{width:auto;margin-top:5px}}.logo{position:relative;width:29px;height:29px;margin:0 auto;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.pushLogo{height:30px}.spinnerBtn .spinner{margin:8px 0 0;height:25px;width:25px;position:static;display:inline-block;z-index:10;padding:0;background-color:transparent;border-width:1.5px;border-style:solid;border-radius:100%;border-color:#009cde #fff #fff;top:0;left:50%;opacity:1;filter:alpha(opacity=100);-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear}.loading #main{opacity:.1}.spinner{height:100%;width:100%;position:absolute;top:0;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .loadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100;outline:none}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.props .vprop-header{font-size:1.6em;color:#2c2e2f;margin:15px 0 10px;font-weight:lighter;line-height:1.2em}.props .prop-img{background-position:center 0}.props.login{padding:0 10px 0 0}.props.login .prop-img{height:104px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png\");background-repeat:no-repeat;margin-top:20px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.login .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v2_2x.png\");background-size:195px 104px}}.props.review .prop-img{height:92px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.review .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags_2x.png\");background-size:206px 92px}}.props.signature .prop-img{height:200px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_ballon.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.signature .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_ballon_2x.png\");background-size:250px 200px}}.props.addTaxId .prop-img{height:104px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png\");background-repeat:no-repeat;margin-top:-25px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.props.addTaxId .prop-img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v2_2x.png\");background-size:195px 104px}}.props li,.props p{color:#757575;font-size:.9em;font-weight:400;line-height:1.35em;margin:5px 0}.props li a,.props p a{font-weight:700}.errorTooltip{background-color:#c72e2e;border-radius:5px;color:#fff;display:none;padding:7px;position:absolute;top:49px;z-index:2;font-size:.8em}.errorTooltip.fixed{position:relative;top:0;margin-bottom:10px}.errorTooltipRequired{z-index:3}.validated .ng-invalid:focus~.errorTooltipRequired~.errorTooltipRuleSpecific,.validated .ng-invalid:focus~.errorTooltipRuleSpecific{display:block!important}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~.errorTooltipRuleSpecific,.validated .ignoreValidation input[type=checkbox].ng-invalid~.errorTooltipRuleSpecific,.validated .ng-invalid-required:focus~.errorTooltipRequired~.errorTooltipRuleSpecific,.validated .ng-invalid-required:focus~.errorTooltipRuleSpecific{display:none!important}.validated .ng-invalid-required:focus:not([type=checkbox])~.errorTooltipRequired,.validated input[type=checkbox].ng-invalid.hasErrorTooltipRuleSpecific:focus~.errorTooltipRuleSpecific,.validated input[type=checkbox].ng-invalid:focus:not(.hasErrorTooltipRuleSpecific)~.errorTooltipRequired{display:block!important}.validated input[type=checkbox].ng-invalid+.errorTooltipRequired+.errorTooltipRuleSpecific,.validated input[type=checkbox].ng-invalid+.errorTooltipRuleSpecific{top:35px;left:-20px}.validated .errorTooltip:empty{display:none!important}.backendError:focus~.errorTooltipRuleSpecific{display:block}.custom-select-container>select.backendError+span.custom-select>span,.inputField input.backendError,.validated .ng-invalid,.validated input.ng-invalid:active,.validated input.ng-invalid:focus,input.backendError{border:1px solid #c72e2e}.toolTip{display:none;font-size:.8em;color:#2c2e2f}.toolTip.balloon{position:absolute;z-index:2;padding:7px;text-align:left;border:1px solid #e1e7eb;border-radius:5px;background:#e1e7eb}.toolTip.displayInline{font-size:.9em;padding:10px 30px;font-size:.85em}.highZindexTooltip .toolTip.balloon{z-index:3}.left{left:0}.right{right:0}#notifications{position:relative}.aside #notifications{width:100%;box-sizing:border-box}.msgPage{padding:7px 0 8px;font-size:.85em}.msgPage ul{margin:0;padding-left:25px;list-style:none}.msgPage ul li{line-height:1.35em;margin:1px 8px}.msg-desc,.msg-error,.msg-info,.msg-success,.msg-warning{color:#c72e2e}.msg-desc .icon,.msg-error .icon,.msg-info .icon,.msg-success .icon,.msg-warning .icon{display:inline-block;width:21px;height:18px;position:absolute;left:0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-63px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.msg-desc .icon,.msg-error .icon,.msg-info .icon,.msg-success .icon,.msg-warning .icon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.msg-info{background-color:#636b6d;border:1px solid #636b6d;color:#fff}.msg-info .icon{background-position:-139px -22px;left:9px}.msg-warning .icon{background-position:-90px -22px;left:9px}.msg-warning,.msg-warning ul li{background-color:#ffad37;color:#5b3300;border:none}.msg-success{padding:5px;background-color:#8fcf8a;border:1px solid #8fcf8a;color:#295425}.msg-success .icon{background-position:-114px -22px;left:10px}.msg-desc{background-color:#fff;border:1px solid #e3e3e3;color:#636b6d}.msg-desc .icon{background-position:-139px -1px;left:9px}.msg-normal{padding:15px 0 0}.msg-normal ul,.msg-normal ul li{color:#636b6d;padding-left:0;margin-left:0;font-size:1.03em;width:100%}@media (max-width:30em) and (min-width:0){#notifications{width:100%}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.review #notifications{width:100%}}.languageToggleDisplay{text-decoration:none;font-size:15px;position:absolute;bottom:17px;right:0}.languageToggleDisplay .changeLanguage{display:inline-block;margin:5px 0 0 5px;width:12px;height:7px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-23px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.languageToggleDisplay .changeLanguage{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.languageToggleDisplay .changeLanguage.expand{background-position:-23px -10px}.languageToggleDisplay .displayText{margin-right:2px}.languageToggleDisplay a{cursor:pointer}.languageToggleDisplay a:focus,.languageToggleDisplay a:hover{outline:none;text-decoration:none;border-bottom:1px solid #0070ba;padding-bottom:4px}.footer .languageToggleDisplay{position:static;display:inline-block;font-size:13px}.footer .languageToggleDisplay span{position:relative}.footer .languageToggleDisplay #langDropdownBlock{right:0;margin-bottom:25px}@media (min-width:30.0625em) and (max-width:41.25em){.languageToggleDisplay .popover{left:auto;top:46px;right:3px}}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){.languageToggleDisplay .popover{left:auto;top:50px;right:-6px}}@media (min-width:41.3125em){.pageLogin .languageToggleEnabled .languageToggle.outside{display:block;position:relative;width:100%;max-width:780px;margin:10px auto 0}#login .languageToggle{display:block}}#langDropdownBlock{position:absolute;z-index:10;background:#fff;border:1px solid #ccc;border-radius:6px;margin-top:15px;right:-15px;min-width:100px;background-clip:padding-box;box-shadow:0 5px 10px rgba(0,0,0,.2);white-space:normal;text-align:left}#langDropdownBlock ul{list-style:outside none disc;margin:0;padding:9px 14px}#langDropdownBlock ul li{list-style-type:none;padding:5px 0;white-space:nowrap}#langDropdownBlock>.arrow,#langDropdownBlock>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}#langDropdownBlock>.arrow{border-width:11px}#langDropdownBlock>.arrow:after{border-width:10px;content:\"\"}#langDropdownBlock.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}#langDropdownBlock.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}#langDropdownBlock.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}#langDropdownBlock.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}#langDropdownBlock.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}#langDropdownBlock.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}#langDropdownBlock.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}#langDropdownBlock.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.cartContainer{float:left;display:block;width:184px}.formatCurrency{display:inline-block}.cartContainer .hasAmount .cartIcon{margin-right:6px}.cartContainer .hasAmount .pointer{right:57px}.transactionDetailsContainer{border-radius:5px 5px 0 0;background-clip:padding-box;-webkit-tap-highlight-color:rgba(0,0,0,.2)}.transactionDetailsContainer.cart #transactionCart{border-bottom:0 none;border-color:#ddd #ddd -moz-use-text-color}.transactionDetailsContainer.cart #transactionCart .arrow{background-position:-23px -10px}.transactionDetailsContainer.cart .transctionCartDetails{visibility:visible}.transactionDetailsContainer .merchantName{width:calc(92% - 36px);min-height:17px;padding:15px 15px 10px;line-height:1.35em;font-size:13px;margin-top:0;margin-bottom:0}.transactionDetailsContainer .merchantTitle{margin-bottom:-3px}.transactionDetailsContainer .note{color:#6c7378;font-size:12px;line-height:1.35em;padding:0 15px 1em;margin-bottom:0;text-overflow:ellipsis;overflow:hidden}.transactionDetailsContainer .note.noteHighlighted{font-size:13px;padding-top:10px;padding-bottom:10px;color:#6c7378;background-color:#f1f4f5;border-radius:0 0 5px 5px;background-clip:padding-box}.transactionDetails{display:block;padding-right:1px;margin:0 auto;overflow:auto;color:#393f44}.transactionDetails:focus,.transactionDetails:hover{text-decoration:none;background-image:none;color:#6c7378;overflow:visible}.transactionDetails:focus .totalWrapper,.transactionDetails:hover .totalWrapper{overflow:visible}.transactionDetails:focus .totalWrapper #transactionCart,.transactionDetails:hover .totalWrapper #transactionCart{border-bottom:1px solid #2c2e2f;margin-bottom:-1px}.transactionDetails:active{background-image:none}.transactionDetails:active #yourCart{background-position:5px -95px}#transactionCart.hasItems:focus,#transactionCart.hasItems:hover{-webkit-opacity:.7;-moz-opacity:.7;opacity:.7;filter:alpha(opacity=70)}.totalWrapper{display:block;overflow:auto}.hasNoItems .totalWrapper{background-image:none}#yourCart{float:left;left:0}#transactionCart{float:right;z-index:1;padding:8px 0 0;margin-bottom:0;border-bottom:0;-ms-box-sizing:border-box;box-sizing:border-box;border-color:#ddd;font-size:1em;font-weight:700;text-align:right;color:#2c2e2f;text-shadow:1px 1px 1px #fff;background-size:24px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#transactionCart:active{background-position:right -290px}#transactionCart .cartIcon{display:inline-block;width:15px;height:14px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#transactionCart .cartIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#transactionCart .arrow{display:inline-block;margin:5px 0 0 5px;width:12px;height:10px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-23px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#transactionCart .arrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#transactionCart span{vertical-align:middle}#transactionCart format-currency span{vertical-align:inherit}#transactionCart format-currency span .currencyCode{font-size:1em}@-moz-document url-prefix(){#transactionCart .cartIcon{margin-top:-2px}}.transctionCartDetails{position:relative;overflow:hidden;visibility:hidden;padding-bottom:0;-webkit-transition:max-height .7s ease;transition:max-height .7s ease}.transctionCartDetails .pointer{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_flyoutArrow_up_2x.png\") no-repeat scroll 0 0 transparent;height:10px;position:absolute;right:38px;top:0;width:34px}.details{-ms-box-sizing:border-box;box-sizing:border-box;background:#fff;border-radius:5px;background-clip:padding-box;box-shadow:1px 1px 1px 0 #ccc;max-height:450px}.details ul{list-style-type:none;margin:0;font-size:.85em;background-color:#f1f4f5}.details ul.detail-items>li{padding-top:0;padding-bottom:10px;min-height:0}.details ul.itemDetails{width:100%;font-size:1em;max-height:none;margin:0;padding:0}.details ul.itemDetails>li{padding:0;color:#6c7378;border:none;line-height:16px;margin:10px 0 0}.details ul.itemDetails>li .item-selections{font-size:13px}.details ul.itemDetails>li .item-selection-name{font-weight:700}.details ul.itemDetails>li .item-selection-value{padding-right:1em}.details li{margin:0;padding:5px 15px;overflow:auto;line-height:16px;border-bottom:1px solid #ccc}.details li:last-of-type{border-bottom:none}.details li.actions{margin:15px;padding:10px 1px 10px 15px;border-top:1px solid #ccc;border-radius:0 0 5px 5px;background-clip:padding-box;text-align:right}.details a.less,.details a.more{cursor:pointer}.details a.more{display:inline-block;float:right}.details a.more.inline-more{display:inline;float:none}.details ul.detail-extras{border-top:1px solid #ccc;padding-top:10px;padding-bottom:15px}.details ul.detail-extras .itemNameContainer,.details ul.detail-extras .itemPrice{margin-top:5px}.details ul.detail-extras li{overflow:hidden;line-height:normal;border-bottom:0;padding-top:0;padding-bottom:0}.details div.subTotal{font-size:.85em;background-color:#f1f4f5;padding:5px 15px 15px;margin-top:0;font-weight:700;border-top:1px solid #ccc;height:auto;line-height:1;border-radius:0 0 5px 5px;background-clip:padding-box}.scrollable-middle{overflow:auto}.notes{font-weight:400;margin-top:3px;line-height:100%;width:100%;overflow:hidden;min-height:1em;white-space:nowrap;text-overflow:ellipsis}.itemNameContainer{display:inline-block;width:60%;min-height:1em;vertical-align:top;margin-top:10px}.itemName{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:block;margin-bottom:0}.expanded .itemName{text-overflow:clip;line-height:16px;white-space:normal}.itemPrice{margin-top:10px;width:38%;overflow:hidden;font-size:1em;text-align:right;white-space:nowrap;text-overflow:ellipsis;-webkit-font-feature-settings:\"tnum\";display:inline-block;vertical-align:top}.currencyCode{float:left;margin-top:5px;font-size:.8em;text-align:right;float:none}#transactionDetails.cart .hasNoItems,.hasNoItems.transactionDetails,.hasNoItems.transactionDetails:active,.hasNoItems.transactionDetails:focus{float:right;background:none;border:none;box-shadow:none;cursor:default}#transactionDetails.cart .hasNoItems #yourCart,.hasNoItems.transactionDetails #yourCart,.hasNoItems.transactionDetails:active #yourCart,.hasNoItems.transactionDetails:focus #yourCart{display:none}#transactionDetails.cart .hasNoItems #transactionCart,.hasNoItems.transactionDetails #transactionCart,.hasNoItems.transactionDetails:active #transactionCart,.hasNoItems.transactionDetails:focus #transactionCart{padding:8px 0 0 30px;width:auto}#transactionDetails.cart .hasNoItems #transactionCart .arrow,.hasNoItems.transactionDetails #transactionCart .arrow,.hasNoItems.transactionDetails:active #transactionCart .arrow,.hasNoItems.transactionDetails:focus #transactionCart .arrow{display:none}#transactionDetails.cart .hasNoItems #transactionCart:focus,#transactionDetails.cart .hasNoItems #transactionCart:hover,.hasNoItems.transactionDetails #transactionCart:focus,.hasNoItems.transactionDetails #transactionCart:hover,.hasNoItems.transactionDetails:active #transactionCart:focus,.hasNoItems.transactionDetails:active #transactionCart:hover,.hasNoItems.transactionDetails:focus #transactionCart:focus,.hasNoItems.transactionDetails:focus #transactionCart:hover{text-decoration:none;background-image:none;color:#393f44}#transactionDetails.cart .hasNoItems #transactionCart .cartIcon,.hasNoItems.transactionDetails #transactionCart .cartIcon,.hasNoItems.transactionDetails:active #transactionCart .cartIcon,.hasNoItems.transactionDetails:focus #transactionCart .cartIcon{background-position:0 0}#closeCart{position:static;float:right;width:10px;height:10px;margin:15px 15px 0 0;padding:5px;border-radius:3px;cursor:pointer}#closeCart:before{content:\"\";position:absolute;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-44px 0;width:10px;height:11px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#closeCart:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#closeCart:focus:before,#closeCart:hover:before{background-position:-44px -15px}.largeScreen .transactionDetails{float:right;margin:0}.largeScreen #transactionDetails{position:relative}.largeScreen #transactionDetails .transctionCartDetails{clear:both}.cartContainer{float:right}.transctionCartDetails{position:absolute;right:43.42553193%;width:320px}.paypalCredit .transctionCartDetails{right:0}.details{margin:10px;box-shadow:0 1px 4px 1px rgba(0,0,0,.3);-webkit-box-shadow:0 1px 2px 1px rgba(0,0,0,.3);-moz-box-shadow:0 1px 2px 1px rgba(0,0,0,.3);list-style-type:none}@media (max-width:41.3125em){.cartContainer{display:block;position:absolute;right:15px;top:10px;z-index:151;width:160px}.minibrowser .cartContainer{right:0}.transctionCartDetails{left:auto;right:0;width:320px}.cartVerB header .cartContainer{display:block}.cartVerB #main .cartContainer{display:none}.incontext .paypalHeaderWrapper .cartContainer{right:35px;top:12px;margin-top:10px;margin-right:41px}.incontext .paypalHeaderWrapper .transctionCartDetails{width:350px}.incontext .cartContainer.hidePayPalLogo{right:214px}.incontext .viewTypeOnePage .hidePayPalLogo .transctionCartDetails{left:-15px}.incontext .viewTypeOnePage .hidePayPalLogo .transctionCartDetails .pointer{right:300px}}@media (min-width:0) and (max-width:30em){.cartContainer{right:0;top:15px}#closeCart{right:20px}.transactionDetails{padding-right:0}}.modal-wrapper .modal-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:#000;opacity:.8;z-index:150}.modal-wrapper .modal-dialog{overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal-wrapper .modal-content{display:block;position:absolute;left:50%;top:45%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.modal-wrapper .modal-default{height:auto;width:200px;padding:30px;background-color:#fff;background-clip:padding-box}.modal-wrapper .modal-default .close{position:absolute;top:15px;right:20px;width:19px;height:19px;padding:0;font-size:0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.modal-wrapper .modal-default .close{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.modal-wrapper .modal-default .close:focus,.modal-wrapper .modal-default .close:hover{background-position:-223px -22px;text-decoration:none}.modal-wrapper .popLink{word-break:break-all;font-size:.8em}@media (min-height:0) and (max-height:500px){.modal-wrapper .modal-content{top:60%}}@media (min-height:500px) and (max-height:700px){.modal-wrapper .modal-content{top:50%}}@font-face{font-family:consumer-icons;src:url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-4-0/fonts/ConsumerIcons-Regular.eot\");src:url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-4-0/fonts/ConsumerIcons-Regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-4-0/fonts/ConsumerIcons-Regular.woff\") format(\"woff\"),url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-4-0/fonts/ConsumerIcons-Regular.ttf\") format(\"truetype\"),url(\"https://www.paypalobjects.com/ui-web/iconfont-consumer/3-4-0/fonts/ConsumerIcons-Regular.svg#69ac2c9fc1e0803e59e06e93859bed03\") format(\"svg\");font-style:normal;font-weight:400}.icon{font-family:consumer-icons;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-small:before{font-size:1.58rem}.icon-medium:before{font-size:2.6rem}.icon-large:before{font-size:7.8rem}.icon-burger-small:before{content:\"\\E000\"}.icon-slider-small:before{content:\"\\E001\"}.icon-slider-half-small:before{content:\"\\E002\"}.icon-close-small:before{content:\"\\E003\"}.icon-add-small:before{content:\"\\E004\"}.icon-arrow-down-small:before{content:\"\\E005\"}.icon-arrow-up-small:before{content:\"\\E006\"}.icon-arrow-left-small:before{content:\"\\E007\"}.icon-arrow-right-small:before{content:\"\\E008\"}.icon-arrow-down-half-small:before{content:\"\\E009\"}.icon-arrow-up-half-small:before{content:\"\\E010\"}.icon-arrow-left-half-small:before{content:\"\\E011\"}.icon-arrow-right-half-small:before{content:\"\\E012\"}.icon-clear-half-small:before{content:\"\\E013\"}.icon-checkmark-small:before{content:\"\\E014\"}.icon-checkmark-small-bold:before{content:\"\\E015\"}.icon-action-arrow-half-small:before{content:\"\\E016\"}.icon-tooltip-outline-small:before{content:\"\\E017\"}.icon-tooltip-small:before{content:\"\\E018\"}.icon-info-small:before{content:\"\\E019\"}.icon-positive-small:before{content:\"\\E020\"}.icon-attention-small:before{content:\"\\E021\"}.icon-critical-small:before{content:\"\\E022\"}.icon-info-large:before{content:\"\\E023\"}.icon-positive-large:before{content:\"\\E024\"}.icon-attention-large:before{content:\"\\E025\"}.icon-critical-large:before{content:\"\\E026\"}.icon-pp-logo:before{content:\"\\E029\"}.icon-visa-logo:before{content:\"\\E030\"}.icon-mastercard-logo:before{content:\"\\E031\"}.icon-maestro-logo:before{content:\"\\E032\"}.icon-amex-logo:before{content:\"\\E033\"}.icon-discover-logo:before{content:\"\\E034\"}.icon-card-half-solid:before{content:\"\\E035\"}.icon-bank-half-solid:before{content:\"\\E036\"}.icon-profile-large:before{content:\"\\E037\"}.icon-profile-add-large:before{content:\"\\E038\"}.icon-notification-small:before{content:\"\\E039\"}.icon-settings-small:before{content:\"\\E040\"}.icon-profile-small:before{content:\"\\E041\"}.icon-funnel-small:before{content:\"\\E042\"}.icon-delete-small:before{content:\"\\E043\"}.icon-edit-small:before{content:\"\\E044\"}.icon-lock-small:before{content:\"\\E045\"}.icon-pdf-small:before{content:\"\\E046\"}.icon-contact-small:before{content:\"\\E047\"}.icon-undo-small:before{content:\"\\E048\"}.icon-cancel-small:before{content:\"\\E049\"}.icon-simple-list-small:before{content:\"\\E050\"}.icon-detailed-list-small:before{content:\"\\E051\"}.icon-print-small:before{content:\"\\E052\"}.icon-camera-small:before{content:\"\\E053\"}.icon-info-outline-small:before{content:\"\\E054\"}.icon-us-dollar-outline-small:before{content:\"\\E055\"}.icon-calendar-half-small:before{content:\"\\E056\"}.icon-hiper-logo:before{content:\"\\E057\"}.icon-hipercard-logo:before{content:\"\\E058\"}.icon-elo-logo:before{content:\"\\E059\"}.icon-star-small:before{content:\"\\E060\"}.icon-jcb-logo:before{content:\"\\E061\"}.icon-attention-outline-small:before{content:\"\\E062\"}.icon-unionpay-logo:before{content:\"\\E063\"}.icon-search-small:before{content:\"\\E064\"}.icon-desktop-small:before{content:\"\\E065\"}.icon-mobile-small:before{content:\"\\E066\"}.icon-laptop-small:before{content:\"\\E067\"}.icon-tablet-small:before{content:\"\\E068\"}.icon-send-money:before{content:\"\\E500\"}.icon-request-money:before{content:\"\\E501\"}.icon-photo:before{content:\"\\E502\"}.icon-gift-cards:before{content:\"\\E503\"}.icon-credit-card:before{content:\"\\E504\"}.icon-truck:before{content:\"\\E505\"}.icon-email:before{content:\"\\E506\"}.icon-email-solid:before{content:\"\\E507\"}.icon-bank-check:before{content:\"\\E508\"}.icon-calendar:before{content:\"\\E509\"}.icon-holiday:before{content:\"\\E510\"}.icon-gift:before{content:\"\\E511\"}.icon-wallet:before{content:\"\\E512\"}.icon-play-video:before{content:\"\\E513\"}.icon-heart:before{content:\"\\E514\"}.icon-shield:before{content:\"\\E515\"}.icon-tunes:before{content:\"\\E516\"}.icon-invoice:before{content:\"\\E517\"}.icon-shopping-bag:before{content:\"\\E518\"}.icon-phone:before{content:\"\\E519\"}.icon-phone-solid:before{content:\"\\E520\"}.icon-tag:before{content:\"\\E521\"}.icon-delivery:before{content:\"\\E522\"}.icon-questionmark:before{content:\"\\E523\"}.icon-cut-coupons:before{content:\"\\E524\"}.icon-register:before{content:\"\\E525\"}.icon-house:before{content:\"\\E526\"}.icon-gift-card:before{content:\"\\E527\"}.icon-messages:before{content:\"\\E528\"}.icon-add-money:before{content:\"\\E529\"}.icon-send-check:before{content:\"\\E530\"}.icon-paypal-me:before{content:\"\\E531\"}.icon-pp-logo-outline:before{content:\"\\E532\"}.icon-money-bag:before{content:\"\\E533\"}.icon-chip-pin:before{content:\"\\E534\"}.icon-boleto-ready:before{content:\"\\E535\"}.icon-boleto-topup:before{content:\"\\E536\"}.icon-clock-pay:before{content:\"\\E537\"}.icon-speeding-cart:before{content:\"\\E538\"}.icon-international-transfer:before{content:\"\\E539\"}.icon-link-small:before{content:\"\\E540\"}.fiIconsGroup .cardIconsGroup{border-radius:4px;padding:10px 13px;height:20px;margin-bottom:10px}.fiIconsGroup .cardIconsGroup .cardIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v10_2x.png\") no-repeat 0 100px;background-size:31px;height:20px;float:left;width:32px;padding:0 4px 0 0}.fiIconsGroup .cardIconsGroup .cardIcon.ELO{background-position:0 -713px}.fiIconsGroup .cardIconsGroup .cardIcon.CUP{background-position:0 -837px}.fiIconsGroup .cardIconsGroup .cardIcon.VISA{background-position:0 -31px}.fiIconsGroup .cardIconsGroup .cardIcon.MASTERCARD{background-position:0 -62px}.fiIconsGroup .cardIconsGroup .cardIcon.HIPER{background-position:0 -682px}.fiIconsGroup .cardIconsGroup .cardIcon.HIPERCARD{background-position:0 -744px}.fiIconsGroup .cardIconsGroup .cardIcon.AMEX{background-position:0 -93px;margin-right:-10px}.fiIconsGroup .cardIconsGroup .cardIcon.JCB{background-position:0 -527px}.fiIconsGroup .cardIconsGroup .cardIcon.ELECTRON{background-position:0 -217px}.fiIconsGroup .cardIconsGroup .cardIcon.MAESTRO,.fiIconsGroup .cardIconsGroup .cardIcon.SWITCH{background-position:0 -248px}.fiIconsGroup .cardIconsGroup .cardIcon.DISCOVER{background-position:0 -124px}.fiIconsGroup .cardIconsGroup .cardIcon.CBNATIONALE{background-position:0 -310px}.fiIconsGroup .cardIconsGroup .cardIcon.CETELEM{background-position:0 -465px}.fiIconsGroup .cardIconsGroup .cardIcon.COFIDIS{background-position:0 -651px;margin-right:-10px}.fiIconsGroup .cardIconsGroup .cardIcon.COFINOGA{background-position:0 -341px}.fiIconsGroup .cardIconsGroup .cardIconVISA.QIWI{background-position:0 -806px;width:30px}.onboardingSection .fiIconsGroup .cardIconsGroup{display:flex;justify-content:center;padding:0;margin-bottom:12px}.marketingOffers{text-align:center}.marketingOffers .prop-img{background-size:contain;background-repeat:no-repeat}.marketingOffers li,.marketingOffers p{color:#757575;font-size:.9em;font-weight:400;line-height:1.35em;margin:5px 0}.marketingOffers li a,.marketingOffers p a{font-weight:700}@media (min-width:42em){.mobileApp header{display:none}.mobileApp #wrapper{margin:0;max-width:inherit;width:100%}.mobileApp .paypalHeader{width:100%}.mobileApp .footer{max-width:inherit}.mobileApp section .row-fluid .span14{width:100%}.mobileApp .feedback,.mobileApp section .row-fluid .span10{display:none}}@keyframes pulse{0%{transform:scale(1);-webkit-transform:scale(1)}50%{transform:scale(1.1);-webkit-transform:scale(1.1)}to{transform:scale(1);-webkit-transform:scale(1)}}@-webkit-keyframes pulse{0%{transform:scale(1);-webkit-transform:scale(1)}50%{transform:scale(1.1);-webkit-transform:scale(1.1)}to{transform:scale(1);-webkit-transform:scale(1)}}.pulseAnimation{animation-name:pulse;animation-duration:1s;animation-iteration-count:1;animation-delay:0s;-webkit-animation-name:pulse;-webkit-animation-duration:1s;-webkit-animation-iteration-count:1;-webkit-animation-delay:0s}@keyframes shake{0%,to{-webkit-transform:translateX(0);transform:translateX(0)}10%,30%,50%,70%,90%{-webkit-transform:translateX(-10px);transform:translateX(-10px)}20%,40%,60%,80%{-webkit-transform:translateX(10px);transform:translateX(10px)}}@-webkit-keyframes shake{0%,to{-webkit-transform:translateX(0);transform:translateX(0)}10%,30%,50%,70%,90%{-webkit-transform:translateX(-10px);transform:translateX(-10px)}20%,40%,60%,80%{-webkit-transform:translateX(10px);transform:translateX(10px)}}.shakeAnimation{animation-name:shake;animation-duration:1s;animation-iteration-count:1;animation-delay:0s;-webkit-animation-name:shake;-webkit-animation-duration:1s;-webkit-animation-iteration-count:1;-webkit-animation-delay:0s}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 33px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1182px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.error .custom-select.active>span,.error .custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.framed ul.footerLinks:before{width:12px;height:12px;margin:3px 10px 10px 0;display:block;float:left;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;content:\"\"}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.framed ul.footerLinks:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.framed .btn.escapeHatch{width:22px;height:20px;border:0;margin-left:0;display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:200px;background-position:-151px -35px;background-color:transparent;cursor:pointer}.framed #closeButton{width:11px;height:14px;padding:0;position:absolute;top:29px;right:20px;display:block;z-index:5;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-44px 1px;-webkit-tap-highlight-color:rgba(0,0,0,.2);text-indent:-999em;overflow:hidden}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.framed #closeButton{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.framed .paypalHeaderWrapper .cartContainer{margin-top:10px;margin-right:35px}@media (max-width:30em) and (min-width:0){.framed .DE footerLinks,.framed .footerLinks,.framed .fr.FR .footerLinks{width:45%}.framed .paypalHeaderWrapper .paypalHeader{padding-bottom:15px}.framed .paypalHeaderWrapper .cartContainer{margin-top:10px;margin-right:35px}.framed .paypalHeaderWrapper .logo{margin:18px 0 0}.framed .footer{padding:5px 22px}.framed .secureIcon{display:none}}@media (max-width:41.3125em){.framed .paypalHeaderWrapper .cartContainer{margin-top:10px;margin-right:35px}}[dir=rtl]{direction:rtl;unicode-bidi:embed}[dir=rtl] .ltrOverride{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .row-fluid>[class*=span]{float:right}[dir=rtl] .row-fluid>.span10{float:left;margin-left:0}[dir=rtl] .paypalHeaderWrapper .logo{float:right;margin-right:5px}[dir=rtl] .fieldGroup.name .inputField.last-child{margin-right:3.7%}[dir=rtl] .fieldGroup.name .inputField:not(.last-child){float:right;margin-right:0}[dir=rtl] input::-webkit-input-placeholder{direction:rtl}[dir=rtl] input:-moz-placeholder,[dir=rtl] input::-moz-placeholder{direction:rtl;text-align:right}[dir=rtl] input:-ms-input-placeholder{direction:rtl}[dir=rtl] .msg-desc .icon,[dir=rtl] .msg-error .icon,[dir=rtl] .msg-info .icon,[dir=rtl] .msg-success .icon,[dir=rtl] .msg-warning .icon{left:auto;right:0}[dir=rtl] .msgPage ul{padding:0 25px 0 0}[dir=rtl] .merchantHeader .merchantName{text-align:right}[dir=rtl] .cartContainer{float:left;right:auto;left:0;margin-left:0}[dir=rtl] #transactionCart{float:left}[dir=rtl] #transactionCart .arrow{margin:5px 5px 0 0}[dir=rtl] #transactionCart .cartIcon{margin:0 0 0 6px}[dir=rtl] #transactionDetails.cart .hasNoItems #transactionCart,[dir=rtl] .hasNoItems.transactionDetails #transactionCart,[dir=rtl] .hasNoItems.transactionDetails:active #transactionCart,[dir=rtl] .hasNoItems.transactionDetails:focus #transactionCart{background-position:right 9px;padding-right:27px;padding-left:0}[dir=rtl] .transctionCartDetails{left:43.42553193%;right:auto}[dir=rtl] .transctionCartDetails .pointer{right:auto;left:38px}[dir=rtl] .transctionCartDetails .detail-extras .amounts .itemName,[dir=rtl] .transctionCartDetails .detail-extras .amounts .itemPrice,[dir=rtl] .transctionCartDetails .detail-items .items .itemName,[dir=rtl] .transctionCartDetails .detail-items .items .itemPrice,[dir=rtl] .transctionCartDetails .subTotal .itemName,[dir=rtl] .transctionCartDetails .subTotal .itemPrice{text-align:right}[dir=rtl] .cartContainer .hasAmount .pointer{right:auto;left:57px}[dir=rtl] .emailField input,[dir=rtl] .passwordField input{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .checkbox input[type=checkbox]~label{padding-left:0;background-position:right 0;margin-right:-5px;padding-right:40px}[dir=rtl] .checkbox.error input[type=checkbox]:focus~label,[dir=rtl] .checkbox.error input[type=checkbox]~label{background-position:right -600px}[dir=rtl] .checkbox input[type=checkbox]:checked~label{background-position:right -400px}[dir=rtl] .checkbox input[type=checkbox]:focus:checked~label{background-position:right -4801px}[dir=rtl] .checkbox input[type=checkbox]:focus~label{background-position:right -4601px}[dir=rtl] .validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,[dir=rtl] .validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:right 0}[dir=rtl] .validated input[type=checkbox].ng-invalid~label{background-position:right -600px}[dir=rtl] .validated input[type=radio].ng-invalid+label,[dir=rtl] .validated input[type=radio].ng-invalid:focus+label{background-position:right -2200px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]~label{background-position:right -2600px}[dir=rtl] .sCheckbox.checkbox.error input[type=checkbox]:focus~label,[dir=rtl] .sCheckbox.checkbox.error input[type=checkbox]~label{background-position:right -3200px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:right -3000px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:right -5409px}[dir=rtl] .sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:right -2800px}[dir=rtl] .radioButton input[type=radio]~label{padding-left:0;background-position:right -1600px;margin-right:-5px;padding-right:40px}[dir=rtl] .radioButton.error input[type=radio]+label,[dir=rtl] .radioButton.error input[type=radio]:focus+label{background-position:right -2200px}[dir=rtl] .radioButton.warning input[type=radio]+label,[dir=rtl] .radioButton.warning input[type=radio]:focus+label{background-position:right -7405px}[dir=rtl] .radioButton input[type=radio]:checked+label{background-position:right -2000px}[dir=rtl] .radioButton input[type=radio]:focus:checked+label{background-position:right -6010px}[dir=rtl] .radioButton input[type=radio]:focus+label{background-position:right -1800px}[dir=rtl] .inputField label{text-align:right}[dir=rtl] .dropdown.billingAddress a{float:left}[dir=rtl] .allFundingInstrumentsList li .fsIcon{margin:18px 15px 0 10px}[dir=rtl] .allPlanList li .fsIcon{margin:2px 10px 0;padding:0}[dir=rtl] .allPlanList li .fsdetails{width:228px;padding:0}[dir=rtl] .validated select.backendError+.custom-select>span,[dir=rtl] .validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat left 10px center;background-size:18px}[dir=rtl] .validated div.inputField:not(.ltrOverride).error input,[dir=rtl] .validated div.inputField:not(.ltrOverride) input.backendError,[dir=rtl] .validated div.inputField:not(.ltrOverride) input.ng-invalid{background-size:18px;background-position:10px;padding:0 14px 0 29px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){[dir=rtl] .inputField.error input,[dir=rtl] .validated .inputField input.backendError,[dir=rtl] .validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat 98% left;background-size:18px;background-position:10px}[dir=rtl] .validated select.backendError+.custom-select>span,[dir=rtl] .validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat left 10px center;background-size:18px}}[dir=rtl] .fsIcons{padding-right:0;float:right;margin-left:10px}[dir=rtl] div.inputField:not(.ltrOverride) .inputField input{padding-right:10px}[dir=rtl] div.inputField:not(.ltrOverride) #securityCode.creditCard,[dir=rtl] div.inputField:not(.ltrOverride) .ccard,[dir=rtl] div.inputField:not(.ltrOverride) .creditCardField .creditCard{left:10px;right:inherit}[dir=rtl] .verifyHelp{text-indent:100%;white-space:nowrap;overflow:hidden}[dir=rtl] .toolTip.balloon{text-align:right;top:125px}[dir=rtl] #payUponInvoice .edits{padding:7px 10px 4px 0}[dir=rtl] .cardType.split{float:left}[dir=rtl] .creditCardField.split,[dir=rtl] div#phoneTypeSelection{float:right}[dir=rtl] .custom-select>span{background-position:left 5px top -1182px;padding:7px 13px 7px 30px}[dir=rtl] .error .custom-select.active>span,[dir=rtl] .error .custom-select>span{background-position:left 10px center}[dir=rtl] .emailHelper{left:10px;right:inherit}[dir=rtl] .footer .languageToggleDisplay #langDropdownBlock{right:-50px;left:5px}[dir=rtl] .footer .languageToggleDisplay #langDropdownBlock.bottom>.arrow:after{margin-left:0;margin-right:-10px}[dir=rtl] .footer .languageToggleDisplay .changeLanguage{margin:5px 5px 0 0}[dir=rtl] .footer .cancelUrl{float:right}[dir=rtl] .footer .footerWrapper{float:left;text-align:left}[dir=rtl] .footer .footerWrapper .footerLinks{float:none;background-position:100%;padding-right:0;width:auto}[dir=rtl] .footer .footerWrapper .footerLinks li{padding-right:0;padding-left:12px}[dir=rtl] .footer .footerWrapper .copyright{width:auto;padding-right:10px}[dir=rtl] .paywith .method{float:right}[dir=rtl] .paywith .method .name{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .paywith .method .forceRTL{direction:rtl;unicode-bidi:normal}[dir=rtl] .paywith .methodAmount{float:left}[dir=rtl] .paywith .conversion,[dir=rtl] .paywith .methodAmount .currencyCode{text-align:left}[dir=rtl] .paywith #currencyConversion a{unicode-bidi:embed}[dir=rtl] .paywith .ltrOverride{unicode-bidi:normal!important}[dir=rtl] .paywith .billingTxt{text-align:right}[dir=rtl] #paymentMethod .edits,[dir=rtl] #shippingAddress .edits{right:auto;left:0}[dir=rtl] .sidebar{left:0;right:-357px}[dir=rtl] .trayOpen #main{margin-left:-327px}[dir=rtl] #disclaimerWithBmlCta span{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] #main{float:left;margin-right:0}[dir=rtl] .trayOpen .maskMember .trayViewMask{left:38px}[dir=rtl] #selectFunding .checkIcon,[dir=rtl] #selectFunding .infoIcon,[dir=rtl] #selectShipping .checkIcon,[dir=rtl] #selectShipping .infoIcon{left:15px;right:auto}[dir=rtl] #currencyConversion a,[dir=rtl] .currencyConversion .conversion{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] #manageFunding .fsIcon,[dir=rtl] #selectFunding .fsIcon{float:right}[dir=rtl] #manageFunding .BANK .lastdigits,[dir=rtl] #manageFunding .CARD .lastdigits,[dir=rtl] #selectFunding .BANK .lastdigits,[dir=rtl] #selectFunding .CARD .lastdigits{direction:ltr;unicode-bidi:bidi-override;float:right}[dir=rtl] #manageFunding .BANK .fsName,[dir=rtl] #manageFunding .CARD .fsName,[dir=rtl] #selectFunding .BANK .fsName,[dir=rtl] #selectFunding .CARD .fsName{padding-right:5px}[dir=rtl] #manageFunding .BANK .amount,[dir=rtl] #manageFunding .BANK .colon,[dir=rtl] #manageFunding .CARD .amount,[dir=rtl] #manageFunding .CARD .colon,[dir=rtl] #selectFunding .BANK .amount,[dir=rtl] #selectFunding .BANK .colon,[dir=rtl] #selectFunding .CARD .amount,[dir=rtl] #selectFunding .CARD .colon{direction:rtl}[dir=rtl] #manageFunding .BALANCE .fsName,[dir=rtl] #selectFunding .BALANCE .fsName{direction:ltr;unicode-bidi:bidi-override;float:right}[dir=rtl] #manageFunding .BALANCE .amount,[dir=rtl] #manageFunding .BALANCE .colon,[dir=rtl] #selectFunding .BALANCE .amount,[dir=rtl] #selectFunding .BALANCE .colon{direction:rtl}[dir=rtl] #closeCart{float:left;margin:15px 0 0 15px}[dir=rtl] .languageToggleDisplay{left:0;right:auto}[dir=rtl] .languageToggleDisplay .displayText{margin-right:0}[dir=rtl] .languageToggleDisplay .changeLanguage{margin:5px 10px 0 0}[dir=rtl] .aside .close{left:10px;right:auto}[dir=rtl] .aside .backArrow{right:10px}[dir=rtl] .aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -256px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){[dir=rtl] .aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}[dir=rtl] .aside .backArrow:focus:before,[dir=rtl] .aside .backArrow:hover:before{background-position:-232px -278px}[dir=rtl] .right{left:0;float:left}[dir=rtl] .left{float:right}[dir=rtl] #selectShipping .subHeader .rightIcon,[dir=rtl] .subHeader .rightIcon{float:left!important;margin:4px 6px 0 0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-200px -220px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){[dir=rtl] #selectShipping .subHeader .rightIcon,[dir=rtl] .subHeader .rightIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}[dir=rtl] #selectShipping .subHeader .rightIcon:focus,[dir=rtl] #selectShipping .subHeader .rightIcon:hover,[dir=rtl] .subHeader .rightIcon:focus,[dir=rtl] .subHeader .rightIcon:hover{background-position:-200px -235px}[dir=rtl] #selectShipping .subHeader .leftIcon,[dir=rtl] .subHeader .leftIcon{float:right!important;margin:4px 0 0 6px}[dir=rtl] #addCard .addNewBillingAddress{float:left}[dir=rtl] .creditCardInput .cardIcon,[dir=rtl] .creditCardInput .expirationField{float:right}[dir=rtl] .creditCardInput .cvvField{float:left}[dir=rtl] .inputField.noFloatingLabel label{right:14px;left:auto;text-align:right}[dir=rtl] .tipCreditCard{direction:rtl}[dir=rtl] .addressDisplay .adr .adr-break{float:right;margin-left:5px}[dir=rtl] .BALANCE .fsName,[dir=rtl] .fsDetails .fsName{direction:rtl!important;unicode-bidi:normal!important}[dir=rtl] #manageFunding .manageLinks{position:absolute;top:25px;left:0;right:auto}[dir=rtl] #manageFunding .manageLinks .updateButton{padding:0 0 0 10px}[dir=rtl] #manageFunding .manageLinks .deleteButton{padding:0 10px 0 15px}[dir=rtl] #manageFunding .infoIcon{right:auto;left:15px}[dir=rtl] #manageFunding .confirm{left:0;right:auto;transform:translate(-100%)}[dir=rtl] #manageFunding .slideIn{transform:translate(0)}[dir=rtl] #manageFunding .slide{transform:translate(6%)}[dir=rtl] #deleteShipping .delete{left:0;right:auto;-webkit-transform:translate(0);transform:translate(0)}[dir=rtl] #deleteShipping .delete.slideOut{-webkit-transform:translate(-102%);transform:translate(-102%)}[dir=rtl] #deleteShipping .msgIcon{right:auto;left:15px}[dir=rtl] #deleteShipping .slide{transform:translate(15%)}[dir=rtl] #deleteShipping .confirm{-webkit-transform:translate(-102%);transform:translate(-102%)}[dir=rtl] #deleteShipping .confirm.slidein{-webkit-transform:translate(0);transform:translate(0)}[dir=rtl] .overlayWrapper{right:auto}[dir=rtl] #langDropdownBlock{left:-15px;right:auto}[dir=rtl] #langDropdownBlock.bottom>.arrow:after{margin:0 -10px 0 0}[dir=rtl] #shippingAddress .frontArrow,[dir=rtl] .paywith .frontArrow{left:0;right:auto;background-position:-200px -216px}[dir=rtl] .footer .footerWrapper .copyright{direction:ltr;unicode-bidi:bidi-override}[dir=rtl] .footer .footerWrapper .copyright .secureIcon{float:left;margin:3px 8px 0 0}[dir=rtl][lang=ar] .footer .footerWrapper .copyright{unicode-bidi:inherit;direction:rtl}@media (max-width:41.25em){[dir=rtl] .trayOpen .sidebar{right:-327px}[dir=rtl] .trayOpen .maskMember .trayViewMask{left:32px}[dir=rtl] .footer .footerWrapper .footerLinks{float:right;width:50%;text-align:right}[dir=rtl] .footer .footerWrapper .footerLinks li{padding-left:0;margin-left:10px;margin-right:0}[dir=rtl] .footer .footerWrapper .copyright{float:left}[dir=rtl] .transctionCartDetails{left:0;right:auto;width:320px}}@media (max-width:30em) and (min-width:0){[dir=rtl] .footer li{margin-right:0}[dir=rtl] .footer .footerWrapper .footerLinks{width:48%;padding-right:0}}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/css-loader/lib/css-base.js":
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },

/***/ "../node_modules/style-loader/addStyles.js":
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },

/***/ "./components/xo-beaver/dist/logger.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/xo-beaver/dist/level.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('beaver', ['beaver.level']).factory('$Logger', function ($injector, $http, $window, $interval, $timeout, $log, $q, $rootScope, $logLevel, $consoleLogLevel) {
	
	        var logger = {};
	        var HERMES_DEV_COOKIE = 'hermesdev';
	
	        angular.forEach($logLevel, function (level) {
	            logger[level] = function (event, payload, settings) {
	                return this.log(level, event, payload, settings);
	            };
	        });
	
	        var hostname = $window.location && $window.location.hostname || '';
	
	        var uniqueEvents = [];
	
	        angular.extend(logger, {
	
	            autoLog: [$logLevel.WARNING, $logLevel.ERROR],
	            flushInterval: 10 * 60 * 1000,
	            heartbeatInterval: 5000,
	            sizeLimit: 300,
	            debounceInterval: 10,
	            uri: '/api/log',
	            hearbeatMaxThreshold: 50,
	
	            deploy: {
	                isLocal: function isLocal() {
	                    return hostname === 'localhost' || hostname === 'localhost.paypal.com';
	                },
	
	                isStage: function isStage() {
	                    return Boolean(hostname.match(/^.*\.qa\.paypal\.com$/));
	                },
	
	                isLive: function isLive() {
	                    return hostname === 'www.paypal.com';
	                }
	            },
	
	            init: function init() {
	                var self = this;
	
	                this.buffer = [];
	
	                var previousBeforeUnloadHandler = $window.onbeforeunload;
	
	                $window.onbeforeunload = function (event) {
	
	                    if (self.isDone) {
	                        return;
	                    }
	
	                    self.info('window_beforeunload');
	
	                    if (previousBeforeUnloadHandler) {
	                        return previousBeforeUnloadHandler.apply(this, arguments);
	                    }
	                };
	
	                var previousUnloadHandler = $window.onunload;
	
	                $window.onunload = function (event) {
	
	                    if (self.isDone) {
	                        return;
	                    }
	
	                    self.info('window_unload')._flush(true);
	
	                    self.done();
	
	                    if (previousUnloadHandler) {
	                        return previousUnloadHandler.apply(this, arguments);
	                    }
	                };
	
	                this.heartbeat();
	                this.daemon();
	            },
	
	            heartbeat: function heartbeat() {
	                var self = this;
	
	                if (!window.enablePerformance) {
	                    return;
	                }
	
	                function timestamp() {
	                    var perf = window.performance;
	
	                    return parseInt(perf.now() - (perf.timing.connectEnd - perf.timing.navigationStart), 10);
	                }
	
	                var howBusy = {
	                    lastSampledTime: timestamp(),
	                    lastLag: 0,
	                    maxLag: 0,
	                    dampendedLag: 0
	                };
	
	                var count = 0;
	
	                $interval(function () {
	
	                    if (!self.buffer.length || self.buffer[self.buffer.length - 1].event !== 'heartbeat') {
	                        count = 0;
	                    }
	
	                    if (!self.buffer.length || count > self.hearbeatMaxThreshold) {
	                        return;
	                    }
	
	                    count += 1;
	
	                    var payload = {
	                        count: count
	                    };
	
	                    var now = timestamp();
	
	                    howBusy.lastLag = now - howBusy.lastSampledTime - self.heartbeatInterval;
	                    howBusy.maxLag = howBusy.lastLag > howBusy.maxLag ? howBusy.lastLag : howBusy.maxLag;
	                    howBusy.dampendedLag = (howBusy.lastLag + howBusy.dampendedLag * 2) / 3;
	                    howBusy.lastSampledTime = now;
	
	                    payload.lastLag = howBusy.lastLag.toFixed(4);
	                    payload.maxLag = howBusy.maxLag.toFixed(4);
	                    payload.dampendedLag = howBusy.dampendedLag.toFixed(4);
	                    payload.lastSampledTime = howBusy.lastSampledTime.toFixed(4);
	
	                    if (howBusy.lastLag > 10000) {
	                        self.info('toobusy', {}, {
	                            noConsole: true,
	                            unique: true
	                        });
	                    }
	
	                    self.info('heartbeat', payload, {
	                        noConsole: true
	                    });
	                }, this.heartbeatInterval);
	            },
	
	            done: function done() {
	                this.isDone = true;
	            },
	
	            addPerformanceData: function addPerformanceData(payload) {
	
	                if (window.enablePerformance) {
	                    var performance = window.performance;
	                    var timing = window.performance.timing || {};
	                    var now = performance.now();
	
	                    if (window.clientStartTime && angular.isUndefined(payload.client_elapsed)) {
	                        payload.client_elapsed = parseInt(now - window.clientStartTime, 10);
	                    }
	
	                    if (timing.connectEnd && timing.navigationStart && angular.isUndefined(payload.req_elapsed)) {
	                        payload.req_elapsed = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
	                    }
	                }
	            },
	
	            addLocaleData: function addLocaleData(payload) {
	
	                var context = {};
	
	                try {
	                    context = $injector.get('$metaBuilder').buildContext();
	                } catch (err) {
	                    return; // Continue without adding locale data
	                }
	                if (context.locale && context.locale.country) {
	                    payload.site_cntry = context.locale.country;
	                }
	            },
	
	            /* jslint maxcomplexity: false */
	            log: function log(level, event, payload, settings) {
	
	                var self = this;
	
	                payload = payload || {};
	
	                if (angular.isArray(payload) || !angular.isObject(payload)) {
	                    payload = {
	                        payload: payload
	                    };
	                }
	                settings = settings || {};
	
	                if (settings.unique) {
	                    var hash = event + ':' + angular.toJson(payload);
	
	                    if (uniqueEvents.indexOf(hash) > -1) {
	                        return self;
	                    }
	                    uniqueEvents.push(hash);
	                }
	
	                payload.pageID = window.meta && window.meta.pageID;
	
	                this.addPerformanceData(payload);
	                this.addLocaleData(payload);
	
	                self.print(level, event, payload, settings);
	
	                if (this.buffer.length >= this.sizeLimit) {
	                    if (this.buffer.length === this.sizeLimit) {
	                        return self.enqueue('info', 'logger_max_buffer_length');
	                    }
	                    return self;
	                }
	
	                return self.enqueue(level, event, payload, settings);
	            },
	
	            getTimestamp: function getTimestamp() {
	                var now = Date.now();
	
	                return window.logOffset ? window.logOffset + now : now;
	            },
	
	            enqueue: function enqueue(level, event, payload, settings) {
	
	                payload = payload || {};
	                settings = settings || {};
	
	                var data = {
	                    level: level,
	                    event: event,
	                    timestamp: this.getTimestamp(),
	                    payload: payload
	                };
	
	                this.buffer.push(data);
	
	                // If the log level is classified as autolog, then flush the data
	                if (this.autoLog.indexOf(level) > -1) {
	                    this.flush();
	                }
	
	                return this;
	            },
	
	            shouldPrintLogsToConsole: function shouldPrintLogsToConsole(settings) {
	
	                if (settings.noConsole) {
	                    return false;
	                }
	
	                if (window.meta && window.meta.corp) {
	                    return true;
	                }
	
	                if (this.deploy.isLocal() || this.deploy.isStage()) {
	                    return true;
	                }
	
	                var cookies = window.cookies || {};
	
	                if (cookies[HERMES_DEV_COOKIE] && cookies[HERMES_DEV_COOKIE] === '1') {
	                    return true;
	                }
	
	                return false;
	            },
	
	            print: function print(level, event, payload, settings) {
	
	                if (!this.shouldPrintLogsToConsole(settings)) {
	                    return;
	                }
	
	                var args = [event];
	
	                if (payload) {
	                    args.push(payload);
	
	                    if (payload.stack || payload.error || payload.warning) {
	                        args.push('\n\n', payload.stack || payload.error || payload.warning);
	                    }
	                }
	
	                $log[$consoleLogLevel[level] || 'info'].apply($log, args);
	            },
	
	            flush: function flush(immediate) {
	                var self = this;
	
	                if (!this.buffer.length) {
	                    return $q.when();
	                }
	
	                if (immediate) {
	                    return $q.when(this._flush());
	                }
	
	                if (self.debouncer_timeout) {
	                    $timeout.cancel(self.debouncer_timeout);
	                }
	
	                self.debouncer_timeout = $timeout(function () {
	
	                    var resolver = self.debouncer_resolver;
	
	                    delete self.debouncer_promise;
	                    delete self.debouncer_resolver;
	                    delete self.debouncer_timeout;
	
	                    self._flush().then(function () {
	                        resolver();
	                    });
	                }, this.debounceInterval);
	
	                self.debouncer_promise = self.debouncer_promise || $q(function (resolver) {
	                    self.debouncer_resolver = resolver;
	                });
	
	                return self.debouncer_promise;
	            },
	
	            _flush: function _flush(sync) {
	                var self = this;
	
	                if (!self.buffer.length) {
	                    return $q.when();
	                }
	
	                var meta = {};
	
	                try {
	                    meta = $injector.get('$metaBuilder').build();
	                } catch (err) {
	                    // @TODO - Log error
	                }
	
	                var req = this.ajax('post', $window.meta.logURL || $window.config.urls.baseUrl + this.uri, {
	                    data: {
	                        events: self.buffer
	                    },
	                    meta: meta
	                }, sync);
	
	                self.buffer = [];
	
	                return req;
	            },
	
	            ajax: function ajax(method, url, json, sync) {
	
	                return $q(function (resolve) {
	                    var XRequest = window.XMLHttpRequest || ActiveXObject; // eslint-disable-line no-undef, block-scoped-var
	                    var req = new XRequest('MSXML2.XMLHTTP.3.0');
	                    var logAppName = $window.meta.logAppName;
	
	                    req.open(method.toUpperCase(), url, !sync);
	
	                    req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	                    req.setRequestHeader('Content-type', 'application/json');
	
	                    if (logAppName) {
	                        req.setRequestHeader('x-app-name', logAppName);
	                    }
	
	                    req.onreadystatechange = function () {
	                        if (req.readyState > 3) {
	                            resolve();
	                        }
	                    };
	                    req.send(angular.toJson(json).replace(/&/g, '%26')); // eslint-disable-line angular/ng_json_functions
	                });
	            },
	
	            daemon: function daemon() {
	                this.stop();
	
	                var self = this;
	
	                this.timer = $interval(function () {
	                    self.flush();
	                }, this.flushInterval);
	            },
	
	            stop: function stop() {
	                if (this.timer) {
	                    $interval.cancel(this.timer);
	                }
	            }
	        });
	
	        function Logger(val) {
	            angular.extend(this, val);
	            this.init();
	        }
	
	        Logger.prototype = logger;
	        Logger.prototype.constructor = Logger;
	
	        return Logger;
	    }).factory('$logger', function ($Logger) {
	        return new $Logger();
	    }).run(function ($logger) {
	        angular.forEach(window.beaconQueue, function (payload) {
	            $logger.log(payload.level, payload.event, payload);
	        });
	
	        window.beacon = function (level, events, payload) {
	            angular.forEach(events, function (event) {
	                $logger.log(level, event, payload);
	            });
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-beaver/dist", "components/xo-beaver/dist/logger.js"))

/***/ },

/***/ "./components/xo-beaver/dist/level.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('beaver.level', []).factory('$logLevel', function () {
	
	        return {
	            INFO: 'info',
	            DEBUG: 'debug',
	            ERROR: 'error',
	            WARN: 'warn',
	            ALERT: 'alert'
	        };
	    }).factory('$consoleLogLevel', function () {
	
	        return {
	            info: 'info',
	            debug: 'debug',
	            error: 'error',
	            warn: 'warn',
	            alert: 'info'
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-beaver/dist", "components/xo-beaver/dist/level.js"))

/***/ },

/***/ "./pages/xo-checkout/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	__webpack_require__("./components/jquery/dist/jquery.min.js");
	
	__webpack_require__("./components/angular-shims-placeholder/dist/angular-shims-placeholder.min.js");
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./components/xo-tracking/dist/index.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	__webpack_require__("./pages/xo-landing/route.js");
	
	__webpack_require__("./pages/xo-login/route.js");
	
	__webpack_require__("./pages/xo-generic-error/route.js");
	
	__webpack_require__("./pages/xo-generic-message/route.js");
	
	__webpack_require__("./pages/xo-select-fi/route.js");
	
	__webpack_require__("./pages/xo-review/route.js");
	
	__webpack_require__("./pages/xo-authorization-message/route.js");
	
	__webpack_require__("./pages/xo-add-card/route.js");
	
	__webpack_require__("./pages/xo-add-fi/route.js");
	
	__webpack_require__("./pages/xo-add-card-meft/route.js");
	
	__webpack_require__("./pages/xo-add-tax-id/route.js");
	
	__webpack_require__("./pages/xo-add-shipping/route.js");
	
	__webpack_require__("./pages/xo-add-national-id/route.js");
	
	__webpack_require__("./pages/xo-update-card/route.js");
	
	var _route = __webpack_require__("./pages/xo-eConsent/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	__webpack_require__("./pages/xo-travel-rule/route.js");
	
	var _route3 = __webpack_require__("./pages/xo-nbr/route.js");
	
	var _route4 = _interopRequireDefault(_route3);
	
	var _route5 = __webpack_require__("./pages/xo-framebust/route.js");
	
	__webpack_require__("./pages/xo-sepa/route.js");
	
	__webpack_require__("./pages/xo-end/route.js");
	
	__webpack_require__("./components/xo-login-components/src/fullpage-onetouch-upsell/route.js");
	
	var _route6 = __webpack_require__("./pages/xo-create-password/route.js");
	
	var _route7 = _interopRequireDefault(_route6);
	
	var _route8 = __webpack_require__("./pages/xo-tokenization-info/route.js");
	
	var _route9 = _interopRequireDefault(_route8);
	
	var _route10 = __webpack_require__("./pages/xo-venmo/route.js");
	
	var _route11 = _interopRequireDefault(_route10);
	
	__webpack_require__("./pages/xo-inventory-soldout/route.js");
	
	__webpack_require__("./components/xo-page-components/src/done/route.js");
	
	__webpack_require__("./components/xo-form-components/src/phone/route.js");
	
	__webpack_require__("./components/xo-credit-components/src/bml-display/route.js");
	
	__webpack_require__("./components/xo-credit-components/src/choose-credit-offer/route.js");
	
	__webpack_require__("./components/xo-credit-components/src/redirect-to-cape/route.js");
	
	__webpack_require__("./pages/xo-pay-with-selection/route.js");
	
	__webpack_require__("./pages/xo-checkout/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoCheckoutRoute', {
	
	    path: 'checkout',
	    directive: 'xo-checkout',
	    titleContent: 'base.payPal',
	
	    defaultState: 'checkout.landing',
	    middleware: _middleware.$Middleware,
	
	    children: [{
	        name: '$LandingRoute'
	    }, {
	        name: '$LoginRoute',
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        name: '$PayWithSelectionRoute',
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        route: _route11['default'],
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        name: '$GenericErrorRoute'
	    }, {
	        name: '$ChooseCreditOfferRoute',
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        name: '$RedirectToCapeRoute',
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        name: '$GenericMessageRoute'
	    }, {
	        name: '$FullpageOnetouchUpsellRoute'
	    }, {
	        name: '$SelectFiRoute',
	        props: function props() {
	            return { token: this.token };
	        }
	    }, {
	        name: '$ReviewRoute'
	    }, {
	        name: '$AuthorizationMessageRoute'
	    }, {
	        name: '$AddPhoneRoute'
	    }, {
	        name: '$AddCardPageRoute'
	    }, {
	        name: '$AddFiPageRoute'
	    }, {
	        route: _route9['default'],
	        props: function props() {
	            return { token: this.token };
	        }
	    }, {
	        name: '$AddCardMeftRoute'
	    }, {
	        name: '$AddTaxIdRoute'
	    }, {
	        name: '$TravelRuleRoute'
	    }, {
	        name: '$AddNationalIdRoute'
	    }, {
	        name: '$UpdateCardPageRoute'
	    }, {
	        name: '$AddShippingPageRoute',
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        name: '$xoSoldOutPageRoute'
	    }, {
	        route: _route2['default'],
	        props: function props() {
	            var _this = this;
	
	            return {
	                token: this.token,
	                success: function success() {
	                    return _this.goto('this.review');
	                }
	            };
	        }
	    }, {
	        route: _route4['default'],
	        props: function props() {
	            return { token: this.token };
	        }
	    }, {
	        route: _route5.$xoFrameBustRoute
	    }, {
	        name: '$SepaPageRoute',
	        attributes: {
	            token: 'token'
	        }
	    }, {
	        name: '$EndRoute'
	    }, {
	        name: '$BMLDisplay',
	        attributes: {
	            'review-url': 'reviewUrl'
	        }
	    }, {
	        name: '$DoneRoute'
	    }, {
	        route: _route7['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }]
	});
	
	
	_index.$Route;
	
	_middleware.$Middleware;
	
	_route5.$xoFrameBustRoute;
	module.exports = exports['default'];

/***/ },

/***/ "./js/lib/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _error = __webpack_require__("./js/lib/error.js");
	
	Object.keys(_error).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _error[key];
	    }
	  });
	});
	
	var _fallback = __webpack_require__("./js/lib/fallback.js");
	
	Object.keys(_fallback).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _fallback[key];
	    }
	  });
	});
	
	var _contingency = __webpack_require__("./js/lib/contingency.js");
	
	Object.keys(_contingency).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _contingency[key];
	    }
	  });
	});
	
	var _metaBuilder = __webpack_require__("./js/lib/metaBuilder.js");
	
	Object.keys(_metaBuilder).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _metaBuilder[key];
	    }
	  });
	});
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	Object.keys(_middleware).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _middleware[key];
	    }
	  });
	});
	
	var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");
	
	Object.keys(_miniBrowser).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _miniBrowser[key];
	    }
	  });
	});
	
	var _security = __webpack_require__("./js/lib/security.js");
	
	Object.keys(_security).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _security[key];
	    }
	  });
	});
	
	var _stateChangeListener = __webpack_require__("./js/lib/stateChangeListener.js");
	
	Object.keys(_stateChangeListener).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _stateChangeListener[key];
	    }
	  });
	});
	
	var _cplIntegration = __webpack_require__("./js/lib/cplIntegration.js");
	
	Object.keys(_cplIntegration).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _cplIntegration[key];
	    }
	  });
	});

/***/ },

/***/ "./js/lib/error.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$forbiddenHandler = $forbiddenHandler;
	exports.$exceptionHandler = $exceptionHandler;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _fallback = __webpack_require__("./js/lib/fallback.js");
	
	var _contingency = __webpack_require__("./js/lib/contingency.js");
	
	function constructEventName(toState, fromState) {
	    var from = fromState.name.replace(/\./g, '_') || 'start';
	    var to = toState.name.replace(/\./g, '_') || 'end';
	
	    return 'state_change_' + from + '_to_' + to;
	}
	
	function $forbiddenHandler(err) {
	    _logger.$logger.warn('forbidden_handler');
	    if (!err.transient) {
	        _index.$AuthModel.instance().invalidate();
	
	        if (_angular.$rootScope.paymentComplete) {
	            throw new _squid.$Contingency('PAYMENT_ALREADY_DONE');
	        }
	
	        _uiRouter.$state.go('checkout.login');
	    }
	}
	
	var ERROR_HANDLERS = [{
	    type: _squid.$FallbackError,
	    handler: _fallback.$fallbackErrorHandler
	}, {
	    type: _squid.$Contingency,
	    handler: _contingency.$contingencyHandler
	}, {
	    type: _squid.$Forbidden,
	    handler: $forbiddenHandler
	}];
	
	function $exceptionHandler(err, cause) {
	
	    if (_angular.$rootScope.ERROR_STATE) {
	
	        if (_angular.$rootScope.ERROR_PREVENTED) {
	            throw err;
	        }
	
	        return;
	    }
	
	    var handled = _squid.$util.some(ERROR_HANDLERS, function (errorHandler) {
	        if (err instanceof errorHandler.type) {
	            errorHandler.handler(err);
	
	            return true;
	        }
	    });
	
	    if (handled) {
	        return;
	    } else if (!err.transient) {
	        _angular.$rootScope.ERROR_STATE = err;
	    }
	
	    var errType = (err.constructor.name || 'error').toLowerCase();
	    var errName = 'ui_unhandled_' + errType;
	    var errMsg = err.message || '';
	
	    if (errMsg.indexOf('infdig') > -1) {
	        errName = 'infinite_digest';
	    } else if (errMsg.indexOf('inprog') > -1) {
	        errName = 'digest_inprog';
	    } else if (errMsg.indexOf('badparse') > -1) {
	        errName = 'sanitize_badparse';
	    } else if (errMsg.match(/^[\w_]+$/)) {
	        errName = 'ui_unhandled_' + errMsg;
	    }
	
	    if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
	        if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
	            errName = 'ui_unhandled_framework_error';
	        }
	    }
	
	    if (err.transient) {
	        errName += '_transient';
	    }
	
	    var payload = {
	        error: err.stack || err.toString(),
	        message: errMsg,
	        cause: cause && cause.toString(),
	        state: _uiRouter.$state.current.name,
	        url: window.location.toString()
	    };
	
	    angular.extend(payload, err.payload || {});
	
	    _logger.$logger.error(errName, payload);
	
	    // emit the error object for subscribers like xo-tracking
	    var event = _angular.$rootScope.$emit('unhandled_error', {
	        err: err,
	        route: (_uiRouter.$state || {}).current,
	        message: payload.error,
	        code: payload.cause
	    });
	
	    if (event.defaultPrevented) {
	        _angular.$rootScope.ERROR_PREVENTED = true;
	        throw err;
	    } else if (!err.transient) {
	        return (0, _fallback.$fallbackErrorHandler)(new _squid.$FallbackError({
	            reason: errName
	        }));
	    }
	}
	
	_angular.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
	    // Set prevent default to avoid angular UI router to keep looping back to same state
	    event.preventDefault();
	    $exceptionHandler(err, constructEventName(toState, fromState));
	});
	
	_angular.$rootScope.$on('$windowError', function (event, details) {
	    _logger.$logger.error('window_error', details, {
	        unique: true
	    });
	});
	
	angular.value("$forbiddenHandler", $forbiddenHandler);
	angular.value("$exceptionHandlerLazy", $exceptionHandler);
	_angular.$rootScope;
	
	_uiRouter.$state;
	
	_squid.$util;
	
	_squid.$FallbackError;
	
	_squid.$Forbidden;
	
	_squid.$Contingency;
	
	_logger.$logger;
	
	_index.$AuthModel;
	
	_fallback.$fallbackErrorHandler;
	
	_contingency.$contingencyHandler;

/***/ },

/***/ "./components/squid/dist/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _ng = __webpack_require__("./components/squid/dist/ng/index.js");
	
	Object.keys(_ng).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ng[key];
	    }
	  });
	});
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	Object.keys(_core).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _core[key];
	    }
	  });
	});
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _paypal = __webpack_require__("./components/squid/dist/paypal/index.js");
	
	Object.keys(_paypal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _paypal[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/ng/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _core = __webpack_require__("./components/squid/dist/ng/core.js");
	
	Object.keys(_core).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _core[key];
	    }
	  });
	});
	
	var _route = __webpack_require__("./components/squid/dist/ng/route.js");
	
	Object.keys(_route).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _route[key];
	    }
	  });
	});
	
	var _component = __webpack_require__("./components/squid/dist/ng/component.js");
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});
	
	var _feature = __webpack_require__("./components/squid/dist/ng/feature.js");
	
	Object.keys(_feature).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _feature[key];
	    }
	  });
	});
	
	var _locale = __webpack_require__("./components/squid/dist/ng/locale.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _module = __webpack_require__("./components/squid/dist/ng/module.js");
	
	Object.keys(_module).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _module[key];
	    }
	  });
	});
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	Object.keys(_ng).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ng[key];
	    }
	  });
	});
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	Object.keys(_directive).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _directive[key];
	    }
	  });
	});
	
	var _events = __webpack_require__("./components/squid/dist/ng/events.js");
	
	Object.keys(_events).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _events[key];
	    }
	  });
	});
	
	var _pxp = __webpack_require__("./components/squid/dist/ng/pxp.js");
	
	Object.keys(_pxp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _pxp[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/ng/core.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	_core.$event.use({
	    on: function on() {
	        return _angular.$rootScope.$on.apply(_angular.$rootScope, arguments);
	    },
	    once: function once(name, handler) {
	        var cancel = _core.$event.on(name, function () {
	            cancel();
	            handler.apply(this, arguments);
	        }, true);
	
	        return cancel;
	    },
	    emit: function emit() {
	        return _angular.$rootScope.$emit.apply(_angular.$rootScope, arguments);
	    },
	    broadcast: function broadcast() {
	        return _angular.$rootScope.$broadcast.apply(_angular.$rootScope, arguments);
	    }
	});
	
	_core.$promise.use(_angular.$q);
	
	_angular.$q;
	
	_angular.$rootScope;
	
	_core.$event;
	
	_core.$promise;

/***/ },

/***/ "./components/squid/dist/core/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _api = __webpack_require__("./components/squid/dist/core/api.js");
	
	Object.keys(_api).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _api[key];
	    }
	  });
	});
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	Object.keys(_class).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _class[key];
	    }
	  });
	});
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	Object.keys(_config).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _config[key];
	    }
	  });
	});
	
	var _error = __webpack_require__("./components/squid/dist/core/error.js");
	
	Object.keys(_error).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _error[key];
	    }
	  });
	});
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	Object.keys(_event).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _event[key];
	    }
	  });
	});
	
	var _integration = __webpack_require__("./components/squid/dist/core/integration.js");
	
	Object.keys(_integration).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _integration[key];
	    }
	  });
	});
	
	var _model = __webpack_require__("./components/squid/dist/core/model.js");
	
	Object.keys(_model).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _model[key];
	    }
	  });
	});
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	Object.keys(_promise).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _promise[key];
	    }
	  });
	});
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	Object.keys(_util).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _util[key];
	    }
	  });
	});
	
	var _loader = __webpack_require__("./components/squid/dist/core/loader.js");
	
	Object.keys(_loader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _loader[key];
	    }
	  });
	});
	
	var _dom = __webpack_require__("./components/squid/dist/core/dom.js");
	
	Object.keys(_dom).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _dom[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/core/api.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$Api = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.$getLatestCorrelationID = $getLatestCorrelationID;
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	var _error = __webpack_require__("./components/squid/dist/core/error.js");
	
	var _loader = __webpack_require__("./components/squid/dist/core/loader.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	 API
	 ---
	
	 This layer is responsible for handling api requests. It has a number of responsibilities:
	
	 - Caching responses
	 - Transparently returning data that has been preloaded into the initial page response
	 - Instrumentation
	 - Batching multiple api calls into a single http request
	 - Handling multiple types of responses and dispatching to the correct handlers
	 - Emitting loading events for all http calls
	 */
	
	_config.$meta.headers = _config.$meta.headers || {};
	_config.$meta.headers['x-cookies'] = _typeof(_config.$meta.headers['x-cookies']) !== 'object' ? JSON.parse(_config.$meta.headers['x-cookies'] || '{}') : _config.$meta.headers['x-cookies'];
	
	// Are we in 'cookies disabled' mode? (Do we need to keep a local store of cookies)
	function cookiesEnabled() {
	    return _util.$util.cookiesEnabled() && window.location.hostname.indexOf('.paypal.com') > -1;
	}
	
	// Cache for api responses, when cache: true
	var cache = {};
	
	var latestCorrelationID = _config.$meta.correlationId;
	
	// Window load promise
	var windowLoad = _util.$util.memoize(function () {
	    return _promise.$promise.resolver(function (resolve) {
	        if (document.readyState === 'complete') {
	            resolve();
	        } else {
	            window.addEventListener('load', resolve);
	        }
	    });
	});
	
	// Buffer for batch requests made within the same frame
	var batchQueue = {};
	
	// Backwards compat
	window.pre = {};
	
	// Transient cache resolvers
	var transientCache = {};
	
	// Transient cache resolvers
	var transientCacheResolvers = {};
	
	// Metabuilder
	var metaBuilder = void 0;
	
	// Add to transientCache
	window.preload = function (method, url, data, name) {
	
	    if (name) {
	        window.pre[name] = {
	            method: method,
	            uri: url,
	            res: data
	        };
	    }
	
	    var key = method + ':' + url;
	    var resolvers = transientCacheResolvers[key] || [];
	
	    transientCache[key] = data;
	
	    while (resolvers.length) {
	        resolvers.pop().call();
	    }
	};
	
	// Preload complete
	var preloadComplete = false;
	
	window.preloadComplete = function () {
	    preloadComplete = true;
	    Object.keys(transientCacheResolvers).forEach(function (key) {
	        var resolvers = transientCacheResolvers[key] || [];
	
	        while (resolvers.length) {
	            resolvers.pop().call();
	        }
	    });
	};
	
	_logger.$logger.info(cookiesEnabled() ? 'cookies_enabled' : 'cookies_disabled');
	
	var $Api = exports.$Api = _class.$Class.extend('$Api', {
	
	    // Cache any GET responses indefinitely
	    cache: false,
	
	    // Http timeout for all requests
	    timeout: 45000,
	
	    // Default number of attempts on aborted requests and 500 server errors
	    getAttempts: 3,
	    postAttempts: 1,
	
	    // POST on a resource with an action name myapi.action('foo') -> POST /my/api/foo
	    action: function action(_action, options) {
	        options.action = _action;
	        return this.post(options);
	    },
	
	    // GET on a resource myapi.retrieve() -> GET /my/api
	    retrieve: function retrieve(options) {
	        options.method = 'get';
	        return this.call(options);
	    },
	
	    // POST on a resource myapi.retrieve() -> POST /my/api
	    post: function post(options) {
	        options.method = 'post';
	        return this.call(options);
	    },
	
	    // Generic handler for calling an api and dispatching requests to the right place
	    call: function call(options) {
	        var self = this;
	
	        // Set up request options and params. `options` is an object which should contain everything
	        // the request needs to run and handle the response
	
	        options.api = this;
	        options.uri = this.getURI(options.model, options.action);
	        options.params = options.params || {};
	        options.cache = options.cache || self.cache && options.method === 'get';
	        options.name = this.buildAPIName(options);
	        options.meta = this.buildMeta();
	        options.transientError = options.transientError || false;
	        options.cacheKey = _util.$util.buildURL(options.uri, options.params);
	
	        _logger.$logger.info(options.name + '_call', {
	            name: options.name,
	            method: options.method,
	            uri: options.uri
	        });
	
	        if (!options.silent) {
	            _event.$event.emit('loading');
	        }
	
	        // Decide where to get the response
	        return _promise.$promise.first([
	
	        // If caching is enabled and we have the data in local cache, use the cache
	        function () {
	            if (options.cache && cache[options.cacheKey]) {
	                return cache[options.cacheKey];
	            }
	        },
	
	        // Otherwise if we have transient cache data for this api, we can use that
	        function () {
	            return _promise.$promise.providing(self.hasTransientCacheData(options), function () {
	
	                // The reason we use self.attemptRequest here is so any errors in the cached response
	                // can trigger the retry code path, as if it were a regular request
	                return self.attemptRequest(options);
	            });
	        },
	
	        // If we're in batch mode, queue up a batch request
	        function () {
	            if (options.batch) {
	                return self.batchRequest(options);
	            }
	        },
	
	        // Otherwise attempt a regular http request (at this point an http call is guaranteed)
	        function () {
	            return self.attemptRequest(options);
	        }])['finally'](function () {
	
	            if (!options.silent) {
	                _event.$event.emit('loaded');
	            }
	        }).then(function (res) {
	
	            // Cache the response if we need to
	            if (options.cache) {
	                cache[options.cacheKey] = res;
	            }
	
	            // Handle the response
	            return self.handleResponse(res.data, options);
	        }, function (err) {
	
	            // $BatchShortCircuit will be thrown if:
	            //
	            // 1. batch api call B depends on api call A, but-
	            // 2. api call A fails
	            //
	            // In which case we end up in a situation where had it been a regular chain of events,
	            // api B would never have been called in the first place.
	            //
	            // One possibility here is to return $unresolved, which prevents the promise from ever
	            // resolving, but this has the potential to cause a lot of difficulty debugging and strange
	            // corner cases.
	            //
	            // Instead we opt to simply reject the promise, and not call any of the response handlers
	
	            if (err instanceof _error.$BatchShortCircuit) {
	                return _promise.$promise.reject(err);
	            }
	
	            // Otherwise, handle the error normally
	            return self.handleErrorResponse(err, options);
	        });
	    },
	
	    // Set up a batch request for processing in the next frame
	    batchRequest: function batchRequest(options) {
	
	        // Batch Requests are an optimization layer on top of regular api calls. The purpose of this
	        // layer is to combine multiple atomic api calls into a single http request, without forcing
	        // developers to create large orchestration layers on the client/server with cross-cutting concerns.
	        //
	        // This layer will queue up multiple requests made in the same frame whenever batch-mode is enabled,
	        // attach them all to an http call to /api/batch/:name, then on the response it will dispatch each
	        // individual api call to the correct handler.
	        //
	        // The way this is implemented is to place each response in the transient api cache, then to yield
	        // control to the regular api request handler, which will handle instrumentation and retries
	
	        // For quick dev-time feedback...
	        _util.$util.assert(options.batch.name, 'Must define a "name" for batch request: ' + options.batch);
	        _util.$util.assert(options.batch.id, 'Must define a "id" for batch request: ' + options.batch);
	
	        var name = options.batch.name;
	        var id = options.batch.id;
	
	        // Add the batch request options to the batchQueue for processing on the next frame
	        var batch = batchQueue[name] = batchQueue[name] || {};
	
	        batch[id] = options;
	
	        // Fire off a batch request. This will be debounced: calls in the same frame will be combined to one
	        return this.buildBatchRequest(name).then(function (results) {
	
	            // We get back a mapping of id->response, so we now extract the response for our api
	            // call. If we have no response, we can assume the call was never made, and short circuit.
	            return results[id].then(function (result) {
	                return result || _promise.$promise.reject(new _error.$BatchShortCircuit());
	            });
	        });
	    },
	
	    // Process all of the accumulated batch api requests
	    buildBatchRequest: _promise.$promise.debounce(function (name) {
	
	        var self = this;
	        var batch = batchQueue[name];
	        var batchIds = _class.$Class.keys(batch);
	        var batchData = {};
	        var headers = {};
	
	        delete batchQueue[name];
	
	        // If we have just a single request, we can short-circuit and just hit that api
	
	        if (batchIds.length === 1) {
	
	            var batchId = batchIds[0];
	            var opts = batch[batchId];
	
	            var results = {};
	
	            results[batchId] = opts.api.attemptRequest(opts);
	            return results;
	        }
	
	        // Build the request to send to the server side. This is an mapping of id->request, each containing
	        // the method, uri, data, and dependencies for each api.
	        //
	        // Specifying a dependency for an api essentially means the back-end will only
	        // call api-B if api-A returns ack=success. Otherwise there will be no response for api B.
	
	        _util.$util.forEach(batch, function (options, id) {
	
	            batchData[id] = {
	                method: options.method,
	                uri: options.api.getURI(options.model, options.action, true),
	                data: options.data,
	                params: options.params,
	                dependencies: options.batch.dependencies
	            };
	
	            _util.$util.extend(headers, options.headers);
	        });
	
	        // Unfortunate circular dependency... $Api depends on another api.
	        //
	        // $batchApi is subject to all of the same rules regarding retries, so if for some reason the server
	        // does not respond the first time, our batch request can still get through.
	
	        return $batchApi.action(name, {
	            data: batchData,
	            headers: headers
	        }).then(function (res) {
	
	            // The final response will be a mapping of id->response-promise.
	            //
	            // However, we do not treat this data as our final response. Instead, we simply use it to
	            // prime our transient cache, then proceed to jump to our regular request handler. This will
	            // take care of retries and instrumentation as if this were a regular request.
	            //
	            // Note that a retry for $batchApi is different to a retry for an individual api. If
	            // an *individual* api call fails, we do not want to re-do the entire batch call; instead we
	            // can just retry the individual api call.
	
	            return self.handleBatchResponse(batch, res.data);
	        });
	    }),
	
	    // Process the responses for all of the batch requests we sent to the server
	    handleBatchResponse: function handleBatchResponse(batch, data) {
	
	        var self = this;
	
	        var promises = {};
	
	        // Loop over each individual api response contained in the batch response, and process the result
	
	        _util.$util.forEach(batch, function (options, id) {
	
	            // Store each response promise so we can check and wait for api dependencies
	
	            promises[id] = _promise.$promise.run(function () {
	
	                // Check if all of the dependencies are present for our individual api call. To do this
	                // we must wait until the dependent api call is entirely complete, including any retries.
	
	                var depsPresent = _promise.$promise.every(options.batch.dependencies || [], function (depName) {
	
	                    if (!batch[depName]) {
	                        _logger.$logger.info('missing_batch_dependency', {
	                            dependency: depName,
	                            available: Object.keys(batch).join('|')
	                        });
	                    }
	
	                    return !batch[depName] || promises[depName].then(function (dependency) {
	                        return dependency && dependency.data && dependency.data.ack === 'success';
	                    });
	                });
	
	                // If our dependencies are present, we can continue, otherwise we are not interested in
	                // the result of the individual api call - if its dependency is not present, it will not be.
	
	                return _promise.$promise.providing(depsPresent, function () {
	
	                    // If there is data returned for the individual call, add it to the transient cache
	
	                    return _promise.$promise.providing(data[id], function (result) {
	                        var uri = options.api.getURI(options.model, options.action);
	                        uri = _util.$util.buildURL(uri, options.params);
	
	                        self.addTransientCacheData(options.method, uri, result);
	                    }).then(function () {
	
	                        // Regardless of whether or not there is data, we can now attempt the request.
	                        // This will either get the data from the transient cache, or make an http call,
	                        // and handle any retries that need to be made.
	
	                        return options.api.attemptRequest(options);
	                    });
	                });
	            });
	        });
	
	        return promises;
	    },
	
	    // Handle the request and any retries, using either the transient cache or http calls
	    attemptRequest: function attemptRequest(options) {
	        var self = this;
	
	        var attempts = options.method === 'get' ? this.getAttempts : this.postAttempts;
	
	        // We allow a certain number of attempts/retries for each api call
	        return _promise.$promise.attempt(attempts, function (remaining) {
	
	            // Query the transient cache
	            return self.getTransientCacheResponse(options).then(function (res) {
	
	                // If we can get a response from the transient cache, then use it
	                if (res) {
	                    return res;
	                }
	
	                // Otherwise resort to making an http call
	                return self.getHttpResponse(options);
	            })['catch'](function (res) {
	
	                // If our request was aborted without even a status code, force a single retry
	                if ((!res || !res.status) && attempts === 1) {
	
	                    _logger.$logger.warn('api_retry_aborted', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return self.getHttpResponse(options);
	                }
	
	                return _promise.$promise.reject(res);
	            })['catch'](function (res) {
	
	                // If our request was 401 denied (probably due to a CSRF error), force a single retry
	                if (res.status === 401) {
	
	                    _logger.$logger.warn('api_retry_401', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return self.getHttpResponse(options);
	                }
	
	                return _promise.$promise.reject(res);
	            })['catch'](function (res) {
	
	                // Set the correct response and ack for 401
	                if (res.status === 401) {
	                    return {
	                        data: {
	                            ack: 'permission_denied'
	                        }
	                    };
	                }
	
	                // If we have any remaining retries, log and reject
	                if (remaining) {
	
	                    _logger.$logger.warn('api_retry', {
	                        method: options.method,
	                        uri: options.uri
	                    });
	
	                    return _promise.$promise.reject(res);
	                }
	
	                // Otherwise reject the request with the appropriate error
	
	                // We got ack=error in the response
	                if (res && res.data && res.data.ack === 'error') {
	                    return _promise.$promise.reject(new _error.$ApiError('api_error', { // eslint-disable-line no-reserved-keys
	                        name: options.name,
	                        method: options.method,
	                        uri: options.uri,
	                        stack: res.data.stack,
	                        transient: options.transientError
	                    }));
	                }
	
	                // We got a response error status
	                else if (res && res.status) {
	                        return _promise.$promise.reject(new _error.$ApiError('response_status_' + res.status, { // eslint-disable-line no-reserved-keys
	                            uri: options.uri,
	                            transient: options.transientError
	                        }));
	                    } else if (res && res.error) {
	                        return _promise.$promise.reject(new _error.$ApiError('request_' + res.error, { // eslint-disable-line no-reserved-keys
	                            uri: options.uri,
	                            transient: options.transientError
	                        }));
	                    }
	
	                    // The request was aborted
	                    else {
	                            return _promise.$promise.reject(new _error.$ApiError('request_aborted', { // eslint-disable-line no-reserved-keys
	                                uri: options.uri,
	                                transient: options.transientError
	                            }));
	                        }
	            });
	        });
	    },
	
	    // Get an api response via http
	    getHttpResponse: function getHttpResponse(options) {
	        var self = this;
	
	        var startTime = _util.$util.now();
	
	        var request = this.http(options);
	
	        return request['finally'](function () {
	
	            // Calculate the end-to-end duration of the request from the client's perspective
	            options.duration = _util.$util.now() - startTime;
	        })['catch'](function (res) {
	
	            // Turn responses with an ack into a 'success' so it makes it to the standard handlers
	            if (res && res.status && res.data && res.data.ack && res.data.ack !== 'error') {
	                return res;
	            }
	
	            return _promise.$promise.reject(res);
	        }).then(function (res) {
	            self.saveResponseState(res);
	
	            var loggerPayload = {
	                name: options.name,
	                method: options.method,
	                uri: options.uri,
	                server: res.data.server,
	                time: options.duration,
	                duration: options.duration,
	                corrid: res && res.headers('Paypal-Debug-Id')
	            };
	
	            // In certain browsers we can match up this api call to the performance data from the browser
	            if (window.performance && window.performance.getEntries) {
	                _util.$util.forEach(window.performance.getEntries(), function (resource) {
	                    if (resource.name && resource.name.indexOf(options.uri) > -1) {
	                        _util.$util.extend(loggerPayload, resource);
	                    }
	                });
	            }
	
	            _logger.$logger.info('api_response', loggerPayload);
	
	            if (res && res.status) {
	                _logger.$logger.info('http_response_' + res.status);
	            }
	
	            return res;
	        }, function (res) {
	            self.saveResponseState(res);
	
	            if (res && res.status) {
	                _logger.$logger.info('http_response_' + res.status);
	            }
	
	            return _promise.$promise.reject(res);
	        });
	    },
	
	    setTransientCache: function setTransientCache(data) {
	        throw new Error('NotImplemented');
	    },
	
	    // Get an individual api response from the transient cache, as an object
	    getTransientCacheData: function getTransientCacheData(options, pop) {
	
	        if (!_config.$config.enablePreload) {
	            return _promise.$promise.resolve();
	        }
	
	        var preMethod = options.method.toLowerCase();
	        var preUri = _util.$util.buildURL(options.uri, options.params);
	
	        var key = preMethod + ':' + preUri;
	
	        return _promise.$promise.resolver(function (resolve) {
	
	            function res() {
	                var data = transientCache[key];
	
	                if (pop) {
	                    delete transientCache[key];
	                }
	                resolve(data);
	            }
	
	            if (transientCache[key] || document.readyState === 'complete' || preloadComplete) {
	                return res();
	            }
	
	            transientCacheResolvers[key] = transientCacheResolvers[key] || [];
	            transientCacheResolvers[key].push(res);
	
	            windowLoad().then(res);
	        });
	    },
	
	    // Check if the transient cache has the data for a particular api
	    hasTransientCacheData: function hasTransientCacheData(options) {
	        return this.getTransientCacheData(options, false).then(function (data) {
	            return Boolean(data);
	        });
	    },
	
	    // Add data to the transient cache
	    addTransientCacheData: function addTransientCacheData(method, uri, data) {
	        var key = method + ':' + uri;
	        transientCache[key] = data;
	    },
	
	    // Get an individual api response from transient cache, as a res promise with the correct status code
	    getTransientCacheResponse: function getTransientCacheResponse(options) {
	
	        return this.getTransientCacheData(options, true).then(function (data) {
	
	            // Preload data does not come with a response code, so massage it into a response promise
	            if (data) {
	                if (data.ack === 'error') {
	                    return _promise.$promise.reject({
	                        status: 500,
	                        data: data
	                    });
	                } else if (data.ack === 'permission_denied') {
	                    return _promise.$promise.reject({
	                        status: 401,
	                        data: data
	                    });
	                } else if (data.ack === 'contingency' || data.ack === 'validation_error') {
	                    return {
	                        status: 400,
	                        data: data
	                    };
	                } else {
	                    return {
	                        status: 200,
	                        data: data
	                    };
	                }
	            }
	
	            // Log a cache miss if we are currently in the first-page load
	            else if (options.method === 'get' && !_loader.$loader.firstLoad() && !options.silent) {
	                    _logger.$logger.info('preload_cache_miss', {
	                        uri: options.uri
	                    });
	                }
	        });
	    },
	
	    getHeaders: function getHeaders(options) {
	
	        if (!_config.$meta.headers['x-csrf-jwt'] && !_config.$meta.csrfJwt) {
	            _logger.$logger.warn('missing_csrf_jwt');
	        }
	
	        var headers = {
	            'X-Requested-With': 'XMLHttpRequest',
	            'x-csrf-jwt': _config.$meta.headers['x-csrf-jwt'] || _config.$meta.csrfJwt
	        };
	
	        if (!cookiesEnabled()) {
	            headers['x-cookies'] = JSON.stringify(_config.$meta.headers['x-cookies']);
	        }
	
	        if (options.headers) {
	            _util.$util.extend(headers, options.headers);
	        }
	
	        return headers;
	    },
	    http: function http(options) {
	        return this.httpJQuery(options);
	    },
	
	
	    /*
	     // Raw http call
	    httpAngular: function(options) {
	         let request = {
	            method: options.method,
	            url: options.uri,
	            data: {
	                data: options.data,
	                meta: options.meta
	            },
	            headers: this.getHeaders(options),
	            params: options.params,
	            requestType: 'json',
	            responseType: 'json',
	            timeout: this.timeout
	        };
	         if (options.method === 'get' && options.meta && Object.keys(options.meta).length) {
	            request.params.meta = JSON.stringify(options.meta);
	        }
	         return $http(request);
	    },
	     */
	
	    httpJQuery: function httpJQuery(options) {
	
	        var request = {
	            method: options.method,
	            data: options.method === 'get' ? options.params : JSON.stringify({
	                data: options.data,
	                meta: options.meta || {}
	            }),
	            headers: this.getHeaders(options),
	            timeout: this.timeout
	        };
	
	        if (options.method === 'post') {
	            request.headers['Content-Type'] = 'application/json;charset=UTF-8';
	        } else if (options.method === 'get') {
	            request.data.meta = JSON.stringify(options.meta);
	        }
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            function getRes(res, data) {
	                return {
	                    status: res.status,
	                    data: data,
	                    headers: function headers(name) {
	                        return res.getResponseHeader(name);
	                    }
	                };
	            }
	
	            request.success = function (data, status, res) {
	                return resolve(getRes(res, data));
	            };
	
	            request.error = function (res) {
	                if (res && res.status) {
	                    if (res.status >= 400) {
	                        return reject(getRes(res, res.responseJSON));
	                    } else {
	                        return resolve(getRes(res, res.responseJSON));
	                    }
	                }
	
	                return reject({
	                    status: 0,
	                    headers: _util.$util.noop,
	                    error: res && res.statusText
	                });
	            };
	
	            _jquery2['default'].ajax(options.uri, request);
	        });
	    },
	
	    // Save cookies and jwt-csrf token from the response
	    saveResponseState: function saveResponseState(res) {
	
	        if (res.headers('x-csrf-jwt')) {
	            _config.$meta.headers['x-csrf-jwt'] = res.headers('x-csrf-jwt');
	            _config.$meta.csrfJwt = res.headers('x-csrf-jwt');
	            _config.$meta.headers['x-csrf-jwt-hash'] = res.headers('x-csrf-jwt-hash');
	        }
	
	        if (res.headers('X-cookies')) {
	
	            _config.$meta.headers['x-cookies-hash'] = res.headers('x-cookies-hash');
	
	            // Extend local cookie jar of encrypted-cookie-name->encrypted-cookie-value with any new cookies
	            _util.$util.extend(_config.$meta.headers['x-cookies'], JSON.parse(res.headers('X-cookies') || '{}'));
	        }
	
	        latestCorrelationID = res.headers('Paypal-Debug-Id') || latestCorrelationID;
	    },
	
	    // Dispatch the response to the correct handlers
	    handleResponse: function handleResponse(res, options) {
	        var loggerName = 'ui_' + options.name;
	
	        var loggerPayload = {
	            name: options.name,
	            method: options.method,
	            uri: options.uri,
	            time: options.duration,
	            duration: options.duration
	        };
	
	        // Here we dispatch the response to the correct handler based on the ack.
	        //
	        // ack=success     -> options.success()
	        // ack=error       -> options.error()
	        // ack=validation  -> options.validation()
	        // ack=contingency -> options.contingencies[contingency]()
	        //
	        // Why do this rather than just rejecting the promise with a custom error?
	        //
	        // a) Angular promises have no `.catchType()`, so this saves us a lot of `instanceof` checks
	        // b) Angular promises have no `.done()`, so callers can not assert that they have handled
	        //    every error they want to. This is exacerbated by the fact that there is no single thread
	        //    of execution on the front-end a la node, so we can't just call `.done()` at the very end :(
	        //
	        // This way, if somebody passes a handler, it will be called. Otherwise, an error will be thrown
	        // and the global error handler will be invoked. The api responses are also given as promises.
	
	        var resultModel = options.resultModel || options.model;
	
	        /* jshint maxcomplexity: 17 */
	        return _promise.$promise.call(function () {
	
	            // If we are given a `resultModel`, we always extend it with `res.data`, no matter the ack
	
	            if (res.data && resultModel) {
	
	                if (resultModel.populate) {
	                    resultModel.populate(res.data);
	                } else {
	                    _util.$util.extend(resultModel, res.data);
	                }
	            }
	
	            if (res && res.ack === 'success' && resultModel && resultModel.fetchChildren) {
	                return _promise.$promise.resolve(resultModel.fetchChildren()).then(function (children) {
	                    return _util.$util.extend(resultModel, children);
	                });
	            }
	        }).then(function () {
	
	            // Handle each ack type, throw errors accordingly
	
	            if (res.ack === 'success') {
	                _logger.$logger.info(loggerName + '_success', loggerPayload);
	
	                if (options.success) {
	                    if (options.success instanceof Function) {
	                        return options.success(res.data);
	                    }
	                    return options.success;
	                }
	
	                return res;
	            }
	
	            if (options.failSilently) {
	                return;
	            }
	
	            if (res.ack === 'contingency') {
	                _logger.$logger.info(loggerName + '_contingency', _util.$util.extend(loggerPayload, {
	                    contingency: res.contingency
	                }));
	
	                if (!res.contingency) {
	                    throw new _error.$ApiError('expected_contingency_name', {
	                        api: options.name
	                    });
	                }
	
	                var contingency = new _error.$Contingency(res.contingency, { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	
	                if (resultModel) {
	                    resultModel.errorData = res.errorData || {};
	                }
	
	                var handler = options.contingencies && (options.contingencies[contingency.message] || options.contingencies['DEFAULT']);
	
	                _util.$util.extend(contingency, res.errorData);
	
	                if (handler) {
	                    if (handler instanceof Function) {
	                        return handler(contingency.message, contingency);
	                    }
	                    return handler;
	                }
	
	                throw contingency;
	            } else if (res.ack === 'validation') {
	                _logger.$logger.info(loggerName + '_validation', _util.$util.extend(loggerPayload, {
	                    validation: res.validation
	                }));
	
	                if (options.validation) {
	                    return options.validation(res.validation);
	                }
	
	                throw new _error.$ApiError('validation', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            } else if (res.ack === 'permission_denied') {
	                _logger.$logger.info(loggerName + '_denied', loggerPayload);
	
	                throw new _error.$Forbidden(options.uri + ': forbidden', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            } else {
	                _logger.$logger.info(loggerName + '_noack', loggerPayload);
	
	                throw new _error.$ApiError('noack', { // eslint-disable-line no-reserved-keys
	                    transient: options.transientError
	                });
	            }
	        });
	    },
	
	    // Handle http error responses (ack=error or unhandled errors)
	    handleErrorResponse: function handleErrorResponse(err, options) {
	
	        return _promise.$promise.run(function () {
	
	            // If the caller provides an error handler, let them handle it
	            if (options.error) {
	                return options.error(err);
	            }
	
	            // Otherwise we throw the error. Please not that this is NOT just rejecting the promise,
	            // this will always end up in the global error handler due to how angular promises work.
	            throw err;
	        });
	    },
	
	    // Build the uri for the api call
	    getURI: function getURI(model, action, relative) {
	        var self = this;
	
	        // build the uri as a seriest of segments
	        var uri = [];
	
	        uri.push(this.uri.replace(/\/:[\w\.]+\?/g, function (key) {
	
	            // Add any *optional* dynamic keys from the model (/foo/:bar? -> /foo/{{model.bar}})
	
	            key = key.slice(2);
	            key = key.substring(0, key.length - 1);
	
	            var component = model.get ? model.get(key) : model[key];
	
	            if (!component) {
	                return '';
	            }
	
	            return '/' + component;
	        }).replace(/:[\w\.]+/g, function (key) {
	
	            // Add any dynamic keys from the model (/foo/:bar -> /foo/{{model.bar}})
	
	            key = key.slice(1);
	
	            var component = model.get ? model.get(key) : model[key];
	
	            if (!component) {
	                throw new Error('Property "' + key + '" not found in model for: ' + self.uri);
	            }
	
	            return component;
	        }));
	
	        // Add the action, if provided (`foo.action('bar', {...})` -> /api/foo/bar
	        if (action) {
	            uri.push(action);
	        }
	
	        // Add the extension (e.g. for doing a GET on a .json resource)
	        if (this.ext) {
	            uri[uri.length - 1] += '.' + this.ext;
	        }
	
	        // Join the uri segments and strip any extra slashes
	        uri = '/' + uri.join('/').replace(/\/{2,}/g, '/').replace(/^\//, '');
	
	        // Add on the base uri, e.g. /webapps/hermes
	        if (!relative) {
	            uri = (this.baseURI || _config.$config.urls.baseUrl) + uri;
	        }
	
	        return uri;
	    },
	
	    // Attach meta data provided by the parent app
	    buildMeta: function buildMeta() {
	        if (metaBuilder) {
	            return metaBuilder();
	        }
	    },
	
	    // Build the name of the api for logging. /api/foo/bar -> api_foo_bar
	    buildAPIName: function buildAPIName(options) {
	        var self = this;
	        var apiName = self.uri.replace(/^\/+/, ''). // Remove leading '/'
	        replace(/\//g, '_'). // Replace remaining '/' with '_'
	        replace(/\?(.*)/, ''). // Remove everything after '?'
	        replace(/[^a-zA-Z0-9_]/g, '');
	
	        apiName = options.action ? apiName + '_' + options.action : apiName;
	        apiName = apiName.charAt(0) === '_' ? apiName.slice(1) : apiName;
	        return apiName;
	    }
	});
	
	$Api.reopenClass({
	    clearCache: function clearCache() {
	        cache = {};
	    }
	});
	
	$Api.registerMetaBuilder = function (builder) {
	    metaBuilder = builder;
	};
	
	var $batchApi = new $Api({
	    uri: '/api/batch',
	    postAttempts: 3
	});
	
	function $getLatestCorrelationID() {
	    return latestCorrelationID;
	}
	
	angular.value("$Api", $Api);
	angular.value("$getLatestCorrelationID", $getLatestCorrelationID);
	_logger.$logger;
	
	_event.$event;
	
	_class.$Class;
	
	_util.$util;
	
	_promise.$promise;
	
	_config.$config;
	
	_config.$meta;
	
	_error.$Contingency;
	
	_error.$Forbidden;
	
	_error.$ApiError;
	
	_error.$BatchShortCircuit;
	
	_loader.$loader;

/***/ },

/***/ "./components/squid/dist/core/event.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$event = undefined;
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var handlers = {};
	
	var customEventEmitter = void 0;
	
	var $event = exports.$event = {
	    use: function use(eventEmitter) {
	        customEventEmitter = eventEmitter;
	
	        for (var _iterator = Object.keys(handlers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var eventName = _ref;
	
	            if (handlers[eventName]) {
	                for (var _iterator2 = handlers[eventName], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	                    var _ref2;
	
	                    if (_isArray2) {
	                        if (_i2 >= _iterator2.length) break;
	                        _ref2 = _iterator2[_i2++];
	                    } else {
	                        _i2 = _iterator2.next();
	                        if (_i2.done) break;
	                        _ref2 = _i2.value;
	                    }
	
	                    var handler = _ref2;
	
	                    customEventEmitter.on(eventName, handler);
	                }
	            }
	        }
	    },
	    on: function on(eventName, method) {
	
	        if (customEventEmitter) {
	            return customEventEmitter.on(eventName, method);
	        }
	
	        handlers[eventName] = handlers[eventName] || [];
	        handlers[eventName].push(method);
	
	        var cancelled = false;
	
	        function cancel() {
	            if (!cancelled) {
	                handlers[eventName].splice(handlers[eventName].indexOf(method), 1);
	                cancelled = true;
	            }
	        }
	
	        cancel.cancel = cancel;
	        return cancel;
	    },
	    once: function once(eventName, method) {
	
	        if (customEventEmitter) {
	            return customEventEmitter.once(eventName, method);
	        }
	
	        var listener = $event.on(eventName, function () {
	            listener.cancel();
	            return method.apply(this, arguments);
	        });
	
	        return listener;
	    },
	    emit: function emit(eventName) {
	        if (customEventEmitter) {
	            var _customEventEmitter;
	
	            return (_customEventEmitter = customEventEmitter).emit.apply(_customEventEmitter, arguments);
	        }
	
	        var event = {
	            preventDefault: function preventDefault() {
	                event.defaultPrevented = true;
	            }
	        };
	
	        if (handlers[eventName]) {
	            for (var _iterator3 = Array.prototype.slice.apply(handlers[eventName]), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	                var _ref3;
	
	                if (_isArray3) {
	                    if (_i3 >= _iterator3.length) break;
	                    _ref3 = _iterator3[_i3++];
	                } else {
	                    _i3 = _iterator3.next();
	                    if (_i3.done) break;
	                    _ref3 = _i3.value;
	                }
	
	                var handler = _ref3;
	
	                handler.apply(this, [event].concat(Array.prototype.slice.call(arguments)));
	            }
	        }
	
	        return event;
	    },
	    broadcast: function broadcast(eventName) {
	
	        if (customEventEmitter) {
	            var _customEventEmitter2;
	
	            return (_customEventEmitter2 = customEventEmitter).broadcast.apply(_customEventEmitter2, arguments);
	        }
	
	        return $event.emit.apply($event, arguments);
	    },
	
	
	    refCount: function refCount($scope, start, stop) {
	        return _promise.$promise.resolver(function (resolve) {
	
	            var count = 0;
	
	            function res() {
	                if (!count) {
	
	                    if (cancelStartListener && cancelStopListener) {
	                        cancelStartListener();
	                        cancelStopListener();
	                    }
	
	                    return resolve();
	                }
	            }
	
	            var cancelStartListener = $scope.$on(start, function (event, data) {
	                count += 1;
	            });
	
	            var cancelStopListener = $scope.$on(stop, function (event, data) {
	                setTimeout(function () {
	                    count -= 1;
	                    res();
	                }, 50);
	            });
	
	            setTimeout(res, 50);
	        });
	    },
	
	    compose: function compose(start, end, startAll, endAll) {
	        var debounce = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	
	        var count = 0;
	        var active = false;
	
	        $event.on(start, function () {
	            if (!count) {
	                setTimeout(function () {
	                    if (count && !active) {
	                        active = true;
	                        $event.emit(startAll);
	                    }
	                }, debounce);
	            }
	
	            count += 1;
	        });
	
	        $event.on(end, function () {
	
	            setTimeout(function () {
	                count -= 1;
	
	                if (!count && active) {
	                    active = false;
	                    $event.emit(endAll);
	                }
	            }, 0);
	        });
	
	        return {
	            getCount: function getCount() {
	                return count;
	            },
	            isActive: function isActive() {
	                return Boolean(count);
	            },
	            reset: function reset() {
	                count = 0;
	            }
	        };
	    }
	};
	
	angular.value("$event", $event);
	_promise.$promise;

/***/ },

/***/ "./components/squid/dist/core/promise.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$promise = $promise;
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var Promise = window.Promise;
	
	function $promise(obj) {
	    return Promise.resolve(obj);
	}
	
	_util.$util.extend($promise, {
	    use: function use(CustomPromise) {
	        Promise = CustomPromise;
	    },
	    resolver: function resolver(method) {
	        return new Promise(method);
	    },
	    resolve: function resolve(value) {
	        return Promise.resolve(value);
	    },
	    reject: function reject(value) {
	        return Promise.reject(value);
	    },
	
	
	    run: function run(method) {
	        return Promise.resolve().then(method);
	    },
	
	    call: function call(method) {
	        return Promise.resolve().then(method);
	    },
	
	    sequential: function sequential(methods) {
	
	        var prom = Promise.resolve();
	
	        _util.$util.forEach(methods, function (method) {
	            prom = prom.then(method);
	        });
	
	        return prom;
	    },
	
	    sleep: function sleep(time) {
	        return new Promise(function (resolve) {
	            setTimeout(resolve, time);
	        });
	    },
	
	    map: function map(items, method) {
	
	        var promises = void 0;
	
	        if (items instanceof Array) {
	            promises = [];
	        } else if (items instanceof Object) {
	            promises = {};
	        } else {
	            return Promise.resolve();
	        }
	
	        return this.all(_util.$util.map(items, function (item, key) {
	
	            promises[key] = Promise.resolve(item).then(function (result) {
	                return method(result, key, promises);
	            });
	
	            return promises[key];
	        }));
	    },
	
	    all: function all(items) {
	
	        if (items instanceof Array) {
	            return Promise.all(items);
	        } else if (items instanceof Object) {
	            return this.hash(items);
	        }
	
	        return Promise.resolve([]);
	    },
	
	    hash: function hash(obj) {
	        var results = {};
	
	        return Promise.all(_util.$util.map(obj, function (item, key) {
	            return Promise.resolve(item).then(function (result) {
	                results[key] = result;
	            });
	        })).then(function () {
	            return results;
	        });
	    },
	
	    extend: function extend(obj, hash) {
	        return this.hash(hash || {}).then(function (data) {
	            _util.$util.extend(obj, data);
	        });
	    },
	
	    attempt: function attempt(attempts, method) {
	
	        attempts -= 1;
	
	        return Promise.resolve().then(function () {
	            return method(attempts);
	        })['catch'](function (err) {
	
	            if (attempts) {
	                return $promise.attempt(attempts, method);
	            }
	
	            return Promise.reject(err);
	        });
	    },
	
	    debounce: function debounce(method, time) {
	
	        var timeout = void 0;
	        var resolvers = {};
	
	        return function () {
	
	            var self = this;
	            var args = arguments;
	            var key = JSON.stringify(args);
	
	            resolvers[key] = resolvers[key] || [];
	
	            return new Promise(function (resolve) {
	                resolvers[key].push(resolve);
	                clearTimeout(timeout);
	
	                timeout = setTimeout(function () {
	
	                    var result = method.apply(self, args);
	
	                    _util.$util.forEach(resolvers[key], function (resolver) {
	                        resolver(result);
	                    });
	
	                    delete resolvers[key];
	                }, time);
	            });
	        };
	    },
	
	    every: function every(collection, handler) {
	        return this.map(collection, function (item) {
	            return handler(item);
	        }).then(function (results) {
	            return _util.$util.every(results);
	        });
	    },
	
	    providing: function providing(condition, handler) {
	        return Promise.resolve(condition).then(function (result) {
	            if (result) {
	                return handler(result);
	            }
	        });
	    },
	
	    until: function until(condition, pollTime, timeout, alwaysResolve) {
	
	        return new Promise(function (resolve, reject) {
	            if (condition()) {
	                return resolve();
	            }
	
	            var interval = setInterval(function () {
	                if (condition()) {
	                    clearInterval(interval);
	                    return resolve();
	                }
	            }, pollTime);
	
	            if (timeout) {
	                setTimeout(function () {
	                    clearInterval(interval);
	                    return alwaysResolve ? resolve() : reject();
	                }, timeout);
	            }
	        });
	    },
	
	    first: function first(handlers) {
	
	        var prom = $promise.resolve();
	        var result = void 0;
	
	        _util.$util.forEach(handlers, function (handler) {
	            prom = prom.then(function () {
	                return result || handler();
	            }).then(function (handlerResult) {
	                result = handlerResult;
	                return result;
	            });
	        });
	
	        return prom;
	    }
	});
	
	angular.value("$promise", $promise);
	_util.$util;

/***/ },

/***/ "./components/squid/dist/core/util.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$unresolved = exports.$util = undefined;
	exports.$getRedirectUrl = $getRedirectUrl;
	exports.$dispatch = $dispatch;
	exports.$experiment = $experiment;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _base = __webpack_require__("./components/base64/base64.min.js");
	
	var base64 = _interopRequireWildcard(_base);
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	var _integration = __webpack_require__("./components/squid/dist/core/integration.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var redirected = false;
	var paramCache = {};
	
	// incase base64 has been CJS packed, it will export itself
	if (typeof window.atob === 'undefined' || typeof window.btoa === 'undefined') {
	    window.atob = base64.atob;
	    window.btoa = base64.btoa;
	}
	
	var $util = exports.$util = {
	
	    forEach: function forEach(collection, method) {
	        if (collection instanceof Array) {
	            for (var i = 0; i < collection.length; i++) {
	                method(collection[i], i);
	            }
	        } else if (collection instanceof Object) {
	            for (var key in collection) {
	                if (collection.hasOwnProperty(key)) {
	                    method(collection[key], key);
	                }
	            }
	        }
	    },
	
	    idleTimeout: function idleTimeout(time) {
	        setTimeout(function () {
	            _logger.$logger.info('page_idle');
	            $util.reload();
	        }, time);
	    },
	
	
	    reload: function reload() {
	        _logger.$logger.info('reload');
	        _event.$event.emit('loading');
	        window.location.reload();
	    },
	
	    redirect: function redirect(url, options) {
	
	        if (url.toLowerCase().indexOf('javascript:') !== -1) {
	            // eslint-disable-line
	            _logger.$logger.error('unsafe_redirect_url', {
	                url: url
	            });
	            throw new Error('Unsafe redirect url: ' + url);
	        }
	
	        _logger.$logger.info('redirect', {
	            url: url
	        });
	
	        _event.$event.on('$stateChangeStart', function (event) {
	            _logger.$logger.info('state_change_after_redirect');
	            event.preventDefault();
	        });
	
	        function redir() {
	
	            if (redirected) {
	                return;
	            }
	
	            _logger.$logger.info('redirect', {
	                url: url
	            });
	
	            window.onunload = window.onbeforeunload = function () {}; // eslint-disable-line no-empty-function
	
	            if (_integration.$integration.getConfig('REDIRECT_TOP') !== false) {
	                window.top.location = url;
	            } else {
	                window.location = url;
	            }
	
	            redirected = true;
	        }
	
	        _event.$event.emit('loading');
	
	        _logger.$logger.flush().then(redir);
	        setTimeout(redir, 500);
	
	        _logger.$logger.done();
	    },
	
	    cookiesEnabled: function cookiesEnabled() {
	        var cookiesEnabled = void 0;
	
	        document.cookie = '_cookiecheck=1';
	        cookiesEnabled = Boolean(document.cookie.indexOf('_cookiecheck') > -1);
	        document.cookie = '_cookiecheck=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	        document.cookie = '_cookiecheck; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	
	        return cookiesEnabled;
	    },
	
	    storageEnabled: function storageEnabled(api) {
	        try {
	            window[api].setItem('__feature_test__', '0');
	            window[api].removeItem('__feature_test__');
	            return true;
	        } catch (e) {
	            return false;
	        }
	    },
	
	    sessionStorageEnabled: function sessionStorageEnabled() {
	        return this.storageEnabled('sessionStorage');
	    },
	
	    localStorageEnabled: function localStorageEnabled() {
	        return this.storageEnabled('localStorage');
	    },
	
	    params: function params(string) {
	
	        if (typeof string !== 'string') {
	            string = this.queryString().slice(1);
	        }
	
	        var params = {};
	
	        if (!string) {
	            return params;
	        }
	
	        if (paramCache[string]) {
	            return $util.extend({}, paramCache[string]);
	        }
	
	        $util.forEach(string.split('&'), function (pair) {
	            pair = pair.split('=');
	
	            if (pair[0] && pair[1]) {
	                params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	            }
	        });
	
	        paramCache[string] = params;
	
	        return params;
	    },
	
	    queryString: function queryString() {
	        if (window.location.search) {
	            return window.location.search;
	        } else {
	            var string = window.location.href;
	            var idx = string.indexOf('&');
	            var rIdx = string.lastIndexOf('#');
	
	            if (idx) {
	                return '?' + string.substring(idx, rIdx >= 0 ? rIdx : string.length);
	            }
	        }
	        return '';
	    },
	
	    queryStringSplice: function queryStringSplice(qs, insert, remove) {
	        if (qs.indexOf('?') === 0) {
	            qs = qs.slice(1);
	        }
	
	        var params = $util.extend(this.params(qs), insert);
	
	        $util.forEach(remove, function (key) {
	            delete params[key];
	        });
	
	        return '?' + this.paramToQueryString(params);
	    },
	
	    extend: function extend(obj, source) {
	
	        if (!source) {
	            return obj;
	        }
	
	        for (var key in source) {
	            if (source.hasOwnProperty(key)) {
	                obj[key] = source[key];
	            }
	        }
	
	        return obj;
	    },
	
	
	    paramToQueryString: function paramToQueryString(params) {
	        return this.filter(this.map(Object.keys(params).sort(), function (key) {
	            if (!params[key]) {
	                return;
	            }
	
	            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
	        })).join('&');
	    },
	
	    param: function $param(name) {
	        return this.params()[name];
	    },
	
	    hashParam: function hashParam(name) {
	        return this.params(window.location.hash.slice(1))[name];
	    },
	
	    base64Decode: function base64Decode(encodedString) {
	        return encodedString && window.atob(encodedString); // eslint-disable-line block-scoped-var,no-undef
	    },
	
	    /*
	     * decodeAndParse :
	     * 1 - Base64Decode
	     * 2 - URI Decode
	     * 3 - Split string into a nvp object
	     * return obj
	     */
	    decodeAndParse: function decodeAndParse(encodedString) {
	        if (encodedString) {
	            return this.params(decodeURIComponent(this.base64Decode(encodedString)));
	        }
	    },
	
	    assert: function $assert(value, message, payload) {
	        if (!value) {
	            throw new Error(message, payload || {});
	        }
	    },
	
	    map: function $map(array, method) {
	
	        array = array || [];
	
	        var results = void 0;
	
	        if (array instanceof Array) {
	            results = [];
	
	            $util.forEach(array, function () {
	                results.push(method.apply(this, arguments));
	            });
	
	            return results;
	        } else if (array instanceof Object) {
	
	            results = {};
	
	            $util.forEach(array, function (val, key) {
	                results[key] = method.apply(this, arguments);
	            });
	
	            return results;
	        } else {
	            throw new Error('$util.map expects array or object');
	        }
	    },
	
	    filter: function $filter(array, method) {
	        method = method || Boolean;
	        var results = [];
	
	        $util.forEach(array, function (item) {
	            if (method.apply(this, arguments)) {
	                results.push(item);
	            }
	        });
	
	        return results;
	    },
	
	    find: function $find(array, method) {
	
	        if (!array) {
	            return;
	        }
	
	        for (var i = 0; i < array.length; i++) {
	            if (method(array[i])) {
	                return array[i];
	            }
	        }
	    },
	
	    findIndex: function $find(array, method) {
	
	        if (!array) {
	            return;
	        }
	
	        for (var i = 0; i < array.length; i++) {
	            if (method(array[i])) {
	                return i;
	            }
	        }
	    },
	
	    range: function range(start, end) {
	        if (!end) {
	            end = start;
	            start = 0;
	        }
	
	        var result = [];
	
	        for (var i = start; i < end; i++) {
	            result.push(i);
	        }
	
	        return result;
	    },
	
	    pad: function $pad(string, n, char) {
	
	        n = n || 0;
	        char = char || '0';
	
	        var padding = Array(n + 1).join(char.toString());
	
	        return (padding + string).slice(-n);
	    },
	
	    /**
	     * Deprecated.
	     *
	     * If you have an array, use Array#some()
	     * If you have an object, use the lodash or underscore .some() method
	     *
	     * @deprecated
	     */
	    some: function $some(array, method) {
	        if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
	            _angular.$log.warn('deprecated_method: squid.$util.some() is deprecated, use Array#some or\n                        lodash/underscore.some() instead.');
	        }
	
	        var result = void 0;
	
	        $util.forEach(array, function (item, key) {
	            if (!result) {
	                result = method(item, key);
	            }
	        });
	
	        return result;
	    },
	
	    every: function $every(array, method) {
	        method = method || Boolean;
	
	        var result = true;
	
	        $util.forEach(array, function (item) {
	            if (!method(item)) {
	                result = false;
	            }
	        });
	
	        return result;
	    },
	
	    reduce: function $reduce(array, method, intial) {
	        $util.forEach(array, function (item) {
	            intial = method(intial, item);
	        });
	
	        return intial;
	    },
	
	    isPopup: function isPopup() {
	        return _integration.$integration.isPopup();
	    },
	
	    isIFrame: function isIFrame() {
	        return _integration.$integration.isIFrame();
	    },
	
	    buildURL: function buildURL(url, params) {
	        /*
	         * Do NOT add a check for anchor cause this function is also used for building XO success / cancel urls.
	         * These urls are defined by the merchants and can also contain urls like "abc.com#merchantanchor" and merchants
	         * expect (!) the following outcome: abc.com#merchantanchor?paypalparam=2
	         */
	        this.assert(url, 'buildURL :: expected url');
	
	        var paramKeys = Object.keys(params || {});
	
	        if (JSON.stringify(params) === '{}') {
	            return url;
	        }
	
	        if (!paramKeys.length) {
	            return url;
	        }
	
	        if (url.indexOf('?') === -1) {
	            url += '?';
	        } else {
	            url += '&';
	        }
	
	        url += this.paramToQueryString(params);
	
	        return url;
	    },
	
	    paypalURL: function paypalURL(url, params) {
	        url = 'https://' + (_config.$meta.stage ? _config.$meta.stage : window.location.host) + url;
	
	        return this.buildURL(url, params);
	    },
	
	    override: function override(obj, methodName, handler) {
	        var existing = obj[methodName];
	
	        obj[methodName] = function () {
	            if (existing) {
	                try {
	                    existing.apply(obj, arguments);
	                } catch (err) {
	                    _logger.$logger.error(methodName + 'event_error', {
	                        error: err.toString
	                    });
	                }
	            }
	
	            return handler.apply(obj, arguments);
	        };
	    },
	
	    result: function result(method) {
	        return method();
	    },
	
	    memoize: function memoize(method) {
	        var result = void 0;
	        var called = false;
	
	        function memoized() {
	            if (!called) {
	                result = method.apply(this, arguments);
	            }
	            called = true;
	            return result;
	        }
	
	        memoized.flush = function () {
	            called = false;
	        };
	
	        return memoized;
	    },
	
	    now: function now() {
	        return window.enablePerformance ? parseInt(window.performance.now(), 10) : Date.now();
	    },
	
	    bindObject: function bindObject(obj, self) {
	        return $util.map(obj, function (method) {
	            return method.bind(self);
	        });
	    },
	
	    hashStr: function hashStr(str) {
	        var hash = 0;
	        var i = void 0;
	        var chr = void 0;
	        var len = void 0;
	
	        if (str.length === 0) {
	            return hash;
	        }
	        for (i = 0, len = str.length; i < len; i++) {
	            chr = str.charCodeAt(i);
	            hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise, no-extra-parens
	            // Convert to 32bit integer
	            hash |= 0; // eslint-disable-line no-bitwise
	        }
	        return Math.abs(hash);
	    },
	
	    hash: function hash() {
	        return this.hashStr(Math.random());
	    },
	
	    popup: function popup(name, url, options, callback) {
	
	        callback = $util.once(callback);
	
	        var win = window.open(url, name, $util.map(Object.keys(options), function (key) {
	            return key + '=' + options[key];
	        }).join(', '));
	
	        var interval = void 0;
	
	        function checkWindowClosed() {
	            if (win.closed) {
	                clearInterval(interval);
	                callback();
	            }
	        }
	
	        interval = setInterval(checkWindowClosed, 50);
	        setTimeout(checkWindowClosed);
	
	        try {
	            var close = win.close;
	
	            win.close = function () {
	                close.apply(this, arguments);
	                checkWindowClosed();
	            };
	        } catch (err) {
	            // pass
	        }
	
	        return win;
	    },
	
	    unique: function unique(collection) {
	        return collection.filter(function (value, index, self) {
	            return self.indexOf(value) === index;
	        });
	    },
	
	    monkeyPatch: function monkeyPatch(mod, prop, method) {
	        var original = mod[prop];
	
	        mod[prop] = function () {
	            var _this = this,
	                _arguments = arguments;
	
	            return method.call(this, arguments, function (self, args) {
	                if (original) {
	                    return original.apply(self || _this, args || _arguments);
	                }
	            });
	        };
	    },
	    once: function once(method) {
	        var called = false;
	
	        return function () {
	            if (!called) {
	                called = true;
	                return method.apply(this, arguments);
	            }
	        };
	    },
	    camelToDasherize: function camelToDasherize(string) {
	        return string.replace(/([A-Z])/g, function (g) {
	            return '-' + g.toLowerCase();
	        });
	    },
	    camelToCapsUnderscore: function camelToCapsUnderscore(string) {
	        return string.replace(/([a-z][A-Z])/g, function (g) {
	            return g[0] + '_' + g[1];
	        }).toUpperCase();
	    },
	    dasherizeToCamel: function dasherizeToCamel(string) {
	        return string.replace(/-([a-z])/g, function (g) {
	            return g[1].toUpperCase();
	        });
	    },
	
	
	    parentWindow: function parentWindow() {
	        if (window.opener) {
	            return window.opener;
	        } else if (window.parent !== window) {
	            return window.parent;
	        }
	    },
	
	    hasRTL: function hasRTL(str) {
	        return new RegExp('[\u0590-\u07BF]').test(str);
	    },
	    noop: function noop() {// eslint-disable-line no-empty-function
	
	    }
	};
	
	var $unresolved = exports.$unresolved = { then: $util.noop, 'catch': $util.noop };
	
	function $getRedirectUrl(product, params) {
	    var url = '';
	    var urlParams = $util.params();
	
	    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
	        url = _config.$config.urls.dispatch && _config.$config.urls.dispatch[product] || '';
	    }
	
	    url += _config.$config.urls.fallbackUrl[product];
	
	    $util.extend(urlParams, params || {});
	
	    // cmd is a reserved slingshot param
	    if (urlParams.cmd) {
	        delete urlParams.cmd;
	    }
	
	    return $util.buildURL(url, urlParams);
	}
	
	function $dispatch(product, params, stateChange) {
	    $util.assert(product, 'expected product');
	
	    _logger.$logger.log('info', 'dispatch', {
	        product: product
	    });
	
	    _event.$event.emit('loading');
	
	    var url = '';
	
	    url = $getRedirectUrl(product, params);
	
	    // fire an event for xo-tracking to listen to and do fpti logging
	    if (stateChange) {
	        _event.$event.emit('page_loaded', stateChange.fromState, stateChange.toState);
	    }
	
	    return $util.redirect(url);
	}
	
	function $experiment(name, sample, id, loggerPayload) {
	
	    var throttle = $util.hashStr(name + '_' + id) % 100;
	
	    var group = void 0;
	
	    if ($util.param(name) === 'true') {
	        group = 'test_forced';
	    } else if ($util.param(name) === 'false') {
	        group = 'control_forced';
	    } else if (throttle < sample) {
	        group = 'test';
	    } else if (sample >= 50 || sample <= throttle && throttle < sample * 2) {
	        // eslint-disable-line no-extra-parens
	        group = 'control';
	    } else {
	        group = 'throttle';
	    }
	
	    _logger.$logger.info('fpti_pxp_check', {
	        from: 'PXP_CHECK',
	        to: 'process_pxp_check',
	        pxp_exp_id: name,
	        pxp_trtmnt_id: group
	    });
	
	    _logger.$logger.info(name + '_' + group, loggerPayload || {});
	
	    if (group === 'test' || group === 'test_forced') {
	        return true;
	    } else if (group === 'control') {
	        return false;
	    }
	}
	
	angular.value("$util", $util);
	angular.value("$unresolved", $unresolved);
	angular.value("$getRedirectUrl", $getRedirectUrl);
	angular.value("$dispatch", $dispatch);
	angular.value("$experiment", $experiment);
	_event.$event;
	
	_logger.$logger;
	
	_config.$config;
	
	_config.$meta;
	
	_integration.$integration;
	
	_angular.$log;

/***/ },

/***/ "./components/base64/base64.min.js":
/***/ function(module, exports, __webpack_require__) {

	!function(){function t(t){this.message=t}var r= true?exports:this,e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";t.prototype=new Error,t.prototype.name="InvalidCharacterError",r.btoa||(r.btoa=function(r){for(var o,n,a=String(r),i=0,c=e,d="";a.charAt(0|i)||(c="=",i%1);d+=c.charAt(63&o>>8-i%1*8)){if(n=a.charCodeAt(i+=.75),n>255)throw new t("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");o=o<<8|n}return d}),r.atob||(r.atob=function(r){var o=String(r).replace(/=+$/,"");if(o.length%4==1)throw new t("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,a,i=0,c=0,d="";a=o.charAt(c++);~a&&(n=i%4?64*n+a:a,i++%4)?d+=String.fromCharCode(255&n>>(-2*i&6)):0)a=e.indexOf(a);return d})}();


/***/ },

/***/ "./components/squid/dist/core/config.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	var $meta = exports.$meta = window.meta || {};
	var $cookies = exports.$cookies = window.cookies || {};
	var $config = exports.$config = window.config || {};
	angular.value("$meta", $meta);
	angular.value("$cookies", $cookies);
	angular.value("$config", $config);

/***/ },

/***/ "./components/squid/dist/core/integration.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$integration = exports.$CONTEXT = exports.$DEFAULT = undefined;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var $DEFAULT = exports.$DEFAULT = 'DEFAULT';
	
	var $CONTEXT = exports.$CONTEXT = {
	
	    // Full page checkout
	    FULLPAGE: 'FULLPAGE',
	
	    // Checkout in popup
	    POPUP: 'POPUP',
	
	    // Checkout in lightbox (iframe)
	    LIGHTBOX: 'LIGHTBOX',
	
	    // Web view
	    WEBVIEW: 'WEBVIEW',
	
	    // Native checkout
	    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
	};
	
	var $integration = exports.$integration = {
	
	    flow: $DEFAULT,
	
	    init: function init(flow, config) {
	        this.config = config || {};
	
	        if (flow) {
	            this.setFlow(flow);
	        }
	
	        this.setContext(this.getContext());
	    },
	    getContext: function getContext() {
	
	        if (this.isIFrame()) {
	            return $CONTEXT.LIGHTBOX;
	        } else if (this.isPopup()) {
	            return $CONTEXT.POPUP;
	        } else {
	            return $CONTEXT.FULLPAGE;
	        }
	    },
	    isPopup: function isPopup() {
	        return Boolean(window.opener);
	    },
	    isIFrame: function isIFrame() {
	        return window.top !== window.self;
	    },
	    setContext: function setContext(context) {
	        _logger.$logger.info('integration_context_' + context);
	        this.context = context;
	    },
	    setFlow: function setFlow(flow) {
	        _logger.$logger.info('integration_flow_' + flow);
	        this.flow = flow;
	    },
	    is: function is(context, flow) {
	        return this.isContext(context) && this.isFlow(flow);
	    },
	    isContext: function isContext(context) {
	        return this.context === context;
	    },
	    isFlow: function isFlow(flow) {
	        return this.flow === flow;
	    },
	    getConfig: function getConfig(key) {
	
	        this.context = this.getContext();
	
	        if (!this.config) {
	            return;
	        }
	
	        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(this.flow) && this.config[this.context][this.flow].hasOwnProperty(key)) {
	
	            return this.config[this.context][this.flow][key];
	        }
	
	        if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(key)) {
	
	            return this.config[this.context][key];
	        }
	
	        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(this.flow) && this.config[$DEFAULT][this.flow].hasOwnProperty(key)) {
	
	            return this.config[$DEFAULT][this.flow][key];
	        }
	
	        if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(key)) {
	
	            return this.config[$DEFAULT][key];
	        }
	    },
	    error: function error(message) {
	        return new Error('Integration error: ' + this.context + ' / ' + this.flow + ' :: ' + message);
	    }
	};
	
	angular.value("$integration", $integration);
	_logger.$logger;

/***/ },

/***/ "./components/squid/dist/core/class.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 Class
	 -----
	
	 A class pattern, adding sugar on top of javascript prototypes
	
	 ### Basic Usage
	
	 let MyClass = Class.extend({
	 foo: 'bar';
	 });
	
	 myInstance = new MyClass({
	 hello: 'world'
	 });
	
	 console.log(myInstance.foo, myInstance.hello)
	
	 In this example, `foo` becomes a property on `MyClass`'s prototype,
	 and `hello` becomes a property on `myInstance`.
	
	 ### Default Object Methods
	
	 - `init()`: Called after the object is first instantiated, with all properties available
	
	 - `get(<path>, <default>)`: Get an object an arbitrary number of levels deep, or return a default
	
	 e.g. `myInstance.get('foo.bar.baz', 'some_default');`
	
	 Default return value is undefined
	
	 - `set(<path>, <value>)`: Set an object an arbitrary number of levels deep
	
	 e.g. `myInstance.set('foo.bar.baz', 'some_value');`
	
	 Error is thrown if no object is found to set the value on
	
	 - `setProperties(<object>)`: Set all the properties from an object onto your object
	
	 e.g. `myInstance.setProperties({foo: 'bar', hello: 'world'})`
	
	 Can not be used with nested properties
	
	 - `forEach(<callback>)`: Loop through the object and call callback(<key>, <value>) for each key/val pair
	
	 */
	
	// Object Create
	// -------------
	//
	// Shim for Object.create, if it is not supported by our browser
	//
	// let myPrototype = {foo: 'bar'}
	// let myObject = create(myPrototype)
	
	// Create an empty anonymous constructor with no side effects, for re-use later
	var EmptyConstructor = function EmptyConstructor() {}; // eslint-disable-line no-empty-function
	
	var create = Object.create || function create(obj) {
	
	    // Set a temporary prototype
	    EmptyConstructor.prototype = obj;
	
	    // Create an object using our temporary constructor/prototype
	    var instance = new EmptyConstructor();
	
	    // Reset the prototype for next time
	    EmptyConstructor.prototype = null;
	
	    // Return our new object, created without side effects
	    return instance;
	};
	
	function _extend(obj, source) {
	
	    if (!source) {
	        return obj;
	    }
	
	    for (var key in source) {
	        if (source.hasOwnProperty(key)) {
	            obj[key] = source[key];
	        }
	    }
	
	    return obj;
	}
	
	// Is Object
	// ---------
	//
	// Check of a let is an object or not
	//
	// isobject({}) -> true
	// isobject('foo') -> false
	
	function isobject(obj) {
	    return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj instanceof Object;
	}
	
	// Transpose properties
	// -------------------------------------------------------------------
	//
	// Transpose properties from a list of objects onto a recipient object
	//
	// let recipient = {};
	// transpose(recipient, [{a: 1, b: 2}, {c: 3}])
	// recipient -> {a: 1, b: 2, c:3}
	
	function transpose(recipient, args) {
	
	    // Loop through all args
	    for (var i = 0; i < args.length; i++) {
	        var ob = args[i];
	
	        // Ignore anything that is not an object
	        if (!isobject(ob)) {
	            continue;
	        }
	
	        // Loop through all keys in our object
	        for (var key in ob) {
	
	            // Ignore any prototypal properties
	            if (!ob.hasOwnProperty(key)) {
	                continue;
	            }
	
	            var item = ob[key];
	
	            // Give the function a name
	            if (item instanceof Function) {
	                item.__name__ = key;
	            }
	
	            recipient[key] = item;
	        }
	    }
	}
	
	// Construct a Class
	// -----------------
	//
	// This is the primary constructor for all $Class objects
	
	function construct() {
	    // eslint-disable-line no-unused-vars
	
	    // Call any custom constructor;
	    if (this.construct) {
	        var ob = this.construct.apply(this, arguments);
	
	        // If we get a new object back, return that to the user
	        if (isobject(ob)) {
	            return ob;
	        }
	    }
	
	    // Load any provided properties directly onto the object
	    transpose(this, arguments);
	
	    // Initialize the object
	    if (this.init) {
	        this.init();
	    }
	}
	
	// Reopen an object
	// ----------------
	//
	// Add properties to the constructor's prototype
	//
	//     let Animal = $Class.extend();
	//
	//     Animal.reopen({
	//       type: 'animal',
	//     });
	//
	//     let cat = new Animal;
	//     console.log(cat.type);
	function reopen() {
	
	    // Add some more properies to our prototype
	    transpose(this.prototype, arguments);
	
	    return this;
	}
	
	// Reopen a class
	// --------------
	//
	// Add properties to the constructor. These will propogate through future extends
	//
	//     let Animal = $Class.extend();
	//
	//     Animal.reopenClass({
	//       fromCache: function(id) {
	//         return cache[id] || new this({id: id});
	//       }
	//     }
	//
	//     let cat = Animal.fromCache('cat_54');
	
	function reopenClass() {
	
	    // Add some more properies to our class
	    transpose(this, arguments);
	
	    // Add to __classmethods__
	    transpose(this.__classmethods__, arguments);
	
	    return this;
	}
	
	function isChild(Cls) {
	    return Cls && Cls.prototype instanceof this;
	}
	
	// Generate a new class
	// --------------------
	//
	// Generate a new constructor, with the specified name, and attach all static and prototypal methods
	
	var id = 0;
	
	function extend(name) {
	    var Cls = void 0;
	    var className = void 0;
	    var args = void 0;
	    var argsLength = void 0;
	    var startIndex = void 0;
	
	    // Accept an optional class name
	    if (typeof name === 'string') {
	
	        // Guard against javascript injection
	        if (!name.match(/^[\w$][\w\d]*$/)) {
	            throw new Error('Class name can not include special characters: ' + name);
	        }
	
	        // Use the provided name and slice out the first argument
	        className = name;
	        argsLength = arguments.length && arguments.length - 1;
	        startIndex = 1;
	    } else {
	
	        // Otherwise default to the parent name, or 'Object' if generating our first class
	        className = this.name || 'Object';
	        argsLength = arguments.length;
	        startIndex = 0;
	    }
	
	    args = new Array(argsLength);
	    for (var i = startIndex; i < arguments.length; i++) {
	        args[i - startIndex] = arguments[i];
	    }
	
	    // Dynamically create our constructor with a custom name
	    eval('Cls = function ' + className + '() { return construct.apply(this, arguments) }'); // eslint-disable-line no-eval
	
	    // Store the class name for future reference
	    Cls.__name__ = className;
	
	    // Set up a classmethods object. These will be inherited through subsequent extend() calls
	    Cls.__classmethods__ = {
	        extend: extend,
	        reopen: reopen,
	        reopenClass: reopenClass,
	        isChild: isChild
	    };
	
	    id += 1;
	    Cls.id = id;
	
	    // If we're being called on an existing class, e.g. Class.extend(), we should inherit from that class
	    if (this && this !== window) {
	
	        // Inherit everything from superclass prototype
	        Cls.prototype = create(this.prototype);
	
	        // Re-set the constructor, which is overwritten by create
	        Cls.prototype.constructor = Cls;
	
	        // Add a reference to the superclass prototype for super method calls
	        Cls.prototype._super = this.prototype;
	
	        // Inherit any class methods from the superclass
	        _extend(Cls.__classmethods__, this.__classmethods__);
	    }
	
	    // Add the class methods to our existing class
	    _extend(Cls, Cls.__classmethods__);
	
	    // Load any provided properties onto the constructor's prototype
	    transpose(Cls.prototype, args);
	
	    // Temporary: allow access from console/debugger
	    if (className.indexOf('$') === 0) {
	        window[className] = Cls;
	    } else {
	        window['$' + className] = Cls;
	    }
	
	    return Cls;
	}
	
	// Multi-layer get
	// ---------------
	//
	// Recursively gets a deep path from an object, returning a default value if any level is not found
	//
	// let obj = {bar: {baz: 1}}
	// get(obj, 'bar.baz', 'default') -> 1
	// get(obj, 'aaa.bbb', 'default') -> default
	
	function _get(item, path, def) {
	
	    if (!path) {
	        return def;
	    }
	
	    path = path.split('.');
	
	    // Loop through each section of our key path
	    for (var i = 0; i < path.length; i++) {
	
	        // If we have an object, we can get the key
	        if (isobject(item)) {
	            item = item[path[i]];
	            // Otherwise, we should return the default (undefined if not provided)
	        } else {
	            return def;
	        }
	    }
	
	    // If our final result is undefined, we should return the default
	    return item === undefined ? def : item;
	}
	
	// Multi-layer set
	// ---------------
	//
	// Recursively sets a deep path from an object
	//
	// let obj = {bar: {baz: 1}}
	// set(obj, 'bar.baz', 2)
	// obj.bar.baz -> 1
	
	function _set(item, path, value) {
	    path = path.split('.');
	
	    // Loop through each section of our key path except the last
	    for (var i = 0; i < path.length - 1; i++) {
	
	        // Get the next item down
	        item = item[path[i]];
	
	        // If we have an object, we're good
	        if (isobject(item)) {
	            continue;
	            // Otherwise, there's nothing to set our key on
	        } else {
	            throw new Error(path[i - 1] + '.' + path[i] + ' is not an object');
	        }
	    }
	
	    // Do the set on the retrieved object with our value
	    item[path[path.length - 1]] = value;
	}
	
	// Loop through object
	// -------------------
	//
	// Loop an object and apply a function for each key/value
	//
	// let ob = {a: 1, b: 2, c: 3}
	// each(ob, console.log) -> a 1  b 2  c 3
	
	function each(ob, callback) {
	    for (var key in ob) {
	        if (ob.hasOwnProperty(key)) {
	            callback.call(ob, key, ob[key]);
	        }
	    }
	}
	
	// Gey keys of object
	// ------------------
	//
	// Shim for Object.keys if it does not already exist
	//
	// let ob = {a: 1, b: 2, c: 3}
	// keys(ob) -> ['a', 'b', 'c']
	
	function _keys(ob) {
	
	    if (Object.keys) {
	        return Object.keys(ob);
	    }
	
	    var result = [];
	
	    for (var key in ob) {
	        if (ob.hasOwnProperty(key)) {
	            result.push(key);
	        }
	    }
	
	    return result;
	}
	
	// Create a base class that can be inherited from
	// ----------------------------------------------
	//
	// This is the public interface to the Class module.
	// All classes with extend from Class and be provided with a set of base convenience methods.
	
	var $Class = exports.$Class = extend('Class', {
	
	    init: function init() {
	        // Empty init class, so calls to _super can be safely made
	    },
	
	    get: function get(path, def) {
	        return _get(this, path, def);
	    },
	
	    set: function set(path, value) {
	        _set(this, path, value);
	    },
	
	    setProperties: function setProperties() {
	        transpose(this, arguments);
	    },
	
	    forEach: function forEach(callback) {
	        each(this, callback);
	    },
	
	    keys: function keys() {
	        return _keys(this);
	    }
	});
	
	$Class.get = _get;
	$Class.set = _set;
	$Class.keys = _keys;
	
	angular.value("$Class", $Class);

/***/ },

/***/ "./components/squid/dist/core/error.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$FallbackError = exports.$BatchShortCircuit = exports.$ApiError = exports.$Forbidden = exports.$Contingency = exports.$Error = undefined;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	_util.$util.monkeyPatch(window, 'onerror', function (_ref, original) {
	    var message = _ref[0],
	        file = _ref[1],
	        line = _ref[2],
	        col = _ref[3],
	        err = _ref[4];
	
	
	    original();
	
	    _event.$event.emit('$windowError', {
	        message: message && (message.stack || message).toString(),
	        file: file && file.toString(),
	        line: line && line.toString(),
	        col: col && col.toString(),
	        stack: err && (err.stack || err).toString()
	    });
	});
	
	var $Error = exports.$Error = _class.$Class.extend.call(Error, '$Error', {
	
	    construct: function construct(err, properties) {
	
	        if (err instanceof Error) {
	            err = err.message;
	        }
	
	        if (properties) {
	            _util.$util.extend(this, properties);
	        }
	
	        this.payload = properties;
	
	        this.message = err;
	    }
	});
	
	var $Contingency = exports.$Contingency = $Error.extend('$Contingency', {
	    handle: function handle(handlers) {
	        var handler = handlers[this.message] || handlers['DEFAULT'];
	
	        if (handler) {
	            var result = handler.call(this, this.message, this);
	
	            if (typeof result !== 'undefined') {
	                return result;
	            }
	            return true;
	        }
	    }
	});
	
	var $Forbidden = exports.$Forbidden = $Error.extend('$Forbidden');
	
	var $ApiError = exports.$ApiError = $Error.extend('$ApiError');
	
	var $BatchShortCircuit = exports.$BatchShortCircuit = $Error.extend('$BatchShortCircuit');
	
	var $FallbackError = exports.$FallbackError = $Error.extend('$FallbackError', {
	    init: function init() {
	        this.reason = this.reason || '';
	        this.product = this.product || '';
	        this.entryPoint = this.entryPoint || '';
	    }
	});
	
	angular.value("$Error", $Error);
	angular.value("$Contingency", $Contingency);
	angular.value("$Forbidden", $Forbidden);
	angular.value("$ApiError", $ApiError);
	angular.value("$BatchShortCircuit", $BatchShortCircuit);
	angular.value("$FallbackError", $FallbackError);
	_event.$event;
	
	_class.$Class;
	
	_util.$util;

/***/ },

/***/ "./components/squid/dist/core/loader.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$loader = undefined;
	
	var _event = __webpack_require__("./components/squid/dist/core/event.js");
	
	var _firstLoad = false;
	
	var loader = _event.$event.compose('loading', 'loaded', 'startLoad', 'allLoaded', 100);
	
	var $loader = exports.$loader = {
	
	    isLoading: function isLoading() {
	        return Boolean(loader.getCount());
	    },
	    firstLoad: function firstLoad() {
	        return _firstLoad;
	    },
	    reset: function reset() {
	        loader.reset();
	    }
	};
	
	_event.$event.on('allLoaded', function () {
	    _firstLoad = true;
	});
	
	angular.value("$loader", $loader);
	_event.$event;

/***/ },

/***/ "./components/squid/dist/core/model.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	
	exports.__esModule = true;
	exports.$Model = undefined;
	
	var _class = __webpack_require__("./components/squid/dist/core/class.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var $Model = exports.$Model = _class.$Class.extend('$Model', {
	
	    init: function init() {
	
	        if (this.keys().length) {
	            this.onPopulate();
	        }
	
	        if (this.id) {
	            var _cache = this.constructor._modelCache = this.constructor._modelCache || {};
	
	            _cache[this.id] = this;
	        }
	
	        this.meta = {
	            populated: false
	        };
	    },
	
	    /**
	     * Add the passed in properties to this Model.
	     * Sets the meta.populated to true. This flag
	     * can be used later to determine if the model is populated.
	     * Calls onPopulate() in the end.
	     */
	    populate: function populate() {
	
	        this.meta.populated = true;
	        this.setProperties.apply(this, arguments);
	        delete this.meta.invalidated;
	        this.onPopulate();
	        return this;
	    },
	
	    fetchChildren: function fetchChildren() {
	        return _promise.$promise.resolve();
	    },
	
	    /**
	     * Override this method, to execute any logic after model is populated.
	     */
	    onPopulate: function onPopulate() {// eslint-disable-line no-empty-function
	
	    },
	
	    /**
	     * Override this method to return a Mock instance. Must return a promise which resolves to model.
	     */
	    fetchMock: function fetchMock() {// eslint-disable-line no-empty-function
	
	    },
	
	    /**
	     * Retrieves the model.
	     *
	     * If model is already populated just returns a promise which resolves to `this`
	     * If there is a retriever for this model, then return the retreiver.
	     * Else calls the api to retrieve the model.
	     *
	     * @param options
	     * @returns {*}
	     */
	    retrieve: function retrieve(options) {
	        var self = this;
	
	        options = options || {};
	
	        if (self.meta.populated) {
	
	            if (options.success) {
	                return _promise.$promise.resolve(options.success(self));
	            }
	
	            return _promise.$promise.resolve(this);
	        }
	
	        if (this.retriever) {
	            return this.retriever;
	        }
	
	        if (!this.api) {
	            throw new Error('Tried to populate a model with no api');
	        }
	
	        options.model = this;
	
	        this.retriever = this.api.retrieve(options).then(function (res) {
	            return self;
	        })['finally'](function () {
	            delete self.retriever;
	        });
	
	        return this.retriever;
	    },
	
	    /**
	     * Calls a post on the api to save this model. Takes options as parameters.
	     * options will passed down to api.post.
	     *
	     * @param options
	     * @returns {*|HttpPromise}
	     */
	    save: function save(options) {
	        options = options || {};
	        options.model = this;
	
	        options.data = options.data || this.serialize();
	
	        return this.api.post(options);
	    },
	
	    /**
	     * Calls Api.action to perform any action on the model.
	     *
	     * Takes action name and optional 'options' object as parameters.
	     *
	     * Ex: $CheckoutSession.actions('create', [options])
	     *
	     * @param action
	     * @param options
	     * @returns {*}
	     */
	    action: function action(_action, options) {
	        options = options || {};
	        options.model = this;
	
	        return this.api.action(_action, options);
	    },
	
	    /**
	     * Use this method to force a api call to get the data.
	     *
	     * @param options
	     * @returns {*}
	     */
	    reload: function reload(options) {
	        this.meta.populated = false;
	        return this.retrieve(options);
	    },
	
	    stringify: function stringify() {
	        return JSON.stringify(this, 2);
	    },
	
	    log: function log() {
	        console.log(this.stringify());
	    },
	
	    serialize: function serialize() {// eslint-disable-line no-empty-function
	
	    },
	
	    /**
	     * Invalidate the current model. Sets the meta.populated to false and sets meta.invalidated to true.
	     */
	    invalidate: function invalidate() {
	        this.meta.populated = false;
	        this.meta.invalidated = true;
	    },
	
	    /**
	     * Creates a new Class with properties from `child`. Then assigns `this` as parent to the new Class.
	     *
	     * @param Cls
	     * @param child
	     * @returns {*}
	     */
	    child: function child(Cls, _child) {
	
	        if (!_child) {
	            return;
	        }
	
	        return Cls.create(_child.id || this.id, { parent: this }).populate(_child);
	    },
	
	    /**
	     *
	     * @param Cls
	     * @param children
	     * @returns {*}
	     */
	    children: function children(Cls, _children) {
	        var self = this;
	
	        if (!_children) {
	            return _children;
	        }
	
	        return _util.$util.map(_children, function (child) {
	            return self.child(Cls, child);
	        });
	    }
	});
	
	var cache = {};
	
	$Model.reopenClass({
	
	    instance: function instance(id) {
	
	        var modelCache = cache[this.id] = cache[this.id] || {};
	        var instance = modelCache[id || 0] || this.create.apply(this, arguments);
	
	        return instance;
	    },
	
	    retrieveInstance: function retrieveInstance() {
	        return this.instance.apply(this, arguments).retrieve();
	    },
	
	    create: function create(id) {
	
	        var modelCache = cache[this.id] = cache[this.id] || {};
	        var instance = modelCache[id || 0] = new this({ // eslint-disable-line new-cap
	            id: id || 0
	        });
	
	        instance.setProperties.apply(instance, Array.prototype.slice.call(arguments, 1));
	
	        return instance;
	    },
	
	    fetch: function fetch() {
	        console.warn('Model.fetch is deprecated, please use Model.instance');
	        return this.instance.apply(this, arguments);
	    },
	
	    clearCache: function clearCache() {
	        cache = {};
	    }
	});
	
	angular.value("$Model", $Model);
	_class.$Class;
	
	_util.$util;
	
	_promise.$promise;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./components/squid/dist/core/dom.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$dom = undefined;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _promise = __webpack_require__("./components/squid/dist/core/promise.js");
	
	var _util = __webpack_require__("./components/squid/dist/core/util.js");
	
	var $dom = exports.$dom = {
	
	    elementReady: function elementReady(id) {
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            if (document.getElementById(id)) {
	                return resolve();
	            }
	
	            var interval = setInterval(function () {
	                if (document.getElementById(id)) {
	                    clearInterval(interval);
	                    return resolve();
	                }
	            }, 10);
	
	            setTimeout(60000, reject);
	        });
	    },
	
	    loadScript: function loadScript(name, src, timeout) {
	        var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	            var script = document.createElement('script');
	            var loadTimeout = void 0;
	
	            function clearScriptLoadTimeout() {
	                if (loadTimeout) {
	                    clearTimeout(loadTimeout);
	                    loadTimeout = undefined;
	                }
	            }
	
	            script.onload = function () {
	                clearScriptLoadTimeout();
	                setTimeout(resolve, 10);
	            };
	
	            // For Internet explorer 8 support
	            script.onreadystatechange = function () {
	                if (this.readyState === 'complete' || this.readyState === 'loaded') {
	                    clearScriptLoadTimeout();
	                    setTimeout(resolve, 10);
	                }
	            };
	
	            script.onerror = function (event) {
	                _logger.$logger.info('script_error', {
	                    script: src
	                });
	                return reject(new Error(name + '_loading_error'));
	            };
	
	            if (timeout) {
	                loadTimeout = setTimeout(function () {
	                    _logger.$logger.info('script_load_timedout', {
	                        script: src
	                    });
	                    return reject(new Error(name + '_loading_timed_out'));
	                }, timeout);
	            }
	
	            script.setAttribute('src', src);
	
	            for (var _iterator = Object.keys(attributes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                var _ref;
	
	                if (_isArray) {
	                    if (_i >= _iterator.length) break;
	                    _ref = _iterator[_i++];
	                } else {
	                    _i = _iterator.next();
	                    if (_i.done) break;
	                    _ref = _i.value;
	                }
	
	                var attribute = _ref;
	
	                script.setAttribute(attribute, attributes[attribute]);
	            }
	
	            document.body.appendChild(script);
	        });
	    },
	
	    cssReady: function cssReady(id) {
	
	        var el = document.getElementById(id);
	
	        return _promise.$promise.resolver(function (resolve, reject) {
	
	            var timeout = void 0;
	            var interval = void 0;
	
	            function check() {
	                _util.$util.forEach(document.styleSheets, function (stylesheet) {
	                    if (stylesheet.href === el.href) {
	                        clearInterval(interval);
	                        clearTimeout(timeout);
	                        resolve();
	                    }
	                });
	            }
	
	            timeout = setTimeout(function () {
	                clearInterval(interval);
	                reject();
	                throw new Error('css_loading_timed_out');
	            }, 30000);
	
	            interval = setInterval(check, 20);
	            check();
	        });
	    }
	};
	
	angular.value("$dom", $dom);
	_logger.$logger;
	
	_promise.$promise;
	
	_util.$util;

/***/ },

/***/ "./components/squid/dist/ng/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ComponentRoute = exports.$Route = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var _component = __webpack_require__("./components/squid/dist/ng/component.js");
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	var $Route = exports.$Route = _core.$Class.extend('$ComponentRoute', {
	
	    childSpec: {},
	
	    init: function init() {
	        var _this = this;
	
	        this.validate();
	
	        this.url = '/' + (this.path || this.name);
	
	        if (this.query) {
	            this.url += '?' + this.query.join('&');
	        }
	
	        this.hasResolver = Boolean(this.resolve);
	
	        var controller = this.controller = function ($scope) {
	            $scope.route = _this;
	            if ($scope.componentScope) {
	                delete $scope.componentScope.view;
	            }
	        };
	
	        if (this.get('resolve.action')) {
	            this.controller = function ($scope, action) {
	                _angular.$injector.invoke(controller, this, { $scope: $scope });
	                if (action) {
	                    if (!action.newState) {
	                        _angular.$location.replace();
	                    }
	
	                    if (angular.isObject(action) && action.to) {
	                        _uiRouter.$state.go(action.to, action.params);
	                    } else {
	                        _uiRouter.$state.go(action);
	                    }
	                }
	            };
	        }
	    },
	
	    validate: function validate() {
	
	        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
	            return;
	        }
	
	        var routeName = this.constructor.name;
	
	        if (!this.name && !this.path) {
	            throw new Error(routeName + ' :: expected property \'path\'');
	        }
	
	        if (this.url) {
	            _logger.$logger.warn(routeName + ' :: unexpected property \'url\' :: ' + this.url);
	        }
	
	        if (this.query && !(this.query instanceof Array)) {
	            throw new Error(routeName + ' :: expected property \'query\' to be array of query params');
	        }
	
	        if (this.controller) {
	            // throw new Error(`${routeName} :: unexpected property 'controller'`);
	        }
	
	        if (this.resolve) {
	            if (this.resolve.action && !(this.resolve.action instanceof Function)) {
	                throw new Error(routeName + ' :: expected property \'resolve.action\' to be a function');
	            }
	
	            Object.keys(this.resolve).forEach(function (name) {
	                if (name === 'data') {
	                    _logger.$logger.warn(routeName + ' :: unexpected resolver :: ' + name);
	                } else if (name !== 'action') {
	                    throw new Error(routeName + ' :: unexpected resolver :: ' + name);
	                }
	            });
	        }
	
	        if (this.template) {
	            throw new Error(routeName + ' :: unexpected property \'template\'');
	        }
	
	        if (!this.directive && !this.resolve && !this.resolve.action) {
	            throw new Error(routeName + ' :: expected property \'directive\'');
	        }
	
	        if (this.directive && angular.isString(this.directive) && !this.getDirective()) {
	            throw new Error(routeName + ' :: unknown directive \'' + this.directive + '\'');
	        }
	
	        if (this.directive && !angular.isString(this.directive) && !_component.$Component.isChild(this.directive)) {
	            throw new Error(routeName + ' :: expected directive to be subclass of $Component');
	        }
	
	        if (this.children) {
	            this.children.forEach(function (childSpec) {
	
	                if (!childSpec.route && !childSpec.name) {
	                    throw new Error(routeName + ' :: child expected property \'route\'');
	                }
	
	                var ChildRoute = childSpec.route;
	                var childName = childSpec.name || ChildRoute.name;
	
	                if (!ChildRoute && childSpec.name) {
	                    try {
	                        ChildRoute = _angular.$injector.get(childSpec.name);
	                    } catch (err) {
	                        throw new Error(routeName + ' :: could not find child route \'' + childName + '\'');
	                    }
	                }
	
	                if (!$Route.isChild(ChildRoute)) {
	                    throw new Error(routeName + ' :: ' + childName + ' :: expected child to be instance of $Route');
	                }
	            });
	        }
	    },
	    goto: function goto(route) {
	        return _uiRouter.$state.go(route.replace('this.', this.absolutePath + '.'));
	    },
	    getDirective: function getDirective() {
	        return _angular.$injector.get(_core.$util.dasherizeToCamel(this.getDirectiveTag() + 'Directive'))[0];
	    },
	    getDirectiveTag: function getDirectiveTag() {
	        return angular.isString(this.directive) ? this.directive : this.directive.prototype.tag;
	    },
	
	
	    bootstrap: function bootstrap(defaultState, middleware) {
	        var _this2 = this;
	
	        return (0, _ng.$angularInvoke)(function () {
	            // only bootstrap if not bootstrapped already
	            var element = angular.element(document.body);
	
	            if (!element.injector()) {
	                angular.bootstrap(element, ['app']);
	            }
	
	            return _this2.load(defaultState, middleware);
	        });
	    },
	
	    load: function load(defaultState, middleware) {
	
	        defaultState = defaultState || this.defaultState;
	        middleware = middleware || this.middleware;
	
	        _logger.$logger.info('bootstrap_route', {
	            route: this.path || this.name
	        });
	
	        (0, _ng.$once)('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
	            event.preventDefault();
	
	            _logger.$logger.error('state_not_found', {
	                name: unfoundState.to,
	                from: fromState.name,
	                fromParams: fromParams,
	                hash: window.location.hash
	            });
	
	            throw new Error('state_not_found: ' + unfoundState.to);
	        });
	
	        this.register();
	
	        _uiRouter.$urlRouterProvider.otherwise(function () {
	            return _logger.$logger.info('otherwise_after_bootstrap', {
	                hash: window.location.hash
	            });
	        });
	
	        this.runMiddleware(middleware).then(function () {
	            var targetState = void 0;
	            var targetParams = void 0;
	
	            if (window.location.hash && window.location.hash.indexOf('#/') === 0) {
	
	                targetState = window.location.hash.slice(2).split('?')[0].replace(/^\/+/, '').replace(/\/+$/, '').replace(/\//g, '.');
	
	                targetParams = _core.$util.params(window.location.hash.slice(2).split('?')[1] || '');
	            }
	
	            _logger.$logger.info('initializing_route', {
	                target: targetState,
	                defaultState: defaultState,
	                hash: window.location.hash
	            });
	
	            _angular.$location.replace();
	
	            if (targetState) {
	                if (_uiRouter.$state.get(targetState)) {
	                    _logger.$logger.info('existing_state', {
	                        stateName: targetState
	                    });
	                    return _uiRouter.$state.go(targetState, targetParams)['catch'](function (err) {
	                        // lib/js/security.js event listener handles auth required state changes
	                        // and cancels transitions if user not authenticated
	                        if (err.message === 'transition prevented') {
	                            _logger.$logger.warn('transition_prevented', {
	                                targetState: targetState
	                            });
	                            return _core.$promise.resolve();
	                        }
	                        return _core.$promise.reject(err);
	                    });
	                }
	
	                _logger.$logger.info('unknown_state', {
	                    stateName: targetState
	                });
	            }
	
	            if (_uiRouter.$state.get(defaultState)) {
	                _logger.$logger.info('default_state', {
	                    stateName: defaultState
	                });
	                return _uiRouter.$state.go(defaultState)['catch'](function (err) {
	                    if (err.message === 'transition prevented') {
	                        _logger.$logger.warn('transition_prevented', {
	                            targetState: defaultState
	                        });
	                        return _core.$promise.resolve();
	                    }
	                    return _core.$promise.reject(err);
	                });
	            }
	
	            throw new Error('Default state not found: ' + defaultState);
	        })['catch'](function (err) {
	            return _angular.$injector.get('$exceptionHandler')(err);
	        });
	    },
	
	    runMiddleware: function runMiddleware(middleware) {
	
	        _logger.$logger.info('middleware', {
	            priority: _core.$util.map(middleware, function (method) {
	                return method.name;
	            }).join('|')
	        });
	
	        var promise = _core.$promise.resolve();
	
	        angular.forEach(middleware, function (method) {
	            promise = promise.then(function () {
	
	                if (method.name) {
	                    _logger.$logger.info('middleware_' + method.name);
	                }
	
	                return method();
	            });
	        });
	
	        return promise;
	    },
	
	    register: function register() {
	        var _this3 = this;
	
	        this.template = this.constructTemplate(this.childAttributes || {});
	
	        this.absolutePath = this.path || this.name;
	
	        if (this.parent) {
	            this.absolutePath = this.parent.absolutePath + '.' + this.absolutePath;
	        }
	
	        if (!_uiRouter.$state.get(this.absolutePath)) {
	            _uiRouter.$stateProvider.state(this.absolutePath, this);
	        }
	
	        angular.forEach(this.children, function (childSpec) {
	
	            var ChildRoute = childSpec.route || _angular.$injector.get(childSpec.name);
	
	            var childRoute = new ChildRoute({
	                parent: _this3,
	                childSpec: childSpec,
	                childAttributes: childSpec.attributes
	            });
	
	            childRoute.register();
	        });
	    },
	
	    /**
	     * Constructs the template string for this route. If route.directive = 'xo-add-bank', then the template will be
	     * '<xo-add-bank/>'.
	     * If attributes are specified, they will be passed to directive. Ex: <xo-add-bank attrname = "attrvalue"/>
	     *
	     * @param attributes - A map of name value pairs - {name: value}.
	     * @returns {string}
	     */
	    constructTemplate: function constructTemplate(attributes) {
	        var self = this;
	
	        if (!self.directive) {
	            return;
	        }
	
	        attributes['component-route'] = 'route';
	
	        if (this.parent) {
	            attributes['export'] = 'view';
	        }
	
	        var tag = this.getDirectiveTag();
	
	        var paramString = '';
	
	        angular.forEach(attributes, function (value, key) {
	            paramString += ' ' + key + '="' + value + '"';
	        });
	
	        return '<div ' + tag + ' ' + paramString + '></div>';
	    }
	});
	
	_uiRouter.$stateProvider.state('default', {
	    auth: false
	});
	
	$Route.reopenClass({
	    render: function render() {
	
	        _core.$Model.clearCache();
	        _core.$Api.clearCache();
	
	        _core.$event.emit('$resetState');
	        (0, _locale.$flushContent)();
	
	        _core.$loader.reset();
	
	        _uiRouter.$state.go('default');
	
	        setTimeout.flush();
	
	        var $scope = _angular.$rootScope.$new();
	        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
	        var element = (0, _angular.$compile)('<div><ui-view></ui-view></div>')($scope);
	
	        afterEach(_core.$util.once(function () {
	            $scope.$destroy();
	            cleanRootScope();
	            _core.$loader.reset();
	            _core.$Model.clearCache();
	            _core.$Api.clearCache();
	        }));
	
	        var route = new this();
	
	        route.bootstrap();
	        setTimeout.flush();
	
	        element.isolateScope = function () {
	            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
	        };
	
	        return element;
	    },
	
	
	    assertActive: function assertActive() {
	        assert(_uiRouter.$state.current instanceof this, 'Current state should be "' + (this.prototype.path || this.prototype.name) + '", found "' + _uiRouter.$state.current.name + '"');
	    }
	});
	
	function getPageTitle(stateName) {
	
	    var state = _uiRouter.$state.get(stateName);
	
	    if (!state) {
	        return;
	    }
	
	    if (state.titleContent) {
	        return _locale.$locale.content.get(state.titleContent);
	    }
	}
	
	function changePageTitle() {
	
	    document.documentElement.setAttribute('lang', _locale.$locale.lang);
	
	    if (!_uiRouter.$state.current || !_uiRouter.$state.current.name) {
	        return;
	    }
	
	    var fullStateTitle = [];
	
	    _uiRouter.$state.current.name.split('.').reduce(function (a, b) {
	
	        var stateName = [a, b].filter(Boolean).join('.');
	        var stateTitle = getPageTitle(stateName);
	
	        if (stateTitle) {
	            fullStateTitle.push(stateTitle);
	        }
	
	        return stateName;
	    }, null);
	
	    document.title = _core.$util.unique(fullStateTitle).join(' - ');
	}
	
	_core.$event.on('$stateChangeSuccess', changePageTitle);
	_core.$event.on('contentChange', changePageTitle);
	
	var $ComponentRoute = exports.$ComponentRoute = $Route;
	
	angular.value("$Route", $Route);
	angular.value("$ComponentRoute", $ComponentRoute);
	_angular.$rootScope;
	
	_angular.$location;
	
	_angular.$injector;
	
	_angular.$compile;
	
	_uiRouter.$state;
	
	_uiRouter.$stateProvider;
	
	_uiRouter.$urlRouterProvider;
	
	_logger.$logger;
	
	_core.$config;
	
	_core.$Class;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$event;
	
	_core.$loader;
	
	_locale.$locale;
	
	_locale.$flushContent;
	
	_component.$Component;
	
	_ng.$cleanRootScope;
	
	_ng.$once;
	
	_ng.$angularInvoke;

/***/ },

/***/ "./components/squid/dist/locale/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	Object.keys(_locale).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _locale[key];
	    }
	  });
	});
	
	var _currency = __webpack_require__("./components/squid/dist/locale/currency.js");
	
	Object.keys(_currency).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _currency[key];
	    }
	  });
	});
	
	var _feature = __webpack_require__("./components/squid/dist/locale/feature.js");
	
	Object.keys(_feature).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _feature[key];
	    }
	  });
	});
	
	var _name = __webpack_require__("./components/squid/dist/locale/name.js");
	
	Object.keys(_name).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _name[key];
	    }
	  });
	});
	
	var _quantity = __webpack_require__("./components/squid/dist/locale/quantity.js");
	
	Object.keys(_quantity).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _quantity[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/locale/locale.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$localeHelper = exports.$locale = exports.$LocaleModel = exports.$MetadataModel = exports.$ContentModel = undefined;
	exports.sanitize = sanitize;
	exports.Content = Content;
	exports.$contentVersion = $contentVersion;
	exports.$flushContent = $flushContent;
	exports.$renderContent = $renderContent;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	function sanitize(html) {
	    return html && html.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
	}
	
	var JSONStringify = JSON.stringify;
	
	JSON.stringify = function (item) {
	    if (item instanceof Content) {
	        return item.toString();
	    }
	    return JSONStringify.apply(this, arguments);
	};
	
	function Content(key, props) {
	    this.key = key;
	    this.props = props;
	}
	
	Content.cache = {};
	
	Content.get = function (key, props) {
	
	    if (!key) {
	        return '';
	    }
	
	    props = props || {};
	
	    var cacheKey = $locale.country + '_' + $locale.lang + '_' + key + '_' + JSONStringify.call(JSON, props);
	    var cacheVal = Content.cache[cacheKey];
	
	    if (cacheVal !== undefined) {
	        return cacheVal;
	    }
	
	    cacheVal = Content.cache[cacheKey] = new Content(key, props);
	
	    return cacheVal;
	};
	
	Content.prototype.toString = Content.prototype.valueOf = function () {
	    if (this.string) {
	        return this.string;
	    }
	
	    this.string = this.render(false);
	
	    return this.string;
	};
	
	Content.prototype.toSafeString = function () {
	    if (this.safeString) {
	        return this.safeString;
	    }
	
	    this.safeString = this.render(true);
	
	    return this.safeString;
	};
	
	Content.prototype.render = function (safe) {
	    var _this = this;
	
	    if (!this.key) {
	        return '';
	    }
	
	    var value = contentCache[$locale.country] && contentCache[$locale.country][$locale.lang];
	    var keys = this.key.split('.');
	
	    for (var i = 0; i < keys.length; i++) {
	        if (value) {
	            value = value[keys[i]];
	        } else {
	            break;
	        }
	    }
	
	    if (!value) {
	        return '';
	    }
	
	    return value.replace(/\{\w+\}/g, function (prop) {
	        prop = prop.slice(1, prop.length - 1);
	
	        if (prop === 'country') {
	            return $locale.country;
	        }
	
	        if (prop === 'lang') {
	            return $locale.lang;
	        }
	
	        if (_this.props[prop] === undefined) {
	            if (!_core.$loader.isLoading()) {
	                _logger.$logger.warn('missing_content_prop', {
	                    key: _this.key,
	                    prop: prop
	                }, { unique: true });
	            }
	
	            return '';
	        }
	
	        var propStr = _this.props[prop].toString();
	
	        if (safe) {
	            return sanitize(propStr);
	        }
	
	        return propStr;
	    });
	};
	
	var contentCache = {};
	var currentVersion = void 0;
	
	window.addContent = function (country, lang, content, version) {
	    var countryCache = contentCache[country] = contentCache[country] || {};
	
	    countryCache[lang] = content;
	    currentVersion = version;
	};
	
	var metadataCache = {};
	
	window.addMetadata = function (country, lang, metadata) {
	    var countryCache = metadataCache[country] = metadataCache[country] || {};
	
	    countryCache[lang] = metadata;
	};
	
	function $contentVersion() {
	    return currentVersion || '';
	}
	
	function $flushContent() {
	    contentCache = {};
	    metadataCache = {};
	}
	
	var PP_SPECIAL_COUNTRIES_ISO_CODES = {
	    C2: 'CN'
	};
	
	var $ContentModel = exports.$ContentModel = _core.$Model.extend('$ContentModel', {
	    api: new _core.$Api({
	
	        baseURI: _core.$meta.staticUrl,
	        uri: '/locales/:countryCode/:lang',
	        ext: 'js',
	
	        retrieve: function retrieve(options) {
	            var self = this;
	            var model = options.model;
	
	            var uri = self.getURI(model);
	
	            return _core.$promise.resolve().then(function () {
	
	                if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
	                    _logger.$logger.info('cached_content');
	                    return contentCache[model.countryCode][model.lang];
	                }
	
	                _logger.$logger.info('retrieve_content', {
	                    uri: uri
	                });
	
	                _core.$event.emit('loading');
	
	                return _core.$promise.attempt(3, function () {
	                    return _core.$dom.loadScript('content', uri, 10000).then(function () {
	                        if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
	                            _logger.$logger.info('content_retrieved');
	                            return contentCache[model.countryCode][model.lang];
	                        }
	
	                        throw new Error('content_not_available');
	                    });
	                })['catch'](function (err) {
	                    throw err;
	                })['finally'](function () {
	                    _core.$event.emit('loaded');
	                });
	            }).then(function (content) {
	                model.setProperties(content);
	                return content;
	            });
	        }
	    }),
	
	    change: function change(country, lang) {
	
	        if (country === this.countryCode && lang === this.lang) {
	            return _core.$promise.resolve(this);
	        }
	
	        this.countryCode = country;
	        this.lang = lang;
	
	        return this.reload().then(function () {
	            _core.$event.broadcast('contentChange');
	        });
	    }
	});
	
	var $MetadataModel = exports.$MetadataModel = _core.$Model.extend('$MetadataModel', {
	
	    api: new _core.$Api({
	
	        baseURI: _core.$meta.staticUrl,
	        uri: '/metadata/:country/:lang/metadata',
	        ext: 'js',
	
	        retrieve: function retrieve(options) {
	            var self = this;
	            var model = options.model;
	
	            var uri = self.getURI(model);
	
	            return _core.$promise.resolve().then(function () {
	
	                if (metadataCache[model.country] && metadataCache[model.country][model.lang]) {
	                    _logger.$logger.info('cached_metadata');
	                    return metadataCache[model.country][model.lang];
	                }
	
	                _logger.$logger.info('retrieve_metadata', {
	                    uri: uri
	                });
	
	                _core.$event.emit('loading');
	
	                return _core.$promise.attempt(3, function () {
	                    return _core.$dom.loadScript('metadata', uri, 10000).then(function () {
	                        if (metadataCache[model.country] && metadataCache[model.country][model.lang]) {
	                            _logger.$logger.info('metadata_retrieved', {
	                                uri: uri
	                            });
	                            return metadataCache[model.country][model.lang];
	                        }
	
	                        // Retry if not found in cache
	                        _logger.$logger.info('metadata_not_available', {
	                            uri: uri
	                        });
	                        return _core.$promise.reject(new Error('metadata_not_available'));
	                    });
	                })['catch'](function (err) {
	                    throw err;
	                })['finally'](function () {
	                    _core.$event.emit('loaded');
	                });
	            }).then(function (metadata) {
	                model.setProperties(metadata);
	                return metadata;
	            });
	        }
	    }),
	
	    change: function change(country, lang) {
	        var _this2 = this;
	
	        this.country = country;
	        this.lang = lang;
	
	        return this.reload().then(function () {
	            if (!_this2.noBroadcast) {
	                _core.$event.broadcast('metadataChange');
	            }
	        });
	    },
	
	    choose: function choose(country, lang, override) {
	
	        if (country && (!this.chosenCountry || override !== false)) {
	            this.chosenCountry = country;
	        }
	
	        if (lang && (!this.chosenLang || override !== false)) {
	            this.chosenLang = lang;
	        }
	
	        country = this.chosenCountry || this.country;
	        lang = this.chosenLang;
	
	        if (_core.$config.supportedCountries) {
	            if (!_core.$config.supportedCountries[country]) {
	                country = this.country;
	            }
	
	            if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
	                lang = _core.$config.supportedCountries[country][0];
	            }
	        }
	
	        if (!lang) {
	            lang = this.lang;
	        }
	
	        return this.change(country, lang);
	    },
	
	    normalizeAddressFields: function normalizeAddressFields(content) {
	
	        var CONTENT_MAPPING = {
	            line1Label: 'streetAddress',
	            line2Label: 'streetAddress2',
	            cityLabel: 'city',
	            stateLabel: 'state',
	            postcodeLabel: 'postalCode'
	        };
	
	        // Loop over all layout props, if they don't exist in Griffin, get them from xo-content
	        for (var prop in CONTENT_MAPPING) {
	            if (this.addressEntry && this.addressEntry.strings[prop]) {
	                this.addressEntry.strings[prop] = this.addressEntry.strings[prop] || content.get('common.' + CONTENT_MAPPING[prop]);
	            }
	        }
	    }
	});
	
	function mapLanguage(lang) {
	    var unselectableLanguages = _core.$config.unselectableLanguages || [];
	
	    if (unselectableLanguages.indexOf(lang) !== -1) {
	        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
	            return 'en';
	        }
	    }
	
	    var unsupportedLanguages = _core.$config.unsupportedLanguages || [];
	
	    if (unsupportedLanguages.indexOf(lang) !== -1) {
	        if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
	            var s = lang + '_locale_not_supported';
	
	            throw new Error(s);
	        }
	    }
	
	    return lang;
	}
	
	var $LocaleModel = exports.$LocaleModel = _core.$Model.extend('LocaleModel', {
	    api: new _core.$Api({
	        uri: '/api/locale'
	    }),
	
	    init: function init() {
	        this._super.init.apply(this);
	        this.content = $ContentModel.instance();
	        this.metadata = $MetadataModel.instance();
	    },
	
	    retrieve: function retrieve() {
	        var self = this;
	
	        return this._super.retrieve.apply(this, arguments).then(function (result) {
	            self.lang = mapLanguage(self.lang);
	            return _core.$promise.all([self.content.change(self.country, self.lang), self.metadata.change(self.country, self.lang)]).then(function () {
	
	                // TODO: This at build time... or make sure griffin metadata is complete
	                self.metadata.normalizeAddressFields(self.content);
	
	                return result;
	            });
	        });
	    },
	
	    change: function change(country, lang) {
	
	        var self = this;
	
	        lang = mapLanguage(lang);
	
	        if (country === this.country && lang === this.lang) {
	            return _core.$promise.resolve(this);
	        }
	
	        _logger.$logger.info('locale_change', {
	            country: country,
	            lang: lang
	        });
	
	        this.country = country;
	        this.lang = lang;
	
	        return _core.$promise.all([this.content.change(country, lang), this.metadata.change(country, lang)]).then(function (loadedData) {
	
	            // TODO: This at build time... or make sure griffin metadata is complete
	            self.metadata.normalizeAddressFields(self.content);
	
	            _core.$event.broadcast('localeChange'); // broadcast only when data has all been loaded
	            return loadedData;
	        });
	    },
	
	    choose: function choose(country, lang, override) {
	
	        if (country && (!this.chosenCountry || override !== false)) {
	            this.chosenCountry = country;
	        }
	
	        if (lang && (!this.chosenLang || override !== false)) {
	            this.chosenLang = lang;
	        }
	
	        country = this.chosenCountry || this.country;
	        lang = this.chosenLang;
	
	        if (!_core.$config.supportedCountries[country]) {
	            country = this.country;
	        }
	
	        if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
	            lang = _core.$config.supportedCountries[country][0];
	        }
	
	        if (!lang) {
	            lang = this.lang;
	        }
	
	        return this.change(country, lang);
	    },
	
	    chooseCountry: function chooseCountry(country) {
	        return this.choose(country, null);
	    },
	
	    chooseLang: function chooseLang(lang) {
	        return this.choose(null, lang);
	    },
	
	    getLocaleCode: function getLocaleCode() {
	        return this.lang + '_' + this.country;
	    },
	
	    getCountryCodeISO: function getCountryCodeISO() {
	        return PP_SPECIAL_COUNTRIES_ISO_CODES[this.country] || this.country;
	    }
	});
	
	var $locale = exports.$locale = $LocaleModel.instance();
	
	function $renderContent(key, props) {
	    return Content.get(key, props);
	}
	
	var $localeHelper = exports.$localeHelper = {
	    /**
	     *
	     * @param locale - Ex: en_US
	     * @returns {{country: *, dialect}}
	     */
	    normalizeLocale: function normalizeLocale(locale) {
	        if (!locale) {
	            return {};
	        }
	
	        locale = locale.replace('-', '_');
	
	        var country = void 0;
	        var language = void 0;
	
	        if (locale.match(/^\w{2}_\w{2}$/)) {
	            locale = locale.split('_');
	
	            language = locale[0];
	            country = locale[1];
	        } else {
	            language = locale;
	        }
	
	        return {
	            country: country,
	            language: language
	        };
	    }
	};
	
	angular.value("sanitize", sanitize);
	angular.value("Content", Content);
	angular.value("$contentVersion", $contentVersion);
	angular.value("$flushContent", $flushContent);
	angular.value("$ContentModel", $ContentModel);
	angular.value("$MetadataModel", $MetadataModel);
	angular.value("$LocaleModel", $LocaleModel);
	angular.value("$locale", $locale);
	angular.value("$renderContent", $renderContent);
	angular.value("$localeHelper", $localeHelper);
	_logger.$logger;
	
	_core.$event;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$meta;
	
	_core.$promise;
	
	_core.$config;
	
	_core.$loader;
	
	_core.$dom;

/***/ },

/***/ "./components/squid/dist/locale/currency.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.roundingAndSeparators = roundingAndSeparators;
	exports.formatCurrency = formatCurrency;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	// This seems to be the only currency / locale specific exception in Griffin
	var STYLE_EXCEPTION = {
	    'tr TR TRY': '# ¤;-# ¤'
	}; // everything to do with currency formatting
	
	// quick Griffin reference on currency format:
	// ¤ : Currency Symbol = $
	// # : Amount = 186432.431
	// C : Currency Code = USD
	
	var ALL_NON_BREAKING_SPACE = new RegExp('\xa0+', 'g');
	var CODE_IN_FRONT = new RegExp('^([^¤#]*)(C[\\s]*)(.*)$'); // matching groups: (any negative symbol)(code)(the rest)
	var ENDS_IN_WHITESPACE = new RegExp('\s$');
	var THOUSANDS_SPLITTER = /\B(?=(\d{3})+(?!\d))/g; // eslint-disable-line fasec/no-unsafe-regex
	
	// Griffin "fuzzy logic"
	// apparently if the symbol is at least "66% similar" to the code, ignore it
	function maybeIgnoreSymbol(style, symbol, code) {
	
	    // THIS IS NOT COMMUTATIVE
	    function fuzzyMatch(code, symbol) {
	        // eslint-disable-line no-shadow
	        if (code === symbol) {
	            return 100;
	        } else {
	            var codeParts = code.split('');
	            var symbolParts = symbol.split('');
	
	            var equivalency = codeParts.reduce(function (equiv, codePart) {
	                var symbolPos = symbolParts.indexOf(codePart);
	
	                if (symbolPos !== -1) {
	                    symbolParts.splice(symbolPos, 1);
	                    return equiv + 1;
	                }
	                return equiv;
	            }, 0);
	
	            var weight = equivalency / codeParts.length;
	
	            return weight * 100;
	        }
	    }
	
	    var ignoreSymbol = symbol.length > 1 && fuzzyMatch(code, symbol) >= 66;
	
	    return ignoreSymbol ? style.replace(/¤\s*/g, '') : style;
	}
	
	// deal with rounding due to truncation (Griffin rounds up) as well as dot/comma symbols
	// and thousand separators
	function roundingAndSeparators(amountString, _ref) {
	    var decimalPlaces = _ref.decimalPlaces,
	        dot = _ref.dot,
	        comma = _ref.comma;
	
	    var value = parseFloat(amountString);
	    var truncate = decimalPlaces === 0;
	
	    var amountParts = truncate && !isNaN(value) ? Math.round(value).toString().split('.') : amountString.split('.');
	    var wholeString = amountParts[0].replace(THOUSANDS_SPLITTER, comma);
	    var decimalString = amountParts[1] || '00';
	
	    return truncate ? wholeString : '' + wholeString + dot + decimalString;
	}
	
	// this is an agreement with UED for visual consistency - the currency code, if displayed, is always on the right
	function forceCodeToRight(style) {
	    var parts = CODE_IN_FRONT.exec(style) || [];
	    var endsWithWhitespace = ENDS_IN_WHITESPACE.test(style);
	    var newStyle = style;
	
	    // if CODE_IN_FRONT regex matches, array indexes -
	    // [1] negative symbol plus whitespace, if any,
	    // [2] the "C" plus any whitespace,
	    // [3] whatever is after "C"
	    if (parts.length === 4) {
	        newStyle = parts[1] + parts[3] + (endsWithWhitespace ? 'C' : ' C');
	    }
	
	    return newStyle;
	}
	
	// deal with
	// 1. exceptions for specific locales
	// 2. positive and negative styles
	// 3. griffin fuzzy logic
	// 4. UED consistency logic
	function getFinalStyle() {
	    var styleString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ';';
	    var _ref2 = arguments[1];
	    var lang = _ref2.lang,
	        country = _ref2.country;
	    var _ref3 = arguments[2];
	    var value = _ref3.value,
	        _ref3$symbol = _ref3.symbol,
	        symbol = _ref3$symbol === undefined ? '' : _ref3$symbol,
	        code = _ref3.code;
	
	
	    var exception = STYLE_EXCEPTION[[lang, country, code].join(' ')]; // special exceptions
	    var currencyStyle = exception || styleString;
	
	    var _currencyStyle$split = currencyStyle.split(';'),
	        positiveStyle = _currencyStyle$split[0],
	        negativeStyle = _currencyStyle$split[1]; // the style is separated by postive and negative notation via a ;
	
	    var baseStyle = value < 0 ? negativeStyle || '-¤# C' : positiveStyle || '¤# C';
	    var griffinStyle = exception ? baseStyle : maybeIgnoreSymbol(baseStyle, symbol, code); // don't apply fuzzy logic on exceptions
	
	    return forceCodeToRight(griffinStyle);
	}
	
	// take the style and the formatted amount (rounded / truncated / thousands separator / decimal separator)
	// and produce the final result.
	//
	// wrapCodeInSpan - wraps the currency code in a span.currencyCode for styling purposes
	function applyCurrencyStyle(finalStyle, amountFormatted, _ref4) {
	    var symbol = _ref4.symbol,
	        code = _ref4.code,
	        _ref4$wrapCodeInSpan = _ref4.wrapCodeInSpan,
	        wrapCodeInSpan = _ref4$wrapCodeInSpan === undefined ? false : _ref4$wrapCodeInSpan;
	
	    // the style will take care of negative symbol (see getFinalStyle function above)
	    var absoluteAmountFormatted = amountFormatted.replace('-', '');
	
	    // parallel operation is safer than serial replace
	    return finalStyle.split('').map(function (char) {
	        switch (char) {
	            case 'C':
	                return wrapCodeInSpan ? '<span class="currencyCode">' + code + '</span>' : code;
	            case '¤':
	                return symbol;
	            case '#':
	                return absoluteAmountFormatted;
	            default:
	                return char;
	        }
	    }).join('').replace(ALL_NON_BREAKING_SPACE, ' ');
	}
	
	function formatCurrency(amount, code, wrapCodeInSpan) {
	    var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'SymbolISOCurrency';
	
	    var _ref5 = _locale.$locale.metadata || {},
	        _ref5$number = _ref5.number,
	        numberConfig = _ref5$number === undefined ? {} : _ref5$number,
	        _ref5$currency = _ref5.currency,
	        currencyConfig = _ref5$currency === undefined ? {} : _ref5$currency;
	
	    var _currencyConfig$digit = currencyConfig.digits,
	        digits = _currencyConfig$digit === undefined ? {} : _currencyConfig$digit,
	        _currencyConfig$style = currencyConfig.styles,
	        styles = _currencyConfig$style === undefined ? {} : _currencyConfig$style,
	        _currencyConfig$suppo = currencyConfig.supportedSymbols,
	        currencySymbols = _currencyConfig$suppo === undefined ? {} : _currencyConfig$suppo;
	
	    var value = parseFloat(amount);
	
	    var dot = numberConfig.DECIMAL_SEP === undefined ? '.' : numberConfig.DECIMAL_SEP;
	    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;
	
	    var amountFormatted = roundingAndSeparators(amount.toString(), { decimalPlaces: digits[code], dot: dot, comma: comma });
	
	    if (code) {
	        var symbol = currencySymbols[code];
	        var finalStyle = getFinalStyle(styles[style], _locale.$locale, { value: value, symbol: symbol, code: code });
	
	        return applyCurrencyStyle(finalStyle, amountFormatted, { symbol: symbol, code: code, wrapCodeInSpan: wrapCodeInSpan });
	    }
	
	    return amountFormatted; // HTML?
	}
	
	_locale.$locale;

/***/ },

/***/ "./components/squid/dist/locale/feature.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$feature = $feature;
	exports.$featureCountries = $featureCountries;
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	function $feature(prop, def, country) {
	
	    var features = _core.$config.features || {};
	
	    country = country || _locale.$locale.country;
	    // 1. Check the feature is present in country
	    var result = _core.$Class.get(features[country], prop);
	
	    if (result !== undefined) {
	        return result;
	    }
	    // 2. Check the feature is present in feature group
	
	    Object.keys(_core.$config.regions).some(function (region) {
	        if (_core.$config.regions[region].indexOf(country) !== -1) {
	            result = _core.$Class.get(features[region], prop);
	            return result !== undefined;
	        }
	
	        return false;
	    });
	
	    if (result !== undefined) {
	        return result;
	    }
	    // 3. Check the feature is present in default group
	    result = _core.$Class.get(features.DEFAULT, prop);
	
	    if (result !== undefined) {
	        return result;
	    }
	    return def;
	}
	
	// Build a list of all countries in our feature list and regions
	// populate countries with out REGION names in the list
	var allCountries = _core.$Class.keys(_core.$config.features || {}).filter(function (country) {
	    return country !== 'DEFAULT' && !(_core.$config.regions && _core.$config.regions.hasOwnProperty(country));
	});
	
	// populate all the region countries in to allcountries
	_core.$util.forEach(_core.$config.regions, function (countries, region) {
	    _core.$util.forEach(countries, function (country) {
	        if (allCountries.indexOf(country) === -1) {
	            allCountries.push(country);
	        }
	    });
	});
	
	function $featureCountries(prop) {
	    // Find the countries with a certain feature enabled
	    return allCountries.filter(function (country) {
	        return $feature(prop, false, country);
	    });
	}
	
	angular.value("$feature", $feature);
	angular.value("$featureCountries", $featureCountries);
	_core.$config;
	
	_core.$Class;
	
	_core.$util;
	
	_locale.$locale;

/***/ },

/***/ "./components/squid/dist/locale/name.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.formatNameInformal = formatNameInformal;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	// Mapping of Griffin fields to name fields that should be used
	var SUBSTITUTED_FIELDS = {
	    givenName: 'first_name',
	    surname: 'last_name'
	};
	
	// Taken from griffin-paypal: test if a string is Latin
	function isLatin(str) {
	    if (!str) {
	        return true;
	    }
	
	    for (var i = 0; i < str.length; i++) {
	        if (str.charCodeAt(i) > 0x24F) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	/**
	 * Formats name into informal format based on Griffin metadata
	 * @param  {Object} name The name to be formatted, containing first_name and last_name properties
	 * @return {String}      The formatted string, or null if data is missing
	 */
	function formatNameInformal(name) {
	    var layoutMetadata = _locale.$locale.metadata.nameInformal;
	    var layout = null;
	
	    if (!layoutMetadata) {
	        return name.first_name || null; // Default to first name if metadata not loaded
	    }
	
	    // According to Griffin, if the name is all Latin and there is a Latin formatting variant, use that one
	    if (layoutMetadata['latinLayout'] && isLatin(name.first_name) && isLatin(name.last_name)) {
	        layout = layoutMetadata['latinLayout'];
	    } else {
	        layout = layoutMetadata['layout'];
	    }
	
	    // Map griffin layout parts to the name passed in. If it requires a value not passed in name, returns null early
	    var formattedName = [];
	
	    for (var i = 0; i < layout.length; i++) {
	        var namePart = layout[i];
	
	        if (name[SUBSTITUTED_FIELDS[namePart['$']]]) {
	            formattedName.push(name[SUBSTITUTED_FIELDS[namePart['$']]]);
	        } else if (namePart['$'] === 'separator') {
	            formattedName.push(namePart._);
	        }
	    }
	
	    return formattedName.join('');
	}
	
	_locale.$locale;

/***/ },

/***/ "./components/squid/dist/locale/quantity.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.formatQuantity = formatQuantity;
	
	var _locale = __webpack_require__("./components/squid/dist/locale/locale.js");
	
	var _currency = __webpack_require__("./components/squid/dist/locale/currency.js");
	
	// format a quantity to add a thousand separator based on a locality
	function formatQuantity(quantity) {
	    var _ref = _locale.$locale.metadata || {},
	        _ref$number = _ref.number,
	        numberConfig = _ref$number === undefined ? {} : _ref$number;
	
	    var dot = '';
	    var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;
	
	    return (0, _currency.roundingAndSeparators)(quantity.toString(), { decimalPlaces: 0, dot: dot, comma: comma });
	}
	
	_locale.$locale;
	
	_currency.roundingAndSeparators;

/***/ },

/***/ "./components/squid/dist/ng/component.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	
	exports.__esModule = true;
	exports.$Component = undefined;
	exports.$populate = $populate;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _ng = __webpack_require__("./components/squid/dist/ng/ng.js");
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	(0, _directive.$registerDirective)('prevent-default', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $element.on('click', function (event) {
	                event.preventDefault();
	            });
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('stop-propagation', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $element.on('click keydown keypress keyup', function (event) {
	                event.stopPropagation();
	            });
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('validate-submit', function () {
	
	    return {
	        link: function link($scope, $element, $attrs) {
	
	            var $form = $element.closest('form');
	            var form = $scope[$form.prop('name')];
	
	            $element.on('click', function (event) {
	                event.preventDefault();
	
	                $form.addClass('validated');
	                $scope.validated = true;
	                form.$setSubmitted();
	
	                if (form.$valid) {
	                    try {
	                        $scope.$eval($attrs.validateSubmit);
	                    } catch (err) {
	                        _angular.$injector.get('$exceptionHandler')(err);
	                    }
	                } else {
	                    $form.find('.ng-invalid:first').focus();
	                }
	            });
	        }
	    };
	});
	
	function assertModelsRetrievedOrEmpty(items) {
	    if (_core.$config.deploy.isLocal() || _core.$config.deploy.isStage()) {
	        angular.forEach(items, function (item, name) {
	            if (item instanceof _core.$Model) {
	                if (item.meta.populated) {
	                    throw new Error(name + ' is already populated. Please call .retrieve() to ensure your code is not relying on cache being present.');
	                }
	            }
	        });
	    }
	}
	
	function setUpComponentRoute($scope, $Component, angular) {
	    var componentRoute = $scope.componentRoute;
	
	    componentRoute.scope = $scope;
	
	    componentRoute.scope.goto = function (route) {
	        componentRoute.goto(route);
	    };
	
	    var parentRoute = componentRoute.parent;
	
	    if (parentRoute) {
	        var parentScope = parentRoute.scope;
	        var parentDirective = parentRoute.getDirective();
	        var childSpec = componentRoute.childSpec;
	
	        if (childSpec.config) {
	            if (parentDirective instanceof $Component) {
	                parentScope.viewConfig = childSpec.config.call(parentScope);
	            } else {
	                throw new Error('In order to use config() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
	            }
	        }
	
	        if (childSpec.props) {
	            if (parentDirective instanceof $Component) {
	                angular.extend($scope, childSpec.props.call(parentScope));
	            } else {
	                throw new Error('In order to use props() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
	            }
	        }
	    }
	}
	
	var $Component = exports.$Component = _core.$Class.extend('$Component', {
	
	    onPopulate: angular.noop,
	
	    init: function init() {
	        var _this = this,
	            _arguments = arguments;
	
	        this.validate();
	
	        this.name = _core.$util.dasherizeToCamel(this.tag);
	        this.template = '<div class="' + this.tag + '-wrapper" ng-if="populated && display">' + this.template + '</div>';
	
	        this.scope = this.scope || {};
	        this.resolve = this.resolve || {};
	        this.props = this.props || {};
	        this.rootEvents = this.rootEvents || {};
	
	        this.actions = this.actions || {};
	
	        this.lifecycle = this.lifecycle || {};
	        this.lifecycle.enter = this.lifecycle.enter || angular.noop;
	        this.lifecycle.reenter = this.lifecycle.reenter || angular.noop;
	        this.lifecycle.exit = this.lifecycle.exit || angular.noop;
	        this.lifecycle.populate = this.lifecycle.populate || angular.noop;
	
	        if (this.scope && Object.keys(this.scope).length) {
	
	            if (this.props && Object.keys(this.props).length) {
	                throw new Error('Can not defined scope and props on the same component');
	            }
	
	            this.scope.componentRoute = '=';
	            this.scope['export'] = '@';
	
	            this.props = _core.$util.map(this.scope, function (type, key) {
	                return {
	                    type: {
	                        '=': 'var',
	                        '@': 'str'
	                    }[type],
	                    required: false
	                };
	            });
	        } else {
	
	            this.props.componentRoute = {
	                type: 'var',
	                required: false
	            };
	
	            this.props['export'] = {
	                type: 'str',
	                required: false
	            };
	
	            this.scope = _core.$util.map(this.props, function (spec, key) {
	                return {
	                    'var': '=',
	                    'str': '@'
	                }[spec.type || 'var'];
	            });
	        }
	
	        var originalController = this.controller || angular.noop;
	
	        this.controller = function ($scope, $element) {
	            $scope.$element = $element;
	
	            $scope.$on('$destroy', function () {
	                if ($scope.componentRoute && $scope.componentRoute.parent && $scope.componentRoute.parent.scope) {
	                    delete $scope.componentRoute.parent.scope.viewConfig;
	                }
	                _this.lifecycle.exit.call($scope);
	            });
	
	            $scope.props = {};
	
	            if ($scope.componentRoute) {
	                setUpComponentRoute($scope, $Component, angular);
	            }
	
	            angular.forEach(_this.props, function (type, key) {
	
	                var prop = _this.props[key];
	                var required = prop.required !== false;
	                var def = void 0;
	
	                if (prop['default'] instanceof Function) {
	                    def = _core.$util.memoize(prop['default'].bind($scope));
	                } else {
	                    def = function def() {
	                        return prop['default'];
	                    };
	                }
	
	                var UNDEFINED = {
	                    'var': undefined,
	                    str: ''
	                }[prop.type];
	
	                Object.defineProperty($scope.props, key, {
	                    get: function get() {
	                        var val = $scope[key];
	
	                        if (val === UNDEFINED) {
	                            if (required) {
	                                throw new Error('Prop required for component :: ' + _this.tag + ' :: ' + key);
	                            }
	
	                            return def();
	                        }
	
	                        return val;
	                    },
	
	                    set: function set() {
	                        throw new Error('Prop is immutable :: ' + _this.tag + ' :: ' + key);
	                    }
	                });
	            });
	
	            $scope.fields = {};
	
	            $scope.actions = _core.$util.bindObject(_this.actions, $scope);
	
	            Object.keys(_this.rootEvents).forEach(function (eventName) {
	                var cancel = _core.$event.on(eventName, function (event) {
	                    _this.rootEvents[eventName].apply($scope, _arguments);
	                });
	
	                $scope.$on('$destroy', cancel);
	            });
	
	            $scope.display = true;
	
	            $scope.reload = function () {
	
	                if (!$scope.populated) {
	                    throw new Error('Can not reload unpopulated component');
	                }
	
	                $scope.display = false;
	                setTimeout(function () {
	                    $scope.display = true;
	                });
	            };
	
	            $scope.componentScope = $scope;
	
	            if ($scope.props['export'] && $scope.$parent.componentScope) {
	
	                $scope.exports = angular.extend({}, _this.exports || {}, {
	                    reload: $scope.reload
	                });
	
	                Object.defineProperty($scope.$parent.componentScope, $scope.props['export'], {
	                    get: function get() {
	                        return $scope.exports;
	                    },
	
	                    configurable: true
	                });
	            }
	
	            $scope._enablePopulateEvents = true;
	
	            _angular.$injector.invoke(originalController, _this, { $scope: $scope, $element: $element });
	            _this.lifecycle.enter.call($scope);
	
	            $scope._enablePopulateEvents = false;
	
	            var cancelReEnterEvent = _core.$event.on('$stateChangeSuccess', function (event, toState) {
	                if (toState === $scope.props.componentRoute) {
	                    _this.lifecycle.reenter.call($scope);
	                }
	            });
	
	            $scope.$on('$destroy', cancelReEnterEvent);
	
	            return _core.$promise.sequential([function () {
	                $scope.$emit('_populating');
	            }, function () {
	                return _core.$promise.map(_this.resolve, function (resolver, name, resolverPromises) {
	
	                    if (angular.isObject(resolver)) {
	                        $scope[name] = resolver;
	                        return resolver;
	                    }
	
	                    return _core.$promise.resolve(resolver.call($scope, resolverPromises)).then(function (data) {
	                        assertModelsRetrievedOrEmpty(data);
	
	                        return _core.$promise.hash(data).then(function (resolvedData) {
	
	                            $scope[name] = resolvedData;
	                            return resolvedData;
	                        });
	                    });
	                });
	            }, function () {
	
	                $scope.populated = true;
	
	                $scope.$emit('_populated');
	
	                _core.$event.refCount($scope, '_populating', '_populated').then(function () {
	
	                    $scope.$on('populated', function (populatedEvent) {
	                        populatedEvent.stopPropagation();
	                    });
	
	                    $scope.$emit('populated');
	                    _this.onPopulate.call($scope);
	                    _this.lifecycle.populate.call($scope);
	                });
	            }]);
	        };
	    },
	
	    validate: function validate() {
	
	        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
	            return;
	        }
	
	        var componentName = this.constructor.name;
	
	        if (!this.tag) {
	            throw new Error(componentName + ' :: expected property \'tag\'');
	        }
	
	        if (!this.tag.match(/^[a-z0-9-]+$/)) {
	            throw new Error(componentName + ' :: tag should contain only lowercase alphanumeric characters and dashes');
	        }
	
	        if (!this.template) {
	            throw new Error(componentName + ' :: expected property \'template\'');
	        }
	
	        if (this.resolve) {
	            angular.forEach(this.resolve, function (resolver, name) {
	                if (!(resolver instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'resolve.' + name + '\' to be a function');
	                }
	            });
	        }
	
	        if (this.props) {
	            angular.forEach(this.props, function (prop, name) {
	
	                if (!(prop instanceof Object)) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '\' to be a function');
	                }
	
	                if (prop.type && ['var', 'str'].indexOf(prop.type) === -1) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '.type\' to be one of var, str');
	                }
	
	                if (prop['default'] && prop.required) {
	                    throw new Error(componentName + ' :: unnecessary \'props.' + name + '.default\', since prop is required');
	                }
	
	                if (prop['default'] && prop['default'] instanceof Object && !(prop['default'] instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'props.' + name + '.default\' to be a primitive or a function - please do not pass mutable objects');
	                }
	            });
	        }
	
	        if (this.actions) {
	            angular.forEach(this.actions, function (action, name) {
	                if (!(action instanceof Function)) {
	                    throw new Error(componentName + ' :: expected \'actions.' + name + '\' to be a function');
	                }
	            });
	        }
	
	        if (this.lifecycle) {
	            Object.keys(this.lifecycle).forEach(function (name) {
	                if (['enter', 'populate', 'exit', 'reenter'].indexOf(name) === -1) {
	                    throw new Error(componentName + ' :: unexpected \'lifecycle.' + name + '\'');
	                }
	            });
	        }
	    }
	});
	
	$Component.reopenClass({
	
	    extend: function extend() {
	
	        var SubClass = _core.$Class.extend.apply(this, arguments);
	        var spec = new SubClass();
	
	        angular.module().directive(spec.name, function () {
	            return spec;
	        });
	
	        return SubClass;
	    },
	
	    render: function render(scope) {
	        _core.$Model.clearCache();
	        _core.$Api.clearCache();
	        _core.$event.emit('$resetState');
	
	        var $scope = _angular.$rootScope.$new();
	
	        angular.extend($scope, scope);
	
	        var attrs = Object.keys(scope).map(function (key) {
	            return _core.$util.camelToDasherize(key) + '="' + (this.prototype.props[key].type === 'var' ? key : scope[key]) + '"';
	        }.bind(this)).join(' ');
	
	        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
	        var html = '<' + this.prototype.tag + ' ' + attrs + '></' + this.prototype.tag + '>';
	
	        console.log('RENDER', html, scope);
	
	        var element = (0, _angular.$compile)(html)($scope);
	
	        afterEach(_core.$util.once(function () {
	            $scope.$destroy();
	            cleanRootScope();
	        }));
	
	        setTimeout.flush();
	
	        element.isolateScope = function () {
	            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
	        };
	
	        return element;
	    }
	});
	
	function autoConvertDirectiveToComponent(_ref, original) {
	    var name = _ref[0],
	        factory = _ref[1];
	
	
	    if (!angular.isFunction(factory)) {
	        return original();
	    }
	
	    var tag = _core.$util.camelToDasherize(name);
	    var spec = _angular.$injector.invoke(factory);
	
	    if (spec.controller) {
	        var originalController = spec.controller;
	
	        spec.controller = function ($scope, $element) {
	            $scope._enablePopulateEvents = true;
	            var result = _angular.$injector.invoke(originalController, this, { $scope: $scope, $element: $element });
	
	            $scope._enablePopulateEvents = false;
	            return result;
	        };
	    }
	
	    if (spec instanceof $Component || !spec.template || !spec.controller || name.indexOf('xo') !== 0 || spec.transclude) {
	        return original(this, [name, function () {
	            return spec;
	        }]);
	    }
	
	    if (spec.componentize) {
	
	        $Component.extend('$' + name + 'Component', spec, {
	            tag: tag
	        });
	
	        return this;
	    }
	
	    return original(this, [name, function () {
	        return spec;
	    }]);
	}
	
	_core.$util.monkeyPatch(_angular.$compileProvider, 'directive', autoConvertDirectiveToComponent);
	_core.$util.monkeyPatch(angular.module(), 'directive', autoConvertDirectiveToComponent);
	
	// $populate needs to go away
	
	function $populate($scope, instances) {
	
	    $scope.$on = $scope.$on || angular.noop;
	    $scope.$emit = $scope.$emit || angular.noop;
	
	    var _enablePopulateEvents = $scope._enablePopulateEvents;
	
	    if (_enablePopulateEvents) {
	        _core.$event.refCount($scope, '_populating', '_populated').then(function () {
	            $scope.$emit('populated');
	        });
	    }
	
	    $scope.$on('populated', function (populatedEvent) {
	        populatedEvent.stopPropagation();
	    });
	
	    if (_enablePopulateEvents) {
	        $scope.$emit('_populating');
	    }
	
	    return _core.$promise.all(_core.$util.map(instances, function (instance, name) {
	
	        var promise = void 0;
	
	        if (instance.then) {
	            promise = instance;
	        } else {
	            promise = instance.retrieve();
	            $scope[name] = instance;
	        }
	
	        return promise.then(function (result) {
	            $scope[name] = result;
	            return result;
	        });
	    })).then(function (result) {
	
	        if (_enablePopulateEvents) {
	            $scope.$emit('_populated');
	        }
	
	        return result;
	    });
	}
	
	angular.value("$Component", $Component);
	angular.value("$populate", $populate);
	_angular.$rootScope;
	
	_angular.$compile;
	
	_angular.$injector;
	
	_angular.$compileProvider;
	
	_core.$Class;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$config;
	
	_core.$event;
	
	_ng.$cleanRootScope;
	
	_directive.$registerDirective;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./components/squid/dist/ng/ng.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$angularInvoke = $angularInvoke;
	exports.$once = $once;
	exports.$cleanRootScope = $cleanRootScope;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	function $angularInvoke(method) {
	    try {
	        return method();
	    } catch (err) {
	        _angular.$injector.get('$exceptionHandler')(err);
	    }
	}
	
	function $once(name, handler) {
	    var cancel = _core.$event.on(name, function () {
	        cancel();
	        handler.apply(this, arguments);
	    }, true);
	}
	
	function $cleanRootScope(rootScope) {
	
	    var keys = Object.keys(rootScope);
	
	    var autoCleanupEventHandlers = [];
	    var eventHandlers = [];
	    var eventCancelers = [];
	
	    _core.$util.monkeyPatch(rootScope, '$on', function (_ref, original) {
	        var name = _ref[0],
	            handler = _ref[1],
	            once = _ref[2];
	
	
	        var cancel = original();
	
	        var $state = void 0;
	
	        try {
	            $state = _angular.$injector.get('$state');
	        } catch (err) {
	            // pass
	        }
	
	        if (name === '$destroy' || !$state || !$state.current || !$state.current.name || $state.current.name === 'default') {
	            autoCleanupEventHandlers.push(cancel);
	            return function autoCleanedUpCancel() {}; // eslint-disable-line no-empty-function
	        }
	
	        if (once) {
	            eventCancelers.push(cancel);
	            return cancel;
	        }
	
	        // Let ng-router do its thing
	        if (handler.toString().indexOf('updateView') !== -1) {
	            return cancel;
	        }
	
	        var stack = void 0;
	
	        try {
	            throw new Error('$rootScope.$on');
	        } catch (err) {
	            stack = err.stack;
	        }
	
	        var reference = {
	            name: name,
	            handler: handler.toString(),
	            stack: stack
	        };
	
	        eventHandlers.push(reference);
	
	        return function () {
	            cancel();
	            eventHandlers.splice(eventHandlers.indexOf(reference), 1);
	        };
	    });
	
	    return function () {
	
	        _core.$event.emit('$destroy');
	
	        autoCleanupEventHandlers.forEach(function (canceler) {
	            return canceler();
	        });
	        autoCleanupEventHandlers = [];
	
	        Object.keys(rootScope).forEach(function (key) {
	            if (keys.indexOf(key) === -1) {
	                delete rootScope[key];
	            }
	        });
	
	        if (eventHandlers.length) {
	            throw new Error('$rootScope event handlers not cleaned up:\n\n' + eventHandlers.map(function (eventHandler) {
	                return eventHandler.name + '\n\n' + eventHandler.handler + '\n\n' + eventHandler.stack;
	            }).join('\n\n'));
	        }
	
	        eventCancelers.forEach(function (cancel) {
	            return cancel();
	        });
	    };
	}
	
	angular.value("$angularInvoke", $angularInvoke);
	angular.value("$once", $once);
	angular.value("$cleanRootScope", $cleanRootScope);
	_angular.$injector;
	
	_core.$util;
	
	_core.$event;

/***/ },

/***/ "./components/squid/dist/ng/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$registerDirective = $registerDirective;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function $registerDirective(tag, definition) {
	
	    var directiveName = tag.replace(/-([a-z])/g, function (g) {
	        return g[1].toUpperCase();
	    });
	
	    return _angular2["default"].module().directive(directiveName, definition);
	}
	
	_angular2["default"].value("$registerDirective", $registerDirective);

/***/ },

/***/ "./components/squid/dist/ng/feature.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _directive = __webpack_require__("./components/squid/dist/ng/directive.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	(0, _directive.$registerDirective)('feature', function () {
	    return {
	        restrict: 'A',
	        transclude: true,
	        scope: {},
	        template: '<span ng-if="enabled()" ng-transclude></span>',
	        link: function link($scope, element, attr) {
	            $scope.enabled = function () {
	                return (0, _locale.$feature)(attr.feature) || _core.$integration.getConfig(attr.feature);
	            };
	        }
	    };
	});
	
	(0, _directive.$registerDirective)('unless-feature', function () {
	    return {
	        restrict: 'A',
	        transclude: true,
	        scope: {},
	        template: '<span ng-if="!enabled()" ng-transclude></span>',
	        link: function link($scope, element, attr) {
	            $scope.enabled = function () {
	                return (0, _locale.$feature)(attr.unlessFeature) || _core.$integration.getConfig(attr.unlessFeature);
	            };
	        }
	    };
	});
	_directive.$registerDirective;
	
	_locale.$feature;
	
	_core.$integration;

/***/ },

/***/ "./components/squid/dist/ng/locale.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	(0, _angular.$registerDirective)('content', function () {
	    return {
	        restrict: 'A',
	
	        link: function link($scope, element, attributes) {
	            $scope.content = $scope.htmlContent = function (key, props) {
	                if (attributes.content) {
	                    key = attributes.content + '.' + key;
	                }
	                var content = _locale.Content.get(key, props);
	
	                if (content.toString()) {
	                    return content;
	                } else {
	                    return;
	                }
	            };
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('bind-html-compile', function () {
	
	    return {
	        restrict: 'A',
	        link: function link($scope, $element, $attrs) {
	            $scope.$watch(function () {
	                return $scope.$eval($attrs.bindHtmlCompile);
	            }, function (value) {
	                $element.html(value && value.toString());
	                (0, _angular.$compile)($element.contents())($scope);
	            });
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('format-currency', function () {
	
	    return {
	        restrict: 'E',
	        template: '<span ng-bind-html="amount_formatted" class="ltrOverride"></span>',
	        scope: {
	            amount: '=',
	            symbol: '=',
	            code: '=',
	            currencyStyle: '@'
	        },
	        controller: function controller($scope) {
	
	            function format() {
	                $scope.amount_formatted = _angular.$sce.trustAsHtml((0, _locale.formatCurrency)($scope.amount, $scope.code, true, $scope.currencyStyle));
	            }
	
	            $scope.$on('$destroy', _core.$event.on('localeChange', format));
	
	            $scope.$watch('amount', function (newValue, oldValue) {
	                if (newValue !== oldValue && _locale.$locale.country) {
	                    format();
	                }
	            });
	
	            if (_locale.$locale.country) {
	                format();
	            }
	        } // controller
	    }; // return
	}); // registerDirective
	
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	angular.module().value('$sanitize', function (val) {
	    if (val instanceof _locale.Content) {
	        return val.toSafeString();
	    }
	    return (0, _locale.sanitize)(val);
	});
	
	_angular.$sce;
	
	_angular.$registerDirective;
	
	_angular.$compile;
	
	_core.$event;
	
	_locale.formatCurrency;
	
	_locale.sanitize;
	
	_locale.Content;
	
	_locale.$locale;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/squid/dist/ng", "components/squid/dist/ng/locale.js"))

/***/ },

/***/ "./components/squid/dist/ng/module.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.module = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _module = _angular2['default'].module;
	exports.module = _module;

/***/ },

/***/ "./components/squid/dist/ng/events.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	angular.module().run(function () {
	
	    _core.$event.on('$stateChangeStart', function (event) {
	        _core.$event.emit('loading');
	        _core.$event.emit('loaded');
	    });
	
	    var startLoadTime = 0;
	    var currentState = 'checkout_init';
	
	    function currentStateName() {
	        return _uiRouter.$state.current.name && _uiRouter.$state.current.name.replace(/\./g, '_');
	    }
	
	    _core.$event.on('startLoad', function () {
	
	        if (startLoadTime) {
	            startLoadTime = _core.$util.now();
	        } else if (window.enablePerformance && window.performance.timing.connectEnd && window.performance.timing.navigationStart) {
	
	            var performance = window.performance;
	            var timing = window.performance.timing || {};
	            var now = performance.now();
	
	            startLoadTime = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
	        }
	    });
	
	    _core.$event.on('allLoaded', function () {
	
	        var newState = currentStateName();
	
	        if (!newState) {
	            return;
	        }
	
	        if (currentState === newState) {
	            _core.$event.emit('page_reloaded', currentState);
	        } else {
	
	            var duration = void 0;
	
	            if (startLoadTime) {
	                duration = _core.$util.now() - startLoadTime;
	            }
	
	            var payload = {
	                start: currentState,
	                end: newState,
	                time: duration,
	                duration: duration
	            };
	
	            _core.$event.emit('$transition', {
	                from: currentState,
	                toState: _uiRouter.$state.current,
	                duration: duration
	            });
	
	            _logger.$logger.info('transition', payload);
	            _logger.$logger.info('transition_' + currentState + '_to_' + newState, payload);
	
	            _core.$event.emit('page_loaded', currentState, newState);
	            _logger.$logger.flush();
	
	            currentState = newState;
	        }
	    });
	
	    _core.$event.emit('loading');
	
	    var cancel = _core.$event.on('$stateChangeSuccess', function () {
	        if (_uiRouter.$state.current.template) {
	            cancel();
	            setTimeout(function () {
	                _core.$event.emit('loaded');
	            }, 50);
	        }
	    });
	});
	
	_uiRouter.$state;
	
	_logger.$logger;
	
	_core.$event;
	
	_core.$util;

/***/ },

/***/ "./components/squid/dist/ng/pxp.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	_core.$event.on('pxp_res', function (event, pxpRes) {
	    _uiRouter.$state.current.trackingData = _uiRouter.$state.current.trackingData || {};
	    _uiRouter.$state.current.trackingData.pxpData = _uiRouter.$state.current.trackingData.pxpData || [];
	    _uiRouter.$state.current.trackingData.pxpData.push(pxpRes);
	});
	
	_uiRouter.$state;
	
	_core.$event;

/***/ },

/***/ "./components/squid/dist/paypal/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _env = __webpack_require__("./components/squid/dist/paypal/env.js");
	
	Object.keys(_env).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _env[key];
	    }
	  });
	});
	
	var _config = __webpack_require__("./components/squid/dist/paypal/config.js");
	
	Object.keys(_config).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _config[key];
	    }
	  });
	});
	
	var _pxp = __webpack_require__("./components/squid/dist/paypal/pxp.js");
	
	Object.keys(_pxp).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _pxp[key];
	    }
	  });
	});

/***/ },

/***/ "./components/squid/dist/paypal/env.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	var $env = exports.$env = {
	
	    isLocal: function isLocal() {
	        return window.location.hostname === 'localhost' || window.location.hostname === 'localhost.paypal.com';
	    },
	
	    isStage: function isStage() {
	        return Boolean(window.location.hostname.match(/^.*\.qa\.paypal\.com$/));
	    },
	
	    isSandbox: function isSandbox() {
	        return Boolean(window.location.hostname.match(/^.*\.sandbox\.paypal\.com$/));
	    },
	
	    isLive: function isLive() {
	        return window.location.hostname === 'www.paypal.com';
	    },
	
	    isTest: function isTest() {
	        return false;
	    }
	};
	
	angular.value("$env", $env);

/***/ },

/***/ "./components/squid/dist/paypal/config.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _env = __webpack_require__("./components/squid/dist/paypal/env.js");
	
	_core.$config.deploy = _core.$config.deploy || _env.$env;
	
	_core.$config;
	
	_env.$env;

/***/ },

/***/ "./components/squid/dist/paypal/pxp.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$PXPModel = undefined;
	exports.$getPxpTreatments = $getPxpTreatments;
	exports.$pxp = $pxp;
	exports.$pxpMatch = $pxpMatch;
	exports.$pxpFactors = $pxpFactors;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _core = __webpack_require__("./components/squid/dist/core/index.js");
	
	var _locale = __webpack_require__("./components/squid/dist/locale/index.js");
	
	var $PXPModel = exports.$PXPModel = _core.$Model.extend({
	    api: new _core.$Api({
	        uri: '/api/pxp/:pagename'
	    })
	});
	
	function logPxp(pxpRes, params, logPayload) {
	    var exp_name = [];
	    var xe = [];
	    var xt = [];
	
	    angular.forEach(pxpRes.treatments, function (treatment) {
	
	        _logger.$logger.info('treatment_' + treatment.treatment_name, angular.extend({
	            experiment: pxpRes.pagename,
	            treatment: treatment.treatment_name,
	            experiment_id: treatment.experiment_id,
	            treatment_id: treatment.treatment_id,
	            loc_country: _locale.$locale.country,
	            loc_lang: _locale.$locale.lang
	        }, params, logPayload));
	
	        exp_name.push(treatment.treatment_name);
	        xe.push(treatment.experiment_id);
	        xt.push(treatment.treatment_id);
	    });
	
	    _logger.$logger.info('pxp_' + pxpRes.pagename, angular.extend({
	        pxp_exp_id: xe.join('|'),
	        pxp_trtmnt_id: xt.join('|'),
	        treatments: exp_name.join('|'),
	        loc_country: _locale.$locale.country,
	        loc_lang: _locale.$locale.lang
	    }, params, logPayload));
	
	    _logger.$logger.info('fpti_pxp_check', {
	        from: 'PXP_CHECK',
	        to: 'process_pxp_check',
	        pxp_exp_id: xe.join(','),
	        pxp_trtmnt_id: xt.join(',')
	    });
	
	    _core.$event.emit('pxp_res', pxpRes);
	}
	
	function $getPxpTreatments(id, params, logPayload) {
	    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	
	    return _core.$promise.run(function () {
	        var pxp = $PXPModel.instance(_core.$util.buildURL(id, params), { pagename: id });
	        var forceTreatments = _core.$util.param('pxp_' + id);
	
	        if (forceTreatments) {
	            var treatments = forceTreatments.split(',').filter(Boolean);
	
	            pxp.treatments = treatments.map(function (treatment_name) {
	                return {
	                    treatment_name: treatment_name
	                };
	            });
	
	            return pxp;
	        }
	
	        if (forceApiCall) {
	            return pxp.reload({
	                params: params
	            });
	        }
	
	        return pxp.retrieve({
	            params: params
	        });
	    }).then(function (pxp) {
	
	        if (!pxp.cached) {
	            logPxp(pxp, params, logPayload);
	        }
	
	        pxp.cached = true;
	
	        return pxp;
	    });
	}
	
	function $pxp(id, params, pattern) {
	    var forceApiCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    if (!pattern) {
	        pattern = params;
	        params = {};
	    }
	
	    pattern = new RegExp('^' + pattern + '$');
	
	    return exports.$getPxpTreatments(id, params, null, forceApiCall).then(function (pxpResponse) {
	        var result = void 0;
	
	        (pxpResponse.treatments || []).some(function (treatment) {
	            if (!pattern.test(treatment.treatment_name)) {
	                return false;
	            }
	
	            result = {
	                treatment_name: treatment.treatment_name,
	                factors: treatment.factors
	            };
	
	            return true;
	        });
	
	        return result;
	    });
	}
	
	function $pxpMatch(id, params, patterns, logPayload) {
	    if (!patterns) {
	        patterns = params;
	        params = {};
	    }
	
	    return exports.$getPxpTreatments(id, params, logPayload).then(function (pxpResponse) {
	        var result = {};
	
	        angular.forEach(patterns, function (pattern, name) {
	            pattern = new RegExp('^' + pattern + '$');
	            result[name] = false;
	
	            (pxpResponse.treatments || []).some(function (treatment) {
	                if (!pattern.test(treatment.treatment_name)) {
	                    return false;
	                }
	
	                result[name] = true;
	                return true;
	            });
	        });
	
	        return result;
	    });
	}
	
	function $pxpFactors(id, params, pattern) {
	    params.factors = 'true';
	    return $pxp(id, params, pattern).then(function (pxpResponse) {
	        var result = void 0;
	
	        if (pxpResponse && pxpResponse.factors) {
	            result = { treatment_name: pxpResponse.treatment_name };
	            var pxpFactors = pxpResponse.factors;
	            var length = pxpFactors.length;
	
	            for (var i = 0; i < length; i++) {
	                result[pxpFactors[i].name] = pxpFactors[i].value;
	            }
	        }
	
	        return result;
	    });
	}
	
	window.$pxp = $pxp;
	
	angular.value("$getPxpTreatments", $getPxpTreatments);
	angular.value("$pxp", $pxp);
	angular.value("$pxpMatch", $pxpMatch);
	angular.value("$pxpFactors", $pxpFactors);
	_logger.$logger;
	
	_core.$Model;
	
	_core.$Api;
	
	_core.$util;
	
	_core.$promise;
	
	_core.$event;
	
	_locale.$locale;

/***/ },

/***/ "./components/xo-models/src/auth/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.auth', ['squid']).factory('$AuthApi', function ($Api, $config) {
	        return $Api.extend('AuthApi', {
	            baseURI: $config.urls.baseUrl,
	            uri: '/api/auth',
	            postAttempts: 3
	        });
	    }).factory('$AuthModel', function ($Model, $AuthApi) {
	
	        return $Model.extend('AuthModel', {
	            api: new $AuthApi(),
	
	            loggedIn: function loggedIn() {
	                return this.logged_in;
	            },
	
	            visitorId: function visitorId() {
	                return this.visitor_id;
	            },
	
	            accessToken: function accessToken() {
	                return this.access_token;
	            },
	
	            accessTokenPresent: function accessTokenPresent() {
	                return this.access_token_present;
	            },
	
	            refreshToken: function refreshToken() {
	                return this.refresh_token;
	            },
	
	            rememberedOT: function rememberedOT() {
	                return this.remembered && this.remembered_device_token;
	            }
	        });
	    }).factory('$ULoginModel', function ($Model, $Api) {
	
	        return $Model.extend('ULoginModel', {
	            api: new $Api({
	                uri: '/api/auth/ulogin',
	                postAttempts: 1,
	                cache: false
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/auth", "components/xo-models/src/auth/index.js"))

/***/ },

/***/ "./js/lib/fallback.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _icFallback = __webpack_require__("./js/lib/icFallback.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	_angular2['default'].module().factory('$fallbackErrorHandler', function ($q, $config, $meta, $timeout, $window, $logger, $log, $feature, $ReturnToMerchant, $locale, $util, $FallbackError, $state, $rootScope, $populate, $CheckoutCartModel, $CheckoutPayeeModel, $CheckoutAppDataModel, $pxp, $experiment) {
	    return function (err) {
	        var reason = err.reason;
	        var product = err.product;
	        var entry_point = err.entryPoint;
	        var params = err.params;
	        var model = {};
	
	        function getFallbackUrl(urlParams, waType) {
	            if ($rootScope.wps || $rootScope.invoice) {
	                return $populate(model, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($meta.token)
	                }).then(function () {
	                    // defaulting for now to ensure backward compatibility
	                    var base = $config.urls.fallbackUrl['buyNow'];
	
	                    if (model.checkoutAppData.flags.is_cart_upload_flow || waType === 'CartUpload' || waType === 'AddToCart' || model.checkoutAppData.flags.is_shopping_cart_flow || waType === 'ShoppingCart') {
	                        base = $config.urls.fallbackUrl['cartUpload'];
	                    }
	
	                    if (model.checkoutAppData.flags.is_invoice_flow) {
	                        urlParams.id = model.checkoutAppData.invoice_id;
	                        base = $config.urls.fallbackUrl['invoice'];
	                    }
	
	                    return $util.paypalURL(base, urlParams);
	                });
	            } else {
	                return $q.when().then(function () {
	                    var base = $config.urls.fallbackUrl[product];
	
	                    return $util.paypalURL(base, urlParams);
	                });
	            }
	        }
	
	        function showGenericErrorPage(errorReason) {
	            if ($rootScope.partnerIntegration) {
	                $logger.info('partner_integration_fallback_to_genericErrorPage');
	            }
	
	            var code = errorReason || reason;
	
	            code = code ? window.btoa(code) : code;
	
	            $state.go('checkout.genericError', {
	                code: code
	            });
	        }
	
	        function doFallback() {
	            $util.assert(reason, 'expected fallback reason');
	
	            product = product || 'ux';
	
	            var urlParams = params || {};
	
	            _angular2['default'].extend(urlParams, {
	                token: $meta.token,
	                fallback: 1,
	                reason: reason,
	                landing: entry_point,
	                useraction: $CheckoutAppDataModel.instance($rootScope.token).useraction()
	            });
	
	            if ($rootScope.partnerIntegration) {
	                urlParams.incontext = '1';
	                urlParams.nolegacy = '1';
	            } else if ($rootScope.miniBrowser) {
	                urlParams.incontext = '1';
	            }
	
	            var wpsParams = void 0;
	
	            if ($rootScope.wps) {
	                wpsParams = $util.decodeAndParse($meta.xclickParams);
	                $logger.info('wps_fallback', {
	                    token: $meta.token,
	                    reason: reason
	                });
	                $logger.info('wps_fallback_reason_' + reason, {
	                    reason: reason
	                });
	            }
	
	            var waType = wpsParams && wpsParams.wa_type;
	
	            return getFallbackUrl(urlParams, waType).then(function (url) {
	                // Fallback whitelist experiment in config to determine if we should fallback or instead redirect to generic error page.
	                // We go to generic error page if the reason is not in the whitelist and random number is below the throttle value
	                var fallbackWhitelist = $config.fallbackWhitelist;
	
	                if (fallbackWhitelist && fallbackWhitelist.throttle > 0) {
	                    var whitelist = fallbackWhitelist.whitelisted || [];
	
	                    if (whitelist.indexOf(reason) === -1) {
	                        if ($util.sessionStorageEnabled() && $experiment('fallback_reason_not_whitelisted', fallbackWhitelist.throttle, $rootScope.token, { reason: reason })) {
	                            // we're using sessionStorage for retry detection
	                            var RETRY_KEY = 'retry_page_shown';
	                            var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
	                            var timesSeen = Number(sessionStorage.getItem(RETRY_KEY));
	                            var destination = 'RETRY';
	
	                            if (!timesSeen || timesSeen < 0) {
	                                // Reset if there's an invalid value for timesSeen for some reason
	                                timesSeen = 0;
	                            }
	
	                            if (timesSeen < RETRY_PAGE_LIMIT) {
	                                // Only try to go to retry page if we're within retry attempts
	                                timesSeen++;
	                                sessionStorage.setItem(RETRY_KEY, timesSeen);
	                            } else {
	                                destination = 'DEFAULT';
	                            }
	
	                            $logger.info('checkout_fpti', {
	                                'enable_refresh_prompt': reason
	                            });
	
	                            return showGenericErrorPage(destination);
	                        }
	                    } else {
	                        $logger.info('fallback_reason_whitelisted', {
	                            reason: reason,
	                            product: product
	                        });
	                    }
	                }
	
	                if (!$config.fallbackEnabled && !entry_point) {
	                    return $log.warn('Fallback inhibited by config', url);
	                }
	
	                if ($config.deploy.isLocal() && !entry_point) {
	                    return $log.warn('Fallback inhibited in local mode.', url);
	                }
	
	                $logger.log(product ? 'info' : 'error', 'fallback', {
	                    reason: reason,
	                    product: product,
	                    entry_point: entry_point,
	                    error_desc: reason,
	                    from: $rootScope.currentState || 'fallback',
	                    to: product ? 'process_fallback_' + product : 'process_fallback'
	                });
	
	                $logger.info('fallback_reason_' + reason, {
	                    reason: reason
	                });
	
	                if (window.xchild) {
	                    if (window.opener) {
	                        return (0, _icFallback.$incontextFallback)(window, url);
	                    }
	
	                    return $state.go('checkout.framebust', { action: 'fallback', url: url });
	                }
	
	                $rootScope.$emit('loading');
	
	                if (product === 'ux') {
	                    // Otherwise we can make a decision based on whether we're in the minibrowser or not
	                    return $rootScope.wps && !$rootScope.invoice ? $ReturnToMerchant.postTo(url, wpsParams) : $ReturnToMerchant.goTo(url);
	                }
	
	                // Safe to always return to Aries
	                return $util.redirect(url);
	            });
	        }
	
	        if (product === 'error') {
	            $logger.error(reason, {
	                url: window.location.href
	            });
	
	            var _$config$urls = $config.urls,
	                baseUrl = _$config$urls.baseUrl,
	                errorUrl = _$config$urls.errorUrl;
	
	
	            return $util.redirect(baseUrl + errorUrl);
	        }
	
	        if (_integration.$integration.getConfig('ERROR_AFTER_PAYMENT') && $rootScope.paymentComplete) {
	            // Do not fallback. UX has no context of hermes token and will result in duplicate payment
	            $logger.info('wps_error_after_payment', {
	                reason: reason
	            });
	
	            return showGenericErrorPage('PAYMENT_ALREADY_DONE');
	        }
	
	        var beamPattern = /^BA-[0-9A-Z]{17}$/;
	        var isBeamIntegration = $meta.baToken && beamPattern.test($meta.baToken);
	        var cartExchangeFailed = isBeamIntegration && beamPattern.test($meta.token);
	
	        if (cartExchangeFailed) {
	            product = 'ux';
	        }
	
	        // For Beam Integration - always show generic Error when cart exchange fails.
	        // On successful Cart Exchange - disable fallback until MPWEB supports BA token support.
	        if (product === 'ux' && isBeamIntegration && cartExchangeFailed) {
	            return showGenericErrorPage();
	        }
	
	        return $populate(model, {
	            checkoutCart: $CheckoutCartModel.instance($meta.token),
	            checkoutAppData: $CheckoutAppDataModel.instance($meta.token),
	            checkoutPayee: $CheckoutPayeeModel.instance($meta.token)
	        }).then(function () {
	            var merchantId = model.checkoutPayee.get('merchant.id');
	
	            // No fallback for Tokenized_Wallet usecases
	            if (model.checkoutCart.isWalletTokenization()) {
	                return showGenericErrorPage();
	            }
	
	            // skip normal fallback behavior, when...
	            if (
	            // there is a whitelist, and...
	            $config.fallbackWhitelist &&
	            // there are exceptions, and...
	            $config.fallbackWhitelist.exceptions &&
	            // this merchant is in the exceptions list
	            $config.fallbackWhitelist.exceptions.hasOwnProperty(merchantId)) {
	                // if the merchant is configured to ignore this particular fallback...
	                if ($config.fallbackWhitelist.exceptions[merchantId].indexOf(reason) !== -1) {
	                    $logger.info('fallback_ignored_for_merchant');
	                    // exit and do nothing
	                    return;
	                }
	
	                $logger.info('fallback_inhibited_for_merchant');
	                // show error page instead
	                return showGenericErrorPage();
	            }
	
	            // V.zero always fallback (no longer controlled by PXP)
	            if (product === 'ux' && $rootScope.partnerIntegration) {
	                $logger.info('partner_integration_fallback_to_UX');
	                $window.resizeTo(screen.availWidth, screen.availHeight);
	                return doFallback();
	            }
	            // Others - Do not fallback if appdata flag dictates no fallback
	            if (model.checkoutAppData.flags.disable_legacy_fallback) {
	                $logger.error('fallback_inhibited_for_xo_order_tokens');
	                return showGenericErrorPage();
	            } else {
	                return doFallback();
	            }
	        })['catch'](showGenericErrorPage);
	    };
	});
	
	_icFallback.$incontextFallback;
	
	_integration.$integration;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/fallback.js"))

/***/ },

/***/ "./components/xo-return-to-merchant/dist/util.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	function match(str, pattern) {
	    var regmatch = str.match(pattern);
	    if (regmatch) {
	        return regmatch[1];
	    }
	}
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-return-to-merchant', ['squid', 'xo-device-info']).factory('$ReturnToMerchant', function ($window, $DeviceInfo, $rootScope, $util, $feature, $logger, $state, $timeout, $CheckoutSessionModel, $CheckoutCartModel) {
	        return {
	            goTo: function goTo(url, forceRedirect) {
	
	                $logger.info(url.indexOf('PayerID') > -1 ? 'return_to_merchant' : 'cancel_to_merchant', {
	                    url: url
	                });
	
	                // if V4 in-context integration, we'll terminate and call the close handler.
	                if (window.xchild) {
	                    $logger.done();
	                    $rootScope.$emit('loading');
	
	                    var params = {
	                        paymentToken: match(url, /token=((EC-)?[A-Z0-9]+)/),
	                        billingToken: match(url, /ba_token=((BA-)?[A-Z0-9]+)/),
	                        payerID: match(url, /PayerID=([A-Z0-9]+)/),
	                        paymentID: match(url, /paymentId=((PAY-)?[A-Z0-9]+)/),
	                        intent: $CheckoutCartModel.instance($rootScope.token).payment_action
	                    };
	
	                    if (window.xprops.onCancel) {
	                        params.cancelUrl = url;
	                        return window.xprops.onCancel(params);
	                    }
	
	                    return window.xchild.close();
	                }
	
	                var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
	                var showPaymentSuccess = Boolean($DeviceInfo.isDevice() && !isHTTPUrl);
	
	                if (showPaymentSuccess) {
	                    $logger.info('redirect', {
	                        url: url
	                    });
	                    $window.onunload = $window.onbeforeunload = function () {};
	                    $window.location = url;
	                    return $state.go('checkout.genericMessage', {
	                        code: 'PAYMENT_SUCCESS'
	                    });
	                }
	
	                if (forceRedirect) {
	                    $util.redirect(url);
	                }
	
	                var isVZeroIframe = Boolean($rootScope.partnerIntegration) && $util.isIFrame();
	
	                if (isVZeroIframe) {
	                    $util.redirect(url, { redirectImmediateParent: true });
	                }
	
	                // If we are not in minibrowser, do a hard redirect
	                else if ($rootScope.partnerIntegration || !$rootScope.miniBrowser && !$util.isIFrame()) {
	                        $util.redirect(url);
	                    } else {
	
	                        // Construct a message to send to the parent
	                        var result = this.postToMerchant({
	                            operation: 'return_to_merchant',
	                            returnUrl: url,
	                            updateParent: true
	                        });
	
	                        // Otherwise we have no choice but to return to the merchant
	                        if (!result) {
	                            $util.redirect(url);
	                        }
	                    }
	
	                var userStatus = function userStatus() {
	                    $logger.info('redirected_user_still_on_page_second_checkpoint');
	                };
	
	                $timeout(function () {
	                    $logger.info('redirected_user_still_on_page_first_checkpoint');
	                    $timeout(userStatus, 10000);
	                }, 10000);
	            },
	
	            postToMerchant: function postToMerchant(msg) {
	
	                try {
	                    msg = angular.toJson(msg, 0);
	
	                    // If we are not in IE, attempt to send a postMessage
	                    if ($window.opener && ($window.navigator.userAgent.match(/edge/i) || $window.opener.postMessage && !$window.navigator.userAgent.match(/msie|trident/i))) {
	                        $window.opener.postMessage(msg, '*');
	                        $logger.info('minibrowser_postmessage');
	                        return true;
	                    }
	                    // Otherwise, attempt to send a message through the iframe bridge
	                    var bridge = $window.opener && $window.opener.frames && $window.opener.frames.length && $window.opener.frames.PayPalBridge;
	
	                    if (bridge && bridge.returnToParent) {
	                        bridge.returnToParent(msg);
	                        $logger.info('minibrowser_bridgemessage');
	                        return true;
	                    }
	
	                    $logger.warn('minibrowser_nopostback');
	                } catch (err) {
	                    $logger.error('minibrowser_postback_error', {
	                        error: err.stack || err.toString()
	                    });
	                }
	
	                return false;
	            },
	
	            postTo: function postTo(url, msg) {
	                var form = document.createElement('form');
	                form.method = 'POST';
	                form.action = url;
	                form.className = 'hide';
	
	                for (var key in msg) {
	                    var input = document.createElement('input');
	                    input.name = key;
	                    input.value = msg[key];
	                    form.appendChild(input);
	                }
	
	                $window.document.body.appendChild(form);
	                form.submit();
	                $logger.info('web_postmessage');
	                return true;
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-return-to-merchant/dist", "components/xo-return-to-merchant/dist/util.js"))

/***/ },

/***/ "./components/xo-device-info/dist/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-device-info', ['squid']).factory('$DeviceInfo', function ($window, $meta, $logger) {
	        var userAgent = $window.navigator.userAgent;
	        var standalone = $window.navigator.standalone;
	        var DEVICE_PATTERN = /iPod|iPhone|iPad|Android|BlackBerry|BB10|Palm|CriOS|IEMobile|Windows Phone OS|webOS|Symbian|silk|Kindle|Opera Mini|mobile/i;
	        var TABLET_PATTERN = /ip(a|ro)d|silk|xoom|playbook|tablet|kindle|Nexus 7|GT-P10|SC-01C|SHW-M180S|SM-T320|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook|FOLIO|MB511.*RUTEM|Mac OS.*Silk/i;
	
	        // Supports iOS and Android. Updated / more accurate method of detecting webviews
	        function isWebView() {
	            var logEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	            var ua = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : userAgent;
	
	            var ios = /iphone|ipod|ipad/i.test(ua),
	                android = /Android/i.test(ua);
	
	            if (ios) {
	                // Unfortunately no perfectly reliable way, this will detect some 3rd party browsers as ui webview
	                // Major browsers: chrome, safari, firefox, uc browser, puffin, are detected reliably.
	                var ios_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
	
	                if (!standalone && ios_uiwebview && !isSafariViewController()) {
	                    // uiwebview
	                    logWebView('iOS');
	                    return true;
	                }
	            } else if (android) {
	                // not iOS, Android platform handling
	                // Whitelist for x-requested-with header values for web view detection
	                var allowedXRequestedWithRegexMap = {
	                    ajax: /XMLHttpRequest/i,
	                    baiduBrowser: /com.baidu.browser.inter/i,
	                    operaMini: /com.opera.mini.native/i,
	                    maxthon: /com.mx.browser/i,
	                    litterPenguinBrowser: /com.explore.web.browser/i
	                };
	                var xRequestedWithHeaderVal = $meta.requestHeaders['x-requested-with'];
	
	                if (xRequestedWithHeaderVal) {
	                    // check if x-requested-with header val is in whitelist
	                    for (var key in allowedXRequestedWithRegexMap) {
	                        if (allowedXRequestedWithRegexMap.hasOwnProperty(key)) {
	                            if (allowedXRequestedWithRegexMap[key].test(xRequestedWithHeaderVal)) {
	                                return false;
	                            }
	                        }
	                    }
	                    logWebView('Android');
	                    return true;
	                }
	            }
	
	            return false;
	
	            function logWebView(device) {
	                if (!logEnabled) {
	                    return;
	                }
	                // cal log
	                $logger.info('WebView :: ' + device);
	            }
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a device.
	         */
	        function isDevice() {
	            if (angular.isString(userAgent)) {
	                return DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent);
	            }
	
	            return false;
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a tablet.
	         */
	        function isTablet() {
	            if (angular.isString(userAgent)) {
	                return TABLET_PATTERN.test(userAgent);
	            }
	
	            return false;
	        }
	
	        /**
	         * Check if the given the user-agent string is belongs to a mobile
	         */
	        function isMobile() {
	            return isDevice(userAgent) && !isTablet(userAgent);
	        }
	
	        /**
	         * Get the mobile platform value given the user-agent string.
	         */
	        function getDevicePlatform() {
	            if (angular.isString(userAgent)) {
	                var matched = userAgent.match(/iPod|iPhone|iPad|Android|BlackBerry|Windows Phone OS|webOS|Symbian|mobile/g);
	
	                if (matched && matched.length > 0) {
	                    return matched[0];
	                }
	            }
	        }
	
	        /**
	         * Check if the give user agent is from an app.
	         */
	        function isApp(uaString) {
	            userAgent = uaString || userAgent;
	
	            if (DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent)) {
	                if (getDevicePlatform(userAgent) === 'Android') {
	                    return (/Version\/\d.\d/i.test(userAgent)
	                    );
	                }
	
	                return (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test(userAgent)
	                );
	            }
	
	            return false;
	        }
	
	        function isSafariViewController() {
	            if (angular.isString(userAgent)) {
	                var ios = /iphone|ipod|ipad/i.test(userAgent);
	                return ios && $window.indexedDB && isApp();
	            } else {
	                return false;
	            }
	        }
	
	        /**
	         * Get the device capabilities
	         */
	        function getCapabilities() {
	            var capabilities = {},
	                device = DEVICE_PATTERN.test(userAgent),
	                tablet = TABLET_PATTERN.test(userAgent),
	                app = isApp(userAgent);
	
	            if (angular.isString(userAgent)) {
	                capabilities.isWireless = device || tablet;
	                capabilities.isTablet = tablet;
	                capabilities.isMobile = device && !tablet;
	                capabilities.isDesktop = !device;
	                capabilities.isApp = app;
	            }
	
	            return capabilities;
	        }
	
	        /**
	         * Get various AppIntegrationType
	         */
	        function getAppIntegrationType() {
	            var app_int_type;
	            if (isDevice()) {
	                if (isApp()) {
	                    if (isSafariViewController()) {
	                        app_int_type = 'SFVC';
	                    } else {
	                        app_int_type = 'WebView';
	                    }
	                } else {
	                    app_int_type = 'Browser';
	                }
	            }
	            return app_int_type;
	        }
	
	        return {
	            isDevice: isDevice,
	            isTablet: isTablet,
	            isMobile: isMobile,
	            isApp: isApp,
	            isSafariViewController: isSafariViewController,
	            getCapabilities: getCapabilities,
	            getAppIntegrationType: getAppIntegrationType,
	            isWebView: isWebView
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-device-info/dist", "components/xo-device-info/dist/index.js"))

/***/ },

/***/ "./components/xo-models/src/checkout/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$CheckoutSessionModel = exports.$CheckoutPlanModel = exports.$CheckoutShippingAddressesModel = exports.$CreditOptionsModel = exports.$CheckoutPayeeModel = exports.$ShippingAddressModel = exports.$CheckoutShippingAddressModel = exports.$FlowEligibilityModel = exports.$InstallmentOptionsModel = exports.$FundingOptionsModel = exports.$FundingSourceModel = exports.$CheckoutAppDataModel = exports.$CheckoutCartModel = undefined;
	
	var _lodash = __webpack_require__("./components/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $CheckoutCartModel = exports.$CheckoutCartModel = _squid.$Model.extend('$CheckoutCartModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/cart',
	        cache: true
	    }),
	
	    isPurchase: function isPurchase() {
	        return Boolean(this.purchase);
	    },
	
	    isBilling: function isBilling() {
	        return Boolean(this.billing);
	    },
	
	    isBillingPurchase: function isBillingPurchase() {
	        return this.isPurchase() && this.isBilling();
	    },
	
	    isBillingNoPurchase: function isBillingNoPurchase() {
	        return this.isBilling() && !this.isPurchase();
	    },
	
	    getBillingDescription: function getBillingDescription() {
	        return this.billing && this.billing.description;
	    },
	
	    isMultiSellerPurchase: function isMultiSellerPurchase() {
	        return this.purchaseUnits && this.purchaseUnits.length > 1;
	    },
	
	    isShippingMethodStorePickUp: function isShippingMethodStorePickUp() {
	        return this.purchase && (this.purchase.shipping_method === '29' || this.purchase.shipping_method === '21');
	    },
	
	    isWalletTokenization: function isWalletTokenization() {
	        return this.billing && this.billing.intent === 'TOKENIZED_WALLET';
	    },
	    getExternalCallbackOptions: function getExternalCallbackOptions() {
	        return this.purchaseUnits && this.purchaseUnits[0] && this.purchaseUnits[0].external_callback_options;
	    }
	});
	
	var $CheckoutAppDataModel = exports.$CheckoutAppDataModel = _squid.$Model.extend('$CheckoutAppDataModel', {
	
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/appData'
	    }),
	
	    useraction: function useraction() {
	        // user_action from session takes precedence over CGI param.
	        var incontext_integration = window.xchild && window.xchild.props.commit ? 'commit' : false;
	        var rest_integration = this.flags && this.flags.user_action === 'PAY' ? 'commit' : false;
	
	        return rest_integration || incontext_integration || _squid.$util.param('useraction');
	    },
	
	    doec_on_approve: function doec_on_approve() {
	        return this.flags && this.flags.doec_on_approve;
	    }
	});
	
	var $FundingSourceModel = exports.$FundingSourceModel = _squid.$Model.extend('$FundingSourceModel', {
	
	    formatLast4: function formatLast4() {
	        var last4;
	
	        if (this.last4) {
	            last4 = this.last4;
	
	            if (!this.parent.isAuthRequired) {
	                last4 = 'x-' + last4;
	            }
	        }
	
	        return last4;
	    }
	});
	
	var $FundingOptionsModel = exports.$FundingOptionsModel = _squid.$Model.extend('$FundingOptionsModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/fundingOptions',
	        postAttempts: 2
	    }),
	
	    eachPlan: function eachPlan(method, context) {
	        angular.forEach(this.plans, method, this);
	    },
	
	    hasECheck: function hasECheck() {
	        return _squid.$util.some(this.instruments, function (instrument) {
	            return instrument.type === 'ECHECK' || instrument.subtype === 'ECHECK';
	        });
	    },
	
	    hasCredit: function hasCredit() {
	        return _squid.$util.some(this.instruments, function (instrument) {
	            return instrument.type === 'CREDIT';
	        });
	    },
	
	    getBankPlanIdByInstrumentId: function getBankPlanIdByInstrumentId(id, subType) {
	        var fundingInstrument = _squid.$util.find(this.plans, function (plan) {
	            return plan.primaryFs && plan.primaryFs.type === 'BANK' && plan.primaryFs.id === id && plan.primaryFs.subtype === subType;
	        });
	
	        return fundingInstrument && fundingInstrument.planId;
	    },
	
	    onPopulate: function onPopulate() {
	        var self = this;
	        angular.forEach(this.plans, function (plan) {
	            if (plan.primaryFs && plan.primaryFs.type === 'BANK' && (plan.primaryFs.subtype === 'IACH' || plan.primaryFs.subtype === 'PAD')) {
	                Object.defineProperty(plan.primaryFs, plan.primaryFs.subtype === 'IACH' ? 'padPlanId' : 'iachPlanId', {
	                    enumerable: true,
	                    configurable: false,
	                    writeable: false,
	                    value: self.getBankPlanIdByInstrumentId(plan.primaryFs.id, plan.primaryFs.subtype === 'IACH' ? 'PAD' : 'IACH')
	                });
	            }
	        });
	    },
	
	    getBankPadPlanIdByInstrumentId: function getBankPadPlanIdByInstrumentId(id, subtype) {
	        var bankPadPlan = this.plans.find(function (plan) {
	            return plan.primaryFs && plan.primaryFs.id === id && plan.primaryFs.type === 'BANK' && plan.primaryFs.subtype === subtype;
	        });
	
	        return bankPadPlan.primaryFs && (bankPadPlan.primaryFs.subtype === 'IACH' ? bankPadPlan.primaryFs.padPlanId : bankPadPlan.primaryFs.iachPlanId);
	    },
	
	    isPadToggleApplicable: function isPadToggleApplicable() {
	        var padToggleApplicable = false;
	        this.eachPlan(function (plan) {
	            if (!padToggleApplicable && plan.primaryFs && plan.primaryFs.type === 'BANK') {
	                if (plan.primaryFs.subtype === 'IACH' && plan.primaryFs.hasOwnProperty('padPlanId')) {
	                    padToggleApplicable = plan.primaryFs.padPlanId ? true : false;
	                } else if (plan.primaryFs.subtype === 'PAD' && plan.primaryFs.hasOwnProperty('iachPlanId')) {
	                    padToggleApplicable = plan.primaryFs.iachPlanId ? true : false;
	                }
	            }
	        }, this);
	
	        return padToggleApplicable;
	    },
	
	    getPreferred: function getPreferred() {
	        return _squid.$util.find(this.plans, function (plan) {
	            return plan.primaryFs.isPreferred;
	        });
	    }
	});
	
	var $InstallmentOptionsModel = exports.$InstallmentOptionsModel = _squid.$Model.extend('$InstallmentOptionsModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/installmentOptions/',
	        postAttempts: 2
	    })
	});
	
	var $FlowEligibilityModel = exports.$FlowEligibilityModel = _squid.$Model.extend('$FlowEligibilityModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/flowEligibility'
	    })
	});
	
	var $CheckoutShippingAddressModel = exports.$CheckoutShippingAddressModel = _squid.$Model.extend('$CheckoutShippingAddressModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:parent.id/shipping/:id'
	    })
	});
	
	var $ShippingAddressModel = exports.$ShippingAddressModel = _squid.$Model.extend('$ShippingAddressModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/shipping/add'
	    }),
	
	    serialize: function serialize() {
	        return {
	            first_name: this.first_name,
	            last_name: this.last_name,
	            recipient_name: this.recipient_name,
	            line1: this.line1,
	            line2: this.line2,
	            city: this.city,
	            state: this.state,
	            postal_code: this.postal_code,
	            country: this.country
	        };
	    }
	});
	
	var $CheckoutPayeeModel = exports.$CheckoutPayeeModel = _squid.$Model.extend('$CheckoutPayeeModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/payee'
	    }),
	
	    getId: function getId() {
	        return this.merchant && this.merchant.id;
	    },
	
	    isGambling: function isGambling() {
	        return this.merchant && this.merchant.isGambling;
	    }
	});
	
	var $CreditOptionsModel = exports.$CreditOptionsModel = {
	    sacEligibleAmount: {
	        US: 99,
	        GB: 150
	    }
	};
	
	var $CheckoutShippingAddressesModel = exports.$CheckoutShippingAddressesModel = _squid.$Model.extend('$CheckoutShippingAddressesModel', {
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/shipping'
	    }),
	
	    onPopulate: function onPopulate() {
	        this.addresses = this.children($CheckoutShippingAddressModel, this.addresses);
	    },
	
	    getPreferredShippingAddress: function getPreferredShippingAddress() {
	        var preferredAddress = {};
	
	        if (this.addresses) {
	            var i = void 0;
	            var address = void 0;
	
	            for (i = 0; i < this.addresses.length; i++) {
	                address = this.addresses[i];
	
	                if (address && address.preferred_address) {
	                    preferredAddress = {
	                        'line1': address.line1,
	                        'line2': address.line2,
	                        'city': address.city,
	                        'state': address.state,
	                        'postal_code': address.postal_code,
	                        'country_code': address.country_code
	                    };
	
	                    break;
	                }
	            }
	        }
	        return preferredAddress;
	    },
	
	    getPrimaryShippingAddress: function getPrimaryShippingAddress() {
	        var primaryAddress = {};
	
	        if (this.addresses) {
	            var i = void 0;
	            var address = void 0;
	
	            for (i = 0; i < this.addresses.length; i++) {
	                address = this.addresses[i];
	
	                if (address && address.primary_address) {
	                    primaryAddress = {
	                        'line1': address.line1,
	                        'line2': address.line2,
	                        'city': address.city,
	                        'state': address.state,
	                        'postal_code': address.postal_code,
	                        'country_code': address.country_code
	                    };
	
	                    break;
	                }
	            }
	        }
	        return primaryAddress;
	    }
	});
	
	var $CheckoutPlanModel = exports.$CheckoutPlanModel = _squid.$Model.extend('$CheckoutPlanModel', {
	
	    onPopulate: function onPopulate() {
	        this.sources = this.children($FundingSourceModel, this.sources);
	    },
	
	    eachSource: function eachSource(method, context) {
	        angular.forEach(this.sources, method, this);
	    },
	
	    hasFundingMethodType: function hasFundingMethodType(name) {
	        var found = false;
	
	        this.eachSource(function (source) {
	            if (source.type === name) {
	                found = true;
	            }
	        }, this);
	
	        return found;
	    },
	
	    hasFundingMethodSubType: function hasFundingMethodSubType(name) {
	        var found = false;
	
	        this.eachSource(function (source) {
	            if (source.sub_type === name) {
	                found = true;
	            }
	        }, this);
	
	        return found;
	    },
	
	    isPAD: function isPAD() {
	        return this.hasFundingMethodSubType('DELAYED_TRANSFER');
	    },
	
	    isIACH: function isIACH() {
	        var found = false;
	
	        this.eachSource(function (source) {
	            if (source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER') {
	                found = true;
	            }
	        }, this);
	
	        return found;
	    },
	
	    isSplitPaymentWithBalanceAndIach: function isSplitPaymentWithBalanceAndIach() {
	        return this.sources && this.sources.length > 1 && this.hasFundingMethodType('BALANCE') && this.isIACH();
	    },
	
	    isMSB: function isMSB() {
	        return this.sources && this.sources.length === 1 && this.sources[0].type === 'INCENTIVE';
	    },
	
	    isBalance: function isBalance() {
	        return this.sources && this.sources.length === 1 && this.sources[0].type === 'BALANCE';
	    },
	
	    hasConversion: function hasConversion() {
	        return _lodash2['default'].isObject(this.conversion);
	    }
	});
	
	var $CheckoutSessionModel = exports.$CheckoutSessionModel = _squid.$Model.extend('$CheckoutSessionModel', {
	
	    api: new _squid.$Api({
	        uri: '/api/checkout/:id/session',
	        postAttempts: 2
	    }),
	
	    onPopulate: function onPopulate() {
	        this.plan = new $CheckoutPlanModel(this.plan);
	        this.shipping = this.child($CheckoutShippingAddressModel, this.shipping);
	        this.fundingOptions = this.child($FundingOptionsModel, this.fundingOptions);
	    },
	
	    getSelectedStickyInstrument: function getSelectedStickyInstrument() {
	
	        if (this.selectedFuturePaymentInstrument) {
	            return this.selectedFuturePaymentInstrument;
	        }
	
	        if (!this.futurePaymentInstruments) {
	            return;
	        }
	
	        if (!(this.plan && this.plan.sources) && this.futurePaymentInstruments) {
	            return this.futurePaymentInstruments[0];
	        }
	
	        var selectedInstrumentId = _squid.$util.some(this.plan.sources, function (fi) {
	            return fi.instrument_id ? fi.instrument_id : undefined;
	        });
	
	        var stickyInstrument = _squid.$util.find(this.futurePaymentInstruments, function (fi) {
	            return fi.instrument_id === selectedInstrumentId;
	        });
	
	        return stickyInstrument;
	    },
	
	    getPlanList: function getPlanList() {
	        return this.fundingOptions && this.fundingOptions.plans;
	    },
	
	    // returns true if more than one plan uses BALANCE as the primary FI
	    isMultipleBalancePlan: function isMultipleBalancePlan() {
	        var matchingBalancePlans = 0;
	
	        return this.fundingOptions && this.fundingOptions.plans && this.fundingOptions.plans.some(function (plan) {
	            // if BALANCE is the primary FI...
	            if (plan.primaryFs.name === 'BALANCE') {
	                // increment number of balance plans found
	                matchingBalancePlans++;
	            }
	            // exit once we have more than one balance plan
	            return matchingBalancePlans > 1;
	        });
	    },
	
	    getDisallowedInstruments: function getDisallowedInstruments() {
	        return this.fundingOptions && this.fundingOptions.disallowedInstruments;
	    },
	
	    getDisallowedPreferred: function getDisallowedPreferred() {
	        var disallowedInstrument = this.getDisallowedInstruments();
	
	        // find only the disallowed instrument that has been marked as preferred.
	        disallowedInstrument = disallowedInstrument && _squid.$util.find(disallowedInstrument, function (fi) {
	            return fi.isPreferred;
	        });
	
	        // if the disallowed instrument is in the plan list (in the case that the instrument has a BUF)
	        // we do not show it in the disallowed section.
	        var isDisallowedInstrumentInPlanList = disallowedInstrument && _squid.$util.some(this.getPlanList(), function (plan) {
	            var instrumentID = plan.primaryFs && plan.primaryFs.id;
	            if (instrumentID && disallowedInstrument.id) {
	                return instrumentID === disallowedInstrument.id;
	            } else {
	                return false;
	            }
	        });
	
	        return !isDisallowedInstrumentInPlanList && disallowedInstrument;
	    },
	
	    getShippingAddressMinimalDetails: function getShippingAddressMinimalDetails() {
	        return {
	            'line1': this.shipping.line1,
	            'line2': this.shipping.line2,
	            'city': this.shipping.city,
	            'state': this.shipping.state,
	            'postal_code': this.shipping.postal_code,
	            'country_code': this.shipping.country
	        };
	    }
	});
	
	angular.value("$CheckoutCartModel", $CheckoutCartModel);
	angular.value("$CheckoutAppDataModel", $CheckoutAppDataModel);
	angular.value("$FundingSourceModel", $FundingSourceModel);
	angular.value("$FundingOptionsModel", $FundingOptionsModel);
	angular.value("$InstallmentOptionsModel", $InstallmentOptionsModel);
	angular.value("$FlowEligibilityModel", $FlowEligibilityModel);
	angular.value("$CheckoutShippingAddressModel", $CheckoutShippingAddressModel);
	angular.value("$ShippingAddressModel", $ShippingAddressModel);
	angular.value("$CheckoutPayeeModel", $CheckoutPayeeModel);
	angular.value("$CreditOptionsModel", $CreditOptionsModel);
	angular.value("$CheckoutShippingAddressesModel", $CheckoutShippingAddressesModel);
	angular.value("$CheckoutPlanModel", $CheckoutPlanModel);
	angular.value("$CheckoutSessionModel", $CheckoutSessionModel);
	_squid.$Model;
	
	_squid.$Api;
	
	_squid.$util;

/***/ },

/***/ "./components/lodash/lodash.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */;(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.17.4';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,reLeadingDot=/^\./,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading and trailing whitespace. */var reTrim=/^\s+|\s+$/g,reTrimStart=/^\s+/,reTrimEnd=/\s+$/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange='\\ud800-\\udfff',rsComboMarksRange='\\u0300-\\u036f',reComboHalfMarksRange='\\ufe20-\\ufe2f',rsComboSymbolsRange='\\u20d0-\\u20ff',rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange='\\u2700-\\u27bf',rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange='\\u2000-\\u206f',rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange='\\ufe0e\\ufe0f',rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos='[\'\u2019]',rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz='\\ud83c[\\udffb-\\udfff]',rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',rsUpper='['+rsUpperRange+']',rsZWJ='\\u200d';/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',rsOrdUpper='\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
	'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
	'\u0100':'A','\u0102':'A','\u0104':'A','\u0101':'a','\u0103':'a','\u0105':'a','\u0106':'C','\u0108':'C','\u010A':'C','\u010C':'C','\u0107':'c','\u0109':'c','\u010B':'c','\u010D':'c','\u010E':'D','\u0110':'D','\u010F':'d','\u0111':'d','\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011A':'E','\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011B':'e','\u011C':'G','\u011E':'G','\u0120':'G','\u0122':'G','\u011D':'g','\u011F':'g','\u0121':'g','\u0123':'g','\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h','\u0128':'I','\u012A':'I','\u012C':'I','\u012E':'I','\u0130':'I','\u0129':'i','\u012B':'i','\u012D':'i','\u012F':'i','\u0131':'i','\u0134':'J','\u0135':'j','\u0136':'K','\u0137':'k','\u0138':'k','\u0139':'L','\u013B':'L','\u013D':'L','\u013F':'L','\u0141':'L','\u013A':'l','\u013C':'l','\u013E':'l','\u0140':'l','\u0142':'l','\u0143':'N','\u0145':'N','\u0147':'N','\u014A':'N','\u0144':'n','\u0146':'n','\u0148':'n','\u014B':'n','\u014C':'O','\u014E':'O','\u0150':'O','\u014D':'o','\u014F':'o','\u0151':'o','\u0154':'R','\u0156':'R','\u0158':'R','\u0155':'r','\u0157':'r','\u0159':'r','\u015A':'S','\u015C':'S','\u015E':'S','\u0160':'S','\u015B':'s','\u015D':'s','\u015F':'s','\u0161':'s','\u0162':'T','\u0164':'T','\u0166':'T','\u0163':'t','\u0165':'t','\u0167':'t','\u0168':'U','\u016A':'U','\u016C':'U','\u016E':'U','\u0170':'U','\u0172':'U','\u0169':'u','\u016B':'u','\u016D':'u','\u016F':'u','\u0171':'u','\u0173':'u','\u0174':'W','\u0175':'w','\u0176':'Y','\u0177':'y','\u0178':'Y','\u0179':'Z','\u017B':'Z','\u017D':'Z','\u017A':'z','\u017C':'z','\u017E':'z','\u0132':'IJ','\u0133':'ij','\u0152':'Oe','\u0153':'oe','\u0149':"'n",'\u017F':'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r','\u2028':'u2028','\u2029':'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=(typeof global==='undefined'?'undefined':_typeof(global))=='object'&&global&&global.Object===Object&&global;/** Detect free variable `self`. */var freeSelf=(typeof self==='undefined'?'undefined':_typeof(self))=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports=( false?'undefined':_typeof(exports))=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&( false?'undefined':_typeof(module))=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*//**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */function addMapEntry(map,pair){// Don't return `map.set` because it's not chainable in IE 11.
	map.set(pair[0],pair[1]);return map;}/**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */function addSetEntry(set,value){// Don't return `set.add` because it's not chainable in IE 11.
	set.add(value);return set;}/**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludes(array,value){var length=array==null?0:array.length;return!!length&&baseIndexOf(array,value,0)>-1;}/**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */var asciiSize=baseProperty('length');/**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function asciiToArray(string){return string.split('');}/**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */function baseIsNaN(value){return value!==value;}/**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */function baseUnary(func){return function(value){return func(value);};}/**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */function cacheHas(cache,key){return cache.has(key);}/**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */var deburrLetter=basePropertyOf(deburredLetters);/**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */function getValue(object,key){return object==null?undefined:object[key];}/**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */function hasUnicode(string){return reHasUnicode.test(string);}/**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*//**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,_Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=_Symbol?_Symbol.isConcatSpreadable:undefined,symIterator=_Symbol?_Symbol.iterator:undefined,symToStringTag=_Symbol?_Symbol.toStringTag:undefined;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol?_Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/*------------------------------------------------------------------------*//**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();/**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */function baseLodash(){}// No operation performed.
	/**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */lodash.templateSettings={/**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'escape':reEscape,/**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'evaluate':reEvaluate,/**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */'interpolate':reInterpolate,/**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */'variable':'',/**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */'imports':{/**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*//**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*//**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
	Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*//**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */function listCacheClear(){this.__data__=[];this.size=0;}/**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}/**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
	ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*//**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
	MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*//**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
	SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*//**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */function stackGet(key){return this.__data__.get(key);}/**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */function stackHas(key){return this.__data__.has(key);}/**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
	Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*//**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
	key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
	isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
	isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
	isIndex(key,length)))){result.push(key);}}return result;}/**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined;}/**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}/**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined:get(object,paths[index]);}return result;}/**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,baseClone,isDeep);}}// Check for circular references and return its corresponding clone.
	stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
	assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEach=createBaseEach(baseForOwn);/**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
	baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseFor=createBaseFor();/**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */var baseForRight=createBaseFor(true);/**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */function baseGt(value,other){return value>other;}/**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined:apply(func,object,args);}/**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	if(typeof value=='function'){return value;}if(value==null){return identity;}if((typeof value==='undefined'?'undefined':_typeof(value))=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */function baseLt(value,other){return value<other;}/**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){if(isObject(srcValue)){stack||(stack=new Stack());baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(object[key],srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=object[key],srcValue=source[key],stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||srcIndex&&isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */function baseOrderBy(collection,iteratees,orders){var index=-1;iteratees=arrayMap(iteratees.length?iteratees:[identity],baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else{baseUnset(array,index);}}}return array;}/**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
	// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */function baseSample(collection){return arraySample(values(collection));}/**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */function baseSortedIndexBy(array,value,iteratee,retHighest){value=iteratee(value);var low=0,high=array==null?0:array.length,valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
	if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
	return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */function castFunction(value){return typeof value=='function'?value:identity;}/**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */var castRest=baseRest;/**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */function cloneMap(map,isDeep,cloneFunc){var array=isDeep?cloneFunc(mapToArray(map),CLONE_DEEP_FLAG):mapToArray(map);return arrayReduce(array,addMapEntry,new map.constructor());}/**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */function cloneSet(set,isDeep,cloneFunc){var array=isDeep?cloneFunc(setToArray(set),CLONE_DEEP_FLAG):setToArray(set);return arrayReduce(array,addSetEntry,new set.constructor());}/**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	// that causes it, under certain circumstances, to provide the same value for
	// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	// for more details.
	//
	// This also ensures a stable sort in V8 and other engines.
	// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	return object.index-other.index;}/**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}/**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
	// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	// for more details.
	var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
	// See https://es5.github.io/#x13.2.2 for more details.
	return isObject(result)?result:thisBinding;};}/**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function predicate(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
	start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision){// Shift with exponential notation to avoid floating-point issues.
	// See [MDN](https://mdn.io/round#Examples) for more details.
	var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */function customOmitClone(value){return isPlainObject(value)?undefined:value;}/**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Assume cyclic values are equal.
	var stacked=stack.get(array);if(stacked&&stack.get(other)){return stacked==other;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
	while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
	if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
	// Invalid dates are coerced to `NaN`.
	return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
	// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	// for more details.
	return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
	var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
	stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Assume cyclic values are equal.
	var stacked=stack.get(object);if(stacked&&stack.get(other)){return stacked==other;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
	if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
	if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */function flatRest(func){return setToString(overRest(func,undefined,flatten),func+'');}/**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}/**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function getTag(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{'start':start,'end':end};}/**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */function initCloneArray(array){var length=array.length,result=array.constructor(length);// Add properties assigned by `RegExp#exec`.
	if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */function initCloneByTag(object,tag,cloneFunc,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return cloneMap(object,isDeep,cloneFunc);case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return cloneSet(object,isDeep,cloneFunc);case symbolTag:return cloneSymbol(object);}}/**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */function isIndex(value,length){length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(typeof value=='number'||reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index==='undefined'?'undefined':_typeof(index);if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value==='undefined'?'undefined':_typeof(value);if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */function isKeyable(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */var isMaskable=coreJsData?isFunction:stubFalse;/**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
	if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
	if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
	newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
	var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
	value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
	value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
	if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
	if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
	data[0]=source[0];data[1]=newBitmask;return data;}/**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */function objectToString(value){return nativeObjectToString.call(value);}/**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */var setData=shortOut(baseSetData);/**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */var setToString=shortOut(baseSetToString);/**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}/**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */var stringToPath=memoizeCapped(function(string){var result=[];if(reLeadingDot.test(string)){result.push('');}string.replace(rePropName,function(match,number,quote,string){result.push(quote?string.replace(reEscapeChar,'$1'):number||match);});return result;});/**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*//**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */function concat(){var length=arguments.length;if(!length){return[];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return[];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */function head(array){return array&&array.length?array[0]:undefined;}/**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator=='function'?comparator:undefined;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined;}/**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */var pull=baseRest(pullAll);/**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return[];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */function uniqWith(array,comparator){comparator=typeof comparator=='function'?comparator:undefined;return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */var zip=baseRest(unzip);/**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*//**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */function tap(value,interceptor){interceptor(value);return value;}/**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */function thru(value,interceptor){return interceptor(value);}/**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function interceptor(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */function wrapperChain(){return chain(this);}/**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{'done':done,'value':value};}/**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */function wrapperToIterator(){return this;}/**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*//**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else{baseAssignValue(result,key,1);}});/**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */var find=createFind(findIndex);/**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */var findLast=createFind(findLastIndex);/**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{baseAssignValue(result,key,[value]);}});/**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*//**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*//**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
	lastInvokeTime=time;// Start the timer for the trailing edge.
	timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
	return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,result=wait-timeSinceLastCall;return maxing?nativeMin(result,maxWait-timeSinceLastInvoke):result;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
	// trailing edge, the system time has gone backwards and we're treating
	// it as the trailing edge, or we've hit the `maxWait` limit.
	return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
	timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
	// debounced at least once.
	if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
	timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */function memoize(func,resolver){if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function memoized(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
	memoize.Cache=MapCache;/**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */function once(func){return before(2,func);}/**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined,partials,holders);});/**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined,undefined,undefined,indexes);});/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */function unary(func){return ary(func,1);}/**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/*------------------------------------------------------------------------*//**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */function cloneWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */function cloneDeepWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */var gt=createRelationalOperation(baseGt);/**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */var isArray=Array.isArray;/**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */var isBuffer=nativeIsBuffer||stubFalse;/**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(isPrototype(value)){return!baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */function isEqual(value,other){return baseIsEqual(value,other);}/**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,undefined,customizer):!!result;}/**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);}/**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
	// in Safari 9 which returns 'object' for typed arrays and other constructors.
	var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */function isObject(value){var type=typeof value==='undefined'?'undefined':_typeof(value);return value!=null&&(type=='object'||type=='function');}/**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */function isObjectLike(value){return value!=null&&(typeof value==='undefined'?'undefined':_typeof(value))=='object';}/**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
	// Perform the `toStringTag` check first to avoid errors with some
	// ActiveX objects in IE.
	return isNumber(value)&&value!=+value;}/**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */function isNull(value){return value===null;}/**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */function isNil(value){return value==null;}/**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */function isSymbol(value){return(typeof value==='undefined'?'undefined':_typeof(value))=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */function isUndefined(value){return value===undefined;}/**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */var lt=createRelationalOperation(baseLt);/**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=value.replace(reTrim,'');var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*//**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */var at=flatRest(baseAt);/**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */var defaults=baseRest(function(args){args.push(undefined,customDefaultsAssignIn);return apply(assignInWith,undefined,args);});/**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */var defaultsDeep=baseRest(function(args){args.push(undefined,customDefaultsMerge);return apply(mergeWith,undefined,args);});/**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */var invert=createInverter(function(result,value,key){result[value]=key;},constant(identity));/**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */var invertBy=createInverter(function(result,value,key){if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */var invoke=baseRest(baseInvoke);/**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */function pickBy(object,predicate){if(object==null){return{};}var props=arrayMap(getAllKeysIn(object),function(prop){return[prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
	if(!length){length=1;object=undefined;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */var toPairs=createToPairs(keys);/**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */var toPairsIn=createToPairs(keysIn);/**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else{accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*//**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper=='boolean'){floating=upper;upper=undefined;}else if(typeof lower=='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*//**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */var lowerFirst=createCaseFirst('toLowerCase');/**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
	// (http://ejohn.org/blog/javascript-micro-templating/)
	// and Laura Doktorova's doT.js (https://github.com/olado/doT).
	var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
	var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
	var sourceURL='//# sourceURL='+('sourceURL'in options?options.sourceURL:'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
	source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
	if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
	// order to produce the correct `offset` value.
	return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
	// code to add the data object to the top of the scope chain.
	var variable=options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Cleanup code by stripping empty strings.
	source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
	source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
	// the `source` property as a convenience for inlining compiled templates.
	result.source=source;if(isError(result)){throw result;}return result;}/**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */function toLower(value){return toString(value).toLowerCase();}/**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */function toUpper(value){return toString(value).toUpperCase();}/**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrim,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimEnd,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */var upperFirst=createCaseFirst('toUpperCase');/**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*//**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */function constant(value){return function(){return value;};}/**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flow=createFlow();/**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */var flowRight=createFlow(true);/**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */function identity(value){return value;}/**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */function noop(){}// No operation performed.
	/**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */var over=createOver(arrayMap);/**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */var overEvery=createOver(arrayEvery);/**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */var overSome=createOver(arraySome);/**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */var range=createRange();/**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */var rangeRight=createRange(true);/**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */function stubArray(){return[];}/**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */function stubFalse(){return false;}/**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */function stubObject(){return{};}/**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */function stubString(){return'';}/**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */function stubTrue(){return true;}/**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*//**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */var ceil=createRound('ceil');/**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */var floor=createRound('floor');/**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */function mean(array){return baseMean(array,identity);}/**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */var round=createRound('round');/**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/// Add methods that return wrapped values in chain sequences.
	lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
	lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
	mixin(lodash,lodash);/*------------------------------------------------------------------------*/// Add methods that return unwrapped values in chain sequences.
	lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
	lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*//**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */lodash.VERSION=VERSION;// Assign default placeholders.
	arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
	arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
	arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function interceptor(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
	isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
	arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
	baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'',names=realNames[key]||(realNames[key]=[]);names.push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined,WRAP_BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined}];// Add methods to `LazyWrapper`.
	LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
	lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
	lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/// Export lodash.
	var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
	if("function"=='function'&&_typeof(__webpack_require__("../node_modules/webpack/buildin/amd-options.js"))=='object'&&__webpack_require__("../node_modules/webpack/buildin/amd-options.js")){// Expose Lodash on the global object to prevent errors when Lodash is
	// loaded by a script tag in the presence of an AMD loader.
	// See http://requirejs.org/docs/errors.html#mismatch for more details.
	// Use `_.noConflict` to remove Lodash from the global object.
	root._=_;// Define as an anonymous module so, through path mapping, it can be
	// referenced as the "underscore" module.
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return _;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// Check for `exports` after `define` in case a build optimizer adds it.
	else if(freeModule){// Export for Node.js.
	(freeModule.exports=_)._=_;// Export for CommonJS support.
	freeExports._=_;}else{// Export to the global object.
	root._=_;}}).call(undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__("../node_modules/webpack/buildin/module.js")(module)))

/***/ },

/***/ "./js/lib/icFallback.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$incontextFallback = $incontextFallback;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	function $incontextFallback(win, url) {
	
	    _angular.$rootScope.$emit('loading');
	
	    window.onbeforeunload = function () {};
	    window.onunload = function () {};
	
	    var parent = window.opener || window.parent;
	
	    if (!window.xprops || !window.xprops.fallback) {
	        parent.location = url;
	        win.close();
	        return;
	    }
	
	    try {
	
	        var frame;
	
	        try {
	            if (typeof parent.onLegacyFallback === 'function') {
	                frame = parent;
	            }
	        } catch (err) {
	            // pass
	        }
	
	        if (!frame) {
	            for (var i = 0; i < parent.frames.length; i++) {
	
	                try {
	                    if (typeof parent.frames[i].onLegacyFallback === 'function') {
	                        frame = parent.frames[i];
	                        break;
	                    }
	                } catch (err) {
	                    // pass
	                }
	            }
	        }
	
	        if (!frame) {
	            parent.location = url;
	            win.close();
	            return;
	        }
	
	        frame.onLegacyFallback(win);
	
	        window.addEventListener('unload', function () {
	
	            var width = 970;
	            var height = 900;
	            var left = void 0;
	            var top = void 0;
	
	            if (window.outerWidth) {
	                left = Math.round((window.outerWidth - width) / 2) + window.screenX;
	                top = Math.round((window.outerHeight - height) / 2) + window.screenY;
	            } else if (window.screen.width) {
	                left = Math.round((window.screen.width - width) / 2);
	                top = Math.round((window.screen.height - height) / 2);
	            }
	
	            window.resizeTo(width, height);
	            window.moveTo(left, top);
	        });
	
	        win.location = url;
	    } catch (err) {
	
	        parent.location = url;
	        win.close();
	    }
	
	    window.xprops.fallback(url);
	}
	
	angular.value("$incontextFallback", $incontextFallback);
	_angular.$rootScope;

/***/ },

/***/ "./js/lib/integration.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$CONTEXT = exports.$integration = exports.$FLOWS = undefined;
	
	var _$DEFAULT, _$CONTEXT$FULLPAGE, _$CONTEXT$LIGHTBOX, _$integration$init;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	Object.defineProperty(exports, '$integration', {
	    enumerable: true,
	    get: function get() {
	        return _squid.$integration;
	    }
	});
	Object.defineProperty(exports, '$CONTEXT', {
	    enumerable: true,
	    get: function get() {
	        return _squid.$CONTEXT;
	    }
	});
	var $FLOWS = exports.$FLOWS = {
	
	    // Regular end-to-end checkout flow with one entry and one exit point
	    CHECKOUT: 'CHECKOUT',
	
	    // Partner flow [ TODO: FACTOR THIS OUT ]
	    PARTNER: 'PARTNER',
	
	    // Incontext lightbox flow
	    INCONTEXT_LIGHTBOX: 'INCONTEXT_LIGHTBOX',
	
	    // Incontext popup flow
	    INCONTEXT_POPUP: 'INCONTEXT_POPUP',
	
	    // Native checkout flow
	    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT',
	
	    // Messenger Integration flow
	    MESSENGER_BA_INTEGRATION: 'MESSENGER_BA_INTEGRATION',
	
	    // WPS flow
	    WPS: 'WPS'
	};
	
	_squid.$integration.init($FLOWS.CHECKOUT, (_$integration$init = {}, _$integration$init[_squid.$DEFAULT] = (_$DEFAULT = {
	
	    ALLOW_AUTH: true,
	    ALLOW_COLLECT_DATA: true,
	    ALLOW_ONETOUCH_TOKEN_EXCHANGE: false,
	    ALLOW_PAYER_ID_RETURN_PARAM: true,
	    DONE_PAGE: false,
	    FALLBACK: true,
	    REDIRECT_TOP: true,
	    REDIRECT_QUERY_PARAM: false,
	    POST_MESSAGE_PARENT: false
	}, _$DEFAULT[$FLOWS.PARTNER] = {
	
	    FALLBACK: false,
	    REDIRECT_TOP: false,
	    POST_MESSAGE_PARENT: false
	}, _$DEFAULT[$FLOWS.INCONTEXT_LIGHTBOX] = {
	
	    ALLOW_ONETOUCH_TOKEN_EXCHANGE: true,
	    POST_MESSAGE_PARENT: true
	}, _$DEFAULT[$FLOWS.INCONTEXT_POPUP] = {
	
	    POST_MESSAGE_PARENT: true
	}, _$DEFAULT[$FLOWS.WPS] = {
	    ALLOW_PAYER_ID_RETURN_PARAM: false,
	    DONE_PAGE: true,
	    ERROR_AFTER_PAYMENT: true,
	    POPULATE_MERCHANT_PREFERENCES: true,
	    RETURN_METHOD_BASED_ON_MERCHANT_PREFS: true,
	    RETURN_URL_FROM_MERCHANT_PREFS: true,
	    SHOW_PAY_NOW_LABEL_ON_REVIEW: true,
	    SHOW_SHIPPING_METHOD: true
	}, _$DEFAULT), _$integration$init[_squid.$CONTEXT.FULLPAGE] = (_$CONTEXT$FULLPAGE = {
	
	    CAN_FRAMEBUST: false,
	    CAN_FALLBACK_TO_POPUP: false,
	    CAN_CLOSE_SELF: false
	
	}, _$CONTEXT$FULLPAGE[$FLOWS.NATIVE_CHECKOUT] = {
	
	    REDIRECT_QUERY_PARAM: true
	
	}, _$CONTEXT$FULLPAGE), _$integration$init[_squid.$CONTEXT.LIGHTBOX] = (_$CONTEXT$LIGHTBOX = {
	
	    ALLOW_AUTH: false,
	    ALLOW_COLLECT_DATA: false,
	
	    CAN_FRAMEBUST: true,
	    CAN_FALLBACK_TO_POPUP: true,
	    CAN_CLOSE_SELF: false,
	
	    RETURN_FROM_DATA_COLLECTION_POPUP: false
	
	}, _$CONTEXT$LIGHTBOX[$FLOWS.MESSENGER_BA_INTEGRATION] = {
	
	    IS_MESSENGER_BA_INTEGRATION: true
	
	}, _$CONTEXT$LIGHTBOX[$FLOWS.PARTNER] = {
	
	    ALLOW_AUTH: true,
	    ALLOW_COLLECT_DATA: true,
	    CAN_FALLBACK_TO_POPUP: false,
	    POST_MESSAGE_PARENT: false
	}, _$CONTEXT$LIGHTBOX), _$integration$init[_squid.$CONTEXT.POPUP] = {
	    ALLOW_AUTH: true,
	    ALLOW_COLLECT_DATA: true,
	
	    CAN_FRAMEBUST: true,
	    CAN_FALLBACK_TO_POPUP: true,
	    CAN_CLOSE_SELF: false
	}, _$integration$init));
	
	_squid.$integration;
	
	_squid.$DEFAULT;
	
	_squid.$CONTEXT;

/***/ },

/***/ "./js/lib/contingency.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	__webpack_require__("./js/lib/fallback.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	_angular2['default'].module().factory('$contingencyHandler', function ($Contingency, $logger, $location, $feature, $state, $config, $meta, $window, $util, $populate, $q, $pxp, $AuthModel, $CheckoutCartModel, $CheckoutPayeeModel, $locale, $Forbidden, $rootScope, $FallbackError) {
	
	    function showGenericError(code) {
	        return function () {
	            var encoded = code ? window.btoa(code) : code;
	            $state.go('checkout.genericError', {
	                code: encoded
	            });
	        };
	    }
	
	    function route(path) {
	        return function () {
	            $state.go(path, { message: arguments[0] });
	        };
	    }
	
	    function forbidden(err) {
	        throw new $Forbidden(err);
	    }
	
	    function fallback(product) {
	        return function (err) {
	            throw new $FallbackError({
	                reason: err,
	                product: product
	            });
	        };
	    }
	
	    function addMissingTokens(urlQuery) {
	        var payload = {
	            'token': $rootScope.token || $meta.token
	        };
	        if ($meta.baToken) {
	            payload.ba_token = $meta.baToken;
	        }
	        return $util.queryStringSplice(urlQuery, payload);
	    }
	
	    function handleStepupAuth(code, authModel, step_up_context) {
	        authModel.stepupAuthRequired = true;
	
	        var reasons = {
	            VERIFY_USER_IDENTITY: 'step_up_auth_needed',
	            PAYER_AUTHENTICATION_REQUIRED: 'login_required'
	        };
	
	        if (authModel.remembered) {
	            $logger.debug('PLANNING_STEP_UP_REMEBERED_USER');
	            authModel.action('logout').then(function () {
	                $state.go('checkout.login', {
	                    targetPage: 'ONETOUCH_GENERIC_ERROR',
	                    source: 'FRESH_START'
	                });
	            });
	        } else if (step_up_context && !_angular2['default'].isObject(step_up_context)) {
	            $logger.debug('PLANNING_STEP_UP_LOGIN_USER_TEST_TRAFFIC');
	
	            var authChallengeNodeUrl = $config.urls.authChallengeNodeUrl;
	
	            if ($config.deploy.isLocal() || $config.deploy.isStage()) {
	                var hostname = $meta.stage ? $meta.stage : $location.host();
	                authChallengeNodeUrl = authChallengeNodeUrl.replace('www.paypal.com', hostname);
	            }
	
	            authChallengeNodeUrl = $util.buildURL(authChallengeNodeUrl, {
	                stepupContext: step_up_context,
	                stsReturnUrl: $config.ulMeta.stsReturnUrl,
	                returnUri: $config.ulMeta.authChallengeReturnUri + addMissingTokens($window.location.search) + '&atoSuccess',
	                locale: $locale.lang,
	                flowId: 'xo',
	                flowContext: 'funding'
	            });
	
	            if (authChallengeNodeUrl) {
	                $util.redirect(authChallengeNodeUrl);
	            }
	        } else {
	            $logger.debug('PLANNING_STEP_UP_LOGIN_USER_CONTROL_TRAFFIC');
	            throw new $FallbackError({
	                reason: reasons[code],
	                product: 'ux'
	            });
	        }
	    }
	
	    function handleMerchantBANocards(contingency) {
	        var FALL_BACK_LIST = ['INSTANT_FUNDING_SOURCE_UPSELL_NEEDED', 'ELV_DECLINE', 'NEED_CREDIT_CARD', 'NEED_CONFIRMED_CARD', 'NEED_AUTHENTICATED_CARD', 'NEED_CREDIT_CARD_OR_BANK_ACCOUNT', 'EXPIRED_CREDIT_CARD'];
	
	        if (FALL_BACK_LIST.indexOf(contingency.message) !== -1) {
	            var models = {};
	
	            return $populate(models, {
	                checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                payee: $CheckoutPayeeModel.instance($rootScope.token)
	            }).then(function () {
	                return $pxp('xo_hermes_ba_nocards', { 'uid': models.payee.merchant.id }, 'xo_hermesnode_ba_nocards_whitelist_treatment').then(function (result) {
	                    if (result && models.checkoutCart.isBilling()) {
	                        $logger.info('ba_nocard_contingency_triggered');
	                        throw new $FallbackError({
	                            reason: 'fallback_merchant_BA_nocards',
	                            product: 'ux'
	                        });
	                    } else {
	                        return $q.when();
	                    }
	                });
	            });
	        } else {
	            return $q.when();
	        }
	    }
	
	    return function (contingency) {
	
	        // Leave a footprint here. The subsequent state where log how it goes..
	        $logger.warn('contingency_handler', contingency);
	
	        return handleMerchantBANocards(contingency).then(function () {
	
	            return contingency.handle({
	                // Route
	                ECONSENT_REQUIRED: route('checkout.econsent'),
	                TRAVEL_RULE_ID_REQUIRED: route('checkout.travelRule'),
	                INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: route('checkout.pageAddCardMeft.addCardFlow.addCard'),
	                ELV_DECLINE: route('checkout.pageAddCard.addCardFlow.addCard'),
	                NEED_CREDIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
	                NEED_CONFIRMED_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
	                NEED_AUTHENTICATED_CARD: route('checkout.updateCard.addCardFlow.addCard'),
	                NEED_CREDIT_CARD_OR_BANK_ACCOUNT: route('checkout.pageAddFi.bank.add'),
	                EXPIRED_CREDIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),
	                NEGATIVE_BALANCE_RECOVERY: route('checkout.negativeBalanceRecovery'),
	                PHONE_NUMBER_REQUIRED: route('checkout.addPhone'),
	                SEPA_MANDATE_ACCEPTANCE_NEEDED: route('checkout.review'),
	                TAX_ID_REQUIRED: route('checkout.addTaxId'),
	                NEED_SHIPPING_ADDRESS: route('checkout.pageAddShipping.addShipping'),
	
	                NEED_DEBIT_CARD: route('checkout.pageAddCard.addCardFlow.addCard'),
	                EXPIRED_DEBIT_CARD: route('checkout.updateCard.addCardFlow.addCard'),
	
	                PAYER_AUTHENTICATION_REQUIRED: function PAYER_AUTHENTICATION_REQUIRED() {
	                    $state.go('checkout.login', {
	                        targetPage: 'PAYER_AUTHENTICATION_REQUIRED'
	                    });
	                },
	
	                // Generic Error Pages
	                RESTRICTED_USER: showGenericError('RESTRICTED_USER'),
	                PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
	                PAYMENT_ALREADY_DONE: showGenericError('PAYMENT_ALREADY_DONE'),
	                DUPLICATE_INVOICE_ID: showGenericError('DUPLICATE_INVOICE_ID'),
	                PAYMENT_DENIED: showGenericError('PAYMENT_DENIED'),
	                PAYEE_ACCOUNT_RESTRICTED: showGenericError('RESTRICTED_USER'),
	                INVALID_RESOURCE_ID: showGenericError('INVALID_RESOURCE_ID'),
	                EXPIRED_SESSION: showGenericError('EXPIRED_SESSION'),
	                PAYER_CANNOT_PAY: showGenericError('PAYER_CANNOT_PAY'),
	                PAYER_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_COUNTRY_NOT_ALLOWED'),
	                PAYER_COUNTRY_NOT_ENABLED: showGenericError('PAYER_COUNTRY_NOT_ENABLED'),
	                PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError('PAYER_LOGIN_COUNTRY_NOT_ALLOWED'),
	                GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError('GAMING_FUNDING_SOURCE_VALIDATION_FAILED'),
	                COMPLIANCE_VIOLATION: showGenericError('COMPLIANCE_VIOLATION'),
	                DOMESTIC_TRANSACTION_REQUIRED: showGenericError('DOMESTIC_TRANSACTION_REQUIRED'),
	                INTERNAL_SERVICE_ERROR: showGenericError('TRANSACTION_REFUSED'),
	                NEGATIVE_BALANCE_TRANSACTION_REFUSED: showGenericError('NEGATIVE_BALANCE_TRANSACTION_REFUSED'),
	                ACCOUNT_CANNOT_BE_FETCHED: showGenericError('ACCOUNT_CANNOT_BE_FETCHED'),
	                BAD_RESPONSE: showGenericError('DEFAULT'),
	                TRANSACTION_REFUSED_LEGACY_FALLBACK: showGenericError('TRANSACTION_REFUSED'),
	                RISK_DENIED: showGenericError('TRANSACTION_REFUSED'),
	                UNSUPPORTED_COUNTRY: showGenericError('UNSUPPORTED_COUNTRY'),
	                // Non-specific errors - update with proper content ASAP
	                AGREEMENT_ALREADY_CREATED: showGenericError('DEFAULT'),
	                PAYMENT_NOT_APPROVED_FOR_EXECUTION: showGenericError('DEFAULT'),
	                PAYER_ACCOUNT_LOCKED_OR_CLOSED: showGenericError('DEFAULT'),
	
	                // This could be a generic error or fallback, depending on the country feature.
	                UNSUPPORTED_PAYEE_CURRENCY: $feature('unsupportedPayeeCurrency') ? showGenericError('UNSUPPORTED_PAYEE_CURRENCY') : fallback('ux'),
	
	                // Fallbacks
	                SENDING_LIMIT_EXCEEDED: fallback('ux'),
	                PAYMENT_CANNOT_BE_INITIATED: fallback('ux'),
	                PERMISSION_DENIED: fallback('ux'),
	                INVALID_TOKEN: fallback('ux'),
	                INVALID_FUNDING_OPTION: fallback('ux'),
	                VALIDATION_ERROR: fallback('ux'),
	                SHIPPING_ADDRESS_INVALID: fallback('ux'),
	                INVALID_ARGUMENT: fallback('ux'),
	                CREDIT_PAYMENT_NOT_ALLOWED: fallback('ux'),
	                PAYEE_ACCOUNT_LOCKED_OR_CLOSED: fallback('ux'),
	                MALFORMED_REQUEST: fallback('ux'),
	                TWOFA_INACTIVE: fallback('ux'),
	                ERROR: fallback('ux'),
	                ISSUER_DECLINE: fallback('ux'),
	                UNSUPPORTED_CUP_SECURECARD: fallback('ux'),
	
	                // Forbidden
	
	                BUYER_NOT_SET: forbidden,
	
	                // Other
	
	                TRANSACTION_REFUSED: function TRANSACTION_REFUSED(message, data) {
	                    var clearedRT = data.clearedRT;
	
	                    if (clearedRT) {
	                        $logger.info('checkout_fpti', {
	                            from: 'CONTINGENCY',
	                            to: 'process_fallback',
	                            routing_reason: 'TRANSACTION_REFUSED'
	                        });
	                    }
	
	                    // always go to generic error page, even if logout fails
	                    $AuthModel.instance().action('logout')['finally'](showGenericError('TRANSACTION_REFUSED'));
	                },
	
	                PAYER_INVALID_FOR_PAYMENT: function PAYER_INVALID_FOR_PAYMENT() {
	                    // Payer is not same payer checkout session was created for.
	                    return $AuthModel.instance().action('logout')['finally'](function () {
	                        $AuthModel.instance().invalidate();
	
	                        return $state.go('checkout.login', {}, {
	                            reload: true
	                        });
	                    });
	                },
	
	                CANNOT_PAY_SELF: function CANNOT_PAY_SELF() {
	                    $AuthModel.instance().meta.selfPay = true;
	                    $rootScope.contingency = {};
	                    $rootScope.contingency.message = 'CANNOT_PAY_SELF';
	
	                    return $state.go($state.current, {}, {
	                        reload: true
	                    });
	                },
	
	                VERIFY_USER_IDENTITY: function VERIFY_USER_IDENTITY(message, data) {
	                    var clearedRT = data.clearedRT;
	
	                    if (clearedRT) {
	                        $logger.info('checkout_fpti', {
	                            from: 'CONTINGENCY',
	                            to: 'process_fallback',
	                            routing_reason: 'VERIFY_USER_IDENTITY'
	                        });
	                    }
	
	                    return handleStepupAuth('VERIFY_USER_IDENTITY', $AuthModel.instance(), data.step_up_context);
	                },
	
	                LOGIN_CONTINGENCY: function LOGIN_CONTINGENCY() {
	                    if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
	                        return _miniBrowser.$miniBrowser.frameBust($rootScope.token);
	                    }
	
	                    return fallback('ux');
	                },
	
	                DEFAULT: function logUnhandledContingency() {
	                    $logger.warn('ui_unhandled_contingency_' + this.message);
	                    throw new $FallbackError({
	                        reason: 'unhandled_contingency',
	                        product: 'ux'
	                    });
	                }
	            });
	        });
	    };
	});
	
	_miniBrowser.$miniBrowser;
	
	_integration.$integration;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/contingency.js"))

/***/ },

/***/ "./js/lib/miniBrowser.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$miniBrowser = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _util = __webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	var _error = __webpack_require__("./js/lib/error.js");
	
	var _$stateGo = _uiRouter.$state.go;
	
	_uiRouter.$state.go = function (name) {
	    var _this = this;
	
	    if (!window.xchild) {
	        return _$stateGo.apply(this, arguments);
	    }
	
	    var state = _uiRouter.$state.get(name);
	
	    if (!state.loginRequired) {
	        return _$stateGo.apply(this, arguments);
	    }
	
	    // If we're allowed to collect data in this integration, we don't need this functionality
	    if (_integration.$integration.getConfig('ALLOW_COLLECT_DATA')) {
	        return _$stateGo.apply(this, arguments);
	    }
	
	    var forceIframe = window.paypal && window.paypal.forceIframe && window.paypal.forceIframe();
	    if (forceIframe) {
	        return _$stateGo.apply(this, arguments);
	    }
	
	    // First check our integration supports falling back to a popup
	    if (!_integration.$integration.getConfig('CAN_FALLBACK_TO_POPUP')) {
	        throw _integration.$integration.error('Can not fallback to popup for data collection');
	    }
	
	    window.xchild.hide();
	
	    var url = window.location.href.split('#')[0] + '#/' + state.name.replace(/\./g, '/');
	
	    var xprops = _extends({}, window.xprops);
	
	    xprops.url = url;
	
	    window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops)['catch'](function (err) {
	
	        if (window.ppxo.PopupOpenError && err instanceof window.ppxo.PopupOpenError) {
	            window.xchild.show();
	
	            _logger.$logger.warn('framebust_from_' + name.replace(/[^a-zA-Z0-9]+/g, '_'));
	
	            return _$stateGo.call(_this, 'checkout.framebust', { action: 'open', url: url });
	        }
	
	        (0, _error.$exceptionHandler)(err);
	    });
	};
	
	var $miniBrowser = exports.$miniBrowser = {
	
	    flags: {},
	    config: {},
	
	    isMiniBrowser: function isMiniBrowser() {
	        return window.name && window.name.indexOf('PPFrame') === 0 && _squid.$util.isPopup() || _squid.$util.param('incontext') === '1' || window.xchild && _squid.$util.isPopup();
	    },
	
	    isFramed: function isFramed() {
	        return _squid.$util.isIFrame();
	    },
	
	    getPartnerIntegration: function getPartnerIntegration(token) {
	        return _squid.$promise.call(function () {
	
	            if (window.name === 'PPFrameRedirect' || _squid.$util.param('nolegacy') === '1') {
	                return true;
	            }
	
	            return _checkout.$CheckoutCartModel.instance(token).retrieve().then(function (cart) {
	                return Boolean(cart.partnerIntegration);
	            });
	        });
	    },
	
	    getNativeCheckoutIntegration: function getNativeCheckoutIntegration(token) {
	        return _squid.$promise.call(function () {
	
	            if (_squid.$util.param('native_xo') === '1') {
	                return true;
	            }
	
	            return false;
	        });
	    },
	
	    getMessengerBAIntegration: function getMessengerBAIntegration(token) {
	        return _squid.$promise.call(function () {
	
	            if (_squid.$util.param('messenger_ba') === '1') {
	                _logger.$logger.info('getMessengerBAIntegration == true');
	                return true;
	            }
	
	            return false;
	        });
	    },
	
	    getDirectIntegration: function getDirectIntegration(token) {
	        return _squid.$promise.call(function () {
	
	            if (_squid.$util.param('incontext')) {
	                return true;
	            }
	
	            if (this.isMiniBrowser() || this.isFramed()) {
	                return true;
	            }
	
	            if (window.location.pathname.indexOf('/checkoutnow') > -1 || window.location.pathname.indexOf('/webapps/hermes') > -1) {
	                return true;
	            }
	
	            return this.getPartnerIntegration(token);
	        }.bind(this));
	    },
	
	    getWPSIntegration: function getWPSIntegration(token) {
	        return _checkout.$CheckoutAppDataModel.instance(token).retrieve().then(function (appData) {
	            var isWPS = appData.doec_on_approve();
	
	            // TODO: remove these, we should not use $rootScope
	            _angular.$rootScope.invoice = appData.flags.is_invoice_flow;
	            _angular.$rootScope.wps = isWPS;
	
	            if (isWPS) {
	                _logger.$logger.info('hermes_wps_flow', {
	                    token: _angular.$rootScope.token
	                });
	            } else {
	                _logger.$logger.info('hermes_xo_order_flow', {
	                    token: _angular.$rootScope.token
	                });
	            }
	            return isWPS;
	        });
	    },
	
	    getFlags: function getFlags(token) {
	        _logger.$logger.info('miniBrowser_getFlags');
	        return _squid.$promise.hash({
	            isMiniBrowser: this.isMiniBrowser(),
	            isFramed: this.isFramed(),
	            isPartnerIntegration: this.getPartnerIntegration(token),
	            isDirectIntegration: this.getDirectIntegration(token),
	            isNativeCheckout: this.getNativeCheckoutIntegration(token),
	            isMessengerBAIntegration: this.getMessengerBAIntegration(token),
	            isWPSIntegration: this.getWPSIntegration(token)
	        }).then(function (flags) {
	
	            // TODO: Remove these, we should not use $rootScope
	            _angular.$rootScope.miniBrowser = flags.isMiniBrowser;
	            _angular.$rootScope.partnerIntegration = flags.isPartnerIntegration;
	
	            if (flags.isPartnerIntegration && !window.xchild) {
	                _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
	            } else if (flags.isFramed) {
	                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_LIGHTBOX);
	                if (flags.isMessengerBAIntegration) {
	                    _integration.$integration.setFlow(_integration.$FLOWS.MESSENGER_BA_INTEGRATION);
	                    _logger.$logger.info('$integration.setFlow($FLOWS.MESSENGER_BA_INTEGRATION)');
	                }
	            } else if (flags.isMiniBrowser) {
	                _integration.$integration.setFlow(_integration.$FLOWS.INCONTEXT_POPUP);
	            } else if (flags.isNativeCheckout) {
	                _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
	            } else if (flags.isWPSIntegration) {
	                _integration.$integration.setFlow(_integration.$FLOWS.WPS);
	            } else {
	                _integration.$integration.setFlow(_integration.$FLOWS.CHECKOUT);
	            }
	
	            return flags;
	        });
	    },
	
	    init: function init(token) {
	        var _this2 = this;
	
	        _logger.$logger.info('miniBrowser_init');
	        return _squid.$promise.sequential([function () {
	            return _this2.enableAutoResize();
	        }, function () {
	            return _this2.getFlags(token);
	        }, function () {
	            return _this2.logIntegration(token);
	        }, function () {
	            return _this2.sendPostMessage(token);
	        }, function () {
	            return _this2.handleWindowOpenerClose();
	        }]);
	    },
	
	    enableAutoResize: function enableAutoResize() {
	        _angular.$rootScope.$on('allLoaded', function () {
	            if (window.xchild && window.xchild.enableAutoResize) {
	                window.xchild.enableAutoResize();
	            }
	        });
	    },
	
	    logIntegration: function logIntegration(token) {
	        _logger.$logger.info('miniBrowser_logIntegration');
	        return this.getFlags(token).then(function (flags) {
	
	            var match = window.name.match(/PPFrame(\w+)/);
	            var guid = match && match[1];
	
	            if (guid) {
	                _logger.$logger.info('integration_guid', {
	                    guid: guid
	                });
	            }
	
	            if (window.xchild || guid) {
	                var beacon = new Image();
	                beacon.src = '/webapps/hermes/api/logger?event=ppxo_uid_token&uid=' + (window.xprops ? window.xprops.uid : guid) + '&token=' + token;
	            }
	
	            _logger.$logger.info(flags.isMiniBrowser ? 'minibrowser_flow' : 'non_minibrowser_flow');
	            _logger.$logger.info(flags.isFramed ? 'framed_flow' : 'non_framed_flow');
	            _logger.$logger.info(flags.isDirectIntegration ? 'direct_integration_flow' : 'non_direct_integration_flow');
	            _logger.$logger.info(flags.isPartnerIntegration ? 'partner_integration_flow' : 'non_partner_integration_flow');
	        });
	    },
	
	    handleWindowOpenerClose: function handleWindowOpenerClose() {
	        _logger.$logger.info('miniBrowser_handleWindowOpenerClose');
	        if (_integration.$integration.isContext(_integration.$CONTEXT.POPUP)) {
	            var interval = setInterval(function () {
	                try {
	                    if (!window.opener || window.opener.closed) {
	                        clearInterval(interval);
	                        _logger.$logger.info('window_opener_closed');
	                        // TODO: close this window if opener closed?
	                    }
	                } catch (err) {
	                    // pass
	                }
	            }, 50);
	        }
	    },
	
	
	    sendPostMessage: function sendPostMessage(token) {
	
	        if (window.xchild) {
	            return;
	        }
	
	        return _squid.$promise.hash({
	
	            isPartnerIntegration: this.getPartnerIntegration(token),
	            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token).retrieve()
	
	        }).then(function (data) {
	
	            if (!_integration.$integration.getConfig('POST_MESSAGE_PARENT')) {
	                return;
	            }
	
	            var msg = void 0;
	
	            try {
	                msg = {
	                    operation: 'init',
	                    cancelUrl: data.checkoutAppData.urls.cancel_url,
	                    landingUrl: window.location.href,
	                    secureWindowmsg: _squid.$locale.content.scripts.secureWindowmsg
	                };
	            } catch (err) {
	                return _logger.$logger.error('minibrowser_msg_construction_failed', {
	                    error: err
	                });
	            }
	
	            if (!_util.$ReturnToMerchant.postToMerchant(msg)) {
	                _logger.$logger.error('minibrowser_post_failed');
	            }
	        });
	    },
	
	    frameBust: function frameBust(token) {
	
	        return _squid.$promise.hash({
	            isFramed: this.isFramed()
	        }).then(function (flags) {
	
	            if (flags.isFramed) {
	                _logger.$logger.info('frame_bust');
	                _squid.$util.redirect(window.location.href);
	            }
	        });
	    }
	};
	
	angular.value("$miniBrowser", $miniBrowser);
	_angular.$rootScope;
	
	_logger.$logger;
	
	_squid.$promise;
	
	_squid.$util;
	
	_squid.$locale;
	
	_uiRouter.$state;
	
	_checkout.$CheckoutAppDataModel;
	
	_checkout.$CheckoutCartModel;
	
	_util.$ReturnToMerchant;
	
	_integration.$integration;
	
	_integration.$FLOWS;
	
	_integration.$CONTEXT;
	
	_error.$exceptionHandler;

/***/ },

/***/ "./js/lib/metaBuilder.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$metaBuilder = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _model = __webpack_require__("./components/xo-tracking/dist/model.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function buildMeta() {
	    return {
	        token: _angular.$rootScope.token || _squid.$config.token || _squid.$meta.token || _squid.$util.param('token'),
	        calc: _model.$CalDataModel.getCalCorrId(),
	        csci: _model.$CalDataModel.getUUID(),
	        locale: {
	            country: _squid.$locale && _squid.$locale.country,
	            language: _squid.$locale && _squid.$locale.lang
	        },
	        state: 'ui_' + (_angular.$rootScope.currentState || 'checkout_init'),
	        app_name: 'hermesnodeweb',
	        baToken: _squid.$meta.baToken
	    };
	}
	
	function buildContext() {
	    return {
	        locale: {
	            country: _squid.$locale && _squid.$locale.country,
	            language: _squid.$locale && _squid.$locale.lang
	        }
	    };
	}
	
	_squid.$Api.registerMetaBuilder(buildMeta);
	
	var $metaBuilder = exports.$metaBuilder = {
	    build: buildMeta,
	    buildContext: buildContext
	};
	
	angular.value("$metaBuilder", $metaBuilder);
	_angular.$rootScope;
	
	_model.$CalDataModel;
	
	_squid.$util;
	
	_squid.$meta;
	
	_squid.$Api;
	
	_squid.$locale;
	
	_squid.$config;

/***/ },

/***/ "./components/xo-tracking/dist/model.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/node-uuid/uuid.js") // Using the same module as used in NodeInfra
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, uuid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.model', ['squid']).constant('$FptiConstants', {
	        // The prototype of buzname data object
	        buznameMap: {
	            country: {
	                placeHolder: 'glb',
	                fptiKey: 'ccpg'
	            },
	
	            flowgatename: {
	                placeHolder: '',
	                fptiKey: 'fltp'
	            },
	
	            'flowname': {
	                placeHolder: 'ec:hermes:',
	                fptiKey: 'flnm'
	            },
	            'hier1': {
	                placeHolder: 'main_ec_hermes_',
	                fptiKey: 'shir'
	            },
	            /*
	             * No key defined in FPTI
	             */
	            //            'hier2': '',
	            //            'hier3': '',
	            //            'hier4': '',
	            //            'hier5': '',
	            'inout': {
	                placeHolder: 'inout',
	                fptiKey: 'lgin'
	            },
	            'pagename': {
	                placeHolder: 'main:ec:hermes',
	                fptiKey: 'pgrp'
	            },
	            'pagename2': {
	                placeHolder: 'main:ec:hermes',
	                fptiKey: 'page'
	            },
	            'version': {
	                placeHolder: 'hermes',
	                fptiKey: 'vers'
	            }
	            /*
	             * Deprecated SiteCatalyst keys
	             */
	            //            'feature': 'ec',
	            //            'oldpagename': '',
	            //            'product': ';ec',
	            //            'subfeature1': 'hermes',
	            //            'subfeature2': '',
	            //            'website': 'main'
	        },
	
	        // Full list of FPTI keys indexed by readable names
	        // This mapping can also be served as default decorator
	        fptiKeys: {
	            'businessType': 'bztp',
	            'correlationId': 'calc', // CalDataModel
	            'countryOfPage': 'ccpg', // buzname
	            'cust': 'cust',
	            'errorCode': 'eccd',
	            'fieldError': 'erfd',
	            'flowgatename': 'fltp', // buzname
	            'flowname': 'flnm', // buzname
	            'locale': 'rsta', // LocaleModel
	            'loggedIn': 'lgin', // buzname
	            'merchantId': 'mrid',
	            'merchantType': 'mbtp',
	            'pageError': 'erpg',
	            'pageGoal': 'goal', // route
	            'pageGroup': 'pgrp', // buzname
	            'pageName': 'page', // buzname
	            'pageQualifer': 'qual', // buzname
	            'pageStartTime': 'pgst', // FptiBuilder
	            'pageTechnologyFlag': 'pgtf', // productConfig
	            'paymentFlowId': 'pfid',
	            'rLogId': 'teal',
	            'sessionId': 'fpti',
	            'siteHierarchy': 'shir', // buzname
	            'sourceCi': 's', // productConfig
	            'tealeaf': 'teal',
	            'templateName': 'tmpl', // route
	            'transition_time': 'transition_time',
	            'uuid': 'csci', // CalDataModel
	            'version': 'vers', // buzname
	            'visitorId': 'vid',
	            'ecToken': 'fltk', // metadata
	            'pxpExpSelected': 'xe',
	            'pxpTreatementSelected': 'xt',
	            'pxpQualifiedTreatment': 'qt',
	            'pxpContextId': 'qc',
	            'dc': 'dc',
	            'az': 'az',
	            'comp': 'comp'
	        },
	
	        landing_page: {
	            login: 'LOGIN',
	            econsent: 'eConsent',
	            review: 'Review',
	            error_page: 'error_page',
	            add_card: 'add_card',
	            add_bank: 'add_bank',
	            billing: 'billing',
	            done_page: 'done_page',
	            shoppingCart: 'shoppingCart',
	            emptyCart: 'emptyCart',
	            soldout: 'soldout',
	            openButton: 'openButton'
	        },
	
	        stateName: {
	            checkout_login: 'login',
	            checkout_genericError: 'error_page',
	            checkout_fastlogin: 'login',
	            checkout_econsent: 'econsent',
	            checkout_review: 'review',
	            checkout_pageAddCard_addCardFlow_addCard: 'add_card',
	            checkout_updateCard_addCardFlow_addCard: 'add_card',
	            checkout_pageAddFi_bank_add: 'add_bank',
	            guest: 'billing',
	            checkout_done: 'done_page',
	            checkout_guest: 'billing',
	            checkout_signup: 'billing',
	            guestupgrade_genericError: 'error_page',
	            checkout_multistepsignup_multistepsignupaddcard: 'billing',
	            checkout_shoppingCart: 'shoppingCart',
	            checkout_emptyCart: 'emptyCart',
	            checkout_soldout: 'soldout',
	            checkout_openButton: 'openButton'
	        }
	    }).factory('$FptiDataModel', function ($Class, $FptiConstants, $util, $config) {
	        var productConfig = {};
	        // TODO to read from config.json
	        productConfig[$FptiConstants.fptiKeys.sourceCi] = 'ci';
	        productConfig[$FptiConstants.fptiKeys.pageTechnologyFlag] = 'NodeJS';
	
	        /**
	         * Utilizing Decorator pattern to allow defining additional logic for specific keys
	         */
	        return $Class.extend('FptiDataModel', {
	            init: function init() {
	                this._dataObj = angular.extend({}, productConfig);
	                this._decoratorList = [];
	            },
	            decorators: {
	                buzname: function buzname(trackingData, pageQualifier, isInContext, productOverride) {
	
	                    if (!trackingData) {
	                        return;
	                    }
	
	                    var buzname = trackingData.buzname;
	                    if (!buzname) {
	                        return;
	                    }
	
	                    var buznameDiff = buzname[pageQualifier];
	                    if (!buznameDiff) {
	                        return;
	                    }
	
	                    var dataObj = this._dataObj;
	                    var buznameMap = $FptiConstants.buznameMap;
	                    // read app specific place holder from config
	                    var placeHolderConfig = $config && $config.fpti && $config.fpti.buznameEntryPlaceHolder;
	
	                    Object.keys(buznameMap).forEach(function (key) {
	                        var buznameEntry = buznameMap[key];
	                        var fptiKey = buznameEntry.fptiKey;
	                        var placeHolder = buznameEntry.placeHolder;
	
	                        if (buznameDiff[key]) {
	                            if (placeHolderConfig && placeHolderConfig[key]) {
	                                placeHolder = placeHolderConfig[key];
	                            }
	
	                            if (productOverride) {
	                                var _placeHolder$split = placeHolder.split(':'),
	                                    main = _placeHolder$split[0],
	                                    hermes = _placeHolder$split[2];
	
	                                placeHolder = main + ':' + productOverride + ':' + hermes;
	                            }
	
	                            dataObj[fptiKey] = buznameDiff[key].replace('%', placeHolder);
	                        } else {
	                            dataObj[fptiKey] = placeHolder;
	                        }
	                    });
	                    dataObj[$FptiConstants.fptiKeys.pageQualifer] = pageQualifier;
	                },
	
	                locale: function locale(_locale) {
	                    if (_locale && _locale.country) {
	                        this._dataObj[$FptiConstants.fptiKeys.locale] = _locale.country;
	                    }
	                },
	
	                pxptrackingdata: function pxptrackingdata(pxpData) {
	                    var qt = [];
	                    var qc = [];
	                    var xe = [];
	                    var xt = [];
	                    $util.some(pxpData, function (trackInfo) {
	                        var match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqt=([^;]+);');
	                        if (match) {
	                            qt.push(match[1]);
	                        }
	
	                        match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqc=([^;]+);');
	                        if (match) {
	                            qc.push(match[1]);
	                        }
	
	                        $util.some(trackInfo.treatments, function (treatment) {
	                            xe.push(treatment.experiment_id);
	                            xt.push(treatment.treatment_id);
	                        });
	                    });
	
	                    this._dataObj[$FptiConstants.fptiKeys.pxpQualifiedTreatment] = qt.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpContextId] = qc.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpExpSelected] = xe.join(',');
	                    this._dataObj[$FptiConstants.fptiKeys.pxpTreatementSelected] = xt.join(',');
	                },
	
	                templateName: function templateName(trackingData, pageQualifier, isInContext) {
	                    if (trackingData && trackingData.templateName) {
	                        var templateName = (trackingData.templateName || '') + (pageQualifier ? ':' + pageQualifier : '');
	
	                        this._dataObj[$FptiConstants.fptiKeys.templateName] = templateName;
	                    }
	                },
	
	                fieldError: function fieldError(err) {
	                    if (err && err.type === 'fieldError') {
	                        this._dataObj[$FptiConstants.fptiKeys.fieldError] = err.field;
	                        this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
	                    }
	                },
	
	                pageError: function pageError(err) {
	                    if (err && err.type === 'pageError') {
	
	                        this._dataObj[$FptiConstants.fptiKeys.pageError] = err.msg;
	                        this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
	                    }
	                }
	
	            },
	            decorate: function decorate(name) {
	                this._decoratorList.push({
	                    name: name,
	                    params: Array.prototype.slice.call(arguments, 1)
	                });
	                return this;
	            },
	            getDataObject: function getDataObject(isInContext) {
	                var i;
	                var decorator;
	
	                for (i = 0; i < this._decoratorList.length; i++) {
	                    decorator = this._decoratorList[i];
	                    if (!decorator) {
	                        continue;
	                    }
	                    var name = decorator.name;
	                    var params = decorator.params;
	                    if (angular.isFunction(this.decorators[name])) {
	                        // Invoke the decorator and pass in the parameter list
	                        this.decorators[name].apply(this, params);
	                    } else {
	                        var fptiKey = $FptiConstants.fptiKeys[name];
	                        // If the fptiKey is defined and value is present, add the k-v pair
	                        if (fptiKey && params && params.length > 0) {
	                            this._dataObj[fptiKey] = params[0];
	                        }
	                    }
	                }
	
	                // 'fullpage' was widely used as default key in page routs definition
	                // finally replace it here if it's incontext
	                var dataObj = this._dataObj;
	                if (isInContext) {
	                    Object.keys(dataObj).forEach(function (k) {
	                        if (angular.isString(dataObj[k])) {
	                            // some values can be number
	                            dataObj[k] = dataObj[k].replace('fullpage', 'incontext');
	                        }
	                    });
	                }
	
	                return this._dataObj;
	            }
	        });
	    }).factory('$CalDataModel', function ($Model) {
	
	        var uuid_v4_mask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
	        var uuid_v1_mask = 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX';
	
	        function _generateCorrelationId() {
	            var uidRandomArr = (uuid.v4() || uuid_v4_mask).split('-');
	            var uidTime = (uuid.v1() || uuid_v1_mask).split('-');
	            return uidTime[0] + uidRandomArr[0].substr(0, 5);
	        }
	
	        function _generateUUID() {
	            return (uuid.v4() || uuid_v4_mask).replace(/-/g, '');
	        }
	
	        var CalModel = $Model.extend({
	            _calCorrId: _generateCorrelationId(),
	            _uuid: _generateUUID(),
	
	            generateCalCorrId: function generateCalCorrId() {
	                this._calCorrId = _generateCorrelationId();
	            },
	            generateUUID: function generateUUID() {
	                this._uuid = _generateUUID();
	            },
	            generateMetaIds: function generateMetaIds() {
	                this.generateCalCorrId();
	                this.generateUUID();
	            },
	
	            getCalCorrId: function getCalCorrId() {
	                return this._calCorrId;
	            },
	
	            getUUID: function getUUID() {
	                return this._uuid;
	            }
	        });
	
	        return new CalModel();
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/model.js"))

/***/ },

/***/ "./components/node-uuid/uuid.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(console) {
	
	//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php
	
	/*global window, require, define */
	(function (_window) {
	  
	
	  // Unique ID creation requires a high quality random # generator.  We feature
	  // detect to determine the best RNG source, normalizing to a function that
	  // returns 128-bits of randomness, since that's what's usually required
	
	  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;
	
	  function setupBrowser() {
	    // Allow for MSIE11 msCrypto
	    var _crypto = _window.crypto || _window.msCrypto;
	
	    if (!_rng && _crypto && _crypto.getRandomValues) {
	      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	      //
	      // Moderately fast, high quality
	      try {
	        var _rnds8 = new Uint8Array(16);
	        _whatwgRNG = _rng = function whatwgRNG() {
	          _crypto.getRandomValues(_rnds8);
	          return _rnds8;
	        };
	        _rng();
	      } catch (e) {}
	    }
	
	    if (!_rng) {
	      // Math.random()-based (RNG)
	      //
	      // If all else fails, use Math.random().  It's fast, but is of unspecified
	      // quality.
	      var _rnds = new Array(16);
	      _mathRNG = _rng = function _rng() {
	        for (var i = 0, r; i < 16; i++) {
	          if ((i & 0x03) === 0) {
	            r = Math.random() * 0x100000000;
	          }
	          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	        }
	
	        return _rnds;
	      };
	      if ('undefined' !== typeof console && console.warn) {
	        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
	      }
	    }
	  }
	
	  function setupNode() {
	    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
	    //
	    // Moderately fast, high quality
	    if (true) {
	      try {
	        var _rb = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"crypto\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())).randomBytes;
	        _nodeRNG = _rng = _rb && function () {
	          return _rb(16);
	        };
	        _rng();
	      } catch (e) {}
	    }
	  }
	
	  if (_window) {
	    setupBrowser();
	  } else {
	    setupNode();
	  }
	
	  // Buffer class to use
	  var BufferClass = 'function' === typeof Buffer ? Buffer : Array;
	
	  // Maps for number <-> hex string conversion
	  var _byteToHex = [];
	  var _hexToByte = {};
	  for (var i = 0; i < 256; i++) {
	    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	    _hexToByte[_byteToHex[i]] = i;
	  }
	
	  // **`parse()` - Parse a UUID into it's component bytes**
	  function parse(s, buf, offset) {
	    var i = buf && offset || 0,
	        ii = 0;
	
	    buf = buf || [];
	    s.toLowerCase().replace(/[0-9a-f]{2}/g, function (oct) {
	      if (ii < 16) {
	        // Don't overflow!
	        buf[i + ii++] = _hexToByte[oct];
	      }
	    });
	
	    // Zero out remaining bytes if string was short
	    while (ii < 16) {
	      buf[i + ii++] = 0;
	    }
	
	    return buf;
	  }
	
	  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	  function unparse(buf, offset) {
	    var i = offset || 0,
	        bth = _byteToHex;
	    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
	  }
	
	  // **`v1()` - Generate time-based UUID**
	  //
	  // Inspired by https://github.com/LiosK/UUID.js
	  // and http://docs.python.org/library/uuid.html
	
	  // random #'s we need to init node and clockseq
	  var _seedBytes = _rng();
	
	  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	  var _nodeId = [_seedBytes[0] | 0x01, _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]];
	
	  // Per 4.2.2, randomize (14 bit) clockseq
	  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	  // Previous uuid creation time
	  var _lastMSecs = 0,
	      _lastNSecs = 0;
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v1(options, buf, offset) {
	    var i = buf && offset || 0;
	    var b = buf || [];
	
	    options = options || {};
	
	    var clockseq = options.clockseq != null ? options.clockseq : _clockseq;
	
	    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	    var msecs = options.msecs != null ? options.msecs : new Date().getTime();
	
	    // Per 4.2.1.2, use count of uuid's generated during the current clock
	    // cycle to simulate higher resolution clock
	    var nsecs = options.nsecs != null ? options.nsecs : _lastNSecs + 1;
	
	    // Time since last uuid creation (in msecs)
	    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;
	
	    // Per 4.2.1.2, Bump clockseq on clock regression
	    if (dt < 0 && options.clockseq == null) {
	      clockseq = clockseq + 1 & 0x3fff;
	    }
	
	    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	    // time interval
	    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
	      nsecs = 0;
	    }
	
	    // Per 4.2.1.2 Throw error if too many uuids are requested
	    if (nsecs >= 10000) {
	      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	    }
	
	    _lastMSecs = msecs;
	    _lastNSecs = nsecs;
	    _clockseq = clockseq;
	
	    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	    msecs += 12219292800000;
	
	    // `time_low`
	    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	    b[i++] = tl >>> 24 & 0xff;
	    b[i++] = tl >>> 16 & 0xff;
	    b[i++] = tl >>> 8 & 0xff;
	    b[i++] = tl & 0xff;
	
	    // `time_mid`
	    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
	    b[i++] = tmh >>> 8 & 0xff;
	    b[i++] = tmh & 0xff;
	
	    // `time_high_and_version`
	    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	    b[i++] = tmh >>> 16 & 0xff;
	
	    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	    b[i++] = clockseq >>> 8 | 0x80;
	
	    // `clock_seq_low`
	    b[i++] = clockseq & 0xff;
	
	    // `node`
	    var node = options.node || _nodeId;
	    for (var n = 0; n < 6; n++) {
	      b[i + n] = node[n];
	    }
	
	    return buf ? buf : unparse(b);
	  }
	
	  // **`v4()` - Generate random UUID**
	
	  // See https://github.com/broofa/node-uuid for API details
	  function v4(options, buf, offset) {
	    // Deprecated - 'format' argument, as supported in v1.2
	    var i = buf && offset || 0;
	
	    if (typeof options === 'string') {
	      buf = options === 'binary' ? new BufferClass(16) : null;
	      options = null;
	    }
	    options = options || {};
	
	    var rnds = options.random || (options.rng || _rng)();
	
	    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	    rnds[6] = rnds[6] & 0x0f | 0x40;
	    rnds[8] = rnds[8] & 0x3f | 0x80;
	
	    // Copy bytes to buffer, if provided
	    if (buf) {
	      for (var ii = 0; ii < 16; ii++) {
	        buf[i + ii] = rnds[ii];
	      }
	    }
	
	    return buf || unparse(rnds);
	  }
	
	  // Export public API
	  var uuid = v4;
	  uuid.v1 = v1;
	  uuid.v4 = v4;
	  uuid.parse = parse;
	  uuid.unparse = unparse;
	  uuid.BufferClass = BufferClass;
	  uuid._rng = _rng;
	  uuid._mathRNG = _mathRNG;
	  uuid._nodeRNG = _nodeRNG;
	  uuid._whatwgRNG = _whatwgRNG;
	
	  if ('undefined' !== typeof module && module.exports) {
	    // Publish as node.js module
	    module.exports = uuid;
	  } else if (true) {
	    // Publish as AMD module
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return uuid;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Publish as global (in browsers)
	    _previousRoot = _window.uuid;
	
	    // **`noConflict()` - (browser only) to reset global 'uuid' var**
	    uuid.noConflict = function () {
	      _window.uuid = _previousRoot;
	      return uuid;
	    };
	
	    _window.uuid = uuid;
	  }
	})('undefined' !== typeof window ? window : null);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./js/lib/middleware.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	__webpack_require__("./js/lib/stateChangeListener.js");
	
	var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-models/src/auth/lib/xoAPayUtils.js");
	
	__webpack_require__("./components/xo-models/src/app/index.js");
	
	__webpack_require__("./components/xo-login-components/src/login/fn.js");
	
	__webpack_require__("./components/xo-device-info/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(function exportProviders(angular) {
	    angular && angular.exportProviders(module, exports, __dirname, __filename);
	})(window.angular);
	
	_angular2['default'].module().factory('$Middleware', function ($rootScope, $q, $util, $CheckoutAppDataModel, $CheckoutPayeeModel, $CheckoutCartModel, $DeviceInfo, $config, $meta, $FallbackError, $locale, $promise, $populate, $window, $timeout, $experiment, $TransactionEligibilityModel, $AuthModel, $dispatch, $logger, $pxp, $Class, $Api, $fn, $feature, $xoAPayUtils, $cookies) {
	    return [function angularDebug() {
	
	        window.root = $rootScope;
	        window.injector = _angular2['default'].element(document.body).injector();
	
	        /**
	         * Config experiment to overwrite the $apply method and use $eval instead of $apply if it would throw a digest inprog error.
	         * This is mainly to address a Firefox bug with angular digest and timeouts, where timeouts can interrupt normal execution flow under certain circumstances
	         * Bug described here: https://github.com/angular/angular.js/issues/10083
	         *
	         * Can remove as a config option if this is a stable change
	         */
	        if ($config.safeApply) {
	            $logger.info('overwriting_angular_apply');
	            var proto = Object.getPrototypeOf && Object.getPrototypeOf($rootScope);
	
	            if (!proto) {
	                $logger.warn('overwriting_angular_apply_failed', {
	                    reason: 'failed_to_get_prototype'
	                });
	            } else {
	                var originalApply = proto.$apply;
	                // If this gets used so many times, something is probably wrong so use original apply instead
	                var skipAttempts = 10;
	
	                proto.$apply = function (fn) {
	                    if (skipAttempts && ($rootScope.$$phase === '$digest' || $rootScope.$$phase === '$apply')) {
	                        skipAttempts--;
	
	                        $logger.warn('inprog_error_skipped', {
	                            stack: new Error().stack
	                        });
	
	                        this.$eval(fn);
	                    } else {
	                        originalApply.call(this, fn);
	                    }
	                };
	            }
	        }
	    }, function waitForToken() {
	        if ($util.isIFrame() && !$util.param('token') && !$meta.token) {
	            return $q(function (resolve, reject) {
	                $logger.info('await_token');
	
	                window.addEventListener('message', function (event) {
	
	                    var message = JSON.parse(event.data);
	
	                    if (message.operation !== 'pass_token') {
	                        return;
	                    }
	
	                    var token = message.token;
	
	                    $logger.info('passed_token', {
	                        token: token
	                    });
	
	                    $meta.token = token;
	
	                    var $preloadApi = new $Api({
	                        uri: 'preload'
	                    });
	
	                    $preloadApi.retrieve({
	                        params: {
	                            token: token
	                        }
	                    }).then(function (response) {
	
	                        $preloadApi.setTransientCache(response.data);
	                        resolve();
	                    })['catch'](reject);
	                }, false);
	            });
	        }
	    }, function checkToken() {
	
	        var pattern = /^EC-[0-9A-Z]{17}$/;
	        var beamPattern = /^BA-[0-9A-Z]{17}$/;
	
	        // wps token are not preceeded with 'EC-'
	        var wpsPattern = /^[0-9A-Z]{17}$/;
	
	        var urlToken = ($util.param('token') || '').trim().slice(0, 20);
	        var bodyToken = ($meta.token || '').trim().slice(0, 20);
	
	        if (urlToken && bodyToken && urlToken !== bodyToken) {
	            $logger.error('token_mismatch', {
	                server: bodyToken,
	                client: urlToken
	            });
	        }
	
	        if (pattern.test(urlToken)) {
	            $rootScope.token = urlToken;
	        } else if (pattern.test(bodyToken)) {
	            $rootScope.token = bodyToken;
	        } else if (wpsPattern.test(urlToken)) {
	            $logger.info('isWpsPattern');
	            $rootScope.token = urlToken;
	        } else if (wpsPattern.test(bodyToken)) {
	            $logger.info('isWpsPattern');
	            $rootScope.token = bodyToken;
	        } else if (beamPattern.test(urlToken)) {
	            $rootScope.token = urlToken;
	            $logger.info('cart_exchange_failed', {
	                token: $rootScope.token
	            });
	        } else if (beamPattern.test(bodyToken)) {
	            $rootScope.token = bodyToken;
	            $logger.info('cart_exchange_failed', {
	                token: $rootScope.token
	            });
	        } else {
	            return $q.reject(new $FallbackError({
	                reason: 'no_token',
	                product: 'error'
	            }));
	        }
	    }, function resolveLocale() {
	
	        var models = {};
	
	        return $populate(models, {
	            appData: $CheckoutAppDataModel.instance($rootScope.token),
	            cart: $CheckoutCartModel.instance($rootScope.token)
	        })['finally'](function () {
	            return $locale.retrieve({
	                params: {
	                    ipCountry: $meta.ipcountry,
	                    localeTestUrlParam: $util.param('locale.test'),
	                    checkoutShippingCountry: models.cart.get('purchase.shipping_address.country_code'),
	                    merchantCountry: models.appData.get('merchant.merchant_country'),
	                    checkoutSessionLocale: models.appData.get('merchant.merchant_locale'),
	                    countryParam: $util.param('country.x'),
	                    localeParam: $util.param('locale.x')
	                }
	            });
	        });
	    }, function fraudentInit() {
	        return $fn.init();
	    }, function setupIntegration() {
	        return _miniBrowser.$miniBrowser.init($rootScope.token);
	    }, function tokenExchange() {
	
	        if (!_integration.$integration.getConfig('ALLOW_ONETOUCH_TOKEN_EXCHANGE')) {
	            return;
	        }
	
	        if ($rootScope.isPartnerIntegration || !$util.isIFrame()) {
	            return;
	        }
	
	        var auth = $AuthModel.instance();
	
	        return auth.retrieve().then(function () {
	
	            if (auth.logged_in || auth.remembered || !auth.refresh_token) {
	                return;
	            }
	
	            return auth.action('onetouch');
	        });
	    }, function xcomponent() {
	
	        if (window.xchild) {
	            window.paypalCheckout = window.xchild;
	        }
	
	        if (window.xprops && window.xprops.init) {
	
	            return $promise.run(function () {
	                return $CheckoutAppDataModel.instance($rootScope.token).retrieve();
	            }).then(function (checkoutAppData) {
	
	                return window.xprops.init({
	                    paymentToken: $rootScope.token,
	                    cancelUrl: checkoutAppData.urls.cancel_url
	                });
	            });
	        }
	    }, function xcomponentAuth() {
	        if (window.xprops && window.xprops.onAuth) {
	
	            var auth = $AuthModel.instance();
	
	            return auth.retrieve().then(function () {
	
	                if (auth.access_token && (auth.logged_in || auth.remembered)) {
	                    return window.xprops.onAuth({
	                        accessToken: auth.access_token
	                    });
	                }
	            });
	        }
	    }, function logPage() {
	
	        $logger.info('href', {
	            href: window.location.href,
	            windowName: $window.name && $window.name.slice(0, 100)
	        });
	
	        var match = document.cookie.toString().match(/ectoken=([^;]+)/);
	
	        if (match && match[1] === $rootScope.token) {
	            $logger.info('returning_user_same_token');
	        } else if (match && match[1] !== $rootScope.token) {
	            $logger.info('returning_user_diff_token');
	        } else {
	            $logger.info('non_returning_user');
	        }
	
	        document.cookie = 'ectoken=' + $rootScope.token + '; expires=Fri, 31 Dec 9999 23:59:59 GMT;';
	
	        if (window.performance && window.performance.navigation && _angular2['default'].isDefined(window.performance.navigation.type)) {
	
	            var navigationType = {
	                0: 'regular',
	                1: 'reload',
	                2: 'back_forward'
	            }[window.performance.navigation.type];
	
	            if (navigationType) {
	                $logger.info('navigation_' + navigationType);
	            }
	        }
	    }, function handleTagManager() {
	        // The following section is added for AB testing
	        return $pxp('xo_hermesnode_ec_tag_manager', {
	            'ctx.COUNTRY': $locale.country
	        }, '(xo_hermesnode_ec_tag_manager_)(.*)').then(function (result) {
	            if (result) {
	                if (result.treatment_name === 'xo_hermesnode_ec_tag_manager_treatment') {
	
	                    // ****** Tag Manager Code Start Here ***********
	                    window.dataLayer = {
	                        // Two letter country code of the current page's content
	                        contentCountry: $locale.country.toLowerCase(),
	                        // Two letter locale
	                        contentLanguage: $locale.lang.toLowerCase()
	                    };
	
	                    var tagManagerUrl = $config.urls.tagProdUrl;
	
	                    // Based on the environment, Tag Manager end point can be changed.
	                    // For now the local and stage end points are same.
	                    if ($config.deploy.isLocal() || $config.deploy.isStage()) {
	                        tagManagerUrl = $config.urls.tagStageUrl;
	                    }
	
	                    // Load bootstrap.js asynchronously
	                    (function (i, s, o, g, r, a, m) {
	                        i['tagManagerObject'] = r;
	                        i[r] = i[r] || function () {
	                            (i[r].q = i[r].q || []).push(arguments);
	                        };
	                        i[r].l = 1 * new Date();
	                        a = s.createElement(o);
	                        m = s.getElementsByTagName(o)[0];
	                        a.async = 1;
	                        a.src = g;
	                        m.parentNode.insertBefore(a, m);
	                    })(window, document, 'script', tagManagerUrl, 'tagManager');
	                }
	            }
	        });
	    }, function logoutGuest() {
	        return $AuthModel.instance().retrieve().then(function (auth) {
	            if (auth.guest) {
	                $logger.info('guest_logout');
	
	                return auth.action('logout');
	            }
	        });
	    }, function checkGCEFallback() {
	
	        var appData = $CheckoutAppDataModel.instance($rootScope.token);
	        var cart = $CheckoutCartModel.instance($rootScope.token);
	        var merchantCountry = appData.get('merchant.merchant_country');
	        var throttle = $feature('redirectToCape', false, merchantCountry);
	        var capeRedirect = throttle ? $experiment('cape_redirect_exp', throttle, $rootScope.token, {}) : false;
	
	        return appData.retrieve().then(function () {
	            return cart.retrieve().then(function () {
	                if ((cart.payment_action === 'order' || cart.payment_action === 'sale') && appData.user_selected_funding_source_type === 'BML' && !capeRedirect) {
	                    return $q.reject(new $FallbackError({
	                        reason: 'gce_not_supported',
	                        product: 'aries'
	                    }));
	                }
	            });
	        });
	    }, function updatePaymentExperience() {
	        $CheckoutAppDataModel.instance($rootScope.token).action('updatePaymentExperience', {
	            data: {
	                payment_experience: 'HERMESNODE',
	                payment_experience_form_factor: _miniBrowser.$miniBrowser.isMiniBrowser() ? 'IN_CONTEXT' : 'FULL_PAGE'
	            },
	            silent: true,
	            transientError: true
	        });
	    }, function checkProcessorDecline() {
	        return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	
	            if (appData.flags.processor_declined) {
	                $logger.info('processor_decline_transaction');
	                var authModel = $AuthModel.instance();
	
	                if (authModel.auth_state === 'IDENTIFIED' && !$util.param('redirectToHermes')) {
	                    // guest
	                    return $dispatch('xoon', {
	                        token: $rootScope.token,
	                        hermesXoonRedirect: true
	                    }, {
	                        fromState: 'checkout_init',
	                        toState: 'guest',
	                        'locale.x': $locale.lang + '_' + $locale.country,
	                        'country.x': $locale.country
	                    });
	                }
	
	                return;
	            }
	        });
	    }, function checkTransactionEligibility() {
	        return $promise.hash({
	            transactionEligibility: $TransactionEligibilityModel.instance($rootScope.token).retrieve(),
	            isPartnerIntegration: _miniBrowser.$miniBrowser.getPartnerIntegration($rootScope.token),
	            isDirectIntegration: _miniBrowser.$miniBrowser.getDirectIntegration($rootScope.token)
	        }).then(function (data) {
	
	            if (data.transactionEligibility.eligible && !data.transactionEligibility.lipp) {
	                return $logger.info('transaction_eligible');
	            }
	
	            if (data.isPartnerIntegration) {
	                return $logger.warn('partner_integration_ineligible_transaction');
	            }
	
	            if (!data.isDirectIntegration) {
	                return $logger.warn('ineligible_indirect_transaction');
	            }
	
	            var appData = $CheckoutAppDataModel.instance($rootScope.token);
	
	            if (appData.user_selected_funding_source_type === 'BML' && ($config.deploy.isLocal() || $config.deploy.isStage())) {
	                return $logger.warn('ineligible_ppcbtn_transaction');
	            }
	
	            $logger.info('transaction_ineligible');
	
	            return $q.reject(new $FallbackError({
	                reason: 'transaction_ineligible',
	                product: 'ux'
	            }));
	        });
	    }, function checkAPayLogin() {
	        // Check if browser supports PaymentRequest API.
	        if (!$xoAPayUtils.isAPayAPISupported()) {
	            return;
	        }
	
	        var models = {};
	
	        return $populate(models, {
	            payee: $CheckoutPayeeModel.instance($rootScope.token),
	            auth: $AuthModel.instance(),
	            cart: $CheckoutCartModel.instance($rootScope.token)
	        }).then(function () {
	            // Do nothing if user is already logged in.
	            if (models.auth.logged_in || models.auth.remembered) {
	                return;
	            }
	
	            // Do nothing for APay onboarding flow.
	            if (models.cart.isWalletTokenization()) {
	                return;
	            }
	
	            return $pxp('xo_hermes_apay', {
	                'uid': models.payee.get('merchant.id', '')
	            }, 'xo_hermes_apay_whitelist_treatment').then(function (t) {
	                if (t && t.treatment_name === 'xo_hermes_apay_whitelist_treatment') {
	                    // Check if apay is part of ui_experience cookie.
	                    var ui_experience = $cookies && $cookies.ui_experience;
	                    var params = $util.params(ui_experience);
	
	                    if (!params || params.apay !== 'true') {
	                        // Cookie is not set.
	                        // For OneTouch, do nothing.
	                        if (models.auth.refresh_token) {
	                            return;
	                        }
	
	                        // Call PaymentRequest API to get JWT anyway
	                        return $xoAPayUtils.authenticateAPay().then(function (result) {
	                            // Set APay cookie for success case.
	                            if (result) {
	                                $xoAPayUtils.setAPayCookie($rootScope.token);
	                            }
	                            return;
	                        });
	                    }
	
	                    if (models.auth.refresh_token) {
	                        // Do nothing if OT user has seen APay login.
	                        if (params && params.otapay === 'true') {
	                            return;
	                        }
	
	                        return $pxp('xo_hermes_apay_ot_auth', {
	                            'ctx.APAY': 'true'
	                        }, 'xo_hermes_apay_ot_auth_(treatment|control)').then(function (tr) {
	                            if (tr && tr.treatment_name === 'xo_hermes_apay_ot_auth_treatment') {
	                                return $xoAPayUtils.authenticateAPay().then(function (result) {
	                                    // Clear APay cookie for error case.
	                                    if (!result) {
	                                        $xoAPayUtils.clearAPayCookie($rootScope.token);
	                                        return;
	                                    }
	
	                                    // Set OneTouch APay cookie.
	                                    $xoAPayUtils.setOTAPayCookie($rootScope.token);
	                                    return;
	                                });
	                            }
	                            return;
	                        });
	                    } else {
	                        return $pxp('xo_hermes_apay_auth', {
	                            'ctx.APAY': 'true'
	                        }, 'xo_hermes_apay_auth_(treatment|control)').then(function (tr) {
	                            if (tr && tr.treatment_name === 'xo_hermes_apay_auth_treatment') {
	                                return $xoAPayUtils.authenticateAPay().then(function (result) {
	                                    // Clear APay cookie for error case.
	                                    if (!result) {
	                                        $xoAPayUtils.clearAPayCookie($rootScope.token);
	                                    }
	                                    return;
	                                });
	                            }
	                            return;
	                        });
	                    }
	                }
	            });
	        });
	    }, function logStart() {
	        return $promise.hash({
	            isMiniBrowser: _miniBrowser.$miniBrowser.isMiniBrowser(),
	            isDirectIntegration: _miniBrowser.$miniBrowser.getDirectIntegration($rootScope.token),
	            isIframe: _miniBrowser.$miniBrowser.isFramed()
	        }).then(function (flags) {
	            var app_int_type = $DeviceInfo.getAppIntegrationType();
	            $logger.info('app_start_design', {
	                'from': 'client_middleware',
	                'to': 'process_app_start_design',
	                is_directintegration: flags.isDirectIntegration ? 1 : 0,
	                is_incontext: flags.isMiniBrowser || flags.isIframe ? 1 : 0,
	                app_int_type: app_int_type
	            });
	        });
	    }, function logPerformance() {
	        if (window.enablePerformance) {
	
	            var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];
	
	            var timing = {};
	
	            _angular2['default'].forEach(keys, function (key) {
	                timing[key] = parseInt(window.performance.timing[key], 10) || 0;
	            });
	
	            var offset = timing.connectEnd - timing.navigationStart;
	
	            if (timing.connectEnd && window.clientStartTime) {
	                _angular2['default'].forEach(timing, function (time, name) {
	                    if (time && _angular2['default'].isNumber(time)) {
	                        $logger.info('timing_' + name, {
	                            client_elapsed: time - timing.connectEnd - (window.clientStartTime - offset),
	                            req_elapsed: time - timing.connectEnd
	                        });
	                    }
	                });
	            }
	
	            $logger.info('timing', timing);
	
	            if (window.performance.memory) {
	                $logger.info('memory', window.performance.memory);
	            }
	
	            if (window.performance.navigation) {
	                $logger.info('navigation', window.performance.navigation);
	            }
	
	            if (window.performance.getEntries) {
	                var logged = [];
	
	                var logResources = function logResources() {
	                    _angular2['default'].forEach(window.performance.getEntries(), function (resource) {
	
	                        if (!resource || !resource.name) {
	                            return;
	                        }
	
	                        if (logged.indexOf(resource.name) === -1) {
	                            logged.push(resource.name);
	                        } else {
	                            return;
	                        }
	
	                        if (resource.initiatorType) {
	                            $logger.info(resource.initiatorType, resource);
	                        }
	                    });
	                };
	
	                logResources();
	                setInterval(logResources, 500);
	            }
	
	            if (timing.connectEnd && timing.navigationStart && window.clientStartTime) {
	                $logger.info('js_init', {
	                    client_elapsed: 0,
	                    req_elapsed: window.clientStartTime - offset
	                });
	            }
	        } else {
	            $logger.info('no_performance_data');
	        }
	    }, function logAuthState() {
	        return $AuthModel.instance().retrieve().then(function (auth) {
	            if (auth.logged_in) {
	                $logger.info('user_logged_in');
	            } else if (auth.remembered) {
	                $logger.info('user_remembered');
	            } else {
	                $logger.info('user_not_logged_in');
	            }
	        });
	    },
	
	    // check for access token in the hash.
	    function checkAccessToken() {
	        var euat = $util.param('euat');
	
	        if (euat) {
	            var accessToken = euat === '1' ? window.location.hash.substr(2) : euat;
	
	            if (accessToken) {
	                $logger.info(euat === '1' ? 'access_token_from_hash' : 'access_token_from_param', {
	                    access_token: accessToken
	                });
	
	                /* if (euat === '1') {
	                    window.location.hash = '';
	                } */
	
	                var authModel = $AuthModel.instance();
	
	                authModel.access_token = accessToken;
	            }
	        }
	    },
	
	    // check for FraudNet for Mobile View
	    function enableFraudNetForMobileWebView() {
	        if ($DeviceInfo.isApp()) {
	            return $CheckoutAppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
	                return $pxp($config.ulMeta.hermesnodePxpConfig, {
	                    'ctx.COUNTRY': appData.merchant.merchant_country
	                }, 'xo_hermesnode_fraudnet_webview_treatment').then(function (result) {
	                    if (result && result.treatment_name) {
	                        $window.enableFraudNetForMobileWebView = true;
	                    }
	                });
	            });
	        }
	    },
	
	    // Logs if service workers are enabled
	    function isServiceWorkerSupported() {
	        if ('serviceWorker' in navigator) {
	            $logger.info('service_worker_supported');
	        } else {
	            $logger.info('service_worker_not_supported');
	        }
	    }, function forceCookiesDisabled() {
	        if ($DeviceInfo.isApp()) {
	            return $CheckoutPayeeModel.instance($rootScope.token).retrieve().then(function (payee) {
	                if (~$config.forceCookiesDisabled.indexOf(payee.merchant.id)) {
	                    $logger.info('force_cookies_disabled');
	                    $Api.forceCookiesDisabled = true;
	                }
	            });
	        }
	    }, function checkFramed() {
	        if ($util.isIFrame()) {
	            // Set this as "framed" mode (X icon, escape hatch, etc.)
	            document.documentElement.className += ' framed';
	        }
	    }];
	});
	
	_integration.$integration;
	
	_miniBrowser.$miniBrowser;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "js/lib", "js/lib/middleware.js"))

/***/ },

/***/ "./js/lib/stateChangeListener.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_angular2['default'].module().run(function ($rootScope, $state) {
	    // Decorate the current state with the transition params
	    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	        $state.toState = toState;
	        $state.toParams = toParams;
	        $state.fromState = fromState;
	        $state.fromParams = fromParams;
	    });
	});

/***/ },

/***/ "./components/xo-models/src/auth/lib/xoAPayUtils.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xoAPayUtils', ['squid']).factory('$xoAPayUtils', function ($q, $logger, $DeviceInfo, $config, $http) {
	        var _jwtToken = '';
	        var _authenticated;
	
	        // Call browser PaymentRequest API that returns a promise
	        function createPaymentRequest() {
	            var supportedInstruments = [{
	                supportedMethods: ['https://android.com/pay'],
	                data: {
	                    minGooglePlayServicesVersion: '10400000',
	                    paymentMethodTokenizationParameters: {
	                        tokenizationType: 'GATEWAY_TOKEN',
	                        parameters: {
	                            gateway: 'paypal'
	                        }
	                    }
	                }
	            }];
	            var details = {
	                // Payment request requires an amount. Hardcode the value for now.
	                total: { label: 'Checkout', amount: { currency: 'USD', value: '5.00' } }
	            };
	
	            var options = {};
	            return new PaymentRequest(supportedInstruments, details, options); // eslint-disable-line no-undef
	        }
	
	        function updateCookie(url, params) {
	            $http({
	                method: 'GET',
	                url: url,
	                params: params
	            });
	        }
	
	        function isPaymentRequestAPISupported() {
	            var currentVersionMatch = navigator.userAgent.match(/Chrome\/([0-9]+)\./i);
	            return $DeviceInfo.isMobile() && window.navigator.vendor === 'Google Inc.' && 'PaymentRequest' in window && navigator.userAgent.match(/Android/i) && currentVersionMatch && Number(currentVersionMatch[1]) >= 58;
	        }
	
	        return {
	            isAPayAPISupported: function isAPayAPISupported() {
	                return isPaymentRequestAPISupported();
	            },
	
	            authenticateAPay: function authenticateAPay() {
	                var forceAuthenticate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	                if (!forceAuthenticate && _authenticated !== undefined) {
	                    return $q.resolve(_authenticated);
	                }
	
	                _authenticated = false;
	                _jwtToken = '';
	
	                // Do not proceed if PaymentRequest is not supported.
	                if (!isPaymentRequestAPISupported()) {
	                    return $q.resolve(false);
	                }
	
	                var paymentRequest = window.appPaymentRequest || createPaymentRequest();
	                if (paymentRequest) {
	                    $logger.info('APAY_AUTHENTICATION_BEGIN');
	                    $logger.info('checkout_fpti', {
	                        from: 'payment_request_auth',
	                        to: 'prepare_payment_request_auth'
	                    });
	
	                    return paymentRequest.show().then(function (result) {
	                        result.complete('success');
	
	                        $logger.info('APAY_AUTHENTICATION_SUCCEEDED');
	                        $logger.info('checkout_fpti', {
	                            from: 'payment_request_auth',
	                            to: 'process_payment_request_auth',
	                            param_type: 'JWT'
	                        });
	
	                        var paymentMethodToken = result.details && result.details.paymentMethodToken && JSON.parse(result.details.paymentMethodToken);
	                        _jwtToken = paymentMethodToken.authJwt;
	                        _authenticated = true;
	                        return true;
	                    })['catch'](function (err) {
	                        $logger.info('APAY_AUTHENTICATION_FAILED', {
	                            msg: err && err.message,
	                            name: err && err.name
	                        });
	
	                        $logger.info('checkout_fpti', {
	                            from: 'payment_request_auth',
	                            to: 'process_payment_request_auth',
	                            int_error_code: err && err.name,
	                            int_error_description: err && err.message,
	                            error_source: 'PaymentRequestAPI',
	                            error_type: 'soft_decline'
	
	                        });
	
	                        return false;
	                    });
	                } else {
	                    return $q.resolve(false);
	                }
	            },
	
	            getAPayAuthToken: function getAPayAuthToken() {
	                return _jwtToken;
	            },
	
	            setAPayCookie: function setAPayCookie(token) {
	                if ($config.tokenizedWalletCookieURL) {
	                    updateCookie($config.tokenizedWalletCookieURL, {
	                        op: 'set',
	                        token: token
	                    });
	                }
	            },
	
	            clearAPayCookie: function clearAPayCookie(token) {
	                if ($config.tokenizedWalletCookieURL) {
	                    updateCookie($config.tokenizedWalletCookieURL, {
	                        op: 'clear',
	                        token: token
	                    });
	                }
	            },
	
	            setOTAPayCookie: function setOTAPayCookie(token) {
	                if ($config.tokenizedWalletCookieURL) {
	                    updateCookie($config.tokenizedWalletCookieURL, {
	                        op: 'setot',
	                        token: token
	                    });
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/auth/lib", "components/xo-models/src/auth/lib/xoAPayUtils.js"))

/***/ },

/***/ "./components/xo-models/src/app/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.app', ['squid']).factory('$TransactionEligibilityModel', function ($Model, $Api) {
	        return $Model.extend('TransactionEligibilityModel', {
	            api: new $Api({
	                uri: '/api/eligibility/transaction/:id'
	            })
	        });
	    }).factory('$BuyerEligibilityModel', function ($Model, $Api) {
	        return $Model.extend('BuyerEligibilityModel', {
	            api: new $Api({
	                uri: '/api/eligibility/buyer/:id'
	            })
	        });
	    }).factory('$PXPModel', function ($Model, $Api) {
	        return $Model.extend({
	            api: new $Api({
	                uri: '/api/pxp/:id'
	            })
	        });
	    }).factory('$LocaleConfigModel', function ($Model, $Api) {
	        return $Model.extend({
	            api: new $Api({
	                uri: '/api/localeConfig'
	            })
	        });
	    }).factory('$AppDataModel', function ($Model, $Api) {
	        return $Model.extend('AppDataModel', {
	            api: new $Api({
	                uri: '/api/app'
	            }),
	
	            isMobile: function isMobile() {
	                return this.platform === 'mobile';
	            }
	        });
	    }).factory('$MessengerIntegrationDataModel', function ($Model, $Api) {
	        return $Model.extend('MessengerIntegrationDataModel', {
	            api: new $Api({
	                uri: '/api/messenger'
	            })
	        });
	    }).factory('$TokenizedWalletEligibilityModel', function ($Model, $Api) {
	        return $Model.extend('TokenizedWalletEligibilityModel', {
	            api: new $Api({
	                uri: '/api/eligibility/tokenizedWallet/:id'
	            }),
	
	            isEligible: function isEligible() {
	                return this.eligible;
	            }
	        });
	    }).factory('$TokenizedWalletPinModel', function ($Model, $Api) {
	        return $Model.extend('TokenizedWalletPinModel', {
	            api: new $Api({
	                uri: '/api/pin/tokenizedWallet/:id'
	            }),
	
	            getPinOrigin: function getPinOrigin() {
	                return this.pinOrigin;
	            },
	            getSuggestedPin: function getSuggestedPin() {
	                return this.suggestedPin;
	            },
	            getSuggestedKey: function getSuggestedKey() {
	                return this.suggestedKey;
	            },
	            getPinId: function getPinId() {
	                return this.pinId;
	            },
	            isPinIdPresent: function isPinIdPresent() {
	                return !!this.pinId;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/app", "components/xo-models/src/app/index.js"))

/***/ },

/***/ "./components/xo-login-components/src/login/fn.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-fn', ['squid', 'xo-device-info', 'beaver']).factory('$fn', function ($populate, $rootScope, $CheckoutAppDataModel, $window, $DeviceInfo, $logger, $config, $util, $meta, $pxp, $q) {
	        var fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';
	        var fnCorrId;
	        var fraudnetConfig = $config.fraudnet;
	        var token = $rootScope.token || $meta.token;
	
	        if ($meta.baToken) {
	            $logger.info('BEAM_In_Hermes_Checkout');
	            fnCorrId = $meta.baToken;
	        } else if ($rootScope.fraudNetId) {
	            fnCorrId = $rootScope.fraudNetId;
	        } else {
	            fnCorrId = $rootScope.token || $meta.token;
	        }
	
	        var options = {
	            fnSessionId: fnCorrId,
	            sourceId: fraudnetConfig && fraudnetConfig.sourceId || 'HERMES_SIGNIN',
	            allowsCustomEvent: typeof CustomEvent !== 'undefined' && angular.isFunction(CustomEvent)
	        };
	
	        function init() {
	
	            $logger.info('FN_contexts', {
	                'token': token,
	                'fnSessionId': options.fnSessionId
	            });
	
	            var appData = {};
	            return $populate(appData, { checkoutAppData: $CheckoutAppDataModel.instance(token) }).then(function () {
	                var country = appData.checkoutAppData.merchant.merchant_country;
	                return $pxp('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_fraudnet_switch_treatment');
	            }).then(function (result) {
	                var treatmentName = result && result.treatment_name || '';
	                if (treatmentName) {
	                    $logger.info('FN_passive_treatment');
	                    options.fnUrl = $config.urls.fraudnetUrl && $config.urls.fraudnetUrl.passive;
	                    options.passive = true;
	                } else {
	                    $logger.info('FN_active_treatment');
	                    options.fnUrl = $config.urls.fraudnetUrl && $config.urls.fraudnetUrl.active;
	                    options.passive = false;
	                }
	                $logger.info('FN_Initialised', {
	                    'allowsCustomEvent': options.allowsCustomEvent
	                });
	            });
	        }
	
	        var enableFraudnet = function enableFraudnet() {
	            var userAgent = $window.navigator.userAgent;
	
	            // Disable for web view
	            if ($DeviceInfo.isApp()) {
	                if ($window.enableFraudNetForMobileWebView) {
	                    $logger.info('Enable_FN_MobileApp_PXP_Decision');
	                    return true;
	                }
	
	                $logger.info('Disable_FN_Mobileapp');
	                return false;
	            } else if (userAgent.indexOf('EtsyInc') > -1) {
	                $logger.info('Disable_FN_Etsy');
	                return false;
	            }
	            $logger.info('Enable_FN');
	            return true;
	        };
	
	        function injectScript(fnUrl) {
	            var script = document.createElement('script');
	            script.id = 'js-sync';
	            script.src = fnUrl;
	            document.body.appendChild(script);
	        }
	
	        function injectIframe(beaconOptions) {
	            var iframe = document.createElement('iframe');
	            var dom;
	            var doc;
	            var where;
	
	            iframe.src = 'javascript:false'; // eslint-disable-line no-script-url
	            iframe.title = '';
	            iframe.role = 'presentation';
	            (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; display: none;';
	
	            where = document.getElementsByTagName('script');
	            where = where[where.length - 1];
	            where.parentNode.insertBefore(iframe, where);
	
	            try {
	                doc = iframe.contentWindow.document;
	            } catch (e) {
	                dom = document.domain;
	                iframe.src = 'javascript:var d=document.open();d.domain="' + dom + '";void(0);'; // eslint-disable-line no-script-url
	                doc = iframe.contentWindow.document;
	            }
	
	            doc.open()._l = function () {
	                var js = this.createElement('script');
	                if (dom) {
	                    this.domain = dom;
	                }
	                js.id = 'js-iframe-async';
	                js.src = beaconOptions.fnUrl;
	                this.body.appendChild(js);
	            };
	
	            doc.write('<body onload="document._l();">');
	            doc.close();
	        }
	
	        function _injectConfig(configOptions) {
	            var script = document.getElementById('fconfig');
	
	            if (script) {
	                if (script.parentNode) {
	                    script.parentNode.removeChild(script);
	                }
	            }
	
	            script = document.createElement('script');
	            script.id = 'fconfig';
	            script.type = 'application/json';
	            script.setAttribute('fncls', fncls);
	
	            script.text = '{"f": "' + configOptions.fnSessionId + '", "s": "' + configOptions.sourceId + '", "cb": "fnCallback"}';
	            document.body.appendChild(script);
	        }
	
	        /**
	         * Loads the fraudnet beacons (triggers 2 image beacons to c.paypal.com and c6.paypal.com)
	         *
	         * Integration pattern ripped from the Fraudnet Integration guide:
	         * https://confluence.paypal.com/display/RiskDataAcquisition/FraudNet+Client+System+Integration+Guide+3.0#FraudNetClientSystemIntegrationGuide3.0-IntegrationCode
	         */
	        function _loadBeacon(beaconOptions) {
	            if ($DeviceInfo.isApp() && $window.enableFraudNetForMobileWebView) {
	                injectScript(beaconOptions.fnUrl);
	            } else {
	                injectIframe(beaconOptions);
	            }
	        }
	
	        function trigger(scope) {
	
	            var fnLoaded = !!$rootScope.fnLoaded;
	
	            if (fnLoaded) {
	                return false;
	            }
	            $logger.info('Trigger_FN');
	
	            if (options.fnUrl) {
	                if (enableFraudnet()) {
	                    $window.fnCallback = function () {
	                        if (scope) {
	                            scope.$emit('fnCallback');
	                        }
	                    };
	                    _injectConfig(options);
	                    _loadBeacon(options);
	                    $rootScope.fnLoaded = true;
	                    return true;
	                }
	            }
	            return false;
	        }
	
	        /**
	         * send a payload to fraudnet for analysing typing speed
	         * @param type
	         */
	        function sendTypingSpeedPayload(type) {
	
	            var tsLoadPayload = {
	                'detail': {
	                    'type': type
	                }
	            };
	
	            if (type === 'Hermes') {
	                tsLoadPayload.detail['fields'] = ['username', 'password'];
	            }
	            if (type === 'HermesUL') {
	                tsLoadPayload.detail['frame'] = 'injectedUl';
	                tsLoadPayload.detail['fields'] = ['email', 'password'];
	            }
	
	            if (type && options.passive) {
	                var event;
	                if (options.allowsCustomEvent) {
	                    // document.createEvent deprecated
	                    $logger.info('fn_CustomEvent_type1');
	                    event = new CustomEvent('tsLoad', tsLoadPayload);
	                } else {
	                    // IE does not support CustomEvent constructor
	                    try {
	                        $logger.info('fn_CustomEvent_type2');
	                        event = window.document.createEvent('CustomEvent');
	                        event.initCustomEvent('tsLoad', true, true, tsLoadPayload.detail);
	                    } catch (err) {
	                        $logger.info('fn_CustomEvent_None', {
	                            'error': err
	                        });
	                    }
	                }
	                if (event) {
	                    window.document.dispatchEvent(event);
	                    $logger.info('Dispatched_FN_TS_Payload_' + type);
	                }
	            }
	        }
	
	        return {
	            init: init,
	            trigger: trigger,
	            sendTypingSpeedPayload: sendTypingSpeedPayload
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/login", "components/xo-login-components/src/login/fn.js"))

/***/ },

/***/ "./js/lib/security.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-models/src/auth/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_angular2['default'].module().run(function ($rootScope, $log, $state, $AuthModel, $Forbidden, $logger, $timeout, $interval) {
	
	    var errorCount = 0;
	
	    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	
	        var auth = $AuthModel.instance();
	
	        if (toState.auth !== false && !auth.logged_in) {
	            errorCount += 1;
	            if (errorCount === 10) {
	                $logger.error('max_state_requires_auth');
	            }
	            if (errorCount >= 10) {
	                return;
	            }
	            $logger.warn('state_requires_auth', {
	                stateName: toState.name
	            });
	            event.preventDefault();
	            throw new $Forbidden('state_transition_forbidden', { fromState: fromState, toState: toState });
	        }
	    });
	
	    $interval(function () {
	
	        var auth = $AuthModel.instance();
	
	        if (auth.logged_in) {
	            auth.reload({
	                silent: true
	            }).then(function () {
	                if ($state.current.auth !== false && !auth.logged_in) {
	                    errorCount += 1;
	                    if (errorCount === 10) {
	                        $logger.error('max_state_requires_auth');
	                    }
	                    if (errorCount >= 10) {
	                        return;
	                    }
	                    $logger.info('idle_timeout');
	                    $logger.warn('state_requires_auth', {
	                        stateName: $state.current.name
	                    });
	                    errorCount += 1;
	                    throw new $Forbidden();
	                }
	            });
	        }
	    }, 30 * 60 * 1000);
	
	    _squid.$util.idleTimeout(10 * 60 * 60 * 1000);
	});
	
	_squid.$util;

/***/ },

/***/ "./js/lib/cplIntegration.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console) {
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _bluebird = __webpack_require__("../node_modules/bluebird/js/browser/bluebird.js");
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	try {
	    var token = window.meta.token;
	    _bluebird2['default'].join(_checkout.$CheckoutAppDataModel.instance(token).retrieve(), _checkout.$CheckoutCartModel.instance(token).retrieve(), function (appData, cart) {
	        if (appData.doec_on_approve()) {
	            window.fptiProductOverride = 'wps';
	        } else if (cart.isBilling()) {
	            window.fptiProductOverride = 'billing';
	        }
	    })['catch'](function (e) {
	        console.error(e);
	    });
	} catch (e) {
	    console.error(e);
	}
	
	_checkout.$CheckoutAppDataModel;
	
	_checkout.$CheckoutCartModel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "../node_modules/bluebird/js/browser/bluebird.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(console, global) {/* @preserve
	 * The MIT License (MIT)
	 * 
	 * Copyright (c) 2013-2015 Petka Antonov
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 * 
	 */
	/**
	 * bluebird build version 2.11.0
	 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, cancel, using, filter, any, each, timers
	*/
	!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};
	
	},{}],2:[function(_dereq_,module,exports){
	
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = _dereq_("./schedule.js");
	var Queue = _dereq_("./queue.js");
	var util = _dereq_("./util.js");
	
	function Async() {
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule =
	        schedule.isStatic ? schedule(this.drainQueues) : schedule;
	}
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.enableTrampoline = function() {
	    if (!this._trampolineEnabled) {
	        this._trampolineEnabled = true;
	        this._schedule = function(fn) {
	            setTimeout(fn, 0);
	        };
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._normalQueue.length() > 0;
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    if (schedule.isStatic) {
	        schedule = function(fn) { setTimeout(fn, 0); };
	    }
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype.invokeFirst = function (fn, receiver, arg) {
	    this._normalQueue.unshift(fn, receiver, arg);
	    this._queueTick();
	};
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = new Async();
	module.exports.firstLineError = firstLineError;
	
	},{"./queue.js":28,"./schedule.js":31,"./util.js":38}],3:[function(_dereq_,module,exports){
	
	module.exports = function(Promise, INTERNAL, tryConvertToPromise) {
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (this._isPending()) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, ret._progress, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, ret._progress, ret, context);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 131072;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~131072);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 131072) === 131072;
	};
	
	Promise.bind = function (thisArg, value) {
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        maybePromise._then(function() {
	            ret._resolveCallback(value);
	        }, ret._reject, ret._progress, ret, null);
	    } else {
	        ret._resolveCallback(value);
	    }
	    return ret;
	};
	};
	
	},{}],4:[function(_dereq_,module,exports){
	
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = _dereq_("./promise.js")();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;
	
	},{"./promise.js":23}],5:[function(_dereq_,module,exports){
	
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = _dereq_("./util.js");
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (false) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	                                                                 \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	                                                                \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
	    if (false) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};
	
	},{"./util.js":38}],6:[function(_dereq_,module,exports){
	
	module.exports = function(Promise) {
	var errors = _dereq_("./errors.js");
	var async = _dereq_("./async.js");
	var CancellationError = errors.CancellationError;
	
	Promise.prototype._cancel = function (reason) {
	    if (!this.isCancellable()) return this;
	    var parent;
	    var promiseToReject = this;
	    while ((parent = promiseToReject._cancellationParent) !== undefined &&
	        parent.isCancellable()) {
	        promiseToReject = parent;
	    }
	    this._unsetCancellable();
	    promiseToReject._target()._rejectCallback(reason, false, true);
	};
	
	Promise.prototype.cancel = function (reason) {
	    if (!this.isCancellable()) return this;
	    if (reason === undefined) reason = new CancellationError();
	    async.invokeLater(this._cancel, this, reason);
	    return this;
	};
	
	Promise.prototype.cancellable = function () {
	    if (this._cancellable()) return this;
	    async.enableTrampoline();
	    this._setCancellable();
	    this._cancellationParent = undefined;
	    return this;
	};
	
	Promise.prototype.uncancellable = function () {
	    var ret = this.then();
	    ret._unsetCancellable();
	    return ret;
	};
	
	Promise.prototype.fork = function (didFulfill, didReject, didProgress) {
	    var ret = this._then(didFulfill, didReject, didProgress,
	                         undefined, undefined);
	
	    ret._setCancellable();
	    ret._cancellationParent = undefined;
	    return ret;
	};
	};
	
	},{"./async.js":2,"./errors.js":13}],7:[function(_dereq_,module,exports){
	
	module.exports = function() {
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](main|debug|zalgo|instrumented)/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var warn;
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.parent = function() {
	    return this._parent;
	};
	
	CapturedTrace.prototype.hasParent = function() {
	    return this._parent !== undefined;
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = CapturedTrace.parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = stackFramePattern.test(line) ||
	            "    (No stack trace)" === line;
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0) {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	CapturedTrace.parseStackAndMessage = function(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: cleanStack(stack)
	    };
	};
	
	CapturedTrace.formatAndLogError = function(error, title) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (typeof error === "object" || typeof error === "function") {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof warn === "function") {
	            warn(message);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	};
	
	CapturedTrace.unhandledRejection = function (reason) {
	    CapturedTrace.formatAndLogError(reason, "^--- With additional stack trace: ");
	};
	
	CapturedTrace.isSupported = function () {
	    return typeof captureStackTrace === "function";
	};
	
	CapturedTrace.fireRejectionEvent =
	function(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent(name, reason, promise);
	    } catch (e) {
	        globalEventFired = true;
	        async.throwLater(e);
	    }
	
	    var domEventFired = false;
	    if (fireDomEvent) {
	        try {
	            domEventFired = fireDomEvent(name.toLowerCase(), {
	                reason: reason,
	                promise: promise
	            });
	        } catch (e) {
	            domEventFired = true;
	            async.throwLater(e);
	        }
	    }
	
	    if (!globalEventFired && !localEventFired && !domEventFired &&
	        name === "unhandledRejection") {
	        CapturedTrace.formatAndLogError(reason, "Unhandled rejection ");
	    }
	};
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj.toString();
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	CapturedTrace.setBounds = function(firstLineError, lastLineError) {
	    if (!CapturedTrace.isSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit = Error.stackTraceLimit + 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit = Error.stackTraceLimit + 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit = Error.stackTraceLimit - 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit = Error.stackTraceLimit + 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit = Error.stackTraceLimit - 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	var fireDomEvent;
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function(name, reason, promise) {
	            if (name === "rejectionHandled") {
	                return process.emit(name, promise);
	            } else {
	                return process.emit(name, reason, promise);
	            }
	        };
	    } else {
	        var customEventWorks = false;
	        var anyEventWorks = true;
	        try {
	            var ev = new self.CustomEvent("test");
	            customEventWorks = ev instanceof CustomEvent;
	        } catch (e) {}
	        if (!customEventWorks) {
	            try {
	                var event = document.createEvent("CustomEvent");
	                event.initCustomEvent("testingtheevent", false, true, {});
	                self.dispatchEvent(event);
	            } catch (e) {
	                anyEventWorks = false;
	            }
	        }
	        if (anyEventWorks) {
	            fireDomEvent = function(type, detail) {
	                var event;
	                if (customEventWorks) {
	                    event = new self.CustomEvent(type, {
	                        detail: detail,
	                        bubbles: false,
	                        cancelable: true
	                    });
	                } else if (self.dispatchEvent) {
	                    event = document.createEvent("CustomEvent");
	                    event.initCustomEvent(type, false, true, detail);
	                }
	
	                return event ? !self.dispatchEvent(event) : false;
	            };
	        }
	
	        var toWindowMethodNameMap = {};
	        toWindowMethodNameMap["unhandledRejection"] = ("on" +
	            "unhandledRejection").toLowerCase();
	        toWindowMethodNameMap["rejectionHandled"] = ("on" +
	            "rejectionHandled").toLowerCase();
	
	        return function(name, reason, promise) {
	            var methodName = toWindowMethodNameMap[name];
	            var method = self[methodName];
	            if (!method) return false;
	            if (name === "rejectionHandled") {
	                method.call(self, promise);
	            } else {
	                method.call(self, reason, promise);
	            }
	            return true;
	        };
	    }
	})();
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    warn = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        warn = function(message) {
	            process.stderr.write("\u001b[31m" + message + "\u001b[39m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        warn = function(message) {
	            console.warn("%c" + message, "color: red");
	        };
	    }
	}
	
	return CapturedTrace;
	};
	
	},{"./async.js":2,"./util.js":38}],8:[function(_dereq_,module,exports){
	
	module.exports = function(NEXT_FILTER) {
	var util = _dereq_("./util.js");
	var errors = _dereq_("./errors.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var keys = _dereq_("./es5.js").keys;
	var TypeError = errors.TypeError;
	
	function CatchFilter(instances, callback, promise) {
	    this._instances = instances;
	    this._callback = callback;
	    this._promise = promise;
	}
	
	function safePredicate(predicate, e) {
	    var safeObject = {};
	    var retfilter = tryCatch(predicate).call(safeObject, e);
	
	    if (retfilter === errorObj) return retfilter;
	
	    var safeKeys = keys(safeObject);
	    if (safeKeys.length) {
	        errorObj.e = new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a");
	        return errorObj;
	    }
	    return retfilter;
	}
	
	CatchFilter.prototype.doFilter = function (e) {
	    var cb = this._callback;
	    var promise = this._promise;
	    var boundTo = promise._boundValue();
	    for (var i = 0, len = this._instances.length; i < len; ++i) {
	        var item = this._instances[i];
	        var itemIsErrorType = item === Error ||
	            (item != null && item.prototype instanceof Error);
	
	        if (itemIsErrorType && e instanceof item) {
	            var ret = tryCatch(cb).call(boundTo, e);
	            if (ret === errorObj) {
	                NEXT_FILTER.e = ret.e;
	                return NEXT_FILTER;
	            }
	            return ret;
	        } else if (typeof item === "function" && !itemIsErrorType) {
	            var shouldHandle = safePredicate(item, e);
	            if (shouldHandle === errorObj) {
	                e = errorObj.e;
	                break;
	            } else if (shouldHandle) {
	                var ret = tryCatch(cb).call(boundTo, e);
	                if (ret === errorObj) {
	                    NEXT_FILTER.e = ret.e;
	                    return NEXT_FILTER;
	                }
	                return ret;
	            }
	        }
	    }
	    NEXT_FILTER.e = e;
	    return NEXT_FILTER;
	};
	
	return CatchFilter;
	};
	
	},{"./errors.js":13,"./es5.js":14,"./util.js":38}],9:[function(_dereq_,module,exports){
	
	module.exports = function(Promise, CapturedTrace, isDebugging) {
	var contextStack = [];
	function Context() {
	    this._trace = new CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (!isDebugging()) return;
	    if (this._trace !== undefined) {
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (!isDebugging()) return;
	    if (this._trace !== undefined) {
	        contextStack.pop();
	    }
	};
	
	function createContext() {
	    if (isDebugging()) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	
	Promise.prototype._peekContext = peekContext;
	Promise.prototype._pushContext = Context.prototype._pushContext;
	Promise.prototype._popContext = Context.prototype._popContext;
	
	return createContext;
	};
	
	},{}],10:[function(_dereq_,module,exports){
	
	module.exports = function(Promise, CapturedTrace) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var Warning = _dereq_("./errors.js").Warning;
	var util = _dereq_("./util.js");
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var debugging = false || (util.isNode &&
	                    (!!process.env["BLUEBIRD_DEBUG"] ||
	                     process.env["NODE_ENV"] === "development"));
	
	if (util.isNode && process.env["BLUEBIRD_DEBUG"] == 0) debugging = false;
	
	if (debugging) {
	    async.disableTrampolineIfNecessary();
	}
	
	Promise.prototype._ignoreRejections = function() {
	    this._unsetRejectionIsUnhandled();
	    this._bitField = this._bitField | 16777216;
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 16777216) !== 0) return;
	    this._setRejectionIsUnhandled();
	    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    CapturedTrace.fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._getCarriedStackTrace() || this._settledValue;
	        this._setUnhandledRejectionIsNotified();
	        CapturedTrace.fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 524288;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~524288);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 524288) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 2097152;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~2097152);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 2097152) > 0;
	};
	
	Promise.prototype._setCarriedStackTrace = function (capturedTrace) {
	    this._bitField = this._bitField | 1048576;
	    this._fulfillmentHandler0 = capturedTrace;
	};
	
	Promise.prototype._isCarryingStackTrace = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._getCarriedStackTrace = function () {
	    return this._isCarryingStackTrace()
	        ? this._fulfillmentHandler0
	        : undefined;
	};
	
	Promise.prototype._captureStackTrace = function () {
	    if (debugging) {
	        this._trace = new CapturedTrace(this._peekContext());
	    }
	    return this;
	};
	
	Promise.prototype._attachExtraTrace = function (error, ignoreSelf) {
	    if (debugging && canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = CapturedTrace.parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	};
	
	Promise.prototype._warn = function(message) {
	    var warning = new Warning(message);
	    var ctx = this._peekContext();
	    if (ctx) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = CapturedTrace.parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	    CapturedTrace.formatAndLogError(warning, "");
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() &&
	        debugging === false
	   ) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/DT1qyG\u000a");
	    }
	    debugging = CapturedTrace.isSupported();
	    if (debugging) {
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return debugging && CapturedTrace.isSupported();
	};
	
	if (!CapturedTrace.isSupported()) {
	    Promise.longStackTraces = function(){};
	    debugging = false;
	}
	
	return function() {
	    return debugging;
	};
	};
	
	},{"./async.js":2,"./errors.js":13,"./util.js":38}],11:[function(_dereq_,module,exports){
	
	var util = _dereq_("./util.js");
	var isPrimitive = util.isPrimitive;
	
	module.exports = function(Promise) {
	var returner = function () {
	    return this;
	};
	var thrower = function () {
	    throw this;
	};
	var returnUndefined = function() {};
	var throwUndefined = function() {
	    throw undefined;
	};
	
	var wrapper = function (value, action) {
	    if (action === 1) {
	        return function () {
	            throw value;
	        };
	    } else if (action === 2) {
	        return function () {
	            return value;
	        };
	    }
	};
	
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value === undefined) return this.then(returnUndefined);
	
	    if (isPrimitive(value)) {
	        return this._then(
	            wrapper(value, 2),
	            undefined,
	            undefined,
	            undefined,
	            undefined
	       );
	    } else if (value instanceof Promise) {
	        value._ignoreRejections();
	    }
	    return this._then(returner, undefined, undefined, value, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    if (reason === undefined) return this.then(throwUndefined);
	
	    if (isPrimitive(reason)) {
	        return this._then(
	            wrapper(reason, 1),
	            undefined,
	            undefined,
	            undefined,
	            undefined
	       );
	    }
	    return this._then(thrower, undefined, undefined, reason, undefined);
	};
	};
	
	},{"./util.js":38}],12:[function(_dereq_,module,exports){
	
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, null, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, null, INTERNAL);
	};
	};
	
	},{}],13:[function(_dereq_,module,exports){
	
	var es5 = _dereq_("./es5.js");
	var Objectfreeze = es5.freeze;
	var util = _dereq_("./util.js");
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    notEnumerableProp(Error, "__BluebirdErrorTypes__", errorTypes);
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};
	
	},{"./es5.js":14,"./util.js":38}],14:[function(_dereq_,module,exports){
	var isES5 = (function(){
	    
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}
	
	},{}],15:[function(_dereq_,module,exports){
	
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};
	
	},{}],16:[function(_dereq_,module,exports){
	
	module.exports = function(Promise, NEXT_FILTER, tryConvertToPromise) {
	var util = _dereq_("./util.js");
	var isPrimitive = util.isPrimitive;
	var thrower = util.thrower;
	
	function returnThis() {
	    return this;
	}
	function throwThis() {
	    throw this;
	}
	function return$(r) {
	    return function() {
	        return r;
	    };
	}
	function throw$(r) {
	    return function() {
	        throw r;
	    };
	}
	function promisedFinally(ret, reasonOrValue, isFulfilled) {
	    var then;
	    if (isPrimitive(reasonOrValue)) {
	        then = isFulfilled ? return$(reasonOrValue) : throw$(reasonOrValue);
	    } else {
	        then = isFulfilled ? returnThis : throwThis;
	    }
	    return ret._then(then, thrower, undefined, reasonOrValue, undefined);
	}
	
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    var ret = promise._isBound()
	                    ? handler.call(promise._boundValue())
	                    : handler();
	
	    if (ret !== undefined) {
	        var maybePromise = tryConvertToPromise(ret, promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            return promisedFinally(maybePromise, reasonOrValue,
	                                    promise.isFulfilled());
	        }
	    }
	
	    if (promise.isRejected()) {
	        NEXT_FILTER.e = reasonOrValue;
	        return NEXT_FILTER;
	    } else {
	        return reasonOrValue;
	    }
	}
	
	function tapHandler(value) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    var ret = promise._isBound()
	                    ? handler.call(promise._boundValue(), value)
	                    : handler(value);
	
	    if (ret !== undefined) {
	        var maybePromise = tryConvertToPromise(ret, promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            return promisedFinally(maybePromise, value, true);
	        }
	    }
	    return value;
	}
	
	Promise.prototype._passThroughHandler = function (handler, isFinally) {
	    if (typeof handler !== "function") return this.then();
	
	    var promiseAndHandler = {
	        promise: this,
	        handler: handler
	    };
	
	    return this._then(
	            isFinally ? finallyHandler : tapHandler,
	            isFinally ? finallyHandler : undefined, undefined,
	            promiseAndHandler, undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThroughHandler(handler, true);
	};
	
	Promise.prototype.tap = function (handler) {
	    return this._passThroughHandler(handler, false);
	};
	};
	
	},{"./util.js":38}],17:[function(_dereq_,module,exports){
	
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise) {
	var errors = _dereq_("./errors.js");
	var TypeError = errors.TypeError;
	var util = _dereq_("./util.js");
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    var promise = this._promise = new Promise(INTERNAL);
	    promise._captureStackTrace();
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	}
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._next(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    if (result === errorObj) {
	        return this._promise._rejectCallback(result.e, false, true);
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._promise._resolveCallback(value);
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._throw(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/4Y4pDk\u000a\u000a".replace("%s", value) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise._then(
	            this._next,
	            this._throw,
	            undefined,
	            this,
	            null
	       );
	    }
	};
	
	PromiseSpawn.prototype._throw = function (reason) {
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._next = function (value) {
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        spawn._generator = generator;
	        spawn._next(undefined);
	        return spawn.promise();
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};
	
	},{"./errors.js":13,"./util.js":38}],18:[function(_dereq_,module,exports){
	
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
	var util = _dereq_("./util.js");
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (false) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	                                                                \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var caller = function(count) {
	        var values = [];
	        for (var i = 1; i <= count; ++i) values.push("holder.p" + i);
	        return new Function("holder", "                                      \n\
	                                                                \n\
	            var callback = holder.fn;                                        \n\
	            return callback(values);                                         \n\
	            ".replace(/values/g, values.join(", ")));
	    };
	    var thenCallbacks = [];
	    var callers = [undefined];
	    for (var i = 1; i <= 5; ++i) {
	        thenCallbacks.push(thenCallback(i));
	        callers.push(caller(i));
	    }
	
	    var Holder = function(total, fn) {
	        this.p1 = this.p2 = this.p3 = this.p4 = this.p5 = null;
	        this.fn = fn;
	        this.total = total;
	        this.now = 0;
	    };
	
	    Holder.prototype.callers = callers;
	    Holder.prototype.checkFulfillment = function(promise) {
	        var now = this.now;
	        now++;
	        var total = this.total;
	        if (now >= total) {
	            var handler = this.callers[total];
	            promise._pushContext();
	            var ret = tryCatch(handler)(this);
	            promise._popContext();
	            if (ret === errorObj) {
	                promise._rejectCallback(ret.e, false, true);
	            } else {
	                promise._resolveCallback(ret);
	            }
	        } else {
	            this.now = now;
	        }
	    };
	
	    var reject = function (reason) {
	        this._reject(reason);
	    };
	}
	}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (false) {
	            if (last < 6 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var holder = new Holder(last, fn);
	                var callbacks = thenCallbacks;
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        if (maybePromise._isPending()) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                        } else if (maybePromise._isFulfilled()) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else {
	                            ret._reject(maybePromise._reason());
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];}
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};
	
	},{"./util.js":38}],19:[function(_dereq_,module,exports){
	
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var PENDING = {};
	var EMPTY_ARRAY = [];
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : domain.bind(fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = limit >= 1 ? [] : EMPTY_ARRAY;
	    async.invoke(init, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	function init() {this._init$(undefined, -2);}
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	    if (values[index] === PENDING) {
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var callback = this._callback;
	        var receiver = this._promise._boundValue();
	        this._promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        this._promise._popContext();
	        if (ret === errorObj) return this._reject(ret.e);
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (maybePromise._isPending()) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = PENDING;
	                return maybePromise._proxyPromiseArray(this, index);
	            } else if (maybePromise._isFulfilled()) {
	                ret = maybePromise._value();
	            } else {
	                return this._reject(maybePromise._reason());
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	
	    }
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    var limit = typeof options === "object" && options !== null
	        ? options.concurrency
	        : 0;
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter);
	}
	
	Promise.prototype.map = function (fn, options) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	
	    return map(this, fn, options, null).promise();
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    return map(promises, fn, options, _filter).promise();
	};
	
	
	};
	
	},{"./async.js":2,"./util.js":38}],20:[function(_dereq_,module,exports){
	
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        ret._popContext();
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn, args, ctx) {
	    if (typeof fn !== "function") {
	        return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value = util.isArray(args)
	        ? tryCatch(fn).apply(ctx, args)
	        : tryCatch(fn).call(ctx, args);
	    ret._popContext();
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false, true);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};
	
	},{"./util.js":38}],21:[function(_dereq_,module,exports){
	
	module.exports = function(Promise) {
	var util = _dereq_("./util.js");
	var async = _dereq_("./async.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var target = promise._target();
	        var newReason = target._getCarriedStackTrace();
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback =
	Promise.prototype.nodeify = function (nodeback, options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};
	
	},{"./async.js":2,"./util.js":38}],22:[function(_dereq_,module,exports){
	
	module.exports = function(Promise, PromiseArray) {
	var util = _dereq_("./util.js");
	var async = _dereq_("./async.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	Promise.prototype.progressed = function (handler) {
	    return this._then(undefined, undefined, handler, undefined, undefined);
	};
	
	Promise.prototype._progress = function (progressValue) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._target()._progressUnchecked(progressValue);
	
	};
	
	Promise.prototype._progressHandlerAt = function (index) {
	    return index === 0
	        ? this._progressHandler0
	        : this[(index << 2) + index - 5 + 2];
	};
	
	Promise.prototype._doProgressWith = function (progression) {
	    var progressValue = progression.value;
	    var handler = progression.handler;
	    var promise = progression.promise;
	    var receiver = progression.receiver;
	
	    var ret = tryCatch(handler).call(receiver, progressValue);
	    if (ret === errorObj) {
	        if (ret.e != null &&
	            ret.e.name !== "StopProgressPropagation") {
	            var trace = util.canAttachTrace(ret.e)
	                ? ret.e : new Error(util.toString(ret.e));
	            promise._attachExtraTrace(trace);
	            promise._progress(ret.e);
	        }
	    } else if (ret instanceof Promise) {
	        ret._then(promise._progress, null, null, promise, undefined);
	    } else {
	        promise._progress(ret);
	    }
	};
	
	
	Promise.prototype._progressUnchecked = function (progressValue) {
	    var len = this._length();
	    var progress = this._progress;
	    for (var i = 0; i < len; i++) {
	        var handler = this._progressHandlerAt(i);
	        var promise = this._promiseAt(i);
	        if (!(promise instanceof Promise)) {
	            var receiver = this._receiverAt(i);
	            if (typeof handler === "function") {
	                handler.call(receiver, progressValue, promise);
	            } else if (receiver instanceof PromiseArray &&
	                       !receiver._isResolved()) {
	                receiver._promiseProgressed(progressValue, promise);
	            }
	            continue;
	        }
	
	        if (typeof handler === "function") {
	            async.invoke(this._doProgressWith, this, {
	                handler: handler,
	                promise: promise,
	                receiver: this._receiverAt(i),
	                value: progressValue
	            });
	        } else {
	            async.invoke(progress, promise, progressValue);
	        }
	    }
	};
	};
	
	},{"./async.js":2,"./util.js":38}],23:[function(_dereq_,module,exports){
	
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/LhFpo0\u000a");
	};
	var reflect = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	
	var util = _dereq_("./util.js");
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var UNDEFINED_BINDING = {};
	var async = _dereq_("./async.js");
	var errors = _dereq_("./errors.js");
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {e: null};
	var tryConvertToPromise = _dereq_("./thenables.js")(Promise, INTERNAL);
	var PromiseArray =
	    _dereq_("./promise_array.js")(Promise, INTERNAL,
	                                    tryConvertToPromise, apiRejection);
	var CapturedTrace = _dereq_("./captured_trace.js")();
	var isDebugging = _dereq_("./debuggability.js")(Promise, CapturedTrace);
	 /*jshint unused:false*/
	var createContext =
	    _dereq_("./context.js")(Promise, CapturedTrace, isDebugging);
	var CatchFilter = _dereq_("./catch_filter.js")(NEXT_FILTER);
	var PromiseResolver = _dereq_("./promise_resolver.js");
	var nodebackForPromise = PromiseResolver._nodebackForPromise;
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	
	function Promise(resolver) {
	    if (typeof resolver !== "function") {
	        throw new TypeError("the promise constructor requires a resolver function\u000a\u000a    See http://goo.gl/EC22Yn\u000a");
	    }
	    if (this.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/KsIlge\u000a");
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._progressHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settledValue = undefined;
	    if (resolver !== INTERNAL) this._resolveFromResolver(resolver);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (typeof item === "function") {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(
	                    new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a"));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        var catchFilter = new CatchFilter(catchInstances, fn, this);
	        return this._then(undefined, catchFilter.doFilter, undefined,
	            catchFilter, undefined);
	    }
	    return this._then(undefined, fn, undefined, undefined, undefined);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflect, reflect, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject, didProgress) {
	    if (isDebugging() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, didProgress,
	        undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject, didProgress) {
	    var promise = this._then(didFulfill, didReject, didProgress,
	        undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (didFulfill, didReject) {
	    return this.all()._then(didFulfill, didReject, undefined, APPLY, undefined);
	};
	
	Promise.prototype.isCancellable = function () {
	    return !this.isResolved() &&
	        this._cancellable();
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = function(fn) {
	    var ret = new Promise(INTERNAL);
	    var result = tryCatch(fn)(nodebackForPromise(ret));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true, true);
	    }
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.defer = Promise.pending = function () {
	    var promise = new Promise(INTERNAL);
	    return new PromiseResolver(promise);
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        var val = ret;
	        ret = new Promise(INTERNAL);
	        ret._fulfillUnchecked(val);
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    var prev = async._schedule;
	    async._schedule = fn;
	    return prev;
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    didProgress,
	    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var ret = haveInternalData ? internalData : new Promise(INTERNAL);
	
	    if (!haveInternalData) {
	        ret._propagateFrom(this, 4 | 1);
	        ret._captureStackTrace();
	    }
	
	    var target = this._target();
	    if (target !== this) {
	        if (receiver === undefined) receiver = this._boundTo;
	        if (!haveInternalData) ret._setIsMigrated();
	    }
	
	    var callbackIndex = target._addCallbacks(didFulfill,
	                                             didReject,
	                                             didProgress,
	                                             ret,
	                                             receiver,
	                                             getDomain());
	
	    if (target._isResolved() && !target._isSettlePromisesQueued()) {
	        async.invoke(
	            target._settlePromiseAtPostResolution, target, callbackIndex);
	    }
	
	    return ret;
	};
	
	Promise.prototype._settlePromiseAtPostResolution = function (index) {
	    if (this._isRejectionUnhandled()) this._unsetRejectionIsUnhandled();
	    this._settlePromiseAt(index);
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 131071;
	};
	
	Promise.prototype._isFollowingOrFulfilledOrRejected = function () {
	    return (this._bitField & 939524096) > 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 536870912) === 536870912;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -131072) |
	        (len & 131071);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 536870912;
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 33554432;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 33554432) > 0;
	};
	
	Promise.prototype._cancellable = function () {
	    return (this._bitField & 67108864) > 0;
	};
	
	Promise.prototype._setCancellable = function () {
	    this._bitField = this._bitField | 67108864;
	};
	
	Promise.prototype._unsetCancellable = function () {
	    this._bitField = this._bitField & (~67108864);
	};
	
	Promise.prototype._setIsMigrated = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._unsetIsMigrated = function () {
	    this._bitField = this._bitField & (~4194304);
	};
	
	Promise.prototype._isMigrated = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0
	        ? this._receiver0
	        : this[
	            index * 5 - 5 + 4];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return index === 0
	        ? this._promise0
	        : this[index * 5 - 5 + 3];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return index === 0
	        ? this._fulfillmentHandler0
	        : this[index * 5 - 5 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return index === 0
	        ? this._rejectionHandler0
	        : this[index * 5 - 5 + 1];
	};
	
	Promise.prototype._boundValue = function() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	};
	
	Promise.prototype._migrateCallbacks = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var progress = follower._progressHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (promise instanceof Promise) promise._setIsMigrated();
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, progress, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    progress,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 131071 - 5) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        if (receiver !== undefined) this._receiver0 = receiver;
	        if (typeof fulfill === "function" && !this._isCarryingStackTrace()) {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : domain.bind(reject);
	        }
	        if (typeof progress === "function") {
	            this._progressHandler0 =
	                domain === null ? progress : domain.bind(progress);
	        }
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] = promise;
	        this[base + 4] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : domain.bind(reject);
	        }
	        if (typeof progress === "function") {
	            this[base + 2] =
	                domain === null ? progress : domain.bind(progress);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._setProxyHandlers = function (receiver, promiseSlotValue) {
	    var index = this._length();
	
	    if (index >= 131071 - 5) {
	        index = 0;
	        this._setLength(0);
	    }
	    if (index === 0) {
	        this._promise0 = promiseSlotValue;
	        this._receiver0 = receiver;
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] = promiseSlotValue;
	        this[base + 4] = receiver;
	    }
	    this._setLength(index + 1);
	};
	
	Promise.prototype._proxyPromiseArray = function (promiseArray, index) {
	    this._setProxyHandlers(promiseArray, index);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false, true);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    var propagationFlags = 1 | (shouldBind ? 4 : 0);
	    this._propagateFrom(maybePromise, propagationFlags);
	    var promise = maybePromise._target();
	    if (promise._isPending()) {
	        var len = this._length();
	        for (var i = 0; i < len; ++i) {
	            promise._migrateCallbacks(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (promise._isFulfilled()) {
	        this._fulfillUnchecked(promise._value());
	    } else {
	        this._rejectUnchecked(promise._reason(),
	            promise._getCarriedStackTrace());
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, shouldNotMarkOriginatingFromRejection) {
	    if (!shouldNotMarkOriginatingFromRejection) {
	        util.markAsOriginatingFromRejection(reason);
	    }
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason, hasStack ? undefined : trace);
	};
	
	Promise.prototype._resolveFromResolver = function (resolver) {
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = tryCatch(resolver)(function(value) {
	        if (promise === null) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }, function (reason) {
	        if (promise === null) return;
	        promise._rejectCallback(reason, synchronous);
	        promise = null;
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined && r === errorObj && promise !== null) {
	        promise._rejectCallback(r.e, true, true);
	        promise = null;
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    if (promise._isRejected()) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY && !this._isRejected()) {
	        x = tryCatch(handler).apply(this._boundValue(), value);
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    promise._popContext();
	
	    if (x === errorObj || x === promise || x === NEXT_FILTER) {
	        var err = x === promise ? makeSelfResolutionError() : x.e;
	        promise._rejectCallback(err, false, true);
	    } else {
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._cleanValues = function () {
	    if (this._cancellable()) {
	        this._cancellationParent = undefined;
	    }
	};
	
	Promise.prototype._propagateFrom = function (parent, flags) {
	    if ((flags & 1) > 0 && parent._cancellable()) {
	        this._setCancellable();
	        this._cancellationParent = parent;
	    }
	    if ((flags & 4) > 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	};
	
	Promise.prototype._fulfill = function (value) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._fulfillUnchecked(value);
	};
	
	Promise.prototype._reject = function (reason, carriedStackTrace) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._rejectUnchecked(reason, carriedStackTrace);
	};
	
	Promise.prototype._settlePromiseAt = function (index) {
	    var promise = this._promiseAt(index);
	    var isPromise = promise instanceof Promise;
	
	    if (isPromise && promise._isMigrated()) {
	        promise._unsetIsMigrated();
	        return async.invoke(this._settlePromiseAt, this, index);
	    }
	    var handler = this._isFulfilled()
	        ? this._fulfillmentHandlerAt(index)
	        : this._rejectionHandlerAt(index);
	
	    var carriedStackTrace =
	        this._isCarryingStackTrace() ? this._getCarriedStackTrace() : undefined;
	    var value = this._settledValue;
	    var receiver = this._receiverAt(index);
	    this._clearCallbackDataAtIndex(index);
	
	    if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof PromiseArray) {
	        if (!receiver._isResolved()) {
	            if (this._isFulfilled()) {
	                receiver._promiseFulfilled(value, promise);
	            }
	            else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (this._isFulfilled()) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value, carriedStackTrace);
	        }
	    }
	
	    if (index >= 4 && (index & 31) === 4)
	        async.invokeLater(this._setLength, this, 0);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    if (index === 0) {
	        if (!this._isCarryingStackTrace()) {
	            this._fulfillmentHandler0 = undefined;
	        }
	        this._rejectionHandler0 =
	        this._progressHandler0 =
	        this._receiver0 =
	        this._promise0 = undefined;
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] =
	        this[base + 4] =
	        this[base + 0] =
	        this[base + 1] =
	        this[base + 2] = undefined;
	    }
	};
	
	Promise.prototype._isSettlePromisesQueued = function () {
	    return (this._bitField &
	            -1073741824) === -1073741824;
	};
	
	Promise.prototype._setSettlePromisesQueued = function () {
	    this._bitField = this._bitField | -1073741824;
	};
	
	Promise.prototype._unsetSettlePromisesQueued = function () {
	    this._bitField = this._bitField & (~-1073741824);
	};
	
	Promise.prototype._queueSettlePromises = function() {
	    async.settlePromises(this);
	    this._setSettlePromisesQueued();
	};
	
	Promise.prototype._fulfillUnchecked = function (value) {
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._rejectUnchecked(err, undefined);
	    }
	    this._setFulfilled();
	    this._settledValue = value;
	    this._cleanValues();
	
	    if (this._length() > 0) {
	        this._queueSettlePromises();
	    }
	};
	
	Promise.prototype._rejectUncheckedCheckError = function (reason) {
	    var trace = util.ensureErrorObject(reason);
	    this._rejectUnchecked(reason, trace === reason ? undefined : trace);
	};
	
	Promise.prototype._rejectUnchecked = function (reason, trace) {
	    if (reason === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._rejectUnchecked(err);
	    }
	    this._setRejected();
	    this._settledValue = reason;
	    this._cleanValues();
	
	    if (this._isFinal()) {
	        async.throwLater(function(e) {
	            if ("stack" in e) {
	                async.invokeFirst(
	                    CapturedTrace.unhandledRejection, undefined, e);
	            }
	            throw e;
	        }, trace === undefined ? reason : trace);
	        return;
	    }
	
	    if (trace !== undefined && trace !== reason) {
	        this._setCarriedStackTrace(trace);
	    }
	
	    if (this._length() > 0) {
	        this._queueSettlePromises();
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    this._unsetSettlePromisesQueued();
	    var len = this._length();
	    for (var i = 0; i < len; i++) {
	        this._settlePromiseAt(i);
	    }
	};
	
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	_dereq_("./progress.js")(Promise, PromiseArray);
	_dereq_("./method.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	_dereq_("./bind.js")(Promise, INTERNAL, tryConvertToPromise);
	_dereq_("./finally.js")(Promise, NEXT_FILTER, tryConvertToPromise);
	_dereq_("./direct_resolve.js")(Promise);
	_dereq_("./synchronous_inspection.js")(Promise);
	_dereq_("./join.js")(Promise, PromiseArray, tryConvertToPromise, INTERNAL);
	Promise.version = "2.11.0";
	Promise.Promise = Promise;
	_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
	_dereq_('./cancel.js')(Promise);
	_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext);
	_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise);
	_dereq_('./nodeify.js')(Promise);
	_dereq_('./call_get.js')(Promise);
	_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
	_dereq_('./settle.js')(Promise, PromiseArray);
	_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
	_dereq_('./promisify.js')(Promise, INTERNAL);
	_dereq_('./any.js')(Promise);
	_dereq_('./each.js')(Promise, INTERNAL);
	_dereq_('./timers.js')(Promise, INTERNAL);
	_dereq_('./filter.js')(Promise, INTERNAL);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._progressHandler0 = value;                                         
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	        p._settledValue = value;                                             
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    CapturedTrace.setBounds(async.firstLineError, util.lastLineError);       
	    return Promise;                                                          
	
	};
	
	},{"./any.js":1,"./async.js":2,"./bind.js":3,"./call_get.js":5,"./cancel.js":6,"./captured_trace.js":7,"./catch_filter.js":8,"./context.js":9,"./debuggability.js":10,"./direct_resolve.js":11,"./each.js":12,"./errors.js":13,"./filter.js":15,"./finally.js":16,"./generators.js":17,"./join.js":18,"./map.js":19,"./method.js":20,"./nodeify.js":21,"./progress.js":22,"./promise_array.js":24,"./promise_resolver.js":25,"./promisify.js":26,"./props.js":27,"./race.js":29,"./reduce.js":30,"./settle.js":32,"./some.js":33,"./synchronous_inspection.js":34,"./thenables.js":35,"./timers.js":36,"./using.js":37,"./util.js":38}],24:[function(_dereq_,module,exports){
	
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection) {
	var util = _dereq_("./util.js");
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    var parent;
	    if (values instanceof Promise) {
	        parent = values;
	        promise._propagateFrom(parent, 1 | 4);
	    }
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        this._values = values;
	        if (values._isFulfilled()) {
	            values = values._value();
	            if (!isArray(values)) {
	                var err = new Promise.TypeError("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
	                this.__hardReject__(err);
	                return;
	            }
	        } else if (values._isPending()) {
	            values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	            return;
	        } else {
	            this._reject(values._reason());
	            return;
	        }
	    } else if (!isArray(values)) {
	        this._promise._reject(apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a")._reason());
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var promise = this._promise;
	    for (var i = 0; i < len; ++i) {
	        var isResolved = this._isResolved();
	        var maybePromise = tryConvertToPromise(values[i], promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (isResolved) {
	                maybePromise._ignoreRejections();
	            } else if (maybePromise._isPending()) {
	                maybePromise._proxyPromiseArray(this, i);
	            } else if (maybePromise._isFulfilled()) {
	                this._promiseFulfilled(maybePromise._value(), i);
	            } else {
	                this._promiseRejected(maybePromise._reason(), i);
	            }
	        } else if (!isResolved) {
	            this._promiseFulfilled(maybePromise, i);
	        }
	    }
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype.__hardReject__ =
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false, true);
	};
	
	PromiseArray.prototype._promiseProgressed = function (progressValue, index) {
	    this._promise._progress({
	        index: index,
	        value: progressValue
	    });
	};
	
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	    }
	};
	
	PromiseArray.prototype._promiseRejected = function (reason, index) {
	    this._totalResolved++;
	    this._reject(reason);
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};
	
	},{"./util.js":38}],25:[function(_dereq_,module,exports){
	
	var util = _dereq_("./util.js");
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = _dereq_("./errors.js");
	var TimeoutError = errors.TimeoutError;
	var OperationalError = errors.OperationalError;
	var haveGetters = util.haveGetters;
	var es5 = _dereq_("./es5.js");
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise) {
	    return function(err, value) {
	        if (promise === null) return;
	
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (arguments.length > 2) {
	            var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
	            promise._fulfill(args);
	        } else {
	            promise._fulfill(value);
	        }
	
	        promise = null;
	    };
	}
	
	
	var PromiseResolver;
	if (!haveGetters) {
	    PromiseResolver = function (promise) {
	        this.promise = promise;
	        this.asCallback = nodebackForPromise(promise);
	        this.callback = this.asCallback;
	    };
	}
	else {
	    PromiseResolver = function (promise) {
	        this.promise = promise;
	    };
	}
	if (haveGetters) {
	    var prop = {
	        get: function() {
	            return nodebackForPromise(this.promise);
	        }
	    };
	    es5.defineProperty(PromiseResolver.prototype, "asCallback", prop);
	    es5.defineProperty(PromiseResolver.prototype, "callback", prop);
	}
	
	PromiseResolver._nodebackForPromise = nodebackForPromise;
	
	PromiseResolver.prototype.toString = function () {
	    return "[object PromiseResolver]";
	};
	
	PromiseResolver.prototype.resolve =
	PromiseResolver.prototype.fulfill = function (value) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._resolveCallback(value);
	};
	
	PromiseResolver.prototype.reject = function (reason) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._rejectCallback(reason);
	};
	
	PromiseResolver.prototype.progress = function (value) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._progress(value);
	};
	
	PromiseResolver.prototype.cancel = function (err) {
	    this.promise.cancel(err);
	};
	
	PromiseResolver.prototype.timeout = function () {
	    this.reject(new TimeoutError("timeout"));
	};
	
	PromiseResolver.prototype.isResolved = function () {
	    return this.promise.isResolved();
	};
	
	PromiseResolver.prototype.toJSON = function () {
	    return this.promise.toJSON();
	};
	
	module.exports = PromiseResolver;
	
	},{"./errors.js":13,"./es5.js":14,"./util.js":38}],26:[function(_dereq_,module,exports){
	
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = _dereq_("./util.js");
	var nodebackForPromise = _dereq_("./promise_resolver.js")
	    ._nodebackForPromise;
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = _dereq_("./errors").TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/iWrZbw\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (false) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL","                            \n\
	        var ret = function (Parameters) {                                    \n\
	                                                                \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise);                      \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	        "
	        .replace("Parameters", parameterDeclaration(newParameterCount))
	        .replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode))(
	            Promise,
	            fn,
	            receiver,
	            withAppended,
	            maybeWrapAsError,
	            nodebackForPromise,
	            util.tryCatch,
	            util.errorObj,
	            util.notEnumerableProp,
	            INTERNAL
	        );
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key, fn, suffix);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver) {
	    return makeNodePromisified(callback, receiver, undefined, callback);
	}
	
	Promise.promisify = function (fn, receiver) {
	    if (typeof fn !== "function") {
	        throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    var ret = promisify(fn, arguments.length < 2 ? THIS : receiver);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/9ITlV0\u000a");
	    }
	    options = Object(options);
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/8FZo5V\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier);
	            promisifyAll(value, suffix, filter, promisifier);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier);
	};
	};
	
	
	},{"./errors":13,"./promise_resolver.js":25,"./util.js":38}],27:[function(_dereq_,module,exports){
	
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = _dereq_("./util.js");
	var isObject = util.isObject;
	var es5 = _dereq_("./es5.js");
	
	function PropertiesPromiseArray(obj) {
	    var keys = es5.keys(obj);
	    var len = keys.length;
	    var values = new Array(len * 2);
	    for (var i = 0; i < len; ++i) {
	        var key = keys[i];
	        values[i] = obj[key];
	        values[i + len] = key;
	    }
	    this.constructor$(values);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {
	    this._init$(undefined, -3) ;
	};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val = {};
	        var keyOffset = this.length();
	        for (var i = 0, len = this.length(); i < len; ++i) {
	            val[this._values[i + keyOffset]] = this._values[i];
	        }
	        this._resolve(val);
	    }
	};
	
	PropertiesPromiseArray.prototype._promiseProgressed = function (value, index) {
	    this._promise._progress({
	        key: this._values[index + this.length()],
	        value: value
	    });
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/OsFKC8\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 4);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};
	
	},{"./es5.js":14,"./util.js":38}],28:[function(_dereq_,module,exports){
	
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype._unshiftOne = function(value) {
	    var capacity = this._capacity;
	    this._checkCapacity(this.length() + 1);
	    var front = this._front;
	    var i = (((( front - 1 ) &
	                    ( capacity - 1) ) ^ capacity ) - capacity );
	    this[i] = value;
	    this._front = i;
	    this._length = this.length() + 1;
	};
	
	Queue.prototype.unshift = function(fn, receiver, arg) {
	    this._unshiftOne(arg);
	    this._unshiftOne(receiver);
	    this._unshiftOne(fn);
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;
	
	},{}],29:[function(_dereq_,module,exports){
	
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var isArray = _dereq_("./util.js").isArray;
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else if (!isArray(promises)) {
	        return apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 4 | 1);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};
	
	},{"./util.js":38}],30:[function(_dereq_,module,exports){
	
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	function ReductionPromiseArray(promises, fn, accum, _each) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    this._preservedValues = _each === INTERNAL ? [] : null;
	    this._zerothIsAccum = (accum === undefined);
	    this._gotAccum = false;
	    this._reducingIndex = (this._zerothIsAccum ? 1 : 0);
	    this._valuesPhase = undefined;
	    var maybePromise = tryConvertToPromise(accum, this._promise);
	    var rejected = false;
	    var isPromise = maybePromise instanceof Promise;
	    if (isPromise) {
	        maybePromise = maybePromise._target();
	        if (maybePromise._isPending()) {
	            maybePromise._proxyPromiseArray(this, -1);
	        } else if (maybePromise._isFulfilled()) {
	            accum = maybePromise._value();
	            this._gotAccum = true;
	        } else {
	            this._reject(maybePromise._reason());
	            rejected = true;
	        }
	    }
	    if (!(isPromise || this._zerothIsAccum)) this._gotAccum = true;
	    var domain = getDomain();
	    this._callback = domain === null ? fn : domain.bind(fn);
	    this._accum = accum;
	    if (!rejected) async.invoke(init, this, undefined);
	}
	function init() {
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._init = function () {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function () {
	    if (this._gotAccum || this._zerothIsAccum) {
	        this._resolve(this._preservedValues !== null
	                        ? [] : this._accum);
	    }
	};
	
	ReductionPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    values[index] = value;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var isEach = preservedValues !== null;
	    var gotAccum = this._gotAccum;
	    var valuesPhase = this._valuesPhase;
	    var valuesPhaseIndex;
	    if (!valuesPhase) {
	        valuesPhase = this._valuesPhase = new Array(length);
	        for (valuesPhaseIndex=0; valuesPhaseIndex<length; ++valuesPhaseIndex) {
	            valuesPhase[valuesPhaseIndex] = 0;
	        }
	    }
	    valuesPhaseIndex = valuesPhase[index];
	
	    if (index === 0 && this._zerothIsAccum) {
	        this._accum = value;
	        this._gotAccum = gotAccum = true;
	        valuesPhase[index] = ((valuesPhaseIndex === 0)
	            ? 1 : 2);
	    } else if (index === -1) {
	        this._accum = value;
	        this._gotAccum = gotAccum = true;
	    } else {
	        if (valuesPhaseIndex === 0) {
	            valuesPhase[index] = 1;
	        } else {
	            valuesPhase[index] = 2;
	            this._accum = value;
	        }
	    }
	    if (!gotAccum) return;
	
	    var callback = this._callback;
	    var receiver = this._promise._boundValue();
	    var ret;
	
	    for (var i = this._reducingIndex; i < length; ++i) {
	        valuesPhaseIndex = valuesPhase[i];
	        if (valuesPhaseIndex === 2) {
	            this._reducingIndex = i + 1;
	            continue;
	        }
	        if (valuesPhaseIndex !== 1) return;
	        value = values[i];
	        this._promise._pushContext();
	        if (isEach) {
	            preservedValues.push(value);
	            ret = tryCatch(callback).call(receiver, value, i, length);
	        }
	        else {
	            ret = tryCatch(callback)
	                .call(receiver, this._accum, value, i, length);
	        }
	        this._promise._popContext();
	
	        if (ret === errorObj) return this._reject(ret.e);
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (maybePromise._isPending()) {
	                valuesPhase[i] = 4;
	                return maybePromise._proxyPromiseArray(this, i);
	            } else if (maybePromise._isFulfilled()) {
	                ret = maybePromise._value();
	            } else {
	                return this._reject(maybePromise._reason());
	            }
	        }
	
	        this._reducingIndex = i + 1;
	        this._accum = ret;
	    }
	
	    this._resolve(isEach ? preservedValues : this._accum);
	};
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	};
	
	},{"./async.js":2,"./util.js":38}],31:[function(_dereq_,module,exports){
	
	var schedule;
	var util = _dereq_("./util");
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
	};
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            window.navigator.standalone)) {
	    schedule = function(fn) {
	        var div = document.createElement("div");
	        var observer = new MutationObserver(fn);
	        observer.observe(div, {attributes: true});
	        return function() { div.classList.toggle("foo"); };
	    };
	    schedule.isStatic = true;
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	},{"./util":38}],32:[function(_dereq_,module,exports){
	
	module.exports =
	    function(Promise, PromiseArray) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = _dereq_("./util.js");
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	    }
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 268435456;
	    ret._settledValue = value;
	    this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 134217728;
	    ret._settledValue = reason;
	    this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return new SettledPromiseArray(this).promise();
	};
	};
	
	},{"./util.js":38}],33:[function(_dereq_,module,exports){
	
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = _dereq_("./util.js");
	var RangeError = _dereq_("./errors.js").RangeError;
	var AggregateError = _dereq_("./errors.js").AggregateError;
	var isArray = util.isArray;
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	    }
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            e.push(this._values[i]);
	        }
	        this._reject(e);
	    }
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/1wAmHx\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};
	
	},{"./errors.js":13,"./util.js":38}],34:[function(_dereq_,module,exports){
	
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValue = promise._settledValue;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValue = undefined;
	    }
	}
	
	PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
	    }
	    return this._settledValue;
	};
	
	PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
	    }
	    return this._settledValue;
	};
	
	PromiseInspection.prototype.isFulfilled =
	Promise.prototype._isFulfilled = function () {
	    return (this._bitField & 268435456) > 0;
	};
	
	PromiseInspection.prototype.isRejected =
	Promise.prototype._isRejected = function () {
	    return (this._bitField & 134217728) > 0;
	};
	
	PromiseInspection.prototype.isPending =
	Promise.prototype._isPending = function () {
	    return (this._bitField & 402653184) === 0;
	};
	
	PromiseInspection.prototype.isResolved =
	Promise.prototype._isResolved = function () {
	    return (this._bitField & 402653184) > 0;
	};
	
	Promise.prototype.isPending = function() {
	    return this._target()._isPending();
	};
	
	Promise.prototype.isRejected = function() {
	    return this._target()._isRejected();
	};
	
	Promise.prototype.isFulfilled = function() {
	    return this._target()._isFulfilled();
	};
	
	Promise.prototype.isResolved = function() {
	    return this._target()._isResolved();
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue;
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue;
	};
	
	Promise.prototype.value = function() {
	    var target = this._target();
	    if (!target.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
	    }
	    return target._settledValue;
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    if (!target.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
	    }
	    target._unsetRejectionIsUnhandled();
	    return target._settledValue;
	};
	
	
	Promise.PromiseInspection = PromiseInspection;
	};
	
	},{}],35:[function(_dereq_,module,exports){
	
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util.js");
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) {
	            return obj;
	        }
	        else if (isAnyBluebirdPromise(obj)) {
	            var ret = new Promise(INTERNAL);
	            obj._then(
	                ret._fulfillUnchecked,
	                ret._rejectUncheckedCheckError,
	                ret._progressUnchecked,
	                ret,
	                null
	            );
	            return ret;
	        }
	        var then = util.tryCatch(getThen)(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function getThen(obj) {
	    return obj.then;
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    return hasProp.call(obj, "_promise0");
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x,
	                                        resolveFromThenable,
	                                        rejectFromThenable,
	                                        progressFromThenable);
	    synchronous = false;
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolveFromThenable(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function rejectFromThenable(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	
	    function progressFromThenable(value) {
	        if (!promise) return;
	        if (typeof promise._progress === "function") {
	            promise._progress(value);
	        }
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};
	
	},{"./util.js":38}],36:[function(_dereq_,module,exports){
	
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util.js");
	var TimeoutError = Promise.TimeoutError;
	
	var afterTimeout = function (promise, message) {
	    if (!promise.isPending()) return;
	    
	    var err;
	    if(!util.isPrimitive(message) && (message instanceof Error)) {
	        err = message;
	    } else {
	        if (typeof message !== "string") {
	            message = "operation timed out";
	        }
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._cancel(err);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (value, ms) {
	    if (ms === undefined) {
	        ms = value;
	        value = undefined;
	        var ret = new Promise(INTERNAL);
	        setTimeout(function() { ret._fulfill(); }, ms);
	        return ret;
	    }
	    ms = +ms;
	    return Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(this, ms);
	};
	
	function successClear(value) {
	    var handle = this;
	    if (handle instanceof Number) handle = +handle;
	    clearTimeout(handle);
	    return value;
	}
	
	function failureClear(reason) {
	    var handle = this;
	    if (handle instanceof Number) handle = +handle;
	    clearTimeout(handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret = this.then().cancellable();
	    ret._cancellationParent = this;
	    var handle = setTimeout(function timeoutTimeout() {
	        afterTimeout(ret, message);
	    }, ms);
	    return ret._then(successClear, failureClear, undefined, handle, undefined);
	};
	
	};
	
	},{"./util.js":38}],37:[function(_dereq_,module,exports){
	
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext) {
	    var TypeError = _dereq_("./errors.js").TypeError;
	    var inherits = _dereq_("./util.js").inherits;
	    var PromiseInspection = Promise.PromiseInspection;
	
	    function inspectionMapper(inspections) {
	        var len = inspections.length;
	        for (var i = 0; i < len; ++i) {
	            var inspection = inspections[i];
	            if (inspection.isRejected()) {
	                return Promise.reject(inspection.error());
	            }
	            inspections[i] = inspection._settledValue;
	        }
	        return inspections;
	    }
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = Promise.defer();
	        function iterator() {
	            if (i >= len) return ret.resolve();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret.promise;
	    }
	
	    function disposerSuccess(value) {
	        var inspection = new PromiseInspection();
	        inspection._settledValue = value;
	        inspection._bitField = 268435456;
	        return dispose(this, inspection).thenReturn(value);
	    }
	
	    function disposerFail(reason) {
	        var inspection = new PromiseInspection();
	        inspection._settledValue = reason;
	        inspection._bitField = 134217728;
	        return dispose(this, inspection).thenThrow(reason);
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return null;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== null
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new Array(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var promise = Promise.settle(resources)
	            .then(inspectionMapper)
	            .then(function(vals) {
	                promise._pushContext();
	                var ret;
	                try {
	                    ret = spreadArgs
	                        ? fn.apply(undefined, vals) : fn.call(undefined,  vals);
	                } finally {
	                    promise._popContext();
	                }
	                return ret;
	            })
	            ._then(
	                disposerSuccess, disposerFail, undefined, resources, undefined);
	        resources.promise = promise;
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 262144;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 262144) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~262144);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};
	
	},{"./errors.js":13,"./util.js":38}],38:[function(_dereq_,module,exports){
	
	var es5 = _dereq_("./es5.js");
	var canEvaluate = typeof navigator == "undefined";
	var haveGetters = (function(){
	    try {
	        var o = {};
	        es5.defineProperty(o, "f", {
	            get: function () {
	                return 3;
	            }
	        });
	        return o.f === 3;
	    }
	    catch (e) {
	        return false;
	    }
	
	})();
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return !isPrimitive(value);
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function f() {}
	    f.prototype = obj;
	    var l = 8;
	    while (l--) new f();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return obj instanceof Error && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    haveGetters: haveGetters,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]"
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	},{"./es5.js":14}]},{},[4])(4)
	});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js"), (function() { return this; }())))

/***/ },

/***/ "./components/xo-tracking/dist/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	/**
	 * xo-tracking encapsulates all the details about instrumentation
	 * and only register event listeners during bootstrap
	 *
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/xo-tracking/dist/listener.js"), __webpack_require__("./components/xo-tracking/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    // Declare the dependency to register the listeners
	    return angular.module('tracking', ['tracking.listener', 'tracking.directive']);
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-tracking/dist/listener.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(console) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-tracking/dist/fpti.js"), __webpack_require__("./components/xo-tracking/dist/button.js"), __webpack_require__("./components/xo-models/src/auth/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, $) {
	    angular.module('tracking.listener', ['beaver', 'tracking.fpti', 'button.tracking']).run(function ($rootScope, $logger, $CalDataModel, $AuthModel, $fpti, $fptiError, $FptiConstants, $ButtonTrackingService, $timeout, $FptiBuilder, $meta, $config, $experiment, $util) {
	
	        function logTransition(state) {
	            return !(state.trackingData && state.trackingData.suppressTransitionLog);
	        }
	
	        function logStateExit(state) {
	            return state.trackingData && state.trackingData.trackStateExit;
	        }
	
	        function getBeaconUrl() {
	            // Logic to switch between production/staging urls. This way we don't pollute live logs,
	            // and we are able to test on stage using the fpti log viewing tool.
	            return $config.deploy.isLocal() || $config.deploy.isStage() ? 'https://tracking.qa.paypal.com/webapps/tracking/ts' // stage url
	            : $config.urls && $config.urls.fptiBeaconUrl;
	        }
	
	        /*
	         * Triggers pa.js recordClick with custom parameters
	         */
	        function fptiCustomRecordClick(route, customData) {
	            var analyticsInstance, fptiData, pxpData, fptiDataObj;
	            var PAYPAL = window.PAYPAL;
	
	            if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
	                PAYPAL.core = PAYPAL.core || {};
	
	                analyticsInstance = new PAYPAL.analytics.Analytics();
	
	                fptiData = new $FptiBuilder({
	                    trackingData: route.trackingData,
	                    isInContext: $rootScope.miniBrowser
	                    // ... Other flow data pass-in here to resolve page qualifier
	                }).build();
	
	                // Add the pxp data in fptiData as custom Attributes
	                fptiDataObj = fptiData._dataObj;
	                if (fptiDataObj) {
	                    pxpData = {
	                        qc: fptiDataObj.qc,
	                        qt: fptiDataObj.qt,
	                        xe: fptiDataObj.xe,
	                        xt: fptiDataObj.xt
	                    };
	                    $.extend(customData, pxpData);
	                }
	
	                analyticsInstance.setRequestData(customData);
	                analyticsInstance.recordClick({
	                    url: getBeaconUrl()
	                });
	            }
	        }
	
	        $rootScope.$on('trackInput', function (event, trackInput) {
	            if (!trackInput) {
	                return;
	            }
	            var customData = {
	                link: trackInput.transition,
	                page: trackInput.page
	            };
	
	            fptiCustomRecordClick(trackInput.currentRoute, customData);
	        });
	
	        $rootScope.$on('trackSubmit', function (event, trackSubmit) {
	            if (!trackSubmit) {
	                return;
	            }
	            var currentRoute = trackSubmit.currentRoute;
	            var routeName = currentRoute ? currentRoute.name : 'noRoute';
	
	            $logger.info('track_submit', {
	                route_name: routeName
	                // ID stuff here later
	            });
	
	            if (logTransition(currentRoute)) {
	                routeName = routeName.replace(/\./g, '_');
	                var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
	                var transition = trackSubmit.transition || state;
	
	                $logger.info(routeName + '_exit', {
	                    fptiState: state,
	                    fptiTransition: transition
	                });
	            }
	
	            var errors = trackSubmit.errors;
	            if (angular.isArray(errors)) {
	                errors.forEach(function (err) {
	                    $logger.debug('track_submit_error', err);
	                    if ($fpti) {
	                        $fpti.setupDataString(currentRoute, new $fptiError({
	                            type: 'fieldError',
	                            field: err.fieldName,
	                            code: err.errorMessage
	                        }));
	                    }
	                });
	
	                if (errors.length) {
	                    $logger.flush(true);
	                }
	            }
	        });
	
	        $rootScope.$on('unhandled_error', function (event, exception) {
	            if ($fpti) {
	                $fpti.setupDataString(exception.currentRoute, new $fptiError({
	                    type: 'pageError',
	                    message: exception.message,
	                    code: exception.cause
	                }));
	            }
	        });
	
	        $rootScope.$on('trackLink', function (event, trackLink) {
	            if (!trackLink) {
	                return;
	            }
	
	            var currentRoute = trackLink.currentRoute;
	            var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
	            var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
	
	            $logger.info(routeName + '_exit', {
	                fptiState: state,
	                fptiTransition: trackLink.transition
	            });
	        });
	
	        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
	
	            var from = fromState.name.replace(/\./g, '_');
	            var to = toState.name.replace(/\./g, '_');
	            if (from && logTransition(fromState) && logStateExit(fromState)) {
	                var trackingData = fromState.trackingData && fromState.trackingData || {};
	                $logger.info(from + '_exit', { fptiState: trackingData.fptiState || from, fptiTransition: trackingData.fptiState || from });
	            }
	
	            $logger.info('state_change', {
	                from: from || 'start',
	                to: to || 'end'
	            });
	
	            // Generate a new CAL correlation_id to be shared until next flow transition (only for view states)
	            if (toState.template) {
	                $CalDataModel.generateMetaIds();
	            }
	
	            $rootScope.currentState = to;
	
	            if (to && logTransition(toState)) {
	                $logger.info(to + '_enter', { fptiState: toState.trackingData && toState.trackingData.fptiState || to });
	            }
	        });
	
	        $rootScope.$on('page_loaded', function (event, from, to) {
	            if (from !== 'checkout_init') {
	                return;
	            }
	            var key = $FptiConstants.stateName[to] || 'review';
	            var landing_page = $FptiConstants.landing_page[key];
	            $logger.info('landing_page', {
	                'from': landing_page,
	                'to': 'process_page_loaded',
	                fpti_landing_page: landing_page
	            });
	        });
	
	        $rootScope.$on('page_reloaded', function () {
	            $logger.flush(true);
	            $CalDataModel.generateMetaIds();
	        });
	
	        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
	            var to = toState.name.replace(/\./g, '_');
	            if (toState.hasResolver && to) {
	                $logger.info(to + '_load');
	            } else if (to) {
	                $logger.info(to + '_rendering');
	            }
	        });
	
	        $rootScope.$on('addrDiff', function (event, addrDiff) {
	            if (!addrDiff) {
	                return;
	            }
	
	            $logger.info('checkout_fpti', addrDiff);
	        });
	
	        function getHash(url) {
	            if (!url || !~url.indexOf('#')) {
	                // eslint-disable-line no-bitwise
	                return;
	            }
	
	            url = url.split('#');
	            return url[url.length - 1];
	        }
	
	        var oldHash = window.location.hash;
	
	        window.addEventListener('hashchange', function (event) {
	            $logger.info('hashchange', {
	                from: getHash(event.oldURL || oldHash),
	                to: getHash(event.newURL || window.location.hash)
	            });
	            oldHash = window.location.hash;
	        });
	
	        $(document).on('click', function (event) {
	            if (event && event.target && event.target.tagName) {
	                var name = event.target.tagName.toLowerCase();
	
	                if (event.target.id) {
	                    name += '#' + event.target.id;
	                } else if (event.target.attributes && event.target.attributes['ng-model']) {
	                    name += ':' + event.target.attributes['ng-model'].value;
	                } else if (event.target.className) {
	                    name += '.' + event.target.className.split(' ').join('.');
	                }
	
	                $logger.info('click', {
	                    el: name
	                });
	            }
	        });
	
	        var cplSettings = $config.enableCPL;
	
	        var token = window.meta.token;
	
	        var addTrackingData = function addTrackingData(object) {
	            return $util.extend(object, {
	                dc: $meta.dc,
	                az: $meta.az,
	                cust: $AuthModel.instance().buyer_id || '',
	                comp: 'hermesnodeweb'
	            });
	        };
	
	        var passesCplThrottle = cplSettings && (typeof cplSettings.throttle === 'undefined' || $experiment('cpl_tracking', cplSettings.throttle, token));
	
	        if (passesCplThrottle || $util.params().forceEnableCPL) {
	
	            window.fptiserverurl = getBeaconUrl();
	
	            var firstInvocation = true;
	            var trackPageStart = function trackPageStart() {
	                if (firstInvocation) {
	                    firstInvocation = false;
	                    return;
	                }
	                try {
	                    window.PAYPAL.analytics.startCPLTracking();
	                } catch (e) {
	                    console.log('error starting cpl tracking', e);
	                }
	            };
	
	            var firstDone = true;
	            var trackDone = function trackDone(beaconData) {
	                window.PAYPAL.analytics.endCPLTracking({
	                    pageData: addTrackingData(beaconData),
	                    inferStart: firstDone
	                });
	                firstDone = false;
	            };
	
	            var currentRoute = null;
	
	            $rootScope.$on('startLoad', function () {
	                return trackPageStart();
	            });
	
	            $rootScope.$on('$stateChangeSuccess', function (e, route) {
	                currentRoute = route;
	            });
	
	            $rootScope.$on('allLoaded', function () {
	                try {
	                    var buildParams = {
	                        productOverride: window.fptiProductOverride,
	                        trackingData: $fpti.getPageTrackingData(currentRoute)
	                    };
	
	                    var legacyFptiData = new $FptiBuilder(buildParams).build()._dataObj;
	
	                    var product = window.fptiProductOverride || 'ec';
	                    legacyFptiData.pgrp = 'main:' + product + ':hermes';
	
	                    legacyFptiData.flid = token;
	
	                    trackDone(legacyFptiData);
	                } catch (e) {
	                    console.log('error tracking CPL data', e);
	                }
	            });
	        } else {
	            $rootScope.$on('$transition', function (event, data) {
	
	                $timeout(function () {
	                    if ($fpti) {
	                        var fptiData = $fpti.setupDataString(data.toState, null, addTrackingData({
	                            transition_time: data.duration
	                        }));
	
	                        // Fire and forget button tracking beacon.
	                        $ButtonTrackingService.fireBeacon(fptiData);
	                    }
	                });
	            });
	        }
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./components/xo-tracking/dist/fpti.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-tracking/dist/builder.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.fpti', ['squid', 'tracking.builder']).factory('$fpti', function ($config, $FptiBuilder, $rootScope, $window, $util) {
	
	        var _beaconUrl;
	
	        // Logic to switch between production/staging urls. This way we don't pollute live logs,
	        // and we are able to test on stage using the fpti log viewing tool.
	        if ($config.deploy.isLocal() || $config.deploy.isStage()) {
	            _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
	        } else {
	            _beaconUrl = $config.urls && $config.urls.fptiBeaconUrl;
	        }
	
	        return {
	            // Get all the tracking data defined at the page level
	            getPageTrackingData: function getPageTrackingData(route) {
	                route = route || {};
	
	                var trackingData = route.trackingData || {};
	                var routeParent = route.parent;
	
	                trackingData.token = $rootScope.token;
	
	                while (routeParent) {
	                    trackingData = angular.merge({}, routeParent.trackingData || {}, trackingData);
	                    routeParent = routeParent.parent;
	                }
	                return trackingData;
	            },
	
	            setupDataString: function setupDataString(route, err, data) {
	
	                var trackingData = this.getPageTrackingData(route);
	                var fptiData;
	
	                var PAYPAL = window.PAYPAL;
	                if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
	                    PAYPAL.core = PAYPAL.core || {};
	
	                    var payload = {
	                        trackingData: trackingData,
	                        error: err,
	                        isInContext: $rootScope.miniBrowser
	                    };
	
	                    angular.extend(payload, data || {});
	
	                    fptiData = new $FptiBuilder(payload).build().toString();
	
	                    // FPTI client side tracking only if we have template
	                    if (route && route.template && typeof PAYPAL.analytics.setup === 'function') {
	                        PAYPAL.core.pta = PAYPAL.analytics.setup({
	                            data: fptiData,
	                            url: _beaconUrl
	                        });
	                    }
	                }
	
	                return fptiData;
	            }
	        };
	    }).factory('$fptiError', function ($Error) {
	        function stringifyErrorMessage(msg) {
	            return encodeURIComponent(angular.isString(msg) ? msg.split('\n').slice(0, 2).join('@') // Get the first two lines of stack
	            : (angular.toJson(msg) || 'undefined').substring(0, 128));
	        }
	
	        return $Error.extend({
	            construct: function construct(err) {
	                if (!err) {
	                    return;
	                }
	                this.type = err.type;
	                this.field = err.field;
	                this.msg = stringifyErrorMessage(err.message || err.error);
	                this.code = err.code || err.cause;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/fpti.js"))

/***/ },

/***/ "./components/xo-tracking/dist/builder.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-tracking/dist/model.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('tracking.builder', ['squid', 'tracking.model']).factory('$FptiBuilder', function ($Class, $locale, $rootScope, $FptiConstants, $FptiDataModel, $CalDataModel, $util, $getLatestCorrelationID) {
	        /**
	         *  Build the front-end FPTI event from three data sources
	         *      1. the per-product configuration
	         *      2. the buzname defined per-route
	         *      3. the additional attributes that only available at a specific checkpoint
	         *
	         */
	
	        return $Class.extend('FptiBuilder', {
	
	            resolvePageQualifier: function resolvePageQualifier(trackingData) {
	                // The pages can populated pageQualifier to override the default one
	                this.pageQualifier = trackingData && trackingData.pageQualifier ? trackingData.pageQualifier
	                // because 'fullpage' has been widely embedded into routes
	                // we had better to keep it as a place holder
	                : 'fullpage'; // update later if it's in-context
	            },
	
	            build: function build() {
	
	                if (!this.trackingData && !this.error) {
	                    // do nothing if neither page nor error tracking
	                    return this;
	                }
	
	                this.resolvePageQualifier(this.trackingData);
	
	                this._dataObj = new $FptiDataModel().decorate('buzname', this.trackingData, this.pageQualifier, undefined, this.productOverride).decorate('templateName', this.trackingData, this.pageQualifier).decorate('locale', $locale).decorate('pageGoal', this.trackingData.pageGoal).decorate('ecToken', this.trackingData.token).decorate('correlationId', $getLatestCorrelationID()).decorate('uuid', $CalDataModel.getUUID()).decorate('fieldError', this.error).decorate('pageError', this.error).decorate('pageStartTime', new Date().getTime()).decorate('pxptrackingdata', this.trackingData.pxpData).decorate('transition_time', this.transition_time).decorate('cust', this.cust).decorate('dc', this.dc).decorate('az', this.az).decorate('comp', this.comp).getDataObject(this.isInContext);
	
	                return this;
	            },
	
	            toString: function toString() {
	
	                var dataAry = [];
	                angular.forEach(this._dataObj, function (v, k) {
	                    dataAry.push(k + '=' + v);
	                });
	
	                return dataAry.join('&');
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/builder.js"))

/***/ },

/***/ "./components/xo-tracking/dist/button.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('button.tracking', ['squid', 'xomodel.checkout']).factory('$ButtonTrackingService', function ($rootScope, $http, $populate, $CheckoutAppDataModel, $CheckoutPayeeModel, $meta, $cookies) {
	
	        var _beaconUrl = 'https://www.paypalobjects.com/en_US/i/scr/btn_tracking_pixel.gif?teal=null&Id=null&ru=null';
	        var _beaconParams = ['fltk', 'calc', 'page', 'xe', 'xt'];
	        var _alreadyFired = false;
	
	        function _strToElements(str) {
	            var elements = {};
	            if (str && str.length) {
	                str.split('&').forEach(function (param) {
	                    var nvp = param.split('=');
	                    elements[nvp[0]] = nvp[1];
	                });
	            }
	            return elements;
	        }
	
	        function _fireButtonTrackingBeacon(elements) {
	            var url = _beaconUrl;
	            var xoData = {};
	
	            function buildParam(param, value) {
	                var p = '&' + param + '=' + (value ? value : 'null');
	                return p;
	            }
	
	            function getGUIID(ts) {
	                return _strToElements(ts).vr;
	            }
	
	            function addToDocument(uri) {
	                var img = document.createElement('img');
	                img.setAttribute('src', uri);
	                document.body.appendChild(img);
	            }
	
	            // Get some params from FPTI data.
	            _beaconParams.forEach(function (param) {
	                url += buildParam(param, elements[param]);
	            });
	
	            // Build the rest of the params.
	            url += buildParam('fpti', getGUIID($cookies && $cookies.ts));
	            url += buildParam('WWW_AKA_MVT_BUTTONS', $cookies && $cookies.WWW_AKA_MVT_BUTTONS);
	            url += buildParam('WWW_AKA_MVT_ID', $cookies && $cookies.WWW_AKA_MVT_ID);
	            url += buildParam('ip', $meta && $meta.ipaddress);
	
	            if ($rootScope.token) {
	                $populate(xoData, {
	                    payee: $CheckoutPayeeModel.instance($rootScope.token),
	                    appData: $CheckoutAppDataModel.instance($rootScope.token)
	                }).then(function () {
	                    url += buildParam('mrid', xoData.payee && xoData.payee.getId());
	                    url += buildParam('calf', xoData.appData && xoData.appData.flow_id);
	
	                    addToDocument(url);
	                });
	            } else {
	                url += buildParam('mrid', null);
	                url += buildParam('calf', null);
	                addToDocument(url);
	            }
	        }
	
	        return {
	            fireBeacon: function fireBeacon(fptiData) {
	                if (!_alreadyFired && fptiData) {
	                    var elements = _strToElements(fptiData);
	
	                    // Fire the beacon if this is a page render.
	                    if (elements.page) {
	                        _alreadyFired = true;
	                        return _fireButtonTrackingBeacon(elements);
	                    }
	                }
	            },
	            resetAlreadyFired: function resetAlreadyFired() {
	                _alreadyFired = false;
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-tracking/dist", "components/xo-tracking/dist/button.js"))

/***/ },

/***/ "./components/xo-tracking/dist/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular) {
	
	    angular.module('tracking.directive', ['ui.router']).directive('trackSubmit', function ($state, $rootScope) {
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('mousedown', function (event) {
	                    var transition = attr && attr.trackSubmit;
	
	                    var trackSubmit = {
	                        currentRoute: $state.current,
	                        transition: transition,
	                        errors: []
	                    };
	                    angular.forEach($('input.ng-invalid, select.ng-invalid'), function (el) {
	                        var modelName = $(el).attr('ng-model');
	                        var errorKey = $(el).attr('data-error-key');
	                        var errorText = $(el).has('required') ? 'required' : 'no error key';
	
	                        trackSubmit.errors.push({
	                            fieldName: modelName ? modelName : 'no-model',
	                            errorMessage: errorKey ? errorKey : errorText
	                        });
	                    });
	
	                    $rootScope.$broadcast('trackSubmit', trackSubmit);
	                });
	            }
	        };
	    }).directive('trackLink', function ($state, $rootScope) {
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('mousedown', function (event) {
	
	                    var state = attr && attr.trackLink;
	
	                    if (state) {
	                        var trackLink = {
	                            currentRoute: $state.current,
	                            transition: state
	                        };
	                        $rootScope.$broadcast('trackLink', trackLink);
	                    }
	                });
	            }
	        };
	    }).directive('trackInput', function ($state, $rootScope) {
	        /*
	         * Track an input tag with track-input attribute
	         * you can use the value of track-input attribute as
	         * a tracking attr Eg.: track-input="xo_guest_yes"
	         */
	        return {
	            restrict: 'AE',
	            link: function link($scope, element, attr) {
	                element.on('click', function (event) {
	
	                    var state;
	
	                    if (event.target.type === 'checkbox') {
	                        if (event.target.checked) {
	                            state = attr && attr.trackInput + '_CHECKED';
	                        } else {
	                            state = attr && attr.trackInput + '_UNCHECKED';
	                        }
	                    } else {
	                        state = attr && attr.trackInput;
	                    }
	
	                    var trackInput = {
	                        currentRoute: $state.current,
	                        page: 'main:ec:hermes::fullpage-billing:guest:aries:'
	                    };
	
	                    if (state) {
	                        trackInput.transition = state;
	                    }
	
	                    $rootScope.$broadcast('trackInput', trackInput);
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./pages/xo-landing/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$LandingRoute = undefined;
	
	__webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-models/src/auth/index.js");
	
	__webpack_require__("./components/xo-models/src/shippingMethod/index.js");
	
	__webpack_require__("./components/xo-models/src/inventory/index.js");
	
	var _venmoInfo = __webpack_require__("./components/xo-venmo-components/src/venmo-info/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('$LandingRoute', {
	
	    path: 'landing',
	
	    trackingData: {
	        fptiState: 'landing',
	        trackStateExit: true
	    },
	
	    auth: false,
	
	    resolve: {
	
	        action: function action($window, $feature, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutPayeeModel, $ShippingRuleSummaryModel, $Class, $experiment, $rootScope, $state, $populate, $logger, $q, $config, $AuthModel, $FallbackError, $util, $dispatch, $locale, $pxp, $InventoryModel, $InstallmentOptionsModel, $CreditDataModel, $FlowEligibilityModel) {
	
	            var models = {};
	
	            return $populate(models, {
	                checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
	                checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                auth: $AuthModel.instance(),
	                checkoutPayeeModel: $CheckoutPayeeModel.instance($rootScope.token),
	                flowEligibility: $FlowEligibilityModel.instance($rootScope.token).retrieve({
	                    params: {
	                        localeCountry: $locale.country // We need this till we completely migrate to server side locale resolution
	                    }
	                })
	            }).then(function () {
	                var forced_signup_offered = models.flowEligibility.guest ? 0 : 1;
	                $logger.info('checkout_fpti', { 'from': 'LANDING_PAGE_PARAM', 'forced_signup_offered': forced_signup_offered });
	
	                var landingFlow = function landingFlow() {
	                    var merchantCountry = models.checkoutAppData.get('merchant.merchant_country', 'US');
	                    var supportBlockNonDomesticShipping = $feature('supportBlockNonDomesticShipping', false, merchantCountry);
	                    var prefillShippingAddress = models.checkoutCart.get('purchase.shipping_address');
	                    var blockNonDomesticShipping = models.checkoutAppData.get('flags.block_non_domestic_shipping');
	                    var allowChangeShipping = models.checkoutAppData.get('flags.allow_change_shipping');
	
	                    if (supportBlockNonDomesticShipping && blockNonDomesticShipping) {
	                        $logger.info('block_non_domestic_shipping', {
	                            block_non_domestic_shipping: blockNonDomesticShipping,
	                            allow_change_shipping: allowChangeShipping,
	                            setec_shipping_country_code: prefillShippingAddress
	                        });
	                    }
	
	                    var shouldBlockBuyer = supportBlockNonDomesticShipping && blockNonDomesticShipping && !allowChangeShipping && prefillShippingAddress && prefillShippingAddress.country_code !== merchantCountry && prefillShippingAddress.country_code !== '';
	
	                    if (shouldBlockBuyer) {
	                        return {
	                            to: 'checkout.genericError',
	                            params: {
	                                code: 'BLOCK_NON_DOMESTIC_SHIPPING'
	                            }
	                        };
	                    }
	
	                    if (models.checkoutAppData.is_second_button_txn) {
	                        var creditDataModel = $CreditDataModel.instance($rootScope.token);
	                        var isCapeReturnKey = creditDataModel.getCapeKey();
	                        var isChangeInstallments = creditDataModel.isChangeStatus();
	                        var offers = $InstallmentOptionsModel.instance($rootScope.token);
	                        var installmentOptions;
	                        var isInstallmentEligible = models.flowEligibility.installment;
	                        var country = models.checkoutAppData.get('merchant.merchant_country');
	                        return offers.save({
	                            data: {
	                                payee: models.checkoutPayeeModel,
	                                checkoutCart: models.checkoutCart,
	                                checkoutAppData: models.checkoutAppData,
	                                isMemberCredit: true
	                            },
	                            success: function success(result) {
	                                installmentOptions = result && result.installments && result.installments[0] && result.installments[0].installment_options && result.installments[0].installment_options.length > 0;
	
	                                if (isCapeReturnKey) {
	                                    return 'checkout.login';
	                                } else if (country === 'GB' || isInstallmentEligible && (installmentOptions && isChangeInstallments || installmentOptions)) {
	                                    $logger.info('ppc_second_btn_acquisition');
	                                    return 'checkout.chooseCreditOffer';
	                                } else {
	                                    $logger.info('ppc_second_btn_resuse');
	                                    return 'checkout.login';
	                                }
	                            },
	                            contingencies: {
	                                DEFAULT: function DEFAULT(name, err) {
	                                    // Check error message === currencyNotCompatible
	                                    return 'checkout.login';
	                                }
	                            }
	                        });
	                    }
	
	                    /* If experiment treatment, we check Venmo eligibility based on UA, merchant country,
	                     payment_action, cookie, and if this is a processor decline. */
	                    return $pxp('xo_hermesnodeweb_pwv', { 'ctx.COUNTRY': merchantCountry }, '(xo_hermesnodeweb_pwv)(.*)').then(function (result) {
	
	                        var treatmentName = result && result.treatment_name || '';
	
	                        if (treatmentName === 'xo_hermesnodeweb_pwv_treatment_3720' && _venmoInfo.venmoInfo.isVenmo()) {
	                            return 'checkout.payWithSelection';
	                        } else {
	                            return 'checkout.login';
	                        }
	                    });
	                };
	
	                var cartHasInventory = models.checkoutCart.get('cartHasInventory');
	                if ($config.enableInventoryWPS && cartHasInventory) {
	                    var inventoryModel = $InventoryModel.instance($rootScope.token);
	                    var inventoryInput = {
	                        items: models.checkoutCart.get('purchase.items'),
	                        merchantId: models.checkoutPayeeModel.getId()
	                    };
	                    return inventoryModel.action('getInventory', {
	                        data: inventoryInput,
	                        success: function success(inventoryResponse) {
	                            if (inventoryResponse.showSoldoutPage) {
	                                return {
	                                    to: 'checkout.soldout',
	                                    params: {
	                                        items: encodeURIComponent(inventoryResponse.soldoutItems),
	                                        soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
	                                    }
	                                };
	                            } else {
	                                inventoryModel.setInvetoryItems(inventoryResponse);
	                                return landingFlow();
	                            }
	                        }
	                    });
	                } else {
	                    return landingFlow();
	                }
	            });
	        }
	    }
	});
	
	angular.value("$LandingRoute", $LandingRoute);
	_venmoInfo.venmoInfo;
	
	_squid.$ComponentRoute;

/***/ },

/***/ "./components/xo-models/src/shippingMethod/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.shippingMethod', ['squid']).factory('$ShippingMethodModel', function ($Model, $Api) {
	        return $Model.extend('ShippingMethodModel', {
	            api: new $Api({
	                uri: '/api/shippingtax/charges'
	            }),
	
	            getShippingMethodId: function getShippingMethodId(shippingMethodType) {
	                var shippingMethodsMap = {
	                    DEFAULT: '0',
	                    AIR_SERVICE: '1',
	                    ECONOMY: '2',
	                    EXPEDITED_AIR_SERVICE: '3',
	                    EXPEDITED_FLAT_RATE_SHIPPING: '4',
	                    EXPRESS: '5',
	                    EXPRESS_DOMESTIC: '6',
	                    FREE_SHIPPING: '7',
	                    GROUND: '8',
	                    GLOBAL_PRIORITY: '9',
	                    INTERNATIONAL_ECONOMY: '10',
	                    INTERNATIONAL_EXPEDITED: '11',
	                    INTERNATIONAL_EXPRESS: '12',
	                    INTERNATIONAL_EXPRESS_AIR: '13',
	                    INTERNATIONAL_PRIORITY_AIR: '14',
	                    NEXT_DAY: '15',
	                    NEXT_DAY_AIR: '16',
	                    NEXT_DAY_AIR_ECONOMY: '17',
	                    ONE_DAY_SHIPPING: '18',
	                    OVERNIGHT: '19',
	                    OVERNIGHT_FLAT_RATE_SHIPPING: '20',
	                    PICKUP: '21',
	                    PRIORITY: '22',
	                    RUSH_DELIVERY: '23',
	                    STANDARD_DOMESTIC: '24',
	                    STANDARD_EXPEDITED: '25',
	                    STANDARD_FLAT_RATE_SHIPPING: '26',
	                    STANDARD_INTERNATIONAL: '27',
	                    STANDARD_SHIPPING: '28',
	                    STORE_PICKUP: '29',
	                    TWO_DAY_SHIPPING: '30',
	                    WORLDWIDE_SHIPPING: '31',
	                    TWO_DAY_AIR: '32'
	                };
	
	                return shippingMethodsMap[shippingMethodType];
	            },
	
	            isStorePickUp: function isStorePickUp(shipping_method_type) {
	                return shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';
	            }
	        });
	    }).factory('$ShippingRuleSummaryModel', function ($Model, $Api) {
	        return $Model.extend('ShippingRuleSummaryModel', {
	            api: new $Api({
	                uri: '/api/shippingtax/:id/rulesSummary'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/shippingMethod", "components/xo-models/src/shippingMethod/index.js"))

/***/ },

/***/ "./components/xo-models/src/inventory/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.inventory', ['squid']).factory('$InventoryModel', function ($Model, $Api) {
	        return $Model.extend('$InventoryModel', {
	            api: new $Api({
	                uri: '/api/catalog/:id/item/',
	                postAttempts: 2,
	                cache: true
	            }),
	
	            setInvetoryItems: function setInvetoryItems(inventoryItems) {
	                this.inventoryItems = inventoryItems;
	            },
	
	            getInventoryItems: function getInventoryItems() {
	                return this.inventoryItems;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/inventory", "components/xo-models/src/inventory/index.js"))

/***/ },

/***/ "./components/xo-venmo-components/src/venmo-info/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.venmoExperience = exports.venmoInfo = exports.VENMO_OPTIONS = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _sessionStorage = __webpack_require__("./components/xo-venmo-components/src/venmo-info/sessionStorage.js");
	
	var _sessionStorage2 = _interopRequireDefault(_sessionStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Decide if Venmo header should be shown
	// TODO: Check how the cookie should be read/set (through meta? if read on server side)
	var PWV_COOKIE = 'pwv';
	var VENMO_SETUP_COOKIE = 'venmoSetup';
	
	var VENMO_OPTIONS = exports.VENMO_OPTIONS = {
	    PAYPAL: 'PAYPAL',
	    VENMO: 'VENMO'
	};
	
	var venmoInfo = exports.venmoInfo = {
	    // Handler to call to determine if user can use Venmo
	    isVenmo: function isVenmo() {
	
	        var venmoRegex = new RegExp('(?:^|; )' + PWV_COOKIE + '=1(?:;|$)');
	        var appData = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
	        var cart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
	
	        var merchantCountry = appData.merchant.merchant_country;
	        var isProcessorDeclined = appData.flags.processor_declined;
	        var isOrderTransaction = cart.payment_action === 'order';
	
	        var isMobile = _index.$DeviceInfo.isDevice();
	        var isVenmoCookiePresent = document.cookie.match(venmoRegex);
	
	        return Boolean(_squid.$util.param('isVenmo') || isVenmoCookiePresent && isMobile && !isProcessorDeclined && !isOrderTransaction && merchantCountry === 'US');
	    },
	
	
	    // Get option user has selected for Venmo, return null if user has not set up yet.
	    venmoState: function venmoState() {
	        var setupRegex = new RegExp('(?:^|; )' + VENMO_SETUP_COOKIE + '=(\\w*)(?:;|$)');
	        var match = document.cookie.match(setupRegex);
	
	        if (match && VENMO_OPTIONS.hasOwnProperty(match[1])) {
	            return match[1];
	        } else {
	            return null;
	        }
	    },
	
	
	    // Delete the venmo state cookie
	    clearVenmoState: function clearVenmoState() {
	        document.cookie = VENMO_SETUP_COOKIE + '=; Max-Age=0';
	    },
	    setVenmoCookie: function setVenmoCookie() {
	        document.cookie = VENMO_SETUP_COOKIE + '=' + VENMO_OPTIONS.VENMO;
	    },
	    setPayPalCookie: function setPayPalCookie() {
	        document.cookie = VENMO_SETUP_COOKIE + '=' + VENMO_OPTIONS.PAYPAL;
	    },
	
	
	    // Build the venmo URL scheme
	    buildVenmoURL: function buildVenmoURL() {
	        var SCHEME = 'https://venmo.com/';
	        var VENMO_ROUTE = '#/checkout/venmo';
	        var LOGIN_ROUTE = '#/checkout/login';
	
	        var cartModel = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
	
	        var params = (0, _angular.$httpParamSerializer)({
	            'x-success': _angular.$location.absUrl().replace(/#.*$/, VENMO_ROUTE),
	            'x-failure': _angular.$location.absUrl().replace(/#.*$/, LOGIN_ROUTE),
	            'ua': _angular.$window.navigator.userAgent,
	            'merchant_id': _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId(),
	            'token': _angular.$rootScope.token,
	            'total': cartModel.purchase.amounts.total.amount,
	            'currency': cartModel.purchase.amounts.total.currency_code
	        });
	
	        return SCHEME + 'paypal/checkout?' + params;
	    }
	};
	
	var venmoExperienceKey = 'VENMO_EXPERIENCE';
	
	// Get whether a token is marked as Venmo experience.
	var venmoExperience = exports.venmoExperience = {
	    set: function set(token) {
	        try {
	            _sessionStorage2['default'].setItem(venmoExperienceKey, token);
	        } catch (e) {
	            return;
	        }
	    },
	    get: function get(token) {
	        var auth = _auth.$AuthModel.instance();
	        try {
	            if (auth.logged_in && auth.guest && // Check if Venmo guest account logged in
	            _sessionStorage2['default'].getItem(venmoExperienceKey) === token) {
	                return true;
	            } else {
	                this.set(null);
	                return false;
	            }
	        } catch (e) {
	            return false;
	        }
	    }
	};
	
	_angular.$rootScope;
	
	_angular.$window;
	
	_angular.$location;
	
	_angular.$httpParamSerializer;
	
	_index.$DeviceInfo;
	
	_squid.$util;
	
	_auth.$AuthModel;
	
	_checkout.$CheckoutPayeeModel;
	
	_checkout.$CheckoutCartModel;
	
	_checkout.$CheckoutAppDataModel;

/***/ },

/***/ "./components/xo-venmo-components/src/venmo-info/sessionStorage.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	var store = {};
	
	// Polyfill for sessionStorage if not available. Simple variable store
	exports['default'] = window.sessionStorage || {
	    getItem: function getItem(key) {
	        if (arguments < 1) {
	            throw new Error('1 argument required');
	        }
	        return store[key];
	    },
	    setItem: function setItem(key, val) {
	        if (arguments < 2) {
	            throw new Error('2 arguments required');
	        }
	        store[key] = val;
	    }
	};
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-login/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$LoginRoute = undefined;
	
	__webpack_require__("./pages/xo-login/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $LoginRoute = exports.$LoginRoute = _squid.$ComponentRoute.extend('$LoginRoute', {
	
	    path: 'login',
	
	    directive: 'xo-login-page',
	
	    params: {
	        targetPage: null,
	        source: null,
	        showNotYou: null
	    },
	
	    auth: false,
	
	    titleContent: 'base.logIn',
	
	    trackingData: {
	        fptiState: 'login',
	        suppressTransitionLog: true, // We will be suppressing the Server Side Tracking for this page
	        templateName: 'login.dust',
	        pageGoal: 'Payment Start',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-login',
	                'pagename2': '%::fullpage-login:member:hermes:',
	                'version': 'member:%:'
	            },
	            'ulLogin': {
	                'pagename': '%::fullpage-ullogin',
	                'pagename2': '%::fullpage-ullogin:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    children: []
	});
	
	angular.value("$LoginRoute", $LoginRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-login/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$xoLoginPageComponent = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	var _template = __webpack_require__("./pages/xo-login/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./pages/xo-login/loginEligibility.js");
	
	__webpack_require__("./pages/xo-login/onboarding/directive.js");
	
	__webpack_require__("./pages/xo-login/util.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-models/src/app/index.js");
	
	__webpack_require__("./components/xo-models/src/fi/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	__webpack_require__("./components/xo-title/dist/directive.js");
	
	__webpack_require__("./components/xo-login-components/src/login/handler/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/language-options/directive.js");
	
	__webpack_require__("./components/xo-login-components/src/unified-login/directive.js");
	
	__webpack_require__("./components/xo-device-info/dist/index.js");
	
	__webpack_require__("./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");
	
	__webpack_require__("./pages/xo-landing/route.js");
	
	__webpack_require__("./components/xo-ui-components/src/card-loader/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoLoginPageComponent = exports.$xoLoginPageComponent = _squid.$Component.extend('$xoLoginPageComponent', {
	    tag: 'xo-login-page',
	    template: _template2['default'],
	    scope: {
	        token: '='
	    },
	    link: function link($scope) {
	        _logger.$logger.info('login_link');
	    },
	    lifecycle: {
	        populate: function populate() {
	            var $scope = this;
	            (0, _squid.$populate)($scope, {
	                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
	            }).then(function () {
	
	                var country = $scope.checkoutAppData.merchant.merchant_country;
	                (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment').then(function (result) {
	                    var treatmentName = result && result.treatment_name || '';
	                    if (treatmentName) {
	                        _logger.$logger.info('xo_hermesnode_hide_cart_logo_treatment');
	                        $('.cartContainer').hide();
	                        $('.merchantHeader > .headerWrapper').hide();
	                    }
	                });
	            });
	        },
	        exit: function exit() {
	
	            var $scope = this;
	            (0, _squid.$populate)($scope, {
	                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
	            }).then(function () {
	
	                var country = $scope.checkoutAppData.merchant.merchant_country;
	                (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment').then(function (result) {
	                    var treatmentName = result && result.treatment_name || '';
	                    if (treatmentName) {
	                        $('.cartContainer').show();
	                        $('.merchantHeader > .headerWrapper').show();
	                    }
	                });
	            });
	        }
	    },
	
	    rootEvents: {
	        allLoaded: function allLoaded() {
	            if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
	                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
	                    if (window.xchild) {
	
	                        var forceIframe = window.paypal && window.paypal.forceIframe && window.paypal.forceIframe();
	                        var isWebView = window.paypal && window.paypal.isWebView && window.paypal.isWebView();
	
	                        if (forceIframe) {
	                            _logger.$logger.info('force_iframe_login');
	                        } else if (isWebView) {
	                            _logger.$logger.info('allow_iframe_login');
	                        } else {
	                            _logger.$logger.warn('framebust_from_login');
	                            _uiRouter.$state.go('checkout.framebust', { action: 'open', url: window.location.href.split('#')[0] });
	                        }
	                    } else {
	                        return _miniBrowser.$miniBrowser.frameBust(this.props.token);
	                    }
	                } else {
	                    throw _integration.$integration.error('Can not framebust');
	                }
	            }
	        }
	    },
	
	    controller: function controller($scope, $FallbackError, $window, $location, $locale, // eslint-disable-line no-shadow
	    $FlowEligibilityModel, $CheckoutSessionModel, $BuyerEligibilityModel, $EConsentModel, $AuthModel, $feature, // eslint-disable-line no-shadow
	    $AppDataModel, $config, $logger, // eslint-disable-line no-shadow
	    $q, $pxp, // eslint-disable-line no-shadow
	    $pxpFactors, $timeout, $util, // eslint-disable-line no-shadow
	    $experiment, $loginEligibility, $dispatch, $DeviceInfo, $KmliUpsell, $ReturnToMerchant, $meta, $stateParams, $CheckoutCartModel, $CreditDataModel, $capeRedirectUtil, $TokenizedWalletEligibilityModel, $TokenizedWalletPinModel, $WalletPreferences) {
	
	        $logger.info('login_controller');
	
	        var fptiHardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];
	
	        $scope.ulEligibility = false;
	        $scope.useTokenizationAnimation = false;
	
	        /* If we detect a back/forward button click to land on the app, do not auto-login. In this case, the buyer
	         is attempting to navigate to a specific page, so we should not auto-redirect them.
	          This also fixes an issue with users:
	         - Authorizing the checkout session
	         - Redirecting to the merchant
	         - Hitting back and landing on login page
	         - Calling create on checkout and overwriting the authorization
	         - Hitting forward and landing again on merchant page
	         */
	
	        if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
	            _angular.$rootScope.forceLogin = true;
	        }
	
	        if (!_angular.$rootScope.forceLogin) {
	            $scope.autoLogin = true;
	        }
	
	        _angular.$rootScope.forceLogin = true;
	
	        $scope.hideGuest = $stateParams.targetPage === 'PAYER_AUTHENTICATION_REQUIRED' || $stateParams.showNotYou;
	        $scope.promptlogin = $scope.hideGuest && !$feature('riskyLoginContingency');
	
	        // log statement for mobile webview
	        if ($DeviceInfo.isApp()) {
	            $logger.debug('HERMES_IN_MOBILE_WEBVIEW');
	        }
	
	        if (!_miniBrowser.$miniBrowser.isMiniBrowser() && $locale.country === 'BR') {
	            var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_login_design;
	
	            $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
	                $scope.loginDesignExp = result;
	            });
	        }
	
	        var ROUTE_MAPPING = {
	            ECONSENT_REQUIRED: 'checkout.econsent'
	        };
	
	        $scope.onContingency = function (name, contingency) {
	
	            if (!ROUTE_MAPPING[name]) {
	                throw new $FallbackError({
	                    reason: name.toLowerCase(),
	                    product: 'ux'
	                });
	            }
	
	            _uiRouter.$state.go(ROUTE_MAPPING[name]);
	        };
	
	        $scope.buyerEligibility = $BuyerEligibilityModel.instance($scope.token);
	        $scope.checkoutSession = $CheckoutSessionModel.instance($scope.token);
	        $scope.eConsent = $EConsentModel.instance($scope.token);
	        $scope.tokenizedWalletEligibility = $TokenizedWalletEligibilityModel.instance($scope.token);
	        $scope.tokenizedWalletPin = $TokenizedWalletPinModel.instance($scope.token);
	        $scope.walletPreferences = $WalletPreferences.instance($scope.token);
	        $scope.dependencyEligibility = true;
	
	        // Temporary light eligibility check for tokenized wallet flow.
	        function isWalletTokenizationEligible() {
	            // Only US buyer is eligible for tokenized wallet.
	            if ($scope.auth.country === 'US') {
	                return true;
	            }
	            return false;
	        }
	
	        $scope.setBuyer = function () {
	
	            $scope.buyerEligibility.invalidate();
	            $scope.checkoutSession.invalidate();
	            $scope.eConsent.invalidate();
	            $scope.tokenizedWalletEligibility.invalidate();
	            $scope.tokenizedWalletPin.invalidate();
	            $scope.walletPreferences.invalidate();
	
	            var fptiData = {
	                from: 'CREATE_XO_SESSION',
	                to: 'process_create_xo_session'
	            };
	
	            function handleContingency(name, err) {
	                // Check if negative case has been previously handled.
	                if (!$scope.dependencyEligibility) {
	                    return;
	                }
	                fptiData.int_error_code = err.cause;
	                fptiData.error_source = 'paymentapiplatformserv';
	                fptiData.error_type = fptiHardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
	                $logger.info('checkout_fpti', fptiData);
	                throw err;
	            }
	
	            function handleNoValidTopupFiContingency(name, err) {
	                // Check if negative case has been previously handled.
	                if (!$scope.dependencyEligibility) {
	                    return;
	                }
	                if ($scope.checkoutCart.isWalletTokenization()) {
	                    $scope.checkoutSession.contingency = name;
	                    $logger.info('tokenized_wallet', {
	                        'from': 'PP_AndroidPay_Info',
	                        'to': 'prepare_PP_AndroidPay_Info',
	                        'context_id': $scope.token,
	                        'context_type': 'EC-Token',
	                        'billing_token': $meta.baToken
	                    });
	                    $('#outerWrapper').addClass('tokenization');
	                    $timeout(function () {
	                        return _uiRouter.$state.go('checkout.tokenizationInfo');
	                    }, 1200);
	                } else {
	                    handleContingency(name, err);
	                }
	            }
	
	            $logger.info('checkout_fpti', {
	                from: 'CREATE_XO_SESSION',
	                to: 'prepare_create_xo_session'
	            });
	
	            $scope.useTokenizationAnimation = $scope.checkoutCart.isWalletTokenization();
	            var walletTokenization = $scope.checkoutCart.isWalletTokenization();
	
	            if ($scope.useTokenizationAnimation) {
	                _angular.$rootScope.$emit('allLoaded');
	
	                $scope.setbuyerProgress = 'notStarted';
	                $logger.info('tokenized_wallet', {
	                    'from': 'adding_pp_ap_animation',
	                    'to': 'prepare_adding_pp_ap_animation',
	                    'context_id': $scope.token,
	                    'context_type': 'EC-Token',
	                    'billing_token': $meta.baToken
	                });
	
	                $timeout(function () {
	                    $scope.setbuyerProgress = 'pending'; // sets animation state to 80%
	                    $logger.info('tokenized_wallet', {
	                        'from': 'adding_pp_ap_animation',
	                        'to': 'process_adding_pp_ap_animation',
	                        'context_id': $scope.token,
	                        'context_type': 'EC-Token',
	                        'billing_token': $meta.baToken
	                    });
	                }, 300);
	            }
	
	            $scope.eConsent.retrieve({
	                batch: {
	                    name: 'setbuyer',
	                    silent: $scope.useTokenizationAnimation,
	                    id: 'eConsent',
	                    dependencies: ['buyerEligibility']
	                },
	                contingencies: {
	                    ECONSENT_REQUIRED: function ECONSENT_REQUIRED(name, err) {
	                        if ($scope.dependencyEligibility) {
	                            $scope.dependencyEligibility = false;
	                            $logger.debug('ULLOGIN_ECONSENT_REQUIRED');
	                            _uiRouter.$state.go('checkout.econsent');
	                        }
	                    }
	                }
	            });
	
	            $scope.buyerEligibility.retrieve({
	                batch: {
	                    name: 'setbuyer',
	                    id: 'buyerEligibility',
	                    silent: $scope.useTokenizationAnimation,
	                    dependencies: $scope.ulEligibility ? ['securityCtx'] : []
	                },
	                success: function success(result) {
	                    $logger.info(result.eligible ? 'buyer_eligible' : 'buyer_ineligible');
	
	                    if ($config.blockStudentAccount && $scope.auth.student_account) {
	                        $scope.dependencyEligibility = false;
	                        $logger.info('blocking_student_account');
	                        _uiRouter.$state.go('checkout.genericError', {
	                            code: 'STUDENT_ACCOUNT'
	                        });
	                        return;
	                    }
	
	                    if (walletTokenization && !isWalletTokenizationEligible()) {
	                        $scope.dependencyEligibility = false;
	                        var msg = 'ineligible_tokenized_wallet_' + $scope.auth.country + '_account';
	                        $logger.info(msg);
	
	                        _uiRouter.$state.go('checkout.genericError', {
	                            code: 'ANDROID_PAY_ELIGIBILITY_ERROR'
	                        });
	                        return;
	                    }
	
	                    if (result.clearedRT) {
	                        $logger.info('checkout_fpti', {
	                            from: 'CONTINGENCY',
	                            to: 'process_fallback',
	                            routing_reason: 'BUYER_INELIGIBLE'
	                        });
	                    }
	
	                    if (!result.eligible) {
	                        $scope.dependencyEligibility = false;
	                        throw new $FallbackError({
	                            reason: 'buyer_ineligible',
	                            product: 'ux'
	                        });
	                    }
	                }
	            });
	
	            if (walletTokenization) {
	                var params = {
	                    wallet_brand: 'APAY',
	                    tenant_id: 'Hermes'
	                };
	                if ($meta.query && $meta.query.wallet_id) {
	                    params.wallet_id = $meta.query.wallet_id;
	                }
	                if ($meta.query && $meta.query.jwt) {
	                    params.jwt = $meta.query.jwt;
	                }
	
	                $scope.tokenizedWalletEligibility.retrieve({
	                    params: params,
	                    batch: {
	                        name: 'setbuyer',
	                        id: 'tokenizedWalletLightEligibility',
	                        silent: $scope.useTokenizationAnimation,
	                        dependencies: ['eConsent', 'buyerEligibility']
	                    },
	                    success: function success(result) {
	                        if (!result.eligible) {
	                            var msg = 'tokenized_wallet_ineligible_for_provisioning';
	                            $logger.info(msg);
	
	                            if ($scope.dependencyEligibility) {
	                                $scope.dependencyEligibility = false;
	                                var code = result.reason === 'WALLET_ID_ALREADY_PROVISIONED' ? 'ANDROID_PAY_ALREADY_PROVISIONED' : 'ANDROID_PAY_ELIGIBILITY_ERROR';
	                                code = window.btoa(code);
	                                _uiRouter.$state.go('checkout.genericError', {
	                                    code: code
	                                });
	                            }
	                        }
	                    }
	                });
	
	                $scope.tokenizedWalletPin.retrieve({
	                    batch: {
	                        name: 'setbuyer',
	                        id: 'tokenizedWalletPin',
	                        silent: $scope.useTokenizationAnimation,
	                        dependencies: ['eConsent', 'buyerEligibility']
	                    },
	                    success: function success(result) {
	                        if (result.pinId) {
	                            $logger.info('tokenized_wallet_get_pin_set', { pinOrigin: result.pinOrigin, pinId: result.pinId });
	                        } else {
	                            $logger.info('tokenized_wallet_get_pin_not_set', { pinKey: result.suggestedKey ? result.suggestedKey : 'unavailable' });
	                        }
	                    },
	                    contingencies: {
	                        DEFAULT: function DEFAULT(name, err) {
	                            $logger.info('tokenized_wallet_get_pin_error');
	                        }
	                    }
	                });
	            }
	
	            $scope.checkoutSession.action('create', {
	                data: {
	                    baToken: $scope.checkoutCart.billing && $scope.checkoutCart.billing.ba_token,
	                    preselected_fi_type: $scope.checkoutAppData.is_second_button_txn ? 'credit' : undefined
	                },
	                batch: {
	                    name: 'setbuyer',
	                    id: 'createCheckoutSession',
	                    silent: $scope.useTokenizationAnimation,
	                    dependencies: walletTokenization ? ['eConsent', 'buyerEligibility', 'tokenizedWalletLightEligibility', 'tokenizedWalletPin'] : ['eConsent', 'buyerEligibility']
	                },
	                success: function success(result) {
	
	                    fptiData.available_plan_count = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : '0';
	
	                    $logger.info('checkout_fpti', fptiData);
	
	                    if (!$scope.dependencyEligibility) {
	                        return;
	                    }
	
	                    if ($scope.auth.password_less && $scope.checkoutCart.isBilling()) {
	                        if ($feature('pomaPasswordRecovery')) {
	                            _uiRouter.$state.go('checkout.createPassword', { targetPage: 'BILLING_AGREEMENTS' });
	                        }
	                        return;
	                    }
	
	                    if ($scope.checkoutAppData.is_second_button_txn) {
	                        return $capeRedirectUtil.handleCapeRouting(result, $scope.checkoutCart, $scope.token);
	                    }
	
	                    return $KmliUpsell.eligible($scope.token).then(function (eligibility) {
	                        var isEligible = eligibility && eligibility.interstitial ? eligibility.interstitial : {};
	                        if (isEligible.eligible) {
	
	                            var stateName = isEligible.type === 'member' ? 'KMLI_UPSELL' : 'KMLI_reactivation';
	
	                            $logger.info('checkout_fpti', {
	                                from: stateName,
	                                to: 'prepare_kmli_upsell'
	                            });
	
	                            var path = $DeviceInfo.isMobile() ? 'checkout.FullpageOnetouchUpsell' : 'checkout.review.oneTouchUpsell';
	                            $logger.info('ryi_optin', {
	                                'from': 'OT_Toggle',
	                                'to': 'prepare_inter_optin'
	                            });
	                            return _uiRouter.$state.go(path, { oneTouchFlowName: 'checkout' });
	                        }
	
	                        if ($scope.auth.rtExchanged && $feature('rmSpinnerText')) {
	                            $scope.checkoutSession.message = {
	                                type: 'success',
	                                msgKeys: ['login.loggedInWithOneTouch']
	                            };
	                        }
	
	                        if ($scope.checkoutSession.negBals) {
	                            return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
	                        }
	
	                        if ($scope.checkoutCart.isWalletTokenization()) {
	                            $logger.info('tokenized_wallet', {
	                                'from': 'PP_AndroidPay_Info',
	                                'to': 'prepare_PP_AndroidPay_Info',
	                                'context_id': $scope.token,
	                                'context_type': 'EC-Token',
	                                'billing_token': $meta.baToken
	                            });
	                            $('#outerWrapper').addClass('tokenization');
	                            $timeout(function () {
	                                return _uiRouter.$state.go('checkout.tokenizationInfo');
	                            }, 1200);
	                        } else {
	                            _uiRouter.$state.go('checkout.review');
	                        }
	                    });
	                },
	                contingencies: {
	                    // override contingency.js handler with custom logic to support both xoon/hermes flows
	                    NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, err) {
	                        // Check if negative case has been previously handled.
	                        if (!$scope.dependencyEligibility) {
	                            return;
	                        }
	                        // come from guest or have alternate FI options, go to review
	                        if ($util.param('redirectToHermesOnUpopCancel') === 'xoon' || err && err.resolution && err.resolution.data && err.resolution.data.alternate_options) {
	                            _uiRouter.$state.go('checkout.review');
	                        } else {
	                            // else go to addCard
	                            _uiRouter.$state.go('checkout.updateCard.addCardFlow.addCard');
	                        }
	                    },
	                    NEED_DEBIT_CARD: handleNoValidTopupFiContingency,
	                    EXPIRED_DEBIT_CARD: handleNoValidTopupFiContingency,
	                    DEFAULT: handleContingency
	                }
	            });
	        };
	
	        // Sorry for the indirection here.  There's postAuth, so "preAuth" compliments it well (easier on the brain)
	        $scope.preAuth = function () {
	
	            // For UL, batch up eConsent, buyerEligibility, xoSession
	            if ($scope.ulEligibility) {
	                $scope.setBuyer();
	            }
	        };
	
	        $scope.onSuccess = function () {
	
	            // If the experiment is enabled, we already have what we need, so /quit.
	            if ($scope.ulEligibility) {
	                return;
	            }
	
	            $scope.setBuyer();
	        };
	
	        (0, _squid.$populate)($scope, {
	            flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
	                params: {
	                    geolocation: $meta.geolocation,
	                    localeCountry: $locale.country // We need this till we completely migrate to server side locale resolution
	                }
	            }),
	            auth: $AuthModel.instance(),
	            checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
	            checkoutCart: $CheckoutCartModel.instance(_angular.$rootScope.token)
	        }).then(function () {
	            if ($scope.flowEligibility.guest) {
	                return;
	            }
	            $('.paypalHeaderWrapper').removeClass('paypalCredit');
	            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
	        }).then(function () {
	            if ($scope.auth.accessToken()) {
	                return $scope.auth.reload({
	                    headers: {
	                        'x-paypal-internal-euat': $scope.auth.accessToken()
	                    },
	                    resultModel: $scope.auth,
	                    success: function success() {
	                        delete $scope.auth.access_token;
	                    },
	                    contingencies: {
	                        DEFAULT: function DEFAULT(name) {
	                            throw new $FallbackError({
	                                reason: name.toLowerCase(),
	                                product: 'ux'
	                            });
	                        }
	                    }
	                });
	            }
	        }).then(function () {
	            return $loginEligibility($scope.token, !$scope.autoLogin).then(function (result) {
	                if (result === 'unifiedLogin') {
	                    $scope.ulEligibility = true;
	                } else if (result === 'apsIntegration') {
	                    $scope.apsIntegration = 'apsIntegration';
	                } else if (result === 'apsIntegrationRM') {
	                    $scope.apsIntegration = 'apsIntegrationRM';
	                }
	            }).then(function () {
	
	                var reinitDisplay = function reinitDisplay() {
	                    $scope.promptlogin = false;
	                    $scope.hideGuest = false;
	                    $scope.autoLogin = true;
	                    delete $stateParams.targetPage;
	                    delete $stateParams.showNotYou;
	                };
	
	                $scope.logout = $scope.promptlogin ? function () {
	                    $logger.info('not_you_logout');
	                    $logger.info('checkout_fpti', {
	                        from: 'LOGIN_UL',
	                        to: 'login_with_diff_user'
	                    });
	                    $scope.auth.action('logout').then(function () {
	                        $scope.auth.reload().then(function () {
	                            reinitDisplay();
	                            $scope.reload();
	                        });
	                    });
	                } : function () {
	                    $logger.info('logout_switch_display');
	                    reinitDisplay();
	                };
	            });
	        });
	    }
	});
	
	angular.value("$xoLoginPageComponent", $xoLoginPageComponent);
	_angular.$rootScope;
	
	_miniBrowser.$miniBrowser;
	
	_integration.$integration;
	
	_squid.$Component;
	
	_squid.$pxp;
	
	_squid.$populate;
	
	_logger.$logger;
	
	_index.$CheckoutAppDataModel;
	
	_uiRouter.$state;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./pages/xo-login/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"login\"\n         id=\"login\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n\n            <xo-login-handler token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\"\n                              contingency-callback=\"onContingency\" ul-eligibility=\"ulEligibility\" pre-auth=\"preAuth\"\n                              aps-integration=\"apsIntegration\" batch=\"batch\"\n                              login-submit=\"loginSubmit\" flowcontext=\"flowcontext\" logout=\"logout\" export=\"loginHandler\"></xo-login-handler>\n\n            <div ng-if=\"promptlogin\" class=\"centerText\">\n                <hr class=\"sepPlain\" />\n\n                <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\" class=\"ng-binding\" tabindex=\"0\">{{ content('memberReview.notYou')}}</a>\n            </div>\n\n            <xo-onboarding-section token=token ng-hide=\"hideGuest\"></xo-onboarding-section>\n\n        </div>\n        <div class=\"span10\" ng-if=\"!loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\"\n                            text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" ng-if=\"loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content(loginDesignExp.propHeader)}}\"\n                            text-content=\"{{loginDesignExp.propText}}\"\n                            image-url=\"{{loginDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n    <div class=\"infoLoader\"  ng-if='useTokenizationAnimation'>\n        <div class='logo_wrapper'>\n            <div class='partner_logo'></div>\n        </div>\n        <div class=\"loader\">\n            <xo-card-loader state=\"setbuyerProgress\" auth=\"auth\" message=\"{{content('topup.addingAndroidPay')}}\"></xo-card-loader>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-login/loginEligibility.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$forceLoginExperience = $forceLoginExperience;
	exports.$loginEligibility = $loginEligibility;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _index3 = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	function $forceLoginExperience(auth, merchant_country, forcedLogin) {
	    var ULParam = _squid.$util.param('ul');
	
	    if (auth.loggedIn() && !auth.stepupAuthRequired && !forcedLogin) {
	        var ulReturn = _squid.$util.param('ulReturn');
	        return {
	            experience: 'apsIntegration',
	            reason: ulReturn ? 'ulReturn' : 'sessionActive'
	        };
	    } else if (ULParam === '0' && !_squid.$config.deploy.isLive()) {
	        return {
	            experience: 'apsIntegration',
	            reason: 'ulParamDisabled'
	        };
	    } else if (ULParam && ULParam.match(/[12]/)) {
	        return {
	            experience: 'unifiedLogin',
	            reason: 'ulParam'
	        };
	    } else if (ULParam === '3') {
	        return {
	            experience: 'apsIntegrationRM',
	            reason: 'ulParamApsRM'
	        };
	    } else if (auth.refreshToken()) {
	        return {
	            experience: 'unifiedLogin',
	            reason: 'rememberedUser'
	        };
	    } else if (_squid.$meta.corp && _squid.$config.ulMeta.allowKMLIForInternalIP && (0, _squid.$feature)('enableOneTouchInternalIP', false, merchant_country)) {
	        return {
	            experience: 'unifiedLogin',
	            reason: 'internalIP'
	        };
	    }
	}
	
	function $loginEligibility(token, forcedLogin) {
	
	    var $scope = {};
	
	    $scope.token = token;
	
	    var routingReason = void 0;
	
	    return (0, _squid.$populate)($scope, {
	        auth: _index2.$AuthModel.instance(),
	        checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
	    }).then(function () {
	
	        var country = $scope.checkoutAppData.merchant.merchant_country;
	        var forceLoginExperience = $forceLoginExperience($scope.auth, $scope.checkoutAppData.merchant.merchant_country, forcedLogin);
	        var isIneligible = angular.isDefined(forceLoginExperience);
	
	        return (0, _squid.$pxpMatch)(_squid.$config.ulMeta.pxpExpId, {
	            'ctx.COUNTRY': country
	        }, {
	            pxpControl: 'xo_hermesnode_ul_(mobile|web)_control',
	            pxpTreatment: 'xo_hermesnode_ul_(mobile|web)_treatment',
	            apsIntegration: 'xo_hermesnode_ul_(mobile|web)_aps_treatment',
	            apsIntegrationRM: 'xo_hermesnode_ul_(mobile|web)_aps_kmli_treatment'
	        }, {
	            ineligible: isIneligible
	        }).then(function (loginExperience) {
	
	            // To do: do this before calling pxp... otherwise every treatment has ineligible buyers
	            if (forceLoginExperience) {
	                routingReason = forceLoginExperience.reason;
	                return forceLoginExperience.experience;
	            }
	
	            var pxpGroup = 'na';
	
	            angular.forEach(loginExperience, function (value, key) {
	                if (value) {
	                    pxpGroup = key;
	                }
	            });
	
	            routingReason = pxpGroup;
	
	            switch (pxpGroup) {
	                case 'pxpTreatment':
	                    return 'unifiedLogin';
	                case 'pxpControl':
	                    return 'apsIntegration';
	                case 'apsIntegration':
	                    return 'apsIntegration';
	                case 'apsIntegrationRM':
	                    return 'apsIntegrationRM';
	                default:
	                    // For those countries where PXP is not setup, make UL as default
	                    if ((0, _squid.$feature)('defaultLoginMethodUL', false, country)) {
	                        return 'unifiedLogin';
	                    }
	                    // Non-UL experience ONLY in case of PXP setup but returned control
	                    return 'apsIntegration';
	            }
	        });
	    }).then(function (finalLoginExperience) {
	
	        _logger.$logger.debug(finalLoginExperience === 'unifiedLogin' ? 'ULLOGIN_ELIGIBLE' : 'ULLOGIN_NOT_ELIGIBLE', {
	            userGroup: [routingReason],
	            routing_reason: routingReason
	        });
	
	        var app_int_type = _index3.$DeviceInfo.getAppIntegrationType();
	
	        _logger.$logger.info('checkout_fpti', {
	            'from': 'UL_ELG_CHK',
	            'to': 'process_ul_elg_chk',
	            'routing_reason': routingReason,
	            'app_int_type': app_int_type
	        });
	
	        return finalLoginExperience;
	    });
	}
	
	angular.value("$forceLoginExperience", $forceLoginExperience);
	angular.value("$loginEligibility", $loginEligibility);
	_squid.$util;
	
	_squid.$meta;
	
	_squid.$config;
	
	_squid.$feature;
	
	_squid.$pxpMatch;
	
	_squid.$populate;
	
	_logger.$logger;
	
	_index.$CheckoutAppDataModel;
	
	_index2.$AuthModel;
	
	_index3.$DeviceInfo;

/***/ },

/***/ "./pages/xo-login/onboarding/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoOnboardingSectionComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-login/onboarding/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-login/guestThrottle.js");
	
	__webpack_require__("./components/xo-wallet-components/src/fi-logos/directive.js");
	
	__webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _paypalplus = __webpack_require__("./pages/xo-login/paypalplus.js");
	
	var _index = __webpack_require__("./components/xo-models/src/credit/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoOnboardingSectionComponent = exports.$xoOnboardingSectionComponent = _squid.$Component.extend('$xoOnboardingSectionComponent', {
	    tag: 'xo-onboarding-section',
	    template: _template2['default'],
	    scope: {
	        token: '='
	    },
	
	    controller: function controller($scope, $guestThrottle, $locale, $populate, $FlowEligibilityModel, $feature, $CheckoutAppDataModel, $state, $pxp, $logger) {
	
	        function throttleOnboardingFlow(flow) {
	            return $guestThrottle(flow, $scope.token, $locale.lang, $locale.country);
	        }
	
	        $scope.signupThrottle = function () {
	            if ($scope.forceCAPESignup) {
	                $state.go('checkout.redirectToCape');
	            } else {
	                throttleOnboardingFlow('signup');
	            }
	        };
	
	        $scope.guestThrottle = function () {
	            throttleOnboardingFlow('guest');
	        };
	
	        function getFlowEligibility() {
	            return $FlowEligibilityModel.instance($scope.token).retrieve({
	                params: {
	                    'localeCountry': $locale.country
	                }
	            }).then(function (flowEligibility) {
	                $scope.flowEligibility = flowEligibility;
	            });
	        }
	
	        function getButtonLabelTreatment() {
	            $scope.newUserVariant = false;
	            $scope.newUserVariantWithText = false;
	            return $pxp('xo_hermes_new_user', { 'ctx.COUNTRY': $locale.country }, 'xo_hermes_new_user_treatment_(a|b)').then(function (t) {
	                if (t) {
	                    $scope.newUserVariant = true;
	                    if (t.treatment_name === 'xo_hermes_new_user_treatment_b') {
	                        $scope.newUserVariantWithText = true;
	                    }
	                }
	            });
	        }
	
	        $populate($scope, {
	            checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	        }).then(function () {
	            return getFlowEligibility();
	        }).then(function () {
	            return getButtonLabelTreatment();
	        }).then(function () {
	            $scope.creditDataModel = _index.$CreditDataModel.instance($scope.token);
	            $scope.forceCAPESignup = $scope.checkoutAppData.is_second_button_txn && !$scope.creditDataModel.payInFull;
	            var useForcedSignupFlow = (0, _paypalplus.$isPayPalPlus)($scope.token) || $scope.forceCAPESignup;
	            var guest = $scope.flowEligibility.guest;
	            var signup = $scope.flowEligibility.signup;
	
	            $scope.showGuestBtn = !useForcedSignupFlow && guest;
	            $scope.showSignupBtn = useForcedSignupFlow || !guest && signup;
	            $scope.hideOrSeparator = !$scope.showGuestBtn && !$scope.showSignupBtn;
	        });
	    }
	});
	
	angular.value("$xoOnboardingSectionComponent", $xoOnboardingSectionComponent);
	_squid.$Component;
	
	_paypalplus.$isPayPalPlus;
	
	_index.$CreditDataModel;

/***/ },

/***/ "./pages/xo-login/onboarding/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"onboardingSection\" id=\"onboardingSection\" content>\n    <div class=\"guestHeading\" ng-if=\"guestVariant.guestBtnOnTop\">\n        <xo-title title-txt=\"{{content('login.guestTitle')}}\"></xo-title>\n        <xo-language-options class=\"span7\"></xo-language-options>\n    </div>\n\n    <div class=\"orSeparator\" ng-if=\"!hideOrSeparator\">\n        <span class=\"textInDivider\">\n            {{content('login.orLowercase')}}\n        </span>\n    </div>\n\n    <a link-button track-link=\"guest\" class=\"btn btn-secondary full submit\" id=\"checkoutAsAGuestBtn\" ng-if=\"showGuestBtn\" ng-click=\"guestThrottle()\">\n        {{ content(newUserVariant ? 'login.newToPayPal' : 'login.guestLinkBtn') }}\n    </a>\n\n    <a link-button track-link=\"signup\" class=\"btn btn-secondary full submit\" id=\"signupBtn\" ng-if=\"showSignupBtn\" ng-click=\"signupThrottle()\">\n        {{ content(newUserVariant ? 'login.newToPayPal' : 'login.createAccount') }}\n    </a>\n\n    <div class=\"inline-prop\" ng-if=\"newUserVariantWithText\" ng-bind-html=\"content('login.guestProp')\"></div>\n</div>\n"

/***/ },

/***/ "./pages/xo-login/guestThrottle.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$guestThrottle = $guestThrottle;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	function $guestThrottle(flowName, token, lang, country) {
	    var models = {};
	
	    function redirectToXoon() {
	        return (0, _squid.$dispatch)('xoon', {
	            exp: flowName,
	            token: token,
	            'locale.x': lang + '_' + country,
	            'country.x': country
	        });
	    }
	
	    function fallback(product, reason, params) {
	        throw new _squid.$FallbackError({
	            product: product || 'ux',
	            reason: reason,
	            entryPoint: flowName,
	            params: params
	        });
	    }
	
	    function checkInstantUpdateGuestEnabled() {
	        return (0, _squid.$pxp)('xoonboardingnodeweb_instant_update_throttle', 'xoonboardingnodeweb_instant_update_throttle_treatment').then(function (result) {
	            var treatmentName = result && result.treatment_name || '';
	            return treatmentName === 'xoonboardingnodeweb_instant_update_throttle_treatment';
	        });
	    }
	
	    function isGuestFlowEnabled() {
	        if (_angular.$rootScope.wps) {
	            if (!_squid.$config.enableGuestWps) {
	                // Fallback to UX for WPS transactions if guest option disabled
	                return _angular.$q.resolve(false);
	            }
	            return (0, _squid.$populate)(models, {
	                checkoutCart: _index.$CheckoutCartModel.instance(token).retrieve()
	            }).then(function () {
	                var cart = models.checkoutCart;
	                /*
	                 1. For SnT and inventory flows , return true enabling guest flows always.
	                 2. For Instant update flows , enable guest flows if treatment name is returned else fallback
	                 */
	                if (cart.instantUpdateIntegration) {
	                    return checkInstantUpdateGuestEnabled();
	                } else {
	                    return _angular.$q.resolve(true);
	                }
	            });
	        }
	        // Allow EC-flows to xoon always
	        return _angular.$q.resolve(true);
	    }
	
	    return isGuestFlowEnabled().then(function (res) {
	        if (!res) {
	            _logger.$logger.info(flowName + '_to_ux_wps');
	            return fallback('ux', flowName + '_to_ux_wps');
	        }
	        return redirectToXoon();
	    });
	}
	
	angular.value("$guestThrottle", $guestThrottle);
	_angular.$rootScope;
	
	_angular.$q;
	
	_squid.$dispatch;
	
	_squid.$populate;
	
	_squid.$config;
	
	_squid.$FallbackError;
	
	_squid.$pxp;
	
	_logger.$logger;
	
	_index.$CheckoutCartModel;

/***/ },

/***/ "./components/xo-wallet-components/src/fi-logos/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/fi-logos/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-fi-logos.directive', ['squid']).directive('xoFiLogos', function () {
	
	        return {
	            template: template,
	            scope: {
	                token: '='
	            },
	
	            controller: function controller($scope, $populate, $locale, $CardTypesModel) {
	
	                $populate($scope, {
	                    cardTypes: $CardTypesModel.instance($scope.token + ':' + $locale.country, {
	                        token: $scope.token,
	                        country: $locale.country
	                    })
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/fi-logos/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"fiIconsGroup\">\n    <div class=\"cardIconsGroup\">\n        <div class=\"icons\" ng-repeat = \"cardType in cardTypes.allowed\">\n            <div class = \"cardIcon {{cardType}}\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-login/paypalplus.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$isPayPalPlus = $isPayPalPlus;
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	function $isPayPalPlus(token) {
	    var checkoutAppDataModel = _index.$CheckoutAppDataModel.instance(token);
	    var experienceInitiator = checkoutAppDataModel.get('flags.payment_experience_initiator');
	    return experienceInitiator === 'PAYPAL_PLUS';
	}
	
	angular.value("$isPayPalPlus", $isPayPalPlus);
	_index.$CheckoutAppDataModel;

/***/ },

/***/ "./components/xo-models/src/credit/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.credit', ['squid']).factory('$CreditDataModel', function ($Model, $Api, $util) {
	
	        return $Model.extend('CreditDataModel', {
	            init: function init() {
	                this._super.init.apply(this);
	                this.setProperties({
	                    flow_type: $util.param('flow'),
	                    cape_key: $util.param('key'),
	                    cape_success: $util.param('success'),
	                    credit_signup: $util.param('creditSignup'),
	                    userAction: $util.param('action'),
	                    merchantAction: $util.param('merchantAction'),
	                    credit_login_failure: false,
	                    cape_service_error: $util.param('isInternalServiceError'),
	                    cape_redirect_uri: '',
	                    change_installment: $util.param('changeStatus'),
	                    nextState: ''
	                });
	            },
	
	            api: new $Api({
	                uri: '/api/credit/:id/creditData',
	                postAttempts: 2
	            }),
	
	            isCreditSignup: function isCreditSignup() {
	                return this.credit_signup && this.credit_signup === 'true';
	            },
	
	            setCapeRedirectUri: function setCapeRedirectUri(input) {
	                this.cape_redirect_uri = input;
	            },
	
	            getCapeRedirectUri: function getCapeRedirectUri() {
	                return this.cape_redirect_uri;
	            },
	
	            getMerchantAction: function getMerchantAction() {
	                return this.merchantAction || '';
	            },
	
	            setCreditSignup: function setCreditSignup(input) {
	                this.credit_signup = input;
	            },
	
	            getCapeKey: function getCapeKey() {
	                return this.cape_key;
	            },
	
	            getFlow: function getFlow() {
	                if (this.userAction === 'addCredit') {
	                    return 'credit';
	                }
	                return this.flow_type;
	            },
	            setFlow: function setFlow(flowType) {
	                this.flow_type = flowType;
	            },
	
	            setNextState: function setNextState(nextState) {
	                this.nextState = nextState;
	            },
	
	            isCapeSuccess: function isCapeSuccess() {
	                return this.cape_success && this.cape_success === 'true';
	            },
	
	            isCreditTxn: function isCreditTxn() {
	                return this.flow_type && this.flow_type === 'credit' || this.userAction && this.userAction === 'addCredit';
	            },
	
	            setCreditLoginFailure: function setCreditLoginFailure(input) {
	                this.credit_login_failure = input;
	            },
	
	            getCreditLoginFailure: function getCreditLoginFailure() {
	                return this.credit_login_failure;
	            },
	
	            isCapeReturn: function isCapeReturn() {
	                return this.flow_type && this.flow_type === 'capeReturn';
	            },
	
	            isCapeInternalServiceError: function isCapeInternalServiceError() {
	                return this.cape_service_error && this.cape_service_error === 'true';
	            },
	
	            getNextState: function getNextState() {
	                return this.nextState;
	            },
	
	            isChangeStatus: function isChangeStatus() {
	                return this.change_installment === 'changeInstallment';
	            },
	
	            isRedirectFromCape: function isRedirectFromCape() {
	                return Boolean(this.cape_key && this.cape_success === 'true' || $util.param('applyCredit'));
	            }
	        });
	    }).factory('$CreditInstallmentModel', function ($Model, $Api) {
	
	        return $Model.extend('CreditInstallmentModel', {
	            api: new $Api({
	                uri: '/api/checkout/:id/creditOptions/'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/credit", "components/xo-models/src/credit/index.js"))

/***/ },

/***/ "./pages/xo-login/util.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-login.capeUtil', ['squid']).factory('$capeRedirectUtil', function ($util, $CreditDataModel, $state) {
	        return {
	            handleCapeRouting: function handleCapeRouting(checkoutSession, checkoutCart, token) {
	                var fundingInstruments = void 0,
	                    isCreditInWallet = void 0;
	
	                if (checkoutCart.isBillingNoPurchase()) {
	                    fundingInstruments = checkoutSession.futurePaymentInstruments;
	                    isCreditInWallet = checkoutSession.futurePayment && checkoutSession.futurePayment.isCreditInWallet;
	                } else {
	                    fundingInstruments = checkoutSession.fundingOptions && checkoutSession.fundingOptions.instruments;
	                    isCreditInWallet = fundingInstruments && $util.find(fundingInstruments, function (fi) {
	                        return fi.name === 'BILL_ME_LATER';
	                    });
	                }
	
	                var creditDataModel = $CreditDataModel.instance(token);
	                var isCapeReturnKey = creditDataModel.getCapeKey();
	                var isCapeReturn = isCapeReturnKey && $util.param('success');
	                var isPPCEligible = checkoutSession.creditOffer || checkoutSession.bmlOffer;
	
	                // User does not have any FI in wallet but they choose to pay in full.
	                // Show add card contingency page instead of redirecting to CAPE.
	
	                if (checkoutSession.isCreditPromoted && !fundingInstruments && creditDataModel.payInFull || !fundingInstruments && !isPPCEligible) {
	
	                    return $state.go('checkout.pageAddCard.addCardFlow.addCard');
	                }
	
	                // Handle case where it was timeout and status is to go back to cape
	                else if (isCreditInWallet || isCapeReturn || creditDataModel.payInFull) {
	                        return $state.go('checkout.review');
	                    }
	
	                    // Handle "checkout with paypal" link on cyco
	                    else if (!isCreditInWallet && isPPCEligible) {
	                            return $state.go('checkout.redirectToCape');
	                        } else {
	                            // show error message
	                            return $state.go('checkout.review');
	                        }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-login", "pages/xo-login/util.js"))

/***/ },

/***/ "./components/xo-models/src/fi/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var BILLING_ADDRESS_FORMAT = {
	    DEFAULT: {
	        ',': ', ',
	        ' ': ' '
	    },
	    IL: {
	        he: {
	            ',': '‏, ‏',
	            ' ': '‏ ‏'
	        }
	    }
	};
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.fi', ['squid']).factory('$CardModel', function ($Model, $util) {
	        return $Model.extend('CardModel', {
	
	            serialize: function serialize() {
	
	                return {
	                    type: this.type,
	                    number: this.number.replace(/[^\d]+/g, ''),
	                    security_code: this.security_code,
	                    expiry_month: this.expiry_month && $util.pad(this.expiry_month, 2),
	                    expiry_year: this.expiry_year,
	                    issue_number: this.issue_number ? this.issue_number : undefined,
	                    start_month: this.start_month ? $util.pad(this.start_month, 2) : undefined,
	                    start_year: this.start_year ? this.start_year : undefined
	                };
	            },
	
	            last4: function last4() {
	                var cardNumber = this.number;
	
	                return cardNumber.substr(cardNumber.length - 4);
	            },
	
	            isExisting: function isExisting() {
	                return this.number && Boolean(this.number.match(/^xxxx-xxxx-xxxx-[\d]{4}$/));
	            }
	        });
	    }).factory('$AddCardModel', function ($Model, $Api, $CardModel) {
	        return $Model.extend('AddCardModel', {
	
	            api: new $Api({
	                uri: '/api/fi/card/:id?'
	            }),
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.card = new $CardModel();
	            },
	
	            serialize: function serialize() {
	                var id = this.address.id && this.address.id !== '0' ? this.address.id : undefined;
	
	                return {
	                    cardType: this.cardType ? this.cardType : 'creditCard',
	                    sponsor_id: this.sponsor_id,
	                    preference: this.preference,
	                    user: this.user,
	                    card: this.card.serialize(),
	                    address: id ? {
	                        id: id
	                    } : this.address.serialize()
	                };
	            },
	
	            clearId: function clearId() {
	                delete this.id;
	            }
	        });
	    }).factory('$CardTypesModel', function ($Model, $Api, $locale, $util, $feature) {
	        return $Model.extend('CardTypesModel', {
	
	            api: new $Api({
	                uri: '/api/fi/card/types?country=:country&token=:token'
	            }),
	
	            retrieve: function retrieve() {
	                return this._super.retrieve.apply(this, arguments).then(function (result) {
	                    // QIWI is VISA cobranded card supported currently in Russia.
	                    if ($feature('qiwiCardSupported') && result.allowed && result.allowed.indexOf('VISA') > -1 && result.allowed.indexOf('QIWI') === -1) {
	                        result.allowed.push('QIWI');
	                    }
	                    return result;
	                });
	            },
	
	            supportedNames: function supportedNames() {
	                return $util.map(this.allowed, function (type) {
	                    return $locale.content.cardTypes[type];
	                });
	            }
	        });
	    }).factory('$BankModel', function ($Model) {
	        return $Model.extend('BankModel', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.bank_account_number = '';
	                this.bank_routing_number = '';
	                this.iban_number = '';
	            },
	
	            serialize: function serialize() {
	                var data = {};
	
	                if (this.bank_account_number) {
	                    data.bank_account_number = this.bank_account_number;
	                }
	                if (this.bank_routing_number) {
	                    data.bank_routing_number = this.bank_routing_number;
	                }
	                if (this.iban_number) {
	                    data.iban_number = this.iban_number.replace(/\s/g, '').toUpperCase();
	                }
	                return data;
	            }
	        });
	    }).factory('$AddBankModel', function ($Model, $Api, $BankModel) {
	
	        return $Model.extend('AddBankModel', {
	
	            api: new $Api({
	                uri: '/api/fi/bank'
	            }),
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.user = this.user || {
	                    first_name: '',
	                    dob_day: '',
	                    dob_month: '',
	                    dob_year: '',
	                    currency_code: '',
	                    country: ''
	                };
	                this.bank = this.bank || new $BankModel();
	                this.address = this.address || {};
	                this.creditorDetails = this.creditorDetails || {};
	                this.fiDetails = this.fiDetails || {};
	            },
	
	            getBankData: function getBankData() {
	                var data = {};
	
	                // Set user info
	                data.user = this.user;
	
	                // Set bank info
	                var bank = {};
	
	                this.bank = this.bank || {};
	
	                if (this.candidate_id) {
	                    data.candidate_id = this.candidate_id;
	                }
	
	                if (this.bank.bank_account_number) {
	                    bank.bank_account_number = this.bank.bank_account_number;
	                }
	
	                if (this.bank.bank_routing_number) {
	                    bank.bank_routing_number = this.bank.bank_routing_number;
	                }
	
	                if (this.bank.iban_number) {
	                    bank.iban_number = this.bank.iban_number.replace(/\s/g, '');
	                }
	                data.bank = bank;
	
	                // Set address info
	                if (this.address) {
	                    data.address = {
	                        line1: this.address.line1,
	                        line2: this.address.line2,
	                        city: this.address.city,
	                        country: this.address.country,
	                        postal_code: this.address.postal_code
	                    };
	                }
	
	                return data;
	            }
	        });
	    }).factory('$PreferredFi', function ($Model, $Api) {
	        return $Model.extend('PreferredFi', {
	            api: new $Api({
	                uri: '/api/fi/preferred'
	            }),
	
	            init: function init() {
	                this._super.init.apply(this);
	
	                // Get the type of device to send to FI for logging
	                function getUiChannel() {
	                    var capabilities = _index.$DeviceInfo.getCapabilities();
	                    if (capabilities.isTablet) {
	                        return 'Tablet';
	                    } else if (capabilities.isMobile) {
	                        return 'Mobile';
	                    } else if (capabilities.isDesktop) {
	                        return 'Desktop';
	                    } else if (capabilities.isApp) {
	                        return 'App';
	                    } else {
	                        return null;
	                    }
	                }
	
	                this.uiChannel = getUiChannel();
	            },
	
	            serialize: function serialize() {
	                return {
	                    preferred: this.preferred,
	                    uiChannel: this.uiChannel
	                };
	            }
	        });
	    }).factory('$SepaModel', function ($Model, $Api) {
	        return $Model.extend('SepaModel', {
	            api: new $Api({
	                uri: '/api/fi/bank'
	            })
	        });
	    }).factory('$DeleteCardModel', function ($Model, $Api) {
	        return $Model.extend('DeleteCardModel', {
	            api: new $Api({
	                uri: '/api/fi/card/:id/delete'
	            })
	        });
	    }).factory('$BillingAddressModel', function ($Model, $Api, $config, $util, $locale) {
	        return $Model.extend('BillingAddressModel', {
	            api: new $Api({
	                uri: '/api/fi/billingaddress/validate'
	            }),
	
	            format: function format() {
	
	                var langConfig = (BILLING_ADDRESS_FORMAT[$locale.country] || {})[$locale.lang] || {};
	
	                var comma = angular.isUndefined(langConfig[',']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][','] : langConfig[','];
	                var space = angular.isUndefined(langConfig[' ']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][' '] : langConfig[' '];
	
	                return $util.filter([this.line1, this.line2, this.city, this.state, this.country]).join(comma) + space + $util.filter([this.postal_code]);
	            },
	
	            serialize: function serialize() {
	                return {
	                    line1: this.line1,
	                    line2: this.line2,
	                    city: this.city,
	                    state: this.state,
	                    postal_code: this.postal_code,
	                    normalization_status: this.normalization_status,
	                    country: this.country
	                };
	            }
	        });
	    }).factory('$BillingAddressesModel', function ($Model, $BillingAddressModel, $Api, $config, $util) {
	        return $Model.extend('BillingAddressesModel', {
	            api: new $Api({
	                uri: '/api/fi/billingaddress'
	            }),
	
	            onPopulate: function onPopulate() {
	                this.addresses = this.children($BillingAddressModel, this.addresses);
	            }
	        });
	    }).factory('$CardTypeFromBinModel', function ($Model, $Api) {
	        return $Model.extend('CardTypeFromBinModel', {
	            api: new $Api({
	                uri: '/api/fi/cardTypeFromBin?country=:country&bin=:bin&user_country=:user_country'
	            })
	        });
	    }).factory('$Resolve3DS', function ($Model, $Api) {
	        return $Model.extend('Resolve3DS', {
	            api: new $Api({
	                uri: '/api/fi/3ds/:id'
	            })
	        });
	    }).factory('$ResolveOTP', function ($Model, $Api) {
	        return $Model.extend('ResolveOTP', {
	            api: new $Api({
	                uri: '/api/fi/otp/:id'
	            })
	        });
	    }).factory('$WalletPreferences', function ($Model, $Api, $config) {
	        return $Model.extend('WalletPreferences', {
	            api: new $Api({
	                uri: '/api/fi/wallet/preferences'
	            }),
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.topup = {};
	            },
	
	            serialize: function serialize() {
	                return {
	                    topup: {
	                        amount: this.topup.amount,
	                        instrument_id: this.topup.fundingSource.instrument_id,
	                        autoload_minimum_threshold: $config.topup.autoload_minimum_threshold
	                    }
	                };
	            }
	        });
	    }).factory('$WalletInstrumentNameMapping', function ($Model, $util) {
	        return $Model.extend('WalletInstrumentNameMapping', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.INSTRUMENT_MAP = {
	                    AMSOUTH: /AMSOUTH,/,
	                    BOFA: /BANK OF AMERICA/,
	                    CAPITAL: /CAPITAL/,
	                    CHASE: /CHASE/,
	                    CITI: /CITIBANK/,
	                    FIFTHTHIRD: /FIFTH THIRD BANK/,
	                    HUNTINGTON: /HUNTINGTON/,
	                    INGDIRECT: /ING DIRECT/,
	                    NATIONALCITY: /NATIONAL CITY/,
	                    PNC: /PNC/,
	                    REGIONS: /REGIONS/,
	                    SUNTRUST: /SUNTRUST/,
	                    TDWATERHOUSE: /TD WATERHOUSE/,
	                    USAA: /USAA/,
	                    USBANK: /US BANK/,
	                    VISA: /VISA/,
	                    WAMUTUAL: /WASHINGTON MUTUAL/,
	                    WELLSFARGO: /WELLS FARGO/
	                };
	                this.INSTRUMENT_NAMES = Object.keys(this.INSTRUMENT_MAP);
	            },
	
	            getInstrumentNameNormalized: function getInstrumentNameNormalized(fsName) {
	                var _this = this;
	
	                if (!fsName) {
	                    return;
	                }
	
	                fsName = fsName.toUpperCase();
	
	                return $util.find(this.INSTRUMENT_NAMES, function (instName) {
	                    if (_this.INSTRUMENT_MAP[instName].test(fsName)) {
	                        return true;
	                    }
	                    return false;
	                });
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_index.$DeviceInfo;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/fi", "components/xo-models/src/fi/index.js"))

/***/ },

/***/ "./components/xo-ui-components/src/message/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-message.directive', ['squid']).directive('xoMessage', function ($timeout, $loader, $rootScope) {
	        return {
	            scope: {
	                message: '=' // Expected type - {msgs: [], type: "info|error|success|warning"}
	            },
	            template: template,
	            link: function link(scope, element, attrs) {
	
	                // Hide and show the alerts so that messages can be registered by
	                // screen reader even if they are repeats. Uses $timeout to
	                // wait for DOM before showing alerts again.
	                var toggleAlert = function toggleAlert() {
	                    var $alert = element.find('ul');
	                    $alert.detach();
	                    $timeout(function () {
	                        element.find('#pageLevelErrors').append($alert);
	                    });
	                };
	
	                // Toggle the alert whenever message changes by removing it and reappending it
	                // to the DOM. Should fire even if message
	                // is changed to the same, as assumes that the message should be reapplied.
	                var cancel;
	                scope.$watchCollection('message', function () {
	                    if ($loader.isLoading() && !cancel) {
	                        // If loading, toggle the alert after all loading calls have been made.
	                        // This is so that the alert can be read by screen reader after focus
	                        cancel = $rootScope.$on('allLoaded', function () {
	                            cancel();
	                            toggleAlert();
	
	                            cancel = null;
	                        });
	                    } else {
	                        toggleAlert();
	                    }
	                });
	
	                scope.$on('$destroy', function () {
	                    if (cancel) {
	                        cancel();
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/message/template.html":
/***/ function(module, exports) {

	module.exports = "<div role=\"alert\" aria-live=\"assertive\">\n    <div id=\"notifications\" ng-if=\"message.msgs || message.msgKeys\" content >\n        <div id=\"pageLevelErrors\" class=\"msgPage msg-{{message.type}}\">\n            <span class=\"icon\"></span>\n            <ul role=\"presentation\">\n                <li ng-repeat=\"msg in message.msgs\">\n                    <span data-ng-bind-html=\"msg\"></span>\n                </li>\n                <li ng-repeat=\"keys in message.msgKeys\" ng-if=\"message.msgKeys\">\n                    <div data-ng-bind-html=\"htmlContent(keys)\"></div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-title/dist/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-title/dist/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-title.directive', ['squid']).directive('xoTitle', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                titleTxt: '@',
	                className: '@'
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-title/dist/template.html":
/***/ function(module, exports) {

	module.exports = "<h1 class=\"alpha\">\n    {{ titleTxt }}\n</h1>\n"

/***/ },

/***/ "./components/xo-login-components/src/login/handler/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/login/handler/template.html"), __webpack_require__("./components/xo-login-components/src/login/directive.js"), __webpack_require__("./components/xo-login-components/src/login/props.js"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/app/index.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-form-components/src/language-options/directive.js"), __webpack_require__("./components/xo-login-components/src/unified-login/directive.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return angular.module('xo-login-handler.directive', ['squid', 'beaver', 'xomodel.checkout', 'xomodel.app', 'xo-message.directive', 'xo-title.directive', 'xo-login.directive', 'xo-language-options.directive', 'xo-unified-login.directive', 'xo-login-props', 'xo-device-info']).directive('xoLoginHandler', function ($util, $pxp, $logger, $locale, $loginProps) {
	
	        return {
	
	            componentize: true,
	
	            template: template,
	
	            scope: {
	                token: '=',
	                successCallback: '=',
	                contingencyCallback: '=',
	                autoLogin: '=',
	                ulEligibility: '=',
	                subFlowTitleKey: '=',
	                apsIntegration: '=',
	                batch: '=',
	                loginSubmit: '=',
	                logout: '=',
	                preAuth: '=',
	                hideloginpp: '=',
	                flowcontext: '=',
	                hideTitle: '='
	            },
	
	            controller: function controller($scope, $rootScope, $populate, $window, $location, $state, $AuthModel, $feature, $AppDataModel, $CheckoutCartModel, $loginProps, // eslint-disable-line no-shadow
	            $config, $logger, // eslint-disable-line no-shadow
	            $timeout, $util, // eslint-disable-line no-shadow
	            $localeHelper, $stateParams, $FallbackError) {
	
	                // Login Contingency Handling
	                var CONTENT_KEY = {
	                    INVALID_EMAIL_PASSWORD: 'invalidEmailPasswordPageError',
	                    ACCOUNT_LOCKED: 'accountLockedPageError',
	                    ACCOUNT_CLOSED: 'accountLockedPageError',
	                    INVALID_PHONE: 'invalidPhone',
	                    INVALID_PIN: 'invalidPin',
	                    INVALID_ACCESS_TOKEN: 'invalidAccessToken',
	                    TIMED_OUT: 'loginStatusTimedOut',
	                    CANNOT_PAY_SELF: 'cannotPaySelf',
	                    RISK_DECLINE: 'riskDeclinePageError',
	                    LOGIN_ADD_PHONE: 'loginAddPhone',
	                    LOGIN_PREFILLED_SHIPPING_ADDRESS: 'loginMerchantPassedAddress',
	                    LOGIN_CONTINGENCY: 'loginContingency',
	                    LOGIN_REACTIVATE: 'checkOneTouch',
	                    LOGIN_LEAVECHECKED: 'leaveOneTouchChecked',
	                    LOGIN_OT_GENERIC_ERROR: 'reactivateOneTouch'
	                };
	
	                var CONTENT_MAPPING = {
	                    INVALID_USER: { content: CONTENT_KEY.INVALID_EMAIL_PASSWORD, type: 'error' },
	                    INVALID_PHONE_PIN: { content: CONTENT_KEY.INVALID_PIN, type: 'error' },
	                    INVALID_ACCESS_TOKEN: { content: CONTENT_KEY.INVALID_ACCESS_TOKEN, type: 'error' },
	                    LOCKED_USER: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
	                    ACCOUNT_LOCKED: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
	                    CLOSED_USER: { content: CONTENT_KEY.ACCOUNT_CLOSED, type: 'error' },
	                    TIMED_OUT: { content: CONTENT_KEY.TIMED_OUT, type: 'error' },
	                    CANNOT_PAY_SELF: { content: CONTENT_KEY.CANNOT_PAY_SELF, type: 'error' },
	                    RISK_DECLINE: { content: CONTENT_KEY.RISK_DECLINE, type: 'error' },
	                    addPhone: { content: CONTENT_KEY.LOGIN_ADD_PHONE, type: 'error' },
	                    PAYER_AUTHENTICATION_REQUIRED: {
	                        content: CONTENT_KEY.LOGIN_PREFILLED_SHIPPING_ADDRESS,
	                        type: 'info'
	                    },
	                    LOGIN_CONTINGENCY: { content: CONTENT_KEY.LOGIN_CONTINGENCY, type: 'error' },
	                    ONETOUCH_REACTIVATE: { content: CONTENT_KEY.LOGIN_REACTIVATE, type: 'warning' },
	                    ONETOUCH_LEAVECHECKED: { content: CONTENT_KEY.LOGIN_LEAVECHECKED, type: 'warning' },
	                    ONETOUCH_GENERIC_ERROR: { content: CONTENT_KEY.LOGIN_OT_GENERIC_ERROR, type: 'warning' }
	                };
	
	                function populateMessage(name, type) {
	                    var contentKey = CONTENT_MAPPING[name];
	                    if (contentKey) {
	                        $scope.message = {
	                            msgKeys: ['login.' + contentKey.content],
	                            type: type || contentKey.type
	                        };
	                    } else {
	                        $logger.debug('unresolved content for login ' + type + ' message ' + name + ' in xo-login page');
	                    }
	                }
	
	                function handleAuthChallengeFailure(urlParams) {
	                    if (urlParams.acRedirect === '2fa') {
	                        var userLocale = urlParams['locale.test'];
	
	                        if (userLocale) {
	                            $locale.chosenLang = $localeHelper.normalizeLocale(userLocale).language;
	                        }
	
	                        if (urlParams.ulMethod === 'phone') {
	                            $logger.debug('2FA_RETURNED_FAILED_PHONE');
	                            populateMessage('INVALID_PHONE_PIN', 'error');
	                        } else {
	                            $logger.debug('2FA_RETURNED_FAILED_EMAIL');
	                            populateMessage('INVALID_USER', 'error');
	                        }
	                    } else if (urlParams.acRedirect === 'loginato') {
	                        $logger.debug('LOGIN_ATO_RETURNED_FAILED');
	                        $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
	                    } else if (urlParams.acRedirect === 'safe') {
	                        $logger.debug('SAFE_RETURNED_FAILED');
	                        $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
	                    }
	                }
	
	                function handleAuthChallengeSuccess(urlParams) {
	                    switch (urlParams.acRedirect) {
	                        case '2fa':
	                            $logger.debug('2FA_RETURNED_SUCCESS');
	                            break;
	                        case 'loginato':
	                            $logger.debug('LOGIN_ATO_RETURNED_SUCCESS');
	                            break;
	                        case 'safe':
	                            $logger.debug('SAFE_RETURNED_SUCCESS');
	                            break;
	                        default:
	                        // do nothing
	                    }
	                    $scope.auth.is_auth_api_call = !urlParams.acRedirect;
	                }
	
	                $scope.onComplete = function (auth) {
	                    // Dont show the login contingency message once poma password recovery is enabled.
	                    if (!$feature('pomaPasswordRecovery') && $scope.auth.password_less && $scope.checkoutCart.isBilling()) {
	                        populateMessage('LOGIN_CONTINGENCY', 'info');
	                    }
	
	                    if ($rootScope.contingency && $rootScope.contingency.message) {
	                        populateMessage($rootScope.contingency.message, 'error');
	                    } else {
	                        $locale.choose(auth.country, auth.language, false);
	                        $scope.successCallback();
	                    }
	                };
	
	                // Make country and lang available to htmlContent for dynamically generating content
	                $scope.locale = $locale;
	
	                if ($stateParams.targetPage) {
	                    if ($loginProps.inList($stateParams.targetPage) && $feature('riskyLoginContingency')) {
	                        var riskyLoginInfo = $loginProps.mapInfo($stateParams.targetPage);
	                        $scope.subFlowTitleKey = riskyLoginInfo.title;
	                        $scope.contingencyDesc = riskyLoginInfo.subtitle;
	                        $scope.hideloginpp = true;
	                        $scope.postlogout = function () {
	                            delete $scope.subFlowTitleKey;
	
	                            if ($scope.contingencyDesc) {
	                                delete $scope.contingencyDesc;
	                            }
	
	                            delete $scope.hideloginpp;
	                            $scope.showLanguageDropdown = $feature('languageToggle');
	                            $scope.logout();
	                        };
	                    } else {
	                        var errMessage = CONTENT_MAPPING[$stateParams.targetPage] ? $stateParams.targetPage : 'LOGIN_CONTINGENCY';
	                        var type = errMessage.type ? errMessage.type : 'info';
	                        populateMessage(errMessage, type);
	                    }
	                }
	
	                if ($AuthModel.instance().meta.invalidated) {
	                    populateMessage('TIMED_OUT', 'error');
	                } else if ($AuthModel.instance().meta.selfPay) {
	                    populateMessage('CANNOT_PAY_SELF', 'error');
	                    $AuthModel.instance().meta.selfPay = false;
	                }
	
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token).retrieve()
	                }).then(function () {
	                    // Land on create password info page in case poma user was routed to login, after the
	                    // initial login/auth.
	                    if ($feature('pomaPasswordRecovery') && $scope.auth.password_less && !$scope.autoLogin) {
	                        $state.go('checkout.createPassword', { targetPage: $stateParams.targetPage });
	                        return;
	                    }
	
	                    var ULCallbacks = {
	                        showErrorMessages: function showErrorMessages(errorCase) {
	                            populateMessage(errorCase);
	                            $timeout(function () {
	                                $scope.$digest(); // eslint-disable-line angular/ng_no_digest
	                            });
	                        },
	                        toggleUnifiedLogin: function toggleUnifiedLogin(value) {
	                            $scope.ulEligibility = value;
	                            $scope.apsIntegration = true;
	                            $rootScope.continueLoadingForUL = value;
	                            $timeout(function () {
	                                $scope.$digest(); // eslint-disable-line angular/ng_no_digest
	                            });
	                        }
	                    };
	
	                    $scope.ULCallback = function (name, value) {
	                        var callback = ULCallbacks[name];
	                        if (callback) {
	                            callback(value);
	                        }
	                    };
	
	                    if ($scope.auth.timed_out) {
	                        populateMessage('TIMED_OUT', 'error');
	                    }
	
	                    if (!$scope.subFlowTitleKey) {
	                        $scope.showLanguageDropdown = $feature('languageToggle');
	                    }
	
	                    var urlParams = $util.params();
	
	                    if (urlParams.acRedirect) {
	                        // Returning from auth challenge
	                        if (urlParams.failedBecause) {
	                            handleAuthChallengeFailure(urlParams);
	                        } else {
	                            handleAuthChallengeSuccess(urlParams);
	                        }
	                    }
	
	                    var handleContingency = {
	                        // Errors - Show Page Level Error
	                        INVALID_USER: populateMessage,
	                        LOCKED_USER: populateMessage,
	                        ACCOUNT_LOCKED: populateMessage,
	                        CLOSED_USER: populateMessage,
	                        ONETOUCH_REACTIVATE: populateMessage,
	                        ONETOUCH_LEAVECHECKED: populateMessage
	
	                    };
	
	                    $scope.onContingency = function (name, contingency, type) {
	                        // eslint-disable-line no-shadow
	
	                        $locale.choose($scope.auth.country, $scope.auth.language, false);
	
	                        if (!handleContingency[name]) {
	                            return $scope.contingencyCallback(name, contingency);
	                        }
	
	                        var message_type = type || 'error';
	                        return handleContingency[name](name, message_type);
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/login/handler/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"login\" id=\"loginSection\" content>\n    <xo-message message=\"message\"></xo-message>\n    <div class=\"pr row-fluid\" ng-class=\"{hasError: message}\" ng-hide=\"hideTitle\">\n        <xo-title title-txt=\"{{content(subFlowTitleKey ? subFlowTitleKey : 'login.loginTitle')}}\" ng-class=\"{span17: showLanguageDropdown, riskyTitle: subFlowTitleKey}\"></xo-title>\n        <xo-language-options class=\"span7\" ng-if=\"showLanguageDropdown\"></xo-language-options>\n    </div>\n    <div class=\"inline-prop\" unless-feature=\"propValue\" ng-hide=\"hideloginpp\">\n        <p ng-bind-html=\"htmlContent('login.propValAlt', {country: locale.country, lang: locale.lang})\")>\n    </div>\n    <div class=\"inline-prop\" ng-show= \"contingencyDesc\" ng-class=\"{riskySubtitle: contingencyDesc}\">\n        <p ng-bind-html=\"htmlContent(contingencyDesc, {country: locale.country, lang: locale.lang})\")>\n    </div>\n    <xo-login ng-if=\"!ulEligibility\" token=token auth=auth done-fn=\"onComplete\" error-fn=\"onContingency\" auto-login=\"autoLogin\" aps-integration=\"apsIntegration\" batch=\"batch\" login-submit=\"loginSubmit\"></xo-login>\n    <xo-unified-login ng-if=\"ulEligibility\" token=token error-fn=\"onContingency\" parent-callback=\"ULCallback\" pre-auth=\"preAuth\" post-auth=\"onComplete\" auto-login=\"autoLogin\" flowcontext=\"flowcontext\" login-submit=\"loginSubmit\" logout-callback=\"postlogout\" ></xo-unified-login>\n</section>\n"

/***/ },

/***/ "./components/xo-login-components/src/login/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/login/template.html"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-ui-components/src/popup/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/credit/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-login-components/src/login/fn.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-login.directive', ['squid', 'xomodel.auth', 'xomodel.checkout', 'xomodel.credit', 'xomodel.user', 'xo-popup.directive', 'xo-error-tooltip.directive', 'xo-device-info', 'xo-fn']).directive('xoLogin', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                doneFn: '=',
	                errorFn: '=',
	                clientId: '=',
	                redirectUri: '=',
	                scope: '=',
	                autoLogin: '=',
	                apsIntegration: '=',
	                batch: '=',
	                loginSubmit: '='
	            },
	
	            controller: function controller($scope, $element, $populate, $rootScope, $locale, $config, $window, $AuthModel, $CheckoutCartModel, $CheckoutInputDataModel, $CreditDataModel, $logger, $feature, $DeviceInfo, $util, $fn) {
	
	                $scope.locale = $locale;
	
	                var localeNVP = $locale.lang && $locale.country ? 'locale.x=' + $locale.lang.toLowerCase() + '_' + $locale.country : 'locale.x=en_US';
	                var forgotPasswordUrl = 'https://www.paypal.com/' + $locale.country.toLowerCase() + '/webapps/accountrecovery/passwordrecovery?' + localeNVP;
	                var legacyForgotPasswordUrl = 'https://www.paypal.com/' + $locale.country.toLowerCase() + '/merchantpaymentweb?cmd=_account-recovery&from=PayPal&' + localeNVP;
	                var checkoutInputData = $CheckoutInputDataModel.instance($rootScope.token);
	                var creditData = $CreditDataModel.instance($rootScope.token);
	                var apsRemMe = $scope.apsIntegration === 'apsIntegrationRM';
	                var fptiStateName = $scope.apsIntegration ? 'LOGIN_APS' : 'LOGIN';
	                var $passwordField = $element.find('[ng-model="auth.password"]');
	
	                $scope.forgotPasswordUrl = $feature('newForgotPasswordSupported') ? forgotPasswordUrl : legacyForgotPasswordUrl;
	
	                $fn.sendTypingSpeedPayload('Hermes');
	
	                /* ******** Here goes the Remember User controls *************************** */
	
	                // Show the RM consent section when
	                // 1. feature is ON
	                // 2. when its not a contingency flow
	                // 3. eBay doesn't want to hide it explicitly
	
	                if (checkoutInputData.rmEnabled(Boolean($config.rememberMeFeatureEnabled)) && !checkoutInputData.hideRM()) {
	                    fptiStateName = 'LOGIN_RM';
	                    $scope.rememberMe = 'nonKmli';
	                } else if (apsRemMe) {
	                    $scope.rememberMe = 'kmli';
	                }
	                $scope.rememberMeChkBox = {
	                    // Leave the consent box un-ticked by default
	                    agreed: false
	                };
	
	                // Show the RM details only if user clicks on 'learn more' link or clicks on Checkbox
	                $scope.showRmMore = false;
	
	                // Expand details when RM check-box is ticked and Remember the user
	                $scope.toggleRMDetails = function () {
	                    $scope.showRmMore = $scope.rememberMeChkBox.agreed;
	                };
	
	                function setRememberUser() {
	
	                    if (checkoutInputData.rmEnabled(Boolean($config.rememberMeFeatureEnabled))) {
	                        if (checkoutInputData.hideRM() === 'true') {
	                            // Feature is ON but consent box is hidden since hideRM param is true
	                            // Do not remember user in this case
	                            $scope.auth.rememberUser = false;
	                        } else {
	                            // RM is enabled and consent box displayed on login page
	                            // Remember the user based on the consent of user
	                            $scope.auth.rememberUser = $scope.rememberMeChkBox.agreed ? true : false;
	                        }
	                    } else {
	                        // Feature is wired off
	                        // If RM is not enabled that means the control is with eBay and we should retain current behavior by remembering the user
	                        $scope.auth.rememberUser = true;
	                    }
	                }
	
	                /* ************ Remember User Ends *************************************** */
	
	                function showLoadingMessage() {
	                    $rootScope.$emit('loadingMessage', $locale.content.get(creditData.isRedirectFromCape() || creditData.isChangeStatus() ? 'base.processing' : 'base.loggingIn'));
	                }
	
	                function loginAction() {
	                    showLoadingMessage();
	                    var loginInput = {
	                        user: {
	                            email: $scope.auth.email,
	                            password: $scope.auth.password
	                        }
	                    };
	
	                    if ($scope.clientId) {
	                        loginInput.client = {
	                            redirect_uri: $config.app_redirect_uri,
	                            client_id: $config.app_clientId || '',
	                            target_client_id: $util.param('fromLipp') === 'true' ? $scope.clientId : $util.base64Decode($scope.clientId), // eslint-disable-line block-scoped-var,no-undef
	                            scope: $scope.scope,
	                            response_type: 'token id_token',
	                            skip_oauth: false,
	                            skip_consent: true
	                        };
	                    } else if ($scope.apsIntegration) {
	                        loginInput.client = {
	                            remember_me: Boolean(apsRemMe && $scope.rememberMeChkBox.agreed)
	                        };
	                        loginInput.fastLogin = true;
	                    }
	
	                    // updated the product to decide the entry point
	                    loginInput.product = $rootScope.wps ? 'wps' : 'ec';
	
	                    $scope.auth.action('login', {
	
	                        data: loginInput,
	
	                        success: function success(result) {
	                            var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';
	                            $logger.info('checkout_fpti', { 'from': fptiStateName, 'to': transition_name });
	
	                            if (window.xprops && window.xprops.onAuth && $scope.auth.access_token) {
	                                return window.xprops.onAuth({
	                                    accessToken: $scope.auth.access_token
	                                }).then(function () {
	                                    return $scope.doneFn($scope.auth);
	                                });
	                            }
	
	                            return $scope.doneFn($scope.auth);
	                        },
	
	                        contingencies: {
	                            DEFAULT: function handleContingency(name, contingency) {
	                                var transition_name = $scope.rememberMeChkBox.agreed ? 'process_login_rm' : 'process_login';
	                                var error_source = $scope.apsIntegration ? 'aps' : 'userauth';
	
	                                $logger.info('checkout_fpti', {
	                                    'from': fptiStateName,
	                                    'to': transition_name,
	                                    'int_error_description': contingency && contingency.message,
	                                    'error_type': 'soft_decline',
	                                    'error_source': error_source
	                                });
	                                $scope.auth.password = '';
	                                $passwordField.focus();
	                                return $scope.errorFn(name, contingency);
	                            }
	                        }
	                    });
	                }
	
	                $scope.$on('$destroy', function () {
	                    $scope.auth.password = '';
	                });
	
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token)
	                }).then(function () {
	                    if ($scope.auth.loggedIn()) {
	                        if ($scope.autoLogin) {
	                            showLoadingMessage();
	                            if ($scope.auth.remembered) {
	                                $logger.info('REMEMBERED_ACTIVE_SESSION');
	                            } else {
	                                $logger.info('ACTIVE_SESSION');
	                            }
	                            return $scope.doneFn($scope.auth);
	                        }
	                    } else if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.email && !$scope.auth.timed_out) {
	                        $scope.auth.email = $scope.checkoutCart.payer.email;
	                    }
	                    var transition_name;
	                    if (apsRemMe) {
	                        transition_name = 'prepare_login_rm';
	                    } else if (creditData.isCreditTxn()) {
	                        transition_name = 'prepare_login_ppc';
	                    } else {
	                        transition_name = 'prepare_login';
	                    }
	
	                    var app_int_type = $DeviceInfo.getAppIntegrationType();
	                    $logger.info('checkout_fpti', {
	                        'from': fptiStateName,
	                        'to': transition_name,
	                        'app_int_type': app_int_type
	                    });
	                    $scope.onSubmit = function () {
	                        setRememberUser();
	                        loginAction();
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-ui-components/src/popup/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid) {
	
	    squid.module('xo-popup.directive', ['squid']).directive('xoPopup', function ($window, $util) {
	        return {
	            restrict: 'A',
	
	            link: function link(scope, element, attr) {
	
	                element.on('click', function (event) {
	                    event.preventDefault();
	                    event.stopPropagation();
	
	                    var config = {
	                        popupUrl: attr.href,
	                        popupWindowName: 'popup',
	                        width: 835,
	                        height: 500,
	
	                        popupWindowFeatures: {
	                            location: 1,
	                            status: 1,
	                            scrollbars: 1,
	                            resizable: 1,
	                            toolbar: 0,
	                            menubar: 0
	                        }
	                    };
	
	                    scope.trackExternalLink(attr.id || 'external_link');
	
	                    var isOneTouch = $util.param('isOneTouch');
	
	                    if (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test($window.navigator.userAgent) && isOneTouch !== '1') {
	                        scope.$emit('showModal', config);
	                        return false;
	                    }
	
	                    if ($(element).hasClass('smallPopup')) {
	                        config.width = 385;
	                    }
	
	                    var left = 0;
	                    var top = 0;
	
	                    if (window.outerWidth) {
	                        left = Math.round((window.outerWidth - config.width) / 2) + window.screenX;
	                        top = Math.round((window.outerHeight - config.height) / 2) + window.screenY;
	                    } else if (window.screen.width) {
	                        left = Math.round((window.screen.width - config.width) / 2);
	                        top = Math.round((window.screen.height - config.height) / 2);
	                    }
	
	                    var features = Object.keys(config.popupWindowFeatures).map(function (k) {
	                        return k + '=' + config.popupWindowFeatures[k];
	                    }).join(',');
	
	                    // put together WindowFeatures, since, window.open needs it as a string
	                    features += ',width=' + config.width + ',height=' + config.height + ',left=' + left + ',top=' + top;
	
	                    var popup = $window.open(config.popupUrl, config.popupWindowName, features);
	
	                    if (popup.focus) {
	                        popup.focus();
	                    }
	                });
	            },
	
	            controller: function controller($scope, $logger) {
	                $scope.trackExternalLink = function (linkName) {
	                    $logger.info(linkName);
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-ui-components/src/error-tooltip/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angularAria = __webpack_require__("./components/angular-aria/angular-aria.min.js");
	
	// Configure angular aria.
	// Note that aria configuration applies globally
	_angularAria.$ariaProvider.config({ // eslint-disable-line angular/di
	    // Remove bindRoleForClick since we use ngClick for several items that shouldn't be treated as buttons.
	    bindRoleForClick: false,
	
	    // Remove ariaInvalid and ariaRequired as we want to handle them ourselves.
	    // These attributes should only be set once the form is submitted, to match what
	    // visually what we display
	    ariaInvalid: false,
	    ariaRequired: false
	});
	
	(0, _angular.$registerDirective)('xo-error-tooltip', function () {
	
	    return {
	        restrict: 'A',
	        require: ['?^form', '?ngModel'],
	        link: function link(scope, element, attrs, ctrls) {
	            var formCtrl = ctrls[0],
	                modelCtrl = ctrls[1];
	
	
	            function shouldBeRequired() {
	                if (formCtrl) {
	                    // If input is a checkbox and has error-text or error-key, show the error text instead of the required text.
	                    // error-text is a legacy thing for backward compatibility, we can get rid of this once all teams
	                    // adopt error-key in all input tags
	                    var showCheckboxRequired = !(element.attr('type') === 'checkbox' && (attrs.errorText || attrs.errorKey));
	                    return formCtrl.$submitted && modelCtrl.$error.required && showCheckboxRequired;
	                } else {
	                    return modelCtrl.$error.required;
	                }
	            }
	
	            function shouldBeInvalid() {
	                if (formCtrl) {
	                    return formCtrl.$submitted && modelCtrl.$invalid;
	                } else {
	                    return modelCtrl.$invalid;
	                }
	            }
	
	            // Add or remove a string into a space split string (eg. aria-describedby ids, class names)
	            function formatSpaceSplitString(str, id, add) {
	                var strArray;
	                if (str) {
	                    strArray = str.split(' ');
	                } else {
	                    strArray = [];
	                }
	
	                var idIndex = strArray.indexOf(id);
	
	                if (~idIndex && !add) {
	                    strArray.splice(idIndex, 1);
	                } else if (!~idIndex && add) {
	                    strArray.push(id);
	                }
	
	                return strArray.join(' ');
	            }
	
	            // Add tooltip behavior after DOM settles
	            (0, _angular.$timeout)(function () {
	                var generateId = function generateId() {
	                    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
	                };
	
	                var requiredId = generateId();
	                var invalidId = generateId();
	                var requiredError;
	                var invalidError;
	
	                if (attrs.errorKey) {
	                    element.addClass('hasErrorTooltipRuleSpecific');
	                    invalidError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">{{content("' + attrs.errorKey + '")}}</div>')(scope);
	                    element.after(invalidError);
	                } else if (attrs.errorText) {
	                    // errorText if case is for backward compatibility, we can get rid of this once
	                    // all teams adopt error-key in all input tags for tooltip message display
	                    element.addClass('hasErrorTooltipRuleSpecific');
	                    invalidError = $('<div class="errorTooltip errorTooltipRuleSpecific" id="' + invalidId + '">' + attrs.errorText + '</div>');
	                    element.after(invalidError);
	                }
	
	                if (attrs.required || (0, _angular.$parse)(attrs.ngRequired)(scope)) {
	                    element.addClass('hasErrorTooltipRequired');
	                    requiredError = (0, _angular.$compile)('<div class="errorTooltip errorTooltipRequired" id="' + requiredId + '">{{content("validation.required")}}</div>')(scope);
	                    element.after(requiredError);
	
	                    element.removeAttr('aria-required');
	                }
	
	                function setAriaAttributes() {
	                    var addTooltips = {
	                        required: false,
	                        invalid: false
	                    };
	
	                    // Do not associate "Required" error with aria-describedby
	                    // because this should already be read out either by "required"
	                    // attribute or "aria-required"=true, and only associate "Invalid"
	                    // error if "Required" is not showing to match visuals
	                    if (shouldBeRequired()) {
	                        addTooltips.required = true;
	                    } else if (shouldBeInvalid()) {
	                        addTooltips.invalid = true;
	                    }
	
	                    var describedby = element.attr('aria-describedby');
	                    describedby = formatSpaceSplitString(describedby, requiredId, addTooltips.required);
	                    describedby = formatSpaceSplitString(describedby, invalidId, addTooltips.invalid);
	                    element.attr('aria-describedby', describedby);
	                }
	
	                scope.$watch(shouldBeRequired, function (newVal) {
	                    setAriaAttributes();
	                });
	                scope.$watch(shouldBeInvalid, function (newVal) {
	                    element.attr('aria-invalid', newVal);
	                    setAriaAttributes();
	                });
	
	                // Set scroll so that the error message is in view when element receives focus
	                element.on('focus', function (event) {
	                    var windowBot = $(window).scrollTop() + $(window).height();
	                    var requiredBot = requiredError ? requiredError.offset().top + requiredError.outerHeight() : 0;
	                    var invalidBot = invalidError ? invalidError.offset().top + invalidError.outerHeight() : 0;
	                    if (windowBot < Math.max(requiredBot, invalidBot)) {
	                        $(window).scrollTop(Math.max(requiredBot, invalidBot) - $(window).height());
	                    }
	                });
	            });
	        }
	    };
	});
	
	_angular.$registerDirective;
	
	_angular.$parse;
	
	_angular.$compile;
	
	_angular.$timeout;
	
	_angularAria.$ariaProvider;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/login/template.html":
/***/ function(module, exports) {

	module.exports = "<form name=\"loginForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\">\n    <div class=\"inputField emailField confidential\">\n        <label for=\"username\" class=\"focus accessAid\">\n            {{ content('index.EmailLabel') }}\n        </label>\n        <input ng-model=\"auth.email\" id=\"username\" name=\"username\" type=\"email\" ng-readonly=\"auth.emailReadOnly\" value=\"\"\n               autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\" placeholder=\"{{ content('index.EmailLabel') }}\" data-error-key=\"email.invalid\" xo-error-tooltip required autofocus/>\n    </div>\n\n    <div class=\"inputField passwordField confidential\">\n        <label for=\"password\" class=\"focus accessAid\">\n            {{ content('login.passwordLabel') }}\n        </label>\n        <input ng-model=\"auth.password\" id=\"password\" name=\"password\" type=\"password\" value=\"\" aria-required=\"true\" autocapitalize=\"off\" autocomplete=\"off\" placeholder=\"{{ content('login.passwordLabel') }}\" xo-error-tooltip required>\n    </div>\n\n    <div ng-switch class=\"checkbox\" id=\"rmSection\" on=\"rememberMe\">\n        <div ng-switch-when=\"nonKmli\" class=\"secondary\">\n            <input ng-model=\"rememberMeChkBox.agreed\" type=\"checkbox\" id=\"agree\" ng-click=\"toggleRMDetails()\"/>\n            <label for=\"agree\">\n                {{content('rememberMe.remember')}}\n                <a ng-click=\"showRmMore=!showRmMore\">\n                    <span ng-bind=\"showRmMore ? content('rememberMe.close'): content('rememberMe.more')\"></span>\n                </a>\n            </label>\n            <ul id=\"rmLearnMore\" ng-show=\"showRmMore\">\n                <li>{{ content('rememberMe.skipLogin') }}</li>\n                <li>{{ content('rememberMe.toCancel') }}</li>\n                <li>{{ content('rememberMe.protectAccounts') }}</li>\n            </ul>\n        </div>\n        <div ng-switch-when=\"kmli\">\n            <input ng-model=\"rememberMeChkBox.agreed\" type=\"checkbox\" id=\"agree\">\n            <label for=\"agree\" ng-bind=\"content('login.keepMeLoggedIn')\" class=\"kmliCheckboxLabel\"></label>\n            <div class=\"signupbml kmliHelpIcon\">\n                <a href=\"#\" id=\"verifyHelp\" class=\"verifyHelp\"><img alt=\"{{ content('login.kmliTooltipTitle') }}\" /></a>\n            </div>\n        </div>\n    </div>\n\n    <xo-tooltip trigger=\"#verifyHelp\" display-inline=\"true\">\n        <div class=\"keepMeLoginTerms\" id=\"keepMeLoginTerms\">\n            <p>{{ content('login.kmliTooltipLine1') }}</p>\n            <p>{{ content('login.kmliTooltipLine2') }}</p>\n            <p>{{ content('login.kmliTooltipLine3') }}</p>\n        </div>\n    </xo-tooltip>\n\n    <input track-submit type=\"submit\" value=\"{{ content('login.loginBtn') }}\" class=\"btn full loginBtn\" validate-submit=\"onSubmit()\" />\n\n    <div class=\"center mt10 secondary\" id=\"forgotPasswordSection\">\n        <a href=\"{{forgotPasswordUrl}}\" id=\"forgot_password_link\" target=\"_blank\" class=\"smallPopup\" xo-popup>\n            {{ content('common.forgotYourPassword') }}</a>\n    </div>\n</form>\n"

/***/ },

/***/ "./components/xo-models/src/user/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.user', ['squid']).factory('$CheckoutClientDataModel', function ($Model, $Api) {
	
	        return $Model.extend('CheckoutClientDataModel', {
	
	            api: new $Api({
	                uri: '/api/user/:id/clientData'
	            }),
	
	            merchantIdentityData: function merchantIdentityData() {
	                return {
	                    email: this.email,
	                    brand_name: this.display_name,
	                    logo_uri: this.logo_uri,
	                    identity_uri: this.identity_uri
	                };
	            },
	
	            validateClient: function validateClient() {
	                if (this.partner_id && this.identity_uri) {
	                    return {
	                        success: true
	                    };
	                } else {
	                    return {
	                        success: false,
	                        error: 'invalid_client'
	                    };
	                }
	            },
	            validateRedirectUri: function validateRedirectUri(redirectUrl) {
	                if (this.identity_uri && this.identity_uri.indexOf(redirectUrl) > -1) {
	                    return {
	                        success: true
	                    };
	                } else {
	                    return {
	                        success: false,
	                        error: 'invalid_redirect_url'
	                    };
	                }
	            }
	        });
	    }).factory('$CheckoutInputDataModel', function ($Model, $Api, $config, $util) {
	
	        var ACTION = {
	            login: 'login',
	            resolve: 'resolve',
	            addCard: 'addCard',
	            addBank: 'addBank',
	            changeCurrencyConv: 'changeCurrencyConv',
	            signup: 'signup',
	            mandate: 'mandate',
	            addCredit: 'addCredit',
	            ulReturn: 'ulReturn',
	            creditReturn: 'creditReturn',
	            guestCurrencyConversion: 'guestCurrencyConversion'
	        };
	
	        return $Model.extend('CheckoutInputDataModel', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.setProperties({
	                    client_id: $util.param('client_id'),
	                    action: $util.param('action'),
	                    redirect_uri: $util.param('redirect_uri'),
	                    scope: $util.param('scope'),
	                    state: $util.param('state'),
	                    flow: $util.param('flow'),
	                    payer_id: $util.param('payer_id'),
	                    mandate_reference_number: $util.param('mandate_reference_number'),
	                    funding_option_id: $util.param('funding_option_id'),
	                    locale: $util.param('locale'),
	                    logout: $util.param('logout'),
	                    refresh_parent: $util.param('refresh_parent'),
	                    escape_hatch: $util.param('escape_hatch'),
	                    failedBecause: $util.param('failedBecause'),
	                    redirectReferrer: $util.param('redirectReferrer'),
	                    id_token: $util.param('prox_id'),
	                    nonce: $util.param('nonce'),
	                    hide_rm: $util.param('hideRM'),
	                    payloadEnc: $util.param('payloadEnc'),
	                    xcancel: $util.param('x-cancel'),
	                    xsuccess: $util.param('x-success')
	                });
	            },
	
	            api: new $Api({
	                baseURI: $config.urls.baseUrl,
	                uri: '/api/user/:id/payerId'
	            }),
	
	            isEbayTxn: function isEbayTxn() {
	                return Boolean(this.client_id);
	            },
	
	            validAction: function validAction() {
	                var actions = {
	                    login: 'login',
	                    resolve: 'resolve',
	                    addCard: 'addCard',
	                    addBank: 'addBank',
	                    changeCurrencyConv: 'changeCurrencyConv',
	                    signup: 'signup',
	                    mandate: 'mandate',
	                    addCredit: 'addCredit',
	                    ulReturn: 'ulReturn',
	                    creditReturn: 'creditReturn',
	                    guestCurrencyConversion: 'guestCurrencyConversion'
	                };
	
	                return actions.hasOwnProperty(this.action);
	            },
	
	            showRYP: function showRYP() {
	                return !this.isEbayTxn();
	            },
	
	            requiresOAuth: function requiresOAuth() {
	                return this.action === ACTION.login || this.action === ACTION.signup;
	            },
	
	            requiresRedirectUri: function requiresRedirectUri() {
	                return this.action === ACTION.mandate || !this.requiresOAuth();
	            },
	
	            validRedirectUri: function validRedirectUri() {
	                if (this.requiresRedirectUri()) {
	                    return Boolean(this.redirect_uri);
	                }
	                return true;
	            },
	
	            validate: function validate() {
	                var error;
	                var success = true;
	
	                if (this.isEbayTxn()) {
	                    if (!this.validAction()) {
	                        success = false;
	                        error = 'invalid_action';
	                    } else if (!this.validRedirectUri()) {
	                        success = false;
	                        error = 'invalid_redirect_uri';
	                    }
	                }
	
	                return {
	                    success: success,
	                    error: error
	                };
	            },
	
	            errorUrl: function errorUrl(err, errorDesc) {
	                var url = this.redirect_uri;
	
	                url += url && url.indexOf('?') < 0 ? '?' : '&';
	                url += 'state=' + encodeURIComponent(this.state);
	
	                if (err) {
	                    url += '&error=' + err;
	                }
	                if (errorDesc) {
	                    url += '&error_description=' + errorDesc;
	                }
	
	                return url;
	            },
	
	            successUrl: function successUrl(code) {
	                var url = this.redirect_uri;
	
	                url += url && url.indexOf('?') < 0 ? '?' : '&';
	                url += 'state=' + encodeURIComponent(this.state);
	
	                url += '&code=' + code;
	
	                return url;
	            },
	
	            rmEnabled: function rmEnabled(featureEnabled) {
	                return featureEnabled && this.action === ACTION.login;
	            },
	
	            hideRM: function hideRM() {
	                return angular.isDefined(this.hide_rm) ? this.hide_rm.toLowerCase() === 'true' : false;
	            }
	        });
	    }).factory('$UserInfoModel', function ($Model, $Api) {
	        return $Model.extend('UserInfoModel', {
	            api: new $Api({
	                uri: '/api/user/:id/session'
	            })
	        });
	    }).factory('$ValidatePhoneModel', function ($Model, $Api) {
	
	        return $Model.extend('validatePhoneModel', {
	            api: new $Api({
	                uri: '/api/user/:token/session/validatePhone',
	                cache: false
	            })
	        });
	    }).factory('$AddKYCModel', function ($Model, $Api) {
	        return $Model.extend('AddKYCModel', {
	            api: new $Api({
	                uri: '/api/user/:token/session/addKYC'
	            })
	        });
	    }).factory('$PatchPhoneModel', function ($Model, $Api) {
	
	        return $Model.extend('patchPhoneModel', {
	            api: new $Api({
	                uri: '/api/checkout/:token/session/patch',
	                cache: false
	            })
	        });
	    }).factory('$WaxUserModel', function ($Model, $Api) {
	        return $Model.extend('WaxUserModel', {
	            api: new $Api({
	                uri: '/api/user/:id/waxUser'
	            })
	        });
	    }).factory('$EConsentModel', function ($Model, $Api) {
	        return $Model.extend('EConsentModel', {
	            api: new $Api({
	                uri: '/api/user/eConsent'
	            })
	        });
	    }).factory('$UserPhotoModel', function ($Model, $Api, $config) {
	        return $Model.extend('UserPhotoModel', {
	            api: new $Api({
	                baseURI: $config.urls.baseUrl,
	                uri: 'api/user/photo'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/user", "components/xo-models/src/user/index.js"))

/***/ },

/***/ "./components/xo-login-components/src/login/props.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-login-props', ['squid']).factory('$loginProps', function ($rootScope, $window, $logger) {
	
	        var RISKY_LOGIN_TITLE = {
	            ECONSENT_REQUIRED: '',
	            ELV_DECLINE: '',
	            EXPIRED_CREDIT_CARD: 'login.riskyLoginUpdateCard',
	            INSTANT_FUNDING_SOURCE_UPSELL_NEEDED: '',
	            NEED_CREDIT_CARD: 'login.riskyLoginAddCard',
	            NEED_CREDIT_CARD_OR_BANK_ACCOUNT: 'login.riskyLoginAddFi',
	            NEED_CONFIRMED_CARD: '',
	            NEED_AUTHENTICATED_CARD: 'login.riskyLoginUpdateCard',
	            NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShipping',
	            PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhone',
	            PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassed',
	            SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepa',
	            TAX_ID_REQUIRED: ''
	        };
	        var RISKY_LOGIN_SUBTITLE = {
	            EXPIRED_CREDIT_CARD: 'login.riskyLoginExpiredCardST',
	            NEED_SHIPPING_ADDRESS: 'login.riskyLoginAddShippingST',
	            PHONE_NUMBER_REQUIRED: 'login.riskyLoginAddPhoneST',
	            SEPA_MANDATE_ACCEPTANCE_NEEDED: 'login.riskyLoginSepaST',
	            PAYER_AUTHENTICATION_REQUIRED: 'login.riskyLoginShippingPassedST'
	        };
	
	        return {
	            mapInfo: function mapInfo(contingency) {
	                var contingencyTitle = RISKY_LOGIN_TITLE[contingency] ? RISKY_LOGIN_TITLE[contingency] : 'login.loginContingency';
	                var contingencySubTitle = RISKY_LOGIN_SUBTITLE[contingency];
	                return { title: contingencyTitle, subtitle: contingencySubTitle };
	            },
	
	            inList: function inList(contingency) {
	                return RISKY_LOGIN_TITLE.hasOwnProperty(contingency);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/login", "components/xo-login-components/src/login/props.js"))

/***/ },

/***/ "./components/xo-form-components/src/language-options/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/language-options/template.html"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	    squid.module('xo-language-options.directive', ['squid', 'xo-accessibility.directive']).directive('xoLanguageOptions', function () {
	        return {
	            template: template,
	
	            scope: {},
	
	            controller: function controller($scope, $populate, $locale, $Class, $config, $meta) {
	                $scope.showLanguages = false;
	
	                function setLanguageVars() {
	                    $scope.localeModel = $locale;
	                    $scope.currentLanguage = $scope.localeModel.lang;
	                    $scope.currentCountry = $scope.localeModel.country;
	                    $scope.languageList = $scope.localeModel.metadata.languageLabel;
	                    $scope.supportedLanguages = $config.supportedCountries[$scope.currentCountry];
	                    $scope.hasMultipleLanguages = $scope.supportedLanguages && $scope.supportedLanguages.length > 1 ? true : false;
	                }
	
	                $scope.selectLanguage = function (language) {
	                    $scope.currentLanguage = language;
	                    $locale.chooseLang(language);
	                };
	
	                $scope.toggle = function ($event) {
	                    if ($event) {
	                        $event.preventDefault();
	                    }
	
	                    $scope.showLanguages = !$scope.showLanguages;
	                };
	
	                setLanguageVars();
	
	                // Reset locale properties for languageToggle
	                $scope.$on('localeChange', function () {
	                    setLanguageVars();
	                });
	
	                // "clickBody" is an artifical event broadcast by the xo-checkout component (essentially document.click)
	                $scope.$on('clickBody', function ($event, target) {
	                    if ($(target).parents('.languageToggleDisplay div').length === 0) {
	                        $scope.showLanguages = false;
	                        $scope.$apply();
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/language-options/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"languageToggleDisplay\" content feature=\"languageToggle\" ng-if=\"hasMultipleLanguages\">\n    <div>\n        <a id=\"clickLanguageToggle\" lang=\"{{ currentLanguage }}\" aria-expanded=\"{{showLanguages}}\" aria-label=\"{{ content('languages.label', {language: languageList[currentLanguage]}) }}\" ng-click=\"toggle()\" select-button focus-when=\"!showLanguages\" focused-once-before><span class=\"displayText\">{{languageList[currentLanguage]}}</span><span class=\"changeLanguage\" ng-class=\"{expand:showLanguages}\"></span></a>\n    </div>\n    <div id=\"langDropdownBlock\" ng-show=\"showLanguages\" class=\"bottom\">\n        <div class=\"arrow\"></div>\n        <div ng-click=\"toggle()\">\n            <ul aria-labelledby=\"clickLanguageToggle\" select-box=\"showLanguages && supportedLanguages\" select-cancel=\"toggle()\">\n                <li role=\"presentation\" ng-repeat=\"lang in supportedLanguages\" lang=\"{{ lang }}\">\n                    <a track-link=\"language_change\" class=\"submit\" ng-click=\"selectLanguage(lang)\" link-button select-option=\"lang == currentLanguage\" focus-when=\"showLanguages && lang == currentLanguage\">{{languageList[lang]}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ },

/***/ "./components/xo-ui-components/src/accessibility/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _ui = __webpack_require__("./components/xo-ui-components/src/accessibility/ui.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adds role='button' and tabindex='0' to anchor elements
	// so that it is keyboard navigable and recognized by screen
	// readers as a button.
	//
	// As anchors without href do not fire their click event
	// automatically on a Space or ENTER key, this directive forces
	// that functionality.
	//
	// If something is assigned to the link-button attribute, then
	// it is used as an aria-label.
	(0, _angular.$registerDirective)('link-button', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var ariaLabel = (0, _angular.$parse)(attrs.linkButton)(scope);
	            var $element = (0, _jquery2['default'])(element);
	
	            $element.attr('role', 'button');
	            $element.attr('tabindex', '0');
	            if (ariaLabel) {
	                $element.attr('aria-label', ariaLabel);
	            }
	            $element.on('keydown', function (event) {
	                // do nothing if there is an alt or ctrl key as well
	                if (!(event.altKey || event.ctrlKey)) {
	                    switch (event.keyCode) {
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            element[0].click();
	                            return false;
	                        default:
	                            break;
	                    }
	                }
	                return true;
	            });
	        }
	    };
	});
	
	// this directive gives an element characteristics of a native
	// select element in terms of keyboard navigation. It becomes reachable
	// via the tab key, reflects screenreader characteristics and
	// can be activated by any of the DOWN, SPACE or ENTER KEYS.
	(0, _angular.$registerDirective)('select-button', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var $element = (0, _jquery2['default'])(element);
	            $element.attr('role', 'button').attr('aria-haspopup', 'true').attr('tabindex', '0').on('keydown', function (event) {
	                // do nothing if there is an alt or ctrl key as well
	                if (!(event.altKey || event.ctrlKey)) {
	                    switch (event.keyCode) {
	                        case _ui.KEYS.DOWN:
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            element[0].click();
	                            return false;
	                        default:
	                            break;
	                    }
	                }
	                return true;
	            });
	        }
	    };
	});
	
	// this directive makes a container with links act as if it were a select dropdown
	// in terms of keyboard accessibility. The following characteristics are implemented:
	//
	// * UP/RIGHT and DOWN/lEFT KEYS navigate through the options.
	// * ESC cancels and closes the dropdown
	// * SPACE or ENTER select an option
	// * You cannot TAB out of a dropdown until you select or cancel
	//
	// in addition, the following extra characteristics are implemented
	//
	// * The TAB (and SHIFT-TAB) key will also function to move between options
	// * Upon reaching the end of the list, the focus will shift back to the first item, and vice versa
	//
	// How to use:
	// 1. The select-cancel attribute is an agnostic expression to implement the cancel / back mechanic.
	//    The expression is run whenever the ESC key is pressed.
	// 2. The select-allow-tab-escape attribute can be added alongside the select-box attribute to allow
	//    tabs to escape the select-box element.
	(0, _angular.$registerDirective)('select-box', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var allowTabEscape = (0, _angular.isDefined)(attrs.selectAllowTabEscape);
	
	            function escapeToggle() {
	                if (attrs.selectCancel) {
	                    (0, _angular.$parse)(attrs.selectCancel)(scope);
	                    scope.$apply();
	                }
	            }
	
	            element.attr('role', 'menu');
	
	            element.on('keydown.selectBox', function (event) {
	                var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
	                var $origin = (0, _jquery2['default'])(event.target);
	
	                if (!(event.altKey || event.ctrlKey)) {
	                    var index = $allTabbable.index($origin);
	
	                    switch (event.keyCode) {
	                        case _ui.KEYS.TAB:
	                            if (allowTabEscape && (index === 0 && event.shiftKey || index === $allTabbable.length && !event.shiftKey)) {
	                                // Enable default behavior to escape select-box
	                                escapeToggle();
	                                break;
	                            } else if (event.shiftKey) {
	                                index = (index - 1 + $allTabbable.length) % $allTabbable.length;
	                            } else {
	                                index = (index + 1) % $allTabbable.length;
	                            }
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.DOWN:
	                        case _ui.KEYS.RIGHT:
	                            index = (index + 1) % $allTabbable.length;
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.UP:
	                        case _ui.KEYS.LEFT:
	                            index = (index - 1 + $allTabbable.length) % $allTabbable.length;
	                            $allTabbable.eq(index).focus();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.SPACE:
	                        case _ui.KEYS.ENTER:
	                            $origin.click();
	                            event.preventDefault();
	                            break;
	                        case _ui.KEYS.ESC:
	                            escapeToggle();
	                            break;
	                        default:
	                            break;
	                    }
	                }
	            });
	        }
	    };
	});
	
	// similar to select-box, this directive restrains tabbing within a container
	// to the container itself.
	//
	// 1. modal-cancel is the equivalent of select-cancel from select-box, and
	// should define a cancellation / ESC function.
	(0, _angular.$registerDirective)('modal-box', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function escapeToggle() {
	                (0, _angular.$parse)(attrs.modalCancel)(scope);
	                scope.$apply();
	            }
	
	            // Gets the index of the element that should be focused after pressing Tab
	            function getNextIndex($element, $elements, shift) {
	                if (shift) {
	                    return ($elements.index($element) - 1 + $elements.length) % $elements.length;
	                } else {
	                    return ($elements.index($element) + 1) % $elements.length;
	                }
	            }
	
	            if ((0, _angular.$parse)(attrs.modalBox)(scope) !== false) {
	                element.on('keydown.modalBox', function (event) {
	                    var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
	                    var $origin = (0, _jquery2['default'])(event.target);
	
	                    if (!(event.altKey || event.ctrlKey)) {
	                        switch (event.keyCode) {
	                            case _ui.KEYS.TAB:
	                                var index = getNextIndex($origin, $allTabbable, event.shiftKey);
	                                $allTabbable.eq(index).focus();
	                                event.preventDefault();
	                                event.stopPropagation();
	                                break;
	                            case _ui.KEYS.ESC:
	                                escapeToggle();
	                                event.preventDefault();
	                                event.stopPropagation();
	                                break;
	                            default:
	                                break;
	                        }
	                    }
	                });
	            }
	        }
	    };
	});
	
	// A simple version of modal that doesn't rely on controlling keyboard behavior
	// as strictly. Should be used in cases where tab items are not as easily accessible
	// via JS (ie. iframes)
	// Redirects focus to container when focusin event fired on element not in container
	(0, _angular.$registerDirective)('simple-modal', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.attr('tabindex', '-1');
	
	            var cancelFn;
	            if (attrs.modalCancel) {
	                cancelFn = function cancelFn() {
	                    (0, _angular.$parse)(attrs.modalCancel)(scope);
	                    scope.$apply();
	                };
	            }
	
	            function registerModal() {
	                (0, _jquery2['default'])(document).on('focusin.simple-modal', function (event) {
	                    if (!element[0].contains(event.target)) {
	                        event.stopPropagation();
	                        element.focus();
	                    }
	                });
	                if (cancelFn) {
	                    (0, _jquery2['default'])(document).on('click.simple-modal', function (event) {
	                        if (!element[0].contains(event.target)) {
	                            deregisterModal();
	                            cancelFn();
	                        }
	                    });
	                }
	            }
	
	            function deregisterModal() {
	                (0, _jquery2['default'])(document).off('focusin.simple-modal');
	                (0, _jquery2['default'])(document).off('click.simple-modal');
	            }
	
	            // Watch the expression provided to simpleModal and add modal behavior when
	            // expression result changes to truthy
	            if ((0, _angular.isDefined)(element.attr('simpleModal'))) {
	                scope.$watch(attrs['simpleModal'], function (newVal) {
	                    if (newVal) {
	                        registerModal();
	                    } else {
	                        deregisterModal();
	                    }
	                });
	            } else {
	                registerModal();
	            }
	
	            scope.$on('$destroy', deregisterModal);
	        }
	    };
	});
	
	// this directive gives an element characteristics of a native
	// option element in terms of aria attributes. It must be used
	// as a child of a selectBox for proper keyboard behavior as it
	// disables default tabbing behavior.
	//
	// The expression provided to the directive is used to set the
	// aria-selected attribute when the expression evaluates to true.
	(0, _angular.$registerDirective)('select-option', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            (0, _jquery2['default'])(element).attr('role', 'menuitem');
	            if ((0, _angular.$parse)(attrs.selectOption)(scope)) {
	                (0, _jquery2['default'])(element).attr('aria-selected', 'true');
	            }
	        }
	    };
	});
	
	// adapted from http://stackoverflow.com/a/24416690
	// This directive makes the element focused when the expression
	// provided _changes_ to true.
	//
	// In order to avoid conflicts with autofocus when a page first loads,
	// adding the focused-once-before attribute will enable the expression
	// only if it has been focused on before.
	//
	// * if the element itself is not focusable, then it will locate the first focusable
	// element within it.
	// * if the additional attribute focus-element is provided, it is wrapped
	// as a jQuery element (could be selector string or actual element) and focused on
	// it will be parsed when the focus-when attribute is true
	// * if the attribute focus-on is provided, then the focus-when attribute is ignored and
	// the directive listens to the event specified by focus-on
	(0, _angular.$registerDirective)('focus-when', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            function locateAndFocus(active) {
	                (0, _angular.$timeout)(function () {
	                    if (active) {
	                        // deal with figuring out which element to focus on
	                        var $elementToFocus = (0, _jquery2['default'])(); // start with "monad" to make life easier
	                        var directiveElementFocusable = (0, _ui.focusable)(element[0]);
	
	                        // this works by fallthrough. it will try each one
	                        // in succession until an element is found
	                        if (attrs.focusElement) {
	                            // scenario 1 - specific element provided
	                            $elementToFocus = (0, _ui.filterAll)((0, _angular.$parse)(attrs.focusElement)(scope), _ui.focusable);
	                        }
	
	                        if ($elementToFocus.length === 0 && !directiveElementFocusable) {
	                            // scenario 2 - element with directive is not focusable
	                            $elementToFocus = (0, _ui.findAll)(element, _ui.focusable);
	                        }
	
	                        // default / scenario 3 - no valid targets specified or found
	                        if ($elementToFocus.length === 0) {
	                            $elementToFocus = (0, _jquery2['default'])(element);
	                        }
	
	                        $elementToFocus.first().focus();
	                    }
	                });
	            }
	
	            var active = true;
	
	            if ('focusedOnceBefore' in attrs) {
	                active = false;
	                (0, _jquery2['default'])(element).on('focus', function () {
	                    active = true;
	                });
	            }
	
	            if (attrs.focusRefreshOn) {
	                scope.$on((0, _angular.$parse)(attrs.focusRefreshOn)(scope), function () {
	                    locateAndFocus(active);
	                });
	            } else {
	                scope.$watch(attrs.focusWhen, function (val) {
	                    locateAndFocus(active && val);
	                });
	            }
	        }
	    };
	});
	
	// angularUI router specific - listens to a specific transition
	// defined in two attributes, focusWhenState (this directive) and TransitionsTo
	var FOCUS_EVENT_NAME = 'accessible-focus';
	(0, _angular.$registerDirective)('focus-when-state', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            var startState = attrs.focusWhenState;
	            var endState = attrs.transitionsTo;
	            var transitionMessage = startState + ' > ' + endState;
	            var unregisterEventFn = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                if (fromState.name === startState && toState.name === endState) {
	                    scope.$broadcast(FOCUS_EVENT_NAME, transitionMessage);
	                }
	            });
	
	            scope.$on(FOCUS_EVENT_NAME, function (event, message) {
	                if (message === transitionMessage) {
	                    (0, _angular.$timeout)(function () {
	                        return element[0].focus();
	                    });
	                }
	            });
	
	            // see http://stackoverflow.com/a/27016855
	            scope.$on('$destroy', unregisterEventFn);
	        }
	    };
	});
	
	// Listens for the next state transition and focuses an element provided by selector
	// Use with links where focus is needed to return to a specific element after the transition
	(0, _angular.$registerDirective)('focus-after-transition', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.on('click', function () {
	                var focusSelector = attrs['focusAfterTransition'];
	                var cancel = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
	                    cancel();
	                    (0, _angular.$timeout)(function () {
	                        (0, _jquery2['default'])(focusSelector).focus();
	                    });
	                });
	            });
	        }
	    };
	});
	
	// focuses on the first focusable element on a container containing form elements
	(0, _angular.$registerDirective)('form-autofocus', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            // wait for the entire DOM to settle down first
	            (0, _angular.$timeout)(function () {
	                var $allFocusable = (0, _ui.findAll)(element, _ui.focusable);
	                if ($allFocusable.length > 0) {
	                    $allFocusable.first().focus();
	                }
	            });
	        }
	    };
	});
	
	// Change element to be focusable and tabbable or unfocusable if it is
	// not typically a focusable element by removing the tabindex attribute.
	(0, _angular.$registerDirective)('focusable', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function setFocusable(value) {
	                if (value) {
	                    element.attr('tabindex', 0);
	                } else {
	                    element.removeAttr('tabindex');
	                }
	            }
	
	            if (attrs.focusable) {
	                scope.$watch(attrs.focusable, function (newVal) {
	                    if (newVal) {
	                        setFocusable(true);
	                    } else {
	                        setFocusable(false);
	                    }
	                });
	            } else {
	                setFocusable(true);
	            }
	        }
	    };
	});
	
	_angular.$registerDirective;
	
	_angular.$parse;
	
	_angular.$timeout;
	
	_angular.$rootScope;
	
	_angular.isDefined;
	
	_ui.KEYS;
	
	_ui.focusable;
	
	_ui.tabbable;
	
	_ui.findAll;
	
	_ui.filterAll;

/***/ },

/***/ "./components/xo-ui-components/src/accessibility/ui.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.filterAll = exports.findAll = exports.tabbable = exports.focusable = exports.visible = exports.KEYS = undefined;
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var KEYS = {
	    TAB: 0x09,
	    ENTER: 0x0D,
	    ESC: 0x1B,
	    SPACE: 0x20,
	    LEFT: 0x25,
	    UP: 0x26,
	    RIGHT: 0x27,
	    DOWN: 0x28
	};
	
	function visible(element) {
	    return _jquery2['default'].expr.filters.visible(element) && !(0, _jquery2['default'])(element).parents().addBack().filter(function () {
	        return _jquery2['default'].css(this, 'visibility') === 'hidden';
	    }).length;
	}
	
	// ripped from http://stackoverflow.com/a/7668761
	/* istanbul ignore next */
	function focusable(element) {
	    var nodeName = element.nodeName.toLowerCase();
	    var isTabIndexNotNaN = !isNaN(_jquery2['default'].attr(element, 'tabindex'));
	    var map;
	    var mapName;
	    var img;
	
	    if (nodeName === 'area') {
	        map = element.parentNode;
	        mapName = map.name;
	        if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
	            return false;
	        }
	        img = (0, _jquery2['default'])('img[usemap=#' + mapName + ']')[0];
	        return !!img && visible(img);
	    }
	    return (/^(input|select|textarea|button|object)$/.test(nodeName) ? // eslint-disable-line no-nested-ternary
	    !element.disabled : nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) &&
	    // the element and all of its ancestors must be visible
	    visible(element);
	}
	
	/* istanbul ignore next */
	function tabbable(element) {
	    var tabIndex = _jquery2['default'].attr(element, 'tabindex');
	    var isTabIndexNaN = isNaN(tabIndex);
	
	    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
	}
	
	function filterAll(elements, filterFn) {
	    return (0, _jquery2['default'])(elements).filter(function () {
	        return filterFn(this);
	    });
	}
	
	function findAll(container, filterFn) {
	    return filterAll((0, _jquery2['default'])(container).find('*'), filterFn);
	}
	
	exports.KEYS = KEYS;
	exports.visible = visible;
	exports.focusable = focusable;
	exports.tabbable = tabbable;
	exports.findAll = findAll;
	exports.filterAll = filterAll;

/***/ },

/***/ "./components/xo-login-components/src/unified-login/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/unified-login/template.html"), __webpack_require__("./components/xo-login-components/src/login/kmliEligibility.js"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js"), __webpack_require__("./components/xo-tracking/dist/index.js"), __webpack_require__("./components/ul-inline/dist/inject.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-models/src/auth/lib/xoAPayUtils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	    return angular.module('xo-unified-login.directive', ['squid', 'xo-unified-login.kmliUpsell', 'tracking', 'xolocale', 'xo-device-info', 'xo-fn']).directive('xoUnifiedLogin', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                redirectUri: '=',
	                parentCallback: '=',
	                doneFn: '=',
	                errorFn: '=',
	                autoLogin: '=',
	                promptlogin: '=',
	                logoutCallback: '=',
	                kmli: '=',
	                preAuth: '=',
	                postAuth: '=',
	                flowcontext: '='
	            },
	            controller: function controller($scope, $populate, $rootScope, $CheckoutAppDataModel, $LocaleModel, $config, $state, $stateParams, $timeout, $FallbackError, $KmliUpsell, $logger, $locale, $fpti, $AuthModel, $ULoginModel, $util, $pxp, $CalDataModel, $meta, $DeviceInfo, $pxpMatch, $feature, $q, $promise, $CheckoutCartModel, $fn, $window, $xoAPayUtils, $KmliEligibility) {
	                var PAYPAL = window.PAYPAL || {};
	                var loginAttemptedMethod = '';
	                var userSelectedLanguage = '';
	                var failureReasons = {
	                    timeout: 'TIMEDOUT',
	                    error: 'INTERNALERROR',
	                    blacklistedDevice: 'PLATFORM_NOT_SUPPORTED',
	                    fallback: 'FALLBACK'
	                };
	                var enteringTime = Date.now();
	                $logger.debug('ENTERING_LOADING_UL_IFRAME', { enteringTime: enteringTime });
	                $scope.locale = $LocaleModel.instance();
	                $scope.forcedLogin = !$scope.autoLogin; // change to true during forcedLogin scenario
	
	                if ($stateParams.source === 'NOT_YOU' || $stateParams.source === 'FRESH_START') {
	                    $scope.forcedLogin = false;
	                }
	
	                var ulTimeoutLimit = 35000;
	                var ulTimeoutPromise = null;
	
	                var loadCnt = 0;
	
	                function setLoading(tag, isRT) {
	                    $rootScope.$emit('loading');
	                    if (isRT && !$scope.auth.loggedIn()) {
	
	                        $rootScope.$emit('loadingMessage', {
	                            heading: $locale.content.get('base.loggingIn'),
	                            subHeading: $locale.content.get('login.rmSubHeading')
	                        });
	                    }
	                    loadCnt++;
	                    $logger.debug('setLoading by ' + tag + ' cnt ' + loadCnt);
	                }
	
	                function setLoaded(tag) {
	                    if (loadCnt > 0) {
	                        $rootScope.$emit('loaded');
	                        loadCnt--;
	                    } else {
	                        $logger.error('loadCnt_zero');
	                    }
	                    $logger.debug('setLoaded by ' + tag + ' cnt ' + loadCnt);
	                }
	
	                function fallback(product, reason, params) {
	                    throw new $FallbackError({
	                        product: product || 'ux',
	                        reason: reason,
	                        params: params
	                    });
	                }
	
	                function appLoginHandler(status) {
	                    $logger.debug('ULLOGIN_' + status);
	                    $logger.info('checkout_fpti', { 'from': 'LOGIN', 'to': 'prepare_login' });
	                    fallback('ux', 'ul_server_error');
	                }
	
	                var startTimerTS;
	                function startTimer(tag) {
	                    startTimerTS = Date.now();
	
	                    $logger.debug('startTimer by ' + tag, {
	                        startTime: startTimerTS
	                    });
	                    $logger.info('checkout_fpti', {
	                        'from': 'UL_Timer',
	                        'to': 'prepare_' + tag
	                    });
	
	                    ulTimeoutPromise = $timeout(function () {
	                        $logger.error('load_ul_timeout');
	                        var stop_time = Date.now();
	                        var time_taken = stop_time - startTimerTS;
	                        $logger.info('checkout_fpti', {
	                            'from': 'UL_Timer',
	                            'to': 'process_timeout',
	                            'int_error_code': 'ULLOGIN_TIMEOUT',
	                            'int_error_description': 'ULLOGIN_TIMEOUT',
	                            'error_source': 'unifiedloginnodeweb',
	                            'error_type': 'soft_decline',
	                            'page_load_time': time_taken
	                        });
	                        if (!$config.disableUlTimeout) {
	                            fallback('ux', 'ul_load_timeout');
	                        }
	                    }, ulTimeoutLimit);
	                }
	
	                function stopTimer(tag, keepLoading) {
	                    var stopTimerTS = Date.now();
	                    var timeTaken = stopTimerTS - startTimerTS;
	
	                    $logger.debug('stopTimer by ' + tag, {
	                        stopTimer: stopTimerTS,
	                        page_load_time: timeTaken
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'UL_Timer',
	                        'to': 'process_' + tag,
	                        'page_load_time': timeTaken
	                    });
	
	                    if (!keepLoading) {
	                        setLoaded('stopTimer');
	                    }
	
	                    if (ulTimeoutPromise) {
	                        $timeout.cancel(ulTimeoutPromise);
	                    }
	                }
	
	                function logFptiData(fptiData, eventName) {
	                    var errorDescription;
	                    switch (eventName) {
	                        case '2fa':
	                            errorDescription = '2fa_required';
	                            break;
	                        case 'safeRequired':
	                            errorDescription = 'SAFE_required';
	                            break;
	                        case 'stepupRequired':
	                            errorDescription = 'Login_ATO_required';
	                            break;
	                        default:
	                        // nothing to do here
	                    }
	                    $logger.info('checkout_fpti', {
	                        'from': fptiData.fptiState,
	                        'to': fptiData.fptiTransition,
	                        'int_error_code': eventName,
	                        'int_error_description': errorDescription,
	                        'error_type': 'soft_decline',
	                        'error_source': 'unifiedloginnodeweb'
	                    });
	                }
	
	                function buildRedirectURL(contingencyUrl, eventName) {
	                    var authChallengeUrl = contingencyUrl;
	                    var paramIndex = authChallengeUrl.indexOf('?');
	                    var urlParams = $util.params(authChallengeUrl.substring(paramIndex + 1));
	
	                    urlParams.returnUri = $config.ulMeta.authChallengeReturnUri;
	                    if (userSelectedLanguage) {
	                        urlParams['locale.x'] = $locale.getLocaleCode();
	                        urlParams['state'] += '&locale.test=' + $locale.getLocaleCode();
	                    }
	                    switch (eventName) {
	                        case '2fa':
	                            urlParams['state'] += '&acRedirect=2fa&ulMethod=' + loginAttemptedMethod;
	                            break;
	                        case 'safeRequired':
	                            urlParams['state'] += '&acRedirect=safe';
	                            break;
	                        case 'stepupRequired':
	                            urlParams['state'] += '&acRedirect=loginato';
	                            break;
	                        default:
	                        // nothing to do here
	                    }
	                    var redirectUrl = $util.buildURL(authChallengeUrl.substring(0, paramIndex), urlParams);
	                    return redirectUrl;
	                }
	
	                if (!$config.ulMeta) {
	                    $logger.error('config_no_ulMeta');
	                }
	
	                var ulMeta = $config.ulMeta || {};
	
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token)
	                }).then(function () {
	
	                    // if remebered user then update spinner text
	                    var isRememberedUser = $scope.auth.refreshToken();
	                    setLoading('loadUL', isRememberedUser);
	
	                    return $KmliEligibility.init({
	                        forcedLogin: $scope.forcedLogin,
	                        logoutCallback: $scope.logoutCallback
	                    });
	                }).then(function (eligibility) {
	                    ulTimeoutLimit = eligibility.ulTimeoutLimit ? eligibility.ulTimeoutLimit : ulTimeoutLimit;
	                    $scope.preloadUL = eligibility.preloadUL;
	                    $scope.safeEligibility = eligibility.safeEligibility;
	                    $scope.kmliEligibility = eligibility.kmliEligibility;
	                    if ($scope.preloadUL) {
	                        $logger.debug('ULSS_CLIENT_PRELOAD_TREATMENT');
	                        return $populate($scope, { ulSource: $ULoginModel.instance() });
	                    }
	
	                    var walletTokenization = $scope.checkoutCart.isWalletTokenization();
	                    var ulAsLanding = eligibility.ulAsLanding;
	
	                    if (!walletTokenization && !ulAsLanding && !$scope.preloadUL) {
	                        return $pxp($config.ulMeta.pxpExpId, {
	                            'ctx.COUNTRY': $scope.checkoutAppData.merchant.merchant_country,
	                            'ctx.CHANNEL': $DeviceInfo.isMobile() || $DeviceInfo.isTablet() ? 'MOBILE' : 'WEB'
	                        }, 'xo_hermes_kmli_upsell_(web|mobile)_treatment.*').then(function (pxpResult) {
	                            if (pxpResult && pxpResult.treatment_name) {
	                                $logger.debug('ryi_optin_treatment');
	                                $scope.ryiOptin = true;
	                            }
	                        });
	                    }
	                }).then(function () {
	
	                    var rememberMe = $scope.kmliEligibility;
	                    var app_int_type = $DeviceInfo.getAppIntegrationType();
	
	                    if ($scope.auth.refreshToken() && !$scope.forcedLogin) {
	                        $logger.info('checkout_fpti', {
	                            'from': 'LOGIN_UL_RM',
	                            'to': 'prepare_login_ul_RM',
	                            'app_int_type': app_int_type
	                        });
	                    }
	
	                    function getPostLoginFpti(data) {
	                        var result;
	
	                        if (data.event === 'tokenExchanged') {
	                            // This is either OneTouch or JWT (Partner Integration).
	                            if (data.authorizationToken === 'jwt_token') {
	                                result = { fptiState: 'LOGIN_UL_JWT', fptiTransition: 'process_UL_JWT' };
	                            } else {
	                                result = { fptiState: 'LOGIN_UL_RM', fptiTransition: 'process_RT_AT_exch' };
	                            }
	                        } else {
	                            var fptiTransitionName = data.keepMeLoggedIn === true ? 'process_login_UL_RM' : 'process_login_UL';
	                            var ULState = rememberMe === true ? 'LOGIN_UL_RM' : 'LOGIN_UL';
	                            result = { fptiState: ULState, fptiTransition: fptiTransitionName };
	                        }
	
	                        return result;
	                    }
	
	                    var cancelLocaleChange;
	
	                    function loginComplete(data) {
	                        var jwtBasedAssertion = data.event === 'tokenExchanged' && data.authorizationToken === 'jwt_token';
	                        var rtExchanged = data.event === 'tokenExchanged' && data.authorizationToken !== 'jwt_token';
	
	                        $promise.run(function () {
	                            // eslint-disable-line
	
	                            $scope.auth.stepupAuthRequired = false;
	
	                            stopTimer('loginComplete');
	
	                            if (cancelLocaleChange) {
	                                cancelLocaleChange();
	                            }
	
	                            $scope.auth.isKmliSet = data.keepMeLoggedIn || rtExchanged;
	                            $scope.auth.rtExchanged = rtExchanged;
	
	                            var fptiData = getPostLoginFpti(data);
	
	                            $logger.info('checkout_fpti', {
	                                'from': fptiData.fptiState,
	                                'to': fptiData.fptiTransition
	                            });
	
	                            if (window.xprops && window.xprops.onAuth && data && data.accessToken) {
	                                return window.xprops.onAuth({
	                                    accessToken: data.accessToken
	                                });
	                            }
	                        }).then(function () {
	
	                            var upsellEligibilityData = {
	                                ulData: data
	                            };
	
	                            // Doesn't exist in risky login case
	                            if ($scope.preAuth) {
	
	                                // Fires off eligibility + econsent + xosession in batch mode
	                                $scope.preAuth();
	                            }
	
	                            if (data.event === 'tokenExchanged') {
	                                if ($feature('rmSpinnerText') && !jwtBasedAssertion) {
	                                    $rootScope.$emit('loadingMessage', {
	                                        heading: $locale.content.get('base.planning'),
	                                        subHeading: $locale.content.get('login.rmSubHeading')
	                                    });
	                                } else {
	                                    $rootScope.$emit('loadingMessage', $locale.content.get('base.planning'));
	                                }
	                            }
	
	                            return $scope.auth.reload({
	                                resultModel: $scope.auth,
	                                headers: {
	                                    'x-paypal-internal-euat': data.accessToken
	                                },
	                                batch: {
	                                    name: 'setbuyer',
	                                    id: 'securityCtx',
	                                    dependencies: []
	                                },
	
	                                success: function success() {
	                                    $scope.auth.is_auth_api_call = data.event === 'tokenExchanged';
	
	                                    angular.extend(upsellEligibilityData, {
	                                        buyerCountry: $scope.auth.country,
	                                        jwtBasedAssertion: jwtBasedAssertion,
	                                        showReactivationInterstitial: $scope.showReactivationInterstitial
	                                    });
	
	                                    $KmliUpsell.init(upsellEligibilityData);
	
	                                    $scope.postAuth($scope.auth);
	                                },
	                                contingencies: {
	                                    DEFAULT: function handleContingency(name, contingency) {
	                                        $scope.auth.password = '';
	                                        $scope.errorFn(name, contingency);
	                                    }
	                                }
	                            });
	                        });
	                    }
	
	                    var ulEventHandlers = {
	                        'loginRendered': function loginRendered(data) {
	                            var loadingCompletedTime = Date.now();
	                            $logger.debug('ULLOGIN_FRAME_LOADED_SUCCESSFULLY', {
	                                page_load_time: loadingCompletedTime - enteringTime
	                            });
	
	                            // Check if this is triggered by JWT assertion failure.
	                            // If so, do FPTI instrumentation.
	                            if (data.authorizationType === 'token' && data.authorizationToken === 'jwt_token') {
	                                $logger.info('checkout_fpti', {
	                                    'from': 'LOGIN_UL_JWT',
	                                    'to': 'process_UL_JWT',
	                                    'int_error_code': 'unknown',
	                                    'int_error_description': 'JWT assertion failed',
	                                    'error_source': 'unifiedloginnodeweb',
	                                    'error_type': 'soft_decline'
	                                });
	                            }
	                        },
	                        'loginFullyLoaded': function loginFullyLoaded(data) {
	                            stopTimer(data.event);
	
	                            if ($scope.notYou) {
	                                $rootScope.$emit('loaded');
	                                delete $scope.notYou;
	                                $logger.info('checkout_fpti', {
	                                    'from': 'LOGIN_UL_RM',
	                                    'to': 'prepare_login_ul'
	                                });
	                                $fn.sendTypingSpeedPayload('HermesUL');
	                                return $scope.logoutCallback();
	                            }
	
	                            if (!$state.current.trackingData) {
	                                $state.current.trackingData = { fptiState: 'ulLoginDefault' };
	                            }
	                            $state.current.trackingData.pageQualifier = 'ulLogin';
	                            var loadingCompletedTime = Date.now();
	                            var timeTaken = loadingCompletedTime - enteringTime;
	                            $logger.debug('ULLOGIN_LOADED_SUCCESSFULLY', {
	                                page_load_time: timeTaken
	                            });
	
	                            if ($scope.preLoadedSource) {
	                                $logger.debug('ULSS_CLIENT_LOADED_SUCCESSFULLY', {
	                                    page_load_time: timeTaken
	                                });
	                            }
	
	                            var ULState = rememberMe === true && !$scope.logoutCallback ? 'LOGIN_UL_RM' : 'LOGIN_UL';
	
	                            $logger.info('checkout_fpti', {
	                                'from': ULState,
	                                'to': 'prepare_iframe',
	                                'page_load_time': timeTaken
	                            });
	
	                            var payload = {
	                                'from': ULState,
	                                'to': 'prepare_login_ul',
	                                'app_int_type': app_int_type
	                            };
	
	                            if ($stateParams.targetPage) {
	                                angular.extend(payload, { 'int_error_code': $stateParams.targetPage });
	                            }
	
	                            $logger.info('checkout_fpti', payload);
	
	                            $fn.sendTypingSpeedPayload('HermesUL');
	
	                            $logger.flush();
	                        },
	                        'loginEmailPasswordAttempted': function loginEmailPasswordAttempted() {
	                            loginAttemptedMethod = 'email';
	                        },
	                        'loginPhonePinAttempted': function loginPhonePinAttempted() {
	                            loginAttemptedMethod = 'phone';
	                        },
	                        'loginAttempted': function loginAttempted(data) {
	                            setLoading(data.event);
	                            $rootScope.$emit('loadingMessage', $locale.content.get('base.loggingIn'));
	                            if (rememberMe === true) {
	                                var kmliStatus = data.keepMeLoggedIn === true ? 'KMLI_CHECKED' : 'KMLI_UNCHECKED';
	                                $logger.debug(kmliStatus);
	                            }
	                            startTimer(data.event);
	                        },
	                        'loginSuccess': loginComplete,
	                        'tokenExchanged': function tokenExchanged(data) {
	                            $logger.info('TOKEN_EXCHANGED', {
	                                authorizationType: data.authorizationType,
	                                authorizationToken: data.authorizationToken || ''
	                            });
	                            loginComplete(data);
	                        },
	                        'notYouLinkClicked': function notYouLinkClicked(data) {
	                            $rootScope.$emit('loading');
	                            $scope.notYou = true;
	                            $logger.info('checkout_fpti', {
	                                from: 'LOGIN_UL',
	                                to: 'login_with_diff_user'
	                            });
	                            startTimer(data.event);
	                        },
	                        '2fa': function fa(data) {
	                            stopTimer(data.event);
	                            var fptidata = getPostLoginFpti(data);
	                            logFptiData(fptidata, data.event);
	                            if (data.contingencyUrl) {
	                                $logger.debug('ULLOGIN_TWO_FA_AUTH_REDIRECT');
	                                var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);
	                                $util.redirect(authChallengeRedirectUrl);
	                            } else {
	                                $logger.debug('ULLOGIN_TWO_FA_GENERIC_ERROR');
	                                $state.go('checkout.genericError', { code: 'DEFAULT' });
	                            }
	                        },
	                        'safeRequired': function safeRequired(data) {
	                            stopTimer(data.event);
	                            var fptidata = getPostLoginFpti(data);
	                            logFptiData(fptidata, data.event);
	                            if ($scope.safeEligibility && data.contingencyUrl) {
	                                if (data.authorizationType && data.authorizationType === 'token') {
	                                    // for remembered user redirect to login instead of SAFE APP
	                                    $logger.debug('LOGIN_REDIRECTION_SAFE_RM_USER');
	                                    $state.go('checkout.login', { targetPage: 'LOGIN_CONTINGENCY' });
	                                }
	                                $logger.debug('ULSAFE_REDIRECTION');
	                                var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);
	                                $util.redirect(authChallengeRedirectUrl);
	                            } else {
	                                $logger.debug('ULSAFE_GENERIC_ERROR');
	                                $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
	                            }
	                        },
	                        'serverError': function serverError(data) {
	                            stopTimer(data.event);
	                            var error_code = 'INVALID_USER';
	                            var error = {
	                                type: 'pageError',
	                                code: 500
	                            };
	                            // internalServerError, code: 500, take user to hermes login, no need for error message
	                            switch (data.reason) {
	                                case 'serverValidationError':
	                                    if (data.authorizationType === 'token') {
	                                        error_code = 'ONETOUCH_GENERIC_ERROR';
	                                        error.msg = $locale.content.get('login.reactivateOneTouch');
	                                    } else if (loginAttemptedMethod === 'phone') {
	                                        error_code = 'INVALID_PHONE_PIN';
	                                        error.msg = $locale.content.get('login.invalidPin');
	                                    } else {
	                                        error.msg = $locale.content.get('login.invalidEmailPasswordPageError');
	                                    }
	                                    break;
	                                case 'invalidUser':
	                                    if (data.authorizationType === 'token') {
	                                        error_code = 'ONETOUCH_GENERIC_ERROR';
	                                        error.msg = $locale.content.get('login.reactivateOneTouch');
	                                    }
	                                    break;
	                                case 'internalServerError':
	                                    if (data.authorizationType === 'token') {
	                                        error_code = 'ONETOUCH_GENERIC_ERROR';
	                                        error.msg = $locale.content.get('login.reactivateOneTouch');
	                                    } else {
	                                        error.msg = $locale.content.get('login.invalidEmailPasswordPageError');
	                                    }
	                                    $fpti.setupDataString($state.current, error);
	                                    return appLoginHandler(failureReasons.error);
	                                case 'accountTemporaryLocked':
	                                case 'accountPermanentlyLocked':
	                                    error.code = data.code;
	                                    error.msg = $locale.content.get('login.accountLockedPageError');
	                                    error_code = 'ACCOUNT_LOCKED';
	                                    break;
	                                case 'riskDecline':
	                                    error.code = data.code;
	                                    if (data.authorizationType === 'token') {
	                                        error_code = 'ONETOUCH_GENERIC_ERROR';
	                                        error.msg = $locale.content.get('login.reactivateOneTouch');
	                                    } else {
	                                        error.msg = $locale.content.get('login.riskDeclinePageError');
	                                        error_code = 'RISK_DECLINE';
	                                    }
	                                    break;
	                                default:
	                                // Do nothing
	                            }
	                            var fptidata = getPostLoginFpti(data);
	                            $logger.info('checkout_fpti', {
	                                'from': fptidata.fptiState,
	                                'to': fptidata.fptiTransition,
	                                'int_error_code': data.code,
	                                'int_error_description': data.reason,
	                                'error_type': 'soft_decline',
	                                'error_source': 'unifiedloginnodeweb'
	                            });
	                            $fpti.setupDataString($state.current, error);
	                            $scope.parentCallback('showErrorMessages', error_code);
	                        },
	                        'client_validation_error': function client_validation_error(data) {
	                            var error = {
	                                type: 'pageError',
	                                msg: $locale.content.get('login.invalidEmailPasswordPageError')
	                            };
	                            var fptidata = getPostLoginFpti(data);
	                            $logger.info('checkout_fpti', {
	                                'from': fptidata.fptiState,
	                                'to': fptidata.fptiTransition,
	                                'int_error_code': data.event,
	                                'int_error_description': 'invalid_credentials',
	                                'error_type': 'soft_decline',
	                                'error_source': 'unifiedloginnodeweb'
	                            });
	                            $fpti.setupDataString($state.current, error);
	                        },
	                        'stepupRequired': function stepupRequired(data) {
	                            stopTimer(data.event);
	                            var fptidata = getPostLoginFpti(data);
	                            logFptiData(fptidata, data.event);
	
	                            if (data.authorizationType && data.authorizationType === 'token') {
	                                // for remembered user redirect to login instead of AuthChallenge APP
	                                $logger.debug('LOGIN_ATO_RM_USER');
	
	                                // doing nothing, ul will render the login page, we need to show warning on top though
	                                var error_code = 'ONETOUCH_GENERIC_ERROR';
	                                var error = { // eslint-disable-line no-unused-vars
	                                    type: 'pageError',
	                                    msg: $locale.content.get('login.reactivateOneTouch')
	                                };
	                            } else if (data.contingencyUrl) {
	                                $logger.debug('LOGIN_ATO_USER');
	                                var authChallengeRedirectUrl = buildRedirectURL(data.contingencyUrl, data.event);
	                                $util.redirect(authChallengeRedirectUrl);
	                            } else {
	                                $logger.debug('LOGIN_ATO_GENERIC_ERROR');
	                                $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
	                            }
	                            // to show error message on login page
	                            $scope.parentCallback('showErrorMessages', error_code); // eslint-disable-line block-scoped-var
	                        },
	
	                        'captcha': function captcha(data) {
	                            var fptiData = getPostLoginFpti(data);
	                            $logger.info('checkout_fpti', {
	                                'from': fptiData.fptiState,
	                                'to': 'prepare_captcha'
	                            });
	                        },
	                        'bodyClick': function bodyClick() {
	                            $rootScope.$broadcast('clickBody');
	                        },
	                        'expiredRefreshToken': function expiredRefreshToken(data) {
	
	                            var treatment = data.treatment;
	
	                            $logger.info('EXPIRED_RT_' + treatment);
	
	                            $logger.info('checkout_fpti', {
	                                'from': 'LOGIN_UL_RM',
	                                'to': 'process_RT_AT_exch',
	                                'int_error_code': 'expired_RT_Token',
	                                'int_error_desc': treatment,
	                                'error_source': 'unifiedloginnodeweb',
	                                'error_type': 'soft_decline'
	                            });
	
	                            switch (treatment) {
	
	                                case 'showInterstitial':
	                                    $scope.showReactivationInterstitial = true;
	                                    break;
	
	                                case 'checkboxPreselectedWithNotification':
	                                    $scope.errorFn('ONETOUCH_LEAVECHECKED', {}, 'warning');
	                                    break;
	
	                                case 'checkboxNotPreselectedWithNotification':
	                                    $scope.errorFn('ONETOUCH_REACTIVATE', {}, 'warning');
	                                    break;
	
	                                case 'expiredRefreshTokenControl':
	                                    break;
	
	                                default:
	                                    break;
	
	                            }
	                        }
	                    };
	
	                    function postMessageHandler(response) {
	                        $timeout(function () {
	                            $logger.info('ul_postmessaged_received', response);
	                            var data = response.data || response.error;
	                            var eventId = data && data.event;
	                            if (eventId) {
	                                $logger.debug('ULLOGIN_' + eventId, response);
	                                var handler = ulEventHandlers[eventId];
	                                if (handler) {
	                                    handler(data);
	                                }
	                            }
	                        });
	                    }
	
	                    function loadUnifiedLogin(iframeCopy) {
	                        var queryString = $util.queryStringSplice($util.queryString(), {
	                            'flow': '1-P',
	                            'token': $scope.token
	                        }, ['cmd']);
	                        var isHermesInsideIframe = $util.isIFrame();
	                        if (isHermesInsideIframe) {
	                            $logger.info('MERCHANT_IFRAME_INTEGRATION');
	                        }
	                        var options = {
	                            targetElement: document.getElementById('injectedUnifiedLogin'),
	                            xhrRequest: isHermesInsideIframe,
	                            queryParams: {
	                                'stsRedirectUri': ulMeta.stsReturnUrl,
	                                'country.x': $scope.locale.country,
	                                'locale.x': $scope.locale.getLocaleCode(),
	                                'returnUri': ulMeta.ulReturnUri,
	                                'state': queryString,
	                                'flowId': $scope.token,
	                                'correlationId': $CalDataModel.getCalCorrId()
	                            },
	                            config: {
	                                title: 'PayPal - ' + $locale.content.get('common.login')
	                            },
	                            onPostMessage: postMessageHandler
	                        };
	
	                        if ($meta.baToken) {
	                            angular.extend(options.queryParams, { 'fn_dt': $meta.baToken });
	                        }
	
	                        if ($scope.forcedLogin) {
	                            angular.extend(options.queryParams, { 'prompt': 'login' });
	                        }
	
	                        if ($scope.logoutCallback) {
	                            angular.extend(options.queryParams, { 'showNotYou': true });
	                        }
	
	                        if ($stateParams.source !== 'NOT_YOU') {
	                            $scope.flowcontext = $scope.checkoutCart.flow_context;
	                        } else {
	                            $scope.flowcontext = $scope.checkoutCart.flow_context_without_email;
	                        }
	
	                        if ($scope.flowcontext) {
	                            angular.extend(options.queryParams, { 'flowContextData': $scope.flowcontext });
	                        }
	
	                        if ($config.deploy.isLocal()) {
	                            options.origin = 'https://' + $meta.stage;
	                            if (!$meta.stage) {
	                                // if no stage url shows up then use any backup url for origin
	                                var backupURL = $config.onboarding.url.split('/webapps/')[0];
	                                options.origin = backupURL;
	                            }
	                        }
	
	                        // preload only for first time login attempts
	                        if ($scope.preloadUL && $scope.ulSource && $scope.ulSource.src && !$scope.forcedLogin && $stateParams.source !== 'NOT_YOU' && !userSelectedLanguage && rememberMe) {
	                            $logger.debug('ULSS_CLIENT_PRELOAD_INJECT');
	                            $scope.preLoadedSource = true;
	                            options.preLoadedSource = decodeURI($scope.ulSource.src);
	                        }
	
	                        function ulInvoke() {
	                            if (PAYPAL && PAYPAL.unifiedLogin) {
	                                startTimer('ulInvoke');
	                                if (!iframeCopy) {
	                                    PAYPAL.unifiedLogin.inject(options);
	                                } else {
	                                    PAYPAL.unifiedLogin.copyPasteIframe({
	                                        targetElement: document.getElementById('injectedUnifiedLogin'),
	                                        onPostMessage: postMessageHandler
	                                    });
	                                }
	                            } else {
	                                return appLoginHandler(failureReasons.fallback);
	                            }
	                        }
	
	                        var kmliContentMapping = {
	                            xo_hermesnode_kmli_content_control: '0',
	                            xo_hermesnode_kmli_content_t1: '1',
	                            xo_hermesnode_kmli_content_t2: '2',
	                            xo_hermesnode_kmli_content_t3: '3'
	                        };
	
	                        var jwtToken = $xoAPayUtils.getAPayAuthToken();
	                        if (jwtToken) {
	                            options.queryParams.jwtToken = jwtToken;
	                        }
	
	                        if (rememberMe === true) {
	                            options.queryParams.rememberMe = true;
	                            var country = $scope.checkoutAppData.merchant.merchant_country;
	                            return $pxp(ulMeta.kmliContentExpId, { 'ctx.COUNTRY': country }, 'xo_hermesnode_kmli_content_.*').then(function (result) {
	                                var contentKey = result && result.treatment_name;
	
	                                if (contentKey && kmliContentMapping[contentKey]) {
	                                    options.queryParams.rememberMeContent = kmliContentMapping[contentKey];
	                                }
	
	                                ulInvoke();
	                            });
	                        }
	
	                        return ulInvoke();
	                    }
	
	                    var cancelAllLoaded = $rootScope.$on('allLoaded', function () {
	                        cancelLocaleChange = $scope.$on('localeChange', function () {
	                            userSelectedLanguage = $locale.lang;
	                            setLoading('localeChange');
	                            loadUnifiedLogin();
	                        });
	                        cancelAllLoaded();
	                    });
	
	                    $scope.$on('$destroy', cancelAllLoaded);
	
	                    loadUnifiedLogin(ulMeta.iframeCopy);
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/unified-login/template.html":
/***/ function(module, exports) {

	module.exports = "<div>\n    <input id=\"email\" name=\"login_email\" type=\"email\" value=\"\" autocomplete=\"off\" placeholder=\"Email\" style=\"display:none\">\n    <input id=\"password\" name=\"login_password\" type=\"password\" value=\"\" placeholder=\"Password\" style=\"display:none\">\n    <div id=\"injectedUnifiedLogin\">\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-login-components/src/login/kmliEligibility.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-login.directive.kmliEligibility', ['squid', 'xo-device-info', 'beaver']).factory('$KmliEligibility', function ($DeviceInfo, $window, $meta, $config, $pxp, $pxpMatch, $populate, $logger, $rootScope, $feature, $util, $q, $CheckoutAppDataModel, $CheckoutCartModel, $AuthModel) {
	        var scope = {};
	        scope.token = $rootScope.token;
	        scope.eligibility = {};
	        var ulMeta = $config.ulMeta || {};
	
	        function getPXPList(country) {
	            // returns a list of Pxp's that needs to be executed
	            var countryCTX = { 'ctx.COUNTRY': country };
	            var pxpExpId = ulMeta.pxpExpId;
	            var pxpList = [$pxp(pxpExpId, countryCTX, 'xo_hermesnode_kmli_(web|mobile)_treatment'), $pxp(pxpExpId, countryCTX, 'xo_hermes_ul_timeout_treatment.*'), $pxp(pxpExpId, countryCTX, 'xo_hermes_ul_preload_treatment'), $pxpMatch(ulMeta.hermesnodePxpConfig, countryCTX, { pxpSAFE: 'xo_hermesnode_ul_safe_treatment' })];
	            return pxpList;
	        }
	
	        function routingReason() {
	            // Check for conditions that deviates from the PXP eligibility
	            // Reasons that deviates from control to treatment
	            var isRememberedUser = scope.auth.refreshToken();
	            if (scope.kmli === true) {
	                return 'kmliMandated';
	            } else if (isRememberedUser) {
	                return 'rememberedUser';
	            } else if ($util.param('ul') === '2') {
	                return 'ulParam';
	            } else if ($meta.corp && ulMeta.allowKMLIForInternalIP) {
	                var merchantCountry = scope.checkoutAppData.merchant.merchant_country;
	                if ($feature('enableOneTouchInternalIP', false, merchantCountry)) {
	                    return 'internalIP';
	                }
	            } else if (ulMeta.enableOneTouchByDefault) {
	                return 'oneTouchByDefault';
	            }
	        }
	
	        function compatibility(reasons) {
	            // Check for compatibility/environment issues which impacts UL/KMLI overall
	            // This should override previous decisions
	            if ($DeviceInfo.isApp()) {
	                scope.kmliEligibility = false;
	                reasons.push('Webview');
	            } else if (!$util.cookiesEnabled()) {
	                scope.kmliEligibility = false;
	                reasons.push('cookiesDisabled');
	            } else if (scope.auth.ota) {
	                scope.kmliEligibility = false;
	                reasons.push('otaDevice');
	            }
	
	            if (scope.forcedLogin === true) {
	                scope.kmliEligibility = false;
	                reasons.push('forcedLogin');
	            }
	            if (scope.logoutCallback) {
	                scope.kmliEligibility = true;
	                reasons.push('riskyLoginContingency');
	            }
	        }
	
	        function isULpreload(preloadULTreatments) {
	            // Allow all IE traffic irrespective of PXP
	            var userAgent = $window.navigator.userAgent;
	            var isIE = !!userAgent.match(/MSIE|trident|edge/i);
	            // Check force param
	            var forceUlss = $util.param('_ulss') === 'true';
	            var preloadUL = Boolean(preloadULTreatments && preloadULTreatments.treatment_name) || isIE || forceUlss;
	
	            return preloadUL;
	        }
	
	        function isUlAsLanding() {
	            // markes
	            var forceUlAsLanding = $util.param('ul') === 'landing';
	            var ulAsLandingParam = $util.param('ulReturn') === 'true';
	            var failedAttempt = $util.param('lndgFailedBecause'); // tried Ul as landing -> failed -> used iframe
	
	            return forceUlAsLanding || ulAsLandingParam;
	        }
	
	        function isSafeEligible(treatment) {
	            var safeEligibility;
	            var config_pxp_treatments = treatment;
	            if (config_pxp_treatments) {
	                safeEligibility = treatment['pxpSAFE'];
	            }
	            return safeEligibility;
	        }
	
	        function getTimeoutLimit(pxpTimeoutTrt) {
	            var ulTimeoutLimit;
	            var timeoutTrtFact = pxpTimeoutTrt && angular.isArray(pxpTimeoutTrt.factors);
	            var pxpTimeoutVal = timeoutTrtFact && pxpTimeoutTrt.factors[0] && pxpTimeoutTrt.factors[0].value;
	            if (pxpTimeoutVal) {
	                ulTimeoutLimit = pxpTimeoutVal;
	                $logger.info('pxp_timeout_treatment', {
	                    'ulTimeoutLimit': ulTimeoutLimit
	                });
	            }
	            return ulTimeoutLimit;
	        }
	
	        return {
	            init: function init(params) {
	                if (Boolean(scope.eligibility.treatment)) {
	                    // do not init twice
	                    return $q.resolve(scope.eligibility);
	                }
	                $logger.debug('kmliEligibility_init');
	                scope.forcedLogin = params && params.forcedLogin;
	                scope.logoutCallback = params && params.logoutCallback;
	                return $populate(scope, {
	                    auth: $AuthModel.instance(),
	                    checkoutAppData: $CheckoutAppDataModel.instance(scope.token),
	                    checkoutCart: $CheckoutCartModel.instance(scope.token)
	                }).then(function () {
	                    var country = scope.checkoutAppData.merchant.merchant_country;
	                    return $q.all(getPXPList(country)).then(function (result) {
	                        scope.kmliEligibility = Boolean(result[0] && result[0].treatment_name);
	                        scope.eligibility.ulTimeoutLimit = getTimeoutLimit(result[1]);
	                        scope.eligibility.preloadUL = isULpreload(result[2]);
	                        scope.eligibility.safeEligibility = isSafeEligible(result[3]);
	                        scope.eligibility.ulAsLanding = isUlAsLanding();
	                    });
	                }).then(function () {
	                    // STEP1: Check PXP response
	                    var pxpGroup = scope.kmliEligibility ? 'pxpTreatment' : 'pxpControl';
	
	                    // STEP2: Check for conditions that deviates from the PXP eligibility
	                    var reasons = []; // Reasons that deviates from control to treatment
	                    reasons.push(pxpGroup);
	
	                    var reason = pxpGroup === 'pxpControl' && routingReason();
	                    if (reason) {
	                        scope.kmliEligibility = true;
	                        reasons.push(reason);
	                    }
	
	                    // STEP3: Check for compatibility/environment issues which impacts UL/KMLI overall
	                    compatibility(reasons);
	
	                    var routing_reason = reasons[reasons.length - 1];
	
	                    scope.eligibility.treatment = pxpGroup;
	                    scope.eligibility.routingReason = routing_reason;
	                    scope.eligibility.deviatingReasons = reasons;
	                    scope.eligibility.kmliEligibility = scope.kmliEligibility;
	
	                    // STEP4: Instrument deterministically whether KMLI is shown to the user or not
	                    $logger.debug(scope.kmliEligibility ? 'KMLI_ELIGIBLE_USER' : 'KMLI_INELIGIBLE_USER', { userGroup: reasons, routing_reason: routing_reason });
	                    $logger.info('checkout_fpti', {
	                        'from': 'KMLI_ELG_CHK',
	                        'to': 'process_kmli_elg_chk',
	                        'routing_reason': routing_reason
	                    });
	                    return scope.eligibility;
	                });
	            },
	
	            eligible: function eligible() {
	                return scope.eligibility;
	            }
	
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/login", "components/xo-login-components/src/login/kmliEligibility.js"))

/***/ },

/***/ "./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-login-components/src/login/kmliEligibility.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-unified-login.kmliUpsell', ['squid']).factory('$KmliUpsell', function ($pxp, $populate, $rootScope, $CheckoutAppDataModel, $CheckoutCartModel, $AuthModel, $DeviceInfo, $KmliEligibility, $config, $logger, $q) {
	
	        var idToken, successfulLogin, isOneTouched, upsellOptInDisplayed, kmliEligible, ulAsLanding, walletTokenization, preloadUL, lastUpsellVersion; // Model Retrived
	        var showReactivationInterstitial, kmliChecked; // Passed in init
	        var expPromise; // Promisified experience data
	        var scope = {};
	        scope.token = $rootScope.token;
	
	        return {
	
	            init: function init(params) {
	
	                if (expPromise) {
	                    return; // do not init twice
	                }
	                $logger.debug('kmliUpsell_init', params);
	                expPromise = $KmliEligibility.init().then(function (KmliEligibility) {
	                    kmliEligible = Boolean(KmliEligibility.kmliEligibility) && !params.jwtBasedAssertion;
	                    ulAsLanding = Boolean(KmliEligibility.ulAsLanding);
	                    preloadUL = Boolean(KmliEligibility.preloadUL);
	                    return $populate(scope, {
	                        auth: $AuthModel.instance(),
	                        checkoutCart: $CheckoutCartModel.instance(scope.token),
	                        checkoutAppData: $CheckoutAppDataModel.instance(scope.token)
	                    });
	                }).then(function () {
	                    idToken = Boolean(scope.auth.idTokenPresent);
	                    successfulLogin = scope.auth.loggedIn();
	                    isOneTouched = scope.auth.loggedIn() && scope.auth.refreshToken();
	                    walletTokenization = scope.checkoutCart.isWalletTokenization(); // android pay, apple pay, etc
	                    kmliChecked = Boolean(params.isKmliSet); // may not be OT but user has already opted in
	                    upsellOptInDisplayed = Boolean(scope.auth.upsellOptInDisplayed);
	                    lastUpsellVersion = scope.auth.ryiOptIn && scope.auth.ryiOptIn.interstitialDisplayed;
	                    showReactivationInterstitial = Boolean(params.showReactivationInterstitial);
	                    if (walletTokenization || preloadUL) {
	                        // do not trigger pxp for walletTokenization, ulpreload
	                        $logger.debug('kmliUpsell_init_ineligible');
	                        return $q.resolve();
	                    }
	
	                    return $pxp($config.ulMeta.pxpExpId, {
	                        'ctx.COUNTRY': scope.checkoutAppData.merchant.merchant_country,
	                        'ctx.CHANNEL': $DeviceInfo.isMobile() || $DeviceInfo.isTablet() ? 'MOBILE' : 'WEB'
	                    }, 'xo_hermes_kmli_upsell_(web|mobile)_treatment.*');
	                }).then(function (pxpRes) {
	                    var experience = pxpRes ? { name: pxpRes.treatment_name } : '';
	                    lastUpsellVersion = lastUpsellVersion ? lastUpsellVersion : upsellOptInDisplayed ? 0.1 : 0.0;
	                    // for lastUpsellVersion use 0.1 when poma and not ryi case else use 0
	                    if (pxpRes && pxpRes.factors) {
	                        var factors = pxpRes.factors.reduce(function (out, factor) {
	                            out[factor.name] = factor.value;
	                            return out;
	                        }, {});
	                        experience.version = +factors.version > +lastUpsellVersion;
	                        experience.color = factors.color;
	                        experience.pxpVersion = factors.version;
	                    }
	                    return experience;
	                });
	            },
	
	            eligible: function eligible() {
	                var eligibility = {};
	                if (!expPromise) {
	                    $logger.debug('kmliUpsell_init_not_executed');
	                    return $q.resolve(eligibility);
	                }
	                return expPromise.then(function (experience) {
	                    var activeOT = experience && isOneTouched;
	                    var regularLogin = experience && kmliEligible && idToken;
	                    eligibility.banner = activeOT || regularLogin;
	                    eligibility.interstitial = {
	                        eligible: eligibility.banner && !isOneTouched // dont show interstitial for OT
	                        && !kmliChecked // to handle cases where not OT but already optedin
	                        && (experience.name.slice(-1) == '1' || experience.name.slice(-1) == '3') // use only treatment 1,3 for interstitial
	                        && experience.version,
	                        type: showReactivationInterstitial ? 'reactivation' : successfulLogin ? 'member' : '',
	                        color: experience && experience.color,
	                        pxpVersion: experience && experience.pxpVersion
	                    };
	                    $logger.debug('kmliUpsell_eligibility', {
	                        eligibility: eligibility,
	                        experience: experience,
	                        cases: {
	                            activeOT: activeOT,
	                            regularLogin: regularLogin
	                        }
	                    });
	                    return eligibility;
	                });
	            },
	
	            getOptions: function getOptions() {
	
	                if (showReactivationInterstitial) {
	                    return {
	                        flowName: 'expiredUpsell'
	                    };
	                }
	            },
	
	            getFPTIAttributes: function getFPTIAttributes() {
	
	                if (showReactivationInterstitial) {
	                    return {
	                        stateName: 'KMLI_reactivation',
	                        transInfix: '_kmli_reactivation_'
	                    };
	                } else {
	                    return {
	                        stateName: 'KMLI_UPSELL',
	                        transInfix: '_kmli_upsell_'
	                    };
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/onetouch-interstitial", "components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js"))

/***/ },

/***/ "./components/ul-inline/dist/inject.js":
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	!function(a,b){a.PAYPAL=a.PAYPAL||{},a.PAYPAL.unifiedLogin=b()}(this,function(){function a(a,b){var c,d={src:a,height:b.height||239,style:"width: 100%;",name:b.name||"injectedUl",frameborder:0,scrolling:b.scrolling||"no",title:b.title||"PayPal",sandbox:"allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"},e=document.createElement("iframe");b.hide&&(d.style=d.style+"display: none;");for(c in d)e.setAttribute(c,d[c]);return e}function b(a,b,c){var d,e=a||window.location.origin||window.location.protocol+"//"+window.location.host,f=e+(c||"/signin/inject/"),g=b?"?":"",h=0;if(!b)return f;for(d in b)h>0&&(g+="&"),g=g+d+"="+encodeURIComponent(b[d]),h+=1;return f+g}function c(a){var b,c="";try{if(a.source.name!==q.name)return}catch(d){return}if(b=g(a.origin),!f(b))throw new Error("PostMessage iframe domain ("+b+"), must be a *.paypal.com domain");if(c=a&&a.data,"string"==typeof c)try{c=JSON.parse(c)}catch(h){throw new Error("Invalid JSON string sent to onPostMessage handler: "+c)}c.data&&"resize"===c.data.event?e(q,c.data.heightInPx):c.data&&"htmlRendered"===c.data.event?x=!0:!w&&p?p(c):w&&v.push(c)}function d(a){a&&"resize"===a.event?e(s,a.heightInPx):r(a)}function e(a,b){a.setAttribute("height",b)}function f(a){var b=/\.paypal\.com$/gi;return b.test(a)}function g(a){if(a){var b=/^https?:\/\/(.*\.paypal\.com)(:[0-9]+)?$/gi,c=b.exec(a);return c&&c[1]}}function h(){var a;if(p){for(a=0;a<v.length;a++)p(v[a]);v=[],w=!1}}function i(c){var d,e,h,i,k;if(!c||!c.targetElement)throw h="targetElement",new Error("The "+h+" option is required");if(c.origin&&(i=g(c.origin),!f(i)))throw new Error('All values for the "origin" setting must match *.paypal.com');for(u=c.config||{},e=b(c.origin,c.queryParams,c.iframePathname),k=c.xhrRequest&&c.xhrRequest===!0,d=k||c.preLoadedSource?a("about:blank",u):a(e,u),t=c.targetElement;c.targetElement.hasChildNodes();)c.targetElement.removeChild(c.targetElement.lastChild);return c.targetElement.appendChild(d),"directMessageIframe"===c.iframeType?(s=d,r=c.onPostMessage):(q=d,p=c.onPostMessage,j()),k?n(e,function(a){a&&o(d,a)}):c.preLoadedSource&&o(d,c.preLoadedSource),w=p?!1:!0,{iframe:d,onPostMessageCallback:p}}function j(){window.addEventListener?window.addEventListener("message",c,!1):window.attachEvent("onmessage",c)}function k(a){p=a,h()}function l(){t.parentNode&&t.parentNode.removeChild(t)}function m(b){var c,d,e,f,g="about:blank";if(!x)return void setTimeout(function(){m(b)},50);for(b.onPostMessage&&k(b.onPostMessage),u.hide=!1,c=a(g,u);b.targetElement.hasChildNodes();)b.targetElement.removeChild(b.targetElement.lastChild);b.targetElement.appendChild(c),d=q.contentWindow.document,e=d.documentElement.outerHTML,f=c.contentWindow.document,f.open(),f.write(e),f.close(),l(),q=c,t=b.targetElement}function n(a,b){var c;window.XMLHttpRequest?c=new XMLHttpRequest:window.ActiveXObject&&(c=new ActiveXObject("Microsoft.XMLHTTP")),c&&(c.onreadystatechange=function(){4==c.readyState&&200==c.status&&b(c.responseText)},c.open("GET",a,!0),c.send())}function o(a,b){a.contentWindow.inlineUlContents=b,a.src='javascript:window["inlineUlContents"]'}var p,q,r,s,t,u,v=[],w=!1,x=!1;return{inject:i,copyPasteIframe:m,removeTargetElement:l,messageDispatcher:c,nonPostMessageDispatcher:d}});
	
	}.call(window));

/***/ },

/***/ "./components/xo-page-components/src/value-props/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/value-props/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-value-props.directive', ['squid']).directive('xoValueProps', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                type: '@',
	                title: '@',
	                text: '@',
	                textContent: '@',
	                imageUrl: '@'
	            },
	            link: function link(scope, element, attrs) {
	                if (angular.isString(attrs.imageUrl)) {
	                    // Only do this when image-url is defined so that we do not affect default behavior. These image-url
	                    // are configured through pxp tool for factor based experiments, hence they should all should adhere
	                    // to standard size i.e. 150X150 pixels.
	                    attrs.$observe('imageUrl', function (imageUrl) {
	                        var url = imageUrl;
	                        var propImg = angular.element(element[0].querySelector('div.prop-img'));
	                        var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;
	
	                        if (isRetina) {
	                            var index = url.lastIndexOf('.'); // index at which file extension start
	                            url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
	                            propImg.css({
	                                'background-image': 'url(' + url + ')',
	                                'height': '150px',
	                                'background-size': '150px 150px',
	                                'margin-top': '0px'
	                            });
	                        } else {
	                            propImg.css({
	                                'background-image': 'url(' + url + ')',
	                                'height': '150px',
	                                'margin-top': '0px'
	                            });
	                        }
	                    });
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/value-props/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"props {{type}}\" content>\n    <div class=\"prop-img\"></div>\n    <h2 class=\"vprop-header\">{{ title }}</h2>\n    <p ng-if=\"textContent\" ng-bind-html=\"htmlContent(textContent)\"></p>\n    <p ng-if=\"!textContent\" ng-bind-html=\"text\"></p>\n</div>\n"

/***/ },

/***/ "./components/xo-ui-components/src/card-loader/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoCardLoader = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/card-loader/styles.less");
	
	var _template = __webpack_require__("./components/xo-ui-components/src/card-loader/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoCardLoader = exports.$xoCardLoader = _squid.$Component.extend('xoCardLoader', {
	    tag: 'xo-card-loader',
	    template: _template2['default'],
	    props: {
	        message: {
	            type: 'str'
	        },
	        state: {
	            type: 'var'
	        },
	        auth: {
	            type: 'var'
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            this.ellipsis = function () {
	                var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	                var MAX_EMAIL_LEN = 34;
	                var MAX_DOMAIN_LEN = 20;
	                var MAX_USERNAME_LEN = MAX_EMAIL_LEN - MAX_DOMAIN_LEN;
	
	                if (email.length <= MAX_EMAIL_LEN) {
	                    return email;
	                }
	
	                var userNameLength = email.indexOf('@');
	                var domainLength = email.length - userNameLength;
	                if (userNameLength > MAX_USERNAME_LEN && domainLength > MAX_DOMAIN_LEN) {
	                    return email.replace(new RegExp('(.{' + (MAX_USERNAME_LEN - 3) + '}).*(@.{' + (MAX_DOMAIN_LEN - 4) + '}).*'), '$1...$2...');
	                } else if (userNameLength > MAX_USERNAME_LEN) {
	                    return email.replace(new RegExp('(.{' + (MAX_EMAIL_LEN - domainLength - 3) + '}).*(@.*)'), '$1...$2');
	                } else {
	                    return email.replace(new RegExp('(.{' + (MAX_EMAIL_LEN - 3) + '}).*'), '$1...');
	                }
	            };
	        }
	    }
	});
	
	angular.value("$xoCardLoader", $xoCardLoader);
	_squid.$Component;

/***/ },

/***/ "./components/xo-ui-components/src/card-loader/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/card-loader/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/card-loader/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#virtual_card{position:absolute;z-index:1;width:240px;height:151px;border-radius:7.2px;background-image:linear-gradient(90deg,#009be1,#002c8a);margin-left:-120px;left:50%}#card_header{height:60px;width:100%}#card_logo{height:23px;width:96px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/simplified/pp_logo_h_white.png\");background-repeat:no-repeat;margin-top:10px;margin-left:10px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#card_logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/simplified/pp_h_white@2x.png\");background-size:96px 23px}}#card_footer{z-index:3;margin-top:50px}#card_user{font-size:.75em;color:#fff;padding:0 15px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#slider{z-index:2;width:inherit;border-top-left-radius:7.2px;border-top-right-radius:7.2px;background-color:hsla(0,0%,100%,.8);top:0;position:absolute}#slider.notStarted{animation:strech_state_off .1s ease-in-out;-moz-animation:strech_state_off .1s ease-in-out;-webkit-animation:strech_state_off .1s ease-in-out;-o-animation:strech_state_off .1s ease-in-out;-ms-animation:strech_state_off .1s ease-in-out;animation-fill-mode:forwards}#slider.pending{animation:strech_state_A 3s ease-in-out;-moz-animation:strech_state_A 3s ease-in-out;-webkit-animation:strech_state_A 3s ease-in-out;-o-animation:strech_state_A 3s ease-in-out;-ms-animation:strech_state_A 3s ease-in-out;animation-fill-mode:forwards}#slider.completed{animation:strech_state_B 1s ease-in-out;-moz-animation:strech_state_B 1s ease-in-out;-webkit-animation:strech_state_B 1s ease-in-out;-o-animation:strech_state_B 1s ease-in-out;-ms-animation:strech_state_B 1s ease-in-out;animation-fill-mode:forwards}#virtual_card_message_wrapper{width:100%}#virtual_card_message{padding-top:176px;width:100%;text-align:center;font-size:1.2em;line-height:1.35em}@keyframes strech_state_off{0%{height:100%}to{height:100%}}@keyframes strech_state_A{0%{height:100%}to{height:30%}}@keyframes strech_state_B{0%{height:20%}to{height:0}}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-ui-components/src/card-loader/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"virtual_card\">\n    <div id=\"card_header\">\n        <div id=\"card_logo\"></div>\n    </div>\n    <div id=\"card_footer\">\n        <div id=\"card_user\" ng-if=\"auth.loggedIn()\">{{ellipsis(auth.email)}}</div>\n    </div>\n    <div id=\"slider\" class=\"{{state}}\"></div>\n</div>\n<div id=\"virtual_card_message\">{{message}}</div>\n\n"

/***/ },

/***/ "./pages/xo-generic-error/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$GenericErrorRoute = undefined;
	
	__webpack_require__("./pages/xo-generic-error/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $GenericErrorRoute = exports.$GenericErrorRoute = _squid.$ComponentRoute.extend('$GenericErrorRoute', {
	
	    path: 'genericError',
	    directive: 'xo-generic-error-page',
	    titleContent: 'genericError.pleaseTryAgain',
	    query: ['code'],
	    // need to find these values
	    trackingData: {
	        fptiState: 'fatal_error',
	        templateName: 'genericError.dust',
	        pageGoal: 'Generic Error',
	        pageQualifier: 'blockNonDomesticShipping',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-generic-error',
	                'pagename2': '%::fullpage-generic-error:member:hermes:',
	                'version': 'member:%:'
	            }
	        }
	    },
	
	    auth: false,
	
	    children: []
	});
	
	angular.value("$GenericErrorRoute", $GenericErrorRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-generic-error/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoGenericErrorPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-generic-error/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/generic-error/directive.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoGenericErrorPageComponent = exports.$xoGenericErrorPageComponent = _squid.$Component.extend('$xoGenericErrorPageComponent', {
	    tag: 'xo-generic-error-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	    $stateParams, $state, $logger, $CheckoutAppDataModel, $util, $ReturnToMerchant, $q, $populate) {
	
	        $scope.token = $rootScope.token;
	
	        var terminalKey = 'terminal-error-' + $scope.token,
	            refreshKey = 'has-seen-error-' + $scope.token;
	
	        if (!$util.sessionStorageEnabled() || !$scope.token || sessionStorage.getItem(terminalKey)) {
	            return renderErrorPage();
	        }
	
	        // is not a refresh
	        if (!sessionStorage.getItem(refreshKey)) {
	            sessionStorage.setItem(refreshKey, '1');
	            return renderErrorPage();
	        }
	
	        // is a refresh
	        else {
	                $logger.info('checkout_fpti', {
	                    user_refresh: 1
	                });
	
	                sessionStorage.removeItem(refreshKey);
	
	                $state.go('checkout.review')['catch'](function () {
	                    return (
	                        // don't try to do this again
	                        sessionStorage.setItem(terminalKey, '1')
	                    );
	                });
	            }
	
	        function renderErrorPage() {
	            // prevent render flicker
	            $scope.shouldRender = true;
	
	            var cancelBlockStateChange = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	                $logger.info('state_change_from_generic_error_blocked');
	                event.preventDefault();
	            });
	
	            $scope.$on('$destroy', cancelBlockStateChange);
	        }
	    }
	});
	
	angular.value("$xoGenericErrorPageComponent", $xoGenericErrorPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-generic-error/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-generic-error ng-if=shouldRender token=token></xo-generic-error>\n"

/***/ },

/***/ "./components/xo-ui-components/src/generic-error/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _util = __webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__("./components/xo-ui-components/src/generic-error/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-ui-components/src/generic-error/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TITLE_KEY_MAPPING = {
	    PAYMENT_PROCESS_ERROR: 'paymentProcessError',
	    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingTitle',
	    PAYER_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
	    PAYER_COUNTRY_NOT_ENABLED: 'payerCountryNotAllowedTitle',
	    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
	    TRANSACTION_REFUSED: 'transactionRefusedTitle',
	    COMPLIANCE_VIOLATION: 'transactionRefusedTitle',
	    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredTitle',
	    INTERNAL_SERVICE_ERROR: 'transactionRefusedTitle',
	    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedTitle',
	    STUDENT_ACCOUNT: 'studentAccountTitle',
	    RETRY: 'sorry'
	};
	
	var CONTENT_KEY_MAPPING = {
	    INVALID_RESOURCE_ID: 'expiredOrTokenNotFoundError',
	    EXPIRED_SESSION: 'expiredOrTokenNotFoundError',
	    PAYMENT_ALREADY_DONE: 'paymentAlreadyCompletedError',
	    PAYEE_BLOCKED_TRANSACTION: 'paymentDeniedError',
	    PAYER_CANNOT_PAY: 'paymentDeniedError',
	    RESTRICTED_USER: 'buyerRestrictedError',
	    PAYMENT_DENIED: 'paymentDeniedError',
	    UNSUPPORTED_PAYEE_CURRENCY: 'unsupportedPayeeCurrency',
	    GUEST_UPGRADE_SESSION_ERROR: 'guestUpgradeSessionError',
	    GUEST_UPGRADE_ERROR: 'guestUpgradeError',
	    BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingMessage',
	    PAYER_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryAccountRegistered',
	    PAYER_COUNTRY_NOT_ENABLED: 'rpUnauthorizedCountryMessage',
	    PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryLogin',
	    PAYMENT_PROCESS_ERROR: 'chooseOtherWayToPay',
	    GAMING_FUNDING_SOURCE_VALIDATION_FAILED: 'unauthorizedCountryAccountRegistered',
	    SENDING_LIMIT_EXCEEDED: 'sendingLimitExceeded',
	    TRANSACTION_LIMIT_EXCEEDED: 'transactionLimitExceeded',
	    TRANSACTION_REFUSED: 'transactionRefusedMessage',
	    COMPLIANCE_VIOLATION: 'complianceViolationMessage',
	    DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredMessage',
	    INTERNAL_SERVICE_ERROR: 'transactionRefusedMessage',
	    DEFAULT: 'genericError',
	    NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedMessage',
	    ACCOUNT_CANNOT_BE_FETCHED: 'genericError',
	    STUDENT_ACCOUNT: 'studentAccountMessage',
	    RETRY: 'thingsNotWorking',
	    DEFAULT_ANDROID_PAY_ERROR: 'androidPayGenericError',
	    ANDROID_PAY_ELIGIBILITY_ERROR: 'androidPayGenericError',
	    DUPLICATE_INVOICE_ID: 'duplicateInvoiceId',
	    UNSUPPORTED_COUNTRY: 'unsupportedCountry',
	    ANDROID_PAY_ALREADY_PROVISIONED: 'androidPayAlreadyProvisioned'
	};
	
	// handle non-standard merchant error title strings
	var TITLE_KEY_HANDLER = {
	    DOMESTIC_TRANSACTION_REQUIRED: function DOMESTIC_TRANSACTION_REQUIRED(key) {
	        var merchantName = this.props.merchant;
	
	        if (merchantName) {
	            return (0, _squid.$renderContent)(key, { merchantName: merchantName });
	        }
	
	        return (0, _squid.$renderContent)(key + 'Default');
	    }
	};
	
	// handle non-standard merchant error content strings
	var CONTENT_KEY_HANDLER = {
	    DOMESTIC_TRANSACTION_REQUIRED: TITLE_KEY_HANDLER.DOMESTIC_TRANSACTION_REQUIRED
	};
	
	var HIDE_CANCEL_LINK_CODES = ['PAYER_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED'];
	
	var RETRY_LINK = ['RETRY'];
	
	var TRANSACTION_REFUSED_BA_TITLE_MSG = {
	    BA_NO_PURCHASE: 'transactionRefusedBAnoPurchaseTitle',
	    BA_WITH_PURCHASE: 'transactionRefusedBAPurchaseTitle'
	};
	
	/* eslint-disable fasec/no-unsafe-regex */
	var base64regex = new RegExp('^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$');
	
	exports['default'] = _squid.$Component.extend('$xoGenericErrorComponent', {
	
	    tag: 'xo-generic-error',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: false
	        },
	        isUnbranded: {
	            type: 'var',
	            required: false
	        },
	        cancelUrl: {
	            type: 'str',
	            required: false
	        },
	        merchant: {
	            type: 'str',
	            required: false,
	            'default': function _default() {
	                if (this.models) {
	                    var merchant = this.models.checkoutAppData.merchant;
	                    return merchant.brand_name || merchant.merchant_name;
	                }
	            }
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            if (this.props.token) {
	                return {
	                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()['catch'](angular.noop),
	                    cart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()['catch'](angular.noop),
	                    checkoutPayee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve()['catch'](angular.noop)
	                };
	            }
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	                event.preventDefault();
	            });
	
	            this.$on('$destroy', cancelPreventStateChange);
	
	            var self = this;
	
	            // to not break other application's error integration, we'll still support base64 decoded code parameters
	            if (_uiRouter.$stateParams.code && base64regex.test(_uiRouter.$stateParams.code)) {
	                self.errorCode = _squid.$util.base64Decode(_uiRouter.$stateParams.code);
	            } else {
	                self.errorCode = _uiRouter.$stateParams.code;
	            }
	
	            self.hideCancelLink = HIDE_CANCEL_LINK_CODES.indexOf(self.errorCode) > -1;
	            self.retryLink = RETRY_LINK.indexOf(self.errorCode) > -1;
	
	            _angular.$rootScope.allowUnload = true;
	            self.cancelLink = self.props.cancelUrl;
	
	            self.cancelRedirect = function ($event) {
	                $event.preventDefault();
	                var redirectUrl = self.cancelLink;
	
	                if (_angular.$rootScope.partnerIntegration) {
	                    _logger.$logger.info('genericerror_partner_integration');
	                    redirectUrl = _squid.$util.buildURL(self.cancelLink, { error: 'true' });
	                }
	
	                _util.$ReturnToMerchant.goTo(redirectUrl);
	            };
	
	            self.retryCheckout = function ($event) {
	                $event.preventDefault();
	
	                _squid.$util.reload();
	            };
	
	            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
	            (0, _jquery2['default'])('#defaultCancelLink').hide();
	            (0, _jquery2['default'])('.footerWrapper').addClass('genericError');
	
	            self.$on('$destroy', function (event) {
	                (0, _jquery2['default'])('.paypalHeaderWrapper').show();
	                (0, _jquery2['default'])('#defaultCancelLink').show();
	                (0, _jquery2['default'])('.footerWrapper').removeClass('genericError');
	            });
	
	            // Returns the title string, based on custom key handler
	            self.getTitle = function () {
	                var key = self.titleKey;
	
	                if (TITLE_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
	                    return TITLE_KEY_HANDLER[self.errorCode].call(_this, key);
	                }
	
	                return (0, _squid.$renderContent)(key);
	            };
	
	            // Returns the content string, based on custom key handler
	            self.getContent = function () {
	
	                var key = self.contentKey;
	
	                if (CONTENT_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
	                    return CONTENT_KEY_HANDLER[self.errorCode].call(_this, key);
	                }
	
	                return (0, _squid.$renderContent)(key);
	            };
	
	            // Returns the cancel button label, based on presence of brand/merchant name
	            self.getCancelLabel = function () {
	                if (self.walletTokenization) {
	                    if (self.errorCode === 'ANDROID_PAY_ALREADY_PROVISIONED') {
	                        return (0, _squid.$renderContent)('common.backToAndroidPayB');
	                    } else {
	                        return (0, _squid.$renderContent)('common.backToAndroidPay');
	                    }
	                } else {
	                    var merchantName = _this.props.merchant;
	
	                    if (merchantName) {
	                        return (0, _squid.$renderContent)('common.returnToMerchant', { merchantName: merchantName });
	                    }
	
	                    return (0, _squid.$renderContent)('common.returnToDefaultMerchant');
	                }
	            };
	        },
	        populate: function populate() {
	            if (this.models.checkoutAppData) {
	                this.cancelLink = this.models.checkoutAppData.urls.cancel_url;
	            }
	
	            if (this.models.checkoutPayee) {
	                var merchant = this.models.checkoutPayee.merchant;
	
	                if (merchant.id && !this.hideCancelLink) {
	                    var hcl = _squid.$config.hideCancelLinkForMerchant;
	
	                    var shouldHide = hcl && hcl.indexOf(merchant.id) !== -1;
	                    if (shouldHide) {
	                        this.hideCancelLink = true;
	                    }
	                }
	            }
	
	            if (this.models.cart) {
	                this.walletTokenization = this.models.cart.isWalletTokenization();
	            }
	
	            // Map error code for Android Pay
	            if (this.walletTokenization) {
	                // For Android Pay, map all errors to generic Android Pay error except for
	                // ANDROID_PAY_ALREADY_PROVISIONED
	                if (this.errorCode !== 'ANDROID_PAY_ALREADY_PROVISIONED') {
	                    this.errorCode = 'DEFAULT_ANDROID_PAY_ERROR';
	                }
	            }
	
	            var titleKey = this.errorCode && TITLE_KEY_MAPPING[this.errorCode];
	            if (titleKey) {
	                if (titleKey === 'transactionRefusedTitle' && this.models.cart && this.models.cart.isBillingNoPurchase()) {
	                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_NO_PURCHASE'];
	                } else if (titleKey === 'transactionRefusedTitle' && this.models.cart && this.models.cart.isBillingPurchase()) {
	                    this.titleKey = 'genericError.' + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_WITH_PURCHASE'];
	                } else {
	                    this.titleKey = 'genericError.' + titleKey;
	                }
	            }
	
	            var contentKey = this.errorCode && CONTENT_KEY_MAPPING[this.errorCode] || CONTENT_KEY_MAPPING.DEFAULT;
	            this.contentKey = 'genericError.' + contentKey;
	        }
	    }
	
	});
	
	
	_angular.$rootScope;
	
	_uiRouter.$stateParams;
	
	_squid.$Component;
	
	_squid.$util;
	
	_squid.$renderContent;
	
	_squid.$config;
	
	_logger.$logger;
	
	_index.$CheckoutAppDataModel;
	
	_index.$CheckoutCartModel;
	
	_index.$CheckoutPayeeModel;
	
	_util.$ReturnToMerchant;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-ui-components/src/generic-error/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"genericError\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{ getTitle() }}\n        </div>\n        <div class=\"message\"\n            ng-if=\"contentKey\"\n            ng-bind-html=\"getContent()\">\n        </div>\n        <p class=\"retryLink\" ng-if=\"retryLink\">\n            <a link-button ng-click=\"retryCheckout($event)\" id=\"retryLink\" class=\"btn full\">\n                {{ content('genericError.tryAgain') }}\n            </a>\n        </p>\n        <p class=\"cancelLink\" ng-if=\"cancelLink && !hideCancelLink\">\n            <a href=\"{{cancelLink}}\" ng-click=\"cancelRedirect($event)\" id=\"cancelLink\" ng-class=\"['btn', 'full', {'btn-secondary': retryLink}]\">\n                {{ getCancelLabel() }}\n            </a>\n        </p>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-ui-components/src/generic-error/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/generic-error/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/generic-error/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}@media (min-width:41.3125em){section#genericError .container{width:400px}.genericError.footerWrapper{float:none;width:99.4%;padding:0 3px}.genericError.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#genericError{height:450px;background:none}section#genericError .container{position:relative;margin:0 auto;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}section#genericError .title{font-size:1.5em;margin-bottom:15px;line-height:1.2}section#genericError .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#genericError .secondaryMessage{color:#979797;line-height:20px}section#genericError .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#genericError .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}section#genericError .cancelLink{margin-top:20px}section#genericError .full{padding-left:20px;padding-right:20px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-generic-message/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$GenericMessageRoute = undefined;
	
	__webpack_require__("./pages/xo-generic-message/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $GenericMessageRoute = exports.$GenericMessageRoute = _squid.$ComponentRoute.extend('$GenericMessageRoute', {
	
	    path: 'genericMessage',
	
	    directive: 'xo-generic-message-page',
	
	    query: ['code'],
	
	    // need to find these values
	    trackingData: {},
	
	    auth: false,
	
	    children: []
	});
	
	angular.value("$GenericMessageRoute", $GenericMessageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-generic-message/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoGenericMessagePageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__("./pages/xo-generic-message/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/generic-message/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoGenericMessagePageComponent = exports.$xoGenericMessagePageComponent = _squid.$Component.extend('$xoGenericMessagePageComponent', {
	    tag: 'xo-generic-message-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	    $stateParams, $state, $logger, $CheckoutAppDataModel, $util, $q, $populate) {
	
	        $scope.token = $rootScope.token;
	
	        (0, _jquery2['default'])('#defaultCancelLink').hide();
	
	        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	            event.preventDefault();
	        });
	    }
	});
	
	angular.value("$xoGenericMessagePageComponent", $xoGenericMessagePageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-generic-message/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-generic-message token=token></xo-generic-message>\n"

/***/ },

/***/ "./components/xo-ui-components/src/generic-message/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/generic-message/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-generic-message.directive', ['squid', 'xomodel.checkout']).directive('xoGenericMessage', function ($rootScope) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '='
	            },
	
	            controller: function controller($scope, $rootScope, // eslint-disable-line no-shadow
	            $stateParams, $state, $logger, $CheckoutAppDataModel, $populate) {
	
	                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	                    event.preventDefault();
	                });
	
	                $('.paypalHeaderWrapper').hide();
	                $('.footerWrapper').addClass('genericMessage');
	
	                var titleKeyMapping = {
	                    PAYMENT_SUCCESS: 'paymentSuccessTitle',
	                    DEFAULT: 'paymentSuccessTitle'
	                };
	
	                $scope.titleKey = 'genericMessage.' + ($stateParams.code && titleKeyMapping[$stateParams.code]) || titleKeyMapping.DEFAULT;
	
	                var contentKeyMapping = {
	                    PAYMENT_SUCCESS: 'paymentSuccessMessage',
	                    DEFAULT: 'paymentSuccessMessage'
	                };
	                var contentKey = $stateParams.code && contentKeyMapping[$stateParams.code];
	
	                if (contentKey) {
	                    $scope.contentKey = 'genericMessage.' + contentKey;
	                }
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                }).then(function () {
	                    var merchant = $scope.checkoutAppData.merchant;
	                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	                });
	
	                $scope.$on('$destroy', function (event) {
	                    $('.paypalHeaderWrapper').show();
	                    $('.footerWrapper').removeClass('genericMessage');
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/generic-message/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"genericMessage\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{content(titleKey)}}\n        </div>\n        <div class=\"message\" ng-if=\"contentKey\">\n            {{content(contentKey)}}\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-select-fi/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SelectFiRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-select-fi/directive.js");
	
	var $SelectFiRoute = exports.$SelectFiRoute = _squid.$ComponentRoute.extend('$SelectFiRoute', {
	
	    path: 'selectFi',
	    directive: _directive.$xoSelectFiComponent,
	    titleContent: 'memberReview.selectFi',
	    trackingData: {
	        fptiState: 'choose_FI_interstitial',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::select-fi',
	                'pagename2': '%::select-fi:member:hermes:',
	                'version': 'member:%:'
	            }
	        }
	    },
	    children: []
	});
	
	angular.value("$SelectFiRoute", $SelectFiRoute);
	_squid.$ComponentRoute;
	
	_directive.$xoSelectFiComponent;

/***/ },

/***/ "./pages/xo-select-fi/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSelectFiComponent = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _bluebird = __webpack_require__("../node_modules/bluebird/js/browser/bluebird.js");
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _choice = __webpack_require__("./components/xo-models/src/choice/index.js");
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/banner/directive.js");
	
	__webpack_require__("./components/xo-title/dist/directive.js");
	
	__webpack_require__("./components/xo-models/src/fi/index.js");
	
	__webpack_require__("./components/xo-models/src/fi/lib/fiMessages.js");
	
	__webpack_require__("./components/xo-models/src/fi/lib/fiApis.js");
	
	__webpack_require__("./components/xo-device-info/dist/index.js");
	
	__webpack_require__("./components/xo-credit-components/src/offer/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/review-paywith/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/marketingOffers/directive.js");
	
	var _template = __webpack_require__("./pages/xo-select-fi/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-select-fi/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSelectFiComponent = exports.$xoSelectFiComponent = _squid.$Component.extend('$xoSelectFiComponent', {
	    tag: 'xo-select-fi',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        }
	    },
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                cart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
	                auth: _auth.$AuthModel.instance().retrieve(),
	                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
	                variant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token)
	            };
	        }
	    },
	    actions: {
	        logout: function logout() {
	            var _this = this;
	
	            _logger.$logger.info('not_you_logout');
	
	            if (window.xchild && _squid.$util.isIFrame()) {
	
	                window.xchild.hide();
	
	                var url = window.location.href.split('#')[0];
	                var xprops = _extends({}, window.xprops);
	
	                xprops.url = url;
	                xprops.payment = function () {
	                    return _this.models.auth.action('logout').then(function () {
	                        return _this.props.token;
	                    });
	                };
	
	                return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
	            }
	
	            this.models.auth.action('logout').then(function () {
	                _uiRouter.$state.go('checkout.login', {
	                    source: 'NOT_YOU'
	                });
	            });
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            var _this2 = this;
	
	            // make this better
	            this.propValueObj = {
	                propHeader: 'memberReview.propHead',
	                propVal: 'memberReview.propVal',
	                propImage: 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png'
	            };
	
	            this.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
	
	            this.personalizedBanner = {};
	            this.setPersonalizedBanner = function (buyer_id) {
	                _this2.personalizedBanner.show = true;
	                _index.$UserPhotoModel.instance(buyer_id).retrieve({
	                    params: {
	                        'min_size': 45
	                    },
	                    success: function success(result) {
	                        if (result && result.photo_url) {
	                            _this2.personalizedBanner.imageUrl = result.photo_url;
	                            _logger.$logger.info('personalized_banner_retrieve_success');
	                        }
	                    }
	                });
	            };
	        },
	        populate: function populate() {
	            var _this3 = this;
	
	            var _models = this.models,
	                checkoutSession = _models.checkoutSession,
	                cart = _models.cart;
	
	            var masterPlanList = checkoutSession.getPlanList();
	
	            this.isBillingNoPurchase = cart.isBillingNoPurchase();
	            this.isBilling = cart.isBilling();
	
	            // Personalization banner
	            var merchantCountry = this.models.checkoutAppData.merchant.merchant_country;
	            var personalizationEnabled = (0, _squid.$feature)('oneTouchPersonalization');
	
	            if (this.models.auth.remembered && this.models.auth.remembered_device_token && personalizationEnabled) {
	                (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': merchantCountry }, 'xo_hermesnode_kmli_personalization_treatment').then(function (result) {
	                    var treatmentName = result && result.treatment_name || '';
	
	                    if (treatmentName) {
	                        _logger.$logger.info('personalized_banner_enabled');
	                        _this3.setPersonalizedBanner(_this3.models.auth.buyer_id);
	                        // delete this.models.checkoutSession.message;
	                    } else {
	                        _this3.personalizedBanner.show = false;
	                        delete _this3.models.auth.rtExchanged;
	                        _logger.$logger.info('personalized_banner_disabled');
	                    }
	                });
	            } else {
	                _logger.$logger.info('personalized_banner_ineligible', {
	                    'isFeature': personalizationEnabled,
	                    'isOneTouch': this.models.auth.remembered && this.models.auth.remembered_device_token
	                });
	                if (this.models.auth.rtExchanged) {
	                    delete this.models.auth.rtExchanged;
	                }
	            }
	
	            this.showNotYou = this.models.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp' && !_squid.$util.param('redirectToHermesOn3DSDecline') && !_squid.$util.param('ulReturn');
	
	            this.formattedNameInformal = (0, _squid.formatNameInformal)({
	                first_name: this.models.auth.first_name,
	                last_name: this.models.auth.last_name
	            }) || this.models.auth.email;
	
	            // selected plan model
	            var selectedmethod = this.selectedmethod = {
	                // first selection to start
	                index: 0,
	                // needed by xo-reuse and will be resolved later
	                planId: 0
	            };
	
	            var serializedPlans = {}; // index of all plans by primary and balance currency code(s)
	            var balanceCodes = {}; // index of cataloged currency codes
	            var primaryList = []; // list of plans with unique primaryFs ids
	            var balanceList = this.balanceList = []; // list of unique balance currencies
	            var cardMap = { // FI names that we know map to content keys
	                BILL_ME_LATER: 'BILL_ME_LATER',
	                PAD: 'PAD',
	                PAYPAL_EXTRAS_MASTERCARD: 'PAYPAL_EXTRAS_MASTERCARD'
	            };
	
	            var getSerializedPrimary = function getSerializedPrimary(primary) {
	                var serial = primary.id + primary.amount.currency_code.toLowerCase();
	
	                // if there's a subtype...
	                if (primary.subtype) {
	                    serial += primary.subtype;
	                }
	                return serial;
	            };
	
	            // return a serialized key for the plan
	            // plan - a plan object from checkoutSession.fundingOptions.plans
	            // balances - array of currency code strings
	            var getSerializedPlanId = function getSerializedPlanId(plan, balances) {
	                var pid = getSerializedPrimary(plan.primaryFs);
	
	                // if no balances array...
	                if (!balances) {
	                    // just return the pid
	                    return pid;
	                }
	
	                // (otherwise) sort balances
	                balances.sort();
	
	                return pid + balances.join();
	            };
	
	            if (masterPlanList) {
	                var showBalanceCurrencies = checkoutSession.isMultipleBalancePlan();
	
	                // if not multiple balance plans...
	                if (!showBalanceCurrencies) {
	                    // start with first plan's currency
	                    var knownCurrency = masterPlanList[0].primaryFs.amount.currency_code;
	
	                    // update flag if any plan has more than two secondaries or one with a different currency
	                    showBalanceCurrencies = masterPlanList.some(function (plan) {
	                        // show currencies, when this plan has a different one, or...
	                        return plan.primaryFs.amount.currency_code !== knownCurrency ||
	                        // this plan has secondaries, where...
	                        plan.secondaryFIs && (
	                        // there's more than one
	                        plan.secondaryFIs.length > 1 ||
	                        // the one has a different currency
	                        plan.secondaryFIs[0].amount.currency_code !== knownCurrency);
	                    });
	                }
	
	                // index of captured primaryFs ids
	                var primaryFsIds = {};
	
	                // with each plan...
	                masterPlanList.forEach(function (plan) {
	                    var balances = plan.secondaryFIs || [];
	                    var balCurCodes = [];
	
	                    // catalog balances
	                    balances.forEach(function (balance) {
	                        var code = balance.amount.currency_code;
	
	                        // capture code (for serialization, next)
	                        balCurCodes.push(code);
	                        // if this code has not been cataloged...
	                        if (!balanceCodes.hasOwnProperty(code)) {
	                            var balInfoAndState = {
	                                code: code,
	                                checked: false,
	                                enabled: true,
	                                intent: false,
	                                fake: false
	                            };
	
	                            if (showBalanceCurrencies) {
	                                balInfoAndState.amount = balance.amount.amount_formatted_currency;
	                            } else {
	                                balInfoAndState.amount = balance.amount.amount_formatted;
	                            }
	                            // flag that we've cataloged this code
	                            balanceCodes[code] = balInfoAndState;
	                            // capture balance details and initial ui state
	                            balanceList.push(balInfoAndState);
	                        }
	                    });
	
	                    // if this is a primary split-balance plan...
	                    if (plan.primaryFs.type === 'BALANCE') {
	                        // add key to template
	                        // NOTE: easier to build string here, than with template tags
	                        plan.currencies = [plan.primaryFs.amount.currency_code].concat(balCurCodes).join(', ');
	                    }
	
	                    // catalog plan by serial and balances
	                    serializedPlans[getSerializedPlanId(plan, balCurCodes)] = plan;
	
	                    // get plan primary
	                    var serialPrimary = getSerializedPrimary(plan.primaryFs);
	
	                    // if haven't indexed the primary...
	                    if (!primaryFsIds.hasOwnProperty(serialPrimary)) {
	                        // note that we've cataloged this primary
	                        primaryFsIds[serialPrimary] = 1;
	                        // capture plan with unique primary
	                        primaryList.push(plan);
	                    }
	                });
	
	                // sort unique balances by currency code
	                balanceList.sort(function (balA, balB) {
	                    // balance codes are never the same, so no need to return 0
	                    return balA.code < balB.code ? -1 : 1;
	                });
	
	                // expose to template
	                this.isMultipleBalance = showBalanceCurrencies;
	                this.primaryList = primaryList;
	            }
	
	            var getPlansByPrimaryId = function getPlansByPrimaryId(pid) {
	                var matchingPlans = {};
	
	                // with each serialized plan
	                for (var key in serializedPlans) {
	                    // if this key is not inherited and begins with this pid...
	                    if (serializedPlans.hasOwnProperty(key) && !key.indexOf(pid)) {
	                        // add to matched plans
	                        matchingPlans[key] = serializedPlans[key];
	                    }
	                }
	                return matchingPlans;
	            };
	
	            this.capUserIntent = function (code, state) {
	                var balance = balanceCodes[code];
	
	                // if this balance is enabled...
	                if (balance.enabled) {
	                    // capture user triggered state change
	                    balance.intent = state;
	                }
	            };
	
	            this.updateBalances = function (index) {
	                var primary = primaryList[index].primaryFs;
	                var bankOrOther = primary.type === 'BANK' ? 'BANK' : 'OTHER';
	                var primaryCodeAsBalance = primary.type === 'BALANCE' && primary.amount.currency_code;
	                var pid = getSerializedPrimary(primary);
	                var matchingPlans = getPlansByPrimaryId(pid);
	
	                // if no balances...
	                if (!balanceList.length) {
	
	                    // if there is a plan with just this primaryFs (there should always be, btw)...
	                    if (matchingPlans.hasOwnProperty(pid)) {
	                        // capture the matching plan (needed by xo-reuse)
	                        selectedmethod.planId = matchingPlans[pid].planId;
	                    }
	
	                    // exit early
	                    return;
	                }
	
	                var combinedSerials = Object.keys(matchingPlans).join();
	                var cardName = cardMap[primary.name] || bankOrOther;
	                var includeCodes = [];
	                var excludeCodes = [];
	
	                // with each balance...
	                _squid.$util.forEach(balanceCodes, function (balState, code) {
	                    var isFake =
	
	                    // show fake selected+disabled checkbox
	                    // when the primary is Balance with the same currency
	                    balState.fake = primaryCodeAsBalance === code;
	
	                    // if faking this checkbox
	                    if (isFake) {
	                        // fake that it's being forced
	                        includeCodes.push(code);
	                    }
	
	                    // if no plans allow this balance...
	                    if (combinedSerials.indexOf(code) === -1) {
	                        // deselect and disable this balance
	                        balState.checked = balState.enabled = false;
	                        if (!isFake) {
	                            // add currency code to exclude list
	                            excludeCodes.push(code);
	                        }
	                    } else {
	                        // assume all plans require this balance
	                        var requiresBalance = true;
	
	                        // with each plan...
	                        for (var serial in matchingPlans) {
	                            // if it can be used without this balance...
	                            if (matchingPlans.hasOwnProperty(serial) && serial.indexOf(code) === -1) {
	                                // flag that all plans do not use this balance
	                                requiresBalance = false;
	                                break;
	                            }
	                        }
	                        // if this balance is required for this (or all) plans...
	                        if (requiresBalance) {
	                            // select this balance
	                            balState.checked = true;
	                            // disable this balance
	                            balState.enabled = false;
	
	                            // add currency code to include list
	                            includeCodes.push(code);
	                        } else {
	                            // (otherwise) when this balance is optional for this primaryFs...
	                            // just enable the balance checkbox
	                            balState.enabled = true;
	                            // use intent state to persist user intent
	                            balState.checked = balState.intent;
	                        }
	                    }
	                });
	
	                // if not a balance plan, and we have any include and/or exclude messages to display...
	                if (primary.type !== 'BALANCE' && (includeCodes.length || excludeCodes.length)) {
	                    var msgs = [];
	                    var fiName = (0, _squid.$renderContent)('fsMappings.' + primary.name).string || primary.name;
	
	                    // log when user messaging occurs
	                    _logger.$logger.info('checkout_fpti', {
	                        primary: primary.id || primary.type,
	                        denied: excludeCodes.join(),
	                        forced: includeCodes.join()
	                    });
	
	                    // build include and exclude messages
	                    [['yes', includeCodes], ['no', excludeCodes]].forEach(function (pair) {
	                        var codes = pair[1];
	                        var codesLn = codes.length;
	
	                        // if there are codes to report as in/ex-cluded...
	                        if (codesLn) {
	                            var msgKey = 'memberReview.' + pair[0] + 'Bal_' + cardName;
	                            var msgObj = { fi: fiName };
	
	                            // if more than one code...
	                            if (codesLn > 1) {
	                                // use plural content key
	                                msgKey += '_plural';
	                                // if more than two codes...
	                                if (codesLn > 2) {
	                                    // group all but the last as the first code
	                                    msgObj.code1 = codes.slice(0, -1).join(', ');
	                                    // use last code alone
	                                    msgObj.code2 = codes[codes.length - 1];
	                                } else {
	                                    // set code to each token
	                                    msgObj.code1 = codes[0];
	                                    msgObj.code2 = codes[1];
	                                }
	                            } else {
	                                // (otherwise) when only one code...
	                                // list as first code
	                                msgObj.code1 = codes[0];
	                            }
	                            // capture final message
	                            msgs.push((0, _squid.$renderContent)(msgKey, msgObj));
	                        }
	                    });
	                    // show informational messages
	                    checkoutSession.message = {
	                        msgs: msgs,
	                        type: 'info'
	                    };
	                } else {
	                    // clear (any) existing message(s)
	                    checkoutSession.message = '';
	                }
	            };
	
	            // determine which plan to pre-select
	
	            // if BA txn...
	            if (this.isBillingNoPurchase) {
	                // just deal with plan id - ignore index approach
	                selectedmethod.planId = checkoutSession.getSelectedStickyInstrument().instrument_id;
	            } else if (balanceList.length) {
	
	                // (or) there are balances...
	
	                // update balance checkboxes for the first/default selected plan
	                this.updateBalances(0);
	            } else {
	
	                // (otherwise) without balances...
	
	                // honor preferred/active/current plan
	                var preferredPlanId = checkoutSession.plan.id;
	
	                // behave as if the preferred plan were selected - if not, the first/default
	                var preferredPlanIndex = _squid.$util.findIndex(primaryList, function (plan) {
	                    return plan.planId === preferredPlanId;
	                }) || 0;
	
	                // specify selected method
	                selectedmethod.index = preferredPlanIndex;
	                // capture preferred plan id - should be same as `preferredPlanId`
	                selectedmethod.planId = primaryList[preferredPlanIndex].planId;
	            }
	
	            this.getBAPlans = function () {
	                return checkoutSession.futurePaymentInstruments;
	            };
	
	            // Check if is variant where preferred can be set
	            var preferredFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];
	
	            this.preferredFiVariant = preferredFiVariants.indexOf(this.models.variant) > -1;
	            var updateFS = function updateFS() {
	                var planId = void 0;
	
	                // if BA plans...
	                if (_this3.isBillingNoPurchase) {
	                    planId = selectedmethod.planId;
	                } else {
	
	                    // (otherwise) resolve plan from index and checked balance checkboxes
	
	                    // get plan with serial, built from user selections
	                    var checkedBalances = [];
	
	                    _squid.$util.forEach(balanceCodes, function (balance, code) {
	                        if (balance.checked) {
	                            checkedBalances.push(code);
	                        }
	                    });
	                    planId = serializedPlans[getSerializedPlanId(primaryList[selectedmethod.index], checkedBalances)].planId;
	                }
	                if (_this3.isBillingNoPurchase && checkoutSession.getSelectedStickyInstrument() && checkoutSession.getSelectedStickyInstrument().instrument_id !== planId) {
	                    return checkoutSession.action('setStickyFI', {
	                        data: {
	                            instrument_id: planId
	                        },
	                        success: function success(result) {
	                            checkoutSession.message = {
	                                type: 'success',
	                                msgKeys: ['paymentMethod.paymentMethodUpdated']
	                            };
	                            return result;
	                        },
	                        DEFAULT: function DEFAULT() {
	                            // Error message for failures
	                            _uiRouter.$state.go('checkout.review');
	                        }
	                    });
	                } else if (!_this3.isBillingNoPurchase && checkoutSession.get('plan.sources')[0].id !== planId) {
	
	                    return checkoutSession.fundingOptions.action('select', {
	                        data: {
	                            planId: planId
	                        },
	                        success: function success(result) {
	                            checkoutSession.populate(result);
	                            return result;
	                        },
	                        contingencies: {
	                            NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
	                                if (result && result.resolution) {
	                                    var card = result.resolution.data;
	
	                                    if (card.fundingId && card.fi && card.fi.type) {
	                                        _this3.cardModel.id = card.fundingId;
	                                        _this3.cardModel.card = new _index2.$CardModel({
	                                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
	                                            type: card.fi.type.toUpperCase(),
	                                            productType: card.fi.productType
	                                        });
	                                    }
	                                }
	
	                                _uiRouter.$state.go('.confirmUpop');
	                            },
	
	                            DEFAULT: function DEFAULT() {
	                                // Error message for failures
	                                _uiRouter.$state.go('checkout.review');
	                            }
	                        }
	                    });
	                } else {
	                    return _bluebird2['default'].resolve();
	                }
	            };
	
	            this['continue'] = function (evt) {
	                return updateFS().then(function (result) {
	
	                    // clear (any) existing message(s)
	                    checkoutSession.message = '';
	
	                    // Decide routing after update
	
	                    if (result) {
	                        // Update the installments to support the user selecting a card that does not support installments.
	                        _this3.models.checkoutSession.installments = result.installments;
	                    }
	
	                    // If paypal credit, check for installments and redirect if needed
	                    if (_this3.models.checkoutSession.get('plan.paypal_credit') && _this3.models.checkoutSession.creditOffer) {
	                        var token = _this3.props.token;
	                        var installments = _index2.$InstallmentOptionsModel.instance(token);
	                        var data = {
	                            isMemberCredit: true
	                        };
	
	                        return (0, _squid.$populate)(data, {
	                            payee: _index2.$CheckoutPayeeModel.instance(token),
	                            checkoutCart: _index2.$CheckoutCartModel.instance(token),
	                            checkoutAppData: _this3.models.checkoutAppData
	                        }).then(function () {
	                            return installments.save({
	                                cache: true, // Cache between here and $ChoiceEligibilityModel
	                                data: data,
	                                success: function success(installmentResult) {
	                                    var offers = installmentResult.installments && installmentResult.installments[0];
	                                    var hasInstallments = offers && offers.installment_options && offers.installment_options.length;
	
	                                    return hasInstallments;
	                                },
	                                contingencies: {
	                                    DEFAULT: function DEFAULT() {
	                                        // Assume is eligible if contingency
	                                        return false;
	                                    }
	                                },
	                                error: function error() {
	                                    return false;
	                                }
	                            });
	                        }).then(function (hasInstallments) {
	                            if (hasInstallments) {
	                                return _uiRouter.$state.go('checkout.chooseCreditOffer');
	                            } else {
	                                return _uiRouter.$state.go('checkout.review');
	                            }
	                        });
	                    } else {
	                        return _uiRouter.$state.go('checkout.review');
	                    }
	                });
	            };
	        }
	    },
	    controller: function controller($scope) {
	        $scope.installment = {
	            showBanner: false,
	            showCYCO: false,
	            showRepresentativeInfo: false
	        };
	    }
	});
	
	angular.value("$xoSelectFiComponent", $xoSelectFiComponent);
	_squid.$Component;
	
	_squid.$renderContent;
	
	_squid.$populate;
	
	_squid.$config;
	
	_squid.$feature;
	
	_squid.$integration;
	
	_squid.$pxp;
	
	_squid.formatNameInformal;
	
	_squid.$util;
	
	_uiRouter.$state;
	
	_logger.$logger;
	
	_auth.$AuthModel;
	
	_index.$UserPhotoModel;
	
	_index2.$CheckoutSessionModel;
	
	_index2.$CardModel;
	
	_index2.$InstallmentOptionsModel;
	
	_index2.$CheckoutPayeeModel;
	
	_index2.$CheckoutCartModel;
	
	_index2.$CheckoutAppDataModel;
	
	_choice.$ChoiceEligibility;

/***/ },

/***/ "./components/xo-models/src/choice/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ChoiceEligibility = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _lodash = __webpack_require__("./components/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Variants:
	// control
	// 5 - If any choice treatment, do 5 unless 5 is ineligible
	// 6 - If any choice treatment, do 6 if 5 is ineligible and 6 is eligible
	
	var checkPPCInstallments = function checkPPCInstallments(token, _ref) {
	    var checkoutSessionModel = _ref.checkoutSessionModel,
	        checkoutPayeeModel = _ref.checkoutPayeeModel,
	        checkoutCartModel = _ref.checkoutCartModel,
	        checkoutAppDataModel = _ref.checkoutAppDataModel;
	
	    // Check for installments - has credit in wallet, has credit offer in checkout session, and has installment options
	    if (checkoutSessionModel.fundingOptions.hasCredit() && checkoutSessionModel.creditOffer && (0, _squid.$feature)('creditInstallmentOffers')) {
	        var installmentOptions = _checkout.$InstallmentOptionsModel.instance(token);
	        return installmentOptions.save({
	            cache: true, // Cache response for selectFi page or wherever needed
	            data: {
	                payee: checkoutPayeeModel,
	                checkoutCart: checkoutCartModel,
	                checkoutAppData: checkoutAppDataModel,
	                isMemberCredit: true
	            },
	            success: function success(result) {
	                var offers = result.installments && result.installments[0];
	                var hasInstallments = offers && offers.installment_options && offers.installment_options.length;
	
	                return hasInstallments;
	            },
	            contingencies: {
	                DEFAULT: function DEFAULT(message) {
	                    // Assume is eligible if contingency
	                    _logger.$logger.info('installments_contingency', {
	                        message: message
	                    });
	                    return false;
	                }
	            },
	            error: function error(err) {
	                _logger.$logger.info('installments_error', err);
	                return false;
	            }
	        });
	    } else {
	        return _squid.$promise.resolve(false);
	    }
	};
	
	// Main logic to decide choice eligibility
	var decideEligibility = function decideEligibility(token, _ref2) {
	    var authModel = _ref2.authModel,
	        checkoutCartModel = _ref2.checkoutCartModel,
	        checkoutSessionModel = _ref2.checkoutSessionModel,
	        checkoutAppDataModel = _ref2.checkoutAppDataModel,
	        checkoutPayeeModel = _ref2.checkoutPayeeModel;
	    var plan = checkoutSessionModel.plan,
	        fundingOptions = checkoutSessionModel.fundingOptions;
	
	    var plans = checkoutSessionModel.get('fundingOptions.plans');
	
	    // Reasons for a transaction to be ineligible:
	    //  - Doesn't meet pxp
	    //  - is MSB
	    //  - is billing
	    //  - is split balance
	    //  - balance covers full transaction but does not have preferred set
	    //  - has PAD
	    //  - is second button
	    //  - is not US
	    //  - has currency conversion
	    //  - is not a merchant account
	
	    // Check to see if any plans include split balance
	    var splitBalance = plans && plans.some(function (option) {
	        return option.primaryFs && option.secondaryFIs;
	    });
	    var MSB = plan.hasFundingMethodType('INCENTIVE');
	    var billing = checkoutCartModel.isBilling();
	    var PAD = plans && plans.some(function (option) {
	        return option.primaryFs && option.primaryFs.subtype === 'PAD';
	    });
	    var secondButton = checkoutAppDataModel.is_second_button_txn;
	    var isUS = checkoutAppDataModel.merchant.merchant_country === 'US';
	    var fullBalance = plans && plans.some(function (option) {
	        return option.primaryFs && option.primaryFs.type === 'BALANCE';
	    });
	    var hasPreferred = fundingOptions.getPreferred();
	    var isNotMerchantAccount = authModel.account_type !== 2;
	    var isNotAndroidPay = !checkoutCartModel.isWalletTokenization();
	    var isNotFbBaFlow = !_squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
	
	    var involvedCurrencies = {};
	    if (checkoutCartModel.get('purchase.amounts.total.currency_code') && plans) {
	        involvedCurrencies[checkoutCartModel.purchase.amounts.total.currency_code] = 1;
	        plans.forEach(function (option) {
	            involvedCurrencies[option.primaryFs.amount.currency_code] = 1;
	        });
	    }
	
	    var singleCurrency = _lodash2['default'].size(involvedCurrencies) <= 1;
	
	    var choiceVariantsName = 'xo_hermes_choice_variant_(?:preferred_newusers_)?treatment_(.*)';
	
	    // Check the global preferred experiment and the choice variant.
	    // User must pass the global preferred experiment to be eligible to see a variant
	    // Forced pxp call in case logged in user is different
	    return (0, _squid.$pxp)('xo_hermes_choice_variant', {}, choiceVariantsName, true).then(function (choiceVariant) {
	        var _$config$choiceExperi = _squid.$config.choiceExperiment;
	        _$config$choiceExperi = _$config$choiceExperi === undefined ? {} : _$config$choiceExperi;
	        var _$config$choiceExperi2 = _$config$choiceExperi.ignored;
	        _$config$choiceExperi2 = _$config$choiceExperi2 === undefined ? {} : _$config$choiceExperi2;
	        var _$config$choiceExperi3 = _$config$choiceExperi2.multipleFi,
	            multipleFiIgnored = _$config$choiceExperi3 === undefined ? [] : _$config$choiceExperi3,
	            _$config$choiceExperi4 = _$config$choiceExperi2.selectFi,
	            selectFiIgnored = _$config$choiceExperi4 === undefined ? [] : _$config$choiceExperi4;
	
	        // Check transaction eligibility
	
	        var eligibilityCriteria = {
	            'pxpVariant': choiceVariant,
	            'noMSB': !MSB,
	            'noBilling': !billing,
	            'noSplitBalance': !splitBalance,
	            'balanceWithPreferred': !(fullBalance && !hasPreferred),
	            'noPAD': !PAD,
	            'noSecondButton': !secondButton,
	            'isUS': isUS,
	            'singleCurrency': singleCurrency,
	            'noMerchant': isNotMerchantAccount,
	            'noAndroidPay': isNotAndroidPay,
	            'isNotFbBaFlow': isNotFbBaFlow
	        };
	        // First check to see if transaction is eligible for choice at all.
	        // Base eligibility check follows the selectFi eligibility
	        var choiceIneligibleReasons = Object.keys(eligibilityCriteria).filter(function (key) {
	            return selectFiIgnored.indexOf(key) === -1 && !eligibilityCriteria[key];
	        });
	        var transactionEligible = choiceIneligibleReasons.length === 0;
	
	        if (!transactionEligible) {
	            _logger.$logger.info('choice_experiment_ineligible', {
	                failed: choiceIneligibleReasons.join()
	            });
	
	            _logger.$logger.info('checkout_fpti', {
	                'from': 'CHOICE_ELG_CHK',
	                'to': 'process_choice_elg_chk',
	                'eligibility_reason': 'pxp_control-' + choiceIneligibleReasons.join()
	            });
	
	            return 'control';
	        }
	
	        // If eligible for choice, check if transaction is eligible for multipleFi variant
	        return checkPPCInstallments(token, {
	            checkoutCartModel: checkoutCartModel,
	            checkoutSessionModel: checkoutSessionModel,
	            checkoutAppDataModel: checkoutAppDataModel,
	            checkoutPayeeModel: checkoutPayeeModel
	        }).then(function (hasPPCInstallments) {
	            var multipleFiEligibility = (0, _angular.extend)({
	                creditInstallments: !hasPPCInstallments // check if does not have credit installments
	            }, eligibilityCriteria);
	            var multipleFiIneligibleReasons = Object.keys(multipleFiEligibility).filter(function (criteria) {
	                return multipleFiIgnored.indexOf(criteria) === -1 && !multipleFiEligibility[criteria];
	            }).join();
	            var multipleFiEligible = multipleFiIneligibleReasons.length === 0;
	
	            if (!multipleFiEligible) {
	                _logger.$logger.info('choice_experiment_var5_ineligible', {
	                    failed: multipleFiIneligibleReasons
	                });
	
	                _logger.$logger.info('checkout_fpti', {
	                    'from': 'CHOICE_ELG_CHK',
	                    'to': 'process_choice_elg_chk',
	                    'eligibility_reason': 'pxp_6-' + multipleFiIneligibleReasons
	                });
	
	                return '6';
	            }
	
	            _logger.$logger.info('choice_experiment_eligible', {
	                variant: '5'
	            });
	
	            _logger.$logger.info('checkout_fpti', {
	                'from': 'CHOICE_ELG_CHK',
	                'to': 'process_choice_elg_chk',
	                'eligibility_reason': 'pxp_treatment'
	            });
	
	            return '5';
	        });
	    });
	};
	
	var promiseControl = _squid.$promise.resolve('control');
	
	var $ChoiceEligibility = exports.$ChoiceEligibility = _squid.$Model.extend('$ChoiceEligibility', {
	    getVariant: function getVariant(token) {
	        var _this = this;
	
	        if (!(0, _squid.$feature)('choiceExperiment')) {
	            return promiseControl;
	        }
	
	        var models = {};
	
	        return (0, _squid.$populate)(models, {
	            authModel: _auth.$AuthModel.instance(),
	            checkoutCartModel: _checkout.$CheckoutCartModel.instance(token),
	            checkoutPayeeModel: _checkout.$CheckoutPayeeModel.instance(token),
	            checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
	            checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token)
	        }).then(function () {
	            // If user logged in is the same, we don't need the pxp call so we can skip the decision making logic
	            if (_this.variant && models.authModel.buyer_id === _this.buyerId) {
	                return _this.variant;
	            }
	
	            _this.variant = decideEligibility(token, models);
	            _this.buyerId = models.authModel.buyer_id;
	
	            return _this.variant;
	        });
	    }
	});
	
	_angular.extend;
	
	_squid.$Model;
	
	_squid.$pxp;
	
	_squid.$promise;
	
	_squid.$populate;
	
	_squid.$config;
	
	_squid.$feature;
	
	_squid.$integration;
	
	_logger.$logger;
	
	_auth.$AuthModel;
	
	_checkout.$CheckoutCartModel;
	
	_checkout.$CheckoutPayeeModel;
	
	_checkout.$CheckoutSessionModel;
	
	_checkout.$CheckoutAppDataModel;
	
	_checkout.$InstallmentOptionsModel;

/***/ },

/***/ "./components/xo-ui-components/src/banner/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-ui-components/src/banner/styles.less");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/banner/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-banner.directive', ['squid']).directive('xoBanner', function () {
	        return {
	            scope: {
	                bannerImage: '='
	            },
	            template: template,
	            transclude: true,
	            link: function link(scope, element) {
	                var imageType = 'default';
	                var deregisterWatcher = scope.$watch('bannerImage', function () {
	                    if (scope.bannerImage) {
	                        var elem = document.getElementById('banner-picture');
	                        if (elem) {
	                            elem.style.backgroundImage = 'url("' + scope.bannerImage + '")';
	                            imageType = 'user';
	                        }
	                        deregisterWatcher(); // $watch returns a deregister function
	                        deregisterWatcher = 'deregisterd'; // converting deregisterWatcher into a non-function
	                    }
	
	                    // Todo : remove logger from ui once proven stable on production
	                    _logger.$logger.info('xoBanner', {
	                        'watcher_enabled': angular.isFunction(deregisterWatcher),
	                        'image_type': imageType
	                    });
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_logger.$logger;

/***/ },

/***/ "./components/xo-ui-components/src/banner/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/banner/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/banner/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#banner-wrapper{padding:5px;border-bottom:1px solid #e3e3e3}#banner-picture{width:40px;height:40px;border-radius:40px;-webkit-border-radius:40px;-moz-border-radius:40px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_phantom.png\") no-repeat;background-size:cover;float:left;margin-right:10px;margin-top:10px;margin-bottom:10px}#banner-content{height:26px;font-family:HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:13px;font-weight:400;color:#000;padding:15px 15px 15px 10px;display:table-cell;vertical-align:middle}#banner-content>p{font-size:inherit;margin:0;padding-bottom:0}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/banner/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"banner-wrapper\">\n    <div id=\"banner-picture\"></div>\n    <div id=\"banner-content\" ng-transclude></div>\n</div>\n"

/***/ },

/***/ "./components/xo-models/src/fi/lib/fiMessages.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('fi.messages', ['squid']).factory('$fiMessages', function ($renderContent, $logger) {
	
	        function getContentKeys(hasFi) {
	            if (hasFi) {
	                return {
	                    member: 'payment.processorDeclineMember',
	                    generic: 'payment.processorDeclineMemberGeneric',
	                    buyerCredit: 'payment.processorDeclineMemberBuyerCredit'
	                };
	            } else {
	                return {
	                    member: 'payment.processorDeclineMemberNoFI',
	                    generic: 'payment.processorDeclineMemberNoFIGeneric',
	                    buyerCredit: 'payment.processorDeclineMemberBuyerCreditNoFI'
	                };
	            }
	        }
	
	        function processorDeclinedMsg(checkoutSession, hasFi) {
	            var declinedInstruments = checkoutSession.get('declinedInstruments');
	
	            if (angular.isArray(declinedInstruments) && declinedInstruments.length) {
	                var msg;
	                var type = 'warning';
	                var instrument = declinedInstruments[0];
	                var contentKeys = getContentKeys(hasFi);
	
	                if (instrument.type === 'PAYMENT_CARD') {
	                    if (instrument.card_type && instrument.last4) {
	                        $logger.info('processor_decline', { hasFi: hasFi, message: 'member' });
	
	                        msg = $renderContent(contentKeys.member, {
	                            type: instrument.card_type,
	                            number: instrument.last4
	                        });
	                    } else {
	                        $logger.info('processor_decline', { hasFi: hasFi, message: 'generic' });
	
	                        msg = $renderContent(contentKeys.generic);
	                    }
	                } else {
	                    $logger.info('processor_decline', { hasFi: hasFi, message: 'buyerCredit' });
	
	                    msg = $renderContent(contentKeys.buyerCredit);
	                }
	
	                checkoutSession.set('declinedInstruments', null);
	                return {
	                    type: type,
	                    msg: msg
	                };
	            }
	        }
	
	        function getAddCardControlMsg() {
	            $logger.info('checkout_fpti', {
	                'int_error_description': 'addcard_msg_control'
	            });
	            return {
	                msg: $renderContent('creditcard.noFIContingency'),
	                type: 'info'
	            };
	        }
	
	        function getAddCardTreatmentMsg(checkoutSession) {
	            var msg;
	            var type;
	            var title;
	            var cardList;
	            var lastCard;
	            var disallowedInstruments = checkoutSession.get('fundingOptions').get('disallowedInstruments');
	
	            if (disallowedInstruments && disallowedInstruments.length === 1) {
	                cardList = disallowedInstruments[0].name + '-' + disallowedInstruments[0].lastDigits;
	                $logger.info('checkout_fpti', {
	                    'int_error_description': 'single_disallowed_FI_addcard_msg'
	                });
	
	                msg = $renderContent('creditcard.hasSingleDisallowedFi', { cardList: cardList });
	                type = 'normal';
	                title = $renderContent('creditcard.hasDisallowedAddCardTitle');
	            } else if (disallowedInstruments && disallowedInstruments.length > 1) {
	                cardList = '';
	
	                for (var i = 0; i < disallowedInstruments.length; i++) {
	                    if (i === disallowedInstruments.length - 1) {
	                        lastCard = disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits;
	                    } else if (i === disallowedInstruments.length - 2) {
	                        cardList += disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits;
	                    } else {
	                        cardList += disallowedInstruments[i].name + '-' + disallowedInstruments[i].lastDigits + ', ';
	                    }
	                }
	
	                $logger.info('checkout_fpti', {
	                    'int_error_description': 'multi_disallowed_FI_addcard_msg'
	                });
	
	                msg = $renderContent('creditcard.hasMultipleDisallowedFi', { cardList: cardList, lastCard: lastCard });
	                type = 'normal';
	                title = $renderContent('creditcard.hasDisallowedAddCardTitle');
	            } else {
	                $logger.info('checkout_fpti', {
	                    'int_error_description': 'has_no_FI_addcard_msg'
	                });
	
	                msg = $renderContent('creditcard.hasNoDisallowedFi');
	                type = 'normal';
	                title = $renderContent('creditcard.noDisallowedAddCardTitle');
	            }
	            return {
	                msg: msg,
	                type: type,
	                title: title
	            };
	        }
	
	        function getGamblingMsg() {
	            return {
	                type: 'error',
	                msg: $renderContent('creditcard.noEligibleFI')
	            };
	        }
	
	        return {
	            processorDeclinedMsg: processorDeclinedMsg,
	            getGamblingMsg: getGamblingMsg,
	            getAddCardTreatmentMsg: getAddCardTreatmentMsg,
	            getAddCardControlMsg: getAddCardControlMsg
	
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/fi/lib", "components/xo-models/src/fi/lib/fiMessages.js"))

/***/ },

/***/ "./components/xo-models/src/fi/lib/fiApis.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('fi.apis', ['squid']).factory('$fiApis', function ($q) {
	        return {
	            patchCvv: function patchCvv(checkoutSession) {
	                var cvvData = checkoutSession.get('cvvData');
	
	                if (cvvData) {
	                    return checkoutSession.action('patchCvv', {
	                        data: {
	                            id: cvvData.id,
	                            cvv: cvvData.security_code,
	                            type: cvvData.type,
	                            number: cvvData.number
	                        }
	                    });
	                }
	
	                return $q.when();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/fi/lib", "components/xo-models/src/fi/lib/fiApis.js"))

/***/ },

/***/ "./components/xo-credit-components/src/offer/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var ACQ_Banner_Type = 'acquisition';
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/offer/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    squid.module('xo-offer.directive', ['squid', 'xomodel.checkout']).directive('xoOffer', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                promotion: '=',
	                bmlaction: '=',
	                installment: '=',
	                selectedmethod: '=',
	                reusetext: '='
	            },
	
	            controller: function controller($scope, $sce, $FallbackError, $populate, $state, $q, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel, $pxp, $logger, $InstallmentOptionsModel, $feature, $locale, $CheckoutPayeeModel, $util, $CreditDataModel, $CreditOptionsModel, $config, $rootScope, $MarketingOfferModel, $fireMORSBeacon, $AuthModel, $CreditInstallmentModel) {
	                var isCreditInWallet = void 0;
	                var isRedirectFromCape = void 0;
	
	                var BANNER_TYPES = {
	                    'PASSIVE': 'PASSIVE',
	                    'PROMINENT': 'PROMINENT'
	                };
	                var USE_CASE = {
	                    'REUSE': 'REUSE',
	                    'ACQUISITION': 'ACQUISITION'
	                };
	                var CREDIT_TYPE = {
	                    'CORE': 'CORE',
	                    'SAC': 'SAC',
	                    'EZP': 'EZP'
	                };
	
	                var getDefaultBanner = function getDefaultBanner(bannerType, useCase, creditType, amount, termsLink) {
	                    if (bannerType === BANNER_TYPES.PROMINENT) {
	                        if (useCase === USE_CASE.ACQUISITION) {
	                            if (creditType === CREDIT_TYPE.CORE) {
	                                return {
	                                    bodyText: $scope.htmlContent('offers.bmlOfferSmallTitleWithAmount', { cartAmount: amount }),
	                                    ctaText: $scope.htmlContent('offers.bmlOfferBtn'),
	                                    termsText: $scope.htmlContent('offers.subjectToApproval'),
	                                    termsLink: termsLink,
	                                    termsLinkText: $scope.htmlContent('offers.seeTermsText')
	                                };
	                            } else if (creditType === CREDIT_TYPE.SAC) {
	                                return {
	                                    bodyText: $scope.htmlContent('offers.bmlOfferLargeTitleWithAmount', { cartAmount: amount }),
	                                    ctaText: $scope.htmlContent('offers.bmlOfferBtn'),
	                                    termsText: $scope.htmlContent('offers.subjectToApproval'),
	                                    termsLink: termsLink,
	                                    termsLinkText: $scope.htmlContent('offers.seeTermsText')
	                                };
	                            } else if (creditType === CREDIT_TYPE.EZP) {
	                                return {
	                                    bodyText: $scope.htmlContent('offers.bmlOfferSmallTitleWithAmount', { cartAmount: amount }),
	                                    ctaText: $scope.htmlContent('offers.bmlOfferBtn'),
	                                    termsText: $scope.htmlContent('offers.subjectToApproval')
	                                };
	                            }
	                        } else if (useCase === USE_CASE.REUSE) {
	                            if (creditType === CREDIT_TYPE.CORE) {
	                                return {
	                                    bodyText: $scope.htmlContent('offers.bmlExistingOfferTitle'),
	                                    bodyText2: $scope.htmlContent('offers.bmlExistingOfferSmall'),
	                                    ctaText: $scope.htmlContent('offers.bmlOfferReuseCta'),
	                                    termsLink: termsLink,
	                                    termsLinkText: $scope.htmlContent('offers.seeTermsText')
	                                };
	                            } else if (creditType === CREDIT_TYPE.SAC) {
	                                return {
	                                    bodyText: $scope.htmlContent('offers.bmlExistingOfferTitle'),
	                                    bodyText2: $scope.htmlContent('offers.bmlExistingOfferLarge'),
	                                    ctaText: $scope.htmlContent('offers.bmlOfferReuseCta'),
	                                    termsLink: termsLink,
	                                    termsLinkText: $scope.htmlContent('offers.seeTermsText')
	                                };
	                            } else if (creditType === CREDIT_TYPE.EZP) {
	                                return {
	                                    bodyText: $scope.htmlContent('offers.bmlExistingOfferTitle'),
	                                    bodyText2: $scope.htmlContent('offers.bmlExistingOfferSmall'),
	                                    ctaText: $scope.htmlContent('offers.cycoOfferBtn')
	                                };
	                            }
	                        }
	                    } else if (useCase === USE_CASE.ACQUISITION) {
	                        if (creditType === CREDIT_TYPE.CORE) {
	                            return {
	                                bodyText: $scope.htmlContent('offers.bmlOfferPassiveDetails', { cartAmount: amount }),
	                                ctaText: $scope.htmlContent('offers.bmlOfferPassiveCta'),
	                                termsText: $scope.htmlContent('offers.subjectToApproval'),
	                                termsLink: termsLink,
	                                termsLinkText: $scope.htmlContent('offers.seeTermsText')
	                            };
	                        } else if (creditType === CREDIT_TYPE.SAC) {
	                            return {
	                                bodyText: $scope.htmlContent('offers.bmlOfferPassiveSACDetails', { cartAmount: amount }),
	                                ctaText: $scope.htmlContent('offers.bmlOfferPassiveCta'),
	                                termsText: $scope.htmlContent('offers.subjectToApproval'),
	                                termsLink: termsLink,
	                                termsLinkText: $scope.htmlContent('offers.seeTermsText')
	                            };
	                        } else if (creditType === CREDIT_TYPE.EZP) {
	                            return {
	                                bodyText: $scope.htmlContent('offers.bmlOfferPassiveDetails', { cartAmount: amount }),
	                                ctaText: $scope.htmlContent('offers.bmlOfferPassiveEZPCta'),
	                                termsText: $scope.htmlContent('offers.subjectToApproval')
	                            };
	                        }
	                    }
	                };
	
	                var getReuseOfferInfo = function getReuseOfferInfo(creditType, termsLink, amount) {
	                    if (creditType === CREDIT_TYPE.CORE) {
	                        return {
	                            bodyText: $scope.htmlContent('offers.bmlOfferPassiveDetails', { cartAmount: amount }) + '.',
	                            termsLink: termsLink,
	                            termsLinkText: $scope.htmlContent('offers.seeTermsText')
	                        };
	                    } else if (creditType === CREDIT_TYPE.SAC) {
	                        return {
	                            bodyText: $scope.htmlContent('offers.bmlOfferPassiveSACDetails', { cartAmount: amount }) + '.',
	                            termsLink: termsLink,
	                            termsLinkText: $scope.htmlContent('offers.seeTermsText')
	                        };
	                    } else if (creditType === CREDIT_TYPE.EZP) {
	                        return {
	                            bodyText: $scope.htmlContent('offers.bmlOfferPassiveDetails', { cartAmount: amount }) + '.'
	                        };
	                    }
	                };
	
	                $populate($scope, {
	                    auth: $AuthModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    payee: $CheckoutPayeeModel.instance($scope.token)
	                }).then(function () {
	                    // pxp for banner ramp in UK
	                    return $pxp('xo_hermes_cape_migration_UK', { 'ctx.COUNTRY': $locale.country }, 'xo_cape_migration_UK_test').then(function (result) {
	                        if (result && result.treatment_name === 'xo_cape_migration_UK_test') {
	                            $scope.isUKBannerEligible = true;
	                        }
	                    });
	                }).then(function () {
	                    // pxp for MORS ramp
	                    $scope.isMorsPxpEnabled = false;
	                    $scope.placementCode = '210004';
	                    $scope.presentation_types = ['PayPalCreditCheckout'];
	                    $scope.pu_type = 'PERSONAL';
	
	                    return $pxp('xo_hermes_choice_1stbutton_phase2_ramp', { 'ctx.COUNTRY': $locale.country }, 'xo_hermes_choice_1stbutton_phase2_ramp_treatment').then(function (result) {
	                        if (result && result.treatment_name === 'xo_hermes_choice_1stbutton_phase2_ramp_treatment') {
	                            $scope.isMorsPxpEnabled = true;
	                        }
	                    });
	                }).then(function () {
	                    var morsCallFailed = false;
	
	                    /** --------------------------------------------------
	                     ** Populate credit offers and $scope.showBml
	                     ** -------------------------------------------------- */
	                    $scope.bmlOffer = $scope.checkoutSession.bmlOffer;
	                    $logger.info('bmlOffer: ' + $scope.bmlOffer);
	                    $scope.buyerCountry = $locale.country;
	                    var isCoreSACEligible = $scope.bmlOffer === 1 || $scope.bmlOffer === 2;
	                    var fundingInstruments = $scope.checkoutSession.get('fundingOptions.instruments');
	                    isCreditInWallet = $util.find(fundingInstruments, function (fi) {
	                        return fi.name === 'BILL_ME_LATER';
	                    });
	                    isRedirectFromCape = $CreditDataModel.instance($scope.token).isRedirectFromCape();
	
	                    $scope.checkIfSelectFiDisplayedBanner = function (showBanner) {
	                        var current = $state.current;
	
	
	                        if (showBanner && current.name === 'checkout.selectFi') {
	                            $rootScope.hideBanner = true;
	                        } else if ($rootScope.hideBanner) {
	                            showBanner = false;
	                        }
	                        return showBanner;
	                    };
	
	                    // Banner for US installments and for all banners in UK
	                    var showBannerRules = function showBannerRules() {
	                        if ($locale.country === 'GB') {
	                            $scope.offerTypeKey = $scope.installmentOptionsPresent ? 'offers.bmlInstallmentTitle' : $scope.isBmlOfferSmallOrLarge(ACQ_Banner_Type);
	                            // FPTI tracking
	                            $logger.info('isUkBannerEligible ' + $scope.isUKBannerEligible);
	
	                            if ($scope.isUKBannerEligible && !isCreditInWallet && !isRedirectFromCape && (isCoreSACEligible || $scope.checkoutSession.creditOffer)) {
	                                // UK banner eligible for credit test group
	                                $logger.info('checkout_fpti', {
	                                    'banner_type': 'test_ACQUISITION'
	                                });
	                            } else if (!$scope.isUKBannerEligible && !isCreditInWallet && !isRedirectFromCape && (isCoreSACEligible || $scope.checkoutSession.creditOffer)) {
	                                // UK banner eligible for credit control group (will not see banner)
	                                $logger.info('checkout_fpti', {
	                                    'banner_type': 'control_ACQUISITION'
	                                });
	                            }
	
	                            if ($scope.showUKBanner && !isCreditInWallet && !isRedirectFromCape && (isCoreSACEligible || $scope.checkoutSession.creditOffer)) {
	                                return true;
	                            } else {
	                                return false;
	                            }
	                        } else {
	                            return !isCreditInWallet && $scope.installmentOptionsPresent && !isRedirectFromCape;
	                        }
	                    };
	
	                    // Logic to determine is CYCO is shown in reuse
	                    var showCYCORules = function showCYCORules() {
	                        var commonRules = isCreditInWallet && $scope.checkoutSession.creditOffer && $scope.installmentOptionsPresent;
	                        if ($locale.country === 'GB') {
	                            return $scope.showUKBanner && commonRules;
	                        } else {
	                            return commonRules;
	                        }
	                    };
	
	                    /**
	                     * This function is to determine that the offer is large offer (transaction amount >= 99) or
	                     * smaller (transaction amount < 99) to display appropriate text on ui
	                     * @returns bmlExistingSmall/LargeOffer
	                     */
	                    $scope.isBmlOfferSmallOrLarge = function (bannerType) {
	                        var key = void 0;
	                        if ($scope.isBmlOfferLarge()) {
	                            key = bannerType === ACQ_Banner_Type ? 'offers.bmlOfferLargeTitle' : 'offers.bmlExistingOfferLarge';
	                        } else {
	                            key = bannerType === ACQ_Banner_Type ? 'offers.bmlOfferSmallTitle' : 'offers.bmlExistingOfferSmall';
	                        }
	                        return key;
	                    };
	
	                    // small refactor of isBmlOfferSmallOrLarge() function
	                    $scope.isBmlOfferLarge = function () {
	                        var transactionAmount = $scope.getTransactionAmount();
	                        var sacEligibleAmount = $CreditOptionsModel.sacEligibleAmount[$locale.country];
	                        return transactionAmount >= sacEligibleAmount;
	                    };
	
	                    $scope.getTransactionAmount = function () {
	                        var transactionAmount = $scope.checkoutCart.get('purchase.amounts.total.amount');
	                        return parseFloat(transactionAmount) || 0;
	                    };
	
	                    // override bmlOffer
	                    if ($scope.buyerCountry === 'US') {
	                        if ($scope.isBmlOfferLarge()) {
	                            $scope.bmlOffer = 1;
	                        } else {
	                            $scope.bmlOffer = 2;
	                        }
	
	                        $scope.installment.bmlOffer = $scope.bmlOffer;
	                    }
	
	                    var executeSsotCall = function executeSsotCall(silent) {
	                        if ($feature('creditInstallmentOffers') && $scope.checkoutAppData.merchant.merchant_country === $locale.country && !$scope.checkoutCart.isBilling()) {
	
	                            var processInstallmentResponse = function processInstallmentResponse(result) {
	                                $scope.creditOffers = result.installments && result.installments[0];
	                                $scope.installmentCount = $scope.creditOffers && $scope.creditOffers.installment_options && $scope.creditOffers.installment_options.length;
	                                $scope.installmentOptionsPresent = $scope.installment.installmentOptionsPresent = $scope.checkoutSession.creditOffer && $scope.installmentCount > 0;
	                                $scope.showUKBanner = $scope.checkoutAppData.is_second_button_txn || $scope.isUKBannerEligible;
	
	                                if ($scope.buyerCountry === 'US') {
	                                    $scope.installment.showBanner = $scope.checkIfSelectFiDisplayedBanner(showBannerRules());
	                                    $scope.installment.showWalletBanner = showBannerRules();
	                                } else {
	                                    $scope.installment.showBanner = showBannerRules();
	                                }
	
	                                $scope.installment.showCYCO = showCYCORules();
	                                var hideSacBanner = $scope.installment.showBanner || isRedirectFromCape || $locale.country === 'GB';
	                                $scope.showBml = hideSacBanner ? false : isCoreSACEligible;
	                            };
	
	                            // Cache the installment offer call to prevent duplicate calls in the same session
	                            $rootScope.instCache = $rootScope.instCache || {};
	                            var instCacheId = '' + $scope.checkoutSession.id;
	                            var cachedInst = $rootScope.instCache[instCacheId];
	
	                            if (cachedInst) {
	                                return $q(function (resolve) {
	                                    return resolve(processInstallmentResponse(cachedInst));
	                                });
	                            } else {
	                                var offers = $InstallmentOptionsModel.instance($scope.token);
	                                return offers.save({
	                                    silent: silent,
	                                    data: {
	                                        payee: $scope.payee,
	                                        checkoutCart: $scope.checkoutCart,
	                                        checkoutAppData: $scope.checkoutAppData,
	                                        isMemberCredit: true
	                                    },
	                                    success: function success(result) {
	                                        processInstallmentResponse(result);
	                                        $rootScope.instCache[instCacheId] = result;
	                                    },
	                                    contingencies: {
	                                        DEFAULT: function DEFAULT() {
	                                            $logger.info('GET_INSTALLMENT_CONTINGENCY');
	                                        }
	                                    }
	                                });
	                            }
	                        } else {
	                            return $q(function (resolve) {
	                                var hideSacBanner = isRedirectFromCape || $locale.country === 'GB';
	                                $scope.showBml = hideSacBanner ? false : isCoreSACEligible;
	                                resolve();
	                            });
	                        }
	                    };
	
	                    /** --------------------------------------------------
	                     ** Call MORS for banner
	                     ** -------------------------------------------------- */
	
	                    $scope.creditTerms = $config.urls.creditTerms;
	                    $scope.creditReuseTerms = $config.urls.creditReuseTerms;
	
	                    var mapResponseToBanner = function mapResponseToBanner(ad) {
	                        var formatBannerField = function formatBannerField(content) {
	                            if (angular.isString(content)) {
	                                // Ensure "PayPal Credit" does not wrap
	                                content = $sce.trustAsHtml(content.replace(/PayPal Credit/g, '<span class="nowrap">PayPal Credit</span>'));
	                            }
	
	                            return content;
	                        };
	
	                        var getMorsOfferType = function getMorsOfferType(offerType) {
	                            if (offerType === 'CORE') {
	                                return CREDIT_TYPE.CORE;
	                            }
	                            if (offerType === 'SAC') {
	                                return CREDIT_TYPE.SAC;
	                            }
	                            if (offerType === 'PALA') {
	                                return CREDIT_TYPE.EZP;
	                            }
	                            $logger.warn('unknown_credit_type');
	                        };
	
	                        $scope.showPassiveBanner = ad['MessageType'] !== 'Prominent';
	                        $scope.banner.offerType = getMorsOfferType(ad['offertype']);
	
	                        if (!$scope.showPassiveBanner) {
	                            $scope.banner.bodyText = formatBannerField(ad['OfferText1']);
	                            $scope.banner.bodyText2 = formatBannerField(ad['OfferText2']);
	                            $scope.banner.logo = ad['Logo'];
	                            $scope.banner.ctaText = formatBannerField(ad['CTAText']);
	                            $scope.banner.termsText = formatBannerField(ad['TermsText']);
	                            $scope.banner.termsLink = ad['TermsLink'];
	                            $scope.banner.termsLinkText = ad['TermsLinkText'];
	                        } else {
	                            $scope.banner.ctaText = formatBannerField(ad['OfferText1']);
	                            $scope.banner.bodyText = formatBannerField(ad['OfferText2']);
	                            $scope.banner.logo = ad['Logo'];
	                            $scope.banner.termsText = formatBannerField(ad['TermsText']);
	                            $scope.banner.termsLink = ad['TermsLink'];
	                            $scope.banner.termsLinkText = ad['TermsLinkText'];
	                        }
	                    };
	
	                    var getCreditType = function getCreditType(bmlOffer, isInst) {
	                        // Check if there is an offer already selected
	                        var instModel = $CreditInstallmentModel.instance($scope.token);
	
	                        if (instModel && instModel.creditType === CREDIT_TYPE.SAC) {
	                            return CREDIT_TYPE.SAC;
	                        } else if (isInst) {
	                            return CREDIT_TYPE.EZP;
	                        } else if (bmlOffer === 1) {
	                            return CREDIT_TYPE.SAC;
	                        } else if (bmlOffer === 2) {
	                            return CREDIT_TYPE.CORE;
	                        }
	                        $logger.warn('unknown_credit_type');
	                    };
	
	                    var mapDefaultToBanner = function mapDefaultToBanner(creditReuseTerms, creditTerms) {
	                        $scope.useFallbackBanner = true;
	                        $scope.showPassiveBanner = !isCreditInWallet;
	
	                        $scope.banner = getDefaultBanner($scope.showPassiveBanner ? BANNER_TYPES.PASSIVE : BANNER_TYPES.PROMINENT, isCreditInWallet ? USE_CASE.REUSE : USE_CASE.ACQUISITION, getCreditType($scope.bmlOffer, $scope.installmentOptionsPresent), $scope.checkoutCart.get('purchase.amounts.total.amount_formatted', ''), isCreditInWallet ? creditReuseTerms : creditTerms);
	                    };
	
	                    var mapReuseText = function mapReuseText(creditReuseTerms) {
	                        $scope.reuseOfferInfo = getReuseOfferInfo(getCreditType($scope.bmlOffer, $scope.installmentOptionsPresent), creditReuseTerms, $scope.checkoutCart.get('purchase.amounts.total.amount_formatted', ''));
	                    };
	
	                    var shouldCallMors = $scope.isMorsPxpEnabled && $locale.country === 'US' && $locale.lang === 'en' && $scope.placementCode;
	
	                    var executeMorsCall = function executeMorsCall(silent) {
	                        $rootScope.MORS = $rootScope.MORS || {};
	                        $scope.banner = {};
	                        var morsCacheId = $scope.checkoutSession.id + '-' + $scope.placementCode + '-' + !!isCreditInWallet + '-' + getCreditType($scope.bmlOffer, $scope.installmentOptionsPresent);
	                        var cachedAd = $rootScope.MORS[morsCacheId];
	
	                        if (cachedAd !== undefined) {
	                            return $q(function (resolve) {
	                                if (cachedAd === null) {
	                                    morsCallFailed = true;
	                                    resolve(mapDefaultToBanner($scope.creditReuseTerms, $scope.creditTerms));
	                                } else {
	                                    $scope.ad = cachedAd;
	                                    resolve(mapResponseToBanner(cachedAd));
	                                }
	                            });
	                        } else {
	                            // Get wallet instruments
	                            var walletInstruments = [];
	
	                            if (isCreditInWallet) {
	                                walletInstruments.push({
	                                    financial_instrument_type: 'FI_PAYPAL_CREDIT',
	                                    financial_instrument_product_type: 'PI_TYPE_CREDIT_TXN_CARD_BML',
	                                    preferred: isCreditInWallet.isPreferred,
	                                    out_of_wallet: false
	                                });
	                            }
	
	                            $scope.marketingOfferModel = new $MarketingOfferModel({
	                                countryCode: $locale.country,
	                                page: 'HERMES_RYI_PAGE',
	                                site: 'HERMES_RYI_PAGE',
	                                puType: $scope.pu_type,
	                                locale: $locale.lang + '_' + $locale.country,
	                                totalTransactionAmount: {
	                                    'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
	                                    'value': $scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100
	                                },
	                                totalShippingAmount: {
	                                    'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
	                                    'value': $scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100
	                                },
	                                payee: $scope.payee.merchant.id || '',
	                                payer: $scope.checkoutSession.payer.id || '',
	                                si: $scope.checkoutSession.id || '',
	                                targetPlacements: [{
	                                    'placement_code': $scope.placementCode,
	                                    'presentation_types': $scope.presentation_types
	                                }],
	                                walletInstruments: walletInstruments,
	                                installmentsNotAllowed: !$scope.checkoutSession.creditOffer
	                            });
	
	                            return $MarketingOfferModel.instance($scope.token).save({
	                                silent: silent,
	                                data: $scope.marketingOfferModel.serialize(),
	                                success: function success(result) {
	                                    $logger.info('MORS_response', result);
	                                    var ads_arr = result && result.ads || [];
	                                    var adFound = false;
	
	                                    // MORS could serve multiple ads for a given page. Iterate to get the
	                                    // correct one based on the ad placement_id
	                                    ads_arr.forEach(function (ad) {
	                                        var adunit_id = ad.campaign.adunit_id;
	
	                                        if (adunit_id.toString() === $scope.placementCode.toString() && ad.valid) {
	                                            adFound = true;
	                                            $scope.ad = {};
	                                            var content = ad.content.nvp;
	                                            content.forEach(function (obj) {
	                                                $scope.ad[obj.name] = obj.value;
	                                            });
	                                            $scope.ad['impressionUrl'] = ad.tracking.impression_url;
	                                            $scope.ad['clickUrl'] = ad.tracking.click_url;
	                                            $scope.ad['campaignId'] = ad.campaign.campaign_id;
	                                        }
	                                    });
	                                    if (adFound) {
	                                        mapResponseToBanner($scope.ad);
	
	                                        // Cache ad
	                                        $rootScope.MORS[morsCacheId] = $scope.ad;
	                                    } else {
	                                        $logger.info('MORS_ad_not_found_credit');
	                                        $rootScope.$broadcast('MORSNotDisplayed');
	                                        $rootScope.MORS[morsCacheId] = null;
	                                        morsCallFailed = true;
	                                    }
	                                },
	
	                                error: function error(err) {
	                                    $logger.error('MORS_api_failure_credit', { error: err });
	                                    $rootScope.MORS[morsCacheId] = null;
	                                    morsCallFailed = true;
	                                }
	                            });
	                        }
	                    };
	
	                    // Don't make SSOT call if MORS is being called, unless it fails
	                    if (shouldCallMors) {
	                        return executeMorsCall(true)['finally'](function () {
	                            if (morsCallFailed) {
	                                return executeSsotCall(true).then(function () {
	                                    mapReuseText($scope.creditReuseTerms);
	                                    mapDefaultToBanner($scope.creditReuseTerms, $scope.creditTerms);
	                                });
	                            } else {
	                                // Process installment response separately
	                                $scope.showBml = !isRedirectFromCape && isCoreSACEligible;
	
	                                $scope.installmentOptionsPresent = $scope.installment.installmentOptionsPresent = $scope.banner.offerType === CREDIT_TYPE.EZP;
	                                var showInstBanner = $scope.installmentOptionsPresent && !isCreditInWallet && !isRedirectFromCape;
	                                $scope.installment.showBanner = $scope.checkIfSelectFiDisplayedBanner(showInstBanner);
	                                $scope.installment.showWalletBanner = showInstBanner;
	                                $scope.installment.showCYCO = isCreditInWallet && $scope.checkoutSession.creditOffer && $scope.banner.offerType === CREDIT_TYPE.EZP;
	
	                                mapReuseText($scope.creditReuseTerms);
	                            }
	                        });
	                    } else {
	                        return executeSsotCall(false);
	                    }
	                }).then(function () {
	                    var fpIsCreditInWallet = $scope.checkoutSession.get('futurePayment.isCreditInWallet');
	
	                    $scope.selectExistingBml = function () {
	                        if ($scope.isMorsPxpEnabled && $scope.ad) {
	                            $fireMORSBeacon.fireBeacon($scope.ad.clickUrl);
	                        }
	
	                        if ($scope.checkoutCart.isBillingNoPurchase()) {
	                            var fpList = $scope.checkoutSession.get('futurePaymentInstruments');
	                            var bml = fpList.find(function (fp) {
	                                return fp.type === 'BILL_ME_LATER';
	                            });
	
	                            $scope.checkoutSession.action('setStickyFI', {
	                                data: {
	                                    instrument_id: bml.instrument_id
	                                },
	                                success: function success(result) {
	                                    $scope.checkoutSession.message = {
	                                        type: 'success',
	                                        msgKeys: ['paymentMethod.paymentMethodUpdated']
	                                    };
	                                    $state.go('checkout.review');
	                                }
	                            });
	                        } else {
	                            var fiList = $scope.checkoutSession.get('fundingOptions.instruments');
	                            var fundingSource = $util.find(fiList, function (fi) {
	                                return fi.name === 'BILL_ME_LATER';
	                            });
	
	                            $scope.checkoutSession.fundingOptions.action('select', {
	                                resultModel: $scope.checkoutSession,
	                                data: {
	                                    planId: fundingSource.planId
	                                },
	                                success: function success(result) {
	                                    // Update selectedmethod if provided, to reflect in multipleFi on RYI choice variant
	                                    if ($scope.selectedmethod) {
	                                        $scope.selectedmethod.index = 0;
	                                        $scope.selectedmethod.planId = $scope.checkoutSession.get('plan.sources')[0].id;
	                                    }
	
	                                    if (result) {
	                                        // Update the installments to support the user selecting a card that does not support installments.
	                                        $scope.checkoutSession.installments = result.installments;
	                                    }
	                                    if (fundingSource.type === 'CREDIT' && $scope.installment.showCYCO) {
	                                        $state.go('checkout.chooseCreditOffer');
	                                    } else {
	                                        if (!fundingSource.selected) {
	                                            $scope.checkoutSession.message = {
	                                                type: 'success',
	                                                msgKeys: ['paymentMethod.paymentMethodUpdated']
	                                            };
	                                            if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
	                                                // Resetting selected installment data, if installment change is not explicitly prohibited.
	                                                $scope.checkoutSession.selectedInstallmentData = undefined;
	                                            }
	                                        }
	                                        $state.go('checkout.review');
	                                    }
	                                }
	                            });
	                        }
	                    };
	
	                    $scope.getBmlOfferTitle = function (suffix, data) {
	                        if ($scope.bmlOffer === 1) {
	                            return $scope.htmlContent('offers.bmlOfferLargeTitle' + suffix, data);
	                        } else if ($scope.bmlOffer === 2) {
	                            return $scope.htmlContent('offers.bmlOfferSmallTitle' + suffix, data);
	                        } else {
	                            return '';
	                        }
	                    };
	
	                    if ($scope.buyerCountry === 'US') {
	                        $scope.bmlOfferTitle = $scope.getTransactionAmount() === 0 ? $scope.htmlContent('offers.bmlOfferTitleWithAmountZero') : $scope.getBmlOfferTitle('WithAmount', {
	                            cartAmount: $scope.checkoutCart.get('purchase.amounts.total.amount_formatted', '')
	                        });
	
	                        // US766704: for use in xo-wallet
	                        $scope.installment.bmlOfferTitle = $scope.bmlOfferTitle;
	                    }
	
	                    $scope.showAcquisitionBanner = function () {
	                        var showBanner = void 0;
	
	                        showBanner = $scope.showBml && $scope.buyerCountry !== 'GB';
	
	                        // Combine acquisition banner and installment banner logic
	                        // TODO: Refactor all of this after control is removed - there needs to be clear separation between
	                        // countries, and installment acquisition banner logic should be in this function
	                        if ($scope.isMorsPxpEnabled) {
	                            showBanner = showBanner || $scope.installment.showBanner;
	                        }
	
	                        showBanner = $scope.checkIfSelectFiDisplayedBanner(showBanner);
	
	                        if (!$scope.usCreditBannerFptiFired && showBanner && $scope.isMorsPxpEnabled && $scope.banner && $scope.buyerCountry === 'US') {
	                            $scope.usCreditBannerFptiFired = true;
	
	                            if ($scope.ad) {
	                                $logger.info('checkout_fpti', {
	                                    'banner_type': USE_CASE.ACQUISITION + '_' + $scope.ad['MessageType'] + '_MORS',
	                                    'caid': $scope.ad['campaignId']
	                                });
	                                $logger.info('MORS_ad_displayed_credit_' + USE_CASE.ACQUISITION + '_' + $scope.ad['MessageType']);
	
	                                $fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);
	
	                                $rootScope.$broadcast('MORSDisplayed', {
	                                    clickUrl: $scope.ad.clickUrl,
	                                    placementId: $scope.placementCode
	                                });
	                            } else {
	                                $logger.info('checkout_fpti', {
	                                    'banner_type': USE_CASE.ACQUISITION + '_' + BANNER_TYPES.PASSIVE + '_MORSfallback'
	                                });
	                                $logger.info('MORS_fallback_ad_displayed_credit_' + USE_CASE.ACQUISITION + '_' + BANNER_TYPES.PASSIVE);
	                            }
	                        }
	
	                        return showBanner;
	                    };
	
	                    /**
	                     * Only show PPC Reuse banner if
	                     * Country is US & Credit is not default AND There is credit in wallet AND pxp variant has banner
	                     **/
	                    $scope.showReuseBanner = function () {
	                        var showBanner = false;
	                        var reuseRules = true;
	                        if ($scope.checkoutCart.isBillingNoPurchase()) {
	                            var stickyFi = $scope.checkoutSession.getSelectedStickyInstrument();
	                            reuseRules = fpIsCreditInWallet && !(stickyFi.type === 'BILL_ME_LATER');
	                        } else {
	                            $scope.isCreditDefault = $scope.checkoutSession.get('plan.paypal_credit');
	                            reuseRules = isCreditInWallet && !$scope.isCreditDefault;
	                        }
	                        $scope.installment.showRepresentativeInfo = $scope.showUKBanner && $locale.country === 'GB' && (reuseRules || $scope.installment.showBanner);
	                        $scope.showPPCLogo = true;
	
	                        // FPTI tracking
	                        if (!$scope.fptiTrigger) {
	                            if ($scope.isUKBannerEligible && $locale.country === 'GB' && reuseRules) {
	                                // UK reuse banner eligible for credit test group (will see banner)
	                                $logger.info('checkout_fpti', {
	                                    'banner_type': 'test_REUSE'
	                                });
	                                $scope.fptiTrigger = true;
	                            } else if (!$scope.isUKBannerEligible && $locale.country === 'GB' && reuseRules) {
	                                // UK reuse banner eligible for credit control (will not see banner)
	                                $logger.info('checkout_fpti', {
	                                    'banner_type': 'control_REUSE'
	                                });
	                                $scope.fptiTrigger = true;
	                            }
	                        }
	
	                        if ($locale.country === 'US' && reuseRules && !(isRedirectFromCape && isCreditInWallet)) {
	                            showBanner = true;
	                        } else if ($scope.showUKBanner && $locale.country === 'GB' && reuseRules) {
	                            $scope.reuseOfferTypeKey = $scope.installmentOptionsPresent ? 'offers.bmlExistingOfferInstallment' : $scope.isBmlOfferSmallOrLarge();
	                            return true;
	                        }
	                        showBanner = $scope.checkIfSelectFiDisplayedBanner(showBanner);
	
	                        if (!$scope.usCreditBannerFptiFired && showBanner && $scope.isMorsPxpEnabled && $scope.banner && $scope.buyerCountry === 'US') {
	                            $scope.usCreditBannerFptiFired = true;
	
	                            if ($scope.ad) {
	                                $logger.info('checkout_fpti', {
	                                    'banner_type': USE_CASE.REUSE + '_' + $scope.ad['MessageType'] + '_MORS',
	                                    'caid': $scope.ad['campaignId']
	                                });
	                                $logger.info('MORS_ad_displayed_credit_' + USE_CASE.REUSE + '_' + $scope.ad['MessageType']);
	
	                                $fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);
	
	                                $rootScope.$broadcast('MORSDisplayed', {
	                                    clickUrl: $scope.ad.clickUrl,
	                                    placementId: $scope.placementCode
	                                });
	                            } else {
	                                $logger.info('checkout_fpti', {
	                                    'banner_type': USE_CASE.REUSE + '_' + BANNER_TYPES.PASSIVE + '_MORSfallback'
	                                });
	                                $logger.info('MORS_fallback_ad_displayed_credit_' + USE_CASE.REUSE + '_' + BANNER_TYPES.PASSIVE);
	                            }
	                        }
	
	                        return showBanner;
	                    };
	
	                    $scope.bml = function () {
	                        if ($scope.isMorsPxpEnabled) {
	                            // TODO: Deprecate creditOffer() - installment should not be a different banner
	                            if ($scope.ad) {
	                                $fireMORSBeacon.fireBeacon($scope.ad.clickUrl);
	                            }
	
	                            if ($scope.installment.showBanner) {
	                                $state.go('checkout.chooseCreditOffer');
	                            } else {
	                                $state.go('checkout.redirectToCape');
	                            }
	                        } else {
	                            $state.go('checkout.redirectToCape');
	                        }
	                    };
	
	                    $scope.creditOffer = function () {
	                        $state.go('checkout.chooseCreditOffer');
	                    };
	
	                    $scope.addPlcc = function () {
	                        $scope.promotion.type = 'plcc';
	                        $state.go('checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard');
	                    };
	
	                    $scope.showPlcc = $scope.checkoutSession.plccOffer;
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/offer/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"offerForm\" action=\"#\" method=\"POST\" class=\"offer\"  content>\n\n    <div id=\"bmlReuseOfferInfo\" ng-if=\"isMorsPxpEnabled && reusetext\">\n        <span class=\"offerInfo ng-binding ng-scope\" ng-bind-html=\"reuseOfferInfo.bodyText\"></span>\n        <span class=\"seeTermsLink ng-scope\">\n            <a href='{{reuseOfferInfo.termsLink}}'\n               class='popup bmlTermsLink' target='_blank'\n               xo-popup>{{reuseOfferInfo.termsLinkText}}</a>\n        </span>\n    </div>\n\n    <div ng-if=\"!reusetext\">\n        <!-- Begin MORS PXP treatment -->\n        <div id=\"bmlAcqOfferPassive\" class=\"payWithOption passiveBanner creditBanner\"\n             ng-if=\"isMorsPxpEnabled && showPassiveBanner && banner.bodyText && showAcquisitionBanner()\">\n            <span class=\"plusicon\" ng-click=\"bml()\" track-link=\"acquisition_offer_banner_MORS\" role=\"button\"></span>\n            <div class=\"payWithOptionBody\">\n                <div class=\"payWithOptionIcon\" ng-click=\"bml()\" track-link=\"acquisition_offer_banner_MORS\" role=\"button\">\n                    <span class=\"fsIcon BILL_ME_LATER\" ng-if=\"useFallbackBanner\"></span>\n                    <img ng-src=\"{{banner.logo}}\" ng-if=\"!useFallbackBanner\" />\n                </div>\n                <div class=\"payWithOptionContent\">\n                    <div><a link-button ng-click=\"bml()\" class=\"name proceed\" ng-bind-html=\"banner.ctaText\" track-link=\"acquisition_offer_banner_MORS\"></a></div>\n                    <div><span class=\"payWithOptionDetails\" ng-bind-html=\"banner.bodyText\"></span></div>\n                    <div>\n                        <span class=\"payWithOptionTerms\" ng-bind-html=\"banner.termsText\"></span>\n                        <a href=\"{{banner.termsLink}}\"\n                           class=\"popup payWithOptionTermsLink\"\n                           target='_blank'\n                           ng-bind-html=\"banner.termsLinkText\"\n                           track-link=\"acquisition_offer_banner_MORS_terms_link\"></a>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div id=\"bmlAcqOfferProminent\" class=\"prominentBanner creditBanner\" ng-if=\"isMorsPxpEnabled && !showPassiveBanner && banner.bodyText && showAcquisitionBanner()\">\n            <div class=\"prominentBannerSeparator\">\n                <span class=\"prominentBannerSeparatorLine\"></span>\n                <span class=\"prominentBannerSeparatorWord\" ng-bind-html=\"htmlContent('common.or')\"></span>\n            </div>\n            <div class=\"bmlCtaWrap\">\n                <span class=\"bmlApplyLink\">\n                    <a link-button ng-click=\"bml()\" class=\"proceed\" ng-bind-html=\"banner.ctaText\" track-link=\"acquisition_offer_banner_MORS\"></a>\n                </span>\n                <div class=\"acquisitionBannerLeft\">\n                    <div class=\"prominentBannerIcon\">\n                        <span class=\"creditIcon\" ng-if=\"useFallbackBanner\"></span>\n                        <img ng-src=\"{{banner.logo}}\" ng-if=\"!useFallbackBanner\" />\n                    </div>\n                </div>\n                <div class=\"acquisitionBannerRight\">\n                    <p class=\"bmlOfferTitle\" ng-bind-html=\"banner.bodyText\"></p>\n                    <p class=\"bmlSeeTerms offerSmallText\">\n                        <span class=\"seeTermsLink ng-scope\" ng-bind-html=\"banner.termsText\"></span>\n                        <a href='{{banner.termsLink}}'\n                           class='popup bmlTermsLink'\n                           target='_blank'\n                           ng-bind-html=\"banner.termsLinkText\"\n                           track-link=\"acquisition_offer_banner_MORS_terms_link\"\n                           xo-popup></a>\n                    </p>\n                </div>\n                <div class=\"clearfix\"></div>\n            </div>\n        </div>\n\n        <div id=\"bmlExistingOfferProminent\" class=\"prominentBanner creditBanner\" ng-if=\"(buyerCountry === 'US' && isMorsPxpEnabled) && banner.bodyText && showReuseBanner()\">\n            <div class=\"prominentBannerSeparator\">\n                <span class=\"prominentBannerSeparatorLine\"></span>\n                <span class=\"prominentBannerSeparatorWord\" ng-bind-html=\"htmlContent('common.or')\"></span>\n            </div>\n            <div class=\"bmlCtaWrap\">\n                <div class=\"prominentBannerIcon\">\n                    <span class=\"creditIcon\" ng-if=\"useFallbackBanner\"></span>\n                    <img ng-src=\"{{banner.logo}}\" ng-if=\"!useFallbackBanner\" />\n                </div>\n                <span class=\"bmlChangeLink\">\n                    <a track-link=\"reuse_offer_banner_MORS\" link-button ng-click=\"selectExistingBml()\" class=\"proceed\"\n                       ng-bind-html=\"banner.ctaText\"></a>\n                </span>\n                <p class=\"bmlExistingOfferTitle\" ng-bind-html=\"banner.bodyText\"></p>\n\n                <p class=\"bmlSeeTerms offerSmallText\">\n                    <span class=\"clearfix bmlExistingOfferText\"\n                          ng-bind-html=\"banner.bodyText2\"></span>\n                    <span class=\"seeTermsLink ng-scope\">\n                        <a href='{{creditReuseTerms}}'\n                           class='popup bmlTermsLink'\n                           target='_blank'\n                           ng-bind-html=\"banner.termsLinkText\"\n                           track-link=\"reuse_offer_banner_MORS_terms_link\"\n                           xo-popup></a>\n                    </span>\n                </p>\n\n            </div>\n        </div>\n        <!-- // End MORS PXP treatment -->\n\n        <!-- Begin MORS PXP control & UK banners -->\n        <div id=\"installmentOffer\" class=\"bmlCtaWrap prominentBanner creditBanner\" ng-if=\"((buyerCountry === 'US' && !isMorsPxpEnabled) || buyerCountry === 'GB') && installment.showBanner\">\n            <div class=\"trayInner\">\n                <div class=\"acquisitionBannerLeft\">\n                    <div class=\"creditIcon\"> </div>\n                </div>\n                <div class=\"clearfix\"></div>\n                    <span class=\"cycoApplyLink\" ng-if=\"buyerCountry === 'GB'\">\n                        <a track-link=\"acquisition_offer_banner\" link-button ng-click=\"creditOffer()\" class=\"proceed apply_uk_credit\">{{content('offers.bmlOfferBtn')}}\n                            <span class=\"frontArrow goTray\"></span>\n                        </a>\n                    </span>\n                    <span class=\"cycoApplyLink\" ng-if=\"buyerCountry !== 'GB'\">\n                        <a track-link=\"acquisition_offer_banner\" link-button ng-click=\"creditOffer()\" class=\"proceed apply_us_credit\">{{content('offers.cycoOfferBtn')}}\n                            <span class=\"frontArrow goTray\"></span>\n                        </a>\n                    </span>\n                <div class=\"offerText\">\n                    <p ng-if=\"offerTypeKey\"\n                       ng-bind-html=\"htmlContent(offerTypeKey,{monthlyPayment: creditOffers.installment_options[installmentCount -1].monthlyPayment.formattedAmt, term:creditOffers.installment_options[installmentCount -1].term,\n                       cartAmount:checkoutCart.get('purchase.amounts.total.amount_formatted')})\"></p>\n                    <p ng-if=\"(!offerTypeKey || checkoutCart.isBilling()) && buyerCountry === 'GB'\"\n                       ng-bind-html=\"htmlContent('offers.bmlOfferNoCart')\"></p>\n                    <p ng-if=\"!offerTypeKey && buyerCountry !== 'GB'\"\n                        ng-bind-html=\"htmlContent('offers.bmlOfferSmallTitle')\"></p>\n                </div>\n                <p ng-if=\"buyerCountry !=='GB'\" class=\"bmlSeeTerms offerSmallText\">\n                    <span class=\"ng-scope\">{{content('applyForBml.subjectApproval')}}</span>\n                </p>\n            </div>\n        </div>\n\n        <div id=\"bmlOffer\" class=\"bmlCtaWrap prominentBanner creditBanner\" ng-if=\"!isMorsPxpEnabled && showAcquisitionBanner()\">\n            <div class=\"trayInner\">\n                <div class=\"acquisitionBannerLeft\">\n                    <div class=\"creditIcon\"/>\n                </div>\n                <div class=\"acquisitionBannerRight\">\n                    <p class=\"bmlOfferTitle\" ng-bind-html=\"bmlOfferTitle\"></p>\n                    <p class=\"bmlSeeTerms offerSmallText\">\n                        <span class=\"seeTermsLink ng-scope\">{{content('applyForBml.subjectApproval')}} <a\n                                href='{{creditTerms}}'\n                                class='popup bmlTermsLink' target='_blank'\n                                xo-popup>{{content('applyForBml.seeTerms')}}</a></span>\n                    </p>\n                </div>\n                <div class=\"clearfix\"></div>\n                <span class=\"bmlApplyLink\">\n                    <a link-button ng-click=\"bml()\" class=\"proceed\">{{content('offers.bmlOfferBtn')}}</a>\n                </span>\n            </div>\n        </div>\n\n        <div id=\"bmlExistingOffer\" class=\"bmlCtaWrap prominentBanner creditBanner\" ng-if=\"((buyerCountry === 'US' && !isMorsPxpEnabled) || buyerCountry === 'GB') && showReuseBanner()\">\n            <div class=\"trayInner\">\n                <div class=\"creditIcon\"/>\n                <p class=\"bmlExistingOfferTitle\" ng-bind-html=\"htmlContent('offers.bmlExistingOfferTitle')\"></p>\n\n                <span class=\"bmlChangeLink\">\n                    <a track-link=\"reuse_offer_banner\" link-button ng-click=\"selectExistingBml()\" class=\"proceed\">{{content('common.select')}}</a>\n                </span>\n\n                <p class=\"bmlSeeTerms offerSmallText\">\n                    <span ng-if=\"buyerCountry !=='GB'\" class=\"clearfix bmlExistingOfferText\"\n                          ng-bind-html=\"htmlContent(isBmlOfferSmallOrLarge())\"></span>\n                    <span ng-if=\"buyerCountry ==='GB'\" class=\"clearfix bmlExistingOfferText\"\n                          ng-bind-html=\"htmlContent(reuseOfferTypeKey,{monthlyPayment: creditOffers.installment_options[installmentCount -1].monthlyPayment.formattedAmt, term:creditOffers.installment_options[installmentCount -1].term})\"></span>\n                    <span ng-if=\"buyerCountry !=='GB'\" class=\"seeTermsLink ng-scope\"><a href='{{creditReuseTerms}}'\n                                                                                        class='popup bmlTermsLink'\n                                                                                        target='_blank'\n                                                                                        xo-popup>{{content('applyForBml.seeTerms')}}</a></span>\n                </p>\n\n            </div>\n        </div>\n        <!-- // End MORS PXP control -->\n\n        <div id=\"plccOffer\" class=\"bmlCtaWrap\" ng-if=\"showPlcc\">\n            <div class=\"trayInner\">\n                <div class=\"plccOfferHeader\">\n                    <img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n                    <p class=\"headerText\"> {{ content('offers.plccCardOfferHeader',{ merchantName:promotion.name}) }}</p>\n                    <span class=\"plccAddNowLink\">\n                        <a link-button ng-click=\"addPlcc()\" class=\"proceed\">{{content('offers.plccAddNowLink')}}</a>\n                    </span>\n                    <p class=\"plccOfferDesc\">{{ content('offers.plccCardOfferDesc',{merchantName:promotion.name}) }}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-member-components/src/review-paywith/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	__webpack_require__("./components/xo-wallet-components/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	__webpack_require__("./components/xo-credit-components/src/pay-with-credit/directive.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-member-components/src/preferred-checkbox/directive.js");
	
	var _pxp = __webpack_require__("./components/xo-page-components/src/cart/lib/pxp.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _template = __webpack_require__("./components/xo-member-components/src/review-paywith/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// <pay-with-credit>
	// <xo-tooltip>
	(0, _angular.$registerDirective)('xo-review-paywith', function () {
	    return {
	        template: _template2['default'],
	        restrict: 'E',
	        scope: {
	            token: '=',
	            showBmlPopup: '=',
	            installmentNotSelected: '=',
	            payButtonText: '=',
	            installment: '=',
	            padToggleFeature: '=',
	            selectedmethod: '=',
	            makeFiPreferred: '=',
	            selectFiVariant: '='
	        },
	
	        controller: function controller($scope, $rootScope) {
	
	            $scope.locale = _squid.$locale;
	            $scope.formatCurrency = _squid.formatCurrency;
	
	            // check for feature enabled in config/inc/ui.json for AU country
	            // this feature is there only in country AU as of June 29th, 2015
	            $scope.showUachFeatureDiscalimer = false;
	
	            (0, _squid.$populate)($scope, {
	                checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token),
	                checkoutCart: _checkout.$CheckoutCartModel.instance($scope.token),
	                checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token),
	                payee: _checkout.$CheckoutPayeeModel.instance($scope.token)
	            }).then(function () {
	
	                // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
	                // are not available and purchase amount is not zero.
	                var userAction = $scope.checkoutAppData.useraction();
	                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && $scope.checkoutCart.get('purchase.items.length', 0) === 0;
	
	                return (0, _pxp.$pxpCartAmt)($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
	                    $scope.showAmt = $scope.checkoutCart.get('payment_action') !== 'authorize' && showAmount;
	                });
	            }).then(function () {
	                // pxp for MORS ramp
	                $scope.isMorsPxpEnabled = false;
	                return (0, _squid.$pxp)('xo_hermes_choice_1stbutton_phase2_ramp', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermes_choice_1stbutton_phase2_ramp_treatment').then(function (result) {
	                    if (result && result.treatment_name === 'xo_hermes_choice_1stbutton_phase2_ramp_treatment') {
	                        $scope.isMorsPxpEnabled = true;
	                    }
	                });
	            }).then(function () {
	                var merchant = $scope.checkoutAppData.merchant;
	                $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	
	                $scope.sacEligible = function (fsType) {
	                    if (fsType !== 'BILL_ME_LATER') {
	                        return false;
	                    }
	
	                    var total = $scope.checkoutCart.get('purchase.amounts.total');
	                    if (total && !$scope.installment.showCYCO && parseFloat(total.amount) >= _checkout.$CreditOptionsModel.sacEligibleAmount[_squid.$locale.country]) {
	                        return true;
	                    }
	                };
	
	                var isBilling = $scope.checkoutCart.isBilling();
	                var isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
	                var disableStickyForMerchant = _squid.$config.disableMerchantForStickyBA.indexOf($scope.payee.merchant.id) > -1;
	                var stickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();
	
	                // Hide 'change' link for sticky disabled merchants
	                $scope.showPayMerchantWithPayPal = isBillingNoPurchase && (disableStickyForMerchant || !stickyInstrument);
	
	                var checkoutPlan = $scope.checkoutSession.plan;
	                $scope.canChangeFI = true;
	                if ($scope.showPayMerchantWithPayPal || checkoutPlan.isMSB()) {
	                    $scope.canChangeFI = false;
	                } else if (checkoutPlan.isBalance() && _squid.$locale.country !== 'US') {
	                    // Show the change link always for US, where planning is finished ramping choice.
	                    // For other countries, keep old checks until we're sure planning has ramped choice changes there.
	                    $scope.canChangeFI = $scope.checkoutSession.plan.hasConversion() || $scope.checkoutSession.fundingOptions.hasECheck() || $scope.checkoutSession.fundingOptions.hasCredit() || Boolean($scope.checkoutSession.getDisallowedPreferred()) || Boolean($scope.checkoutSession.fundingOptions.getPreferred());
	                }
	
	                $scope.gotoWallet = function () {
	                    // For choice variant, go to manage wallet instead. Always available
	                    if ($scope.selectedmethod) {
	                        return _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
	                    }
	
	                    if ($scope.canChangeFI) {
	                        return _uiRouter.$state.go('checkout.review.sidebar.wallet', { padToggleFeature: $scope.padToggleFeature });
	                    }
	                };
	
	                $scope.bmlSeeTerms = function () {
	                    $scope.showBmlPopup();
	                };
	
	                var currentPlanId = $scope.checkoutSession.plan.id;
	
	                $scope.isSplitPaymentWithBalanceAndIachPlan = false;
	
	                var padToggleFeatureSupported = (0, _squid.$feature)('padToggleFeatureSupported');
	
	                if (padToggleFeatureSupported) {
	                    $scope.padToggleFeature.applicable = $scope.checkoutSession.fundingOptions.isPadToggleApplicable();
	
	                    $scope.padToggleFeature.checkboxEnabled = $scope.padToggleFeature.applicable && $scope.checkoutSession.plan.isPAD() ? true : false;
	
	                    $scope.padToggleFeature.defaultPlan = $scope.checkoutSession.plan.isPAD();
	                }
	
	                // page section changes to show pad toggle tooltip properly
	                if (padToggleFeatureSupported && $scope.padToggleFeature.applicable) {
	                    var checkoutPageSection = angular.element(document.getElementById('sliding-area'));
	                    checkoutPageSection.css('overflow', 'visible');
	                }
	
	                $scope.showPadToggle = function () {
	                    var padToggle = false;
	                    if (padToggleFeatureSupported && $scope.padToggleFeature.applicable) {
	                        $scope.isIachPlan = $scope.checkoutSession.plan.isIACH();
	
	                        if ($scope.isIachPlan && !$scope.isSplitPaymentWithBalanceAndIachPlan) {
	                            $scope.isSplitPaymentWithBalanceAndIachPlan = $scope.checkoutSession.plan.isSplitPaymentWithBalanceAndIach();
	                        }
	
	                        $scope.padToggleFeature.showCheckbox = $scope.checkoutSession.plan.isPAD() || $scope.isIachPlan;
	
	                        if (currentPlanId !== $scope.checkoutSession.plan.id && !$scope.checkoutSession.plan.isPAD()) {
	                            $scope.padToggleFeature.checkboxEnabled = false;
	                            currentPlanId = $scope.checkoutSession.plan.id;
	                        } else if (currentPlanId !== $scope.checkoutSession.plan.id && $scope.checkoutSession.plan.isPAD()) {
	                            $scope.padToggleFeature.checkboxEnabled = true;
	                            currentPlanId = $scope.checkoutSession.plan.id;
	                        }
	
	                        if ($scope.padToggleFeature.pxpTreatmentEnabled && $scope.padToggleFeature.showCheckbox) {
	                            padToggle = true;
	                        }
	                    }
	
	                    return padToggle;
	                };
	
	                $scope.isPadToggleFeatureApplicable = function () {
	                    var padToggle = false;
	                    if (padToggleFeatureSupported && $scope.padToggleFeature.pxpTreatmentEnabled && $scope.padToggleFeature.applicable) {
	                        padToggle = true;
	                    }
	
	                    return padToggle;
	                };
	
	                $scope.updatePlan = function (planId) {
	                    currentPlanId = planId;
	
	                    $scope.checkoutSession.fundingOptions.action('select', {
	                        data: {
	                            planId: planId
	                        },
	                        success: function success(result) {
	
	                            $scope.checkoutSession.populate(result);
	
	                            if (result) {
	                                // Update the installments to support the user selecting a card that does not support installments.
	                                $scope.checkoutSession.installments = result.installments;
	                            }
	                        }
	                    });
	                };
	
	                function getBankInstrumentId() {
	                    var instrumentId = void 0;
	                    if ($scope.isSplitPaymentWithBalanceAndIachPlan) {
	                        var iachSource = $scope.checkoutSession.plan.sources.find(function (source) {
	                            return source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER';
	                        });
	                        instrumentId = iachSource && iachSource.instrument_id;
	                    } else if ($scope.isIachPlan) {
	                        instrumentId = $scope.checkoutSession.plan.sources[0].instrument_id;
	                    }
	
	                    return instrumentId;
	                }
	
	                $scope.padToggleCheckboxEvent = function () {
	                    var planId = void 0;
	                    if ($scope.padToggleFeature.checkboxEnabled) {
	                        var bankInstrumentId = getBankInstrumentId();
	                        planId = $scope.checkoutSession.fundingOptions.getBankPadPlanIdByInstrumentId(bankInstrumentId, 'IACH');
	                        _logger.$logger.info('checkout_fpti', {
	                            'pad_toggle_status': 'padToggleOn'
	                        });
	                    } else {
	                        var padInstrumentId = $scope.checkoutSession.plan.sources[0].instrument_id;
	                        planId = $scope.checkoutSession.fundingOptions.getBankPadPlanIdByInstrumentId(padInstrumentId, 'PAD');
	                        _logger.$logger.info('checkout_fpti', {
	                            'pad_toggle_status': 'padToggleOff'
	                        });
	                    }
	
	                    $scope.updatePlan(planId);
	                };
	
	                var processAllLoadedPadToggle = function processAllLoadedPadToggle() {
	                    if (padToggleFeatureSupported && $scope.showPadToggle()) {
	                        // To remove focus from checkbox so that focus style is not applied
	                        if ($scope.padToggleFeature.checkboxEnabled) {
	                            var section = document.querySelector('#padToggleHelp');
	                            section.focus();
	                            section.blur();
	                        }
	                        // fpti logging
	                        if (!$scope.padToggleFeature.fptiLogged) {
	                            if ($scope.padToggleFeature.checkboxEnabled) {
	                                _logger.$logger.info('pad_toggle_on_feature_shown');
	                                _logger.$logger.info('checkout_fpti', {
	                                    'pad_toggle_status': 'padToggleOnShown'
	                                });
	                            } else {
	                                _logger.$logger.info('pad_toggle_off_feature_shown');
	                                _logger.$logger.info('checkout_fpti', {
	                                    'pad_toggle_status': 'padToggleOffShown'
	                                });
	                            }
	
	                            $scope.padToggleFeature.fptiLogged = true;
	                        }
	                    }
	                };
	
	                var handleAllLoadedForPadToggle = $rootScope.$on('allLoaded', processAllLoadedPadToggle);
	
	                $scope.$on('$destroy', handleAllLoadedForPadToggle);
	
	                var stickyEligible = isBilling && !disableStickyForMerchant;
	                // save sticky decision - to be used in the app and other components
	                _squid.$config.features.DEFAULT.enableStickyFunding = stickyEligible;
	
	                $scope.getPlanList = function () {
	                    // with purchase - always use plan
	                    var planList = stickyEligible && isBillingNoPurchase ? $scope.checkoutSession.getSelectedStickyInstrument() && [$scope.checkoutSession.getSelectedStickyInstrument()] : $scope.checkoutSession.plan.sources;
	
	                    $scope.showUachFeatureDiscalimer = false;
	
	                    // required to display direct debit agreement to AU buyers with unconfirmed bank as payment mode
	                    angular.forEach(planList, function (plan) {
	                        // display uach - direct debit agreement for AU as of July 1st, 2015
	                        if (plan && plan.type === 'BANK_ACCOUNT' && plan.unconfirmed_bank && (0, _squid.$feature)('directDebitAgreement', false, plan.country_code)) {
	                            $scope.showUachFeatureDiscalimer = true;
	                        }
	                    });
	
	                    return planList;
	                };
	
	                $scope.showBackupPlan = function () {
	                    return $scope.checkoutSession.plan.backup && !(stickyEligible && isBillingNoPurchase);
	                };
	
	                if (isBilling) {
	                    $scope.isRP = $scope.checkoutCart.billing.type === 'RECURRING_PAYMENTS';
	                }
	
	                // Show expanded Variant of Text
	                $scope.showExpandedText = function () {
	                    $scope.isExpandedAgreementText = true;
	                };
	
	                if (_squid.$locale.country === 'US') {
	                    $scope.isExpandedAgreementText = true;
	                }
	
	                $scope.getBAContent = function () {
	                    var consentCode = $scope.checkoutCart.billing.consent_code;
	                    var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';
	                    var stickyFI = $scope.checkoutSession.getSelectedStickyInstrument();
	                    var stickyOrNoStickyText = stickyEligible && stickyFI ? 'FiSticky' : 'NoFiSticky';
	                    var expandedOrCollapsedText = $scope.isExpandedAgreementText === true ? 'Expanded' : 'Collapsed';
	
	                    var contentKey;
	                    if (consentCode) {
	                        contentKey = 'enterpriseAgreement.' + consentCode + (stickyEligible && stickyFI ? '' : 'No') + 'FiStickyConsent';
	                    } else {
	                        contentKey = 'billingAgreement.';
	
	                        $scope.isCIB = $scope.checkoutCart.billing.type === 'CHANNEL_INITIATED_BILLING';
	                        if ($scope.isCIB) {
	                            contentKey += 'memberAgreementCib' + stickyOrNoStickyText + useraction + expandedOrCollapsedText;
	                        } else {
	                            contentKey += 'memberAgreement' + stickyOrNoStickyText + useraction;
	                        }
	                    }
	                    return contentKey;
	                };
	
	                $scope.getRPContent = function () {
	                    var contentKey = 'billingAgreement.';
	                    var useraction = $scope.checkoutAppData.useraction() === 'commit' ? 'Pay' : 'Continue';
	
	                    if (stickyEligible && $scope.checkoutSession.getSelectedStickyInstrument()) {
	                        contentKey += 'rpAgreementFiSticky' + useraction;
	                    } else {
	                        contentKey += 'rpAgreementNoFiSticky' + useraction;
	                    }
	                    return contentKey;
	                };
	
	                $scope.getStickyFiName = function () {
	                    var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();
	                    return stickyEligible && selectedStickyInstrument && selectedStickyInstrument.name;
	                };
	
	                $scope.getStickyFiLast4 = function () {
	                    var selectedStickyInstrument = $scope.checkoutSession.getSelectedStickyInstrument();
	                    return stickyEligible && selectedStickyInstrument && selectedStickyInstrument.last4 && 'x-' + selectedStickyInstrument.last4;
	                };
	
	                // Choice Experiment
	                // Preferred checkbox for single FI variants should only be shown if:
	                $scope.showSinglePreferred = function () {
	                    return $scope.makeFiPreferred && // is variant 4
	                    !$scope.selectedmethod && ( // is not variant 5
	                    !$scope.selectFiVariant || $scope.checkoutSession.getPlanList().length > 1); // is variant 6 with more than 1 FI
	                };
	
	                // Update selectedmethod to call update on checkout session later
	                $scope.updateFS = function (fundingsource) {
	                    $scope.selectedmethod.planId = fundingsource.planId;
	
	                    if ($scope.makeFiPreferred) {
	                        $scope.makeFiPreferred.selected = false;
	                    }
	                };
	
	                $scope.getSortedPlans = function () {
	                    return $scope.checkoutSession.getPlanList();
	                };
	
	                // Decide whether multiple FI or single FI section should be shown, based on choice experiment criteria
	                $scope.showMultipleFi = function () {
	                    return $scope.selectedmethod && $scope.getSortedPlans().length > 1;
	                };
	            }).then(function () {
	                var negBals = $scope.checkoutSession.negBals;
	
	                // re-order multiple currencies when first balance has different currency
	                if (negBals && negBals[0].currency_code !== $scope.checkoutCart.purchase.amounts.currency_code) {
	                    negBals = negBals.reverse();
	                }
	                $scope.negBals = negBals;
	            }); // end $populate chain
	        } // end controller function
	    };
	}); // accessibility directives
	// <xo-cvv>
	
	
	_logger.$logger;
	
	_pxp.$pxpCartAmt;
	
	_checkout.$CheckoutCartModel;
	
	_checkout.$CheckoutAppDataModel;
	
	_checkout.$CheckoutSessionModel;
	
	_checkout.$CreditOptionsModel;
	
	_checkout.$CheckoutPayeeModel;
	
	_squid.formatCurrency;
	
	_squid.$config;
	
	_squid.$feature;
	
	_squid.$populate;
	
	_squid.$locale;
	
	_squid.$pxp;
	
	_uiRouter.$state;
	
	_angular.$registerDirective;

/***/ },

/***/ "./components/xo-wallet-components/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _addCard = __webpack_require__("./components/xo-wallet-components/src/add-card/index.js");
	
	Object.keys(_addCard).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _addCard[key];
	    }
	  });
	});

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _directive = __webpack_require__("./components/xo-wallet-components/src/add-card/cardExpiry/directive.js");
	
	Object.keys(_directive).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _directive[key];
	    }
	  });
	});
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	Object.keys(_cardMetaData).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _cardMetaData[key];
	    }
	  });
	});
	
	var _directive2 = __webpack_require__("./components/xo-wallet-components/src/add-card/cvv/directive.js");
	
	Object.keys(_directive2).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _directive2[key];
	    }
	  });
	});

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cardExpiry/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$xoCardExpiryDirective = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/add-card/cardExpiry/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoCardExpiryDirective = exports.$xoCardExpiryDirective = _squid.$Component.extend('$xoCardExpiryDirective', {
	    tag: 'xo-card-expiry',
	    template: _template2['default'],
	
	    props: {
	        expiryMonth: {
	            type: 'var',
	            required: false
	        },
	        expiryYear: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var format = (0, _squid.$feature)('ccExpiryDateFormat', 'MMYY', _squid.$locale.country);
	            var regexPattern = format === 'MMYY' ? /(0\d|1[0-2])\/(\d{2})/ : /(0\d|1[0-2])\/(\d{4})/;
	
	            if (this.expiryMonth && this.expiryYear) {
	                if (format === 'MMYY') {
	                    this.expiryDate = this.expiryMonth + '/' + this.expiryYear.substring(2, 4);
	                } else if (format === 'MMYYYY') {
	                    this.expiryDate = this.expiryMonth + '/' + this.expiryYear;
	                }
	            }
	
	            $('#expiry_value').mask(format === 'MMYY' ? '00/00' : '00/0000');
	
	            this.validate = function (expiryDate) {
	                if (!expiryDate) {
	                    return false;
	                }
	
	                var regexMatch = regexPattern.exec(expiryDate);
	                if (!regexMatch) {
	                    return false;
	                }
	
	                var today = new Date();
	                var currentYear = today.getFullYear();
	                var expMonth = Number(regexMatch[1]);
	                var expYear = Number(regexMatch[2]);
	
	                if (format === 'MMYY') {
	                    // convert year from YY to YYYY format e.g currentYear = 2017, expYear = 20,
	                    // result should be (2020) = (2017 - 17 + 20)
	                    expYear = currentYear - currentYear % 100 + expYear;
	                }
	
	                var expDate = new Date(expYear, expMonth - 1);
	
	                if (expDate < today) {
	                    return false;
	                }
	
	                _this.expiryYear = expYear.toString();
	                _this.expiryMonth = expMonth.toString();
	
	                return true;
	            };
	        }
	    }
	});
	
	angular.value("$xoCardExpiryDirective", $xoCardExpiryDirective);
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$feature;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-ui-components/src/tooltip/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/tooltip/template.html"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template, $) {
	    squid.module('xo-tooltip.directive', ['squid']).directive('xoTooltip', function () {
	
	        return {
	            template: template,
	            restrict: 'E',
	            transclude: true,
	            scope: {
	                trigger: '@',
	                showEvent: '@',
	                hideEvent: '@',
	                displayInline: '=',
	                align: '@' // can take left/right
	            },
	
	            link: function link($scope, $element) {
	                $($element).find('.toolTip').on('click', function (event) {
	                    event.stopPropagation();
	                });
	            },
	
	            controller: function controller($scope, $element, $timeout) {
	
	                function isLink() {
	                    return $($scope.trigger).is('a');
	                }
	
	                $timeout(function () {
	                    var $trigger = $($scope.trigger);
	                    var isMouseOver = false;
	                    var toolTip = $($element).find('.toolTip');
	
	                    var toolTipID = $scope.toolTipID = 'toolTip_' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
	
	                    $scope.showEvent = $scope.showEvent || (isLink() ? 'click' : 'focus');
	                    $scope.hideEvent = $scope.hideEvent || 'blur';
	
	                    $scope.toggle = function (event) {
	
	                        if (event) {
	                            event.stopPropagation();
	                            event.preventDefault();
	                        }
	
	                        if (toolTip.length && $(toolTip).is(':visible')) {
	                            $scope.close();
	                        } else {
	                            $scope.show();
	                        }
	                    };
	
	                    $scope.show = function (event) {
	
	                        if (event) {
	                            event.stopPropagation();
	                            event.preventDefault();
	                        }
	
	                        // Associate toolTipId with trigger element aria-describedby
	                        var describedByIds;
	                        if ($trigger.attr('aria-describedby')) {
	                            describedByIds = $trigger.attr('aria-describedby').split(' ');
	                        } else {
	                            describedByIds = [];
	                        }
	
	                        if (!~describedByIds.indexOf(toolTipID)) {
	                            describedByIds.push(toolTipID);
	                        }
	
	                        $trigger.attr('aria-describedBy', describedByIds.join(' '));
	
	                        // Show the tooltip and position the page scroll to include the element on page
	                        $($element).show();
	                        $(toolTip).slideDown({
	                            progress: function progress() {
	                                var windowBot = $(window).scrollTop() + $(window).height();
	                                var toolTipBot = toolTip.offset().top + toolTip.outerHeight();
	                                if (toolTipBot > windowBot) {
	                                    $(window).scrollTop(toolTipBot - $(window).height());
	                                }
	                            }
	                        });
	                    };
	
	                    $scope.close = function (event) {
	                        if (event) {
	                            event.stopPropagation();
	                            event.preventDefault();
	                        }
	
	                        if (!isMouseOver) {
	                            if (toolTip.length && $(toolTip).is(':visible')) {
	                                $(toolTip).slideUp(100, function () {
	                                    $($element).hide();
	                                });
	                            } else {
	                                $($element).hide();
	                            }
	
	                            // Remove tooltipId from aria-describedby
	                            var describedByIds = $trigger.attr('aria-describedby');
	                            if (describedByIds && ~describedByIds.indexOf(toolTipID)) {
	                                describedByIds = describedByIds.split(' ').filter(function (id) {
	                                    return id !== toolTipID;
	                                });
	                                $trigger.attr('aria-describedby', describedByIds.join(' '));
	                            }
	                        }
	                    };
	
	                    $($element).on('click', '.close', function (event) {
	                        $scope.close(event);
	                    });
	
	                    $($element).on('mouseover', function (event) {
	                        isMouseOver = true;
	                    });
	
	                    $($element).on('mouseleave', function (event) {
	                        isMouseOver = false;
	                    });
	
	                    $(document).on('click.toolTip', function (event) {
	                        $scope.close();
	                    });
	
	                    if (isLink()) {
	                        $trigger.on('click.toolTip', $scope.toggle);
	                        $trigger.on('blur.toolTip', $scope.close);
	                    } else if ($scope.showEvent === $scope.hideEvent) {
	                        $trigger.on($scope.showEvent + '.toolTip', function (event) {
	                            $scope.toggle(event);
	                        });
	                    } else {
	                        $trigger.on($scope.showEvent + '.toolTip', function (event) {
	                            $scope.show(event);
	                        });
	
	                        $trigger.on($scope.hideEvent + '.toolTip', function (event) {
	                            $scope.close(event);
	                        });
	                    }
	
	                    // Clean up document listener on close
	                    $scope.$on('$destroy', function () {
	                        $(document).off('click.toolTip');
	                        $trigger.off($scope.showEvent + '.toolTip');
	                        $trigger.off($scope.hideEvent + '.toolTip');
	                        $scope.close();
	                    });
	                }, 50);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/tooltip/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"toolTip {{align}}\" ng-class=\"{'displayInline': displayInline, 'balloon': !displayInline}\" ng-transclude role=\"tooltip\" id=\"{{toolTipID}}\">\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cardExpiry/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"expirationField inputField\" id=\"expirationField\" directionality content>\n    <label class=\"expires\" for=\"expiry_value\">{{ content('creditcard.expiresLabel') }}</label>\n    <div class=\"inputField\" directionality>\n        <input ng-model=\"expiryDate\"\n               name=\"expiry_value\"\n               id=\"expiry_value\"\n               value=\"\"\n               maxlength=\"{{maxlength}}\"\n               autocapitalize=\"off\"\n               aria-describedby=\"expiryHelp\"\n               autocomplete=\"off\"\n               ui-validate=\"'validate($value)'\"\n               placeholder=\"{{content('creditcard.expiresPlaceholder')}}\"\n               data-error-text=\"{{content('validation.validExpirationDate')}}\"\n               xo-error-tooltip\n               required />\n        <span id=\"expiryHelp\" class=\"accessAid\" ng-bind=\"content('creditcard.expiresPlaceholder')\"></span>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cardMetaData/index.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$CardMetaData = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CARD_META_DATA = {
	    DEFAULT: {
	        fields: {
	            address: true,
	            cvv: true,
	            dob: false,
	            expiry: true,
	            issue: false,
	            phone: false
	        },
	        length: {
	            cvv: 3,
	            min: 16,
	            max: 16
	        },
	        luhn: true,
	        phoneType: 'Mobile',
	        spaces: '4,8,12'
	    },
	
	    PLCC: {
	        fields: {
	            expiry: false,
	            cvv: false,
	            address: false
	        },
	        length: {
	            min: 10,
	            max: 16
	        }
	    },
	
	    MAESTRO: {
	        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
	        length: {
	            min: 12,
	            max: 19
	        },
	        spaces: '4,8,12,16'
	    },
	
	    SWITCH: {
	        pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
	        fields: {
	            issue: true
	        },
	        length: {
	            min: 12,
	            max: 19
	        },
	        spaces: '4,8,12,16'
	    },
	
	    DINERSCLUB: {
	        pattern: /^(36|38|30[0-5])/,
	        length: {
	            min: 14,
	            max: 14
	        }
	    },
	
	    DISCOVER: {
	        pattern: /^(6011|65|64[4-9]|622|36|38|30[0-5])/,
	        length: {
	            min: 14
	        }
	    },
	
	    MASTERCARD: {
	        pattern: /^(5[1-5]|2(2(2[1-9]|[3-9]\d)|[3-6]\d\d|7[0-1]\d|720))/
	    },
	
	    AMEX: {
	        pattern: /^3[47]/,
	        length: {
	            cvv: 4,
	            min: 15,
	            max: 15
	        },
	        spaces: '4,10'
	    },
	
	    VISA: {
	        pattern: /^4/,
	        length: {
	            min: 13
	        },
	        subTypes: {
	            QIWI: {
	                pattern: /^(428122|489049|469395|446942|462012)/
	            }
	        }
	    },
	
	    JCB: {
	        pattern: /^(?:2131|1800|35[0-9]{3})/,
	        length: {
	            min: 15
	        }
	    },
	
	    CBNATIONALE: {},
	
	    CETELEM: {
	        fields: {
	            dob: true
	        },
	        length: {
	            max: 19
	        },
	        spaces: '4,8,12,16'
	    },
	
	    COFIDIS: {
	        fields: {
	            dob: true,
	            expiry: false,
	            cvv: false
	        },
	        length: {
	            min: 8,
	            max: 9
	        },
	        spaces: '4,8',
	        luhn: false
	    },
	
	    COFINOGA: {
	        fields: {
	            dob: true,
	            cvv: false
	        },
	        length: {
	            min: 17,
	            max: 17
	        },
	        spaces: '4,8,12,16'
	    },
	
	    ELO: {
	        pattern: /^9/,
	        length: {
	            min: 13
	        }
	    },
	
	    HIPER: {
	        pattern: /^6/,
	        length: {
	            min: 13
	        }
	    },
	
	    HIPERCARD: {
	        pattern: /^7/,
	        length: {
	            min: 13
	        }
	    },
	
	    CUPCREDIT: {
	        fields: {
	            address: false,
	            phone: true
	        },
	        length: {
	            max: 19
	        }
	    },
	
	    CUPAMEXCREDIT: {
	        fields: {
	            address: false,
	            phone: true
	        },
	        length: {
	            cvv: 4,
	            min: 15,
	            max: 15
	        }
	    },
	
	    CUPDEBIT: {
	        fields: {
	            address: false,
	            cvv: false,
	            expiry: false,
	            phone: true
	        },
	        length: {
	            max: 19
	        }
	    },
	
	    CUPAMEXDEBIT: {
	        fields: {
	            address: false,
	            cvv: false,
	            expiry: false,
	            phone: true
	        },
	        length: {
	            min: 15,
	            max: 15
	        }
	    }
	};
	
	Object.keys(CARD_META_DATA).forEach(function (key) {
	    CARD_META_DATA[key] = $.extend(true, {}, CARD_META_DATA.DEFAULT, CARD_META_DATA[key]);
	});
	
	Object.keys(CARD_META_DATA).forEach(function (key) {
	    CARD_META_DATA[key].spaces = CARD_META_DATA[key].spaces.split(',').map(Number);
	});
	
	function getTypeByPattern(cardMetaData, types, number) {
	    var result = void 0;
	    types.some(function (type) {
	        var metaData = cardMetaData[type];
	        if (metaData && metaData.pattern && metaData.pattern.test(number)) {
	            result = type;
	            return true;
	        }
	    });
	    return result;
	}
	
	var $CardMetaData = exports.$CardMetaData = {
	    getMetaData: function getMetaData(card, field) {
	        var cardType = card && card.type || 'DEFAULT';
	        if (cardType === 'CUP') {
	            cardType = cardType + (card.dualType ? card.dualType : '');
	            cardType = cardType + (['DEBIT', 'DEBITCARD'].indexOf(card.productType) > -1 ? 'DEBIT' : 'CREDIT');
	        }
	        return _squid.$Class.get(CARD_META_DATA[cardType], field);
	    },
	    getCardType: function getCardType(types, number) {
	        var cardType = {};
	        if (_angular2['default'].isArray(types) && number) {
	            cardType.type = getTypeByPattern(CARD_META_DATA, types, number);
	            var metaData = CARD_META_DATA[cardType.type];
	            if (metaData && metaData.subTypes) {
	                cardType.subType = getTypeByPattern(metaData.subTypes, types, number);
	            }
	        }
	        return cardType;
	    }
	};
	
	_angular2['default'].value("$CardMetaData", $CardMetaData);
	_squid.$Class;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cvv/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoCvvDirective = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/add-card/cvv/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoCvvDirective = exports.$xoCvvDirective = _squid.$Component.extend('$xoCvvDirective', {
	    tag: 'xo-cvv',
	    template: _template2['default'],
	
	    props: {
	        card: {
	            type: 'var'
	        },
	        showLabel: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.maskCVV = (0, _squid.$feature)('maskCVV', false, _squid.$locale.country);
	            this.cvvLength = function () {
	                return _cardMetaData.$CardMetaData.getMetaData(_this.props.card, 'length.cvv');
	            };
	            this.cvvRequired = function () {
	                return _this.props.card.type !== 'MAESTRO' || (0, _squid.$feature)('maestroCvvRequired', false, _squid.$locale.country);
	            };
	        }
	    }
	});
	
	angular.value("$xoCvvDirective", $xoCvvDirective);
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$feature;
	
	_cardMetaData.$CardMetaData;

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cvv/template.html":
/***/ function(module, exports) {

	module.exports = "<div content class=\"inputField cvvField\" id=\"cvvField\" directionality>\n    <label ng-if=\"showLabel\" class=\"cvv nolap\" for=\"cvv\">{{ content('creditcard.cscLabel') }}</label>\n\n    <div class=\"cvvSecurityCode inputField\" directionality>\n        <input type=\"{{maskCVV ? 'password' : 'tel'}}\" id=\"cvv\" name=\"cvv\" ng-model=\"card.security_code\"\n               aria-describedby=\"securityCodeHelp\"\n               ng-pattern=\"/^[0-9]{1,4}$/\" ng-minlength=\"cvvLength()\" maxlength=\"{{cvvLength()}}\"\n               placeholder=\"{{cvvLength() === 3 ? content('creditcard.threeDigits') : content('creditcard.fourDigits')}}\"\n               ng-required=\"cvvRequired()\" ng-class=\"{'four': cvvLength() === 4}\" autocomplete=\"off\"\n               data-error-text=\"{{content('validation.validCSC')}}\" xo-error-tooltip />\n\n        <span id=\"securityCode\" class=\"creditCard\" role=\"img\" ng-class=\"{'four': cvvLength() === 4}\"\n              aria-label=\"{{cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')}}\">\n        </span>\n        <span id=\"securityCodeHelp\" class=\"accessAid\" ng-bind=\"cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')\"></span>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-credit-components/src/pay-with-credit/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/pay-with-credit/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-pay-with-credit.directive', ['squid', 'xomodel.checkout']).directive('xoPayWithCredit', function () {
	        return {
	            template: template,
	
	            restrict: 'E',
	
	            scope: {
	                token: '=',
	                doneFn: '='
	            },
	
	            controller: function controller($scope, $populate, $state, $CheckoutCartModel, $CheckoutSessionModel, $locale, $window, $logger, $config) {
	
	                var stateName = 'gce_pay_with_credit';
	
	                $populate($scope, {
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(function () {
	
	                    // For US and GB if txn amount is >= 99 or 150 resp show pay with credit option if credit in
	                    // wallet and is not the current funding option
	
	                    // required to avoid looging every digest cycle.
	                    // TODO: remove this when debounce is fixed for logger
	                    var offerShown = false;
	
	                    $scope.showPayWithCredit = function () {
	
	                        if (!$scope.checkoutCart.get('purchase.amounts.total.amount')) {
	                            offerShown = false;
	                            return false;
	                        }
	
	                        var amount = parseFloat($scope.checkoutCart.purchase.amounts.total.amount);
	                        var minAmount = $window.config.minCreditAmtNoInterest[$locale.country];
	                        var hasCredit = $scope.checkoutSession.fundingOptions.hasCredit();
	                        var fundingSource = $scope.checkoutSession.plan.sources;
	                        var showOffer = $config.features.DEFAULT.showPayWithCreditOffer && !$scope.checkoutSession.plccOffer;
	
	                        if (showOffer && minAmount && amount >= minAmount && hasCredit) {
	                            for (var i in fundingSource) {
	                                if (fundingSource[i].type === 'BILL_ME_LATER') {
	                                    offerShown = false;
	                                    return false;
	                                }
	                            }
	                            if (!offerShown) {
	                                $logger.info(stateName + '_offer_shown');
	                            }
	                            offerShown = true;
	                            return true;
	                        }
	                        offerShown = false;
	                        return false;
	                    };
	
	                    $scope.onSubmit = function () {
	
	                        $logger.info(stateName + '_offer_clicked');
	
	                        $scope.checkoutSession.message = null;
	
	                        var instruments = $scope.checkoutSession.fundingOptions.instruments;
	                        var creditPlanId;
	
	                        for (var i in instruments) {
	                            if (instruments[i].type === 'CREDIT' && instruments[i].name === 'BILL_ME_LATER') {
	                                creditPlanId = instruments[i].planId;
	                            }
	                        }
	
	                        if (!creditPlanId) {
	                            $logger.info(stateName + '_credit_planid_not_found');
	                            return;
	                        }
	
	                        $scope.checkoutSession.fundingOptions.action('select', {
	
	                            resultModel: $scope.checkoutSession,
	                            data: {
	                                planId: creditPlanId
	                            },
	
	                            success: function success(result) {
	
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['paymentMethod.paymentMethodUpdated']
	                                };
	                                $logger.info(stateName + '_success');
	                            }
	                        });
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/pay-with-credit/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"pay-with-credit\" class=\"bmlCtaWrap\" ng-if=\"showPayWithCredit()\" content>\n    <div class=\"trayInner trayInnerDefault\">\n        <div class=\"decreasedWidth noBottom\">\n            <p>{{ content('memberReview.switchToBml') }}</p>\n            <span class=\"disclaimer\" bind-html-compile=\"htmlContent('offers.seeBmlTerms')\"></span>\n        </div>\n        <a href=\"\" track-submit class=\"button-as-link edits\" ng-click=\"onSubmit()\">{{ content('common.select') }}</a>\n    </div>\n</div>\t"

/***/ },

/***/ "./components/xo-member-components/src/preferred-checkbox/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _template = __webpack_require__("./components/xo-member-components/src/preferred-checkbox/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-member-components/src/preferred-checkbox/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend({
	    tag: 'xo-preferred-checkbox',
	    template: _template2['default'],
	    props: {
	        makeFiPreferred: {
	            type: 'var',
	            required: true
	        },
	        plan: {
	            type: 'var',
	            required: true
	        }
	    },
	    actions: {
	        toggleModel: function toggleModel() {
	            if (this.props.makeFiPreferred.selected) {
	                this.props.makeFiPreferred.planId = this.props.plan.planId;
	                this.props.makeFiPreferred.fiId = this.props.plan.primaryFs.type === 'BALANCE' ? this.props.plan.primaryFs.type : // Balance doesn't have an instrument id
	                this.props.plan.primaryFs.id;
	            }
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.showCheckbox = function () {
	                return (_this.props.plan.primaryFs.id || _this.props.plan.primaryFs.type === 'BALANCE') && !_this.props.plan.primaryFs.isPreferred;
	            };
	
	            if (this.showCheckbox()) {
	                _logger.$logger.info('checkout_fpti', {
	                    'pref_fi_option_shown': '1'
	                });
	            }
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_logger.$logger;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-member-components/src/preferred-checkbox/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"showCheckbox()\" class=\"checkboxFiPreferred sCheckbox checkbox\" ng-class=\"plan.primaryFs.name\" content>\n    <input type=\"checkbox\" ng-model=\"makeFiPreferred.selected\" name=\"makeFiPreferred\" id=\"makeFiPreferred\" ng-change=\"actions.toggleModel()\">\n    <label for=\"makeFiPreferred\">{{\n    \tcontent(\n    \t\t'memberReview.prefer_' + plan.primaryFs.type,\n    \t\t{ name: content('fsMappings.'+ plan.primaryFs.name) }\n    \t)\n\t}}</label>\n</div>\n"

/***/ },

/***/ "./components/xo-member-components/src/preferred-checkbox/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-member-components/src/preferred-checkbox/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-member-components/src/preferred-checkbox/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".paywith .checkboxFiPreferred{margin-left:40px}.paywith .singleFi .checkboxFiPreferred.AMEX{margin-left:30px}.paywith .multipleFi .checkboxFiPreferred{margin-top:10px}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-page-components/src/cart/lib/pxp.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-cart.pxp', ['squid.pxp']).factory('$pxpCartAmt', function ($pxp, $q) {
	        return function (merchantCountry, merchantId, noLineItemDetails, isPurchase) {
	
	            if (merchantCountry !== 'AU' && noLineItemDetails && isPurchase) {
	
	                var pageName = 'xo_hermes_no_line_item_details';
	                var showAmtBlacklistTreatment = 'xo_hermes_no_line_items_show_amount_blacklist_test_group';
	                var showAmtTreatment = 'xo_hermes_no_line_items_show_amount_test_group';
	
	                return $q.all([$pxp(pageName, {
	                    'ctx.merchantID': merchantId,
	                    uid: merchantId
	                }, showAmtBlacklistTreatment), $pxp(pageName, {
	                    'ctx.merchantID': merchantId,
	                    uid: merchantId
	                }, showAmtTreatment)]).then(function (results) {
	                    var showAmtBlacklist = results[0];
	                    var showAmt = results[1];
	
	                    if (showAmtBlacklist && showAmtBlacklist.treatment_name === showAmtBlacklistTreatment) {
	                        return true;
	                    }
	
	                    if (showAmt && showAmt.treatment_name === showAmtTreatment) {
	                        return true;
	                    }
	
	                    return false; // default to hide
	                });
	            }
	
	            return $q.when(!noLineItemDetails && isPurchase);
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-page-components/src/cart/lib", "components/xo-page-components/src/cart/lib/pxp.js"))

/***/ },

/***/ "./components/xo-member-components/src/review-paywith/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"paywith asideView\" content>\n    <div class=\"trayInner trayInnerDefault\" ng-class=\"{installments:(checkoutSession.installments.length > 1)}\">\n        <div id=\"paymentMethod\">\n            <div ng-click=\"gotoWallet()\" ng-if=\"!showMultipleFi()\" focusable=\"canChangeFI || selectedmethod\" ng-class=\"{editable:canChangeFI || selectedmethod}\" class=\"focusable singleFi\">\n                <h4 class=\"noBottom paymentsHeader zeta\">\n                    <span ng-if=\"isPadToggleFeatureApplicable()\">\n                        {{ content('paymentMethod.payWith') }}\n                    </span>\n                    <span ng-if=\"!isPadToggleFeatureApplicable()\">\n                        <span ng-if=\"checkoutSession.plan.isPAD()\">\n                        {{ content('paymentMethod.payAfter') }}\n                        </span>\n                        <span ng-if=\"!checkoutSession.plan.isPAD()\">\n                            <span ng-if=\"showPayMerchantWithPayPal\">\n                                {{ content('paymentMethod.payMerchantWithPayPal', {merchantName: merchant}) }}\n                            </span>\n                            <span ng-if=\"!showPayMerchantWithPayPal\">\n                                {{ content('paymentMethod.payWith') }}\n                            </span>\n                        </span>\n                    </span>\n                </h4>\n                <ul class=\"charges\">\n                    <li ng-repeat=\"fs in getPlanList()\" class=\"clearfix fs\" ng-if=\"fs.amount.doubleValue != 0\">\n                        <div ng-class=\"['method', fs.type, fs.sub_type, fs.card_type]\">\n                            <span class=\"fsIcons\" ng-if=\"!fs.is_pinless_debit\"></span>\n                            <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                            <span class=\"name\">\n                                <span ng-if=\"fs.type === 'PPCREDIT'\">\n                                    {{ content('paymentMethod.billmelater') }}\n                                </span>\n                                <span ng-if=\"fs.sub_type === 'DELAYED_TRANSFER' && !isPadToggleFeatureApplicable()\" ng-bind-html=\"htmlContent('paymentMethod.padFs', {bank: fs.name, date: fs.hop_date, last4: fs.last4})\">\n                                </span>\n                                <span ng-if=\"fs.sub_type === 'DELAYED_TRANSFER' && isPadToggleFeatureApplicable()\" ng-bind-html=\"htmlContent('paymentMethod.padToggleFs', {bank: fs.name, last4: fs.last4})\">\n                                </span>\n                                <span ng-if=\"fs.type === 'INCENTIVE'\">\n                                    {{ content('paymentMethod.msbOffer') }}\n                                </span>\n                                <span class=\"forceRTL\" ng-if=\"fs.type === 'BALANCE'\">\n                                    {{ content('paymentMethod.paypalBalance') }}\n                                </span>\n                                <span ng-if=\"fs.type === 'PAYPAL_EXTRAS_MASTERCARD'\">\n                                    {{ content('fsMappings.PAYPAL_EXTRAS_MASTERCARD') }}\n                                </span>\n                                <span ng-if=\"fs.type !== 'PPCREDIT' && fs.type !== 'INCENTIVE' && fs.type !== 'BALANCE' && fs.sub_type !== 'DELAYED_TRANSFER' && fs.type !== 'PAYPAL_EXTRAS_MASTERCARD'\">\n                                    <span class=\"fsNamePinlessDebit\" ng-if=\"fs.is_pinless_debit\">\n                                        {{ content('paymentMethod.pinlessDebit') }}\n                                    </span>\n                                    <span class=\"fsname\" ng-if=\"!fs.is_pinless_debit\">\n                                        {{fs.name}}\n                                    </span>\n                                    <p class=\"bmlDetails\" ng-if=\"!isMorsPxpEnabled && sacEligible(fs.type)\" bind-html-compile=\"htmlContent('fundingInstruments.bmlDetails')\"></p>\n                                    <span ng-if=\"fs.type === 'ECHECK'\">{{ content('paymentMethod.eCheck') }}</span>\n                                    <span class=\"fsLastDigitsPinlessDebit\" ng-if=\"fs.is_pinless_debit\">\n                                        {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                                    </span>\n                                    <span class=\"fslastdigits\" ng-if=\"!fs.is_pinless_debit\">\n                                        {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                                    </span>\n                                    <span ng-if=\"countryCode === 'DE'\">\n                                        <span ng-if=\"fs.sub_type === 'MEFT'\">\n                                            {{ content('paymentMethod.meft') }}\n                                        </span>\n                                        <span ng-if=\"fs.sub_type === 'IACH'\">\n                                            {{ content('paymentMethod.iach') }}\n                                        </span>\n                                        <span ng-if=\"fs.sub_type === 'INSTANT_TRANSFER' && fs.type === 'BANK'\">\n                                            {{ content('paymentMethod.instantTransfer') }}\n                                        </span>\n                                    </span>\n                                </span>\n                                <span ng-if=\"fs.is_preferred && selectFiVariant && makeFiPreferred && checkoutSession.getPlanList().length > 1\" class=\"preferredLabel\">\n                                    <br>\n                                    ({{ content('memberReview.preferred') }})\n                                </span>\n                            </span>\n                            <span ng-if=\"isMorsPxpEnabled && !fs.is_pinless_debit && fs.name === 'PayPal Credit'\">\n                                <xo-offer token=\"token\" promotion=\"promotion\"\n                                          bmlaction=\"bmlaction\" installment=\"installment\"\n                                          selectedmethod=\"selectedmethod\" reusetext=\"true\">\n                                </xo-offer>\n                            </span>\n                            <p class=\"msbHelpText secondary\" ng-if=\"fs.type === 'INCENTIVE'\">\n                                {{ content('paymentMethod.msbHelpText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)})}}\n\n                                <a class=\"msbDetails\" id=\"msb_{{$index}}\">{{ content('paymentMethod.msbDetails')}}</a>\n                            </p>\n\n                            <xo-tooltip ng-if=\"fs.type === 'INCENTIVE'\" trigger=\"#msb_{{$index}}\" show-event=\"click\" hide-event=\"click\" ng-click=\"$event.stopPropagation()\">\n                                <div class=\"tip tipDesc\">\n                                    <h4>{{ content('paymentMethod.msbToolTipOffer') }}</h4>\n                                    <div class=\"msbToolTipDescription\">\n                                        <p ng-if=\"fs.minPurchaseAmount\">\n                                            {{ content('paymentMethod.msbToolTipText', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code), minimumPurchase:fs.minPurchaseAmount})\n                                            }}\n                                        </p>\n                                        <p ng-if=\"!fs.minPurchaseAmount\">\n                                            {{ content('paymentMethod.msbToolTipText2', {amount: formatCurrency(fs.amount.amount, fs.amount.currency_code)}) }}\n                                        </p>\n                                        <p>\n                                        </p>\n                                    </div>\n                                </div>\n                            </xo-tooltip>\n\n                            <xo-tooltip class=\"tip tipHint padHelpToolTip\" ng-if=\"fs.sub_type === 'DELAYED_TRANSFER'\"\n                                trigger=\"#padHelp\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                                <div class=\"tipText tipHintText\">\n                                    <p class=\"padHeader\">\n                                        {{content('paymentMethod.padHelpTxt')}}\n                                    </p>\n                                    <ul class=\"bul\">\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList1', {date: fs.hop_date, country: locale.country, lang: locale.lang})\"></span>\n                                        </li>\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList2', {country: locale.country, lang: locale.lang})\"></span>\n                                        </li>\n                                        <li>\n                                            <span ng-bind-html=\"htmlContent('paymentMethod.padHelpTxtList3')\"></span>\n                                        </li>\n                                    </ul>\n                                    <p>\n                                        <span ng-bind-html=\"htmlContent('paymentMethod.padTnc', {country: locale.country, lang: locale.lang})\"></span>\n                                    </p>\n                                </div>\n                            </xo-tooltip>\n                        </div>\n                        <div ng-if=\"(checkoutSession.installments.length > 1)\">\n                            <div ng-if=\"!installmentNotSelected || checkoutSession.selectedInstallmentData\">\n                                <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallments btn btn-secondary\">\n                                    <span ng-if=\"checkoutSession.selectedInstallmentData\">{{checkoutSession.selectedInstallmentData.term}}X {{content('paymentMethod.of')}} {{checkoutSession.selectedInstallmentData.monthly_payment.formatted_value}}</span>\n                                    <span ng-if=\"!checkoutSession.selectedInstallmentData\">{{content('paymentMethod.changeInstallmentLink') }}</span>\n                                    <span class=\"raq\"></span>\n                                </a>\n                            </div>\n\n                            <div ng-if=\"installmentNotSelected && !checkoutSession.selectedInstallmentData\">\n                                <a ui-sref=\"checkout.review.sidebar.installmentOptions\" ng-init=\"installments = checkoutSession.plan.installments\" class=\"getInstallmentsError btn btn-secondary\">\n                                    {{content('paymentMethod.changeInstallmentLink') }}\n                                    <span class=\"raq\"></span>\n                                </a>\n                            </div>\n                        </div>\n                        <span ng-if=\"showAmt && !(checkoutSession.installments.length > 1)\" class=\"methodAmount\">\n                            <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                        </span>\n                    </li>\n                    <li class=\"method backupFunding\" ng-if=\"showBackupPlan()\">\n                        {{checkoutSession.plan.backup.name}}\n                        <span ng-if=\"!checkoutSession.plan.isAuthRequired\">x-{{checkoutSession.plan.backup.last4}} {{ content('paymentMethod.backup') }}</span>\n                    </li>\n                    <li ng-if=\"showSinglePreferred()\" stop-propagation tabindex=\"-1\">\n                        <xo-preferred-checkbox make-fi-preferred=\"makeFiPreferred\" plan=\"checkoutSession.fundingOptions.plans[0]\"></xo-preferred-checkbox>\n                    </li>\n                    <li ng-repeat=\"fs in checkoutSession.plan.sources\" class=\"clearfix\" ng-if=\"fs.sub_type === 'ECHECK' || (countryCode === 'AU' && fs.sub_type === 'DELAYED_TRANSFER')\">\n                        <span class=\"disclaimer\" ng-if=\"fs.sub_type === 'ECHECK'\">\n                            {{ content('paymentMethod.eCheckDescription') }}\n                        </span>\n                        <span class=\"disclaimer\" ng-if=\"countryCode === 'AU' && fs.sub_type === 'DELAYED_TRANSFER'\">\n                            <a id=\"pad_details\">{{ content('paymentMethod.payAfterDeliveryDetails') }}</a>\n                            <xo-tooltip trigger=\"#pad_details\" on-events=\"click\">\n                                <div class=\"tip tipDesc\">\n                                    {{ content('paymentMethod.padHelpTxt', {date: fs.HOPDate}) }}\n                                    {{ content('paymentMethod.padHelpTxtList') }}\n                                </div>\n                            </xo-tooltip>\n                        </span>\n                    </li>\n                    <li ng-if=\"showAmt && negBals\" class=\"nbr-line fsicon-margin\">\n                        <span ng-bind-html=\"content('memberReview.nbrMerchantCut', { merchantName: merchant })\"></span>:\n                        <span class=\"nbr-amt ltrOverride\">\n                            <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\" amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                        </span>\n                    </li>\n                    <li ng-if=\"showAmt\" ng-repeat=\"nb in negBals\" class=\"nbr-line fsicon-margin\">\n                        {{ content('memberReview.nbrPaypalCut') }}:\n                        <span class=\"nbr-amt ltrOverride\">\n                            <format-currency code=\"nb.currency_code\" amount=\"nb.amount\"></format-currency>\n                        </span>\n                    </li>\n                    <li ng-if=\"checkoutSession.cvvData && !checkoutSession.cvvData.lastAddedCard\" class=\"clearfix reviewEnterCvvContainer\" ng-click=\"$event.stopPropagation()\" tabindex=\"-1\">\n                        <div class=\"reviewEnterCvv\">\n                            <span class=\"enterCvvPrompt\">{{ content('memberReview.enterCSC') }}</span>\n                            <xo-cvv card=\"checkoutSession.cvvData\" show-label=\"false\"></xo-cvv>\n                        </div>\n                    </li>\n\n                    <li id=\"currencyConversion\" class=\"conversion\" ng-if=\"checkoutSession.plan.conversion\" ng-click=\"$event.stopPropagation()\"\n                        tabindex=\"-1\">\n                        <span ng-if=\"checkoutSession.plan.conversion.paypal\">\n\n                            <a id=\"conversionLink\" ui-sref=\"{{checkoutSession.plan.conversion.changeable ? 'checkout.review.sidebar.currencyConversion' : 'checkout.review'}}\"\n                                bind-html-compile=\"content('currencyOptions.conversionRate', {currencyFrom: checkoutSession.plan.conversion.from, currencyTo: checkoutSession.plan.conversion.to})\">\n                            </a>\n\n                            <xo-tooltip trigger=\"#conversionLink\" show-event=\"mouseover\" hide-event=\"mouseleave\" align=\"right\">\n                                <div class=\"tip tipDesc\">\n                                    <div bind-html-compile=\"content('paymentMethod.conversionDate', {date: checkoutSession.plan.conversion.date})\"></div>\n                                    <div ng-if=\"checkoutSession.plan.ispad && checkoutSession.plan.countryCode === 'AU'\">\n                                        {{ content('paymentMethod.conversionToolTipStatement', {date: checkoutSession.plan.conversion.date_formatted}) }}\n                                        ({{ content('paymentMethod.conversionDate', {date: checkoutSession.plan.conversion.date}) }})\n                                    </div>\n                                    <div ng-if=\"checkoutSession.plan.conversion.changeable && checkoutSession.plan.countryCode !== 'AU'\"\n                                        bind-html-compile=\"htmlContent('paymentMethod.changeConversionLink')\">\n                                    </div>\n                                </div>\n                            </xo-tooltip>\n                            <div ng-if=\"checkoutSession.plan.countryCode === 'AU' && checkoutSession.plan.conversion.changeable\"\n                                bind-html-compile=\"htmlContent('paymentMethod.changeConversionLink')\">\n                            </div>\n                        </span>\n                        <span ng-if=\"!checkoutSession.plan.conversion.paypal && checkoutSession.plan.conversion.changeable\">\n                            <a ui-sref=\"checkout.review.sidebar.currencyConversion\">{{ content('paymentMethod.optInConversionLink')}}</a>\n                        </span>\n                    </li>\n                </ul>\n                <div ng-if=\"checkoutSession.plan.conversion.from_code === 'BRL'\">\n                    <p class=\"disclaimer\">{{ content('currencyOptions.noBrazilianReal1')}} {{ content('currencyOptions.noBrazilianReal2')}}</p>\n                    <p class=\"disclaimer\">{{ content('currencyOptions.foreignExchange1')}} {{ content('currencyOptions.foreignExchange2')}}</p>\n                </div>\n            </div>\n\n            <div ng-if=\"showMultipleFi()\" ng-class=\"{editable:canChangeFI}\" class=\"multipleFi\">\n                <h4 class=\"noBottom paymentsHeader zeta\">\n                    <span ng-if=\"checkoutSession.plan.isPAD()\">\n                        {{ content('paymentMethod.payAfter') }}\n                    </span>\n                    <span ng-if=\"!checkoutSession.plan.isPAD()\">\n                        <span ng-if=\"showPayMerchantWithPayPal\">\n                            {{ content('paymentMethod.payMerchantWithPayPal', {merchantName: merchant}) }}\n                        </span>\n                        <span ng-if=\"!showPayMerchantWithPayPal\">\n                            {{ content('paymentMethod.payWith') }}\n                        </span>\n                    </span>\n                </h4>\n                <ul class=\"charges\">\n\n                    <!--List of Plans-->\n                    <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in getSortedPlans()\">\n                        <div class=\"row-fluid radioButton\">\n\n                            <input type=\"radio\" id=\"{{plan.planId}}\" name=\"selectedFI\" value=\"{{plan.planId}}\" ng-model=\"selectedmethod.planId\" ng-click=\"updateFS(plan, $index)\"\n                            />\n\n                            <label class=\"noBottom\" for=\"{{plan.planId}}\">\n                                <div ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length\">\n                                    <div class=\"fsdetails\" ng-class=\"[plan.secondaryFIs[0].type]\">\n                                        <span class=\"fsIcon\" ng-class=\"[plan.secondaryFIs[0].type, plan.secondaryFIs[0].name]\"></span>\n                                        <span class=\"fsName\">{{content('fsMappings.'+ plan.secondaryFIs[0].name) || plan.secondaryFIs[0].name}}</span>\n                                        <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                                        <span class=\"amount\" ng-if=\"plan.secondaryFIs.length === 1 && plan.secondaryFIs[0].amount\">{{plan.secondaryFIs[0].amount.amount_formatted}}</span>\n                                    </div>\n                                </div>\n                                <div ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\">\n                                    <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                                    <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                                    <div class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                        <span ng-switch=\"plan.primaryFs.subtype\">\n                                            <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                                <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span><br>\n                                                <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}}</span>\n                                                <span class=\"\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                            </span>\n                                            <span ng-switch-default>\n                                                <span class=\"fsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                                <!--<span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\" ng-bind-html=\"content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name + '&#8207;').toString()\"></span>-->\n                                                <span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                                <span class=\"\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                                    <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                                    <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                                </span>\n                                                <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                                            </span>\n                                        </span>\n                                        <span class=\"amount\" ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length === 1 && plan.primaryFs.amount\">{{plan.primaryFs.amount.amount_formatted}}</span>\n                                        <div ng-if=\"plan.primaryFs.isPreferred && makeFiPreferred\" class=\"preferredLabel\">\n                                            ({{ content('memberReview.preferred') }})\n                                        </div>\n                                    </div>\n                                </div>\n                            </label>\n\n                        </div>\n                        <div class=\"fsSubdetails\">\n                            <div ng-if=\"sacEligible(plan.primaryFs.name)\">\n                                <div class=\"bmlDetails\" bind-html-compile=\"htmlContent('fundingInstruments.bmlDetailsWallet')\"></div>\n                            </div>\n                            <xo-preferred-checkbox ng-if=\"makeFiPreferred && plan.planId === selectedmethod.planId\" make-fi-preferred=\"makeFiPreferred\" plan=\"plan\"></xo-preferred-checkbox>\n                            <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                {{ content('paymentMethod.eCheckDescription') }}\n                            </div>\n                        </div>\n                    </li>\n                </ul>\n                <div ng-if=\"checkoutSession.plan.conversion.from_code === 'BRL'\">\n                    <p class=\"disclaimer\">{{ content('currencyOptions.noBrazilianReal1')}} {{ content('currencyOptions.noBrazilianReal2')}}</p>\n                    <p class=\"disclaimer\">{{ content('currencyOptions.foreignExchange1')}} {{ content('currencyOptions.foreignExchange2')}}</p>\n                </div>\n            </div>\n\n            <div ng-if=\"selectedmethod\" class=\"multipleFi addCard\">\n                <a ui-sref=\"checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard\" class=\"addCardLink\" role=\"button\">\n                    <span class=\"plusicon\"></span>\n                    <p class=\"addOption\">\n                        <span class=\"name\">{{content('fundingInstruments.addNewCard')}}</span>\n                    </p>\n                </a>\n            </div>\n\n            <div class=\"cibBillingTxt secondary\" ng-if=\"checkoutCart.isBilling() && isCIB && !isRP\">\n                <span class=\"cibTextBox\" data-ng-bind-html=\"htmlContent(getBAContent(), { merchantName: merchant,\n                    partner: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\">\n                </span>\n                <span ng-if=\"!isExpandedAgreementText\">...\n                <a href=\"javascript:void(0);\" class=\"textLink\"\n                   ng-click=\"showExpandedText()\"\n                   onclick=\"return false;\">{{content('billingAgreement.memberAgreementCibShowMore')}}</a>\n                    </span>\n            </div>\n\n            <div class=\"padToggle checkbox\" ng-if=\"showPadToggle()\">\n                <input type=\"checkbox\" ng-checked=\"padToggleFeature.checkboxEnabled\" ng-change=\"padToggleCheckboxEvent()\" ng-model=\"padToggleFeature.checkboxEnabled\" id=\"padToggle\" name=\"padToggle\"\n                       ng-true-value=\"true\" ng-false-value=\"false\"/>\n                <label for=\"padToggle\" id=\"padToggleLabel\" class=\"padToggleSectionTitle\">{{ content('paymentMethod.padToggleTitle') }}</label>\n                <div id=\"padToggleOnSection\" class=\"padToggleSection\" ng-if=\"padToggleFeature.checkboxEnabled\">\n                    <p id=\"padToggleOnText\" class=\"padToggleSectionOnInfoText\">\n                        <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOnInfoText', {date: checkoutSession.plan.sources[0].hop_date, lang: locale.lang, country: locale.country})\"></span>\n                    </p>\n                    <xo-tooltip ng-if=\"padToggleFeature.checkboxEnabled\" trigger=\"#padToggleHelp\" show-event=\"mouseover\" hide-event=\"mouseleave\">\n                        <div class=\"padToggleHelpToolTip\">\n                            <p class=\"padToggleHelpToolTipHeader\">\n                                {{content('paymentMethod.padToggleHelpTooltipHeader')}}\n                            </p>\n                            <p class=\"padToggleHelpToolTipText\">\n                                <span ng-bind-html=\"htmlContent('paymentMethod.padToggleHelpTooltipText', {lang: locale.lang, country: locale.country})\"></span>\n                            </p>\n                        </div>\n                    </xo-tooltip>\n                    <div class=\"padToggleSectionOnBalanceText\" ng-if=\"isSplitPaymentWithBalanceAndIachPlan\">\n                        <div>\n                            <span class=\"balanceMsgIcon\"/>\n                        </div>\n                        <div class=\"balanceMsg\">\n                            <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOnBalanceText')\"/>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"padToggleSection\" ng-if=\"!padToggleFeature.checkboxEnabled\">\n                    <p class=\"padToggleSectionOffInfoText\">\n                        <span ng-bind-html=\"htmlContent('paymentMethod.padToggleOffInfoText', {lang: locale.lang, country: locale.country})\"></span>\n                    </p>\n                </div>\n            </div>\n\n            <p class=\"billingTxt secondary\" ng-if=\"checkoutCart.isBilling() && !isCIB && !isRP\">\n                <span data-ng-bind-html=\"htmlContent(getBAContent(), { merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <p id=\"rpAgreement\" class=\"billingTxt secondary\" ng-if=\"checkoutCart.isBilling() && isRP\">\n                <span data-ng-bind-html=\"htmlContent(getRPContent(), { merchantName: merchant, fiName: getStickyFiName(), fiFormatLast4: getStickyFiLast4(), country: locale.country, lang: locale.lang})\"></span>\n            </p>\n\n            <div class=\"payWithCredit\">\n                <xo-pay-with-credit token=\"token\"></xo-pay-with-credit>\n            </div>\n\n            <!-- AU only direct debit agreement message for a AU buyer with unconfirmed bank -->\n            <p bind-html-compile=\"htmlContent('paymentMethod.directDebitAgreement', { payButtonText: payButtonText })\" ng-if=\"showUachFeatureDiscalimer\"\n                class=\"disclaimer directDebitAgreement\"></p>\n\n            <a ng-if=\"canChangeFI && !selectedmethod\" ui-sref=\"checkout.review.sidebar.wallet\" class=\"edits changePayment\"\n                select-button aria-label=\"{{ content('paymentMethod.label') }}\" focus-when-state=\"checkout.review.sidebar.wallet\" transitions-to=\"checkout.review\">\n                {{ locale.country === 'BR' ? content('common.changePayment') : content('common.change') }}\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n\n            <a ng-if=\"selectedmethod\" ui-sref=\"checkout.review.sidebar.sidebarManageWallet\" class=\"edits changePayment\"\n                select-button focus-when-state=\"checkout.review.sidebar.sidebarManageWallet\" transitions-to=\"checkout.review\">\n                {{ content('asideHeader.manage') }}\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/marketingOffers/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/marketingOffers/template.html"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-models/src/marketingoffer/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	
	    return angular.module('xo-page-components.marketingOffers', ['squid', 'xo-title.directive', 'xomodel.marketingoffer', 'xomodel.checkout', 'xomodel.auth']).directive('xoMarketingOffers', function () {
	        return {
	            template: template,
	
	            scope: {
	                placementCode: '=',
	                titleTxtProperty: '=',
	                subtitleProperty: '=',
	                token: '=',
	                pageName: '=',
	                backgroundImage: '='
	            },
	
	            controller: function controller($scope, $sce, $rootScope, $populate, $state, $locale, $renderContent, $logger, $pxp, $config, $CheckoutCartModel, $MarketingOfferModel, $fireMORSBeacon, $element, $feature, $CheckoutSessionModel, $CheckoutPayeeModel, $AuthModel) {
	                var morsOfferFlag = $scope.placementCode === '202003' && $feature('morsValuePropOffers');
	                var populateObj;
	                if (morsOfferFlag) {
	                    populateObj = {
	                        checkoutCart: $CheckoutCartModel.instance($scope.token),
	                        checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                        payee: $CheckoutPayeeModel.instance($scope.token),
	                        auth: $AuthModel.instance()
	                    };
	                } else {
	                    populateObj = {
	                        checkoutCart: $CheckoutCartModel.instance($scope.token)
	                    };
	                }
	                $populate($scope, populateObj).then(function () {
	                    $scope.locale = $locale;
	                    $scope.token = $rootScope.token;
	                    function setDefaultValues() {
	                        $scope.ad = {
	                            Title: $renderContent($scope.titleTxtProperty),
	                            Body: $renderContent($scope.subtitleProperty),
	                            backgroundImage: $scope.backgroundImage
	                        };
	                    }
	
	                    $scope.$watch('ad.backgroundImage', function (imageUrl) {
	                        if (imageUrl) {
	                            var url = imageUrl;
	                            var propImg = angular.element($element[0].querySelector('div.prop-img'));
	                            var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;
	
	                            if (isRetina && url) {
	                                var index = url.lastIndexOf('.'); // index at which file extension start
	                                url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
	                                propImg.css({
	                                    'background-image': 'url(' + url + ')',
	                                    'height': '150px',
	                                    'margin-top': '0px'
	                                });
	                            } else {
	                                propImg.css({
	                                    'background-image': 'url(' + url + ')',
	                                    'height': '150px',
	                                    'margin-top': '0px'
	                                });
	                            }
	                        }
	                    });
	
	                    if ($scope.placementCode === '202002') {
	                        $scope.pu_type = 'ANONYMOUS';
	                        $scope.presentation_types = ['CompositeText'];
	                        $scope.pxpInfo = {
	                            name: 'xo_xoon_hermes_mors',
	                            pattern: '(xo_xoon_hermes_mors_)(.*)',
	                            treatment: 'xo_xoon_hermes_mors_treatment'
	                        };
	                    } else if ($scope.placementCode === '202003') {
	                        $scope.className = 'props';
	                        $scope.pu_type = 'PERSONAL';
	                        $scope.presentation_types = ['GenericComposite'];
	                        $scope.pxpInfo = {
	                            name: 'xo_mors_hermes_placements_ryi',
	                            pattern: '(xo_mors_hermes_placements_ryi_)(.*)',
	                            treatment: 'xo_mors_hermes_placements_ryi_treatment'
	                        };
	                    } else {
	                        setDefaultValues();
	                    }
	
	                    //  serve ads only if pxp is true, country is US and lang is en
	                    if ($locale.country === 'US' && $locale.lang === 'en' && $scope.placementCode && $feature('morsValuePropOffers')) {
	                        $scope.marketingOfferData = new $MarketingOfferModel({
	                            countryCode: $scope.locale.country,
	                            page: $scope.pageName,
	                            puType: $scope.pu_type,
	                            locale: $locale.lang + '_' + $locale.country,
	                            totalTransactionAmount: {
	                                'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
	                                // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
	                                // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
	                                'value': Math.round($scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100)
	                            },
	                            totalShippingAmount: {
	                                'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
	                                // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)        
	                                // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html                            
	                                'value': Math.round($scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100)
	                            },
	                            payee: morsOfferFlag ? $scope.payee.merchant.id : '',
	                            payer: morsOfferFlag ? $scope.checkoutSession.payer.id : '',
	                            si: morsOfferFlag ? $scope.checkoutSession.id : '',
	                            visitor_id: morsOfferFlag ? $scope.auth.visitor_id : '',
	                            targetPlacements: [{
	                                'placement_code': $scope.placementCode,
	                                'presentation_types': $scope.presentation_types
	                            }]
	                        });
	                        $pxp($scope.pxpInfo.name, { 'ctx.COUNTRY': $locale.country }, $scope.pxpInfo.pattern).then(function (res) {
	
	                            $logger.info('MO treatment: ' + (res ? res.treatment_name : '[no pxp response!]'));
	                            if (res && res.treatment_name === $scope.pxpInfo.treatment) {
	
	                                return $MarketingOfferModel.instance($scope.token).save({
	
	                                    silent: true,
	                                    data: $scope.marketingOfferData.serialize(),
	                                    success: function success(result) {
	                                        var ads_arr = result && result.ads || [];
	                                        var adFound = false;
	
	                                        // MORS could serve multiple ads for a given page. Iterate to get the
	                                        // correct one based on the ad placement_id
	                                        ads_arr.forEach(function (ad) {
	                                            var adunit_id = ad.campaign.adunit_id;
	
	                                            if (adunit_id.toString() === $scope.placementCode.toString() && ad.valid) {
	                                                adFound = true;
	                                                $scope.ad = {};
	                                                var content = ad.content.nvp;
	                                                content.forEach(function (obj) {
	                                                    $scope.ad[obj.name] = obj.value;
	                                                });
	                                                $scope.ad['impressionUrl'] = ad.tracking.impression_url;
	                                                $scope.ad['clickUrl'] = ad.tracking.click_url;
	                                            }
	                                        });
	
	                                        if (adFound) {
	                                            $scope.ad.Body = $sce.trustAsHtml($scope.ad.Body);
	                                            // $scope.ad.Title does not need to be assigned. for 202001, 202002,
	                                            // and 202003 placement_ids as this will already be assigned.
	
	                                            // notify MORS of successful rendering by firing the impressionurl
	                                            // beacon and by setting the click url to be fired for future
	                                            // conversion.
	                                            // setting the placement_id helps to differentiate between multiple ads
	                                            // displayed on the same page
	
	                                            $logger.info('MORS_ad_displayed');
	                                            $fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);
	
	                                            $rootScope.$broadcast('MORSDisplayed', {
	                                                clickUrl: $scope.ad.clickUrl,
	                                                placementId: $scope.placementCode
	                                            });
	                                        } else {
	                                            $logger.info('MORS_ad_not_found');
	                                            setDefaultValues();
	                                            $rootScope.$broadcast('MORSNotDisplayed');
	                                        }
	                                    },
	
	                                    error: function error(err) {
	                                        setDefaultValues();
	                                        $logger.error('MORS_api_failure', { error: err });
	                                    }
	                                });
	                            } else {
	                                setDefaultValues();
	                                $rootScope.$broadcast('MORSNotDisplayed');
	                            }
	                        });
	                    } else {
	                        setDefaultValues();
	                        $rootScope.$broadcast('MORSNotDisplayed');
	                    }
	                    $scope.$on('localeChange', function () {
	                        setDefaultValues();
	                    });
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/marketingOffers/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"marketingOffers {{className}}\" content >\n    <div ng-if=\"ad.backgroundImage\" class=\"prop-img\"></div>\n    <xo-title title-txt=\"{{ ad.Title }}\"></xo-title>\n    <p class=\"subTitle\" ng-bind-html=\"ad.Body\"></p>\n</div>\n"

/***/ },

/***/ "./components/xo-models/src/marketingoffer/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/node-uuid/uuid.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, uuid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.marketingoffer', ['squid']).factory('$MarketingOfferModel', function ($Model, $Api) {
	        return $Model.extend('$MarketingOfferModel', {
	            api: new $Api({
	                uri: '/api/checkout/offer/search-ads',
	                postAttempts: 1
	
	            }),
	
	            serialize: function serialize() {
	                var data = {
	                    'site': this.site,
	                    'locale': this.locale,
	                    'si': this.si,
	                    'visit_id': uuid.v4(),
	                    'page': this.page,
	                    'epu': this.payer,
	                    'pu_type': this.puType || 'ANONYMOUS',
	                    'country_code': this.countryCode,
	                    'payment_context': {
	                        'total_transaction_amount': this.totalTransactionAmount,
	                        'total_shipping_amount': this.totalShippingAmount,
	                        'business_case': 'NONE',
	                        'business_case_variation': '',
	                        'validate_existing_offer': 'false',
	                        'payment_units': [{
	                            'transaction_amount': this.totalTransactionAmount,
	                            'transaction_id': '',
	                            'encrypted_transaction_id': '',
	                            'activity_id': '',
	                            'payee': {
	                                'pu_type': 'BUSINESS',
	                                'country_code': this.countryCode,
	                                'epu': this.payee,
	                                'pu': ''
	                            }
	                        }]
	                    },
	                    'target_placements': this.targetPlacements,
	                    'wallet_instruments': this.walletInstruments,
	                    'addl_property_installments_not_allowed': this.installmentsNotAllowed
	                };
	
	                return data;
	            }
	        });
	    }).service('$fireMORSBeacon', function ($q) {
	        this.fireBeacon = function (uri) {
	            var img = document.createElement('img');
	
	            img.setAttribute('src', uri);
	            document.body.appendChild(img);
	
	            return;
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/marketingoffer", "components/xo-models/src/marketingoffer/index.js"))

/***/ },

/***/ "./pages/xo-select-fi/template.html":
/***/ function(module, exports) {

	module.exports = "<section id='xoSelectFi' class=\"review\" content tabindex=-1 role=\"presentation\">\n    <xo-title title-txt=\"{{content('memberReview.memberReviewTitle')}}\" class=\"accessAid\"></xo-title>\n\n    <div class=\"row-fluid justMember\">\n        <div class=\"span14 trayInner reviewSections\">\n            <xo-banner ng-if=\"personalizedBanner.show && !isMessengerBAIntegration\" banner-image=\"personalizedBanner.imageUrl\">\n                <p class=\"userEmail\" id=\"reviewUserInfo\">\n                    {{ content('memberReview.loggedInWithOneTouch', {userName: formattedNameInformal}) }}\n                    <span ng-if=\"showNotYou\">\n                        <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"actions.logout()\">{{ content('memberReview.notYou')}}</a>\n                    </span>\n                </p>\n            </xo-banner>\n            <xo-message message=\"models.checkoutSession.message\"></xo-message>\n            <div ng-if=\"!personalizedBanner.show && !isMessengerBAIntegration\">\n                <p class=\"userEmail\" id=\"reviewUserInfo\">\n                    {{ content('creditcard.hi', {userName: formattedNameInformal}) }}\n                    <span ng-if=\"showNotYou\">\n                        <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"actions.logout()\">{{ content('memberReview.notYou')}}</a>\n                    </span>\n                </p>\n            </div>\n\n            <div class=\"reviews reviews_first\">\n                <div class=\"paywith asideView\" content>\n                    <div class=\"trayInner trayInnerDefault multipleFi\">\n                        <div class=\"\">\n                            <h4 class=\"noBottom paymentsHeader alpha\">\n                                {{ content('memberReview.selectFi') }}\n                            </h4>\n                            <div\n                                class=\"split_bal_option\"\n                                ng-if=\"balanceList.length\">\n                                <div\n                                    class=\"sCheckbox checkbox\"\n                                    ng-repeat=\"balance in balanceList\"\n                                    ng-class=\"{disabled: !balance.enabled}\">\n                                    <input\n                                        ng-if=\"balance.fake\"\n                                        type=\"checkbox\"\n                                        disabled=\"disabled\"\n                                        checked=\"checked\">\n                                    <input\n                                        ng-if=\"!balance.fake\"\n                                        id=\"bal_{{balance.code}}\"\n                                        type=\"checkbox\"\n                                        ng-model=\"balance.checked\"\n                                        ng-disabled=\"!balance.enabled\"\n                                        value=\"{{balance.code}}\"\n                                        ng-change=\"capUserIntent(balance.code, balance.checked)\">\n                                    <label\n                                        for=\"bal_{{balance.code}}\"\n                                        class=\"choice-split-balance\"\n                                        ng-class=\"{disabled: !balance.enabled}\"\n                                        bind-html-compile=\"htmlContent('memberReview.useBalanceLabel', { amt: balance.amount })\">\n                                    </label>\n                                </div>\n                            </div>\n                            <ul class=\"charges\">\n\n                                <!--List of Plans-->\n                                <li role=\"presentation\" class=\"fundingsource\" ng-if=\"!isBillingNoPurchase\" ng-repeat=\"plan in primaryList\">\n                                    <div class=\"row-fluid radioButton\">\n\n                                        <input type=\"radio\" id=\"{{plan.planId}}\" name=\"selectedFI\" value=\"{{ $index }}\"\n                                            ng-model=\"selectedmethod.index\" ng-change=\"updateBalances($index)\"/>\n\n                                        <label class=\"noBottom\" for=\"{{plan.planId}}\">\n                                            <div ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\">\n                                                <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                                                <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                                                <div class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                                                    <span ng-switch=\"plan.primaryFs.subtype\">\n                                                        <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                                            <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span><br>\n                                                            <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}} </span>\n                                                            <span ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                                        </span>\n                                                        <span ng-switch-default>\n                                                            <span class=\"fsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                                            <span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                                            <span ng-if=\"plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.currencies}})</span>\n                                                            <span ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                                                <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                                                <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                                            </span>\n                                                        </span>\n                                                    </span>\n                                                    <div ng-if=\"!isBilling && plan.primaryFs.isPreferred && preferredFiVariant && plan.primaryFs.subtype !== 'PAD'\" class=\"preferredLabel\">\n                                                        ({{ content('memberReview.preferred') }})\n                                                    </div>\n\n                                            </div>\n                                                <div ng-if=\"!plan.primaryFs.isPinlessDebit && plan.primaryFs.name === 'BILL_ME_LATER'\">\n                                                    <xo-offer token=\"token\" promotion=\"promotion\"\n                                                              bmlaction=\"bmlaction\" installment=\"installment\"\n                                                              selectedmethod=\"selectedmethod\" reusetext=\"true\">\n                                                    </xo-offer>\n                                                </div>\n                                            </div>\n                                        </label>\n                                    </div>\n                                    <div class=\"fsSubdetails\">\n                                        <div ng-if=\"sacEligible(plan.primaryFs.name)\">\n                                            <div class=\"bmlDetails\" bind-html-compile=\"htmlContent('fundingInstruments.bmlDetailsWallet')\"></div>\n                                        </div>\n                                        <div ng-if=\"plan.primaryFs.subtype === 'ECHECK'\" class=\"disclaimer\">\n                                            {{ content('paymentMethod.eCheckDescription') }}\n                                        </div>\n                                    </div>\n                                </li>\n                                <li role=\"presentation\" class=\"fundingsource\" ng-if=\"isBillingNoPurchase\" ng-repeat=\"stickyFI in getBAPlans()\">\n                                    <div class=\"row-fluid radioButton\">\n\n                                        <input type=\"radio\" id=\"{{stickyFI.instrument_id}}\" name=\"selectedFI\" value=\"{{stickyFI.instrument_id}}\" ng-model=\"selectedmethod.planId\"/>\n\n                                        <label class=\"noBottom\" for=\"{{stickyFI.instrument_id}}\">\n                                            <div>\n                                                <span class=\"fsIcon\" ng-class=\"[stickyFI.type, stickyFI.name, stickyFI.card_type]\"></span>\n                                                <div class=\"fsdetails\">\n                                                    <span ng-switch=\"fundingsource.subtype\">\n                                                        <span ng-switch-default>\n                                                            <span class=\"name\">{{content('fsMappings.'+ stickyFI.name) || stickyFI.name}}</span>\n                                                            <span class=\"lastdigits\" ng-if=\"stickyFI.last4\">x-{{stickyFI.last4}}</span>\n                                                        </span>\n                                                    </span>\n                                                </div>\n                                            </div>\n                                        </label>\n                                    </div>\n                                </li>\n\n                            </ul>\n\n                            <div class=\"multipleFi addCard\">\n                                <a track-link=\"choose_FI_interstitial\" ui-sref=\"checkout.pageAddCard.addCardFlow.addCard\"\n                                    class=\"addCardLink\" role=\"button\">\n                                    <span class=\"plusicon\"></span>\n                                    <p class=\"addOption\">\n                                        <span class=\"name\">{{content('fundingInstruments.addNewCard')}}</span>\n                                    </p>\n                                </a>\n                            </div>\n\n                            <div class=\"offers\">\n                                <xo-offer token=\"token\" promotion=\"promotion\" bmlaction=\"bmlaction\"installment=\"installment\"\n                                    selectedmethod=\"selectedmethod\">\n                                </xo-offer>\n                            </div>\n                        </div>\n                    </div>\n                    <div id=\"button\" class=\"buttons reviewButton\">\n                        <button track-submit='choose_FI_interstitial' class=\"btn full confirmButton continueButton\" ng-click=\"continue()\">{{content\n                            ('common.continuetext')}}</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"span10\">\n            <xo-marketing-offers placement-code=\"'202003'\"\n                                 token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"propValueObj.propHeader\"\n                                 subtitle-property=\"propValueObj.propVal\"\n                                 background-image= \"propValueObj.propImage\"\n            >\n            </xo-marketing-offers>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-select-fi/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-select-fi/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-select-fi/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}.split_bal_option{margin:1em 0;padding:1em 1em .6em;color:#000;background:#f1f4f5}.split_bal_option label{cursor:pointer}.split_bal_option .disabled{color:#999}.split_bal_option .disabled label{cursor:default!important}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-review/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ReviewRoute = undefined;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _route = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _route3 = __webpack_require__("./components/xo-credit-components/src/apply-ppc/route.js");
	
	var _route4 = _interopRequireDefault(_route3);
	
	__webpack_require__("./components/xo-login-components/src/onetouch-interstitial/route.js");
	
	var _route5 = __webpack_require__("./pages/xo-sidebar/route.js");
	
	var _route6 = _interopRequireDefault(_route5);
	
	var _route7 = __webpack_require__("./pages/xo-sidepage/route.js");
	
	var _route8 = _interopRequireDefault(_route7);
	
	var _directive = __webpack_require__("./pages/xo-review/directive.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _choice = __webpack_require__("./components/xo-models/src/choice/index.js");
	
	var _credit = __webpack_require__("./components/xo-models/src/credit/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $ReviewRoute = exports.$ReviewRoute = _squid.$ComponentRoute.extend('$ReviewRoute', {
	
	    path: 'review',
	    directive: _directive.$xoReviewPageComponent,
	    titleContent: 'memberReview.memberReviewTitle',
	
	    trackingData: {
	        fptiState: 'review',
	        templateName: 'memberReview.dust',
	        pageGoal: 'Payment Review',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-review',
	                'pagename2': '%::fullpage-review:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    resolve: {
	        action: function action($rootScope, $state) {
	            // Determine if we should instead route to the selectFi choice experiment page
	            if (!(0, _squid.$feature)('choiceExperiment')) {
	                return;
	            }
	
	            var _$config$choiceExperi = _squid.$config.choiceExperiment;
	            _$config$choiceExperi = _$config$choiceExperi === undefined ? {} : _$config$choiceExperi;
	            var _$config$choiceExperi2 = _$config$choiceExperi.selectFi,
	                fiPageVariants = _$config$choiceExperi2 === undefined ? [] : _$config$choiceExperi2,
	                _$config$choiceExperi3 = _$config$choiceExperi.skipSelectFi,
	                skipFiPageVariants = _$config$choiceExperi3 === undefined ? [] : _$config$choiceExperi3;
	            var fromState = $state.fromState;
	
	            var skipStates = ['checkout.selectFi', 'checkout.authorizationmessage', 'checkout.pageAddCard.addCardFlow.addCard', 'checkout.chooseCreditOffer'];
	
	            if (!fromState.name || fromState.name.indexOf('checkout.review') !== -1 || skipStates.indexOf(fromState.name) !== -1) {
	                return;
	            }
	
	            // If returning from credit application, skip the selectFi page
	            var isCapeReturnKey = _credit.$CreditDataModel.instance($rootScope.token).getCapeKey();
	
	            if (isCapeReturnKey) {
	                return;
	            }
	
	            return _choice.$ChoiceEligibility.instance().getVariant($rootScope.token).then(function (variant) {
	                // Check if variant is selectFi variant
	                if (fiPageVariants.indexOf(variant) === -1) {
	                    return;
	                }
	
	                var models = {};
	
	                // Check that there is more than one plan to choose from, or that plan is not preferred
	                return (0, _squid.$populate)(models, {
	                    checkoutSession: _checkout.$CheckoutSessionModel.instance($rootScope.token)
	                }).then(function () {
	                    var plans = models.checkoutSession.get('fundingOptions.plans');
	                    var isPreferredDefault = skipFiPageVariants.indexOf(variant) > -1 && plans && plans[0].primaryFs.isPreferred;
	                    var stickyPlans = models.checkoutSession.futurePaymentInstruments;
	                    if (!isPreferredDefault && (plans && plans.length > 1 || stickyPlans && stickyPlans.length > 1)) {
	                        return {
	                            to: 'checkout.selectFi',
	                            newState: true
	                        };
	                    } else {
	                        _logger.$logger.info('skip_selectFi', {
	                            reason: isPreferredDefault ? 'default_is_preferred' : 'not_enough_plans'
	                        });
	                        return;
	                    }
	                });
	            });
	        }
	    },
	
	    children: [{
	        route: _route6['default'],
	        attributes: {
	            'back-uri': 'backUri',
	            'promotion': 'promotion',
	            'update': 'update',
	            'token': 'token',
	            'installment': 'installment'
	        }
	    }, {
	        name: '$OneTouchUpsellRoute',
	        attributes: {
	            'token': 'token',
	            'on-complete': 'onComplete'
	        }
	    }, {
	        route: _route2['default'],
	        attributes: {
	            'token': 'token',
	            'cardmodel': 'cardModel',
	            'on-success': 'onConfirmUpopSuccess',
	            'on-cancel': 'onConfirmUpopCancel'
	        }
	    }, {
	        route: _route4['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }, {
	        route: _route8['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }]
	});
	
	angular.value("$ReviewRoute", $ReviewRoute);
	_logger.$logger;
	
	_squid.$ComponentRoute;
	
	_squid.$feature;
	
	_squid.$config;
	
	_squid.$populate;
	
	_directive.$xoReviewPageComponent;
	
	_checkout.$CheckoutSessionModel;
	
	_choice.$ChoiceEligibility;
	
	_credit.$CreditDataModel;

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoConfirmUpopRoute', {
	    path: 'confirmUpop',
	    directive: _directive2['default'],
	    titleContent: 'confirmUpop.confirm',
	    trackingData: {
	        fptiState: 'confirm_upop'
	    },
	    query: ['fromLoginOverlay'],
	    loginRequired: true,
	    pageOnOverlay: true,
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _addCard = __webpack_require__("./components/xo-wallet-components/src/add-card/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__("./components/xo-wallet-components/src/confirm-upop/init/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/confirm-upop/confirm/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/confirm-upop/styles.less");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoConfirmUpopDirective', {
	    tag: 'xo-confirm-upop',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        phone: {
	            type: 'var',
	            required: false
	        },
	        cardmodel: {
	            type: 'var',
	            required: true
	        },
	        onSuccess: {
	            type: 'var',
	            required: false
	        },
	        onCancel: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.phone = this.props.phone || {};
	            this.cardLast4 = this.cardmodel.card.number.slice(-4);
	            this.fromLoginOverlay = _uiRouter.$stateParams.fromLoginOverlay;
	
	            (0, _angular.$timeout)(function () {
	                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').addClass('upopOpen');
	                if (_this.fromLoginOverlay) {
	                    (0, _angular.$timeout)(function () {
	                        (0, _jquery2['default'])('#upopConfirmation .modalWrapper').addClass('modalWrapperAnimation');
	                    });
	                }
	            });
	
	            var hideModal = function hideModal() {
	                (0, _jquery2['default'])('#upopConfirmation .upopConfirm').removeClass('upopOpen');
	            };
	
	            var done = function done(handler, target) {
	                hideModal();
	                (0, _angular.$timeout)(function () {
	                    return handler ? handler() : _this.goto(target);
	                }, 300);
	            };
	
	            var _success = function _success() {
	                done(_this.props.onSuccess, 'checkout.review');
	            };
	
	            this.closeModal = function (event) {
	                if (event) {
	                    event.preventDefault();
	                }
	
	                done(_this.props.onCancel, '^');
	            };
	
	            this.initSuccess = function () {
	                _this.collectOtpInput = false;
	            };
	
	            this.confirmed = function () {
	                if (_this.props.onSuccess) {
	                    return _success();
	                }
	
	                _this.models.checkoutSession.fundingOptions.action('update', {
	                    resultModel: _this.models.checkoutSession,
	                    silent: true,
	                    data: {
	                        planId: _this.cardmodel.id
	                    },
	                    success: function success() {
	                        if (_this.models.checkoutSession.cvvData) {
	                            _this.models.checkoutSession.set('cvvData.security_code', _this.cardmodel.get('card.security_code'));
	                        }
	                        var isNewCard = !_this.cardmodel.card.isExisting();
	
	                        var msg = isNewCard ? ['smallToolTip.cardAddedConfirmed'] : ['smallToolTip.cardConfirmed'];
	
	                        _this.models.checkoutSession.message = {
	                            type: 'success',
	                            msgKeys: msg
	                        };
	
	                        _success();
	                    },
	                    contingencies: {
	                        TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
	                            _this.models.checkoutSession.message = {
	                                type: 'info',
	                                msgKeys: 'creditcard.addedButCannotUse'
	                            };
	
	                            _success();
	                        }
	                    }
	                });
	            };
	
	            this.flag = function (field) {
	                return _addCard.$CardMetaData.getMetaData(_this.cardmodel.card, field);
	            };
	
	            this.setMessage = function (message) {
	                _this.message = message;
	            };
	
	            this.collectOtpInput = this.flag('fields.expiry') && !this.cardmodel.get('card.expiry_month') || this.flag('fields.cvv') && !this.cardmodel.get('card.expiry_month') || this.flag('fields.phone') && !(this.phone && this.phone.telephone);
	        }
	    }
	});
	
	
	_angular.$timeout;
	
	_squid.$Component;
	
	_uiRouter.$stateParams;
	
	_addCard.$CardMetaData;
	
	_index.$CheckoutSessionModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/init/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _util = __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js");
	
	var _index = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/spinner-button/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/init/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoInitOtpDirective', {
	    tag: 'xo-init-otp',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        phone: {
	            type: 'var',
	            required: false
	        },
	        cardmodel: {
	            type: 'var',
	            required: true
	        },
	        onSuccess: {
	            type: 'var',
	            required: true
	        },
	        flag: {
	            type: 'var',
	            required: true
	        },
	        message: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    actions: {
	        initOtp: function initOtp() {
	            var _this = this;
	
	            var handleContingencies = function handleContingencies() {
	                var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	                var prop = arguments[1];
	
	                var errorData = void 0;
	                if (result.errorCodes) {
	                    errorData = result;
	                } else {
	                    errorData = {
	                        errorCodes: [result['0'] || 'ISSUER_DECLINE']
	                    };
	                }
	
	                _this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));
	
	                if (window.scrollTo) {
	                    window.scrollTo(0, 0);
	                }
	            };
	
	            this.isProcessing = true;
	
	            var resolveOTP = new _index.$ResolveOTP({ id: this.cardmodel.id });
	
	            resolveOTP.action('init', {
	                silent: true,
	                data: {
	                    phone: {
	                        country_code: this.phone.IntDialingCountryCode,
	                        number: this.phone.telephone
	                    }
	                },
	                resultModel: {},
	                success: function success() {
	                    _this.onSuccess();
	                },
	
	                error: function error() {
	                    handleContingencies();
	                },
	
	                contingencies: {
	                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
	                        // prop for last 4 digits of card in error message
	                        var prop = {
	                            number: _this.cardmodel.card.number.slice(-4)
	                        };
	
	                        handleContingencies(result, prop);
	                        _util.$fiErrorUtil.addFieldErrors(result, _this.$element);
	                    },
	                    DEFAULT: function DEFAULT() {
	                        handleContingencies();
	                    }
	                }
	            })['finally'](function () {
	                _this.isProcessing = false;
	            });
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this2 = this;
	
	            this.$watch('isProcessing', function (isProcessing) {
	                if (isProcessing) {
	                    _this2.$element.addClass('processing');
	                } else {
	                    _this2.$element.removeClass('processing');
	                }
	            });
	            $('#upopConfirmation .modalContainer').focus();
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_util.$fiErrorUtil;
	
	_index.$ResolveOTP;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-wallet-components/src/fi-contingency-list/util.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/contingencies.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, contingencyList) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('fi.errorUtil', ['squid']).factory('$fiErrorUtil', function ($renderContent) {
	        return {
	            addPageErrors: function addPageErrors(errorData, contentBundle, prop, defaultKey) {
	
	                // error handling for filifecycle and fimanagement. 
	                if (!errorData.errorCodes) {
	                    errorData.errorCodes = errorData && [errorData['0']];
	                }
	
	                var messages = [];
	                if (errorData.errorCodes && errorData.errorCodes.length) {
	                    errorData.errorCodes.forEach(function (errorCode) {
	                        var contentKey = contingencyList[errorCode] || defaultKey || 'errorGeneral';
	                        var message;
	                        if (angular.isArray(contentKey)) {
	                            for (var i = 0; i < contentKey.length; i++) {
	                                message = $renderContent(contentBundle + '.' + contentKey[i], prop);
	                                if (message) {
	                                    break;
	                                }
	                            }
	                        } else {
	                            message = $renderContent(contentBundle + '.' + contentKey, prop);
	                        }
	
	                        messages.push(message);
	                    });
	
	                    return {
	                        msgs: messages,
	                        type: 'error'
	                    };
	                }
	            },
	
	            /**
	             * Highlight the Error Fields by ng-model
	             * @param errorData
	             * @param element
	             * @param modelPrefix
	             */
	            addFieldErrors: function addFieldErrors(errorData, element, modelPrefix) {
	
	                if (errorData.fields && errorData.fields.length) {
	                    errorData.fields.forEach(function (field) {
	                        var $field = $(element).find('[ng-model="' + (modelPrefix ? modelPrefix : '') + field.field + '"]');
	                        $field.addClass('backendError');
	                        $field.attr('aria-invalid', true);
	                    });
	                }
	                $(element).find('.backendError:first').focus();
	            },
	
	            /**
	             * Highlight the Error Fields by element name
	             * @param errorData
	             * @param element
	             * @param modelPrefix
	             */
	            addFieldErrorsByName: function addFieldErrorsByName(errorData, element, modelPrefix) {
	
	                if (errorData.fields && errorData.fields.length) {
	                    errorData.fields.forEach(function (field) {
	                        var fieldName = void 0;
	                        if (modelPrefix && field.field && field.field.length > 0) {
	                            // Add prefix with CamelCase of field name
	                            fieldName = modelPrefix + field.field[0].toUpperCase() + field.field.substring(1);
	                        } else {
	                            fieldName = field.field;
	                        }
	                        var $field = $(element).find('[name="' + fieldName + '"]');
	                        $field.addClass('backendError');
	                        $field.attr('aria-invalid', true);
	                    });
	                }
	                $(element).find('.backendError:first').focus();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/fi-contingency-list", "components/xo-wallet-components/src/fi-contingency-list/util.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/fi-contingency-list/contingencies.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var contingencyList = {
	        INSTRUMENT_COUNT_EXCEEDED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_COUNT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_COUNT_LIMIT_EXCEEDED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_COUNT_LIMIT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
	        INSTRUMENT_UNAVAILABLE: 'errorInstrumentUnavailable',
	        INSTRUMENT_REFUSED_DUE_TO_MAX_LIMIT: 'errorInstrumentRefused',
	        INSTRUMENT_REFUSED_DUE_TO_MAX_SHARED_INSTRUMENT_LIMIT: ['errorInstrumentUnavailable', 'errorInstrumentRefused'],
	        INSTRUMENT_ALREADY_EXISTS: 'errorInstrumentAlreadyExists',
	        INSTRUMENT_BILLING_ADDRESS_NOT_ACCEPTED: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_ADDRESS1: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_CITY: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_COUNTRY: 'errorInstrumentBillingAddressNotAccepted',
	        BILLING_DIFFERENT_COUNTRY: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
	        INSTRUMENT_UPDATE_NO_CHANGE: 'errorInstrumentUpdateNoChange',
	        INSTRUMENT_DUPLICATE_LIMIT_REACHED: 'errorInstrumentRefused',
	        NOT_ELIGIBLE_TO_EDIT_CARD: 'notEligibleToEditCard',
	        INTERNAL_ERROR: 'errorInternalError',
	        INSTRUMENT_REFUSED: 'errorInstrumentRefused',
	        INSTRUMENT_INTERNATIONAL: 'errorIssuerRejectIntl',
	        REJECT_REFUSED: ['errorIssuerReject', 'errorInstrumentRefused'],
	        PAYPAL_DEBIT_CARD_REFUSED: ['errorPaypalDebitRefused', 'errorGeneral'],
	        PAYPAL_CREDIT_CARD_REFUSED: ['errorPaypalCreditRefused', 'errorGeneral'],
	        PAYPAL_CARD_REFUSED: ['errorPaypalRefused', 'errorGeneral'],
	        EXCESSIVE_REJECTIONS: ['errorExcessiveRejectGuest', 'errorInstrumentRefused'],
	        CC_INVALID_CSC: ['errorCheckDigits', 'errorGeneral'],
	        INVALID_EXPIRATION_DATE: 'errorInvalidExpirationDate',
	        CHECK_DIGITS_NOT_PRESENT: ['errorCheckDigitsNotPresent', 'errorGeneral'],
	        REJECT_UNKNOWN: ['errorIssuerReject', 'errorInstrumentRefused'],
	        SETTLEMENT_DENIED: 'errorInstrumentRefused',
	        MAX_AMOUNT_EXCEEDED: ['errorMaxAmountExceeded', 'errorInstrumentRefused'],
	        ISSUER_ERROR: ['errorIssuerDenied', 'errorInstrumentRefused'],
	        MISSING_FIELD: ['errorInvalidData', 'errorGeneral'],
	        INVALID_PARAMETERS: ['errorInvalidData', 'errorGeneral'],
	        INVALID_DATA: ['errorInvalidData', 'errorGeneral'],
	        INVALID_ACCOUNT: ['errorInvalidAccount', 'errorGeneral'],
	        INVALID_INSTRUMENT_ID: ['errorInvalidAccount', 'errorGeneral'],
	        ACCOUNT_RESTRICTED: ['errorAccountRestricted', 'errorGeneral'],
	        ISSUER_RESTRICTED: ['errorIssuerReject', 'errorGeneral'],
	        ISSUER_REJECTED: ['errorIssuerReject', 'errorGeneral'],
	        ADDRESS_MISMATCH: 'errorInstrumentBillingAddressNotMatch',
	        CHECK_DIGITS_NOT_PROC: ['errorCheckDigitsNotPresent', 'errorGeneral'],
	        CHECK_DIGITS_UNSUPPORTED: ['errorCheckDigits', 'errorGeneral'],
	        CHECK_DIGITS_UNAVAILABLE: ['errorCheckDigits', 'errorGeneral'],
	        BILL_ADDR_UNAVAILABLE: ['errorInstrumentBillingAddressUnavailable', 'errorInstrumentBillingAddressNotAccepted'],
	        BILL_ADDR_UNSUPPORTED: ['errorInstrumentBillingAddressUnsupported', 'errorInstrumentBillingAddressNotAccepted'],
	        BILL_ADDR_UNAVAILABLE_GLOBAL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
	        BILL_ADDR_NOT_ALLOWED: ['errorInstrumentBillingAddressNotAccepted', 'errorAddressNotAllowed'],
	        BILL_ADDR_UNAVAILABLE_INTL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
	        INSTRUMENT_DISABLED: 'errorInstrumentRefused',
	        PI_TYPE_NOT_SUPPORTED: 'errorInvalidCCNumberOrType_global',
	        REJECT_AMEX_ADULT: ['errorAmexAdult', 'errorGeneral'],
	        INVALID_BANK_ROUTING_NUMBER: 'invalidRoutingNumber',
	        BANK_ROUTING_NUMBER_IS_EMPTY: 'invalidPINumber',
	        INVALID_BANK_ACCOUNT_NUMBER: 'invalidPINumber',
	        BANK_ACCOUNT_NUMBER_IS_EMPTY: 'invalidPINumber',
	        INVALID_BANK_IBAN: 'invalidPINumber',
	        INVALID_IBAN_CODE: 'invalidPINumber',
	        INVALID_BANK_IBAN_CONVERSION_ERROR: 'invalidPINumber',
	        INVALID_BENEFICIARY_FIRST_NAME: 'errorInvalidFirstName',
	        INVALID_BENEFICIARY_NAME: 'errorInvalidFirstName',
	        INVALID_BANK_BENEFICIARY_NUMBER: 'errorGeneral',
	        INVALID_BANK_ADDRESS: 'errorGeneral',
	        INVALID_CARD_NUMBER: 'errorInvalidCCNumberOrType',
	        INVALID_CARD_TYPE: 'errorInvalidCCNumberOrType',
	        INVALID_SECURITY_CODE: 'errorInvalidCSC',
	        INVALID_FIRST_NAME: 'errorInvalidFirstName',
	        INVALID_LAST_NAME: 'errorInvalidLastName',
	        INVALID_EXPIRY: 'errorInvalidExpirationDate',
	        INVALID_PHONE: 'errorInvalidPhone',
	        BANK_ADDRESS_IS_EMPTY: 'errorGeneral',
	        INVALID_BANK_BRANCH_NUMBER: 'errorGeneral',
	        ADD_REFUSED_DUE_TO_EXCEEDING_MAX_DUPLICATE_INSTRUMENT_LIMIT: 'errorInstrumentUnavailable',
	        EMPTY_DATA: 'errorGeneral',
	        ISSUER_DECLINE: 'errorIssuerReject',
	        WRONG_CONFIRMATION_VALUES: 'wrongConfirmationValue',
	        CONFIRMATION_RESEND_COUNT_EXCEEDED: 'resendValExceeded',
	        FREQUENT_REQUEST_VERIFICATION_CODE: 'frequentVerificationCodeReq',
	        TRANSACTION_TIMEOUT: 'transactionTimeout',
	        NOT_CONFIRMED: 'notConfirmed',
	        CONTACT_CARD_ISSUER_TO_VERIFY: 'issuerVerify',
	        CARD_NOT_ACTIVATED_FOR_UPOP: 'cardNotActivatedUpop',
	        RESTRICTED_CARD: 'cardRestricted',
	        INVALID_ONE_TIME_PASSWORD: 'errorInvalidOtpCode',
	        DUPLICATED_TRANSACTION: 'duplicateTransaction'
	
	    };
	
	    return contingencyList;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-ui-components/src/spinner-button/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner-button/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	    return angular.module('xo-spinner-button.directive', []).directive('xoSpinnerButton', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                track: '@',
	                onClick: '=',
	                buttonText: '@',
	                isProcessing: '=',
	                validate: '='
	            },
	            controller: function controller($scope) {
	
	                $scope.submit = function () {
	                    if ($scope.onClick) {
	                        $scope.onClick();
	                    } else {
	                        $scope.validate = true;
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner-button/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"spinnerBtn\" content>\n    <button track-submit={{track}} ng-click=\"submit()\" class=\"btn full\">\n        <div ng-show=\"isProcessing\" ng-class=\"{processing: isProcessing}\" class=\"spinner\"></div>\n        <div ng-hide=\"isProcessing\" class=\"text\" ng-bind-html=\"htmlContent(buttonText)\"></div>\n    </button>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/init/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"initOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent(flag('fields.expiry') ? 'confirmUpop.creditInitOtp' : 'confirmUpop.debitInitOtp')\"></div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.initOtp()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n        <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"flag('fields.expiry') || flag('fields.cvv')\">\n            <xo-card-expiry ng-if=\"flag('fields.expiry')\" expiry-month=\"cardmodel.card.expiry_month\" expiry-year=\"cardmodel.card.expiry_year\"></xo-card-expiry>\n            <xo-cvv ng-if=\"flag('fields.cvv')\" card=\"cardmodel.card\" show-label=\"true\"></xo-cvv>\n        </div>\n        <xo-phone-input token=\"token\" ng-if=\"flag('fields.phone')\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n\n        <xo-spinner-button track='init_otp_code' token=\"token\" validate=\"validated\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnsendOtpCode\"></xo-spinner-button>\n    </form>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/confirm/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _util = __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js");
	
	var _index = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/spinner-button/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/confirm/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var VERIFICATION_CODE_COUNTDOWN_IN_SECS = 180; // 3 minutes
	var RESEND_CODE_LINK_TIMEOUT_MILLI_SECS = 60000; // 1 minute
	var ONE_MINUTE_IN_SECS = 60;
	
	exports['default'] = _squid.$Component.extend('$xoConfirmOtpDirective', {
	    tag: 'xo-confirm-otp',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        phone: {
	            type: 'var',
	            required: false
	        },
	        cardmodel: {
	            type: 'var',
	            required: true
	        },
	        onSuccess: {
	            type: 'var',
	            required: true
	        },
	        message: {
	            type: 'var',
	            required: true
	        }
	    },
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	    actions: {
	        addMessage: function addMessage(type, contentKey) {
	            if (contentKey) {
	                this.message({
	                    msgKeys: [_angular2['default'].isArray(contentKey) ? contentKey[0] : contentKey],
	                    type: type || 'error'
	                });
	            }
	        },
	        stopConfirmCodeTimer: function stopConfirmCodeTimer() {
	            if (this.confirmCodeTimer) {
	                _angular.$interval.cancel(this.confirmCodeTimer);
	            }
	            this.countdown = 0;
	        },
	        stopResendCodeTimer: function stopResendCodeTimer() {
	            if (this.resendCodeTimer) {
	                _angular.$timeout.cancel(this.resendCodeTimer);
	            }
	            this.showResendLink = false;
	        },
	        updateCountdown: function updateCountdown() {
	            if (this.countdown > 0) {
	                this.countdown--;
	                this.timer = Math.floor(this.countdown / ONE_MINUTE_IN_SECS) + ':' + ('0' + this.countdown % ONE_MINUTE_IN_SECS).slice(-2);
	            } else {
	                if (!this.isConfirmProcessing) {
	                    this.actions.addMessage('warning', 'confirmUpop.codeExpired');
	                }
	                this.actions.stopConfirmCodeTimer();
	                this.actions.stopResendCodeTimer();
	            }
	        },
	        startCountdown: function startCountdown(resetTimer) {
	            var _this = this;
	
	            if (resetTimer) {
	                this.actions.stopConfirmCodeTimer();
	                this.countdown = VERIFICATION_CODE_COUNTDOWN_IN_SECS;
	                this.actions.updateCountdown();
	                this.confirmCodeTimer = (0, _angular.$interval)(this.actions.updateCountdown, 1000);
	            }
	
	            this.actions.stopResendCodeTimer();
	            this.showResendLink = false;
	            this.resendCodeTimer = (0, _angular.$timeout)(function () {
	                _this.showResendLink = true;
	            }, RESEND_CODE_LINK_TIMEOUT_MILLI_SECS);
	            this.actions.addMessage('success', 'confirmUpop.codeSent');
	        },
	        processed: function processed() {
	            if (!this.countdown && this.isConfirmProcessing) {
	                this.actions.addMessage('warning', 'confirmUpop.codeExpired');
	            }
	            this.isProcessing = this.isConfirmProcessing = false;
	        },
	        handleContingencies: function handleContingencies() {
	            var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var prop = arguments[1];
	
	            var errorData = void 0;
	            if (result.errorCodes) {
	                errorData = result;
	            } else {
	                errorData = {
	                    errorCodes: [result['0'] || 'ISSUER_DECLINE']
	                };
	            }
	
	            this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));
	
	            if (window.scrollTo) {
	                window.scrollTo(0, 0);
	            }
	        },
	        sendNewCode: function sendNewCode() {
	            // reset the code field.
	            if (this.cardmodel && this.cardmodel.card) {
	                this.cardmodel.card.otp_code = '';
	            }
	            this.actions.resendCode(true);
	        },
	        resendCode: function resendCode(resetTimer) {
	            var _this2 = this;
	
	            this.isProcessing = true;
	
	            this.resolveOTP.action('init', {
	                silent: true,
	                data: {
	                    phone: {
	                        country_code: this.phone.IntDialingCountryCode,
	                        number: this.phone.telephone
	                    }
	                },
	                resultModel: {},
	                success: function success() {
	                    _this2.actions.startCountdown(resetTimer);
	                },
	
	                error: function error() {
	                    _this2.actions.handleContingencies();
	                },
	
	                contingencies: {
	                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
	                        // prop for last 4 digits of card in error message
	                        var prop = {
	                            number: _this2.cardLast4
	                        };
	
	                        _this2.actions.handleContingencies(result, prop);
	                        _util.$fiErrorUtil.addFieldErrors(result, _this2.$element);
	                    },
	                    DEFAULT: function DEFAULT() {
	                        _this2.actions.handleContingencies();
	                    }
	                }
	            })['finally'](this.actions.processed);
	        },
	        confirmOTP: function confirmOTP() {
	            var _this3 = this;
	
	            this.isProcessing = this.isConfirmProcessing = true;
	
	            this.resolveOTP.action('complete', {
	                silent: true,
	                data: {
	                    code: this.cardmodel.card.otp_code,
	                    phone: {
	                        country_code: this.phone.IntDialingCountryCode,
	                        number: this.phone.telephone
	                    },
	                    card_data: {
	                        expiration_time: {
	                            month: this.cardmodel.card.expiry_month,
	                            year: this.cardmodel.card.expiry_year
	                        },
	                        card_verification_code: this.cardmodel.card.security_code
	                    }
	                },
	
	                success: this.onSuccess,
	
	                error: function error() {
	                    _this3.actions.handleContingencies({}, 'confirmUpop');
	                    _this3.actions.processed();
	                },
	
	                contingencies: {
	                    COMPLETE_OTP_CONTINGENCY: function COMPLETE_OTP_CONTINGENCY(name, result) {
	                        // prop for last 4 digits of card in error message
	                        var prop = {
	                            number: _this3.cardLast4
	                        };
	
	                        _this3.actions.handleContingencies(result, prop);
	                        _util.$fiErrorUtil.addFieldErrors(result, _this3.$element);
	                        _this3.actions.processed();
	                    }
	                }
	            })['catch'](function () {
	                _this3.actions.handleContingencies();
	                _this3.actions.processed();
	            });
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            var _this4 = this;
	
	            this.resolveOTP = new _index.$ResolveOTP({ id: this.cardmodel.id });
	            this.isProcessing = this.showResendLink = false;
	            this.cardLast4 = this.cardmodel.card.number.slice(-4);
	            this.phoneLast4 = this.phone && this.phone.telephone && this.phone.telephone.slice(-4);
	            this.actions.startCountdown(true);
	
	            this.$watch('isProcessing', function (isProcessing) {
	                if (isProcessing) {
	                    _this4.$element.addClass('processing');
	                } else {
	                    _this4.$element.removeClass('processing');
	                }
	            });
	            $('#upopConfirmation .modalContainer').focus();
	        }
	    }
	});
	
	
	_angular.$interval;
	
	_angular.$timeout;
	
	_squid.$Component;
	
	_util.$fiErrorUtil;
	
	_index.$ResolveOTP;
	
	_index2.$CheckoutSessionModel;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/confirm/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"confirmOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent('confirmUpop.verificationCodeMsg', {phoneLastFour: phoneLast4})\"></div>\n\n    <div class=\"timer\">\n        <span class=\"left\">{{content('confirmUpop.timeRemaining')}}</span>\n        <span class=\"timeLeft\">{{timer}} {{content('confirmUpop.minutes')}}</span>\n        <a link-button class=\"resendLink right focusableIcon\" href=\"\" ng-if=\"showResendLink\" ng-click=\"actions.resendCode(false)\">{{content('confirmUpop.resendCode')}}</a>\n    </div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.confirmOTP()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n        <div class=\"confirmFields\" ng-show=\"countdown || isConfirmProcessing\">\n            <div class=\"inputField confidential\">\n                <input id=\"otp_code\"\n                       class=\"otp_code\"\n                       type=\"tel\"\n                       ng-model=\"cardmodel.card.otp_code\"\n                       name=\"otp_code\"\n                       value=\"\"\n                       placeholder=\"{{ content('confirmUpop.verificationCodeHint') }}\"\n                       autocapitalize=\"off\"\n                       autocomplete=\"off\"\n                       aria-required=\"false\"\n                       required\n                       scroll-to-top\n                       data-error-text=\"{{ content('confirmUpop.fieldInvalidOTP') }}\"\n                       xo-error-tooltip/>\n\n            </div>\n            <xo-spinner-button track='confirm_otp_code' token=\"token\" validate=\"validated\"\n                               is-processing=\"isProcessing\" button-text=\"common.confirm\"></xo-spinner-button>\n        </div>\n    </form>\n    <div class=\"sendNewOtp\">\n        <xo-spinner-button ng-if=\"!countdown && !isConfirmProcessing\" track='resend_otp_code' token=\"token\" on-click=\"actions.sendNewCode\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnResendCode\"></xo-spinner-button>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/confirm-upop/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/confirm-upop/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#upopConfirmation .modalMask,#upopConfirmation .modalWrapper{position:fixed;top:0;bottom:0;left:0;right:0;z-index:10}#upopConfirmation .close{position:absolute;top:20px;right:20px;width:19px;height:19px;padding:5px;border-radius:3px}#upopConfirmation .close:before{content:\"\";position:absolute;width:19px;height:19px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .close:focus:before,#upopConfirmation .close:hover:before{background-position:-223px -22px}#upopConfirmation .modalMask{background:#cbd2d6;opacity:.7}#upopConfirmation .modalWrapperAnimation{-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}#upopConfirmation .modalWrapper{background:#fff;width:620px;-ms-box-sizing:border-box;box-sizing:border-box;left:50%;padding:80px 120px 0;overflow:auto;border-radius:5px;background-clip:padding-box;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}#upopConfirmation .modalWrapper .logo{position:relative;margin-top:-60px;width:25px;height:30px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#upopConfirmation .modalWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#upopConfirmation .modalContainer{min-height:99%;width:380px;display:block}#upopConfirmation .modalContainer .pushlogo{height:90px}#upopConfirmation .processing input{background-color:#f2f3f4}#upopConfirmation .upopOpen .modalWrapper{-webkit-transform:translate(-50%);transform:translate(-50%)}#upopConfirmation .upopConfirm .header{border-bottom:none}#upopConfirmation .upopConfirm .timingFields{padding-bottom:35px}#upopConfirmation .upopConfirm .counter{float:left}#upopConfirmation .upopConfirm a.resendCode{float:right}#upopConfirmation .upopConfirm #notifications{padding:0 0 5px}#upopConfirmation .expiration{display:inline-flex}#upopConfirmation .expiration .expires{position:relative;top:auto;left:auto}#upopConfirmation .expiration .expirationField{margin-right:10px}#upopConfirmation .expiration input.ng-invalid{padding-right:13px}#upopConfirmation .expiration label{margin-bottom:5px;color:#000}#upopConfirmation .telephoneField{clear:both;padding:0;float:none}#upopConfirmation .heading{margin:5px 0 10px;font-size:1.6em;font-family:HelveticaNeue-Light,Helvetica Neue Light,Helvetica,Arial,sans-serif}#upopConfirmation .timer{margin-bottom:20px}#upopConfirmation .timeLeft{margin-left:5px;font-weight:700}#upopConfirmation .confirmMsg{color:#6c7378;margin-bottom:20px}#upopConfirmation .resendLink{font-size:.85em}#upopConfirmation .btn{margin-top:10px}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#upopConfirmation .modalWrapper{width:100%;padding:60px 15px 0}#upopConfirmation .modalWrapper .modalContainer{width:auto}}#addCard.aside #upopConfirmation #notifications{padding:0 0 5px;margin-bottom:0}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-wallet-components/src/confirm-upop/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"upopConfirmation\">\n    <div class=\"upopConfirm\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper\" modal-box modal-cancel=\"closeModal()\" ng-class=\"{'modalWrapperAnimation': !fromLoginOverlay}\">\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <a link-button track-submit=\"{{collectOtpInput ? 'close_otp_init' : 'close_otp_confirm'}}\" class=\"close focusableIcon\" href=\"#\" ng-click=\"closeModal($event)\"></a>\n                <xo-message message=\"message\"></xo-message>\n                <div class=\"heading\" ng-bind-html=\"htmlContent('confirmUpop.heading', {acctLastFour: cardLast4})\"></div>\n\n                <xo-init-otp token=\"token\" message=\"setMessage\" phone=\"props.phone\" cardmodel=\"cardmodel\" on-success=\"initSuccess\" flag=\"flag\" ng-if=\"collectOtpInput\"></xo-init-otp>\n                <xo-confirm-otp token=\"token\" message=\"setMessage\" phone=\"props.phone\" cardmodel=\"cardmodel\" on-success=\"confirmed\" ng-if=\"!collectOtpInput\"></xo-confirm-otp>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"logo\"></div>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-credit-components/src/apply-ppc/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _directive = __webpack_require__("./components/xo-credit-components/src/apply-ppc/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Route.extend('$xoApplyPPCRoute', {
	    path: 'applyPPC',
	    directive: _directive2['default'],
	    loginRequired: true,
	    children: []
	});
	
	
	_squid.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-credit-components/src/apply-ppc/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	exports['default'] = _squid.$Component.extend('$xoApplyPPCDirective', {
	    tag: 'apply-ppc',
	    template: '<div></div>',
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        redirect: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            var _this = this;
	
	            var country = this.models.checkoutAppData.merchant.merchant_country;
	
	            return (0, _squid.$pxp)('xo_hermes_cape_migration', {
	                'ctx.COUNTRY': country
	            }, 'xo_cape_migration_test').then(function (result) {
	                if (result && result.treatment_name === 'xo_cape_migration_test') {
	                    _this.goto('checkout.redirectToCape');
	                } else {
	                    var queryString = _squid.$util.queryStringSplice(_squid.$util.queryString(), {
	                        'flow': '1-P',
	                        'token': _this.token,
	                        'applyCredit': '1'
	                    }, ['cmd']);
	
	                    throw new _squid.$FallbackError({
	                        reason: 'bml_not_supported',
	                        product: 'aries',
	                        entryPoint: 'bml',
	                        params: {
	                            state: queryString
	                        }
	                    });
	                }
	            });
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$FallbackError;
	
	_squid.$util;
	
	_squid.$pxp;
	
	_checkout.$CheckoutAppDataModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-login-components/src/onetouch-interstitial/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-onetouch-upsell.route', ['squid', 'xo-onetouch-upsell.directive']).factory('$OneTouchUpsellRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('OneTouchUpsellRoute', {
	
	            name: 'oneTouchUpsell',
	            directive: 'xo-onetouch-upsell',
	            trackingData: {
	                fptiState: 'onetouch-upsell',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::onetouch-upsell',
	                        'pagename2': '%::onetouch-upsell:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            query: ['oneTouchFlowName'],
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/onetouch-interstitial", "components/xo-login-components/src/onetouch-interstitial/route.js"))

/***/ },

/***/ "./components/xo-login-components/src/onetouch-interstitial/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _ul = __webpack_require__("./components/xo-login-components/src/unified-login/ul.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/onetouch-interstitial/template.html"), __webpack_require__("./components/xo-ui-components/src/accessibility/ui.js"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js"), __webpack_require__("./components/xo-tracking/dist/index.js"), __webpack_require__("./components/ul-inline/dist/inject.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template, ui) {
	
	    return angular.module('xo-onetouch-upsell.directive', ['squid', 'xolocale', 'tracking', 'xo-device-info']).directive('xoOnetouchUpsell', function () {
	
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                onComplete: '=',
	                disableCloseButton: '=',
	                ignoreBgClicks: '='
	            },
	            controller: function controller($scope, $rootScope, $state, $element, $timeout, $logger, $KmliUpsell, $LocaleModel, $locale, $CalDataModel, $config, $meta, $DeviceInfo, $stateParams, $AuthModel) {
	                $scope.oneTouchFlowName = $stateParams.oneTouchFlowName;
	                $scope.modalActive = false;
	                $scope.locale = $LocaleModel.instance();
	                $scope.disableCloseButton = $scope.disableCloseButton || $DeviceInfo.isDevice();
	                $scope.upsellOptInDisplayed = false;
	                var ulMeta = $config.ulMeta || {};
	                var PAYPAL = window.PAYPAL || {};
	                var ulTimeOutValue = 5000;
	                var ulTimeoutPromise = null;
	
	                var fptiData = $KmliUpsell.getFPTIAttributes();
	                $KmliUpsell.eligible().then(function (eligibility) {
	                    if (eligibility && eligibility.interstitial && eligibility.interstitial.color) {
	                        $scope.color = eligibility.interstitial.color;
	                    }
	                });
	
	                function closeInterstitial(params) {
	                    $('#wrapper > xo-spinner').attr('style', '');
	                    $('body').removeClass('kmliUpsellActive');
	                    $element.removeClass('upsellOpen');
	                    $scope.onComplete(params);
	                }
	
	                function failureHandler(reason) {
	                    $logger.info('KMLI_UPSELL_error_' + reason);
	                    closeInterstitial();
	                }
	
	                var startTimerTS;
	                function startTimer(tag) {
	                    startTimerTS = Date.now();
	                    $logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
	                        startTime: startTimerTS
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'Interstitial_Timer',
	                        'to': 'prepare_' + tag
	                    });
	
	                    ulTimeoutPromise = $timeout(function () {
	                        var stop_time = Date.now();
	                        var time_taken = stop_time - startTimerTS;
	                        $logger.info('checkout_fpti', {
	                            'from': 'Interstitial_Timer',
	                            'to': 'process_timeout',
	                            'int_error_code': 'ULLOGIN_TIMEOUT',
	                            'int_error_description': 'ULLOGIN_TIMEOUT',
	                            'error_source': 'unifiedloginnodeweb',
	                            'error_type': 'soft_decline',
	                            'page_load_time': time_taken
	                        });
	                        failureHandler('timedout');
	                        $rootScope.$emit('loaded');
	                    }, ulTimeOutValue);
	                }
	
	                function stopTimer(tag) {
	                    var stopTimerTS = Date.now();
	                    var timeTaken = stopTimerTS - startTimerTS;
	                    $logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
	                        stopTimer: stopTimerTS,
	                        page_load_time: timeTaken
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'Interstitial_Timer',
	                        'to': 'process_' + tag,
	                        'page_load_time': timeTaken
	                    });
	
	                    if (ulTimeoutPromise) {
	                        $timeout.cancel(ulTimeoutPromise);
	                    }
	                }
	
	                function logSubmit(data) {
	                    var fptiPayload = {
	                        'from': fptiData.stateName,
	                        'to': 'process' + fptiData.transInfix + 'optin'
	                    };
	                    if (data && data.errorCode) {
	                        angular.extend(fptiPayload, {
	                            'int_error_code': data.errorCode,
	                            'error_type': 'hard_decline',
	                            'error_source': 'unifiedloginnodeweb'
	                        });
	                    }
	                    $logger.info('checkout_fpti', fptiPayload);
	                }
	
	                $scope.hideModal = function (event) {
	                    if (event) {
	                        event.preventDefault();
	                    } else if ($scope.ignoreBgClicks) {
	                        return;
	                    }
	
	                    $logger.info('checkout_fpti', {
	                        'from': fptiData.stateName,
	                        'to': 'process' + fptiData.transInfix + 'decline',
	                        'click_source': 'close_button'
	                    });
	
	                    closeInterstitial();
	                };
	
	                var ulEventHandlers = {
	                    'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        $('#wrapper > xo-spinner').hide();
	                        $('body').addClass('kmliUpsellActive');
	
	                        // CSS transition to open upsell modal and set modal to trap focus after open
	                        $timeout(function () {
	                            $element.addClass('upsellOpen');
	                            $element.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
	                                $scope.$apply(function () {
	                                    $scope.modalActive = true;
	                                    // Focus Continue button in iframe
	                                    $('#injectedOneTouchInterstitial').focus();
	
	                                    var escHandler = function escHandler(event) {
	                                        if (event.keyCode === ui.KEYS.ESC) {
	                                            $scope.hideModal();
	                                        }
	                                    };
	
	                                    // Add handler to iframe document, as events do not propagate past the iframe
	                                    $element.find('iframe').contents().on('keydown', escHandler);
	                                    $element.on('keydown', escHandler);
	                                });
	                            });
	                        });
	                    },
	                    'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
	                        $rootScope.$emit('loading');
	                        startTimer(data.event);
	                    },
	                    'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        logSubmit();
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        logSubmit({ errorCode: data.event });
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
	                        stopTimer(data.event);
	                        logSubmit({ errorCode: data.event });
	                        $rootScope.$emit('loaded');
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
	                        $logger.info('checkout_fpti', {
	                            'from': fptiData.stateName,
	                            'to': 'process' + fptiData.transInfix + 'decline',
	                            'click_source': 'not_now_link'
	                        });
	                        closeInterstitial(data);
	                    }
	                };
	
	                function postMessageHandler(response) {
	                    $timeout(function () {
	                        $logger.info('ul_postmessaged_received', response);
	                        var data = response.data || response.error;
	                        var eventId = data && data.event;
	                        if (eventId) {
	                            $logger.debug('KMLI_UPSELL_' + eventId, response);
	                            var handler = ulEventHandlers[eventId];
	                            if (handler) {
	                                handler(data);
	                            }
	                        }
	                    });
	                }
	
	                function upsellOptInDisplayed() {
	                    return $AuthModel.instance().retrieve().then(function (auth) {
	                        if (auth.upsellOptInDisplayed) {
	                            $scope.upsellOptInDisplayed = true;
	                        }
	                    });
	                }
	
	                function loadOneTouchUpsell() {
	                    upsellOptInDisplayed().then(function () {
	                        // If the optin upsell is already displayed, no need to display again.
	                        if ($scope.upsellOptInDisplayed) {
	                            $scope.onComplete();
	                        } else {
	                            $rootScope.$emit('loading');
	
	                            var options = {
	                                targetElement: document.getElementById('injectedOneTouchInterstitial'),
	                                queryParams: {
	                                    'stsRedirectUri': ulMeta.stsReturnUrl,
	                                    'country.x': $scope.locale.country,
	                                    'locale.x': $scope.locale.getLocaleCode(),
	                                    'flowId': $scope.token,
	                                    'correlationId': $CalDataModel.getCalCorrId(),
	                                    'flowName': $scope.oneTouchFlowName
	                                },
	                                iframePathname: '/signin/activate-one-touch',
	                                onPostMessage: postMessageHandler
	                            };
	
	                            angular.extend(options.queryParams, $KmliUpsell.getOptions());
	
	                            if ($config.deploy.isLocal()) {
	                                if ($meta.stage) {
	                                    options.origin = 'https://' + $meta.stage;
	                                } else {
	                                    // if no stage url shows up then use any backup url for origin
	                                    options.origin = $config.onboarding.url.split('/webapps/')[0];
	                                }
	                            }
	
	                            if (PAYPAL && PAYPAL.unifiedLogin) {
	                                startTimer('initializeUpsell');
	                                PAYPAL.unifiedLogin.inject(options);
	                            } else {
	                                failureHandler('PAYPAL.unifiedLogin_undefined');
	                            }
	                        }
	                    });
	                }
	
	                $timeout(function () {
	                    $element.addClass('upsellOpen');
	                });
	
	                $scope.optinOneTouch = function () {
	                    var flowName = 'checkoutInterstitial'; // login interstitial flow
	                    var silent = true;
	                    return _ul.$ul.optInToOneTouch($scope.token, $locale.country, $locale.getLocaleCode(), silent, fptiData, flowName).then(closeInterstitial({ isKmliSet: true }))['catch'](function (error) {
	                        closeInterstitial({
	                            isKmliSet: false,
	                            error: error
	                        });
	                    });
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_ul.$ul;

/***/ },

/***/ "./components/xo-login-components/src/unified-login/ul.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ul = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	var _model = __webpack_require__("./components/xo-tracking/dist/model.js");
	
	/**
	 * Created by upigilam on 4/8/16.
	 * UL handler is to exchange ST to RT exchanges.
	 */
	
	var $ul = exports.$ul = {
	
	    optInToOneTouch: function optInToOneTouch(token, locale_country, locale_code, silent, fptiData, flowName) {
	
	        return (0, _angular.$q)(function (resolve, reject) {
	
	            var PAYPAL = window.PAYPAL || {};
	            var ulTimeOutValue = 10000;
	            var ulTimeoutPromise = null;
	
	            function logSubmit(data) {
	                var fptiPayload = {
	                    'from': fptiData && fptiData.stateName ? fptiData.stateName : 'poma_page',
	                    'to': fptiData && fptiData.transInfix ? fptiData.transInfix : 'process_kmli_optin'
	                };
	                if (data && data.errorCode) {
	                    angular.extend(fptiPayload, {
	                        'int_error_code': data.errorCode,
	                        'error_type': 'hard_decline',
	                        'error_source': 'unifiedloginnodeweb'
	                    });
	                }
	                _logger.$logger.info('checkout_fpti', fptiPayload);
	            }
	
	            function failureHandler(reason) {
	                logSubmit({ errorCode: reason });
	                _logger.$logger.info('UL_Loading_error_' + reason);
	                return reject(new Error('UL_Loading_error_' + reason));
	            }
	
	            function startTimer(tag) {
	                _logger.$logger.info('UL_START_TIMER_' + tag);
	                ulTimeoutPromise = (0, _angular.$timeout)(function () {
	                    failureHandler('timed_out');
	                    if (!silent) {
	                        _angular.$rootScope.$emit('loaded');
	                    }
	                }, ulTimeOutValue);
	            }
	
	            function stopTimer(tag) {
	                if (!silent) {
	                    _angular.$rootScope.$emit('loaded');
	                }
	                _logger.$logger.info('UL_STOP_TIMER_' + tag);
	
	                if (ulTimeoutPromise) {
	                    _angular.$timeout.cancel(ulTimeoutPromise);
	                    ulTimeoutPromise = null;
	                }
	            }
	
	            var ulEventHandlers = {
	                'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
	                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
	                },
	                'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
	                    // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
	                },
	                'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
	                    stopTimer(data.event);
	                    logSubmit();
	                    // UL will drop RT cookie and respond oneTouchInterstitialOptInSuccess postmessage.
	                    return resolve();
	                },
	                'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
	                    stopTimer(data.event);
	                    failureHandler(data.event);
	                },
	                'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
	                    // removing the element - ulTargetAttribute from DOM, to avoid any other accidental
	                    // actions on the element which is causing excess spinners later.
	                    var child = document.getElementById('ulTargetAttribute');
	                    child.parentNode.removeChild(child);
	                    stopTimer(data.event);
	                    failureHandler(data.event);
	                }
	            };
	
	            function postMessageHandler(response) {
	                (0, _angular.$timeout)(function () {
	                    _logger.$logger.info('ul_postmessaged_received', response);
	                    var data = response.data || response.error;
	                    var eventId = data && data.event;
	                    if (eventId) {
	                        _logger.$logger.debug('UL' + eventId, response);
	                        var handler = ulEventHandlers[eventId];
	                        if (handler) {
	                            handler(data);
	                        }
	                    }
	                });
	            }
	
	            function loadOneTouchUpsell() {
	                if (!silent) {
	                    _angular.$rootScope.$emit('loading');
	                }
	
	                var ulTargetAttribute = document.createElement('div');
	                ulTargetAttribute.setAttribute('id', 'ulTargetAttribute');
	
	                // setting display to None leading FireFox hiding all the ul elements due to which body click doesn't work
	                // ulTargetAttribute.style.display = "None";
	
	                // Making 0px, it works for FF, Chrome, Safari
	                ulTargetAttribute.style.width = '0px';
	                ulTargetAttribute.style.margin = '0px';
	                ulTargetAttribute.style.height = '0px';
	                ulTargetAttribute.style.padding = '0px';
	
	                document.body.appendChild(ulTargetAttribute);
	
	                var options = {
	                    targetElement: document.getElementById('ulTargetAttribute'),
	                    queryParams: {
	                        'country.x': locale_country,
	                        'locale.x': locale_code,
	                        'flowId': token,
	                        'correlationId': _model.$CalDataModel.getCalCorrId(),
	                        'flowName': flowName ? flowName : 'checkoutOnlyMember' // default is poma flow
	                    },
	                    iframePathname: '/signin/activate-one-touch',
	                    onPostMessage: postMessageHandler
	                };
	
	                if (_config.$config.deploy.isLocal()) {
	                    if (_config.$meta.stage) {
	                        options.origin = 'https://' + _config.$meta.stage;
	                    } else {
	                        // if no stage url shows up then use any backup url for origin
	                        options.origin = _config.$config.onboarding.url.split('/webapps/')[0];
	                    }
	                }
	
	                if (PAYPAL && PAYPAL.unifiedLogin) {
	                    startTimer('initializeUl');
	                    PAYPAL.unifiedLogin.inject(options);
	                } else {
	                    failureHandler('PAYPAL.unifiedLogin_undefined');
	                }
	            }
	
	            loadOneTouchUpsell();
	        });
	    }
	};
	
	angular.value("$ul", $ul);
	_angular.$rootScope;
	
	_angular.$q;
	
	_angular.$timeout;
	
	_logger.$logger;
	
	_config.$config;
	
	_config.$meta;
	
	_model.$CalDataModel;

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/onetouch-interstitial/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"kmliUpsell\" ng-class=\"{mobile: isDevice}\" content>\n\n    <div ng-if=\"ulUpsell\">\n        <!-- =============================================\n                Regular interstial (also used by POMA)\n            ============================================== -->\n        <div class=\"upsellMask\"></div>\n        <div class=\"upsellWrapper\" simple-modal=\"modalActive\" modal-cancel=\"hideModal()\">\n            <div class=\"upsellContainer\">\n                <xo-spinner></xo-spinner>\n                <div class=\"aside\">\n                    <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\" ng-hide=\"disableCloseButton\" aria-label=\"{{content('common.back')}}\"></a>\n                    <section class=\"login\" id=\"login\">\n                        <div id=\"injectedOneTouchInterstitial\" tabindex=\"-1\">\n                        </div>\n                    </section>\n                </div>\n                <div class=\"pushLogo\"></div>\n            </div>\n            <div class=\"logo\"></div>\n        </div>\n    </div>\n\n    <div ng-if=\"!ulUpsell\">\n        <!-- ===========================\n                RYI optin interstial\n            ============================ -->\n        <div class=\"upsellMask_white\"></div>\n        <div class=\"upsellWrapper\" ng-class=\"{whiteWithBlur: color === 'white' , blackWithBlur: color === 'black'}\" simple-modal=\"modalActive\" modal-cancel=\"hideModal()\">\n            <div class=\"upsellContainer\">\n                <div class=\"fill\"></div>\n                <div class=\"aside\">\n                    <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\" ng-hide=\"disableCloseButton\" aria-label=\"{{content('common.back')}}\"></a>\n                    <section class=\"login\" id=\"login\">\n                        <div class=\"promoHeading\" ng-bind-html=\"content('oneTouchUpsell.promoHeading')\"></div>\n                        <div class=\"promo\">\n                            <div class=\"icon password\"></div>\n                            <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText1')\"></div>\n                        </div>\n                        <div class=\"promo\">\n                            <div class=\"icon merchants\"></div>\n                            <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText2')\"></div>\n                        </div>\n                        <div class=\"promo\">\n                            <div class=\"icon secure\"></div>\n                            <div class=\"text\" ng-bind-html=\"content('oneTouchUpsell.promoText3')\"></div>\n                        </div>\n                        <div class=\"buttons\">\n                            <input type=\"button\" value=\"{{content('common.activate')}}\" class=\"btn full\" ng-click=\"optinOneTouch()\">\n                            <div class=\"cancel\">\n                                <a href=\"#\" prevent-default ng-click=\"hideModal($event)\">{{content('common.noThanks')}}</a>\n                            </div>\n                        </div>\n                    </section>\n                </div>\n                <div class=\"pushLogo\"></div>\n            </div>\n            <div class=\"logo\" id=\"pp_min_logo\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-sidebar/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	__webpack_require__("./components/xo-wallet-components/src/add-bank/route.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/add-shipping/route.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/delete-shipping/route.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/update-shipping/route.js");
	
	__webpack_require__("./pages/xo-shipping/route.js");
	
	__webpack_require__("./pages/xo-sidebar/directive.js");
	
	__webpack_require__("./pages/xo-sidebar-add-shipping/route.js");
	
	__webpack_require__("./pages/xo-sidebar-update-shipping/route.js");
	
	__webpack_require__("./pages/xo-sidebar-add-card/route.js");
	
	__webpack_require__("./pages/xo-sidebar-add-bank/route.js");
	
	__webpack_require__("./pages/xo-sidebar-currency-conversion/route.js");
	
	__webpack_require__("./pages/xo-sidebar-installment-options/route.js");
	
	__webpack_require__("./pages/xo-wallet/route.js");
	
	var _route = __webpack_require__("./pages/xo-sidebar-manage-wallet/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _route3 = __webpack_require__("./pages/xo-sidebar-update-card/route.js");
	
	var _route4 = _interopRequireDefault(_route3);
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$SidebarRoute', {
	
	    path: 'sidebar',
	    directive: 'xo-sidebar',
	    children: [{
	        name: '$SidebarShippingRoute',
	        attributes: {
	            token: 'props.token'
	        }
	    }, {
	        name: '$SidebarAddShippingRoute',
	        attributes: {
	            token: 'props.token'
	        }
	    }, {
	        name: '$SidebarAddCardRoute',
	        attributes: {
	            token: 'props.token',
	            promotion: 'props.promotion'
	        }
	    }, {
	        name: '$SidebarAddBankRoute',
	        attributes: {
	            token: 'props.token'
	        }
	    }, {
	        name: '$SidebarWalletRoute',
	        props: function props() {
	            return {
	                token: this.props.token,
	                promotion: this.props.promotion,
	                installment: this.props.installment
	            };
	        },
	        config: function config() {
	            return {
	                heading: 'asideHeader.fundingInstruments',
	                subHeading: 'asideHeader.fundingInstrumentsSubHead',
	                addRoute: 'checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'
	            };
	        }
	    }, {
	        name: '$AddBankFlowRoute',
	        attributes: {
	            token: 'props.token',
	            'parent-callbacks': 'callbacks'
	        }
	    }, {
	        name: '$AddCardPageRoute',
	        attributes: {
	            token: 'props.token',
	            'parent-callbacks': 'callbacks'
	        }
	    }, {
	        name: '$AddShippingRoute',
	        attributes: {
	            token: 'props.token',
	            'parent-callbacks': 'callbacks',
	            'done-fn': 'callbacks.done',
	            sidebar: 'sidebar',
	            update: 'props.update'
	        }
	    }, {
	        name: '$UpdateShippingRoute',
	        attributes: {
	            token: 'props.token',
	            'parent-callbacks': 'callbacks',
	            'done-fn': 'callbacks.done',
	            sidebar: 'sidebar'
	        }
	    }, {
	        name: '$DeleteShippingRoute',
	        attributes: {
	            token: 'props.token',
	            'parent-callbacks': 'callbacks',
	            sidebar: 'sidebar'
	        }
	    }, {
	        name: '$SidebarCurrencyConversionRoute',
	        attributes: {
	            token: 'props.token'
	        }
	    }, {
	        name: '$SidebarInstallmentOptionsRoute',
	        attributes: {
	            token: 'props.token'
	        }
	    }, {
	        route: _route2['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }, {
	        route: _route4['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }]
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/directive.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/addbank/route.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/sepa/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-bank.route', ['squid', 'xo-add-bank.directive', 'xo-add-bank.addbank.route', 'xo-add-bank.sepa.route']).factory('$AddBankFlowRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('BankRoute', {
	            name: 'bank',
	            directive: 'xo-add-bank-flow',
	            titleContent: 'asideHeader.addBank',
	            children: [{
	                name: '$XOAddBankRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-callbacks': 'callbacks',
	                    'error-message': 'errorMessage',
	                    bank: 'bank',
	                    sidebar: 'sidebar',
	                    hideparenthead: 'hideparenthead',
	                    'page-level': 'pageLevel'
	                }
	            }, {
	                name: '$XOSepaRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-callbacks': 'callbacks',
	                    model: 'bank',
	                    sidebar: 'sidebar',
	                    hideparenthead: 'hideparenthead'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-bank", "components/xo-wallet-components/src/add-bank/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    return squid.module('xo-add-bank.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xo-message.directive', 'xo-error-tooltip.directive', 'fi.errorUtil']).directive('xoAddBankFlow', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                sidebar: '=',
	                hideparenthead: '=',
	                pageLevel: '='
	            },
	
	            controller: function controller($scope, $rootScope, $AddBankModel, $CheckoutCartModel, $populate, $CheckoutSessionModel, $state, $locale, $element, $fiErrorUtil) {
	
	                function handleContingency(name, result) {
	
	                    $scope.errorMessage = $fiErrorUtil.addPageErrors(result, 'bank');
	                    $fiErrorUtil.addFieldErrors(result, $element, 'model.');
	                    $state.go('^.add');
	                }
	
	                function updateFundingOptions() {
	                    $scope.checkoutSession.fundingOptions.action('update', {
	
	                        resultModel: $scope.checkoutSession,
	
	                        data: {
	                            planId: $scope.bankId
	                        },
	                        success: function success(result) {
	
	                            $scope.checkoutSession.message = {
	                                type: 'success',
	                                msgKeys: ['paymentMethod.paymentMethodUpdated']
	                            };
	                            $scope.parentCallbacks.done();
	                        },
	                        contingencies: {
	                            ADD_BANK_CONTINGENCY: handleContingency
	                        }
	
	                    });
	                }
	
	                $scope.callbacks = {
	
	                    addBankDone: function addBankDone(bank) {
	                        $scope.bank = bank;
	                        $state.go('^.sepa');
	                    },
	
	                    sepaDone: function sepaDone() {
	
	                        $populate($scope, {
	                            checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                            cart: $CheckoutCartModel.instance($scope.token)
	                        }).then(function () {
	
	                            $scope.locale = $locale;
	
	                            var addBankReq = $scope.bank.getBankData();
	                            $scope.bank.action('add', {
	
	                                data: addBankReq,
	
	                                resultModel: {},
	
	                                success: function success(data) {
	
	                                    $scope.bankId = data.id;
	                                    var sepaStatus = data.sepaStatus;
	                                    if (sepaStatus === 'AUTHORIZED') {
	                                        return updateFundingOptions();
	                                    }
	                                    $scope.bank.action('sepaAccept', {
	
	                                        data: {
	                                            bank: {
	                                                id: data.id
	                                            }
	                                        },
	
	                                        resultModel: {},
	
	                                        success: updateFundingOptions,
	                                        contingencies: {
	                                            DEFAULT: handleContingency
	                                        }
	
	                                    });
	                                },
	
	                                contingencies: {
	                                    ADD_BANK_CONTINGENCY: handleContingency
	                                }
	
	                            });
	                        });
	                    }
	
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/template.html":
/***/ function(module, exports) {

	module.exports = "<div ui-view></div>"

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/addbank/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/addbank/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-bank.addbank.route', ['squid', 'xo-add-bank.addbank.directive']).factory('$XOAddBankRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddRoute', {
	
	            name: 'add',
	            titleContent: 'asideHeader.addBank',
	            directive: 'xo-add-bank',
	            trackingData: {
	                fptiState: 'add_bank'
	            },
	            loginRequired: true,
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-bank/addbank", "components/xo-wallet-components/src/add-bank/addbank/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/addbank/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/addbank/template.html"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/bank-input/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-ui-components/src/popup/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return squid.module('xo-add-bank.addbank.directive', ['squid', 'xomodel.fi', 'xomodel.checkout', 'xomodel.auth', 'xo-add-bank.bank-input.directive', 'xo-message.directive', 'xo-popup.directive', 'xo-tray-height.directive', 'xo-aside-header.directive', 'xo-error-tooltip.directive', 'fi.errorUtil']).directive('xoAddBank', function () {
	        return {
	            template: template,
	
	            scope: {
	                parentCallbacks: '=',
	                errorMessage: '=',
	                bank: '=',
	                sidebar: '=',
	                hideparenthead: '=',
	                message: '=',
	                pageLevel: '='
	            },
	
	            controller: function controller($scope, $populate, $AddBankModel, $BillingAddressesModel, $AuthModel, $element, $locale, $fiErrorUtil) {
	                $scope.model = $scope.bank || new $AddBankModel({
	                    id: 123
	                });
	
	                $scope.locale = $locale;
	
	                if ($scope.hideparenthead) {
	                    $scope.hideparenthead.toggle = false;
	                }
	
	                $scope.onSubmit = function () {
	                    if ($scope.pageLevel) {
	                        $scope.pageLevel.message = null;
	                    }
	
	                    var data = $scope.model.getBankData();
	
	                    function mapValidationErrors(err) {
	                        var fields = err && err.fields || [];
	                        fields.forEach(function (fieldError) {
	                            if (fieldError && fieldError.property) {
	                                fieldError.field = fieldError.property;
	                            }
	                        });
	                        return {
	                            fields: fields
	                        };
	                    }
	
	                    $scope.model.action('validate', {
	
	                        data: data,
	
	                        resultModel: {},
	
	                        success: function success(successData) {
	                            $scope.model.creditorDetails = successData.creditorDetails;
	                            $scope.model.fiDetails = successData.fiDetails;
	                            $scope.parentCallbacks.addBankDone($scope.model);
	                        },
	
	                        contingencies: {
	                            VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, contingencyData) {
	                                $scope.errorMessage = $fiErrorUtil.addPageErrors(contingencyData, 'bank');
	                                $fiErrorUtil.addFieldErrors(contingencyData, $element, 'model.');
	                            }
	                        },
	                        validation: function validation(res) {
	                            $fiErrorUtil.addFieldErrors(mapValidationErrors(res), $element, 'model.');
	                        }
	                    });
	                };
	
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    billingAddresses: $BillingAddressesModel.instance()
	
	                }).then(function () {
	
	                    $scope.model.address = $scope.billingAddresses.addresses && $scope.billingAddresses.addresses[0];
	
	                    $scope.model.user.first_name = $scope.auth.first_name;
	                    $scope.model.user.last_name = $scope.auth.last_name;
	                    $scope.model.user.country = $scope.model.address && $scope.model.address.country;
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/addbank/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-aside-header back-url=\"checkout.review.sidebar.wallet\" heading='asideHeader.addBank' ng-if=\"sidebar\"></xo-aside-header>\n<xo-message message=\"errorMessage\"></xo-message>\n<div class=\"container\" ng-class=\"{asideContent: sidebar}\" xo-tray-height>\n\t<form id=\"bankForm\" name=\"bankForm\" method=\"post\" class=\"asideProceed formSmall\" novalidate=\"novalidate\">\n        <div id=\"bankFields\" class=\"clearfix\" content>\n\n\n            <div id=\"name\" class=\"fieldGroup clearfix\">\n                <div class=\"inputField  half confidential firstname\">\n                    <label for=\"firstName\" class=\"focus accessAid\">\n                        {{ content('common.firstName') }}\n                    </label>\n                    <input ng-model=\"model.user.first_name\" name=\"firstName\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('common.firstName') }}\" xo-error-tooltip required />\n                </div>\n\n                <div class=\"inputField half last-child confidential lastname\">\n                    <label for=\"lastName\" class=\"focus accessAid\">\n                        {{ content('common.lastName') }}\n                    </label>\n                    <input ng-readonly=\"model.user.last_name\" ng-model=\"model.user.last_name\" name=\"lastName\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('common.lastName') }}\" xo-error-tooltip required />\n                </div>\n            </div>\n\n            <xo-bank-input user=\"model.user\" bank=\"model.bank\"></xo-bank-input>\n\n            <p class=\"infoTxt secondary \" data-ng-bind-html=\"htmlContent( 'bank.addBankDisclaimer') \"></p>\n\n            <div class=\"buttons\">\n                <input track-submit id=\"proceedButton\" type=\"submit\" value=\"{{ content('common.continuetext') }}\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n            </div>\n        </div>\n    </form>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/bank-input/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/bank-input/template.html"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-add-bank.bank-input.directive', ['squid', 'xomodel.fi', 'xo-dropdown.directive', 'xo-error-tooltip.directive']).directive('xoBankInput', function ($rootScope) {
	        return {
	            template: template,
	
	            scope: {
	                user: '=',
	                bank: '='
	            },
	
	            /* auto formatting the user entered IBAN input */
	            link: function link(scope, element, attr) {
	                var IBANMask = 'AA00 0000 0000 0000 0000 0000 0000 0000 00';
	
	                element.on('keyup', function (event) {
	
	                    $('#ibanNumber').mask(IBANMask, {
	                        'translation': {
	                            0: { pattern: /[A-Za-z0-9]/ }
	                        }
	                    });
	                });
	            },
	
	            controller: function controller($scope, $AddBankModel) {
	
	                $scope.showIBAN = false;
	
	                var days = [];
	                var months = [];
	                var years = [];
	
	                var i;
	                for (i = 1; i <= 31; i += 1) {
	                    var d = i < 10 ? '0' + i : i.toString();
	                    days.push(d);
	                }
	
	                for (i = 1; i <= 12; i += 1) {
	                    var m = i < 10 ? '0' + i : i.toString();
	                    months.push(m);
	                }
	
	                var year = new Date().getFullYear();
	
	                for (i = year - 17; i >= year - 100; i -= 1) {
	                    years.push(i);
	                }
	
	                $scope.days = days;
	                $scope.months = months;
	                $scope.years = years;
	
	                $scope.toggleIBAN = function () {
	                    $scope.showIBAN = !$scope.showIBAN;
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/bank-input/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"bankFields\" content>\n\n    <div class=\"bban\" ng-if = \"!showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterBBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadIBAN')}}</a>\n        </p>\n\n        <div class=\"inputField restricted\">\n            <label for=\"bankAccountNumber\" class=\"accessAid nolap\">\n                {{content('DEMemberGuest.account')}}\n            </label>\n            <input id=\"bankAccountNumber\" name=\"bankAccountNumber\" type=\"text\" value=\"\" ng-model=\"bank.bank_account_number\" placeholder=\"{{content('DEMemberGuest.accountPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"10\" aria-required=\"true\"\n                   xo-validation='{\n                \"validator\": \"validBankAccount\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-text=\"{{content('scripts.validNumber')}}\" xo-error-tooltip />\n        </div>\n\n        <div class=\"inputField restricted\">\n            <label for=\"blz\" class=\"accessAid nolap\">\n                {{content('DEMemberGuest.sort')}}\n            </label>\n            <input id=\"blz\" name=\"blz\" type=\"text\" value=\"\" ng-model=\"bank.bank_routing_number\" placeholder=\"{{content('DEMemberGuest.sortPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"8\" aria-required=\"true\"  xo-validation='{\n                \"validator\": \"validRouting\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-text=\"{{content('scripts.validNumber')}}\" xo-error-tooltip />\n        </div>\n    </div>\n    <div class=\"iban\" ng-if=\"showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterIBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadBBAN')}}</a>\n        </p>\n        <div class=\"inputField restricted\">\n            <label for=\"ibanNumber\" class=\"accessAid nolap\">\n                {{content('bank.iban')}}\n            </label>\n            <input id=\"ibanNumber\" name=\"ibanNumber\" type=\"text\" value=\"\" placeholder=\"{{content('bank.IBANPlaceholder')}}\" autocomplete=\"off\" maxlength=\"42\" aria-required=\"true\" ng-model=\"bank.iban_number\" xo-validation='{ \"validator\": \"validIBANWithValidCountryCode\",\n            \"required\":  \"{{showIBAN}}\"} ' data-error-text=\"{{content('scripts.validIBAN')}}\" xo-error-tooltip />\n        </div>\n    </div>\n\n    <div id=\"dobBank\" class=\"dobbank\">\n        <fieldset>\n            <legend class=\"fieldLegend\" for=\"dob\">{{content('DEMemberGuest.dob')}}</legend>\n\n            <div class=\"dropdown fidobDay\">\n                <select xo-dropdown name=\"dobDay\" ng-model=\"user.dob_day\" id=\"dobDay\" aria-label=\"{{content('applyForBml.bmlApplyDay')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyDD')}}</option>\n                    <option ng-repeat=\"day in days\" value=\"{{day}}\" ng-selected=\"user.dob_day==='{{day}}'\">{{day}}</option>\n                </select>\n            </div>\n\n\n            <div class=\"dropdown fidobMonth\">\n                <select xo-dropdown name=\"dobMonth\" ng-model=\"user.dob_month\" id=\"dobMonth\" aria-label=\"{{content('applyForBml.bmlApplyMonth')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyMM')}}</option>\n                    <option ng-repeat=\"month in months\" value=\"{{month}}\" ng-selected=\"user.dob_month==='{{month}}'\">{{month}}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobYear\">\n                <select xo-dropdown name=\"dobYear\" ng-model=\"user.dob_year\" id=\"dobYear\" aria-label=\"{{content('applyForBml.bmlApplyYear')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyYYYY')}}</option>\n                    <option ng-repeat=\"year in years\" value=\"{{year}}\" ng-selected=\"user.dob_year==='{{year}}'\">{{year}}</option>\n                </select>\n            </div>\n\n        </fieldset>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-ui-components/src/dropdown/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(console) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, $) {
	
	    $.fn.dropdown = function () {
	        console.warn('Dropdown deprecated');
	    };
	
	    squid.module('xo-dropdown.directive', ['squid']).directive('xoDropdown', function ($parse, $window, $timeout, $injector, $rootScope, $config, $locale, $experiment, $util, $compile) {
	
	        var userAgent = ($window.navigator || {}).userAgent;
	        var isWinOS = Boolean(userAgent.match(/\(win/i));
	
	        return {
	
	            restrict: 'A',
	
	            scope: {
	                dropdownTextBindVar: '='
	            },
	
	            link: function link($scope, $element, attrs) {
	                var $parentScope = $scope.$parent;
	
	                var $select = $($element);
	
	                var selectInitialValue = '';
	
	                var ngChange = '';
	                // TODO: This html should be refactored out into a template.
	                var $span = $('<span class="custom-select" aria-hidden="true"><span><span></span></span></span>');
	
	                $select.parent().addClass('custom-select-container');
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseenter', function () {
	                    $span.addClass('active');
	                });
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('focus', function () {
	                    selectInitialValue = $parse(attrs.ngModel)($parentScope);
	                    $span.addClass('active');
	                });
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseleave', function () {
	                    $span.removeClass('active');
	                });
	
	                function executeSelectChange() {
	                    // setTimeout here is to ensure activeElement is set before our function executes
	                    $timeout(function () {
	                        var val = $parse(attrs.ngModel)($parentScope);
	                        if (selectInitialValue !== val) {
	                            if (ngChange) {
	                                ngChange($parentScope);
	                            }
	                            selectInitialValue = val;
	                        }
	                    }, 10);
	                }
	
	                if (isWinOS) {
	                    if (attrs['ngChange']) {
	                        ngChange = $parse(attrs.ngChange);
	                        attrs['ngChange'] = '';
	                    }
	
	                    $select.bind('blur', function () {
	                        executeSelectChange();
	                        $span.removeClass('active');
	                    });
	
	                    $select.bind('click', function () {
	                        executeSelectChange();
	                    });
	                } else {
	                    $select.bind('blur', function () {
	                        $span.removeClass('active');
	                    });
	                }
	
	                $select.after($span);
	
	                $select.addClass('replaced');
	
	                if (attrs['default']) {
	                    var defaultOption = document.createElement('option');
	                    defaultOption.innerText = attrs['default'];
	                    $select.append(defaultOption);
	                }
	
	                var match = (attrs.ngOptions || '').match(/in ([\w\.]+)/);
	                // Text Update Method 1(new): ng-bind on variable passed in directive and that is updated in parent/sibling scope
	                if (angular.isDefined($scope.dropdownTextBindVar)) {
	                    var selectTextElement = $span.find('span span');
	                    if (selectTextElement.length) {
	                        $(selectTextElement).attr('ng-bind', 'dropdownTextBindVar');
	                        $(selectTextElement).html($compile(selectTextElement[0])($scope));
	                    }
	
	                    $scope.$watch('dropdownTextBindVar', function (newVal) {
	                        if (document.documentElement.getAttribute('dir') === 'rtl') {
	                            $span.toggleClass('ltrOverride', !$util.hasRTL(newVal));
	                        }
	                    });
	                }
	                // Text Update Method 2(old): jQuery text update on various conditions (not as reliable for me, ran into timing edge cases)
	                else {
	                        var updateCover = function updateCover() {
	                            $timeout(function () {
	                                var text = $select.find(':selected').text().trim();
	                                $span.find('span span').text(text);
	                                if (document.documentElement.getAttribute('dir') === 'rtl') {
	                                    $span.toggleClass('ltrOverride', !$util.hasRTL(text));
	                                }
	                            }, 10);
	                        };
	
	                        $parentScope.$watch(attrs.ngModel, updateCover);
	
	                        $scope.$on('contentChange', updateCover);
	
	                        if (match) {
	                            $parentScope.$watch(match[1], updateCover);
	                        }
	                        // Update cover on arrow key press, for case where menu is not open
	                        // but user is interacting with dropdown (eg. Firefox)
	                        $select.bind('keyup', function (event) {
	                            // Arrow keys are 37 - 40
	                            if (event.which >= 37 || event.which <= 40) {
	                                updateCover();
	                            }
	                        });
	                    }
	
	                toggleOptionsLTROverride();
	                if (match) {
	                    $parentScope.$watch(match[1], function (newVal) {
	                        toggleOptionsLTROverride();
	                    });
	                }
	
	                function toggleOptionsLTROverride() {
	                    if (document.documentElement.getAttribute('dir') === 'rtl') {
	                        $timeout(function () {
	                            var options = $select.find('option');
	                            for (var i = 0; i < options.length; i++) {
	                                $(options.get(i)).toggleClass('ltrOverride', !$util.hasRTL(options.get(i).text));
	                            }
	                        });
	                    }
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ },

/***/ "./components/xo-tray-height/dist/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global define:true */
	
	
	/* grab the logger so we can warn about being in the fallback mode */
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	/** Name:  Tray height helper */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, $) {
	    squid.module('xo-tray-height.directive', ['squid']).directive('xoTrayHeight', function ($timeout) {
	        return {
	            restrict: 'A',
	            link: function link($scope, element, attrs) {
	                // Check to see if we can use the safer full height approach
	                // or if we need to fallback to calculating the height using
	                // math and relying on the "right" timing.
	                var topClass = 'xo-sidebar-wrapper';
	                var topSelector = '.' + topClass;
	                var topElem = document.querySelector(topSelector);
	                var inScope = topElem && topElem.querySelector('[xo-tray-height]');
	                var useNewFlow = topElem && inScope;
	
	                /**
	                 * NOTE:
	                 * The following code, despite being the "new" flow, is still
	                 * a stopgap solution until such time as the markup and or
	                 * CSS undergo an overhaul. It relies on the more stable
	                 * cascading relative/absolute positioning and 100% height
	                 * *and* the fact that the code is an instance of xo-tray-height
	                 * within the xo-sidebar-wrapper.
	                 */
	                function calculate() {
	                    var curElem = element[0];
	
	                    while (!~curElem.className.indexOf(topClass)) {
	                        var style = getComputedStyle(curElem, null);
	
	                        if (style.position !== 'absolute') {
	                            curElem.style.position = 'relative';
	                        }
	                        curElem.style.height = '100%';
	                        curElem = curElem.parentNode;
	                    }
	                }
	
	                /**
	                 * NOTE:
	                 * The following DEPRECATED version of the calculate method
	                 * relies on calculating the heights using math. This heavy
	                 * handed approach is fine if it is called at the right times
	                 * and often enough; however, this criteria is hard to achieve.
	                 *
	                 * A markup and styles overhaul is recommended to do away with
	                 * both of these methods.
	                 */
	                function deprecatedCalculate() {
	                    // DEPRECATED
	                    _logger.$logger.warn('xo-tray-height-fallback', {
	                        message: 'Using the fallback sidebar height calculation. ' + 'height may not be 100%. You should not be here!'
	                    });
	                    var height;
	                    var headerHeight;
	                    var mainHeight;
	                    var trayMinheight = 400;
	                    var asideContentHeight;
	                    var $aside = $(element).parents('aside:visible');
	                    var $asideContent = $aside.find('.asideContent');
	
	                    if (!$aside || !$asideContent) {
	                        return;
	                    }
	
	                    // Updates the tray height to the section height
	                    headerHeight = $aside.find('.header').outerHeight(true);
	                    mainHeight = $('#main').outerHeight(true);
	
	                    height = mainHeight - headerHeight;
	                    asideContentHeight = $asideContent.outerHeight(true);
	                    if ($scope.miniBrowser) {
	                        $aside.find('.aside').css('height', '534px');
	                        var minHeight = 534 - headerHeight;
	
	                        $asideContent.css('height', minHeight);
	                    } else if (asideContentHeight > height) {
	                        $asideContent.css('height', height);
	                        $aside.find('aside:visible').addClass('hasScroll');
	                    } else {
	                        height = height > trayMinheight ? height : trayMinheight;
	                        $asideContent.css('height', height);
	                        $aside.removeClass('hasScroll');
	                    }
	                }
	
	                if (useNewFlow) {
	                    calculate();
	                } else {
	                    $timeout(deprecatedCalculate, 1);
	
	                    $scope.$on('SidebarError', function () {
	                        deprecatedCalculate();
	                    });
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_logger.$logger;

/***/ },

/***/ "./components/xo-page-components/src/aside-header/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/aside-header/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-aside-header.directive', ['squid']).directive('xoAsideHeader', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                hdrtype: '@',
	                heading: '@',
	                subHead: '@',
	                addLink: '@',
	                backUrl: '@',
	                closeUrl: '@',
	                hidex: '@',
	                headerLeftLink: '=',
	                headerLeft: '@',
	                headerLeftIcon: '@',
	                headerRightLink: '=',
	                headerRight: '@',
	                headerRightIcon: '@',
	                subHeaderLeftLink: '@',
	                subHeaderLeft: '@',
	                subHeaderLeftIcon: '@',
	                subHeaderRightLink: '@',
	                subHeaderRight: '@',
	                subHeaderRightIcon: '@',
	                showDualFi: '='
	            },
	            controller: function controller($scope, $state, $timeout) {
	                $timeout(function () {
	                    $('.header').find('a:visible').focus();
	                });
	
	                if (angular.isUndefined($scope.closeUrl)) {
	                    $scope.closeUrl = 'checkout.review';
	                }
	
	                if ($scope.addLink) {
	                    $scope.subHeaderRight = 'asideHeader.add';
	                    $scope.subHeaderRightLink = $scope.addLink;
	                }
	
	                $scope.onClickLink = function (event, target, showDualFi) {
	                    event.preventDefault();
	                    if (showDualFi) {
	                        $scope.showFiOptions = true;
	                    } else if (angular.isFunction(target)) {
	                        target();
	                    } else {
	                        $state.go(target);
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/aside-header/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"header noButtons\" ng-class=\"[hdrtype]\" content>\n    <div class=\"primaryHeader\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content(heading) }}</h1>\n        <a link-button ui-sref=\"{{backUrl}}\" class=\"backArrow focusableIcon goTray\" ng-if=\"backUrl\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerLeftLink)\" class=\"left\" ng-if=\"headerLeftLink\">\n            <span ng-if=\"headerLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{closeUrl}}\" class=\"close focusableIcon\" ng-if=\"!backUrl && !hidex\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerRightLink)\" class=\"right focusableIcon\" ng-if=\"headerRightLink\">\n            <span ng-if=\"headerRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerRight) }}</span>\n        </a>\n    </div>\n\n    <div class=\"subHeader\" ng-class=\"{'addOptions': !subHeaderLeftLink}\" ng-if=\"subHeaderLeftLink || subHeaderRightLink\">\n        <h2 class=\"subheading gamma\" ng-if=\"!subHeaderLeftLink\">{{ content(subHead) }}</h2>\n        <a link-button ui-sref=\"{{subHeaderLeftLink}}\" ng-click=\"onClickLink($event, subHeaderLeftLink, showDualFi)\" ng-if=\"subHeaderLeftLink\" id=\"leftLink\" class=\"left\">\n            <span ng-if=\"subHeaderLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"leftText\">{{ content(subHeaderLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{subHeaderRightLink}}\" ng-class=\"{'addLink': !subHeaderLeftLink}\"  ng-click=\"onClickLink($event, subHeaderRightLink)\" ng-if=\"subHeaderRightLink\" id=\"rightLink\" class=\"right\">\n            <span ng-if=\"subHeaderRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"rightText\">{{ content(subHeaderRight) }}</span>\n        </a>\n    </div>\n</div>\n<div class=\"fundingInstrumentList\" id=\"fundingInstrumentList\" ng-if=\"showFiOptions\">\n    <ul>\n        <li class=\"bank\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddBank.bank.add\" id=\"addBank\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addBank')}}</span>\n            </a>\n        </li>\n        <li class=\"cards\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard\" id=\"addCC\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addCC')}}</span>\n            </a>\n        </li>\n    </ul>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/sepa/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-bank/sepa/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-bank.sepa.route', ['squid', 'xo-add-bank.sepa.directive']).factory('$XOSepaRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('SepaRoute', {
	
	            name: 'sepa',
	            directive: 'xo-sepa',
	            titleContent: 'DEMemberGuest.sepaTitle',
	            trackingData: {
	                fptiState: 'sepa_mandate',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::sepa_mandate',
	                        'pagename2': '%::sepa_mandate:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	
	            },
	            loginRequired: true,
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-bank/sepa", "components/xo-wallet-components/src/add-bank/sepa/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-bank/sepa/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/sepa/template.html"), __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/contingencies.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-add-bank.sepa.directive', ['squid', 'xo-aside-header.directive', 'xo-error-tooltip.directive']).directive('xoSepa', function ($state, $timeout) {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                model: '=',
	                sidebar: '=',
	                hideparenthead: '='
	            },
	
	            controller: function controller($scope) {
	
	                if (!$scope.model) {
	                    return $state.go('^.add');
	                }
	
	                $('body').addClass('pageSepaMandate');
	
	                $scope.$on('$destroy', function () {
	                    $('body').removeClass('pageSepaMandate');
	                });
	
	                if ($scope.hideparenthead) {
	                    $scope.hideparenthead.toggle = true;
	                }
	
	                function getDate() {
	                    var today = new Date();
	                    var dd = today.getDate();
	                    var mm = today.getMonth() + 1; // January is 0!
	
	                    var yyyy = today.getFullYear();
	                    if (dd < 10) {
	                        dd = '0' + dd;
	                    }
	                    if (mm < 10) {
	                        mm = '0' + mm;
	                    }
	                    return dd + '.' + mm + '.' + yyyy;
	                }
	
	                $scope.date = getDate();
	
	                $scope.onSubmit = function () {
	                    $scope.parentCallbacks.sepaDone();
	                };
	            },
	
	            link: function link($scope, element, attrs) {
	                $timeout(function () {
	                    $(element).find('.asideContent').height($('#main').height() - $('#tray').find('.header').height() + 10);
	                }, 10);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/sepa/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"sepaMandate\">\n<xo-aside-header back-url=\"^.add\" heading='DEMemberGuest.ddAgreementHead' ng-if=\"sidebar\"></xo-aside-header>\n<h1 class=\"gamma noHead\" ng-if=\"!sidebar\">{{ content('DEMemberGuest.ddAgreementHead') }}</h1>\n<div class=\"container\" ng-class=\"{asideContent: sidebar}\" content>\n    <form ng-submit=\"onSubmit()\" id=\"sepaMandateForm\" method=\"post\" class=\"asideProceed formSmall\"\n          novalidate=\"novalidate\">\n            <div class=\"sepaText\">\n                <p>{{ content('DEMemberGuest.ddAgreementPara1') }}</p>\n                <div class=\"sepaDetails\">\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.accountCarrier')}} </span>\n                            <span class=\"col2\">\n                                <span>{{model.user.first_name}}</span>\n                                <span>{{model.user.last_name}}</span>\n                                <br/>{{model.address.line1}}\n                                <br/>{{model.address.line2}}\n                                <br/>{{model.address.postal_code}} {{model.address.city}}\n                            </span>\n                        </p>\n                    </div>\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.IBAN')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.piAccountNumber}}</span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.bankName')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.isssuerDetails.name}}</span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.bic')}}</span>\n                            <span class=\"col2\">{{model.fiDetails.piDetails.bic}}</span>\n                        </p>\n                    </div>\n                    <div class=\"span\">\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.creditor')}}</span>\n                            <span class=\"col2\">\n                                <span>{{model.creditorDetails.creditorName}}</span>\n                                <br/><span class=\"confidential streets street-address\">{{model.creditorDetails.address.address1}}</span>\n                                <br/><span class=\"confidential postal-code\">{{model.creditorDetails.address.zip}}</span>\n                                    <span class=\"confidential locality\">{{model.creditorDetails.address.city}}</span>\n                                    <span class=\"confidential country adr-break\">{{model.creditorDetails.address.isoCountry}}</span>\n\n                            </span>\n                        </p>\n\n                        <p>\n                            <span class=\"col1\">{{content('DEMemberGuest.creditorId')}}</span>\n                            <span class=\"col2 creditorId\">{{model.creditorDetails.creditorId}}</span>\n                        </p>\n                    </div>\n                </div>\n                <p class=\"secondary\">{{content('DEMemberGuest.ddAgreementPara2WithoutLink')}}</p>\n\n                <p class=\"help\">{{date}}, {{model.address.city}}, {{content('DEMemberGuest.country'+model.address.country)}}</p>\n            </div>\n\n                <div class=\"buttons\">\n                    <input id=\"proceedButton\" type=\"submit\" value=\"{{ content('DEMemberGuest.agreeBtn') }}\"\n                           class=\"btn full \" ng-click=\"validated=true \"/>\n                    <a id=\"cancelBtn\" ui-sref=\"^.add\" class=\"btn full btn-secondary goTray\"\n                       role=\"button\">\n                        {{content('DEMemberGuest.cancelBtn')}}\n                    </a>\n                </div>\n\n    </form>\n\n</div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/directive.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addcard/route.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/selectcard/route.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addbilling/route.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addCep/route.js"), __webpack_require__("./components/xo-wallet-components/src/confirm-upop/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.route', ['squid', 'xo-add-card.directive', 'xo-add-card.addcard.route', 'xo-add-card.selectcard.route', 'xo-add-card.addbilling.route', 'xo-add-card.addcep.route', 'xo-confirm-upop.route']).factory('$AddCardFlowRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('CardRoute', {
	
	            name: 'addCardFlow',
	            directive: 'xo-add-card-flow',
	            titleContent: 'asideHeader.addCard',
	            children: [{
	                name: '$AddCardRoute',
	                attributes: {
	                    token: 'token',
	                    cardmodel: 'cardmodel',
	                    done: 'addCCDone',
	                    messagetitle: 'messagetitle',
	                    message: 'message',
	                    pagetitle: 'pagetitle',
	                    sidebar: 'sidebar',
	                    showmeftsection: 'showmeftsection',
	                    hideparenthead: 'hideparenthead',
	                    billingaddressupdated: 'billingaddressupdated',
	                    isupdatecard: 'isupdatecard',
	                    'parent-callbacks': 'callbacks',
	                    'selected-promotion-card-type': 'selectedPromotionCardType',
	                    promotion: 'promotion',
	                    'page-level': 'pageLevel',
	                    logout: 'logout',
	                    phone: 'phone',
	                    'show-cancel': 'showCancel',
	                    'show-set-preferred-fi': 'showSetPreferredFi',
	                    'on-success': 'onSuccess'
	                }
	
	            }, {
	                name: '$SelectCardRoute',
	                attributes: {
	                    token: 'token',
	                    'parent-callbacks': 'callbacks',
	                    message: 'message',
	                    pagetitle: 'pagetitle',
	                    sidebar: 'sidebar',
	                    'selected-promotion-card-type': 'selectedPromotionCardType',
	                    promotion: 'promotion'
	                }
	            }, {
	                name: '$AddBillingRoute',
	                attributes: {
	                    token: 'token',
	                    sidebar: 'sidebar',
	                    showmeftsection: 'showmeftsection',
	                    'parent-callbacks': 'callbacks',
	                    hideparenthead: 'hideparenthead',
	                    billingaddressupdated: 'billingaddressupdated',
	                    'prefill-address': 'prefillAddress'
	                }
	            }, {
	                name: '$AddCepRoute',
	                attributes: {
	                    token: 'token',
	                    sidebar: 'sidebar',
	                    'done-fn': 'cepDone',
	                    'prefill-address': 'prefillAddress'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card", "components/xo-wallet-components/src/add-card/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/address/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return squid.module('xo-add-card.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address']).directive('xoAddCardFlow', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '=',
	                messagetitle: '=',
	                message: '=',
	                pagetitle: '=',
	                sidebar: '=',
	                showmeftsection: '=',
	                hideparenthead: '=',
	                promotion: '=',
	                pageLevel: '=',
	                logout: '=',
	                phone: '=',
	                fundingid: '=',
	                showCancel: '=',
	                showSetPreferredFi: '=',
	                onSuccess: '='
	            },
	
	            controller: function controller($scope, $state, $populate, $AddCardModel, $CardModel, $CheckoutSessionModel, $PrefillAddressModel, $util, $renderContent) {
	
	                $scope.addCCDone = function () {
	                    $scope.parentCallbacks.finish();
	                };
	
	                $scope.callbacks = {
	                    done: $scope.parentCallbacks.finish,
	                    cancel: $scope.parentCallbacks.cancel,
	                    showCep: function showCep() {
	                        $scope.prefillAddress = new $PrefillAddressModel({
	                            id: $scope.token
	                        });
	
	                        $state.go('^.addCep');
	                    },
	
	                    cardTypeSelected: function cardTypeSelected(type) {
	                        $scope.selectedPromotionCardType = {
	                            type: type
	                        };
	                        $state.go('^.addCard');
	                    }
	                };
	
	                $scope.cepDone = function () {
	                    $state.go('^.addBilling');
	                };
	
	                $scope.selectedPromotionCardType = {
	                    type: $scope.promotion && $scope.promotion.type
	                };
	
	                if ($scope.promotion) {
	                    $scope.promotion.type = null;
	                }
	
	                $scope.billingaddressupdated = {
	                    value: false
	                };
	
	                $scope.phone = {
	                    hide_type: true
	                };
	
	                $scope.cardmodel = new $AddCardModel({
	                    card: new $CardModel()
	                });
	
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
	                        contingencies: {
	                            NEED_CREDIT_CARD: angular.noop,
	                            EXPIRED_CREDIT_CARD: angular.noop
	                        }
	                    })
	                }).then(function () {
	
	                    if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.resolution) {
	                        var card = $scope.checkoutSession.errorData.resolution.data;
	
	                        if (card.fundingId && card.fi && card.fi.type) {
	                            $scope.cardmodel.id = card.fundingId;
	                            $scope.cardmodel.card = new $CardModel({
	                                number: 'xxxx-xxxx-xxxx-' + card.fi.number,
	                                type: card.fi.type.toUpperCase(),
	                                productType: card.fi.productType
	                            });
	                        }
	                    }
	                    if ($scope.fundingid) {
	                        var fundingSource = $util.find($scope.checkoutSession.fundingOptions.instruments, function (funding) {
	                            if (funding && funding.id === $scope.fundingid) {
	                                return funding;
	                            }
	                        });
	
	                        if (fundingSource) {
	                            $scope.cardmodel.id = fundingSource.id;
	                            $scope.cardmodel.card = new $CardModel({
	                                number: 'xxxx-xxxx-xxxx-' + fundingSource.lastDigits,
	                                lastDigits: fundingSource.lastDigits,
	                                type: fundingSource.name,
	                                name: $renderContent('fsMappings.' + fundingSource.name)
	                            });
	                        }
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/template.html":
"../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-bank/template.html",

/***/ "./components/xo-models/src/address/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.address', ['squid']).factory('$AddressNormalizationModel', function ($Model, $Api) {
	        return $Model.extend('AddressNormalizationModel', {
	            api: new $Api({
	                uri: '/api/address/normalize'
	            })
	        });
	    }).factory('$PrefillAddressModel', function ($Model, $Api) {
	        return $Model.extend('PrefillAddressModel', {
	            api: new $Api({
	                uri: '/api/address/prefill'
	            })
	        });
	    }).factory('$ValidateAddressModel', function ($Model, $Api) {
	        return $Model.extend('ValidateAddressModel', {
	            api: new $Api({
	                uri: '/api/address/validate'
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/address", "components/xo-models/src/address/index.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addcard/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	var _route = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addcard/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.addcard.route', ['squid', 'xo-add-card.addcard.directive']).factory('$AddCardRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddCardRoute', {
	
	            name: 'addCard',
	            directive: 'xo-add-card',
	            titleContent: 'asideHeader.addCard',
	
	            trackingData: {
	                fptiState: 'add_or_update_cc'
	            },
	            loginRequired: true,
	            children: [{
	                route: _route2['default'],
	                attributes: {
	                    token: 'token',
	                    phone: 'phone',
	                    cardmodel: 'cardmodel',
	                    'on-success': 'onSuccess'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/addcard", "components/xo-wallet-components/src/add-card/addcard/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addcard/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _choice = __webpack_require__("./components/xo-models/src/choice/index.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addcard/template.html"), __webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/creditcard-input/directive.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js"), __webpack_require__("./components/xo-wallet-components/src/fi-contingency-list/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, module, template, $) {
	
	    return module('xo-add-card.addcard.directive', ['squid', 'xomodel.checkout', 'xomodel.auth', 'xomodel.fi', 'xo-add-card.creditcard-input.directive', 'xo-dropdown.directive', 'xo-tray-height.directive', 'xo-aside-header.directive', 'xo-message.directive', 'xo-error-tooltip.directive', 'ui.validate', 'xo-accessibility.directive', 'fi.errorUtil']).directive('xoAddCard', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                done: '=',
	                messagetitle: '=',
	                message: '=',
	                pagetitle: '=',
	                sidebar: '=',
	                showmeftsection: '=',
	                hideparenthead: '=',
	                billingaddressupdated: '=',
	                cardmodel: '=',
	                parentCallbacks: '=',
	                selectedPromotionCardType: '=',
	                promotion: '=',
	                pageLevel: '=',
	                logout: '=',
	                phone: '=',
	                manageCardFlow: '=',
	                showCancel: '=',
	                showSetPreferredFi: '=',
	                onSuccess: '='
	            },
	            controller: function controller($scope, $populate, $state, $stateParams, $BillingAddressesModel, $CardTypesModel, $CheckoutSessionModel, $AuthModel, $CheckoutCartModel, $timeout, $element, $rootScope, $locale, $util, $config, $ResolveOTP, $Class, $fiErrorUtil, $renderContent, $meta, $FlowEligibilityModel, $q, $PreferredFi) {
	
	                $populate($scope, {
	                    cart: $CheckoutCartModel.instance($scope.token),
	                    auth: $AuthModel.instance(),
	                    billingAddresses: $BillingAddressesModel.instance(),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
	                        contingencies: {
	                            NEED_CREDIT_CARD: angular.noop,
	                            EXPIRED_CREDIT_CARD: angular.noop
	                        }
	                    }),
	                    flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
	                        params: {
	                            geolocation: $meta.geolocation,
	                            localeCountry: $locale.country
	                        }
	                    })
	                }).then(function () {
	                    return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
	                        var multipleFiVariants = $config.choiceExperiment && $config.choiceExperiment.multipleFi || [];
	
	                        if (multipleFiVariants.indexOf(variant) !== -1) {
	                            $scope.showMultipleFI = true;
	                        }
	                    });
	                }).then(function () {
	                    if ($scope.cart.isWalletTokenization()) {
	                        _logger.$logger.info('tokenized_wallet', {
	                            'from': 'ADD_DEBIT_CARD',
	                            'to': 'prepare_ADD_DEBIT_CARD',
	                            'context_id': $scope.token,
	                            'context_type': 'BA-Token',
	                            'ba_token': $meta.baToken
	                        });
	                    }
	
	                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';
	
	                    if ($scope.showmeftsection) {
	                        $scope.showmeftsection.toggle = true;
	                    }
	
	                    if ($scope.hideparenthead) {
	                        $scope.hideparenthead.toggle = false;
	                    }
	
	                    $scope.manageCardFlow = $scope.sidebar && $scope.cardmodel.card.isExisting();
	
	                    var type = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type;
	
	                    if ($scope.checkoutSession.plccOffer && !type && $scope.promotion) {
	                        $state.go('^.selectCard');
	                    }
	
	                    $scope.showplcc = type === 'plcc';
	                    $scope.country = $locale.country;
	
	                    $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && $scope.logout;
	
	                    $scope.showHiMsg = Boolean($scope.messagetitle);
	
	                    $scope.cardmodel.cardType = 'creditCard';
	
	                    if ($scope.checkoutSession.plccOffer && $scope.showplcc) {
	                        $scope.cardmodel.cardType = 'privateLabel';
	                        $scope.cardmodel.sponsor_id = $scope.checkoutSession.plccOffer.sponsor_id;
	                    }
	
	                    $scope.cardmodel.user = {
	                        first_name: $scope.auth.first_name,
	                        last_name: $scope.auth.last_name
	                    };
	
	                    $scope.cardmodel.address = $scope.billingAddresses.addresses[0];
	
	                    if ($scope.billingaddressupdated.value) {
	                        $scope.billingaddressupdated = {
	                            msgs: [$locale.content.get('editCard.newAddressAdded')],
	                            type: 'success',
	                            value: true
	                        };
	                    }
	
	                    $scope.gotoBilling = function (address) {
	                        if ($scope.pageLevel) {
	                            $scope.pageLevel.message = null;
	                        }
	                        if (!address) {
	                            if ($locale.country === 'BR') {
	                                $scope.parentCallbacks.showCep();
	                            } else {
	                                // page transition
	                                var el = $('.tokenization #sidepageAddCard');
	                                if (el) {
	                                    el.addClass('slideLeft');
	                                }
	                                $state.go('^.addBilling');
	                            }
	                        }
	                    };
	
	                    $scope.isCUP = function () {
	                        return $scope.cardmodel.card && $scope.cardmodel.card.type && $scope.cardmodel.card.type === 'CUP';
	                    };
	
	                    $scope.isUpdateDebitCard = function () {
	                        return $stateParams.message === 'EXPIRED_DEBIT_CARD';
	                    };
	
	                    $scope.flag = function (field) {
	                        return _cardMetaData.$CardMetaData.getMetaData($scope.cardmodel.card, field);
	                    };
	
	                    $scope.buttonText = function () {
	                        if ($scope.debitCardFlow) {
	                            return 'creditcard.saveBtn';
	                        }
	
	                        var contentString = 'creditcard.addBtn';
	                        if ($scope.cardmodel.card.isExisting()) {
	                            contentString = 'creditcard.updateBtn';
	                        } else if ($scope.isCUP()) {
	                            contentString = 'creditcard.continuetext';
	                        }
	                        return contentString;
	                    };
	
	                    $scope.cardTypeChanged = function () {
	                        $scope.phone.phoneType = $scope.flag('phoneType');
	                    };
	
	                    function addErrorMessage(contentKey) {
	                        if (contentKey) {
	                            contentKey = angular.isArray(contentKey) ? contentKey[0] : contentKey;
	                            var message = $locale.content.get('creditcard.' + contentKey);
	                            $scope.message.msgs.push(message);
	                        }
	                    }
	
	                    function handleContingencies(result, contentBundle, defaultErrorKey, prop) {
	                        var errorData;
	
	                        if (result.errorCodes) {
	                            errorData = result;
	                        } else {
	                            errorData = {
	                                errorCodes: result && [result['0']]
	                            };
	                        }
	                        $scope.message = $fiErrorUtil.addPageErrors(errorData, contentBundle, prop, defaultErrorKey);
	
	                        if (window.scrollTo) {
	                            window.scrollTo(0, 0);
	                        }
	                    }
	
	                    $scope.cancelFn = function () {
	                        // Use callback provided by parent route if there
	                        if ($scope.parentCallbacks.cancel) {
	                            return $scope.parentCallbacks.cancel();
	                        }
	
	                        // For multiple FI variant, route back to review page
	                        if ($scope.showMultipleFI) {
	                            if ($scope.manageCardFlow) {
	                                return $state.go('checkout.review.sidebar.sidebarManageWallet');
	                            }
	                            return $state.go('checkout.review');
	                        }
	
	                        if ($scope.sidebar) {
	                            if (!$scope.checkoutSession.plccOffer) {
	                                return $state.go('checkout.review.sidebar.wallet');
	                            } else {
	                                return $state.go('^.selectCard');
	                            }
	                        }
	
	                        $scope.done();
	                    };
	
	                    function initiateOTP() {
	                        var resolveOTP = new $ResolveOTP({ id: $scope.cardmodel.id });
	                        resolveOTP.action('init', {
	                            data: {
	                                phone: {
	                                    country_code: $scope.phone.IntDialingCountryCode,
	                                    number: $scope.phone.telephone
	                                }
	                            },
	                            resultModel: {},
	                            success: function success() {
	                                $state.go('.confirmUpop');
	                            },
	
	                            error: function error() {
	                                handleContingencies({}, 'confirmUpop', 'declineMessage');
	                            },
	
	                            contingencies: {
	                                INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
	                                    // prop for last 4 digits of card in error message
	                                    var prop = {
	                                        number: $scope.cardmodel && $scope.cardmodel.card && $scope.cardmodel.card.last4()
	                                    };
	
	                                    handleContingencies(result, 'confirmUpop', 'declineMessage', prop);
	                                    $fiErrorUtil.addFieldErrors(result, $element);
	                                },
	                                DEFAULT: function DEFAULT() {
	                                    handleContingencies({}, 'confirmUpop', 'declineMessage');
	                                }
	                            }
	                        });
	                    }
	
	                    function handleCheckoutSession(result, isNewCard) {
	                        if ($scope.cardmodel && $scope.cardmodel.cardType === 'privateLabel') {
	                            delete $scope.checkoutSession.plccOffer;
	                        }
	
	                        delete $scope.checkoutSession.errorData;
	
	                        var cardAdded = $scope.cardmodel && $scope.cardmodel.card;
	                        var numberAdded;
	                        var cardTypeAdded;
	
	                        if (cardAdded) {
	                            numberAdded = angular.isString(cardAdded.number) && cardAdded.number.replace(/\s/g, '');
	                            cardTypeAdded = cardAdded.type;
	                        }
	
	                        var last4Added = angular.isString(numberAdded) && numberAdded.substr(numberAdded.length - 4);
	                        var cvvData = $scope.checkoutSession.cvvData;
	                        var last4ToUse;
	                        var cardTypeToUse;
	
	                        if (cvvData) {
	                            last4ToUse = cvvData.number;
	                            cardTypeToUse = cvvData.type;
	                        }
	
	                        if (last4ToUse === last4Added && cardTypeAdded === cardTypeToUse) {
	                            $scope.checkoutSession.set('cvvData.security_code', $scope.cardmodel.get('card.security_code'));
	
	                            $scope.checkoutSession.set('cvvData.lastAddedCard', true);
	                        }
	
	                        var updateCardSidebarMessage = $renderContent('wallet.cardUpdated', {
	                            type: cardTypeAdded,
	                            number: last4Added
	                        });
	                        var updateCardPageMessage = $renderContent('smallToolTip.cardUpdated');
	                        var addCardMessage = $renderContent('smallToolTip.cardAdded');
	
	                        var msgs = [addCardMessage];
	
	                        if (!isNewCard) {
	                            msgs = $scope.manageCardFlow ? [updateCardSidebarMessage] : [updateCardPageMessage];
	                        }
	
	                        $scope.checkoutSession.message = {
	                            type: 'success',
	                            msgs: msgs
	                        };
	
	                        $scope.done();
	                    }
	
	                    $scope.onSubmit = function () {
	                        if ($scope.pageLevel) {
	                            $scope.pageLevel.message = null;
	                        }
	                        var isNewCard = !$scope.cardmodel.card.isExisting();
	
	                        if (isNewCard) {
	                            delete $scope.cardmodel.id;
	                        }
	
	                        if ($('#plccAgree').is(':checked')) {
	                            $scope.cardmodel.preference = true;
	                        }
	
	                        // Only initiateOTP needs to be called for unconfirmed CUP contingency. Add card call does not need to be made.
	                        if ($scope.isCUP() && $scope.cardmodel.id && ($scope.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD' || $scope.checkoutSession.get('errorData.cause') === 'EXPIRED_CREDIT_CARD')) {
	
	                            initiateOTP();
	                        } else {
	                            $scope.cardmodel.save({
	
	                                success: function success() {
	                                    if ($scope.isCUP()) {
	                                        initiateOTP();
	                                    } else if ($scope.cart.isWalletTokenization()) {
	                                        var fpti_payload = {
	                                            'from': 'ADD_DEBIT_CARD',
	                                            'to': 'process_ADD_debit_card',
	                                            'context_id': $scope.token,
	                                            'context_type': 'BA-Token',
	                                            'ba_token': $meta.baToken
	                                        };
	                                        $scope.checkoutSession.fundingOptions.action('notifyChange', {
	                                            resultModel: $scope.checkoutSession,
	
	                                            data: {
	                                                planId: $scope.cardmodel.id,
	                                                operation: 'ADDED'
	                                            },
	
	                                            success: function success(result) {
	                                                _logger.$logger.info('tokenized_wallet', fpti_payload);
	                                                handleCheckoutSession(result, isNewCard);
	                                            },
	
	                                            contingencies: {
	                                                TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
	                                                    fpti_payload.int_error_desc = 'TRANSACTION_REFUSED_addedButCannotUse';
	                                                    fpti_payload.error_source = 'ppas';
	                                                    _logger.$logger.info('tokenized_wallet', fpti_payload);
	                                                    $scope.message.msgs = [];
	                                                    $scope.message.type = 'info';
	                                                    addErrorMessage('addedButCannotUse');
	                                                }
	                                            }
	                                        });
	                                    } else {
	                                        return $q.when().then(function () {
	                                            // setPreferredFI checkbox is checked
	                                            if ($scope.showSetPreferredFi && $('#makeFiPreferred').is(':checked')) {
	
	                                                _logger.$logger.info('set_preferredFI_checked');
	
	                                                // set preferred FI before updating
	                                                var preferredFi = new $PreferredFi({
	                                                    preferred: [$scope.cardmodel.id]
	                                                });
	
	                                                return preferredFi.save({
	                                                    success: function success() {
	                                                        _logger.$logger.info('SET_PREFERREDFI_SUCCESS', { preferred: [$scope.cardmodel.id] });
	                                                    },
	                                                    transientError: true,
	                                                    error: function error(err) {
	                                                        // log the error but fails silently because card is added
	                                                        _logger.$logger.error('SET_PREFERREDFI_ERROR', { error: err });
	                                                    },
	                                                    contingencies: {
	                                                        DEFAULT: function DEFAULT(name, contingency) {
	                                                            _logger.$logger.info('SET_PREFERREDFI_CONTINGENCY', name);
	                                                        }
	                                                    }
	                                                });
	                                            }
	                                        }).then(function () {
	                                            return $scope.checkoutSession.fundingOptions.action('update', {
	
	                                                resultModel: $scope.checkoutSession,
	
	                                                data: {
	                                                    planId: $scope.cardmodel.id
	                                                },
	
	                                                success: function success(result) {
	                                                    handleCheckoutSession(result, isNewCard);
	                                                },
	
	                                                contingencies: {
	                                                    TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
	                                                        $scope.message.msgs = [];
	                                                        $scope.message.type = 'info';
	                                                        addErrorMessage('addedButCannotUse');
	                                                    }
	                                                }
	                                            });
	                                        });
	                                    }
	                                },
	
	                                contingencies: {
	                                    ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(name, result) {
	                                        if ($scope.sidebar) {
	                                            $scope.$emit('SidebarError');
	                                        }
	                                        $scope.billingaddressupdated.value = false;
	                                        if (result && result.errorCodes) {
	                                            handleContingencies(result, 'creditcard', 'errorInvalidData');
	                                            $fiErrorUtil.addFieldErrors(result, $element);
	                                        } else if (result && result['0']) {
	                                            handleContingencies(result, 'creditcard');
	                                        } else {
	                                            handleContingencies({}, 'creditcard', 'errorInternalError');
	                                        }
	                                    },
	                                    DISALLOWED_CUPSECURE_ADDITION: function DISALLOWED_CUPSECURE_ADDITION(name, result) {
	                                        handleContingencies({}, 'creditcard', 'errorInternalError');
	                                    },
	                                    VALIDATION_ERROR: function VALIDATION_ERROR(name, result) {
	                                        var $field = $($element).find('[ng-model="card.number"]');
	                                        $field.addClass('backendError');
	                                        $field.attr('aria-invalid', true);
	                                        $field.focus();
	                                    },
	                                    DEFAULT: function DEFAULT(name, result) {
	                                        handleContingencies({ errorCodes: [name] }, 'creditcard', 'errorInternalError');
	                                    }
	
	                                },
	
	                                error: function error() {
	                                    handleContingencies({}, 'creditcard', 'errorInternalError');
	                                },
	
	                                validation: function validation(res) {}
	                            });
	                        }
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_cardMetaData.$CardMetaData;
	
	_logger.$logger;
	
	_choice.$ChoiceEligibility;

/***/ },

/***/ "./components/squid/dist/module.js":
/***/ function(module, exports) {

	
	
	module.exports = angular.module;

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addcard/template.html":
/***/ function(module, exports) {

	module.exports = "\n<div content modal-box=\"!!sidebar\" modal-cancel=\"cancelFn()\" xo-tray-height>\n    <xo-aside-header back-url=\"checkout.review.sidebar.wallet\" heading=\"asideHeader.addCard\" ng-if=\"!showMultipleFI && sidebar && !debitCardFlow && !checkoutSession.plccOffer && !cardmodel.card.isExisting()\"></xo-aside-header>\n    <xo-aside-header back-url=\"checkout.review\" heading=\"asideHeader.addCard\" ng-if=\"showMultipleFI && sidebar && !checkoutSession.plccOffer && !cardmodel.card.isExisting() && !debitCardFlow\"></xo-aside-header>\n    <div class=\"header noButtons\" ng-if=\"manageCardFlow\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content('asideHeader.updateCard', {type: cardmodel.card.name, number: cardmodel.card.lastDigits}) }}</h1>\n        <a link-button ng-if=\"!showMultipleFI\" ui-sref=\"checkout.review.sidebar.wallet\" class=\"backArrow goTray\"><span\n                class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-if=\"showMultipleFI\" ui-sref=\"checkout.review.sidebar.sidebarManageWallet\"\n           class=\"backArrow goTray\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n\n    </div>\n    <xo-aside-header back-url=\"^.selectCard\" heading='asideHeader.selectCard' ng-if=\"sidebar && checkoutSession.plccOffer\"></xo-aside-header>\n    <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showHiMsg\">\n        {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n            <span ng-if=\"showNotYou\">\n                <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\" style=\"font-weight:700;\">{{ content('memberReview.notYou')}}</a>\n            </span>\n    </p>\n    <h1 class=\"gamma\" ng-if=\"messagetitle\">{{ messagetitle }}</h1>\n    <xo-message message=\"message\" ng-if=\"!sidebar\"></xo-message>\n    <h1 class=\"gamma\" ng-if=\"pagetitle\">{{ pagetitle }}</h1>\n\n    <div ng-class=\"{true: 'sidebar'}[asideContent]\" xo-tray-height>\n        <form id=\"creditCardForm\" name=\"creditCardForm\" class=\"addCard asideView asideContent\" content form-autofocus novalidate>\n            <div class=\"trayInner container\">\n                <p id=\"addCardDebitCardFlow\" ng-if=\"debitCardFlow && !isUpdateDebitCard()\">\n                    {{ content('addCard.addTopupDebitCard') }}\n                </p>\n                <xo-message message=\"message\" ng-if=\"sidebar\"></xo-message>\n                <xo-message id=\"billingAddressUpdatedMsg\" ng-if=\"billingaddressupdated.value\" message=\"billingaddressupdated\"></xo-message>\n                <xo-name-input user=\"cardmodel.user\" country=\"{{country}}\"></xo-name-input>\n\n                <xo-credit-card token=\"token\" card=\"cardmodel.card\" user=\"cardmodel.user\"\n                                selected-promotion-card-type=\"selectedPromotionCardType\"\n                                card-type-changed=\"cardTypeChanged\" promotion=\"promotion\"\n                                manage-card-flow=\"manageCardFlow\"></xo-credit-card>\n\n                <div ng-if=\"flag('fields.address')\" id=\"billingAddress\" class=\"dropdown billingAddress confidential\">\n                    <label for=\"billingAddressDropdown\" class=\"billingAddressLabel\">\n                        {{ content(\"addressBook.billingAddress\") }}\n                        <a href=\"\" link-button ng-click=\"gotoBilling()\" class=\"addNewBillingAddress\" aria-label=\"{{ content('addCard.addNewBillingAddress') }}\">{{ content(\"addressBook.add\") }}</a>\n                    </label>\n                    <div class=\"dropdown billingAddress nullable\">\n                        <select xo-dropdown default=\"{{content('addCard.addNewBillingAddress')}}\" ng-model=\"cardmodel.address\"\n                                ng-change=\"gotoBilling(cardmodel.address)\"\n                                ng-options=\"address.full_address for address in billingAddresses.addresses\"\n                                name=\"billingAddress\" id=\"billingAddressDropdown\" required>\n                        </select>\n                    </div>\n                </div>\n\n                <div ng-if=\"flag('fields.phone')\">\n                    <div class=\"otpVerification\" ng-bind-html=\"htmlContent('confirmUpop.debitInitOtp')\"></div>\n                    <xo-phone-input token=\"token\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n                </div>\n\n                <div class=\"addressLabel\">\n                    <a href=\"\" link-button ng-click=\"gotoBilling()\">{{ content(\"addCard.addNewBillingAddress\") }}</a>\n                </div>\n\n                <div ng-if=\"showplcc\">\n                    <div class=\"plccAgree checkbox\">\n                        <input type=\"checkbox\" checked=\"true\" name=\"plccAgree\" id=\"plccAgree\" />\n                        <label class=\"noBottom\" for=\"plccAgree\">{{content('addCard.plccPreferMethod', { merchant: promotion.name})}}</label>\n                    </div>\n                    <div class=\"legal\">{{content('addCard.plccLegal', { merchant: promotion.name})}}</div>\n                </div>\n\n                <div ng-if=\"showSetPreferredFi\">\n                    <div class=\"checkbox\">\n                        <input type=\"checkbox\" name=\"makeFiPreferred\" id=\"makeFiPreferred\" />\n                        <label for=\"makeFiPreferred\">{{ content('addCard.makeFiPreferred') }}</label>\n                    </div>\n                    <div class=\"legal infoTxt\">{{content('addCard.makeFiPreferredLegal')}}\n                        <span id=\"setPreferredFiLearnMore\" bind-html-compile=\"htmlContent('addCard.learnMore')\"></span>\n                    </div>\n                </div>\n\n                <input track-submit=\"{{cardmodel.card.isExisting() ? 'update_cc' : 'add_cc' }}\" type=\"submit\" value=\"{{ content(buttonText()) }}\" id=\"proceedButton\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n\n                <div ng-if=\"showCancel\" class=\"linkButton\">\n                    <a link-button prevent-default href=\"#\" ng-click=\"parentCallbacks.cancel()\">{{content('common.cancel')}}</a>\n                </div>\n            </div>\n        </form>\n    </div>\n\n    <div ui-view></div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/creditcard-input/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _cardMetaData = __webpack_require__("./components/xo-wallet-components/src/add-card/cardMetaData/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/cardExpiry/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/cardIssueDate/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/cvv/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/dob/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/creditcard-input/template.html"), __webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/xo-form-components/src/name-input/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template, $) {
	
	    squid.module('xo-add-card.creditcard-input.directive', ['squid', 'xomodel.fi', 'xo-tooltip.directive', 'xo-error-tooltip.directive', 'xo-name-input.directive', 'ui.validate']).directive('scrollToTop', function () {
	        return {
	            link: function link(scope, element, attr) {
	                $(element).on('focus', function () {
	                    if ($('#mxCardTitle').is(':visible')) {
	                        $('#creditCardForm').scrollTop($(element).offset().top);
	                    }
	                });
	            }
	        };
	    }).directive('xoCreditCard', function ($timeout, $util) {
	        return {
	            template: template,
	            restrict: 'E',
	
	            scope: {
	                token: '=',
	                card: '=',
	                user: '=',
	                selectedPromotionCardType: '=',
	                promotion: '=',
	                cardTypeChanged: '=',
	                cardNumberChanged: '=',
	                manageCardFlow: '='
	            },
	            controller: function controller($scope, $populate, $CardTypesModel, $Class, $locale, $CardTypeFromBinModel, $config, $feature, $pxp, $logger, $stateParams, $FlowEligibilityModel, $meta) {
	
	                $scope.cardLengthValid = function (number) {
	                    if ($scope.card && $scope.card.isExisting()) {
	                        return true;
	                    }
	
	                    number = (number || '').replace(/[^0-9]+/g, '');
	
	                    return number.length >= $scope.flag('length.min') && number.length <= $scope.flag('length.max');
	                };
	
	                $scope.cardLuhnValid = function (input) {
	
	                    if (!$scope.flag('luhn')) {
	                        return true;
	                    }
	
	                    if ($scope.card && $scope.card.isExisting()) {
	                        return true;
	                    }
	
	                    input = (input || '').replace(/[^0-9]+/g, '');
	
	                    var sum = 0;
	                    var numdigits = input.length;
	                    var parity = numdigits % 2;
	                    var i = 0;
	                    var digit;
	
	                    for (; i < numdigits; i++) {
	
	                        digit = parseInt(input.charAt(i), 10);
	
	                        if (i % 2 === parity) {
	                            digit *= 2;
	                        }
	
	                        if (digit > 9) {
	                            digit -= 9;
	                        }
	
	                        sum += digit;
	                    }
	
	                    return sum % 10 === 0;
	                };
	
	                $scope.isPlcc = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type === 'plcc' ? true : false;
	
	                $scope.flag = function (field) {
	                    if ($scope.isPlcc && !$scope.card.type) {
	                        $scope.card.type = 'PLCC';
	                    }
	                    return _cardMetaData.$CardMetaData.getMetaData($scope.card, field);
	                };
	
	                $scope.maxLength = function () {
	
	                    if ($scope.card && $scope.card.isExisting()) {
	                        return 30;
	                    }
	
	                    return $scope.flag('length.max') + $scope.flag('spaces.length');
	                };
	
	                $populate($scope, {
	                    flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
	                        params: {
	                            geolocation: $meta.geolocation,
	                            localeCountry: $locale.country
	                        }
	                    })
	                }).then(function () {
	                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';
	
	                    $scope.locale = $locale;
	                    $scope.country = $scope.locale.country;
	
	                    var cardTypeServiceCall = $feature('cardTypeServiceCallRequired', false, $scope.country) || $scope.debitCardFlow;
	                    var isUnsupportedCard;
	                    var lastVerifiedBin = '';
	                    var lastRequestedBin; // bin requested to service to fetch card type and pending response.
	
	                    $scope.mxDebitCards = ['BANAMEX', 'BANCOARFACA', 'BBVA', 'BANORTE', 'HSBC', 'INBURSA', 'SANTANDER'];
	
	                    $scope.cardProductValid = function () {
	                        return $scope.debitCardFlow ? $scope.card.productType === 'DEBIT' : true;
	                    };
	
	                    if ($scope.card && $scope.card.number) {
	                        $scope.unformattedCardNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
	                    }
	
	                    $scope.showMXCardLogos = function () {
	                        return $locale.country === 'MX';
	                    };
	
	                    function pxpMXCardLabels() {
	                        if ($scope.showMXCardLogos()) {
	                            $pxp('xo_hermes_mx_cardlogo', {}, 'xo_hermes_mx_cardlogo_treatment').then(function (result) {
	                                $scope.showLabels = result && result.treatment_name === 'xo_hermes_mx_cardlogo_treatment';
	                            });
	                        } else {
	                            $scope.showLabels = false;
	                        }
	                    }
	
	                    $populate($scope, {
	                        cardTypes: $CardTypesModel.instance($scope.token + ':' + $locale.country, {
	                            token: $scope.token,
	                            country: $locale.country
	                        })
	                    }).then(function () {
	                        var forceDropDown = false;
	
	                        $scope.supportedCardNamesCommaSeparated = $scope.cardTypes.supportedNames().join(', ');
	
	                        $scope.$on('localeChange', function () {
	
	                            $scope.cardTypes = $CardTypesModel.instance($scope.token + ':' + $locale.country, {
	                                token: $scope.token,
	                                country: $locale.country
	                            });
	
	                            $scope.cardTypes.retrieve().then(function () {
	                                if ($scope.card.type && $scope.cardTypes.allowed.indexOf($scope.card.type) === -1) {
	                                    delete $scope.card.type;
	                                    forceDropDown = false;
	                                    $scope.changeCardNumber(true);
	                                }
	                            });
	
	                            $scope.country = $locale.country;
	
	                            pxpMXCardLabels();
	                        });
	
	                        pxpMXCardLabels();
	
	                        $scope.cvvShown = function () {
	                            if ($scope.card.type === 'CETELEM' && $scope.locale.country === 'FR') {
	                                return false;
	                            }
	
	                            if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
	                                return false;
	                            }
	
	                            if ($scope.isPlcc && $scope.card.type) {
	                                return true;
	                            }
	
	                            return $scope.flag('fields.cvv');
	                        };
	
	                        $scope.expiryShown = function () {
	
	                            if ($scope.isPlcc && $scope.card.type) {
	                                return true;
	                            }
	                            if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
	                                return false;
	                            }
	
	                            return $scope.flag('fields.expiry');
	                        };
	
	                        $scope.enableDropDown = function () {
	                            return Boolean(['ES', 'FR', 'GB', 'IT'].indexOf($scope.locale.country) > -1) || forceDropDown;
	                        };
	
	                        $scope.showDropDown = function () {
	
	                            if ($scope.enableDropDown()) {
	                                return true;
	                            }
	
	                            if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 4 && !cardTypeServiceCall && !$scope.isPlcc) {
	                                return true;
	                            }
	
	                            if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 7 && cardTypeServiceCall && isUnsupportedCard) {
	                                return true;
	                            }
	
	                            return false;
	                        };
	
	                        $scope.showAcceptedCardLogos = function () {
	                            return !$scope.showDropDown() && $feature('showAcceptedCardLogos', false, $scope.country);
	                        };
	
	                        $scope.getCardTypeByNumber = function (types, number) {
	                            if ($scope.isPlcc && number.length > 6 || !$scope.isPlcc) {
	                                return _cardMetaData.$CardMetaData.getCardType(types, number);
	                            }
	                        };
	
	                        function formatCardNumber(number) {
	                            var spaces = $scope.flag('spaces');
	                            var formatted = [];
	
	                            for (var i = 0; i < number.length; i++) {
	                                if (spaces.indexOf(i) > -1) {
	                                    formatted.push(' ');
	                                }
	
	                                formatted.push(number.charAt(i));
	                            }
	
	                            number = formatted.join('');
	                            return number;
	                        }
	
	                        $scope.$watch('card.type', function () {
	                            if ($scope.cardTypeChanged) {
	                                $scope.cardTypeChanged();
	                            }
	                        });
	
	                        /**
	                         * Hit Callback(unformatted cc no) when user gets out of the cardNumber field.
	                         */
	                        $scope.ccOnBlur = function () {
	                            if ($scope.cardNumberChanged) {
	                                $scope.cardNumberChanged($scope.unformattedCardNumber);
	                            }
	                        };
	
	                        // e.g for a dual brand = ['CUP' ,'VISA'], select VISA or CUP based
	                        // on regex defined for card type. If not regex was defined, pick one
	                        // of the allowed card type.
	                        function selectCardTypeForDualBrands(result) {
	                            var dualCardTypes = $feature('dualCardTypes', {});
	                            var match;
	                            Object.keys(dualCardTypes).some(function (key) {
	                                return result.some(function (cardType) {
	                                    if (cardType.type === key) {
	                                        match = key;
	                                        return true;
	                                    }
	                                });
	                            });
	
	                            if (match) {
	                                var regex = new RegExp(dualCardTypes[match]);
	                                var selected = $util.find(result, function (cardType) {
	                                    if (regex.test(cardType.type)) {
	                                        return true;
	                                    }
	                                });
	                                if (selected && selected.type === 'CUP') {
	                                    $util.some(result, function (cardType) {
	                                        if (/^AMEX$/.test(cardType.type)) {
	                                            selected.dualType = cardType.type;
	                                            return true;
	                                        }
	                                    });
	                                }
	
	                                return selected;
	                            } else {
	                                return $util.find(result, function (cardType) {
	                                    return $scope.cardTypes.allowed.indexOf(cardType.type) > -1;
	                                });
	                            }
	                        }
	
	                        function selectCardType(result) {
	                            if (angular.isArray(result)) {
	                                if (result.length >= 2) {
	                                    result = selectCardTypeForDualBrands(result);
	                                } else {
	                                    result = result[0];
	                                }
	                            }
	
	                            return result || {};
	                        }
	
	                        function clearCardType() {
	                            $scope.card.type = '';
	                            $scope.card.dualType = '';
	                            $scope.card.productType = '';
	                        }
	
	                        function getCardTypeByNumberServiceCall(number) {
	                            if (number.length >= 6) {
	                                var bin = number.slice(0, 6);
	
	                                if (lastVerifiedBin && lastVerifiedBin.bin === bin) {
	                                    $scope.card.type = lastVerifiedBin.type;
	                                    $scope.card.dualType = lastVerifiedBin.dualType;
	                                    $scope.card.productType = lastVerifiedBin.productType;
	                                    return;
	                                }
	
	                                if (isUnsupportedCard === bin || bin === lastRequestedBin) {
	                                    return;
	                                }
	
	                                lastRequestedBin = bin;
	
	                                var params = {
	                                    country: $scope.country,
	                                    user_country: $scope.country,
	                                    bin: bin
	                                };
	
	                                $scope.cardTypeFromBinModel = new $CardTypeFromBinModel(params);
	
	                                $scope.cardTypeFromBinModel.retrieve({
	                                    silent: true,
	                                    success: function success(result) {
	                                        result = selectCardType(result);
	                                        var type = result.type;
	                                        lastRequestedBin = undefined;
	
	                                        var disallowedCard = false;
	                                        if ($scope.cardTypes.allowed.indexOf(type) === -1) {
	                                            disallowedCard = true;
	                                        } else if ($scope.debitCardFlow) {
	                                            if (result.productType !== 'DEBIT') {
	                                                disallowedCard = true;
	                                            }
	                                        }
	
	                                        if (disallowedCard) {
	                                            clearCardType();
	                                            isUnsupportedCard = bin;
	                                            $scope.allowedCardsTooltip = true;
	                                            return;
	                                        }
	
	                                        isUnsupportedCard = undefined;
	                                        forceDropDown = false;
	                                        if (!$scope.showDropDown()) {
	                                            $scope.card.type = type;
	                                            $scope.card.dualType = result.dualType;
	                                            $scope.card.productType = result.productType;
	                                        }
	
	                                        lastVerifiedBin = {
	                                            bin: bin,
	                                            type: type,
	                                            dualType: result.dualType,
	                                            productType: result.productType
	                                        };
	
	                                        // This logic is to handle copy paste case when all numbers are entered at once
	                                        if ($scope.card.type && number.length >= $scope.flag('length.min')) {
	                                            if (/android/i.test(navigator.userAgent)) {
	                                                return;
	                                            }
	
	                                            var ccNumber = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
	
	                                            if (ccNumber.indexOf(number) >= 0) {
	                                                $scope.card.number = formatCardNumber(ccNumber);
	                                            }
	                                        }
	
	                                        return;
	                                    },
	                                    contingencies: {
	                                        GET_FI_ISSUER_DETAILS_ERR: function GET_FI_ISSUER_DETAILS_ERR(name, result) {
	                                            clearCardType();
	                                            isUnsupportedCard = bin;
	                                            lastRequestedBin = undefined;
	                                        }
	                                    },
	                                    error: function error() {
	                                        clearCardType();
	                                        isUnsupportedCard = bin;
	                                    }
	                                });
	                            } else {
	                                isUnsupportedCard = undefined;
	                                lastRequestedBin = undefined;
	                                forceDropDown = false;
	                                clearCardType();
	                            }
	                        }
	
	                        $scope.getAllowedCardTypeByNumber = function (number) {
	                            return $scope.getCardTypeByNumber($scope.cardTypes.allowed, number);
	                        };
	
	                        $scope.getDisallowedCardTypeByNumber = function (number) {
	                            return $scope.getCardTypeByNumber($scope.cardTypes.disallowed, number);
	                        };
	
	                        $scope.enableAddMode = function () {
	
	                            if ($scope.card.isExisting()) {
	                                $scope.card.number = '';
	                            }
	                        };
	
	                        $scope.changeType = function () {
	                            forceDropDown = true;
	
	                            $scope.changeCardNumber(true);
	
	                            // Blank out unsupported fields
	
	                            if (!$scope.flag('fields.expiry')) {
	                                delete $scope.card.expiry_month;
	                                delete $scope.card.expiry_year;
	                            }
	
	                            if (!$scope.flag('fields.issue')) {
	                                delete $scope.card.start_month;
	                                delete $scope.card.start_year;
	                                delete $scope.card.issue_number;
	                            }
	
	                            if (!$scope.flag('fields.dob')) {
	                                delete $scope.card.dob_day;
	                                delete $scope.card.dob_month;
	                                delete $scope.card.dob_year;
	                            }
	
	                            if (!$scope.flag('fields.cvv')) {
	                                delete $scope.card.security_code;
	                            }
	                        };
	
	                        $scope.changeCardNumber = function (isCardTypeChanged) {
	                            // If buyer tries to modify an update card number. We remove the whole string
	                            // so buyer can add a card instead.
	                            $scope.enableAddMode();
	                            $scope.allowedCardsTooltip = false;
	
	                            var regex = /[０-９]/;
	                            if ($feature('disableFullWidthCharacters') && regex.test($scope.card.number)) {
	                                $logger.info('checkout_fpti', {
	                                    'is_fullwidth_character': true
	                                });
	                            }
	
	                            var number = ($scope.card.number || '').replace(/[^0-9]+/g, '').slice(0, $scope.maxLength());
	                            var formattedNumber;
	
	                            $scope.unformattedCardNumber = number;
	
	                            // Attempt to determine the card type
	
	                            var cardType;
	
	                            if (cardTypeServiceCall) {
	                                if (!isCardTypeChanged) {
	                                    getCardTypeByNumberServiceCall(number);
	                                }
	
	                                if (isUnsupportedCard) {
	                                    $scope.allowedCardsTooltip = true;
	                                }
	                            } else {
	                                if (!isCardTypeChanged) {
	                                    // Hide dropdown and trigger bin matching when the cc number is < 4 digits
	                                    if (number.length < 4) {
	                                        forceDropDown = false;
	                                    }
	
	                                    if (!$scope.enableDropDown()) {
	                                        cardType = $scope.getAllowedCardTypeByNumber(number);
	                                        $scope.card.type = cardType.type;
	                                        $scope.card.subType = cardType.subType;
	                                    }
	                                }
	
	                                if ($scope.isPlcc && $scope.card.type) {
	                                    $scope.cvvShown();
	                                    $scope.expiryShown();
	                                }
	
	                                if (!$scope.card.type && !$scope.isPlcc && (number.length >= 4 || $scope.getDisallowedCardTypeByNumber(number).type)) {
	                                    $scope.allowedCardsTooltip = true;
	                                }
	                            }
	
	                            // Format the card number
	
	                            /*
	                             * PPPLMER-1563 commented out to fix this bug
	                             if (/android/i.test(navigator.userAgent)) {
	                             return;
	                             }
	                             */
	
	                            formattedNumber = formatCardNumber(number);
	
	                            // If the card is already formatted correctly, we can leave the user to continue in peace.
	                            if ($scope.card.number === formattedNumber) {
	                                return;
	                            }
	
	                            // Wait for the user's input to be reflected on the page (necessary for safari 5 otherwise selectionStart is incorrect)
	                            $timeout(function () {
	
	                                // re-formatting the number, since the card type may not have resolved before the first call
	                                $scope.card.number = formatCardNumber(number);
	
	                                // Save the current cursor positions
	                                var ccField = document.getElementById('cc');
	                                if (!ccField) {
	                                    return;
	                                }
	                                var inputLength = ccField.value.length;
	                                var cursorStart = ccField.selectionStart;
	
	                                // Wait for the formatted card to be reflected on the page
	                                $timeout(function () {
	
	                                    // If the cursor was at the end of the input field, keep it at the end
	                                    if (cursorStart === inputLength) {
	                                        ccField.selectionStart = ccField.selectionEnd = ccField.value.length;
	                                        // Otherwise place the cursor to the position it was in before we replaced with the formatted number
	                                    } else {
	                                        ccField.selectionStart = ccField.selectionEnd = cursorStart;
	                                    }
	                                });
	                            });
	                        };
	                    });
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_cardMetaData.$CardMetaData;

/***/ },

/***/ "./components/xo-ui-components/src/directionality/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/styles.less");
	
	/**
	 * This directive watches the model and listens to user input to look for arabic/hebrew/right-to-left language
	 * unicode chars, then adds dir="rtl" or dir="ltr" attribute to input field
	 *
	 * Add directionality to the container html div element of a input field.
	 * <div directionality><input type=text ng-model="user.name"></div>
	 */
	(0, _angular.$registerDirective)('directionality', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            var currentWatchDeregister = void 0;
	            var input = element.find('input');
	            if (!input.length) {
	                listenForInputRendered();
	                return;
	            }
	
	            // If the input has not yet been rendered inside the container, listen for dom node inserted
	            // then, if the node inserted is an input, we will use that element and init the directionality 
	            // listeners. The first input rendered is the one that will be captured by this directive.
	            function listenForInputRendered() {
	                element.bind('DOMNodeInserted', checkDOMNodeInserted);
	
	                function checkDOMNodeInserted(event) {
	                    if (event && event.target && event.target.tagName === 'INPUT') {
	                        element.unbind('DOMNodeInserted', checkDOMNodeInserted);
	                        input = angular.element(event.target);
	                        init();
	                    }
	                }
	            }
	
	            function setDirectionality(value) {
	                if (value) {
	                    // set directionality to 'rtl' if the value has hebrew/arabic unicode chars.
	                    element.toggleClass('ltrOverride', !_squid.$util.hasRTL(value));
	                } else {
	                    element.toggleClass('ltrOverride', _angular.$document.prop('documentElement').getAttribute('dir') !== 'rtl');
	                }
	            }
	
	            function jqueryOnKeyupHandler(event) {
	                setDirectionality(event.target.value);
	            }
	
	            // Reset directionality listeners when we transition from ltr -> rtl locale or vice versa
	            function resetDirectionalityListener() {
	                // remove directionality listeners that were set on prior locale
	                input.unbind('keyup', jqueryOnKeyupHandler);
	                if (currentWatchDeregister) {
	                    currentWatchDeregister();
	                }
	
	                // set new directionality listeners for the current locale if 'rtl'
	                if (document.documentElement.getAttribute('dir') === 'rtl') {
	                    (0, _angular.$timeout)(function () {
	                        // Watch ng-model on input to set directionality if it contains RTL char
	                        currentWatchDeregister = scope.$watch(input.attr('ng-model'), function (value) {
	                            setDirectionality(value);
	                        });
	                        // jQuery listener for cases where ng-model is not populated until post validation
	                        input.on('keyup', jqueryOnKeyupHandler);
	                    });
	                }
	            }
	
	            function init() {
	                resetDirectionalityListener();
	                scope.$on('localeChange', function () {
	                    resetDirectionalityListener();
	                });
	            }
	
	            init();
	        }
	    };
	});
	
	/**
	 * This directive watches the model for arabic/hebrew/right-to-left language unicode chars, then adds dir="rtl"
	 * or dir="ltr" attribute to the html element.
	 *
	 * Add directionality-text="<<model>>" to the div or span or any element containing text.
	 * <span directionality-text="user.name"><{{user.name}}</span>
	 */
	(0, _angular.$registerDirective)('directionality-text', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            if (document.documentElement.getAttribute('dir') === 'rtl') {
	                var $element = $(element);
	
	                (0, _angular.$timeout)(function () {
	                    if (attrs.directionalityText) {
	                        scope.$watch(attrs.directionalityText, function () {
	                            $element.toggleClass('ltrOverride', !_squid.$util.hasRTL((0, _angular.$parse)(attrs.directionalityText)(scope)));
	                        });
	                    } else {
	                        $element.toggleClass('ltrOverride', !_squid.$util.hasRTL(element.text()));
	                    }
	                });
	            }
	        }
	    };
	});
	
	_angular.$document;
	
	_angular.$parse;
	
	_angular.$registerDirective;
	
	_angular.$timeout;
	
	_squid.$util;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-ui-components/src/directionality/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/directionality/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/directionality/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".ltrOverride{direction:ltr!important;unicode-bidi:bidi-override!important}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cardIssueDate/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$xoCardIssueDateDirective = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/add-card/cardIssueDate/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoCardIssueDateDirective = exports.$xoCardIssueDateDirective = _squid.$Component.extend('$xoCardIssueDateDirective', {
	    tag: 'xo-card-issue-date',
	    template: _template2['default'],
	
	    props: {
	        issueMonth: {
	            type: 'var',
	            required: true
	        },
	        issueYear: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.dateFormat = (0, _squid.$feature)('ccIssueDateDateFormat', 'MMYY', _squid.$locale.country);
	
	            if (this.dateFormat === 'MMYY') {
	                this.maxlength = 5;
	                this.mask = '99/99';
	            } else if (this.dateFormat === 'MMYYYY') {
	                this.maxlength = 7;
	                this.mask = '99/9999';
	            }
	
	            this.formatIssueDate = function (event) {
	                var key = event.keyCode || event.charCode;
	                var $el = $(event.target);
	                var val = $el.val().replace(/[^0-9\/]/gi, '');
	                var strokes = val.length;
	
	                // Ignore delete keys
	                if (key === 8 || key === 46) {
	                    return;
	                }
	
	                // after two characters add a slash char
	                if (strokes === 2) {
	                    val += '/';
	                }
	
	                _this.issueDate = val;
	                $el.mask(_this.mask);
	            };
	
	            var currentYear = new Date().getFullYear();
	            var validMonths = _squid.$util.map(_squid.$util.range(1, 13), function (num) {
	                return ('0' + num).substr(-2);
	            });
	            var validYears = _squid.$util.map(_squid.$util.range(currentYear - 10, currentYear + 1), function (y) {
	                return y.toString();
	            });
	
	            this.validate = function (issueDate) {
	                if (!issueDate) {
	                    return;
	                }
	
	                var month = void 0,
	                    year = void 0,
	                    unformatted = void 0;
	                var isValid = false;
	
	                unformatted = issueDate.replace(/[^0-9]/gi, '');
	                if (unformatted.length > 3) {
	                    month = unformatted.substring(0, 2);
	                    if (_this.dateFormat === 'MMYY') {
	                        year = currentYear.toString().substring(0, 2) + unformatted.substring(2, 4);
	                    } else if (_this.dateFormat === 'MMYYYY') {
	                        year = unformatted.substring(2, 6);
	                    }
	
	                    isValid = validMonths.indexOf(month) > -1 && validYears.indexOf(year) > -1;
	
	                    if (isValid) {
	                        var date = new Date(year, parseInt(month, 10) - 1);
	                        var today = new Date();
	                        isValid = date < today;
	                    }
	                }
	
	                _this.issueYear = year;
	                _this.issueMonth = month;
	
	                return isValid;
	            };
	        }
	    }
	});
	
	angular.value("$xoCardIssueDateDirective", $xoCardIssueDateDirective);
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$feature;
	
	_squid.$util;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/cardIssueDate/template.html":
/***/ function(module, exports) {

	module.exports = "<div content directionality>\n    <input ng-model=\"issueDate\"\n           name=\"issue_date_value\"\n           id=\"issue_date_value\"\n           value=\"\"\n           maxlength=\"{{maxlength}}\"\n           autocapitalize=\"off\"\n           aria-describedby=\"issueHelp\"\n           autocomplete=\"off\"\n           ui-validate=\"'validate($value)'\"\n           ng-keyup=\"formatIssueDate($event)\"\n           placeholder=\"{{content('creditcard.expiresPlaceholder')}}\"\n           data-error-text=\"{{content('validation.validIssueDate')}}\"\n           xo-error-tooltip\n           required />\n    <span id=\"issueHelp\" class=\"accessAid\" ng-bind=\"content('creditcard.expiresPlaceholder')\"></span>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/dob/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/add-card/dob/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoDobCardInputDirective', {
	    tag: 'xo-dob-card-input',
	    template: _template2['default'],
	
	    props: {
	        user: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            function pad() {
	                var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
	
	                return function (num) {
	                    return (new Array(length + 1).join('0') + num).substr(-length);
	                };
	            }
	
	            var year = new Date().getFullYear();
	            this.days = _squid.$util.map(_squid.$util.range(1, 32), pad());
	            this.months = _squid.$util.map(_squid.$util.range(1, 13), pad());
	            this.years = _squid.$util.map(_squid.$util.range(year - 100, year), pad(4)).reverse();
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$util;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/dob/template.html":
/***/ function(module, exports) {

	module.exports = "<div content id=\"cardDOB\" class=\"cardDOB inputField invisiField confidential last-child\">\n    <label class=\"dobLabel nolap\" for=\"dobDayCC\">{{ content('creditcard.dob') }}</label>\n\n    <div class=\"dropdown fidobDay nullable\">\n        <select xo-dropdown name=\"dobDayCC\" id=\"dobDayCC\" ng-model=\"user.dob_day\"\n                ng-options=\"day for day in days track by day\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyDD') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobMonth nullable\">\n        <select xo-dropdown name=\"dobMonthCC\" id=\"dobMonthCC\" ng-model=\"user.dob_month\"\n                ng-options=\"month for month in months track by month\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyMM') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobYear nullable\">\n        <select xo-dropdown name=\"dobYearCC\" id=\"dobYearCC\" ng-model=\"user.dob_year\"\n                ng-options=\"year for year in years track by year\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyYYYY') }}</option>\n        </select>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-form-components/src/name-input/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/name-input/template.html"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/floating-label/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	
	    return angular.module('xo-name-input.directive', ['squid', 'xo-error-tooltip.directive', 'floating-label.directive']).directive('xoNameInput', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                user: '=',
	                country: '@'
	            },
	
	            controller: function controller($populate, $scope, $locale, $MetadataModel) {
	
	                $scope.locale = $locale;
	                $scope.metadata = $MetadataModel.create();
	
	                // Normalizes Griffin's address-related content for rendering.
	
	                $scope.$watch('country', function () {
	                    $scope.metadata.choose($scope.country || $locale.country, $locale.lang);
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/name-input/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"fieldGroup name clearfix\" ng-class=\"country || locale.country\" content>\n  <div ng-if=\"metadata.nameEntry.layout\" ng-repeat=\"layoutItem in metadata.nameEntry.layout\">\n\n    <!-- First name -->\n    <div ng-if=\"layoutItem.$ === 'givenName'\">\n      <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" floating-label directionality>\n\n        <input ng-model=\"user.first_name\"\n               id=\"firstName\"\n               name=\"firstName\"\n               value=\"\"\n               pattern=\"(?!^\\d+$)^.+$\"\n               autocapitalize=\"off\"\n               aria-required=\"false\"\n               autocomplete=\"off\"\n               maxlength=\"100\"\n               xo-error-tooltip\n               ng-required=\"{{layoutItem.required}}\" />\n          <label for=\"firstName\">\n              {{content('common.firstName')}}\n          </label>\n      </div>\n    </div>\n\n    <!-- Last name -->\n    <div ng-if=\"layoutItem.$ === 'surname'\">\n      <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" floating-label directionality>\n        <input ng-model=\"user.last_name\"\n               id=\"lastName\"\n               name=\"lastName\"\n               value=\"\"\n               pattern=\"(?!^\\d+$)^.+$\"\n               autocapitalize=\"off\"\n               aria-required=\"false\"\n               autocomplete=\"off\"\n               maxlength=\"100\"\n               xo-error-tooltip\n               ng-required=\"{{layoutItem.required}}\" />\n          <label for=\"lastName\">\n              {{content('common.lastName')}}\n          </label>\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"!metadata.nameEntry.layout\">\n    <div class=\"inputField half confidential\" floating-label directionality>\n\n      <input ng-model=\"user.first_name\"\n             id=\"firstName\"\n             name=\"firstName\"\n             value=\"\"\n             pattern=\"(?!^\\d+$)^.+$\"\n             autocapitalize=\"off\"\n             aria-required=\"false\"\n             autocomplete=\"off\"\n             maxlength=\"100\"\n             xo-error-tooltip\n             ng-required=\"true\" />\n        <label for=\"firstName\">\n            {{content('common.firstName')}}\n        </label>\n    </div>\n\n    <!-- Last name -->\n    <div class=\"inputField half confidential last-child\" floating-label directionality>\n\n      <input ng-model=\"user.last_name\"\n             id=\"lastName\"\n             name=\"lastName\"\n             value=\"\"\n             pattern=\"(?!^\\d+$)^.+$\"\n             autocapitalize=\"off\"\n             aria-required=\"false\"\n             autocomplete=\"off\"\n             maxlength=\"100\"\n             xo-error-tooltip\n             ng-required=\"true\" />\n        <label for=\"lastName\">\n            {{content('common.lastName')}}\n        </label>\n    </div>\n  </div>\n</div>\n"

/***/ },

/***/ "./components/xo-ui-components/src/floating-label/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/floating-label/styles.less");
	
	var treatmentType;
	var newLocale;
	var oldLocale;
	
	function getTreatment() {
	
	    if (treatmentType !== undefined) {
	        return treatmentType;
	    }
	    if ((0, _squid.$feature)('floatingLabels')) {
	        return true;
	    }
	    var token = _angular.$rootScope.token;
	    var throttle = _squid.$config['floatingLabelLocales'] && _squid.$config['floatingLabelLocales'][_squid.$locale.country] && _squid.$config['floatingLabelLocales'][_squid.$locale.country][_squid.$locale.lang];
	    var id = _squid.$locale.lang + '_' + _squid.$locale.country + token;
	    treatmentType = throttle && (0, _squid.$experiment)('floating_label_exp', throttle, id, {}) ? true : false;
	    return treatmentType;
	}
	
	(0, _angular.$registerDirective)('floating-label', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            scope.$on('localeChange', function () {
	                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;
	                if (oldLocale !== newLocale) {
	                    treatmentType = undefined;
	                    oldLocale = newLocale;
	                }
	                scope.showFloatingLabels = getTreatment();
	            });
	
	            (0, _angular.$timeout)(function () {
	                scope.showFloatingLabels = getTreatment();
	
	                scope.$watch('showFloatingLabels', function (val) {
	                    // remove else block after experimentation is complete
	                    if (val) {
	                        element.addClass('floatingLabel');
	                        element.removeClass('noFloatingLabel');
	                    } else {
	                        element.removeClass('floatingLabel');
	                        element.addClass('noFloatingLabel');
	                    }
	                });
	
	                var input = element.find('input');
	
	                if (input.attr('placeholder')) {
	                    input.addClass('hasPlaceholder');
	                }
	
	                // To hide the placeholder labels for pre-populated input fields
	                scope.$watch(input.attr('ng-model'), function (value) {
	                    input.toggleClass('focused', !!value);
	                });
	
	                // We're using this as an alternative to watching 'ng-model' since this properly triggers the focused CSS property on email input.
	                input.on('keyup', function (event) {
	                    var val = event.target.value;
	                    input.toggleClass('focused', !!val);
	                });
	
	                input.on('focus blur click', function (event) {
	                    if (scope.showFloatingLabels) {
	                        input.toggleClass('focused', event.type === 'focus' || this.value.length > 0);
	                    }
	                }).trigger('blur');
	            });
	        }
	    };
	});
	
	(0, _angular.$registerDirective)('floating-label-dropdown', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	
	            scope.$on('localeChange', function () {
	                newLocale = _squid.$locale.country + '_' + _squid.$locale.lang;
	                if (oldLocale !== newLocale) {
	                    treatmentType = undefined;
	                    oldLocale = newLocale;
	                }
	                scope.showFloatingLabels = getTreatment();
	            });
	
	            (0, _angular.$timeout)(function () {
	
	                scope.showFloatingLabels = getTreatment();
	
	                scope.$watch('showFloatingLabels', function (val) {
	                    // remove else block after experimentation is complete
	                    if (val) {
	                        element.addClass('floatingLabel');
	                        element.removeClass('noFloatingLabel');
	                    } else {
	                        element.removeClass('floatingLabel');
	                        element.addClass('noFloatingLabel');
	                    }
	                });
	
	                var select = element.find('select');
	                var label = element.find('label');
	                var flSpan = element.find('.custom-select span span');
	
	                select.on('change mouseenter mouseleave blur', function (event) {
	                    select.toggleClass('focused', event.type === 'change' || this.value.length > 0);
	                    flSpan.toggleClass('noValue', this.value.length < 1);
	                    label.toggleClass('hide', this.value.length < 1);
	                }).trigger('mouseleave');
	            });
	        }
	    };
	});
	
	_angular.$timeout;
	
	_angular.$rootScope;
	
	_angular.$registerDirective;
	
	_squid.$locale;
	
	_squid.$experiment;
	
	_squid.$config;
	
	_squid.$feature;

/***/ },

/***/ "./components/xo-ui-components/src/floating-label/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/floating-label/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/floating-label/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}.inputField.floatingLabel input{height:49px}.inputField.floatingLabel select{height:48px;font-size:15px}.inputField.floatingLabel select.focused~label.hide,.inputField.floatingLabel select:focus~label.hide{display:none}.inputField.floatingLabel.dropdown label{color:transparent}.inputField.floatingLabel.dropdown .custom-select span{padding:0 14px;position:relative;height:47px}.inputField.floatingLabel.dropdown .custom-select span span{top:18px;padding:0}.inputField.floatingLabel.dropdown .custom-select span span.noValue{top:9px}.inputField.floatingLabel input.focused,.inputField.floatingLabel input:focus,.inputField.floatingLabel select.focused,.inputField.floatingLabel select:focus{padding-top:16px}.inputField.floatingLabel input.focused::-webkit-input-placeholder,.inputField.floatingLabel input:focus::-webkit-input-placeholder,.inputField.floatingLabel select.focused::-webkit-input-placeholder,.inputField.floatingLabel select:focus::-webkit-input-placeholder{color:#6c7378}.inputField.floatingLabel input.focused:-moz-placeholder,.inputField.floatingLabel input.focused::-moz-placeholder,.inputField.floatingLabel input:focus:-moz-placeholder,.inputField.floatingLabel input:focus::-moz-placeholder,.inputField.floatingLabel select.focused:-moz-placeholder,.inputField.floatingLabel select.focused::-moz-placeholder,.inputField.floatingLabel select:focus:-moz-placeholder,.inputField.floatingLabel select:focus::-moz-placeholder{color:#6c7378}.inputField.floatingLabel input.focused:-ms-input-placeholder,.inputField.floatingLabel input:focus:-ms-input-placeholder,.inputField.floatingLabel select.focused:-ms-input-placeholder,.inputField.floatingLabel select:focus:-ms-input-placeholder{color:#6c7378}.inputField.floatingLabel input.focused~label,.inputField.floatingLabel input:focus~label,.inputField.floatingLabel select.focused~label,.inputField.floatingLabel select:focus~label{color:#0070ba;-webkit-transform:translate3d(0,-7px,0) scale(.8);transform:translate3d(0,-7px,0) scale(.8);text-overflow:ellipsis;overflow-x:hidden;width:100%;display:inline-block;white-space:nowrap}.inputField.floatingLabel input.focused:not(:focus)~label,.inputField.floatingLabel select.focused:not(:focus)~label{color:#6c7378}.inputField.floatingLabel input::-webkit-input-placeholder,.inputField.floatingLabel select::-webkit-input-placeholder{color:transparent}.inputField.floatingLabel input:-moz-placeholder,.inputField.floatingLabel input::-moz-placeholder,.inputField.floatingLabel select:-moz-placeholder,.inputField.floatingLabel select::-moz-placeholder{color:transparent}.inputField.floatingLabel input:-ms-input-placeholder,.inputField.floatingLabel select:-ms-input-placeholder{color:transparent}.inputField.floatingLabel label{color:#6c7378;position:absolute;top:14px;left:14px;pointer-events:none;-webkit-transform:translateZ(0) scale(1);transform:translateZ(0) scale(1);transform-origin:left top 0;transition:all .25s ease-in-out;text-overflow:ellipsis;overflow-x:hidden;width:90%;display:inline-block;white-space:nowrap}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus::-webkit-input-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid.focused::-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus::-moz-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid:focus:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:focus:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid.focused:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:focus:-ms-input-placeholder{color:#6c7378}.validated .inputField.floatingLabelDropdown input.ng-invalid:not(:focus):not(.focused)~label,.validated .inputField.floatingLabel input.ng-invalid:not(:focus):not(.focused)~label,.validated .inputField.noFloatingLabel input.ng-invalid:not(:focus):not(.focused)~label{color:#c72e2e}.validated .inputField.floatingLabelDropdown input.ng-invalid::-webkit-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid::-webkit-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid::-webkit-input-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid:-moz-placeholder,.validated .inputField.floatingLabelDropdown input.ng-invalid::-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid:-moz-placeholder,.validated .inputField.floatingLabel input.ng-invalid::-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:-moz-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid::-moz-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid:-ms-input-placeholder,.validated .inputField.floatingLabel input.ng-invalid:-ms-input-placeholder,.validated .inputField.noFloatingLabel input.ng-invalid:-ms-input-placeholder{color:transparent}.validated .inputField.floatingLabelDropdown input.ng-invalid~label,.validated .inputField.floatingLabel input.ng-invalid~label,.validated .inputField.noFloatingLabel input.ng-invalid~label{color:#c72e2e}.validated .inputField.floatingLabelDropdown input.ng-invalid~label.hide,.validated .inputField.floatingLabel input.ng-invalid~label.hide,.validated .inputField.noFloatingLabel input.ng-invalid.focused~label,.validated .inputField.noFloatingLabel input.ng-invalid~label.hide{color:transparent}.inputField.noFloatingLabel label{color:transparent;left:14px;text-overflow:ellipsis;overflow-x:hidden;width:90%;white-space:nowrap;pointer-events:none}.inputField.noFloatingLabel input{height:49px}.inputField.noFloatingLabel input::-webkit-input-placeholder{color:transparent}.inputField.noFloatingLabel input:-moz-placeholder,.inputField.noFloatingLabel input::-moz-placeholder{color:transparent}.inputField.noFloatingLabel input:-ms-input-placeholder{color:transparent}.inputField.noFloatingLabel input:focus.focused~label{color:transparent}.inputField.noFloatingLabel input:not(.focused):focus~label{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder~label{color:transparent}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder::-webkit-input-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder:-moz-placeholder,.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder::-moz-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(.focused):focus.hasPlaceholder:-ms-input-placeholder{color:#6c7378}.inputField.noFloatingLabel input:not(:focus):not(.focused)~label{color:#6c7378}.inputField.noFloatingLabel select{height:48px;font-size:15px}.inputField.noFloatingLabel select.focused~label,.inputField.noFloatingLabel select:focus~label{color:transparent}.inputField.noFloatingLabel .custom-select span{padding:0 14px;position:relative;height:47px}.inputField.noFloatingLabel .custom-select span span{top:11px;padding:0}.inputField.noFloatingLabel#countryOfResidenceDropDown,.inputField.noFloatingLabel#nationalityDropDown{min-height:87px}.inputField.noFloatingLabel#countryOfResidenceDropDown .custom-select,.inputField.noFloatingLabel#countryOfResidenceDropDown select,.inputField.noFloatingLabel#nationalityDropDown .custom-select,.inputField.noFloatingLabel#nationalityDropDown select{top:20px}.inputField.noFloatingLabel#countryOfResidenceDropDown label,.inputField.noFloatingLabel#nationalityDropDown label{color:#6c7378;top:0;left:0}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/creditcard-input/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"creditCardInput\" content>\n    <!-- These two hidden fields are added to avoid autofill issue by chome for password and login field -->\n    <input style=\"display:none\">\n    <input type=\"password\" style=\"display:none\">\n\n    <div class=\"cardIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showAcceptedCardLogos()\">\n        <div class=\"icons\" ng-repeat = \"cardType in cardTypes.allowed\"><div class = \"cardIcon {{cardType}}\"></div></div>\n    </div>\n\n    <div class=\"debitAndCreditIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showMXCardLogos()\">\n        <p id=\"mxCardTitle\" class=\"cardIconTitle\">{{content('creditcard.cardIconTitle')}} </p>\n        <div class=\"cardIconsSection\">\n            <p class=\"creditIconLabel\" ng-if=\"showLabels\">{{content('creditcard.creditIconLabel')}}</p>\n            <div class=\"mxCardIconGroup\">\n                <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed\">\n                    <div class=\"cardIcon {{cardType}}\"></div>\n                </div>\n            </div>\n            <br>\n            <p class=\"debitIconLabel\" ng-if=\"showLabels\">{{content('creditcard.debitIconLabel')}}</p>\n            <div class=\"icons\"\n                 ng-repeat=\"cardType in mxDebitCards\">\n                <div class=\"debitcardIcon {{cardType}}\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isPlcc\" class=\"plccCardNumberTitle\" >{{content('addCard.plccAddCard', { merchant: promotion.name})}}</div>\n\n    <div class=\"dropdown cardType confidential nullable\" ng-if=\"!manageCardFlow && showDropDown()\">\n        <label for=\"cardType\" id=\"cardTypeLabel\" class=\"accessAid\">{{ content('creditcard.typeLabel') }}</label>\n        <select xo-dropdown name=\"cardType\" ng-model=\"card.type\" ng-change=\"changeType()\" ng-required=\"true\"\n                ng-options=\"cardType as content('cardTypes.' + cardType) for cardType in cardTypes.allowed track by cardType\"\n                id=\"cardType\" aria-labelledby=\"cardTypeLabel\" data-show-card-type=\"false\">\n            <option value=\"\" selected>{{ content('creditcard.typeLabel') }}</option>\n        </select>\n    </div>\n\n    <div ng-if=\"!manageCardFlow\" class=\"inputField confidential cardNumber creditCardField\" directionality>\n        <label for=\"cc\" class=\"focus accessAid\">\n            {{ content('creditcard.cardNumber') }}\n        </label>\n\n        <input type=\"tel\" ui-validate=\"{luhn: 'cardLuhnValid($value)', len: 'cardLengthValid($value)', prodType: 'cardProductValid($value)'}\"\n                ui-validate-watch=\"'card.type'\"\n                ng-model=\"card.number\" name=\"cardNumber\" id=\"cc\" value=\"\" ng-change=\"changeCardNumber(false)\"\n                ng-blur=\"ccOnBlur()\"\n                maxlength=\"{{maxLength()}}\" data-number=\"{{unformattedCardNumber}}\"\n                autocapitalize=\"off\" data-country=\"{{ locale.country }}\" autocomplete=\"off\"\n                placeholder=\"{{ content('creditcard.cardNumber') }}\"\n                ng-pattern=\"/.*/\"\n                pattern=\"[0-9]*\"\n                scroll-to-top\n                data-error-text=\"{{content(debitCardFlow ? 'validation.validDebitCard' : 'validation.validCreditCard')}}\" xo-error-tooltip />\n\n        <xo-tooltip trigger=\"#cc\" ng-if=\"allowedCardsTooltip\" show-event=\"keyup\">\n            <div class=\"tip tipDesc tipCreditCard\">\n                {{ !debitCardFlow ? content('creditcard.acceptableCards') : content('creditcard.acceptDebitCardOnly') }}\n                <span class=\"acceptedCards\" ng-if=\"!debitCardFlow\">\n                    {{supportedCardNamesCommaSeparated}}\n                </span>\n            </div>\n        </xo-tooltip>\n\n        <span ng-if=\"card.type\" class=\"creditCard {{card.type}} {{card.subType}}\" aria-label=\"{{card.type}}\" id=\"creditCard\" role=\"img\">{{card.type}}</span>\n    </div>\n\n    <!-- Issue no and start date for maestro cards -->\n    <div id=\"cardIssueInfo\" data-cardspecific=\"true\" class=\"fieldGroup clearfix\" ng-if=\"flag('fields.issue')\">\n        <div>\n            <div class=\"startDate inputField invisiField half confidential\">\n                <label class=\"starts nolap\" for=\"startmonth\">{{ content('creditcard.startDate') }}</label>\n\n                <xo-card-issue-date issue-month=\"card.start_month\" issue-year=\"card.start_year\"></xo-card-issue-date>\n\n            </div>\n\n            <div class=\"issueNo inputField half last-child confidential last-child\">\n                <input id=\"issueNo\" name=\"issueNo\" placeholder=\"{{content('creditcard.issueNoLabel')}}\" type=\"text\" ng-model=\"card.issue_number\" autocapitalize=\"off\" autocomplete=\"off\" maxlength=\"2\" ng-pattern=\"/^[0-9]+$/\" pattern=\"[0-9]*\"/>\n\n                <xo-tooltip trigger=\"#issueNo\">\n                    <div class=\"tip tipDesc tipIssueNo\">\n                        {{ content('creditcard.issueNoLabelToolTip') }}\n                    </div>\n                </xo-tooltip>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"expiryShown() || cvvShown()\">\n        <xo-card-expiry ng-if=\"expiryShown()\" expiry-month=\"card.expiry_month\" expiry-year=\"card.expiry_year\"></xo-card-expiry>\n        <xo-cvv ng-if=\"cvvShown()\" card=\"card\" show-label=\"true\"></xo-cvv>\n    </div>\n    \n    <!-- DOB fields for Country specific cards -->\n    <xo-dob-card-input ng-if=\"flag('fields.dob')\" user=\"user\"></xo-dob-card-input>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/selectcard/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/selectcard/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-add-card.selectcard.route', ['xo-add-card.selectcard.directive']).factory('$SelectCardRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('SelectCardRoute', {
	
	            name: 'selectCard',
	            directive: 'xo-select-card',
	            titleContent: 'asideHeader.selectCard',
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/selectcard", "components/xo-wallet-components/src/add-card/selectcard/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/selectcard/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/selectcard/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	
	    return angular.module('xo-add-card.selectcard.directive', []).directive('xoSelectCard', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                parentCallbacks: '=',
	                token: '=',
	                promotion: '='
	            },
	
	            controller: function controller($scope, $populate, $CheckoutSessionModel) {
	
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(function () {
	                    $scope.selectCardType = function (type) {
	                        // card type is either 'cc' or 'plcc'
	                        $scope.parentCallbacks.cardTypeSelected(type);
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/selectcard/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"selectCardType\">\n\t<xo-aside-header hdrtype='tall' heading='asideHeader.selectCard' sub-head='asideHeader.fundingInstrumentsSubHead' back-url=\"checkout.review.sidebar.wallet\"></xo-aside-header>\n\n\t<div class=\"asideContent fundingCards\" id=\"selectFundingType\" content>\n\t\t<div class=\"allCards\">\n\t\t\t<ul class=\"allFundingInstrumentsList clearfix\">\n\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('cc')\">\n\t\t\t\t\t\t<span class=\"fsIcon\"></span>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">Debit or Credit Card</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('plcc')\">\n\t\t\t\t\t\t<img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">{{content('addCard.plccAddCard', { merchant: promotion.name})}}</span>\n\t\t\t\t\t\t\t<span class=\"secondary\">{{content('addCard.plccSelectIncentive')}}</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addbilling/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addbilling/directive.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-address-components/src/address-normalization/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.addbilling.route', ['squid', 'xo-add-card.addbilling.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$AddBillingRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddBillingRoute', {
	
	            name: 'addBilling',
	            directive: 'xo-add-billing',
	            titleContent: 'addBillingAddress.title',
	
	            trackingData: {
	                fptiState: 'edit_billing'
	            },
	            loginRequired: true,
	            children: [{
	                name: '$AddressNormalizationRoute',
	                attributes: {
	                    id: 'token',
	                    sidebar: 'sidebar',
	                    address: 'address',
	                    'done-fn': 'uponNormalization'
	                }
	            }]
	
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/addbilling", "components/xo-wallet-components/src/add-card/addbilling/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addbilling/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addbilling/template.html"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, module, template) {
	
	    return module('xo-add-card.addbilling.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address', 'xo-add-address.directive', 'xo-aside-header.directive', 'xo-error-tooltip.directive', 'ui.validate', 'xo-accessibility.directive']).directive('xoAddBilling', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                auth: '=',
	                token: '=',
	                doneFn: '=',
	                parentCallbacks: '=',
	                sidebar: '=',
	                showmeftsection: '=',
	                hideparenthead: '=',
	                billingaddressupdated: '=',
	                prefillAddress: '='
	            },
	
	            controller: function controller($scope, $populate, $BillingAddressesModel, $BillingAddressModel, $PrefillAddressModel, $feature, $state, $element, $config, $locale, $timeout, $FlowEligibilityModel, $meta) {
	                var country = $locale.getCountryCodeISO();
	                $scope.billing = true; // to denote its billing address page still
	                $scope.normalize = $feature('addressNormalization');
	                $scope.country = country;
	                var $el = $($element);
	                if ($scope.showmeftsection) {
	                    $scope.showmeftsection.toggle = false;
	                }
	
	                if ($scope.hideparenthead) {
	                    $scope.hideparenthead.toggle = true;
	                }
	
	                function isUserInputtedAddress(address) {
	                    return address.id === '0';
	                }
	
	                // Label fields has having error if needed to, and focus the first error if needed
	                function handleValidation(res) {
	                    if (res && res.fields && res.fields.length) {
	                        res.fields.forEach(function (field) {
	                            if (field.field) {
	                                var $field = $($el.find('[name="' + field.field + '"]'));
	                                if ($field.length === 0 && field.field === 'zip') {
	                                    $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
	                                }
	
	                                $field.addClass('backendError');
	                                $field.attr('aria-invalid', true);
	                            }
	                        });
	                    }
	
	                    $el.find('form').find('.backendError, .ng-invalid').first().focus();
	                }
	
	                var prefilledAddress = $scope.prefillAddress && $scope.prefillAddress.address;
	
	                if (prefilledAddress) {
	                    $scope.prefilled = true;
	                }
	
	                $scope.address = $scope.address || prefilledAddress || { country: country };
	
	                $populate($scope, {
	                    billingAddresses: $BillingAddressesModel.instance(),
	                    flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
	                        params: {
	                            geolocation: $meta.geolocation,
	                            localeCountry: $locale.country
	                        }
	                    })
	                }).then(function () {
	                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';
	
	                    $scope.cancelFn = function () {
	                        $scope.done();
	                    };
	
	                    $scope.done = function (target) {
	                        var el = $('.tokenization #sidepageAddCard');
	                        if (el) {
	                            el.removeClass('slideLeft');
	                        }
	
	                        target = target || '^.addCard';
	                        $state.go(target);
	                    };
	
	                    $scope.onSubmit = function () {
	                        $scope.updateAddress();
	                    };
	
	                    $scope.prefill = function () {
	                        $scope.address.country = $scope.country;
	                        $scope.prefillAddress = new $PrefillAddressModel({
	                            id: $scope.token,
	                            address: $scope.address
	                        });
	
	                        $scope.prefillAddress.save({
	                            data: $scope.prefillAddress,
	
	                            success: function success(result) {
	                                $scope.address = result;
	                                $scope.prefilled = true;
	                                $scope.showAddressFields = true;
	
	                                $timeout(function () {
	                                    var value = $scope.address.state;
	
	                                    var $option = $el.find('[value="' + value + '"]');
	                                    $option.prop('selected', 'selected');
	                                    $option.trigger('change');
	
	                                    value = $option.attr('label');
	                                }, 1000);
	                            }
	                        });
	                    };
	
	                    $scope.updateAddress = function () {
	
	                        var newBilling = new $BillingAddressModel({
	                            line1: $scope.address.line1,
	                            line2: $scope.address.line2,
	                            city: $scope.address.city,
	                            state: $scope.address.state,
	                            postal_code: $scope.address.postal_code,
	                            normalization_status: $scope.address.normalization_status,
	                            country: country,
	                            id: '0'
	                        });
	
	                        newBilling.save({
	                            data: $scope.billingAddress,
	
	                            success: function success() {
	                                if ($scope.normalize) {
	                                    // set to false so that html related to billing address is hidden when child is shown
	                                    $scope.billing = false;
	                                    $scope.address.full_address = newBilling.full_address;
	                                    $state.go('.addressNormalization');
	                                } else {
	                                    $scope.updateBillingAddressAndReturn('^.addCard', newBilling);
	                                }
	                            },
	
	                            validation: function validation(res) {
	                                handleValidation(res);
	                            }
	
	                        });
	                    };
	
	                    $scope.uponNormalization = function (normalizedAddress, isBack) {
	                        if (isBack) {
	                            $scope.billing = true;
	                            $state.go('^');
	                        } else {
	                            $scope.updateBillingAddressAndReturn('^.^.addCard', normalizedAddress);
	                        }
	                    };
	
	                    $scope.updateBillingAddressAndReturn = function (target, address) {
	                        var newBillingAddress;
	                        if (address && address instanceof $BillingAddressModel) {
	                            newBillingAddress = address;
	                        } else {
	                            newBillingAddress = new $BillingAddressModel({
	                                line1: address.line1,
	                                line2: address.line2,
	                                city: address.city,
	                                state: address.state,
	                                postal_code: address.postal_code,
	                                normalization_status: address.normalization_status,
	                                country: address.country || $scope.country,
	                                full_address: address.full_address || $scope.address.full_address,
	                                id: '0'
	                            });
	                        }
	
	                        var addresses = $scope.billingAddresses.addresses;
	                        if (!isUserInputtedAddress(addresses[0])) {
	                            addresses.unshift(newBillingAddress);
	                        } else {
	                            addresses[0] = newBillingAddress;
	                        }
	                        $scope.billingaddressupdated.value = true;
	
	                        $scope.done(target);
	                    };
	
	                    // page transition after the page is loaded
	                    var el = $('.tokenization #sidepageAddCard');
	                    if (el) {
	                        el.addClass('slideLeft');
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addbilling/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"addBillingAddress\" ng-if=\"billing\" modal-box=\"address\" modal-cancel=\"cancelFn()\">\n    <xo-aside-header heading='asideHeader.addBillingAddress' ng-if=\"debitCardFlow\"\n                     hidex=\"true\"\n                     header-left-link=\"done\"\n                     header-left=\"common.back\"\n                     header-left-icon=\"true\"></xo-aside-header>\n\n    <xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n    <h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar && !debitCardFlow\">{{ content('addBillingAddress.title') }}</h1>\n\n    <form id=\"billingAddressForm\" name=\"billingAddressForm\" class=\"asideView addressForm\" content form-autofocus novalidate>\n        <div class=\"trayInner container\">\n            <div class=\"clearfix\">\n                <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n            </div>\n\n            <div class=\"buttons clearfix\">\n                <a ng-hide=\"sidebar || debitCardFlow\" id=\"backButton\" ui-sref=\"^.addCard\" class=\"btn btn-secondary\" role=\"button\">{{ content('common.back') }}</a>\n                <input ng-if=\"country==='BR' && !prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"prefill()\" />\n                <input track-submit ng-if=\"country!=='BR' || prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.save') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"onSubmit()\" />\n            </div>\n        </div>\n    </form>\n</div>\n<div ui-view></div>\n"

/***/ },

/***/ "./components/xo-address-components/src/add-address/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-address-components/src/add-address/template.html"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/dropdown-multiline/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-form-components/src/name-input/directive.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-form-components/src/zipcode/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-add-address.directive', ['squid', 'xo-dropdown.directive', 'xo-dropdown-multiline.directive', 'xo-error-tooltip.directive', 'xo-name-input.directive', 'xomodel.address', 'xo-zipcode.directive']).directive('discriminate', function ($timeout, $parse) {
	        // scans through the rendered elements within a container and
	        // applies the supplied discriminator function to all the 'id'
	        // and 'for' attributes. NOTE: Use the string 'baseId' when
	        // entering the expression for the directive.
	        //
	        // e.g. discriminate='someDiscriminator(baseId)'
	        //
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attrs) {
	                // wait for the DOM to settle down
	                $timeout(function () {
	                    var discriminatorFn = $parse(attrs.discriminate);
	
	                    $(element).find('[for],[id],[name]').each(function () {
	                        // apply the discriminator to the attributes
	                        var baseFor = $(this).attr('for');
	                        var baseId = $(this).attr('id');
	                        var baseName = $(this).attr('name');
	
	                        if (baseFor) {
	                            $(this).attr('for', discriminatorFn(scope, { baseId: baseFor }));
	                        }
	
	                        if (baseId) {
	                            $(this).attr('id', discriminatorFn(scope, { baseId: baseId }));
	                        }
	
	                        if (baseName) {
	                            $(this).attr('name', discriminatorFn(scope, { baseId: baseName }));
	                        }
	                    });
	                });
	            }
	        };
	    }).directive('xoAddAddress', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                address: '=',
	                isShipping: '=',
	                country: '=',
	                metadata: '@',
	                hideButtonHandler: '=',
	                hideCep: '=',
	                hideName: '=',
	                triggerZipCodeBlur: '=',
	                triggerZipCodeKeyPress: '='
	            },
	
	            controller: function controller($scope, $populate, $rootScope, $locale, $window, $feature, $PrefillAddressModel, $MetadataModel) {
	
	                var country = $scope.country || $scope.address && $scope.address.country;
	
	                $scope.country = country;
	                $scope.locale = $locale;
	                $scope.metadata = $MetadataModel.create();
	
	                // If the user changes their shipping/billing address country, fetch that metadata (if needed) and re-render.
	                $scope.$watch('country', function setMetadata() {
	                    $scope.metadata.choose($scope.country, $scope.locale.lang);
	                });
	
	                // If the user changes languagle toggle, fetch that metadata (if needed) and re-render.
	                $scope.$on('contentChange', function setMetadata() {
	                    $scope.metadata.choose($scope.country, $scope.locale.lang);
	                });
	
	                // this function is used on ids and fors in the template to add 'shipping' or 'billing'
	                // in front of the identifier in camelCase. Use in conjunction with the 'discriminate' directive
	                $scope.addPrefix = function (baseId) {
	                    return ($scope.isShipping ? 'shipping' : 'billing') + baseId.replace(/^(.)/, function (match) {
	                        return match[0].toUpperCase();
	                    });
	                };
	
	                $scope.normalizeCountry = function (countryCode) {
	                    return $feature('AddressFormat', countryCode, countryCode) || countryCode;
	                };
	
	                $scope.isAddPreferred = $feature('preferredShipping', false, $scope.country) && $scope.isShipping;
	
	                $scope.isAddressLookupEnabled = $feature('addressLookup', false, $scope.country);
	                var sortStates = $feature('sortStatesForAddress', false, $scope.country);
	
	                $scope.isShowLookupFields = $scope.isAddressLookupEnabled;
	
	                if ($scope.isShowLookupFields) {
	                    // Show the Address Lookup Fields only when the hideButtonHandler function is passed by the caller.
	                    if ($scope.hideButtonHandler) {
	                        $scope.hideButtonHandler(true);
	                    } else {
	                        $scope.isShowLookupFields = false;
	                    }
	                }
	
	                function getSortedStateList() {
	                    var states = $locale.content.get(sortStates, {});
	                    var statesList = [];
	                    angular.forEach(states, function (key, value) {
	                        statesList.push({
	                            code: value,
	                            sname: key
	                        });
	                    });
	
	                    statesList.sort(function (a, b) {
	                        return a.sname.localeCompare(b.sname);
	                    });
	                    $scope.sortedStatesList = statesList;
	                }
	
	                if (sortStates) {
	                    getSortedStateList();
	                }
	
	                $scope.formatZip = function () {
	                    var unformatted = $scope.address.postal_code.replace(/[^0-9]/gi, '');
	                    var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3)]].map(function (x) {
	                        return x[1] && x[0] + x[1] || '';
	                    }).join('');
	                    $scope.address.postal_code = formatted;
	                };
	
	                function getAddress(address) {
	                    var COMMA = ', ';
	                    var SPACE = ' ';
	                    var line1, line2;
	
	                    function prefix(str, prefixStr) {
	                        if (str) {
	                            return (prefixStr ? prefixStr : '') + str;
	                        }
	                        return '';
	                    }
	
	                    if (!address.deliveryAddresses || angular.isArray(address.deliveryAddresses) && address.deliveryAddresses.length === 0) {
	                        // if deliveryAddresses is not an array or is empty
	                        // line would be empty, hence return to caller.
	                        return;
	                    }
	
	                    var array = address.deliveryAddresses;
	                    if (array.length > 1) {
	                        // populate line2 from the last element
	                        line2 = array.pop();
	                    }
	                    line1 = array.join(COMMA);
	
	                    var displayLine1 = line1 + prefix(line2, COMMA);
	                    var displayLine2 = prefix(address.city) + prefix(address.state, COMMA) + prefix(address.postal_code, SPACE);
	                    var displayLine3 = prefix(address.country);
	
	                    return {
	                        line1: line1,
	                        line2: line2,
	                        city: address.city,
	                        state: address.state,
	                        postal_code: address.postal_code,
	                        country: address.country,
	
	                        displayLine1: displayLine1,
	                        displayLine2: displayLine2,
	                        displayLine3: displayLine3,
	
	                        dropDownAddress: displayLine1 + prefix(displayLine2, ' \\n ') + prefix(displayLine3, ' \\n ')
	                    };
	                }
	
	                function populateAddressFormFields(address) {
	                    $scope.address.line1 = address.line1;
	                    $scope.address.line2 = address.line2;
	                    $scope.address.city = address.city;
	                    $scope.address.state = address.state;
	                    $scope.address.postal_code = address.postal_code;
	                    $scope.address.neighborhood = address.neighborhood;
	                }
	
	                /**
	                 * Show error message and display the full-address fields
	                 */
	                function populateErrorMessage() {
	                    var messages = [];
	                    messages.push($scope.locale.content.get('addressBook.lookupError'));
	
	                    $scope.lookupFailureMessage = {
	                        msgs: messages,
	                        type: 'warning'
	                    };
	
	                    $scope.isShowLookupFields = false;
	                    $scope.isLookupFailure = true;
	                }
	
	                function processLookupResult(list) {
	                    if (list.length > 1) {
	                        // Show drop-down list of all addresses
	                        $scope.isLookupSuccess = true;
	                        $scope.isShowLookupDropDown = true;
	                        $scope.lookupAddressList = list.map(function (addr) {
	                            return getAddress(addr);
	                        });
	                    } else if (list.length === 1) {
	                        // Show single address component
	                        $scope.isLookupSuccess = true;
	                        $scope.isShowLookupDropDown = false;
	
	                        var address = getAddress(list[0]);
	                        $scope.singleAddress = address;
	                        populateAddressFormFields(address);
	                    } else {
	                        populateErrorMessage();
	                    }
	                }
	
	                if ($scope.address) {
	                    $scope.lastPrefilledZip = $scope.address.postal_code;
	                }
	                $scope.prefill = function () {
	                    var cepPattern = /^(\d{5}-\d{3}|\d{5}|\d{8})$/;
	                    var first_name;
	                    var last_name;
	
	                    if ($scope.lastPrefilledZip === $scope.address.postal_code || !cepPattern.test($scope.address.postal_code)) {
	                        return;
	                    }
	
	                    if ($scope.isShipping) {
	                        first_name = $scope.address.first_name;
	                        last_name = $scope.address.last_name;
	                    }
	
	                    $scope.prefillAddress = new $PrefillAddressModel({
	                        id: $scope.token,
	                        address: {
	                            country: $scope.address.country,
	                            postal_code: $scope.address.postal_code
	                        }
	                    });
	
	                    $scope.prefillAddress.save({
	                        data: $scope.prefillAddress,
	
	                        success: function success(result) {
	                            if (result) {
	                                populateAddressFormFields(result);
	                                $scope.lastPrefilledZip = $scope.address.postal_code;
	                                if ($scope.isShipping) {
	                                    $scope.address.first_name = first_name;
	                                    $scope.address.last_name = last_name;
	                                }
	                            }
	                        }
	                    });
	                };
	
	                $scope.findAddress = function () {
	                    $scope.lookupAddress = $PrefillAddressModel.create($scope.token, {
	                        address: {
	                            country: $scope.address.country,
	                            postal_code: $scope.address.postal_code,
	                            house_number: $scope.address.house_number,
	                            building_name: $scope.address.building_name
	                        }
	                    });
	
	                    if (document.querySelector('#lookupZip.ng-invalid')) {
	                        document.querySelector('#addressLookupFields').classList.add('validated');
	                    } else {
	                        $scope.isLookupProcessing = true;
	                        $scope.lookupAddress.save({
	                            data: $scope.lookupAddress,
	                            silent: true,
	
	                            success: function success(result) {
	                                processLookupResult(result);
	                                $scope.hideButtonHandler(false);
	                            },
	
	                            contingencies: {
	                                INTERNAL_ERROR: populateErrorMessage
	                            }
	                        });
	                    }
	                };
	
	                $scope.changeAddressDropDown = function () {
	                    populateAddressFormFields($scope.address.selectedAddress);
	                };
	
	                $scope.showFullAddress = function () {
	                    $scope.isShowLookupFields = false;
	                    $scope.hideButtonHandler(false);
	                };
	
	                /**
	                 * Pass an array of group names to retrieve the list of states
	                 * e.g. ['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies']
	                 */
	                var stateNamesInGroup = [];
	                $scope.retrieveStateNamesInGroup = function (groups) {
	                    if (stateNamesInGroup.length) {
	                        // Angular keeps watching for this method as its used in ng-model, hence return cached data.
	                        return stateNamesInGroup;
	                    }
	                    var content = $locale.content;
	                    angular.forEach(groups, function (group) {
	                        var groupName = content.common[group];
	                        var statesList = content[group];
	                        angular.forEach(statesList, function (value, key) {
	                            stateNamesInGroup.push({
	                                key: key,
	                                value: value,
	                                group: groupName
	                            });
	                        });
	                    });
	                    return stateNamesInGroup;
	                };
	
	                $scope.zipCodeBlur = function () {
	                    if ($scope.triggerZipCodeBlur) {
	                        $rootScope.$emit('zip_code_blur');
	                    }
	                };
	
	                $scope.zipCodeKeyPress = function (event) {
	                    if ($scope.triggerZipCodeKeyPress) {
	                        $rootScope.$emit('zip_code_keypress', { event: event });
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-address-components/src/add-address/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"addressForm\" class=\"addressForm\" content ng-class=\"country\">\n\n    <xo-name-input user=\"address\" country=\"{{country}}\" ng-if=\"isShipping && !hideName\"></xo-name-input>\n\n    <div ng-switch=\"normalizeCountry(country)\" discriminate=\"addPrefix(baseId)\" class=\"addressGroup clearfix\">\n\n        <div ng-switch-when=\"BR\">\n            <xo-zipcode id=\"zipcode\" country=\"BR\" zip-code=\"address.postal_code\" zip-label=\"{{content('common.cep')}}\" zip-error-key=\"common.valueInvalid\" done-fn=\"prefill\" ng-if=\"!hideCep\"></xo-zipcode>\n\n            <div name=\"addressFields\" id=\"addressFields\">\n                <div class=\"streetName clearfix\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"60\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                        <label for=\"line1\" id=\"line1Label\">{{ content('common.streetAddress') }}</label>\n                    </div>\n                    <div class=\"inputField streetNumber\" floating-label>\n                        <input type=\"text\" name=\"streetNumber\" id=\"streetNumber\" ng-pattern=\"/^(?=.*[0-9])([a-zA-Z0-9]+)$/\" ng-model=\"address.streetNumber\" value=\"\" maxlength=\"6\" ariaRequired=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                        <label for=\"streetNumber\" id=\"streetNumberLabel\">{{ content('common.streetNumber') }}</label>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" />\n                    <label for=\"line2\" id=\"line2Label\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential neighborhood\" floating-label>\n                    <input type=\"text\" name=\"neighborhood\" id=\"neighborhood\" ng-model=\"address.neighborhood\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" ariaRequired=\"true\" data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                    <label for=\"neighborhood\" id=\"neighborhoodLabel\">{{ content('common.neighborhood') }}</label>\n                </div>\n                <div class=\"inputField confidential clearfix\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                        <label for=\"city\" id=\"cityLabel\">{{ content('common.onlyCity') }}</label>\n                    </div>\n                    <div class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-options=\"state.code as state.sname for state in sortedStatesList\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\" required >\n                            <option value=\"\">{{ content('common.otherState') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ content('common.otherState') }}</label>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-switch-when=\"GB\">\n            <!-- start: Show all the fields for Add Address if isShowLookupFields is false -->\n            <div ng-if=\"!isShowLookupFields\">\n                <div ng-if=\"isAddressLookupEnabled\">\n                    <div ng-if=\"isShipping\" class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                    </div>\n                    <div ng-show=\"isLookupFailure\" class=\"lookupFailureMsg\">\n                        <xo-message message=\"lookupFailureMessage\"></xo-message>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line1\" floating-label>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                    <label for=\"line1\" id=\"line1Label\">{{ content('common.streetAddress') }}</label>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" />\n                    <label for=\"line2\" id=\"line2Label\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential city\" floating-label>\n                    <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\">{{ content('common.onlyCity') }}</label>\n                </div>\n                <div class=\"stateZip clearfix\">\n                    <div class=\"dropdown confidential state inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\"\n                                aria-required=\"true\"\n                                ng-options=\"c.key as c.value group by c.group for c in retrieveStateNamesInGroup(['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies'])\">\n                            <option value=\"\">{{ content('common.countyOptional') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ content('common.countyOptional') }}</label>\n                    </div>\n                    <div class=\"inputField confidential postalCode\" floating-label>\n\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" value=\"\"\n                               autocapitalize=\"off\" aria-required=\"true\" ng-blur=\"zipCodeBlur()\"  ng-keypress=\"zipCodeKeyPress()\" autocomplete=\"off\" data-error-key=\"validation.validZipCode\"\n                               xo-validation='{\n                                    \"validator\": \"validZip\",\n                                    \"options\": {\n                                        \"country\": \"GB\"\n                                    }\n                                }'\n                               xo-error-tooltip required />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\">{{ content('common.zip') }}</label>\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show all the fields -->\n            <!-- start: Show only the address lookup fields -->\n            <div ng-if=\"isShowLookupFields\" id=\"addressLookup\" class=\"addressLookup\">\n                <div ng-hide=\"isLookupSuccess\" id=\"addressLookupFields\"> <!-- class=\"validated\" -->\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addBillingAddress.lookupTitle') }}</span>\n                        <a class=\"editAddress\" ng-click=\"showFullAddress()\">{{content('addressBook.enterFullAddress')}}</a>\n                    </div>\n                    <div class=\"fieldGroup\">\n                        <div class=\"inputField confidential lookupZip\">\n                            <input type=\"text\" name=\"lookupZip\" id=\"lookupZip\" ng-model=\"address.postal_code\" value=\"\"\n                                   autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                                   data-error-key=\"validation.validZipCode\"\n                                   xo-validation='{\n                                     \"validator\": \"validZip\",\n                                     \"options\": {\n                                       \"country\": \"GB\"\n                                     }\n                                   }'\n                                   ng-disabled=\"isLookupProcessing\" xo-error-tooltip required />\n                            <label for=\"lookupZip\" id=\"postalCodeLabel\">{{ content('common.zip') }}</label>\n                        </div>\n                    </div>\n                    <div class=\"inputField confidential houseNo\" floating-label>\n                        <input type=\"text\" id=\"houseNo\" ng-model=\"address.house_number\"\n                               value=\"\" maxlength=\"50\"\n                               autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\"\n                               data-error-key=\"common.valueInvalid\" xo-error-tooltip\n                               ng-disabled=\"isLookupProcessing\" />\n                        <label for=\"houseNo\" id=\"houseNoLabel\">{{ content('common.houseBldgNo')}}\n                        </label>\n                    </div>\n                    <div class=\"inputField confidential buildingName\" floating-label>\n                        <input type=\"text\" id=\"buildingName\" ng-model=\"address.building_name\"\n                               value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\"\n                               data-error-key=\"common.valueInvalid\"\n                               ng-disabled=\"isLookupProcessing\" />\n                        <label for=\"buildingName\" id=\"buildingNameLabel\"\n                            {{ content('common.houseBldgName') }}\n                        </label>\n                    </div>\n                    <button track-submit ng-click=\"findAddress()\" id=\"findAddressButton\" class=\"btn full continue\"\n                            ng-class=\"{processing: isLookupProcessing}\">\n                        <div ng-show=\"isLookupProcessing\" class=\"spinner\">\n                            <p class=\"loader\" ></p>\n                        </div>\n                        <div ng-hide=\"isLookupProcessing\" class=\"text\">{{ content('addressBook.findAddress') }}</div>\n                    </button>\n                </div>\n                <div ng-show=\"isLookupSuccess\">\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                        <a class=\"editAddress\"\n                           ng-click=\"showFullAddress()\">{{ content('common.change') }}</a>\n                    </div>\n                    <div ng-if=\"isShowLookupDropDown\" id=\"lookedupDropDown\"\n                         class=\"dropdown confidential clearfix\">\n\n                        <select xo-dropdown-multiline ng-model=\"address.selectedAddress\"\n                                ng-change=\"changeAddressDropDown()\"\n                                id=\"addressDropDown\" ng-required=\"isShowLookupDropDown\">\n                            <option value=\"\" selected=\"selected\"> {{ content('addressBook.selectYourAddress',\n                                { count: lookupAddressList.length}) }}</option>\n                            <option ng-repeat=\"addr in lookupAddressList\" value=\"{{$index}}\">\n                                {{ addr.dropDownAddress }}\n                            </option>\n                        </select>\n                    </div>\n                    <div ng-hide=\"isShowLookupDropDown\" class=\"singleAddress\">\n                        {{singleAddress.displayLine1}}<br/>\n                        {{singleAddress.displayLine2}}<br/>\n                        {{singleAddress.displayLine3}}\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show only the address lookup fields -->\n        </div>\n        <!-- GB end -->\n        <!-- IE begin -->\n        <div ng-switch-when=\"IE\">\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"line1\" id=\"line1Label\">{{locale.metadata.addressEntry.strings[country].line1Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" />\n                        <label for=\"line2\" id=\"line2Label\">{{locale.metadata.addressEntry.strings[country].line2Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"city\" id=\"cityLabel\">{{locale.metadata.addressEntry.strings[country].cityLabel}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country].stateList\"\n                         class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown ng-options=\"state.$id as state.$id for state in locale.metadata.addressEntry.strings[country].stateList\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\" ng-required=\"{{layoutItem.required}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                    <div ng-if=\"!locale.metadata.addressEntry.strings[country].stateList\" class=\"inputField confidential state\"\n                         floating-label>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" />\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <div class=\"inputField confidential postalCode\" floating-label>\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" ng-blur=\"zipCodeBlur()\"  ng-keypress=\"zipCodeKeyPress()\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"  data-error-key=\"validation.validZipCode\" maxlength=\"{{layoutItem.maxLength}}\" xo-error-tooltip />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\">{{ locale.metadata.addressEntry.strings[country].postcodeLabel }} </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- IE end -->\n\n        <div ng-switch-default>\n            <!-- Griffin metadata DOES exist for this country -->\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label directionality>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"line1\" id=\"line1Label\">{{locale.metadata.addressEntry.strings[country].line1Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label directionality>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" />\n                        <label for=\"line2\" id=\"line2Label\">{{locale.metadata.addressEntry.strings[country].line2Label}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label directionality>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip ng-required=\"{{layoutItem.required}}\" />\n                        <label for=\"city\" id=\"cityLabel\">{{locale.metadata.addressEntry.strings[country].cityLabel}}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country].stateList\"\n                         class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown ng-options=\"state.$id as state.$elt for state in locale.metadata.addressEntry.strings[country].stateList\" ng-model=\"address.state\" id=\"state\" aria-required=\"true\" ng-required=\"{{layoutItem.required}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                    <div ng-if=\"!locale.metadata.addressEntry.strings[country].stateList\" class=\"inputField confidential state\"\n                         floating-label directionality>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" />\n                        <label for=\"state\" id=\"stateLabel\">{{ locale.metadata.addressEntry.strings[country].stateLabel }}</label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <xo-zipcode id=\"zipcode\" zip-entry=\"layoutItem\" country=\"{{country}}\"\n                                max-length=\"layoutItem.maxLength\" zip-code=\"address.postal_code\"\n                                done-fn=\"zipCodeBlur\"\n                                key-press-fn=\"zipCodeKeyPress\"\n                                zip-label=\"{{ locale.metadata.addressEntry.strings[country].postcodeLabel }}\"\n                                zip-error-key=\"validation.validZipCode\"\n                                zip-required=\"layoutItem.required\"></xo-zipcode>\n                </div>\n            </div>\n            <!-- Griffin metadata DOES NOT exist for this country -->\n            <div ng-if=\"!metadata.addressEntry.layout\">\n                <div class=\"inputField confidential line1\" floating-label directionality>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                    <label for=\"line1\" id=\"line1Label\">{{ content('common.stAddress') }}</label>\n                </div>\n\n                <div class=\"inputField confidential city\" floating-label directionality>\n                    <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\">{{ content('common.otherCity') }}</label>\n                </div>\n\n                <div class=\"inputField confidential state\" floating-label directionality>\n                    <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" />\n                    <label for=\"state\" id=\"stateLabel\">{{ content('common.optionalState') }}</label>\n                </div>\n\n                <div class=\"inputField confidential postalCode\" floating-label directionality>\n                    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" value=\"\"  ng-blur=\"zipCodeBlur()\" ng-keypress=\"zipCodeKeyPress()\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"validation.validZipCode\"/>\n                    <label for=\"postalCode\" id=\"zipLabel\">{{ content('common.optionalPostalCode') }}</label>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isAddPreferred\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\" ng-model=\"address.preferred_address\" name=\"addPreferred\" id=\"addPreferred\" />\n        <label for=\"addPreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-ui-components/src/dropdown-multiline/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, $) {
	
	    squid.module('xo-dropdown-multiline.directive', ['squid']).directive('xoDropdownMultiline', function ($timeout) {
	        return {
	            restrict: 'A',
	
	            require: '?ngModel',
	
	            link: function link($scope, $select, attrs, ngModel) {
	
	                var isListVisible = false;
	                var listCreated = false;
	
	                $select = $($select);
	
	                var $span = $('<span class="custom-select" aria-hidden="true"><div class="arrow"></div><span class="innerContainer"><span></span></span></span>');
	                var $container = $('<div class="custom-select-container multiline-select-container" tabindex="0" />');
	                var $list;
	
	                function updateCover() {
	                    $timeout(function () {
	                        $span.find('span span').html($select.find('[selected]').text().replace(/\\n/gi, '<br>').trim());
	                    }, 10);
	                }
	
	                function createList($options) {
	                    if ($options.length < 2) {
	                        return;
	                    }
	
	                    function getModel() {
	                        var modelName;
	                        var model;
	                        var subParts;
	
	                        if ($select.attr('ng-options')) {
	                            modelName = $select.attr('ng-options').substring($select.attr('ng-options').indexOf('in ') + 3, $select.attr('ng-options').length);
	                        } else {
	                            var $option = $($select.find('[ng-repeat]')[0]);
	                            modelName = $option.attr('ng-repeat').substring($option.attr('ng-repeat').indexOf('in ') + 3, $option.attr('ng-repeat').length);
	                        }
	
	                        // This is to handle cases like card.billingAddress
	                        if (modelName.indexOf('.') !== -1) {
	                            subParts = modelName.split('.');
	                            model = $scope;
	
	                            for (var i = 0; i < subParts.length; i++) {
	                                model = model[subParts[i]];
	                            }
	                        } else {
	                            // And this is to handle straightforward model names
	                            model = $scope[modelName];
	                        }
	
	                        return model;
	                    }
	
	                    function hideList(event) {
	                        $list.hide();
	                        $container.append($list);
	                        isListVisible = false;
	                        $container.removeClass('open');
	                    }
	
	                    function positionList() {
	                        $list.css('left', $container.offset().left + 'px');
	                        $list.css('top', $container.offset().top + $container.height() + 'px');
	                        $list.css('width', $container.width() + 'px');
	                    }
	
	                    function setFocusOnSelected() {
	                        var $selected = $select.find('[selected]');
	
	                        if ($selected.length) {
	                            var $item = $list.find('[data-value="' + $selected.attr('value') + '"]');
	                            $item.focus();
	                        } else {
	                            $list.find('li')[0].focus();
	                        }
	                    }
	
	                    function showList() {
	                        $('body').append($list);
	                        $container.addClass('open');
	                        $list.show();
	                        positionList();
	                        isListVisible = true;
	                        setFocusOnSelected();
	                    }
	
	                    function processContainerKeypress(event) {
	                        var keyCode = event.keyCode;
	
	                        if (keyCode === 13 || keyCode === 40) {
	                            // enter or down arrow
	                            if (!isListVisible) {
	                                showList();
	                            } else {
	                                hideList();
	                                $container.focus();
	                            }
	                        } else if (keyCode === 27) {
	                            // escape
	                            if (isListVisible) {
	                                hideList();
	                                $container.focus();
	                            }
	                        }
	                    }
	
	                    if ($list) {
	                        $list.remove();
	                    }
	
	                    $list = $('<ul class="multiline-select-list" tabindex="0"></ul>');
	
	                    Array.prototype.forEach.call($options, function (option) {
	                        var $option = $(option);
	                        var value = $option.attr('value');
	                        var text = option.innerHTML.replace(/\\n/gi, '<br>');
	
	                        if (text.indexOf('content(') !== -1) {
	                            text = $scope.content(text.substring(text.indexOf('(\'') + 2, text.indexOf('\')')));
	                        }
	
	                        var html = '<li tabindex="0"';
	                        if (value !== $option.text()) {
	                            html = html + ' data-value="' + value + '"';
	                        }
	                        html = html + '>' + text + '</li>';
	                        $list.append($(html));
	                    });
	
	                    $container.append($list);
	                    $list.hide();
	
	                    $($list.find('li')).click(function (event) {
	                        var $target = $(event.target);
	                        var value = $target.data('value');
	
	                        if (typeof value !== 'undefined') {
	                            $select.find('option').removeAttr('selected');
	                            $select.find('option[value="' + value + '"]').attr('selected', 'selected');
	                            $select.find('option').removeProp('selected');
	                            $select.find('option[value="' + value + '"]').prop('selected', 'selected');
	                        } else {
	                            value = $target.html().replace(/\/<br\/>/gi, '\\n');
	                            $select.val(value);
	                        }
	
	                        if ($select.attr('ng-model')) {
	                            if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
	                                /* This parses the 'ng-options' directive and returns the options model.
	                                For example: If you have: ng-options='opt as opt.label for opt in options'
	                                Here it will parse this attribute and return 'options */
	                                var model = getModel();
	
	                                ngModel.$setViewValue(model[value]);
	                            } else {
	                                ngModel.$setViewValue(value);
	                            }
	                        }
	
	                        updateCover();
	                        hideList();
	                    });
	
	                    var $innerContainer = $container.find('.innerContainer');
	
	                    $container.click(function (event) {
	                        if (isListVisible) {
	                            hideList();
	                            $container.focus();
	                        } else {
	                            showList();
	                        }
	                    });
	
	                    $container.keydown(function (event) {
	                        processContainerKeypress(event);
	                    });
	
	                    $innerContainer.keydown(function (event) {
	                        processContainerKeypress(event);
	                    });
	
	                    $list.find('li').keydown(function (event) {
	                        var keyCode = event.keyCode;
	                        var $target = $(event.target);
	
	                        if (keyCode === 13) {
	                            // enter
	                            $target.click();
	                            event.stopPropagation();
	                        } else if (keyCode === 27) {
	                            // escape
	                            if (isListVisible) {
	                                hideList();
	                                $container.focus();
	                                event.stopPropagation();
	                            }
	                        } else if (keyCode === 40) {
	                            // down arrow
	                            if (!$target.is(':last-of-type')) {
	                                $target.next().focus();
	                                event.preventDefault();
	                                event.stopPropagation();
	                            }
	                        } else if (keyCode === 38) {
	                            // up arrow
	                            if (!$target.is(':first-of-type')) {
	                                $target.prev().focus();
	                            }
	                            event.preventDefault();
	                            event.stopPropagation();
	                        }
	                    });
	
	                    $(window).resize(function () {
	                        if (isListVisible) {
	                            positionList();
	                        }
	                    });
	
	                    $(window).bind('hashchange', function () {
	                        if (isListVisible) {
	                            hideList();
	                        }
	                    });
	
	                    $(document).click(function (event) {
	                        var $target = $(event.target);
	
	                        if (!($target.is($container) || $.contains($container.get()[0], $target.get()[0])) && isListVisible) {
	                            hideList();
	                        }
	                    });
	
	                    $container.blur(function (event) {
	                        // The setTimeout here is to ensure activeElement is set before our function executes
	                        $timeout(function () {
	                            var $newTarget = $(event.explicitOriginalTarget || document.activeElement);
	
	                            if (!($.contains($container.get()[0], $newTarget.get()[0]) || $.contains($list.get()[0], $newTarget.get()[0]))) {
	                                hideList(event);
	                            }
	                        }, 1);
	                    });
	
	                    listCreated = true;
	                    updateCover();
	                }
	
	                function render() {
	                    var options = $select.find('option');
	                    if (!listCreated) {
	                        createList(options);
	                    }
	                }
	
	                $select.wrap($container);
	                $container = $select.parent();
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseenter focus', function () {
	                    $span.addClass('active');
	                });
	
	                // Change class names to enable styling of hover/focus states
	                $select.bind('mouseleave blur', function () {
	                    $span.removeClass('active');
	                });
	
	                $select.after($span);
	
	                $select.addClass('replaced');
	
	                $select.attr('tabindex', '-1');
	
	                if (attrs['default']) {
	                    var defaultOption = document.createElement('option');
	                    defaultOption.innerText = attrs['default'];
	                    $select.append(defaultOption);
	                }
	
	                if ($select.attr('ng-options')) {
	                    $scope.$watch(attrs.ngModel, function () {
	                        render();
	                    });
	                } else {
	                    $timeout(function () {
	                        $scope.$broadcast('pageRendered');
	                    }, 0);
	                }
	
	                $scope.$on('pageRendered', function () {
	                    render();
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-form-components/src/zipcode/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/zipcode/template.html"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	    return angular.module('xo-zipcode.directive', ['squid', 'xo-error-tooltip.directive']).directive('xoZipcode', function () {
	        return {
	            template: template,
	            scope: {
	                country: '@',
	                zipLabel: '@',
	                postalCodeLabel: '@',
	                zipErrorKey: '@',
	                doneFn: '=',
	                keyPressFn: '=',
	                zipCode: '=',
	                zipEntry: '=',
	                maxLength: '='
	            },
	
	            controller: function controller($scope, $feature) {
	                var formatRegex;
	                var inputParams = $feature('zipcodeInputParams', undefined, $scope.country);
	                if (inputParams) {
	                    $scope.minLength = inputParams.minLength;
	                    $scope.maxLength = inputParams.maxLength;
	                    if (inputParams.formatPattern) {
	                        formatRegex = new RegExp(inputParams.formatPattern, 'g');
	                    }
	                }
	
	                function formatZipWithDash(zipcode, index) {
	                    if (zipcode.length > index) {
	                        zipcode = [zipcode.slice(0, index), '-', zipcode.slice(index)].join('');
	                    }
	                    return zipcode;
	                }
	
	                $scope.changeZip = function (zipcode) {
	                    if (zipcode) {
	
	                        if (formatRegex) {
	                            zipcode = zipcode.replace(formatRegex, '');
	                        }
	
	                        if (inputParams && inputParams.formatZip) {
	                            zipcode = formatZipWithDash(zipcode, inputParams.minLength);
	                        }
	
	                        $scope.zipCode = zipcode;
	                    }
	                };
	
	                $scope.doneFunction = function () {
	                    if ($scope.doneFn) {
	                        $scope.doneFn();
	                    }
	                };
	
	                $scope.keyPressHandler = function (event) {
	                    if ($scope.keyPressFn) {
	                        $scope.keyPressFn(event);
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/zipcode/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"zipField\" class=\"inputField confidential postalCode\" floating-label directionality content>\n    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"zipCode\"\n       autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" ng-change=\"changeZip(zipCode)\" xo-validation='{\"validator\": \"validZip\"}'\n       minlength=\"{{minLength}}\" maxlength=\"{{maxLength}}\" ng-blur=\"doneFunction()\" ng-keypress=\"keyPressHandler($event)\"\n       data-error-key=\"{{zipErrorKey}}\" xo-error-tooltip ng-required=\"{{zipRequired}}\"/>\n    <label for=\"postalCode\" id=\"postalCodeLabel\" >{{zipLabel}}</label>\n</div>\n\n"

/***/ },

/***/ "./components/xo-address-components/src/address-normalization/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-address-components/src/address-normalization/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-address-normalization.route', ['squid', 'xo-address-normalization.directive']).factory('$AddressNormalizationRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddressNormalizationRoute', {
	
	            name: 'addressNormalization',
	            titleContent: 'addressNormalization.addressmatch',
	            directive: 'xo-address-normalization',
	            trackingData: {
	                fptiState: 'address_normalization',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::address_normalization',
	                        'pagename2': '%::address_normalization:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            loginRequired: true,
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-address-components/src/address-normalization", "components/xo-address-components/src/address-normalization/route.js"))

/***/ },

/***/ "./components/xo-address-components/src/address-normalization/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {
	
	__webpack_require__("./components/xo-address-components/src/address-normalization/styles.less");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-address-components/src/address-normalization/template.html"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-address-normalization.directive', ['squid', 'xomodel.address', 'xo-aside-header.directive', 'xomodel.address', 'xo-tray-height.directive']).directive('xoAddressNormalization', function () {
	        return {
	            template: template,
	            scope: {
	                id: '=',
	                address: '=',
	                doneFn: '=',
	                sidebar: '=',
	                hideBackButton: '='
	            },
	            controller: function controller($scope, $populate, $feature, $util, $AddressNormalizationModel, $timeout) {
	                $util.assert($scope.address, 'Original Address cannot be empty');
	
	                $scope.showNormalization = false;
	
	                var normalize = $feature('addressNormalization', false, $scope.address.country);
	                if (!normalize) {
	                    $scope.doneFn($scope.address, false);
	                    return;
	                }
	
	                var userEnteredAddress;
	                var addrFormat = $feature('FormatAddressForNormalization', $scope.address.country, $scope.address.country);
	
	                $scope.addressSelected = 'normalizedAddress';
	                $scope.transitionName = 'address_normalization_normalizedAddress';
	
	                // Brazil specific format
	                if (addrFormat === 'AddressBR') {
	                    userEnteredAddress = angular.fromJson(angular.toJson($scope.address));
	                    userEnteredAddress.line1 = $scope.address.line1 + '  ' + $scope.address.streetNumber;
	                    userEnteredAddress.line2 = $scope.address.neighborhood;
	                }
	
	                $scope.servAddress = userEnteredAddress ? userEnteredAddress : $scope.address;
	                $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
	
	                $scope.addressNormalization = new $AddressNormalizationModel({
	                    id: $scope.id,
	                    address: $scope.servAddress
	                });
	
	                function centerLightBox() {
	                    var element = $('#lbox');
	                    if (!element.length) {
	                        return;
	                    }
	
	                    var windowElement = $(window);
	                    var lboxContainerElem = $('#lboxContainer');
	                    element.css('top', Math.max(0, (windowElement.height() - element.outerHeight()) / 2) + 'px');
	                    element.css('width', '65%');
	                    var computedLeft = (windowElement.width() - element.outerWidth()) / 2;
	                    var leftBound = lboxContainerElem.offset().left + lboxContainerElem.width() * 0.1;
	                    var elementLeft = computedLeft < leftBound ? leftBound : computedLeft;
	                    if (computedLeft < leftBound) {
	                        element.css('width', lboxContainerElem.width() * 0.8);
	                    }
	                    element.css('left', Math.max(0, elementLeft) + 'px');
	                    return element;
	                }
	
	                function trinityResponseCallback() {
	                    $scope.showNormalization = true;
	
	                    // default behavior of $timeout with no 2nd param is to wait for dom to finish rendering before executing callback
	                    $timeout(function () {
	                        centerLightBox();
	                        $(window).resize(centerLightBox);
	                    });
	                }
	
	                $scope.addressNormalization.save({
	                    data: $scope.addressNormalization,
	
	                    contingencies: {
	                        VALIDATION_ERROR: function VALIDATION_ERROR() {
	                            trinityResponseCallback();
	                            $scope.transitionName = 'address_normalization_enteredAddress';
	                            return;
	                        }
	                    },
	
	                    success: function success(result) {
	                        trinityResponseCallback();
	                        if (result === false) {
	                            // trinity doesn't find any match
	                            $scope.transitionName = 'address_normalization_enteredAddress';
	                            return;
	                        }
	                        $scope.normalizedAddress = result;
	                        $scope.normalizedAddress.normalization_status = 'NORMALIZED';
	
	                        if (addrFormat === 'AddressBR') {
	                            $scope.normalizedAddress.line1 = $scope.normalizedAddress.streetName + '  ' + $scope.normalizedAddress.streetNumber;
	                            $scope.normalizedAddress.line2 = $scope.normalizedAddress.neighborhood;
	                        }
	
	                        // if the two addresses equal, no need to show the panel
	                        if ($scope.isEqual($scope.normalizedAddress, $scope.servAddress)) {
	                            if ($scope.servAddress.preferred_address) {
	                                $scope.normalizedAddress.preferred_address = true;
	                            }
	
	                            if (addrFormat === 'AddressBR' && $scope.address.line2) {
	                                $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
	                            }
	                            $scope.callback($scope.normalizedAddress, false);
	                        } else if (addrFormat === 'AddressBR' && $scope.address.line2) {
	                            $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
	                        }
	                    },
	
	                    error: trinityResponseCallback
	                });
	
	                // make space and case insensitive. sub empty vals for undefined.
	                function desensitizedAddress(addr) {
	                    for (var key in addr) {
	                        var val = addr[key];
	                        if (addr.hasOwnProperty(key)) {
	                            if (val && val.length) {
	                                addr[key] = val.trim().toLowerCase();
	                            } else {
	                                addr[key] = undefined;
	                            }
	                        }
	                    }
	                    return addr;
	                }
	
	                // check if the two address are the same
	                $scope.isEqual = function (address1, address2) {
	                    var addressOne = desensitizedAddress(JSON.parse(JSON.stringify(address1)));
	                    var addressTwo = desensitizedAddress(JSON.parse(JSON.stringify(address2)));
	
	                    if (!addressOne || !addressTwo) {
	                        return false;
	                    }
	
	                    return addressOne.line1 === addressTwo.line1 && addressOne.line2 === addressTwo.line2 && addressOne.city === addressTwo.city && addressOne.state === addressTwo.state && addressOne.postal_code === addressTwo.postal_code && addressOne.country === addressTwo.country;
	                };
	
	                // Australia displays address line2 first
	                $scope.isLine2First = function () {
	                    return $scope.address.country === 'AU';
	                };
	
	                $scope.onBack = function () {
	                    $scope.callback($scope.address, true);
	                };
	
	                $scope.selection = function (value) {
	                    $scope.transitionName = 'address_normalization_' + value;
	                };
	
	                $scope.onContinue = function () {
	                    $scope.addressSelected = this.addressNormalizationForm.addressSelected;
	
	                    if ($scope.addressSelected && $scope.addressSelected.$modelValue === 'normalizedAddress') {
	                        if ($scope.servAddress.preferred_address) {
	                            $scope.normalizedAddress.preferred_address = true;
	                        }
	                        $scope.callback($scope.normalizedAddress, false);
	                    } else {
	                        $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
	                        if (addrFormat === 'AddressBR' && $scope.address.line2) {
	                            $scope.servAddress.line1 = $scope.servAddress.line1 + ' ' + $scope.address.line2;
	                        }
	                        $scope.callback($scope.servAddress, false);
	                    }
	                };
	
	                $scope.callback = function (address, isBack) {
	                    $scope.doneFn(address, isBack);
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-address-components/src/address-normalization/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-address-components/src/address-normalization/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-address-components/src/address-normalization/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#addressNormalization .addrRadio{position:relative}#addressNormalization .addrLabel{display:inline-block;padding-left:5px;vertical-align:top;width:75%}#addressNormalization .normalizedAdrSection{margin-bottom:10px}#addressNormalization .adr{margin-top:-2px;margin-left:10px}#addressNormalization .subContainer{border-top:none}#addressNormalization #fullContinue{width:100%}@media (min-width:0) and (max-width:30em){#addressNormalization .addrRadio{position:relative;float:left}#addressNormalization .adr{margin-top:-2px;margin-left:20px}#addressNormalization .buttons{margin-top:-5px;overflow:visible}#addressNormalization .subContainer{border-top:none;margin-top:-10px}#addressNormalization .row-fluid>[class*=span]{width:auto}}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-address-components/src/address-normalization/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-show=\"showNormalization\" content id=\"addressNormalization\" xo-tray-height>\n    <xo-aside-header heading='asideHeader.selectNormalizedAddress' hidex='true' ng-if=\"sidebar\"></xo-aside-header>\n    <div class=\"asideContent\">\n        <form method=\"post\" class=\"formSmall asideView container\" novalidate=\"novalidate\" name=\"addressNormalizationForm\">\n            <div ng-if=\"normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.title') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.intro') }}</p>\n                <div class=\"normalizedAdrSection radio\">\n                    <p class=\"theta\" data-ng-bind-html=\"htmlContent('addressNormalization.addressmatch')\"></p>\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" id=\"defaultAddress\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"normalizedAddress\" ng-click=\"selection('normalizedAddress')\" class=\"addrRadio span2\" checked=\"true\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\">\n                                <div ng-if=\"normalizedAddress.line2\">{{normalizedAddress.line1}}, {{normalizedAddress.line2}},</div>\n                                <div ng-if=\"!normalizedAddress.line2\">{{normalizedAddress.line1}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{normalizedAddress.city}}</span>, <span class=\"state\">{{normalizedAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{normalizedAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n                <div class=\"enteredAddrSection radio subContainer\">\n                    <p class=\"addressNormalizationIntro\" data-ng-bind-html=\"htmlContent('addressNormalization.addressenter')\"></p>\n\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"enteredAddress\" ng-click=\"selection('enteredAddress')\" class=\"addrRadio span2\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                                <div ng-if=\"servAddress.line2\">{{servAddress.line2}}, </div>{{servAddress.line1}},\n                            </div>\n                            <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                                <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}},</div>\n                                <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n            </div>\n            <div ng-if=\"!normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.noaddressmatchTitle') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.noaddressmatchMsg') }}</p>\n                <input type=\"hidden\" name=\"addressdisplay\" value=\"enteredAddress\">\n                <div class=\"enteredAddrSection subContainer\">\n                    <p class=\"theta\">{{ content('addressNormalization.addressyouenter') }}</p>\n                    <div class=\"adr\">\n                        <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                            {{servAddress.line2}} {{servAddress.line1}},\n                        </div>\n                        <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                            <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}}</div>\n                            <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}}</div>\n                        </div>\n                        <div class=\"confidential\">\n                            <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                            <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"buttons\" ng-if=\"!hideBackButton\">\n                <input id=\"back\" type=\"submit\" value=\"{{ content('common.back') }}\" class=\"btn firstHalf btn-secondary\" ng-click=\"onBack()\" >\n                <input track-submit=\"{{transitionName}}\" id=\"continue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn secondHalf\" ng-click=\"onContinue()\">\n            </div>\n            <div class=\"buttons\" ng-if=\"hideBackButton\">\n                <input track-submit=\"{{transitionName}}\" id=\"fullContinue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-click=\"onContinue()\">\n            </div>\n        </form>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addCep/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/add-card/addCep/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-card.addcep.route', ['squid', 'xo-add-card.addcep.directive']).factory('$AddCepRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddCepRoute', {
	
	            name: 'addCep',
	            directive: 'xo-add-cep',
	            titleContent: 'addBillingAddress.title',
	            loginRequired: true,
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/add-card/addCep", "components/xo-wallet-components/src/add-card/addCep/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/add-card/addCep/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addCep/template.html"), __webpack_require__("./components/angular-ui-utils/ui-utils.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-form-components/src/zipcode/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, template) {
	    return angular.module('xo-add-card.addcep.directive', ['squid', 'xomodel.address', 'ui.validate', 'xo-zipcode.directive']).directive('xoAddCep', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                sidebar: '=',
	                prefillAddress: '=',
	                doneFn: '='
	            },
	
	            controller: function controller($scope, $populate, $state, $PrefillAddressModel, $locale) {
	                $scope.country = $locale.country;
	
	                $scope.onSubmit = function () {
	                    $scope.prefillAddress.address = {
	                        country: $locale.country,
	                        postal_code: $scope.postal_code
	                    };
	
	                    $scope.prefillAddress.save({
	                        data: $scope.prefillAddress,
	
	                        success: function success(result) {
	                            $scope.prefillAddress.address = result;
	                            $scope.doneFn();
	                        }
	                    });
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/add-card/addCep/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n<h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar\">{{ content('addBillingAddress.title') }}</h1>\n\n<form id=\"cepForm\" name=\"cepForm\" class=\"asideView addressForm\" content novalidate>\n    <div class=\"trayInner container\">\n        <xo-zipcode id=\"zipcode\" country=\"{{country}}\" zip-code=\"postal_code\" zip-label=\"{{content('common.cep')}}\"\n                    zip-error-text=\"{{content('common.valueInvalid')}}\"></xo-zipcode>\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\"\n                   value=\"{{ content('common.continueLabel') }}\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n        </div>\n    </div>\n</form>\n\n"

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/add-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/add-shipping/directive.js"), __webpack_require__("./components/xo-address-components/src/address-normalization/route.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-add-shipping.route', ['squid', 'xo-shipping-address.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$AddShippingRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddShippingRoute', {
	            name: 'addShipping',
	            directive: 'xo-add-shipping',
	            titleContent: 'addShipping.addAddress',
	            trackingData: {
	                fptiState: 'add_shipping',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::fullpage-add-shipping-address',
	                        'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
	                        'version': 'member:%:tray'
	                    }
	                }
	            },
	            loginRequired: true,
	            children: [{
	                name: '$AddressNormalizationRoute',
	                attributes: {
	                    id: 'token',
	                    sidebar: 'sidebar',
	                    address: 'address',
	                    'done-fn': 'uponNormalization'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-member-components/src/select-shipping/add-shipping", "components/xo-member-components/src/select-shipping/add-shipping/route.js"))

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/add-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/add-shipping/template.html"), __webpack_require__("./components/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-select-shipping.add-shipping.directive', ['squid', 'xo-shipping-address.directive']).directive('xoAddShipping', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                auth: '=',
	                token: '=',
	                doneFn: '=',
	                sidebar: '=',
	                update: '='
	            },
	
	            controller: function controller($scope) {}
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/add-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\"></xo-shipping-address>\n"

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/shipping-address/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/shipping-address/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-form-components/src/select-shipping-country/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-form-components/src/zipcode/directive.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-select-shipping.xo-shipping-address.directive', ['squid', 'xomodel.address', 'xomodel.checkout', 'xo-add-address.directive', 'xo-select-shipping-country.directive', 'xo-tray-height.directive', 'xo-error-tooltip.directive', 'xo-dropdown.directive', 'xo-message.directive', 'xo-zipcode.directive', 'xo-accessibility.directive']).directive('xoShippingAddress', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                auth: '=',
	                token: '=',
	                doneFn: '=',
	                sidebar: '=',
	                update: '='
	            },
	
	            controller: function controller($scope, $populate, $element, $timeout, $ShippingAddressModel, $CheckoutSessionModel, $logger, $PrefillAddressModel, $CheckoutAppDataModel, $state, $config, $locale, $feature, $renderContent) {
	
	                if (!$scope.sidebar) {
	                    $scope.pageTitle = $renderContent('addShipping.addAddress');
	                }
	
	                $scope.buttonLabel = function () {
	                    if (!$scope.sidebar || $scope.address.country === 'BR' && !$scope.prefilled) {
	                        return $renderContent('common.continueLabel');
	                    } else {
	                        return $renderContent('common.save');
	                    }
	                };
	
	                $scope.address = {
	                    country: $locale.getCountryCodeISO()
	                };
	                $scope.isShipping = true;
	                $scope.normalize = function () {
	                    return $feature('shippingAddressNormalization') && $scope.address.country === $locale.country // Should be domestic address
	                    && !$scope.normalized;
	                };
	
	                $scope.showshipping = true;
	                $scope.country = $locale.country;
	                $scope.recipient = {
	                    first_name: '',
	                    last_name: ''
	                };
	
	                var $el = $($element);
	
	                function focusFirstError() {
	                    $el.find('form').find('.backendError, .ng-invalid').first().focus();
	                }
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(function () {
	                    var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
	                    var contingencyPrefilledAddress;
	
	                    if ($feature('supportBlockNonDomesticShipping', false, merchantCountry)) {
	
	                        $scope.disableChangeShippingCountry = $scope.checkoutAppData.get('flags.block_non_domestic_shipping', false);
	
	                        if ($scope.disableChangeShippingCountry) {
	
	                            $scope.address.country = merchantCountry;
	
	                            contingencyPrefilledAddress = $scope.checkoutSession.get('errorData.resolution.data', null);
	                            if (!$scope.sidebar && contingencyPrefilledAddress) {
	                                angular.extend($scope.address, {
	                                    line1: contingencyPrefilledAddress.line1,
	                                    line2: contingencyPrefilledAddress.line2,
	                                    city: contingencyPrefilledAddress.city,
	                                    state: contingencyPrefilledAddress.state,
	                                    postal_code: contingencyPrefilledAddress.postal_code
	                                });
	                            }
	
	                            $logger.info('member_block_non_domestic_shipping', {
	                                block_non_domestic_shipping: $scope.disableChangeShippingCountry,
	                                sidebar: $scope.sidebar
	                            });
	
	                            var countryName = $renderContent('shippingCountry.' + merchantCountry);
	                            var infoMessage = $renderContent('largeScreenPayment.blockNonDomesticShippingAlert', {
	                                shippingCountry: countryName
	                            });
	                            $scope.message = {
	                                msgs: [infoMessage],
	                                type: 'warning'
	                            };
	                        }
	                    }
	
	                    $scope.prefill = function () {
	                        $scope.prefillAddress = new $PrefillAddressModel({
	                            id: $scope.token,
	                            address: {
	                                country: $locale.country,
	                                postal_code: $scope.address.postal_code
	                            }
	                        });
	
	                        $scope.prefillAddress.save({
	                            data: $scope.prefillAddress,
	
	                            success: function success(result) {
	                                if (result) {
	                                    $scope.address = result;
	                                }
	                                $scope.prefilled = true;
	                                $scope.address.first_name = $scope.recipient.first_name;
	                                $scope.address.last_name = $scope.recipient.last_name;
	
	                                $timeout(function () {
	                                    var value = $scope.address.state;
	
	                                    var $option = $el.find('[value="' + value + '"]');
	                                    $option.prop('selected', 'selected');
	                                    $option.trigger('change');
	
	                                    value = $option.attr('label');
	                                    focusFirstError();
	                                }, 1000);
	                            }
	                        });
	                    };
	
	                    if ($scope.update) {
	                        if ($scope.checkoutSession.shipping.name) {
	                            var name = $scope.checkoutSession.shipping.name.trim();
	                            var index = name.indexOf(' ');
	                            $scope.recipient.first_name = name.substr(0, index);
	                            $scope.recipient.last_name = name.substr(index + 1);
	                        }
	                        $scope.address.postal_code = $scope.checkoutSession.get('shipping.postal_code', '');
	                        $scope.prefill();
	                    }
	
	                    function handleValidation(res) {
	                        if (res && res.fields && res.fields.length) {
	                            res.fields.forEach(function (field) {
	                                if (field.field) {
	                                    var $field = $($el.find('[ng-model="address.' + field.field + '"]'));
	                                    if ($field.length === 0 && field.field === 'zip') {
	                                        $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
	                                    }
	                                    $field.addClass('backendError');
	                                    $field.attr('aria-invalid', true);
	                                }
	                            });
	                            focusFirstError();
	                        }
	                    }
	
	                    $scope.cancelFn = function () {
	                        $state.go('checkout.review.sidebar.shipping');
	                    };
	
	                    $scope.onSubmit = function () {
	                        if ($scope.address.country === 'BR' && $scope.address.country === $locale.country && !$scope.prefilled) {
	                            return $scope.prefill();
	                        }
	
	                        if ($scope.normalize()) {
	                            $scope.showshipping = false;
	                            $state.go('.addressNormalization');
	                        } else {
	                            $scope.submitAddress();
	                        }
	                    };
	
	                    $scope.removeValidation = function () {
	                        $el.find('form').removeClass('validated');
	                    };
	
	                    function prefilledAddressUnchanged(prefilledAddress, addressToSubmit) {
	
	                        function lowercaseEquals(str1, str2) {
	                            return angular.lowercase(str1) === angular.lowercase(str2);
	                        }
	
	                        return lowercaseEquals(prefilledAddress.recipient_name, addressToSubmit.recipient_name) && lowercaseEquals(prefilledAddress.line1, addressToSubmit.line1) && lowercaseEquals(prefilledAddress.line2, addressToSubmit.line2) && lowercaseEquals(prefilledAddress.city, addressToSubmit.city) && lowercaseEquals(prefilledAddress.state, addressToSubmit.state) && lowercaseEquals(prefilledAddress.postal_code, addressToSubmit.postal_code) && lowercaseEquals(prefilledAddress.country_code, addressToSubmit.country);
	                    }
	
	                    $scope.submitAddress = function () {
	
	                        if ($scope.address.preferred_address) {
	                            $logger.info('addAddrPreferred.selected', {});
	                        }
	
	                        var country = $scope.address.country;
	
	                        // keep this for compatability
	                        var recipient_name = $scope.address.first_name + ' ' + $scope.address.last_name;
	                        if ($feature('nameFormat', country, country) === 'LastFirst') {
	                            recipient_name = $scope.address.last_name + ' ' + $scope.address.first_name;
	                        }
	
	                        var data = {
	                            recipient_name: recipient_name,
	                            first_name: $scope.address.first_name,
	                            last_name: $scope.address.last_name,
	                            line1: $scope.address.line1,
	                            line2: $scope.address.line2,
	                            city: $scope.address.city,
	                            state: $scope.address.state,
	                            postal_code: $scope.address.postal_code,
	                            country: country,
	                            normalization_status: $scope.address.normalization_status,
	                            preferred_address: $scope.address.preferred_address,
	                            default_address: true
	                        };
	
	                        if (contingencyPrefilledAddress && prefilledAddressUnchanged(contingencyPrefilledAddress, data)) {
	                            data.address_id = contingencyPrefilledAddress.id;
	                        }
	                        // Update is used for the address normalization flow.
	                        data.address_id = data.address_id ? data.address_id : $scope.checkoutSession.get('shipping.id');
	                        if ($scope.update && data.address_id) {
	                            updateAddress(data);
	                        } else {
	                            addAddress(data);
	                        }
	                    };
	
	                    function updateAddress(payload) {
	                        $scope.checkoutSession.shipping.action('update', {
	                            data: payload,
	
	                            resultModel: $scope.checkoutSession,
	
	                            success: function success(result) {
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['smallToolTip.addressAdded']
	                                };
	
	                                $scope.doneFn();
	                            },
	
	                            validation: function validation(res) {
	                                handleValidation(res);
	                            }
	                        });
	                    }
	
	                    function addAddress(payload) {
	                        // make sure this param is not passed as behavior from symphony is erratic. 
	                        delete payload.address_id;
	
	                        $scope.shippingAddress = $ShippingAddressModel.create($scope.token, payload);
	
	                        $scope.shippingAddress.save({
	                            data: payload,
	
	                            resultModel: $scope.checkoutSession,
	
	                            success: function success(result) {
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['smallToolTip.addressAdded']
	                                };
	                                $scope.doneFn();
	                            },
	
	                            validation: function validation(res) {
	                                handleValidation(res);
	                            }
	                        });
	                    }
	
	                    $scope.uponNormalization = function (normalizedAddress, isBack) {
	                        if (isBack) {
	                            $scope.normalized = false;
	                            $scope.showshipping = true;
	                            $state.go('^');
	                        } else {
	                            $scope.address = normalizedAddress;
	                            $scope.normalized = true;
	                            $scope.address.first_name = $scope.recipient.first_name;
	                            $scope.address.last_name = $scope.recipient.last_name;
	                            $scope.submitAddress();
	                        }
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/shipping-address/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-class=\"{'aside': sidebar, 'fullpage': !sidebar}\" id=\"addShipping\" modal-box modal-refresh-on=\"'metadataChange'\" modal-cancel=\"cancelFn()\">\n    <div ng-if=\"showshipping\">\n    <xo-aside-header ng-if=\"!update && sidebar\" back-url=\"checkout.review.sidebar.shipping\" heading='asideHeader.addShipping'></xo-aside-header>\n    <xo-aside-header ng-if=\"update && sidebar\" back-url=\"checkout.review.sidebar.shipping\"\n                     heading='addressNormalization.update'></xo-aside-header>\n\n    <div class=\"container\" ng-class=\"{'asideContent': sidebar}\" xo-tray-height>\n\n        <xo-message ng-if=\"message\" message=\"message\"></xo-message>\n        <h1 class=\"gamma\" ng-if=\"pageTitle\">{{ pageTitle }}</h1>\n\n        <div ng-if=\"update\" content>\n            <p class=\"theta\">{{ content('addressNormalization.updateIntro') }}</p>\n        </div>\n\n            <form id=\"shippingAddressForm\" name=\"shippingAddressForm\" class=\"asideView addressForm\"\n                  content novalidate form-autofocus>\n\n                <div ng-if=\"!update\">\n                    <xo-select-shipping-country shipping-address=\"address\"\n                                                disable-change-shipping-country=\"disableChangeShippingCountry\"\n                                                token=\"token\" ng-click=\"removeValidation()\"></xo-select-shipping-country>\n                </div>\n\n                <div ng-if=\"prefilled || address.country!=='BR'\">\n                    <xo-add-address country=\"address.country\" address=\"address\" is-shipping=\"true\"\n                                    token=\"token\"></xo-add-address>\n                </div>\n\n                <div ng-if=\"!prefilled && address.country==='BR'\">\n                    <xo-name-input user=\"recipient\"></xo-name-input>\n                    <xo-zipcode country=\"{{address.country}}\" zip-code=\"address.postal_code\" zip-label=\"{{content('common.cep')}}\"\n                                zip-error-text=\"{{content('common.valueInvalid')}}\"></xo-zipcode>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit type=\"submit\" id=\"proceedButton\"\n                           type=\"submit\" value=\"{{buttonLabel()}}\" class=\"btn full\"  validate-submit=\"onSubmit()\"/>\n                </div>\n\n            </form>\n        </div>\n\n    </div>\n    <div ui-view></div>\n</div>\n\n"

/***/ },

/***/ "./components/xo-form-components/src/select-shipping-country/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/select-shipping-country/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-models/src/app/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return angular.module('xo-select-shipping-country.directive', ['squid', 'xomodel.app', 'xomodel.checkout', 'xo-dropdown.directive', 'xo-error-tooltip.directive']).directive('xoSelectShippingCountry', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                shippingAddress: '=',
	                disableChangeShippingCountry: '='
	            },
	
	            controller: function controller($rootScope, $scope, $populate, $locale, $LocaleConfigModel, $CheckoutAppDataModel) {
	
	                var defaultCountry = $scope.shippingAddress && $scope.shippingAddress.country || $locale.country;
	
	                var countries = $locale.content.get('countryList', {});
	                var countryList = [];
	
	                function insertDefaultCountryTop() {
	                    countryList.unshift({
	                        key: defaultCountry,
	                        value: countries[defaultCountry]
	                    });
	                }
	
	                insertDefaultCountryTop();
	
	                $scope.countryList = countryList;
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                }).then(function () {
	                    return $populate($scope, {
	                        localeConfigModel: $LocaleConfigModel.instance($scope.checkoutAppData.merchant.merchant_country)
	                    }).then(function () {
	
	                        var shippingCountries = $scope.localeConfigModel && $scope.localeConfigModel.xBorderCountries;
	
	                        function getSortedCountryList() {
	                            countries = $locale.content.get('countryList', {});
	                            countryList = [];
	
	                            angular.forEach(shippingCountries, function (shippingCountry) {
	                                if (shippingCountry && angular.isString(shippingCountry)) {
	                                    var countryCode = shippingCountry.split(',')[0];
	                                    if (countryCode && countryCode !== defaultCountry && countries[countryCode]) {
	                                        countryList.push({
	                                            key: countryCode,
	                                            value: countries[countryCode]
	                                        });
	                                    }
	                                }
	                            });
	
	                            countryList.sort(function (a, b) {
	                                return a.value.localeCompare(b.value);
	                            });
	
	                            insertDefaultCountryTop();
	                            $scope.countryList = countryList;
	                        }
	
	                        $scope.$on('contentChange', getSortedCountryList);
	
	                        getSortedCountryList();
	                    });
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/select-shipping-country/template.html":
/***/ function(module, exports) {

	module.exports = "<span id=\"selectShippingCountry\" feature=\"changeShippingCountry\">\n    <div class=\"dropdown confidential country clearfix inputField\"\n         ng-class=\"{'disabled': disableChangeShippingCountry}\" content floating-label-dropdown>\n        <select xo-dropdown name=\"country\" ng-change=\"chooseCountry()\" ng-model=\"shippingAddress.country\" ng-options=\"country.key as country.value for country in countryList\" id=\"country\" aria-labelledby=\"countryLabel\" xo-error-tooltip required ng-disabled=\"disableChangeShippingCountry\">\n        </select>\n        <label for=\"country\" id=\"countryLabel\">{{ content('common.country') }}</label>\n    </div>\n</span>\n"

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/delete-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/delete-shipping/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-select-shipping.xo-delete-shipping.route', ['squid', 'xo-select-shipping.xo-delete-shipping.directive']).factory('$DeleteShippingRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('DeleteShippingRoute', {
	            name: 'deleteShipping',
	            directive: 'xo-delete-shipping',
	            titleContent: 'asideHeader.deleteShipping',
	            trackingData: {
	                fptiState: 'delete_shipping',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::delete_shipping',
	                        'pagename2': '%::delete_shipping:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            loginRequired: true,
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-member-components/src/select-shipping/delete-shipping", "components/xo-member-components/src/select-shipping/delete-shipping/route.js"))

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/delete-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/delete-shipping/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-address-components/src/address-display/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-select-shipping.xo-delete-shipping.directive', ['squid', 'xomodel.checkout', 'xo-address-display.directive', 'xo-aside-header.directive', 'xo-tray-height.directive', 'xo-accessibility.directive']).directive('xoDeleteShipping', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                sidebar: '='
	            },
	            controller: function controller($scope, $log, $populate, $state, $rootScope, $timeout, $CheckoutShippingAddressesModel) {
	
	                var contingencyMapping = {
	                    RISK_CHECK_FAILED: 'deleteShipping.genericError',
	                    ADDRESS_ALREADY_REMOVED: 'deleteShipping.genericError',
	                    ADDRESS_CANNOT_REMOVE_PRIMARY: 'deleteShipping.primaryOrBillingAddress',
	                    ADDRESS_CANNOT_REMOVE_BILLING: 'deleteShipping.primaryOrBillingAddress',
	                    ADDRESS_CANNOT_REMOVE_SELECTED: 'deleteShipping.selectedAddress',
	                    ACCOUNT_NEGATIVE_BALANCE: 'deleteShipping.genericError',
	                    ADDRESS_CANNOT_REMOVE: 'deleteShipping.genericError'
	                };
	
	                function isPrimaryOrSelected(address) {
	                    return address.primary_address || address.default_address;
	                }
	
	                function removeAddress(address) {
	                    $('#deleteShipping .address' + address.idx).addClass('collapse');
	                    $timeout(function () {
	                        $scope.checkoutShippingAddresses.addresses = $scope.checkoutShippingAddresses.addresses.filter(function (item) {
	                            return item.id !== address.id;
	                        });
	                        $scope.$broadcast('addressUpdated');
	                    }, 600);
	                }
	
	                $populate($scope, {
	                    checkoutShippingAddresses: $CheckoutShippingAddressesModel.instance($scope.token)
	                }).then(function () {
	                    $scope.checkoutShippingAddresses.addresses.forEach(function (address, index) {
	                        address.showDelete = address.isDeletable = !isPrimaryOrSelected(address);
	                        address.idx = index;
	                    });
	                    $scope.$broadcast('addressUpdated');
	                });
	
	                $scope.backUrl = 'checkout.review.sidebar.shipping';
	
	                // Return on modal cancel
	                $scope.goBack = function () {
	                    $state.go($scope.backUrl);
	                };
	
	                // Needed the three variables for animating buttons slide in/out
	                $scope.onDelete = function (address) {
	                    address.showConfirm = true;
	                    $scope.checkoutShippingAddresses.addresses.filter(function (item) {
	                        if (item.deleteClicked) {
	                            $('#deleteShipping .address' + item.idx + ' .address').removeClass('slide');
	                            $('#deleteShipping .address' + item.idx + ' .confirm').removeClass('slidein');
	                            item.showDelete = true;
	                            $timeout(function () {
	                                item.deleteClicked = false;
	                                item.showConfirm = false;
	                                $('#deleteShipping .address' + item.idx + ' .delete:not(.confirm)').removeClass('slideOut');
	                            }, 500);
	                        }
	                    });
	
	                    address.deleteClicked = true;
	                    $('#deleteShipping .address' + address.idx + ' .delete:not(.confirm)').addClass('slideOut');
	                    $timeout(function () {
	                        $('#deleteShipping .address' + address.idx + ' .confirm').addClass('slidein');
	                        $('#deleteShipping .address' + address.idx + ' .address').addClass('slide');
	                        address.showDelete = false;
	                    });
	                    // Focus the confirm link when it comes into view after the css animation
	                    $timeout(function () {
	                        $('#deleteShipping .address' + address.idx + ' .confirmBtn').focus();
	                    }, 500);
	                };
	
	                $scope.showDelete = function (address) {
	                    return address.isDeletable && address.showDelete;
	                };
	
	                $scope.showConfirmDelete = function (address) {
	                    return address.isDeletable && address.showConfirm;
	                };
	
	                $scope.showInfoMsgIcon = function (address) {
	                    return isPrimaryOrSelected(address) && !address.contingencyInfoMsgKey;
	                };
	
	                $scope.showInfoMessage = function (address) {
	                    if (address.default_address) {
	                        address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_SELECTED;
	                    } else if (address.primary_address) {
	                        address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_PRIMARY;
	                    }
	                    // Expand the info message and focus on the first delete link to keep focus within form
	                    $timeout(function () {
	                        $('#deleteShipping .address' + address.idx + ' .msg-inline').addClass('expand');
	                        $('#deleteShipping .deleteBtn').first().focus();
	                    });
	                };
	
	                $scope.onConfirmDelete = function (address) {
	                    address.action('delete', {
	                        success: function success() {
	                            removeAddress(address);
	                        },
	                        contingencies: {
	                            DEFAULT: function DEFAULT(name) {
	                                if (name === 'ADDRESS_ALREADY_REMOVED') {
	                                    removeAddress(address);
	                                    return;
	                                }
	
	                                address.isDeletable = false;
	                                address.contingencyErrorMsgKey = contingencyMapping[name] || contingencyMapping.ADDRESS_CANNOT_REMOVE;
	                                $('#deleteShipping .address' + address.idx + ' .address').removeClass('slide');
	                                $('#deleteShipping .address' + address.idx + ' .address').addClass('slideFast');
	                                $timeout(function () {
	                                    $('#deleteShipping .address' + address.idx + ' .msg-inline').addClass('expand');
	                                }, 500);
	                            }
	                        }
	                    });
	                };
	
	                // Provide watch value for modal-box and select-box to recalculate keyboard behavior based on number of infoMsgIcons and confirmLinks
	                $scope.numModalElements = function () {
	                    if (!$scope.checkoutShippingAddresses.addresses) {
	                        return 0;
	                    }
	                    // Track messages by index, if they have flags active, seeing which flags they have active
	                    return $scope.checkoutShippingAddresses.addresses.reduce(function (sum, address, index) {
	                        var item = $scope.showInfoMsgIcon(address) || $scope.showConfirmDelete(address) ? index + 1 : 0;
	                        return sum + item;
	                    }, 0);
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/delete-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-class=\"{'aside': sidebar, 'fullpage': !sidebar}\" id=\"deleteShipping\" modal-box=\"numModalElements()\" modal-cancel=\"goBack()\">\n    <xo-aside-header heading='asideHeader.deleteShipping' back-url=\"{{backUrl}}\"></xo-aside-header>\n\n    <div class=\"asideContent showAll\" xo-tray-height content>\n        <ul class=\"items\" select-box=\"numModalElements()\" select-allow-tab-escape focus-when focus-refresh-on=\"'addressUpdated'\">\n            <li ng-repeat=\"address in checkoutShippingAddresses.addresses\" role=\"presentation\" class=\"item address{{address.idx}}\">\n                <div class=\"itemInner\">\n                    <div class=\"address\" ng-class=\"{'notDeletable': !address.isDeletable}\">\n                        <span class=\"display fullName\">{{address.recipient_name}}</span>\n                        <xo-address-display address=address country-code=countryCode show-preferred=\"true\"></xo-address-display>\n                    </div>\n                    <div>\n                        <span class=\"msgIcon\" ng-if=\"showInfoMsgIcon(address)\" ng-click=\"showInfoMessage(address)\" title=\"More Info\"></span>\n                    </div>\n                    <div ng-if=\"address.isDeletable\">\n                        <div class=\"delete\" ng-if=\"showDelete(address)\">\n                            <a track-link=\"address_delete\" href=\"\" ng-click=\"onDelete(address)\" class=\"deleteBtn\">\n                                <span>{{content('deleteShipping.delete')}}</span>\n                            </a>\n                        </div>\n                        <div class=\"delete confirm\" ng-if=\"showConfirmDelete(address)\">\n                            <a track-link=\"address_delete_confirm\" href=\"\" ng-click=\"onConfirmDelete(address)\" class=\"confirmBtn\">\n                                <span>{{content('deleteShipping.confirm')}}</span>\n                            </a>\n                        </div>\n                    </div>\n                    <div class=\"msg-inline\" ng-if=\"address.contingencyInfoMsgKey\">\n                        <div class=\"msg-inlineInner\" tabindex=\"-1\" focus-when=\"address.contingencyInfoMsgKey\">\n                            <span>{{content(address.contingencyInfoMsgKey)}}</span>\n                        </div>\n                    </div>\n                    <div class=\"msg-inline msg-error\" ng-if=\"address.contingencyErrorMsgKey\">\n                        <div class=\"msg-inlineInner\" tabindex=\"-1\" focus-when=\"address.contingencyErrorMsgKey\">\n                            <span class=\"icon\"></span>\n                            <div class=\"content\">{{content(address.contingencyErrorMsgKey)}}</div>\n                        </div>\n                    </div>\n                </div>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-address-components/src/address-display/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoAddressDisplayComponent = undefined;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-address-components/src/address-display/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-address-components/src/address-display/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoAddressDisplayComponent = exports.$xoAddressDisplayComponent = _index.$Component.extend('$xoAddressDisplayComponent', {
	
	    tag: 'xo-address-display',
	    template: _template2['default'],
	
	    props: {
	        address: {
	            type: 'var'
	        },
	        showPreferred: {
	            type: 'str',
	            required: false
	        },
	        countryCode: {
	            type: 'var',
	            required: false
	        },
	        displayFormattedAddr: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            var _this = this;
	
	            var address = this.props.address || {};
	            var countryCode = typeof this.props.countryCode === 'undefined' ? address.country || address.country_code : this.props.countryCode;
	            this.isPreferred = this.props.showPreferred && address.preferred_address && (0, _index.$feature)('preferredShipping', false, countryCode);
	
	            if (this.props.displayFormattedAddr) {
	                this.formattedAddr = this.actions.formatAddress(address);
	                this.$watchCollection('props.address', function (newVal) {
	                    _this.formattedAddr = _this.actions.formatAddress(newVal);
	                });
	            }
	        }
	    },
	
	    actions: {
	        formatAddress: function formatAddress(address) {
	            var COMMA = ', ';
	            var SPACE = ' ';
	
	            function prefix(str, prefixStr) {
	                if (str) {
	                    return (prefixStr ? prefixStr : '') + str;
	                }
	                return '';
	            }
	
	            var displayLine1 = (address.line1 ? address.line1 : '') + (address.line2 ? prefix(address.line2, COMMA) : '');
	            var displayLine2 = (address.city ? prefix(address.city) : '') + (address.state ? prefix(address.state, COMMA) : '') + (address.postal_code ? prefix(address.postal_code, SPACE) : '');
	            var displayLine3 = address.country ? prefix(address.country) : '';
	
	            return {
	                displayLine1: displayLine1,
	                displayLine2: displayLine2,
	                displayLine3: displayLine3
	            };
	        }
	    }
	});
	
	angular.value("$xoAddressDisplayComponent", $xoAddressDisplayComponent);
	_index.$Component;
	
	_index.$feature;

/***/ },

/***/ "./components/xo-address-components/src/address-display/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"adr\" ng-class=[props.countryCode] content>\n    <div ng-if=\"props.address.full_address && !props.displayFormattedAddr\" class=\"confidential\">\n        <span class=\"full-address\" directionality-text=\"props.address.full_address\">{{props.address.full_address}}</span>\n        <span class=\"country adr-break\">{{content('countryList.'+props.address.country)}}</span>\n    </div>\n\n    <div ng-if=\"props.displayFormattedAddr\" class=\"shippingAddress\">\n        {{formattedAddr.displayLine1}}<br/>\n        {{formattedAddr.displayLine2}}<br/>\n        {{formattedAddr.displayLine3}}\n    </div>\n\n    <div ng-if=\"isPreferred\" class=\"preferred\">\n        <span>\n            {{content('shippingAddress.preferred')}}\n        </span>\n    </div>\n</div>"

/***/ },

/***/ "./components/xo-address-components/src/address-display/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-address-components/src/address-display/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-address-components/src/address-display/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".adr{margin-top:3px;color:#6c7378;font-size:.85em;width:90%}.adr .adr-break{display:block}.adr .country,.adr .singleline{display:none}.adr .preferred{margin:15px 0 7px}.adr .preferred span{padding:5px 10px;background-color:#eaf7e9;color:#2a5327;font-size:1em}.addressDisplay .adr .streets{display:inline;white-space:normal}.addressDisplay .adr .adr-break,.addressDisplay .adr .postal-code,.addressDisplay .adr .singleline,.addressDisplay .adr .streets,.addressDisplay .adr .streets+div{display:inline}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-member-components/src/select-shipping/update-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/update-shipping/directive.js"), __webpack_require__("./components/xo-address-components/src/address-normalization/route.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-update-shipping.route', ['squid', 'xo-shipping-address.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$UpdateShippingRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('UpdateShippingRoute', {
	            name: 'updateShipping',
	            directive: 'xo-update-shipping',
	            titleContent: 'addShipping.addAddress',
	            trackingData: {
	                fptiState: 'update_shipping',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::update_shipping',
	                        'pagename2': '%::update_shipping:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            loginRequired: true,
	            children: [{
	                name: '$AddressNormalizationRoute',
	                attributes: {
	                    id: 'token',
	                    sidebar: 'sidebar',
	                    address: 'address',
	                    'done-fn': 'uponNormalization'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-member-components/src/select-shipping/update-shipping", "components/xo-member-components/src/select-shipping/update-shipping/route.js"))

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/update-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/update-shipping/template.html"), __webpack_require__("./components/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-select-shipping.update-shipping.directive', ['squid', 'xo-shipping-address.directive']).directive('xoUpdateShipping', function () {
	
	        return {
	            template: template,
	
	            scope: {
	                auth: '=',
	                token: '=',
	                doneFn: '=',
	                sidebar: '='
	            },
	            controller: function controller($scope) {}
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/update-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\" update=\"true\"></xo-shipping-address>"

/***/ },

/***/ "./pages/xo-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarShippingRoute = undefined;
	
	__webpack_require__("./pages/xo-shipping/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidebarShippingRoute = exports.$SidebarShippingRoute = _squid.$ComponentRoute.extend('$SidebarShippingRoute', {
	
	    path: 'shipping',
	    directive: 'xo-shipping',
	    titleContent: 'asideHeader.selectShipping',
	    trackingData: {
	        fptiState: 'select_shipping_address',
	        templateName: 'selectShipping.dust',
	        pageGoal: 'Select Shipping',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-select-shipping-address',
	                'pagename2': '%::fullpage-select-shipping-address:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    }
	});
	
	angular.value("$SidebarShippingRoute", $SidebarShippingRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoShippingComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-shipping/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoShippingComponent = exports.$xoShippingComponent = _squid.$Component.extend('$xoShippingComponent', {
	    tag: 'xo-shipping',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $location) {
	        $scope.token = $rootScope.token;
	        $scope.onComplete = function (result) {
	            $location.path('/checkout/review');
	        };
	    }
	});
	
	angular.value("$xoShippingComponent", $xoShippingComponent);
	_squid.$Component;

/***/ },

/***/ "./js/app.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	__webpack_require__("./css/app.less");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _route = __webpack_require__("./pages/xo-checkout/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _middleware = __webpack_require__("./js/lib/middleware.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_logger.$logger.info('app_bootstrap', {
	    hash: window.location.hash
	});
	
	var xoCheckoutRoute = new _route2['default']();
	
	xoCheckoutRoute.bootstrap('checkout.landing', _middleware.$Middleware);
	
	window.bootstrap = true;
	
	_logger.$logger;
	
	_middleware.$Middleware;

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/xo-member-components/src/select-shipping/select-shipping/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/add-shipping/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/delete-shipping/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/update-shipping/directive.js"), __webpack_require__("./components/xo-member-components/src/select-shipping/shipping-address/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function () {}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-member-components/src/select-shipping/select-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/select-shipping/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-address-components/src/address-display/directive.js"), __webpack_require__("./components/xo-page-components/src/aside-header/directive.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-select-shipping.directive', ['squid', 'xomodel.checkout', 'xo-address-display.directive', 'xo-aside-header.directive', 'xo-tray-height.directive', 'xo-accessibility.directive']).directive('xoSelectShipping', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                doneFn: '='
	            },
	            controller: function controller($scope, $log, $populate, $state, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutShippingAddressesModel, $config, $feature, $renderContent, $locale) {
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                    checkoutShippingAddresses: $CheckoutShippingAddressesModel.create($scope.token)
	                }).then(function () {
	                    // Do not remove error message in review page when user does not change shipping address
	                    if (!($scope.checkoutSession.get('message.type') === 'error')) {
	                        $scope.checkoutSession.message = null;
	                    }
	                    $scope.deleteShipping = $scope.checkoutShippingAddresses.addresses.some(function (address) {
	                        return !(address.primary_address || address.default_address);
	                    });
	                });
	
	                $scope.onSelect = function (address) {
	                    if (!address.disable_for_transaction) {
	                        address.action('select', {
	                            resultModel: $scope.checkoutSession,
	                            success: function success(result) {
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['smallToolTip.addressUpdated']
	                                };
	                                $scope.checkoutShippingAddresses.invalidate();
	                                $scope.doneFn(address);
	                            }
	                        });
	                    }
	                };
	
	                $scope.locale = $locale;
	
	                $scope.onAdd = function () {
	                    $state.go('checkout.review.sidebar.addShipping');
	                };
	
	                // Construct message object for block non-domestic shipping alert
	                var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
	
	                var countryName = $renderContent('countryList.' + merchantCountry);
	                var infoMessage = $renderContent('selectShipping.blockNonDomesticShippingInfo', {
	                    shippingCountry: countryName
	                });
	                $scope.blkNonDomesticShippingMsg = {
	                    msgs: [infoMessage],
	                    type: 'desc'
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-member-components/src/select-shipping/select-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"selectShipping\" content modal-box modal-refresh-on=\"'populated'\" modal-cancel=\"doneFn()\">\n    <xo-aside-header ng-if=\"deleteShipping\" hdrtype='tall' heading='asideHeader.selectShipping'\n                     sub-header-left-link='checkout.review.sidebar.addShipping'\n                     sub-header-left=\"asideHeader.add\"\n                     sub-header-left-icon=\"true\"\n                     sub-header-right-link='checkout.review.sidebar.deleteShipping'\n                     sub-header-right=\"asideHeader.delete\"\n                     sub-header-right-icon=\"true\"></xo-aside-header>\n\n    <xo-aside-header hdrtype='tall' heading='asideHeader.selectShipping'\n                     ng-if=\"!deleteShipping\"\n                     sub-header-left-link='checkout.review.sidebar.addShipping'\n                     sub-header-left=\"asideHeader.add\"\n                     sub-header-left-icon=\"true\"></xo-aside-header>\n\n    <div class=\"asideContent showAll\" xo-tray-height>\n        <ul class=\"items\" select-box=\"checkoutShippingAddresses.addresses\" select-allow-tab-escape>\n            <li ng-repeat=\"address in checkoutShippingAddresses.addresses\"\n                role=\"presentation\"\n                class=\"address trayInner trayInnerDefault\"\n                ng-class=\"{selectable: !address.default_address, disabled: address.disable_for_transaction}\">\n\n                <xo-message ng-if=\"address.disable_for_transaction\" message=\"blkNonDomesticShippingMsg\"\n                            class=\"shippingBlk\"></xo-message>\n\n                <a track-submit href=\"\" ng-click=\"onSelect(address)\" class=\"shippingBlk\" select-option=\"address.default_address\" focus-when=\"address.default_address\" role=\"option\" ng-attr-aria-selected=\"{{ address.default_address ? 'true' : undefined }}\">\n                    <span class=\"display fullName\">{{address.recipient_name}}</span>\n                    <xo-address-display address=address country-code=countryCode\n                                        show-preferred=\"true\"></xo-address-display>\n                    <span class=\"checkIcon\" ng-if=\"address.default_address\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n        </ul>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-sidebar/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__("./pages/xo-sidebar/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoSidebarComponent', {
	
	    tag: 'xo-sidebar',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            required: true,
	            type: 'var'
	        },
	        backUri: {
	            required: true,
	            type: 'var'
	        },
	        promotion: {
	            required: false,
	            type: 'var'
	        },
	        update: {
	            required: false,
	            type: 'var'
	        },
	        installment: {
	            required: false,
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            _squid.$util.assert(this.props.backUri, 'Expected backUri');
	
	            this.sidebar = true;
	
	            this.onPageClick = function ($event) {
	                $event.stopPropagation();
	            };
	
	            /*
	                Stores history of sidebar nested routes to be able to go to
	                previous sidebar routes by calling back() on sidebar.
	             */
	            this.history = [this.props.backUri];
	            this.cancelStateListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
	                var index = _this.history.indexOf(to.name);
	
	                if (index === -1) {
	                    _this.history.push(from.name);
	                } else {
	                    _this.history = _this.history.slice(0, index);
	                }
	            });
	
	            this.back = function () {
	                _uiRouter.$state.go(_this.history[_this.history.length - 1]);
	            };
	
	            this.close = function () {
	                _uiRouter.$state.go(_this.props.backUri);
	            };
	
	            this.callbacks = {
	                done: function done() {
	                    _uiRouter.$state.go('checkout.review');
	                }
	            };
	        },
	        populate: function populate() {
	            (0, _jquery2['default'])('body').addClass('trayOpen');
	            (0, _jquery2['default'])('#wrapper').addClass('maskMember');
	
	            var payButton = (0, _jquery2['default'])('.confirmButton');
	
	            if (payButton) {
	                payButton.attr('disabled', true);
	            }
	        },
	        exit: function exit() {
	            (0, _jquery2['default'])('body').removeClass('trayOpen');
	
	            var payButton = (0, _jquery2['default'])('.confirmButton');
	
	            if (payButton) {
	                payButton.attr('disabled', false);
	            }
	
	            this.cancelStateListener();
	        }
	    }
	});
	
	
	_angular.$rootScope;
	
	_uiRouter.$state;
	
	_squid.$Component;
	
	_squid.$util;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidebar/template.html":
/***/ function(module, exports) {

	module.exports = "<aside class=\"sidebar\" id=\"tray\" ng-click=\"onPageClick($event)\" modal-box modal-cancel=\"back()\" tabindex=\"-1\">\n\n    <div class=\"aside\" id=\"{{viewConfig.aside}}\">\n        <xo-aside-header ng-if=\"viewConfig.aside\" hdrtype=\"tall\" heading=\"{{viewConfig.heading}}\" sub-head='{{viewConfig.subHeading}}' add-link='{{viewConfig.addRoute}}'></xo-aside-header>\n        <div ui-view></div>\n    </div>\n</aside>\n\n<span class=\"trayViewMask\" ng-click=\"close()\"></span>\n"

/***/ },

/***/ "./pages/xo-sidebar-add-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarAddShippingRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./pages/xo-sidebar-add-shipping/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/add-shipping/route.js");
	
	var $SidebarAddShippingRoute = exports.$SidebarAddShippingRoute = _squid.$ComponentRoute.extend('$SidebarAddShippingRoute', {
	
	    path: 'sidebarAddShipping',
	    directive: 'xo-sidebar-add-shipping-page',
	    titleContent: 'addShipping.addAddress',
	    trackingData: {
	        templateName: 'tray/addShippingAddress.dust',
	        pageGoal: 'Add Shipping',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-shipping-address',
	                'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddShippingRoute',
	        attributes: {
	            token: 'token'
	        },
	        message: 'message',
	        sidebar: 'sidebar',
	        'parent-callbacks': 'callbacks'
	    }]
	});
	
	angular.value("$SidebarAddShippingRoute", $SidebarAddShippingRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidebar-add-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarAddShippingPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-sidebar-add-shipping/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarAddShippingPageComponent = exports.$xoSidebarAddShippingPageComponent = _squid.$Component.extend('$xoSidebarAddShippingPageComponent', {
	    tag: 'xo-sidebar-add-shipping-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state) {
	        $scope.token = $rootScope.token;
	        $scope.sidebar = true;
	
	        $scope.onComplete = function () {
	            $state.go('checkout.review');
	        };
	    }
	});
	
	angular.value("$xoSidebarAddShippingPageComponent", $xoSidebarAddShippingPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidebar-add-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"addShipping\">\n\n</div>\n"

/***/ },

/***/ "./components/xo-validation/dist/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid) {
	    squid.module('xo-validation.directive', ['squid']).directive('xoValidation', function () {
	        return {
	            template: '',
	            restrict: 'A',
	            require: 'ngModel',
	
	            link: function link(scope, elem, attr, ngModel) {
	
	                var validationUtil = {
	
	                    // because IE8 doesnt have String.prototype.trim()
	                    trim: function trim(value) {
	                        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	                        return value.replace(rtrim, '');
	                    },
	
	                    /**
	                     * Generic function that runs a given input against
	                     * a given regular expression
	                     *
	                     * @param {String} value input to test
	                     * @param {String/RegExp} regex Regular expression to test against
	                     * @returns {Boolean} matches or does not match given pattern
	                     */
	                    valid: function valid(value, regex) {
	                        if (this.empty(value)) {
	                            return false;
	                        }
	
	                        if (angular.isString(regex)) {
	                            regex = new RegExp(regex);
	                        }
	
	                        return regex ? regex.test(value) : true;
	                    },
	
	                    // returns whether empty or not
	                    empty: function empty(value) {
	                        if (!value) {
	                            return true;
	                        }
	
	                        // IE8 and below doesn't have native .trim()
	                        return !this.trim(value);
	                    },
	
	                    // returns whether alphabetic or not
	                    alphabetic: function alphabetic(value) {
	                        return this.valid(value, /[A-Za-z]+$/);
	                    },
	
	                    // returns whether numeric or not
	                    numeric: function numeric(value) {
	                        var NUMERIC_REGEX = new RegExp('^[0-9]+$');
	
	                        return this.valid(value, NUMERIC_REGEX);
	                    },
	
	                    validBankAccount: function validBankAccount(value) {
	                        if (!scope.showIBAN) {
	                            return this.numeric(value);
	                        }
	
	                        return true;
	                    },
	
	                    validRouting: function validRouting(value) {
	                        if (!scope.showIBAN) {
	                            return this.valid(value, /^\d{8}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBANCode: function validIBANCode(value) {
	                        if (scope.showIBAN) {
	                            value = value && value.replace(/ +/g, '');
	                            return this.valid(value, /^([A-Z]){2}\d{2}[A-Z0-9]{1,30}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBAN: function validIBAN(value) {
	                        if (scope.showIBAN) {
	                            value = value && value.replace(/ +/g, '');
	                            return this.valid(value, /^DE\d{20}$/);
	                        }
	                        return true;
	                    },
	
	                    validIBANCountry: function validIBANCountry(value) {
	                        value = value && value.replace(/ +/g, '');
	                        return !this.valid(value, /^([^D0-9][E]|[D][^E0-9]|[^D0-9][^E0-9])\d{2}[A-Z0-9]{1,30}$/i);
	                    },
	
	                    // first two letters are the country code the rest are the bank account numbers max length 32
	                    validIBANWithValidCountryCode: function validIBANWithValidCountryCode(value) {
	                        value = value && value.replace(/ +/g, '');
	                        return this.valid(value, /^(AT|BE|CY|EE|FI|FR|DE|EL|IE|IT|LV|LT|LU|MT|MC|NL|PT|SK|SI|ES)\d{3,32}$/i);
	                    },
	
	                    validLast4: function validLast4(value) {
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var LAST_4 = /^([0-9]{4})?$/; // eslint-disable-line fasec/no-unsafe-regex
	                        return this.valid(value, LAST_4);
	                    },
	
	                    validStreet: function validStreet(value) {
	                        return this.valid(value, /^([A-Za-z0-9-. ]*)$/);
	                    },
	
	                    // Validating phone format with metadata from griffin
	                    validPhone: function validPhone(value) {
	                        var regex = scope.pattern;
	                        /*
	                         * User can enter phone format in various manner according to griffin mask
	                         * (00) 0000-0000
	                         * 00 000 0000
	                         * Since the griffin pattern only validates against numbers, need to trim the input
	                         * to only validate the numbers
	                         */
	                        value = value && value.replace(/[^0-9]/gi, '');
	                        return this.valid(value, regex);
	                    },
	
	                    validDobYear: function validDobYear(value) {
	                        return value !== 'YYYY';
	                    },
	
	                    validDobDay: function validDobDay(value) {
	                        return value !== 'DD';
	                    },
	
	                    validDobMonth: function validDobMonth(value) {
	                        return value !== 'MM';
	                    },
	
	                    validPoBox: function validPoBox(value) {
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var boxRE = /\b(((general\s+)?post\s+(office|mail)?)|((g\.?)?p[-\.]?\s?[om][\.-]?))\s?(b(ox|\.)?)?(\s+\d+)\b/i; // eslint-disable-line fasec/no-unsafe-regex
	
	                        if (boxRE.test(value)) {
	                            return true;
	                        }
	                        return false;
	                    },
	
	                    validAddressSansPoBox: function validAddressSansPoBox(value) {
	                        var boxRE = /(p[-.]? ?[om]?[-.]? ?|post ?(office|mail)?)? ?b(.|ox)[^,]*\d+/i;
	                        var cassRE = /(drawer|locker|bin|firm caller)\s?#?[0-9]+/i;
	
	                        if (boxRE.test(value) || cassRE.test(value)) {
	                            return false;
	                        }
	                        return true;
	                    },
	
	                    validEmailOrPhone: function validEmailOrPhone(value) {
	                        if (!value) {
	                            return false;
	                        }
	
	                        return this.validEmail(value) || this.validPhone(value);
	                    },
	
	                    validEmail: function validEmail(value) {
	                        if (!value) {
	                            return false;
	                        }
	                        var trimmedValue = this.trim(value); // Trim leading and trailing whitespace
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i; // eslint-disable-line
	
	                        return this.valid(trimmedValue, EMAIL_REGEX) && !this.highAscii(trimmedValue);
	                    },
	
	                    highAscii: function highAscii(value) {
	                        var trimmedValue = this.trim(value);
	                        // @TODO - Unsafe regular expression, need to fix.
	                        var HIGH_ASCII_REGEX = /[^\x00-\x7F]/; // eslint-disable-line no-control-regex
	
	                        return this.valid(trimmedValue, HIGH_ASCII_REGEX);
	                    },
	
	                    // expected format: MM/DD/YYYY
	                    validDate: function validDate(value) {
	                        var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
	                        var dArr = value.split('/');
	                        var d = new Date(value);
	                        var isValid = false;
	
	                        if (re.test(value)) {
	                            isValid = d.getMonth() + 1 === dArr[0] && d.getDate() === dArr[1] && d.getFullYear() === dArr[2];
	                        }
	
	                        return isValid;
	                    },
	
	                    /* Expects value and state. state can be "past" or "future".
	                     NOTE: This function validates only month and year, not day!
	                     Please use validDate() if you need to validate the whole date. */
	                    validDateWithoutDay: function validDateWithoutDay(value, options) {
	                        var state = options.state;
	
	                        value = value.replace(/\s/g, '');
	
	                        if (value === '') {
	                            return true;
	                        }
	
	                        var split = value.split('/');
	                        var month = split[0];
	                        var year = split[1];
	                        var currentYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);
	                        var currentMonth = parseInt(new Date().getMonth(), 10) + 1;
	                        var validYear = true;
	                        var validMonth = true;
	
	                        if (value.length < 5) {
	                            return false;
	                        }
	
	                        if (this.validDobMonth(month)) {
	                            month = parseInt(month, 10);
	                        } else {
	                            return false;
	                        }
	
	                        year = parseInt(year, 10);
	
	                        if (state === 'past') {
	                            validYear = year <= currentYear;
	                            if (!validYear) {
	                                return false;
	                            }
	                            if (year === currentYear) {
	                                validMonth = month <= currentMonth;
	                            }
	                        } else if (state === 'future') {
	                            validYear = year >= currentYear;
	                            if (!validYear) {
	                                return false;
	                            }
	                            if (year === currentYear) {
	                                validMonth = month >= currentMonth;
	                            }
	                        }
	
	                        if (!validYear || !validMonth) {
	                            return false;
	                        }
	
	                        return true;
	                    },
	
	                    // formats to MM/DD/YYYY
	                    mmddyyyy: function mmddyyyy(day, month, year) {
	                        if (year.length < 4) {
	                            year = '20' + year;
	                        }
	
	                        return this.twoDigits(month) + '/' + this.twoDigits(day) + '/' + this.twoDigits(year);
	                    },
	
	                    // formats to YY-MMM-DDDD
	                    yyyymmdd: function yyyymmdd(day, month, year) {
	                        if (year.length < 4) {
	                            year = '20' + year;
	                        }
	
	                        return year + '-' + this.twoDigits(month) + '-' + this.twoDigits(day);
	                    },
	
	                    // pads a number to two digits
	                    twoDigits: function twoDigits(value) {
	                        return value < 10 ? '0' + value : '' + value;
	                    },
	
	                    // expects YYYY-MM-DD
	                    legalAge: function legalAge(value) {
	                        if (this.empty(value)) {
	                            return false;
	                        }
	
	                        var dateParts = value.split('-'); // expecting YYYY-MM-DD
	                        var birthDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
	                        var yr = 365.25 * 24 * 60 * 60 * 1000; // milliseconds in a year
	                        var validBD = new Date(new Date() - 18 * yr);
	
	                        return validBD >= birthDate;
	                    },
	
	                    validZip: function validZip(value, options) {
	
	                        var postalCodeRegex = {
	                            // TODO: Once this is removed from the xo-add-address template, we can remove it...
	                            'GB': /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/,
	                            /*
	                             * Note: These are "nice to have".
	                             * Once we add support for these countries, we can remove these.
	                             */
	                            'BA': /^\d{5}$/,
	                            'CY': /^\d{4}$/,
	                            'EE': /^\d{5}$/,
	                            'HR': /^\d{5}$/,
	                            'LU': /^\d{4}$/,
	                            'LV': /^\d{4}$/,
	                            'MT': /^\d{3,4}$/,
	                            'SI': /^\d{4}$/,
	                            'SK': /^[0-9]{3}[\s][0-9]{2}$/,
	                            'NZ': /^\d{4}$/,
	                            'LT': /^\d{5}$/,
	                            'BG': /^\d{4}$/,
	                            'CZ': /^\d{5}$/,
	                            'GR': /^\d{3}[\s]\d{2}$/,
	                            'HU': /^\d{4}$/,
	                            'MX': /^\d{5}$/
	                        };
	
	                        var country = options && options.country;
	                        var regex = scope.zipEntry && scope.zipEntry.validationPattern || postalCodeRegex[country];
	                        var isRequired = scope.zipEntry && scope.zipEntry.required;
	
	                        if (!isRequired && this.empty(value)) {
	                            return true;
	                        }
	
	                        // If there is no regex, or it's not populated yet...
	                        if (!regex || angular.isString(regex) && regex.indexOf('validationPattern') > -1) {
	                            return !this.empty(value);
	                        }
	
	                        value = value && value.toUpperCase();
	
	                        return this.valid(value, regex);
	                    },
	
	                    validExpiry: function validExpiry(value, options) {
	                        var $monthEl = $('[ng-model="card.expiry_month"]');
	                        var $yearEl = $('[ng-model="card.expiry_year"]');
	                        var month = $monthEl.val();
	                        var year = $yearEl.val();
	                        var isValid = false;
	                        var monthElName = 'card.expiry_month';
	                        var yearElName = 'card.expiry_year';
	                        var cardType = options.cardType;
	
	                        if (month) {
	                            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
	                        }
	
	                        if (year) {
	                            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
	                        }
	
	                        if (month && year) {
	                            isValid = this.validExpires(month, year);
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id');
	                        var form = scope[formName] || scope.$parent[formName];
	                        var monthFieldName = monthElName;
	                        var yearFieldName = yearElName;
	
	                        if (monthFieldName.indexOf('.') !== -1) {
	                            monthFieldName = monthFieldName.split('.')[1];
	                        }
	
	                        if (yearFieldName.indexOf('.') !== -1) {
	                            yearFieldName = yearFieldName.split('.')[1];
	                        }
	
	                        var cardsDontNeedExpiry = ['COFIDIS', 'COFINOGA', 'CETELEM'];
	
	                        if (cardType && cardsDontNeedExpiry.indexOf(cardType) !== -1) {
	                            isValid = true;
	                        }
	
	                        if (form) {
	                            form[monthFieldName].$setValidity('validExpiry', isValid);
	                            form[yearFieldName].$setValidity('validExpiry', isValid);
	                        }
	
	                        return isValid;
	                    },
	
	                    validExpires: function validExpires(month, year) {
	                        var date = new Date();
	                        var currentYear = parseInt(date.getFullYear().toString().substr(2, 2), 10);
	                        var currentMonth;
	
	                        if (year < currentYear) {
	                            return false;
	                        } else if (year > currentYear) {
	                            return this.validDobMonth(month);
	                        }
	
	                        // account for display date vs. system date
	                        currentMonth = date.getMonth() + 1;
	                        return this.validDobMonth(month) && month >= currentMonth;
	                    },
	
	                    startDate: function startDate(value, options) {
	                        var valueOptions = {
	                            cardType: scope.card.type
	                        };
	                        valueOptions[elem.attr('id')] = value;
	
	                        return this.setStartDateValidity(valueOptions);
	                    },
	
	                    setExpiryValidity: function setExpiryValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var cardType = options.cardType || '',
	                            expiryValidity = this.validExpiry(null, {
	                            cardType: cardType
	                        });
	
	                        return expiryValidity;
	                    },
	
	                    // start date validation for Maestro card
	                    setStartDateValidity: function setStartDateValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var cardType = options.cardType || '';
	                        var startDateValidity = true;
	                        var $monthEl = $('#startmonth');
	                        var $yearEl = $('#startyear');
	                        var month = $monthEl.val();
	                        var year = $yearEl.val();
	
	                        if (cardType === 'MAESTRO') {
	                            if (!month || !year) {
	                                startDateValidity = false;
	                            }
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id'),
	                            form = scope[formName] || scope.$parent[formName];
	
	                        if (form) {
	                            form.startmonth.$setValidity('startDate', startDateValidity);
	                            form.startyear.$setValidity('startDate', startDateValidity);
	                        }
	
	                        return startDateValidity;
	                    },
	
	                    dobField: function dobField(value, options) {
	                        var valueOptions = {};
	                        var fieldMap = {
	                            'dobDayCC': 'day',
	                            'dobMonthCC': 'month',
	                            'dobYearCC': 'year'
	                        };
	
	                        valueOptions.cardType = scope.card.type;
	                        valueOptions[fieldMap[elem.attr('id')]] = value;
	
	                        return this.setDOBValidity(valueOptions);
	                    },
	
	                    setDOBValidity: function setDOBValidity(options) {
	                        if (!options) {
	                            return true;
	                        }
	
	                        var dobEnabledCards = ['COFIDIS', 'COFINOGA', 'CETELEM'];
	
	                        var dobValidity = true;
	
	                        var $monthEl = $('#dobMonthCC');
	                        var $dayEl = $('#dobDayCC');
	                        var $yearEl = $('#dobYearCC');
	
	                        var month = options.month || $monthEl.val();
	                        var year = options.year || $yearEl.val();
	                        var day = options.day || $dayEl.val();
	
	                        if (month) {
	                            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
	                        }
	
	                        if (day) {
	                            day = $dayEl.find('option')[$dayEl.val() * 1 + 1].label;
	                        }
	
	                        if (year) {
	                            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
	                        }
	
	                        var cardType = options.cardType;
	                        if (cardType && dobEnabledCards.indexOf(cardType) !== -1) {
	                            if (!month || !year || !day) {
	                                dobValidity = false;
	                                // invalidate if < 18 y/o.
	                            } else if (!this.legalAge(this.yyyymmdd(day, month, year))) {
	                                dobValidity = false;
	                            } else if (!this.validDate(this.mmddyyyy(day, month, year))) {
	                                dobValidity = false;
	                            }
	                        }
	
	                        var formName = $monthEl.closest('form').attr('id');
	                        var form = scope[formName] || scope.$parent[formName];
	
	                        if (form) {
	                            form.dobMonthCC.$setValidity('dobField', dobValidity);
	                            form.dobDayCC.$setValidity('dobField', dobValidity);
	                            form.dobYearCC.$setValidity('dobField', dobValidity);
	                        }
	
	                        return dobValidity;
	                    },
	
	                    validName: function validName(value) {
	                        return this.valid(value, /^([a-zA-Z,\xC0-\xFF,\u00C0-\u017F\,\-\s\,\'])*$/);
	                        // ' this comment is to un-confuse editors on synax coloring because of the single quote above
	                    },
	
	                    isChecked: function isChecked(value, options) {
	                        // $.is does not exist in $
	                        // eslint-disable-line angular/ng_angularelement
	                        var $el = $(options.el);
	
	                        return $el.is(':checked');
	                    },
	
	                    validRUPassport: function validRUPassport(value, options) {
	                        if (scope.user.countryOfResidence === 'RU') {
	                            return this.valid(value, /^\d{10}$/);
	                        }
	                        return true;
	                    }
	                };
	
	                var customValidator = function customValidator(value) {
	                    var ruleJson = angular.fromJson(elem.attr('xo-validation'));
	                    var validator = ruleJson.validator;
	                    var options = ruleJson.options;
	
	                    ngModel.$setValidity(validator, validationUtil[validator](value, options));
	
	                    return value;
	                };
	
	                ngModel.$parsers.unshift(customValidator);
	                ngModel.$formatters.unshift(customValidator);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./pages/xo-sidebar-update-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarUpdateShippingRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./pages/xo-sidebar-update-shipping/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/update-shipping/route.js");
	
	var $SidebarUpdateShippingRoute = exports.$SidebarUpdateShippingRoute = _squid.$ComponentRoute.extend('$SidebarUpdateShippingRoute', {
	
	    path: 'sidebarUpdateShipping',
	    directive: 'xo-sidebar-Update-shipping-page',
	    titleContent: 'addShipping.addAddress',
	    trackingData: {
	        templateName: 'tray/addShippingAddress.dust',
	        pageGoal: 'Update Shipping',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-shipping-address',
	                'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$UpdateShippingRoute',
	        attributes: {
	            token: 'token'
	        },
	        message: 'message',
	        sidebar: 'sidebar',
	        'parent-callbacks': 'callbacks'
	    }]
	});
	
	angular.value("$SidebarUpdateShippingRoute", $SidebarUpdateShippingRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidebar-update-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarUpdateShippingPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-sidebar-update-shipping/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/select-shipping/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarUpdateShippingPageComponent = exports.$xoSidebarUpdateShippingPageComponent = _squid.$Component.extend('$xoSidebarUpdateShippingPageComponent', {
	    tag: 'xo-sidebar-update-shipping-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state) {
	        $scope.token = $rootScope.token;
	        $scope.sidebar = true;
	
	        $scope.onComplete = function () {
	            $state.go('checkout.review');
	        };
	    }
	});
	
	angular.value("$xoSidebarUpdateShippingPageComponent", $xoSidebarUpdateShippingPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidebar-update-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"updateShipping\">\n\n</div>\n"

/***/ },

/***/ "./pages/xo-sidebar-add-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarAddCardRoute = undefined;
	
	__webpack_require__("./pages/xo-sidebar-add-card/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidebarAddCardRoute = exports.$SidebarAddCardRoute = _squid.$ComponentRoute.extend('$SidebarAddCardRoute', {
	
	    path: 'sidebarAddCard',
	    directive: 'xo-sidebar-add-card-page',
	    titleContent: 'asideHeader.addCard',
	    trackingData: {
	        templateName: 'tray/addCard.dust',
	        pageGoal: 'Add Card',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-cc',
	                'pagename2': '%::fullpage-add-cc:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            sidebar: 'sidebar',
	            'parent-callbacks': 'callbacks',
	            promotion: 'promotion'
	        }
	    }]
	});
	
	angular.value("$SidebarAddCardRoute", $SidebarAddCardRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidebar-add-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarAddCardPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-sidebar-add-card/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarAddCardPageComponent = exports.$xoSidebarAddCardPageComponent = _squid.$Component.extend('$xoSidebarAddCardPageComponent', {
	    tag: 'xo-sidebar-add-card-page',
	    template: _template2['default'],
	
	    scope: {
	        promotion: '='
	    },
	
	    controller: function controller($scope, $rootScope, $state) {
	        // eslint-disable-line no-shadow
	        $scope.billingaddressupdated = {
	            value: false
	        };
	        $scope.sidebar = true;
	        $scope.token = $rootScope.token;
	        $scope.message = {};
	        $scope.callbacks = {
	            finish: function finish() {
	                $state.go('checkout.review');
	            }
	        };
	    }
	});
	
	angular.value("$xoSidebarAddCardPageComponent", $xoSidebarAddCardPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidebar-add-card/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"addCard\" content>\n\t<ui-view sidebar=\"sidebar\"></ui-view>\n</div>\n"

/***/ },

/***/ "./pages/xo-sidebar-add-bank/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarAddBankRoute = undefined;
	
	__webpack_require__("./pages/xo-sidebar-add-bank/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-bank/route.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidebarAddBankRoute = exports.$SidebarAddBankRoute = _squid.$ComponentRoute.extend('$SidebarAddBankRoute', {
	
	    path: 'sidebarAddBank',
	    directive: 'xo-sidebar-add-bank-page',
	    titleContent: 'asideHeader.addBank',
	    trackingData: {
	        templateName: 'tray/addBank.dust',
	        pageGoal: 'Add Bank',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::add-bank',
	                'pagename2': '%::add-bank:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddBankFlowRoute',
	        attributes: {
	            token: 'token',
	            sidebar: 'sidebar',
	            'parent-callbacks': 'callbacks'
	        }
	    }]
	});
	
	angular.value("$SidebarAddBankRoute", $SidebarAddBankRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidebar-add-bank/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarAddBankPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-sidebar-add-bank/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/add-bank/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarAddBankPageComponent = exports.$xoSidebarAddBankPageComponent = _squid.$Component.extend('$xoSidebarAddBankPageComponent', {
	    tag: 'xo-sidebar-add-bank-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state) {
	        // eslint-disable-line no-shadow
	        $scope.sidebar = true;
	        $scope.token = $rootScope.token;
	        $scope.message = {};
	        $scope.callbacks = {
	            done: function done() {
	                $state.go('checkout.review');
	            }
	        };
	    }
	});
	
	angular.value("$xoSidebarAddBankPageComponent", $xoSidebarAddBankPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidebar-add-bank/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"addBank\" content>\n    <ui-view></ui-view>\n</div>\n"

/***/ },

/***/ "./pages/xo-sidebar-currency-conversion/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarCurrencyConversionRoute = undefined;
	
	__webpack_require__("./pages/xo-sidebar-currency-conversion/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidebarCurrencyConversionRoute = exports.$SidebarCurrencyConversionRoute = _squid.$ComponentRoute.extend('$SidebarCurrencyConversionRoute', {
	    path: 'currencyConversion',
	    directive: 'xo-sidebar-currency-conversion-page',
	    titleContent: 'asideHeader.currencyOptions',
	    trackingData: {
	        fptiState: 'currency_conversion',
	        templateName: 'tray/currencyOptions.dust',
	        pageGoal: 'Currency Conversion',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-currency-options',
	                'pagename2': '%::fullpage-currency-options::hermes:',
	                'version': ':%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: []
	});
	
	angular.value("$SidebarCurrencyConversionRoute", $SidebarCurrencyConversionRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidebar-currency-conversion/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarCurrencyConversionPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-sidebar-currency-conversion/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/currency-conversion/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarCurrencyConversionPageComponent = exports.$xoSidebarCurrencyConversionPageComponent = _squid.$Component.extend('$xoSidebarCurrencyConversionPageComponent', {
	    tag: 'xo-sidebar-currency-conversion-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state) {
	        $scope.token = $rootScope.token;
	
	        $scope.onComplete = function () {
	            $state.go('checkout.review');
	        };
	
	        $scope.$emit('populated');
	    }
	});
	
	angular.value("$xoSidebarCurrencyConversionPageComponent", $xoSidebarCurrencyConversionPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidebar-currency-conversion/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"currencyConversion\">\n    <xo-aside-header heading='asideHeader.currencyOptions'></xo-aside-header>\n    <div class=\"currencyConversion asideContent container\" xo-tray-height>\n       <xo-currency-conversion token=\"token\" done-fn=\"onComplete\"></xo-currency-conversion>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/currency-conversion/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/currency-conversion/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoCurrencyConversionDirective', {
	    tag: 'xo-currency-conversion',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        doneFn: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        changeConversionChoice: function changeConversionChoice() {
	            // The button will usually be Agree but for Brazil, when Vendor is chosen,
	            // the button changes to Continue.
	            this.continueButton = _squid.$locale.content.get('buttons.agree');
	
	            if (this.conversion.from_code === 'BRL' && !this.models.ppconversion) {
	                this.continueButton = _squid.$locale.content.get('buttons.continue');
	            }
	        },
	        onSubmit: function onSubmit() {
	            var _this = this;
	
	            if (this.models.ppconversion === this.conversion.paypal) {
	                this.props.doneFn();
	                return;
	            }
	
	            var conversionType = this.models.ppconversion ? 'PAYPAL' : 'VENDOR';
	            var payload = {
	                conversionType: conversionType,
	                planId: this.checkoutInputData.funding_option_id || this.models.checkoutSession.plan.id
	            };
	
	            if (payload.planId) {
	                this.models.checkoutSession.fundingOptions.action('updateConversion', {
	
	                    data: payload,
	
	                    success: function success(result) {
	                        _this.models.checkoutSession.reload({
	                            success: function success() {
	                                var conversion = _this.models.checkoutSession.plan.conversion || {};
	                                if (!_this.models.ppconversion) {
	                                    if (conversion.paypal) {
	                                        _logger.$logger.info('currency_conversion_not_honored', {
	                                            type: _this.currencyConverion,
	                                            from: conversion.from,
	                                            to: conversion.to,
	                                            changeable: conversion.changeable
	                                        });
	                                    } else {
	                                        _this.models.checkoutSession.plan.conversion = {
	                                            changeable: true,
	                                            paypal: false
	                                        };
	                                    }
	                                }
	                            }
	                        });
	
	                        _this.props.doneFn(result);
	                    }
	                });
	            }
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            this.conversion = this.models.checkoutSession.plan.conversion;
	            this.models.ppconversion = this.conversion.paypal;
	            this.continueButton = _squid.$locale.content.get('buttons.agree');
	            this.checkoutInputData = _index2.$CheckoutInputDataModel.instance(this.props.token);
	
	            var fundingOptionId = this.checkoutInputData.funding_option_id;
	            if (fundingOptionId && fundingOptionId !== this.models.checkoutSession.plan.id) {
	                this.models.checkoutSession.fundingOptions.action('getConversion', {
	
	                    data: {
	                        planId: fundingOptionId
	                    },
	
	                    success: function success(result) {
	                        this.conversion = result;
	                    }
	                });
	            }
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$locale;
	
	_logger.$logger;
	
	_index.$CheckoutSessionModel;
	
	_index2.$CheckoutInputDataModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/currency-conversion/template.html":
/***/ function(module, exports) {

	module.exports = "<form method=\"post\" class=\"curr_conv asideProceed formSmall\" novalidate=\"novalidate\" ng-submit=\"actions.onSubmit()\" content>\n    <p>{{ content('currencyOptions.subHead') }}</p>\n    <ul class=\"conversionoptions\">\n        <li>\n            <div class=\"radioButton\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"ppconversion\" id=\"converionPayPal\" ng-value=\"true\" tabindex=\"0\" ng-change='actions.changeConversionChoice()'/>\n                <label for=\"converionPayPal\">{{ content('currencyOptions.ppRateDesc') }}</label>\n            </div>\n            <p class=\"conversion\" ng-if=\"conversion.paypal\">\n                {{ content('currencyOptions.conversionRate', { currencyFrom: conversion.from, currencyTo: conversion.to}) }}\n            </p>\n            <div ng-if=\"models.checkoutSession.plan.conversion.from_code !== 'BRL'\">\n                <ul>\n                    <li>{{content('currencyOptions.ppUpSell1')}}</li>\n                    <li>{{content('currencyOptions.ppUpSell2')}}</li>\n                </ul>\n            </div>\n            <div ng-if=\"models.checkoutSession.plan.conversion.from_code === 'BRL'\">\n                <ul>\n                    <li><strong>{{content('currencyOptions.ppUpSell3')}}</strong> {{content('currencyOptions.ppUpSell4')}} {{content('currencyOptions.ppUpSell5')}}</li>\n                </ul>\n            </div>\n        </li>\n        <li>\n            <div class=\"radioButton\">\n                <input type=\"radio\" ng-model=\"models.ppconversion\" name=\"ppconversion\" id=\"converionVendor\" ng-value=\"false\" tabindex=\"0\" ng-change='actions.changeConversionChoice()'/>\n                <label for=\"converionVendor\">{{content('currencyOptions.cardIssuerRate')}}</label>\n            </div>\n            <div ng-if=\"models.checkoutSession.plan.conversion.from_code !== 'BRL'\">\n                <ul>\n                    <li>{{content('currencyOptions.cardIssuerRate1')}}</li>\n                    <li>{{content('currencyOptions.cardIssuerRate2')}}</li>\n                </ul>\n            </div>\n            <div ng-if=\"models.checkoutSession.plan.conversion.from_code === 'BRL'\">\n                <ul>\n                    <li><strong>{{content('currencyOptions.cardIssuerRate3')}}</strong> {{content('currencyOptions.cardIssuerRate4')}} <strong>{{content('currencyOptions.cardIssuerRate5')}}</strong></li>\n                </ul>\n            </div>\n        </li>\n    </ul>\n    <div class=\"buttons\">\n        <input id=\"proceedButton\" type=\"submit\" value=\"{{continueButton}}\" class=\"btn full\">\n    </div>\n</form>\n\n"

/***/ },

/***/ "./pages/xo-sidebar-installment-options/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarInstallmentOptionsRoute = undefined;
	
	__webpack_require__("./pages/xo-sidebar-installment-options/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidebarInstallmentOptionsRoute = exports.$SidebarInstallmentOptionsRoute = _squid.$ComponentRoute.extend('$SidebarInstallmentOptionsRoute', {
	    path: 'installmentOptions',
	    directive: 'xo-sidebar-installment-options-page',
	    titleContent: 'asideHeader.installmentsPanel',
	    trackingData: {
	        fptiState: 'installment_options',
	        templateName: 'tray/installmentOptions.dust',
	        pageGoal: 'Installment Options',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-installment-options',
	                'pagename2': '%::fullpage-installment-options::hermes:',
	                'version': ':%:'
	            }
	        }
	    },
	    children: []
	});
	
	angular.value("$SidebarInstallmentOptionsRoute", $SidebarInstallmentOptionsRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidebar-installment-options/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarInstallmentOptionsPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-sidebar-installment-options/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/installment-options/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarInstallmentOptionsPageComponent = exports.$xoSidebarInstallmentOptionsPageComponent = _squid.$Component.extend('$xoSidebarInstallmentOptionsPageComponent', {
	    tag: 'xo-sidebar-installment-options-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state) {
	        $scope.token = $rootScope.token;
	
	        $scope.onComplete = function () {
	            $state.go('checkout.review');
	        };
	
	        $scope.$emit('populated');
	    }
	});
	
	angular.value("$xoSidebarInstallmentOptionsPageComponent", $xoSidebarInstallmentOptionsPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidebar-installment-options/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"installmentOptions\">\n    <xo-aside-header heading='asideHeader.installmentsPanel'></xo-aside-header>\n    <xo-installment-options token=\"token\" done-fn=\"onComplete\"></xo-installment-options>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/installment-options/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/installment-options/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-tray-height/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-installment-options.directive', ['squid', 'xomodel.checkout', 'xomodel.auth', 'xo-tray-height.directive']).directive('xoInstallmentOptions', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                doneFn: '=',
	                cardNumber: '='
	            },
	
	            controller: function controller($AuthModel, $scope, $populate, $CheckoutSessionModel, $InstallmentOptionsModel, $CheckoutPayeeModel, $CheckoutCartModel, $CheckoutAppDataModel) {
	
	                $populate($scope, {
	                    auth: $AuthModel.instance()
	                }).then(function () {
	
	                    if ($scope.auth.logged_in) {
	
	                        // Installment support for authenticated user
	                        $populate($scope, {
	                            checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                        }).then(function () {
	                            $scope.cardInfo = $scope.checkoutSession.plan.sources[0];
	                            $scope.installments = $scope.checkoutSession.installments;
	                        });
	                    } else {
	                        // Installment support added for not authenticated user, e.g. BR signup flow
	                        var installmentsModel = $InstallmentOptionsModel.instance($scope.token);
	
	                        installmentsModel.save({
	                            data: {
	                                cc: $scope.cardNumber,
	                                payee: $CheckoutPayeeModel.instance($scope.token),
	                                checkoutCart: $CheckoutCartModel.instance($scope.token),
	                                checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	                            },
	
	                            success: function success(result) {
	                                $scope.cardInfo = result.cardInfo;
	                                $scope.installments = result.installment_options;
	                            }
	                        });
	                    }
	                });
	
	                $scope.onSelect = function (index) {
	                    var selectedInstallmentData = $scope.installments[index];
	                    $scope.installmentsModel = $InstallmentOptionsModel.instance($scope.token);
	
	                    var param = {
	                        term: selectedInstallmentData.term,
	                        payment_value: selectedInstallmentData.monthly_payment.value,
	                        payment_currency: selectedInstallmentData.monthly_payment.currency
	                    };
	
	                    if (selectedInstallmentData.discount_amount) {
	                        param.discount_value = selectedInstallmentData.discount_amount.value;
	                        param.discount_currency = selectedInstallmentData.monthly_payment.currency;
	                    }
	
	                    if (selectedInstallmentData.discount_percentage) {
	                        param.discount_percentage = selectedInstallmentData.discount_percentage;
	                    }
	
	                    return $scope.installmentsModel.action('select', {
	                        data: param,
	
	                        success: function success(result) {
	                            if ($scope.auth.logged_in) {
	                                $scope.checkoutSession.selectedInstallmentData = selectedInstallmentData;
	                            }
	                            $scope.doneFn(result);
	                        }
	                    });
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/installment-options/template.html":
/***/ function(module, exports) {

	module.exports = "<div content class=\"aside installmentOptions\" ng-class=\"{true: 'signupflow'}[!auth.logged_in]\" >\n    <div class=\"cardInfo\" ng-if=\"cardInfo\">\n        <span class=\"ccard {{cardInfo.card_type}}\" id=\"creditCard\" role=\"img\" aria-label=\"{{cardInfo.name}}\"></span> {{cardInfo.name}} x-{{cardInfo.last4}}&nbsp;<span class=\"installmentText\" ng-if=\"installments\">{{content('installments.upto')}}&nbsp;{{installments.length}}x</span>\n    </div>\n    <ul class=\"asideContent items\" ng-if=\"installments\">\n        <li class=\"installment\" ng-repeat=\"installment in installments\" ng-click=\"onSelect($index)\" track-submit>\n            <div class=\"term\">\n                <span>{{installment.term}}x {{content('installments.of')}}&nbsp;</span>\n            </div>\n            <div class=\"display\">\n                <span>{{installment.monthly_payment.formatted_value}}</span>\n                <div class=\"confidential total\">\n                    <span>{{content('installments.total')}}: {{installment.total}}</span>\n                    <span class=\"save\" ng-if=\"installment.discount_amount\">\n                        {{content('installments.save')}} {{installment.discount_amount.formatted_value}}\n                    </span>\n                </div>\n            </div>\n\n        </li>\n    </ul>\n</div>"

/***/ },

/***/ "./pages/xo-wallet/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidebarWalletRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _route = __webpack_require__("./components/xo-wallet-components/src/confirm-upop/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _route3 = __webpack_require__("./components/xo-credit-components/src/apply-ppc/route.js");
	
	var _route4 = _interopRequireDefault(_route3);
	
	__webpack_require__("./pages/xo-wallet/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $SidebarWalletRoute = exports.$SidebarWalletRoute = _squid.$ComponentRoute.extend('$SidebarWalletRoute', {
	
	    path: 'wallet',
	    directive: 'xo-wallet',
	    titleContent: 'asideHeader.wallet',
	    trackingData: {
	        fptiState: 'funding_option_selection',
	        templateName: 'fundingInstruments.dust',
	        pageGoal: 'Change Instruments',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-wallet-fundingsources',
	                'pagename2': '%::fullpage-wallet-fundingsources:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    params: {
	        padToggleFeature: null
	    },
	    children: [{
	        route: _route2['default'],
	        attributes: {
	            token: 'token',
	            phone: 'phone',
	            cardmodel: 'cardModel'
	        }
	    }, {
	        route: _route4['default'],
	        props: function props() {
	            return {
	                token: this.token
	            };
	        }
	    }]
	});
	
	angular.value("$SidebarWalletRoute", $SidebarWalletRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-wallet/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _choice = __webpack_require__("./components/xo-models/src/choice/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/credit/index.js");
	
	var _index4 = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	__webpack_require__("./components/xo-credit-components/src/offer/directive.js");
	
	__webpack_require__("./components/xo-tray-height/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/popup/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	var _template = __webpack_require__("./pages/xo-wallet/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-wallet/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend({
	
	    tag: 'xo-wallet',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        promotion: {
	            type: 'var',
	            required: false
	        },
	
	        installment: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                choiceVariant: _choice.$ChoiceEligibility.instance().getVariant(this.props.token)
	            };
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var $scope = this;
	
	            $scope.locale = _squid.$locale;
	            $scope.showDisallowedMessage = false;
	            $scope.toggleDisallowedMessage = function () {
	                $scope.showDisallowedMessage = !$scope.showDisallowedMessage;
	            };
	
	            $scope.doneFn = function (result) {
	                if ($scope.checkoutSession.plan.paypal_credit && $scope.installment.showCYCO) {
	                    _uiRouter.$state.go('checkout.chooseCreditOffer');
	                } else {
	                    _uiRouter.$state.go('checkout.review');
	                }
	            };
	
	            $scope.showDualFi = (0, _squid.$feature)('addBank');
	
	            $scope.padToggleFeature = _uiRouter.$stateParams.padToggleFeature;
	
	            $scope.padToggleFeatureSupported = (0, _squid.$feature)('padToggleFeatureSupported');
	
	            $scope.padToggleWalletSupported = (0, _squid.$feature)('padToggleWalletSupported');
	
	            $scope.isPadToggleFeatureApplicable = function () {
	                var applicable = false;
	
	                if ($scope.padToggleFeatureSupported && $scope.padToggleWalletSupported && $scope.padToggleFeature && $scope.padToggleFeature.pxpTreatmentEnabled && $scope.padToggleFeature.applicable) {
	                    applicable = true;
	                }
	
	                return applicable;
	            };
	
	            var isCreditInWallet = void 0;
	            var isCoreSACEligible = void 0;
	
	            var CREDIT_TYPE = {
	                'CORE': 'CORE',
	                'SAC': 'SAC',
	                'EZP': 'EZP'
	            };
	
	            var getDefaultBanner = function getDefaultBanner(creditType, amount, termsLink) {
	                if (creditType === CREDIT_TYPE.CORE) {
	                    return {
	                        bodyText: (0, _squid.$renderContent)('offers.bmlOfferPassiveDetails', { cartAmount: amount }),
	                        ctaText: (0, _squid.$renderContent)('offers.bmlOfferPassiveCta'),
	                        termsText: (0, _squid.$renderContent)('offers.subjectToApproval'),
	                        termsLink: termsLink,
	                        termsLinkText: (0, _squid.$renderContent)('offers.seeTermsText')
	                    };
	                }
	
	                if (creditType === CREDIT_TYPE.SAC) {
	                    return {
	                        bodyText: (0, _squid.$renderContent)('offers.bmlOfferPassiveSACDetails', { cartAmount: amount }),
	                        ctaText: (0, _squid.$renderContent)('offers.bmlOfferPassiveCta'),
	                        termsText: (0, _squid.$renderContent)('offers.subjectToApproval'),
	                        termsLink: termsLink,
	                        termsLinkText: (0, _squid.$renderContent)('offers.seeTermsText')
	                    };
	                }
	
	                if (creditType === CREDIT_TYPE.EZP) {
	                    return {
	                        bodyText: (0, _squid.$renderContent)('offers.bmlOfferPassiveDetails', { cartAmount: amount }),
	                        ctaText: (0, _squid.$renderContent)('offers.bmlOfferPassiveCta'),
	                        termsText: (0, _squid.$renderContent)('offers.subjectToApproval')
	                    };
	                }
	            };
	
	            (0, _squid.$populate)($scope, {
	                auth: _index4.$AuthModel.instance($scope.token),
	                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
	                checkoutCart: _index.$CheckoutCartModel.create($scope.token),
	                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
	                payee: _index.$CheckoutPayeeModel.instance($scope.token)
	            }).then(function () {
	                if ($scope.padToggleFeatureSupported && $scope.padToggleWalletSupported && $scope.padToggleFeature === null) {
	                    var padToggleApplicable = $scope.checkoutSession.fundingOptions.isPadToggleApplicable();
	
	                    if (padToggleApplicable) {
	                        $scope.padToggleFeature = {
	                            applicable: false,
	                            pxpTreatmentEnabled: false
	                        };
	
	                        $scope.padToggleFeature.applicable = padToggleApplicable;
	
	                        (0, _squid.$pxp)('xo_de_hermes_pad_toggle', { 'ctx.COUNTRY': _squid.$locale.country }, '(xo_de_hermes_pad_toggle_)(.*)').then(function (result) {
	                            var treatmentName = result && result.treatment_name || '';
	
	                            if (treatmentName === 'xo_de_hermes_pad_toggle_treatment') {
	                                $scope.padToggleFeature.pxpTreatmentEnabled = true;
	                            }
	                        });
	                    }
	                }
	
	                $scope.isCurrentPlanPad = $scope.checkoutSession.plan.isPAD();
	            }).then(function () {
	                // pxp for MORS ramp
	                $scope.isMorsPxpEnabled = false;
	
	                return (0, _squid.$pxp)('xo_hermes_choice_1stbutton_phase2_ramp', { 'ctx.COUNTRY': _squid.$locale.country }, 'xo_hermes_choice_1stbutton_phase2_ramp_treatment').then(function (result) {
	                    if (result && result.treatment_name === 'xo_hermes_choice_1stbutton_phase2_ramp_treatment') {
	                        $scope.isMorsPxpEnabled = true;
	                    }
	                });
	            }).then(function () {
	                var fundingInstruments = _index.$CheckoutSessionModel.instance($scope.token).get('fundingOptions.instruments');
	
	                isCreditInWallet = _squid.$util.find(fundingInstruments, function (fi) {
	                    return fi.name === 'BILL_ME_LATER';
	                });
	                isCoreSACEligible = $scope.checkoutSession.bmlOffer === 1 || $scope.checkoutSession.bmlOffer === 2;
	
	                var getCreditType = function getCreditType(bmlOffer, isInst) {
	                    // Check if there is an offer already selected
	                    var instModel = _index3.$CreditInstallmentModel.instance($scope.token);
	
	                    if (instModel && instModel.creditType === CREDIT_TYPE.SAC) {
	                        return CREDIT_TYPE.SAC;
	                    } else if (isInst) {
	                        return CREDIT_TYPE.EZP;
	                    } else if (bmlOffer === 1) {
	                        return CREDIT_TYPE.SAC;
	                    } else if (bmlOffer === 2) {
	                        return CREDIT_TYPE.CORE;
	                    }
	                    _logger.$logger.warn('unknown_credit_type');
	                };
	
	                var mapDefaultToBanner = function mapDefaultToBanner(creditReuseTerms, creditTerms) {
	                    $scope.useFallbackBanner = true;
	
	                    _logger.$logger.info('checkout_fpti', {
	                        'banner_type': 'ACQUISITION_wallet'
	                    });
	
	                    $scope.banner = getDefaultBanner(getCreditType($scope.installment.bmlOffer, $scope.installment.installmentOptionsPresent), $scope.checkoutCart.get('purchase.amounts.total.amount_formatted'), isCreditInWallet ? creditReuseTerms : creditTerms);
	                };
	
	                if ($scope.isMorsPxpEnabled && _squid.$locale.country === 'US' && _squid.$locale.lang === 'en' && !isCreditInWallet) {
	                    $scope.banner = {};
	                    return mapDefaultToBanner(_squid.$config.urls.creditReuseTerms, _squid.$config.urls.creditTerms);
	                }
	            }).then(function () {
	                $scope.disallowedPreferredInstrument = $scope.checkoutSession.getDisallowedPreferred();
	                $scope.isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
	                $scope.isBilling = $scope.checkoutCart.isBilling();
	
	                if ((0, _squid.$feature)('giftCard')) {
	                    $scope.showGC = Math.random() < 0.01 && !$scope.isBillingNoPurchase;
	
	                    if ($scope.showGC) {
	                        _logger.$logger.info('wallet_gift_card_redeem_link_shown');
	                    } else {
	                        _logger.$logger.info('wallet_gift_card_redeem_link_not_shown');
	                    }
	                }
	
	                // Manage wallet feature can be turned on by country.
	                // User will see manage link on wallet page if feature is turned on and has FIs allowed to edit.
	                if ((0, _squid.$feature)('enableManageWallet')) {
	                    var instruments = $scope.checkoutSession.get('fundingOptions.instruments');
	                    var managebleFIs = _squid.$util.filter(instruments, function (funding) {
	                        if (funding && !funding.editDisallowedMsg) {
	                            return funding;
	                        }
	                    });
	
	                    $scope.showManageLink = managebleFIs && managebleFIs.length > 0;
	                }
	
	                var creditDataModel = _index3.$CreditDataModel.instance($scope.token);
	
	                $scope.checkoutSession.message = null;
	                $scope.showAddLink = _squid.$locale.country !== 'DE';
	                $scope.showPlcc = $scope.checkoutSession.plccOffer && !$scope.checkoutCart.isBilling();
	                $scope.showBML = function () {
	                    return _squid.$locale.country !== 'GB' && !isCreditInWallet && isCoreSACEligible && !$scope.installment.showWalletBanner && !creditDataModel.isRedirectFromCape();
	                };
	
	                $scope.bml = function () {
	                    // TODO: Deprecate creditOffer() - installment should not be a different banner
	                    if ($scope.isMorsPxpEnabled && $scope.installment.showWalletBanner) {
	                        _uiRouter.$state.go('checkout.chooseCreditOffer');
	                    } else {
	                        _uiRouter.$state.go('checkout.redirectToCape');
	                    }
	                };
	
	                $scope.onRedeemGC = function () {
	                    throw new _squid.$FallbackError({
	                        reason: 'redeem_coupon_feature_not_supported',
	                        product: 'ux',
	                        entryPoint: 'giftCard'
	                    });
	                };
	
	                $scope.addPlcc = function () {
	                    if ($scope.promotion) {
	                        $scope.promotion.type = 'plcc';
	                    }
	                    _uiRouter.$state.go('checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard');
	                };
	
	                $scope.sacEligible = function (fsName) {
	                    // Return false for non BML products
	                    if (fsName !== 'BILL_ME_LATER') {
	                        return false;
	                    }
	
	                    if (!$scope.installment.showCYCO && parseFloat($scope.checkoutCart.purchase.amounts.total.amount) >= _index.$CreditOptionsModel.sacEligibleAmount[_squid.$locale.country]) {
	                        return true;
	                    }
	                };
	
	                $scope.cardModel = new _index2.$AddCardModel({
	                    card: new _index2.$CardModel()
	                });
	
	                $scope.creditOffer = function () {
	                    _uiRouter.$state.go('checkout.chooseCreditOffer');
	                };
	
	                $scope.showBannerinWallet = function () {
	                    if ($scope.installment.showBanner && _squid.$locale.country === 'GB') {
	                        if ($scope.installment.installmentOptionsPresent) {
	                            $scope.showInstallmentBannerContent = true;
	                            $scope.showBannerContent = false;
	                        } else {
	                            $scope.showBannerContent = true;
	                            $scope.showInstallmentBannerContent = false;
	                        }
	                        return true;
	                    }
	                    return false;
	                };
	
	                $scope.userSelectedFI = $scope.checkoutSession.getSelectedStickyInstrument() && $scope.checkoutSession.getSelectedStickyInstrument().instrument_id;
	
	                $scope.updateStickyFS = function (stickyFI) {
	                    if (stickyFI.instrument_id !== $scope.userSelectedFI) {
	                        $scope.checkoutSession.action('setStickyFI', {
	                            data: {
	                                instrument_id: stickyFI.instrument_id
	                            },
	                            success: function success(result) {
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['paymentMethod.paymentMethodUpdated']
	                                };
	                                $scope.doneFn(result);
	                            }
	                        });
	                    } else {
	                        _uiRouter.$state.go('checkout.review');
	                    }
	                };
	
	                var masterPlanList = $scope.checkoutSession.getPlanList();
	                var serializedPlans = {}; // index of all plans by primary and balance currency code(s)
	                var balanceCodes = {}; // index of cataloged currency codes
	                var primaryList = []; // list of plans with unique primaryFs ids
	                var balanceList = $scope.balanceList = []; // list of unique balance currencies
	                // determine if the selectFi variant is active
	                var isSelectFiVariant = $scope.isSelectFiVariant = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi && _squid.$config.choiceExperiment.selectFi.indexOf($scope.models.choiceVariant) !== -1;
	
	                var getSerializedPrimary = function getSerializedPrimary(primary) {
	                    var serial = primary.id + primary.amount.currency_code.toLowerCase();
	
	                    // if there's a subtype...
	                    if (primary.subtype) {
	                        serial += primary.subtype;
	                    }
	                    return serial;
	                };
	
	                // return a serialized key for the plan
	                // plan - a plan object from checkoutSession.fundingOptions.plans
	                // balances - array of currency code strings
	                var getSerializedPlanId = function getSerializedPlanId(plan, balances) {
	                    var pid = getSerializedPrimary(plan.primaryFs);
	
	                    // if no balances array...
	                    if (!balances) {
	                        // just return the pid
	                        return pid;
	                    }
	
	                    // (otherwise) sort balances
	                    balances.sort();
	
	                    return pid + balances.join();
	                };
	
	                if (masterPlanList) {
	                    var initiallyActiveBalances = [];
	                    var showBalanceCurrencies = $scope.checkoutSession.isMultipleBalancePlan();
	
	                    // if selectFi variant...
	                    if (isSelectFiVariant) {
	
	                        // if not multiple balance plans...
	                        if (!showBalanceCurrencies) {
	                            // start with first plan's currency
	                            var knownCurrency = masterPlanList[0].primaryFs.amount.currency_code;
	
	                            // update flag if any plan has more than two secondaries or one with a different currency
	                            showBalanceCurrencies = masterPlanList.some(function (plan) {
	                                // show currencies, when this plan has a different one, or...
	                                return plan.primaryFs.amount.currency_code !== knownCurrency ||
	                                // this plan has secondaries, where...
	                                plan.secondaryFIs && (
	                                // there's more than one
	                                plan.secondaryFIs.length > 1 ||
	                                // the one has a different currency
	                                plan.secondaryFIs[0].amount.currency_code !== knownCurrency);
	                            });
	                        }
	
	                        // index of captured primaryFs ids
	                        var primaryFsIds = {};
	
	                        // with each plan...
	                        masterPlanList.forEach(function (plan) {
	                            var balances = plan.secondaryFIs || [];
	                            var balCurCodes = [];
	
	                            // if this is the active plan...
	                            if ($scope.checkoutSession.plan.id === plan.planId) {
	                                // capture it's balances - to be processed later
	                                initiallyActiveBalances = balances;
	                            }
	
	                            // catalog balances
	                            balances.forEach(function (balance) {
	                                var code = balance.amount.currency_code;
	
	                                // capture code (for serialization, next)
	                                balCurCodes.push(code);
	                                // if this code has not been cataloged...
	                                if (!balanceCodes.hasOwnProperty(code)) {
	                                    var balInfoAndState = {
	                                        code: code,
	                                        checked: false
	                                    };
	
	                                    if (showBalanceCurrencies) {
	                                        balInfoAndState.amount = balance.amount.amount_formatted_currency;
	                                    } else {
	                                        balInfoAndState.amount = balance.amount.amount_formatted;
	                                    }
	                                    // flag that we've cataloged this code
	                                    balanceCodes[code] = balInfoAndState;
	                                    // capture balance details and initial ui state
	                                    balanceList.push(balInfoAndState);
	                                }
	                            });
	
	                            // if this is a primary split-balance plan...
	                            if (plan.primaryFs.type === 'BALANCE') {
	                                // add key to template
	                                // NOTE: easier to build string here, than with template tags
	                                plan.currencies = [plan.primaryFs.amount.currency_code].concat(balCurCodes).join(', ');
	                            }
	
	                            // catalog plan by serial and balances
	                            serializedPlans[getSerializedPlanId(plan, balCurCodes)] = plan;
	
	                            // get plan primary
	                            var serialPrimary = getSerializedPrimary(plan.primaryFs);
	
	                            // if haven't indexed the primary...
	                            if (!primaryFsIds.hasOwnProperty(serialPrimary)) {
	                                // note that we've cataloged this primary
	                                primaryFsIds[serialPrimary] = 1;
	                                // capture plan with unique primary
	                                primaryList.push(plan);
	                            }
	                        });
	
	                        // sort unique balances by currency code
	                        balanceList.sort(function (balA, balB) {
	                            // balance codes are never the same, so no need to return 0
	                            return balA.code < balB.code ? -1 : 1;
	                        });
	
	                        // pre-check balances that match the active plan's balances (if any)
	                        initiallyActiveBalances.forEach(function (balance) {
	                            balanceCodes[balance.amount.currency_code].checked = true;
	                        });
	                    } else {
	                        // (otherwise) use master as local and scoped list
	                        primaryList = masterPlanList;
	                    }
	
	                    // expose to template
	                    $scope.isMultipleBalance = showBalanceCurrencies;
	
	                    // expose final list
	                    $scope.primaryList = primaryList;
	                }
	
	                $scope.updateFS = function (index) {
	                    // impacts when/how to notify user that balances were unusable
	                    var unusableBalances = 0;
	                    // impacts when/how to notify user that balances were required
	                    var requiredBalances = 0;
	                    // the plan to use
	                    var fundingsource = void 0;
	
	                    // flag when the plan has changed
	                    var updateMessaging = function updateMessaging(planWasChanged) {
	                        // if this is a primary balance plan...
	                        if ($scope.checkoutSession.plan.sources[0].type === 'BALANCE') {
	                            // suppress any info messages
	                            unusableBalances = requiredBalances = 0;
	                        }
	                        if (unusableBalances) {
	                            // show info message about failed balances
	                            $scope.checkoutSession.message = {
	                                type: 'info',
	                                msgKeys: [unusableBalances === 1 ? 'memberReview.ryi_noBal' : 'memberReview.ryi_noBal_plural']
	                            };
	                        } else if (requiredBalances) {
	                            // show info message about added balances
	                            $scope.checkoutSession.message = {
	                                type: 'info',
	                                msgKeys: [requiredBalances === 1 ? 'memberReview.ryi_yesBal' : 'memberReview.ryi_yesBal_plural']
	                            };
	                        } else if (planWasChanged) {
	                            // show that their selection went fine
	                            $scope.checkoutSession.message = {
	                                type: 'success',
	                                msgKeys: ['paymentMethod.paymentMethodUpdated']
	                            };
	                        }
	                    };
	
	                    if (isSelectFiVariant) {
	                        // get plan with serial, built from user selections
	                        var checkedBalances = [];
	
	                        // capture checked balance codes
	                        _squid.$util.forEach(balanceCodes, function (balInfoAndState, code) {
	                            if (balInfoAndState.checked) {
	                                // capture balance object
	                                // this is what getSerializedPlanId expects - ugh
	                                checkedBalances.push(code);
	                            }
	                        });
	                        var plan = primaryList[index];
	                        var pid = void 0;
	                        var pidForLogger = void 0;
	
	                        // use plan with this primaryFs and balance options - if any
	                        fundingsource = serializedPlans[getSerializedPlanId(plan, checkedBalances)];
	
	                        // if no plan yet...
	                        // (perhaps only one of the selected balances is applicable?)
	                        if (!fundingsource) {
	                            // resolve pid now
	                            pid = getSerializedPrimary(plan.primaryFs);
	                            pidForLogger = plan.primaryFs.id || plan.primaryFs.type;
	                            // find a plan with each individual balance
	                            checkedBalances.some(function (code) {
	                                // match plan with this serial combination
	                                fundingsource = serializedPlans[pid + code];
	                                return fundingsource;
	                            });
	                            // flag that one of the checked balances was unusable
	                            if (fundingsource) {
	                                unusableBalances = 2;
	
	                                _logger.$logger.info('checkout_fpti', {
	                                    primary: pidForLogger,
	                                    denied: checkedBalances.join()
	                                });
	                            }
	                        }
	
	                        // if no plan yet...
	                        // (perhaps the plan doesn't have any balance combination?)
	                        if (!fundingsource) {
	                            // get the plan with just this primaryFs
	                            fundingsource = serializedPlans[pid];
	                            // if we now have a plan...
	                            if (fundingsource) {
	                                // note how many desired balances we're ignoring (if any)
	                                unusableBalances = checkedBalances.length;
	
	                                _logger.$logger.info('checkout_fpti', {
	                                    primary: pidForLogger,
	                                    denied: checkedBalances.join()
	                                });
	                            }
	                        }
	
	                        // if still no plan...
	                        // (at this point, the plan requires a specific balance combination)
	                        if (!fundingsource) {
	                            var serializedPlanKeys = Object.keys(serializedPlans);
	
	                            // use the first plan that begins with this primary
	                            fundingsource = serializedPlans[serializedPlanKeys[_squid.$util.findIndex(serializedPlanKeys, function (serial) {
	                                return serial.indexOf(pid) === 0;
	                            })]];
	                            // indicate that one or more balances were required for this plan
	                            requiredBalances = balanceList.length;
	
	                            _logger.$logger.info('checkout_fpti', {
	                                primary: pidForLogger,
	                                forced: balanceList.map(function (balance) {
	                                    return balance.code;
	                                }).join()
	                            });
	                        }
	                    } else {
	
	                        // (otherwise) when performing control logic...
	
	                        // the first argument is the funding source
	                        fundingsource = index;
	                    }
	
	                    // clear messaging - by default
	                    $scope.checkoutSession.message = '';
	
	                    if (fundingsource.infoMsg) {
	                        $scope.disallowedIndex = index;
	                        return;
	                    }
	
	                    // if the final plan hasn't changed...
	                    if (fundingsource.planId === $scope.checkoutSession.plan.id) {
	                        // tells user if any balances were not used or were required
	                        updateMessaging();
	                        // show message if balances were selected, but couldn't be used
	                        $scope.doneFn();
	                        return;
	                    }
	
	                    $scope.checkoutSession.fundingOptions.action('select', {
	
	                        data: {
	                            planId: fundingsource.planId
	                        },
	                        success: function success(result) {
	
	                            $scope.checkoutSession.populate(result);
	
	                            if (result) {
	                                // Update the installments to support the user selecting a card that does not support installments.
	                                $scope.checkoutSession.installments = result.installments;
	                            }
	
	                            if ($scope.checkoutSession.plan.paypal_credit && $scope.installment.showCYCO) {
	                                _uiRouter.$state.go('checkout.chooseCreditOffer');
	                            } else {
	                                if (!fundingsource.selected) {
	                                    // handle messaging around unusable balances (if any)
	                                    // send flag that the plan was changed
	                                    updateMessaging(true);
	
	                                    if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
	                                        // Resetting selected installment data, if installment change is not explicitly prohibited.
	                                        $scope.checkoutSession.selectedInstallmentData = undefined;
	                                    }
	                                }
	
	                                $scope.doneFn(result);
	                            }
	                        },
	                        contingencies: {
	                            NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
	                                if (result && result.resolution) {
	                                    var card = result.resolution.data;
	
	                                    if (card.fundingId && card.fi && card.fi.type) {
	                                        $scope.cardModel.id = card.fundingId;
	                                        $scope.cardModel.card = new _index2.$CardModel({
	                                            number: 'xxxx-xxxx-xxxx-' + card.fi.number,
	                                            type: card.fi.type.toUpperCase(),
	                                            productType: card.fi.productType
	                                        });
	                                    }
	                                }
	
	                                _uiRouter.$state.go('.confirmUpop');
	                            }
	                        }
	                    });
	                };
	
	                $scope.shouldShowFSTile = function (fundingsource) {
	                    var showFS = true;
	
	                    if ($scope.isPadToggleFeatureApplicable()) {
	                        // If PAD is not the current plan, then we will not show any PAD plan and show IACH plans.
	                        // If PAD is the current plan, then we will visualize it as a bank plan and IACH plan without balance for corresponding bank will not be shown
	                        if (!$scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'PAD') {
	                            showFS = false;
	                        } else if ($scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'PAD' && fundingsource.planId !== $scope.checkoutSession.plan.id) {
	                            showFS = false;
	                        } else if ($scope.isCurrentPlanPad && fundingsource.primaryFs && fundingsource.primaryFs.subtype === 'IACH' && fundingsource.primaryFs.id === $scope.checkoutSession.plan.sources[0].instrument_id && !fundingsource.secondaryFIs) {
	                            showFS = false;
	                        }
	                    }
	
	                    return showFS;
	                };
	            });
	        },
	        populate: function populate() {
	            // Check if is variant where preferred label can be shown
	            var preferredFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];
	
	            this.preferredFiVariant = preferredFiVariants.indexOf(this.models.choiceVariant) > -1;
	        }
	    }
	});
	
	
	_uiRouter.$state;
	
	_uiRouter.$stateParams;
	
	_squid.$Component;
	
	_squid.$populate;
	
	_squid.$FallbackError;
	
	_squid.$feature;
	
	_squid.$locale;
	
	_squid.$pxp;
	
	_squid.$util;
	
	_squid.$config;
	
	_squid.$renderContent;
	
	_logger.$logger;
	
	_choice.$ChoiceEligibility;
	
	_index.$CheckoutSessionModel;
	
	_index.$CheckoutCartModel;
	
	_index.$CheckoutAppDataModel;
	
	_index.$CreditOptionsModel;
	
	_index.$CheckoutPayeeModel;
	
	_index2.$AddCardModel;
	
	_index2.$CardModel;
	
	_index3.$CreditDataModel;
	
	_index3.$CreditInstallmentModel;
	
	_index4.$AuthModel;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-wallet/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-aside-header ng-if=\"showManageLink\" hdrtype='tall' heading='asideHeader.fundingInstruments'\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'\n                 sub-header-left=\"asideHeader.add\"\n                 sub-header-left-icon=\"true\"\n                 sub-header-right-link='checkout.review.sidebar.sidebarManageWallet'\n                 sub-header-right=\"asideHeader.manage\"\n                 sub-header-right-icon=\"true\"\n                 show-dual-fi=\"showDualFi\"></xo-aside-header>\n<xo-aside-header hdrtype='tall' heading='asideHeader.fundingInstruments'\n                 ng-if=\"!showManageLink\"\n                 sub-header-left-link='checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'\n                 sub-header-left=\"asideHeader.add\"\n                 sub-header-left-icon=\"true\"\n                 show-dual-fi=\"showDualFi\"></xo-aside-header>\n<div class=\"asideContent fundingCards\" id=\"selectFunding\" content xo-tray-height>\n    <div class=\"split_bal_option\" ng-if=\"balanceList.length\">\n        <div\n            class=\"sCheckbox checkbox\"\n            ng-repeat=\"balance in balanceList\">\n            <input\n                id=\"bal_{{balance.code}}\"\n                type=\"checkbox\"\n                ng-model=\"balance.checked\"\n                value=\"{{balance.code}}\">\n            <label\n                class=\"choice-split-balance\" for=\"bal_{{balance.code}}\"\n                bind-html-compile=\"htmlContent('memberReview.useBalanceLabel', { amt: balance.amount })\">\n            </label>\n        </div>\n    </div>\n    <div class=\"allCards\">\n        <ul\n            ng-class=\"{varSelectFi: isSelectFiVariant}\"\n            class=\"allPlanList clearfix\"\n            select-box=\"checkoutSession.fundingOptions.plans\"\n            select-allow-tab-escape>\n            <!--Disallowed Preferred Instrument-->\n            <li ng-if=\"disallowedPreferredInstrument && !isBillingNoPurchase\" class=\"fundingsource\">\n                <a href=\"#\" prevent-default class=\"source\" role=\"button\">\n                    <div class=\"disallowedContainer\">\n                        <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"disallowedPreferredInstrument.isPinlessDebit\"></span>\n                        <span class=\"fsIcon\" ng-class=\"[disallowedPreferredInstrument.type, disallowedPreferredInstrument.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                        <p class=\"fsdetails\">\n                            <span ng-if=\"disallowedPreferredInstrument.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                            <span ng-if=\"!disallowedPreferredInstrument.isPinlessDebit\">{{content('fsMappings.'+disallowedPreferredInstrument.name) || disallowedPreferredInstrument.name}}</span>\n                            <span class=\"lastdigits\" ng-if=\"disallowedPreferredInstrument.lastDigits\">x-{{disallowedPreferredInstrument.lastDigits}}\n                                <span class=\"subtype\" ng-if=\"locale.country === 'DE' && disallowedPreferredInstrument.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                <span class=\"subtype\" ng-if=\"locale.country === 'DE' && disallowedPreferredInstrument.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                <span class=\"subtype\" ng-if=\"disallowedPreferredInstrument.subtype === 'ECHECK'\">{{content('fundingInstruments.eCheck')}}</span>\n                            </span>\n                        </p>\n                        <span class=\"infoIcon\" ng-click=\"toggleDisallowedMessage()\"></span>\n\n                    </div>\n                    <div ng-class=\"{showMsg: showDisallowedMessage}\">\n                        <p class=\"infoMsg\">\n                            {{content('wallet.'+disallowedPreferredInstrument.declineReason)}}\n                        </p>\n                    </div>\n                </a>\n            </li>\n\n            <!--List of Plans : selectFi variant-->\n            <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in primaryList\" ng-if=\"isSelectFiVariant && !isBillingNoPurchase && shouldShowFSTile(plan)\">\n                <a track-submit href=\"#\" prevent-default class=\"source\" ng-click=\"updateFS($index)\" role=\"button\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !plan.infoMsg}\" select-option=\"plan.selected\" focus-when=\"plan.selected\" ng-attr-aria-selected=\"{{ plan.selected ? 'true' : undefined }}\">\n\n                    <span class=\"checkIcon\" ng-if=\"plan.selected\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                    <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable()\">\n                        <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                        <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                        <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                            <span>\n                                <span class=\"fsName\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                <div class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                    <span class=\"subtype\" ng-if=\"locale.country === 'DE'\">{{content('fundingInstruments.iach')}}</span>\n                                </div>\n                            </span>\n                        </p>\n                    </div>\n                    <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"!(plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable())\">\n                        <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                        <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                        <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                            <span ng-switch=\"plan.primaryFs.subtype\">\n                                <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                    <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span><br>\n                                    <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}}</span>\n                                    <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                    <span ng-if=\"!isBilling && plan.primaryFs.isPreferred && preferredFiVariant && plan.primaryFs.subtype !== 'PAD'\" class=\"preferredLabel\">\n                                        ({{ content('memberReview.preferred') }})\n                                    </span>\n                                </span>\n                                <span ng-switch-default>\n                                    <span class=\"fsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                    <span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                    <span ng-if=\"!isSelectFiVariant && plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.primaryFs.amount.currency_code}})</span>\n                                    <span ng-if=\"isSelectFiVariant && plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.currencies}})</span>\n                                    <div class=\"lastdigits\" ng-if=\"plan.primaryFs.subtype !== 'PAD'\">\n                                        <span ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                        <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                        <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                        <span class=\"subtype\" ng-if=\"plan.primaryFs.subtype === 'ECHECK'\">{{content('fundingInstruments.eCheck')}}</span>\n                                        <span ng-if=\"!isBilling && plan.primaryFs.isPreferred && preferredFiVariant && plan.primaryFs.subtype !== 'PAD'\" class=\"preferredLabel\">\n                                            ({{ content('memberReview.preferred') }})\n                                        </span>\n                                    </div>\n                                </span>\n                            </span>\n                            <span ng-if=\"!isMorsPxpEnabled && sacEligible(plan.primaryFs.name)\">\n                                <span class=\"bmlDetails\" bind-html-compile=\"htmlContent('fundingInstruments.bmlDetailsWallet')\"></span>\n                            </span>\n                            <span ng-if=\"!plan.primaryFs.isPinlessDebit && plan.primaryFs.name === 'BILL_ME_LATER'\">\n                                <xo-reuse-offer token=\"token\" promotion=\"promotion\"\n                                    bmlaction=\"bmlaction\" installment=\"installment\"\n                                    selectedmethod=\"selectedmethod\">\n                                </xo-reuse-offer>\n                            </span>\n                        </p>\n                    </div>\n                </a>\n            </li>\n\n            <!--List of Plans : control-->\n            <li role=\"presentation\" class=\"fundingsource\" ng-repeat=\"plan in primaryList\" ng-if=\"!isSelectFiVariant && !isBillingNoPurchase && shouldShowFSTile(plan)\">\n                <a track-submit href=\"#\" prevent-default class=\"source\" ng-click=\"updateFS(plan, $index)\" role=\"button\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !plan.infoMsg}\" select-option=\"plan.selected\" focus-when=\"plan.selected\" ng-attr-aria-selected=\"{{ plan.selected ? 'true' : undefined }}\">\n\n                    <span class=\"checkIcon\" ng-if=\"plan.selected\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                    <div class=\"instrumentContainer\" ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length\">\n                        <p class=\"fsdetails\" ng-class=\"[plan.secondaryFIs[0].type]\">\n                            <span class=\"fsIcon\" ng-class=\"[plan.secondaryFIs[0].type, plan.secondaryFIs[0].name]\"></span>\n                            <span class=\"fsName\">{{content('fsMappings.'+ plan.secondaryFIs[0].name) || plan.secondaryFIs[0].name}}</span>\n                            <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1\">: </span>\n                            <span class=\"amount\" ng-if=\"plan.secondaryFIs.length === 1 && plan.secondaryFIs[0].amount\">{{plan.secondaryFIs[0].amount.amount_formatted}}</span>\n                        </p>\n                    </div>\n                    <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable()\">\n                        <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                        <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                        <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                            <span>\n                                <span class=\"fsName\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                    <span class=\"subtype\" ng-if=\"locale.country === 'DE'\">{{content('fundingInstruments.iach')}}</span>\n                                </span>\n                            </span>\n                        </p>\n                    </div>\n                    <div class=\"instrumentContainer\" ng-class=\"{singleInstrumentContainer: !plan.secondaryFIs}\" ng-if=\"!(plan.primaryFs.subtype === 'PAD' && plan.selected && isPadToggleFeatureApplicable())\">\n                        <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"plan.primaryFs.isPinlessDebit\"></span>\n                        <span class=\"fsIcon\" ng-class=\"[plan.primaryFs.type, plan.primaryFs.name]\" ng-if=\"!plan.primaryFs.isPinlessDebit\"></span>\n                        <p class=\"fsdetails\" ng-class=\"[plan.primaryFs.type]\">\n                            <span ng-switch=\"plan.primaryFs.subtype\">\n                                <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                    <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span><br>\n                                    <span class=\"name\">{{content('fsMappings.'+plan.primaryFs.name) || plan.primaryFs.name}}</span>\n                                    <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}</span>\n                                </span>\n                                <span ng-switch-default>\n                                    <span class=\"fsName\" ng-if=\"plan.primaryFs.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                    <!--<span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\" ng-bind-html=\"content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name + '&#8207;').toString()\"></span>-->\n                                    <span class=\"fsName\" ng-if=\"!plan.primaryFs.isPinlessDebit\">{{content('fsMappings.'+plan.primaryFs.name) || (plan.primaryFs.name)}} &rlm;</span>\n                                    <span ng-if=\"plan.primaryFs.name === 'BALANCE' && isMultipleBalance\">({{plan.primaryFs.amount.currency_code}})</span>\n                                    <span class=\"lastdigits\" ng-if=\"plan.primaryFs.lastDigits\">x-{{plan.primaryFs.lastDigits}}\n                                        <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'MEFT'\">{{content('fundingInstruments.meft')}}</span>\n                                        <span class=\"subtype\" ng-if=\"locale.country === 'DE' && plan.primaryFs.subtype === 'IACH'\">{{content('fundingInstruments.iach')}}</span>\n                                        <span class=\"subtype\" ng-if=\"plan.primaryFs.subtype === 'ECHECK'\">{{content('fundingInstruments.eCheck')}}</span>\n                                    </span>\n                                    <span class=\"colon\" ng-if=\"plan.secondaryFIs.length === 1 && plan.primaryFs.type !== 'INCENTIVE'\">: </span>\n                                </span>\n                            </span>\n                            <span class=\"amount\" ng-if=\"plan.secondaryFIs && plan.secondaryFIs.length === 1 && plan.primaryFs.amount && plan.primaryFs.type !== 'INCENTIVE'\">{{plan.primaryFs.amount.amount_formatted}}</span>\n                            <span ng-if=\"!isBilling && plan.primaryFs.isPreferred && !plan.secondaryFIs && preferredFiVariant\" class=\"preferredLabel\">\n                                <br>\n                                ({{ content('memberReview.preferred') }})\n                            </span>\n                            <span ng-if=\"!isMorsPxpEnabled && sacEligible(plan.primaryFs.name)\">\n                                <span class=\"bmlDetails\" bind-html-compile=\"htmlContent('fundingInstruments.bmlDetailsWallet')\"></span>\n                            </span>\n                            <span ng-if=\"!plan.primaryFs.isPinlessDebit && plan.primaryFs.name === 'BILL_ME_LATER'\">\n                                <xo-offer token=\"token\" promotion=\"promotion\"\n                                    bmlaction=\"bmlaction\" installment=\"installment\"\n                                    selectedmethod=\"selectedmethod\" reusetext=\"true\">\n                                </xo-offer>\n                            </span>\n                        </p>\n                    </div>\n                </a>\n            </li>\n\n\n            <li role=\"presentation\" class=\"fundingsource fs-item\" ng-repeat=\"stickyFI in checkoutSession.futurePaymentInstruments\" ng-if=\"isBillingNoPurchase\">\n                <a class=\"source\" href=\"#\" ng-click=\"updateStickyFS(stickyFI)\" select-option role=\"button\"\n                    ng-attr-aria-selected=\"{{ (stickyFI.instrument_id===userSelectedFI) ? 'true' : undefined }}\"\n                    focus-when=\"stickyFI.instrument_id===userSelectedFI\">\n                    <div class=\"instrumentContainer singleInstrumentContainer\">\n                        <span class=\"fsIcon\" ng-class=\"[stickyFI.type, stickyFI.name, stickyFI.card_type]\"></span>\n                        <p class=\"fsdetails\">\n                            <span ng-switch=\"fundingsource.subtype\">\n                                <span ng-switch-default>\n                                    <span class=\"name\">{{content('fsMappings.'+ stickyFI.name) || stickyFI.name}}</span>\n                                    <div class=\"lastdigits\" ng-if=\"stickyFI.last4\">x-{{stickyFI.last4}}</div>\n                                </span>\n                            </span>\n                        </p>\n                    </div>\n                    <span class=\"checkIcon\" ng-if=\"stickyFI.instrument_id===userSelectedFI\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n\n            <!-- Begin MORS PXP treatment -->\n\n            <li role=\"presentation\" ng-if=\"isMorsPxpEnabled && banner.bodyText && (installment.showWalletBanner || showBML())\"\n                class=\"plusLink creditBanner\">\n                <form class=\"bmlAsideOffer\">\n                    <div class=\"fundingContainerBml\">\n                        <div id=\"bmlAcqOfferPassive\" class=\"payWithOption\">\n                            <span class=\"plusicon\" ng-click=\"bml()\" role=\"button\"></span>\n                            <div class=\"payWithOptionBody\">\n                                <div class=\"payWithOptionIcon\" ng-click=\"bml()\" role=\"button\">\n                                    <span class=\"fsIcon BILL_ME_LATER\" ng-if=\"useFallbackBanner\"></span>\n                                    <img src=\"{{banner.logo}}\" ng-if=\"!useFallbackBanner\" />\n                                </div>\n                                <div class=\"payWithOptionContent\">\n                                    <div><a link-button ng-click=\"bml()\" class=\"name proceed\" ng-bind-html=\"banner.ctaText\" link-button></a></div>\n                                    <div><span class=\"payWithOptionDetails\" ng-bind-html=\"banner.bodyText\"></span></div>\n                                    <div>\n                                        <span class=\"payWithOptionTerms\" ng-bind-html=\"banner.termsText\"></span>\n                                        <a href=\"{{banner.termsLink}}\" class=\"popup payWithOptionTermsLink\" target='_blank'\n                                           ng-bind-html=\"banner.termsLinkText\"></a>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </li>\n\n            <!-- // End MORS PXP treatment -->\n\n            <!-- Begin MORS PXP control -->\n\n            <li role=\"presentation\" ng-if=\"!isMorsPxpEnabled && showBML()\"\n                class=\"trayInner trayInnerDefault offerTile creditBanner\">\n                <form class=\"bmlAsideOffer\">\n                    <div class=\"fundingContainerBml\">\n                        <div>\n                            <div class=\"creditIcon\"></div>\n                            <a style=\"width:auto;cursor:pointer;\" ng-click=\"bml()\" id=\"bmlApplyLink\" class=\"bmlApply\" link-button>{{content('offers.bmlOfferBtn')}}</a>\n                            <div class=\"clearfix\"></div>\n                        </div>\n                        <div class=\"smallOffer\">\n                            <p class=\"bmlTitle\" ng-bind-html=\"installment.bmlOfferTitle\"></p>\n                            <div class=\"seeTermsLink fundingContainerBmlOffer disclaimer\">\n                                {{content('applyForBml.subjectApproval')}}\n                                <a ng-click=\"$event.stopPropagation()\" href='https://www.securecheckout.billmelater.com/paycapture-content/fetch?hash=AU826TU8&content=/bmlweb/bmlppaiw.html' class='popup bmlTermsLink' target='_blank' xo-popup>{{content('applyForBml.seeTerms')}}</a>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </li>\n\n            <li role=\"presentation\" ng-if=\"!isMorsPxpEnabled && installment.showWalletBanner && locale.country !== 'GB'\"\n                class=\"trayInner trayInnerDefault editable offerTile\" ng-click=\"creditOffer()\">\n                <form class=\"bmlAsideOffer\">\n                    <div class=\"fundingContainerBml\">\n                        <div>\n                            <div class=\"creditIcon\"></div>\n                            <div class=\"clearfix\"></div>\n                        </div>\n                        <div>\n                            <div class=\"creditOffer\" ng-if=\"locale.country !== 'GB'\" class=\"proceed\"\n                               select-option ng-bind-html=\"htmlContent('offers.bmlOfferSmallTitle')\"></div>\n                            <div class=\"cycoApplyLink\">\n                                <a link-button ng-click=\"creditOffer()\" class=\"proceed\">{{content('offers.cycoOfferBtn')}}\n                                    <span class=\"frontArrow goTray\"></span>\n                                </a>\n                            </div>\n                        </div>\n                        <div class=\"fundingContainerBmlOffer disclaimer clearfix\"\n                                  bind-html-compile=\"htmlContent('applyForBml.subjectApproval')\">\n                        </div>\n                    </div>\n                </form>\n            </li>\n\n            <li role=\"presentation\" ng-if=\"showBannerinWallet()\"\n                class=\"trayInner trayInnerDefault editable offerTile\" ng-click=\"creditOffer()\">\n                <form class=\"bmlAsideOffer\">\n                    <div class=\"fundingContainerBml\">\n                        <div>\n                            <div class=\"creditOffer\" ng-if=\"showInstallmentBannerContent\" ng-click=\"creditOffer()\"\n                                 class=\"proceed\"\n                               select-option>{{content('offers.bmlWalletTitleInstallments')}}</div>\n                            <div class=\"creditOffer\" ng-if=\"showBannerContent\" ng-click=\"creditOffer()\"\n                                class=\"proceed\"\n                                select-option>{{content('offers.bmlWalletTitle')}}</div>\n                            <div class=\"cycoApplyLink\">\n                                <a link-button ng-click=\"creditOffer()\" class=\"proceed apply_uk_credit\">{{content('offers.bmlOfferBtn')}}\n                                    <span class=\"frontArrow goTray\"></span>\n                                </a>\n                            </div>\n                        </div>\n                        <div class=\"fundingContainerBmlOffer disclaimer clearfix\"\n                                  bind-html-compile=\"htmlContent('applyForBml.subjectApproval')\">\n                        </div>\n                    </div>\n                </form>\n            </li>\n\n            <!-- // End MORS PXP control -->\n\n            <!-- Gift Card link offer -->\n            <!-- changes for the coupon remdeem -->\n            <li role=\"presentation\" ng-if=\"showGC\" class=\"fundingsource redeemGC\" ng-click=\"onRedeemGC()\">\n                <p class=\"addOption\">\n                    <span>\n                        <a ng-click=\"onRedeemGC()\" class=\"proceed\" select-option> {{ content('memberReview.redeemGiftLink') }} {{ content('memberReview.giftCardDec') }}</a>\n                    </span>\n                </p>\n            </li>\n\n            <li role=\"presentation\" ng-if=\"showPlcc\" class=\"trayInner trayInnerDefault editable offerTile\"\n                ng-click=\"addPlcc()\">\n                <form class=\"bmlAsideOffer\">\n                    <div class=\"fundingContainerPlcc\">\n                        <div class=\"plccOfferHeader\">\n                            <img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n                            <p class=\"headerText\"> {{ content('memberReview.plccCardOfferHeader',{merchantName:promotion.name}) }}</p>\n                            <p class=\"plccOfferDesc\">{{ content('memberReview.plccCardOfferDesc',{merchantName:promotion.name})}}</p>\n                        </div>\n\n                    </div>\n                    <input type=\"hidden\" name=\"_csrf\" value=\"{data._csrf}\"/>\n                </form>\n            </li>\n        </ul>\n    </div>\n\n    <ui-view></ui-view>\n\n</div>\n"

/***/ },

/***/ "./pages/xo-wallet/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-wallet/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-wallet/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#selectFunding .infoIcon{background-position:-139px -1px;top:26px;right:12px}#selectFunding.asideContent{clear:both}#selectFunding .items{margin:0;width:100%;list-style:none}#selectFunding .items .addBtnItem{margin:0;padding:20px 10px;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}#selectFunding .items .addBtnItem:focus,#selectFunding .items .addBtnItem:hover{background-color:#f7f9fa}#selectFunding .address:after{content:\"\";width:100%;display:block;position:absolute;bottom:-2px;left:0}#selectFunding .backArrowContainer{margin-left:41px}#selectFunding .display .adr{margin-top:3px;color:#6c7378;font-weight:lighter;font-size:.85em;width:90%}#selectFunding .secondHalf{float:right}#selectFunding .review{float:left;width:65%}#selectFunding .editCard{font-size:1em}#selectFunding .add{cursor:pointer;display:block}#selectFunding .add:hover{text-decoration:none}#selectFunding .add .btn{display:inline-block;vertical-align:middle;width:29px;height:29px;background:url(https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_flat.png) 7px -895px no-repeat}#selectFunding .fundingContainerPAD .lastdigits,#selectFunding .fundingContainerPAD .name{color:#6c7378;font-size:.9em;margin-bottom:0;margin-left:0!important}#selectFunding .checkIcon{width:24px;height:17px;display:inline-block;position:absolute;top:40%;right:11px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-192px -2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectFunding .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectFunding .addAddressContent{width:73%;display:inline-block;vertical-align:middle;color:#0070ba;font-weight:400}#selectFunding .addAddressContent:focus,#selectFunding .addAddressContent:hover{text-decoration:underline}#selectFunding .addIcon{display:inline-block;width:20px;height:20px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#selectFunding .addIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#selectFunding .bmlAsideOffer{padding:15px 10px}#selectFunding .bmlAsideOffer .payWithOption{margin:0}#selectFunding .offerTile{background-color:#f7f9fa}#selectFunding .fundingContainerBml{padding-left:5px;position:relative;min-height:35px}#selectFunding .fundingContainerBmlOffer{font-size:11px;line-height:1.15em;padding-top:10px;display:block}#selectFunding .bmlTitle{display:inline-block;width:65%;font-size:1em;margin-bottom:5px}#selectFunding .bmlApply{display:inline-block;float:right;width:35%;font-size:.85em;text-align:right}#selectFunding .seeTermsLink{font-size:.75em;margin-top:10px}#selectFunding .fundingContainerPlcc{cursor:pointer;position:relative;min-height:35px}#selectFunding .fundingContainerPlcc .p{margin-left:30px}#selectFunding .redeemGC{margin-top:0;cursor:pointer}#selectFunding .bmlTermsLink{color:#0079ad}#selectFunding .bmlTermsLink:focus,#selectFunding .bmlTermsLink:hover{text-decoration:underline;background-color:transparent}#selectFunding .bmlDetails{display:inline-block;width:100%;font-size:.85em;padding-top:0}#selectFunding .plccAddNowLink{cursor:pointer;position:absolute;top:2px;right:0;font-size:.85em}#selectFunding .plccOfferDesc{margin-top:3px;font-size:.68em;color:#666}#selectFunding .headerText,#selectFunding .plccOfferDesc{margin-left:40px;margin-bottom:0}#selectFunding .fsIcon{float:left;position:inherit}#selectFunding .plccInstIcon{float:left;display:inline-block;height:20px;top:22px;left:15px;background:none;width:25px}#selectFunding .fsIcon.PLCC{background-image:none}#selectFunding #bmlApplyLink{line-height:1.75em}#selectFunding .creditOffer{display:inline-block;width:70%;line-height:1.33em;font-size:15px}#selectFunding .cycoApplyLink{font-size:13px;text-align:right;color:#0070ba}#selectFunding .varSelectFi .source .lastdigits,#selectFunding .varSelectFi .source .preferredLabel{font-size:.9em;color:#666}#selectFunding .varSelectFi .source .lastdigits{margin-left:40px}#selectFunding .split_bal_option{margin:1em 10px;padding:1em 1em .6em;color:#000;background:#f1f4f5}#selectFunding .split_bal_option label{cursor:pointer}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-sidebar-manage-wallet/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-sidebar-manage-wallet/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Route.extend('$SidebarManageWalletRoute', {
	
	    path: 'sidebarManageWallet',
	    directive: _directive2['default'],
	    trackingData: {
	        fptiState: 'manage_wallet',
	        templateName: 'tray/manageWallet',
	        pageGoal: 'Manage Instruments',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-manage-wallet',
	                'pagename2': '%::fullpage-manage-wallet:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	        }
	    },
	    loginRequired: true,
	    children: []
	});
	
	
	_squid.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidebar-manage-wallet/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _choice = __webpack_require__("./components/xo-models/src/choice/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-tray-height/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/popup/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	var _template = __webpack_require__("./pages/xo-sidebar-manage-wallet/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-sidebar-manage-wallet/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$SidebarManageWalletDirective', {
	
	    tag: 'xo-manage-wallet',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        showInfoMsg: function showInfoMsg($index) {
	            this.disallowedIndex = $index;
	        },
	        confirm: function confirm($index) {
	            this.selectedIndex = $index;
	            this.deleteCard = true;
	        },
	        deleteFS: function deleteFS(fundingsource) {
	            var _this = this;
	
	            /* Call walletfiserv to delete selected card and call Symphony's notifyChangeFundingInstruments api
	             to get back updated funding options.
	             */
	            this.deleteCardModel = new _index.$DeleteCardModel({
	                id: fundingsource.id
	            });
	            this.deleteCardModel.save({
	                data: this.deleteCardModel,
	
	                contingencies: {
	                    DELETE_CARD_CONTINGENCY: function DELETE_CARD_CONTINGENCY() {
	                        _this.handleSingleContingency('creditcard.errorDeleteCard');
	                        return;
	                    }
	                },
	
	                error: function error() {
	                    _this.handleSingleContingency('creditcard.errorDeleteCard');
	                    return;
	                },
	
	                /* Call notifyChangeFundingInstruments to get updated funding options from checkout session
	                 During this call if any error or contignecies return back, just remove the deleted FI from checkout
	                 session as its already deleted successfully
	                 */
	
	                success: function success() {
	                    _this.models.checkoutSession.fundingOptions.action('notifyChange', {
	                        resultModel: _this.models.checkoutSession,
	
	                        data: {
	                            planId: fundingsource.id,
	                            operation: 'REMOVED'
	                        },
	                        success: function success() {
	                            _logger.$logger.info('manage_wallet: deleted FI - 1', fundingsource.id);
	                            _this.selectedIndex = -1;
	                            _this.disallowedIndex = -1;
	                        },
	                        contingencies: {
	                            NOTIFY_FUNDING_CHANGE_CONTINGENCY: function NOTIFY_FUNDING_CHANGE_CONTINGENCY() {
	                                _this.removeFIFromCheckoutSession(fundingsource);
	                                return;
	                            }
	                        },
	                        error: function error() {
	                            _this.removeFIFromCheckoutSession(fundingsource);
	                            return;
	                        }
	                    });
	                }
	            });
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            var _this2 = this;
	
	            this.models.checkoutSession.reload()
	            // Check the choice experiment variant after reloading the checkout session
	            // If multipleFi variant, then need to modify the UI
	            .then(function () {
	                return _choice.$ChoiceEligibility.instance().getVariant(_this2.props.token);
	            }).then(function (variant) {
	                var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];
	
	                if (multipleFiVariants.indexOf(variant) !== -1) {
	                    _this2.showMultipleFI = true;
	                }
	            });
	
	            if (this.models.checkoutSession) {
	                this.message = this.models.checkoutSession.message;
	                this.isSysmtemError = this.message && this.message.type === 'error';
	                this.models.checkoutSession.message = null;
	            }
	        },
	        enter: function enter() {
	            this.locale = _squid.$locale;
	            this.doneFn = function (result) {
	                _uiRouter.$state.go('checkout.review');
	            };
	
	            this.handleSingleContingency = function (errorKey) {
	                var messages = [];
	
	                messages.push(_squid.$locale.content.get(errorKey));
	
	                this.message = {
	                    msgs: messages,
	                    type: 'error'
	                };
	                this.isSysmtemError = true;
	                this.selectedIndex = -1;
	                this.disallowedIndex = -1;
	            };
	
	            this.removeFIFromCheckoutSession = function (fundingsource) {
	                this.models.checkoutSession.fundingOptions.instruments = this.models.checkoutSession.fundingOptions.instruments.filter(function (item) {
	                    return item.id !== fundingsource.id;
	                });
	            };
	        }
	    }
	});
	
	
	_uiRouter.$state;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$config;
	
	_logger.$logger;
	
	_choice.$ChoiceEligibility;
	
	_index.$DeleteCardModel;
	
	_index2.$CheckoutSessionModel;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidebar-manage-wallet/template.html":
/***/ function(module, exports) {

	module.exports = "<xo-aside-header ng-if=\"!showMultipleFI\" heading='asideHeader.manageWallet'\n                 back-url='checkout.review.sidebar.wallet'></xo-aside-header>\n<xo-aside-header ng-if=\"showMultipleFI\"  heading='asideHeader.manageWallet'></xo-aside-header>\n\n    <div class=\"asideContent fundingCards\" id=\"manageFunding\" content xo-tray-height>\n        <xo-message message=\"message\"></xo-message>\n        <div class=\"allCards\">\n            <ul class=\"allFundingInstrumentsList clearfix\" select-box=\"models.checkoutSession.fundingOptions.instruments\" select-allow-tab-escape>\n                <li role=\"presentation\" class=\"fundingsource item\" ng-repeat=\"fundingsource in models.checkoutSession.fundingOptions.instruments\" ng-if=\"!isBillingNoPurchase\">\n                    <div class=\"source\" ng-class=\"{showMsg: ($index == disallowedIndex), noInfoMsg: !fundingsource.editDisallowedMsg}\">\n                        <div ng-class=\"{'rowMask':fundingsource.editDisallowedMsg, slide: ($index == selectedIndex && deleteCard)}\">\n                            <span class=\"fsIcon pinlessIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fundingsource.isPinlessDebit\"></span>\n                            <span class=\"fsIcon\" ng-class=\"[fundingsource.type, fundingsource.name]\" ng-if=\"!fundingsource.isPinlessDebit\">\n                                <img class=\"plccInstIcon\" ng-src=\"{{fundingsource.productUrl}}\" ng-show=\"fundingsource.type === 'PLCC'\">\n                            </span>\n                            <p class=\"fsdetails\">\n                                <span ng-switch=\"fundingsource.subtype\">\n                                    <span class=\"fundingContainerPAD\" ng-switch-when=\"PAD\">\n                                        <span class=\"subtype\">{{content('fundingInstruments.pad')}}</span>\n                                        <span class=\"name\">{{content('fsMappings.'+fundingsource.name) || fundingsource.name}}</span>\n                                        <span class=\"lastdigits\" ng-if=\"fundingsource.lastDigits\">x-{{fundingsource.lastDigits}}</span>\n                                    </span>\n                                    <span ng-switch-default>\n                                        <span class=\"name\" ng-if=\"fundingsource.isPinlessDebit\">{{content('fsMappings.PINLESSDEBIT')}}</span>\n                                        <span class=\"name\" ng-if=\"!fundingsource.isPinlessDebit\">{{content('fsMappings.'+fundingsource.name) || fundingsource.name}}</span>\n                                        <span class=\"lastdigits\" ng-if=\"fundingsource.lastDigits\">x-{{fundingsource.lastDigits}}</span>\n                                    </span>\n                                </span>\n                            </p>\n                        </div>\n\n                        <a ng-if=\"fundingsource.editDisallowedMsg && (disallowedIndex !== $index)\" ui-sref=\"checkout.review.sidebar.sidebarManageWallet\" ng-click=\"actions.showInfoMsg($index)\" class=\"infoIcon\" ></a>\n                        <p ng-if=\"fundingsource.editDisallowedMsg\" class=\"infoMsg\" ng-class=\"{showMsg: ($index == disallowedIndex)}\">\n                            {{content('wallet.'+fundingsource.editDisallowedMsg)}}\n                        </p>\n\n                        <div class=\"manageLinks\" ng-class=\"{slideOut: ($index == selectedIndex && deleteCard)}\" ng-if=\"!fundingsource.editDisallowedMsg &&  ($index !== selectedIndex) && !isSysmtemError \">\n                            <a track-submit=\"update_card\" ui-sref='checkout.review.sidebar.sidebarUpdateCard.addCardFlow.addCard({planId: fundingsource.id})' class=\"updateButton\">\n                                <span>{{content('wallet.update')}}</span>\n                            </a>\n                            <span class=\"vertical\"></span>\n                            <a href=\"\" link-button class=\"deleteButton\" ng-click=\"actions.confirm($index)\">{{content('wallet.delete')}}</a>\n                        </div>\n                        <div ng-class=\"{slideIn: ($index == selectedIndex && deleteCard)}\" class=\"confirm\" ng-if=\"!fundingsource.editDisallowedMsg && ($index === selectedIndex) && !isSysmtemError\">\n                            <a href=\"\" link-button track-submit=\"delete_card\" class=\"confirmButton\" ng-click=\"actions.deleteFS(fundingsource)\">{{content('common.confirm')}}</a>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n\n\n"

/***/ },

/***/ "./pages/xo-sidebar-manage-wallet/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-sidebar-manage-wallet/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-sidebar-manage-wallet/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#manageFunding .item{margin:0;position:relative;max-height:200px;overflow:hidden;border-bottom:1px solid #e3e3e3;-webkit-transition:max-height .5s ease;transition:max-height .5s ease}#manageFunding .infoIcon{background-position:-139px -1px;top:26px;right:12px}#manageFunding .pinlessIcon{margin:18px 18px 0 8px}#manageFunding .showMsg .infoMsg{padding:0 15px 5px;position:relative;left:0;width:90%;max-height:40px}#manageFunding .rowMask{opacity:.5}#manageFunding .vertical{height:15px;overflow:visible;border-right:1px solid #ccc}#manageFunding .slide{-webkit-transform:translate(-20%);transform:translate(-20%);-webkit-transition:-webkit-transform .5s ease;transition:transform .5s ease}#manageFunding .confirm,#manageFunding .slideOut{-webkit-transform:translate(102%);transform:translate(102%);-webkit-transition:-webkit-transform .5s ease;transition:transform .5s ease}#manageFunding .confirm{font-size:.85em;display:inline-flex;position:absolute;height:100%;top:0;right:0;padding:0 15px;text-align:center;align-items:center;overflow:hidden;background-color:#009cde}#manageFunding .confirm a{font-weight:700;color:#fff}#manageFunding .slideIn{-webkit-transform:translate(0);transform:translate(0);-webkit-transition:-webkit-transform 1s ease-in-out;transition:transform 1s ease-in-out}#manageFunding .show .confirmButton{right:0;-webkit-transition:all 1s ease-in-out;transition:all 1s ease-in-out}#manageFunding .hide .confirmButton,#manageFunding .show .confirmButton{position:absolute;top:0;display:inline-block;font-size:.8em;color:#fff;border:1px solid #009cde;border-sizing:border-box;background-color:#009cde;height:100%;text-align:center;vertical-align:middle;width:87px;line-height:68px}#manageFunding .hide .confirmButton{right:-223px}#manageFunding .confirmButton:hover{text-decoration:underline;background-color:transparent}#manageFunding .deleteButton{font-size:.8em;color:#0079ad;padding:0 15px 0 10px}#manageFunding .deleteButton:hover{text-decoration:underline;background-color:transparent}#manageFunding .updateButton{font-size:.8em;color:#0079ad;padding-right:5px}#manageFunding .updateButton:hover{text-decoration:underline;background-color:transparent}#manageFunding li a{text-decoration:none;color:#292929}#manageFunding.asideContent{clear:both}#manageFunding .items{margin:0;width:100%;list-style:none}#manageFunding .items .addBtnItem{margin:0;padding:20px 10px;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}#manageFunding .items .addBtnItem:focus,#manageFunding .items .addBtnItem:hover{background-color:#f7f9fa}#manageFunding .address:after{content:\"\";width:100%;display:block;position:absolute;bottom:-2px;left:0}#manageFunding .backArrowContainer{margin-left:41px}#manageFunding .display .adr{margin-top:3px;color:#6c7378;font-weight:lighter;font-size:.85em;width:90%}#manageFunding .secondHalf{float:right}#manageFunding .review{float:left;width:65%}#manageFunding .editCard{font-size:1em}#manageFunding .add{cursor:pointer;display:block}#manageFunding .add:hover{text-decoration:none}#manageFunding .add .btn{display:inline-block;vertical-align:middle;width:29px;height:29px;background:url(https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_flat.png) 7px -895px no-repeat}#manageFunding .plusicon{left:19px}#manageFunding .fundingContainerPAD .name{color:#6c7378;font-size:.85em;margin-bottom:0}#manageFunding .checkIcon{width:24px;height:17px;display:inline-block;position:absolute;top:40%;right:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-192px -2px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#manageFunding .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#manageFunding .addAddressContent{width:73%;display:inline-block;vertical-align:middle;color:#0070ba;font-weight:400}#manageFunding .addAddressContent:focus,#manageFunding .addAddressContent:hover{text-decoration:underline}#manageFunding .addIcon{display:inline-block;width:20px;height:20px;vertical-align:middle;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#manageFunding .addIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#manageFunding .fundingContainerPlcc{cursor:pointer;position:relative;min-height:35px}#manageFunding .fundingContainerPlcc .p{margin-left:30px}#manageFunding .plccAddNowLink{cursor:pointer;position:absolute;top:2px;right:0;font-size:.85em}#manageFunding .plccOfferDesc{margin-top:3px;font-size:.68em;color:#666}#manageFunding .headerText,#manageFunding .plccOfferDesc{margin-left:40px;margin-bottom:0}#manageFunding .fsIcon{float:left;position:inherit}#manageFunding .plccInstIcon{float:left;display:inline-block;height:20px;top:22px;left:15px;background:none;width:25px}#manageFunding .fsIcon.PLCC{background-image:none}#manageFunding .manageLinks{position:absolute;top:25px;right:0}#manageFunding .leftIcon{display:inline-block;float:left;width:10px;margin:4px 6px 0 0;background-position:-180px -180px}#manageFunding .leftIcon,#manageFunding .rightIcon{height:10px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v12.png\");background-repeat:no-repeat}#manageFunding .rightIcon{float:right;width:6px;margin:4px 0 0 6px;background-position:-200px -180px}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-sidebar-update-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	__webpack_require__("./pages/xo-sidebar-update-card/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-bank/route.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	exports['default'] = _squid.$Route.extend('$SidebarUpdateCardRoute', {
	
	    params: {
	        planId: null
	    },
	    path: 'sidebarUpdateCard',
	    directive: 'xo-sidebar-update-card',
	    titleContent: 'asideHeader.updateCard',
	    trackingData: {
	        templateName: 'tray/updateCard.dust',
	        pageGoal: 'update Card',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-update-cc',
	                'pagename2': '%::fullpage-update-cc:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            sidebar: 'sidebar',
	            'parent-callbacks': 'callbacks',
	            logout: 'logout',
	            fundingid: 'fundingid'
	        }
	    }]
	});
	
	
	_squid.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidebar-update-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidebarUpdateCardComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _template = __webpack_require__("./pages/xo-sidebar-update-card/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidebarUpdateCardComponent = exports.$xoSidebarUpdateCardComponent = _squid.$Component.extend('$xoSidebarUpdateCardComponent', {
	    tag: 'xo-sidebar-update-card',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.fundingid = _uiRouter.$stateParams.planId;
	            this.sidebar = true;
	            this.callbacks = {
	                finish: function finish() {
	                    _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
	                }
	            };
	        }
	    }
	});
	
	angular.value("$xoSidebarUpdateCardComponent", $xoSidebarUpdateCardComponent);
	_squid.$Component;
	
	_uiRouter.$state;
	
	_uiRouter.$stateParams;

/***/ },

/***/ "./pages/xo-sidebar-update-card/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside addCard\" id=\"addCard\" content>\n    <ui-view sidebar=\"sidebar\"></ui-view>\n</div>\n"

/***/ },

/***/ "./pages/xo-sidepage/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-sidepage/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	var _route = __webpack_require__("./components/xo-wallet-components/src/topup/topup-amount/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	var _route3 = __webpack_require__("./components/xo-wallet-components/src/topup/topup-funding/route.js");
	
	var _route4 = _interopRequireDefault(_route3);
	
	var _route5 = __webpack_require__("./components/xo-wallet-components/src/topup/update-pin/route.js");
	
	var _route6 = _interopRequireDefault(_route5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$SidepageRoute', {
	
	    path: 'sidepage',
	    directive: _directive2['default'],
	    children: [{
	        route: _route4['default'],
	        props: function props() {
	            return {
	                token: this.token,
	                success: this.actions.done
	            };
	        }
	    }, {
	        route: _route2['default'],
	        props: function props() {
	            return {
	                token: this.token,
	                success: this.actions.done
	            };
	        }
	    }, {
	        route: _route6['default'],
	        props: function props() {
	            return {
	                token: this.token,
	                success: this.actions.done
	            };
	        }
	    }]
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidepage/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _template = __webpack_require__("./pages/xo-sidepage/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoSidepage', {
	
	    tag: 'xo-sidepage',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            required: true,
	            type: 'var'
	        }
	    },
	
	    actions: {
	        done: function done() {
	            (0, _jquery2['default'])('body').removeClass('sidePageOpen');
	            (0, _angular.$timeout)(function () {
	                return _uiRouter.$state.go('checkout.review');
	            }, 300);
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            (0, _jquery2['default'])('body').addClass('sidePageOpen');
	        },
	        exit: function exit() {
	            this.actions.done();
	        }
	    }
	});
	
	
	_angular.$timeout;
	
	_squid.$Component;
	
	_uiRouter.$state;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-sidepage/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"sidepage\" modal-box tabindex=\"-1\">\n    <div ui-view></div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-amount/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./components/xo-wallet-components/src/topup/topup-amount/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoTopupAmountRoute', {
	    path: 'topupAmount',
	    directive: _directive2['default'],
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-amount/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _fi = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/topup/topup-amount/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/topup/topup-amount/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoTopupAmountDirective', {
	    tag: 'xo-topup-amount',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        },
	        success: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        selectAmount: function selectAmount(amount) {
	            this.models.walletPreferences.topup.amount = amount;
	            this.success();
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.topupAmounts = _squid.$config.topup.topupAmounts;
	            this.locale = _squid.$locale;
	        },
	        populate: function populate() {
	            if (this.models.walletPreferences.topup.amount && this.topupAmounts.indexOf(this.models.walletPreferences.topup.amount) === -1) {
	                this.topupAmounts.push(this.models.walletPreferences.topup.amount);
	                this.topupAmounts.sort(function (a, b) {
	                    return parseInt(a, 10) - parseInt(b, 10);
	                });
	            }
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$config;
	
	_squid.$locale;
	
	_fi.$WalletPreferences;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-amount/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"topupAmountList\" class=\"aside\" modal-box content>\n    <xo-aside-header heading='asideHeader.topupAmount'\n                     hidex=\"true\"\n                     header-left=\"common.back\"\n                     header-left-link=\"success\"\n                     header-left-icon=\"true\"></xo-aside-header>\n    <div class=\"content\">\n        <div tabindex=\"-1\" focus-when=\"true\">{{content(\"topup.topupAmountDesc\")}}</div>\n        <ul>\n            <li ng-repeat=\"amount in topupAmounts\">\n                <a class=\"listItem\" ng-click=\"actions.selectAmount(amount)\" focusable>\n                    <format-currency class=\"formatCurrency amount\" code=\"models.walletPreferences.topup.currency\"\n                                     amount=\"amount\"\n                                     currency-style=\"Currency\"></format-currency>\n                    <span class=\"checkIcon\" ng-if=\"amount === models.walletPreferences.topup.amount\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en'\">Selected</span>\n                    </span>\n                </a>\n            </li>\n        </ul>\n    </div>\n</section>\n\n"

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-amount/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/topup/topup-amount/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/topup/topup-amount/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#topupAmountList ul{margin:7px 0 0;position:relative}#topupAmountList li{cursor:pointer;list-style:none;width:99.8%;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}#topupAmountList li a:hover{background-color:#f7f9fa}#topupAmountList li a:focus{border:2px solid #009cde}#topupAmountList .checkIcon{top:26px;right:2px;width:22px;height:17px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2.png\");background-repeat:no-repeat;background-position:-66px -183px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#topupAmountList .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2_2x.png\");background-size:119px 243px}}#topupAmountList .listItem{display:block;padding:23px 0;position:relative;text-decoration:none;color:#000;border:2px solid transparent}#topupAmountList .listItem:focus{border:2px solid #009cde}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-funding/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./components/xo-wallet-components/src/topup/topup-funding/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	__webpack_require__("./pages/xo-sidepage-add-card/route.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoTopupFundingRoute', {
	    path: 'topupFunding',
	    directive: _directive2['default'],
	    children: [{
	        name: '$SidepageAddCardRoute',
	        attributes: {
	            token: 'token',
	            callbacks: 'addCardCallbacks'
	        }
	    }]
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-funding/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _fi = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/topup/topup-funding/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/topup/topup-funding/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoTopupFundingDirective', {
	    tag: 'xo-topup-funding',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        },
	        success: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        selectFundingSource: function selectFundingSource(id) {
	            if (this.models.walletPreferences.topup.fundingSource.instrument_id !== id) {
	                this.models.walletPreferences.topup.fundingSource = this.models.checkoutSession.topupFundingSources.find(function (fs) {
	                    return fs.instrument_id === id;
	                });
	                this.models.checkoutSession.action('setTopupFI', {
	                    data: {
	                        instrument_id: id
	                    },
	                    silent: true
	                });
	            }
	            this.props.success();
	        },
	        addCard: function addCard() {
	            _uiRouter.$state.go('.sidepageAddCard.addCardFlow.addCard');
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.locale = _squid.$locale;
	            this.addCardCallbacks = {
	                finish: function finish() {
	                    if (_this.models.checkoutSession.selectedTopupFundingSource) {
	                        _this.models.walletPreferences.topup.fundingSource = _this.models.checkoutSession.selectedTopupFundingSource;
	                    }
	                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
	                    (0, _angular.$timeout)(function () {
	                        return _uiRouter.$state.go('checkout.review');
	                    }, 300);
	                },
	                cancel: function cancel() {
	                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
	                    (0, _angular.$timeout)(function () {
	                        return _uiRouter.$state.go('^.^.^');
	                    }, 300);
	                }
	            };
	
	            this.instrumentIconId = function (name) {
	                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
	            };
	        }
	    }
	});
	
	
	_angular.$timeout;
	
	_uiRouter.$state;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_checkout.$CheckoutSessionModel;
	
	_fi.$WalletPreferences;
	
	_fi.$WalletInstrumentNameMapping;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-funding/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"topupFundingList\" class=\"aside\" modal-box content>\n    <xo-aside-header heading='asideHeader.topupFunding'\n                     hidex=\"true\"\n                     header-left-link=\"success\"\n                     header-left=\"common.back\"\n                     header-left-icon=\"true\"\n                     header-right=\"fundingInstruments.addDebitCard=\"\n                     header-right-link=\"'checkout.review.sidepage.topupFunding.sidepageAddCard.addCardFlow.addCard'\"\n                     header-right-icon=\"true\"></xo-aside-header>\n    <div class=\"content\">\n        <div tabindex=\"-1\" focus-when=\"true\">{{content(\"topup.topupFundingDesc\")}}</div>\n        <ul>\n            <li ng-repeat=\"fundingSource in models.checkoutSession.topupFundingSources\" focusable>\n                <a class=\"listItem noLink\" ng-click=\"actions.selectFundingSource(fundingSource.instrument_id)\">\n                    <span class=\"walletIcons\" ng-class=\"[fundingSource.type,\n                                                        instrumentIconId(fundingSource.name),\n                                                        fundingSource.card_type]\"></span>\n                    <div class=\"fsItem\">\n                        <div>{{fundingSource.name}}</div>\n                        <div>x-{{fundingSource.last4 }}</div>\n                        <span class=\"checkIcon\" ng-if=\"fundingSource.instrument_id === models.walletPreferences.topup.fundingSource.instrument_id\">\n                        <span class=\"accessAid\" ng-if=\"locale.lang === 'en' && fundingSource.instrument_id === models.walletPreferences.topup.fundingSource.instrument_id\">Selected</span>\n                    </span>\n                    </div>\n                </a>\n            </li>\n            <li>\n                <a href=\"#\" prevent-default link-button ng-click=\"actions.addCard()\" class=\"submit listItem addccLink\">\n                    <span class=\"icon\"></span>\n                    <span class=\"description\">{{content('fundingInstruments.addDebitCard')}}</span>\n                </a>\n            </li>\n        </ul>\n    </div>\n</section>\n<div ui-view></div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/topup/topup-funding/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/topup/topup-funding/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/topup/topup-funding/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#topupFundingList ul{margin:7px 0 0;position:relative;height:calc(100vh - 180px);overflow-y:auto}#topupFundingList li{cursor:pointer;list-style:none;width:99.8%;border-bottom:1px solid #e3e3e3;-webkit-transition:background-color .3s ease-in-out;transition:background-color .3s ease-in-out}#topupFundingList li a:hover{background-color:#f7f9fa}#topupFundingList li:last-child{border:none}#topupFundingList li:last-child a:hover{background-color:#f7f9fa}#topupFundingList .checkIcon{top:26px;right:2px;width:22px;height:17px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2.png\");background-repeat:no-repeat;background-position:-66px -183px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#topupFundingList .checkIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_tokenization_v2_2x.png\");background-size:119px 243px}}#topupFundingList .noLink{text-decoration:none}#topupFundingList .listItem{display:block;padding:23px 0;position:relative;color:#000;border:2px solid transparent}#topupFundingList .listItem:focus{border:2px solid #009cde}#topupFundingList .listItem .walletIcons{top:25px}#topupFundingList .listItem .fsItem{margin-left:35px}#topupFundingList .description{color:#0070ba}#topupFundingList .description:focus{color:#005ea6}#topupFundingList .listItem.addccLink,#topupFundingList .listItem.addccLink:focus{border:none}#topupFundingList .listItem.addccLink .icon{display:inline-block;float:left;width:10px;height:10px;margin:4px 6px 0 0;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-180px -180px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#topupFundingList .listItem.addccLink .icon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}#topupFundingList .listItem.addccLink .icon:focus,#topupFundingList .listItem.addccLink .icon:hover{background-position:-180px -200px}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-sidepage-add-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SidepageAddCardRoute = undefined;
	
	__webpack_require__("./pages/xo-sidepage-add-card/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SidepageAddCardRoute = exports.$SidepageAddCardRoute = _squid.$ComponentRoute.extend('$SidepageAddCardRoute', {
	
	    path: 'sidepageAddCard',
	    directive: 'xo-sidepage-add-card-page',
	    titleContent: 'asideHeader.addCard',
	    trackingData: {
	        templateName: 'tray/addCard.dust',
	        pageGoal: 'Add Card',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-cc',
	                'pagename2': '%::fullpage-add-cc:member:hermes:tray',
	                'version': 'member:%:tray'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            sidebar: 'sidebar',
	            'parent-callbacks': 'callbacks',
	            promotion: 'promotion',
	            'show-cancel': true
	        }
	    }]
	});
	
	angular.value("$SidepageAddCardRoute", $SidepageAddCardRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sidepage-add-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSidepageAddCardPageComponent = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _template = __webpack_require__("./pages/xo-sidepage-add-card/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/aside-header/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSidepageAddCardPageComponent = exports.$xoSidepageAddCardPageComponent = _squid.$Component.extend('$xoSidepageAddCardPageComponent', {
	    tag: 'xo-sidepage-add-card-page',
	    template: _template2['default'],
	
	    scope: {
	        token: '=',
	        callbacks: '='
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var interval = (0, _angular.$interval)(function () {
	                var el = (0, _jquery2['default'])('#sidepageAddCard');
	                if (el) {
	                    _angular.$interval.cancel(interval);
	                    el.addClass('sidepageAddCardOpen');
	                }
	            }, 100);
	        }
	    },
	
	    controller: function controller($scope, $rootScope, $stateParams) {
	        $scope.billingaddressupdated = {
	            value: false
	        };
	        $scope.isUpdateDebitCard = function () {
	            return $stateParams.message === 'EXPIRED_DEBIT_CARD';
	        };
	        $scope.token = $rootScope.token;
	        $scope.message = {};
	    }
	});
	
	angular.value("$xoSidepageAddCardPageComponent", $xoSidepageAddCardPageComponent);
	_angular.$interval;
	
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sidepage-add-card/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\" id=\"sidepageAddCard\" modal-box content>\n    <xo-aside-header heading=\"{{isUpdateDebitCard() ? 'asideHeader.updateDebitCard' : 'asideHeader.addDebitCard'}}\"\n                     hidex=\"true\"></xo-aside-header>\n    <div class=\"content\">\n\t    <ui-view></ui-view>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/topup/update-pin/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./components/xo-wallet-components/src/topup/update-pin/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoUpdatePinRoute', {
	    path: 'updatePin',
	    directive: _directive2['default'],
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-wallet-components/src/topup/update-pin/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-ui-components/src/mobile-pin/directive.js");
	
	var _index = __webpack_require__("./components/xo-models/src/app/index.js");
	
	var _template = __webpack_require__("./components/xo-wallet-components/src/topup/update-pin/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/topup/update-pin/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoUpdatePinDirective', {
	    tag: 'xo-update-pin',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        },
	        success: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            _logger.$logger.info('tokenized_wallet', {
	                'from': 'PINSETUP',
	                'to': 'PREPARE_PINSETUP'
	            });
	        }
	    },
	
	    controller: function controller($scope) {
	
	        var currentPin = '';
	        $scope.madeAttempt = false;
	        $scope.pinMissMatch = false;
	        $scope.pinChanged = false;
	
	        function done(pinValue) {
	            _index.$TokenizedWalletPinModel.instance(_angular.$rootScope.token).retrieve().then(function (WalletPinModel) {
	                WalletPinModel.userPin = pinValue;
	                _logger.$logger.info('tokenized_wallet', {
	                    'from': 'PINSETUP',
	                    'to': 'PROCESS_PINSETUP'
	                });
	                (0, _angular.$timeout)(function () {
	                    return _uiRouter.$state.go('checkout.review');
	                }, 1500);
	            });
	        }
	
	        $scope.pinComplete = function (value) {
	
	            $scope.pinChanged = $scope.madeAttempt && currentPin === value;
	            $scope.pinMissMatch = $scope.madeAttempt && !$scope.pinChanged;
	            currentPin = $scope.madeAttempt ? '' : value; // reset old pin if already made an attempt
	            $scope.madeAttempt = !$scope.madeAttempt; // flip flag
	
	            if (!$scope.pinChanged) {
	                $scope.$broadcast('resetPin');
	            } else {
	                done(value);
	            }
	        };
	    }
	});
	
	
	_angular.$timeout;
	
	_uiRouter.$state;
	
	_squid.$Component;
	
	_logger.$logger;
	
	_index.$TokenizedWalletPinModel;
	
	_angular.$rootScope;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-ui-components/src/mobile-pin/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-ui-components/src/mobile-pin/styles.less");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _underscore = __webpack_require__("../node_modules/underscore/underscore.js");
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/mobile-pin/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-mobile-pin.directive', ['squid']).directive('xoMobilePin', function () {
	        return {
	            scope: {
	                pinvalue: '=',
	                done: '='
	            },
	            template: template,
	            controller: function controller($scope, $element) {
	                $scope.pinvalue = {};
	                var delay = 200;
	                $scope.doingReset = false;
	                $scope.fields = ['field1', 'field2', 'field3', 'field4'];
	
	                function reset() {
	                    $scope.fields.forEach(function (fieldName) {
	                        $scope.pinvalue[fieldName] = '';
	                        var currentElement = document.getElementById(fieldName);
	                        angular.element(currentElement)[0].type = 'number';
	                    });
	                    var ele = document.getElementById($scope.fields[0]);
	                    angular.element(ele)[0].focus(); // set focus to first elemnt
	                    $scope.doingReset = false;
	                }
	                reset();
	
	                function getPin() {
	                    var result = '';
	                    $scope.fields.forEach(function (fieldName) {
	                        result = result + String($scope.pinvalue[fieldName]);
	                    });
	                    return result;
	                }
	
	                function isPinValid(val) {
	                    return (/^\d{1}/.test(val)
	                    );
	                }
	
	                function isDone() {
	                    var values = _underscore2['default'].values($scope.pinvalue);
	                    var result = _underscore2['default'].every(values, function (val) {
	                        return isPinValid(val);
	                    });
	                    return result;
	                }
	
	                function moveCursor(currID, direction, clearCurrent) {
	                    var currentIndex = $scope.fields.indexOf(currID);
	                    var currEle = angular.element(document.getElementById(currID))[0];
	                    if (clearCurrent) {
	                        currEle.value = '';
	                        $scope.pinvalue[currID] = '';
	                    }
	
	                    var nextIndex = void 0;
	                    if (direction === 'left') {
	                        nextIndex = currentIndex > 0 ? currentIndex - 1 : 0;
	                    }
	                    if (direction === 'right') {
	                        nextIndex = currentIndex < $scope.fields.length - 1 ? currentIndex + 1 : $scope.fields.length - 1;
	                    }
	
	                    var nextID = $scope.fields[nextIndex];
	                    if (nextID !== currID) {
	                        var nextEle = angular.element(document.getElementById(nextID))[0];
	                        nextEle.type = 'number';
	                        nextEle.focus();
	                    }
	                }
	
	                $scope.$on('resetPin', function () {
	                    $scope.doingReset = true;
	                    (0, _angular.$timeout)(function () {
	                        return reset();
	                    }, delay);
	                });
	
	                $scope.pressedKey = function (eventObj) {
	                    var currID = eventObj && eventObj.currentTarget.id;
	                    if (eventObj && eventObj.key === 'Backspace') {
	                        moveCursor(currID, 'left', true);
	                    }
	                };
	
	                $scope.releaseKey = function (eventObj) {
	                    var currID = eventObj && eventObj.currentTarget.id;
	                    if (eventObj && eventObj.key === 'Backspace') {
	                        return;
	                    }
	                    var currEle = angular.element(document.getElementById(currID))[0];
	                    var currentValue = $scope.pinvalue[currID];
	
	                    if (isDone()) {
	                        currEle.blur();
	                        var pin = getPin();
	                        $scope.done(pin);
	                    }
	                    if (isPinValid(currentValue)) {
	                        moveCursor(currID, 'right', false);
	                    }
	                };
	
	                $scope.onFocus = function (eventObj) {
	                    var currID = eventObj && eventObj.currentTarget.id;
	                    var currEle = angular.element(document.getElementById(currID))[0];
	                    $scope.pinvalue[currID] = '';
	                    currEle.value = '';
	                    currEle.type = 'number';
	                };
	
	                $scope.onBlur = function (eventObj) {
	                    var currID = eventObj && eventObj.currentTarget.id;
	                    var currentValue = eventObj && eventObj.currentTarget.value;
	                    var currEle = angular.element(document.getElementById(currID))[0];
	
	                    if (!$scope.doingReset && currentValue) {
	                        (0, _angular.$timeout)(function () {
	                            currEle.type = 'password';
	                        }, delay);
	                    }
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	_angular.$timeout;

/***/ },

/***/ "./components/xo-ui-components/src/mobile-pin/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/mobile-pin/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-ui-components/src/mobile-pin/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}.pinbox{width:165px;height:70px;margin:auto}.numpin{margin:10px;width:15px!important;height:15px!important;text-align:center;font-size:30px;outline:none;border:0 solid;color:#2c2e2f;float:left;width:10px}.numpin.empty{margin:15px;border-radius:50%;width:9px!important;height:9px!important;border:1px solid #e3e3e3}.numpin:focus{margin:10px;width:15px!important;height:15px!important;text-align:center;font-size:30px;outline:none;border:0 solid;color:grey}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/underscore/underscore.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/mobile-pin/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"pinbox\">\n    <input type=\"number\" pattern=\"[0-9]\" maxlength=1 id=\"field1\" autofocus=\"autofocus\"\n            class=\"numpin\" ng-class=\"{empty:pinvalue.field1===''}\"\n            ng-keyup=\"releaseKey($event)\" ng-keydown=\"pressedKey($event)\"\n            ng-model=\"pinvalue.field1\"\n            ng-blur=\"onBlur($event)\" ng-focus=\"onFocus($event)\" />\n    <input type=\"number\" pattern=\"[0-9]\" maxlength=1 id=\"field2\"\n            class=\"numpin\" ng-class=\"{empty:pinvalue.field2===''}\"\n            ng-keyup=\"releaseKey($event)\" ng-keydown=\"pressedKey($event)\"\n            ng-model=\"pinvalue.field2\"\n            ng-blur=\"onBlur($event)\" ng-focus=\"onFocus($event)\" />\n    <input type=\"number\" pattern=\"[0-9]\" maxlength=1 id=\"field3\"\n            class=\"numpin\" ng-class=\"{empty:pinvalue.field3==''}\"\n            ng-keyup=\"releaseKey($event)\" ng-keydown=\"pressedKey($event)\"\n            ng-model=\"pinvalue.field3\"\n            ng-blur=\"onBlur($event)\" ng-focus=\"onFocus($event)\" />\n    <input type=\"number\" pattern=\"[0-9]\" maxlength=1 id=\"field4\"\n            class=\"numpin\" ng-class=\"{empty:pinvalue.field4===''}\"\n            ng-keyup=\"releaseKey($event)\" ng-keydown=\"pressedKey($event)\"\n            ng-model=\"pinvalue.field4\"\n            ng-blur=\"onBlur($event)\" ng-focus=\"onFocus($event)\" />\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/topup/update-pin/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"updatePin\" class=\"aside\" modal-box content>\n    <xo-aside-header heading='asideHeader.inStorePin'\n                    hidex=\"true\"\n                    header-left=\"common.back\"\n                    header-left-link=\"success\"\n                    header-left-icon=\"true\"></xo-aside-header>\n    <div class=\"pinError\" ng-if=\"pinMissMatch\">\n        <span class=\"errorIcon\"></span>\n        <span>{{content('review.pinMissMatch')}}</span>\n    </div>\n    <div class=\"content\">\n        <div class=\"pinUpdate\" ng-if=\"!pinChanged\">\n            <xo-mobile-pin done=\"pinComplete\"></xo-mobile-pin>\n            <div class=\"subtext\" ng-if=\"!pinMissMatch && !madeAttempt\">{{content('review.pinFirstEntry')}}</div>\n            <div class=\"subtext\" ng-if=\"!pinMissMatch && madeAttempt\">{{content('review.pinSecondEntry')}}</div>\n            <div class=\"subtext\" ng-if=\"pinMissMatch\">{{content('review.pinBadEntry')}}</div>\n        </div>\n        <div class=\"pinSuccess\" ng-if=\"pinChanged\">\n            <div id=\"successGif\"></div>\n            <div class=\"subtext successText\">{{content('review.pinChanged')}}</div>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/topup/update-pin/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/topup/update-pin/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-wallet-components/src/topup/update-pin/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}.pinError{padding:15px 30px;color:#c72e2e}.errorIcon{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat;background-size:21px;width:21px;height:21px;top:5px;display:inline-block;position:relative}.pinUpdate{padding:30px 0}.pinSuccess{width:244px;padding-top:50px;text-align:center;margin:auto}.subtext{color:#2c2e2f;text-align:center;margin:20px 0}.bold{font-weight:700}#successGif{top:15px;right:-5px;margin:0 auto 50px;position:relative;width:90px;height:90px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/animation-checkmark.gif\");background-repeat:no-repeat;background-size:90px 90px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#successGif{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/animation-checkmark.gif\");background-size:90px 90px}}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-review/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoReviewPageComponent = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-title/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/banner/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/select-shipping-method/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/review-address/directive.js");
	
	__webpack_require__("./components/xo-member-components/src/review-paywith/directive.js");
	
	__webpack_require__("./components/xo-venmo-components/src/review-paywith-venmo/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/messenger-plugin/directive.js");
	
	__webpack_require__("./components/xo-address-components/src/address-display/directive.js");
	
	__webpack_require__("./components/xo-credit-components/src/offer/directive.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	__webpack_require__("./components/xo-models/src/app/index.js");
	
	__webpack_require__("./components/xo-models/src/bml/index.js");
	
	__webpack_require__("./components/xo-models/src/fi/index.js");
	
	__webpack_require__("./components/xo-models/src/fi/lib/fiMessages.js");
	
	__webpack_require__("./components/xo-models/src/fi/lib/fiApis.js");
	
	__webpack_require__("./components/xo-models/src/auth/lib/xoAPayUtils.js");
	
	__webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-popup/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/done/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/cart/lib/pxp.js");
	
	__webpack_require__("./components/xo-wallet-components/src/3ds/directive.js");
	
	__webpack_require__("./components/xo-models/src/profilemanagement/index.js");
	
	__webpack_require__("./components/xo-models/src/inventory/index.js");
	
	__webpack_require__("./components/xo-models/src/shoppingcart/index.js");
	
	__webpack_require__("./components/xo-page-components/src/marketingOffers/directive.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	__webpack_require__("./components/xo-member-components/src/review-topup/directive.js");
	
	var _template = __webpack_require__("./pages/xo-review/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _index = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _fi = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _choice = __webpack_require__("./components/xo-models/src/choice/index.js");
	
	__webpack_require__("./components/xo-styles/dist/lib/toggle.less");
	
	var _ul = __webpack_require__("./components/xo-login-components/src/unified-login/ul.js");
	
	var _venmoInfo = __webpack_require__("./components/xo-venmo-components/src/venmo-info/index.js");
	
	__webpack_require__("./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoReviewPageComponent = exports.$xoReviewPageComponent = _squid.$Component.extend('$xoReviewPageComponent', {
	    tag: 'xo-review-page',
	    template: _template2['default'],
	    scope: {
	        redirectiframe: '=',
	        redirectLightbox: '='
	    },
	    actions: {
	        updatePreferredFi: function updatePreferredFi(logger) {
	            if (this.makeFiPreferred && this.makeFiPreferred.selected) {
	                var PreferredFi = new _fi.$PreferredFi({
	                    preferred: [this.makeFiPreferred.fiId]
	                });
	
	                logger.info('checkout_fpti', {
	                    'pref_fi_set': '1'
	                });
	
	                return PreferredFi.save({
	                    transientError: true,
	                    contingencies: {
	                        DEFAULT: function DEFAULT() {}
	                    }
	                });
	            }
	
	            logger.info('checkout_fpti', {
	                'pref_fi_set': '0'
	            });
	
	            return _angular.$q.when();
	        }
	    },
	    lifecycle: {
	        reenter: function reenter() {
	            var msgKeys = this.checkoutSession.get('message.msgKeys', []);
	
	            if (msgKeys.indexOf('confirmUpop.confirmUpopOrChooseAltMethod') === -1) {
	                this.showUnconfirmedUpopMsg = !!this.checkoutSession.unconfirmed_upop;
	            }
	
	            // Reset the selectedmethod indicator and state change listener
	            if (this.setupMultipleFi) {
	                this.setupMultipleFi();
	            }
	
	            // If FS has changed due to an update, reset the preferred FI checkbox
	            if (this.makeFiPreferred && this.makeFiPreferred.fiId !== this.checkoutSession.fundingOptions.plans[0].primaryFs.id) {
	                _logger.$logger.info('checkout_fpti', {
	                    'pref_fi_option_shown': '1'
	                });
	                this.makeFiPreferred.selected = false;
	            }
	            this.topupError = false; // set default value to false (hide error when enter)
	        },
	        populate: function populate() {
	            (0, _jquery2['default'])('.review .reviewTopup').css('min-height', function () {
	                var height = window.innerHeight || document.documentElement && document.documentElement.clientHeight;
	                return height && height - 110; // 110px => height of header & footer
	            });
	        }
	    },
	    controller: function controller($scope, $state, $rootScope, $FallbackError, $populate, $DeviceInfo, $KmliUpsell, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutSessionModel, $ShippingRuleSummaryModel, $feature, $AuthModel, $pxp, $config, $meta, $experiment, $miniBrowser, $locale, $pxpFactors, $window, $util, $featureCountries, $BMLModel, $ApplyForBMLModel, $CheckoutPayeeModel, $pxpCartAmt, $timeout, $unresolved, $BuyerEligibilityModel, $renderContent, $fiMessages, $fiApis, $element, $MerchantPreferenceModel, $AddCardModel, $CardModel, $CreditInstallmentModel, $InventoryModel, $CreditDataModel, $ShoppingCartModel, $WalletPreferences, $xoAPayUtils, $TokenizedWalletPinModel) {
	
	        _logger.$logger.info('buyer_info', {
	            fpti_buyer_type: 'Existinguser'
	        });
	
	        var showButtonPxp = false;
	        // show fixed button for mobile and incontext view
	        var allowFixedButton = $DeviceInfo.isMobile() || $miniBrowser.isMiniBrowser();
	
	        $scope.token = $rootScope.token;
	
	        $scope.backUri = 'checkout.review';
	
	        $scope.installmentNotSelected = false;
	
	        $scope.installment = {
	            showBanner: false,
	            showCYCO: false,
	            showRepresentativeInfo: false
	        };
	
	        /* Flag to determine whether merchant supports callback shipping options for given address
	         1. Default : true
	         2. shippingRegionSupported : false -> Show shipping region not supported error in review page and do not allow Pay
	         */
	        $scope.instantUpdateFeature = {
	            shippingRegionSupported: true
	        };
	
	        // PAD Toggle feature
	        $scope.padToggleFeature = {
	            applicable: false,
	            checkboxEnabled: false,
	            showCheckbox: false,
	            defaultPlan: false,
	            pxpTreatmentEnabled: false,
	            pxpControlEnabled: false,
	            fptiLogged: false
	        };
	
	        $scope.padToggleFeatureSupported = $feature('padToggleFeatureSupported');
	
	        // 'continue' or 'pay now' button text
	        $scope.payButtonText = function () {
	            return '';
	        };
	        $scope.isVenmoFlow = function () {
	            return _venmoInfo.venmoExperience.get($rootScope.token);
	        };
	
	        $scope.isGCcountry = ($config.giftCardSupportedCountries || '').indexOf($locale.country) > -1;
	
	        $scope.showPaypalPolicies = $featureCountries('showPaypalPolicies').indexOf($locale.country) > -1;
	
	        $scope.makeAddrPreferred = {
	            shown: false,
	            selected: false
	        };
	
	        $scope.showPolicyAgreement = $feature('showPolicyAgreement');
	
	        $scope.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
	
	        $scope.personalizedBanner = {};
	        function setPersonalizedBanner(buyer_id) {
	            $scope.personalizedBanner.show = true;
	            _index.$UserPhotoModel.instance(buyer_id).retrieve({
	                params: {
	                    'min_size': 45
	                },
	                success: function success(result) {
	                    if (result && result.photo_url) {
	                        $scope.personalizedBanner.imageUrl = result.photo_url;
	                        _logger.$logger.info('personalized_banner_retrieve_success');
	                    }
	                }
	            });
	        }
	
	        $scope.optin_toggle = {
	            isEnabled: false,
	            value: false,
	            showExpandedTerms: true,
	            setValue: function setValue(val) {
	                this.value = val;
	                // this.showExpandedTerms = false; // hide terms upon user interaction
	                _logger.$logger.debug('ryi_optin_toggle_setValue', {
	                    value: this.value,
	                    showExpandedTerms: this.showExpandedTerms
	                });
	            }
	        };
	        _logger.$logger.debug('kmliUpsell review: init');
	        $KmliUpsell.init($scope.token, false, true);
	
	        function optInUser() {
	            // eslint-disable-line no-unused-vars
	
	            _logger.$logger.info('ryi_optin', {
	                'from': 'OT_Toggle',
	                'to': 'prepare_optin'
	            });
	            $scope.optin_toggle.setValue(true);
	            var optinSource = 'checkoutToggle';
	            var silentSpinner = true;
	            _ul.$ul.optInToOneTouch($scope.token, $locale.country, $locale.lang, silentSpinner, {
	                'stateName': 'OT_Toggle',
	                'transInfix': 'process_optin'
	            }, optinSource).then(function (res) {
	                _logger.$logger.debug('ryi_optin_toggle_process_optin');
	            })['catch'](function (err) {
	                // eslint-disable-line handle-callback-err
	                _logger.$logger.debug('ryi_optin_toggle_process_optin_Error', {
	                    'int_error_description': err.message
	                });
	            });
	        }
	
	        function optOutUser() {
	            // eslint-disable-line no-unused-vars
	
	            _logger.$logger.info('ryi_optin', {
	                'from': 'OT_Toggle',
	                'to': 'prepare_optout'
	            });
	
	            $scope.auth.action('optout', { silent: true }).then(function (res) {
	                _logger.$logger.info('ryi_optin', {
	                    'from': 'OT_Toggle',
	                    'to': 'process_optout'
	                });
	                $scope.$applyAsync(function () {
	                    var bannerElement = $element.find('.oneTouchBanner');
	                    bannerElement.addClass('leave_animation');
	                    _logger.$logger.debug('ryi_optin bannerElement animate');
	                    $timeout(function () {
	                        $scope.optin_toggle.setValue(false);
	                        $scope.optin_toggle.isEnabled = false;
	                    }, 1400);
	                });
	            })['catch'](function (err) {
	                _logger.$logger.info('ryi_optin', {
	                    'from': 'OT_Toggle',
	                    'to': 'process_optout',
	                    'error_source': 'identityauthorizationserv',
	                    'int_error_code': 'optout_failure',
	                    'int_error_description': err.message
	                });
	            });
	        }
	
	        $scope.onTouchToggle = function (value) {
	            _logger.$logger.debug('optin_toggle_change_attempt', {
	                'ryi_optin': $scope.optin_toggle,
	                'remembered': $scope.auth.remembered,
	                'value': value
	            });
	            if ($scope.optin_toggle.isEnabled) {
	                if (value) {
	                    optInUser();
	                } else {
	                    optOutUser();
	                }
	            }
	        };
	
	        // Format the informal name if populated
	        function setInformalName() {
	            if ($scope.auth) {
	                $scope.formattedNameInformal = (0, _squid.formatNameInformal)({
	                    first_name: $scope.auth.first_name,
	                    last_name: $scope.auth.last_name
	                }) || $scope.auth.email;
	            }
	        }
	
	        function updateAddressAsPreferred() {
	            if ($scope.makeAddrPreferred.shown) {
	                _logger.$logger.info('makeAddrPreferred.shown', {});
	            }
	
	            if ($scope.makeAddrPreferred.selected) {
	                _logger.$logger.info('makeAddrPreferred.selected', {});
	
	                // Ignore all errors from setPreferred api, by passing transientError as true
	                return $scope.checkoutSession.shipping.action('setPreferred', {
	                    transientError: true
	                });
	            }
	
	            return _angular.$q.when();
	        }
	
	        function setStickyInstrument() {
	            if (!$config.features.DEFAULT.enableStickyFunding) {
	                return _angular.$q.when();
	            }
	
	            var stickyInstrument = $scope.checkoutSession.selectedFuturePaymentInstrument ? undefined : $scope.checkoutSession.getSelectedStickyInstrument();
	
	            if (stickyInstrument) {
	                return $scope.checkoutSession.action('setStickyFI', {
	                    data: {
	                        instrument_id: stickyInstrument.instrument_id
	                    }
	                });
	            }
	
	            return _angular.$q.when();
	        }
	
	        function setWalletTopupPreferences() {
	            if ($scope.checkoutCart.isWalletTokenization()) {
	                $scope.walletPreferences = $WalletPreferences.instance($scope.token);
	                return $scope.walletPreferences.save();
	            }
	        }
	
	        function isValidPinSetup() {
	            if ($scope.walletPinModel && $scope.walletPinModel.pinOrigin === 'UNSET') {
	                var userPin = $scope.walletPinModel.userPin ? $scope.walletPinModel.userPin : $scope.walletPinModel.suggestedPin;
	                if (!userPin) {
	                    return false;
	                }
	            }
	            return true;
	        }
	
	        function prepareTokenizedWalletPinModel() {
	            if ($scope.checkoutCart.isWalletTokenization()) {
	                return $TokenizedWalletPinModel.instance($scope.token).retrieve().then(function (result) {
	                    $scope.walletPinModel = result;
	                    var pinStatus = 'default_pin_unavailable';
	                    if ($scope.walletPinModel.isPinIdPresent()) {
	                        pinStatus = 'already_exist';
	                    } else if ($scope.walletPinModel.getPinOrigin() !== 'UNSET') {
	                        pinStatus = 'pin_error';
	                    } else if ($scope.walletPinModel.getSuggestedPin()) {
	                        pinStatus = 'default_pin_available';
	                    }
	
	                    _logger.$logger.info('tokenized_wallet', {
	                        'from': 'TopUp_REVIEW',
	                        'to': 'prepare_review',
	                        'context_id': $scope.token,
	                        'context_type': 'EC-Token',
	                        'billing_token': $meta.baToken,
	                        'pin': pinStatus
	                    });
	                });
	            }
	            return _angular.$q.when();
	        }
	
	        function setTokenizedWalletPin() {
	            if ($scope.walletPinModel && $scope.walletPinModel.pinOrigin === 'UNSET') {
	                var userPin = $scope.walletPinModel.userPin ? $scope.walletPinModel.userPin : $scope.walletPinModel.suggestedPin;
	                return $scope.walletPinModel.save({
	                    data: {
	                        pin: userPin
	                    },
	                    contingencies: {
	                        DEFAULT: function DEFAULT(name, err) {
	                            _logger.$logger.info('tokenized_wallet', {
	                                'from': 'TopUp_REVIEW',
	                                'to': 'process_review',
	                                'context_id': $scope.token,
	                                'context_type': 'BA-Token',
	                                'billing_token': $meta.baToken,
	                                'int_error_code': 'pin_setup_contingencies',
	                                'int_error_description': err,
	                                'error_source': 'issuancemanagementserv'
	                            });
	                            throw err;
	                        }
	                    }
	                });
	            }
	            return _angular.$q.when();
	        }
	
	        function show3DSLightbox() {
	            $scope.resolve_3ds_data = {
	                cc_id: $scope.checkoutSession.get('resolve_3ds.ccId'),
	                flow_id: 'HERMES',
	                merchant_id: $scope.payee.get('merchant.id'),
	                merchant_country_code: $scope.checkoutAppData.get('merchant.merchant_country'),
	                transaction_amount_currency: $scope.checkoutCart.get('purchase.amounts.total.currency_code'),
	                transaction_amount_value: $scope.checkoutCart.get('purchase.amounts.total.amount')
	            };
	            $scope.launch3DSResolver = true;
	        }
	
	        function showGenericError(code) {
	            return function () {
	                inventoryOperation('failed');
	                var encoded = code ? window.btoa(code) : code;
	                return $state.go('checkout.genericError', {
	                    code: encoded
	                });
	            };
	        }
	
	        function getMerchantPreferences() {
	
	            return $populate($scope, {
	                pref: $MerchantPreferenceModel.instance($scope.payee.merchant.id)
	            });
	        }
	
	        function setProcessorDeclineMessage() {
	
	            var processorDeclinedMsg = $fiMessages.processorDeclinedMsg($scope.checkoutSession, true);
	
	            if (processorDeclinedMsg) {
	                $scope.checkoutSession.message = {
	                    type: processorDeclinedMsg.type,
	                    msgs: [processorDeclinedMsg.msg]
	                };
	            }
	        }
	
	        function makePayment() {
	            var wpsParams = $util.decodeAndParse($meta.xclickParams);
	
	            return $scope.checkoutSession.action('createPayment', {
	                data: {
	                    payer_id: $scope.checkoutSession.payer.id,
	                    intent: $scope.checkoutCart.payment_action,
	                    wa_type: wpsParams && wpsParams.wa_type,
	                    correlation_id: $meta.correlationId,
	                    merchant_id: $scope.payee.get('merchant.id'),
	                    custom: $scope.checkoutCart.get('purchase.custom'),
	                    invoice: $scope.checkoutCart.get('purchase.invoice')
	                },
	
	                success: function success(result) {
	                    $rootScope.paymentComplete = true;
	                    _logger.$logger.info('wps_cart_to_txn_mapping', {
	                        cart_id: $scope.token,
	                        txn_id: result.transactionDetails && result.transactionDetails.id,
	                        txn_receipt_id: result.transactionDetails && result.transactionDetails.receipt_id
	                    });
	                    return 'success';
	                },
	
	                contingencies: {
	                    TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
	                    PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
	                    DUPLICATE_TRANSACTION: showGenericError('PAYMENT_ALREADY_DONE'),
	                    CC_PROCESSOR_DECLINED: function CC_PROCESSOR_DECLINED() {
	                        inventoryOperation('failed');
	                        return $scope.checkoutSession.action('create', {
	                            success: function success(result) {
	                                setProcessorDeclineMessage();
	                                return $state.go('checkout.review');
	                            },
	                            contingencies: {
	                                DEFAULT: function DEFAULT(name, err) {
	                                    throw err;
	                                }
	                            }
	
	                        });
	                    },
	                    DEFAULT: function DEFAULT(name, err) {
	                        inventoryOperation('failed');
	                        throw err;
	                    }
	
	                }
	            });
	        }
	
	        function inventoryOperation(paymentStatus) {
	            var cartHasInventory = $scope.checkoutCart.get('cartHasInventory');
	            if (cartHasInventory) {
	                var inventoryModel = $InventoryModel.instance($rootScope.token);
	                var inventoryItems = inventoryModel.getInventoryItems();
	                paymentStatus = paymentStatus ? paymentStatus : 'success';
	                var inventoryPatchInput = {
	                    inventoryItems: inventoryItems,
	                    cartItems: $scope.checkoutCart.get('purchaseUnits')[0].item_list.items,
	                    merchantId: $scope.payee.get('merchant.id', ''),
	                    paymentStatus: paymentStatus
	                };
	                return inventoryModel.action('patchInventory', {
	                    data: inventoryPatchInput,
	                    success: function success(patchResponse) {
	                        if (patchResponse.showSoldoutPage) {
	                            // show soldout page
	                            return {
	                                soldoutpage: true,
	                                items: patchResponse.soldoutItems,
	                                soldOutUrl: patchResponse.soldoutUrl
	                            };
	                        } else if (patchResponse.patchCart) {
	                            var purchase_unit = $scope.checkoutCart.get('purchaseUnits')[0];
	                            purchase_unit.item_list.items = patchResponse.cartItems;
	                            var patchCartPayload = {
	                                id: $scope.token,
	                                patchEntities: [{
	                                    field: 'inventoryItems',
	                                    value: purchase_unit.item_list.items
	                                }]
	                            };
	
	                            return $scope.checkoutCart.action('patchCartData', {
	                                data: patchCartPayload
	                            });
	                        }
	                        return;
	                    }
	                });
	            } else {
	                return _angular.$q.when(); // not an inventory request proceed with existing flow
	            }
	        }
	
	        function markCartCheckedout() {
	            var shoppingCartModel = $ShoppingCartModel.instance($rootScope.token);
	            return shoppingCartModel.action('cartCheckedOut', {
	                data: {
	                    payee_email: $scope.checkoutAppData.get('merchant.merchant_email')
	                },
	                success: function success(result) {
	                    _logger.$logger.info('cart checked out successfully');
	                }
	            });
	        }
	
	        function isPadToggleFeatureApplicable() {
	            var padToggle = false;
	            if ($scope.padToggleFeatureSupported && $scope.padToggleFeature.pxpTreatmentEnabled && $scope.padToggleFeature.applicable) {
	                padToggle = true;
	            }
	
	            return padToggle;
	        }
	
	        function getPadToggleStatus() {
	            var toggleStatus = 'NA'; // NOT APPLICABLE status
	            if (isPadToggleFeatureApplicable()) {
	                if ($scope.checkoutSession.plan.isPAD() && $scope.padToggleFeature.checkboxEnabled) {
	                    toggleStatus = 'ON';
	                } else {
	                    toggleStatus = 'OFF';
	                }
	            }
	
	            return toggleStatus;
	        }
	
	        function authorize() {
	            if ($scope.checkoutSession.resolve_3ds) {
	                return show3DSLightbox();
	            }
	
	            function isXoonUpopRedirect() {
	                if (!($scope.checkoutSession && $scope.checkoutSession.get('errorData.resolution.data.fi.type'))) {
	                    return false;
	                }
	
	                return $util.param('redirectToHermesOnUpopCancel') === 'xoon' && $scope.checkoutSession.errorData.resolution.name === 'PAYER_TO_AUTHENTICATE_CARD' && !$scope.checkoutSession.errorData.resolution.data.alternate_options && $scope.checkoutSession.errorData.resolution.data.fi.type.toUpperCase() === 'CUP';
	            }
	
	            if ($scope.checkoutSession.unconfirmed_upop || isXoonUpopRedirect()) {
	                var card = void 0;
	                if ($scope.checkoutSession.unconfirmed_upop) {
	                    card = $scope.checkoutSession.unconfirmed_upop;
	                } else {
	                    card = $scope.checkoutSession.errorData.resolution.data;
	                }
	
	                $scope.cardModel = new $AddCardModel({});
	                $scope.cardModel.id = card.fundingId;
	                $scope.cardModel.card = new $CardModel({
	                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
	                    type: card.fi.type.toUpperCase(),
	                    productType: card.fi.productType
	                });
	
	                $state.go('.confirmUpop');
	                return;
	            }
	
	            if ($scope.checkoutCart.isWalletTokenization()) {
	                $xoAPayUtils.setAPayCookie($scope.token);
	            }
	
	            return $scope.checkoutSession.action('authorize', {
	                success: function success() {
	                    if ($scope.checkoutSession.get('plan.paypal_credit')) {
	                        _logger.$logger.info('checkout_fpti', {
	                            'ppc_reuse_status': 'success'
	                        });
	                    }
	
	                    var padToggleStatus = getPadToggleStatus();
	
	                    if (padToggleStatus === 'ON') {
	                        _logger.$logger.info('checkout_fpti', {
	                            'pad_toggle_status': 'padToggleOnSuccess'
	                        });
	                    } else if (padToggleStatus === 'OFF') {
	                        _logger.$logger.info('checkout_fpti', {
	                            'pad_toggle_status': 'padToggleOffSuccess'
	                        });
	                    }
	
	                    if ($scope.checkoutCart.isWalletTokenization()) {
	                        _logger.$logger.info('tokenized_wallet', {
	                            'from': 'TopUp_REVIEW',
	                            'to': 'process_review',
	                            'topup_amt': $scope.walletPreferences.topup.amount,
	                            'currency_code': $scope.walletPreferences.topup.currency,
	                            'context_id': $scope.token,
	                            'context_type': 'BA-Token',
	                            'billing_token': $meta.baToken
	                        });
	                    }
	
	                    if (window.xchild) {
	                        return $state.go('checkout.end');
	                    }
	
	                    if (_integration.$integration.getConfig('DONE_PAGE')) {
	                        return inventoryOperation().then(function (result) {
	                            if (result && result.soldoutpage) {
	                                return $state.go('checkout.soldout', {
	                                    items: encodeURIComponent(result.items),
	                                    soldOutUrl: encodeURIComponent(result.soldOutUrl)
	                                });
	                            }
	                            return _angular.$q.all([makePayment(), getMerchantPreferences()]).then(function () {
	                                if ($rootScope.paymentComplete) {
	                                    if ($config.enableShoppingCartWPS && $scope.checkoutAppData.flags.is_shopping_cart_flow) {
	                                        markCartCheckedout();
	                                    }
	
	                                    return $state.go('checkout.done');
	                                }
	                            });
	                        });
	                    } else {
	                        if ($scope.checkoutSession.get('sepa_mandate.bankId')) {
	                            return $state.go('checkout.sepapage');
	                        }
	
	                        return $state.go('checkout.end');
	                    }
	                }
	            });
	        }
	
	        function setShowShippingMethodProperty() {
	            return $populate($scope, {
	                shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
	                    params: {
	                        merchant_id: $scope.payee.get('merchant.id'),
	                        currency_code: $scope.checkoutCart.get('purchase.amounts.total.currency_code')
	                    }
	                })
	            }).then(function () {
	                if ($scope.shippingRulesSummary.isSnTEnabled) {
	                    _logger.$logger.info('shipping_rules_summary_snt_enabled');
	                } else {
	                    _logger.$logger.info('shipping_rules_summary_snt_disabled');
	                }
	                $scope.showShippingMethod = $scope.shippingRulesSummary.isSnTEnabled || $scope.isInstantUpdateAPIFlow;
	                return;
	            });
	        }
	
	        function show3DSDeclineMsg(declineAfter3DSAccept) {
	            var key = 'threeDS.memberDecline';
	
	            if (declineAfter3DSAccept) {
	                key = 'threeDS.memberDeclineAfter3DSAccept';
	            }
	
	            var card = $scope.checkoutSession.resolve_3ds;
	
	            if (card) {
	                var msg = $renderContent(key, {
	                    cardType: card.type,
	                    last4: card.number
	                });
	
	                $scope.checkoutSession.message = {
	                    msgs: [msg],
	                    type: 'warning'
	                };
	            }
	        }
	
	        /**
	         * call patchXO API to clear the 3DS contingency and then call authorize API.
	         */
	        function clear3DSContingency() {
	            var resolve_3ds = $scope.checkoutSession.resolve_3ds || {};
	
	            return $scope.checkoutSession.action('clear3DSContingency', {
	                data: {
	                    ccId: resolve_3ds.ccId
	                },
	                success: function success(response) {
	                    if (!$scope.checkoutSession.resolve_3ds) {
	                        return authorize();
	                    } else {
	                        // Symphony is not able to clear the 3DS contingency
	                        show3DSDeclineMsg(true);
	                    }
	                }
	            });
	        }
	
	        $scope.onComplete3DSHandler = function (status) {
	            $scope.launch3DSResolver = false;
	            if (status === 'success') {
	                return clear3DSContingency();
	            } else if (status === 'decline') {
	                // 3DS got declined
	                show3DSDeclineMsg();
	            }
	        };
	
	        $scope.onConfirmUpopSuccess = function () {
	            $state.go('checkout.review');
	            $scope.checkoutSession.action('clearContingency', {
	                data: {
	                    contingency: 'UNCONFIRMED_UPOP',
	                    ccId: $scope.checkoutSession.get('unconfirmed_upop.fundingId') || $scope.checkoutSession.get('errorData.resolution.data.fundingId')
	                },
	                success: function success() {
	                    if (!$scope.checkoutSession.unconfirmed_upop) {
	                        return authorize();
	                    } else {
	                        $scope.checkoutSession.message = {
	                            type: 'warning',
	                            msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
	                        };
	                    }
	                }
	            });
	        };
	
	        $scope.onConfirmUpopCancel = function () {
	            $state.go('checkout.review');
	            $scope.showUnconfirmedUpopMsg = false;
	            $scope.checkoutSession.message = {
	                type: 'warning',
	                msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
	            };
	        };
	
	        $scope.errorHandlerHelper = {};
	
	        $scope.errorHandlerHelper.addPageError = function (contentKey, dynamicValuesInContent) {
	            var messages = [];
	            var msg;
	
	            if (dynamicValuesInContent) {
	                msg = $renderContent(contentKey, dynamicValuesInContent);
	            } else {
	                msg = $locale.content.get(contentKey);
	            }
	
	            messages.push(msg);
	
	            $scope.checkoutSession.message = {
	                msgs: messages,
	                type: 'error'
	            };
	        };
	
	        $scope.errorHandlerHelper.clearPageErrors = function () {
	            $scope.checkoutSession.message = '';
	        };
	
	        $scope.returnFromCape = function (isCapeReturnKey) {
	            return $scope.creditDataModel.action('readCreditKey', {
	                data: {
	                    capeKey: isCapeReturnKey
	                },
	                success: function success(res) {
	
	                    if (res.financial_instrument_id) {
	                        var financial_instrument_id = res.financial_instrument_id.indexOf('BC') !== 0 ? 'BC' + res.financial_instrument_id : res.financial_instrument_id;
	
	                        return $scope.checkoutSession.fundingOptions.action('update', {
	                            resultModel: $scope.checkoutSession,
	                            data: {
	                                planId: financial_instrument_id
	                            },
	                            success: function success(result) {
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['offers.bmlInWalletSuccessMsg']
	                                };
	
	                                if ($scope.setupMultipleFi) {
	                                    $scope.setupMultipleFi();
	                                }
	                            }
	                        });
	                    }
	
	                    // User does not have any FI in wallet and they choose to pay in full.
	                    else if (!$scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.isCreditPromoted) {
	                            $state.go('checkout.pageAddCard.addCardFlow.addCard');
	                        } else if ($scope.creditDataModel.isCapeInternalServiceError()) {
	                            // Todo Show error message from CAPE
	                            return _angular.$q.when();
	                        } else {
	                            return _angular.$q.when();
	                        }
	                },
	                contingencies: {
	                    DEFAULT: function DEFAULT(name, err) {
	                        _logger.$logger.info('read_cape_key_failure');
	                        return _angular.$q.when();
	                    }
	                }
	
	            });
	        };
	
	        // For the multiple FI variant of the choice experiment:
	        // Update the funding option in the plan based on the user's stored selection
	        function updateFS() {
	
	            if ($scope.selectedmethod && $scope.checkoutSession.get('plan.sources')[0].id !== $scope.selectedmethod.planId) {
	
	                return $scope.checkoutSession.fundingOptions.action('select', {
	                    data: {
	                        planId: $scope.selectedmethod.planId
	                    },
	                    success: function success(result) {
	                        $scope.checkoutSession.populate(result);
	                    }
	                    // TODO: contingency handler
	                });
	            } else {
	                return _angular.$q.when();
	            }
	        }
	
	        $populate($scope, {
	            auth: $AuthModel.instance(),
	            checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	            checkoutCart: $CheckoutCartModel.instance($scope.token),
	            checkoutSession: $CheckoutSessionModel.instance($scope.token),
	            payee: $CheckoutPayeeModel.instance($scope.token),
	            buyerEligibility: $BuyerEligibilityModel.instance($scope.token)
	        }).then(function () {
	            // Get the choice experiment variant to determine what needs to be shown in the UI
	            return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
	                $scope.choiceVariant = variant;
	
	                var checkboxVariants = $config.choiceExperiment && $config.choiceExperiment.preferredCheckbox || [];
	                var multipleFiVariants = $config.choiceExperiment && $config.choiceExperiment.multipleFi || [];
	                var selectFiVariants = $config.choiceExperiment && $config.choiceExperiment.selectFi || [];
	
	                if (checkboxVariants.indexOf(variant) !== -1 && !$scope.checkoutCart.isBilling()) {
	                    // Do setup for preferred checkbox
	                    $scope.makeFiPreferred = {
	                        selected: false
	                    };
	                }
	
	                if (multipleFiVariants.indexOf(variant) !== -1) {
	                    // Do the setup for the multipleFiVariant
	                    $scope.setupMultipleFi = function () {
	                        $scope.selectedmethod = {
	                            index: 0,
	                            planId: $scope.checkoutSession.get('plan.sources')[0].id
	                        };
	
	                        if ($scope.cancelUpdateListener) {
	                            $scope.cancelUpdateListener();
	                        }
	
	                        // Before changing state, persist the change that the user selected
	                        $scope.cancelUpdateListener = $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
	                            $scope.cancelUpdateListener();
	                            if ($scope.checkoutSession.get('plan.sources')[0].id === $scope.selectedmethod.planId) {
	                                return;
	                            }
	
	                            event.preventDefault();
	                            updateFS().then(function () {
	                                return $state.go(toState, toParams);
	                            });
	                        });
	
	                        $scope.$on('$destroy', $scope.cancelUpdateListener);
	                    };
	
	                    $scope.setupMultipleFi();
	                }
	
	                if (selectFiVariants.indexOf(variant) !== -1) {
	                    $scope.selectFiVariant = true;
	                }
	            })['catch'](function (err) {
	                // TODO: Check what happens to PXP errors
	                _logger.$logger.error('choice_eligibility_error', err);
	            });
	        }).then(function () {
	            return prepareTokenizedWalletPinModel();
	        }).then(function () {
	            if ($util.param('redirectToHermesOnUpopCancel') === 'xoon') {
	                var fiModel = $scope.checkoutSession.get('plan.sources');
	                if (fiModel && fiModel.length && fiModel[0].card_type === 'CHINA_UNION_PAY') {
	                    $scope.checkoutSession.message = {
	                        msgKeys: ['confirmUpop.confirmUpopToPay'],
	                        type: 'warning'
	                    };
	                }
	            }
	
	            $KmliUpsell.eligible().then(function (eligibility) {
	                eligibility.interstitial = eligibility.interstitial ? eligibility.interstitial : {};
	                eligibility.banner = eligibility.banner && $feature('ryiOptIn');
	                eligibility.interstitial.eligible = eligibility.interstitial.eligible && $feature('ryiOptIn');
	                $scope.optin_toggle.isEnabled = eligibility.banner;
	                _logger.$logger.info('ryi_optin', {
	                    'from': 'ryi_optin_elg_chk',
	                    'to': 'process_ryi_optin_elg_chk',
	                    'eligibility_reason': $feature('ryiOptIn') ? 'uk_buyer' : 'non_uk_buyer'
	                });
	                $scope.optin_toggle.value = $scope.auth.rememberedOT() // came in as OneTouch user
	                || $scope.auth.loggedIn() && $scope.auth.refreshToken(); // FirstTime OT (check this for webview case)
	                $scope.optin_toggle.showExpandedTerms = !eligibility.interstitial.eligible // interstitial not shown in current session
	                && !$scope.optin_toggle.value // not already OT
	                && $scope.auth.ryiOptIn // to avoid testing issues
	                && !$scope.auth.ryiOptIn.interstitialDisplayed // do not show if interstial has been shown before
	                && !$scope.auth.ryiOptIn.termsDisplayed; // not shown before
	                var cookiePayload = {};
	                if (eligibility.interstitial.eligible) {
	                    // show optin interstitial only once per user per version
	                    cookiePayload.ot_inter_shown = eligibility.interstitial.pxpVersion; // cookieList.push({ name: 'ot_inter_shown', value: eligibility.interstitial.pxpVersion });
	                }
	                if ($scope.optin_toggle.showExpandedTerms) {
	                    // show optin terms only once per user
	                    cookiePayload.ot_terms_shown = 'true';
	                }
	                if (Object.keys(cookiePayload).length > 0) {
	                    $scope.auth.action('updateAuthExperience', {
	                        silent: true,
	                        data: cookiePayload
	                    }).then(function (res) {
	                        _logger.$logger.debug('optin_toggle_cookie_drop_success', res);
	                    })['catch'](function (err) {
	                        _logger.$logger.debug('optin_toggle_cookie_drop_err', err);
	                    });
	                }
	                _logger.$logger.info('optin_toggle_init', $scope.optin_toggle);
	            });
	
	            var merchantCountry = $scope.checkoutAppData.merchant.merchant_country;
	            var personalizationEnabled = $feature('oneTouchPersonalization');
	            $scope.showRemittanceDisclosure = $DeviceInfo.isMobile() && $scope.checkoutSession.showRemittanceDisclosure ? true : false;
	            if ($scope.auth.remembered && $scope.auth.remembered_device_token && personalizationEnabled) {
	                $pxp('xo_hermesnode_config', { 'ctx.COUNTRY': merchantCountry }, 'xo_hermesnode_kmli_personalization_treatment').then(function (result) {
	                    var treatmentName = result && result.treatment_name || '';
	                    if (treatmentName) {
	                        _logger.$logger.info('personalized_banner_enabled');
	                        setPersonalizedBanner($scope.auth.buyer_id);
	                        delete $scope.checkoutSession.message;
	                    } else {
	                        $scope.personalizedBanner.show = false;
	                        delete $scope.auth.rtExchanged;
	                        _logger.$logger.info('personalized_banner_disabled');
	                    }
	                });
	            } else {
	                _logger.$logger.info('personalized_banner_ineligible', {
	                    'isFeature': personalizationEnabled,
	                    'isOneTouch': $scope.auth.remembered && $scope.auth.remembered_device_token
	                });
	                if ($scope.auth.rtExchanged) {
	                    delete $scope.auth.rtExchanged;
	                }
	            }
	
	            if ($scope.padToggleFeatureSupported) {
	                return $pxp('xo_de_hermes_pad_toggle', {
	                    'ctx.COUNTRY': $locale.country
	                }, '(xo_de_hermes_pad_toggle_)(.*)').then(function (result) {
	                    var treatmentName = result && result.treatment_name || '';
	                    if (treatmentName === 'xo_de_hermes_pad_toggle_treatment') {
	                        _logger.$logger.info('pad_toggle_treatment_applicable');
	                        $scope.padToggleFeature.pxpTreatmentEnabled = true;
	                    } else if (treatmentName === 'xo_de_hermes_pad_toggle_control') {
	                        _logger.$logger.info('pad_toggle_control_applicable');
	                        $scope.padToggleFeature.pxpControlEnabled = true;
	                    } else {
	                        _logger.$logger.info('pad_toggle_treatment_and_control_not_applicable');
	                    }
	                });
	            }
	        }).then(function () {
	            $scope.logout = function () {
	                _logger.$logger.info('not_you_logout');
	
	                if (window.xchild && $util.isIFrame()) {
	
	                    window.xchild.hide();
	
	                    var url = window.location.href.split('#')[0];
	
	                    var xprops = _extends({}, window.xprops);
	
	                    xprops.url = url;
	                    xprops.payment = function () {
	                        return $scope.auth.action('logout').then(function () {
	                            return $scope.token;
	                        });
	                    };
	
	                    return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
	                }
	
	                $scope.auth.action('logout').then(function () {
	                    $state.go('checkout.login', {
	                        source: 'NOT_YOU'
	                    });
	                });
	            };
	
	            $scope.creditDataModel = $CreditDataModel.instance($scope.token);
	            var isChangeInstallments = $scope.creditDataModel.isChangeStatus();
	            var isCapeReturnKey = $scope.creditDataModel.getCapeKey();
	            var isCapeReturn = isCapeReturnKey && $util.param('success');
	
	            if (isChangeInstallments && $scope.creditDataModel && !$scope.creditDataModel.payInFull) {
	                $state.go('checkout.chooseCreditOffer');
	            }
	            if (isCapeReturn) {
	                $scope.returnFromCape(isCapeReturnKey);
	            }
	
	            if ($feature('creditInstallmentOffers') && ($scope.checkoutSession.get('plan.paypal_credit') || isCapeReturnKey)) {
	                $scope.creditOptions = $CreditInstallmentModel.instance($scope.token);
	                $scope.creditOptions.retrieve();
	            }
	
	            $scope.cartCurrency = $scope.checkoutCart.get('purchase.amounts.total.currency_code');
	
	            $scope.showInstallmentOption = function () {
	                if ($feature('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.creditOptions && $scope.creditOptions.creditType) {
	                    if ($scope.creditOptions.creditType === 'INST') {
	                        $scope.installmentInfo = {
	                            monthlyPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.monthlyPayment, $scope.cartCurrency),
	                            totalInterestAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalInterest, $scope.cartCurrency),
	                            totalPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalPayment, $scope.cartCurrency)
	                        };
	                    }
	                    return true;
	                } else {
	                    return false;
	                }
	            };
	
	            $scope.showCYCO = function () {
	                $state.go('checkout.chooseCreditOffer');
	            };
	
	            $scope.showRepresentativeInfo = function () {
	                return $locale.country === 'GB' && $scope.installment.showRepresentativeInfo;
	            };
	
	            if (!$scope.buyerEligibility.eligible) {
	                throw new $FallbackError({
	                    reason: 'buyer_ineligible',
	                    product: 'ux'
	                });
	            }
	
	            if ($window.location.search.search('atoSuccess') !== -1) {
	                _logger.$logger.debug('PLANNING_ATO_SUCCESS');
	                var atoMsg = $locale.content.get('memberReview.stepupAuthSuccess');
	
	                if (atoMsg) {
	                    $scope.checkoutSession.message = {
	                        msgs: [atoMsg],
	                        type: 'success'
	                    };
	                }
	            }
	
	            $scope.$on('localeChange', setInformalName);
	            setInformalName();
	
	            $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && !$util.param('redirectToHermesOn3DSDecline') && !$util.param('ulReturn');
	
	            if ($util.param('redirectToHermesOn3DSDecline')) {
	                // check and show the 3DS decline message when the app is redirected from Xoon app
	                show3DSDeclineMsg();
	            }
	
	            $scope.showAuthMsg = ['authorize', 'order'].indexOf($scope.checkoutCart.get('payment_action')) > -1 && !$scope.checkoutSession.get('plan.paypal_credit');
	
	            $scope.showUnconfirmedUpopMsg = !!$scope.checkoutSession.unconfirmed_upop;
	
	            $scope.useraction = $scope.checkoutAppData.useraction() && $scope.checkoutAppData.useraction().toLowerCase();
	
	            // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
	            // are not available and purchase amount is not zero.
	            var noLineItemDetails = $scope.useraction !== 'commit' && $scope.checkoutCart.get('purchase.items.length', 0) === 0;
	
	            if ($scope.checkoutSession.bmlOffer) {
	                if (!$rootScope.bml) {
	                    $rootScope.bml = new $BMLModel();
	                }
	                $rootScope.bmlApply = new $ApplyForBMLModel();
	            }
	
	            $scope.showSoftDescriptor = !$scope.checkoutAppData.flags.hide_soft_descriptor && $scope.checkoutCart.get('purchaseUnits.length', 0) <= 1;
	
	            return $pxpCartAmt($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
	                $scope.showAmt = showAmount;
	            });
	        }).then(function () {
	            var checkoutSession = $scope.checkoutSession,
	                negBals = checkoutSession.negBals,
	                nbrMsgContentKey,
	                tokenHash;
	
	            if (negBals) {
	
	                nbrMsgContentKey = 'memberReview.nbrMsg';
	                tokenHash = {
	                    neg_bal: (0, _squid.formatCurrency)(negBals[0].amount, negBals[0].currency_code, false),
	                    merchantName: $scope.checkoutAppData.get('merchant.brand_name')
	                };
	
	                if (negBals.length > 1) {
	                    nbrMsgContentKey += 'Plural';
	                    tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
	                }
	
	                checkoutSession.message = {
	                    type: 'warning',
	                    msgs: [$renderContent(nbrMsgContentKey, tokenHash)]
	                };
	            }
	        }).then(function () {
	            if (allowFixedButton) {
	                return $pxp('xo_hermes_fixed_button', {}, 'xo_hermes_fixed_button_test_group').then(function (result) {
	                    showButtonPxp = result && result.treatment_name === 'xo_hermes_fixed_button_test_group';
	                });
	            }
	        }).then(function () {
	            if (!$miniBrowser.isMiniBrowser() && $locale.country === 'BR') {
	                var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_ryi_design;
	
	                $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
	                    $scope.ryiDesignExp = result;
	                });
	            }
	        }).then(function () {
	            $scope.isInstantUpdateAPIFlow = $scope.checkoutCart && $scope.checkoutCart.get('instantUpdateIntegration');
	            $scope.showShippingMethod = $scope.isInstantUpdateAPIFlow ? true : false;
	            if (_integration.$integration.getConfig('SHOW_SHIPPING_METHOD')) {
	                return setShowShippingMethodProperty();
	            }
	            return _angular.$q.when();
	        }).then(function () {
	            $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
	
	            var isBilling = $scope.checkoutCart.isBilling();
	            var isBillingPurchase = $scope.checkoutCart.isBillingPurchase();
	            $scope.merchantMsg = $scope.checkoutCart.getBillingDescription();
	            /* -- refined by creating isBilling and isBillingPurchase variables -- */
	            $scope.showReviewLater = !$scope.showAmt && (!isBilling || isBillingPurchase);
	
	            // show shipping address based on merchant passed in parameter
	            $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required && $scope.checkoutSession.shipping);
	
	            /* -- end refined -- */
	
	            // review page 'continue' or 'pay now' button logic to return the button text
	            $scope.payButtonText = function () {
	
	                if (isBilling) {
	                    if ($scope.useraction === 'commit') {
	                        return $locale.content.get('memberReview.agreeAndPayLabel');
	                    } else {
	                        return $locale.content.get('memberReview.agreeAndContinueLabel');
	                    }
	                } else if (getPadToggleStatus() === 'ON') {
	                    return $locale.content.get('memberReview.padLabel');
	                } else if (_integration.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW') || $scope.useraction === 'commit') {
	                    if ($scope.checkoutSession.unconfirmed_upop) {
	                        return $locale.content.get('memberReview.pay');
	                    } else {
	                        $scope.payButton = 'paynnow_y';
	                        return $locale.content.get('memberReview.payLabel');
	                    }
	                } else {
	                    $scope.payButton = 'paynnow_n';
	                    return $locale.content.get('memberReview.continueLabel');
	                }
	            };
	
	            $scope.onRedeemGC = function () {
	                throw new $FallbackError({
	                    reason: 'redeem_coupon_feature_not_supported',
	                    product: 'ux'
	                });
	            };
	
	            // Check if processor decline message needs to be set
	            setProcessorDeclineMessage();
	
	            var isButtonBelowScreen = function isButtonBelowScreen() {
	                var $button = $element.find('#button')[0];
	                var $windowElement = (0, _jquery2['default'])(window)[0];
	
	                if (!$button) {
	                    return;
	                }
	
	                var windowTop = $windowElement.scrollY;
	                var windowBottom = windowTop + $windowElement.screen.height;
	
	                var buttonTop = windowTop + $button.getBoundingClientRect().top;
	                var buttonBottom = buttonTop + $button.offsetHeight;
	
	                return !(buttonBottom <= windowBottom && buttonTop >= windowTop);
	            };
	
	            $scope.showFixedButton = function () {
	                return allowFixedButton && showButtonPxp && isButtonBelowScreen();
	            };
	
	            $timeout(function () {
	                if (!allowFixedButton) {
	                    return false;
	                }
	
	                if ($scope.showFixedButton()) {
	                    _logger.$logger.info('button_below_screen', {
	                        fpti_fixed_button_pxp: 'test'
	                    });
	                } else if (isButtonBelowScreen() && !showButtonPxp) {
	                    _logger.$logger.info('button_below_screen', {
	                        fpti_fixed_button_pxp: 'control'
	                    });
	                }
	            }, 500);
	
	            if (allowFixedButton && showButtonPxp) {
	                (0, _jquery2['default'])(window).bind('scroll', function () {
	                    $scope.$apply();
	                });
	            }
	
	            $scope.$on('$destroy', function () {
	                (0, _jquery2['default'])(window).unbind('scroll');
	            });
	
	            $scope.promotion = {
	                type: null,
	                name: ''
	            };
	
	            var plccOffer = $scope.checkoutSession.plccOffer;
	
	            if (plccOffer) {
	                $scope.promotion.logoUrl = plccOffer.product_logo;
	                $scope.promotion.name = plccOffer.product_name;
	            }
	
	            $scope.onFBBANotNow = function () {
	                window.xchild.close();
	            };
	
	            $scope.onPay = function (result) {
	
	                if (!isValidPinSetup()) {
	                    $scope.topupError = true;
	                    return;
	                }
	
	                if ($scope.checkoutSession.installments && $scope.checkoutSession.installments.length > 1 && !$scope.checkoutSession.selectedInstallmentData) {
	                    $scope.installmentNotSelected = true;
	                    return;
	                }
	
	                if ($scope.isInstantUpdateAPIFlow && !$scope.instantUpdateFeature.shippingRegionSupported) {
	                    return;
	                }
	
	                _logger.$logger.info('checkout_fpti', {
	                    'ryp_button_text': $scope.payButton
	                });
	
	                if ($feature('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.installment.showCYCO && $scope.creditOptions && !$scope.creditOptions.creditType) {
	                    return $state.go('checkout.chooseCreditOffer');
	                }
	                // Address Normalization Checks
	                if ($scope.checkoutAppData.get('flags.allow_change_shipping', false) && $feature('shippingAddressNormalization') && $scope.checkoutSession.get('shipping.normalization_status') === 'UNKNOWN') {
	
	                    return $state.go('checkout.review.sidebar.updateShipping');
	                }
	
	                var padToggleStatus = getPadToggleStatus();
	
	                if (padToggleStatus === 'ON') {
	                    _logger.$logger.info('checkout_fpti', {
	                        'pad_toggle_status': 'padToggleOnSubmit'
	                    });
	                } else if (padToggleStatus === 'OFF') {
	                    _logger.$logger.info('checkout_fpti', {
	                        'pad_toggle_status': 'padToggleOffSubmit'
	                    });
	                }
	
	                /* Call patchCvv first, if error, need buyers to input again */
	                /* Call to set Sticky Funding Instrument for Billing Agreement.
	                 *  We have to ensure the sticky call happens before authorize due to symphony spec.*/
	                /* We need to wait for the response from updateAddressAsPreferred before calling authorize */
	
	                return updateFS().then(function () {
	                    return setTokenizedWalletPin();
	                }).then(function () {
	                    return $fiApis.patchCvv($scope.checkoutSession);
	                }).then(function () {
	                    return _angular.$q.all([setWalletTopupPreferences(), setStickyInstrument(), updateAddressAsPreferred(), $scope.actions.updatePreferredFi(_logger.$logger)])['catch'](function (err) {
	                        // should we have more elaborate error handling here?
	                        _logger.$logger.error('onPay() error', err);
	                    })['finally'](function () {
	                        return authorize();
	                    });
	                }, function (err) {
	                    if (err.message === 'ISSUANCE_PIN_SERVICE_ERROR') {
	                        _logger.$logger.debug('ISSUANCE_PIN_SERVICE_ERROR:', err);
	                        throw err;
	                    }
	                    _logger.$logger.error('onPay() patchCvv error', err);
	                });
	            };
	
	            /* This is used for a BML 'popup' that opens covering the whole review page,
	             hiding the rest of the review page when its open. */
	            $scope.bmlPopupOpen = false;
	
	            $scope.showBmlPopup = function () {
	                $scope.bmlPopupOpen = true;
	            };
	
	            $scope.hideBmlPopup = function () {
	                $scope.bmlPopupOpen = false;
	            };
	        });
	        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCredit');
	        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
	
	        $scope.onComplete = function (params) {
	            if (params) {
	                _logger.$logger.debug('ryi_optin_isKmliSet_' + params.isKmliSet);
	                if (params.isKmliSet) {
	                    $scope.optin_toggle.setValue(true);
	                }
	            }
	            $state.go('checkout.review');
	        };
	        $scope.propValueObj = {};
	        if ($feature('propValue')) {
	            $scope.propValueObj.propHeader = 'memberReview.propHead';
	            $scope.propValueObj.propVal = 'memberReview.propVal';
	            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png';
	        } else {
	            $scope.propValueObj.propHeader = 'login.propHeadAlt';
	            $scope.propValueObj.propVal = 'login.propValAlt';
	            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png';
	        }
	    }
	});
	
	angular.value("$xoReviewPageComponent", $xoReviewPageComponent);
	_angular.$q;
	
	_squid.formatCurrency;
	
	_squid.$Component;
	
	_squid.formatNameInformal;
	
	_integration.$integration;
	
	_index.$UserPhotoModel;
	
	_fi.$PreferredFi;
	
	_choice.$ChoiceEligibility;
	
	_logger.$logger;
	
	_ul.$ul;
	
	_venmoInfo.venmoExperience;

/***/ },

/***/ "./components/xo-form-components/src/select-shipping-method/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/shippingMethod/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/modal/directive.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _template = __webpack_require__("./components/xo-form-components/src/select-shipping-method/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _util = __webpack_require__("./components/xo-form-components/lib/util.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var callbackShippingOptions = void 0,
	    fallbackShippingOptions = void 0,
	    callbackInsuranceOffered = void 0;
	var defaultFallbackOptionIndex = void 0;
	
	exports['default'] = _squid.$Component.extend('$xoSelectShippingMethod', {
	    tag: 'xo-select-shipping-method',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        showShippingAddress: {
	            type: 'var'
	        },
	        errorHandlerHelper: {
	            type: 'var'
	        },
	        instantUpdateFeature: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
	                checkoutPayee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
	                checkoutShippingAddresses: _index2.$CheckoutShippingAddressesModel.instance(this.props.token).retrieve(),
	                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        closeModal: function closeModal() {
	            this.showModal = false;
	        },
	        openModal: function openModal() {
	            this.showModal = true;
	        },
	        continueHandler: function continueHandler() {
	
	            /**
	             * Function responsible to patch Cart for
	             * 1. Buyer select's a new shipping method.
	             * 2. Buyer chooses to opt for insurance or chooses not to.
	             */
	            if (this.selectedMethod.current.index !== this.selectedMethod.previous.index || this.selectedMethod.current.insuranceSelected !== this.selectedMethod.previous.insuranceSelected) {
	
	                var selectedMethodCharges = void 0,
	                    taxAmtApplied = void 0,
	                    insurance = void 0;
	                selectedMethodCharges = this.response.charges[this.selectedMethod.current.index];
	                taxAmtApplied = this.getTax(selectedMethodCharges);
	                insurance = this.getInsurance(selectedMethodCharges);
	                this.shippingAmtApplied = this.safeConvert(selectedMethodCharges.shipping_charge.shipping_amount.value);
	                if (this.isInstantUpdateFlow) {
	                    this.selectedMethod.showInsuranceAmount = this.selectedMethod.current.insuranceSelected;
	                    this.insuranceApplied = insurance;
	                    this.updateSelectedExternalCallbackOption(this.response.shipping_options_source, this.selectedMethod.previous.index, this.selectedMethod.current.index);
	                    this.selectedMethod.previous.insuranceSelected = this.selectedMethod.current.insuranceSelected;
	                }
	                this.updateShippingTaxCharge(this.shippingAmtApplied, taxAmtApplied, selectedMethodCharges.shipping_charge.shipping_method_type, insurance);
	                this.selectedShippingMethod = (0, _util.decodeEntities)(selectedMethodCharges.shipping_charge.shipping_method);
	                this.selectedMethod.previous.index = this.selectedMethod.current.index;
	            }
	
	            this.actions.closeModal();
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.decodeEntities = _util.decodeEntities;
	            this.selectedMethod = {
	                current: {
	                    index: 0,
	                    insuranceSelected: false
	                },
	                previous: {
	                    index: 0,
	                    insuranceSelected: false
	                },
	                insuranceAvailable: false,
	                showInsuranceAmount: false
	            };
	
	            // Initialization
	            this.showModal = false;
	            this.shippingInfoDisplay = 'noHighlight';
	            this.addressChanged = false;
	
	            var timer = void 0;
	            this.previousCosts = {};
	
	            // Function used to format amount based on currency code
	            this.formatAmount = function (amount) {
	                if (amount && amount.value) {
	                    var amountToBeFormatted = (parseInt(amount.value.toString(), 10) / 100).toFixed(2);
	                    if (amountToBeFormatted) {
	                        return (0, _squid.formatCurrency)(amountToBeFormatted, _this.currencyCode);
	                    }
	                }
	            };
	
	            this.uncheckInsuranceCheckbox = function () {
	                _this.selectedMethod.current.insuranceSelected = false;
	            };
	
	            this.showInsurance = function (selectedIndex) {
	                return Number(_this.selectedMethod.current.index) === selectedIndex;
	            };
	
	            // Function to check if is insurance is offered for a shipping charge
	            this.isInsuranceOfferedInCharge = function (charge) {
	                return charge.shipping_charge.offer_insurance_option;
	            };
	
	            var responseHasShippingCharges = function responseHasShippingCharges() {
	                if (_this.response.charges.length === 0) {
	                    return false;
	                }
	                return !!_this.response.charges[0].shipping_charge;
	            };
	
	            var responseHasTaxCharges = function responseHasTaxCharges() {
	                if (_this.response.charges.length === 0) {
	                    return false;
	                }
	                return !!_this.response.charges[0].tax;
	            };
	
	            this.safeConvert = function (value) {
	                value = Number(value);
	                if (isNaN(value)) {
	                    throw new Error(value + ' cannot be divided');
	                }
	                return value / 100;
	            };
	
	            /*
	             This function is responsible to update the previously selected external callback option to newly selected one.
	             */
	            this.updateSelectedExternalCallbackOption = function (optionsSource, prevIndex, index) {
	                if (optionsSource === 'CALLBACK' && callbackShippingOptions) {
	                    if (!isNaN(prevIndex)) {
	                        callbackShippingOptions[prevIndex].is_selected = false;
	                    }
	                    callbackShippingOptions[index].is_selected = true;
	                } else if (optionsSource === 'FALLBACK' && fallbackShippingOptions) {
	                    if (!isNaN(prevIndex)) {
	                        fallbackShippingOptions[prevIndex].is_selected = false;
	                    }
	                    fallbackShippingOptions[index].is_selected = true;
	                }
	            };
	
	            var highlight = function highlight(duration) {
	                _this.shippingInfoDisplay = 'highlight';
	                if (timer) {
	                    _angular.$timeout.cancel(timer);
	                }
	                timer = (0, _angular.$timeout)(function () {
	                    _this.shippingInfoDisplay = 'noHighlight';
	                }, duration);
	            };
	
	            this.getTax = function (charge) {
	                var tax = void 0;
	                if (!_this.isInstantUpdateFlow && (_this.isBuyNow || _this.isCartUpload) && _this.cartAmounts.taxAmt >= 0) {
	                    tax = _this.cartAmounts.taxAmt;
	                }
	                // tax calculation
	                else {
	                        charge = charge || responseHasTaxCharges() && _this.response.charges[0];
	                        if (charge && charge.tax && charge.tax.total_tax) {
	                            tax = _this.safeConvert(charge.tax.total_tax.value);
	                        }
	                    }
	                return tax;
	            };
	
	            /**
	             * Function to return the insurance from shipping charge.
	             * 1. By default return insurance amount from the charge.
	             * 2. In case insurance is offered and is not chosen , do not return the insurance amount.
	             * @param charge - shipping charge
	             * @param index - index of the shipping charge
	             */
	            this.getInsurance = function (charge) {
	                if (charge && charge.shipping_charge && charge.shipping_charge.insurance_amount) {
	                    if (charge.shipping_charge.offer_insurance_option && !_this.selectedMethod.current.insuranceSelected) {
	                        return;
	                    }
	                    return _this.safeConvert(charge.shipping_charge.insurance_amount.value);
	                }
	            };
	
	            var updatePreviousCosts = function updatePreviousCosts() {
	                _this.previousCosts = {};
	                if (_this.models.checkoutCart.purchase.amounts.shipping) {
	                    _this.previousCosts.shippingAmount = _this.models.checkoutCart.purchase.amounts.shipping.amount;
	                }
	                if (_this.models.checkoutCart.purchase.amounts.tax) {
	                    _this.previousCosts.taxAmount = _this.models.checkoutCart.purchase.amounts.tax.amount;
	                }
	            };
	
	            var hasShippingCostChanged = function hasShippingCostChanged(newShipping) {
	                if (newShipping !== undefined) {
	                    return newShipping.amount !== _this.previousCosts.shippingAmount;
	                }
	                return newShipping !== _this.previousCosts.shippingAmount;
	            };
	
	            var hasTaxCostChanged = function hasTaxCostChanged(newTax) {
	                if (newTax !== undefined) {
	                    return newTax.amount !== _this.previousCosts.taxAmount;
	                }
	                return newTax !== _this.previousCosts.taxAmount;
	            };
	
	            var setToolTipMessage = function setToolTipMessage() {
	                _this.models.checkoutSession.message.msgKeys = hasShippingCostChanged(_this.models.checkoutCart.purchase.amounts.shipping) || hasTaxCostChanged(_this.models.checkoutCart.purchase.amounts.tax) ? ['smallToolTip.addressShippingChargesUpdated'] : ['smallToolTip.onlyAddressUpdated'];
	            };
	
	            var addExternalCallBackOptionsToPatchRequest = function addExternalCallBackOptionsToPatchRequest(patchEntities) {
	                var externalCallbackOptions = _this.models.checkoutCart.purchaseUnits[0].external_callback_options;
	                if (_this.response.shipping_options_source === 'CALLBACK') {
	                    externalCallbackOptions.callback_shipping_options = callbackShippingOptions;
	                    externalCallbackOptions.callback_insurance_option_offered = callbackInsuranceOffered;
	                } else if (_this.response.shipping_options_source === 'FALLBACK') {
	                    externalCallbackOptions.fallback_shipping_options = fallbackShippingOptions;
	                }
	                patchEntities.push({
	                    field: 'externalCallbackOptions',
	                    value: externalCallbackOptions
	                });
	            };
	
	            var populatePatchShippingDetails = function populatePatchShippingDetails(patchEntities, shipMethod) {
	                if (_this.isInstantUpdateFlow) {
	                    addExternalCallBackOptionsToPatchRequest(patchEntities);
	                } else {
	                    patchEntities.push({
	                        field: 'shippingMethod',
	                        value: shipMethod ? _this.shippingMethods.getShippingMethodId(shipMethod) : ''
	                    });
	                }
	            };
	
	            var populatePatchAmountDetails = function populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts) {
	                var newTotal = _this.cartAmounts.total;
	                Object.keys(patchableAmountEntities).forEach(function (key) {
	                    var detail = patchableAmountEntities[key];
	                    if (!isNaN(detail.value)) {
	                        detail.value = Number(detail.value);
	                        amounts.details[key] = detail.value.toFixed(decimalDigits);
	                    } else {
	                        detail.value = 0;
	                    }
	                    newTotal += detail.valueInCart ? detail.value - detail.valueInCart : detail.value;
	                });
	                amounts.total = newTotal.toFixed(decimalDigits);
	                Object.keys(constantAmountEntities).forEach(function (key) {
	                    var detail = constantAmountEntities[key];
	                    if (detail.valueInCart !== undefined) {
	                        amounts.details[key] = detail.valueInCart.toFixed(decimalDigits);
	                    }
	                });
	            };
	
	            // Generates the request body to be used for patch Cart
	            var getPatchReqData = function getPatchReqData(shippingAmt, taxAmt, shipMethod, insuranceAmt) {
	                // 1. amount values in the cart,
	                // 2. shipping method (only in case of non instant update flows)
	                // 3. external_callback_options (only in case of instant update flows)
	
	                var currencyDigits = _squid.$locale.metadata && _squid.$locale.metadata.currency && _squid.$locale.metadata.currency.digits;
	                var decimalDigits = currencyDigits && currencyDigits[_this.currencyCode];
	                if (isNaN(decimalDigits)) {
	                    decimalDigits = 2;
	                }
	                var patchEntities = [];
	                var amounts = {
	                    'currency': _this.currencyCode,
	                    'details': {
	                        'subtotal': _this.cartAmounts.subTotal.toFixed(decimalDigits)
	                    }
	                };
	                var patchableAmountEntities = {
	                    shipping: {
	                        value: shippingAmt,
	                        valueInCart: _this.cartAmounts.shippingAmt
	                    },
	                    tax: {
	                        value: taxAmt,
	                        valueInCart: _this.cartAmounts.taxAmt
	                    },
	                    insurance: {
	                        value: insuranceAmt,
	                        valueInCart: _this.cartAmounts.insuranceAmt
	                    }
	                };
	
	                // amount details which are not affected by SnT response,
	                // but still need to get included in the patch request if initially present
	                var constantAmountEntities = {
	                    handling_fee: {
	                        valueInCart: _this.cartAmounts.handlingAmt
	                    },
	                    shipping_discount: {
	                        valueInCart: _this.cartAmounts.shippingDiscountAmt
	                    },
	                    discount: {
	                        valueInCart: _this.cartAmounts.discountAmt
	                    }
	                };
	                populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts);
	
	                patchEntities.push({
	                    field: 'purchaseAmount',
	                    value: amounts
	                });
	
	                populatePatchShippingDetails(patchEntities, shipMethod);
	
	                return {
	                    id: _this.token,
	                    patchEntities: patchEntities
	                };
	            };
	
	            this.updateShippingTaxCharge = function (shippingAmt, taxAmt, shipMethod, insurance) {
	                _this.models.checkoutCart.action('patchCartData', {
	                    data: getPatchReqData(shippingAmt, taxAmt, shipMethod, insurance),
	                    success: function success(result) {
	                        _this.models.checkoutSession.invalidate();
	                        (0, _squid.$populate)(_this, {
	                            checkoutSession: _index2.$CheckoutSessionModel.instance(_this.token)
	                        }).then(function () {
	                            highlight(4000);
	                            if (_this.addressChanged) {
	                                setToolTipMessage();
	                                _this.addressChanged = false;
	                            }
	                            updatePreviousCosts();
	                        });
	                    }
	                });
	            };
	
	            var populateCallbackShippingOptions = function populateCallbackShippingOptions() {
	                var charges = _this.response && _this.response.charges;
	                if (charges) {
	                    callbackShippingOptions = charges.map(function (charge, index) {
	                        var shippingCharge = charge.shipping_charge;
	                        var taxCharge = charge.tax;
	                        var option = {};
	                        if (shippingCharge) {
	                            option = {
	                                method: shippingCharge.shipping_method,
	                                amount: {
	                                    value: _this.safeConvert(shippingCharge.shipping_amount.value),
	                                    currency: shippingCharge.shipping_amount.currency_code
	                                },
	                                is_default: shippingCharge.default_method,
	                                is_selected: false
	                            };
	                            if (shippingCharge.insurance_amount) {
	                                option.insurance = {
	                                    value: _this.safeConvert(shippingCharge.insurance_amount.value),
	                                    currency: shippingCharge.insurance_amount.currency_code
	                                };
	                                callbackInsuranceOffered = true;
	                            }
	                            if (taxCharge) {
	                                option.tax = {
	                                    value: _this.safeConvert(taxCharge.total_tax.value),
	                                    currency: taxCharge.total_tax.currency_code
	                                };
	                            }
	                        }
	                        return option;
	                    });
	                }
	            };
	
	            var setDefaultShippingMethod = function setDefaultShippingMethod() {
	                _this.showShippingOptions = true;
	                var chargesElement = void 0,
	                    methodType = void 0,
	                    taxAmtApplied = void 0,
	                    insurance = void 0;
	                for (var i = 0; i < _this.response.charges.length; i++) {
	                    chargesElement = _this.response.charges[i];
	                    if (chargesElement.shipping_charge.default_method) {
	                        _this.selectedMethod.current.index = i;
	                        _this.selectedMethod.previous.index = i;
	                        insurance = _this.getInsurance(chargesElement);
	                        if (_this.isInstantUpdateFlow) {
	                            _this.updateSelectedExternalCallbackOption(_this.response.shipping_options_source, _this.selectedMethod.previous.index, _this.selectedMethod.current.index);
	                        }
	                        _this.selectedShippingMethod = (0, _util.decodeEntities)(chargesElement.shipping_charge.shipping_method);
	                        methodType = chargesElement.shipping_charge.shipping_method_type;
	                        _this.shippingAmtApplied = _this.safeConvert(chargesElement.shipping_charge.shipping_amount.value);
	
	                        taxAmtApplied = _this.getTax(chargesElement);
	
	                        insurance = _this.getInsurance(chargesElement);
	
	                        break;
	                    }
	                }
	                _this.updateShippingTaxCharge(_this.shippingAmtApplied, taxAmtApplied, methodType, insurance);
	            };
	
	            var isPatchCartRequired = function isPatchCartRequired(applicableShippingAmt, applicableTaxAmt) {
	                return applicableShippingAmt !== _this.previousCosts.shippingAmount || applicableTaxAmt !== _this.previousCosts.taxAmount;
	            };
	
	            // Find the charges of the default option and patch cart with corresponding values.
	            var updateShippingTaxChargeWithDefaultOption = function updateShippingTaxChargeWithDefaultOption() {
	                var defaultOption = void 0,
	                    shippingAmt = void 0,
	                    taxAmt = void 0,
	                    insuranceAmt = void 0,
	                    methodType = void 0;
	                if (_this.response.shipping_options_source === 'FALLBACK' && !isNaN(defaultFallbackOptionIndex)) {
	                    defaultOption = fallbackShippingOptions[defaultFallbackOptionIndex];
	                }
	                if (defaultOption) {
	                    shippingAmt = defaultOption.amount && defaultOption.amount.value;
	                    taxAmt = defaultOption.tax && defaultOption.tax.value;
	                    insuranceAmt = defaultOption.insurance && defaultOption.insurance.value;
	                    methodType = defaultOption.shipping_method_type || 'DEFAULT';
	                }
	                _this.updateShippingTaxCharge(shippingAmt, taxAmt, methodType, insuranceAmt);
	            };
	
	            /**
	             Function to enable the link to select insurance's by the user if offered in charges
	             */
	            var enableUserToChooseInsuranceOptionsIfAvailable = function enableUserToChooseInsuranceOptionsIfAvailable() {
	                var charges = _this.response && _this.response.charges;
	                if (!charges) {
	                    return;
	                }
	                for (var i = 0; i < charges.length; i++) {
	                    if (_this.isInsuranceOfferedInCharge(charges[i])) {
	                        _this.selectedMethod.insuranceAvailable = true;
	                        _this.selectedMethod.showInsuranceAmount = false;
	                        break;
	                    }
	                }
	            };
	
	            /*  Function which is responsible to process shipping tax response
	             Use cases
	             ---------
	             1. (i) WPS: If response has shipping charges and shipping options are to be shown, set default shipping method else patch cart
	             with shipping amount returned.
	             (ii)Instant Update: If the shipping region is unsupported, display error message. Otherwise the above behavior applies.
	             2. If no_shipping = 1
	             (i) WPS:  If profile_override = true , apply shipping from button if it is not empty.
	             (ii) Instant Update: Do not display the shipping options. Apply the default fallback(or callback) shipping option charges.
	             3. Apply tax if applicable.
	             */
	            var processShippingAndTaxResponse = function processShippingAndTaxResponse() {
	
	                var applicableShippingAmt = void 0,
	                    applicableTaxAmt = void 0;
	
	                if (_this.isInstantUpdateFlow) {
	                    if (!_this.response.shipping_region_supported) {
	                        _this.errorHandlerHelper.addPageError('shippingMethod.shippingRegionUnsupported', { merchant: _this.merchant });
	                        _this.instantUpdateFeature.shippingRegionSupported = false;
	                    }
	
	                    if (_this.response.shipping_options_source === 'CALLBACK') {
	                        populateCallbackShippingOptions();
	                    }
	
	                    enableUserToChooseInsuranceOptionsIfAvailable();
	
	                    // no_shipping = 0
	                    if (_this.showShippingAddress) {
	                        if (responseHasShippingCharges()) {
	                            setDefaultShippingMethod();
	                        }
	                    }
	                    // no_shipping=1 in case of instant update api , hide the overlay, shipping and tax from default fallback or callback options should be applied
	                    else {
	                            _this.showShippingOptions = false;
	                            updateShippingTaxChargeWithDefaultOption();
	                        }
	                    return;
	                }
	
	                // shipping calculation
	                if (_this.showShippingAddress) {
	                    if (responseHasShippingCharges()) {
	                        if (_this.response.show_shipping_options) {
	                            setDefaultShippingMethod(); // setDefaultShippingMethod takes care of both shipping and tax
	                            return;
	                        } else {
	                            applicableShippingAmt = _this.safeConvert(_this.response.charges[0].shipping_charge.shipping_amount.value);
	                        }
	                    }
	                }
	                // when not instant update flow , no_shipping is 1, shipping is applied only when override is true and shipping is passed in button
	                else if (_this.response.profile_override_allowed) {
	                        if (_this.cartAmounts.shippingAmt !== undefined) {
	                            applicableShippingAmt = _this.cartAmounts.shippingAmt;
	                        }
	                    }
	
	                applicableTaxAmt = _this.getTax();
	
	                if (isPatchCartRequired(applicableShippingAmt, applicableTaxAmt)) {
	                    _this.updateShippingTaxCharge(applicableShippingAmt, applicableTaxAmt);
	                }
	            };
	
	            var clearFallbackOptionsSelectionFlags = function clearFallbackOptionsSelectionFlags() {
	                for (var i = 0; i < fallbackShippingOptions.length; i++) {
	                    fallbackShippingOptions[i].is_selected = false;
	                }
	            };
	
	            this.getShippingMethods = function () {
	                _this.showShippingOptions = false;
	                _this.selectedShippingMethod = '';
	                _this.shippingAmtApplied = 0;
	                _this.insuranceAmountOffered = 0;
	                _this.response = {};
	
	                // when no_shipping = 1, checkoutSession,shipping is undefined. Primary address is considered for SnT as per legacy
	                var shippingAddress = _this.models.checkoutSession.shipping ? _this.models.checkoutSession.getShippingAddressMinimalDetails() : _this.models.checkoutShippingAddresses.getPrimaryShippingAddress();
	
	                var sntRequest = {
	                    'address': shippingAddress,
	                    'cart_weight': _this.cartWeight,
	                    'cart_handling': { value: _this.cartAmounts.handlingAmt, currency_code: _this.currencyCode },
	                    'discount': _this.cartDiscount,
	                    'item_list': _this.models.checkoutCart.purchase.items,
	                    'tax_on_shipping_required': _this.showShippingAddress, //    tax on shipping is not applicable when no_shipping is 1
	                    'merchant_id': _this.models.checkoutPayee.merchant.id,
	                    'locale': _squid.$locale.content.lang + '_' + _squid.$locale.chosenCountry,
	                    'currency_code': _this.currencyCode
	                };
	
	                if (_this.isInstantUpdateFlow) {
	                    _this.selectedMethod = {
	                        current: {
	                            index: 0,
	                            insuranceSelected: false
	                        },
	                        previous: {
	                            index: 0,
	                            insuranceSelected: false
	                        },
	                        insuranceAvailable: false,
	                        showInsuranceAmount: false
	                    };
	                    callbackShippingOptions = [];
	                    callbackInsuranceOffered = false;
	                    clearFallbackOptionsSelectionFlags();
	                    _this.instantUpdateFeature.shippingRegionSupported = true;
	                    _this.errorHandlerHelper.clearPageErrors();
	
	                    if (_this.models.checkoutCart.purchaseUnits && _this.models.checkoutCart.purchaseUnits[0]) {
	                        sntRequest.external_callback_options = _this.models.checkoutCart.purchaseUnits[0].external_callback_options;
	                    }
	                }
	
	                _this.shippingMethods = new _index.$ShippingMethodModel(sntRequest);
	
	                _logger.$logger.info('calculate_shipping_charges_call');
	                _this.shippingMethods.save({
	                    data: _this.shippingMethods,
	                    success: function success(result) {
	                        _this.response = result;
	                        processShippingAndTaxResponse();
	                    }
	                });
	            };
	        },
	        populate: function populate() {
	            var _this2 = this;
	
	            var set = function set(key, value) {
	                if (value) {
	                    _this2.cartAmounts[key] = Number(value.amount);
	                }
	            };
	
	            function hasAddressChanged(newValue, oldValue) {
	                // only these values determine if the shiptax service needs to be called again
	                return newValue.country !== oldValue.country || newValue.state !== oldValue.state || newValue.city !== oldValue.city || newValue.postal_code !== oldValue.postal_code;
	            }
	
	            this.currencyCode = this.models.checkoutCart.purchase.amounts.total.currency_code;
	
	            var appDataFlags = this.models.checkoutAppData && this.models.checkoutAppData.flags;
	
	            var merchant = this.models.checkoutAppData && this.models.checkoutAppData.merchant;
	
	            this.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	
	            this.isBuyNow = appDataFlags && appDataFlags.is_buy_now_flow;
	
	            this.isCartUpload = appDataFlags && appDataFlags.is_cart_upload_flow;
	
	            this.isInstantUpdateFlow = this.models.checkoutCart && this.models.checkoutCart.instantUpdateIntegration;
	
	            if (this.isInstantUpdateFlow) {
	                fallbackShippingOptions = this.models.checkoutCart.purchaseUnits[0].external_callback_options.fallback_shipping_options;
	                if (fallbackShippingOptions) {
	                    defaultFallbackOptionIndex = fallbackShippingOptions.findIndex(function (option) {
	                        return option.is_default;
	                    });
	                }
	            }
	
	            this.cartAmounts = {};
	            set('shippingAmt', this.models.checkoutCart.purchase.amounts.shipping);
	            set('taxAmt', this.models.checkoutCart.purchase.amounts.tax);
	            set('subTotal', this.models.checkoutCart.purchase.amounts.subtotal);
	            set('total', this.models.checkoutCart.purchase.amounts.total);
	            set('handlingAmt', this.models.checkoutCart.purchase.amounts.handling_fee);
	            set('insuranceAmt', this.models.checkoutCart.purchase.amounts.insurance);
	            set('shippingDiscountAmt', this.models.checkoutCart.purchase.amounts.shipping_discount);
	            set('discountAmt', this.models.checkoutCart.purchase.amounts.discount);
	            this.previousCosts = {
	                shippingAmount: this.models.checkoutCart.purchase.amounts.shipping ? Number(this.models.checkoutCart.purchase.amounts.shipping.amount) : undefined,
	                taxAmount: this.models.checkoutCart.purchase.amounts.tax ? Number(this.models.checkoutCart.purchase.amounts.tax.amount) : undefined
	            };
	
	            if (this.models.checkoutCart.cartWeight) {
	                this.cartWeight = {};
	                if (this.models.checkoutCart.cartWeight.value) {
	                    this.cartWeight.value = Number(this.models.checkoutCart.cartWeight.value).toFixed(2);
	                }
	                this.cartWeight.unit = this.models.checkoutCart.cartWeight.unit;
	            }
	
	            if (this.models.checkoutCart.purchase.amounts.discount) {
	                this.cartDiscount = {
	                    value: Number(this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2),
	                    currency_code: this.currencyCode
	                };
	            }
	
	            if (this.showShippingAddress) {
	                this.$watch('this.models.checkoutSession.shipping', function (newValue, oldValue) {
	                    if (hasAddressChanged(newValue, oldValue)) {
	                        _this2.addressChanged = true;
	                        _this2.getShippingMethods();
	                    }
	                });
	            }
	            this.getShippingMethods();
	        }
	    }
	});
	
	
	_angular.$timeout;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$populate;
	
	_squid.formatCurrency;
	
	_index.$ShippingMethodModel;
	
	_index2.$CheckoutSessionModel;
	
	_index2.$CheckoutPayeeModel;
	
	_index2.$CheckoutCartModel;
	
	_index2.$CheckoutShippingAddressesModel;
	
	_index2.$CheckoutAppDataModel;
	
	_logger.$logger;
	
	_util.decodeEntities;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-ui-components/src/modal/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-ui-components/src/modal/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Directives used in the template
	(0, _squid.$registerDirective)('xoModal', function () {
	    return {
	        template: _template2['default'],
	        restrict: 'E',
	        replace: true,
	        transclude: true,
	
	        scope: {
	            show: '=?',
	            showCloseButton: '=?',
	            onClose: '=?',
	            overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
	        },
	
	        controller: function controller($scope) {
	            $scope.hideModal = function ($event) {
	                if ($event) {
	                    $event.preventDefault();
	                }
	
	                $scope.show = false;
	
	                if ($scope.onClose) {
	                    $scope.onClose();
	                }
	            };
	        }
	    };
	});
	
	_squid.$registerDirective;

/***/ },

/***/ "./components/xo-ui-components/src/modal/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"modal-wrapper\" ng-show='show' content>\n\t<div class=\"modal-overlay\" ng-click=\"hideModal()\"></div>\n\t<div class=\"modal-dialog\" modal-box modal-cancel=\"hideModal()\">\n\t\t<div class=\"modal-content\" ng-class=\"{'modal-default': !overrideDefaultContainer}\" tabindex=\"-1\" focus-when=\"show\">\n\t\t\t<div ng-transclude>\n\t\t\t</div>\n\t\t\t<a link-button ng-if=\"showCloseButton\" ng-click=\"hideModal($event)\" class=\"close\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ },

/***/ "./components/xo-form-components/src/select-shipping-method/template.html":
/***/ function(module, exports) {

	module.exports = "<span id=\"selectShippingMethod\" content>\n    <div id=\"selectShippingMethodContainer\" ng-if=\"showShippingOptions\">\n        <div id=\"storePickUpDetails\" ng-if=\"models.checkoutCart.isShippingMethodStorePickUp()\">\n            <hr class=\"lightHR\">\n            <div class=\"shipTo\">{{ content('shippingMethod.shipTo') }}</div>\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <div id=\"shippingInformation\">\n            <div id=\"methodCharges\" ng-class=\"shippingInfoDisplay\">\n                <span class=\"shippingText\">{{ content('shippingMethod.shipping') }}:</span>\n            <span>\n                <a id=\"shippingMethodCharge\" class=changeShippingMethod href=\"#\"  aria-label=\"{{ content('shippingMethod.selectMethod')}}\" ng-click=\"actions.openModal()\">\n                    <span class=\"selectedShippingMethod\">{{selectedShippingMethod}} - </span>\n                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"shippingAmtApplied\"></format-currency>\n                </a>\n            </span>\n            </div>\n            <div id=\"insuranceInfo\" ng-if=\"selectedMethod.insuranceAvailable\" ng-class=\"shippingInfoDisplay\">\n                <span class=\"insuranceText\">{{ content('shippingMethod.shippingInsurance') }}:</span>\n            <span>\n                <a id=\"insuranceNoneApplied\" ng-if=\"!selectedMethod.showInsuranceAmount\" class=changeInsurance href=\"#\" aria-label=\"{{ content('shippingMethod.insuranceNoneSelected') }}\" ng-click=\"actions.openModal()\">\n                    <span class=\"noInsuranceOption\"> {{ content('shippingMethod.insuranceNoneSelected')}}</span>\n                </a>\n                <a id=\"insuranceAmtOffered\" ng-if=\"selectedMethod.showInsuranceAmount\" class=changeInsurance href=\"#\" aria-label=\"{{ content('shippingMethod.shippingInsurance') }}\" ng-click=\"actions.openModal()\">\n                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"insuranceApplied\"></format-currency>\n                </a>\n            </span>\n            </div>\n        </div>\n        <xo-modal show=showModal>\n            <div class=\"shippingMethodsContainer\">\n                <a href=\"#\" ng-click=\"actions.closeModal()\" class=\"close closeModal\">&nbsp;</a>\n                <div>\n                    <div class=\"shippingOptions\">\n                        <span class=\"shippingHeader\" id=\"shippingHeader1\">{{ content('shippingMethod.selectMethod') }}</span>\n                        <span class=\"gamma\" id=\"shippingHeader2\">{{ content('shippingMethod.merchantOptions') }}</span>\n                        <br>\n                        <div>\n                            <div ng-repeat=\"charge in response.charges\">\n                                <div class=\"row-fluid radioButton\">\n                                    <input type=\"radio\" name=\"shippingMethodRadioButton\" id=\"{{$index}}\" value=\"{{$index}}\" ng-model=\"selectedMethod.current.index\" ng-change=\"isInstantUpdateFlow && uncheckInsuranceCheckbox()\"/>\n                                    <label class=\"noBottom\" for=\"{{$index}}\">\n                                            <span class=\"methodContents\">\n                                        <span>\n                                            <span>\n                                                <span class=\"methodName\">\n                                                    {{decodeEntities(charge.shipping_charge.shipping_method)}} -\n                                                </span>\n                                                <span class=\"shippingCharge\">\n                                                    <format-currency class=\"formatCurrency\" code=\"currencyCode\" amount=\"charge.shipping_charge.shipping_amount.value / 100\"></format-currency>\n                                                </span>\n                                            </span>\n                                            <span class=\"deliveryTime\">\n                                                {{charge.shipping_charge.delivery_time}}\n                                            </span>\n                                            <span class=\"description animate-show\" ng-if=\"shippingMethods.isStorePickUp(charge.shipping_charge.shipping_method_type)\" ng-show=\"selectedMethod.current.index == $index\">\n                                                {{ content('shippingMethod.storeLocationInfo') }}\n                                            </span>\n                                        </span>\n                                        <span ng-if=\"charge.shipping_charge.offer_insurance_option\" ng-show=\"showInsurance($index)\" class=\"insuranceOfferedInOption checkbox\">\n                                            <input ng-model=\"selectedMethod.current.insuranceSelected\" type=\"checkbox\" id=\"insurance\" value=\"false\">\n                                            <label for=\"insurance\" ng-bind-html=\"htmlContent('shippingMethod.addShippingInsurance', { amount: formatAmount(charge.shipping_charge.insurance_amount) })\"></label>\n                                        </span>\n                                    </span>\n                                    </label>\n                                </div>\n                                <hr class=\"hr\" ng-if=\"!$last\">\n                            </div>\n                        </div>\n                        <input id=\"confirmShippingMethod\" type=\"button\" class=\"confirmation btn\" value=\"{{ content('shippingMethod.continue') }}\" ng-click=\"actions.continueHandler()\">\n                    </div>\n                </div>\n            </div>\n            <div class=\"logo\"></div>\n        </xo-modal>\n    </div>\n</span>\n"

/***/ },

/***/ "./components/xo-form-components/lib/util.js":
/***/ function(module, exports) {

	
	
	exports.__esModule = true;
	function decodeEntities(input) {
	    // A constant key that can be used to find the element
	    var ENTITY_ELEM = '__xpc_entitydecoder__';
	
	    // Create the element if this is the first time this is called
	    if (!window[ENTITY_ELEM]) {
	        window[ENTITY_ELEM] = document.createElement('p');
	    }
	    var converter = window[ENTITY_ELEM];
	    converter.innerHTML = input;
	    return converter.innerText || converter.text || converter.textContent;
	}
	
	exports.decodeEntities = decodeEntities;

/***/ },

/***/ "./components/xo-member-components/src/review-address/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	__webpack_require__("./components/xo-address-components/src/address-display/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/accessibility/directive.js");
	
	var _template = __webpack_require__("./components/xo-member-components/src/review-address/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend({
	    tag: 'xo-review-address',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var'
	        },
	        makeAddrPreferred: {
	            type: 'var',
	            required: false
	        },
	        countryCode: {
	            type: 'str',
	            required: false
	        },
	        storePickUpSelected: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
	                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                auth: _index2.$AuthModel.instance().retrieve()
	            };
	        }
	    },
	
	    actions: {
	        gotoShipping: function gotoShipping() {
	            if (this.models.checkoutAppData.flags.allow_change_shipping) {
	                _uiRouter.$state.go('checkout.review.sidebar.shipping');
	            } else {
	                this.cannotChangeShippingInfoMessages = true;
	            }
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var updateMakePreferredFlag = function updateMakePreferredFlag(flag) {
	                if (_this.makeAddrPreferred) {
	                    // Update the makeAddrPreferred.shown flag, for the caller to know about it.
	                    _this.makeAddrPreferred.shown = flag;
	                }
	                return flag;
	            };
	
	            /**
	             * Decision on whether to show Make Preferred Checkbox
	             * @returns {boolean}
	             */
	            this.isMakePreferred = function () {
	                if (_this.models.auth.remembered) {
	                    return updateMakePreferredFlag(false);
	                }
	
	                if (_this.isPreferredShippingEnabled && !_this.models.checkoutSession.get('shipping.preferred_address') && !_this.models.checkoutSession.get('shipping.s2s_address')) {
	                    return updateMakePreferredFlag(true);
	                }
	
	                return updateMakePreferredFlag(false);
	            };
	        },
	        populate: function populate() {
	
	            // countryCode is not available, hence we use the shipping.county to retrieve the feature flag.
	            var shipping = this.models.checkoutSession && this.models.checkoutSession.shipping || {};
	
	            this.isPreferredShippingEnabled = (0, _squid.$feature)('preferredShipping', false, shipping.country);
	        }
	    }
	});
	
	
	_uiRouter.$state;
	
	_squid.$Component;
	
	_squid.$feature;
	
	_index.$CheckoutAppDataModel;
	
	_index.$CheckoutSessionModel;
	
	_index2.$AuthModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-member-components/src/review-address/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"shippingForm\" class=\"shipping asideView\" content>\n    <div class=\"trayInner trayInnerDefault\">\n        <div id=\"shippingAddress\">\n            <div ng-class=\"{editable:models.checkoutAppData.flags.allow_change_shipping}\" focusable=\"!cannotChangeShippingInfoMessages\" class=\"focusable\" select-button ng-click=\"actions.gotoShipping()\">\n                <h4 ng-show=\"!storePickUpSelected\" class=\"noBottom gamma\">{{ content('shippingAddress.shipTo') }}</h4>\n                <div ng-show=\"storePickUpSelected\">\n                    <h4 class=\"noBottom gamma\">{{ content('shippingAddress.yourAddress') }}</h4>\n                    <span class=\"merchantReq\">{{ content('shippingAddress.merchantReq') }}</span>\n                </div>\n                <div class=\"addressDisplay\">\n                    <div>\n                        <span class=\"given-name\">{{models.checkoutSession.shipping.name}}</span>\n                        <span class=\"family-name\"></span>\n                    </div>\n                    <xo-address-display address=models.checkoutSession.shipping country-code=countryCode></xo-address-display>\n                </div>\n            </div>\n            <a class=\"edits changeShipping ng-class:{disabled:cannotChangeShippingInfoMessages}\" select-button focusable=\"!cannotChangeShippingInfoMessages\" ng-click=\"actions.gotoShipping()\" aria-label=\"{{ content('shippingAddress.label') }}\" focus-when-state=\"checkout.review.sidebar.shipping\" transitions-to=\"checkout.review\">\n                {{ content('common.change') }}\n                <span class=\"frontArrow goTray ng-scope ng-class:{disabled:cannotChangeShippingInfoMessages}\"></span>\n            </a>\n        </div>\n    </div>\n    <div id=\"infoMessages\" class=\"msgPage msg-info shipNotification\" ng-if=\"cannotChangeShippingInfoMessages\">\n        <span class=\"icon\"></span>\n        <ul>\n            <li ng-if=\"models.checkoutAppData.useraction() === 'commit'\" focus-when=\"cannotChangeShippingInfoMessages\" tabindex=\"-1\">\n                {{ content('memberReview.cannotChangeShippingMsgUserActionCommit', {merchantName: models.checkoutAppData.merchant.brand_name, merchantName2: models.checkoutAppData.merchant.brand_name}) }}\n            </li>\n            <li ng-if=\"models.checkoutAppData.useraction() !== 'commit'\" focus-when=\"cannotChangeShippingInfoMessages\" tabindex=\"-1\">\n                {{ content('memberReview.cannotChangeShippingMsg', {merchantName: models.checkoutAppData.merchant.brand_name, merchantName2: models.checkoutAppData.merchant.brand_name}) }}\n            </li>\n        </ul>\n    </div>\n</div>\n\n<div class=\"reviewPreferredShipping sCheckbox checkbox\" ng-if=\"isMakePreferred()\">\n    <input type=\"checkbox\" ng-model=\"makeAddrPreferred.selected\" name=\"makePreferred\" id=\"makePreferred\" />\n    <label for=\"makePreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n</div>\n"

/***/ },

/***/ "./components/xo-venmo-components/src/review-paywith-venmo/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _venmoModels = __webpack_require__("./components/xo-venmo-components/src/venmo-models/index.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _pxp = __webpack_require__("./components/xo-page-components/src/cart/lib/pxp.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-venmo-components/src/review-paywith-venmo/styles.less");
	
	var _template = __webpack_require__("./components/xo-venmo-components/src/review-paywith-venmo/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
	    tag: 'xo-review-paywith-venmo',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            optional: false
	        }
	    },
	    resolve: {
	        models: function models() {
	            return {
	                venmo: _venmoModels.$VenmoOnboardModel.instance(this.token).retrieve(),
	                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.token).retrieve(),
	                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.token).retrieve(),
	                checkoutCart: _checkout.$CheckoutCartModel.instance(this.token).retrieve(),
	                payee: _checkout.$CheckoutPayeeModel.instance(this.token).retrieve()
	            };
	        }
	    },
	    lifecycle: {
	        populate: function populate() {
	
	            var mapperFS = {
	                BALANCE: function BALANCE(fs) {
	                    return {
	                        type: fs.funding_mode,
	                        amount: getAmount()
	                    };
	                },
	                PAYMENT_CARD: function PAYMENT_CARD(fs) {
	                    return {
	                        type: fs.funding_mode,
	                        card_type: fs.payment_card.type,
	                        sub_type: 'INSTANT_TRANSFER',
	                        name: fs.payment_card.type,
	                        last4: fs.payment_card.number,
	                        amount: getAmount()
	                    };
	                },
	                BANK_ACCOUNT: function BANK_ACCOUNT(fs) {
	                    return {
	                        type: fs.funding_mode,
	                        sub_type: 'INSTANT_TRANSFER',
	                        name: fs.bank_account.bank_name,
	                        last4: fs.bank_account.account_number,
	                        amount: getAmount()
	                    };
	                }
	            };
	
	            function determineShowAmt() {
	                var userAction = models.checkoutAppData.useraction();
	                var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && models.checkoutCart.purchase.items.length === 0;
	
	                return (0, _pxp.$pxpCartAmt)(models.checkoutAppData.merchant.merchant_country, models.payee.merchant.id, noLineItemDetails, models.checkoutCart.isPurchase()).then(function (showAmount) {
	                    return models.checkoutCart.payment_action !== 'authorize' && showAmount;
	                });
	            }
	
	            function getAmount() {
	                return models.checkoutSession.plan.sources['0'].amount;
	            }
	
	            function getPlanList() {
	                var defaultFS = models.venmo.funding_sources.default_option;
	
	                if (defaultFS && defaultFS.funding_mode && mapperFS[defaultFS.funding_mode]) {
	                    return [mapperFS[defaultFS.funding_mode](defaultFS)];
	                } else {
	                    return models.checkoutSession.plan.sources['0'];
	                }
	            }
	
	            function getBackup() {
	                var backup = models.venmo.funding_sources.alternate_option;
	
	                if (backup && backup.funding_mode && mapperFS[backup.funding_mode]) {
	                    return mapperFS[backup.funding_mode](backup);
	                }
	            }
	
	            var models = this.models;
	
	            this.venmoUser = models.venmo.username || '@' + models.venmo.first_name + '-' + models.venmo.last_name;
	            this.showAmt = determineShowAmt();
	
	            this.defaultFs = getPlanList();
	            this.backupFs = getBackup();
	        }
	    }
	});
	
	
	_venmoModels.$VenmoOnboardModel;
	
	_checkout.$CheckoutSessionModel;
	
	_checkout.$CheckoutAppDataModel;
	
	_checkout.$CheckoutCartModel;
	
	_checkout.$CheckoutPayeeModel;
	
	_pxp.$pxpCartAmt;
	
	_squid.$Component;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-venmo-components/src/venmo-models/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$VenmoOnboardModel = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $VenmoOnboardModel = exports.$VenmoOnboardModel = _squid.$Model.extend('$VenmoOnboardModel', {
	    api: new _squid.$Api({
	        uri: '/api/venmo/onboard'
	    })
	});
	
	angular.value("$VenmoOnboardModel", $VenmoOnboardModel);
	_squid.$Model;
	
	_squid.$Api;

/***/ },

/***/ "./components/xo-venmo-components/src/review-paywith-venmo/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-venmo-components/src/review-paywith-venmo/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-venmo-components/src/review-paywith-venmo/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".pwVenmo .BALANCE .fsIcons{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/venmo/venmo-balance.png\");background-repeat:no-repeat;background-size:30px 20px}.pwVenmo .venmoUsername{font-size:1em;line-height:1em;color:#6c7378;position:absolute;left:40px;top:55px}.pwVenmo .backup{color:#6c7378;text-align:center;margin-right:15px;margin-left:15px;margin-top:25px;font-size:.75em;line-height:1.154em}.pwVenmo .lineBreak{margin-top:20px;border-top:1px solid #e3e3e3}.pwVenmo .venmoReceipt{font-size:.95em;line-height:1.154em;margin:15px;text-align:center}.pwVenmo .learnMore p{text-align:center;color:#6c7378;font-size:.75em;line-height:1em;margin:0 30px}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-venmo-components/src/review-paywith-venmo/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"paywith asideView pwVenmo\" content>\n    <div class=\"trayInner trayInnerDefault\" >\n        <div id=\"paymentMethod\">\n\n            <h4 class=\"noBottom paymentsHeader zeta\">\n                <span>\n                    {{ content('paymentMethod.payWith') }}\n                </span>\n            </h4>\n            <ul class=\"charges\">\n                <li ng-repeat=\"fs in defaultFs\" class=\"clearfix fs\">\n                    <div ng-class=\"['method', fs.type, fs.sub_type, fs.card_type]\">\n                        <span class=\"fsIcons\" ng-if=\"!fs.is_pinless_debit\"></span>\n                        <span class=\"pinlessGlyphIcon icon icon-card-half-solid\" aria-hidden=\"true\" ng-if=\"fs.is_pinless_debit\"></span>\n                         <span class=\"name\" ng-if=\"fs.type === 'BALANCE'\">\n                             <!--{{ content('paymentMethod.paypalBalance') }} -->\n                             Your Venmo Balance\n                         </span>\n                        <span class=\"name\" ng-if=\"fs.type !== 'BALANCE'\">\n                            <span class=\"fsname\" ng-if=\"!fs.is_pinless_debit\">\n                                {{fs.name}}\n                            </span>\n                            <span class=\"fslastdigits\" ng-if=\"!fs.is_pinless_debit\">\n                                {{fs.last4 ? 'x-' + fs.last4 : ''}}\n                            </span>\n                        </span>\n                    </div>\n                    <span ng-if=\"showAmt\" class=\"methodAmount\">\n                        <span class=\"amountFormatted\"><format-currency code=\"fs.amount.currency_code\" amount=\"fs.amount.amount\"></format-currency></span>\n                    </span>\n                    <span class=\"venmoUsername\">\n                        {{'@' + venmoUser}}\n                    </span>\n                </li>\n            </ul>\n\n            <div ng-if=\"backupFs\" class=\"backup\">\n                <p>Your backup payment method {{backupFs.name}} x-{{backupFs.last4}} may be used if you no longer have enough Venmo balance to cover the entire purchase at the time the transaction is completed by the merchant.</p>\n            </div>\n\n            <div class=\"lineBreak\"></div>\n\n            <div class=\"venmoReceipt\">\n                <p>Your receipt may say PayPal, but your Venmo account will be charged.</p>\n            </div>\n\n            <div class=\"learnMore\">\n                <p><a href=\"#\">Learn more</a> about your rights when using different payment methods.</p>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/messenger-plugin/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-page-components/src/messenger-plugin/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/app/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _fbMessenger = __webpack_require__("./components/xo-page-components/src/constants/fbMessenger.js");
	
	var _fbMessenger2 = _interopRequireDefault(_fbMessenger);
	
	var _index4 = __webpack_require__("./components/xo-page-components/src/utils/index.js");
	
	var _index5 = _interopRequireDefault(_index4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoMessengerPluginDirective', {
	
	    tag: 'xo-messenger-plugin',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	        pluginType: {
	            type: 'str',
	            required: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                messengerIntegration: _index3.$MessengerIntegrationDataModel.instance().retrieve()
	            };
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            var that = this;
	            var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
	
	            // BA was offered to user or not
	            var fbBAShownFlag = window.localStorage.getItem(_fbMessenger2['default'].FB_BA_SHOWN_FLAG);
	
	            // Added following flags to override usual behaviour to enable internal testing by FB and PYPL teams
	            var overrideRepeatUserFlag = _squid.$util.param(_fbMessenger2['default'].OVERRIDE_FBPP_REPEAT_FLAG);
	
	            _logger.$logger.info('Messenger_plugin_props', {
	                'pluginType': this.props.pluginType,
	                'isMobile': isMobile
	            });
	            _logger.$logger.info(isMobile ? 'messenger_mobile_tablet_traffic' : 'messenger_desktop_traffic');
	            _logger.$logger.info('Messenger_plugin_data', this.models.messengerIntegration);
	
	            var isChatPrefEnabled = this.models.messengerIntegration.isChatEnabled;
	            if (isChatPrefEnabled === undefined) {
	                _logger.$logger.info('chat_pref_not_available');
	            }
	            // if 'isChatPrefEnabled' variable is enabled, it means that user has already onboarded to messenger feature hence we don't trigger messenger onboarding for that user again
	
	            if (overrideRepeatUserFlag) {
	                // override isChatPrefEnabled and fbBAShownFlag
	                _logger.$logger.info('override_repeat_user_flag_active');
	            } else if (isChatPrefEnabled || fbBAShownFlag === 'true' && this.props.pluginType === 'STM') {
	                _logger.$logger.info('UNP_chat_prefernce_is_already_enabled');
	                (0, _jquery2['default'])('.fb-send-to-messenger').hide();
	                (0, _jquery2['default'])('#stm-upsell-content').hide();
	                return;
	            }
	
	            var txnId = void 0;
	            var checkoutSession = this.models.checkoutSession;
	
	            if (checkoutSession && checkoutSession.transactionDetails) {
	                txnId = checkoutSession.transactionDetails.receipt_id || checkoutSession.transactionDetails.id;
	            }
	            var identityMatchJSON = {
	                'email_hash': this.models.messengerIntegration.emailHash,
	                'name_hash': this.models.messengerIntegration.nameHash
	            };
	
	            // Messenger plugin comparare this user ID hash with FB user 
	            this.identityMatchVal = JSON.stringify(identityMatchJSON);
	            this.dataRefVal = this.models.messengerIntegration.dataRefJWT + '_txnID_' + txnId + '_plugin_' + this.props.pluginType + '_token_' + this.props.token;
	            this.originVal = window.location.origin;
	            if (that.originVal.indexOf('qa.paypal.com') !== -1 || that.originVal.indexOf('localhost') !== -1 || that.originVal.indexOf('sandbox.paypal.com') !== -1) {
	                this.pageIdVal = _fbMessenger2['default'].FB_TEST_PAGE_ID;
	            } else {
	                this.pageIdVal = _fbMessenger2['default'].FB_PROD_PAGE_ID;
	            }
	
	            this.generateUUID = function () {
	                function s4() {
	                    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	                }
	                return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	            };
	
	            if (that.props.pluginType === 'CHECKBOX') {
	                this.uuidVal = this.generateUUID();
	                window.sessionStorage.checkboxUUIDVal = this.uuidVal;
	            }
	
	            _logger.$logger.info('loading_fb_script');
	            _squid.$dom.loadScript('facebook-jssdk', 'https://www.paypalobjects.com/js/xo/fb_sdk.js').then(function () {
	                if (window.FB) {
	                    that.fbAsyncInit();
	                    //  Note - Uncomment following on stage and localhost
	                    // that.cbSTMPlugin({
	                    //     event: 'identity_match',
	                    //     ref: that.dataRefVal,
	                    //     result: 'match'
	                    // });
	                }
	                _logger.$logger.info('no_fb_obj_script_init');
	            });
	
	            this.cbSTMPlugin = function (evt) {
	                var _this = this;
	
	                // callback for events triggered by the STM plugin
	                if (evt.event === 'rendered' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('STM_plugin_rendered');
	                }
	
	                if (evt.event === 'identity_match' && evt.result === 'match' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('FBPP_ID_match');
	                    var pxpContext = _index5['default'].getMessengerPXPContext();
	                    that.dataRefVal = evt.ref;
	
	                    (0, _squid.$pxp)(_fbMessenger2['default'].PXP_MESSENGER_EXPT, pxpContext, _fbMessenger2['default'].PXP_SHOW_FB_BA_TREATMENT).then(function (result) {
	                        _logger.$logger.info('Messenger_Plugin_PXP_RESULT', result);
	                        if (result && result.treatment_name === _fbMessenger2['default'].PXP_SHOW_FB_BA_TREATMENT) {
	                            _this.pxpMessengerBAIntegrationEnabled = true;
	                            _jquery2['default'].ajax({
	                                url: isMobile ? _fbMessenger2['default'].FB_USER_API_MOBILE_URL : _fbMessenger2['default'].FB_USER_API_URL,
	                                xhrFields: {
	                                    withCredentials: true
	                                }
	                            }).always(function (response) {
	                                var responseText = response.responseText;
	                                var json = responseText.substring(responseText.indexOf('{'));
	                                var data = _jquery2['default'].parseJSON(json);
	                                _logger.$logger.info('callFBToGetBAToken_call', data);
	                                that.models.messengerIntegration.action('callFBToGetBAToken', {
	                                    data: {
	                                        userIdentifier: data.user_identifier
	                                    },
	                                    success: function success(fbresult) {
	                                        if (fbresult.success) {
	                                            _logger.$logger.info('BAToken_from_FB', {
	                                                'batoken': fbresult.batoken
	                                            });
	                                            var fbBAToken = fbresult.batoken,
	                                                BAUrl = void 0,
	                                                xoJSData = void 0;
	
	                                            if (that.originVal.indexOf('localhost') !== -1) {
	                                                // Generate new FB Channel BA and update while testing, BA gets invalidated in few hours
	                                                fbBAToken = 'BA-0V626307R39449349';
	                                            }
	                                            if (that.originVal.indexOf('localhost') !== -1) {
	                                                BAUrl = 'http://localhost.paypal.com:8000/webapps/hermes/agreements/approve?ul=0&messenger_ba=1';
	                                                xoJSData = {
	                                                    'data-env': 'local',
	                                                    'data-stage': 'msmaster',
	                                                    'data-no-bridge': ''
	                                                };
	                                            } else if (that.originVal.indexOf('sandbox.paypal.com') !== -1 || that.originVal.indexOf('qa.paypal.com') !== -1) {
	                                                BAUrl = 'https://www.sandbox.paypal.com/agreements/approve?messenger_ba=1';
	                                                xoJSData = {
	                                                    'data-env': 'sandbox',
	                                                    'data-no-bridge': ''
	                                                };
	                                            } else {
	                                                BAUrl = 'https://www.paypal.com/agreements/approve?messenger_ba=1';
	                                                xoJSData = {
	                                                    'data-env': 'production',
	                                                    'data-no-bridge': ''
	                                                };
	                                            }
	                                            if (overrideRepeatUserFlag) {
	                                                BAUrl = BAUrl + '&override_fbpp_repeat=1';
	                                            }
	                                            var launchBAFlow = function launchBAFlow() {
	                                                _logger.$logger.info('Launch_BA_flow_with_token', {
	                                                    'fbBAToken': fbBAToken
	                                                });
	                                                _logger.$logger.info('Launch_BA_flow_with_URL', {
	                                                    'BAUrl': BAUrl
	                                                });
	                                                window.ppxo.Checkout.contexts.lightbox = true;
	                                                window.localStorage.setItem(_fbMessenger2['default'].FB_BA_SHOWN_FLAG, 'true');
	                                                window.ppxo.Checkout.render({
	                                                    url: BAUrl,
	                                                    billingAgreement: fbBAToken,
	                                                    onAuthorize: function onAuthorize(authorizedResponse) {
	                                                        _logger.$logger.info('User_accepted_FB_BA');
	                                                        if (window.sessionStorage.checkboxPluginState === 'unchecked') {
	                                                            _logger.$logger.info('user_not_accepted_messenger_notifications');
	                                                            (0, _jquery2['default'])('.fb-send-to-messenger').hide();
	                                                            (0, _jquery2['default'])('#stm-upsell-content').hide();
	                                                            (0, _jquery2['default'])('#ba-integration-content').show();
	                                                        } else {
	                                                            _logger.$logger.info('user_accepted_checkbox_messenger_notifications');
	                                                            (0, _jquery2['default'])('.fb-send-to-messenger').hide();
	                                                            (0, _jquery2['default'])('#stm-upsell-content').hide();
	                                                            (0, _jquery2['default'])('#messenger-ba-integration-content').show();
	                                                        }
	                                                        that.confirmCheckboxPluginOptIn();
	                                                        that.models.messengerIntegration.action('notifyFBOntBAAuthorize', {
	                                                            data: {
	                                                                baToken: authorizedResponse.billingToken
	                                                            },
	                                                            success: function success(fbCallResult) {
	                                                                if (fbCallResult.success) {
	                                                                    _logger.$logger.info('notifyFBOntBAAuthorize_call_success!');
	                                                                } else {
	                                                                    _logger.$logger.info('notifyFBOntBAAuthorize_call_failure!');
	                                                                }
	                                                            }
	                                                        });
	                                                    }
	                                                });
	                                            };
	                                            if (window.ppxo) {
	                                                _logger.$logger.info('xo_JS_is_already_present');
	                                                launchBAFlow();
	                                            } else {
	                                                _squid.$dom.loadScript('xo-js', 'https://www.paypalobjects.com/api/paypal.checkout.v4.js', 0, xoJSData).then(function () {
	                                                    _logger.$logger.info('xo_JS_got_loaded');
	                                                    launchBAFlow();
	                                                });
	                                            }
	                                        } else {
	                                            _logger.$logger.info('callFBToGetBAToken_call_failure!');
	                                        }
	                                    }
	                                });
	                            });
	                        } else {
	                            _logger.$logger.info('no_pxp_for_ba');
	                            _this.pxpMessengerBAIntegrationEnabled = false;
	                        }
	                    });
	                } else if (evt.event === 'identity_match' && evt.result === 'no_match' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('No_FBPP_ID_match');
	                } else if (evt.event === 'identity_match' && evt.result === 'no_logged_in_user' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('No_loggedin_FBPP_ID_match');
	                } else if (evt.event === 'identity_match' && evt.result === 'failure' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('Fail_FBPP_ID_match');
	                } else if (evt.event === 'clicked' && that.props.pluginType === 'STM') {
	                    _logger.$logger.info('user_accepted_STM_messenger_notifications');
	                }
	            };
	            this.fbAsyncInit = function () {
	                _logger.$logger.info('Initializing_FB_scripts');
	                window.FB.init({
	                    appId: _fbMessenger2['default'].FB_PROD_APP_ID,
	                    xfbml: true,
	                    version: 'v2.6'
	                });
	                // Subscribe to STM
	                window.FB.Event.subscribe('send_to_messenger', this.cbSTMPlugin);
	
	                // Subscribe to CHECKBOX
	                window.FB.Event.subscribe('messenger_checkbox', function (evt) {
	                    _logger.$logger.info('messenger_checkbox_event', evt);
	                    if (evt.event === 'checkbox') {
	                        window.sessionStorage.checkboxPluginState = evt.state;
	                        _logger.$logger.info('checkbox_plugin_state_' + that.checkboxPluginState);
	                    }
	                });
	            };
	
	            this.confirmCheckboxPluginOptIn = function () {
	                _logger.$logger.info('MessengerCheckboxPluginUserConfirmation_event_to_fb', {
	                    'uuidVal': window.sessionStorage.checkboxUUIDVal,
	                    'pageIdVal': this.pageIdVal,
	                    'dataRefVal': this.dataRefVal
	                });
	                window.FB.AppEvents.logEvent('MessengerCheckboxUserConfirmation', null, {
	                    'page_id': this.pageIdVal,
	                    'app_id': _fbMessenger2['default'].FB_PROD_APP_ID,
	                    'ref': this.dataRefVal,
	                    'user_ref': window.sessionStorage.checkboxUUIDVal
	                });
	            };
	        },
	        exit: function exit() {
	            _logger.$logger.info('Messenger_plugin_EXIT_event');
	        }
	    }
	});
	
	
	_logger.$logger;
	
	_squid.$Component;
	
	_squid.$pxp;
	
	_squid.$dom;
	
	_squid.$util;
	
	_index.$DeviceInfo;
	
	_index2.$CheckoutSessionModel;
	
	_index3.$MessengerIntegrationDataModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-page-components/src/messenger-plugin/template.html":
/***/ function(module, exports) {

	module.exports = "<messenger-plugin content>\n\t<div id=\"messenger-plugin\" ng-value=\"props.pluginType\">\n\n\t\t<div class=\"fb-send-to-messenger\" origin=\"{{originVal}}\" identity_match=\"{{identityMatchVal}}\" messenger_app_id=1084613224964631\n\t\t\tpage_id={{pageIdVal}} data-ref=\"{{dataRefVal}}\" color=\"blue\" size=\"xlarge\" ng-if=\"(props.pluginType == 'STM')\">\n\t\t</div>\n\n\t\t<div class=\"fb-messenger-checkbox\" origin=\"{{originVal}}\" page_id={{pageIdVal}} messenger_app_id=1084613224964631\n\t\t\tpixel_id=329481497393670 user_ref=\"{{uuidVal}}\" prechecked=\"true\" allow_login=\"true\" size=\"xlarge\"\n\t\t\tng-if=\"(props.pluginType == 'CHECKBOX')\">\n\t\t</div>\n        \n\t</div>\n</messenger-plugin>"

/***/ },

/***/ "./components/xo-page-components/src/constants/fbMessenger.js":
/***/ function(module, exports) {

	
	
	/* Constants for FB messenger related components */
	
	module.exports = {
	    OVERRIDE_FBPP_REPEAT_FLAG: 'override_fbpp_repeat',
	    OVERRIDE_FBPP_MOBILE_FLAG: 'override_fbpp_mobile',
	    FB_BA_SHOWN_FLAG: 'is_xo_wps_fb_messenger_plugin_match_withba_shown',
	    MOBILE_CHANNEL: 'MOBILE',
	    WEB_CHANNEL: 'WEB',
	    FB_USER_API_MOBILE_URL: 'https://m.facebook.com/paypal/user_identifier',
	    FB_USER_API_URL: 'https://www.facebook.com/paypal/user_identifier',
	    FB_PROD_APP_ID: '1084613224964631',
	    FB_PROD_PAGE_ID: '55982004572',
	    FB_TEST_PAGE_ID: '676472402496128',
	    PXP_MESSENGER_EXPT: 'xo_wps_fb_messenger_plugin',
	    PXP_SHOW_MESSENGER_PLUGIN_TREATMENT: 'xo_wps_fb_messenger_plugin_1_treatment',
	    PXP_SHOW_FB_BA_TREATMENT: 'xo_wps_fb_messenger_plugin_match_withba'
	};

/***/ },

/***/ "./components/xo-page-components/src/utils/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	/* eslint-disable angular/typecheck-string */
	
	var _fbMessenger = __webpack_require__("./components/xo-page-components/src/constants/fbMessenger.js");
	
	var _fbMessenger2 = _interopRequireDefault(_fbMessenger);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = {
	    /**
	     * add non empty key, value to the object
	     * @param {Object} object where to add new key, value
	     * @param {String} key
	     * @param {Any type} value, can not be empty
	     * @returns {void}
	     */
	    addValidParam: function addValidParam(obj, key, val) {
	        if (!obj) {
	            return;
	        }
	        if (typeof key === 'string' && key && val !== undefined && val !== null) {
	            obj[key] = val;
	        }
	    },
	
	    // Get PXP context for Messenger feature
	    getMessengerPXPContext: function getMessengerPXPContext() {
	        var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
	        var overrideMobileUserFlag = _squid.$util.param(_fbMessenger2['default'].OVERRIDE_FBPP_MOBILE_FLAG);
	        var channelVal = isMobile ? _fbMessenger2['default'].MOBILE_CHANNEL : _fbMessenger2['default'].WEB_CHANNEL;
	
	        var pxpContext = {
	            'ctx.COUNTRY': _squid.$locale.country,
	            'ctx.CHANNEL': overrideMobileUserFlag ? _fbMessenger2['default'].WEB_CHANNEL : channelVal,
	            'ctx.LANGUAGE': _squid.$locale.lang + '_' + _squid.$locale.country
	        };
	
	        return pxpContext;
	    }
	};
	_squid.$util;
	
	_squid.$locale;
	
	_index.$DeviceInfo;

/***/ },

/***/ "./components/xo-models/src/bml/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.bml', ['squid']).factory('$ApplyForBMLModel', function ($Model, $Api) {
	
	        return $Model.extend('ApplyForBMLModel', {
	            api: new $Api({
	                uri: '/api/checkout/:id/cart',
	                cache: true
	            }),
	
	            personalInformation: {
	                day: '',
	                month: '',
	                year: '',
	                natId: '',
	                phone: {
	                    telephone: '',
	                    phoneType: ''
	                }
	            },
	
	            billingAdrress: {
	                phoneType: '',
	                phoneNumber: ''
	            }
	        });
	    }).factory('$BMLModel', function ($Model, $Api) {
	
	        return $Model.extend('BMLModel', {
	            api: new $Api({
	                uri: '/api/bml',
	                cache: false
	            }),
	
	            applicationStatus: function applicationStatus() {
	                return this.application_status;
	            },
	
	            applicationId: function applicationId() {
	                return this.application_id;
	            }
	        });
	    }).factory('$BMLApplicationModel', function ($Model, $Api) {
	
	        return $Model.extend('BMLApplicationModel', {
	            api: new $Api({
	                uri: '/api/bml/:application_id',
	                cache: false
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/bml", "components/xo-models/src/bml/index.js"))

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-popup/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-popup/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/bml/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    return angular.module('xo-bml-popup.directive', ['squid', 'xomodel.checkout', 'xomodel.bml', 'beaver']).directive('xoBmlPopup', function () {
	
	        return {
	            template: template,
	            controller: function controller($scope, $populate, $rootScope, $CheckoutSessionModel, $BMLModel, $logger) {
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($rootScope.token)
	                }).then(function () {
	                    if ($scope.checkoutSession.showDeclinePopup) {
	                        if (!$rootScope.bml) {
	                            $rootScope.bml = new $BMLModel();
	                        }
	                        if (!$scope.bml) {
	                            $scope.bml = $rootScope.bml;
	                        }
	
	                        $scope.bml.preferenceCheck = false;
	                        $scope.bml.showModal = true;
	                        $scope.bml.showModalBackdrop = true;
	
	                        if ($scope.bml.applicationStatus() || $scope.bml.contingency) {
	                            $scope.bml.showModalBackdrop = true;
	                        }
	                    }
	                });
	
	                $scope.bmlSetPreferrence = function () {
	                    if ($scope.bml.preferenceCheck) {
	                        $scope.bml.action('preference', {
	                            data: {
	                                financial_instrument_id: $scope.bml.financial_instrument_id
	                            },
	
	                            success: function success() {
	                                $logger.info('COMPLETEBMLAPPLY_PREFERRED');
	                                $scope.checkoutSession.message = {
	                                    type: 'success',
	                                    msgKeys: ['memberReview.bmlPreferredConfirmation']
	                                };
	                            }
	                        });
	                    } else {
	                        $scope.checkoutSession.message = {
	                            type: 'success',
	                            msgKeys: ['paymentMethod.paymentMethodUpdated']
	                        };
	                    }
	                    $scope.bml.showModal = false;
	                };
	
	                $scope.bmlClickContinue = function ($event) {
	                    $event.preventDefault();
	                    $scope.bml.showModalBackdrop = false;
	                    $scope.bml.showModal = false;
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-popup/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"xoBmlPopup\" content>\n    <!-- BML Decision -->\n    <div ng-if=\"bml.application_status !== undefined || bml.contingency\">\n        <div ng-show=\"bml.showModal\" id=\"bmlModal\" style=\"display:block;\" class=\"modal bmlModal\" aria-labelledby=\"modal-title\" role=\"alertdialog\" tabindex=\"-1\">\n\n            <div ng-show=\"bml.showModalBackdrop\" class=\"modal-backdrop\"></div>\n\n            <div class=\"modal-wrap\">\n\n                <div ng-switch=\"bml.application_status == 'APPROVED' || bml.application_status == 'PENDING_COMPLETION_STATUS'\">\n                    <div ng-switch-when=\"true\">\n                        <span class=\"bmlLogoVert\"></span>\n                        <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('memberReview.bmlSuccessHeader') }}</h2>\n\n                        <div ng-if=\"bml.nape == 'napePositive'\">\n                            <p>{{ content('memberReview.bmlNapeLinkSuccess')}}</p>\n                        </div>\n                        <div ng-if=\"bml.nape !== 'napePositive' && bml.credit_line.value == 0\">\n                            <p>{{ content('memberReview.bmlApprovalMessage') }}</p>\n                        </div>\n                        <div ng-if=\"bml.nape !== 'napePositive' && bml.credit_line.value > 0\">\n                            <p ng-bind-html=\"htmlContent('memberReview.bmlSuccessMessage', {creditLine: bml.credit_line.value})\"></p>\n                            <p>{{ content('memberReview.bmlSuccessMessageSend', {email: bml.user_info.email_address}) }}</p>\n                        </div>\n\n                        <form method=\"post\" name=\"confirm\" ng-submit=\"bmlSetPreferrence()\">\n                            <div class=\"checkbox\">\n                                <input type=\"checkbox\" ng-model=\"bml.preferenceCheck\" name=\"bmlPreferred\" id=\"bmlPreferredCheckbox\" class=\"chkbx\">\n                                <label for=\"bmlPreferredCheckbox\" class=\"chkbxLabel\">{{ content('memberReview.bmlSetPreferred')}}</label>\n                            </div>\n                            <input class=\"btn btn-submit full\" type=\"submit\" value=\"{{ content('memberReview.bmlContinue')}}\">\n                        </form>\n\n                    </div>\n                    <div ng-switch-default>\n                        <div ng-switch=\"bml.application_status\">\n                            <!-- bmlMaxAttempts -->\n                            <div ng-switch-when=\"SOFT_DECLINED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('memberReview.bmlSorry')}}</h2>\n                                <p>{{ content('bmlDeclined.hardDeclineMsg')}}</p>\n                            </div>\n                            <!-- bmlDeclineLinkedToDiffMember -->\n                            <div ng-switch-when=\"FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.bmlAcctLinkedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.bmlAcctLinkedMsg')}}</p>\n                            </div>\n                            <!-- creditDeclineHard -->\n                            <div ng-switch-when=\"DECLINED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.hardDeclineHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.hardDeclineMsg')}}</p>\n                            </div>\n                            <!-- ??? creditPaymentNotAllowed -->\n                            <div ng-switch-when=\"CREDIT_PAYMENT_NOT_ALLOWED\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.creditNotAllowedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.creditNotAllowedMsg')}}</p>\n                            </div>\n                            <!-- ??? creditEligibilityDeclined -->\n                            <div ng-switch-when=\"CREDIT_ELIGIBILITY_DECLINE\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.creditEligibilityDeniedHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.creditEligibilityDeniedMsg')}}</p>\n                            </div>\n                            <!-- ??? declineOtherCreditInstrumentExists -->\n                            <div ng-switch-when=\"FP_DECLINED_DUE_TO_CREDIT_IN_WALLET_RULE\">\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.declineOtherCreditInstrumentExistsHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.declineOtherCreditInstrumentExistsLine1')}}</p>\n                                <p>{{ content('bmlDeclined.declineOtherCreditInstrumentExistsLine2\" merchantName=\"{bmlResult.merchantFullName}')}}</p>\n                            </div>\n                            <!-- systemError, bmlGenericError, invalidError -->\n                            <div ng-switch-default> <!-- ng-switch-when=\"UNKNOWN_DECISION\" -->\n                                <h2 id=\"modal-title\" class=\"alpha noHead\">{{ content('bmlDeclined.systemErrorHeader')}}</h2>\n                                <p>{{ content('bmlDeclined.systemErrorMsg')}}</p>\n                            </div>\n                        </div>\n\n                        <!--\n                         && bml.application_status == 'APPROVED' || bml.application_status == 'PENDING_COMPLETION_STATUS'\n                        -->\n                        <div ng-if=\"bml.application_status !== undefined || bml.contingency\" >\n                            <div ng-if=\"locale.countryCode === 'DE'\">\n                                <p class=\"cancelUrl\">\n                                    <a href=\"{{cancel}}\" role=\"button\" class=\"btn full\">{{ content('common.returnToCart') }}</a>\n                                </p>\n                            </div>\n                            <div ng-if=\"locale.countryCode !== 'DE'\">\n                                <input class=\"btn btn-submit full buttonGroup button-spacing\" type=\"button\" id=\"continueBml\" value=\"{{ content('common.payWithPayPal') }}\" ng-click=\"bmlClickContinue($event)\" />\n                                <a href=\"{{cancel}}\" role=\"button\" class=\"btn btn-secondary full buttonGroup\" id=\"cancelLink\">\n                                    {{ merchant ? content('common.bmlCancelButtonLabel', { merchantName: merchant }) : content('common.cancelAndReturnToMerchant') }}\n                                </a>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <!-- BML Decision -->\n</section>\n"

/***/ },

/***/ "./components/xo-page-components/src/done/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	var _fbMessenger = __webpack_require__("./components/xo-page-components/src/constants/fbMessenger.js");
	
	var _fbMessenger2 = _interopRequireDefault(_fbMessenger);
	
	var _index = __webpack_require__("./components/xo-page-components/src/utils/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var AUTORETURN_TIMEOUT = 10000;
	
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/done/template.html"), __webpack_require__("./components/xo-beaver/dist/logger.js"), __webpack_require__("./components/xo-return-to-merchant/dist/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, ng, squid, template) {
	
	    return angular.module('xo-done.directive', ['squid', 'beaver', 'xo-error-tooltip.directive', 'xo-return-to-merchant']).directive('xoDone', function () {
	
	        return {
	            template: template,
	            controller: function controller($rootScope, $scope, $populate, $logger, $CheckoutAppDataModel, $CheckoutSessionModel, $MerchantPreferenceModel, $CheckoutPayeeModel, $CheckoutCartModel, $locale, $ReturnToMerchant, $DeviceInfo, $state, $window, $stateParams, $pxp, $timeout) {
	
	                $scope.isGuestSignup = $rootScope.mode && $rootScope.mode === 'signup';
	                $scope.locale = $locale;
	
	                function addPageMessage(code) {
	                    var CONTENT_KEY_MAPPING = {
	                        NO_UPGRADE: 'accountUpgradeFailed'
	                    };
	                    if (code && CONTENT_KEY_MAPPING[code]) {
	                        $scope.errorMessage = {
	                            msgs: [$locale.content.get('done.' + CONTENT_KEY_MAPPING[code])],
	                            type: 'warning'
	                        };
	                    }
	                }
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    payee: $CheckoutPayeeModel.instance($scope.token)
	                }).then(function () {
	
	                    return $populate($scope, {
	                        merchantPreferenceModel: $MerchantPreferenceModel.instance($scope.payee.merchant.id)
	                    }).then(function () {
	                        // Show auto return page when feature is enabled by merchant and txn
	                        $scope.isAutoReturn = $scope.merchantPreferenceModel.autoReturn();
	
	                        $logger.info('wps_autoreturn_' + ($scope.isAutoReturn ? 'enabled' : 'disabled'), {
	                            return_url: $scope.checkoutAppData.urls.return_url || 'not_available',
	                            autoreturn_url: $scope.merchantPreferenceModel.returnUrl() || 'not_available'
	                        });
	
	                        // Set content key based on device
	                        $scope.autoReturnContentKey = $DeviceInfo.isMobile() || $DeviceInfo.isTablet() ? 'done.autoReturnStatement' : 'done.autoReturnStatementWeb';
	                        $scope.guestSignupKey = $scope.isGuestSignup ? 'done.paymentGuest' : 'done.payment';
	                        if ($stateParams.code) {
	                            addPageMessage($stateParams.code);
	                        }
	                        var amount = $scope.checkoutSession.transactionDetails.amount.total;
	                        var code = $scope.checkoutSession.transactionDetails.amount.currency;
	                        $scope.formattedAmount = squid.formatCurrency(amount, code);
	                        var itemList = $scope.checkoutSession.itemsList;
	
	                        itemList.forEach(function (item) {
	                            item.quantity = squid.formatQuantity(item.quantity);
	                        });
	                    });
	                }).then(function () {
	                    var pxpContext = _index2['default'].getMessengerPXPContext();
	                    $logger.info('pxp_xo_wps_fb_messenger_plugin_1_treatment ', pxpContext);
	
	                    $pxp(_fbMessenger2['default'].PXP_MESSENGER_EXPT, pxpContext, _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT).then(function (result) {
	                        $logger.info('Messenger_done_page_PXP_RESULT', result);
	                        if (result && result.treatment_name === _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT && !$scope.isAutoReturn) {
	                            $logger.info('messenger_done_page_test_traffic');
	                            $scope.pxpMessengerIntegrationEnabled = true;
	                        } else {
	                            $logger.info('messenger_done_page_control_traffic');
	                            $scope.pxpMessengerIntegrationEnabled = false;
	                        }
	                    });
	
	                    $('#outerWrapper').addClass('xo-done');
	
	                    $scope.expansion = false;
	                    $scope.toggle = function () {
	                        if ($scope.expansion === false) {
	                            $scope.maxHeight = document.getElementsByClassName('details-expand')[0].scrollHeight + 'px';
	                            $scope.expansion = true;
	                        } else {
	                            $scope.expansion = false;
	                        }
	                        return $scope.expansion;
	                    };
	
	                    $scope.autoReturnStatementClick = function (event) {
	                        event.preventDefault();
	                        if (event.target && event.target.nodeName === 'A') {
	                            $logger.info('autoreturn_statement_clicked');
	                            $scope.returnToMerchant();
	                        }
	                    };
	
	                    if ($scope.isAutoReturn) {
	                        $logger.info('autoreturn_to_merchant');
	                        $timeout($scope.returnToMerchant, AUTORETURN_TIMEOUT);
	                    }
	                });
	
	                $scope.$on('localeChange', function () {
	                    if ($stateParams.code) {
	                        addPageMessage($stateParams.code);
	                    }
	                });
	
	                $scope.returnToMerchant = function () {
	                    $logger.info('return_to_merchant_clicked');
	                    return $state.go('checkout.end');
	                };
	
	                $rootScope.$on('$stateChangeSuccess', function (event, newState, newParams, oldState) {
	                    if (oldState.name === 'checkout.done') {
	                        $('#outerWrapper').removeClass('xo-done');
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/done/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"xo-done-content\" content>\n    <div ng-click=\"toggle()\"class=\"splash-receipt\">\n        <div class=\"receipt basics\">\n            <div class=\"done\" id=\"circle\"></div>\n            <div id=\"paid-text\" bind-html-compile=\"htmlContent(guestSignupKey, {amt: formattedAmount})\"/>\n            <div id=\"merchant-text\">{{content('done.payment_target', {merchantName: (checkoutAppData.merchant.brand_name || checkoutAppData.merchant.merchant_email)})}}</div>\n            <div id=\"details-text\">{{content('paymentMethod.msbDetails')}}</div>\n        </div>\n        <div class=\"details-expand\" ng-class=\"{ expansion : expansion}\" ng-style=\"expansion && {'max-height': maxHeight}\">\n            <div class=\"grouping\" ng-repeat=\"item in checkoutSession.itemsList\">\n                <div class=\"row\">\n                    <span><span ng-if=\"item.quantity\">{{item.quantity}} x </span>{{item.name}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\" amount=\"item.price\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"item.sku\" class=\"item-number-container\">\n                    <span>\n                        <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ item.sku }}</span>\n                    </span>\n                </div>\n                <div ng-if=\"item.item_option_selections\" class=\"item-selections\">\n                    <span class=\"item-selection\" ng-repeat=\"selection in item.item_option_selections track by $index\">\n                        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n                        <span class=\"item-selection-value\">{{ selection.select }}</span>\n                    </span>\n                </div>\n            </div>\n            <div class=\"grouping\">\n                <div ng-if=\"checkoutSession.transactionDetails.amount.subtotal\" class=\"row\">\n                    <span>{{content('header.subTotal')}}</span>\n                     <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.subtotal\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.tax\" class=\"row\">\n                    <span>{{content('header.tax')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.tax\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.shipping\" class=\"row\">\n                    <span>{{content('header.shipping')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.shipping\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.insurance\" class=\"row\">\n                    <span>{{content('header.insurance')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.insurance\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.handling_fee\" class=\"row\">\n                    <span>{{content('header.handling')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.handling_fee\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.discount\" class=\"row\">\n                    <span>{{content('header.discount')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.discount\">\n                        </format-currency>\n                    </span>\n                </div>\n            </div>\n            <div class=\"row totalAmount\">\n                <b>\n                    <span>{{content('base.totalLabel')}}</span>\n                <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.total\">\n                        </format-currency>\n                    </span>\n                </b>\n            </div>\n        </div>\n        <div id=\"details-button\">\n            <span ng-hide=\"!expansion\" class=\"arrow collapse\"></span>\n            <span ng-hide=\"expansion\" class=\"arrow expand\"></span>\n        </div>\n    </div>\n    <div class=\"essentials\" ng-show=\"checkoutSession.transactionDetails.reason_code === 'REGULATORY_REVIEW'\">\n        <div class=\"alert\" role=\"alert\">\n            {{content('done.temporarily_pending')}}\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"!isAutoReturn\">\n        <xo-message message=\"errorMessage\"></xo-message>\n\n       <div id=\"messenger-ba-integration\" ng-if=\"pxpMessengerIntegrationEnabled\">\n\t\t\t<div id=\"messenger-ba-integration-content\" style=\"display:none\">\n\t\t\t\t<div class=\"text\">Be sure to check Messenger for your receipts whenever you shop using PayPal</div>\n\t\t\t</div>\n            <div id=\"ba-integration-content\" style=\"display:none\">\n\t\t\t\t<div class=\"receipt title\">You're all set to shop on Facebook</div>\n\t\t\t\t<div class=\"text\">When you're ready to shop, just choose PayPal at checkout!</div>\n\t\t\t</div>\n            <div id=\"stm-upsell-content\" class=\"text\">Get your PayPal receipts in Messenger</div>\n\t\t\t<xo-messenger-plugin plugin-type=\"STM\" token=\"token\"></xo-messenger-plugin>\n\t\t</div>\n\n        <div ng-if=\"checkoutSession.plan.sources.length > 0\" class=\"receipt title\">{{content('done.paidWith')}}</div>\n        <div ng-repeat=\"item in checkoutSession.plan.sources\">\n            <div class=\"row clearfix\">\n                <span class=\"money-source\">{{content('fsMappings.'+item.type) || item.name}} <span ng-if=\"item.last4\">x-</span>{{item.last4}}</span>\n                <span class='amount'>\n                        <format-currency code=\"item.amount.currency_code\"\n                                         amount=\"item.amount.amount\">\n                        </format-currency>\n                </span>\n            </div>\n        </div>\n        <div ng-if=\"checkoutSession.transactionDetails.soft_descriptor\" class=\"secondary receipt statement\">{{content('done.transactionInformation', {merchantName: checkoutSession.transactionDetails.soft_descriptor})}}\n        </div>\n        <div ng-if=\"checkoutSession.shipping\" class=\"receipt title\">{{content('done.shippedTo')}}</div>\n        <div class=\"text\" ng-if=\"!checkoutCart.isShippingMethodStorePickUp()\">\n            <div ng-if=\"checkoutSession.shipping.name\">{{checkoutSession.shipping.name}}</div>\n            <div><span directionality-text=\"checkoutSession.shipping.full_address\">{{checkoutSession.shipping.full_address}}</span></div>\n            <div><span>{{content('countryList.'+checkoutSession.shipping.country)}}</span></div>\n        </div>\n        <div class=\"text\" ng-if=\"checkoutCart.isShippingMethodStorePickUp()\">\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <div class=\"receipt title\">{{content('done.purchaseDetails')}}</div>\n        <div id=\"receiptNumber\"> {{content('done.receiptNumber')}} {{checkoutSession.transactionDetails.receipt_id}}</div>\n        <div class=\"text\">\n            <div>{{content('done.confirmation')}}</div>\n            <div id=\"buyerEmail\">{{checkoutSession.payer.email}}</div>\n        </div>\n        <div text-align=\"left\" class=\"receipt title\">{{content('done.merchantDetails')}}</div>\n        <div class=\"text\" id=\"merchantInfoSection\">\n            <div><span directionality-text=\"checkoutAppData.merchant.brand_name\">{{checkoutAppData.merchant.brand_name}}</span></div>\n            <div ng-if=\"checkoutAppData.merchant.phone\">{{checkoutAppData.merchant.phone}}</div>\n            <div id=\"merchantEmail\" ng-if=\"checkoutAppData.merchant.merchant_email\">{{checkoutAppData.merchant.merchant_email}}</div>\n        </div>\n        <div ng-if=\"checkoutAppData.urls.return_url\" id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{content('common.returnToDefaultMerchant')}}\" id=\"merchantReturnBtn\"\n                   class=\"btn btn-secondary full submit receipt ng-binding ng-scope\" ng-click=\"returnToMerchant()\" />\n        </div>\n    </div>\n    <div class=\"essentials autoReturnSection\" ng-if=\"isAutoReturn\">\n        <div>{{content('done.paymentCompleted')}}</div>\n        <div ng-click=\"autoReturnStatementClick($event)\" bind-html-compile=\"htmlContent(autoReturnContentKey, {merchantName: checkoutAppData.merchant.brand_name, autoReturnUrl: checkoutAppData.urls.return_url})\"/>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/3ds/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/3ds/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, template) {
	    return angular.module('xo-3ds.directive', ['squid']).directive('xo3ds', function () {
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                data: '=',
	                onComplete3dsHandler: '='
	            },
	            controller: function controller($scope, $rootScope, $timeout, $window, $Resolve3DS, $CheckoutAppDataModel, $config, $locale, $logger) {
	
	                var resolve3DS = $Resolve3DS.instance($scope.token);
	
	                $scope.termUrl = window.location.origin + $config.urls.baseUrl + '/process3DS';
	
	                $scope.data = $scope.data || {};
	
	                function handleInitFailure(message) {
	                    // Since init3DS call failed. We disable the feature and proceed to checkout.
	                    $CheckoutAppDataModel.instance($rootScope.token).action('updatePaymentExperience', {
	                        data: {
	                            payment_experience: 'HERMESNODE',
	                            '3d_secure_authentication_supported': false
	                        },
	                        silent: true,
	                        transientError: true
	                    }).then(function () {
	
	                        $logger.info('checkout_fpti', {
	                            from: '3DS_CHALLENGE',
	                            to: 'process_3ds_challenge',
	                            'int_error_description': message,
	                            'error_type': 'soft_decline',
	                            'error_source': 'fiLifecycle'
	                        });
	
	                        $scope.onComplete3dsHandler('success');
	                    });
	                }
	
	                function init3DSApi() {
	                    $rootScope.$emit('loadingMessage', $locale.content.get('threeDS.processing'));
	
	                    return resolve3DS.action('init3DS', {
	                        data: {
	                            cc_id: $scope.data.cc_id,
	                            flow_id: $scope.data.flow_id,
	                            merchant_id: $scope.data.merchant_id,
	                            merchant_country: $scope.data.merchant_country_code,
	                            currency: $scope.data.transaction_amount_currency,
	                            transaction_amount: $scope.data.transaction_amount_value
	                        },
	                        success: function success(response) {
	                            if (response.status === 'SUCCESS' && response.acsUrl) {
	
	                                $logger.info('checkout_fpti', { from: '3DS_CHALLENGE', to: 'prepare_3ds_challenge' });
	
	                                $scope.acsUrl = response.acsUrl;
	                                $scope.acsMethod = response.acsMethod || 'POST';
	                                $scope.acsPaReq = response.acsPaReq;
	
	                                var lightbox;
	                                var form = $('<form/>', {
	                                    action: $scope.acsUrl,
	                                    method: $scope.acsMethod,
	                                    id: 'iFrameForm',
	                                    target: 'threeDSFrame'
	                                });
	                                form.append($('<input/>', {
	                                    type: 'hidden',
	                                    name: 'TermUrl',
	                                    value: $scope.termUrl
	                                }));
	
	                                form.append($('<input/>', {
	                                    type: 'hidden',
	                                    name: 'PaReq',
	                                    value: $scope.acsPaReq
	                                }));
	                                $('#lightBoxAcsWrapper').append(form);
	                                $('#iFrameForm').submit();
	
	                                // put lightbox to display with transition
	                                lightbox = angular.element(document.getElementById('light-box'));
	                                lightbox.addClass('open');
	                            } else {
	                                $logger.info('checkout_fpti', {
	                                    from: '3DS_CHALLENGE',
	                                    to: 'process_3ds_challenge',
	                                    'int_error_description': 'acsUrl_not_presented_on_init',
	                                    'error_type': 'soft_decline',
	                                    'error_source': 'fiLifecycle'
	                                });
	
	                                // When there is no 3DS challenge page to be shown, we return success to the caller
	                                $scope.onComplete3dsHandler('success');
	                            }
	                        },
	                        error: function error() {
	                            handleInitFailure('unknown_error_on_init3DS');
	                        },
	                        validation: function validation() {
	                            handleInitFailure('validation_error_on_init3DS');
	                        },
	                        contingencies: {
	                            DEFAULT: function DEFAULT() {
	                                handleInitFailure('contingency_presented_on_init3DS');
	                            }
	                        }
	                    });
	                }
	
	                function complete3DSApi(paRes) {
	                    return resolve3DS.action('complete3DS', {
	                        data: {
	                            third_party_response: paRes,
	                            cc_id: $scope.data.cc_id,
	                            flow_id: $scope.data.flow_id
	                        },
	                        success: function success(response) {
	
	                            var status;
	
	                            if (response.status === 'SUCCESS') {
	                                status = 'success';
	
	                                $logger.info('checkout_fpti', {
	                                    from: '3DS_CHALLENGE',
	                                    to: 'process_3ds_challenge'
	                                });
	                            } else {
	                                status = 'decline';
	
	                                $logger.info('checkout_fpti', {
	                                    from: '3DS_CHALLENGE',
	                                    to: 'process_3ds_challenge',
	                                    'int_error_description': 'complete3DS_decline',
	                                    'error_type': 'soft_decline',
	                                    'error_source': 'fiLifecycle'
	
	                                });
	                            }
	
	                            $scope.onComplete3dsHandler(status);
	                        }
	                    });
	                }
	
	                $scope.close3DSFrame = function () {
	                    $logger.info('checkout_fpti', { from: '3DS_CHALLENGE', to: 'process_user_close' });
	
	                    var lightbox = angular.element(document.getElementById('light-box'));
	                    lightbox.removeClass('open');
	
	                    $timeout(function () {
	                        var lightboxMask = angular.element(document.getElementById('mask'));
	                        lightboxMask.remove();
	                        $scope.onComplete3dsHandler('close');
	                    }, 200);
	                };
	
	                init3DSApi();
	
	                $scope.complete3DS = function (paRes) {
	                    complete3DSApi(paRes);
	                };
	
	                $window.complete3DSFrame = function (paRes) {
	                    $scope.complete3DS(paRes);
	                };
	
	                // when the esc key is pressed
	                $('html').on('keyup', function (ev) {
	                    if (ev.which === 27) {
	                        $scope.close3DSFrame();
	                    }
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/3ds/template.html":
/***/ function(module, exports) {

	module.exports = "<div content id=\"light-box-3ds\" class=\"light-box-3ds\">\n    <div content id=\"light-box\" class=\"light-box\" ng-class=\"{mobile: isDevice}\">\n        <div id=\"mask\" class=\"light-box mask\"></div>\n        <div class=\"light-box wrapper\">\n\n            <div class=\"light-box-container\">\n                <div class=\"aside\" id=\"lightBoxAcsWrapper\">\n                    <a class=\"close\" ng-click=\"close3DSFrame()\" href=\"#\">&nbsp;</a>\n                    <p class=\"light-box-header\">\n                        {{ content('threeDS.iFrameTitle') }}\n                    </p>\n                    <iframe name=\"threeDSFrame\" src=\"\" class=\"light-box-iframe\"></iframe>\n                </div>\n\n                <div class=\"logo\"></div>\n            </div>\n\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-models/src/profilemanagement/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.profilemanagement', ['squid']).factory('$MerchantPreferenceModel', function ($Model, $Api, $config, $util) {
	
	        return $Model.extend('MerchantPreferenceModel', {
	
	            init: function init() {
	
	                this._super.init.apply(this);
	
	                this.setProperties({
	                    rm: $util.param('rm'), // Return Method
	                    return_url: $util.param('return'),
	                    auto_return: {
	                        enabled: false
	                    },
	                    pdt: {
	                        enabled: false
	                    }
	                });
	            },
	
	            api: new $Api({
	                baseURI: $config.urls.baseUrl,
	                uri: '/api/profilemanagement/:id/getMerchantPreferences'
	            }),
	
	            autoReturn: function autoReturn() {
	                return this.auto_return.enabled;
	            },
	
	            pdtEnabled: function pdtEnabled() {
	                return this.pdt && this.pdt.enabled;
	            },
	
	            returnUrl: function returnUrl() {
	                return this.return_url || this.auto_return.url;
	            },
	
	            /**
	             * 0 – redirect using GET method ( default behavior )
	             * 1 – redirect using the GET method, but no payment variables are included
	             * 2 – redirect using the POST method, and include all payment variables
	             */
	            returnMethod: function returnMethod() {
	                var rm = this.rm;
	
	                if (rm === '2') {
	                    return this.pdtEnabled() ? 'GET' : 'POST';
	                } else {
	                    return 'GET';
	                }
	            },
	
	            returnMethodSupported: function returnMethodSupported() {
	                return this.returnMethod() === 'GET';
	            },
	
	            /**
	             * Determines if payment details need to be sent back to the merchant.
	             * @returns {boolean}
	             */
	            postPaymentData: function postPaymentData() {
	                return this.rm === '2' && !this.pdtEnabled() && this.returnUrl();
	            },
	
	            // charset of merchant having in profile
	            charSet: function charSet() {
	                return this.charset;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/profilemanagement", "components/xo-models/src/profilemanagement/index.js"))

/***/ },

/***/ "./components/xo-models/src/shoppingcart/index.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xomodel.shoppingcart', ['squid']).factory('$ShoppingCartModel', function ($Model, $Api) {
	        return $Model.extend('$ShoppingCartModel', {
	            api: new $Api({
	                uri: '/api/shoppingcart/:id',
	                postAttempts: 2,
	                cache: false
	            })
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-models/src/shoppingcart", "components/xo-models/src/shoppingcart/index.js"))

/***/ },

/***/ "./components/xo-member-components/src/review-topup/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _fi = __webpack_require__("./components/xo-models/src/fi/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/app/index.js");
	
	__webpack_require__("./components/xo-member-components/src/review-topup/styles.less");
	
	var _template = __webpack_require__("./components/xo-member-components/src/review-topup/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('xoReviewTopup', {
	    tag: 'xo-review-topup',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
	                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve(),
	                walletPinModel: _index.$TokenizedWalletPinModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        gotoTopupFunding: function gotoTopupFunding() {
	            _uiRouter.$state.go('checkout.review.sidepage.topupFunding');
	        },
	        gotoTopupAmount: function gotoTopupAmount() {
	            _uiRouter.$state.go('checkout.review.sidepage.topupAmount');
	        },
	        gotoUpdatePin: function gotoUpdatePin() {
	            _uiRouter.$state.go('checkout.review.sidepage.updatePin');
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.formatCurrency = _squid.formatCurrency;
	            this.instrumentIconId = function (name) {
	                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
	            };
	            (0, _jquery2['default'])('.tokenization').addClass('topup');
	        },
	        populate: function populate() {
	            // Use the user selected topup funding intrument during the flow.
	            if (this.models.checkoutSession.selectedTopupFundingSource) {
	                this.models.walletPreferences.topup.fundingSource = this.models.checkoutSession.selectedTopupFundingSource;
	            }
	
	            var topupFundingSource = this.models.walletPreferences.topup.fundingSource;
	            // Pick the first funding instrument in the topup FIs list, if user hasn't selected one already.
	            if (!topupFundingSource || !topupFundingSource.instrument_id) {
	                this.models.walletPreferences.topup.fundingSource = this.models.checkoutSession.topupFundingSources && this.models.checkoutSession.topupFundingSources[0];
	            } else if (!topupFundingSource.name) {
	                // Fetch topup funding instrument details from topup FIs list for FI from user wallet preferences.
	                this.models.walletPreferences.topup.fundingSource = _squid.$util.find(this.models.checkoutSession.topupFundingSources, function (fs) {
	                    return fs.instrument_id === topupFundingSource.instrument_id;
	                });
	            } else {
	                // Do Nothing
	            }
	
	            if (!this.models.walletPreferences.topup.amount) {
	                this.models.walletPreferences.topup.amount = _squid.$config.topup.topupAmounts[0];
	                this.models.walletPreferences.topup.currency = _squid.$config.topup.currency;
	            } else if (!this.models.walletPreferences.topup.currency) {
	                this.models.walletPreferences.topup.currency = _squid.$config.topup.currency;
	            }
	        },
	        exit: function exit() {
	            (0, _jquery2['default'])('.tokenization').removeClass('topup');
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$config;
	
	_squid.formatCurrency;
	
	_squid.$util;
	
	_uiRouter.$state;
	
	_checkout.$CheckoutSessionModel;
	
	_fi.$WalletPreferences;
	
	_fi.$WalletInstrumentNameMapping;
	
	_index.$TokenizedWalletPinModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-member-components/src/review-topup/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-member-components/src/review-topup/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-member-components/src/review-topup/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#reviewTopup .listItem{cursor:pointer;margin-bottom:35px;position:relative}#reviewTopup .listItem .label{font-weight:500}#reviewTopup .listItem .listItemValue{float:right;padding-right:20px;display:inline-flex;max-width:55%}#reviewTopup .listItem .listItemValue .fsname{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-left:35px}#reviewTopup .listItem .listItemValue .fsLast4{vertical-align:top;white-space:nowrap}#reviewTopup .hiddenPin{font-size:25px!important;line-height:.8!important}#reviewTopup .pinValue{float:right;font-size:15px;line-height:1.13;text-align:right;color:#2c2e2f}#reviewTopup .pinKey{float:right;font-size:10px;line-height:1.7;text-align:right;color:#6c7378}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-member-components/src/review-topup/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"reviewTopup\" content>\n    <div class=\"listItem\" ng-if=\"models.walletPreferences.topup.amount && models.walletPreferences.topup.currency\" ng-click=\"actions.gotoTopupAmount()\">\n        <span class=\"label\">{{content('review.topupAmountLabel')}}</span>\n        <format-currency class=\"listItemValue\" code=\"models.walletPreferences.topup.currency\"\n                         amount=\"models.walletPreferences.topup.amount\"\n                         currency-style=\"Currency\"></format-currency>\n        <a ui-sref=\"checkout.review.sidepage.topupAmount\" class=\"edits changePayment\" select-button focus-when-state=\"checkout.review.sidepage.topupAmount\" transitions-to=\"checkout.review\">\n            <span class=\"frontArrow goTray\"></span>\n        </a>\n    </div>\n    <div class=\"listItem\" ng-click=\"actions.gotoTopupFunding()\">\n        <span class=\"label\">{{content('review.topupFundingLabel')}}</span>\n        <div class=\"listItemValue\">\n            <span class=\"walletIcons\" ng-class=\"[models.walletPreferences.topup.fundingSource.type,\n                                                instrumentIconId(models.walletPreferences.topup.fundingSource.name),\n                                                models.walletPreferences.topup.fundingSource.card_type]\"></span>\n            <span class=\"fsname\">{{models.walletPreferences.topup.fundingSource.name}}</span>\n            <span class=\"fsLast4\">&nbsp;x-{{models.walletPreferences.topup.fundingSource.last4}}</span>\n            <a ui-sref=\"checkout.review.sidepage.topupFunding\" class=\"edits changePayment\" select-button focus-when-state=\"checkout.review.sidepage.topupFunding\" transitions-to=\"checkout.review\">\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n        </div>\n    </div>\n    <div class=\"listItem\" ng-click=\"actions.gotoUpdatePin()\" ng-if=\"models.walletPinModel.pinOrigin==='UNSET'\">\n        <span class=\"label\">{{content('review.inStorePinLabel')}}</span>\n        <div class=\"listItemValue\">\n            <div ng-if=\"models.walletPinModel.userPin\">\n                <div><span class=\"pinValue hiddenPin\">••••</span></div>\n            </div>\n            <div ng-if=\"!models.walletPinModel.userPin\">\n                <div ng-if=\"models.walletPinModel.suggestedPin\">\n                    <div class=\"pinValue\">{{models.walletPinModel.suggestedPin}}</div>\n                    <div>\n                        <span class=\"pinKey\" ng-if=\"models.walletPinModel.suggestedKey==='dob'\">{{content('review.inStorePinYear')}}</span>\n                        <span class=\"pinKey\" ng-if=\"models.walletPinModel.suggestedKey==='phone'\">{{content('review.inStorePinPhone')}}</span>\n                    </div>\n                </div>\n                <div ng-if=\"!models.walletPinModel.suggestedPin\">\n                    <span class=\"pinValue\">{{content('review.inStorePinUnset')}}</span>\n                </div>\n            </div>\n            <a ui-sref=\"checkout.review.sidepage.updatePin\" class=\"edits changePayment\" select-button focus-when-state=\"checkout.review.sidepage.updatePin\" transitions-to=\"checkout.review\">\n                <span class=\"frontArrow goTray\"></span>\n            </a>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-review/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"review\" content ng-click=\"onPageClick($event)\" id=\"memberReview\" tabindex=-1 role=\"presentation\">\n    <xo-title title-txt=\"{{content('memberReview.memberReviewTitle')}}\" class=\"accessAid\"></xo-title>\n    <div ng-if=\"!checkoutCart.isWalletTokenization()\" class=\"row-fluid justMember\" ng-class=\"{ bmlPopupOpen: bmlPopupOpen }\">\n        <div class=\"span14 trayInner reviewSections\" ng-show=\"!bmlPopupOpen\">\n\n            <div class=\"userBanner\">\n                <xo-banner ng-if=\"personalizedBanner.show && !isMessengerBAIntegration\" banner-image=\"personalizedBanner.imageUrl\">\n                    <p class=\"userEmail\" id=\"reviewUserInfo\">\n                        <span ng-if=\"!optin_toggle.isEnabled\">{{ content('memberReview.loggedInWithOneTouch', {userName: formattedNameInformal}) }}</span>\n                        <span ng-if=\"optin_toggle.isEnabled\">{{ content('memberReview.hiUser', {userName: formattedNameInformal}) }}</span>\n                        <span ng-if=\"showNotYou\">\n                            <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                        </span>\n                    </p>\n                </xo-banner>\n                <xo-message message=\"checkoutSession.message\"></xo-message>\n                <div ng-if=\"!personalizedBanner.show && !isMessengerBAIntegration\">\n                    <p class=\"userEmail\" id=\"reviewUserInfo\">\n                        {{ content('memberReview.hiUser', {userName: formattedNameInformal}) }}\n                        <span ng-if=\"showNotYou\">\n                            <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                        </span>\n                    </p>\n                </div>\n            </div>\n            <div ng-if=\"optin_toggle.isEnabled\" class=\"oneTouchBanner\">\n                <div class=\"highlight_bar\"></div>\n                <div class=\"oneTouchTerms\">\n                    <p class=\"enable_auto_login bold\" ng-if=\"!optin_toggle.value\">{{ content('memberReview.autoLoginOff') }}</p>\n                    <p class=\"enable_auto_login\" ng-if=\"optin_toggle.value\">{{ content('memberReview.autoLoginOn') }}</p>\n\n                    <div ng-show=\"optin_toggle.showExpandedTerms\" class=\"oneTouchTermsText\">\n                        <p class=\"expanded\" ng-bind-html=\"htmlContent('memberReview.expandedTermsOT')\"></p>\n                        <p class=\"securityInfo\">\n                            {{ content('memberReview.securityInfoOT') }} <a ng-click=\"optin_toggle.showExpandedTerms = !optin_toggle.showExpandedTerms\">Hide</a>\n                        </p>\n                    </div>\n                    <div ng-show=\"!optin_toggle.showExpandedTerms\">\n                        <p class=\"securityInfo\">\n                            <span ng-show=\"!optin_toggle.value\">{{ content('memberReview.sharedDevicesOT') }}</span>\n                            <a ng-click=\"optin_toggle.showExpandedTerms = !optin_toggle.showExpandedTerms\">Details</a>\n                        </p>\n                    </div>\n                </div>\n                <div id=\"banner-switch\">\n                    <input id=\"optin_toggel\" class=\"cmn-toggle cmn-toggle-round\" type=\"checkbox\" ng-model=\"optin_toggle.value\" ng-change=\"onTouchToggle(optin_toggle.value)\">\n                    <label for=\"optin_toggel\"></label>\n                </div>\n            </div>\n\n            <form name=\"confirm\" class=\"proceed\" novalidate=\"novalidate\" id=\"ryiForm\">\n                <!-- {@if cond=\"'{data.updated}' === 'bmlSuccess'\" } -->\n\n                <div class=\"reviews\" ng-if=\"merchantMsg\">\n                    <h4 ng-if=\"!isMessengerBAIntegration\" class=\"noBottom gamma\" id=\"merchantMsgHeader\">\n                        {{ content('memberReview.merchantMsgHeader')}}\n                    </h4>\n                    <!--content-->\n                    <h1 ng-if=\"isMessengerBAIntegration\" class=\"messengerBAHeader\" id=\"merchantMsgHeader\">\n                        PayPal is on Messenger!\n                    </h1>\n                    <div class=\"merchantMsg\" id=\"merchantMsg\">\n                        <span class=\"given-name\">\n                            {{ merchantMsg }}\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"showInstallmentOption()\">\n                    <div id=\"installmentPlanInfo\">\n                        <h4 class=\"noBottom gamma\" id=\"installmentInfoHeader\">\n                            {{content('chooseCreditOption.reviewPaymentPlan')}}\n                        </h4>\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"creditOptions.creditType === 'INST'\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText1',{term:creditOptions.term, monthlyPayment: installmentInfo.monthlyPaymentAmt})\"> </p>\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText2',{apr:creditOptions.apr, interest: installmentInfo.totalInterestAmt, totalPayment: installmentInfo.totalPaymentAmt})\"> </p>\n                        </div>\n\n                        <div class=\"merchantMsg installmentInfo\" ng-if=\"creditOptions.creditType === 'SAC' || creditOptions.creditType === 'NI'\">\n                            <p class=\"selectedCreditDesc\" ng-bind-html=\"htmlContent('fundingInstruments.bmlDetails')\"> </p>\n                        </div>\n                        <a class=\"edits creditEdit\" ng-click=\"showCYCO()\">\n                            {{ content('common.change') }}\n                            <span class=\"frontArrow goTray ng-scope\"></span>\n                        </a>\n                    </div>\n                </div>\n\n                <div class=\"reviews\" ng-if=\"showShippingAddress\">\n                    <xo-review-address token=\"token\" make-addr-preferred=\"makeAddrPreferred\" store-pick-up-selected=\"checkoutCart.isShippingMethodStorePickUp()\"></xo-review-address>\n                </div>\n\n                <xo-select-shipping-method ng-if=\"showShippingMethod\" token=\"token\" show-shipping-address=\"showShippingAddress\" error-handler-helper=\"errorHandlerHelper\" instant-update-feature=\"instantUpdateFeature\"></xo-select-shipping-method>\n\n                <div class=\"reviews\">\n                    <xo-review-paywith ng-if=\"!isVenmoFlow()\" token=\"token\" pay-button-text=\"payButtonText()\" show-auth-msg=\"showAuthMsg\"\n                                       installment-not-selected=\"installmentNotSelected\"\n                                       show-bml-popup=\"showBmlPopup\" installment=\"installment\"\n                                       pad-toggle-feature=\"padToggleFeature\"\n                                       make-fi-preferred=\"makeFiPreferred\"\n                                       selectedmethod=\"selectedmethod\"\n                                       select-fi-variant=\"selectFiVariant\">\n                    </xo-review-paywith>\n                    <xo-review-paywith-venmo ng-if=\"isVenmoFlow()\" token=\"token\"></xo-review-paywith-venmo>\n                </div>\n\n                <div class=\"offers\" ng-if=\"!isVenmoFlow()\">\n                    <xo-offer token=\"token\" promotion=\"promotion\" bmlaction=\"bmlaction\" installment=\"installment\"\n                        selectedmethod=\"selectedmethod\">\n                    </xo-offer>\n                </div>\n\n                <div ng-if=\"showRemittanceDisclosure\" class=\"rtrWrap\">\n                    {{ content('memberReview.rtrMsg', { merchantName: checkoutAppData.merchant.brand_name }) }}\n                </div>\n\n                <!--inc/bmlLearnMore-->\n                <div>\n                    <div class=\"buttons bmlSeeTermsBtn hide\">\n                        <button class=\"btn full hide\" name=\"authUserBtn\">{{content('authUserLearnMore.ok')}}</button>\n                    </div>\n                </div>\n\n                <!--Action button -->\n                <p ng-if=\"!isVenmoFlow() && showPaypalPolicies\" class=\"paypalPoliciesLink disclaimer\" data-ng-bind-html=\"content('memberReview.viewPaypalPolicies')\">\n                </p>\n\n                <p class=\"unconfirmedUpopMsg\" ng-if=\"showUnconfirmedUpopMsg\">\n                    {{ content('confirmUpop.confirmUpopToPay')}}\n                </p>\n\n                <div ng-if=\"checkoutSession.isAuthRequired\">\n                    <input type=\"hidden\" name=\"email\" ng-value=\"auth.email\" />\n                    <div class=\"inputField password confidential\">\n                        <!-- take care of error class-->\n                        <label for=\"oneclickpassword\">{{ content('memberReview.enterPassword')}}</label>\n                        <input id=\"oneclickpassword\" name=\"password\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\" aria-required=\"true\" ng-maxlength=\"22\" />\n                    </div>\n                </div>\n\n                <p ng-if=\"!isVenmoFlow() && showPolicyAgreement\" class=\"disclaimer\" id=\"policyAgreement\" data-ng-bind-html=\"content('memberReview.policyAgreement', {country: locale.country, lang: locale.lang})\">\n                </p>\n\n                <div id=\"fixedButton\" class=\"frame\" ng-if=\"showFixedButton()\">\n                    <hr class=\"frameborder\">\n                    <div class=\"buttons fixed\">\n                        <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\" class=\"btn full confirmButton continueButton\" validate-submit=\"onPay()\" />\n                    </div>\n                </div>\n\n                <div id=\"messengerPlugin\" class=\"messengerBAPlugin\" ng-if=\"isMessengerBAIntegration\">\n                    <!--content-->\n                    <h4 class=\"noBottom paymentsHeader zeta\"> Get PayPal receipts in Messenger</h4>\n                    <div>\n                        <xo-messenger-plugin token=\"token\" plugin-type=\"CHECKBOX\"></xo-messenger-plugin>\n                        <p class=\"messengerLegalTxt\">Any information sent or received on Messenger can be used according to Facebook’s Data Policy</p>\n                    </div>\n                </div>\n\n                <div id=\"button\" class=\"buttons reviewButton\">\n                    <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\" class=\"btn full confirmButton continueButton\" validate-submit=\"onPay()\" />\n                </div>\n\n                <!--content-->\n                <div class=\"messengerBANotnow\" ng-if=\"isMessengerBAIntegration\">\n                    <a href=\"\" ng-click=\"onFBBANotNow()\">Not Now</a>\n                </div>\n\n\n                <!-- checkoutSession.isRT need to review this -->\n                <p class=\"reviewLaterContainer disclaimer\" ng-if=\"showReviewLater\">\n                    {{ content('common.reviewLater')}}\n                </p>\n\n                <div id=\"disclaimerWithBmlCta\" class=\"disclaimer reviewMsg\" ng-if=\"!isVenmoFlow() && showSoftDescriptor && checkoutSession.plan.soft_descriptor\"\n                     ng-bind-html=\"content('memberReview.disclaimer', {merchantName: checkoutSession.plan.soft_descriptor})\"></div>\n\n                <div class=\"disclaimer reviewMsg\" ng-if=\"checkoutSession.displayBankChargeDisclaimer\">{{ content('memberReview.bankChargeDisclaimer')}}</div>\n\n                <div class=\"billingAddressConsent reviewMsg\" ng-if=\"checkoutAppData.flags.billing_address_consent_required\">\n                    <p class=\"disclaimer\">{{ content('memberReview.billingRequired') }}\n                        <p>\n                </div>\n\n                <div class=\"disclaimer reviewMsg\" ng-if=\"checkoutSession.plan.isAuthSignupEnabled || showAuthMsg\">\n                    <span class=\"authMsgContent\">{{ content('memberReview.authUser') }}</span> <a ui-sref=\"checkout.authorizationmessage\" class=\"authUserLink\" aria-describedby=\"authMsgHelp\">{{ content('memberReview.learnMore') }}</a>\n                    <span id=\"authMsgHelp\" class=\"accessAid\">{{content('authUserLearnMore.authUserTitle')}}</span>\n                </div>\n\n                <div id=\"creditExampleUK\" ng-if=\"showRepresentativeInfo()\">\n                    <p class=\"disclaimer reviewMsg bmlLender\">{{content('chooseCreditOption.representativeEx')}}</p>\n                    <p class=\"disclaimer reviewMsg bmlLender\">{{content('chooseCreditOption.representativeExHeader')}}</p>\n                    <table class=\"trayInner trayInnerDefault representativeEx row-fluid\">\n                        <tr class=\"span6\">\n                            <td class=\"representativeExKey\">{{content('chooseCreditOption.purchaseRate')}}</td>\n                            <td class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.purchaseRateValue')}}</td>\n                        </tr>\n                        <tr class=\"span6\">\n                            <td class=\"representativeExKey\">{{content('chooseCreditOption.representativeAPR')}}</td>\n                            <td class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.representativeAPRValue')}}</td>\n                        </tr>\n                        <tr class=\"span6 last\">\n                            <td class=\"representativeExKey\">{{content('chooseCreditOption.exCreditLimit')}}</td>\n                            <td class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.exCreditLimitValue')}}</td>\n                        </tr>\n                    </table>\n                    <p class=\"disclaimer reviewMsg bmlLender\">{{content('chooseCreditOption.terms')}}</p>\n                </div>\n            </form>\n\n        </div>\n\n        <xo-bml-popup ng-if=\"!isVenmoFlow()\"></xo-bml-popup>\n\n        <div ng-show=\"bmlPopupOpen\" class=\"bmlPopup span14\">\n            <p>\n                {{ content('fundingInstruments.bmlLearnMoreDesc') }}\n            </p>\n\n            <input type=\"button\" class=\"btn full primary\" value=\"{{ content('fundingInstruments.ok') }}\" ng-click=\"hideBmlPopup()\" />\n        </div>\n\n        <div class=\"span10\" ng-if=\"!isVenmoFlow()\">\n\n            <xo-marketing-offers placement-code=\"'202003'\"\n                                 token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"propValueObj.propHeader\"\n                                 subtitle-property=\"propValueObj.propVal\"\n                                 background-image= \"propValueObj.propImage\"\n                                 ng-if=\"!ryiDesignExp && !isMessengerBAIntegration\"\n            >\n            </xo-marketing-offers>\n\n            <xo-marketing-offers token=\"token\"\n                                 page-name=\"'HERMES_RYI_PAGE'\"\n                                 title-txt-property=\"'ryiDesignExp.propHeader'\"\n                                 subtitle-property=\"'ryiDesignExp.propText'\"\n                                 background-image=\"{{ryiDesignExp.propImage}}\"\n                                 ng-if=\"ryiDesignExp && !isMessengerBAIntegration\"\n\n            >\n            </xo-marketing-offers>\n        </div>\n    </div>\n    <div class=\"reviewTopup\" ng-if=\"checkoutCart.isWalletTokenization()\">\n        <div class=\"topupError\" ng-if=\"topupError\">\n            <span class=\"topupErrorIcon\"></span>\n            <span>{{content('review.pinError')}}</span>\n        </div>\n        <xo-title title-txt=\"Review the details\"></xo-title>\n        <div class=\"topupMsg\">{{content('review.topup')}}</div>\n        <xo-review-topup class=\"fillflex\" token=\"token\" pin=\"pin\"></xo-review-topup>\n        <div class=\"disclaimer reviewMsg\" ng-bind-html=\"content('review.topupSetupAgreements')\"></div>\n        <div id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{payButtonText()}}\" id=\"confirmButtonTop\"\n                   class=\"btn full confirmButton continueButton\" ng-click=\"onPay()\" />\n        </div>\n    </div>\n    <div ui-view></div>\n    <xo-3ds on-complete-3ds-handler=\"onComplete3DSHandler\" token=\"token\" data=\"resolve_3ds_data\" ng-if=\"launch3DSResolver\"></xo-3ds>\n</section>\n"

/***/ },

/***/ "./components/xo-styles/dist/lib/toggle.less":
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-styles/dist/lib/toggle.less");
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./toggle.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./toggle.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-styles/dist/lib/toggle.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".cmn-toggle{position:absolute;visibility:hidden}.cmn-toggle+label{display:block;position:relative;cursor:pointer;outline:none;user-select:none}input.cmn-toggle-round+label{padding:2px;width:47px;height:18px;border-radius:9px;border:1px solid #c8c8c8;background-image:linear-gradient(0deg,#ebebeb,#dcdcdc);box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box}input.cmn-toggle-round+label:after,input.cmn-toggle-round+label:before{display:block;position:absolute;top:1px;left:1px;bottom:1px;content:\"\"}input.cmn-toggle-round+label:before{right:1px;background-color:#dcdcdc;border-radius:30px;transition:background .4s}input.cmn-toggle-round+label:after{width:30px;height:30px;background-color:#fff;border:2px solid #b4b4b4;border-radius:100%;transition:margin .4s;margin-left:-4px;margin-top:-8px}input.cmn-toggle-round+label:after,input.cmn-toggle-round:checked+label{box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box}input.cmn-toggle-round:checked+label{background-image:linear-gradient(0deg,#00cf92,#00cf92);border:1px solid #00aa78}input.cmn-toggle-round:checked+label:before{background-color:#00cf92}input.cmn-toggle-round:checked+label:after{border:2px solid #01aa78;margin-left:15px}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-authorization-message/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AuthorizationMessageRoute = undefined;
	
	__webpack_require__("./pages/xo-authorization-message/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AuthorizationMessageRoute = exports.$AuthorizationMessageRoute = _squid.$ComponentRoute.extend('$AuthorizationMessageRoute', {
	
	    path: 'authorizationmessage',
	    directive: 'xo-authorization-message',
	    titleContent: 'authUserLearnMore.authUserTitle',
	
	    trackingData: {
	        fptiState: 'authorizationmessage',
	        templateName: 'authorizationMessage.dust',
	        pageGoal: 'Authorization Message',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-authorizationmessage',
	                'pagename2': '%::fullpage-authorizationmessage:member:hermes:',
	                'version': 'member:%:'
	            }
	        }
	    }
	});
	
	angular.value("$AuthorizationMessageRoute", $AuthorizationMessageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-authorization-message/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-authorization-message/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoAuthorizationMessageComponent', {
	
	    tag: 'xo-authorization-message',
	    template: _template2['default']
	
	});
	
	
	_squid.$Component;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-authorization-message/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"review\" content id=\"memberReview\" form-autofocus>\n\n    <div class=\"row-fluid justMember\">\n        <div class=\"span14 trayInner reviewSections\">\n            <div id=\"authMsg\" tabindex=\"-1\" modal-box aria-labelledby=\"authUserTitle\" aria-describedby=\"authUserContent1 authUserContent2\">\n                <div id=\"authUserLearnMore\" class=\"trayInner trayInnerDefault\">\n                    <h4 id=\"authUserTitle\" class=\"authUserTitle zeta\">{{content('authUserLearnMore.authUserTitle')}}</h4>\n                    <p id=\"authUserContent1\" class=\"authUserContent\">{{content('authUserLearnMore.authUserContentPara1')}}</p>\n                    <p id=\"authUserContent2\" class=\"authUserContent\">{{content('authUserLearnMore.authUserContentPara2')}}</p>\n                </div>\n                <div class=\"buttons\">\n                    <button class=\"btn authUserBtn full\" ui-sref=\"checkout.review\" focus-after-transition=\".authUserLink\" name=\"authUserBtn\">{{content('authUserLearnMore.ok')}}</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-add-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddCardPageRoute = undefined;
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	__webpack_require__("./pages/xo-add-card/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddCardPageRoute = exports.$AddCardPageRoute = _squid.$ComponentRoute.extend('$AddCardPageRoute', {
	
	    path: 'pageAddCard',
	    directive: 'xo-page-add-card-page',
	    titleContent: 'asideHeader.addCard',
	    query: ['cause', 'message'],
	    trackingData: {
	        templateName: 'addCard.dust',
	        pageGoal: 'Add Card',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-cc',
	                'pagename2': '%::fullpage-add-cc:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            messagetitle: 'messagetitle',
	            message: 'message',
	            pagetitle: 'pagetitle',
	            'parent-callbacks': 'callbacks',
	            logout: 'logout',
	            'show-cancel': 'showCancel'
	        }
	    }]
	});
	
	angular.value("$AddCardPageRoute", $AddCardPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoPageAddCardPageComponent = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _template = __webpack_require__("./pages/xo-add-card/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-models/src/fi/lib/fiMessages.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _choice = __webpack_require__("./components/xo-models/src/choice/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoPageAddCardPageComponent = exports.$xoPageAddCardPageComponent = _squid.$Component.extend('$xoPageAddCardPageComponent', {
	    tag: 'xo-page-add-card-page',
	    template: _template2['default'],
	    scope: {},
	
	    controller: function controller($scope, $rootScope, $state, $locale, $CheckoutSessionModel, $populate, $stateParams, $CheckoutPayeeModel, $CheckoutCartModel, $AuthModel, $fiMessages) {
	        // eslint-disable-line max-params,no-shadow
	        $scope.token = $rootScope.token;
	        $scope.locale = $locale;
	        $scope.callbacks = {
	            finish: function finish() {
	                $state.go('checkout.review');
	            }
	        };
	
	        var models = {};
	
	        $populate(models, {
	            checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
	                contingencies: {
	                    NEED_CREDIT_CARD: angular.noop,
	                    EXPIRED_CREDIT_CARD: angular.noop,
	                    NEED_DEBIT_CARD: angular.noop,
	                    EXPIRED_DEBIT_CARD: angular.noop
	                }
	            }),
	            payee: $CheckoutPayeeModel.instance($scope.token),
	            cart: $CheckoutCartModel.instance($scope.token),
	            auth: $AuthModel.instance().retrieve()
	        }).then(function () {
	            (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': $scope.locale.country }, 'xo_hermes_addcard_msg_treatment').then(function (result) {
	                var message = $fiMessages.processorDeclinedMsg(models.checkoutSession, false);
	
	                // If no processor decline, get the message when contingency is anything but NEED_DEBIT_CARD
	                if (!message && models.checkoutSession.get('errorData.cause') && $stateParams.message !== 'NEED_DEBIT_CARD') {
	                    if (models.payee.isGambling()) {
	                        message = $fiMessages.getGamblingMsg();
	                    } else if (result) {
	                        message = $fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
	                    } else {
	                        message = $fiMessages.getAddCardControlMsg();
	                    }
	                }
	
	                $scope.message = undefined;
	                $scope.cart = models.cart;
	                $scope.auth = models.auth;
	
	                if (message) {
	                    $scope.message = {
	                        type: message.type,
	                        msgs: [message.msg]
	                    };
	                    if (message.title) {
	                        $scope.messagetitle = $locale.content.get(message.title.key);
	                    }
	                }
	
	                // Set ShowCancel if selectFi variant, to cancel to the Select Fi page
	                return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
	                    var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];
	
	                    // Show selectFi features if no contingency
	                    if (selectFiVariants.indexOf(variant) !== -1 && !message) {
	                        $scope.showCancel = true;
	                        $scope.callbacks.cancel = function () {
	                            $state.go('checkout.selectFi');
	                        };
	                        $scope.pagetitle = $locale.content.get('addCard.addACard');
	                    }
	                });
	            });
	        });
	
	        $scope.isUpdateDebitCard = function () {
	            return $stateParams.message === 'EXPIRED_DEBIT_CARD';
	        };
	
	        $scope.logout = function () {
	            _logger.$logger.info('not_you_logout');
	
	            if (window.xchild && _squid.$util.isIFrame()) {
	
	                window.xchild.hide();
	
	                var url = window.location.href.split('#')[0];
	
	                var xprops = _extends({}, window.xprops);
	
	                xprops.url = url;
	                xprops.payment = function () {
	                    return $scope.auth.action('logout').then(function () {
	                        return $scope.token;
	                    });
	                };
	
	                return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
	            }
	
	            $scope.auth.action('logout').then(function () {
	                $state.go('checkout.login', {
	                    source: 'NOT_YOU'
	                });
	            });
	        };
	    }
	});
	
	angular.value("$xoPageAddCardPageComponent", $xoPageAddCardPageComponent);
	_squid.$Component;
	
	_squid.$config;
	
	_squid.$pxp;
	
	_squid.$util;
	
	_choice.$ChoiceEligibility;
	
	_logger.$logger;

/***/ },

/***/ "./pages/xo-add-card/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\" ng-if=\"!cart.isWalletTokenization()\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n    <div class=\"sidepage noSlide\" modal-box tabindex=\"-1\" ng-if=\"cart.isWalletTokenization()\">\n        <div class=\"aside noSlide\" id=\"sidepageAddCard\" modal-box>\n            <xo-aside-header heading=\"{{isUpdateDebitCard() ? 'asideHeader.updateDebitCard' : 'asideHeader.addDebitCard'}}\"\n                             hidex=\"true\"></xo-aside-header>\n            <div class=\"content\">\n                <ui-view></ui-view>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-add-fi/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddFiPageRoute = undefined;
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-bank/route.js");
	
	__webpack_require__("./pages/xo-add-fi/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddFiPageRoute = exports.$AddFiPageRoute = _squid.$ComponentRoute.extend('$AddFiPageRoute', {
	
	    path: 'pageAddFi',
	
	    directive: 'xo-page-add-fi-page',
	
	    query: ['cause', 'message'],
	
	    titleContent: 'addCard.addPaymentMethod',
	
	    trackingData: {
	        templateName: 'addFi.dust',
	        pageGoal: 'Add Funding Instrument',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-fi',
	                'pagename2': '%::fullpage-add-fi:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            hideparenthead: 'hideparenthead',
	            billingaddressupdated: 'billingaddressupdated',
	            'parent-callbacks': 'callbacks',
	            'page-level': 'pageLevel'
	        }
	    }, {
	        name: '$AddBankFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            hideparenthead: 'hideparenthead',
	            'parent-callbacks': 'callbacks',
	            'page-level': 'pageLevel'
	        }
	    }]
	});
	
	angular.value("$AddFiPageRoute", $AddFiPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-fi/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoPageAddFiPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-add-fi/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-models/src/fi/lib/fiMessages.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoPageAddFiPageComponent = exports.$xoPageAddFiPageComponent = _squid.$Component.extend('$xoPageAddFiPageComponent', {
	    tag: 'xo-page-add-fi-page',
	    template: _template2['default'],
	    scope: {
	        logout: '='
	    },
	    controller: function controller($scope, $rootScope, $util, $AuthModel, $state, $locale, $CheckoutSessionModel, $populate, $stateParams, $CheckoutPayeeModel, $fiMessages, $logger) {
	        // eslint-disable-line no-shadow
	        $scope.token = $rootScope.token;
	        $scope.locale = $locale;
	
	        $scope.billingaddressupdated = {
	            value: false
	        };
	
	        $scope.hideparenthead = {
	            toggle: false
	        };
	
	        $scope.title = $locale.content.get('addCard.addACard');
	
	        $scope.callbacks = {
	            finish: function finish() {
	                $state.go('checkout.review');
	            },
	            done: function done() {
	                $state.go('checkout.review');
	            }
	
	        };
	
	        var models = {};
	
	        $populate($scope, {
	            auth: $AuthModel.instance(),
	            payee: $CheckoutPayeeModel.instance($scope.token)
	        }).then(function () {
	
	            $scope.logout = function () {
	                $logger.info('not_you_logout');
	                $scope.auth.action('logout').then(function () {
	                    $state.go('checkout.login');
	                });
	            };
	
	            $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && !$util.param('ulReturn');
	            $populate(models, {
	                checkoutSession: $CheckoutSessionModel.instance($scope.token)
	            }).then(function () {
	                (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': $scope.locale.country }, 'xo_hermes_addcard_msg_treatment').then(function (result) {
	                    var message = $fiMessages.processorDeclinedMsg(models.checkoutSession, false);
	
	                    if ($scope.payee.isGambling()) {
	                        message = $fiMessages.getGamblingMsg();
	                    } else if (result) {
	                        message = $fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
	                    } else {
	                        message = $fiMessages.getAddCardControlMsg();
	                    }
	
	                    if (message.msg) {
	                        $scope.pageLevel = $scope.pageLevel || {};
	                        $scope.pageLevel.message = {
	                            type: message.type,
	                            msgs: [message.msg]
	                        };
	                        if (message.title) {
	                            $scope.messagetitle = $locale.content.get(message.title.key);
	                        }
	                    }
	                });
	            });
	        });
	    }
	});
	
	angular.value("$xoPageAddFiPageComponent", $xoPageAddFiPageComponent);
	_squid.$Component;
	
	_squid.$pxp;

/***/ },

/***/ "./pages/xo-add-fi/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addFi\" id=\"addFi\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <div class=\"trayInner trayInnerDefault\">\n                <h1 class=\"gamma noHead\" ng-if=\"!hideparenthead.toggle\">\n    \t\t\t\t{{content('addCard.addPaymentMethod')}}\n\t\t\t\t</h1>\n                <xo-message message=\"pageLevel.message\"></xo-message>\n                <ul class=\"form-tabs\" id=\"paymentTab\" ng-if=\"!hideparenthead.toggle\">\n                    <li class=\"bank\" ui-sref-active=\"active\">\n                        <a ui-sref=\".bank.add\" class=\"bankTab\">{{content('bank.bank')}}</a>\n                    </li>\n                    <li class=\"card\" ui-sref-active=\"active\">\n                        <a ui-sref=\".addCardFlow.addCard\" class=\"cardTab\" for=\"cardTab\">{{content('bank.card')}}</a>\n                    </li>\n                </ul>\n                <ui-view></ui-view>\n            </div>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props  type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-add-card-meft/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddCardMeftRoute = undefined;
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/route.js");
	
	__webpack_require__("./pages/xo-add-card-meft/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddCardMeftRoute = exports.$AddCardMeftRoute = _squid.$ComponentRoute.extend('$AddCardMeftRoute', {
	
	    path: 'pageAddCardMeft',
	    directive: 'xo-page-add-card-meft-page',
	    titleContent: 'asideHeader.addCard',
	    query: ['message'],
	    trackingData: {
	        templateName: 'meftDeclineAddCard.dust',
	        pageGoal: 'Add Card for MEFT Decline',
	        buzname: {
	            'fullpage': {
	                'pagename': '%:de:meft-addcard',
	                'pagename2': '%:de:meft-addcard:member:hermes:',
	                'hier1': '%de',
	                'version': 'member:%:',
	                'flowname': '%de',
	                'subfeature2': '%de'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            pagetitle: 'pagetitle',
	            billingaddressupdated: 'billingaddressupdated',
	            showmeftsection: 'showmeftsection',
	            'parent-callbacks': 'callbacks'
	        }
	    }]
	});
	
	angular.value("$AddCardMeftRoute", $AddCardMeftRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-card-meft/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoPageAddCardMeftPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-add-card-meft/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoPageAddCardMeftPageComponent = exports.$xoPageAddCardMeftPageComponent = _squid.$Component.extend('$xoPageAddCardMeftPageComponent', {
	    tag: 'xo-page-add-card-meft-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state, $CheckoutAppDataModel, $locale, $CheckoutSessionModel) {
	        // eslint-disable-line no-shadow
	        $scope.token = $rootScope.token;
	        $scope.locale = $locale;
	
	        $scope.checkoutAppData = $CheckoutAppDataModel.instance($scope.token);
	
	        function populateInfoMessage() {
	            var msg = $locale.content.get('DEMemberGuest.meftDeclinePageErrorMsg');
	
	            $scope.message = {
	                msgs: [msg],
	                type: 'info'
	            };
	        }
	
	        populateInfoMessage();
	
	        $scope.showmeftsection = {
	            toggle: true
	        };
	
	        $scope.useMeft = function () {
	            $scope.checkoutAppData.action('meft', {
	                success: function success(result) {
	                    // reload checkout session with new meft instrument.
	                    $CheckoutSessionModel.instance($scope.token).reload();
	                    $state.go('checkout.review');
	                }
	            });
	        };
	
	        $scope.callbacks = {
	            finish: function finish() {
	                $state.go('checkout.review');
	            }
	        };
	
	        $scope.billingaddressupdated = {
	            value: false
	        };
	    }
	});
	
	angular.value("$xoPageAddCardMeftPageComponent", $xoPageAddCardMeftPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-add-card-meft/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n            <div ng-show=\"showmeftsection.toggle\">\n                <p class=\"useMeftInstead\">{{content ('DEMemberGuest.useMeftInstead')}}</p>\n\n                <div>\n                    <a track-link=\"meft_done\" id=\"submitBtnMeft\" href=\"\" class=\"btn btn-secondary\n                            btn-large full submit\" ng-click=\"useMeft()\"\n                       role=\"button\">{{content ('DEMemberGuest.useMeftBtn')}}</a>\n                </div>\n            </div>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-add-tax-id/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddTaxIdRoute = undefined;
	
	__webpack_require__("./pages/xo-add-tax-id/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddTaxIdRoute = exports.$AddTaxIdRoute = _squid.$ComponentRoute.extend('$AddTaxIdRoute', {
	
	    path: 'addTaxId',
	    directive: 'xo-add-tax-id-page',
	    titleContent: 'addTaxId.addTaxId',
	    query: ['message'],
	    trackingData: {
	        templateName: 'addTaxId.dust',
	        pageGoal: 'Add Tax Id',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-tax-id',
	                'pagename2': '%::fullpage-add-tax-id:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    loginRequired: true,
	    children: []
	});
	
	angular.value("$AddTaxIdRoute", $AddTaxIdRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-tax-id/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _template = __webpack_require__("./pages/xo-add-tax-id/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-form-components/src/add-tax-id/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoAddTaxIdPageComponent', {
	
	    tag: 'xo-add-tax-id-page',
	
	    template: _template2['default'],
	
	    lifecycle: {
	        enter: function enter() {
	            this.token = _angular.$rootScope.token;
	            this.locale = _squid.$locale;
	
	            this.finish = function () {
	                _uiRouter.$state.go('checkout.review');
	            };
	        }
	    }
	
	});
	
	
	_angular.$rootScope;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_uiRouter.$state;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-add-tax-id/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addTaxId\" id=\"addTaxId\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-add-tax-id token=\"token\" finish=\"finish\"></xo-add-tax-id>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-form-components/src/add-tax-id/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/add-tax-id/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-add-tax-id.directive', ['squid', 'xomodel.checkout', 'xomodel.user', 'xo-error-tooltip.directive']).directive('xoAddTaxId', function () {
	        return {
	            scope: {
	                token: '=',
	                finish: '='
	            },
	            template: template,
	
	            controller: function controller($scope, $populate, $state, $element, $CheckoutSessionModel, $UserInfoModel, $CheckoutCartModel) {
	
	                function thenFunction() {
	                    var taxIdType = 'CPF';
	                    if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.cause === 'NEED_BUSINESS_TAX_INFO_TO_PAY') {
	                        taxIdType = 'CNPJ';
	                    }
	                    var issuer = 'BR_' + taxIdType;
	                    $scope.subType = taxIdType;
	
	                    $scope.userInfo = $UserInfoModel.instance($scope.token);
	
	                    $scope.onSubmit = function () {
	                        // Scrub the formatting when invoking the backend services.
	                        var unformatted = ($scope.taxId || '').replace(/[^0-9]+/g, '');
	                        var data = {
	                            newDocId: {
	                                type: 'TAX_ID',
	                                subType: $scope.subType,
	                                issuerCountry: 'BR',
	                                issuer: issuer,
	                                value: unformatted,
	                                collectionPoint: 'UNKNOWN',
	                                placeOfIssue: 'BR'
	                            }
	                        };
	
	                        $scope.userInfo.action('addTaxId', {
	                            data: data,
	
	                            success: function success() {
	                                var checkoutSession = $CheckoutSessionModel.instance($scope.token);
	                                var checkoutCart = $CheckoutCartModel.instance($scope.token);
	                                return checkoutSession.action('create', {
	                                    data: {
	                                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token
	                                    },
	                                    success: function success() {
	                                        // Clear the errors if create checkout session was successful
	                                        $scope.checkoutSession.errorData = undefined;
	                                        $scope.finish();
	                                    }
	                                });
	                            },
	
	                            validation: function validation(validationData) {
	                                var $el = $($element);
	                                var $field = $($el.find('[name="' + validationData.field + '"]'));
	                                $field.addClass('backendError');
	                                $field.attr('aria-invalid', true);
	                                $field.focus();
	                            }
	                        });
	                    };
	
	                    $scope.changeTaxId = function (newValue) {
	                        var unformatted = (newValue || '').replace(/[^0-9]+/g, '');
	                        var formatted = '';
	                        var i = 0;
	
	                        // For CPF we will format the output with dots and dashes like this:
	                        // 999.999.999-99
	                        if ($scope.subType === 'CPF') {
	                            for (i = 0; i < unformatted.length; i++) {
	                                if (i === 3 || i === 6) {
	                                    formatted = formatted + '.';
	                                }
	                                if (i === 9) {
	                                    formatted = formatted + '-';
	                                }
	                                formatted = formatted + unformatted.charAt(i);
	                            }
	                            $scope.taxId = formatted;
	                            // For CNPJ we will format the output with dots, dashes, and slashes like this:
	                            // 99.999.999/9999-99
	                        } else if ($scope.subType === 'CNPJ') {
	                            for (i = 0; i < unformatted.length; i++) {
	                                if (i === 2 || i === 5) {
	                                    formatted = formatted + '.';
	                                } else if (i === 8) {
	                                    formatted = formatted + '/';
	                                } else if (i === 12) {
	                                    formatted = formatted + '-';
	                                }
	                                formatted = formatted + unformatted.charAt(i);
	                            }
	                            $scope.taxId = formatted;
	                        } else {
	                            $scope.taxId = unformatted;
	                        }
	                    };
	                }
	
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(thenFunction());
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/add-tax-id/template.html":
/***/ function(module, exports) {

	module.exports = "<form id=\"taxIdForm\" name=\"taxIdForm\" class=\"taxIdForm\" content novalidate>\n    <div class=\"trayInner trayInnerDefault\">\n        <div ng-if=\"subType === 'CNPJ'\">\n            <h3 class=\"gamma noHead\">{{ content('addTaxId.addTaxIdCNPJ') }}</h3>\n            <p>{{ content('addTaxId.noteCNPJ') }}</p>\n\n            <div class=\"inputField confidential\" floating-label>\n                <input id=\"taxId\" name=\"taxId\" maxlength=\"18\" ng-model=\"$parent.taxId\"\n                       xo-error-tooltip required placeholder=\"{{ content('common.taxIdCNPJ_length') }}\"\n                       data-error-key=\"validation.validCNPJ\" ng-change=\"changeTaxId(taxId)\" />\n                <label for=\"taxId\">{{ content('addTaxId.cnpj') }}</label>\n            </div>\n        </div>\n\n        <div ng-if=\"subType === 'CPF'\">\n            <h3 class=\"gamma noHead\">{{ content('addTaxId.addTaxId') }}</h3>\n            <p>{{ content('addTaxId.note') }}</p>\n\n            <div class=\"inputField confidential\" floating-label>\n                <input id=\"taxId\" name=\"taxId\" maxlength=\"14\" ng-model=\"$parent.taxId\"\n                       xo-error-tooltip required placeholder=\"{{ content('common.taxId_length') }}\"\n                       data-error-key=\"validation.validCPF\" ng-change=\"changeTaxId(taxId)\" />\n                <label for=\"taxId\">{{ content('addTaxId.cpf') }}</label>\n            </div>\n        </div>\n\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{ content('addTaxId.save') }}\" class=\"btn full btn-large\" validate-submit=\"onSubmit()\" />\n        </div>\n    </div>\n</form>\n"

/***/ },

/***/ "./pages/xo-add-shipping/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddShippingPageRoute = undefined;
	
	__webpack_require__("./pages/xo-add-shipping/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddShippingPageRoute = exports.$AddShippingPageRoute = _squid.$ComponentRoute.extend('$AddShippingPageRoute', {
	
	    path: 'pageAddShipping',
	    directive: 'xo-page-add-shipping-page',
	
	    titleContent: 'addShipping.addAddress',
	
	    query: ['message'],
	
	    trackingData: {
	        templateName: 'addShipping.dust',
	        pageGoal: 'Add Shipping',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-add-shipping-address-nonXB',
	                'pagename2': '%::fullpage-add-shipping-address-nonXB:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddShippingRoute',
	        attributes: {
	            token: 'token',
	            'done-fn': 'callbacks.done',
	            sidebar: 'sidebar'
	        }
	    }]
	});
	
	angular.value("$AddShippingPageRoute", $AddShippingPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-shipping/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoPageAddShippingPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-add-shipping/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-address-components/src/add-address/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/select-shipping-country/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoPageAddShippingPageComponent = exports.$xoPageAddShippingPageComponent = _squid.$Component.extend('$xoPageAddShippingPageComponent', {
	    tag: 'xo-page-add-shipping-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state, $populate, // eslint-disable-line no-shadow
	    $feature, $locale, $CheckoutAppDataModel) {
	
	        $scope.token = $rootScope.token;
	        $scope.locale = $locale;
	        $scope.sidebar = false;
	        $scope.callbacks = {
	            done: function done() {
	                $state.go('checkout.review');
	            }
	        };
	
	        $populate($scope, {
	            checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
	        }).then(function () {
	            var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');
	
	            if (!$feature('supportBlockNonDomesticShipping', false, merchantCountry)) {
	                $state.go('checkout.review');
	            }
	        });
	    }
	});
	
	angular.value("$xoPageAddShippingPageComponent", $xoPageAddShippingPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-add-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addShipping\" id=\"addShipping\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-add-national-id/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$AddNationalIdRoute = undefined;
	
	__webpack_require__("./pages/xo-add-national-id/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $AddNationalIdRoute = exports.$AddNationalIdRoute = _squid.$ComponentRoute.extend('$AddNationalIdRoute', {
	
	    path: 'addNationalId',
	
	    directive: 'xo-add-national-id-page',
	
	    titleContent: 'addTaxId.nationalityUpdate',
	
	    trackingData: {
	        fptiState: 'add-national-id',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::add-national-id',
	                'pagename2': '%::add-national-id:member:hermes:',
	                'version': 'member:%:'
	            }
	        }
	    },
	
	    children: []
	});
	
	angular.value("$AddNationalIdRoute", $AddNationalIdRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-add-national-id/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoAddNationalIdPageComponent = undefined;
	
	var _template = __webpack_require__("./pages/xo-add-national-id/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-form-components/src/national-id-input/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoAddNationalIdPageComponent = exports.$xoAddNationalIdPageComponent = _squid.$Component.extend('$xoAddNationalIdPageComponent', {
	    tag: 'xo-add-national-id-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $state, $locale, $AddKYCModel, $CheckoutSessionModel, $NationalIdModel, $logger) {
	
	        $scope.locale = $locale;
	        $scope.user = {
	            country: $locale.country,
	            countryOfResidence: $locale.country
	        };
	
	        $scope.validate = function () {
	            $scope.validated = true;
	            return true;
	        };
	
	        $scope.onContinue = function () {
	            $scope.nationalIdModel = $NationalIdModel.instance($rootScope.token);
	            $scope.checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
	            $scope.addKYC = new $AddKYCModel({
	                token: $rootScope.token
	            });
	
	            $scope.KYCData = {
	                nationalIdModel: $scope.nationalIdModel,
	                user: $scope.user
	            };
	
	            $scope.addKYC.save({
	
	                data: $scope.KYCData,
	
	                success: function success() {
	                    $state.go('checkout.review');
	                },
	
	                contingencies: {
	                    DEFAULT: function DEFAULT(err, message) {
	                        $logger.info('add_KYC_contingency', {
	                            name: err,
	                            message: message
	                        });
	                    }
	                },
	                validation: function validation(res) {}
	            });
	        };
	    }
	});
	
	angular.value("$xoAddNationalIdPageComponent", $xoAddNationalIdPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-add-national-id/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addNationalId\" id=\"addNationalId\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner reviewSections\">\n            <p>\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span ng-if=\"auth.is_auth_api_call\">\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n\n            <div class=\"trayInner trayInnerDefault\">\n                <h1 class=\"gamma noHead\" ng-if=\"!hideparenthead.toggle\">\n                    {{ content( 'addTaxId.nationalityUpdate' ) }}\n                </h1>\n                <p>\n                    {{ content( 'addTaxId.nationalityNote' ) }}\n                </p>\n                <ui-view></ui-view>\n            </div>\n\n            <form id=\"addNationalIdForm\" name=\"addNationalIdForm\" ng-submit=\"addNationalIdForm.$valid && onContinue()\" ng-class=\"{'validated': validated}\" novalidate>\n                <xo-national-id-input country={{locale.country}} user=\"user\"></xo-national-id-input>\n\n                <div class=\"buttons\">\n                    <input track-submit id=\"nationalIdSubmit\" type=\"submit\" value=\"{{ content( 'common.agreeAndContinue' ) }}\" ng-click=\"validate()\" class=\"btn full signupFlowSubmit\"/>\n                </div>\n            </form>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props  type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-form-components/src/national-id-input/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/national-id-input/template.html"), __webpack_require__("./components/xo-ui-components/src/tooltip/directive.js"), __webpack_require__("./components/xo-form-components/src/dob-input/directive.js"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-national-id-input.directive', ['squid', 'xo-tooltip.directive', 'xo-dob-input.directive', 'xomodel.checkout']).directive('brIdValidations', function () {
	        return {
	            require: 'ngModel',
	
	            link: function link(scope, element, attr, ctrl) {
	                scope.cpfValidator = function cpfValidator(ngModelValue) {
	                    var value = ngModelValue.replace(/[^0-9]/gi, '');
	                    var len = value.length;
	
	                    if (len !== 11) {
	                        ctrl.$setValidity('nationalId', false);
	                        return ngModelValue;
	                    }
	
	                    var x = value.match(/\b(\d)\1+\b/);
	
	                    if (x) {
	                        ctrl.$setValidity('nationalId', false);
	                        return ngModelValue;
	                    }
	
	                    var v1 = 0;
	                    var v2 = 0;
	                    var dv1;
	                    var dv2;
	                    var i;
	                    var j;
	
	                    for (i = 0, j = 10; i < 9, j > 1; i++, j--) {
	                        // eslint-disable-line no-sequences
	                        v1 += j * +value[i];
	                    }
	
	                    v1 = v1 % 11;
	                    dv1 = 11 - v1 < 10 ? 11 - v1 : 0;
	
	                    for (i = 0, j = 11; i < 9, j > 2; i++, j--) {
	                        // eslint-disable-line no-sequences
	                        v2 += j * +value[i];
	                    }
	
	                    v2 += dv1 * 2;
	                    v2 = v2 % 11;
	                    dv2 = 11 - v2 < 10 ? 11 - v2 : 0;
	
	                    scope.isValid = dv1 === parseInt(value[9], 10) && dv2 === parseInt(value[10], 10);
	
	                    ctrl.$setValidity('nationalId', scope.isValid);
	
	                    return ngModelValue;
	                };
	
	                ctrl.$parsers.push(scope.cpfValidator);
	            }
	        };
	    }).directive('sgIdValidations', function () {
	        return {
	            require: 'ngModel',
	
	            link: function link(scope, element, attr, ctrl) {
	                scope.nricFinValidator = function nricFinValidator(ngModelValue) {
	                    var idType = scope.$parent.nationalIdModel.nationalId.type;
	                    if (idType === 'NATIONAL_ID') {
	                        scope.isValid = false;
	
	                        // Valid if first char is "S", "T", "F" or "G" and the rest 7 are digits.
	                        if (ngModelValue.match(/^[S|T|G|F]\d{7}$/gi)) {
	                            scope.isValid = true;
	                        }
	                    } else {
	                        scope.isValid = true;
	                    }
	                    ctrl.$setValidity('nationalId', scope.isValid);
	                    return ngModelValue;
	                };
	                ctrl.$parsers.push(scope.nricFinValidator);
	            }
	        };
	    }).directive('ruIdValidations', function () {
	        return {
	            require: 'ngModel',
	
	            link: function link(scope, element, attr, ctrl) {
	
	                function validateSNILSChunk(sum, checksum) {
	                    if (sum < 100 && sum === checksum) {
	                        return true;
	                    } else if ((sum === 100 || sum === 101) && checksum === 0) {
	                        return true;
	                    } else if (sum > 101) {
	                        var remainder = sum % 101;
	                        return validateSNILSChunk(remainder, checksum);
	                    }
	
	                    return false;
	                }
	
	                function validateSNILS(value) {
	                    if (value.length === 11) {
	                        if (Number(value) > 1001998) {
	                            var snilsNumber = value.substring(0, 9);
	                            var checksum = Number(value.substring(9));
	                            var sum = 0;
	                            var multiplier = 1;
	
	                            for (var i = snilsNumber.length - 1; i >= 0; i--) {
	                                sum = sum + Number(snilsNumber.charAt(i)) * multiplier;
	                                multiplier++;
	                            }
	
	                            return validateSNILSChunk(sum, checksum);
	                        }
	
	                        return true;
	                    }
	
	                    return false;
	                }
	
	                function validateINNChecksum(value, factor, valueLength, match) {
	                    var n;
	                    var sumn = 0;
	                    for (var i = 0; i < valueLength; i++) {
	                        sumn = sumn + Number(value[i]) * Number(factor[i]);
	                    }
	                    n = sumn % 11;
	                    n = n === 10 ? 0 : n;
	
	                    if (n !== Number(match)) {
	                        return false;
	                    }
	
	                    return true;
	                }
	
	                function validateINN(value) {
	                    if (value.length === 12) {
	                        var factor = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
	
	                        if (!validateINNChecksum(value, factor, value.length - 2, value[10])) {
	                            return false;
	                        }
	
	                        factor.unshift(3);
	
	                        if (!validateINNChecksum(value, factor, value.length - 1, value[11])) {
	                            return false;
	                        }
	
	                        return true;
	                    }
	
	                    return false;
	                }
	
	                function validateOMS(value) {
	                    if (value.length >= 11 && value.length <= 16) {
	                        return true;
	                    }
	
	                    return false;
	                }
	
	                scope.idValidator = function idValidator(ngModelValue) {
	                    var value = ngModelValue.replace(/[^0-9]/gi, '');
	                    var secondaryType = scope.nationalIdModel.secondaryIdType;
	
	                    if (secondaryType === 'SNILS') {
	                        scope.isValid = validateSNILS(value);
	                    } else if (secondaryType === 'INN') {
	                        scope.isValid = validateINN(value);
	                    } else if (secondaryType === 'OMS') {
	                        scope.isValid = validateOMS(value);
	                    }
	
	                    ctrl.$setValidity('secondaryId', scope.isValid);
	
	                    return ngModelValue;
	                };
	
	                ctrl.$parsers.push(scope.idValidator);
	            }
	        };
	    }).directive('xoNationalIdInput', function () {
	        return {
	            template: template,
	            scope: {
	                user: '=',
	                country: '@'
	            },
	
	            link: function link(scope, element, attr) {
	                var passportMask = '0000000000';
	
	                element.on('keyup', function (event) {
	                    if (scope.user.countryOfResidence === 'RU') {
	                        $('#nationalId').mask(passportMask, {
	                            'translation': {
	                                0: { pattern: /[0-9]/ }
	                            }
	                        });
	                    } else {
	                        $('#nationalId').unmask(passportMask);
	                    }
	                });
	            },
	
	            controller: function controller($scope, $feature, $locale, $rootScope, $CheckoutCartModel, $NationalIdModel, $util) {
	
	                $scope.nationalIdModel = $NationalIdModel.instance($rootScope.token);
	                $scope.checkoutCart = $CheckoutCartModel.instance($rootScope.token);
	                $scope.user = $scope.user || {};
	                $scope.user.countryOfResidence = $scope.user.countryOfResidence || $scope.country;
	                $scope.formattedValues = {};
	                $scope.showNationalIdFields = false;
	
	                function sortCountryList() {
	                    $scope.metadata = angular.copy($locale.metadata);
	                    return $scope.metadata.territory;
	                }
	
	                $scope.countries = sortCountryList();
	
	                if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.tax_id) {
	                    $scope.nationalIdModel.nationalId.value = $scope.checkoutCart.payer.tax_id;
	                }
	
	                $scope.countryChanged = function () {
	                    if ($scope.user.countryOfResidence === 'RU') {
	                        $scope.showNationalIdFields = true;
	                        $scope.minLengthNatId = 10;
	                        $scope.maxLengthNatId = 10;
	                    } else {
	                        $scope.showNationalIdFields = false;
	                        $scope.minLengthNatId = 6;
	                        $scope.maxLengthNatId = 15;
	                    }
	                };
	
	                $scope.cpfMasking = function (newValue) {
	                    if (newValue) {
	                        var unformatted = newValue.replace(/[^0-9]/gi, '');
	                        var formatted = [['', unformatted.slice(0, 3)], ['.', unformatted.slice(3, 6)], ['.', unformatted.slice(6, 9)], ['-', unformatted.slice(9)]].map(function (x) {
	                            return x[1] && x[0] + x[1] || '';
	                        }).join('');
	
	                        $scope.formattedValues.nationalId = formatted;
	                        $scope.nationalIdModel.nationalId.value = unformatted;
	                    } else {
	                        $scope.nationalIdModel.nationalId.value = '';
	                    }
	                };
	
	                $scope.secondaryIdFormatting = function () {
	                    var $el = $('#idValue');
	
	                    if ($scope.nationalIdModel.secondaryIdType === 'SNILS' && $el.length > 0) {
	                        var unformatted = $el.val().replace(/[^0-9]/gi, '');
	                        var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3, 6)], ['-', unformatted.slice(6, 9)], [' ', unformatted.slice(9)]].map(function (x) {
	                            return x[1] && x[0] + x[1] || '';
	                        }).join('');
	
	                        $scope.nationalIdModel.secondaryIdValue = formatted;
	                    }
	                };
	
	                $scope.secondaryIdChange = function () {
	                    var currentSecondaryId = $scope.secondaryIds[$scope.nationalIdModel.secondaryIdType];
	
	                    $scope.nationalIdModel.secondaryIdValue = '';
	                    $scope.maxLength = currentSecondaryId.length;
	                    $scope.minLength = currentSecondaryId.minlength ? currentSecondaryId.minlength : currentSecondaryId.length;
	
	                    $scope.maskCharLength = currentSecondaryId.maskCharLength ? currentSecondaryId.maskCharLength : 0;
	                };
	
	                $scope.sgIdChange = function () {
	                    $scope.nationalIdModel.nationalId.value = '';
	                };
	
	                function setLocalizedNatIDLabels() {
	                    $scope.nationalIds = {
	                        'NATID': { name: 'NATIONAL_ID', value: $locale.content.addTaxId.natid },
	                        'DL': { name: 'DRIVERS_LICENSE', value: $locale.content.addTaxId.dl },
	                        'PASSPORT': { name: 'PASSPORT_NUMBER', value: $locale.content.addTaxId.passport }
	                    };
	                }
	
	                if ($locale.country === 'BR') {
	                    $scope.nationalIdModel.nationalId.type = 'TAX_ID';
	                    $scope.nationalIdModel.nationalId.subType = 'CPF';
	
	                    $scope.cpfMasking($scope.nationalIdModel.nationalId.value);
	                } else if ($scope.country === 'RU') {
	                    $scope.nationalIdModel.nationalId.type = 'PASSPORT';
	                    $scope.nationalIdModel.nationalId.subType = '';
	                    $scope.user.nativeName = $scope.user.nativeName || {};
	                    $scope.secondaryIds = {
	                        'INN': { name: 'INN', value: $locale.content.addTaxId.INN, length: 12 },
	                        'SNILS': { name: 'SNILS', value: $locale.content.addTaxId.SNILS, length: 14, maskCharLength: 3 },
	                        'OMS': { name: 'OMS', value: $locale.content.addTaxId.OMS, length: 16, minlength: 11 }
	                    };
	
	                    if (!$scope.nationalIdModel.secondaryIdType) {
	                        $scope.nationalIdModel.secondaryIdType = $scope.secondaryIds.INN.name;
	                    }
	
	                    $scope.secondaryIdChange();
	
	                    $scope.countryChanged();
	                } else if ($scope.country === 'KR') {
	                    $scope.nationalIds = {
	                        'PASSPORT': { name: 'PASSPORT_NUMBER', value: $locale.content.addTaxId.passport },
	                        'DL': { name: 'DRIVERS_LICENSE', value: $locale.content.addTaxId.dl }
	
	                    };
	                    $scope.nationalIdModel.nationalId.type = 'PASSPORT_NUMBER';
	                    $scope.nationalIdModel.nationalId.subType = '';
	                } else {
	                    // Default behaviour - set to 3pl countries
	                    setLocalizedNatIDLabels();
	                    $scope.nationalIdModel.nationalId.type = 'NATIONAL_ID';
	                    $scope.nationalIdModel.nationalId.subType = '';
	                }
	
	                $scope.$on('contentChange', function () {
	                    setLocalizedNatIDLabels();
	                });
	            }
	        };
	    }).factory('$NationalIdModel', function ($Model) {
	
	        return $Model.extend('NationalIdModel', {
	
	            init: function init() {
	                this._super.init.apply(this);
	                this.nationalId = this.nationalId || {};
	            },
	
	            serialize: function serialize() {
	                return this.nationalId;
	            }
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-form-components/src/national-id-input", "components/xo-form-components/src/national-id-input/directive.js"))

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/national-id-input/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"nationalIdFields\" class=\"clearfix\" content>\n    <div class=\"bankField restricted\">\n        <div ng-switch=\"country\">\n            <div ng-switch-when=\"SG\">\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            ng-change=\"sgIdChange()\"\n                            aria-required=\"true\">\n                        <option ng-repeat=\"items in nationalIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type==='{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           valid-letters=\"data.validLetters\"\n                           sg-id-validations\n                           required/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n            </div>\n\n            <div ng-switch-when=\"BR\">\n\n                <div class=\"inputField confidential nationalId\" floating-label directionality>\n                    <input ng-model=\"formattedValues.nationalId\"\n                           name=\"nationalId\"\n                           id=\"nationalId\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           xo-error-tooltip\n                           br-id-validations\n                           maxlength=\"14\"\n                           ng-change=\"cpfMasking(formattedValues.nationalId)\"\n                           required/>\n                    <label for=\"nationalId\">{{content('addTaxId.cpf')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"KR\">\n\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            aria-required=\"false\">\n                        <option ng-repeat=\"items in nationalIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type==='{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"false\"\n                           autocomplete=\"off\"/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"RU\">\n\n                <div class=\"nationalId\">\n                    <div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"country\" ng-model=\"user.countryOfResidence\" id=\"country\"\n                                        aria-labelledby=\"countryLabel\" ng-change=\"countryChanged()\" xo-error-tooltip required>\n                            <option ng-repeat=\"country in countries\" value=\"{{country.code}}\" ng-selected=\"user.countryOfResidence === country.code\">{{country.name}}</option>\n                        </select>\n                        <label for=\"country\" id=\"countryLabel\">{{content('common.country')}}</label>\n                    </div>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <xo-name-input user=\"user.nativeName\"></xo-name-input>\n\n                        <div class=\"inputField confidential full\" floating-label directionality>\n                            <input ng-model=\"user.nativeName.middle_name\"\n                                   name=\"middleName\"\n                                   id=\"middleName\"\n                                   value=\"\"\n                                   autocapitalize=\"off\"\n                                   aria-required=\"true\"\n                                   autocomplete=\"off\"\n                                   required />\n                            <label for=\"middleName\" id=\"middleNameLabel\">{{content('common.middleName')}}</label>\n                        </div>\n                    </div>\n\n                    <div class=\"fieldGroup\">\n                        <div class=\"inputField full\" floating-label directionality>\n                                <input ng-model=\"nationalIdModel.nationalId.value\"\n                                       name=\"nationalId\"\n                                       id=\"nationalId\"\n                                       value=\"\"\n                                       autocapitalize=\"off\"\n                                       aria-required=\"true\"\n                                       autocomplete=\"off\"\n                                       minlength=\"{{minLengthNatId}}\"\n                                       maxlength=\"{{maxLengthNatId}}\"\n                                       placeholder=\"{{user.countryOfResidence === 'RU' && content('addTaxId.passportRU') || content('addTaxId.passportEN')}}\"\n                                       xo-validation='{\"validator\": \"validRUPassport\"}'\n                                       xo-error-tooltip\n                                       required />\n\n                                <label for=\"nationalId\">{{content('addTaxId.passport')}}</label>\n                        </div>\n\n                        <div class=\"full last-child\">\n                            <xo-dob-input user=\"user\"></xo-dob-input>\n                        </div>\n                    </div>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <legend class=\"fieldLegend\" for=\"additionalId\">{{content('addTaxId.additionalInfo')}}\n                            <div class=\"additionalIdHelper\">\n                                <a href=\"#\" id=\"verifyHelpAdditionalId\" alt=\"Why do we need this\" class=\"verifyHelp\"></a>\n                            </div>\n                            <div class=\"lineSpacing\">\n                                <xo-tooltip trigger=\"#verifyHelpAdditionalId\">\n                                    <div class=\"tip tipDesc\">\n                                        {{content('addTaxId.additionalInfoNote')}}\n                                    </div>\n                                </xo-tooltip>\n                            </div>\n                        </legend>\n\n                        <div id=\"additionalId\">\n                            <div class=\"dropdown additionalID inputField\" floating-label-dropdown>\n                                <select xo-dropdown name=\"idType\"\n                                        ng-model=\"nationalIdModel.secondaryIdType\"\n                                        id=\"idType\"\n                                        aria-label=\"{{ content('signup.accountCreationGuest.dobDay') }}\"\n                                        ng-change=\"secondaryIdChange()\"\n                                        aria-required=\"true\">\n                                    <option ng-repeat=\"items in secondaryIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.secondaryIdType==='{{items.name}}'\">{{items.value}}</option>\n                                </select>\n                                <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                            </div>\n\n                            <div class=\"inputField additionalIDValue\" floating-label directionality>\n                                <input ng-model=\"nationalIdModel.secondaryIdValue\"\n                                       name=\"idValue\"\n                                       id=\"idValue\"\n                                       class=\"additionalIDBox\"\n                                       value=\"\"\n                                       maxlength=\"{{maxLength}}\"\n                                       minlength=\"{{minLength}}\"\n                                       autocapitalize=\"off\"\n                                       aria-required=\"true\"\n                                       autocomplete=\"off\"\n                                       placeholder=\"{{(maxLength - maskCharLength)}} {{content('addTaxId.digits')}}\"\n                                       required\n                                       ru-id-validations\n                                       ng-change=\"secondaryIdFormatting()\"/>\n                                <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-switch-default>\n              <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                  <select xo-dropdown name=\"idType\"\n                          ng-model=\"nationalIdModel.nationalId.type\"\n                          id=\"idType\"\n                          aria-required=\"true\">\n                      <option ng-repeat=\"items in nationalIds\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type==='{{items.name}}'\">{{items.value}}</option>\n                  </select>\n                  <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n              </div>\n\n              <div class=\"inputField nationalIDValue\" floating-label directionality>\n                  <input ng-model=\"nationalIdModel.nationalId.value\"\n                         name=\"idValue\"\n                         id=\"idValue\"\n                         class=\"additionalIDBox\"\n                         value=\"\"\n                         autocapitalize=\"off\"\n                         aria-required=\"true\"\n                         autocomplete=\"off\"\n                         required/>\n                  <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n              </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-form-components/src/dob-input/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/dob-input/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-dob-input.directive', ['squid']).directive('dobValidation', function () {
	
	        return {
	            require: 'ngModel',
	            link: function link(scope, element, attr, ctrl) {
	
	                // init scope vars
	                // age - above 18 yrs
	                // validDate - months <= 12 and day <= 31 or based on month
	                scope.isValidDate = true;
	                scope.isValidAge = true;
	                scope.isValid = false;
	                scope.dobToolTip = 'hide';
	
	                function isValidDate(year, month, day) {
	                    // dates like 02/31 33/33 should return false
	                    var date = new Date(year, month, day);
	
	                    var fullYear = date.getFullYear();
	                    var dateMonth = date.getMonth();
	                    var dateDay = date.getDate();
	
	                    // If birth year is in the future or before 1900, dob is invalid
	                    var now = new Date();
	                    if (fullYear > now.getFullYear() || fullYear < 1900) {
	                        return false;
	                    }
	
	                    if (fullYear === parseInt(year, 10) && dateMonth === parseInt(month, 10) && dateDay === parseInt(day, 10)) {
	                        return true;
	                    }
	                    return false;
	                }
	
	                function isOfLegalAge(birthDate) {
	                    // user should be of exact 18 years of age or older
	                    var tempDate = new Date(birthDate.getFullYear() + 18, birthDate.getMonth(), birthDate.getDate());
	                    return tempDate <= new Date().setHours(0, 0, 0, 0);
	                }
	
	                /**
	                 * Parses input value to set corresponding day, month, year values for scope
	                 * @param {String} inputVal - the value to be parsed
	                 */
	                function parseDob(inputVal) {
	                    var day;
	                    var month;
	                    var year;
	
	                    var sep = scope.dateSeparator();
	                    var partsArr = inputVal.split(sep);
	                    var first = partsArr[0];
	                    var sec = partsArr[1];
	                    var third = partsArr[2];
	
	                    if (scope.dateFormat() === 'DMY') {
	                        day = first;
	                        month = sec;
	                        year = third;
	                    } else if (scope.dateFormat() === 'YMD') {
	                        year = first;
	                        month = sec;
	                        day = third;
	                    } else {
	                        month = first;
	                        day = sec;
	                        year = third;
	                    }
	
	                    // Validate only on entering the last digit of the dob
	                    var dayLen = ('' + day).length;
	                    var monLen = ('' + month).length;
	                    var yrLen = ('' + year).length;
	                    var validDay = dayLen === 1 || dayLen === 2;
	                    var validMon = monLen === 1 || monLen === 2;
	                    var validYr = yrLen === 4;
	                    var requirement = validDay && validMon && validYr;
	
	                    if (requirement) {
	                        scope.isValidDate = isValidDate(year, month - 1, day);
	
	                        scope.isValidAge = isOfLegalAge(new Date(year, month - 1, day));
	                        scope.isValid = scope.isValidDate && scope.isValidAge;
	                        scope.dobToolTip = scope.isValid ? 'hide' : 'show';
	
	                        scope.user.dob_day = day;
	                        scope.user.dob_month = month;
	                        scope.user.dob_year = year;
	                    } else {
	                        scope.isValid = false;
	                    }
	
	                    ctrl.$setValidity('dobText', scope.isValid);
	
	                    return inputVal;
	                }
	
	                /**
	                 * Validates the inputted DOB value
	                 * @param {string} ngModelValue - the to-be mutated input value
	                 * onComplete for mask listener - called when user copy/pastes DOB into the field
	                 */
	                scope.dobValidator = function dobValidator(ngModelValue) {
	                    var input = $('#dobText');
	                    var dateMask = scope.dateMask();
	                    input.mask(dateMask, {
	                        translation: {
	                            'Z': {
	                                pattern: /[0-9]/, optional: true
	                            },
	                            '0': {
	                                pattern: /[0-9]/, optional: false
	                            }
	                        },
	                        onComplete: function onComplete(val) {
	                            ngModelValue = val;
	                            return parseDob(ngModelValue);
	                        }
	                    });
	
	                    ngModelValue = input.val();
	                    return parseDob(ngModelValue);
	                };
	
	                scope.dobTester = function dobTester(val) {
	                    return parseDob(val);
	                };
	
	                ctrl.$parsers.push(scope.dobValidator);
	            }
	        };
	    }).directive('xoDobInput', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                user: '='
	            },
	            controller: function controller($scope, $locale) {
	
	                // To support additional date separators, simply add separator to getDateSeparators function
	                var DateManager = {
	                    dateSeparator: undefined,
	                    dateFormat: undefined,
	                    griffinDateEntry: undefined,
	
	                    _init_: function _init_() {
	                        this.griffinDateEntry = $locale.metadata.dateEntry;
	                        this.dateSeparator = this.getDateSeparator(this.griffinDateEntry);
	                        this.dateFormat = undefined;
	                        this.dateFormat = this.getDateFormat();
	                        this.dateRegex = this.getDateRegex();
	                        // dob validator depends on dateFormat function in $scope, so context is bound.
	                        $scope.dateFormat = this.getDateFormat.bind(this);
	                        $scope.dateSeparator = this.getDateSeparator.bind(this, this.griffinDateEntry);
	                        $scope.dateMask = this.getDateMask.bind(this, this.dateSeparator);
	                    },
	                    getDateFormat: function getDateFormat() {
	                        // cache date format value, must be unset on init
	                        if (this.dateFormat) {
	                            return this.dateFormat;
	                        }
	
	                        var griffinDateFormat = $locale.metadata.dateFormat.toUpperCase();
	                        var dateFormatComponents = griffinDateFormat.split(this.dateSeparator);
	
	                        var dIdx = dateFormatComponents.indexOf('DD'),
	                            mIdx = dateFormatComponents.indexOf('MM');
	
	                        var formatComponentMap = this.getFormatComponentIdxMappings();
	                        if (formatComponentMap['DMY'].day === dIdx && formatComponentMap['DMY'].month === mIdx) {
	                            return 'DMY';
	                        } else if (formatComponentMap['MDY'].day === dIdx && formatComponentMap['MDY'].month === mIdx) {
	                            return 'MDY';
	                        }
	                        return 'YMD';
	                    },
	                    setDobTextPlaceHolder: function setDobTextPlaceHolder() {
	                        $scope.dobTextPlaceholder = this.griffinDateEntry.toUpperCase();
	                    },
	                    dobTextKeyupHandler: function dobTextKeyupHandler(event) {
	                        this.updateDobBindings(true);
	                    },
	                    /**
	                     * Absolutely makes sure that dob input doesn't contain bad characters.
	                     * Called on any chatacter input AND on locale change.
	                     */
	                    updateDobBindings: function updateDobBindings(change) {
	                        var cleanedDob = ($scope.dob.value || '').replace(this.dateRegex, '');
	                        $scope.dob.value = cleanedDob;
	
	                        // This way, our dob value is always formatted correctly.
	                        if (change) {
	                            $scope.dob.value = $('#dobText').val();
	                        }
	                    },
	                    // Dynamically construct regex to only include date separator supported by country and nondigits
	                    getDateRegex: function getDateRegex() {
	                        var escapedRegexChars = ['.', '$', '^', '{', '[', '(', '|', ')', '*', '+', '?', '\\'];
	                        var sep = this.dateSeparator;
	                        var assembledRegex = '[^0-9' + (escapedRegexChars.indexOf(sep) !== -1 ? '\\' + sep : sep) + ']';
	                        return new RegExp(assembledRegex, 'gi');
	                    },
	                    getDateMask: function getDateMask(dateSeparator) {
	                        var dateFormat = this.dateFormat;
	                        if (dateFormat === 'DMY' || dateFormat === 'MDY') {
	                            return '0Z' + dateSeparator + '0Z' + dateSeparator + '0000';
	                        }
	
	                        return '0000' + dateSeparator + '0Z' + dateSeparator + '0Z';
	                    },
	                    getDateSeparator: function getDateSeparator(dateEntry) {
	                        var ret = '';
	                        this.getDateSeparators().forEach(function (ele, iter) {
	                            // eslint-disable-line
	                            if (dateEntry.indexOf(ele) !== -1) {
	                                ret = ele;
	                            }
	                        });
	                        return ret;
	                    },
	                    // To add any additional date separators, simply add them to the returned array.
	                    getDateSeparators: function getDateSeparators() {
	                        return ['-', '.', '/'];
	                    },
	                    // Handles changes in date component order or date separator change.
	                    updateDateInputForFormat: function updateDateInputForFormat(oldFormat, newFormat, oldSeparator) {
	                        var curDateVal = $scope.dob.value || '';
	
	                        // Clear dob input if date is incomplete so user can see updated placeholder
	                        if (curDateVal.length < 8) {
	                            $scope.dob.value = '';
	                            return;
	                        }
	
	                        var formatComponentIdxMappings = this.getFormatComponentIdxMappings(),
	                            oldFormatIdxMapping = formatComponentIdxMappings[oldFormat],
	                            newFormatIdxMapping = formatComponentIdxMappings[newFormat];
	                        var oldDateComponents = curDateVal.split(oldSeparator),
	                            newDateComponents = ['', '', ''];
	
	                        newDateComponents[newFormatIdxMapping.day] = oldDateComponents[oldFormatIdxMapping.day];
	                        newDateComponents[newFormatIdxMapping.month] = oldDateComponents[oldFormatIdxMapping.month];
	                        newDateComponents[newFormatIdxMapping.year] = oldDateComponents[oldFormatIdxMapping.year];
	                        $scope.dob.value = newDateComponents.join(this.dateSeparator);
	                    },
	                    getFormatComponentIdxMappings: function getFormatComponentIdxMappings() {
	                        return {
	                            'DMY': {
	                                'day': 0,
	                                'month': 1,
	                                'year': 2
	                            },
	                            'MDY': {
	                                'day': 1,
	                                'month': 0,
	                                'year': 2
	                            },
	                            'YMD': {
	                                'day': 2,
	                                'month': 1,
	                                'year': 0
	                            }
	                        };
	                    },
	                    prefillFetchedDob: function prefillFetchedDob() {
	                        if ($scope.user && $scope.user.dob_day && $scope.user.dob_month && $scope.user.dob_year) {
	                            if (!$scope.dob) {
	                                $scope.dob = {};
	                            }
	
	                            if (this.dateFormat === 'DMY') {
	                                $scope.dob.value = $scope.user.dob_day + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_year;
	                            } else if (this.dateFormat === 'YMD') {
	                                $scope.dob.value = $scope.user.dob_year + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day;
	                            } else {
	                                $scope.dob.value = $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day + this.dateSeparator + $scope.user.dob_year;
	                            }
	                        } else {
	                            $scope.dob = {
	                                value: ''
	                            };
	                        }
	                    }
	                };
	
	                DateManager._init_();
	                DateManager.setDobTextPlaceHolder();
	                DateManager.prefillFetchedDob();
	
	                $scope.onDobTextKeyup = function (event) {
	                    DateManager.dobTextKeyupHandler(event);
	                };
	
	                $scope.$on('localeChange', function () {
	                    var oldDateFormat = DateManager.dateFormat;
	                    var oldSeparator = DateManager.dateSeparator;
	                    DateManager._init_();
	                    DateManager.updateDateInputForFormat(oldDateFormat, DateManager.dateFormat, oldSeparator);
	                    DateManager.updateDobBindings(false);
	                    DateManager.setDobTextPlaceHolder();
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/dob-input/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"dobComp\" class=\"dobbank\" ng-class=\"{dobTXT: dobInputType()==='TXT'}\" content>\n    <div class=\"dobField full inputField last-child\" floating-label directionality>\n        <input ng-model=\"dob.value\"\n               name=\"dobText\"\n               id=\"dobText\"\n               value=\"\"\n               maxlength=\"10\"\n               autocapitalize=\"off\"\n               aria-required=\"true\"\n               autocomplete=\"off\"\n               placeholder=\"{{ dobTextPlaceholder }}\"\n               xo-error-tooltip\n               dob-validation\n               ng-keyup=\"onDobTextKeyup($event)\"\n               required />\n        <div ng-class=\"dobToolTip\">\n            <xo-tooltip trigger=\"#dobText\" show-event=\"keyup\" ng-class=\"dobToolTip\" id=\"dobToolTip\">\n                <div class=\"tip tipDesc dobToolTip\">\n                  <p class=\"tipInfoText restriction active\" ng-if=\"!isValidDate\">{{ content('scripts.validDate') }}</p>\n                  <p class=\"tipInfoText restriction active\" ng-if=\"isValidDate && !isValidAge\">{{ content('scripts.legalAge') }}</p>\n                </div>\n            </xo-tooltip>\n        </div>\n        <label id=\"dobLabel\" for=\"dob\">{{ content('signup.accountCreationGuest.dobLabel') }}</label>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-update-card/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$UpdateCardPageRoute = undefined;
	
	__webpack_require__("./pages/xo-update-card/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $UpdateCardPageRoute = exports.$UpdateCardPageRoute = _squid.$ComponentRoute.extend('$UpdateCardPageRoute', {
	
	    path: 'updateCard',
	    directive: 'xo-update-card-page',
	    titleContent: 'asideHeader.update',
	    query: ['message'],
	    trackingData: {
	        templateName: 'tray/editCard.dust',
	        pageGoal: 'Update Card',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-edit-cc',
	                'pagename2': '%::fullpage-edit-cc:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    children: [{
	        name: '$AddCardFlowRoute',
	        attributes: {
	            token: 'token',
	            message: 'message',
	            pagetitle: 'pagetitle',
	            isUpdateFlow: 'isUpdateFlow',
	            cardmodel: 'cardmodel',
	            'parent-callbacks': 'callbacks'
	
	        }
	    }]
	});
	
	angular.value("$UpdateCardPageRoute", $UpdateCardPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-update-card/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoUpdateCardPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	__webpack_require__("./components/xo-wallet-components/src/add-card/directive.js");
	
	__webpack_require__("./components/xo-models/src/fi/index.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	var _template = __webpack_require__("./pages/xo-update-card/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoUpdateCardPageComponent = exports.$xoUpdateCardPageComponent = _squid.$Component.extend('$xoUpdateCardPageComponent', {
	
	    tag: 'xo-update-card-page',
	    template: _template2['default'],
	
	    controller: function controller($scope, $rootScope, $populate, $state, $renderContent, $locale, $CheckoutSessionModel, $stateParams) {
	        // eslint-disable-line no-shadow
	
	        $scope.callbacks = {
	            finish: function finish() {
	                $state.go('checkout.review');
	            }
	        };
	        $scope.token = $rootScope.token;
	        $scope.locale = $locale;
	
	        var models = {};
	
	        function setErrorMessage(contentKey, msgType) {
	            $scope.message = {
	                msgs: [$renderContent(contentKey)],
	                type: msgType
	            };
	        }
	
	        $populate(models, {
	            checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
	                contingencies: {
	                    NEED_CREDIT_CARD: angular.noop,
	                    EXPIRED_CREDIT_CARD: angular.noop,
	                    NEED_DEBIT_CARD: angular.noop,
	                    EXPIRED_DEBIT_CARD: angular.noop
	                }
	            })
	        }).then(function () {
	
	            if (models.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD') {
	                setErrorMessage('creditcard.errorUnconfirmedCard');
	            } else {
	                setErrorMessage('creditcard.errorExpiredCard', $stateParams.message === 'EXPIRED_DEBIT_CARD' ? 'error' : 'info');
	            }
	        });
	    }
	});
	
	angular.value("$xoUpdateCardPageComponent", $xoUpdateCardPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-update-card/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addCard updateCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addCard\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-eConsent/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-eConsent/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoEConsentPageRoute', {
	
	    path: 'econsent',
	    directive: _directive2['default'],
	    titleContent: 'eConsent.title',
	
	    trackingData: {
	        fptiState: 'econsent',
	        templateName: 'eConsent.dust',
	        pageGoal: 'eConsent',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-econsent',
	                'pagename2': '%::fullpage-econsent:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-eConsent/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/app/index.js");
	
	var _index4 = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _util = __webpack_require__("./pages/xo-login/util.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _config = __webpack_require__("./components/squid/dist/core/config.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-title/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	var _template = __webpack_require__("./pages/xo-eConsent/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-eConsent/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Component.extend('$xoEConsentPageDirective', {
	
	    tag: 'xo-econsent-page',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        },
	
	        success: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    resolve: {
	        models: function models() {
	
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.props.token),
	                eConsent: _index4.$EConsentModel.instance(),
	                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve(),
	                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
	                tokenizedWalletEligibility: _index3.$TokenizedWalletEligibilityModel.instance(this.props.token),
	                tokenizedWalletPin: _index3.$TokenizedWalletPinModel.instance(this.props.token)
	            };
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _index.$locale;
	        }
	    },
	
	    actions: {
	        submit: function submit() {
	            var _this = this;
	
	            var self = this;
	
	            self.handleSymphonyContingency = function (name, err) {
	                // Check if negative case has been previously handled.
	                if (!self.dependencyEligibility) {
	                    return;
	                }
	
	                var fptiData = {
	                    from: 'CREATE_XO_SESSION',
	                    to: 'process_create_xo_session'
	                };
	
	                var hardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];
	
	                fptiData.int_error_code = err.cause;
	                fptiData.error_source = 'paymentapiplatformserv';
	                fptiData.error_type = hardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
	                _logger.$logger.info('checkout_fpti', fptiData);
	                throw err;
	            };
	
	            self.handleSymphonyNoValidTopupFiContingency = function (name, err) {
	                // Check if negative case has been previously handled.
	                if (!self.dependencyEligibility) {
	                    return;
	                }
	
	                if (self.models.checkoutCart.isWalletTokenization()) {
	                    self.models.checkoutSession.contingency = name;
	                    _logger.$logger.info('tokenized_wallet', {
	                        'from': 'PP_AndroidPay_Info',
	                        'to': 'prepare_PP_AndroidPay_Info',
	                        'context_id': self.props.token,
	                        'context_type': 'EC-Token',
	                        'billing_token': _config.$meta.baToken
	                    });
	                    $('#outerWrapper').addClass('tokenization');
	                    _uiRouter.$state.go('checkout.tokenizationInfo');
	                } else {
	                    self.handleSymphonyContingency(name, err);
	                }
	            };
	
	            // We use this flag to tell if negative case has been previously handled.
	            self.dependencyEligibility = true;
	
	            // We use this flag to decide if we should to review page.
	            // Set this to false if the next page is no review page.
	            self.proceedToReview = true;
	
	            var eConsentBatch = [this.models.eConsent.save({
	
	                batch: {
	                    name: 'econsent',
	                    id: 'accept'
	                }
	            }), this.models.checkoutSession.action('create', {
	
	                data: {
	                    baToken: this.models.checkoutCart.get('billing.ba_token'),
	                    preselected_fi_type: this.models.checkoutAppData.is_second_button_txn ? 'credit' : undefined
	                },
	
	                success: function success(result) {
	
	                    // Check if negative case has been previously handled.
	                    if (!self.dependencyEligibility) {
	                        return;
	                    }
	
	                    _logger.$logger.info('checkout_fpti', {
	                        from: 'CREATE_XO_SESSION',
	                        to: 'process_create_xo_session'
	                    });
	
	                    // consider negative balance first
	                    if (self.models.checkoutSession.negBals) {
	                        self.proceedToReview = false;
	                        return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
	                    }
	
	                    // Handle routing to cape for second button
	                    if (self.models.checkoutAppData.is_second_button_txn) {
	                        self.proceedToReview = false;
	                        return _util.$capeRedirectUtil.handleCapeRouting(result, self.models.checkoutCart, self.props.token);
	                    }
	
	                    // Check for tokenized wallet
	                    if (self.models.checkoutCart.isWalletTokenization()) {
	                        _logger.$logger.info('tokenized_wallet', {
	                            'from': 'PP_AndroidPay_Info',
	                            'to': 'prepare_PP_AndroidPay_Info',
	                            'context_id': self.props.token,
	                            'context_type': 'EC-Token',
	                            'billing_token': _config.$meta.baToken
	                        });
	                        $('#outerWrapper').addClass('tokenization');
	                        return _uiRouter.$state.go('checkout.tokenizationInfo');
	                    }
	                },
	
	
	                contingencies: {
	                    NEED_DEBIT_CARD: self.handleSymphonyNoValidTopupFiContingency,
	                    EXPIRED_DEBIT_CARD: self.handleSymphonyNoValidTopupFiContingency,
	                    DEFAULT: self.handleSymphonyContingency
	                },
	
	                batch: {
	                    name: 'econsent',
	                    id: 'createCheckout',
	                    dependencies: self.models.checkoutCart.isWalletTokenization() ? ['accept', 'tokenizedWalletLightEligibility', 'tokenizedWalletPin'] : ['accept']
	                }
	            })];
	
	            if (self.models.checkoutCart.isWalletTokenization()) {
	                // Wallet tokenization always goes tokenization info page unless there is an error
	                // which is tracked by a separate flag.
	                self.proceedToReview = false;
	
	                var params = {
	                    wallet_brand: 'APAY',
	                    tenant_id: 'Hermes'
	                };
	                if (_config.$meta.query && _config.$meta.query.wallet_id) {
	                    params.wallet_id = _config.$meta.query.wallet_id;
	                }
	                if (_config.$meta.query && _config.$meta.query.jwt) {
	                    params.jwt = _config.$meta.query.jwt;
	                }
	
	                eConsentBatch.push(this.models.tokenizedWalletEligibility.retrieve({
	                    params: params,
	
	                    success: function success(result) {
	                        if (!result.eligible) {
	                            var msg = 'tokenized_wallet_ineligible_for_provisioning';
	                            _logger.$logger.info(msg);
	
	                            self.dependencyEligibility = false;
	                            var code = result.reason === 'WALLET_ID_ALREADY_PROVISIONED' ? 'ANDROID_PAY_ALREADY_PROVISIONED' : 'ANDROID_PAY_ELIGIBILITY_ERROR';
	                            code = window.btoa(code);
	                            return _uiRouter.$state.go('checkout.genericError', {
	                                code: code
	                            });
	                        }
	                    },
	
	
	                    batch: {
	                        name: 'econsent',
	                        id: 'tokenizedWalletLightEligibility',
	                        dependencies: ['accept']
	                    }
	                }));
	
	                eConsentBatch.push(this.models.tokenizedWalletPin.retrieve({
	                    success: function success(result) {
	                        if (result.pinId) {
	                            _logger.$logger.info('tokenized_wallet_get_pin_set', { pinOrigin: result.pinOrigin, pinId: result.pinId });
	                        } else {
	                            _logger.$logger.info('tokenized_wallet_get_pin_not_set');
	                        }
	                    },
	
	
	                    contingencies: {
	                        DEFAULT: function DEFAULT(name, err) {
	                            _logger.$logger.info('tokenized_wallet_get_pin_error');
	                        }
	                    },
	
	                    batch: {
	                        name: 'econsent',
	                        id: 'tokenizedWalletPin',
	                        dependencies: ['accept']
	                    }
	                }));
	            }
	
	            return _angular.$q.all(eConsentBatch).then(function () {
	                if (self.proceedToReview) {
	                    return _this.props.success();
	                }
	            });
	        }
	    }
	});
	
	
	_angular.$q;
	
	_logger.$logger;
	
	_index.$Component;
	
	_index.$locale;
	
	_index2.$CheckoutSessionModel;
	
	_index2.$CheckoutCartModel;
	
	_index2.$CheckoutAppDataModel;
	
	_index3.$TokenizedWalletEligibilityModel;
	
	_index3.$TokenizedWalletPinModel;
	
	_index4.$EConsentModel;
	
	_util.$capeRedirectUtil;
	
	_uiRouter.$state;
	
	_config.$meta;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./pages/xo-eConsent/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"eConsent\" id=\"eConsent\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <xo-title title-txt=\"{{content('eConsent.title')}}\"></xo-title>\n            <form name=\"eConsentForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\">\n                <p class=\"content\">{{content('eConsent.consent')}}</p>\n\n                <div class=\"agree checkbox legal\">\n                    <input ng-model=\"fields.agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" data-error-text=\"{{content('eConsent.eConsentError')}}\" xo-error-tooltip required />\n                    <label class=\"noBottom\" for=\"agree\" ng-bind-html=\"content('eConsent.agreement')\"></label>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit type=\"submit\" id=\"submitEConsent\" value=\"{{content('common.agreeAndContinue')}}\" class=\"btn full\" validate-submit=\"actions.submit()\" />\n                </div>\n            </form>\n        </div>\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"review\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-eConsent/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-eConsent/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-eConsent/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#eConsent .content{line-height:1.35em}#eConsent .agree{position:relative}#eConsent label{line-height:1.2em}#eConsent .validated input[type=checkbox].ng-invalid+.errorTooltipRuleSpecific{width:300px;font-size:12px;top:30px;left:0;line-height:1.2em;width:275px}#eConsent .buttons{margin-top:20px}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-travel-rule/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$TravelRuleRoute = undefined;
	
	__webpack_require__("./pages/xo-travel-rule/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $TravelRuleRoute = exports.$TravelRuleRoute = _squid.$ComponentRoute.extend('$TravelRuleRoute', {
	
	    path: 'travelRule',
	    directive: 'xo-travel-rule-page',
	    titleContent: 'travelRule.travelRule',
	    trackingData: {
	        templateName: 'travelRule.dust',
	        pageGoal: 'collect payer ssn and/or taxId',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-travel-rule',
	                'pagename2': '%::fullpage-travel-rule:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	    loginRequired: true,
	    children: []
	});
	
	angular.value("$TravelRuleRoute", $TravelRuleRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-travel-rule/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _template = __webpack_require__("./pages/xo-travel-rule/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-form-components/src/travel-rule/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/tooltip/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoTravelRulePageComponent', {
	
	    tag: 'xo-travel-rule-page',
	
	    template: _template2['default'],
	
	    lifecycle: {
	        enter: function enter() {
	            this.token = _angular.$rootScope.token;
	            this.locale = _squid.$locale;
	
	            this.finish = function () {
	                _uiRouter.$state.go('checkout.review');
	            };
	        }
	    }
	
	});
	
	
	_angular.$rootScope;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_uiRouter.$state;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-travel-rule/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"travelRule\" id=\"travelRule\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-travel-rule token=\"token\" finish=\"finish\"></xo-travel-rule>\n        </div>\n\n        <div class=\"span10\" feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" unless-feature=\"propValue\">\n            <xo-value-props type=\"addTaxId\" title=\"{{content('login.propHeadAlt')}}\" text-content=\"login.propValAlt\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-form-components/src/travel-rule/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/user/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/dropdown/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-address-components/src/add-address/directive.js");
	
	var _template = __webpack_require__("./components/xo-form-components/src/travel-rule/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-form-components/src/travel-rule/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Component.extend('xoTravelRule', {
	    tag: 'xo-travel-rule',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            optional: false
	        },
	        finish: {
	            type: 'var',
	            optional: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index2.$CheckoutSessionModel.instance(this.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        submit: function submit() {
	            var _this = this;
	
	            var data = {};
	
	            if (this.needPayerGovtId) {
	                var findChoosenId = function findChoosenId(compareId) {
	                    return function (obj) {
	                        return obj.name === compareId;
	                    };
	                };
	                var chosenIdDetails = this.idTypes.filter(findChoosenId(this.idData.type))[0];
	
	                // Scrub the formatting when invoking the backend services.
	                var unformatted = (this.idData.value || '').replace(/[^0-9a-zA-Z]+/g, '');
	
	                data.newDocId = {
	                    type: chosenIdDetails.idType,
	                    subType: chosenIdDetails.idSubtype,
	                    issuerCountry: this.idData.country,
	                    issuer: chosenIdDetails.idIssuer,
	                    value: unformatted,
	                    collectionPoint: 'UNKNOWN',
	                    placeOfIssue: this.idData.country
	                };
	            }
	
	            if (this.needPayerAddress) {
	                var address = this.address;
	                data.newAddress = {
	                    address1: address.line1,
	                    address2: address.line2,
	                    city: address.city,
	                    state: address.state,
	                    zip: address.postal_code,
	                    iso_country: 'US'
	                };
	            }
	            this.userInfo.action('governmentId-address', {
	                data: data,
	
	                success: function success() {
	                    var checkoutCart = _index2.$CheckoutCartModel.instance(_this.token);
	                    return _this.models.checkoutSession.action('create', {
	                        data: {
	                            baToken: checkoutCart.billing && checkoutCart.billing.ba_token
	                        },
	                        success: function success() {
	                            // Clear the errors if create checkout session was successful
	                            _this.models.checkoutSession.errorData = undefined;
	                            _this.finish();
	                        }
	                    });
	                },
	                validation: function validation(validationData) {
	                    var $el = $(this.$element);
	                    var $field = $($el.find('[name="' + validationData.field + '"]'));
	                    $field.addClass('backendError');
	                    $field.attr('aria-invalid', true);
	                    $field.focus();
	                }
	            });
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            var country = _index.$locale.getCountryCodeISO(),
	                countries = _index.$locale.content.get('countryList', {}),
	                countryList = [];
	            this.country = country;
	            this.address = { country: country };
	            this.locale = _index.$locale;
	            this.metadata = _index.$locale.metadata;
	            Object.keys(countries).forEach(function (countryCode) {
	                countryList.push({
	                    key: countryCode,
	                    value: countries[countryCode]
	                });
	            });
	            countryList.sort(function (a, b) {
	                return a.value.localeCompare(b.value);
	            });
	            this.countryList = countryList;
	
	            this.idTypes = [{ name: 'SSN', value: _index.$locale.content.travelRule.ssnDropdownLabel, idType: 'TAX_ID', idSubtype: 'SSN', idIssuer: 'US_SSN' }, { name: 'TaxID', value: _index.$locale.content.travelRule.taxIdDropdownLabel, idType: 'TAX_ID', idSubtype: 'ITIN', idIssuer: 'US_ITIN' }, { name: 'EmployerID', value: _index.$locale.content.travelRule.employerIdDropdownLabel, idType: 'TAX_ID', idSubtype: 'TIN', idIssuer: 'US_TIN' }, { name: 'Passport', value: _index.$locale.content.travelRule.passportDropdownLabel, idType: 'PASSPORT', idIssuer: 'PASSPORT' }, { name: 'AlienNumber', value: _index.$locale.content.travelRule.aNumberDropdownLabel, idType: 'IMMGT_ID', idIssuer: 'IMMIGRATION' }];
	            this.idData = {
	                'type': 'SSN',
	                'value': '',
	                'country': 'US'
	            };
	            this.idTypeChanged = function () {
	                this.idData.country = 'US';
	            };
	
	            var checkoutSession = _index2.$CheckoutSessionModel.instance(this.token);
	            var payerDetailsTypes = checkoutSession.get('errorData.resolution.data', []);
	            if (payerDetailsTypes.indexOf('GOVERNMENT_ID') > -1) {
	                this.needPayerGovtId = true;
	            }
	            if (payerDetailsTypes.indexOf('STREET_ADDRESS') > -1) {
	                this.needPayerAddress = true;
	            }
	
	            this.userInfo = _index3.$UserInfoModel.instance(this.token);
	        }
	    }
	});
	
	
	_index.$Component;
	
	_index.$locale;
	
	_index2.$CheckoutSessionModel;
	
	_index2.$CheckoutCartModel;
	
	_index3.$UserInfoModel;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-form-components/src/travel-rule/template.html":
/***/ function(module, exports) {

	module.exports = "<form id=\"travelRuleForm\" name=\"travelRuleForm\" class=\"travelRuleForm\" content novalidate>\n    <div class=\"trayInner trayInnerDefault\">\n        <h3 class=\"gamma noHead\">{{ content('travelRule.travelRule') }}</h3>\n        <p>{{ content('travelRule.note') }}</p>\n        \n        <div ng-if=\"needPayerGovtId\" class=\"govtId\">\n            <div class=\"dropdown idType inputField\" floating-label-dropdown>\n                <select xo-dropdown \n                        name=\"idType\"\n                        ng-model=\"idData.type\"\n                        id=\"idType\"\n                        ng-change=\"idTypeChanged()\"\n                        aria-required=\"true\">\n                    <option ng-repeat=\"item in idTypes\" value=\"{{item.name}}\" ng-selected=\"idData.type==='{{item.name}}'\">{{item.value}}</option>\n                </select>\n                <label for=\"idType\">{{content('travelRule.idType')}}</label>\n            </div>\n            <div></div>\n            <div class=\"inputField confidential\" \n                ng-switch on=\"idData.type\">\n                <div class=\"animate-switch\" ng-switch-when=\"SSN\">\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.ssnPlaceholder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"TaxID\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.taxIdDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.taxIdPlaceholder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"EmployerID\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.employerIdDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.employerIdPlaceHolder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"Passport\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.passportDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.passportPlaceholder') }}\"/>\n                    <div class=\"dropdown confidential country clearfix inputField\" content floating-label-dropdown>\n                        <select xo-dropdown name=\"passportCountry\" ng-model=\"idData.country\" ng-options=\"country.key as country.value for country in countryList\" id=\"passportCountry\" aria-labelledby=\"countryLabel\" xo-error-tooltip required>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"AlienNumber\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.aNumberDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.aNumberPlaceholder') }}\"/>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"needPayerAddress\" class=\"address\">\n            <p>{{ content('travelRule.pleaseEnterStreetAddress') }}</p>\n            <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n        </div>\n    \n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{ content('travelRule.payButton') }}\" class=\"btn full btn-large\" validate-submit=\"actions.submit()\" />\n        </div>\n    </div>\n</form>"

/***/ },

/***/ "./components/xo-form-components/src/travel-rule/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/travel-rule/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/travel-rule/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#travelRuleForm .nolap{margin-top:15px;margin-bottom:20px}#travelRuleForm .address p{margin-top:21px;margin-bottom:21px}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-nbr/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-nbr/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoNbrDEPageRoute', {
	
	    path: 'negativeBalanceRecovery',
	    directive: _directive2['default'],
	    // titleContent: 'nbr.title',
	
	    // trackingData: {
	    //     fptiState: 'econsent',
	    //     templateName: 'eConsent.dust',
	    //     pageGoal: 'eConsent',
	    //     buzname: {
	    //         'fullpage': {
	    //             'pagename': '%::fullpage-econsent',
	    //             'pagename2': '%::fullpage-econsent:member:hermes:',
	    //             'version': 'member:%:'
	    //         }
	    //         // More page qualifiers come here...
	    //     }
	    // },
	
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-nbr/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _util = __webpack_require__("./pages/xo-login/util.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-title/dist/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	var _template = __webpack_require__("./pages/xo-nbr/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-nbr/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoNbrDEPageDirective', {
	
	    tag: 'xo-nbr-page',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: false
	        },
	        isUnbranded: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            var props = this.props;
	
	            if (props.token) {
	                return {
	                    checkoutSession: _index.$CheckoutSessionModel.instance(props.token).retrieve({
	                        contingencies: {
	                            NEGATIVE_BALANCE_RECOVERY: _angular2['default'].noop,
	                            EXPIRED_CREDIT_CARD: _angular2['default'].noop
	                        }
	                    }),
	                    checkoutAppData: _index.$CheckoutAppDataModel.instance(props.token).retrieve(),
	                    checkoutCart: _index.$CheckoutCartModel.instance(props.token).retrieve()
	                };
	            }
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var self = this,
	                configUrls = _squid.$config.urls;
	
	            (0, _jquery2['default'])('.paypalHeaderWrapper').hide();
	            (0, _jquery2['default'])('.footerWrapper').addClass('nbr');
	
	            // this is only used by DE
	            self.nbrUrl = configUrls.nbrUrl;
	
	            // only invoked via DE view
	            self.meft = function (evt) {
	                evt.preventDefault();
	                // forward to negative legacy balance collection flow
	                _squid.$util.redirect(configUrls.nbrUrl);
	            };
	
	            self.resume = function (evt) {
	                var models = self.models;
	
	                evt.preventDefault();
	
	                // throw original contingency
	                if (models.checkoutSession.origContName) {
	                    throw new _squid.$Contingency(models.checkoutSession.origContName);
	                }
	
	                // consider CAPE scenario first
	                if (models.checkoutAppData.is_second_button_txn) {
	                    _util.$capeRedirectUtil.handleCapeRouting(models.checkoutSession, models.checkoutCart, self.props.token);
	                } else {
	                    _uiRouter.$state.go('checkout.review');
	                }
	            };
	        },
	        exit: function exit() {
	            (0, _jquery2['default'])('.paypalHeaderWrapper').show();
	            (0, _jquery2['default'])('.footerWrapper').removeClass('nbr');
	        },
	        populate: function populate() {
	            var self = this,
	                checkoutSession = self.models.checkoutSession,
	                negBals = checkoutSession.negBals,
	                plan = checkoutSession.plan.sources && checkoutSession.plan.sources[0],
	                tokenHash = {
	                neg_bal: (0, _squid.formatCurrency)(negBals[0].amount, negBals[0].currency_code, false),
	                amt: plan && (0, _squid.formatCurrency)(plan.amount, plan.currency_code, false)
	            },
	                bodyContentKey = 'nbr.body',
	                preBankBtnKey = 'nbr.preBankBtn',
	                prePayBtnKey = 'nbr.prePayBtn';
	
	            if (negBals.length > 1) {
	                bodyContentKey += 'Plural';
	                preBankBtnKey += 'Plural';
	                tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
	            }
	
	            if (!plan) {
	                prePayBtnKey += 'NoAmt';
	            }
	
	            self.bodyContentKey = bodyContentKey;
	            self.tokenHash = tokenHash;
	            self.isDE = _squid.$locale.metadata.country === 'DE';
	            self.prePayBtnKey = prePayBtnKey;
	            self.preBankBtnKey = preBankBtnKey;
	        }
	    }
	});
	
	
	_squid.formatCurrency;
	
	_squid.$Component;
	
	_squid.$locale;
	
	_squid.$util;
	
	_squid.$config;
	
	_squid.$Contingency;
	
	_uiRouter.$state;
	
	_index.$CheckoutSessionModel;
	
	_index.$CheckoutAppDataModel;
	
	_index.$CheckoutCartModel;
	
	_util.$capeRedirectUtil;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-nbr/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"nbr\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n        <div class=\"title\">\n            {{ content('nbr.title') }}\n        </div>\n        <div class=\"message\" ng-bind-html=\"content(bodyContentKey, tokenHash)\"></div>\n        <div ng-if=\"isDE\" class=\"actions message\">\n            <p class=\"bold\" ng-bind-html=\"content(prePayBtnKey, tokenHash)\"></p>\n            <button ng-click=\"resume($event)\" class=\"btn full\">\n                {{ content('nbr.payBtn') }}\n            </button>\n            <p class=\"small\">\n                {{ content('nbr.postPayBtn') }}\n            </p>\n            <p class=\"bold\" ng-bind-html=\"content(preBankBtnKey, tokenHash)\"></p>\n            <a href=\"{{nbrUrl}}\" ng-click=\"meft($event)\" class=\"btn full btn-secondary\">\n                {{ content('nbr.bankBtn') }}\n            </a>\n            <p class=\"small\">\n                {{ content('nbr.postBankBtn') }}\n            </p>\n        </div>\n        <p class=\"btn-spaced\" ng-if=\"!isDE\">\n            <button ng-click=\"resume($event)\" class=\"btn full\">\n                {{ content('nbr.payBtn') }}\n            </button>\n        </p>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-nbr/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-nbr/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-nbr/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}@media (min-width:41.3125em){section#nbr .container{width:400px}.nbr.footerWrapper{float:none;width:99.4%;padding:0 3px}.nbr.footerWrapper .footerLinks{float:left;width:70%;text-align:left}}section#nbr{min-height:450px;display:table;margin:0 auto}section#nbr .container{position:relative;padding:0;display:table-cell;vertical-align:middle}section#nbr .title{font-size:1.5em;margin-bottom:15px;line-height:1.2}section#nbr .message{font-size:1em;margin-bottom:15px;color:#7b8388}section#nbr .message .actions{padidng-top:.5em}section#nbr .message .bold{font-weight:700}section#nbr .message .small{margin:1em 0 2em;font-size:.85em}section#nbr .btn-spaced{padding-top:1em}section#nbr .logo{width:112px;height:29px;margin:5px 0 20px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){section#nbr .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-framebust/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoFrameBustRoute = undefined;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-framebust/directive.js");
	
	var $xoFrameBustRoute = exports.$xoFrameBustRoute = _index.$Route.extend('$xoFrameBustRoute', {
	
	    path: 'framebust',
	    directive: _directive.$xoFrameBustPageDirective,
	
	    auth: false,
	
	    query: ['action', 'url'],
	
	    children: []
	});
	
	angular.value("$xoFrameBustRoute", $xoFrameBustRoute);
	_index.$Route;
	
	_directive.$xoFrameBustPageDirective;

/***/ },

/***/ "./pages/xo-framebust/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoFrameBustPageDirective = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _icFallback = __webpack_require__("./js/lib/icFallback.js");
	
	var _template = __webpack_require__("./pages/xo-framebust/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-framebust/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoFrameBustPageDirective = exports.$xoFrameBustPageDirective = _index.$Component.extend('$xoFrameBustPageDirective', {
	
	    tag: 'xo-framebust-page',
	    template: _template2['default'],
	
	    props: {},
	
	    resolve: {},
	
	    actions: {
	        submit: function submit() {
	
	            window.xchild.hide();
	
	            var url = decodeURIComponent(_uiRouter.$stateParams.url);
	
	            if (_uiRouter.$stateParams.action === 'open') {
	
	                var xprops = _extends({}, window.xprops);
	
	                xprops.url = url;
	
	                _logger.$logger.warn('framebust_click_to_hermes');
	
	                return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
	            }
	
	            if (_uiRouter.$stateParams.action === 'fallback') {
	
	                var _xprops = _extends({}, window.xprops);
	                _xprops.url = url;
	                _xprops.dimensions = {
	                    width: 970,
	                    height: 850
	                };
	
	                var component = window.ppxo.Checkout.init(_xprops);
	
	                _logger.$logger.warn('framebust_click_to_legacy');
	
	                component.renderTo(window.top, null, 'popup');
	
	                (0, _icFallback.$incontextFallback)(component.window, url);
	            }
	        }
	    }
	});
	
	angular.value("$xoFrameBustPageDirective", $xoFrameBustPageDirective);
	_logger.$logger;
	
	_uiRouter.$stateParams;
	
	_index.$Component;
	
	_icFallback.$incontextFallback;

/***/ },

/***/ "./pages/xo-framebust/template.html":
/***/ function(module, exports) {

	module.exports = "<form content novalidate=\"novalidate\" autocomplete=\"off\">\n    <input type=\"submit\" value=\"{{ content('login.loginBtn') }}\" class=\"btn full loginBtn frameBustBtn\" ng-click=\"actions.submit()\" />\n</form>\n\n\n"

/***/ },

/***/ "./pages/xo-framebust/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-framebust/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-framebust/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".frameBustBtn{margin:20px auto!important}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-sepa/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$SepaPageRoute = undefined;
	
	__webpack_require__("./pages/xo-sepa/directive.js");
	
	__webpack_require__("./components/xo-wallet-components/src/member-sepa/route.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $SepaPageRoute = exports.$SepaPageRoute = _squid.$ComponentRoute.extend('$SepaPageRoute', {
	
	    path: 'sepapage',
	    directive: 'xo-sepa-page',
	    titleContent: 'DEMemberGuest.sepaTitle',
	    query: ['message'],
	    trackingData: {
	        fptiState: 'membersepa',
	        templateName: 'membersepa.dust',
	        pageGoal: 'SEPA Review'
	    },
	    children: [{
	        name: '$MemberSepaRoute',
	        attributes: {
	            token: 'token',
	            'parent-callbacks': 'callbacks'
	        }
	    }]
	});
	
	angular.value("$SepaPageRoute", $SepaPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-sepa/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSepaPageComponent = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _template = __webpack_require__("./pages/xo-sepa/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSepaPageComponent = exports.$xoSepaPageComponent = _squid.$Component.extend('$xoSepaPageComponent', {
	    tag: 'xo-sepa-page',
	    template: _template2['default'],
	
	    scope: {
	        token: '='
	    },
	
	    controller: function controller($scope, $state, $populate, $ReturnToMerchant, $CheckoutAppDataModel, $CheckoutSessionModel) {
	        $scope.callbacks = {
	            success: function success(sepaModel) {
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(function () {
	                    return sepaModel.action('clearSepa', {
	
	                        data: {
	                            bank: {
	                                id: sepaModel.bankId
	                            },
	                            token: $scope.token
	                        },
	
	                        success: function success() {
	                            $scope.checkoutSession.action('authorize', {
	                                success: function success() {
	                                    $state.go('checkout.end');
	                                }
	
	                            });
	                        }
	
	                    });
	                });
	            }
	        };
	        $state.go('checkout.sepapage.membersepa.sepaAgreement');
	    }
	
	});
	
	angular.value("$xoSepaPageComponent", $xoSepaPageComponent);
	_squid.$Component;

/***/ },

/***/ "./pages/xo-sepa/template.html":
/***/ function(module, exports) {

	module.exports = "<ui-view></ui-view>\n"

/***/ },

/***/ "./components/xo-wallet-components/src/member-sepa/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/member-sepa/directive.js"), __webpack_require__("./components/xo-wallet-components/src/member-sepa/sepaAgreement/route.js"), __webpack_require__("./components/xo-wallet-components/src/member-sepa/sepaMandate/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-member-sepa.route', ['squid', 'xo-member-sepa.directive', 'xo-member-sepa.sepaAgreement.route', 'xo-member-sepa.sepaMandate.route']).factory('$MemberSepaRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('MemberSepaRoute', {
	
	            name: 'membersepa',
	
	            directive: 'xo-member-sepa',
	            titleContent: 'directDebitAgreement.sepaTitle',
	
	            children: [{
	                name: '$XOSepaAgreementRoute',
	                attributes: {
	                    token: 'token',
	                    sepa: 'sepa',
	                    'parent-callbacks': 'callbacks'
	                }
	            }, {
	                name: '$XOSepaMandateRoute',
	                attributes: {
	                    token: 'token',
	                    sepa: 'sepa',
	                    'parent-callbacks': 'callbacks'
	                }
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/member-sepa", "components/xo-wallet-components/src/member-sepa/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/member-sepa/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    return squid.module('xo-member-sepa.directive', ['squid', 'xomodel.checkout', 'xomodel.fi']).directive('xoMemberSepa', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                parentCallbacks: '='
	            },
	
	            controller: function controller($scope, $CheckoutAppDataModel, $CheckoutSessionModel, $SepaModel, $populate, $rootScope) {
	
	                $scope.sepa = $SepaModel.instance({ id: 123 });
	
	                $scope.callbacks = {
	                    sepaAccept: function sepaAccept() {
	
	                        $populate($scope, {
	                            checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                            checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                        }).then(function () {
	                            $rootScope.$emit('loading');
	                            $scope.sepa.action('sepaAccept', {
	                                data: {
	                                    bank: {
	                                        id: $scope.sepa.bankId
	                                    }
	                                },
	                                success: function success() {
	                                    $scope.parentCallbacks.success($scope.sepa);
	                                }
	                            });
	                        });
	                    }
	
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/template.html":
"./pages/xo-sepa/template.html",

/***/ "./components/xo-wallet-components/src/member-sepa/sepaAgreement/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/member-sepa/sepaAgreement/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-member-sepa.sepaAgreement.route', ['squid', 'xo-member-sepa.sepaAgreement.directive']).factory('$XOSepaAgreementRoute', function ($ComponentRoute) {
	        return $ComponentRoute.extend('XOSepaAgreementRoute', {
	            name: 'sepaAgreement',
	
	            directive: 'xo-sepa-agreement',
	            titleContent: 'directDebitAgreement.sepaTitle',
	
	            trackingData: {
	                fptiState: 'sepa_agreement',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::sepa_agreement',
	                        'pagename2': '%::sepa_agreement:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	
	            loginRequired: true,
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/member-sepa/sepaAgreement", "components/xo-wallet-components/src/member-sepa/sepaAgreement/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/member-sepa/sepaAgreement/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/sepaAgreement/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-member-sepa.sepaAgreement.directive', ['squid', 'xomodel.checkout', 'xomodel.fi']).directive('xoSepaAgreement', function ($rootScope) {
	
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                sepa: '=',
	                parentCallbacks: '='
	            },
	
	            controller: function controller($scope, $CheckoutSessionModel, $SepaModel, $populate) {
	
	                $('body').addClass('pageSepaAgreementContingency');
	
	                $scope.$on('$destroy', function () {
	                    $('body').removeClass('pageSepaAgreementContingency');
	                });
	
	                $populate($scope, {
	                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
	                }).then(function () {
	                    $scope.sepa.bankId = $scope.checkoutSession.sepa_mandate.bankId;
	                    $scope.sepa.action('sepaDirectMandate', {
	                        resultModel: $scope.sepa,
	
	                        data: {
	                            bank: {
	                                id: $scope.sepa.bankId
	                            }
	                        },
	
	                        success: function success() {
	                            $scope.onSubmit = function () {
	                                $scope.parentCallbacks.sepaAccept();
	                            };
	                        }
	                    });
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/sepaAgreement/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"sepaAgreementContingency\" content>\n    <div class=\"row-fluid\">\n        <div class=\"centerTray\">\n            <div class=\"trayInner trayInnerDefault loggingIn\">\n                <form ng-submit=\"onSubmit()\" method=\"post\" class=\"proceed ddAgreementForm\" id=\"payment_form\" novalidate>\n                    <h2 class=\"zeta\">{{content('directDebitAgreement.sepaTitle')}}</h2>\n\n                    <p ng-bind-html =\"content('directDebitAgreement.ddAgreementPara1')\"></p>\n                    <p>\n\n                        <span\n                                bind-html-compile=\"htmlContent('directDebitAgreement.ddAgreementPara2',{bankName:sepa.bank.bank_name, bankNumber:sepa.bank.bank_id, href: '^.sepaMandate'})\">\n                        </span>\n\n                    </p>\n\n                    <div class=\"buttons\">\n                        <input track-submit ng-if=\"model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndPay')}}\"  class=\"btn\" />\n                        <input track-submit ng-if=\"!model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndContinue')}}\" class=\"btn\" />\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div>\n</section>\n\n"

/***/ },

/***/ "./components/xo-wallet-components/src/member-sepa/sepaMandate/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-wallet-components/src/member-sepa/sepaMandate/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-member-sepa.sepaMandate.route', ['squid', 'xo-member-sepa.sepaMandate.directive']).factory('$XOSepaMandateRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('XOSepaMandateRoute', {
	            name: 'sepaMandate',
	
	            directive: 'xo-sepa-mandate',
	            titleContent: 'directDebitAgreement.ddFullAgreementTitle',
	
	            trackingData: {
	                fptiState: 'sepa_mandate',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::sepa_mandate',
	                        'pagename2': '%::sepa_mandate:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	
	            loginRequired: true,
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-wallet-components/src/member-sepa/sepaMandate", "components/xo-wallet-components/src/member-sepa/sepaMandate/route.js"))

/***/ },

/***/ "./components/xo-wallet-components/src/member-sepa/sepaMandate/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/sepaMandate/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    return squid.module('xo-member-sepa.sepaMandate.directive', ['squid']).directive('xoSepaMandate', function () {
	        return {
	            template: template,
	
	            scope: {
	                token: '=',
	                sepa: '=',
	                parentCallbacks: '='
	            },
	
	            controller: function controller($scope) {
	                $('body').addClass('pageSepaMandateContingency');
	
	                $scope.$on('$destroy', function () {
	                    $('body').removeClass('pageSepaMandateContingency');
	                });
	
	                $scope.onSubmit = function () {
	                    $scope.parentCallbacks.sepaAccept();
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-wallet-components/src/member-sepa/sepaMandate/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"sepaMandateContingency\" content>\n    <div class=\"row-fluid\">\n        <div class=\"centerTray\">\n            <div class=\"trayInner trayInnerDefault loggingIn\">\n                <form ng-submit=\"onSubmit()\" method=\"post\" class=\"proceed\" id=\"payment_form\" novalidate>\n                    <h2 class=\"zeta\">{{content('directDebitAgreement.ddFullAgreementTitle')}}</h2>\n                    <p>{{content('DEMemberGuest.ddAgreementPara1')}}</p>\n                    <div class=\"row-fluid sepaInfo\">\n                        <div class=\"span\">\n                            <strong>{{content('DEMemberGuest.accountCarrier')}}</strong>\n                            <p>\n                                <span>{{sepa.user.name}}</span>\n                                <br/>{{sepa.user.address.line1}}\n                                <br/>{{sepa.user.address.line2}}\n                                <br/> {{sepa.user.address.city}}, {{sepa.user.address.postal_code}}\n                                <br/>{{sepa.user.address.country}}\n                            </p>\n                        </div>\n                        <div class=\"span bankDetails\">\n                            <p>\n                                <strong>{{content('DEMemberGuest.IBAN')}}</strong>\n                            </p>\n                            {{sepa.bank.iban_number}}\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.bankName')}}</strong>\n                            </p>\n                            {{sepa.bank.bank_name}}\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.bic')}}</strong>\n                            </p>\n                            {{sepa.bank.bic}}\n                        </div>\n                        <div class=\"span\">\n                            <p>\n                                <strong>{{content('DEMemberGuest.creditor')}}</strong>\n                            </p>\n                            {{sepa.creditor.name}}\n                            <p></p>\n                            <div class=\"adr\">\n                                <div class=\"confidential streets street-address darker\">\n                                    {{sepa.creditor.address.line1}}\n                                </div>\n\n                            <div class=\"confidential\">\n                                <span class=\"postal-code\">{{sepa.creditor.address.postal_code}}</span>\n                                <span class=\"locality\">{{sepa.creditor.address.country}}</span>\n                            </div>\n                            </div>\n                            <p></p>\n                            <p class=\"marginTop\">\n                                <strong>{{content('DEMemberGuest.creditorId')}}</strong>\n                            </p>\n                            {{sepa.creditor.id}}\n                        </div>\n                    </div>\n                    <p>\n                        <span ng-if=\"model.useraction.commit\" ng-bind-html=\"htmlContent('directDebitAgreement.ddAgreementPara2AcceptPay')\"></span>\n                        <span ng-if=\"!model.useraction.commit\" ng-bind-html=\"htmlContent('directDebitAgreement.ddAgreementPara2AcceptContinue')\"></span>\n                    </p>\n                    <p class=\"dateLocationMarker\">{{sepa.date}},{{sepa.user.address.city}},{{content('countryList.DE')}}</p>\n                    <div class=\"buttons\">\n                        <input track-submit ng-if=\"model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndPay')}}\"  class=\"btn\" />\n                        <input track-submit ng-if=\"!model.useraction.commit\" id=\"proceedButton\" type=\"submit\" value=\"{{content('directDebitAgreement.acceptAndContinue')}}\" class=\"btn\" />\n                    </div>\n                </form>\n            </div>\n        </div>\n\n    </div>\n</section>\n\n"

/***/ },

/***/ "./pages/xo-end/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$EndRoute = undefined;
	
	__webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	var _returnParams = __webpack_require__("./components/xo-page-components/src/returnParams/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $EndRoute = exports.$EndRoute = _squid.$ComponentRoute.extend('EndRoute', {
	
	    path: 'end',
	
	    trackingData: {
	        fptiState: 'back_to_merchant',
	        trackStateExit: true
	    },
	
	    resolve: {
	        action: function action($q, $window, $util, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutSessionModel, $ReturnToMerchant, $rootScope, $populate, $MerchantPreferenceModel, $CheckoutPayeeModel, $unresolved) {
	
	            function returnMethod(merchantPreferences) {
	                if (_squid.$integration.getConfig('RETURN_METHOD_BASED_ON_MERCHANT_PREFS') && merchantPreferences) {
	                    return merchantPreferences.returnMethod();
	                } else {
	                    return 'GET';
	                }
	            }
	
	            function returnUrl(checkoutAppData, merchantPreferences) {
	                // When "redirect_uri" is passed as a query param
	                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
	                    return $util.param('redirect_uri');
	                }
	
	                if (_squid.$integration.getConfig('RETURN_URL_FROM_MERCHANT_PREFS') && merchantPreferences) {
	                    return checkoutAppData.urls.return_url || merchantPreferences.returnUrl();
	                }
	
	                // By default, use return_uri from checkout session
	                return checkoutAppData.urls.return_url;
	            }
	
	            function returnParams(checkoutCart, checkoutSession, checkoutAppData, returnToMerchantMethod) {
	
	                var params = {};
	
	                // Don't post PayerID for RT without purchase
	                if (_squid.$integration.getConfig('ALLOW_PAYER_ID_RETURN_PARAM') && !checkoutCart.isBillingNoPurchase()) {
	                    params.PayerID = checkoutSession.payer.id;
	                }
	
	                var billingData = checkoutCart.billing;
	
	                if (billingData && billingData.ba_token && !checkoutAppData.legacy_billing_integration) {
	                    params.ba_token = billingData.ba_token;
	                }
	
	                if (_squid.$integration.isFlow('WPS')) {
	                    var isCartUpload = checkoutAppData.flags.is_cart_upload_flow || checkoutAppData.flags.is_shopping_cart_flow;
	                    params = (0, _returnParams.$returnParams)(checkoutCart, checkoutSession, returnToMerchantMethod, 'WPS', isCartUpload);
	                }
	
	                // When "redirect_uri" is passed as a query param
	                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM')) {
	                    params.opType = 'payment';
	                    params.token = $rootScope.token;
	                    params.return_uri = $util.buildURL(checkoutAppData.urls.return_url, params);
	                }
	
	                return params;
	            }
	
	            function getMerchantPreferences(dataModel) {
	                if (_squid.$integration.getConfig('POPULATE_MERCHANT_PREFERENCES')) {
	                    return $populate(dataModel, {
	                        merchantPreferences: $MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
	                    });
	                } else {
	                    return $q.when();
	                }
	            }
	
	            var models = {};
	
	            return $populate(models, {
	                checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
	                checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
	                payee: $CheckoutPayeeModel.instance($rootScope.token)
	            }).then(function () {
	                return getMerchantPreferences(models);
	            }).then(function () {
	                var url = returnUrl(models.checkoutAppData, models.merchantPreferences);
	                var returnToMerchantMethod = returnMethod(models.merchantPreferences);
	                var params = returnParams(models.checkoutCart, models.checkoutSession, models.checkoutAppData, returnToMerchantMethod);
	
	                // if V4 in-context integration, we'll call the onAuthorize handler.
	
	                if (window.xchild) {
	                    _logger.$logger.done();
	                    $rootScope.$emit('loading');
	
	                    var xparams = {
	                        paymentToken: $rootScope.token,
	                        billingToken: params['ba_token'],
	                        payerID: params['PayerID'],
	                        paymentID: params['paymentId'] || models.checkoutAppData.payment_id,
	                        intent: models.checkoutCart.payment_action
	                    };
	
	                    xparams.returnUrl = $util.buildURL(url, params);
	                    return window.xprops.onAuthorize(xparams);
	                }
	
	                if (returnToMerchantMethod === 'POST') {
	                    $ReturnToMerchant.postTo(url, params);
	                } else {
	                    // if PDT is disabled don't send params in the url
	                    if (models.merchantPreferences && !models.merchantPreferences.pdtEnabled()) {
	                        return $ReturnToMerchant.goTo(url);
	                    }
	                    $ReturnToMerchant.goTo($util.buildURL(url, params));
	                }
	
	                return $unresolved;
	            });
	        }
	    }
	});
	
	angular.value("$EndRoute", $EndRoute);
	_returnParams.$returnParams;
	
	_logger.$logger;
	
	_squid.$ComponentRoute;
	
	_squid.$integration;

/***/ },

/***/ "./components/xo-page-components/src/returnParams/index.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var addValidParam = __webpack_require__("./components/xo-page-components/src/utils/index.js").addValidParam;
	
	function returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow) {
	    var params = {};
	    var customData = checkoutCart.get('purchase.custom');
	
	    if (returnToMerchantMethod === 'POST') {
	        // TODO: find out why we get postbackData as undefined
	        // UPDATE: couldn't reproduce an issue on the stage for now
	        if (checkoutSession.postbackData) {
	            params = checkoutSession.postbackData;
	        }
	    } else {
	        var transactionDetail = checkoutSession.transactionDetails;
	
	        if (transactionDetail) {
	            addValidParam(params, 'tx', transactionDetail.id);
	            addValidParam(params, 'st', transactionDetail.state);
	
	            if (transactionDetail.amount) {
	                addValidParam(params, 'amt', transactionDetail.amount.total);
	                addValidParam(params, 'cc', transactionDetail.amount.currency);
	            }
	        }
	
	        // Cart uploads can have more than one item so we don't add any in return URL
	        if (!is_cart_upload_flow) {
	            var itemDetail = checkoutSession.get('itemsList.0');
	            if (itemDetail) {
	                addValidParam(params, 'item_name', itemDetail.name);
	                addValidParam(params, 'item_number', itemDetail.sku);
	            }
	        }
	
	        addValidParam(params, 'cm', customData);
	    }
	    return params;
	}
	
	/**
	 * this API function is used by hermesnodeweb/public/pages/xo-end and xoonboardingnodeweb/public/pages/xo-end
	 * Create params to return back to the merchant after clicking on "Return to merchant" on the Done page.
	 * buy-now and cart-upload params are slightly different: given cart-upload might have multiple items,
	 * please refer https://github.paypal.com/NodeXOShared/xo-hermes-checkout/blob/master/apis/session/postBackDataMapper.js
	 * to know more details about post back data
	
	 * @param {Object (angular model)} cart model
	 * @param {Object (angular model)} session model
	 * @param {String} http method, either "POST" or "GET"
	 * @param {String} feature type (WPS only for now)
	 * @param {Boolean} flag that indicates if it's a cart upload or not
	 * @returns {object} params to pass back to the merchant
	*/
	module.exports = {
	    $returnParams: function $returnParams(checkoutCart, checkoutSession, returnToMerchantMethod, feature, is_cart_upload_flow) {
	        if (feature === 'WPS') {
	            return returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow);
	        }
	        return {};
	    }
	};

/***/ },

/***/ "./components/xo-login-components/src/fullpage-onetouch-upsell/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-login-components/src/fullpage-onetouch-upsell/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-fullpage-onetouch-upsell.route', ['squid', 'xo-fullpage-onetouch-upsell.directive']).factory('$FullpageOnetouchUpsellRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('FullpageOnetouchUpsellRoute', {
	
	            name: 'FullpageOnetouchUpsell',
	            directive: 'xo-fullpage-onetouch-upsell',
	            trackingData: {
	                fptiState: 'fullpage-onetouch-upsell',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::fullpage-onetouch-upsell',
	                        'pagename2': '%::fullpage-onetouch-upsell:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-login-components/src/fullpage-onetouch-upsell", "components/xo-login-components/src/fullpage-onetouch-upsell/route.js"))

/***/ },

/***/ "./components/xo-login-components/src/fullpage-onetouch-upsell/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/fullpage-onetouch-upsell/template.html"), __webpack_require__("./components/xo-tracking/dist/index.js"), __webpack_require__("./components/ul-inline/dist/inject.js"), __webpack_require__("./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js"), __webpack_require__("./components/xo-device-info/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-fullpage-onetouch-upsell.directive', ['squid', 'xolocale', 'tracking', 'xo-device-info']).directive('xoFullpageOnetouchUpsell', function () {
	
	        return {
	            template: template,
	            scope: {
	                token: '='
	            },
	            controller: function controller($scope, $rootScope, $state, $element, $timeout, $logger, $LocaleModel, $locale, $CalDataModel, $config, $meta, $KmliUpsell, $DeviceInfo) {
	
	                $scope.locale = $LocaleModel.instance();
	                $scope.disableCloseButton = $DeviceInfo.isDevice();
	                var ulMeta = $config.ulMeta || {};
	                var PAYPAL = window.PAYPAL || {};
	                var ulTimeOutValue = 5000;
	                var ulTimeoutPromise = null;
	                var styleSet = false;
	
	                var fptiData = $KmliUpsell.getFPTIAttributes();
	
	                function deInitStyles() {
	                    $('#paypalLogo').show();
	                    $('.footer').show();
	                    $('.paypalHeaderWrapper.span14').attr('style', '');
	                    $('.row-fluid.paypalHeaderWrapper').show();
	                }
	
	                function closeInterstitial() {
	                    deInitStyles();
	                    $state.go('checkout.review');
	                }
	
	                function failureHandler(reason) {
	                    $logger.info('KMLI_UPSELL_error_' + reason);
	                    closeInterstitial();
	                }
	
	                var startTimerTS;
	                function startTimer(tag) {
	                    startTimerTS = Date.now();
	                    $logger.info('KMLI_UPSELL_START_TIMER_' + tag, {
	                        startTime: startTimerTS
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'Interstitial_Timer',
	                        'to': 'prepare_' + tag
	                    });
	
	                    ulTimeoutPromise = $timeout(function () {
	                        var stop_time = Date.now();
	                        var time_taken = stop_time - startTimerTS;
	                        $logger.info('checkout_fpti', {
	                            'from': 'Interstitial_Timer',
	                            'to': 'process_timeout',
	                            'int_error_code': 'ULLOGIN_TIMEOUT',
	                            'int_error_description': 'ULLOGIN_TIMEOUT',
	                            'error_source': 'unifiedloginnodeweb',
	                            'error_type': 'soft_decline',
	                            'page_load_time': time_taken
	                        });
	                        failureHandler('timedout');
	                        $rootScope.$emit('loaded');
	                    }, ulTimeOutValue);
	                }
	
	                function stopTimer(tag) {
	                    var stopTimerTS = Date.now();
	                    var timeTaken = stopTimerTS - startTimerTS;
	                    $logger.info('KMLI_UPSELL_STOP_TIMER_' + tag, {
	                        stopTimer: stopTimerTS,
	                        page_load_time: timeTaken
	                    });
	
	                    $logger.info('checkout_fpti', {
	                        'from': 'Interstitial_Timer',
	                        'to': 'process_' + tag,
	                        'page_load_time': timeTaken
	                    });
	
	                    if (ulTimeoutPromise) {
	                        $timeout.cancel(ulTimeoutPromise);
	                    }
	                }
	
	                function logSubmit(data) {
	                    var fptiPayload = {
	                        'from': fptiData.stateName,
	                        'to': 'process' + fptiData.transInfix + 'optin'
	                    };
	                    if (data && data.errorCode) {
	                        angular.extend(fptiPayload, {
	                            'int_error_code': data.errorCode,
	                            'error_type': 'hard_decline',
	                            'error_source': 'unifiedloginnodeweb'
	                        });
	                    }
	                    $logger.info('checkout_fpti', fptiPayload);
	                }
	
	                $scope.$on('$locationChangeStart', function (event, next, current) {
	                    if (styleSet) {
	                        deInitStyles();
	                    }
	                });
	
	                $scope.hideModal = function (event) {
	                    if (event) {
	                        event.preventDefault();
	                    }
	
	                    $logger.info('checkout_fpti', {
	                        'from': fptiData.stateName,
	                        'to': 'process' + fptiData.transInfix + 'decline',
	                        'click_source': 'close_button'
	                    });
	
	                    closeInterstitial();
	                };
	
	                var ulEventHandlers = {
	                    'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        $('#paypalLogo').hide();
	                        $('.footer').hide();
	                        $('.paypalHeaderWrapper.span14').attr('style', 'border:none;');
	                        $('.row-fluid.paypalHeaderWrapper').hide();
	                        styleSet = true;
	                    },
	                    'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
	                        $rootScope.$emit('loading');
	                        startTimer(data.event);
	                    },
	                    'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        logSubmit();
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
	                        stopTimer(data.event);
	                        $rootScope.$emit('loaded');
	                        logSubmit({ errorCode: data.event });
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
	                        stopTimer(data.event);
	                        logSubmit({ errorCode: data.event });
	                        $rootScope.$emit('loaded');
	                        closeInterstitial(data);
	                    },
	                    'oneTouchInterstitialOptInNotNowClicked': function oneTouchInterstitialOptInNotNowClicked(data) {
	                        $logger.info('checkout_fpti', {
	                            'from': fptiData.stateName,
	                            'to': 'process' + fptiData.transInfix + 'decline',
	                            'click_source': 'not_now_link'
	                        });
	                        closeInterstitial(data);
	                    }
	                };
	
	                function postMessageHandler(response) {
	                    $timeout(function () {
	                        $logger.info('ul_postmessaged_received', response);
	                        var data = response.data || response.error;
	                        var eventId = data && data.event;
	                        if (eventId) {
	                            $logger.debug('KMLI_UPSELL_' + eventId, response);
	                            var handler = ulEventHandlers[eventId];
	                            if (handler) {
	                                handler(data);
	                            }
	                        }
	                    });
	                }
	
	                function loadOneTouchUpsell() {
	                    $rootScope.$emit('loading');
	                    var options = {
	                        targetElement: document.getElementById('injectedOneTouchInterstitial'),
	                        queryParams: {
	                            'stsRedirectUri': ulMeta.stsReturnUrl,
	                            'country.x': $scope.locale.country,
	                            'locale.x': $scope.locale.getLocaleCode(),
	                            'flowId': $scope.token,
	                            'correlationId': $CalDataModel.getCalCorrId(),
	                            'flowName': 'checkout'
	                        },
	                        iframePathname: '/signin/activate-one-touch',
	                        onPostMessage: postMessageHandler
	                    };
	
	                    angular.extend(options.queryParams, $KmliUpsell.getOptions());
	
	                    if ($config.deploy.isLocal()) {
	                        options.origin = 'https://' + $meta.stage;
	                    }
	
	                    if (PAYPAL && PAYPAL.unifiedLogin) {
	                        startTimer('initializeUpsell');
	                        PAYPAL.unifiedLogin.inject(options);
	                    } else {
	                        failureHandler('PAYPAL.unifiedLogin_undefined');
	                    }
	                }
	
	                loadOneTouchUpsell();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/fullpage-onetouch-upsell/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"aside\">\n    <a class=\"close\" href=\"#\" title=\"Close\" ng-click=\"hideModal($event)\"></a>\n    <div id=\"injectedOneTouchInterstitial\">\n    </div>\n</div>\n<div class=\"pushLogo\"></div>\n<div class=\"logo\"></div>\n\n"

/***/ },

/***/ "./pages/xo-create-password/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-create-password/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	var _route = __webpack_require__("./components/xo-login-components/src/password-recovery-overlay/route.js");
	
	var _route2 = _interopRequireDefault(_route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Route.extend('$xoPageCreatePasswordRoute', {
	    path: 'createPassword',
	    directive: _directive2['default'],
	    trackingData: {
	        fptiState: 'quick_security_check'
	    },
	    params: {
	        targetPage: null
	    },
	    children: [{
	        route: _route2['default'],
	        props: function props() {
	            var _this = this;
	
	            return {
	                token: this.token,
	                cancel: function cancel() {
	                    return _this.goto('^');
	                },
	                success: function success() {
	                    return _this.goto('checkout.login');
	                }
	            };
	        }
	    }]
	});
	
	
	_squid.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-create-password/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-login-components/src/create-password/directive.js");
	
	__webpack_require__("./pages/xo-create-password/styles.less");
	
	var _template = __webpack_require__("./pages/xo-create-password/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoPageCreatePasswordDirective', {
	    tag: 'xo-page-create-password',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.auth = _auth.$AuthModel.instance();
	            this.reason = _uiRouter.$stateParams.targetPage;
	            this.onContinue = function () {
	                return _this.goto('.passwordRecovery');
	            };
	
	            this.logout = function () {
	                _logger.$logger.info('not_you_logout');
	                _this.auth.action('logout').then(function () {
	                    _this.goto('checkout.login', {
	                        source: 'NOT_YOU'
	                    });
	                });
	            };
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_uiRouter.$stateParams;
	
	_auth.$AuthModel;
	
	_logger.$logger;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-login-components/src/create-password/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	__webpack_require__("./components/xo-login-components/src/create-password/styles.less");
	
	var _template = __webpack_require__("./components/xo-login-components/src/create-password/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CONTENT_KEY_MAP = {
	    ADD_CARD: {
	        benefitsKey: 'passwordRecovery.stepUpBenefits',
	        reasonKey: 'passwordRecovery.stepUpAddCard'
	    },
	    ADD_SHIPPING: {
	        benefitsKey: 'passwordRecovery.stepUpBenefits',
	        reasonKey: 'passwordRecovery.stepUpAddShipping'
	    },
	    APPLY_PPC: {
	        benefitsKey: 'passwordRecovery.stepUpApplyPPCBenefits',
	        reasonKey: 'passwordRecovery.stepUpApplyPPC'
	    },
	    GENERIC: {
	        benefitsKey: 'passwordRecovery.stepUpGenericBenefits',
	        reasonKey: 'passwordRecovery.stepUpGeneric'
	    },
	    NEW_PHONE: {
	        reasonKey: 'passwordRecovery.stepUpNewPhone'
	    },
	    NEED_US_ADDRESS: {
	        reasonKey: 'passwordRecovery.stepUpNeedUSAddress'
	    },
	    CARD_EXPIRED: {
	        reasonKey: 'passwordRecovery.stepUpCardExpired'
	    },
	    MERCHANT_NOT_ACCEPT_AMEX: {
	        reasonKey: 'passwordRecovery.stepUpMerchantNotAcceptAmex'
	    },
	    NEED_CREDIT_CARD: {
	        reasonKey: 'passwordRecovery.stepUpContigencyAddCard'
	    },
	    PAYER_AUTHENTICATION_REQUIRED: {
	        reasonKey: 'passwordRecovery.stepUpNewAddress'
	    },
	    BILLING_AGREEMENTS: {
	        reasonKey: 'passwordRecovery.stepUpBillingAgreements'
	    },
	    GENERIC_CONTINGENCY: {
	        reasonKey: 'passwordRecovery.stepUpContigencyGeneric'
	    }
	};
	
	exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryLandingDirective', {
	    tag: 'xo-create-password',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        },
	        onContinue: {
	            type: 'var'
	        },
	        onCancel: {
	            type: 'var',
	            required: false
	        },
	        reason: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.contingencyName = this.reason && _squid.$util.camelToCapsUnderscore(this.reason) || 'GENERIC';
	            this.getReasonKey = function () {
	                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).reasonKey;
	            };
	
	            this.getBenefitsKey = function () {
	                return (CONTENT_KEY_MAP[_this.contingencyName] || CONTENT_KEY_MAP['GENERIC']).benefitsKey;
	            };
	            this.onSubmit = function () {
	                _logger.$logger.info('checkout_fpti', {
	                    from: 'quick_security_check',
	                    to: 'process_quick_security_check'
	                });
	                _this.onContinue();
	            };
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$util;
	
	_logger.$logger;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-login-components/src/create-password/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-login-components/src/create-password/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-login-components/src/create-password/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#createPassword .heading{padding:5px 0 10px;font-size:1.6em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}#createPassword .msg{padding-top:10px}#createPassword .continueBtn{margin:10px 0}#createPassword .cancelLink{width:100%;text-align:center;padding-top:10px}#createPassword .cancelLink a{cursor:pointer}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){#createPassword{padding-top:40px}}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-login-components/src/create-password/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"createPassword\" content>\n    <div class=\"heading\">{{content('passwordRecovery.quickSecurityCheck')}}</div>\n\n    <div class=\"msg\">{{content(getReasonKey())}}</div>\n\n    <div class=\"msg\">{{content(getBenefitsKey())}}</div>\n\n    <button class=\"btn full continueBtn\" ng-click=\"onSubmit()\">{{content('common.continueLabel')}}</button>\n    <div ng-if=\"onCancel\" class=\"cancelLink\"><a ng-click=\"onCancel($event)\">{{content('common.cancel')}}</a></div>\n</section>\n"

/***/ },

/***/ "./pages/xo-create-password/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-create-password/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-create-password/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#createPasswordPage .userEmail{margin:15px 0}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-create-password/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"createPasswordPage\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <xo-create-password token=\"token\" reason=\"reason\" on-continue=\"onContinue\"></xo-create-password>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ },

/***/ "./components/xo-login-components/src/password-recovery-overlay/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./components/xo-login-components/src/password-recovery-overlay/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Route.extend('$xoPasswordRecoveryOverlayRoute', {
	    path: 'passwordRecovery',
	    directive: _directive2['default'],
	    trackingData: {
	        fptiState: 'password_recovery'
	    },
	    children: []
	});
	
	
	_squid.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-login-components/src/password-recovery-overlay/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _template = __webpack_require__("./components/xo-login-components/src/password-recovery-overlay/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryOverlayDirective', {
	    tag: 'xo-password-recovery-overlay',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        },
	        cancel: {
	            type: 'var'
	        },
	        success: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var auth = _auth.$AuthModel.instance();
	
	            _angular.$rootScope.$emit('loading');
	
	            var hideOverlay = function hideOverlay(callback) {
	                $('#wrapper #spinner').attr('style', '');
	                _this.$element.removeClass('overlayOpen');
	                (0, _angular.$timeout)(function () {
	                    return callback();
	                }, 300);
	            };
	
	            this.hideModal = function (event) {
	                event.preventDefault();
	                hideOverlay(auth.password_less ? _this.cancel : _this.success);
	            };
	
	            this.onPasswordRecoveryReady = function () {
	                (0, _angular.$timeout)(function () {
	                    _angular.$rootScope.$emit('loaded');
	                    _this.$element.addClass('overlayOpen');
	                });
	            };
	
	            this.onContinue = function () {
	                hideOverlay(_this.success);
	            };
	
	            this.onPasswordRecovery = function () {
	                auth.password_less = false;
	            };
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_angular.$rootScope;
	
	_angular.$timeout;
	
	_auth.$AuthModel;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-login-components/src/password-recovery-overlay/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"pwrOverlay\" ng-class=\"{mobile: isDevice}\">\n    <div class=\"overlayMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <a track-link=\"user_cancel\" class=\"close\" href=\"#\" ng-click=\"hideModal($event)\"></a>\n                <section id=\"pwrOverlay\">\n                    <xo-password-recovery token=\"token\" on-password-recovery=\"onPasswordRecovery\" on-load=\"onPasswordRecoveryReady\" on-continue=\"onContinue\"></xo-password-recovery>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</div>\n"

/***/ },

/***/ "./pages/xo-tokenization-info/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _index = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-tokenization-info/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _index.$Route.extend('$xoTokenizationInfoPageRoute', {
	    path: 'tokenizationInfo',
	    directive: _directive2['default'],
	    titleContent: 'Tokenization Info Page',
	    trackingData: {
	        fptiState: 'tokenizationInfo'
	    },
	
	    children: []
	});
	
	
	_index.$Route;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-tokenization-info/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _template = __webpack_require__("./pages/xo-tokenization-info/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-tokenization-info/styles.less");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoTokenizationInfoPageDirective', {
	    tag: 'xo-tokenization-info',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        logout: function logout() {
	            var _this = this;
	
	            this.auth.action('logout').then(function () {
	                _logger.$logger.info('tokenized_wallet', {
	                    'from': 'PP_AndroidPay_Info',
	                    'to': 'process_PP_AndroidPay_Info',
	                    'context_id': _this.props.token,
	                    'context_type': 'EC-Token'
	                });
	                _uiRouter.$state.go('checkout.login', {
	                    source: 'NOT_YOU'
	                });
	            });
	        },
	        'continue': function _continue() {
	            var fi = this.models.checkoutSession.get('errorData.resolution.data.fi');
	            if (fi) {
	                var contingency = new _squid.$Contingency(fi.fundingId ? 'EXPIRED_DEBIT_CARD' : 'NEED_DEBIT_CARD');
	                _squid.$util.extend(contingency, this.models.checkoutSession.errorData);
	                throw contingency;
	            }
	
	            _logger.$logger.info('tokenized_wallet', {
	                'from': 'PP_AndroidPay_Info',
	                'to': 'process_PP_AndroidPay_Info',
	                'context_id': this.props.token,
	                'context_type': 'EC-Token'
	            });
	            _uiRouter.$state.go('checkout.review');
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            this.auth = _auth.$AuthModel.instance();
	            this.showNotYou = this.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp' && !_squid.$util.param('redirectToHermesOn3DSDecline') && !_squid.$util.param('ulReturn');
	            this.userName = (0, _squid.formatNameInformal)({
	                first_name: this.auth.first_name,
	                last_name: this.auth.last_name
	            }) || this.auth.email;
	        },
	        populate: function populate() {
	            (0, _jquery2['default'])('#tokenizationInfo .infoPage').css('min-height', function () {
	                var height = window.innerHeight || document.documentElement && document.documentElement.clientHeight;
	                return height && height - 125; // 125px => height of header & action button bottom padding
	            });
	        }
	    }
	});
	
	
	_auth.$AuthModel;
	
	_squid.$Component;
	
	_squid.$Contingency;
	
	_squid.formatNameInformal;
	
	_squid.$util;
	
	_index.$CheckoutSessionModel;
	
	_uiRouter.$state;
	
	_logger.$logger;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-tokenization-info/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"tokenizationInfo\" modal-box content>\n    <div class=\"infoPage\">\n        <span>\n            {{ content('creditcard.hi', {userName: userName}) }}\n            <span ng-if=\"showNotYou\">\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"actions.logout()\">{{ content('memberReview.notYou')}}</a>\n            </span>\n        </span>\n        <div class=\"info_content\">\n            <div class=\"heading\">{{content('topup.topupInfoHeading')}}</div>\n            <div class=\"content_wrapper\">\n                <div class=\"segment\">\n                    <div class=\"glyph\" id=\"glyph_a\"></div>\n                    <div class=\"text\" ng-bind-html=\"content('topup.topupInfo1')\"></div>\n                </div>\n                <div class=\"segment\">\n                    <div class=\"glyph\" id=\"glyph_b\"></div>\n                    <div class=\"text\" ng-bind-html=\"content('topup.topupInfo2')\"></div>\n                </div>\n                <div class=\"segment\">\n                    <div class=\"glyph\" id=\"glyph_c\"></div>\n                    <div class=\"text\" ng-bind-html=\"content('topup.topupInfo3')\"></div>\n                </div>\n            </div>\n        </div>\n        <input ng-click=\"actions.continue()\" value=\"{{content('common.next')}}\" class=\"btn full continueButton\">\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-tokenization-info/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-tokenization-info/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-tokenization-info/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#tokenizationInfo .infoPage{padding:20px 0 40px;display:flex;flex-direction:column}#tokenizationInfo .infoPage .info_content{margin:40px 0 25px;flex:1 1 auto}#tokenizationInfo .infoPage .info_content .heading{font-size:1.2em}#tokenizationInfo .infoPage .info_content .content_wrapper{margin-top:20px}#tokenizationInfo .infoPage .info_content .content_wrapper .segment{margin-top:10px}#tokenizationInfo .infoPage .info_content .content_wrapper .segment .glyph{position:absolute;width:34px;height:34px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/Sprite_SXO_and_Provision.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){#tokenizationInfo .infoPage .info_content .content_wrapper .segment .glyph{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/Sprite_SXO_and_Provision_2x.png\");background-size:243px 243px}}#tokenizationInfo .infoPage .info_content .content_wrapper .segment .glyph#glyph_a{background-position:-9px -74px}#tokenizationInfo .infoPage .info_content .content_wrapper .segment .glyph#glyph_b{background-position:-9px -117px}#tokenizationInfo .infoPage .info_content .content_wrapper .segment .glyph#glyph_c{background-position:-9px -200px}#tokenizationInfo .infoPage .info_content .content_wrapper .segment .text{margin-left:60px}#tokenizationInfo .infoPage #nextBtn{margin-bottom:auto;margin-top:auto}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-venmo/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-venmo/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Route.extend('$VenmoRoute', {
	    path: 'venmo',
	    directive: _directive2['default'],
	
	    auth: false,
	    query: [_directive.TOKEN_PARAM_NAME]
	});
	
	
	_squid.$Route;
	
	_directive.TOKEN_PARAM_NAME;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-venmo/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.TOKEN_PARAM_NAME = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _checkout = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _venmoModels = __webpack_require__("./components/xo-venmo-components/src/venmo-models/index.js");
	
	var _venmoInfo = __webpack_require__("./components/xo-venmo-components/src/venmo-info/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var TOKEN_PARAM_NAME = exports.TOKEN_PARAM_NAME = 'payload_id';
	
	exports['default'] = _squid.$Component.extend('$VenmoPayloadBootstrap', {
	    tag: 'venmo-payload-bootstrap',
	    template: '<div>', // Empty template
	
	    props: {
	        token: {
	            type: 'var',
	            optional: false
	        }
	    },
	
	    resolve: {
	        venmoParams: function venmoParams() {
	            var _ref;
	
	            return _ref = {}, _ref[TOKEN_PARAM_NAME] = _uiRouter.$stateParams[TOKEN_PARAM_NAME], _ref;
	        },
	        checkoutCart: function checkoutCart() {
	            return _checkout.$CheckoutCartModel.instance(this.token);
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            _logger.$logger.info(['xo-venmo directive', 'lifecycle', 'enter'].join('::'));
	        },
	        populate: function populate() {
	            var _this = this;
	
	            var venmoParams = this.venmoParams,
	                checkoutCart = this.checkoutCart;
	
	            var checkoutSessionModel = _checkout.$CheckoutSessionModel.instance(this.token);
	            var venmoOnboardModel = _venmoModels.$VenmoOnboardModel.instance(this.token);
	            var appData = _checkout.$CheckoutAppDataModel.instance(this.token);
	            var payee = _checkout.$CheckoutPayeeModel.instance(this.token);
	            var venmoDcvv = void 0;
	
	            var totalTransaction = checkoutCart && checkoutCart.purchase && checkoutCart.purchase.amounts && checkoutCart.purchase.amounts.total;
	
	            venmoParams.limit = {
	                currency: totalTransaction.currency_code,
	                amount: totalTransaction.amount
	            };
	
	            venmoParams.merchant_id = payee.merchant.id;
	
	            // define steps
	            var onboardMember = function onboardMember() {
	                return venmoOnboardModel.save({
	                    data: venmoParams,
	                    success: function success(data) {
	                        _logger.$logger.info(data);
	                        venmoDcvv = data.dcvv;
	                        return data;
	                    },
	                    error: function error(err) {
	                        _logger.$logger.info(err);
	                        _uiRouter.$state.go('checkout.login');
	                    },
	                    validation: function validation(_validation) {
	                        return _uiRouter.$state.go('checkout.login');
	                    },
	                    contingencies: {
	                        DEFAULT: function DEFAULT(msg, contingency) {
	                            _uiRouter.$state.go('checkout.login');
	                            _logger.$logger.error(msg);
	                            _logger.$logger.error(contingency);
	                        }
	                    }
	                });
	            };
	            var setVenmoToken = function setVenmoToken() {
	                return _venmoInfo.venmoExperience.set(_this.token);
	            };
	            var createCheckoutSession = function createCheckoutSession() {
	                return checkoutSessionModel.action('create', {
	                    data: {
	                        fraudnet_id: checkoutCart.supplementary && checkoutCart.supplementary.risk_correlation_id,
	                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token,
	                        user_selected_funding_source: {
	                            dcvv: venmoDcvv,
	                            product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
	                        }
	                    },
	                    success: function success(result) {
	                        return result;
	                    }
	                });
	            };
	            var refreshAuthState = function refreshAuthState() {
	                return _auth.$AuthModel.instance().reload();
	            };
	
	            var onAuth = function onAuth(authModel) {
	
	                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {
	
	                    return window.xprops.onAuth({
	                        accessToken: authModel.access_token
	                    });
	                }
	            };
	
	            var routeDecision = function routeDecision(checkoutSession) {
	
	                // if shipping is required and no shipping is sent in xo session, we route to shipping address page
	                if (appData.get('flags.shipping_address_required') && !checkoutSession.shipping) {
	
	                    return _uiRouter.$state.go('checkout.pageAddShipping.addShipping');
	                }
	
	                // else, we go to review page.
	                return _uiRouter.$state.go('checkout.review');
	            };
	
	            onboardMember().then(setVenmoToken).then(refreshAuthState).then(onAuth).then(createCheckoutSession).then(routeDecision)['catch'](function (err) {
	                _logger.$logger.error(err && err.stack || err);
	                venmoOnboardModel.invalidate();
	                _uiRouter.$state.go('checkout.login');
	            });
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_logger.$logger;
	
	_checkout.$CheckoutSessionModel;
	
	_checkout.$CheckoutCartModel;
	
	_checkout.$CheckoutAppDataModel;
	
	_checkout.$CheckoutPayeeModel;
	
	_auth.$AuthModel;
	
	_venmoModels.$VenmoOnboardModel;
	
	_venmoInfo.venmoExperience;
	
	_uiRouter.$stateParams;
	
	_uiRouter.$state;

/***/ },

/***/ "./pages/xo-inventory-soldout/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$xoSoldOutPageRoute = undefined;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _directive = __webpack_require__("./pages/xo-inventory-soldout/directive.js");
	
	var _directive2 = _interopRequireDefault(_directive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoSoldOutPageRoute = exports.$xoSoldOutPageRoute = _squid.$ComponentRoute.extend('$xoSoldOutPageRoute', {
	
	    path: 'soldout',
	    directive: _directive2['default'],
	    titleContent: 'soldout.title',
	    query: ['items', 'soldOutUrl'],
	    auth: false,
	    trackingData: {
	        fptiState: 'soldout',
	        templateName: 'soldout.dust',
	        pageGoal: 'soldout page',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-soldout',
	                'pagename2': '%::fullpage-soldout:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    children: []
	});
	
	angular.value("$xoSoldOutPageRoute", $xoSoldOutPageRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-inventory-soldout/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _util = __webpack_require__("./components/xo-return-to-merchant/dist/util.js");
	
	__webpack_require__("./components/xo-ui-components/src/modal/directive.js");
	
	var _template = __webpack_require__("./pages/xo-inventory-soldout/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoSoldoutPageDirective', {
	    tag: 'xo-soldout-page',
	    template: _template2['default'],
	    auth: false,
	
	    actions: {
	        continueShoppingHandler: function continueShoppingHandler() {
	            _util.$ReturnToMerchant.goTo(decodeURIComponent(_uiRouter.$state.params.soldOutUrl), true);
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            this.locale = _squid.$locale;
	            angular.element('.paypalHeader').css('display', 'none');
	            angular.element('#defaultCancelLink').css('display', 'none');
	        },
	        populate: function populate() {
	            this.item_name = decodeURIComponent(_uiRouter.$state.params.items);
	        }
	    }
	
	});
	
	
	_squid.$Component;
	
	_squid.$locale;
	
	_util.$ReturnToMerchant;
	
	_uiRouter.$state;
	module.exports = exports['default'];

/***/ },

/***/ "./pages/xo-inventory-soldout/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"soldOut\" content>\n    <div id=\"soldouticon\">\n        <div class=\"left_section\"> </div>\n\n        <div class=\"text_lines\">\n            <span id=\"text\">{{content ('soldout.icon')}}</span>\n        </div>\n\n        <div id=\"rightSection\">\n            <span class=\"shape-right\">   </span>\n        </div>\n    </div>\n\n    <div class=\"soldOutMessage\" ng-bind-html=\"htmlContent('soldout.message', {item: item_name})\">\n    </div>\n    <div>\n        <input id= \"Continue-Shopping\" class=\"btn full confirmButton continueButton\" type=\"button\" value=\"{{content ('soldout.continueShoppingButton')}}\" ng-click=\"actions.continueShoppingHandler()\"/>\n\n    </div>\n\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/done/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-page-components/src/done/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-done', ['squid', 'xo-done.directive']).factory('$DoneRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('DoneRoute', {
	            name: 'done',
	            directive: 'xo-done',
	            titleContent: 'done.paymentCompleted',
	            query: ['code'],
	            trackingData: {
	                fptiState: 'done_page',
	                templateName: 'memberDone.dust',
	                pageGoal: 'Payment Done Receipt',
	                trackStateExit: true,
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::fullpage-done',
	                        'pagename2': '%::fullpage-done:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-page-components/src/done", "components/xo-page-components/src/done/route.js"))

/***/ },

/***/ "./components/xo-form-components/src/phone/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-form-components/src/phone/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-phone.route', ['squid', 'xo-phone.directive']).factory('$AddPhoneRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('AddPhoneRoute', {
	
	            name: 'addPhone',
	
	            directive: 'xo-add-phone',
	
	            titleContent: 'addPhone.addPhoneNumber',
	
	            query: ['message'],
	
	            trackingData: {
	                templateName: 'addPhone.dust',
	                fptiState: 'add_phone',
	                pageGoal: 'Add Phone',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::fullpage-add-phone',
	                        'pagename2': '%::fullpage-add-phone:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                    // More page qualifiers come here...
	                }
	            },
	
	            loginRequired: true,
	
	            children: []
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-form-components/src/phone", "components/xo-form-components/src/phone/route.js"))

/***/ },

/***/ "./components/xo-form-components/src/phone/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/template.html"), __webpack_require__("./components/xo-form-components/src/phone/phoneInput/directive.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-phone.directive', ['squid', 'xo-phone.phoneInput', 'xomodel.checkout', 'xomodel.user', 'xomodel.auth', 'xo-message.directive', 'xo-title.directive', 'xo-value-props.directive']).directive('xoAddPhone', function () {
	        return {
	            template: template,
	            scope: {},
	            controller: function controller($scope, $rootScope, $location, $populate, $contentVersion, $UserInfoModel, $state, $locale, $featureCountries, $CheckoutSessionModel, $util, $logger, $AuthModel, $feature) {
	
	                $scope.showPhoneDisclosure = $featureCountries('showPhoneDisclosure').indexOf($locale.country) > -1;
	                $scope.phoneConsent = $feature('phoneConsent');
	                $scope.consentContentKey = $scope.phoneConsent ? 'addPhone.phoneConsent' : 'addPhone.phoneDisclosure';
	                $scope.errorMessage = {
	                    msgKeys: ['addPhone.addPhoneNumberConsent'],
	                    type: 'info'
	                };
	
	                $scope.userInfo = $UserInfoModel.instance($rootScope.token);
	
	                var CONTENT_KEY = {
	                    INVALID_PHONE_NUMBER: 'validPhone'
	                };
	
	                var CONTENT_MAPPING = {
	                    numberError: CONTENT_KEY.INVALID_PHONE_NUMBER,
	                    typeError: CONTENT_KEY.INVALID_PHONE_NUMBER
	                };
	
	                var populateErrorMessage = function populateErrorMessage(name) {
	                    var contentKey = CONTENT_MAPPING[name];
	                    var msg = contentKey ? $locale.content.get('scripts.' + contentKey) : 'unresolved content for login error ' + name;
	
	                    $scope.errorMessage = {
	                        msgs: [msg],
	                        type: 'error'
	                    };
	                };
	
	                var validationErrorHandler = {
	                    numberError: populateErrorMessage,
	                    typeError: populateErrorMessage
	                };
	
	                $populate($scope, {
	                    auth: $AuthModel.instance()
	                }).then(function () {
	
	                    $scope.logout = function () {
	                        $logger.info('not_you_logout');
	                        $scope.auth.action('logout').then(function () {
	                            $state.go('checkout.login');
	                        });
	                    };
	
	                    $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && $scope.logout;
	
	                    $scope.onSubmit = function () {
	                        if ($scope.phoneConsent) {
	                            $scope.phone.consent = {
	                                agreed: true,
	                                contentId: $locale.country + ':' + $locale.lang + ':' + $scope.consentContentKey + ':' + $contentVersion()
	                            };
	                        }
	                        $scope.userInfo.action('addPhone', {
	
	                            data: $scope.phone,
	
	                            success: function success(data) {
	                                return $CheckoutSessionModel.instance($rootScope.token).action('create', {
	                                    success: function success() {
	                                        $state.go('checkout.review');
	                                    }
	                                });
	                            },
	
	                            contingencies: {
	                                NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
	                                    $location.path('/checkout/addCard');
	                                },
	
	                                EXPIRED_CREDIT_CARD: function EXPIRED_CREDIT_CARD() {
	                                    $location.path('/checkout/updateCard');
	                                }
	                            },
	
	                            validation: function validation(data) {
	                                angular.forEach(data, function (value, key) {
	                                    validationErrorHandler[key](key);
	                                });
	                            }
	                        });
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"addPhone\" id=\"addPhone\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n                {{ content('memberReview.welcomeBack', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <xo-title title-txt=\"{{content('addPhone.addPhoneNumber')}}\"></xo-title>\n            <form name=\"addPhoneForm\" class=\"proceed\" content autocomplete=\"off\" ng-submit=\"addPhoneForm.$valid && onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n                <xo-phone-input phone=\"phone\"></xo-phone-input>\n                <p class=\"disclaimer\" id=\"phoneDisclosure\" ng-if=\"showPhoneDisclosure\">\n                    <span data-ng-bind-html=\"htmlContent(consentContentKey)\"></span>\n                </p>\n                <input track-submit type=\"submit\" value=\"{{showPhoneDisclosure ? content('addPhone.agreeContinue') : content('common.continueLabel') }}\" class=\"btn full\" ng-click=\"validated=true\" />\n            </form>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-form-components/src/phone/phoneInput/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-form-components/src/phone/phoneInput/styles.less");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/phoneInput/template.html"), __webpack_require__("./components/xo-form-components/src/phone/lib/territoriesByCode.js"), __webpack_require__("./components/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("./components/xo-ui-components/src/floating-label/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template, countryPhoneCode) {
	
	    angular.module('xo-phone.phoneInput', ['squid', 'xo-dropdown.directive', 'xo-error-tooltip.directive', 'floating-label.directive']).directive('xoPhoneInput', function () {
	        return {
	            template: template,
	            scope: {
	                phone: '=',
	                showPhoneType: '=',
	                exclude: '@'
	            },
	
	            link: function link(scope, element, attr, controller) {
	                element.on('keyup', function (event) {
	                    $('.telephone').mask(scope.mask, {
	                        'translation': {
	                            0: { pattern: /[0-9]/ }
	                        }
	                    });
	                });
	            },
	
	            controller: function controller($scope, $feature, $locale) {
	                $scope.locale = $locale;
	                $scope.IntDialingCodes = countryPhoneCode;
	                $scope.defaultCountryPhoneCode = countryPhoneCode[$locale.country];
	                $scope.showPhoneType = $feature('phoneType', true, $scope.country) && $scope.showPhoneType !== false;
	
	                // dont display countries that are tagged with hideInOtherCountries flag in territoriesByCode.js.
	                // if localeCountry and dropdown country are same ignore hideInOtherCountries and display the countrycode.
	                $scope.hideCountry = function (dropdownCountry, hideInOtherCountries) {
	                    return $locale.country !== dropdownCountry && hideInOtherCountries;
	                };
	
	                $scope.phone = $scope.phone || {};
	                $scope.phone.phoneType = $scope.phone.phoneType || 'Mobile';
	                $scope.phone.IntDialingCountryCode = $scope.defaultCountryPhoneCode.phoneCountryCode;
	
	                angular.extend($scope.phone, {
	                    phoneCountryCode: $locale.country
	                });
	
	                function getPhoneMask(phoneType, phoneEntry) {
	                    var defaultMask = '0000000000000000';
	                    var masks = phoneEntry && phoneEntry.masks;
	                    var mobileMask = masks && masks.MOBILE ? masks.MOBILE : defaultMask;
	                    var fixedLineMask = masks && masks.FIXED_LINE ? masks.FIXED_LINE : defaultMask;
	                    return phoneType === 'Mobile' ? mobileMask : fixedLineMask;
	                }
	
	                function getPhonePattern(phoneEntry) {
	                    var defaultPattern = '^[0-9]+$';
	                    var patterns = phoneEntry && phoneEntry.patterns;
	                    // less stric regex validation in place for now, just use general regex to match mobile AND fixed-line formats
	                    // for now we use less strict regex validation because we are not ready for this more strict validation
	                    if (patterns) {
	                        return patterns.GENERAL ? patterns.GENERAL : defaultPattern;
	                    }
	                    return defaultPattern;
	
	                    // more strict regex validaiton based on phone type is found commented below
	                    // var ret;
	                    // switch ($scope.phone.phoneType) {
	                    //     case 'Mobile':
	                    //         ret = patterns.MOBILE;
	                    //         break;
	                    //     case 'Home':
	                    //     case 'Work':
	                    //         ret = patterns.FIXED_LINE;
	                    //         break;
	                    //     default:
	                    //         ret = patterns.GENERAL;
	                    //         break;
	                    // }
	                    // return ret ? ret : defaultPattern;
	                }
	
	                function populatePhoneMetadata() {
	                    if (!$scope.metadata || $scope.metadata.country !== $locale.metadata.country) {
	                        $scope.metadata = angular.copy($locale.metadata);
	                    }
	                    var phoneEntry = $scope.metadata.phoneEntry;
	                    $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
	                    $scope.pattern = getPhonePattern(phoneEntry);
	                }
	
	                populatePhoneMetadata();
	
	                // Reset the phone number mask from according to the phone type
	                $scope.phoneTypeChanged = function () {
	                    $scope.mask = getPhoneMask($scope.phone.phoneType, $scope.metadata.phoneEntry);
	                    $scope.pattern = getPhonePattern($scope.metadata.phoneEntry);
	                    $('.telephone').mask($scope.mask);
	                };
	
	                $scope.$watch('phone.phoneCountryCode', function (newValue) {
	                    $scope.phone.IntDialingCountryCode = countryPhoneCode[newValue].phoneCountryCode;
	                });
	
	                $scope.$on('localeChange', function () {
	                    $scope.defaultCountryPhoneCode = countryPhoneCode[$locale.country];
	                    $scope.phone.phoneCountryCode = $locale.country;
	                    if (!$scope.metadata || $scope.metadata.country !== $locale.metadata.country) {
	                        populatePhoneMetadata();
	                        $('.telephone').mask($scope.mask);
	                    }
	                });
	
	                $scope.showWork = $scope.exclude === 'WORK';
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-form-components/src/phone/phoneInput/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/phone/phoneInput/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-form-components/src/phone/phoneInput/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".singleLineMobile{float:none!important}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/phone/phoneInput/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"row-fluid fieldGroup clearfix\" ng-class=\"{countryCodeSelect: defaultCountryPhoneCode.showCountryCodeList === true}\" content>\n    <div id=\"phoneTypeContainer\" class=\"phoneTypeContainer dropdown confidential inputField half\" ng-cloak\n         ng-if=\"showPhoneType === true\" ng-class=\"{'rtlPhoneType': locale.metadata.directionality === 'rtl'}\"\n         floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneType\" name=\"phoneType\" id=\"phoneType\" ng-change=\"phoneTypeChanged()\" xo-error-tooltip>\n            <option value=\"Mobile\" selected=\"\">{{content('common.mobile')}}</option>\n            <option value=\"Home\">{{content('common.home')}}</option>\n            <option ng-if=\"!showWork\" value=\"Work\">{{content('common.work')}}</option>\n        </select>\n        <label for=\"phoneType\" id=\"phoneTypeLabel\">{{content('common.phoneType')}}</label>\n    </div>\n\n    <div id=\"phoneCodeContainer\" class=\"phoneCodeContainer dropdown confidential half last-child inputField\" ng-cloak\n         ng-if=\"defaultCountryPhoneCode.showCountryCodeList\" floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneCountryCode\" name=\"phoneCountryCode\" id=\"phoneCountryCode\" aria-required=\"true\" xo-error-tooltip required>\n            <option ng-repeat=\"(key, value) in IntDialingCodes\" value=\"{{key}}\" ng-if=\"!hideCountry(key, value.hideInOtherCountries)\" ng-selected=\"phone.phoneCountryCode === key\">{{value.phoneCountryCode}} ({{key}})</option>\n        </select>\n        <label for=\"phoneCountryCode\" id=\"phoneCodeLabel\">{{content('common.phoneCountryCode')}}</label>\n    </div>\n\n    <div class=\"inputField confidential last-child\"\n         ng-class=\"{'half': showPhoneType || defaultCountryPhoneCode.showCountryCodeList, 'telephoneField': showPhoneType,\n         'telephoneFieldFull': !showPhoneType, 'rtlPhoneField': locale.metadata.directionality === 'rtl',\n         singleLineMobile: !showPhoneType && !defaultCountryPhoneCode.showCountryCodeList}\" floating-label directionality >\n\n        <input id=\"telephone\"\n               class=\"telephone\"\n               type=\"tel\"\n               ng-model=\"phone.telephone\"\n               name=\"telephone\"\n               value=\"\"\n               autocapitalize=\"off\"\n               autocomplete=\"off\"\n               aria-required=\"true\"\n               country-code=\"phone.phoneCountryCode\"\n               phone-pattern=\"{{pattern}}\"\n               xo-validation='{\"validator\": \"validPhone\"}'\n               data-error-key=\"validation.validPhone\"\n               maxlength=\"{{mask.length}}\"\n               required\n               xo-error-tooltip />\n        <label for=\"telephone\" class=\"focus\">{{content('common.phone')}}</label>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-form-components/src/phone/lib/territoriesByCode.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return {
	        'AC': {
	            'status': 'reserved',
	            'phoneCountryCode': '247',
	            'showCountryCodeList': false
	        },
	        'AD': {
	            'status': 'assigned',
	            'phoneCountryCode': '376',
	            'showCountryCodeList': false
	        },
	        'AE': {
	            'status': 'assigned',
	            'phoneCountryCode': '971',
	            'showCountryCodeList': false
	        },
	        'AF': {
	            'status': 'assigned',
	            'phoneCountryCode': '93',
	            'showCountryCodeList': false
	        },
	        'AG': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'AI': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'AL': {
	            'status': 'assigned',
	            'phoneCountryCode': '355',
	            'showCountryCodeList': false
	        },
	        'AM': {
	            'status': 'assigned',
	            'phoneCountryCode': '374',
	            'showCountryCodeList': false
	        },
	        'AN': {
	            'status': 'assigned',
	            'phoneCountryCode': '599',
	            'showCountryCodeList': false
	        },
	        'AO': {
	            'status': 'assigned',
	            'phoneCountryCode': '244',
	            'showCountryCodeList': false
	        },
	        'AQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '672',
	            'showCountryCodeList': false
	        },
	        'AR': {
	            'status': 'assigned',
	            'phoneCountryCode': '54',
	            'showCountryCodeList': false
	        },
	        'AS': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'AT': {
	            'status': 'assigned',
	            'phoneCountryCode': '43',
	            'showCountryCodeList': true
	        },
	        'AU': {
	            'status': 'assigned',
	            'phoneCountryCode': '61',
	            'showCountryCodeList': true
	        },
	        'AW': {
	            'status': 'assigned',
	            'phoneCountryCode': '297',
	            'showCountryCodeList': false
	        },
	        'AZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '994',
	            'showCountryCodeList': false
	        },
	        'BA': {
	            'status': 'assigned',
	            'phoneCountryCode': '387',
	            'showCountryCodeList': false
	        },
	        'BB': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'BD': {
	            'status': 'assigned',
	            'phoneCountryCode': '880',
	            'showCountryCodeList': false
	        },
	        'BE': {
	            'status': 'assigned',
	            'phoneCountryCode': '32',
	            'showCountryCodeList': true
	        },
	        'BF': {
	            'status': 'assigned',
	            'phoneCountryCode': '226',
	            'showCountryCodeList': false
	        },
	        'BG': {
	            'status': 'assigned',
	            'phoneCountryCode': '359',
	            'showCountryCodeList': false
	        },
	        'BH': {
	            'status': 'assigned',
	            'phoneCountryCode': '973',
	            'showCountryCodeList': false
	        },
	        'BI': {
	            'status': 'assigned',
	            'phoneCountryCode': '257',
	            'showCountryCodeList': false
	        },
	        'BJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '229',
	            'showCountryCodeList': false
	        },
	        'BL': {
	            'status': 'assigned',
	            'phoneCountryCode': '590',
	            'showCountryCodeList': false
	        },
	        'BM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'BN': {
	            'status': 'assigned',
	            'phoneCountryCode': '673',
	            'showCountryCodeList': false
	        },
	        'BO': {
	            'status': 'assigned',
	            'phoneCountryCode': '591',
	            'showCountryCodeList': false
	        },
	        'BQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '599',
	            'showCountryCodeList': false
	        },
	        'BR': {
	            'status': 'assigned',
	            'phoneCountryCode': '55',
	            'showCountryCodeList': false
	        },
	        'BS': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'BT': {
	            'status': 'assigned',
	            'phoneCountryCode': '975',
	            'showCountryCodeList': false
	        },
	        'BV': {
	            'status': 'assigned'
	        },
	        'BW': {
	            'status': 'assigned',
	            'phoneCountryCode': '267',
	            'showCountryCodeList': false
	        },
	        'BY': {
	            'status': 'assigned',
	            'phoneCountryCode': '375',
	            'showCountryCodeList': false
	        },
	        'BZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '501',
	            'showCountryCodeList': false
	        },
	        'C2': {
	            'status': 'assigned',
	            'phoneCountryCode': '86',
	            'showCountryCodeList': false
	        },
	        'CA': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'CC': {
	            'status': 'assigned',
	            'phoneCountryCode': '61',
	            'showCountryCodeList': false
	        },
	        'CD': {
	            'status': 'assigned',
	            'phoneCountryCode': '243',
	            'showCountryCodeList': false
	        },
	        'CF': {
	            'status': 'assigned',
	            'phoneCountryCode': '236',
	            'showCountryCodeList': false
	        },
	        'CG': {
	            'status': 'assigned',
	            'phoneCountryCode': '242',
	            'showCountryCodeList': false
	        },
	        'CH': {
	            'status': 'assigned',
	            'phoneCountryCode': '41',
	            'showCountryCodeList': true
	        },
	        'CI': {
	            'status': 'assigned',
	            'phoneCountryCode': '225',
	            'showCountryCodeList': false
	        },
	        'CK': {
	            'status': 'assigned',
	            'phoneCountryCode': '682',
	            'showCountryCodeList': false
	        },
	        'CL': {
	            'status': 'assigned',
	            'phoneCountryCode': '56',
	            'showCountryCodeList': false
	        },
	        'CM': {
	            'status': 'assigned',
	            'phoneCountryCode': '237',
	            'showCountryCodeList': false
	        },
	        'CN': {
	            'status': 'assigned',
	            'phoneCountryCode': '86',
	            'showCountryCodeList': false
	        },
	        'CO': {
	            'status': 'assigned',
	            'phoneCountryCode': '57',
	            'showCountryCodeList': false
	        },
	        'CR': {
	            'status': 'assigned',
	            'phoneCountryCode': '506',
	            'showCountryCodeList': false
	        },
	        'CU': {
	            'status': 'assigned',
	            'phoneCountryCode': '53',
	            'showCountryCodeList': false
	        },
	        'CV': {
	            'status': 'assigned',
	            'phoneCountryCode': '238',
	            'showCountryCodeList': false
	        },
	        'CW': {
	            'status': 'assigned',
	            'phoneCountryCode': '599',
	            'showCountryCodeList': false
	        },
	        'CX': {
	            'status': 'assigned',
	            'phoneCountryCode': '61',
	            'showCountryCodeList': false
	        },
	        'CY': {
	            'status': 'assigned',
	            'phoneCountryCode': '357',
	            'showCountryCodeList': false
	        },
	        'CZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '420',
	            'showCountryCodeList': false
	        },
	        'DE': {
	            'status': 'assigned',
	            'phoneCountryCode': '49',
	            'showCountryCodeList': false
	        },
	        'DJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '253',
	            'showCountryCodeList': false
	        },
	        'DK': {
	            'status': 'assigned',
	            'phoneCountryCode': '45',
	            'showCountryCodeList': true
	        },
	        'DM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'DO': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'DZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '213',
	            'showCountryCodeList': false
	        },
	        'EC': {
	            'status': 'assigned',
	            'phoneCountryCode': '593',
	            'showCountryCodeList': false
	        },
	        'EE': {
	            'status': 'assigned',
	            'phoneCountryCode': '372',
	            'showCountryCodeList': false
	        },
	        'EG': {
	            'status': 'assigned',
	            'phoneCountryCode': '20',
	            'showCountryCodeList': false
	        },
	        'EH': {
	            'status': 'assigned',
	            'phoneCountryCode': '212',
	            'showCountryCodeList': false
	        },
	        'ER': {
	            'status': 'assigned',
	            'phoneCountryCode': '291',
	            'showCountryCodeList': false
	        },
	        'ES': {
	            'status': 'assigned',
	            'phoneCountryCode': '34',
	            'showCountryCodeList': false
	        },
	        'ET': {
	            'status': 'assigned',
	            'phoneCountryCode': '251',
	            'showCountryCodeList': false
	        },
	        'FI': {
	            'status': 'assigned',
	            'phoneCountryCode': '358',
	            'showCountryCodeList': false
	        },
	        'FJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '679',
	            'showCountryCodeList': false
	        },
	        'FK': {
	            'status': 'assigned',
	            'phoneCountryCode': '500',
	            'showCountryCodeList': false
	        },
	        'FM': {
	            'status': 'assigned',
	            'phoneCountryCode': '691',
	            'showCountryCodeList': false
	        },
	        'FO': {
	            'status': 'assigned',
	            'phoneCountryCode': '298',
	            'showCountryCodeList': false
	        },
	        'FR': {
	            'status': 'assigned',
	            'phoneCountryCode': '33',
	            'showCountryCodeList': false
	        },
	        'GA': {
	            'status': 'assigned',
	            'phoneCountryCode': '241',
	            'showCountryCodeList': false
	        },
	        'GB': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'GD': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'GE': {
	            'status': 'assigned',
	            'phoneCountryCode': '995',
	            'showCountryCodeList': false
	        },
	        'GF': {
	            'status': 'assigned',
	            'phoneCountryCode': '594',
	            'showCountryCodeList': false
	        },
	        'GG': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'GH': {
	            'status': 'assigned',
	            'phoneCountryCode': '233',
	            'showCountryCodeList': false
	        },
	        'GI': {
	            'status': 'assigned',
	            'phoneCountryCode': '350',
	            'showCountryCodeList': false
	        },
	        'GL': {
	            'status': 'assigned',
	            'phoneCountryCode': '299',
	            'showCountryCodeList': false
	        },
	        'GM': {
	            'status': 'assigned',
	            'phoneCountryCode': '220',
	            'showCountryCodeList': false
	        },
	        'GN': {
	            'status': 'assigned',
	            'phoneCountryCode': '224',
	            'showCountryCodeList': false
	        },
	        'GP': {
	            'status': 'assigned',
	            'phoneCountryCode': '590',
	            'showCountryCodeList': false
	        },
	        'GQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '240',
	            'showCountryCodeList': false
	        },
	        'GR': {
	            'status': 'assigned',
	            'phoneCountryCode': '30',
	            'showCountryCodeList': false
	        },
	        'GS': {
	            'status': 'assigned',
	            'phoneCountryCode': '500',
	            'showCountryCodeList': false
	        },
	        'GT': {
	            'status': 'assigned',
	            'phoneCountryCode': '502',
	            'showCountryCodeList': false
	        },
	        'GU': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'GW': {
	            'status': 'assigned',
	            'phoneCountryCode': '245',
	            'showCountryCodeList': false
	        },
	        'GY': {
	            'status': 'assigned',
	            'phoneCountryCode': '592',
	            'showCountryCodeList': false
	        },
	        'HK': {
	            'status': 'assigned',
	            'phoneCountryCode': '852',
	            'showCountryCodeList': true
	        },
	        'HM': {
	            'status': 'assigned'
	        },
	        'HN': {
	            'status': 'assigned',
	            'phoneCountryCode': '504',
	            'showCountryCodeList': false
	        },
	        'HR': {
	            'status': 'assigned',
	            'phoneCountryCode': '385',
	            'showCountryCodeList': false
	        },
	        'HT': {
	            'status': 'assigned',
	            'phoneCountryCode': '509',
	            'showCountryCodeList': false
	        },
	        'HU': {
	            'status': 'assigned',
	            'phoneCountryCode': '36',
	            'showCountryCodeList': false
	        },
	        'ID': {
	            'status': 'assigned',
	            'phoneCountryCode': '62',
	            'showCountryCodeList': false
	        },
	        'IE': {
	            'status': 'assigned',
	            'phoneCountryCode': '353',
	            'showCountryCodeList': false
	        },
	        'IL': {
	            'status': 'assigned',
	            'phoneCountryCode': '972',
	            'showCountryCodeList': false
	        },
	        'IM': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'IN': {
	            'status': 'assigned',
	            'phoneCountryCode': '91',
	            'showCountryCodeList': false
	        },
	        'IO': {
	            'status': 'assigned',
	            'phoneCountryCode': '246',
	            'showCountryCodeList': false
	        },
	        'IQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '964',
	            'showCountryCodeList': false
	        },
	        'IR': {
	            'status': 'assigned',
	            'phoneCountryCode': '98',
	            'showCountryCodeList': false
	        },
	        'IS': {
	            'status': 'assigned',
	            'phoneCountryCode': '354',
	            'showCountryCodeList': false
	        },
	        'IT': {
	            'status': 'assigned',
	            'phoneCountryCode': '39',
	            'showCountryCodeList': false
	        },
	        'JE': {
	            'status': 'assigned',
	            'phoneCountryCode': '44',
	            'showCountryCodeList': false
	        },
	        'JM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'JO': {
	            'status': 'assigned',
	            'phoneCountryCode': '962',
	            'showCountryCodeList': false
	        },
	        'JP': {
	            'status': 'assigned',
	            'phoneCountryCode': '81',
	            'showCountryCodeList': false
	        },
	        'KE': {
	            'status': 'assigned',
	            'phoneCountryCode': '254',
	            'showCountryCodeList': false
	        },
	        'KG': {
	            'status': 'assigned',
	            'phoneCountryCode': '996',
	            'showCountryCodeList': false
	        },
	        'KH': {
	            'status': 'assigned',
	            'phoneCountryCode': '855',
	            'showCountryCodeList': false
	        },
	        'KI': {
	            'status': 'assigned',
	            'phoneCountryCode': '686',
	            'showCountryCodeList': false
	        },
	        'KM': {
	            'status': 'assigned',
	            'phoneCountryCode': '269',
	            'showCountryCodeList': false
	        },
	        'KN': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'KP': {
	            'status': 'assigned',
	            'phoneCountryCode': '850',
	            'showCountryCodeList': false
	        },
	        'KR': {
	            'status': 'assigned',
	            'phoneCountryCode': '82',
	            'showCountryCodeList': false
	        },
	        'KW': {
	            'status': 'assigned',
	            'phoneCountryCode': '965',
	            'showCountryCodeList': false
	        },
	        'KY': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'KZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '7',
	            'showCountryCodeList': false
	        },
	        'LA': {
	            'status': 'assigned',
	            'phoneCountryCode': '856',
	            'showCountryCodeList': true
	        },
	        'LB': {
	            'status': 'assigned',
	            'phoneCountryCode': '961',
	            'showCountryCodeList': false
	        },
	        'LC': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'LI': {
	            'status': 'assigned',
	            'phoneCountryCode': '423',
	            'showCountryCodeList': false
	        },
	        'LK': {
	            'status': 'assigned',
	            'phoneCountryCode': '94',
	            'showCountryCodeList': false
	        },
	        'LR': {
	            'status': 'assigned',
	            'phoneCountryCode': '231',
	            'showCountryCodeList': false
	        },
	        'LS': {
	            'status': 'assigned',
	            'phoneCountryCode': '266',
	            'showCountryCodeList': false
	        },
	        'LT': {
	            'status': 'assigned',
	            'phoneCountryCode': '370',
	            'showCountryCodeList': false
	        },
	        'LU': {
	            'status': 'assigned',
	            'phoneCountryCode': '352',
	            'showCountryCodeList': false
	        },
	        'LV': {
	            'status': 'assigned',
	            'phoneCountryCode': '371',
	            'showCountryCodeList': false
	        },
	        'LY': {
	            'status': 'assigned',
	            'phoneCountryCode': '218',
	            'showCountryCodeList': false
	        },
	        'MA': {
	            'status': 'assigned',
	            'phoneCountryCode': '212',
	            'showCountryCodeList': false
	        },
	        'MC': {
	            'status': 'assigned',
	            'phoneCountryCode': '377',
	            'showCountryCodeList': false
	        },
	        'MD': {
	            'status': 'assigned',
	            'phoneCountryCode': '373',
	            'showCountryCodeList': false
	        },
	        'ME': {
	            'status': 'assigned',
	            'phoneCountryCode': '382',
	            'showCountryCodeList': false
	        },
	        'MF': {
	            'status': 'assigned',
	            'phoneCountryCode': '590',
	            'showCountryCodeList': false
	        },
	        'MG': {
	            'status': 'assigned',
	            'phoneCountryCode': '261',
	            'showCountryCodeList': false
	        },
	        'MH': {
	            'status': 'assigned',
	            'phoneCountryCode': '692',
	            'showCountryCodeList': false
	        },
	        'MK': {
	            'status': 'assigned',
	            'phoneCountryCode': '389',
	            'showCountryCodeList': false
	        },
	        'ML': {
	            'status': 'assigned',
	            'phoneCountryCode': '223',
	            'showCountryCodeList': false
	        },
	        'MM': {
	            'status': 'assigned',
	            'phoneCountryCode': '95',
	            'showCountryCodeList': false
	        },
	        'MN': {
	            'status': 'assigned',
	            'phoneCountryCode': '976',
	            'showCountryCodeList': false
	        },
	        'MO': {
	            'status': 'assigned',
	            'phoneCountryCode': '853',
	            'showCountryCodeList': false
	        },
	        'MP': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'MQ': {
	            'status': 'assigned',
	            'phoneCountryCode': '596',
	            'showCountryCodeList': false
	        },
	        'MR': {
	            'status': 'assigned',
	            'phoneCountryCode': '222',
	            'showCountryCodeList': false
	        },
	        'MS': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'MT': {
	            'status': 'assigned',
	            'phoneCountryCode': '356',
	            'showCountryCodeList': false
	        },
	        'MU': {
	            'status': 'assigned',
	            'phoneCountryCode': '230',
	            'showCountryCodeList': false
	        },
	        'MV': {
	            'status': 'assigned',
	            'phoneCountryCode': '960',
	            'showCountryCodeList': false
	        },
	        'MW': {
	            'status': 'assigned',
	            'phoneCountryCode': '265',
	            'showCountryCodeList': false
	        },
	        'MX': {
	            'status': 'assigned',
	            'phoneCountryCode': '52',
	            'showCountryCodeList': false
	        },
	        'MY': {
	            'status': 'assigned',
	            'phoneCountryCode': '60',
	            'showCountryCodeList': false
	        },
	        'MZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '258',
	            'showCountryCodeList': false
	        },
	        'NA': {
	            'status': 'assigned',
	            'phoneCountryCode': '264',
	            'showCountryCodeList': false
	        },
	        'NC': {
	            'status': 'assigned',
	            'phoneCountryCode': '687',
	            'showCountryCodeList': false
	        },
	        'NE': {
	            'status': 'assigned',
	            'phoneCountryCode': '227',
	            'showCountryCodeList': false
	        },
	        'NF': {
	            'status': 'assigned',
	            'phoneCountryCode': '672',
	            'showCountryCodeList': false
	        },
	        'NG': {
	            'status': 'assigned',
	            'phoneCountryCode': '234',
	            'showCountryCodeList': false
	        },
	        'NI': {
	            'status': 'assigned',
	            'phoneCountryCode': '505',
	            'showCountryCodeList': false
	        },
	        'NL': {
	            'status': 'assigned',
	            'phoneCountryCode': '31',
	            'showCountryCodeList': true
	        },
	        'NO': {
	            'status': 'assigned',
	            'phoneCountryCode': '47',
	            'showCountryCodeList': true
	        },
	        'NP': {
	            'status': 'assigned',
	            'phoneCountryCode': '977',
	            'showCountryCodeList': false
	        },
	        'NR': {
	            'status': 'assigned',
	            'phoneCountryCode': '674',
	            'showCountryCodeList': false
	        },
	        'NU': {
	            'status': 'assigned',
	            'phoneCountryCode': '683',
	            'showCountryCodeList': false
	        },
	        'NZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '64',
	            'showCountryCodeList': false
	        },
	        'OM': {
	            'status': 'assigned',
	            'phoneCountryCode': '968',
	            'showCountryCodeList': false
	        },
	        'PA': {
	            'status': 'assigned',
	            'phoneCountryCode': '507',
	            'showCountryCodeList': false
	        },
	        'PE': {
	            'status': 'assigned',
	            'phoneCountryCode': '51',
	            'showCountryCodeList': false
	        },
	        'PF': {
	            'status': 'assigned',
	            'phoneCountryCode': '689',
	            'showCountryCodeList': false
	        },
	        'PG': {
	            'status': 'assigned',
	            'phoneCountryCode': '675',
	            'showCountryCodeList': false
	        },
	        'PH': {
	            'status': 'assigned',
	            'phoneCountryCode': '63',
	            'showCountryCodeList': false
	        },
	        'PK': {
	            'status': 'assigned',
	            'phoneCountryCode': '92',
	            'showCountryCodeList': false
	        },
	        'PL': {
	            'status': 'assigned',
	            'phoneCountryCode': '48',
	            'showCountryCodeList': true
	        },
	        'PM': {
	            'status': 'assigned',
	            'phoneCountryCode': '508',
	            'showCountryCodeList': false
	        },
	        'PN': {
	            'status': 'assigned',
	            'phoneCountryCode': '870',
	            'showCountryCodeList': false
	        },
	        'PR': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'PS': {
	            'status': 'assigned',
	            'phoneCountryCode': '970',
	            'showCountryCodeList': false
	        },
	        'PT': {
	            'status': 'assigned',
	            'phoneCountryCode': '351',
	            'showCountryCodeList': false
	        },
	        'PW': {
	            'status': 'assigned',
	            'phoneCountryCode': '680',
	            'showCountryCodeList': false
	        },
	        'PY': {
	            'status': 'assigned',
	            'phoneCountryCode': '595',
	            'showCountryCodeList': false
	        },
	        'QA': {
	            'status': 'assigned',
	            'phoneCountryCode': '974',
	            'showCountryCodeList': false
	        },
	        'RE': {
	            'status': 'assigned',
	            'phoneCountryCode': '262',
	            'showCountryCodeList': false
	        },
	        'RO': {
	            'status': 'assigned',
	            'phoneCountryCode': '40',
	            'showCountryCodeList': false
	        },
	        'RS': {
	            'status': 'assigned',
	            'phoneCountryCode': '381',
	            'showCountryCodeList': false
	        },
	        'RU': {
	            'status': 'assigned',
	            'phoneCountryCode': '7',
	            'showCountryCodeList': false
	        },
	        'RW': {
	            'status': 'assigned',
	            'phoneCountryCode': '250',
	            'showCountryCodeList': false
	        },
	        'SA': {
	            'status': 'assigned',
	            'phoneCountryCode': '966',
	            'showCountryCodeList': false
	        },
	        'SB': {
	            'status': 'assigned',
	            'phoneCountryCode': '677',
	            'showCountryCodeList': false
	        },
	        'SC': {
	            'status': 'assigned',
	            'phoneCountryCode': '248',
	            'showCountryCodeList': false
	        },
	        'SD': {
	            'status': 'assigned',
	            'phoneCountryCode': '249',
	            'showCountryCodeList': false
	        },
	        'SE': {
	            'status': 'assigned',
	            'phoneCountryCode': '46',
	            'showCountryCodeList': true
	        },
	        'SG': {
	            'status': 'assigned',
	            'phoneCountryCode': '65',
	            'showCountryCodeList': true
	        },
	        'SH': {
	            'status': 'assigned',
	            'phoneCountryCode': '290',
	            'showCountryCodeList': false
	        },
	        'SI': {
	            'status': 'assigned',
	            'phoneCountryCode': '386',
	            'showCountryCodeList': false
	        },
	        'SJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '47',
	            'showCountryCodeList': false
	        },
	        'SK': {
	            'status': 'assigned',
	            'phoneCountryCode': '421',
	            'showCountryCodeList': false
	        },
	        'SL': {
	            'status': 'assigned',
	            'phoneCountryCode': '232',
	            'showCountryCodeList': false
	        },
	        'SM': {
	            'status': 'assigned',
	            'phoneCountryCode': '378',
	            'showCountryCodeList': false
	        },
	        'SN': {
	            'status': 'assigned',
	            'phoneCountryCode': '221',
	            'showCountryCodeList': false
	        },
	        'SO': {
	            'status': 'assigned',
	            'phoneCountryCode': '252',
	            'showCountryCodeList': false
	        },
	        'SR': {
	            'status': 'assigned',
	            'phoneCountryCode': '597',
	            'showCountryCodeList': false
	        },
	        'SS': {
	            'status': 'assigned',
	            'phoneCountryCode': '211',
	            'showCountryCodeList': false
	        },
	        'ST': {
	            'status': 'assigned',
	            'phoneCountryCode': '239',
	            'showCountryCodeList': false
	        },
	        'SV': {
	            'status': 'assigned',
	            'phoneCountryCode': '503',
	            'showCountryCodeList': false
	        },
	        'SX': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'SY': {
	            'status': 'assigned',
	            'phoneCountryCode': '963',
	            'showCountryCodeList': false
	        },
	        'SZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '268',
	            'showCountryCodeList': false
	        },
	        'TC': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'TD': {
	            'status': 'assigned',
	            'phoneCountryCode': '235',
	            'showCountryCodeList': false
	        },
	        'TF': {
	            'status': 'assigned',
	            'phoneCountryCode': '262',
	            'showCountryCodeList': false
	        },
	        'TG': {
	            'status': 'assigned',
	            'phoneCountryCode': '228',
	            'showCountryCodeList': false
	        },
	        'TH': {
	            'status': 'assigned',
	            'phoneCountryCode': '66',
	            'showCountryCodeList': false
	        },
	        'TJ': {
	            'status': 'assigned',
	            'phoneCountryCode': '992',
	            'showCountryCodeList': false
	        },
	        'TK': {
	            'status': 'assigned',
	            'phoneCountryCode': '690',
	            'showCountryCodeList': false
	        },
	        'TL': {
	            'status': 'assigned',
	            'phoneCountryCode': '670',
	            'showCountryCodeList': false
	        },
	        'TM': {
	            'status': 'assigned',
	            'phoneCountryCode': '993',
	            'showCountryCodeList': false
	        },
	        'TN': {
	            'status': 'assigned',
	            'phoneCountryCode': '216',
	            'showCountryCodeList': false
	        },
	        'TO': {
	            'status': 'assigned',
	            'phoneCountryCode': '676',
	            'showCountryCodeList': false
	        },
	        'TR': {
	            'status': 'assigned',
	            'phoneCountryCode': '90',
	            'showCountryCodeList': true
	        },
	        'TT': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'TV': {
	            'status': 'assigned',
	            'phoneCountryCode': '688',
	            'showCountryCodeList': false
	        },
	        'TW': {
	            'status': 'assigned',
	            'phoneCountryCode': '886',
	            'showCountryCodeList': true
	        },
	        'TZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '255',
	            'showCountryCodeList': false
	        },
	        'UA': {
	            'status': 'assigned',
	            'phoneCountryCode': '380',
	            'showCountryCodeList': false
	        },
	        'UG': {
	            'status': 'assigned',
	            'phoneCountryCode': '256',
	            'showCountryCodeList': false
	        },
	        'UM': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'US': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false,
	            'hideInOtherCountries': true
	        },
	        'UY': {
	            'status': 'assigned',
	            'phoneCountryCode': '598',
	            'showCountryCodeList': false
	        },
	        'UZ': {
	            'status': 'assigned',
	            'phoneCountryCode': '998',
	            'showCountryCodeList': false
	        },
	        'VA': {
	            'status': 'assigned',
	            'phoneCountryCode': '39',
	            'showCountryCodeList': false
	        },
	        'VC': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'VE': {
	            'status': 'assigned',
	            'phoneCountryCode': '58',
	            'showCountryCodeList': false
	        },
	        'VG': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'VI': {
	            'status': 'assigned',
	            'phoneCountryCode': '1',
	            'showCountryCodeList': false
	        },
	        'VN': {
	            'status': 'assigned',
	            'phoneCountryCode': '84',
	            'showCountryCodeList': false
	        },
	        'VU': {
	            'status': 'assigned',
	            'phoneCountryCode': '678',
	            'showCountryCodeList': false
	        },
	        'WF': {
	            'status': 'assigned',
	            'phoneCountryCode': '681',
	            'showCountryCodeList': false
	        },
	        'WS': {
	            'status': 'assigned',
	            'phoneCountryCode': '685',
	            'showCountryCodeList': false
	        },
	        'YE': {
	            'status': 'assigned',
	            'phoneCountryCode': '967',
	            'showCountryCodeList': false
	        },
	        'YT': {
	            'status': 'assigned',
	            'phoneCountryCode': '262',
	            'showCountryCodeList': false
	        },
	        'ZA': {
	            'status': 'assigned',
	            'phoneCountryCode': '27',
	            'showCountryCodeList': false
	        },
	        'ZM': {
	            'status': 'assigned',
	            'phoneCountryCode': '260',
	            'showCountryCodeList': false
	        },
	        'ZW': {
	            'status': 'assigned',
	            'phoneCountryCode': '263',
	            'showCountryCodeList': false
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/directive.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-apply/route.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-signature/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-bml-display.route', ['squid', 'xo-bml-display.directive', 'xo-bml-apply.route', 'xo-bml-terms-and-conditions.route', 'xo-bml-signature.route']).factory('$BMLDisplay', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('BmlDisplay', {
	
	            name: 'bmldisplay',
	            directive: 'xo-bml-display',
	            trackingData: {
	                fptiState: 'ppc_display',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::ppc_display',
	                        'pagename2': '%::ppc_display:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            titleContent: 'applyForBml.bmlApplyHeadline',
	            children: [{
	                name: '$BmlApplyRoute'
	            }, {
	                name: '$BmlTermsAndConditionsRoute'
	            }, {
	                name: '$BmlSignatureRoute'
	            }]
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-credit-components/src/bml-display", "components/xo-credit-components/src/bml-display/route.js"))

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/template.html"), __webpack_require__("./components/xo-models/src/bml/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid, template) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    squid.module('xo-bml-display.directive', ['squid', 'xomodel.bml', 'beaver']).factory('$BMLStateHandler', function ($state, $logger) {
	
	        var APPROVED = 'APPROVED';
	        var SOFT_DECLINED = 'SOFT_DECLINED';
	        var DECLINED = 'DECLINED';
	        var FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER = 'FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER';
	        var NEED_SIGNATURE = 'NEED_SIGNATURE';
	        var PENDING_COMPLETION_STATUS = 'PENDING_COMPLETION_STATUS';
	        var FULL_APPLY_REQUIRED = 'FULL_APPLY_REQUIRED';
	        var UNKNOWN_DECISION = 'UNKNOWN_DECISION';
	        var INELIGIBLE = 'INELIGIBLE'; // TODO; This state is returned by applybml but was not defined in Aries
	        var MAX_SOFT_DECLINES = config.bmlMaxSoftDeclines; // eslint-disable-line block-scoped-var,no-undef
	
	        var BMLStateHandler = function BMLStateHandler(bmlData) {
	            this.reviewUrl = bmlData.reviewUrl;
	            this.bml = bmlData.bml;
	            this.bmlApply = bmlData.bmlApply;
	            this.bmlComplete = bmlData.bmlComplete;
	            this.checkoutSession = bmlData.checkoutSession;
	            this.auth = bmlData.auth;
	            this.purchase = bmlData.purchase;
	            this.patchPhone = bmlData.patchPhone;
	            this.billingAddresses = bmlData.billingAddresses;
	            this.merchant = bmlData.merchant;
	            this.merchantId = bmlData.merchantId;
	
	            this.handlers = {};
	            this.handlers[APPROVED] = this.handleAppStatusApproved;
	            this.handlers[DECLINED] = this.handleAppStatusDeclined;
	            this.handlers[SOFT_DECLINED] = this.handleAppStatusSoftDeclined;
	            this.handlers[FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER] = this.handleAppStatusFundingInsExist;
	            this.handlers[NEED_SIGNATURE] = this.handleAppStatusNeedSignature;
	            this.handlers[PENDING_COMPLETION_STATUS] = this.handleAppStatusPendingCompletion;
	            this.handlers[UNKNOWN_DECISION] = this.handleAppStatusUnknownDecision;
	            this.handlers[FULL_APPLY_REQUIRED] = this.handleAppStatusFullApplyRequired;
	            this.handlers[INELIGIBLE] = this.handleAppStatusIneligible;
	        };
	
	        BMLStateHandler.prototype.payInFullRedirect = function payInFullRedirect(result) {
	            $logger.info('APPLYFORBML_VIEW_OPTOUTBML');
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.termsAndCondition = function termsAndCondition(result) {
	            $state.go('^.bmltermsandconditions');
	        };
	
	        BMLStateHandler.prototype.handleAppStatusIneligible = function handleAppStatusIneligible(result) {
	            $logger.info('APPLYFORBML_INELIGIBLE');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'bmlIneligible'
	            });
	            this.checkoutSession.bmlOffer = false;
	            this.checkoutSession.creditOffer = false;
	            this.checkoutSession.showDeclinePopup = true;
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.handleAppStatusUnknownDecision = function handleAppStatusUnknownDecision(result) {
	            $logger.info('APPLYFORBML_UNKNOWN_DECISION');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'bmlUnknownDecision'
	            });
	            this.checkoutSession.bmlOffer = false;
	            this.checkoutSession.creditOffer = false;
	            this.checkoutSession.showDeclinePopup = true;
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.handleAppStatusApproved = function handleAppStatusApproved(result) {
	            $logger.info('APPLYFORBML_ACTION_BMLSUCCESS');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'bmlSuccess'
	            });
	            this.checkoutSession.fundingOptions.action('update', {
	                resultModel: this.checkoutSession,
	                data: {
	                    planId: this.bml.financial_instrument_id
	                },
	                success: $.proxy(function (successResult) {
	                    $state.go(this.reviewUrl);
	                }, this),
	                contingencies: {
	                    DEFAULT: function DEFAULT(name) {
	                        $state.go(this.reviewUrl);
	                    }
	                }
	            });
	        };
	
	        BMLStateHandler.prototype.handleAppStatusPendingCompletion = function handleAppStatusPendingCompletion(result) {
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'completeBmlApply'
	            });
	            this.completeApplication(result.application_id);
	        };
	
	        BMLStateHandler.prototype.handleAppStatusNeedSignature = function handleAppStatusNeedSignature(result) {
	            $logger.info('APPLYFORBML_NEED_SIGNATURE');
	            this.bml.application_id = result.application_id;
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'needSignature'
	            });
	            $state.go('^.bmlsignature');
	        };
	
	        BMLStateHandler.prototype.handleAppStatusDeclined = function handleAppStatusDeclined(result) {
	
	            $logger.info('APPLYFORBML_ACTION_BMLDECLINEHARD');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'creditDeclineHard'
	            });
	            this.bml.application_status = 'DECLINED';
	            this.checkoutSession.bmlOffer = false;
	            this.checkoutSession.creditOffer = false;
	            this.checkoutSession.showDeclinePopup = true;
	
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.handleAppStatusSoftDeclined = function handleAppStatusSoftDeclined(result) {
	
	            this.bml.bmlSoftDeclineCtr = (this.bml.bmlSoftDeclineCtr || 0) + 1;
	            if (this.bml.bmlSoftDeclineCtr < MAX_SOFT_DECLINES) {
	                $logger.info('APPLYFORBML_ACTION_BMLDECLINESOFT');
	                $state.go('^.bmlapply');
	            } else {
	                $logger.info('checkout_fpti', {
	                    'ppc_status': 'bmlMaxAttempts'
	                });
	                $logger.info('APPLYFORBML_ACTION_BMLMAXATTEMPTS');
	                this.bml.application_status = 'DECLINED';
	                this.checkoutSession.bmlOffer = false;
	                this.checkoutSession.creditOffer = false;
	                this.checkoutSession.showDeclinePopup = true;
	
	                $state.go(this.reviewUrl);
	            }
	        };
	
	        BMLStateHandler.prototype.handleAppStatusFundingInsExist = function handleAppStatusFundingInsExist(result) {
	            $logger.info('APPLYFORBML_ACTION_BMLDECLINELINKEDTODIFFMEMBER');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'bmlDeclineLinkedToDiffMember'
	            });
	            this.checkoutSession.bmlOffer = false;
	            this.checkoutSession.creditOffer = false;
	            this.checkoutSession.showDeclinePopup = true;
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.handleAppStatusFullApplyRequired = function handleAppStatusFullApplyRequired(result) {
	            $logger.info('APPLYFORBML_FULLAPPLYREQUIRED');
	            $logger.info('checkout_fpti', {
	                'ppc_status': 'fullApplyRequired'
	            });
	            this.checkoutSession.bmlOffer = false;
	            this.checkoutSession.creditOffer = false;
	            this.bml.fullApplyRequired = true;
	            this.checkoutSession.showDeclinePopup = true;
	
	            $state.go(this.reviewUrl);
	        };
	
	        BMLStateHandler.prototype.handleBmlTransitions = function handleBmlTransitions(result) {
	            var handler = this.handlers[result.application_status];
	            if (!handler) {
	                throw new Error('no registered handler for bml transition for application status ' + result.application_status);
	            }
	            return $.proxy(handler, this, result)();
	        };
	
	        BMLStateHandler.prototype.completeApplication = function completeApplication(application_id) {
	
	            this.bmlComplete.application_id = application_id;
	            this.bmlComplete.action('complete', {
	
	                success: $.proxy(function (result) {
	                    $logger.info('COMPLETEBMLAPPLY_ACTION_BMLSUCCESS');
	                    var bml = this.bml;
	
	                    // Update the application_status & financial_instrument_id in bml model
	                    bml.setProperties({
	                        financial_instrument_id: result.financial_instrument_id,
	                        application_status: result.application_status
	                    });
	
	                    if (bml.phoneChanged && result && result.user_info && result.user_info.phones && result.user_info.phones.length > 0 && result.user_info.phones[0].id) {
	
	                        var newPhoneVO = {
	                            op: 'add',
	                            path: '/payer_info',
	                            value: {
	                                phone: this.bmlApply.personalInformation.phone.telephone
	                            }
	                        };
	                        this.patchPhone.save({
	                            data: {
	                                patch: newPhoneVO
	                            },
	                            success: $.proxy(function () {
	                                delete bml.phoneChanged;
	                                this.handleBmlTransitions(result);
	                            }, this),
	                            contingencies: {
	                                DEFAULT: $.proxy(function handleContingency(name, contingency) {
	                                    $logger.info('BMLPATCHPHONE_CONTINGENCY', name);
	                                    this.handleBmlTransitions(result);
	                                }, this)
	                            }
	                        });
	                    } else {
	                        this.handleBmlTransitions(result);
	                    }
	                }, this)
	            });
	        };
	
	        BMLStateHandler.prototype.getDefaultBillingAddress = function getDefaultBillingAddress(billingAddresses) {
	            var defaultBillingAddress = billingAddresses && billingAddresses.addresses;
	            defaultBillingAddress = defaultBillingAddress.map(function (address, index, array) {
	                if (address && address['default'] === true) {
	                    return address;
	                }
	            });
	
	            defaultBillingAddress = defaultBillingAddress.length > 0 && defaultBillingAddress[0];
	            return defaultBillingAddress;
	        };
	
	        BMLStateHandler.prototype.applyBML = function applyBML() {
	
	            var defaultBillingAddress = this.getDefaultBillingAddress(this.billingAddresses);
	
	            this.bml.action('apply', {
	                data: {
	                    flow: {
	                        nape: this.bml.nape,
	                        fullApplyRequired: this.bml.fullApplyRequired
	                    },
	                    payer: {
	                        email: this.checkoutSession.payer.email,
	                        id: this.checkoutSession.payer.id,
	                        phone: this.bmlApply.personalInformation.phone.telephone,
	                        phone_type: this.bmlApply.personalInformation.phone.phoneType
	                    },
	                    billing_address: {
	                        line1: defaultBillingAddress.line1,
	                        line2: defaultBillingAddress.line2,
	                        city: defaultBillingAddress.city,
	                        state: defaultBillingAddress.state,
	                        postal_code: defaultBillingAddress.postal_code,
	                        country: defaultBillingAddress.country,
	                        id: defaultBillingAddress.id
	                    },
	                    payment_info: {
	                        total_transaction_amount: {
	                            value: this.purchase.amounts.total.amount,
	                            currency: this.purchase.amounts.total.currency_code
	                        },
	                        recipient: {
	                            id: this.merchantId,
	                            total_amount: {
	                                value: this.purchase.amounts.total.amount,
	                                currency: this.purchase.amounts.total.currency_code
	                            },
	                            business_name: this.merchant.brand_name,
	                            type: 'PAYPAL_CORE',
	                            multi_seller_indicator: false,
	                            country_code: this.merchant.merchant_country
	                        },
	                        shipping_address: {
	                            id: this.checkoutSession.shipping.id,
	                            name: this.checkoutSession.shipping.name,
	                            line1: this.checkoutSession.shipping.line1,
	                            line2: this.checkoutSession.shipping.line2,
	                            city: this.checkoutSession.shipping.city,
	                            state: this.checkoutSession.shipping.state,
	                            country_code: this.checkoutSession.shipping.country,
	                            postal_code: this.checkoutSession.shipping.postal_code,
	                            'default': this.checkoutSession.shipping['default']
	                        },
	                        name: {
	                            first_name: this.auth.first_name,
	                            last_name: this.auth.last_name
	                        },
	                        item_info: this.purchase.items
	                    },
	                    dobSsn: {
	                        dobMonth: this.bmlApply.personalInformation.month,
	                        dobDay: this.bmlApply.personalInformation.day,
	                        dobYear: this.bmlApply.personalInformation.year,
	                        nationalId: this.bmlApply.personalInformation.natId
	                    }
	                },
	
	                resultModel: this.bml,
	
	                success: $.proxy(function (result) {
	                    this.handleBmlTransitions(result);
	                }, this),
	
	                contingencies: {
	                    DEFAULT: $.proxy(function handleContingency(name, contingency) {
	                        this.bml.contingency = name;
	                        this.checkoutSession.bmlOffer = false;
	                        this.checkoutSession.creditOffer = false;
	                        this.checkoutSession.showDeclinePopup = true;
	                        $state.go(this.reviewUrl);
	                    }, this)
	                }
	            });
	        };
	
	        return BMLStateHandler;
	    }).directive('xoBmlDisplay', function () {
	        return {
	            template: template,
	            scope: {
	                reviewUrl: '='
	            },
	
	            controller: function controller($scope, $state, $rootScope, $BMLModel, $ApplyForBMLModel, $BMLApplicationModel, $stateParams) {
	
	                if (!$rootScope.bml && !$rootScope.bmlApply) {
	                    $scope.bml = new $BMLModel();
	                    $scope.bmlApply = new $ApplyForBMLModel();
	                } else {
	                    $scope.bml = $rootScope.bml;
	                    $scope.bmlApply = $rootScope.bmlApply;
	                }
	                $scope.bmlComplete = new $BMLApplicationModel();
	
	                $state.go('^.bmlapply');
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-credit-components/src/bml-display", "components/xo-credit-components/src/bml-display/directive.js", __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/template.html":
/***/ function(module, exports) {

	module.exports = "<div ui-view>\n</div>\n"

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-apply/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-apply/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-bml-apply.route', ['squid', 'xo-bml-apply.directive']).factory('$BmlApplyRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('BmlApplyRoute', {
	
	            name: 'bmlapply',
	            trackingData: {
	                fptiState: 'ppc_apply',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::ppc_apply',
	                        'pagename2': '%::ppc_apply:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            directive: 'xo-bml-apply-page',
	            titleContent: 'applyForBml.bmlApplyHeadline',
	
	            children: []
	
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-credit-components/src/bml-display/xo-bml-apply", "components/xo-credit-components/src/bml-display/xo-bml-apply/route.js"))

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-apply/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-apply/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-form-components/src/phone/phoneInput/directive.js"), __webpack_require__("./components/xo-form-components/src/dob-nationalid/directive.js"), __webpack_require__("./components/xo-ui-components/src/tooltip/directive.js"), __webpack_require__("./components/xo-address-components/src/add-address/directive.js"), __webpack_require__("./components/xo-models/src/bml/index.js"), __webpack_require__("./components/xo-models/src/address/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/credit/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-bml-apply.directive', ['squid', 'xomodel.checkout', 'xo-title.directive', 'xo-message.directive', 'xo-address-display.directive', 'xo-phone.phoneInput', 'xo-dob-nationalid.directive', 'xo-tooltip.directive', 'xo-add-address.directive', 'xomodel.bml', 'xomodel.address', 'xomodel.user', 'xomodel.fi', 'xomodel.auth', 'beaver']).directive('xoBmlApplyPage', function () {
	
	        return {
	
	            template: template,
	
	            controller: function controller($scope, $rootScope, $state, $locale, $populate, $BillingAddressModel, $BillingAddressesModel, $AuthModel, $ValidateAddressModel, $element, $ValidatePhoneModel, $CheckoutSessionModel, $CheckoutAppDataModel, $BMLStateHandler, $CheckoutCartModel, $CheckoutPayeeModel, $CreditInstallmentModel, $logger, $PatchPhoneModel) {
	
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    payee: $CheckoutPayeeModel.instance($rootScope.token),
	                    billingAddresses: $BillingAddressesModel.instance(),
	                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
	                    checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                    creditOptions: $CreditInstallmentModel.instance($rootScope.token)
	                }).then(function () {
	                    var defaultBillingAddress = $scope.billingAddresses && $scope.billingAddresses.addresses;
	                    defaultBillingAddress = defaultBillingAddress.map(function (address, index, array) {
	                        if (address && address['default'] === true) {
	                            return address;
	                        }
	                    });
	
	                    defaultBillingAddress = defaultBillingAddress.length > 0 && defaultBillingAddress[0];
	                    if (defaultBillingAddress) {
	                        $scope.bml.action('napeLookUp', {
	
	                            data: {
	                                payer: $scope.checkoutSession.payer,
	                                billing_address: {
	                                    country: defaultBillingAddress.country,
	                                    line1: defaultBillingAddress.line1,
	                                    line2: defaultBillingAddress.line2,
	                                    city: defaultBillingAddress.city,
	                                    state: defaultBillingAddress.state,
	                                    postal_code: defaultBillingAddress.postal_code
	                                }
	                            },
	
	                            success: function success(result) {
	                                if (result && result.account_exists === true) {
	                                    $scope.bml.nape = 'napePotential';
	                                    $scope.bml.fullApplyRequired = false;
	                                }
	                            },
	                            contingencies: {
	                                DEFAULT: function DEFAULT() {
	                                    // add a log here
	                                }
	                            }
	                        });
	                    }
	
	                    if ($scope.billingAddresses && $scope.billingAddresses.addresses && $scope.billingAddresses.addresses.length > 0) {
	                        $scope.billingAddresses.addresses.forEach(function (address) {
	                            if (address['default']) {
	                                $scope.address = billingAddressObject(address);
	                                $scope.previousDefaultBillingAddress = address;
	                            }
	                        });
	                    }
	
	                    var bmlData = {
	                        reviewUrl: $scope.$parent.reviewUrl,
	                        bml: $scope.$parent.bml,
	                        bmlApply: $scope.$parent.bmlApply,
	                        bmlComplete: $scope.$parent.bmlComplete,
	                        checkoutSession: $scope.checkoutSession,
	                        auth: $scope.auth,
	                        purchase: $scope.checkoutCart.purchase,
	                        patchPhone: $scope.patchPhoneModel,
	                        billingAddresses: $scope.billingAddresses,
	                        merchant: $scope.checkoutAppData.merchant,
	                        merchantId: $scope.payee.merchant.id
	                    };
	
	                    $scope.bmlStateHandler = new $BMLStateHandler(bmlData);
	
	                    if ($scope.checkoutSession.payer) {
	                        $scope.bmlApply.personalInformation.phone.telephone = $scope.checkoutSession.payer.phone;
	                        $scope.bmlApply.personalInformation.phone.phoneType = 'MOBILE';
	                        // Set mobile as default to prevent unknown type.
	                    } else {
	                        $scope.bmlFlags.PhoneAdd = true;
	                    }
	                });
	
	                var $el = $($element);
	
	                $scope.showPhone = function () {
	                    return $scope.checkoutSession.payer.phone && $scope.checkoutSession.payer.phone_type === 'WORK';
	                };
	                $scope.patchPhoneModel = new $PatchPhoneModel();
	                $scope.patchPhoneModel.token = $scope.token;
	
	                $scope.init = function () {
	                    $scope.checkoutSession.message = null;
	
	                    $scope.previousDefaultBillingAddress = {};
	                    $scope.bmlFlags = {};
	                    $scope.address = {};
	                    $scope.token = $rootScope.token;
	                    $scope.countryCode = $locale.country;
	                    $scope.validateAddress = new $ValidateAddressModel();
	                    $scope.validatePhoneModel = new $ValidatePhoneModel();
	                    $scope.validatePhoneModel.token = $scope.token;
	
	                    $scope.bmlFlags.billingAddressUpdated = false;
	                    $scope.bmlFlags.AddressAdd = false;
	                    $scope.bmlFlags.AddressDisplay = true;
	                    $scope.bmlFlags.PhoneAdd = false;
	                    $scope.bmlFlags.ChangeLink = true;
	                    $scope.billingAddressUpdated = false;
	
	                    $('.paypalHeaderWrapper').addClass('paypalCredit');
	                    $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
	                    $('.paypalHeader').addClass('span14');
	                    $('.paypalHeader').removeClass('span24');
	
	                    if ($scope.bml && $scope.bml.application_status === 'SOFT_DECLINED') {
	                        $scope.checkoutSession.message = {
	                            type: 'warning',
	                            msgKeys: ['applyForBml.bmlDeclineSoft']
	                        };
	                    }
	                    $logger.info('APPLYFORBML_VIEW_RENDER');
	                };
	
	                $scope.redirectToReview = function () {
	                    $scope.bmlStateHandler.payInFullRedirect();
	                };
	
	                $scope.onContinue = function () {
	                    if ($scope.validateLegalAge()) {
	                        if ($scope.bmlFlags.billingAddressUpdated) {
	                            $scope.validateBillingAddress();
	                        } else {
	                            triggerNextState();
	                        }
	                    }
	                };
	
	                $scope.validateLegalAge = function () {
	                    var dobMonth = $scope.bmlApply.personalInformation.month,
	                        dobDay = $scope.bmlApply.personalInformation.day,
	                        dobYear = $scope.bmlApply.personalInformation.year,
	                        currentDate = new Date(),
	                        currentMonth = currentDate.getMonth() + 1,
	                        currentDay = currentDate.getDate(),
	                        currentYear = currentDate.getFullYear(),
	                        largestDOBYear = currentYear - 18; // Legal Age is 18
	
	                    var isLegal = dobYear < largestDOBYear || dobYear === largestDOBYear && dobMonth < currentMonth || // eslint-disable-line no-extra-parens
	                    dobYear === largestDOBYear && dobMonth === currentMonth && dobDay <= currentDay; // eslint-disable-line no-extra-parens
	
	                    if (!isLegal) {
	                        handleDobValidation();
	                    }
	
	                    return isLegal;
	                };
	
	                function handleDobValidation() {
	                    var $fields = $('#dobSelect .dropdown select');
	                    $fields.addClass('backendError');
	                    if (window.scrollTo) {
	                        window.scrollTo(0, 0);
	                    }
	                }
	
	                function triggerNextState() {
	                    $logger.info('APPLYFORBML_VIEW_SUBMIT');
	                    if ($scope.bml.nape === 'napePotential') {
	                        $scope.bmlStateHandler.applyBML();
	                    } else {
	                        $scope.checkoutSession.message = null;
	                        $scope.bmlStateHandler.termsAndCondition();
	                    }
	                }
	
	                $scope.changeAddress = function () {
	
	                    $scope.bmlFlags.billingAddressUpdated = true;
	                    $scope.bml.phoneChanged = true;
	                    $scope.bmlFlags.AddressAdd = true;
	                    $scope.bmlFlags.AddressDisplay = false;
	                    $scope.bmlFlags.PhoneAdd = true;
	                    $scope.bmlFlags.ChangeLink = false;
	                };
	
	                $scope.changePlan = function () {
	                    $state.go('checkout.chooseCreditOffer');
	                };
	
	                $scope.validateBillingAddress = function () {
	                    var newBilling = billingAddressObject($scope.address);
	                    newBilling['default'] = true;
	                    $scope.previousDefaultBillingAddress['default'] = false;
	                    $scope.validatePhoneModel.save({
	                        data: {
	                            telephone: $scope.bmlApply.personalInformation.phone.telephone,
	                            phoneType: $scope.bmlApply.personalInformation.phone.phoneType
	                        },
	                        success: function success(result) {
	
	                            if (result) {
	                                newBilling.save({
	                                    data: $scope.billingAddress,
	
	                                    success: function success() {
	                                        $scope.updateBillingAddress(newBilling);
	                                    },
	
	                                    validation: function validation(res) {
	                                        handleValidation(res);
	                                    }
	                                });
	                            } else {
	                                handlePhoneValidation(result);
	                            }
	                        },
	                        validation: function validation(result) {
	                            handlePhoneValidation(result);
	                        }
	                    });
	                };
	
	                $scope.updateBillingAddress = function (newBillingAddress) {
	                    var addresses = $scope.billingAddresses.addresses;
	                    if (!isUserInputtedAddress(addresses[0])) {
	                        addresses.unshift(newBillingAddress);
	                    } else {
	                        addresses[0] = newBillingAddress;
	                    }
	                    triggerNextState();
	                };
	
	                function isUserInputtedAddress(address) {
	                    return address.id === '0';
	                }
	
	                function handleValidation(res) {
	                    if (res && res.fields && res.fields.length) {
	                        res.fields.forEach(function (field) {
	                            if (field.field) {
	                                var $field = $($el.find('[name="' + field.field + '"]'));
	                                $field.addClass('backendError');
	                            }
	                        });
	                    }
	
	                    $scope.checkoutSession.message = {
	                        type: 'error',
	                        msgKeys: ['genericError.incontextGenericPageError']
	                    };
	
	                    if (window.scrollTo) {
	                        window.scrollTo(0, 0);
	                    }
	                }
	
	                function handlePhoneValidation() {
	                    var $field = $('.telephone');
	                    $field.addClass('backendError');
	                    if (window.scrollTo) {
	                        window.scrollTo(0, 0);
	                    }
	                }
	
	                function billingAddressObject(address) {
	                    return new $BillingAddressModel({
	                        line1: address.line1,
	                        line2: address.line2,
	                        city: address.city,
	                        state: address.state,
	                        postal_code: address.postal_code,
	                        country: $scope.countryCode,
	                        full_address: address.full_address,
	                        id: '0'
	                    });
	                }
	
	                $scope.init();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-apply/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"signupbml\" id=\"signupbml\" content>\n    <xo-title title-txt=\"{{content('signupBml.title')}}\" class=\"accessAid\"></xo-title>\n    <div class=\"row-fluid justMember\">\n        <div class=\"span14 trayInner\">\n\n            <div class=\"title\">\n                <xo-message message=\"checkoutSession.message\"></xo-message>\n            </div>\n\n            <!--Title-->\n            <div id=\"title\">\n                <h2 class=\"beta\">{{ content('applyForBml.bmlApplyHeadlineShort') }}</h2>\n                <p>{{ content('applyForBml.bmlApplyWithPayPal') }}</p>\n            </div>\n\n            <form id=\"userInfoForm\" name=\"userInfoForm\" ng-submit=\"userInfoForm.$valid && onContinue()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n                <!--Installment information-->\n                <div class=\"bmlRow\" ng-if=\"creditOptions.creditType\">\n                    <div class=\"billingAddressRow\">\n                        <h4 class=\"noBottom gamma sameLine\">{{ content('chooseCreditOption.paymentPlan') }}</h4>\n                        <a id=\"changePlanLink\" class=\"changeBillingAddress sameLine\" ng-click=\"changePlan()\">{{ content('common.change') }}</a>\n                    </div>\n\n                    <div class=\"installmentInfo\" ng-if=\"creditOptions.creditType==='INST'\">\n                        <p class=\"billingName\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText1',{term:creditOptions.term, monthlyPayment: creditOptions.monthlyPayment})\"></p>\n                        <p class=\"installmentDescription\" ng-bind-html=\"htmlContent('chooseCreditOption.selectedOfferText2',{apr:creditOptions.apr, interest: creditOptions.totalInterest, totalPayment: creditOptions.totalPayment})\"></p>\n                    </div>\n\n                    <div class=\"installmentInfo\" ng-if=\"creditOptions.creditType==='SAC'\">\n                        <p class=\"billingName\" ng-bind-html=\"htmlContent('applyForBml.bmlSACOfferDetail')\"></p>\n                    </div>\n                </div>\n\n                <!--Personal information-->\n                <div class=\"bmlRow\">\n                    <h4 class=\"piHeight gamma\">{{ content('applyForBml.personalInfo') }}\n                        <a class=\"verifyHelp\" id=\"verifyHelp\"></a>\n\n                        <xo-tooltip trigger=\"#verifyHelp\" show-event=\"click\">\n                            {{ content('applyForBml.ssnToolTip') }}\n                        </xo-tooltip>\n                    </h4>\n\n                    <div class=\"dobNatlIdGroup\">\n                        <xo-dob-nationalid pi=\"bmlApply.personalInformation\"></xo-dob-nationalid>\n                    </div>\n                </div>\n\n\n                <!--Billing Address-->\n                <div class=\"bmlRow\">\n                    <div class=\"billingAddressRow\">\n                        <h4 class=\"noBottom gamma sameLine\">{{ content('applyForBml.bmlApplyBillingAddress') }}</h4>\n                        <a id=\"changeAddressLink\" class=\"changeBillingAddress sameLine\" ng-show=\"bmlFlags.ChangeLink\" ng-click=\"changeAddress()\">{{ content('common.change') }}</a>\n                    </div>\n\n                    <div id=\"bmlGivenName\">\n                        <p class=\"billingName\">{{auth.first_name}}&nbsp{{auth.last_name}}</p>\n                    </div>\n\n                    <div id=\"bmlAddressDisplay\" class=\"billingAddressRow\" ng-show=\"bmlFlags.AddressDisplay\">\n                        <xo-address-display address=address country-code=countryCode></xo-address-display>\n                        <div id=\"bmlBillingPhone\" class=\"bmlBillingPhone adr\">{{bmlApply.personalInformation.phone.telephone}}</div>\n                    </div>\n\n                    <div id=\"bmlAddressAdd\" class=\"bmlMargin\" ng-show=\"bmlFlags.AddressAdd\">\n                        <xo-add-address country=countryCode address=\"address\" token=\"token\"></xo-add-address>\n                    </div>\n\n                    <div id=\"addPhone\" class=\"addPhone\" ng-show=\"bmlFlags.PhoneAdd\">\n                        <xo-phone-input token=\"token\" exclude=\"WORK\" phone=\"bmlApply.personalInformation.phone\"></xo-phone-input>\n                    </div>\n\n                </div>\n\n                <!--Agree and Continue-->\n                <p class=\"bmlSeeTerms\" bind-html-compile=\"htmlContent('applyForBml.bmlApplyESign')\"></p>\n\n                <div class=\"buttons\">\n                    <input type=\"submit\" track-submit='bml_apply' id=\"bmlAgreeAndContinue\" name=\"bmlAgreeAndContinue\"\n                           value=\"{{content('applyForBml.bmlApplyTermsSubmit')}}\" class=\"btn full\" ng-click=\"validated=true\" />\n                </div>\n\n            </form>\n\n            <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                <p class=\"bmlSeeTerms sameLine\">{{ content('applyForBml.notInterestedNoInstallments') }}</p>\n                <p class=\"bmlSeeTerms sameLine payInFullLink\" ng-bind-html=\"htmlContent('applyForBml.payInFull')\"\n                   ng-click=\"redirectToReview()\"></p>\n            </div>\n\n            <div id=\"bmlLender\">\n                <p class=\"bmlSeeTerms\">{{ content('base.bmlLender') }}</p>\n            </div>\n\n        </div>\n\n        <div class=\"span10 trayInner\" id=\"bmlApplyEdu\">\n            <h2 class=\"gamma\">{{ content('applyForBml.bmlApplyEduTitle') }}</h2>\n            <ul>\n                <li>{{ content('applyForBml.bmlApplyEduBullet1') }}</li>\n                <li>{{ content('applyForBml.bmlApplyEduBullet2') }}</li>\n                <li>{{ content('applyForBml.bmlApplyEduBullet3') }}</li>\n            </ul>\n            <p>{{ content('applyForBml.bmlApplyInterestTerms') }}</p>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ },

/***/ "./components/xo-form-components/src/dob-nationalid/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-form-components/src/dob-nationalid/template.html"), __webpack_require__("./components/xo-ui-components/src/tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-dob-nationalid.directive', ['squid', 'xo-tooltip.directive']).directive('xoDobNationalid', function () {
	        var padNumber = function padNumber(num) {
	            return num.toString().replace(/^(\d)$/, '0$1');
	        };
	        /**
	         * Create an array from a start and end number.
	         * @param  {Number} start
	         * @param  {Number} end
	         * @return {Array}
	         */
	        var getRange = function getRange(start, end) {
	            var arr = [];
	            // decide how this array shall be sorted
	            if (start < end) {
	                for (; start <= end; start++) {
	                    arr.push(padNumber(start));
	                }
	            } else {
	                for (; start >= end; start--) {
	                    arr.push(padNumber(start));
	                }
	            }
	            return arr;
	        };
	
	        return {
	            template: template,
	            scope: {
	                pi: '='
	            },
	
	            controller: function controller($scope) {
	
	                $scope.init = function () {
	                    var thisYear = new Date().getFullYear();
	                    $scope.days = getRange(1, 31);
	                    $scope.months = getRange(1, 12);
	                    $scope.years = getRange(thisYear - 18, thisYear - 110);
	                };
	                $scope.init();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-form-components/src/dob-nationalid/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"dobNationalId\" class=\"dobNatlIdGroup fieldGroup clearfix\" content>\n\n    <div id=\"dobSelect\" class=\"dob bankField restricted\">\n        <fieldset>\n            <legend class=\"fieldLegend\" for=\"dob\">{{content('applyForBml.bmlApplyDateOfBirth')}}</legend>\n\n            <div class=\"dropdown fidobMonth inputField\" floating-label-dropdown>\n                <select xo-dropdown name=\"dobMonth\" ng-model=\"pi.month\" id=\"dobMonth\" aria-label=\"{{content('applyForBml.bmlApplyMonth')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyMM')}}</option>\n                    <option ng-repeat=\"month in months\" value=\"{{month}}\" ng-selected=\"pi.month==='{{month}}'\">{{month}}</option>\n                </select>\n                <label for=\"dobMonth\">\n                    {{content('applyForBml.bmlApplyMM')}}\n                </label>\n            </div>\n\n            <div class=\"dropdown fidobDay inputField\" floating-label-dropdown>\n                <select xo-dropdown name=\"dobDay\" ng-model=\"pi.day\" id=\"dobDay\" aria-label=\"{{content('applyForBml.bmlApplyDay')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyDD')}}</option>\n                    <option ng-repeat=\"day in days\" value=\"{{day}}\" ng-selected=\"pi.day==='{{day}}'\">{{day}}</option>\n                </select>\n                <label for=\"dobDay\">\n                    {{content('applyForBml.bmlApplyDD')}}\n                </label>\n            </div>\n\n            <div class=\"dropdown fidobYear inputField\" floating-label-dropdown>\n                <select xo-dropdown name=\"dobYear\" ng-model=\"pi.year\" id=\"dobYear\" aria-label=\"{{content('applyForBml.bmlApplyYear')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyYYYY')}}</option>\n                    <option ng-repeat=\"year in years\" value=\"{{year}}\" ng-selected=\"pi.year==='{{year}}'\">{{year}}</option>\n                </select>\n                <label for=\"dobYear\">\n                    {{content('applyForBml.bmlApplyYYYY')}}\n                </label>\n            </div>\n\n        </fieldset>\n    </div>\n\n    <div class=\"inputField confidential nationalId\" floating-label>\n        <input ng-model=\"pi.natId\" name=\"nationalId\" id=\"nationalId\" value=\"\" pattern=\"\\d{4}\" maxlength=\"4\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" placeholder=\"{{ content('applyForBml.lastFour') }}\" xo-error-tooltip required />\n        <label for=\"nationalId\">{{ content('applyForBml.bmlApplyLast4SSN') }}</label>\n        <xo-tooltip trigger=\"#nationalId\" show-event=\"click\">\n            {{ content('applyForBml.bmlApplyToolTipSSN') }}\n        </xo-tooltip>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-bml-terms-and-conditions.route', ['squid', 'xo-bml-terms-and-conditions.directive']).factory('$BmlTermsAndConditionsRoute', function ($ComponentRoute) {
	
	        return $ComponentRoute.extend('BmlTermsAndConditionsRoute', {
	
	            name: 'bmltermsandconditions',
	            trackingData: {
	                fptiState: 'ppc_termsandconditions',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::ppc_termsandconditions',
	                        'pagename2': '%::ppc_termsandconditions:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            directive: 'xo-bml-terms-and-conditions-page',
	            titleContent: 'applyForBml.bmlApplyHeadline',
	
	            children: []
	
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions", "components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js"))

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-models/src/fi/index.js"), __webpack_require__("./components/xo-models/src/bml/index.js"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/user/index.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-bml-terms-and-conditions.directive', ['squid', 'xomodel.checkout', 'xo-title.directive', 'xo-message.directive', 'xomodel.checkout', 'xomodel.fi', 'xomodel.bml', 'xomodel.auth', 'xomodel.user', 'xo-device-info', 'beaver']).directive('xoBmlTermsAndConditionsPage', function () {
	
	        var linkFn = function linkFn(scope, element, attrs) {
	            var $agreeButton = $('#bmlAgreeToTerms');
	
	            var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent',
	                eventer = window[eventMethod],
	                data,
	                messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
	
	            // Browsers that support postMessage
	            if (window.postMessage) {
	                /**
	                 * Event to listen for post messages sent from PayPal popup window.
	                 * Data from PayPal will contains return url and the localised content.
	                 */
	                eventer(messageEvent, function (event) {
	                    data = angular.fromJson(event.data);
	                    if (data.action === 'scroll') {
	
	                        if (data.toEnd && !scope.isMobile) {
	                            scope.scrollComplete();
	                        }
	                    } else if (data.action === 'setHeight' && scope.isMobile) {
	                        $('.bmlTermsBody iframe').css('height', data.height + 20 + 'px');
	                    }
	                }, false);
	            }
	
	            $agreeButton.click(function (event) {
	                event.preventDefault();
	                scope.handleAgreeToTermsClick();
	            });
	        };
	
	        return {
	            template: template,
	            link: linkFn,
	
	            controller: function controller($scope, $populate, $rootScope, $state, $CheckoutPayeeModel, $BillingAddressesModel, $CheckoutCartModel, $CheckoutSessionModel, $AuthModel, $CheckoutAppDataModel, $BMLApplicationModel, $BMLStateHandler, $PatchPhoneModel, $DeviceInfo, $logger) {
	
	                if ($scope.$parent && $scope.$parent.bml) {
	                    $scope.bml = $scope.$parent.bml;
	                    $scope.bmlApply = $scope.$parent.bmlApply;
	                    $scope.bmlComplete = $scope.$parent.bmlComplete;
	                }
	                $populate($scope, {
	                    auth: $AuthModel.instance(),
	                    payee: $CheckoutPayeeModel.instance($rootScope.token),
	                    billingAddresses: $BillingAddressesModel.instance(),
	                    checkoutCart: $CheckoutCartModel.instance($rootScope.token),
	                    checkoutSession: $CheckoutSessionModel.instance($rootScope.token),
	                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
	                }).then(function () {
	                    $scope.patchPhoneModel = new $PatchPhoneModel();
	                    $scope.patchPhoneModel.token = $scope.token;
	
	                    if ($scope.$parent && $scope.$parent.bml) {
	                        var bmlData = {
	                            reviewUrl: $scope.$parent.reviewUrl,
	                            bml: $scope.bml,
	                            bmlApply: $scope.bmlApply,
	                            bmlComplete: $scope.bmlComplete,
	                            checkoutSession: $scope.checkoutSession,
	                            auth: $scope.auth,
	                            purchase: $scope.checkoutCart.purchase,
	                            patchPhone: $scope.patchPhoneModel,
	                            billingAddresses: $scope.billingAddresses,
	                            merchant: $scope.checkoutAppData.merchant,
	                            merchantId: $scope.payee.merchant.id
	                        };
	
	                        $scope.bmlStateHandler = new $BMLStateHandler(bmlData);
	                    }
	                });
	
	                $scope.init = function () {
	                    $scope.token = $rootScope.token;
	                    $('.paypalHeaderWrapper').addClass('paypalCreditTnc');
	                    $('.paypalHeader').removeClass('span14');
	                    $('.paypalHeader').addClass('span24');
	                    $('.paypalHeader').addClass('headerBar');
	                    $('.footerWrapper').addClass('hide');
	                    $scope.isMobile = $DeviceInfo.isMobile();
	                    $scope.isMiniBrowser = $rootScope.miniBrowser;
	                    $scope.bmlFlags = {
	                        bmlFooterShow: true,
	                        full: true,
	                        xoFooter: true,
	                        enableFooter: true,
	                        showConfirmationModal: false,
	                        showModalBackdrop: true
	                    };
	
	                    if (window.scrollTo) {
	                        window.scrollTo(0, 0);
	                    }
	                    $logger.info('TERMSNCONDITIONS_VIEW_RENDER');
	                };
	
	                $scope.handleAgreeToTermsClick = function () {
	                    this.showConfirmationModal();
	                    $logger.info('bmlAgreeToTerms', {});
	                };
	
	                $scope.showConfirmationModal = function (show) {
	                    show = angular.isUndefined(show) ? true : show;
	                    $scope.bmlFlags.showConfirmationModal = show;
	                };
	
	                $scope.agreeToTermsConfirmation = function (event) {
	                    event.preventDefault();
	
	                    $logger.info('bmlConfirmAgreeToTermsPopup', {});
	                    this.showConfirmationModal(false);
	                    this.onContinue();
	                };
	
	                $scope.cancelApplication = function (event) {
	                    event.preventDefault();
	                    $logger.info('bmlCancelApplication', {});
	                    $scope.bmlStateHandler.payInFullRedirect();
	                };
	
	                // when the esc key is pressed
	                $('html').on('keyup', function (ev) {
	                    if (ev.which === 27) {
	                        $scope.showConfirmationModal(false);
	                    }
	                });
	
	                $scope.onContinue = function () {
	                    $logger.info('BMLTERMSNCONDITIONS_VIEW_SUBMIT');
	                    $scope.bmlStateHandler.applyBML();
	                };
	
	                $scope.init();
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"bmlTermsAndConditions\" id=\"bmlTermsAndConditions\" content>\n\n    <div ng-show=\"bmlFlags.showConfirmationModal\" id=\"creditConfirmation\" class=\"modal bmlModal\" role=\"alertdialog\" tabindex=\"-1\">\n\n        <div ng-show=\"bmlFlags.showModalBackdrop\" class=\"modal-backdrop\"></div>\n\n        <div class=\"modal-wrap\">\n\n            <div class=\"paypalHeaderWrapper paypalCredit\">\n                <div class=\"logo\">\n                    <span class=\"accessAid\">{{content('applyForBml.payPalCredit')}}</span>\n                </div>\n                <a class=\"close\" href=\"#\" ng-click=\"showConfirmationModal(false)\">\n                    {{content('applyForBml.close')}}\n                </a>\n            </div>\n\n            <div class=\"confirmationPopupContent\">\n                <h2>{{content('applyForBml.justToConfirm')}}</h2>\n                <ul>\n                    <li>\n                        {{content('applyForBml.confirmationPopupListItem1')}}\n                    </li>\n                    <li>\n                        {{content('applyForBml.confirmationPopupListItem2', { email: auth.email })}}\n                    </li>\n                </ul>\n                <form id=\"confirmAgreeToTerms\">\n                    <input ng-click=\"agreeToTermsConfirmation($event)\" id=\"confirmAgreeToTermsSubmit\"\n                        class=\"btn btn-submit full\" type=\"submit\" value=\"{{content('applyForBml.agreeApply')}}\">\n                </form>\n            </div>\n            <div class=\"cancelApplicationBlock\">\n                <a ng-click=\"cancelApplication($event)\" id=\"cancelCreditApplication\" href=\"#\">\n                    {{content('applyForBml.cancelApplication')}}\n                </a>\n            </div>\n        </div>\n    </div>\n\n\n    <xo-title title-txt=\"{{content('signupBml.title')}}\" class=\"accessAid\"></xo-title>\n    <div class=\"row-fluid justMember\">\n        <div class=\"trayInner\">\n            <xo-message message=\"checkoutSession.message\"></xo-message>\n\n            <div class=\"bmlTermsHeader\">\n                <h2 class=\"gamma zeta bmlTermsHead\">{{ content('applyForBml.agreementTermsTitle') }}</h2>\n                <p class=\"printContent\">\n                    <a href=\"https://www.paypalobjects.com/webstatic/checkout/hermes/html/PayPalCreditTerms_print.html\" xo-popup class=popup target=\"_blank\">\n                       <span ng-if= \"!isMobile\" >{{ content('applyForBml.printCopy') }} </span>\n                        <span ng-if=\"isMobile\">{{ content('applyForBml.download') }}</span>\n                    </a>\n                </p>\n            </div>\n\n            <div class=\"span24 trayInner\">\n\n                <div class=\"bmlTermsInnerWrap\">\n                    <div class=\"bmlTermsBody\" tabindex=\"-1\">\n                        <iframe id= \"tncFrame\" src=\"https://www.paypalobjects.com/webstatic/checkout/hermes/html/PayPalCreditTerms_v2.html\"></iframe>\n                   </div>\n                </div>\n\n                <div class=\"bmlTermsFooter buttons\"\n                     ng-class=\"{'bmlTermsFooter buttons bmlFooterShow': bmlFlags.bmlFooterShow ,\n                                'bmlTermsFooter buttons enabled' : bmlFlags.enableFooter,\n                                'bmlTermsFooter buttons': !bmlFlags.bmlFooterShow || !bmlFlags.enableFooter}\">\n                    <div class=\"proceed\">\n                        <button id=\"bmlAgreeToTerms\" track-submit='ppc_agree_terms' class=\"btn bmlAgreeToTerms\"\n                                name=\"bmlAgreeApply\">{{content('applyForBml.agreeApply')}}</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-signature/route.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("./components/xo-credit-components/src/bml-display/xo-bml-signature/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, squid) {
	
	    (function exportProviders(angular) {
	        angular && angular.exportProviders(module, exports, __dirname, __filename);
	    })(window.angular);
	
	    angular.module('xo-bml-signature.route', ['squid', 'xo-bml-signature.directive']).factory('$BmlSignatureRoute', function ($ComponentRoute) {
	        return $ComponentRoute.extend('BmlSignatureRoute', {
	
	            name: 'bmlsignature',
	            trackingData: {
	                fptiState: 'ppc_signature',
	                buzname: {
	                    'fullpage': {
	                        'pagename': '%::ppc_signature',
	                        'pagename2': '%::ppc_signature:member:hermes:',
	                        'version': 'member:%:'
	                    }
	                }
	            },
	            titleContent: 'consumerCreditInfo.applicationApprovedMessage',
	            directive: 'xo-bml-signature-page',
	
	            children: []
	
	        });
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "components/xo-credit-components/src/bml-display/xo-bml-signature", "components/xo-credit-components/src/bml-display/xo-bml-signature/route.js"))

/***/ },

/***/ "./components/xo-credit-components/src/bml-display/xo-bml-signature/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-signature/template.html"), __webpack_require__("./components/xo-models/src/bml/index.js"), __webpack_require__("./components/xo-page-components/src/value-props/directive.js"), __webpack_require__("./components/xo-title/dist/directive.js"), __webpack_require__("./components/xo-ui-components/src/message/directive.js"), __webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-bml-signature.directive', ['squid', 'xomodel.bml', 'xo-value-props.directive', 'xo-title.directive', 'xo-message.directive', 'xo-error-tooltip.directive']).directive('xoBmlSignaturePage', function () {
	
	        return {
	            template: template,
	
	            controller: function controller($scope, $AuthModel, $populate, $state, $rootScope, $BMLApplicationModel) {
	                $populate($scope, {
	                    auth: $AuthModel.instance()
	                }).then(function () {
	
	                    $scope.init = function () {
	                        $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
	                        $('.paypalHeaderWrapper').addClass('paypalCredit');
	                        $('.paypalHeader').removeClass('span14');
	                        $('.paypalHeader').addClass('span24');
	                        $('.paypalHeader').addClass('headerBar');
	                        $scope.token = $rootScope.token;
	                        $scope.bmlSign = new $BMLApplicationModel();
	                    };
	
	                    $scope.onSubmit = function () {
	                        var application_id = $scope.bml.application_id;
	                        $scope.bmlSign.application_id = application_id;
	                        $scope.bmlSign.action('sign', {
	
	                            resultModel: $scope.bml,
	
	                            success: function success(result) {
	                                $state.go('checkout.review');
	                            }
	                        });
	                    };
	
	                    $scope.redirectToReview = function () {
	                        $state.go('checkout.review');
	                    };
	
	                    $scope.init();
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/xo-bml-signature/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"bmlSignature\" id=\"bmlSignature\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <xo-title title-txt=\"{{content('consumerCreditInfo.applicationApprovedMessage')}}\"></xo-title>\n            <form name=\"bmlSignatureForm\" class=\"proceed\" content novalidate=\"novalidate\" autocomplete=\"off\" ng-submit=\"bmlSignatureForm.$valid && onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n                <p class=\"content\">{{content('consumerCreditInfo.reviewSecciMessage')}}</p>\n\n                <div class=\"agree checkbox legal\" ng-class=\"{error: validated && !bmlSignatureForm.$valid}\">\n                    <input ng-model=\"fields.agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" data-error-text=\"{{content('eConsent.eConsentError')}}\" xo-error-tooltip xo-validation='{\n                        \"validator\": \"isChecked\",\n                        \"options\": {\n                            \"el\": \"#agree\"\n                        }\n                    }' />\n                    <label id=\"confirmationMessage\" class=\"noBottom\" for=\"agree\" ng-bind-html=\"htmlContent('consumerCreditInfo.secciReadConfirmationMessage')\"></label>\n                </div>\n                <div class=\"buttons\">\n                    <input track-submit='bml_signature' type=\"submit\" value=\"{{content('common.continueLabel')}}\"\n                           class=\"btn full\" ng-click=\"validated=true\" />\n                </div>\n\n                <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                    <p class=\"bmlSeeTerms sameLine\">{{ content('applyForBml.notInterestedNoInstallments') }}</p>\n                    <p class=\"bmlSeeTerms sameLine\" ng-bind-html=\"htmlContent('applyForBml.payInFull')\" ng-click=\"redirectToReview()\"></p>\n                </div>\n            </form>\n        </div>\n        <div class=\"span10 bmlMargin\">\n            <xo-value-props type=\"signature\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./components/xo-credit-components/src/choose-credit-offer/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$ChooseCreditOfferRoute = undefined;
	
	__webpack_require__("./components/xo-credit-components/src/choose-credit-offer/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $ChooseCreditOfferRoute = exports.$ChooseCreditOfferRoute = _squid.$ComponentRoute.extend('$ChooseCreditOfferRoute', {
	
	    path: 'chooseCreditOffer',
	    directive: 'xo-choose-credit-offer',
	    titleContent: 'chooseCreditOffer.choose',
	    trackingData: {
	        fptiState: 'choose_credit_offer',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::choose_credit_offer',
	                'pagename2': '%::choose_credit_offer:member:hermes:',
	                'version': 'member:%:'
	            }
	        }
	    },
	    auth: false,
	    children: []
	});
	
	angular.value("$ChooseCreditOfferRoute", $ChooseCreditOfferRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./components/xo-credit-components/src/choose-credit-offer/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	__webpack_require__("./components/xo-credit-components/src/choose-credit-offer/styles.less");
	
	var _template = __webpack_require__("./components/xo-credit-components/src/choose-credit-offer/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/credit/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoChooseCreditOfferDirective', {
	    tag: 'xo-choose-credit-offer',
	    template: _template2['default'],
	
	    props: {
	        token: {
	            type: 'var',
	            required: true
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            return {
	                auth: _auth.$AuthModel.instance().retrieve(),
	                checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve(),
	                checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
	                payee: _index.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
	                creditOptions: _index2.$CreditInstallmentModel.instance(this.props.token).retrieve(),
	                flowEligibility: _index.$FlowEligibilityModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	
	    actions: {
	        redirectToReview: function redirectToReview() {
	            $('body').removeClass('CYCOPage');
	            this.creditDataModel.payInFull = true;
	            if (!this.models.auth.logged_in) {
	                _uiRouter.$state.go('checkout.login');
	            } else {
	                _uiRouter.$state.go('checkout.review');
	            }
	        },
	        toggleSacOffer: function toggleSacOffer(isExtended) {
	            this.sacExtended = isExtended ? false : true;
	        },
	        toggleInstallmentOffer: function toggleInstallmentOffer(isExtended) {
	            this.installmentExtended = isExtended ? false : true;
	        },
	
	
	        getCreditFinancingCodes: function getCreditFinancingCodes(creditOffers) {
	            var financingCodes = '';
	            var installmentOffer = creditOffers.installment_options;
	            var sacOffer = creditOffers.sac_options;
	
	            if (installmentOffer && installmentOffer.length) {
	                installmentOffer.forEach(function (installment) {
	                    financingCodes += installment.financingCode;
	                    financingCodes += ',';
	                });
	            }
	
	            if (sacOffer) {
	                financingCodes += sacOffer.financingCode;
	            }
	
	            return financingCodes;
	        },
	
	        handleRedirect: function handleRedirect() {
	            var creditMemberType = this.isCreditInWallet ? 'existingMember' : 'newMember';
	            var isBuyerSet = this.fundingInstruments;
	            var isSignUpFlow = this.creditDataModel.isCreditSignup();
	            var isChangeInstallment = this.creditDataModel.isChangeStatus();
	            $('body').removeClass('CYCOPage');
	
	            if (isBuyerSet && creditMemberType === 'newMember' || isSignUpFlow && isChangeInstallment) {
	                _uiRouter.$state.go('checkout.redirectToCape');
	            } else if (creditMemberType === 'existingMember') {
	                _uiRouter.$state.go('checkout.review');
	            } else {
	                _uiRouter.$state.go('checkout.login');
	            }
	        },
	        onSelect: function onSelect(index) {
	            var _this = this;
	
	            if (index === 'CORE') {
	                if (this.models.creditOptions && this.models.creditOptions.creditType) {
	                    delete this.models.creditOptions.creditType;
	                }
	                _logger.$logger.info('checkout_fpti', {
	                    'credit_type': 'CORE'
	                });
	                this.actions.handleRedirect();
	            } else {
	                var isPPCReuse = this.isCreditInWallet;
	                var selectedOffer = index === 'SAC' ? this.creditOffers.sac_options : this.creditOffers.installment_options[index];
	                var param = {
	                    'financing_code': selectedOffer.financingCode,
	                    'apr': selectedOffer.apr,
	                    'term': selectedOffer.term,
	                    'credit_type': selectedOffer.creditType,
	                    'paypal_subsidy': selectedOffer.paypalSubsidy
	                };
	
	                if (index !== 'SAC') {
	                    param.monthly_percentage_rate = selectedOffer.monthlyPercentageRate;
	                    param.total_cost = selectedOffer.totalPayment.value;
	                    param.total_interest = selectedOffer.totalInterest.value;
	                    param.monthly_payment = selectedOffer.monthlyPayment.value;
	                    param.currency = selectedOffer.monthlyPayment.currency;
	                }
	
	                return this.models.creditOptions.action('select', {
	                    data: param,
	                    success: function success() {
	                        _logger.$logger.info('checkout_fpti', {
	                            'is_ppc_reuse': isPPCReuse ? '1' : '0',
	                            'credit_type': selectedOffer.creditType,
	                            'financing_code_selected': selectedOffer.financingCode
	                        });
	
	                        _this.actions.handleRedirect();
	                    }
	                });
	            }
	        }
	    },
	    lifecycle: {
	        enter: function enter() {
	            this.offers = _index.$InstallmentOptionsModel.instance(this.props.token);
	            this.checkoutSession = _index.$CheckoutSessionModel.instance(this.props.token);
	            this.creditOffers = this.offers.installments && this.offers.installments[0];
	            this.creditDataModel = _index2.$CreditDataModel.instance(this.props.token);
	            this.installmentCount = this.creditOffers && this.creditOffers.installment_options && this.creditOffers.installment_options.length;
	            $('.paypalHeaderWrapper').addClass('paypalCredit');
	            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
	            $('body').addClass('CYCOPage');
	        },
	        populate: function populate() {
	            var _this2 = this;
	
	            var self = this;
	            this.fundingInstruments = this.checkoutSession.get('fundingOptions.instruments');
	            if (this.models.auth.logged_in && this.fundingInstruments) {
	                this.checkoutSession.retrieve();
	            }
	            this.isCreditInWallet = this.fundingInstruments && _squid.$util.some(this.fundingInstruments, function (fi) {
	                return fi.name === 'BILL_ME_LATER';
	            });
	
	            this.country = this.models.checkoutAppData.get('merchant.merchant_country');
	
	            function getFlowEligibility() {
	                return self.models.flowEligibility.reload({
	                    params: {
	                        'localeCountry': self.country
	                    }
	                });
	            }
	
	            function getInstallmentContent() {
	                var contentKey = 'chooseCreditOption.singleInstallmentDescription';
	                var isZeroAprAvailable = false;
	
	                if (self.installmentCount > 1) {
	                    self.creditOffers.installment_options.forEach(function (installment) {
	                        if (installment.apr === '0.00') {
	                            isZeroAprAvailable = true;
	                            contentKey = 'chooseCreditOption.installmentDescriptionAprZero';
	                        }
	                    });
	
	                    if (!isZeroAprAvailable) {
	                        contentKey = 'chooseCreditOption.installmentDescription2';
	                    }
	                }
	                return contentKey;
	            }
	
	            this.offers.save({
	                data: {
	                    payee: this.models.payee,
	                    checkoutCart: this.models.checkoutCart,
	                    checkoutAppData: this.models.checkoutAppData,
	                    isMemberCredit: true
	                }, success: function success(result) {
	                    _this2.creditOffers = result.installments && result.installments[0];
	                    var installmentsPresent = _this2.creditOffers && _this2.creditOffers.installment_options;
	                    _this2.installmentCount = installmentsPresent && _this2.creditOffers.installment_options.length;
	                    _this2.termsUrl = _this2.creditOffers ? (0, _squid.$feature)('creditOfferSeeTermsUrl') + _this2.creditOffers.terms_param : undefined;
	                    if (_this2.creditOffers) {
	                        _logger.$logger.info('checkout_fpti', {
	                            'financing_code_offered': _this2.actions.getCreditFinancingCodes(_this2.creditOffers)
	                        });
	                    }
	                    _this2.installmentContentKey = getInstallmentContent();
	                    var isFlowInstallmentEligible = getFlowEligibility().then(function (eligibility) {
	                        return eligibility.installment;
	                    });
	                    _this2.defaultinstallmentExtended = _this2.country === 'GB' && installmentsPresent && _this2.models.checkoutAppData.is_second_button_txn && isFlowInstallmentEligible;
	                    _this2.showSingleOffer = _this2.country === 'GB' && (installmentsPresent && (_this2.models.checkoutAppData.is_second_button_txn ? isFlowInstallmentEligible : _this2.checkoutSession && _this2.checkoutSession.creditOffer) ? false : true);
	                    _this2.showNoInterestSection = _this2.country === 'GB' ? !_this2.defaultinstallmentExtended : _this2.creditOffers && _this2.creditOffers.sac_options;
	                }
	            });
	        }
	    }
	
	});
	
	
	_squid.$Component;
	
	_squid.$util;
	
	_squid.$feature;
	
	_logger.$logger;
	
	_uiRouter.$state;
	
	_auth.$AuthModel;
	
	_index.$CheckoutSessionModel;
	
	_index.$CheckoutCartModel;
	
	_index.$InstallmentOptionsModel;
	
	_index.$CheckoutPayeeModel;
	
	_index.$CheckoutAppDataModel;
	
	_index.$FlowEligibilityModel;
	
	_index2.$CreditInstallmentModel;
	
	_index2.$CreditDataModel;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./components/xo-credit-components/src/choose-credit-offer/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-credit-components/src/choose-credit-offer/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-credit-components/src/choose-credit-offer/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "blockquote,body,code,dd,div,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:400}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:400}q:after,q:before{content:\"\"}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,select,textarea{font-family:inherit;font-size:inherit;font-weight:inherit;font-size:100%}legend{color:#000}body{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:95%;color:#2c2e2f;line-height:1.35em}h1{font-size:138.5%}h2{font-size:123.1%}h3{font-size:108%}h1,h2,h3{margin:1em 0}h1,h2,h3,h4,h5,h6,strong{font-weight:700}a{color:#0070ba}abbr,acronym{border-bottom:1px dotted #000;cursor:help}em{font-style:italic}blockquote,dl,ol,ul{margin:1em}dl,ol,ul{margin-left:2em}ol{list-style:decimal outside}ul{list-style:disc outside}dl dd{margin-left:1em}td,th{border:1px solid #000;padding:.5em}th{font-weight:700;text-align:center}input{margin-bottom:10px}caption{margin-bottom:.5em;text-align:center}fieldset,legend,p,pre,table{margin-bottom:1em}input[type=password],input[type=text],textarea{width:12.25em;*width:11.9em}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid>[class*=span]{float:left;margin-left:4.12765957%}.row-fluid>[class*=span]:first-child{margin-left:0}.row-fluid>.span24{width:99.99999998%}.row-fluid>.span23{width:95.74468083%}.row-fluid>.span22{width:91.48936168%}.row-fluid>.span21{width:87.23404253%}.row-fluid>.span20{width:82.97872339%}.row-fluid>.span19{width:78.72340424%}.row-fluid>.span18{width:74.46808509%}.row-fluid>.span17{width:70.21276594%}.row-fluid>.span16{width:65.95744679%}.row-fluid>.span15{width:61.70212765%}.row-fluid>.span14{width:54.4468085%}.row-fluid>.span13{width:53.19148935%}.row-fluid>.span12{width:48.9361702%}.row-fluid>.span11{width:44.68085105%}.row-fluid>.span10{width:40.42553191%}.row-fluid>.span9{width:36.17021276%}.row-fluid>.span8{width:31.91489361%}.row-fluid>.span7{width:27.65957446%}.row-fluid>.span6{width:23.40425531%}.row-fluid>.span5{width:19.14893617%}.row-fluid>.span4{width:14.89361702%}.row-fluid>.span3{width:10.63829787%}.row-fluid>.span2{width:6.38297872%}.row-fluid>.span1{width:2.12765957%}.container-fluid{padding-left:20px;padding-right:20px;*zoom:1}.container-fluid:after,.container-fluid:before{display:table;content:\"\"}.container-fluid:after{clear:both}.mt10,.mt15{margin-top:10px}.pt10{padding-top:10px}.pt15{padding-top:15px}.mb10{margin-bottom:10px}.mb15{margin-bottom:15px}.pb10{padding-bottom:10px}.pb15{padding-bottom:15px}.ml10{margin-left:10px}.ml15{margin-left:15px}.pl10{padding-left:10px}.pl15{padding-left:15px}.mr10{margin-right:10px}.mr15{margin-right:15px}.pr10{padding-right:10px}.pr15{padding-right:15px}.btn{height:44px;margin-bottom:0;border:1px solid #0070ba;border-radius:5px;*margin-left:.3em;display:inline-block;*display:inline;*zoom:1;background-color:#0070ba;-webkit-transition:background-color .4s ease-out 0s;transition:background-color .4s ease-out 0s;font-size:1em;font-weight:700;line-height:42px;color:#fff;text-align:center;vertical-align:middle;cursor:pointer;outline:none;-webkit-font-smoothing:antialiased}.btn .btn-secondary{-webkit-font-smoothing:auto}.btn:focus,.btn:hover{background-color:#005ea6}.btn:focus{text-decoration:underline}.btn.active,.btn:active{background-color:#005ea6;outline:0}.btn.disabled,.btn[disabled]{background-color:#b2d9ea;border-color:#b2d9ea;cursor:default}.btn.firstHalf{float:left}.btn.firstHalf,.btn.secondHalf{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box}.btn.secondHalf{float:right}a.btn:focus,a.btn:hover{color:#fff}.btn:first-child{*margin-left:0}.btn-large{padding:8px 15px;font-size:18px;line-height:normal;border-radius:5px}.btn-small{padding:5px 9px;font-size:11px;line-height:16px}.btn-mini{padding:2px 6px;font-size:11px;line-height:14px}.btn-secondary{border-style:solid;border-color:#e1e7eb;color:#393f44;background-color:#e1e7eb}.btn-secondary:hover{color:#393f44;border-color:#edf2f5;background-color:#edf2f5;text-decoration:none}.btn-secondary:active,.btn-secondary:focus{border-color:#c5ccd1;background-color:#c5ccd1;text-decoration:underline}.btn-secondary.disabled,.btn-secondary[disabled]{color:#393f55}a.btn-secondary:active,a.btn-secondary:focus,a.btn-secondary:hover{color:#393f44;border-color:#c5ccd1;background-color:#c5ccd1}a.btn-secondary.disabled,a.btn-secondary[disabled]{color:#393f55;background-color:#e7edf0}button.btn,input[type=submit].btn{*padding-top:2px;*padding-bottom:2px}button.btn::-moz-focus-inner,input[type=submit].btn::-moz-focus-inner{padding:0;border:0}button.btn.btn-large,input[type=submit].btn.btn-large{*padding-top:7px;*padding-bottom:7px}button.btn.btn-small,input[type=submit].btn.btn-small{*padding-top:3px;*padding-bottom:3px}button.btn.btn-mini,input[type=submit].btn.btn-mini{*padding-top:1px;*padding-bottom:1px}#largeScreenAccountCreation .buttons #backButton,section .buttons #backButton{width:30%}#largeScreenAccountCreation .buttons #proceedButton,section .buttons #proceedButton{width:65%}#largeScreenAccountCreation .buttons #proceedButton.full,section .buttons #proceedButton.full{width:100%}.custom-select-container,select.replaced{position:relative}select.replaced{z-index:8;width:100%;height:44px;border:0;line-height:2;opacity:0;filter:alpha(opacity=0)}.custom-select{position:absolute;top:0;left:0;z-index:1;width:100%;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;border-radius:5px}.custom-select,.custom-select>span{display:block;background-clip:padding-box}.custom-select>span{padding:7px 30px 7px 13px;border:1px solid #ccd0d4;border-radius:5px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:right -7px top -1178px;color:#000;line-height:28px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.disabled .custom-select>span{background-position:right -7px top -6990px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat right 10px center;background-size:16px;color:#c72e2e;border:1px solid #c72e2e}.custom-select span span{display:block;overflow:hidden;height:28px;text-overflow:ellipsis;white-space:nowrap;font-size:1em}.custom-select.active>span{border:1px solid #009cde;outline:0}#task .custom-select{border-radius:5px;background-clip:padding-box}.mobile .dob label{position:static;top:0;left:0}input[type=date]{padding:5px 38px 3px 6px;border:1px solid #ccd0d4;border-radius:5px;background-clip:padding-box;color:#333;background-size:24px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_cart_icons.png\") no-repeat 100% 61%}input[type=date]:focus{border-color:#39f}.showDropdopwnLabels .labelText{float:left;color:#aaa}.showDropdopwnLabels .valueText{float:right;min-width:90px}@media (min-width:0) and (max-width:40em){.showDropdopwnLabels .labelText{display:none}.showDropdopwnLabels .valueText{float:none;min-width:0}}.multiline-select-container{outline:0 none}.multiline-select-container:active .innerContainer,.multiline-select-container:focus .innerContainer{border-color:#009cde}.multiline-select-container.open:active .innerContainer,.multiline-select-container.open:focus .innerContainer{border-color:#ccd0d4}.multiline-select-container option,.multiline-select-container select{position:absolute!important;left:-9999px}.multiline-select-container .custom-select{position:relative}.multiline-select-container .custom-select span span{height:auto;white-space:normal}.multiline-select-container .custom-select>span{background:none}.multiline-select-container.open .custom-select>span{border-radius:5px 5px 0 0;border-bottom-color:#eee}.multiline-select-container .arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_forms.png\");background-position:left -8px top -1198px;background-repeat:no-repeat;height:10px;position:absolute;width:14px;top:40%;right:12px}.backendError .multiline-select-container .ng-invalid+.custom-select .arrow,.validated .multiline-select-container .ng-invalid+.custom-select .arrow{display:none}.multiline-select-list{position:absolute;list-style:none;margin:0;background-color:#fff;z-index:1000;border-radius:0 0 5px 5px;border-bottom:1px solid #ccd0d4;max-height:200px;overflow:auto;box-shadow:0 -1px 1px 0 #ccc}.multiline-select-list li{padding:10px;border:1px solid;border-color:#eee #ccd0d4;border-top:0 none;cursor:pointer;line-height:1.35em;vertical-align:middle}.multiline-select-list li:active,.multiline-select-list li:focus,.multiline-select-list li:hover{background-color:#e5f5fc;outline:0 none}.multiline-select-list li:first-of-type{border-top:0 none}.multiline-select-list li:last-of-type{border-bottom:0 none}.multiline-select-list:hover li:focus{background-color:#fff}.multiline-select-list:hover li:focus:active,.multiline-select-list:hover li:focus:hover{background-color:#e5f5fc}#midflash,.accessAid{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}body{-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#fff}a{text-decoration:none;-webkit-tap-highlight-color:rgba(0,0,0,.2)}a:focus,a:hover{color:#005ea6;text-decoration:underline;outline:none}a.dashed{text-decoration:none;border-bottom:1px dashed #0070ba;font-size:.9em}[tabindex=\"-1\"]{outline:none}em{font-style:normal;font-weight:700}fieldset{margin:0;padding:0;border:0}fieldset legend{padding-bottom:.5em;font-size:1.5em}section:focus{outline:none}.show-section{display:block}hr.faded{width:100%;height:1px;margin:10px 0;border:0;background-image:-webkit-gradient(linear,left top,right top,color-stop(0,transparent),color-stop(.5,rgba(0,0,0,.3)),color-stop(1,transparent));background-image:-webkit-linear-gradient(left,transparent,rgba(0,0,0,.3),transparent);background-image:-o-linear-gradient(left,transparent,rgba(0,0,0,.75),transparent)}.alpha{font-size:1.5em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin:.5em 0;line-height:1.154em}#loginSection h1.alpha{max-width:240px}.asideAlpha{font-size:1.44em}aside .aside .header.noButtons .walletHeading{text-align:center;line-height:1.05em}.beta{font-size:1.54em;color:#2c2e2f;font-weight:lighter;line-height:1.2em}.gamma{font-size:1.3em}.gamma,.zeta{font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:lighter;margin-bottom:.75em}.zeta{font-size:1.25em}.delta{font-size:1.1em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;margin-bottom:12px;font-weight:400}.vprop-header{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin:10px 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.vprop-content,.vprop-header{color:#2c2e2f;font-weight:lighter;line-height:1.2em}.vprop-content{font-size:1em;font-family:HelveticaNeue,helvetica,arial,sans-serif}.vprop-image{margin-top:25px}.eta{font-size:1.1em}.eta,.theta{font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400}.theta{font-size:1em}.value-prop-title{color:#2c2e2f;font-size:24px;font-weight:lighter;margin:10px 0}.props{padding:0 0 0 5px;clear:both;text-align:center}.props li,.props p{line-height:1.154em;font-size:.9em;font-weight:400;line-height:1.2em;margin:5px 0}.secondary{color:#6c7378;font-size:.85em}.legal{color:#6c7378;font-size:.75em;line-height:1.154em}.legal a{font-weight:700}.mu{font-size:2.46em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:400;text-shadow:0 1px 0 #fff;color:#0079c1}.noHead{margin-top:0}.noBottom{margin-bottom:0}.showTray #task{overflow:hidden;margin-left:0}#spinner,.hide{display:none}.clearfix,.loading #spinner,.media .img img,html[xmlns] .clearfix{display:block}#billingToggleLink{display:inline-block}.left{float:left}.right{float:right}.center{text-align:center}.outerWrapper{position:relative;border-radius:5px;background-clip:padding-box;background-color:#fff}header{z-index:2}.framed #wrapper,html.framed{border-radius:5px;background-clip:padding-box}html.framed .trayOpen #main{height:585px}html.framed .trayOpen .asideContent{height:495px}body>iframe,body>img{display:none}#wrapper{margin:0 auto;max-width:780px;border:1px solid #e3e3e3;border-radius:5px;overflow-y:visible;outline:none}#wrapper,#wrapper #header{-ms-box-sizing:border-box;box-sizing:border-box;background-clip:padding-box;position:relative;background-color:#fff}#wrapper #header{border-radius:5px 5px 0 0;width:100%;z-index:4;box-shadow:0 0 3px 0}#contents{position:relative;z-index:1}.active #wrapper{visibility:visible;-webkit-animation-duration:.4s;-webkit-animation-timing-function:ease;-webkit-animation-name:slideUp}#logo{margin:22px 0 0 20px}.container{clear:both;padding:20px}.containerNoHead{padding-top:0}.noPaddingBottom{padding-bottom:0}.noPaddingTop{padding-top:0}.subContainer{border-top:1px solid #e3e3e3;padding:20px 0;position:relative}#proceedButton{width:46.4%;-ms-box-sizing:border-box;box-sizing:border-box;float:right}#proceedButton.full{width:100%}#proceedButton:focus{color:#fff}#backButton{width:46.4%;text-decoration:none;-ms-box-sizing:border-box;box-sizing:border-box;float:left}#backButton:focus,#backButton:hover{color:#2c2e2f}.middleName{display:none;float:right}.h2,h2{font-size:1.2em;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;margin-top:0;font-weight:400;color:#0666b3}.clearfix:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}* html .clearfix{height:1%}#sliding-area{overflow:hidden}#main{padding:25px 30px 15px;-webkit-transition:margin .3s ease-out;transition:margin .3s ease-out;width:100%;float:right;-ms-box-sizing:border-box;box-sizing:border-box}.loading #main{background:none}.bmlLoadingMessage,.loginLoadingMessage,.loginProcessing .genericLoadingMessage{display:none}.loginProcessing .loginLoadingMessage{display:block}.full{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;text-decoration:none}.trayInner{padding:20px 0}.disclaimer{font-size:.75em;color:#6c7378}.reviewMsg{margin-top:10px;line-height:1.5}.infoTxt{clear:both;padding-top:10px}.help{color:#a9a9a9}.keyValue label{color:#292929}.frontArrow{position:absolute;display:inline-block;width:9px;height:15px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-196px -177px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.frontArrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.focusableIcon:focus{box-shadow:0 0 1px #6c7378}input[type=button],input[type=submit]{-webkit-appearance:none}.inputField input[disabled=disabled],.inputField input[disabled=disabled]:active,input[disabled=disabled]{background:#f7f9fa;border:1px solid #cbd2d6;color:#6c7378}input::-ms-clear{display:none}input.link:hover{cursor:pointer}input.xsmall{width:2em}input.small{width:3.35em;font-size:1em}input.medium{width:7em}input.large{width:14em}input.xlarge{width:20em}.button-as-link{margin:0;padding:0;border:none;width:auto;font-size:.85em;background:transparent;color:#0070ba;cursor:pointer}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.buttons{margin-top:15px;margin-bottom:15px;overflow:hidden}.inputField{position:relative}.inputField input,.inputField label{display:block;vertical-align:top}.ignoreValidation .inputField.error input,.inputField input,.validated .ignoreValidation .inputField input.backendError,.validated .ignoreValidation .inputField input.ng-invalid{width:100%;height:44px;padding:0 14px;border-radius:5px;background-clip:padding-box;border:1px solid #c5ccd1;color:#000;-webkit-transition:border-color .3s ease 0s;transition:border-color .3s ease 0s;-ms-box-sizing:border-box;box-sizing:border-box;background:none}.ignoreValidation .inputField.error input::-webkit-input-placeholder,.inputField input::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.backendError::-webkit-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-webkit-input-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-moz-placeholder,.ignoreValidation .inputField.error input::-moz-placeholder,.inputField input:-moz-placeholder,.inputField input::-moz-placeholder,.validated .ignoreValidation .inputField input.backendError:-moz-placeholder,.validated .ignoreValidation .inputField input.backendError::-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-moz-placeholder,.validated .ignoreValidation .inputField input.ng-invalid::-moz-placeholder{color:#6c7378}.ignoreValidation .inputField.error input:-ms-input-placeholder,.inputField input:-ms-input-placeholder,.validated .ignoreValidation .inputField input.backendError:-ms-input-placeholder,.validated .ignoreValidation .inputField input.ng-invalid:-ms-input-placeholder{color:#6c7378}.inputField input:active,.inputField input:focus{border:1px solid #009cde;outline:0}.inputField select{font-size:1.5em;margin-bottom:10px}.custom-select-container select{font-size:15px}.inputField label{position:absolute;top:14px;left:14px;cursor:text;text-align:left;color:#666;font-size:1em}.no-js .dropdown label,.no-js .inputField label{position:static}.fieldGroup .inputField{float:left;padding:0 .5em 0 0}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.inputField.error input::-webkit-input-placeholder,.validated .inputField input.backendError::-webkit-input-placeholder,.validated .inputField input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.inputField.error input:-moz-placeholder,.inputField.error input::-moz-placeholder,.validated .inputField input.backendError:-moz-placeholder,.validated .inputField input.backendError::-moz-placeholder,.validated .inputField input.ng-invalid:-moz-placeholder,.validated .inputField input.ng-invalid::-moz-placeholder{color:#c72e2e}.inputField.error input:-ms-input-placeholder,.validated .inputField input.backendError:-ms-input-placeholder,.validated .inputField input.ng-invalid:-ms-input-placeholder{color:#c72e2e}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}.inputField.valid input{background:#fff url(https://www.paypalobjects.com/images/checkout/hermes/icon_checkmark_wallet_2x.png) no-repeat 98%;background-size:14px}.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.creditCardField.valid input{background:#fff}.dropdown.error select,.inputField.error select{border:1px solid #c72e2e}.selectLabel{display:block}input::-webkit-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-size:1em}input:-moz-placeholder,input::-moz-placeholder{color:#6c7378;opacity:1;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}input:-ms-input-placeholder{color:#6c7378;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif}.checkbox input[type=checkbox]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.checkbox input[type=checkbox]~label{display:inline-block;position:static;min-height:25px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px 0;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.checkbox input[type=checkbox]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.checkbox.error input[type=checkbox]:focus~label,.checkbox.error input[type=checkbox]~label{background-position:-9px -600px}.checkbox input[type=checkbox]:checked~label{background-position:-9px -400px}.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -4801px}.checkbox input[type=checkbox]:focus~label{background-position:-9px -4601px}.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -800px}.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:25px 25px}.validated .ignoreValidation input[type=checkbox].ng-invalid:focus~label,.validated .ignoreValidation input[type=checkbox].ng-invalid~label{background-position:-9px 0}.validated input[type=checkbox].ng-invalid~label{background-position:-9px -600px}.validated input[type=radio].ng-invalid+label,.validated input[type=radio].ng-invalid:focus+label{background-position:-10px -2200px}.sCheckbox.checkbox{position:relative}.sCheckbox.checkbox input[type=checkbox]~label{line-height:19px;padding-left:27px;font-size:.85em;background-position:-9px -2600px}.sCheckbox.checkbox.error input[type=checkbox]:focus~label,.sCheckbox.checkbox.error input[type=checkbox]~label{background-position:-9px -3200px}.sCheckbox.checkbox input[type=checkbox]:checked~label{background-position:-9px -3000px}.sCheckbox.checkbox input[type=checkbox]:focus:checked~label{background-position:-9px -5409px}.sCheckbox.checkbox input[type=checkbox]:focus~label{background-position:-9px -2800px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]~label{background-position:-9px -3400px}.sCheckbox.checkbox input[type=checkbox][disabled=disabled]:checked~label{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/checkbox-disabled.png\");background-position:0 0;background-size:18px 19px}.radioButton input[type=radio]{position:absolute!important;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);padding:0!important;border:0!important;height:1px!important;width:1px!important;overflow:hidden}.radioButton input[type=radio]~label{display:inline-block;min-height:26px;padding-left:35px;line-height:27px;background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_1x.png\");background-repeat:no-repeat;background-position:-9px -1600px;vertical-align:middle;cursor:pointer}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.radioButton input[type=radio]~label{background-image:url(\"https://www.paypalobjects.com/images/shared/sprite_forms_2x.png\");background-size:40px 8000px}}.radioButton.error input[type=radio]+label,.radioButton.error input[type=radio]:focus+label{background-position:-9px -2200px}.radioButton.warning input[type=radio]+label,.radioButton.warning input[type=radio]:focus+label{background-position:-9px -7405px}.radioButton input[type=radio]:checked+label{background-position:-9px -2000px}.radioButton input[type=radio]:focus:checked+label{background-position:-9px -6010px}.radioButton input[type=radio]:focus+label{background-position:-9px -1800px}.inputField label.nolap{position:relative;top:auto;left:auto;color:#2c2e2f}.inputField.half{width:48.15%;margin-right:3.7%;padding-right:0}.multistepSignupForm .inputField.half,.singlePagePaymentForm .inputField.half{width:48.7%;margin-right:2.6%;padding-right:0}.inputField.half.issueNo{width:42%;margin-top:15px}.inputField.half.startDate{width:54%;margin-right:10px}#cardIssueInfo .inputField.half.startDate{width:48%;margin-right:0}#cardIssueInfo .inputField.half.issueNo{width:48%;margin-top:0;float:right}#cardIssueInfo .inputField.half.issueNo:before{content:\"\\200C\"}.inputField.half.last-child{margin-right:0}.fieldGroup .inputField.last-child{padding-right:0}.fidobDay{width:30%;float:left}.fidobDay .custom-select>span{border-radius:5px 0 0 5px;border-right:0}.fidobMonth{width:30%;float:left}.fidobMonth .custom-select>span{border-radius:0}.fidobYear{width:40%;float:left}.fidobYear .custom-select>span{border-radius:0 5px 5px 0;border-left:0}.cardDOB{width:100%;clear:both}.dobLabel{top:auto;left:auto;position:relative;display:block;bottom:4px}.dobTXT{margin-top:10px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.inputField.error input,.validated .inputField input.backendError,.validated .inputField input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.validated select.backendError+.custom-select>span,.validated select.ng-invalid+.custom-select>span{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\") no-repeat right 10px center;background-size:18px}}.submitted input.ng-invalid{border-color:#c72e2e;padding-right:29px;background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%}.submitted input.ng-invalid::-webkit-input-placeholder{color:#c72e2e}.submitted input.ng-invalid:-moz-placeholder,.submitted input.ng-invalid::-moz-placeholder{color:#c72e2e}.submitted input.ng-invalid:-ms-input-placeholder{color:#c72e2e}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.submitted input.ng-invalid{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}.merchantHeader{height:90px;margin:0 auto}.merchantHeader .headerWrapper{max-width:780px;margin:0 auto;overflow:hidden;max-height:90px;line-height:90px}.merchantHeader .merchantName{font-size:1.6em;font-family:Helvetica Neue,HelveticaNeue,HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;color:#2c2e2f;font-weight:400;width:575px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block}.merchantHeader img{vertical-align:middle}.paypalHeaderWrapper .logo{float:left;width:112px;height:29px;margin-top:5px;background-position:0 -47px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.paypalHeaderWrapper .logo{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.paypalHeaderWrapper .span14{padding-bottom:20px;border-bottom:1px solid #dbdbdb}.paypalHeaderWrapper .cartContainer{position:static;line-height:29px}.paypalHeaderWrapper .transctionCartDetails{z-index:2}.paypalHeaderWrapper.paypalCredit .logo{height:35px;background-position:0 -129px}.aside .header{padding:15px;vertical-align:middle;line-height:50px;border-bottom:1px solid #e3e3e3}.aside .header.tall{min-height:65px;line-height:normal;padding:13px 15px 10px;margin-bottom:0}.aside .asideAlpha{padding:0 30px;text-align:center;line-height:1.2em}.aside .walletHeading{text-align:center}.aside .close{top:10px;right:15px;padding:5px;border-radius:3px}.aside .close,.aside .close:before{position:absolute;width:19px;height:19px}.aside .close:before{content:\"\";display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .close:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .close:focus:before,.aside .close:hover:before{background-position:-223px -22px}.aside .backArrow{position:absolute;top:10px;left:15px;width:9px;height:18px;padding:5px;border-radius:3px}.aside .backArrow:before{content:\"\";display:inline-block;position:absolute;width:9px;height:18px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -46px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.aside .backArrow:before{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.aside .backArrow:focus:before,.aside .backArrow:hover:before{background-position:-232px -68px}.aside .addOptions{margin-top:20px}.aside .addOptions h2{float:left;width:70%;margin-bottom:0}.aside .addOptions a{float:right;display:block;line-height:1.9em;font-size:.85em}.aside .subHeader{margin-top:20px}.CYCOPage .paypalHeader.span14,.pageSepaAgreementContingency .paypalHeader.span14,.pageSepaMandate .paypalHeader.span14,.pageSepaMandateContingency .paypalHeader.span14{width:100%}@media (max-width:41.3125em){.merchantHeader{display:none}.paypalHeaderWrapper{height:65px}.paypalHeaderWrapper .cartContainer{margin-top:10px;margin-bottom:-5px;margin-right:15px}.paypalHeaderWrapper .logo{margin:15px 0 0 30px}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}}@media (max-width:30em) and (min-width:0){.paypalHeaderWrapper .cartContainer{margin-top:15px;margin-bottom:-10px;margin-right:0}.paypalHeaderWrapper .logo{margin:15px 0 0}.paypalHeaderWrapper.paypalCredit .logo{height:35px;margin:15px 0 0;background-position:0 -129px}.header{height:55px}.aside .header{height:auto}.aside .close{right:15px}}.footer{max-width:780px;margin:10px auto;font-size:.75em}.cancelUrl{float:left;width:39%}.micaLender{display:none;color:#2c2e2f;clear:both}.footerWrapper{float:right;width:60%;text-align:right}.footerLinks{margin:0;display:inline-block}.footerLinks a{color:#6c7378}.footerLinks a.feedbackLink{color:#0070ba;margin-left:5px}.copyright{display:inline;width:auto;vertical-align:top;color:#6c7378}.secureIcon{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:0 -33px;margin-left:3px;margin-right:3px;margin-top:3px;width:10px;height:12px;vertical-align:top}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.secureIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.poweredBy{float:right;margin-top:-49px}.poweredBy .text{float:left;margin-top:8px;margin-right:8px;font-size:12px;font-weight:400;font-style:italic;color:#6c7378}.footerLinks li{padding:0 12px 0 0;display:inline-block}.footerLinks .last{padding-right:18px;border-right:none}.footer .policyInfoWrapper p{line-height:1.3em}.footer .policyInfoWrapper p a{font-weight:700}.minibrowser .APAC.footer,.minibrowser.AU .footer{position:relative;bottom:0;width:auto}.minibrowser .APAC.footer .policyInfoWrapper,.minibrowser.AU .footer .policyInfoWrapper{padding:0}.minibrowser .cancelUrl{display:none}.minibrowser .footerWrapper{padding:0 10px;float:none;width:95%;margin:0}.minibrowser .footerLinks li{padding:0 5px 0 0}.DE .footerWrapper,.fr.CA .footerWrapper,.fr.FR .footerWrapper{float:none;width:auto}.DE .footerWrapper:after,.fr.CA .footerWrapper:after,.fr.FR .footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.DE .footerLinks,.fr.CA .footerLinks,.fr.FR .footerLinks{float:left;width:70%;text-align:left}.DE .footerLinks li:first-child,.fr.CA .footerLinks li:first-child,.fr.FR .footerLinks li:first-child{padding-left:0}.DE .copyright,.fr.CA .copyright,.fr.FR .copyright{float:right;width:30%;margin:0}.DE .cancelUrl,.fr.CA .cancelUrl,.fr.FR .cancelUrl{float:none;margin:5px 0;width:100%}.APAC .policyInfoWrapper{padding:5px 0 10px;color:#6c7378}.APAC .policyInfoWrapper p.moreInfo{padding:15px 0 20px;float:left;line-height:1.3em}.AU .policyInfoWrapper,.en_AU .policyInfoWrapper{padding:20px 0 10px;color:#6c7378}.AU .policyInfoWrapper p.moreInfo,.en_AU .policyInfoWrapper p.moreInfo{padding:15px 0 20px;border-bottom:1px solid #ccc;float:left}.AU .policyInfoWrapper p.moreCopyRight,.en_AU .policyInfoWrapper p.moreCopyRight{padding:5px 0 0;clear:both}.fr_XC .footerWrapper{float:left;width:70%;text-align:left;padding-left:0;margin-left:-7px}@media (max-width:41.25em){.footer{border-top:1px solid #ccc;padding:5px 20px;margin-top:10px}.footer .policyInfoWrapper{padding:0 10px}.footerWrapper{float:none;width:100%;padding:0;margin:0}.footerWrapper:after{height:0;display:block;visibility:hidden;clear:both;overflow:auto;line-height:0;content:\" \"}.cancelUrl{width:95%;padding:0}.footerLinks{float:left;width:70%;text-align:left}.footerLinks .feedback{display:none}.minibrowser .footerLinks .feedback{display:inline-block}.copyright{width:20%}.cancelUrl{float:none;margin:5px 0}}@media (max-width:30em) and (min-width:0){.footer{margin-top:0;padding:5px 10px}.footer .policyInfoWrapper{padding:0}.cancelUrl,.footerWrapper{padding:0;margin:5px 0;width:100%}.DE .footerLinks,.footerLinks,.fr.FR .footerLinks{width:65%}.DE .footerLinks li,.footerLinks li,.fr.FR .footerLinks li{padding:0;margin-right:10px}.DE .footerLinks li.last,.footerLinks li.last,.fr.FR .footerLinks li.last{margin-right:0}.DE .footerLinks .feedback,.footerLinks .feedback,.fr.FR .footerLinks .feedback{display:none}.copyright,.DE .copyright{width:33%;margin:0}.minibrowser .copyright{margin-right:0;width:30%}.minibrowser .footerLinks .feedback{display:inline-block}}.modal-open{overflow:hidden}.modal-open #contents,.modal-open #wrapper,.modal-open .outerWrapper{position:static}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:140;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop,.modal-backdrop.fade.in{opacity:.54}.modal{display:none;overflow:auto;overflow-y:scroll;position:fixed;top:0;right:0;bottom:0;left:0;z-index:150}.modal.fade .modal-wrap{-webkit-transform:translateY(-25%);transform:translateY(-25%);-webkit-transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out}.modal.fade.in .modal-wrap{-webkit-transform:translate(0);transform:translate(0)}.modal-wrap{position:relative;margin:10px;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;background-clip:padding-box;box-shadow:0 3px 9px rgba(0,0,0,.3);outline:none}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{margin:0;line-height:30px}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-clip:padding-box;box-shadow:inset 0 1px 0 #fff}.modal-footer:after,.modal-footer:before{display:table;content:\"\";line-height:0}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.spinner{height:100%;width:100%;position:absolute;z-index:10}.spinner .spinWrap{width:200px;height:100px;position:absolute;top:50%;left:50%;margin-left:-100px;margin-top:-50px}.spinner .spinnerImage{margin:28px 0 0 -25px;background:url(\"https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png\") no-repeat}.spinner .loader,.spinner .spinnerImage{height:100px;width:100px;position:absolute;top:0;left:50%;opacity:1;filter:alpha(opacity=100)}.spinner .loader{margin:0 0 0 -55px;background-color:transparent;-webkit-animation:rotation .7s infinite linear;animation:rotation .7s infinite linear;border-left:5px solid #cbcbca;border-right:5px solid #cbcbca;border-bottom:5px solid #cbcbca;border-top:5px solid #2380be;border-radius:100%}.spinner .bmlLoadingMessage,.spinner .genericLoadingMessage,.spinner .loginLoadingMessage{-ms-box-sizing:border-box;box-sizing:border-box;width:100%;margin-top:125px;text-align:center;z-index:100}.spinner.preloader{position:fixed;top:0;left:0;z-index:1000;background-color:#fff}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.aside{min-height:380px}.aside .container{padding:15px}.asideContent{height:100%}.centerText{text-align:center}.fsIcons{display:inline-block;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;min-width:32px;width:25px;height:21px;padding-right:5px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.BALANCE .fsIcons,.DELAYED_TRANSFER .fsIcons,.HOLDING .fsIcons{background-position:0 0}.ELO .fsIcons{background-position:0 -479px}.HIPER .fsIcons{background-position:0 -458px}.HIPERCARD .fsIcons{background-position:0 -500px}.pinlessGlyphIcon{display:inline-block;position:relative;top:-5px;left:-8px;width:32px;height:20px;font-size:3.1rem;padding-right:5px}.BANK .fsIcons,.BANK_ACCOUNT .fsIcons,.IACH .fsIcons{background-position:0 -252px;height:19px;left:19px}.ECHECK .fsIcons,.ELV .fsIcons,.TAB.DELAYED_TRANSFER .fsIcons{background-position:0 -252px;height:19px}.TAB.DELAYED_TRANSFER .fsIcons{left:19px}.BILL_ME_LATER .fsIcons,.BML .fsIcons,.CREDIT_OPTION .fsIcons,.PPCREDIT .fsIcons{background-position:0 -105px}.PAYPAL_SMART_CONNECT .fsIcons{background-position:0 0}.VISA .fsIcons{background-position:0 -21px}.MASTERCARD .fsIcons{background-position:0 -42px}.AMEX .fsIcons{background-position:0 -63px;left:19px;height:20px}.DISC .fsIcons,.DISCOVER .fsIcons{background-position:0 -84px}.JCB .fsIcons{background-position:0 -353px}.CHINA_UNION_PAY .fsIcons{background-position:0 -563px}.ELECTRON .fsIcons{background-position:0 -146px}.MAESTRO .fsIcons,.MSTRO .fsIcons,.SWITCH .fsIcons{background-position:0 -168px}.CB_NATIONALE .fsIcons,.CBN .fsIcons{background-position:0 -210px}.CELEM .fsIcons,.CETELEM .fsIcons{background-position:0 -311px}.COFINOGA .fsIcons,.CONF .fsIcons{background-position:0 -231px}.COFID .fsIcons,.COFIDIS .fsIcons{background-position:0 -437px;left:20px}.INCENTIVE .fsIcons{background-position:0 -271px;height:18px}.PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -374px}.PPSMTCONNECT .fsIcons{background-position:0 0}.ES .PAYPAL_EXTRAS_MASTERCARD .fsIcons{background-position:0 -521px}.fsIcon{display:block;position:absolute;width:25px;height:21px;left:15px;top:20px;min-width:32px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_1x.png\");background-repeat:no-repeat;background-position:0 0}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.fsIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_logos_wallet_v11_2x.png\");background-size:31px 590px}}.fsIcon.BANK,.fsIcon.PAD{background-position:6px -252px;height:19px;left:19px}.fsIcon.MASTER,.fsIcon.MASTERCARD,.fsIcon.MCARD{background-position:0 -42px}.fsIcon.ELO{background-position:0 -479px}.fsIcon.HIPER{background-position:0 -458px}.fsIcon.HIPERCARD{background-position:0 -500px}.fsIcon.DISC,.fsIcon.DISCOVER{background-position:0 -84px}.fsIcon.VISA{background-position:0 -21px}.fsIcon.JCB{background-position:0 -353px}.fsIcon.AMEX,.fsIcon.Amex{background-position:6px -63px;left:19px;height:20px}.fsIcon.MAESTRO,.fsIcon.MSTRO,.fsIcon.SWITCH{background-position:0 -168px}.fsIcon.PAYPAL_SMART_CONNECT{background-position:0 0}.fsIcon.CB_NATIONALE,.fsIcon.CBN{background-position:0 -210px}.fsIcon.CELEM,.fsIcon.CETELEM{background-position:0 -311px}.fsIcon.COFID,.fsIcon.COFIDIS{background-position:0 -437px;left:20px;height:20px}.fsIcon.CHINA_UNION_PAY,.fsIcon.CUP{background-position:0 -563px}.fsIcon.COFINOGA,.fsIcon.CONF{background-position:0 -231px}.fsIcon.PAYPAL_EXTRAS_MASTERCARD,.fsIcon.PPXMCARD{background-position:0 -374px}.fsIcon.EBAY_MASTERCARD,.fsIcon.EBAYMCARD{background-position:0 0}.fsIcon.BILL_ME_LATER,.fsIcon .BML,.fsIcon .PPCREDIT{background-position:0 -105px}.fsIcon.PPSMTCONNECT{background-position:0 0}.fsIcon.pinlessIcon{background-image:none;font-size:3.1rem;left:5px;top:14px}.ES .fsIcon.PAYPAL_EXTRAS_MASTERCARD,.ES .fsIcon.PPXMCARD{background-position:0 -521px}.infoIcon{width:19px;height:18px;display:inline-block;position:absolute;top:25px;right:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-89px -1px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.infoIcon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.addOption{padding:25px 10px;margin:0 0 0 44px;color:#0070ba;font-size:.85em}.plusicon{display:block;position:absolute;left:15px;top:22px;width:20px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-223px -97px}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.plusicon{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}.infoIcon+.checkIcon{display:none}.infoMsg{margin:0;overflow:hidden;font-size:.85em}.expiredIcon{background:#fff url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1.png\") no-repeat 98%;width:16px;height:16px;top:6px}.expiredIcon,.plccIcon{display:inline-block;position:relative}.plccIcon{float:left;height:20px;background:none;width:32px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.fsIcon,.fsIcons{height:20px}}.walletIcons{position:absolute;width:30px;height:20px;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons.png\");background-repeat:no-repeat}@media only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.walletIcons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/sprite_wallet_icons_2x.png\");background-size:90px 970px}}.walletIcons.BANK,.walletIcons.BANK_ACCOUNT{background-position:-50px -460px}.walletIcons.BANK.BOFA,.walletIcons.BANK_ACCOUNT.BOFA{background-position:-50px -10px}.walletIcons.BANK.CHASE,.walletIcons.BANK_ACCOUNT.CHASE{background-position:-50px -130px}.walletIcons.BANK.WELLSFARGO,.walletIcons.BANK_ACCOUNT.WELLSFARGO{background-position:-50px -100px}.walletIcons.BANK.CITI,.walletIcons.BANK_ACCOUNT.CITI{background-position:-50px -40px}.walletIcons.BANK.FIFTHTHIRD,.walletIcons.BANK_ACCOUNT.FIFTHTHIRD{background-position:-50px -220px}.walletIcons.BANK.CAPITAL,.walletIcons.BANK_ACCOUNT.CAPITAL{background-position:-50px -70px}.walletIcons.BANK.AMERITRADE,.walletIcons.BANK_ACCOUNT.AMERITRADE{background-position:-50px -160px}.walletIcons.BANK.SUNTRUST,.walletIcons.BANK_ACCOUNT.SUNTRUST{background-position:-50px -280px}.walletIcons.BANK.USBANK,.walletIcons.BANK_ACCOUNT.USBANK{background-position:-50px -310px}.walletIcons.BANK.USAA,.walletIcons.BANK_ACCOUNT.USAA{background-position:-50px -250px}.walletIcons.CARD.VISA,.walletIcons.PAYMENT_CARD.VISA{background-position:-10px -40px}.walletIcons.CARD.MASTER,.walletIcons.CARD.MASTERCARD,.walletIcons.PAYMENT_CARD.MASTER,.walletIcons.PAYMENT_CARD.MASTERCARD{background-position:-10px -70px}.walletIcons.CARD.DISCOVER,.walletIcons.PAYMENT_CARD.DISCOVER{background-position:-10px -100px}.walletIcons.CARD.AMEX,.walletIcons.PAYMENT_CARD.AMEX{background-position:-10px -130px}hr.sep,hr.sepPlain{padding:0;margin-top:25px;height:auto;border:none;border-top:1px solid #ccc;color:#2c2e2f;text-align:center;overflow:visible}hr.sep:after,hr.sepPlain:after{content:\"or\";display:inline-block;position:relative;top:-.7em;font-size:1em;padding:0 .5em;background:#fff;color:#6c7378;font-weight:400}.de hr.sep:after{content:\"oder\"}.da hr.sep:after{content:\"eller\"}.es hr.sep:after{content:\"o\"}.fr hr.sep:after{content:\"ou\"}.he hr.sep:after{content:\"\\5D0\\5D5\"}.id hr.sep:after{content:\"Atau\"}.it hr.sep:after{content:\"oppure\"}.ja hr.sep:after{content:\"\\307E\\305F\\306F\"}.ko hr.sep:after{content:\"\\B610\\B294\"}.nl hr.sep:after{content:\"of\"}.no hr.sep:after{content:\"eller\"}.pl hr.sep:after{content:\"lub\"}.pt hr.sep:after{content:\"ou\"}.ru hr.sep:after{content:\"\\418\\43B\\438\"}.sv hr.sep:after{content:\"eller\"}.th hr.sep:after{content:\"\\E2B\\E23\\E37\\E2D\"}.tr hr.sep:after{content:\"Veya\"}.zh hr.sep:after{content:\"\\6216\"}hr.sepPlain:after{content:\"\"}@media (max-width:40em) and (orientation:landscape),(min-width:0) and (max-width:30em){body{-webkit-text-size-adjust:100%}.merchantBrand{display:none}.outerWrapper{background-position:left 50px}.centerTray.loginSignup{margin-bottom:60px}#main{padding:0;background:none;z-index:2}#contents{padding:0 20px;-ms-box-sizing:border-box;box-sizing:border-box}.tokenization #contents{padding:0 30px}.paypalHeader{padding:0 20px 20px;-ms-box-sizing:border-box;box-sizing:border-box}.props,header{display:none}.review #wrapper{min-height:512px}#contents{min-height:0;margin-bottom:0}.bmlAppProcessing,.loginProcessing{background-color:#f9f9f9}.loggingIn{margin:0 25px}.mobile .loggingIn{margin:0}.saferEasier,.simpler{display:none}#login .row-fluid{padding-top:0}#login .centerTray{padding:0}#login #signupLink.btn{margin:5px 0}#wrapper{margin:0;width:auto;border-radius:0;background-clip:padding-box;border:none}#task{width:295px}.loading .spinner{background-position-y:35%}.centerTray{width:auto}.accountTerms .tray .inner,.tray .inner{padding:10px}.row-fluid>[class*=span],.signup{width:100%;margin-left:0;float:none}#notifications{width:100%}.delta,.gamma{font-size:1.2em}.inputField label{left:7px;top:13px}.saferEasier{display:none}#fundingInstruments .buttons{height:40px}.cityState select{font-size:14px}.cityState .city{width:100%}.cityState .state{width:55%}.cityState .postalCode{width:40.8%}#tab{margin-top:0;height:125px}.toolTip.whatsthis ul{width:242px;left:9px}.toolTip.whatsthis ul li{font-size:.9em}#expiration.varB .expires{width:49%}#expiration .inputField{padding:0}#expiration .cvc{width:44%;float:right}#expiration.varB .cvc{width:49%}.month{margin-left:46px}.separator{margin-left:5px;margin-top:3px}.year{margin-left:0}#expiration .cardIcon{position:absolute;right:4px}.details{margin-right:2px}.mask #closeButton,.mask #header{display:none}}@media (min-width:30.0625em) and (max-width:41.25em){#notifications,.row-fluid>.span10,.row-fluid>.span12,.row-fluid>.span14{width:100%}.outerWrapper{background-position:left 59px}.props,header{display:none}#wrapper{margin:0;border:none}#main{padding:0}#contents{padding:0 25px}}@media (min-width:41.3125em){.banner{display:block}#wrapper{min-height:0}#wrapper,.footer,.merchantHeader{width:95%}.largeScreen .centerTray{margin-top:0}.signup{margin-bottom:0}#genericError{min-height:375px;background:url(https://www.paypalobjects.com/images/checkout/hermes/scr_cloud_balloon.png) no-repeat bottom}#transactionDetails .merchantName{display:none}}@media (device-height:568px) and (-webkit-min-device-pixel-ratio:2){#contents{min-height:0;margin-bottom:0}.pageLanding #contents{margin:70px auto 40px 0}}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){.cardType{display:none}ul.validations li.restriction.active{background:url(https://www.paypalobjects.com/images/checkout/hermes/close3_2x.png) no-repeat 0 2px;background-size:10px}.inputField.error input{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}.inputField.error input,.inputField.valid input{background-position:-webkit-calc(100% - 10px) 50%;background-position:right 10px center}.error .custom-select.active>span,.error .custom-select>span{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/error-icon_v1_2x.png\");background-size:18px}}@media only screen and (-webkit-min-device-pixel-ratio:2) and (min-width:41.3125em){#genericError{background-size:640px 242px}}#creditoffer .cycoHeader{margin-bottom:5px}#creditoffer .mainDescription{color:#6c7378}#creditoffer .inputField input{height:40px}#creditoffer p{margin-bottom:5px}#creditoffer .ukOfferDescription{width:90%}#creditoffer .offerTitle{font-weight:700}#creditoffer .offerSmallText{width:100%;margin-bottom:0;font-size:1em}#creditoffer .moreInfoLink{padding:7px 33px 4px 18px;position:absolute;top:12px;right:0;color:#0070ba;cursor:pointer;font-weight:500}#creditoffer .noMargin{top:2px}#creditoffer .down{background-position:-219px -234px}#creditoffer .up{background-position:-219px -219px}#creditoffer .frontArrow{top:10px;right:0;width:22px}#creditoffer .bmlLender{font-size:.75em;margin-top:10px;color:#6c7378}#creditoffer .bmlMargin{margin-top:15px}#creditoffer .sameLine{display:inline}#creditoffer .payInFullLink{font-weight:700}#creditoffer .payInFullText{color:#6c7378}#creditoffer .buttons{width:100%;margin-top:10px;-ms-box-sizing:border-box;box-sizing:border-box;bottom:0}#creditoffer .btn{width:100%}#creditoffer .smallText{padding:3px 35px 0;font-size:.75em}#creditoffer .extendedOfferContent{display:inline-block;width:75%;padding:10px 0}#creditoffer .chooseOffer,#creditoffer .ukChooseOffer{width:25%;font-size:1em;display:inline-block;float:right;margin-bottom:0}#creditoffer .ukChooseOffer{margin-top:0}#creditoffer .terms{font-size:.85em;margin:0;font-weight:700}#creditoffer .installmentOfferWrapper,#creditoffer .sacOfferWrapper{margin-bottom:15px;margin-top:20px}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .installmentOfferWrapper .extendedSacCtaWrap,#creditoffer .installmentOfferWrapper .installmentCtaWrap,#creditoffer .installmentOfferWrapper .sacCtaWrap,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .sacOfferWrapper .extendedSacCtaWrap,#creditoffer .sacOfferWrapper .installmentCtaWrap,#creditoffer .sacOfferWrapper .sacCtaWrap{padding:20px;background-color:#f7f9fa;position:relative;border-radius:5px;background-clip:padding-box}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .extendedSacCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .installmentCtaWrap .trayInner,#creditoffer .installmentOfferWrapper .sacCtaWrap .trayInner,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap .trayInner,#creditoffer .sacOfferWrapper .extendedSacCtaWrap .trayInner,#creditoffer .sacOfferWrapper .installmentCtaWrap .trayInner,#creditoffer .sacOfferWrapper .sacCtaWrap .trayInner{position:relative;margin:0;padding:0;background-color:transparent;overflow:hidden}#creditoffer .installmentOfferWrapper .extendedInstallmentCtaWrap,#creditoffer .sacOfferWrapper .extendedInstallmentCtaWrap{padding:0}#creditoffer .installmentOfferWrapper .extended,#creditoffer .sacOfferWrapper .extended{background-color:#fff;color:#6c7378;border:1px solid #e1e7eb}#creditoffer .installmentOfferWrapper .seeTermsWrap,#creditoffer .sacOfferWrapper .seeTermsWrap{padding:10px 0 10px 20px}#creditoffer .installmentOfferWrapper #extendedInstallmentOffer,#creditoffer .installmentOfferWrapper #extendedSacOffer,#creditoffer .sacOfferWrapper #extendedInstallmentOffer,#creditoffer .sacOfferWrapper #extendedSacOffer{margin-top:5px}#creditoffer .reverseOrder{display:table;width:100%}#creditoffer .reverseOrder .sacOfferWrapper{display:table-footer-group}#creditoffer .gceOffers .row-fluid .span12{width:49.9%}#creditoffer .gceOffers .row-fluid .span8{width:33.1%}#creditoffer .gceOffers .row-fluid .span6{width:24.8%}#creditoffer .gceOffers .row-fluid [class*=span]{margin-left:0}#creditoffer .gceOffers .postScriptCondition{clear:both;padding:10px 0 0;font-size:.73em}#creditoffer .gceOffers .span12.singleOffer{float:none}#creditoffer .gceOffers ul.installmentOptionsB{overflow:hidden;white-space:nowrap;border-radius:5px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner{padding:0;margin:0;background-color:#f7f9fa}#creditoffer .gceOffers ul.installmentOptionsB.trayInner.fullPageOffer{padding-bottom:20px;background-color:transparent}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .sacOffer{box-sizing:border-box;float:left;line-height:1.154em;list-style:outside none none;padding:20px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer{float:left;list-style:none;border-right:3px solid #fff;-ms-box-sizing:border-box;box-sizing:border-box;padding:15px 15px 0;line-height:1.154em}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form{position:relative;min-height:230px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.en{min-height:250px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.es,#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.fr,#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer form.US.zh{min-height:278px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .offer:last-child{border-right:none}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections{white-space:normal;margin:0;padding-bottom:10px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections li{list-style:none}#creditoffer .gceOffers ul.installmentOptionsB.trayInner ul.subSections li.offerHeading1{padding:0 0 5px}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .theta{font-size:.85em}#creditoffer .gceOffers ul.installmentOptionsB.trayInner .smallText{padding:3px 16px 0;font-size:.75em}#creditoffer .gceOffers .offerAmount{display:block;font-weight:700}#creditoffer .gceOffers .totalInstallment{margin:0 0 10px}#creditoffer .gceOffers .offerDetails{width:75%;white-space:normal;padding:10px 0 0}#creditoffer #creditExampleUK{margin:30px 0}#creditoffer #creditExampleUK .creditWorksTitle{margin-bottom:5px;color:#2c2e2f}#creditoffer #creditExampleUK .creditWorksDescription{color:#6c7378}#creditoffer #creditExampleUK .representativeExKey{font-size:.85em}#creditoffer #creditExampleUK .representativeExHeader{margin-top:-10px}#creditoffer #creditExampleUK .span6{text-align:center;margin:0}#creditoffer #creditExampleUK .representativeEx{margin:0 0 20px;list-style:none;padding:0;background:none;border-top:7px solid #e3e3e3;border-bottom:1px solid #e3e3e3}#creditoffer #creditExampleUK .representativeEx .creditExHeading{color:#6c7378}#creditoffer #creditExampleUK .representativeEx li{padding:10px 30px;vertical-align:middle;border-right:1px solid #e3e3e3;width:175px}#creditoffer #creditExampleUK .representativeEx li p{margin-bottom:5px}#creditoffer #creditExampleUK .representativeEx li .representativeExampleAPRAmount{margin:2px 0 0;font-family:HelveticaNeue-Light,Helvetica Neue Light,helvetica,arial,sans-serif;font-weight:700}#creditoffer #creditExampleUK .representativeEx li:last-child{border-right:none}#creditoffer .faq{text-align:center}@media (min-width:0) and (max-width:50em){#creditoffer .installmentOfferWrapper .installmentCtaWrap p,#creditoffer .installmentOfferWrapper .sacCtaWrap p,#creditoffer .sacOfferWrapper .installmentCtaWrap p,#creditoffer .sacOfferWrapper .sacCtaWrap p{width:52%}#creditoffer .buttons{position:absolute;top:40%;right:0;width:16px;height:16px;box-shadow:none;text-shadow:none;border:none;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16.png\");background-repeat:no-repeat;background-position:-232px -168px;text-indent:-200px;width:9px;height:18px}#creditoffer .buttons .btn{display:none}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span6,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span8,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.row-fluid .span12,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span6,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span8,#creditoffer .gceOffers ul.installmentOptionsB.row-fluid .span12{width:100%;border-right:none;border-bottom:1px solid #fff}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.trayInner li.offer,#creditoffer .gceOffers ul.installmentOptionsB.trayInner li.offer{padding:20px;border-bottom:5px solid #fff}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB.trayInner li.offer form,#creditoffer .gceOffers ul.installmentOptionsB.trayInner li.offer form{min-height:0}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB ul.subSections,#creditoffer .gceOffers ul.installmentOptionsB ul.subSections{width:auto}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB ul.subSections:last-of-type,#creditoffer .gceOffers ul.installmentOptionsB ul.subSections:last-of-type{padding-bottom:0}#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span6,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span8,#creditoffer .fourOffers .gceOffers ul.installmentOptionsB .span12,#creditoffer .gceOffers ul.installmentOptionsB .span6,#creditoffer .gceOffers ul.installmentOptionsB .span8,#creditoffer .gceOffers ul.installmentOptionsB .span12{position:relative}#creditoffer .fourOffers .gceOffers .offerAmount,#creditoffer .gceOffers .offerAmount{display:inline}#creditoffer .fourOffers .gceOffers .offerDetails,#creditoffer .gceOffers .offerDetails{display:block;width:auto}#creditoffer #creditExampleUK .representativeEx li{padding:10px 30px 10px 0;vertical-align:middle;border-right:1px solid #e3e3e3;width:100%}}@media (min-width:0) and (max-width:50em) and only screen and (-webkit-min-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min--moz-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min-device-pixel-ratio:2),(min-width:0) and (max-width:50em) and only screen and (min-resolution:2dppx),(min-width:0) and (max-width:50em) and only screen and (min-resolution:192dpi){#creditoffer .buttons{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/hermes_window_sprite_v16_2x.png\");background-size:250px 350px}}", ""]);
	
	// exports


/***/ },

/***/ "./components/xo-credit-components/src/choose-credit-offer/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"creditoffer\" id=\"creditoffer\" content>\n    <div class=\"row-fluid\">\n\n        <div class=\"trayInner\">\n            <!--Title-->\n            <div id=\"title\">\n                <h2 class=\"beta cycoHeader\">{{ content('chooseCreditOption.offerHeading')}}</h2>\n                <p ng-if=\"country === 'GB' || !isCreditInWallet\" class=\"theta mainDescription\">\n                    {{content('chooseCreditOption.offerDescription')}}</p>\n            </div>\n\n            <div class=\"sacOfferWrapper\" ng-if=\"showSingleOffer\">\n                <div id=\"sacOnlyOffer\" class=\"extendedSacCtaWrap\">\n                    <div class=\"trayInner\">\n                        <div class = \"extendedOfferContent\">\n                            <p class=\"offerTitle\" ng-if=\"creditOffers.sac_options\">{{content('chooseCreditOption.NIOnlyHeading')}}</p>\n                            <p class=\"offerTitle\" ng-if=\"!creditOffers.sac_options\">{{content('chooseCreditOption.noOfferHeading')}}</p>\n                            <p class=\"ukOfferDescription\" ng-if=\"creditOffers.sac_options\">{{content('chooseCreditOption.NIOnlyDescription')}}</p>\n                            <p class=\"ukOfferDescription\" ng-if=\"!creditOffers.sac_options\">{{content('chooseCreditOption.noOfferDescription')}}</p>\n                        </div>\n\n                        <div class=\"chooseOffer buttons\"\n                             ng-click=\"actions.handleRedirect()\">\n                            <input type=\"submit\" value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-class=\"{reverseOrder:country === 'GB'}\" ng-if=\"!showSingleOffer\">\n                <div class=\"sacOfferWrapper\" ng-if=\"showNoInterestSection\">\n                    <div id=\"sacOffer\" class=\"sacCtaWrap\" ng-class=\"{extended:sacExtended}\">\n                        <div class=\"trayInner\">\n                            <p ng-if=\"creditOffers.sac_options\" class=\"offerTitle\">{{content('chooseCreditOption.sacHeading')}}</p>\n                            <p ng-if=\"!creditOffers.sac_options\" class=\"offerTitle\">{{content('chooseCreditOption.noOfferInstallmentHeading')}}</p>\n                            <a link-button track-link=\"more_info_sac\" class=\"moreInfoLink sacLink\"\n                               ng-click=\"actions.toggleSacOffer(sacExtended)\"\n                               ng-class=\"{noMargin:!creditOffers.sac_options}\"\n                               ng-if=\"!sacExtended\">{{ content('chooseCreditOption.moreInfo') }}\n                                <span class=\"frontArrow down\"></span>\n                            </a>\n                            <a link-button class=\"moreInfoLink \" ng-click=\"actions.toggleSacOffer(sacExtended)\"\n                               ng-if=\"sacExtended\"  ng-class=\"{noMargin:!creditOffers.sac_options}\">{{ content('chooseCreditOption.close') }}\n                                <span class=\"frontArrow up\"></span>\n                            </a>\n                            <p ng-if=\"creditOffers.sac_options\" class=\"offerSmallText\">{{content('chooseCreditOption.sacDescription')}}</p>\n                        </div>\n                    </div>\n                    <div class=\"extendedSacCtaWrap seeTermsWrap\" ng-if=\"sacExtended && country !== 'GB'\">\n                        <p class=\"terms\" ng-bind-html=\"htmlContent('chooseCreditOption.seeTermsSAC')\"></p>\n                    </div>\n                    <div id=\"extendedSacOffer\" class=\"extendedSacCtaWrap\" ng-if=\"sacExtended\">\n                        <div class=\"trayInner\">\n                            <div class=\"extendedOfferContent\">\n                                <p class= \"ukOfferDescription\" ng-if=\"creditOffers.sac_options\">{{content('chooseCreditOption.sacNote1')}}</p>\n                                <p class= \"ukOfferDescription\" ng-if=\"!creditOffers.sac_options\">{{content('chooseCreditOption.noOfferInstallmentNote1')}}</p>\n                                <p>{{content('chooseCreditOption.sacNote2')}}</p>\n                            </div>\n                            <div class=\"chooseOffer buttons\" ng-if=\"creditOffers.sac_options\" ng-click=\"actions.onSelect('SAC')\">\n                                <input id=\"sacOfferButton\" type=\"submit\" track-submit='choose_sac'\n                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                                <p ng-if=\"country !== 'GB'\" class=\"smallText\"\n                                   ng-bind-html=\"htmlContent('chooseCreditOption.minimumAmt', {minAmount:'$99'})\"></p>\n                            </div>\n                            <div ng-if=\"!creditOffers.sac_options\" class=\"chooseOffer buttons\" ng-click=\"actions.onSelect('CORE')\">\n                                <input id=\"coreOfferButton\" type=\"submit\" track-submit='choose_core'\n                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\" class=\"btn\"/>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n\n                <div class=\"installmentOfferWrapper\" ng-if=\"creditOffers.installment_options\">\n                    <div id=\"installmentOffer\" class=\"installmentCtaWrap\"\n                         ng-class=\"{extended:installmentExtended || defaultinstallmentExtended}\">\n                        <div class=\"trayInner\">\n                            <p class=\"offerTitle\">{{content('chooseCreditOption.installmentHeading')}}</p>\n                            <div class=\"expandableLinks\" ng-if=\"!defaultinstallmentExtended\">\n                                <a link-button ng-if=\"installmentCount === 1 && !installmentExtended\"\n                                   track-link=\"more_info_installment\"\n                                   class=\"moreInfoLink\" ng-click=\"actions.toggleInstallmentOffer(installmentExtended)\">{{\n                                    content('chooseCreditOption.moreInfo') }}\n                                    <span class=\"frontArrow down\"></span>\n                                </a>\n                                <a link-button ng-if=\"installmentCount > 1 && !installmentExtended\"\n                                   track-link=\"more_info_installment\" class=\"moreInfoLink\"\n                                   ng-click=\"actions.toggleInstallmentOffer(installmentExtended)\">{{content('chooseCreditOption.seeAllPlans')\n                                    }}\n                                    <span class=\"frontArrow down\"></span>\n                                </a>\n                                <a link-button class=\"moreInfoLink\"\n                                   ng-click=\"actions.toggleInstallmentOffer(installmentExtended)\"\n                                   ng-if=\"installmentExtended || defaultinstallmentExtended\">{{ content('chooseCreditOption.close') }}\n                                    <span class=\"frontArrow up\"></span>\n                                </a>\n                            </div>\n                            <p class=\"offerSmallText\"\n                               data-ng-bind-html=\"htmlContent(installmentContentKey,{monthlyPayment: creditOffers.installment_options[installmentCount -1].monthlyPayment.formattedAmt, term:creditOffers.installment_options[installmentCount -1].term , apr: creditOffers.installment_options[installmentCount -1].apr})\"></p>\n                        </div>\n                    </div>\n                    <div class=\"extendedInstallmentCtaWrap seeTermsWrap\" ng-if=\"installmentExtended && country !== 'GB' \">\n                        <p class=\"terms\"\n                           ng-bind-html=\"htmlContent('chooseCreditOption.seeTermsInstallment', {seeTermsUrl: termsUrl})\"></p>\n                    </div>\n                    <div id=\"extendedInstallmentOffer\" class=\"extendedInstallmentCtaWrap\" ng-if=\"installmentExtended || defaultinstallmentExtended\">\n                        <div class=\"row-fluid gceOffers\">\n                            <div class=\"span24\">\n                                <ul class=\"trayInner trayInnerDefault installmentOptionsB row-fluid\">\n                                    <li class=\"offer span6\" ng-repeat=\"installment in creditOffers.installment_options\"\n                                        ng-click=\"actions.onSelect($index)\" track-submit='choose_installment'>\n                                        <form>\n                                            <div ng-if=\"country !== 'GB'\"class=\"installmentPlanDetails\">\n                                                <ul class=\"subSections\">\n                                                    <li class=\"offerHeading1\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueMonths',{term: installment.term})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valuePerMonth',{ monthlyPayment: installment.monthlyPayment.formattedAmt})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\" ng-bind-html=\"\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueAPR',{apr: installment.apr})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueInterest', { interest: installment.totalInterest.formattedAmt})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueEveryMonth', {term: installment.term})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\">\n                                                        {{content('chooseCreditOption.valueTotalPayment')}}\n                                                    </li>\n                                                    <li class=\"theta\">\n                                                        <strong>{{installment.totalPayment.formattedAmt}}</strong></li>\n                                                    <li class=\"terms\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.seeTerms')\"></li>\n                                                </ul>\n                                            </div>\n                                            <div ng-if=\"country === 'GB'\" class=\"installmentPlanDetails\">\n                                                <ul class=\"subSections\">\n                                                    <li class=\"offerHeading1\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valuePerMonth',{ monthlyPayment: installment.monthlyPayment.formattedAmt})\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueMonths',{term: installment.term})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\" ng-bind-html=\"\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.promotionalRate')\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueAPR',{apr: installment.apr})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.interestRate')\"></li>\n                                                    <li class=\"theta\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.valueInterest', { interest: installment.totalInterest.formattedAmt})\"></li>\n                                                </ul>\n                                                <ul class=\"subSections\">\n                                                    <li class=\"theta\">\n                                                        {{content('chooseCreditOption.valueTotalPayment')}}\n                                                    </li>\n                                                    <li class=\"theta\">\n                                                        <strong>{{installment.totalPayment.formattedAmt}}</strong></li>\n                                                    <li class=\"terms\"\n                                                        ng-bind-html=\"htmlContent('chooseCreditOption.seeTerms')\"></li>\n                                                </ul>\n                                            </div>\n\n                                            <div class=\"buttons\">\n                                                <input type=\"submit\" track-submit='choose_installment'\n                                                       value=\"{{content('chooseCreditOption.chooseOfferBtn')}}\"\n                                                       class=\"btn\"/>\n                                                <p ng-if=\"country !== 'GB'\" class=\"smallText\"\n                                                   ng-bind-html=\"htmlContent('chooseCreditOption.minimumAmt', {minAmount:installment.minimumAmount})\"></p>\n                                            </div>\n\n                                        </form>\n                                    </li>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n            </div>\n\n            <div class=\"bmlMargin\" id=\"bmlBottomText\">\n                <p class=\"sameLine payInFullText\" ng-bind-html=\"htmlContent('chooseCreditOption.payInFullText')\"></p>\n                <a link-button class=\"payInFullLink sameLine\" ng-bind-html=\"htmlContent('chooseCreditOption.payInFullLink')\"\n                   ng-click=\"actions.redirectToReview()\"></a>\n            </div>\n\n            <div id=\"creditExampleUK\" ng-if=\"country === 'GB'\">\n                <div class=\"creditWorks\">\n                <p class=\"creditWorksTitle\">{{content('chooseCreditOption.creditSampleHeader')}}</p>\n                <p class=\"creditWorksDescription\">{{content('chooseCreditOption.creditSamplePara')}}</p>\n                </div>\n                <p class=\"bmlLender\">{{content('chooseCreditOption.representativeEx')}}</p>\n                <p class=\"bmlLender representativeExHeader\">{{content('chooseCreditOption.representativeExHeader')}}</p>\n                <ul class=\"trayInner trayInnerDefault representativeEx row-fluid\">\n                    <li class=\"span6\">\n                        <p class=\"representativeExKey\">{{content('chooseCreditOption.purchaseRate')}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.purchaseRateValue')}}</p>\n                    </li>\n                    <li class=\"span6\">\n                        <p class=\"representativeExKey\">{{content('chooseCreditOption.representativeAPR')}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.representativeAPRValue')}}</p>\n                    </li>\n                    <li class=\"span6 last\">\n                        <p class=\"representativeExKey\">{{content('chooseCreditOption.exCreditLimit')}}</p>\n                        <p class=\"representativeExampleAPRAmount\">{{content('chooseCreditOption.exCreditLimitValue')}}</p>\n                    </li>\n                </ul>\n\n                <p class=\"faq\" ng-bind-html=\"htmlContent('chooseCreditOption.faqLink')\"></p>\n            </div>\n\n            <div id=\"bmlLender\">\n                <p ng-if=\"!isCreditInWallet\" class=\"sameLine bmlLender\">\n                    {{content('chooseCreditOption.disclaimerText1')}}</p>\n                <p ng-if=\"country === 'GB' && creditOffers.installment_options\" class=\"sameLine bmlLender\">{{content('chooseCreditOption.disclaimerTextInst')}}</p>\n                <p ng-if=\"!(country === 'GB' && creditOffers.installment_options)\" class=\"sameLine bmlLender\">{{content('chooseCreditOption.disclaimerText2')}}</p>\n            </div>\n\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n\n"

/***/ },

/***/ "./components/xo-credit-components/src/redirect-to-cape/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$RedirectToCapeRoute = undefined;
	
	__webpack_require__("./components/xo-credit-components/src/redirect-to-cape/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $RedirectToCapeRoute = exports.$RedirectToCapeRoute = _squid.$ComponentRoute.extend('$RedirectToCapeRoute', {
	
	    path: 'redirectToCape',
	    directive: 'xo-redirect-to-cape',
	    titleContent: 'redirectToCape',
	    trackingData: {
	        fptiState: 'redirect-to-cape',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::redirect-to-cape',
	                'pagename2': '%::redirect-to-cape:member:hermes:',
	                'version': 'member:%:'
	            }
	        }
	    },
	    loginRequired: true,
	    auth: false,
	    children: []
	});
	
	angular.value("$RedirectToCapeRoute", $RedirectToCapeRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./components/xo-credit-components/src/redirect-to-cape/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _template = __webpack_require__("./components/xo-credit-components/src/redirect-to-cape/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	var _auth = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index3 = __webpack_require__("./components/xo-models/src/credit/index.js");
	
	var _model = __webpack_require__("./components/xo-tracking/dist/model.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoRedirectToCapeDirective', {
	    tag: 'xo-redirect-to-cape',
	    template: _template2['default'],
	    props: { token: { type: 'var', required: true } },
	    resolve: {
	        models: function models() {
	            return {
	                checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
	                auth: _auth.$AuthModel.instance().retrieve(),
	                checkoutCart: _index2.$CheckoutCartModel.instance(this.props.token).retrieve()
	            };
	        }
	    },
	    lifecycle: {
	        populate: function populate() {
	            var _this = this;
	
	            this.creditDataModel = _index3.$CreditDataModel.instance(this.props.token);
	            var url = 'https://' + window.location.host + _squid.$config.urls.baseUrl;
	            var returnUrl = _squid.$util.buildURL(url, { token: this.props.token });
	            var transactionType = this.models.checkoutAppData.is_second_button_txn ? 'SECOND_BUTTON' : 'HERMES';
	            var isSignupFlow = this.models.auth.logged_in ? 'false' : 'true';
	            var isRP = this.models.checkoutCart.get('billing.type') === 'RECURRING_PAYMENTS';
	            var trafficSourceContent = '';
	            var pageContext = 'Full-context';
	            var flow = this.models.checkoutAppData.is_second_button_txn ? 'CHECKOUT_CREDIT_BUTTON' : 'CHECKOUT';
	
	            if (_angular.$rootScope.miniBrowser) {
	                pageContext = 'Mb-context';
	            } else if (_angular.$rootScope.isIFrame) {
	                pageContext = 'In-context';
	            }
	
	            if (this.models.checkoutCart.isBillingNoPurchase()) {
	                if (isRP) {
	                    trafficSourceContent = 'BA_RP_WITHOUT_PURCHASE';
	                } else {
	                    trafficSourceContent = 'BA_RT_WITHOUT_PURCHASE';
	                }
	            } else if (this.models.checkoutCart.isBillingPurchase()) {
	                if (isRP) {
	                    trafficSourceContent = 'BA_RP_WITH_PURCHASE';
	                } else {
	                    trafficSourceContent = 'BA_RT_WITH_PURCHASE';
	                }
	            }
	
	            var capeData = {
	                'flow_attributes': {
	                    'channel': _index.$DeviceInfo.isMobile() ? 'MOBILE' : 'WEB',
	                    'flow': flow,
	                    'primary_actor': 'PAYPAL',
	                    'tracking_id': this.props.token,
	                    'business_case_variation': transactionType,
	                    'credit_application_traffic_source': trafficSourceContent
	                },
	                'locale': _squid.$locale.lang + '_' + _squid.$locale.country,
	                'cart_id': this.props.token,
	                'fraudnet_id': this.props.token,
	                'context-type': pageContext,
	                'cal_correlation_id': _model.$CalDataModel.getCalCorrId(),
	                'return_uris': {
	                    'normal_return_uri': returnUrl + '&success=true',
	                    'system_error_uri': returnUrl + '&success=false&isInternalServiceError=true',
	                    'return_to_login_uri': returnUrl,
	                    'full_pay_uri': this.models.auth.logged_in ? returnUrl + '&success=false' : undefined,
	                    'cancel_uri': this.models.checkoutAppData.urls.cancel_url,
	                    'change_installments_uri': returnUrl + '&changeStatus=changeInstallment&creditSignup=' + isSignupFlow
	                }
	            };
	            var data = {
	                creditData: capeData,
	                newUserSignup: isSignupFlow
	            };
	
	            return this.creditDataModel.action('createCreditKey', {
	                data: data,
	                success: function success(res) {
	                    var capeUrl = (0, _squid.$feature)('capeUrl') + res.capeKey + '&token=' + _this.props.token;
	                    if (_this.creditDataModel.isChangeStatus()) {
	                        capeUrl += '&status=changeInstallment';
	                    }
	                    _this.creditDataModel.setCapeRedirectUri(capeUrl);
	                    _squid.$util.redirect(capeUrl);
	                }
	            });
	        }
	    }
	});
	
	
	_squid.$Component;
	
	_squid.$util;
	
	_squid.$config;
	
	_squid.$locale;
	
	_squid.$feature;
	
	_index.$DeviceInfo;
	
	_auth.$AuthModel;
	
	_index2.$CheckoutAppDataModel;
	
	_index2.$CheckoutCartModel;
	
	_index3.$CreditDataModel;
	
	_model.$CalDataModel;
	
	_angular.$rootScope;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-credit-components/src/redirect-to-cape/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"capeRedirect\">\n</div>\n"

/***/ },

/***/ "./pages/xo-pay-with-selection/route.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$PayWithSelectionRoute = undefined;
	
	__webpack_require__("./pages/xo-pay-with-selection/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var $PayWithSelectionRoute = exports.$PayWithSelectionRoute = _squid.$ComponentRoute.extend('$PayWithSelectionRoute', {
	
	    path: 'payWithSelection',
	
	    directive: 'xo-pay-with-selection-page',
	
	    params: {
	        targetPage: null,
	        source: null,
	        showNotYou: null
	    },
	
	    auth: false,
	
	    titleContent: 'base.logIn',
	
	    venmoHeaders: {
	        venmoTabs: true
	    },
	
	    trackingData: {
	        fptiState: 'payWithSelection',
	        suppressTransitionLog: true, // We will be suppressing the Server Side Tracking for this page
	        templateName: 'login.dust',
	        pageGoal: 'Select a payment scheme',
	        buzname: {
	            'fullpage': {
	                'pagename': '%::fullpage-login',
	                'pagename2': '%::fullpage-login:member:hermes:',
	                'version': 'member:%:'
	            },
	            'ulLogin': {
	                'pagename': '%::fullpage-ullogin',
	                'pagename2': '%::fullpage-ullogin:member:hermes:',
	                'version': 'member:%:'
	            }
	            // More page qualifiers come here...
	        }
	    },
	
	    children: []
	});
	
	angular.value("$PayWithSelectionRoute", $PayWithSelectionRoute);
	_squid.$ComponentRoute;

/***/ },

/***/ "./pages/xo-pay-with-selection/directive.js":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	
	exports.__esModule = true;
	exports.$xoPayWithSelectionPageComponent = undefined;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	var _template = __webpack_require__("./pages/xo-pay-with-selection/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	__webpack_require__("./pages/xo-pay-with-selection/style.less");
	
	__webpack_require__("./js/lib/index.js");
	
	__webpack_require__("./pages/xo-login/loginEligibility.js");
	
	__webpack_require__("./pages/xo-login/onboarding/directive.js");
	
	__webpack_require__("./pages/xo-login/util.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	__webpack_require__("./components/xo-models/src/app/index.js");
	
	__webpack_require__("./components/xo-ui-components/src/message/directive.js");
	
	__webpack_require__("./components/xo-title/dist/directive.js");
	
	__webpack_require__("./components/xo-login-components/src/login/handler/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/value-props/directive.js");
	
	__webpack_require__("./components/xo-form-components/src/language-options/directive.js");
	
	__webpack_require__("./components/xo-login-components/src/unified-login/directive.js");
	
	__webpack_require__("./components/xo-device-info/dist/index.js");
	
	__webpack_require__("./components/xo-login-components/src/onetouch-interstitial/kmliUpsell.js");
	
	__webpack_require__("./pages/xo-landing/route.js");
	
	__webpack_require__("./components/xo-ui-components/src/card-loader/directive.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _venmoInfo = __webpack_require__("./components/xo-venmo-components/src/venmo-info/index.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $xoPayWithSelectionPageComponent = exports.$xoPayWithSelectionPageComponent = _squid.$Component.extend('$xoPayWithSelectionPageComponent', {
	    tag: 'xo-pay-with-selection-page',
	    template: _template2['default'],
	    scope: {
	        token: '='
	    },
	    link: function link($scope) {
	        _logger.$logger.info('login_link');
	    },
	    lifecycle: {
	        enter: function enter() {
	            $('#contents').addClass('payWithSelection');
	            if (_venmoInfo.venmoInfo.isVenmo()) {
	                _venmoInfo.venmoInfo.setPayPalCookie();
	            }
	        },
	        populate: function populate() {
	            var $scope = this;
	            (0, _squid.$populate)($scope, {
	                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
	            }).then(function () {
	
	                var country = $scope.checkoutAppData.merchant.merchant_country;
	                (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment').then(function (result) {
	                    var treatmentName = result && result.treatment_name || '';
	                    if (treatmentName) {
	                        _logger.$logger.info('xo_hermesnode_hide_cart_logo_treatment');
	                        $('.cartContainer').hide();
	                        $('.merchantHeader > .headerWrapper').hide();
	                    }
	                });
	            });
	        },
	        exit: function exit() {
	            $('#contents').removeClass('payWithSelection');
	            var $scope = this;
	            (0, _squid.$populate)($scope, {
	                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
	            }).then(function () {
	
	                var country = $scope.checkoutAppData.merchant.merchant_country;
	                (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment').then(function (result) {
	                    var treatmentName = result && result.treatment_name || '';
	                    if (treatmentName) {
	                        $('.cartContainer').show();
	                        $('.merchantHeader > .headerWrapper').show();
	                    }
	                });
	            });
	        }
	    },
	
	    rootEvents: {
	        allLoaded: function allLoaded() {
	            if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
	                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
	                    if (window.xchild) {
	                        var isWebView = window.paypal && window.paypal.isWebView && window.paypal.isWebView();
	
	                        if (!isWebView) {
	                            _uiRouter.$state.go('checkout.framebust', { action: 'open', url: window.location.href.split('#')[0] });
	                        }
	                    } else {
	                        return _miniBrowser.$miniBrowser.frameBust(this.props.token);
	                    }
	                } else {
	                    throw _integration.$integration.error('Can not framebust');
	                }
	            }
	        }
	    },
	
	    controller: function controller($scope, $FallbackError, $window, $location, $locale, // eslint-disable-line no-shadow
	    $FlowEligibilityModel, $CheckoutSessionModel, $BuyerEligibilityModel, $EConsentModel, $AuthModel, $feature, // eslint-disable-line no-shadow
	    $AppDataModel, $config, $logger, // eslint-disable-line no-shadow
	    $q, $pxp, // eslint-disable-line no-shadow
	    $pxpFactors, $timeout, $util, // eslint-disable-line no-shadow
	    $experiment, $loginEligibility, $dispatch, $DeviceInfo, $KmliUpsell, $ReturnToMerchant, $meta, $stateParams, $CheckoutCartModel, $CreditDataModel, $capeRedirectUtil, $TokenizedWalletEligibilityModel) {
	
	        $scope.expandPaypalDrawer = false;
	        $scope.expandVenmoDrawer = false;
	        $scope.hideLoginHandlerTitle = true;
	
	        $scope.clickPaypalDrawer = function () {
	            $scope.expandPaypalDrawer = !$scope.expandPaypalDrawer;
	
	            // if venmo is expanded, close it
	            $scope.closeVenmoDrawer();
	
	            return $scope.expandPaypalDrawer;
	        };
	
	        $scope.clickVenmoDrawer = function () {
	            $scope.expandVenmoDrawer = !$scope.expandVenmoDrawer;
	
	            // if paypal is expanded, close it
	            $scope.closePaypalDrawer();
	
	            return $scope.expandVenmoDrawer;
	        };
	
	        $scope.closePaypalDrawer = function () {
	            // if paypal is expanded, close it
	            if ($scope.expandPaypalDrawer) {
	                $scope.expandPaypalDrawer = !$scope.expandPaypalDrawer;
	            }
	        };
	
	        $scope.closeVenmoDrawer = function () {
	            // if venmo is expanded, close it
	            if ($scope.expandVenmoDrawer) {
	                $scope.expandVenmoDrawer = !$scope.expandVenmoDrawer;
	            }
	        };
	
	        $scope.sendToVenmo = function () {
	            window.location.href = _venmoInfo.venmoInfo.buildVenmoURL();
	        };
	
	        $timeout($scope.clickVenmoDrawer, 800);
	        $logger.info('login_controller');
	
	        var fptiHardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];
	
	        $scope.ulEligibility = false;
	        $scope.useTokenizationAnimation = false;
	
	        /* If we detect a back/forward button click to land on the app, do not auto-login. In this case, the buyer
	         is attempting to navigate to a specific page, so we should not auto-redirect them.
	          This also fixes an issue with users:
	         - Authorizing the checkout session
	         - Redirecting to the merchant
	         - Hitting back and landing on login page
	         - Calling create on checkout and overwriting the authorization
	         - Hitting forward and landing again on merchant page
	         */
	
	        if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
	            _angular.$rootScope.forceLogin = true;
	        }
	
	        if (!_angular.$rootScope.forceLogin) {
	            $scope.autoLogin = true;
	        }
	
	        _angular.$rootScope.forceLogin = true;
	
	        $scope.hideGuest = $stateParams.targetPage === 'PAYER_AUTHENTICATION_REQUIRED' || $stateParams.showNotYou;
	        $scope.promptlogin = $scope.hideGuest && !$feature('riskyLoginContingency');
	
	        // log statement for mobile webview
	        if ($DeviceInfo.isApp()) {
	            $logger.debug('HERMES_IN_MOBILE_WEBVIEW');
	        }
	
	        if (!_miniBrowser.$miniBrowser.isMiniBrowser() && $locale.country === 'BR') {
	            var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_login_design;
	
	            $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
	                $scope.loginDesignExp = result;
	            });
	        }
	
	        var ROUTE_MAPPING = {
	            ECONSENT_REQUIRED: 'checkout.econsent'
	        };
	
	        $scope.onContingency = function (name, contingency) {
	
	            if (!ROUTE_MAPPING[name]) {
	                throw new $FallbackError({
	                    reason: name.toLowerCase(),
	                    product: 'ux'
	                });
	            }
	
	            _uiRouter.$state.go(ROUTE_MAPPING[name]);
	        };
	
	        $scope.buyerEligibility = $BuyerEligibilityModel.instance($scope.token);
	        $scope.checkoutSession = $CheckoutSessionModel.instance($scope.token);
	        $scope.eConsent = $EConsentModel.instance($scope.token);
	        $scope.tokenizedWalletEligibility = $TokenizedWalletEligibilityModel.instance($scope.token);
	        $scope.dependencyEligibility = true;
	
	        // Temporary light eligibility check for tokenized wallet flow.
	        function isWalletTokenizationEligible() {
	            // Only US buyer is eligible for tokenized wallet.
	            if ($scope.auth.country === 'US') {
	                return true;
	            }
	            return false;
	        }
	
	        $scope.setBuyer = function () {
	
	            var fptiData = {
	                from: 'CREATE_XO_SESSION',
	                to: 'process_create_xo_session'
	            };
	
	            function handleContingency(name, err) {
	                // Check if negative case has been previously handled.
	                if (!$scope.dependencyEligibility) {
	                    return;
	                }
	                fptiData.int_error_code = err.cause;
	                fptiData.error_source = 'paymentapiplatformserv';
	                fptiData.error_type = fptiHardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
	                $logger.info('checkout_fpti', fptiData);
	                throw err;
	            }
	
	            function handleNoValidTopupFiContingency(name, err) {
	                // Check if negative case has been previously handled.
	                if (!$scope.dependencyEligibility) {
	                    return;
	                }
	                if ($scope.checkoutCart.isWalletTokenization()) {
	                    $scope.checkoutSession.contingency = name;
	                    $logger.info('tokenized_wallet', {
	                        'from': 'PP_AndroidPay_Info',
	                        'to': 'prepare_PP_AndroidPay_Info',
	                        'context_id': $scope.token,
	                        'context_type': 'EC-Token',
	                        'billing_token': $meta.baToken
	                    });
	                    $('#outerWrapper').addClass('tokenization');
	                    $timeout(function () {
	                        return _uiRouter.$state.go('checkout.tokenizationInfo');
	                    }, 1200);
	                } else {
	                    handleContingency(name, err);
	                }
	            }
	
	            $logger.info('checkout_fpti', {
	                from: 'CREATE_XO_SESSION',
	                to: 'prepare_create_xo_session'
	            });
	
	            $scope.useTokenizationAnimation = $scope.checkoutCart.isWalletTokenization();
	            var walletTokenization = $scope.checkoutCart.isWalletTokenization();
	
	            if ($scope.useTokenizationAnimation) {
	                _angular.$rootScope.$emit('allLoaded');
	
	                $scope.setbuyerProgress = 'notStarted';
	                $logger.info('tokenized_wallet', {
	                    'from': 'adding_pp_ap_animation',
	                    'to': 'prepare_adding_pp_ap_animation',
	                    'context_id': $scope.token,
	                    'context_type': 'EC-Token',
	                    'billing_token': $meta.baToken
	                });
	
	                $timeout(function () {
	                    $scope.setbuyerProgress = 'pending'; // sets animation state to 80%
	                    $logger.info('tokenized_wallet', {
	                        'from': 'adding_pp_ap_animation',
	                        'to': 'process_adding_pp_ap_animation',
	                        'context_id': $scope.token,
	                        'context_type': 'EC-Token',
	                        'billing_token': $meta.baToken
	                    });
	                }, 300);
	            }
	
	            $scope.eConsent.reload({
	                batch: {
	                    name: 'setbuyer',
	                    silent: $scope.useTokenizationAnimation,
	                    id: 'eConsent',
	                    dependencies: ['buyerEligibility']
	                },
	                contingencies: {
	                    ECONSENT_REQUIRED: function ECONSENT_REQUIRED(name, err) {
	                        if ($scope.dependencyEligibility) {
	                            $scope.dependencyEligibility = false;
	                            $logger.debug('ULLOGIN_ECONSENT_REQUIRED');
	                            _uiRouter.$state.go('checkout.econsent');
	                        }
	                    }
	                }
	            });
	
	            $scope.buyerEligibility.reload({
	                batch: {
	                    name: 'setbuyer',
	                    id: 'buyerEligibility',
	                    silent: $scope.useTokenizationAnimation,
	                    dependencies: $scope.ulEligibility ? ['securityCtx'] : []
	                },
	                success: function success(result) {
	                    $logger.info(result.eligible ? 'buyer_eligible' : 'buyer_ineligible');
	
	                    if ($config.blockStudentAccount && $scope.auth.student_account) {
	                        $scope.dependencyEligibility = false;
	                        $logger.info('blocking_student_account');
	                        _uiRouter.$state.go('checkout.genericError', {
	                            code: 'STUDENT_ACCOUNT'
	                        });
	                        return;
	                    }
	
	                    if (walletTokenization && !isWalletTokenizationEligible()) {
	                        $scope.dependencyEligibility = false;
	                        var msg = 'ineligible_tokenized_wallet_' + $scope.auth.country + '_account';
	                        $logger.info(msg);
	
	                        _uiRouter.$state.go('checkout.genericError', {
	                            code: 'ANDROID_PAY_ELIGIBILITY_ERROR'
	                        });
	                        return;
	                    }
	
	                    if (result.clearedRT) {
	                        $logger.info('checkout_fpti', {
	                            from: 'CONTINGENCY',
	                            to: 'process_fallback',
	                            routing_reason: 'BUYER_INELIGIBLE'
	                        });
	                    }
	
	                    if (!result.eligible) {
	                        $scope.dependencyEligibility = false;
	                        throw new $FallbackError({
	                            reason: 'buyer_ineligible',
	                            product: 'ux'
	                        });
	                    }
	                }
	            });
	
	            if (walletTokenization) {
	                var params = {
	                    wallet_brand: 'APAY',
	                    tenant_id: 'Hermes'
	                };
	                if ($meta.query && $meta.query.wallet_id) {
	                    params.wallet_id = $meta.query.wallet_id;
	                }
	                if ($meta.query && $meta.query.jwt) {
	                    params.jwt = $meta.query.jwt;
	                }
	
	                $scope.tokenizedWalletEligibility.reload({
	                    params: params,
	                    batch: {
	                        name: 'setbuyer',
	                        id: 'tokenizedWalletLightEligibility',
	                        silent: $scope.useTokenizationAnimation,
	                        dependencies: ['eConsent', 'buyerEligibility']
	                    },
	                    success: function success(result) {
	                        if (!result.eligible) {
	                            var msg = 'tokenized_wallet_ineligible_for_provisioning';
	                            $logger.info(msg);
	
	                            if ($scope.dependencyEligibility) {
	                                $scope.dependencyEligibility = false;
	                                _uiRouter.$state.go('checkout.genericError', {
	                                    code: 'ANDROID_PAY_ELIGIBILITY_ERROR'
	                                });
	                            }
	                        }
	                    }
	                });
	            }
	
	            $scope.checkoutSession.action('create', {
	                data: {
	                    baToken: $scope.checkoutCart.billing && $scope.checkoutCart.billing.ba_token,
	                    preselected_fi_type: $scope.checkoutAppData.is_second_button_txn ? 'credit' : undefined
	                },
	                batch: {
	                    name: 'setbuyer',
	                    id: 'createCheckoutSession',
	                    silent: $scope.useTokenizationAnimation,
	                    dependencies: walletTokenization ? ['eConsent', 'buyerEligibility', 'tokenizedWalletLightEligibility'] : ['eConsent', 'buyerEligibility']
	                },
	                success: function success(result) {
	
	                    fptiData.available_plan_count = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : '0';
	
	                    $logger.info('checkout_fpti', fptiData);
	
	                    if (!$scope.dependencyEligibility) {
	                        return;
	                    }
	
	                    if ($scope.auth.password_less && $scope.checkoutCart.isBilling()) {
	                        if ($feature('pomaPasswordRecovery')) {
	                            _uiRouter.$state.go('checkout.createPassword', { targetPage: 'BILLING_AGREEMENTS' });
	                        }
	                        return;
	                    }
	
	                    if ($scope.checkoutAppData.is_second_button_txn) {
	                        return $capeRedirectUtil.handleCapeRouting(result, $scope.checkoutCart, $scope.token);
	                    }
	
	                    return $KmliUpsell.eligible($scope.token).then(function (isEligible) {
	                        if (isEligible.eligible) {
	
	                            var stateName = isEligible.type === 'member' ? 'KMLI_UPSELL' : 'KMLI_reactivation';
	
	                            $logger.info('checkout_fpti', {
	                                from: stateName,
	                                to: 'prepare_kmli_upsell'
	                            });
	
	                            var path = $DeviceInfo.isMobile() ? 'checkout.FullpageOnetouchUpsell' : 'checkout.review.oneTouchUpsell';
	
	                            return _uiRouter.$state.go(path, { oneTouchFlowName: 'checkout' });
	                        }
	
	                        if ($scope.auth.rtExchanged && $feature('rmSpinnerText')) {
	                            $scope.checkoutSession.message = {
	                                type: 'success',
	                                msgKeys: ['login.loggedInWithOneTouch']
	                            };
	                        }
	
	                        if ($scope.checkoutSession.negBals) {
	                            return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
	                        }
	
	                        if ($scope.checkoutCart.isWalletTokenization()) {
	                            $logger.info('tokenized_wallet', {
	                                'from': 'PP_AndroidPay_Info',
	                                'to': 'prepare_PP_AndroidPay_Info',
	                                'context_id': $scope.token,
	                                'context_type': 'EC-Token',
	                                'billing_token': $meta.baToken
	                            });
	                            $('#outerWrapper').addClass('tokenization');
	                            $timeout(function () {
	                                return _uiRouter.$state.go('checkout.tokenizationInfo');
	                            }, 1200);
	                        } else {
	                            _uiRouter.$state.go('checkout.review');
	                        }
	                    });
	                },
	                contingencies: {
	                    // override contingency.js handler with custom logic to support both xoon/hermes flows
	                    NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, err) {
	                        // Check if negative case has been previously handled.
	                        if (!$scope.dependencyEligibility) {
	                            return;
	                        }
	                        // come from guest or have alternate FI options, go to review
	                        if ($util.param('redirectToHermesOnUpopCancel') === 'xoon' || err && err.resolution && err.resolution.data && err.resolution.data.alternate_options) {
	                            _uiRouter.$state.go('checkout.review');
	                        } else {
	                            // else go to addCard
	                            _uiRouter.$state.go('checkout.updateCard.addCardFlow.addCard');
	                        }
	                    },
	                    NEED_DEBIT_CARD: handleNoValidTopupFiContingency,
	                    EXPIRED_DEBIT_CARD: handleNoValidTopupFiContingency,
	                    DEFAULT: handleContingency
	                }
	            });
	        };
	
	        // Sorry for the indirection here.  There's postAuth, so "preAuth" compliments it well (easier on the brain)
	        $scope.preAuth = function () {
	
	            // For UL, batch up eConsent, buyerEligibility, xoSession
	            if ($scope.ulEligibility) {
	                $scope.setBuyer();
	            }
	        };
	
	        $scope.onSuccess = function () {
	
	            // If the experiment is enabled, we already have what we need, so /quit.
	            if ($scope.ulEligibility) {
	                return;
	            }
	
	            $scope.setBuyer();
	        };
	
	        function fetchGuestButtonPxpVarients() {
	            $scope.guestVariant = {};
	            // PXP for showing Guest button Call-To-Actions
	            return $pxp('xo_hermesnode_guest_cta', {
	                'ctx.COUNTRY': $locale.country
	            }, '(xo_hermesnode_guest_cta_)(.*)').then(function (result) {
	                var treatmentName = result && result.treatment_name || '';
	
	                switch (treatmentName) {
	                    case 'xo_hermesnode_guest_cta_standard_label_treatment':
	                        $scope.guestVariant.standardGuestBtn = true;
	                        $scope.guestVariant.test = true;
	                        break;
	                    case 'xo_hermesnode_guest_cta_card_icons_treatment':
	                        $scope.guestVariant.cardIconsAboveGuestBtn = true;
	                        $scope.guestVariant.test = true;
	                        break;
	                    default:
	                    // Do nothing
	                }
	            });
	        }
	
	        (0, _squid.$populate)($scope, {
	            flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
	                params: {
	                    geolocation: $meta.geolocation,
	                    localeCountry: $locale.country // We need this till we completely migrate to server side locale resolution
	                }
	            }),
	            auth: $AuthModel.instance(),
	            checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
	            checkoutCart: $CheckoutCartModel.instance(_angular.$rootScope.token)
	        }).then(function () {
	            if ($scope.flowEligibility.guest) {
	                return fetchGuestButtonPxpVarients();
	            }
	            $('.paypalHeaderWrapper').removeClass('paypalCredit');
	            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
	        }).then(function () {
	            if ($scope.auth.accessToken()) {
	                return $scope.auth.reload({
	                    headers: {
	                        'x-paypal-internal-euat': $scope.auth.accessToken()
	                    },
	                    resultModel: $scope.auth,
	                    success: function success() {
	                        delete $scope.auth.access_token;
	                    },
	                    contingencies: {
	                        DEFAULT: function DEFAULT(name) {
	                            throw new $FallbackError({
	                                reason: name.toLowerCase(),
	                                product: 'ux'
	                            });
	                        }
	                    }
	                });
	            }
	        }).then(function () {
	            return $loginEligibility($scope.token, !$scope.autoLogin).then(function (result) {
	                if (result === 'unifiedLogin') {
	                    $scope.ulEligibility = true;
	                } else if (result === 'apsIntegration') {
	                    $scope.apsIntegration = 'apsIntegration';
	                } else if (result === 'apsIntegrationRM') {
	                    $scope.apsIntegration = 'apsIntegrationRM';
	                }
	            }).then(function () {
	
	                var reinitDisplay = function reinitDisplay() {
	                    $scope.promptlogin = false;
	                    $scope.hideGuest = false;
	                    $scope.autoLogin = true;
	                    delete $stateParams.targetPage;
	                    delete $stateParams.showNotYou;
	                };
	
	                $scope.logout = $scope.promptlogin ? function () {
	                    $logger.info('not_you_logout');
	                    $logger.info('checkout_fpti', {
	                        from: 'LOGIN_UL',
	                        to: 'login_with_diff_user'
	                    });
	                    $scope.auth.action('logout').then(function () {
	                        $scope.auth.reload().then(function () {
	                            reinitDisplay();
	                            $scope.reload();
	                        });
	                    });
	                } : function () {
	                    $logger.info('logout_switch_display');
	                    reinitDisplay();
	                };
	            });
	        });
	    }
	});
	
	angular.value("$xoPayWithSelectionPageComponent", $xoPayWithSelectionPageComponent);
	_angular.$rootScope;
	
	_miniBrowser.$miniBrowser;
	
	_integration.$integration;
	
	_squid.$Component;
	
	_squid.$pxp;
	
	_squid.$populate;
	
	_logger.$logger;
	
	_index.$CheckoutAppDataModel;
	
	_venmoInfo.venmoInfo;
	
	_uiRouter.$state;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./components/jquery/dist/jquery.min.js")))

/***/ },

/***/ "./pages/xo-pay-with-selection/template.html":
/***/ function(module, exports) {

	module.exports = "<section id=\"payWithSelection\" ng-class=\"{standardGuestBtn: guestVariant.standardGuestBtn, guestBtnOnTop: guestVariant.guestBtnOnTop, cardIconsAboveGuestBtn: guestVariant.cardIconsAboveGuestBtn}\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\" id=\"selectPaymentMethodAccordion\">\n\n            <section id=\"paypalDrawer\" class=\"drawer\" ng-class=\"{hidden: !expandPaypalDrawer}\" ng-click=\"clickPaypalDrawer()\" content>\n                <xo-title title-txt=\"{{content('login.loginTitle')}}\" class=\"span17\"></xo-title>\n                <span class=\"arrow\" ng-class=\"{expand: expandPaypalDrawer }\"></span>\n\n                <xo-login-handler ng-click=\"$event.stopPropagation()\" ng-show=\"expandPaypalDrawer\" token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\"\n                                  contingency-callback=\"onContingency\" ul-eligibility=\"ulEligibility\" pre-auth=\"preAuth\"\n                                  aps-integration=\"apsIntegration\" batch=\"batch\"\n                                  login-submit=\"loginSubmit\" flowcontext=\"flowcontext\" logout=\"logout\" export=\"loginHandler\" hide-title=\"hideLoginHandlerTitle\"></xo-login-handler>\n                <xo-onboarding-section ng-show=\"expandPaypalDrawer\" ng-click=\"$event.stopPropagation()\" token=token ng-hide=\"hideGuest\"></xo-onboarding-section>\n            </section>\n\n            <section id=\"venmoDrawer\" class=\"drawer\" ng-class=\"{hidden: !expandVenmoDrawer}\" ng-click=\"clickVenmoDrawer()\" content>\n                <xo-title title-txt=\"{{'Pay with '}}\" class=\"span17\"></xo-title>\n                <span class=\"venmoLogo\"></span>\n                <span class=\"arrow\" ng-class=\"{expand: expandVenmoDrawer, paypalExpanded: expandPaypalDrawer}\"></span>\n                <p ng-click=\"$event.stopPropagation()\" class=\"legal\">Purchases made using Venmo are subject to the <a href=\"https://venmo.com/legal/us-user-agreement\">Venmo User Agreement</a>, <a href=\"https://venmo.com/legal/us-privacy-policy\">Venmo Privacy Policy</a>, and Venmo Buyer Protection Policy, rather than PayPal's policies and agreements.</p>\n                <a class=\"btn full venmoBtn\" link-button ng-click=\"sendToVenmo()\">Continue with Venmo</a>\n            </section>\n\n\n            <div ng-if=\"promptlogin\" class=\"centerText\">\n                <hr class=\"sepPlain\" />\n\n                <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\" class=\"ng-binding\" tabindex=\"0\">{{ content('memberReview.notYou')}}</a>\n            </div>\n\n        </div>\n        <div class=\"span10\" ng-if=\"!loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\"\n                            text-content=\"login.propVal\"></xo-value-props>\n        </div>\n\n        <div class=\"span10\" ng-if=\"loginDesignExp\">\n            <xo-value-props type=\"login\" title=\"{{content(loginDesignExp.propHeader)}}\"\n                            text-content=\"{{loginDesignExp.propText}}\"\n                            image-url=\"{{loginDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n    <div class=\"infoLoader\"  ng-if='useTokenizationAnimation'>\n        <div class='logo_wrapper'>\n            <div class='partner_logo'></div>\n        </div>\n        <div class=\"loader\">\n            <xo-card-loader state=\"setbuyerProgress\" auth=\"auth\" message=\"{{content('topup.addingAndroidPay')}}\"></xo-card-loader>\n        </div>\n    </div>\n</section>\n"

/***/ },

/***/ "./pages/xo-pay-with-selection/style.less":
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__("../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-pay-with-selection/style.less");
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./style.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./style.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-pay-with-selection/style.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, "#payWithSelection .wallet_vprop_img{background:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png\") 0 0 no-repeat;height:104px}#payWithSelection .inline-prop{font-size:.85em}#payWithSelection .trayInner{margin:0 0 25px;padding:0}#payWithSelection #forgotPasswordSection{margin:16px auto 19px;padding-bottom:5px}#payWithSelection .alpha{margin-top:0}#payWithSelection .pr{position:relative;padding-top:25px}#payWithSelection .pr.hasError{margin-top:0}#payWithSelection .loginBtn{margin-top:5px}#payWithSelection .msgPage{padding:15px 0 5px}#payWithSelection .row-fluid>.span10{float:right}#payWithSelection p{text-align:center;color:#6c7378}#payWithSelection p,#payWithSelection p.a{font-weight:400;font-size:75%}#payWithSelection section .login{margin-top:25px}#contents.payWithSelection{padding:0}#paypalDrawer span.arrow,#venmoDrawer span.arrow,section.drawer{-webkit-transition:all .3s ease-in-out;transition:all .3s ease-in-out}#selectPaymentMethodAccordion{margin-bottom:30px}#selectPaymentMethodAccordion .drawer{overflow:hidden;height:430px;padding:22px 15px}#paypalDrawer{border-bottom:1px solid #ccc}#paypalDrawer h1{display:inline-block;vertical-align:middle;margin:0;padding-right:125px}#venmoDrawer .btn.venmoBtn{background-color:#3d95ce;border-color:#3d95ce}#venmoDrawer p.legal{margin-top:20px}#venmoDrawer h1{display:inline-block;vertical-align:middle;margin-bottom:0;margin-right:5px}#selectPaymentMethodAccordion .drawer.hidden{height:25px}#paypalDrawer span.arrow{background-clip:padding-box;background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/venmo_arrow.png\");background-repeat:no-repeat;background-size:25px 25px;height:25px;display:inline-block;vertical-align:middle;width:25px;top:20px;right:25px;float:right}#paypalDrawer span.arrow.expand{-webkit-transform:rotate(90deg);transform:rotate(90deg)}#venmoDrawer span.venmoLogo{background-image:url(\"https://www.paypalobjects.com/images/checkout/venmo/venmo-logo-blue.png\");background-size:85px 17px;height:17px;width:85px;padding-right:110px}#venmoDrawer span.arrow,#venmoDrawer span.venmoLogo{background-clip:padding-box;background-repeat:no-repeat;display:inline-block;vertical-align:middle}#venmoDrawer span.arrow{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/venmo_arrow.png\");background-size:25px 25px;height:25px;width:25px;top:85px;right:25px;float:right}#venmoDrawer span.arrow.expand{-webkit-transform:rotate(90deg);transform:rotate(90deg)}#venmoDrawer span.arrow.paypalExpanded{top:361px}.onboardingSection .inline-prop{font-size:.85em;text-align:center;margin-top:10px}.onboardingSection .guestHeading{position:relative}.onboardingSection .orSeparator{height:auto;border-top:1px solid #ccc;text-align:center;margin:25px 0 5px}.onboardingSection .orSeparator .textInDivider{background-color:#fff;color:#6c7378;display:inline-block;padding:0 .5em;position:relative;top:-.7em}.noscript{margin:0;padding:30px;width:58%;border:3px solid red;position:absolute;top:95px;left:20%;display:block;z-index:1001;background:#fff;font-size:18px;text-align:center}.payWithSelection .span14.trayInner{padding:0}.capeRedirect{height:300px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2){#payWithSelection .wallet_vprop_img{background-image:url(\"https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v2_2x.png\");background-size:195px 104px}}@media (min-width:0) and (max-width:30em){#payWithSelection .pr{margin-top:0}#payWithSelection .trayInner{margin:0}#paypalDrawer h1{padding-right:100px}#venmoDrawer span.venmoLogo{padding-right:90px}}", ""]);
	
	// exports


/***/ },

/***/ "./pages/xo-checkout/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _uiRouter = __webpack_require__("./components/angular-ui-router/release/angular-ui-router.min.js");
	
	var _integration = __webpack_require__("./js/lib/integration.js");
	
	var _index = __webpack_require__("./components/xo-models/src/auth/index.js");
	
	var _index2 = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	var _venmoInfo = __webpack_require__("./components/xo-venmo-components/src/venmo-info/index.js");
	
	var _fn = __webpack_require__("./components/xo-login-components/src/login/fn.js");
	
	__webpack_require__("./components/xo-ui-components/src/spinner/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/merchant-header/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/header/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/footer/directive.js");
	
	__webpack_require__("./components/xo-page-components/src/cart/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/directionality/directive.js");
	
	__webpack_require__("./components/xo-ui-components/src/error-tooltip/directive.js");
	
	__webpack_require__("./components/xo-validation/dist/directive.js");
	
	__webpack_require__("./components/xo-login-components/src/login-overlay/directive.js");
	
	var _template = __webpack_require__("./pages/xo-checkout/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoCheckoutComponent', {
	
	    tag: 'xo-checkout',
	    template: _template2['default'],
	
	    resolve: {
	        pxp: function pxp() {
	            var pxp = _squid.$config.purchaseProtectionProp.pxp;
	
	            return {
	                purchaseProtectionAlt: (0, _squid.$pxp)(pxp.pgName, pxp.patterns)
	            };
	        }
	    },
	
	    controller: function controller() {
	        if (_angular.$location.path() === '/checkout') {
	            _uiRouter.$state.go('checkout.review');
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            this.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
	            this.token = _angular.$rootScope.token;
	            this.locale = _squid.$locale;
	            this.redirectiframe = _angular.$rootScope.partnerIntegration;
	            this.redirectLightbox = true;
	            this.escapeHatchInContext = !_angular.$rootScope.partnerIntegration;
	
	            this.reviewUrl = 'checkout.review';
	            this.isApp = _index2.$DeviceInfo.isApp();
	
	            _angular.$document.bind('click', function (event) {
	                _this.$broadcast('clickBody', event.target);
	            });
	
	            function rtl() {
	                if ((0, _squid.$feature)('rtl')) {
	                    _angular.$document.prop('documentElement').setAttribute('dir', _squid.$locale.metadata.directionality);
	                }
	            }
	
	            this.$on('metadataChange', rtl);
	            rtl();
	
	            _fn.$fn.trigger();
	        },
	        populate: function populate() {
	            var _this2 = this;
	
	            if (this.pxp.purchaseProtectionAlt) {
	                _squid.$config.features.DEFAULT.propValue = false;
	            }
	
	            function requiresRiskyLogin(state) {
	                var auth = _index.$AuthModel.instance();
	                return state.loginRequired && auth.remembered;
	            }
	
	            function displayRiskyLogin(oldState, newState, newParams) {
	
	                if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
	                    _logger.$logger.info('login_overlay_suppressed');
	                    return;
	                }
	
	                var isUserinitiated = oldState.template && !oldState.name.match(/checkout\.login/);
	
	                if (isUserinitiated) {
	                    var stateName = newState && newState.name;
	                    var subFlowName = stateName && stateName.replace(/^.*\./, '');
	
	                    if (subFlowName === 'sepaAgreement') {
	                        _uiRouter.$state.go('checkout.review');
	                    }
	
	                    _angular.$rootScope.$broadcast('$insufficientPermission', {
	                        oldState: oldState.name,
	                        newState: newState.name,
	                        pageOnOverlay: newState.pageOnOverlay
	                    });
	                } else {
	                    var auth = _index.$AuthModel.instance();
	                    var cause = newParams && newParams.message ? newParams.message : newState.name.replace(/^.*\./, '');
	                    _logger.$logger.info('RISKY_LOGIN_TRANSITION_' + cause);
	                    var showPasswordRecovery = (0, _squid.$feature)('pomaPasswordRecovery') && auth.password_less;
	                    var transition = showPasswordRecovery ? 'checkout.createPassword' : 'checkout.login';
	                    _uiRouter.$state.go(transition, {
	                        targetPage: cause,
	                        showNotYou: true
	                    });
	                }
	
	                return false;
	            }
	
	            var cancelStateChangeEventListener = _angular.$rootScope.$on('$stateChangeStart', function (event, newState, newParams, oldState) {
	                if (_venmoInfo.venmoInfo.isVenmo()) {
	                    _this2.showVenmoHeader = _venmoInfo.venmoExperience.get(_this2.token);
	                }
	
	                if (requiresRiskyLogin(newState)) {
	                    event.preventDefault();
	                    displayRiskyLogin(oldState, newState, newParams);
	                }
	            });
	
	            this.$on('$destroy', cancelStateChangeEventListener);
	
	            if (requiresRiskyLogin(_uiRouter.$state.current)) {
	                displayRiskyLogin(_uiRouter.$state.current, _uiRouter.$state.current);
	            }
	        }
	    }
	});
	
	
	_angular.$rootScope;
	
	_angular.$document;
	
	_angular.$location;
	
	_squid.$Component;
	
	_squid.$config;
	
	_squid.$feature;
	
	_squid.$pxp;
	
	_squid.$locale;
	
	_logger.$logger;
	
	_uiRouter.$state;
	
	_integration.$integration;
	
	_index.$AuthModel;
	
	_index2.$DeviceInfo;
	
	_venmoInfo.venmoInfo;
	
	_venmoInfo.venmoExperience;
	
	_fn.$fn;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-ui-components/src/spinner/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner/template.html"), __webpack_require__("./components/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-spinner.directive', ['squid', 'beaver']).directive('xoSpinner', function () {
	
	        return {
	            scope: {},
	            template: template,
	            controller: function controller($scope, $element, $rootScope, $Api, $locale, $logger, $loader, $timeout, $window) {
	
	                var $body = angular.element(document.getElementsByTagName('body'));
	                var $priorActiveElement = $();
	                var $capturedElement = $();
	                var $header = $('header');
	                var $slidingArea = $('#main');
	                var $footer = $('footer');
	
	                /**
	                 * This hides page content from any screen readers.
	                 * When the spinner's active, the only thing that should be read out is the "Loading..." text.
	                 *
	                 * The only crappy thing here is the spinner's nested deep in the content, so please excuse this jQuery crap.
	                 * At the very least, let's cache these selectors :|
	                 */
	                function hidePageContentFromScreenReader(toggle) {
	                    $header.attr('aria-disabled', toggle);
	                    $slidingArea.attr('aria-disabled', toggle);
	                    $footer.attr('aria-disabled', toggle);
	                }
	
	                function preventDefault(event) {
	                    event.preventDefault();
	                }
	
	                function captureFocus(event) {
	                    if (!$element.has(event.target).length) {
	                        $capturedElement = $(event.target);
	                    }
	                }
	
	                function setLoadingMessage(message) {
	                    if (angular.isObject(message)) {
	                        $scope.message = message.heading;
	                        $('#spinnerMessage').css('font-size', '17.5px');
	                        $('#spinnerMessage').html(message.heading);
	                        $('#spinnerSubHeading').html(message.subHeading);
	                    } else {
	                        $scope.message = message;
	                        $('#spinnerMessage').html(message);
	                    }
	                }
	
	                function showSpinner() {
	                    $scope.loading = true;
	                    $logger.info('show_loading_spinner');
	                    $body.addClass('loading');
	
	                    // remember what was previously focused
	                    $priorActiveElement = $(':focus');
	
	                    $(':input, a').blur();
	
	                    hidePageContentFromScreenReader(true);
	
	                    if ($loader.firstLoad()) {
	                        setLoadingMessage($locale.content.get('base.processing'));
	                    }
	
	                    // focus on the message so that screen readers will let the user know the page is loading
	                    $(document).on('keydown', preventDefault);
	                    $(document).on('focusin', captureFocus);
	                    $timeout(function () {
	                        $('#spinner-message').focus();
	                    });
	                }
	
	                function hideSpinner() {
	                    $scope.loading = false;
	                    $logger.info('hide_loading_spinner');
	                    $('#preloaderSpinner').hide();
	                    $body.removeClass('loading');
	                    $(document).off('keydown', preventDefault);
	                    $(document).off('focusin', captureFocus);
	
	                    hidePageContentFromScreenReader(false);
	
	                    // Focus captured element if focus was given to an element while spinner was active.
	                    if ($capturedElement.length && $(document.body).has($capturedElement).length) {
	                        $capturedElement.focus();
	                        // Focus element that had focus before if it is still within the document
	                    } else if ($priorActiveElement.length && $(document.body).has($priorActiveElement).length) {
	                        $priorActiveElement.focus();
	                    } else {
	                        // If focus is not managed, default to focusing sliding area. Fixes FF and IE bug where tab focus starts from
	                        // the element last clicked, rather than top of page.
	                        $slidingArea.focus();
	                        $window.scrollTo(0, 0);
	                    }
	                    $priorActiveElement = $();
	                    $capturedElement = $();
	                }
	
	                var cancelStartLoad = $rootScope.$on('startLoad', showSpinner);
	                var cancelAllLoaded = $rootScope.$on('allLoaded', hideSpinner);
	
	                var cancelSetLoadingMessage = $rootScope.$on('loadingMessage', function (event, text) {
	                    setLoadingMessage(text);
	                });
	
	                $scope.$on('$destroy', function () {
	                    hideSpinner();
	                    cancelStartLoad();
	                    cancelAllLoaded();
	                    cancelSetLoadingMessage();
	                });
	
	                if ($loader.isLoading()) {
	                    showSpinner();
	                }
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"loading\" id=\"spinner\" class=\"spinner\">\n    <div class=\"spinWrap\">\n        <p class=\"spinnerImage\"></p>\n        <p class=\"loader\"></p>\n        <p id=\"spinner-message\" tabIndex=\"0\" role=\"alert\" class=\"loadingMessage\">{{message}}</p>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/merchant-header/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-models/src/checkout/index.js");
	
	var _index2 = __webpack_require__("./components/xo-models/src/user/index.js");
	
	var _template = __webpack_require__("./components/xo-page-components/src/merchant-header/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoMerchantHeaderDirective', {
	    tag: 'xo-merchant-header',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var',
	            required: false
	        },
	        merchant: {
	            type: 'var',
	            required: false
	        }
	    },
	
	    resolve: {
	        models: function models() {
	            if (this.props.token) {
	                return {
	                    checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()
	                };
	            }
	        }
	    },
	
	    lifecycle: {
	        populate: function populate() {
	            if (this.props.token && !_index2.$CheckoutInputDataModel.instance(this.props.token).isEbayTxn()) {
	                this.merchant = this.models.checkoutAppData.merchant;
	            }
	        }
	    }
	});
	
	
	(0, _squid.$registerDirective)('xoMerchantImageResize', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element) {
	            element.bind('load', function () {
	                var MAX_WIDTH = 780;
	                var MAX_HEIGHT = 90;
	
	                if (this.width > MAX_WIDTH) {
	                    var ratio = MAX_WIDTH / this.width;
	                    var height = this.height * ratio;
	
	                    this.width = MAX_WIDTH;
	                    this.height = height > MAX_HEIGHT ? MAX_HEIGHT : height;
	                }
	            });
	        }
	    };
	});
	
	_squid.$Component;
	
	_squid.$registerDirective;
	
	_index.$CheckoutAppDataModel;
	
	_index2.$CheckoutInputDataModel;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-page-components/src/merchant-header/template.html":
/***/ function(module, exports) {

	module.exports = "<header role=\"banner\">\n    <div id=\"header\" class=\"merchantHeader clearfix\">\n        <div class=\"headerWrapper\">\n            <span class=\"merchantName\" directionality-text=\"merchant.brand_name || merchant.merchant_name || merchant.merchant_email\" ng-if=\"!(merchant.logo_url || merchant.imageUrl)\">\n             {{ merchant.brand_name || merchant.merchant_name || merchant.merchant_email }}\n         \t</span>\n            <img ng-src=\"{{merchant.logo_url || merchant.imageUrl}}\" alt=\"{{ merchant.brand_name || merchant.merchant_name || merchant.merchant_email }}\" ng-if=\"merchant.logo_url || merchant.imageUrl\" xo-merchant-image-resize/>\n        </div>\n    </div>\n</header>\n"

/***/ },

/***/ "./components/xo-page-components/src/header/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-page-components/src/header/styles.less");
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _index = __webpack_require__("./components/xo-device-info/dist/index.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/header/template.html"), __webpack_require__("./components/xo-page-components/src/cart/directive.js"), __webpack_require__("./components/xo-ui-components/src/escape-hatch/closeFrame/directive.js"), __webpack_require__("./components/xo-form-components/src/language-options/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-header.directive', ['squid', 'xo-cart.directive', 'xo-escape-hatch.closeFrame.directive', 'xo-language-options.directive']).directive('xoHeader', function () {
	        return {
	            template: template,
	            scope: {
	                showCartTotal: '=',
	                renderCartContainer: '=',
	                token: '=',
	                isUnbranded: '=',
	                unbrandedTitle: '=',
	                unbrandedSubTitle: '=',
	                languageSwitch: '=?',
	                redirectiframe: '=',
	                redirectLightbox: '=',
	                isVenmoFlow: '='
	            },
	            controller: function controller($scope, $rootScope, $renderContent) {
	                $scope.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
	                $scope.isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
	                // $util.assert($scope.token, 'Expected token');
	                $scope.title = $renderContent($scope.unbrandedTitle);
	                $scope.subTitle = $renderContent($scope.unbrandedSubTitle);
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	_squid.$integration;
	
	_index.$DeviceInfo;

/***/ },

/***/ "./components/xo-page-components/src/header/styles.less":
["./..", "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-page-components/src/header/styles.less"],

/***/ "../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-page-components/src/header/styles.less":
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__("../node_modules/css-loader/lib/css-base.js")();
	// imports
	
	
	// module
	exports.push([module.id, ".paypalHeader .languageToggleDisplay{position:relative;bottom:0;clear:left;right:0;top:20px;margin-bottom:20px}.paypalHeader #langDropdownBlock{right:auto}.paypalHeader .messengerLogo{margin-left:25%;padding-top:20px}.paypalHeader .venmoLogo{position:absolute;width:100px;height:20px;margin-top:30px;margin-left:10px;background-image:url(https://www.paypalobjects.com/images/checkout/venmo/venmo-logo-blue.png);background-repeat:no-repeat;background-size:100px 20px}@media (max-width:41.3125em){.paypalHeaderWrapper.langDropdown{margin-bottom:30px}}", ""]);
	
	// exports


/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/header/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"row-fluid paypalHeaderWrapper\" ng-class=\"{ 'langDropdown': languageSwitch && languageSwitch.show }\" content>\n    <div class=\"span14 clearfix paypalHeader\">\n\n        <span class=\"pageTitle\" ng-if=\"unbrandedTitle\">{{title}}</span>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && !isVenmoFlow\" id=\"paypalLogo\" class=\"logo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && isVenmoFlow\" class=\"venmoLogo\"><span class=\"accessAid\">Venmo Checkout</span></div>\n        <div ng-if=\"isMessengerBAIntegration\">\n            <div ng-if=\"isMobile\">\n                <img src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_mobile_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n            <div ng-if=\"!isMobile\">\n                <img src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n        </div>\n        <xo-cart token=\"token\" show-cart-total=\"showCartTotal\" render-cart-container=\"renderCartContainer\"></xo-cart>\n\n        <xo-language-options ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n\n        <div class=\"subTitle\" ng-if=\"unbrandedSubTitle\">{{subTitle}}</div>\n        <xo-close-frame redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-close-frame>\n    </div>\n</div>"

/***/ },

/***/ "./components/xo-page-components/src/cart/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/template.html"), __webpack_require__("./components/xo-page-components/src/cart/lib/pxp.js"), __webpack_require__("./components/xo-page-components/src/cart/lib/cart_pxp.js"), __webpack_require__("./components/xo-page-components/src/cart/lib/ui.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js"), __webpack_require__("./components/xo-page-components/src/cart/cartWrapper/directive.js"), __webpack_require__("./components/xo-page-components/src/cart/itemDetails/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, squid, template) {
	
	    squid.module('xo-cart.directive', ['squid', 'xomodel.checkout', 'xo-cart.pxp', 'xo-cart.ui', 'xo-cart.cart-wrapper.directive', 'xo-cart.item-details.directive', 'xo-accessibility.directive']).directive('xoCart', function () {
	
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                showCartTotal: '=',
	                renderCartContainer: '=',
	                token: '='
	            },
	            controller: function controller( // eslint-disable-line max-params
	            $scope, $populate, $rootScope, $util, $state, $CheckoutCartModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $pxpCartAmt, $pxpCartDesc) {
	
	                $util.assert($scope.token, 'Expected token');
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                    checkoutCart: $CheckoutCartModel.instance($scope.token),
	                    payee: $CheckoutPayeeModel.instance($scope.token)
	                }).then($pxpCartDesc).then(function loadCartData(canShowCart) {
	
	                    var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
	                    var cartDesc = $scope.checkoutCart.get('purchase.description');
	                    $scope.note = $scope.checkoutCart.get('note');
	
	                    if (!canShowCart) {
	                        cartDesc = '';
	                    } else
	                        // resolve string in descriptions array since the only element may be `null`
	                        // TODO: fix backend to return a string, to avoid this conditional
	                        if (cartDesc && angular.isString(cartDesc[0])) {
	                            cartDesc = cartDesc[0];
	                        } else {
	                            cartDesc = '';
	                        }
	
	                    $scope.desc = cartDesc;
	                    $scope.hasItems = !$scope.renderCartContainer && !emptyCart;
	                    $scope.showArrow = !$scope.checkoutAppData.flags.hide_cart_details && (cartDesc || $scope.hasItems || $scope.note) && !$scope.checkoutCart.isMultiSellerPurchase();
	
	                    // add details to render to the checkoutCart items
	                    $scope.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
	                        item.details = {};
	
	                        if (item.quantity > 1) {
	                            item.details.price = item.price.amount;
	                            item.details.quantity = squid.formatQuantity(item.quantity);
	                        }
	
	                        if (item.description) {
	                            if (!item.name) {
	                                item.name = item.description;
	                            } else {
	                                item.details.description = item.description;
	                            }
	                        }
	
	                        // move options to detail section
	                        if (item.item_option_selections) {
	                            item.details.hasSelections = true;
	                            item.details.item_option_selections = item.item_option_selections;
	                        }
	
	                        if (item.sku) {
	                            item.details.sku = item.sku;
	                        }
	
	                        item.hasDetails = Object.keys(item.details).length > 0;
	                        item.details.hasMore = item.hasDetails || item.details.hasSelections;
	                    });
	
	                    // Mapping of field name as recieved by API to corresponding property key
	                    $scope.amountHeaders = {
	                        'total': 'header.total',
	                        'subtotal': 'header.itemTotal',
	                        'tax': 'header.tax',
	                        'shipping': 'header.shipping',
	                        'insurance': 'header.insurance',
	                        'handling_fee': 'header.handling',
	                        'shipping_discount': 'header.shippingDiscount',
	                        'description': 'header.description',
	                        'discount': 'header.discount'
	                    };
	
	                    // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
	                    // are not available and purchase amount is not zero.
	                    var userAction = $scope.userAction = $scope.checkoutAppData.useraction();
	                    var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && emptyCart;
	
	                    return $pxpCartAmt($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
	                        $scope.showAmt = showAmount;
	                    });
	                }).then(function handleCartOpenClose() {
	                    // the cart is only automatically open under the following criteria:
	                    // 1. the cart has a 'note to buyer' ($scope.note is defined)
	                    // 2. the cart was not previously automatically opened before
	                    // 3. the state has transitioned to checkout.review or checkout.guest
	                    function decideShowCart(currentState) {
	                        if ($scope.note && !$scope.openedAlready && /^checkout\.(review|guest)$/.test(currentState)) {
	                            $scope.openedAlready = true; // may have been undefined before
	                            return true;
	                        }
	
	                        return false;
	                    }
	
	                    $scope.showCartItem = function (breakdown) {
	                        return breakdown.field_name !== 'total' && Number(breakdown.amount) !== 0;
	                    };
	
	                    $scope.showCart = decideShowCart($state.current.name);
	
	                    // TODO: Must we really couple this so tightly with the state transition names?
	                    var openCartListener = $rootScope.$on('$stateChangeSuccess', function (event, toState) {
	                        $scope.showCart = decideShowCart(toState.name);
	                    });
	                    $scope.$on('$destroy', openCartListener); // see http://stackoverflow.com/a/27016855 on why $destroy
	
	                    $scope.toggleCart = function ($event) {
	                        $scope.showCart = !$scope.showCart;
	                        $event.preventDefault();
	                    };
	
	                    $scope.closeCart = function ($event) {
	                        $scope.showCart = false;
	                        // for accessible autofocus on cart toggle link button
	                        $scope.$broadcast('cart-closed');
	                        if ($event) {
	                            $event.preventDefault();
	                        }
	                    };
	
	                    $scope.$on('clickBody', function ($event, target) {
	                        if ($scope.showCart && $(target).parents('.cartContainer').length === 0) {
	                            $scope.closeCart($event);
	                            $scope.$apply();
	                        }
	                    });
	
	                    // this listener / broadcast allows accessibility components to scan and focus inside the cart
	                    // when the cart is displayed
	                    $scope.$watch('showCart', function (showCart) {
	                        if (showCart) {
	                            $scope.$broadcast('cart-updated');
	                        }
	                    });
	                }).then(function handleEllipsisIssues() {
	                    // NOTE: the scattered broadcasts of "cart-updated" events are mostly
	                    // to allow the accessibility directives modal-box and focus-when to
	                    // know when to recalculate keyboard behavior / focus
	                    $scope.toolongTracker = {};
	
	                    // this function is invoked by the onEllipsis directive that tracks
	                    // if the item name won't fit within the restricted space.
	                    $scope.toolong = function (idx) {
	                        $scope.toolongTracker[idx] = true;
	                        $scope.$broadcast('cart-updated');
	                    };
	
	                    $scope.showMore = function (idx, type) {
	                        // there are 2 types of more, "floating" when the name is too long
	                        // and "inline" when the name can fit, but there are additional details.
	                        //
	                        // Show a more if the item
	                        // 1. has an expanded state
	                        // 2. is not already expanded
	                        // 3. if it is appropriate to show that type.
	                        var itemIsTooLong = $scope.toolongTracker[idx];
	                        var isAppropriateType = itemIsTooLong && type === 'floating' || !itemIsTooLong && type === 'inline';
	
	                        return $scope.hasExpandedState(idx) && !$scope.isExpanded(idx) && isAppropriateType;
	                    };
	
	                    $scope.expandedIndex = -1; // initially, none of the line items are expanded
	                    $scope.isExpanded = function isExpanded(idx) {
	                        return idx === $scope.expandedIndex;
	                    };
	                    $scope.hasExpandedState = function hasExpandedState(idx) {
	                        // A line item is exandable if
	                        // 1. the name cannot fit in one line ($scope.toolongTracker) and/or
	                        // 2. there are details (attached to purchase.items in the cart)
	                        // 3. there is item number (sku) in the item
	                        var item = $scope.checkoutCart.get('purchase.items', [])[idx] || {};
	                        var nameTooLong = $scope.toolongTracker[idx];
	                        return nameTooLong || item.hasDetails || item.sku;
	                    };
	                    $scope.expand = function expand(idx) {
	                        $scope.expandedIndex = idx;
	                        $scope.$broadcast('cart-updated');
	                    };
	                    $scope.collapse = function collapse() {
	                        $scope.expandedIndex = -1;
	                        $scope.$broadcast('cart-updated');
	                    };
	
	                    $scope.$emit('dataLoaded');
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-page-components/src/cart/lib/ui.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	var _jquery = __webpack_require__("./components/jquery/dist/jquery.min.js");
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _decode_entities = __webpack_require__("./components/xo-page-components/src/cart/lib/decode_entities.js");
	
	var _decode_entities2 = _interopRequireDefault(_decode_entities);
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Register entity decoding filter in Angular
	_angular.$filterProvider.register('decodeEntities', _decode_entities2['default']);
	
	// if an element has an ellipsis text-overflow in effect (it must already have
	// the appropriate css styling) then invoke the function that is passed to the directive
	function getVisibleWidth(elem) {
	    var elemRect = elem.getBoundingClientRect();
	    // cross browser, returns decimals for ultra-precision
	    return elemRect.right - elemRect.left;
	}
	
	function getNaturalWidth(elem) {
	    var old = {
	        overflow: elem.style.overflow,
	        width: elem.style.width,
	        display: elem.style.display
	    };
	    var result;
	
	    elem.style.overflow = 'visible';
	    elem.style.width = 'auto';
	    elem.style.display = 'inline-block';
	    result = getVisibleWidth(elem);
	    elem.style.overflow = old.overflow;
	    elem.style.width = old.width;
	    elem.style.display = old.display;
	
	    return result;
	}
	
	// pre-determine approach to reading styles
	var getStyle = _angular.$window.getComputedStyle ?
	// modern browsers
	function (elem, style) {
	    return _angular.$window.getComputedStyle(elem)[style];
	} :
	// IE
	function (elem, style) {
	    return elem.currentStyle[style];
	};
	
	function hasEllipsis(elem) {
	    var overflowHidden = getStyle(elem, 'overflow') === 'hidden';
	    var textOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
	    var whiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';
	
	    if (overflowHidden && textOverflowEllipsis && whiteSpaceNowrap) {
	        return getVisibleWidth(elem) < getNaturalWidth(elem);
	    }
	
	    return false;
	}
	
	(0, _angular.$registerDirective)('onEllipsis', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function invokeSubscriber() {
	                (0, _angular.$parse)(attrs.onEllipsis)(scope);
	                scope.$apply();
	            }
	
	            (0, _angular.$timeout)(function () {
	                if (hasEllipsis(element[0])) {
	                    invokeSubscriber();
	                }
	            });
	        }
	
	    };
	});
	
	// Makes an element examine the outerHeight of its siblings
	// and the max-height of its parent, then sets a max-height for itself
	// so that everything fits within the limits of the parent. Note that it assumes
	// no other sibling also has dynamic-maxheight.
	(0, _angular.$registerDirective)('dynamicMaxheight', function () {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            function resizeContainer() {
	                var $element = (0, _jquery2['default'])(element);
	                var parentHeight = parseFloat(getStyle($element.parent()[0], 'max-height'));
	                var siblings = $element.siblings().filter(function () {
	                    var pos = getStyle((0, _jquery2['default'])(this)[0], 'position');
	                    return pos !== 'fixed' && pos !== 'absolute';
	                }).map(function getOuterHeights() {
	                    return (0, _jquery2['default'])(this).outerHeight();
	                });
	                var siblingsHeight = 0;
	                var i;
	
	                for (i = 0; i < siblings.length; i += 1) {
	                    siblingsHeight += siblings[i];
	                }
	
	                var spaceAvailable = parentHeight - siblingsHeight;
	
	                if (!isNaN(spaceAvailable)) {
	                    $element.css('max-height', spaceAvailable + 'px');
	                }
	            }
	
	            // if an expression is provided, it is used as an event to listen for and recalculate the height
	            if (attrs.dynamicMaxheight) {
	                scope.$on((0, _angular.$parse)(attrs.dynamicMaxheight)(scope), resizeContainer);
	            }
	
	            (0, _angular.$timeout)(resizeContainer);
	        }
	    };
	});
	
	_angular.$registerDirective;
	
	_angular.$filterProvider;
	
	_angular.$parse;
	
	_angular.$timeout;
	
	_angular.$window;

/***/ },

/***/ "./components/xo-page-components/src/cart/lib/decode_entities.js":
/***/ function(module, exports) {

	
	
	/**
	 * Takes a string with HTML entities within and renders it as the unicode
	 * characters they represent. This is done by leveraging the browser to
	 * perform this transformation internally. InnerText is chosen as the output
	 * so as to kill any HTML itself that was supplied.
	 *
	 * @param {Element} element any HTML element supporting innerText and
	 * innerHTML. Preferably one not connected to the DOM or visible in any way.
	 * @param {String} input a String containing HTML entities that need to be
	 * decoded and HTML stripped.
	 * @return {String} the same string with HTML tags removed and entities
	 * decoded.
	 */
	
	exports.__esModule = true;
	exports.decodeEntities = decodeEntities;
	exports['default'] = decodeEntitiesAngularFilter;
	function decodeEntities(element, input) {
	    // Escape opening tags on vulnerable tags
	    input = input.replace(/<(\/?)(html|script|body|meta|style|img|iframe|svg|link)/ig, '&lt;$1$2');
	    element.innerHTML = input;
	    return element.textContent || element.innerText;
	}
	
	function decodeEntitiesAngularFilter() {
	    // A constant key that can be used to find the element
	    var ENTITY_ELEM = '__xpc_entitydecoder__';
	
	    // Create the element if this is the first time this is called
	    if (!window[ENTITY_ELEM]) {
	        window[ENTITY_ELEM] = document.createElement('p');
	    }
	
	    // Retrieve the converter element rather than create one every
	    // time. Angular may call this filter many times repeatedly and
	    // we should make a small effort to optimize the process
	    var converter = window[ENTITY_ELEM];
	
	    /**
	     * Takes a string with HTML entities within and renders it as the unicode
	     * characters they represent. This is done by leveraging the browser to
	     * perform this transformation internally. InnerText is chosen as the output
	     * so as to kill any HTML itself that was supplied.
	     *
	     * @param {String} input a String containing HTML entities that need to be
	     * decoded and HTML stripped.
	     * @return {String} the same string with HTML tags removed and entities
	     * decoded.
	     */
	    return decodeEntities.bind(null, converter);
	}

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"cartContainer\" content ng-if=\"showAmt || showArrow\">\n    <div class=\"transactionDetailsContainer\" ng-class=\"{cart:showCart, hasAmount:showAmt}\">\n\n        <a href=\"#transactionCartDetails\"\n           class=\"transactionDetails scTrack:hermes-cartExpanded\"\n           aria-controls=\"transctionCartDetails\" aria-label=\"{{ content('base.shoppingCart') }}\" aria-haspopup=\"true\"\n           role=\"button\" ng-click=\"toggleCart($event)\"\n           focus-when focus-refresh-on=\"'cart-closed'\" ng-if=\"showArrow\">\n            <cart-wrapper ng-if=\"showArrow\" show-amt=\"showAmt\" show-arrow=\"showArrow\" token=\"token\"></cart-wrapper>\n        </a>\n\n        <cart-wrapper ng-if=\"!showArrow\" show-amt=\"showAmt\" show-arrow=\"showArrow\"\n                      token=\"token\"></cart-wrapper>\n\n        <div class=\"transctionCartDetails\" modal-box modal-refresh-on=\"'cart-updated'\" modal-cancel=\"closeCart()\" aria-hidden=\"{{ !showArrow }}\" ng-if=\"showArrow\">\n            <div class=\"details\" role=\"document\" focus-when focus-refresh-on=\"'cart-updated'\" focus-element=\"expandedIndex === -1 ? 'a.more': 'a.less'\">\n\n                <a id=\"closeCart\" link-button=\"content('header.close')\" class=\"actions focusableIcon\" ng-click=\"closeCart($event)\" ></a>\n\n                <div>\n                    <h3 ng-if=\"checkoutAppData.merchant\" class=\"merchantName\" ng-class=\"{merchantTitle: showAmt && (note || desc)}\" id=\"merchantName\">\n                        <span ng-if=\"note\">{{ content('header.noteFromMerchant', {merchant: checkoutAppData.merchant.brand_name}) }}</span>\n                        <span ng-if=\"!note\">{{ checkoutAppData.merchant.brand_name }}</span>\n                    </h3>\n                    <p ng-if=\"note || desc\"class=\"note\" ng-class=\"{ noteHighlighted: desc || !showAmt }\">\n                        <span ng-if=\"note\">{{ note | decodeEntities }}</span>\n                        <span ng-if=\"!note\">{{ desc | decodeEntities }}</span>\n                    </p>\n                </div>\n\n                <div dynamic-maxheight=\"'cart-updated'\" class=\"scrollable-middle\">\n                    <ul class=\"detail-items\" ng-if=\"hasItems\">\n                        <li ng-repeat=\"item in checkoutCart.purchase.items\" class=\"items\">\n\n                            <div class=\"itemNameContainer\" ng-class=\"{expanded: isExpanded($index)}\">\n                                <a class=\"more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'floating')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a>\n                                <span on-ellipsis=\"toolong($index)\" title=\"{{ item.name }}\" class=\"itemName\">{{ item.name }} <a class=\"less\" link-button=\"content('header.srLess')\" ng-show=\"isExpanded($index) && !item.hasDetails\" ng-click=\"collapse()\">{{ content('header.less') }}</a><a class=\"more inline-more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'inline')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a></span>\n                            </div>\n                            <span class=\"itemPrice\">\n                                <format-currency code=\"item.amount.currency_code\" amount=\"item.amount.amount\"></format-currency>\n                            </span>\n                            <item-details ng-show=\"isExpanded($index) && item.hasDetails\" currency-code=\"item.amount.currency_code\" details=\"item.details\" on-click-less=\"collapse()\">\n                        </li>\n                    </ul>\n\n                    <ul class=\"detail-extras\" ng-if=\"showAmt && hasItems\">\n                        <li class=\"detail-breakdown\" ng-if=\"checkoutCart.purchase.amounts\">\n                            <li ng-repeat=\"breakdown in checkoutCart.purchase.amounts\" class=\"amounts\" ng-if=\"showCartItem(breakdown)\">\n                                <span class=\"itemNameContainer\">{{ content(amountHeaders[breakdown.field_name]) }}</span>\n                                <span class=\"itemPrice\">\n                                    <format-currency code=\"breakdown.currency_code\" amount=\"breakdown.amount\"></format-currency>\n                                </span>\n                            </li>\n                        </li>\n                    </ul>\n                </div>\n\n                <div class=\"subTotal\" ng-if=\"showAmt && checkoutCart.purchase.amounts.total\">\n                    <span class=\"itemNameContainer\">{{ userAction === 'commit' || showCartTotal === true ? content('header.total') : content('header.subTotal') }}</span>\n                    <span class=\"itemPrice\">\n                        <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                         amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                    </span>\n                </div>\n\n            </div>\n            <div class=\"pointer\"> </div>\n        </div>\n    </div>\n</div>\n"

/***/ },

/***/ "./components/xo-page-components/src/cart/lib/cart_pxp.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	exports.$pxpCartDesc = $pxpCartDesc;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	function $pxpCartDesc() {
	    // ask if the show desc treatment is present
	    return (0, _squid.$pxp)('xo_hermesnodeweb_all_cart_DESC_v1', 'xo_hermesnodeweb_all_cart_DESC_Treatment').then(function (result) {
	        return !!result;
	    });
	}
	
	angular.value("$pxpCartDesc", $pxpCartDesc);
	_squid.$pxp;

/***/ },

/***/ "./components/xo-page-components/src/cart/cartWrapper/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/cartWrapper/template.html"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-cart.cart-wrapper.directive', ['squid', 'xomodel.checkout']).directive('cartWrapper', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                showAmt: '=',
	                showArrow: '=',
	                token: '='
	            },
	            controller: function controller($scope, $populate, $util, $CheckoutCartModel) {
	
	                $util.assert($scope.token, 'Expected token');
	
	                $populate($scope, {
	                    checkoutCart: $CheckoutCartModel.instance($scope.token)
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/cartWrapper/template.html":
/***/ function(module, exports) {

	module.exports = "<span class=\"totalWrapper clearfix\" id=\"totalWrapper\" content>\n    <span id=\"transactionCart\" ng-class=\"{hasItems:showArrow}\">\n        <span class=\"cartIcon\" aria-label=\"{{ content('base.shoppingCart') }}\"></span>\n        <span ng-if=\"showAmt\">\n            <format-currency class=\"formatCurrency\" code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                             amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n        </span>\n        <span ng-if=\"showArrow && checkoutCart.purchase.items\" class=\"arrow\" aria-label=\"{{ content('common.show') }}\"/>\n    </span>\n</span>"

/***/ },

/***/ "./components/xo-page-components/src/cart/itemDetails/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/itemDetails/template.html"), __webpack_require__("./components/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	    squid.module('xo-cart.item-details.directive', ['squid', 'xo-accessibility.directive']).directive('itemDetails', function () {
	        return {
	            template: template,
	            restrict: 'E',
	            scope: {
	                details: '=',
	                sku: '=',
	                currencyCode: '=',
	                onClickLess: '&'
	            },
	            controller: function controller() {/* dumb component */}
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/cart/itemDetails/template.html":
/***/ function(module, exports) {

	module.exports = "<!-- this directive requires\n  * visible boolean\n  * details object (with .price, .quantity, .description,\n  * possible .item_option_selections)\n  * currency-code string\n  * possible sku (item number)\n  * on-click-less - function invocation expression\n-->\n<ul content class=\"itemDetails\">\n  <li ng-if=\"details.sku\">\n      <span>\n          <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ details.sku }}</span>\n      </span>\n  </li>\n  <li ng-if=\"details.price\">{{ content('header.price') }}\n    <format-currency code=\"currencyCode\" amount=\"details.price\"></format-currency>\n  </li>\n  <li ng-if=\"details.quantity\">{{ content('header.quantity') }} <span class=\"item-quantity\">{{ details.quantity }}</span></li>\n  <li ng-if=\"details.hasMore\">\n    <div ng-if=\"details.hasSelections\" class=\"item-selections\">\n      <span class=\"item-selection\" ng-repeat=\"selection in details.item_option_selections\">\n        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n        <span class=\"item-selection-value\">{{ selection.select }}</span>\n      </span>\n    </div>\n\n    <div ng-if=\"details.description\">\n      <strong class=\"item-selection-name\">{{ content('header.description') }}</strong> <span class=\"item-description\">{{ details.description }}</span>\n    </div>\n    <a class=\"less\" link-button=\"content('header.srLess')\" ng-click=\"onClickLess()\">{{ content('header.less') }}</a>\n  </li>\n</ul>\n"

/***/ },

/***/ "./components/xo-ui-components/src/escape-hatch/closeFrame/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/closeFrame/template.html"), __webpack_require__("./components/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-escape-hatch.closeFrame.directive', ['squid', 'xomodel.user']).directive('xoCloseFrame', function () {
	        return {
	            template: template,
	
	            restrict: 'E',
	
	            scope: {
	                redirectiframe: '=',
	                redirectLightbox: '='
	            },
	
	            controller: function controller($scope, $rootScope, $populate, $CheckoutInputDataModel, $window, $CheckoutAppDataModel, $util, $injector, $logger, $ReturnToMerchant) {
	
	                $populate($scope, {
	                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
	                }).then(function () {
	                    var cancel_url = $scope.checkoutAppData.urls.cancel_url;
	
	                    $scope.checkoutInputData = $CheckoutInputDataModel.instance($scope.token);
	                    $scope.isIFrame = $util.isIFrame();
	
	                    $scope.closeFrame = function (event) {
	                        event.preventDefault();
	                        event.stopPropagation();
	
	                        if (window.xchild) {
	                            if (window.xprops.onCancel) {
	                                return window.xprops.onCancel({
	                                    token: $scope.token,
	                                    cancelUrl: cancel_url
	                                });
	                            } else {
	                                return window.xchild.close();
	                            }
	                        }
	
	                        if ($scope.redirectLightbox) {
	                            var result = $ReturnToMerchant.postToMerchant({
	                                operation: 'return_to_merchant',
	                                returnUrl: cancel_url,
	                                updateParent: true
	                            });
	
	                            // Otherwise we have no choice but to return to the merchant
	                            if (!result) {
	                                $util.redirect(cancel_url);
	                            }
	
	                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
	                        } else if ($scope.redirectiframe) {
	                            $window.location.replace(cancel_url);
	
	                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
	                        } else {
	
	                            var iFrameFlow = $injector.get('$IFrameFlow');
	
	                            $logger.info('HELIOS_FLOW_FALLBACK'); // overall fallbacks
	                            $logger.info('HELIOS_FALLBACK_TO_MERCHANT');
	                            $logger.info('HELIOS_FALLBACK_MERCHANT_USER_CANCELLED');
	
	                            var url = $scope.checkoutInputData.errorUrl('user_cancelled');
	
	                            if ($scope.auth && $scope.auth.code) {
	                                url += '&code=' + $scope.auth.code;
	                            }
	
	                            iFrameFlow.findWindowAndRedirect($scope.checkoutInputData, url);
	                        }
	                        $scope.$emit('exitFrame');
	                    };
	                });
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/closeFrame/template.html":
/***/ function(module, exports) {

	module.exports = "<a ng-show=\"isIFrame\" href=\"{{redirectURL}}\" id=\"closeButton\" target=\"_parent\" role=\"button\" ng-click=\"closeFrame($event)\">{{ content('base.closePayPalCheckoutLabel') }}</a>\n"

/***/ },

/***/ "./components/xo-page-components/src/footer/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-page-components/src/footer/template.html"), __webpack_require__("./components/xo-page-components/src/footer/opinionlab.js"), __webpack_require__("./components/xo-page-components/src/footer/footerMap.js"), __webpack_require__("./components/xo-models/src/checkout/index.js"), __webpack_require__("./components/xo-ui-components/src/modal/directive.js"), __webpack_require__("./components/xo-return-to-merchant/dist/util.js"), __webpack_require__("./components/xo-ui-components/src/escape-hatch/escapeHatch/directive.js"), __webpack_require__("./components/xo-device-info/dist/index.js"), __webpack_require__("./components/xo-form-components/src/language-options/directive.js"), __webpack_require__("./components/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template, opinionlab, footerMap) {
	    squid.module('xo-footer.directive', ['squid', 'xomodel.checkout', 'xo-modal.directive', 'xo-return-to-merchant', 'xo-escape-hatch.escapeHatch.directive', 'xo-device-info', 'xo-language-options.directive', 'xomodel.user']).directive('xoFooter', function () {
	
	        return {
	            template: template,
	            restrict: 'EA',
	            scope: {
	                token: '=',
	                escapeHatchIncontext: '=',
	                cancel: '@',
	                merchant: '@',
	                languageSwitch: '=?'
	            },
	            controller: function controller($scope, $populate, $rootScope, $CheckoutAppDataModel, $CheckoutPayeeModel, $ReturnToMerchant, $util, $integration, $locale, $window, $DeviceInfo, $feature, $config, $state, $CheckoutInputDataModel) {
	
	                $scope.isIFrame = $util.isIFrame();
	                if ($scope.escapeHatchIncontext) {
	                    $scope.showEscapeHatch = $scope.isIFrame;
	                }
	                $scope.locale = $locale;
	                $scope.proxSignUpFlow = $CheckoutInputDataModel.instance($scope.token).isEbayTxn();
	                $scope.year = new Date().getFullYear();
	
	                $scope.isApac = function () {
	                    return $config.apacCountries && $config.apacCountries.indexOf($scope.locale.country) > -1;
	                };
	
	                // Determine if country belongs to a region to serve correct footer links
	                var getRegion = function getRegion(country) {
	                    var regions = $config.regions;
	                    for (var region in regions) {
	                        if (regions[region].indexOf(country) > -1) {
	                            return region;
	                        }
	                    }
	
	                    return false;
	                };
	
	                $scope.footerLinks = function () {
	                    if ($scope.isApac()) {
	                        return footerMap.APAC;
	                    }
	
	                    return footerMap[$scope.locale.country] || footerMap[getRegion($scope.locale.country)] || footerMap.DEFAULT;
	                };
	
	                $scope.showPolicyInfo = function () {
	                    return $scope.isApac() || $scope.locale.country === 'AU';
	                };
	
	                $scope.cancelRedirect = function ($event) {
	                    $event.preventDefault();
	
	                    var cancelUri = $scope.cancel;
	                    var redirectUri;
	
	                    // "redirect_uri" as a query param overrides the cancel url in the checkout session
	                    if ($integration.getConfig('REDIRECT_QUERY_PARAM')) {
	                        redirectUri = $util.param('redirect_uri');
	
	                        cancelUri = $util.buildURL(redirectUri, {
	                            opType: 'cancel',
	                            return_uri: $scope.cancel,
	                            token: $scope.token
	                        });
	                    }
	
	                    $ReturnToMerchant.goTo(cancelUri);
	                };
	
	                if ($scope.token) {
	                    $populate($scope, {
	                        checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
	                        checkoutPayee: $CheckoutPayeeModel.instance($scope.token)
	                    }).then(function () {
	                        var merchant = $scope.checkoutAppData.merchant;
	
	                        var payee = $scope.checkoutPayee;
	
	                        if (payee && payee.merchant && payee.merchant.id) {
	                            var hcl = $config.hideCancelLinkForMerchant;
	
	                            var shouldHide = hcl && hcl.indexOf(payee.merchant.id) !== -1;
	                            if (shouldHide) {
	                                $scope.hideCancel = true;
	                            }
	                        }
	
	                        $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
	                        $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
	
	                        // for ebay transactions, override the merchant name to ebay instead of the actual merchant.
	                        if ($scope.proxSignUpFlow) {
	                            $scope.merchant = $locale.content.signup.ebay;
	                        }
	                    });
	                }
	
	                var cancelShowModal = $rootScope.$on('showModal', function (event, config) {
	                    $scope.popupUrl = config && config.popupUrl;
	                    $scope.show = true;
	                    $scope.$digest(); // eslint-disable-line angular/ng_no_digest
	                });
	
	                $scope.$on('$destroy', cancelShowModal);
	
	                $scope.showOL = function showOL(event) {
	                    event.preventDefault();
	
	                    var placeholder = 'main:ec:hermes';
	                    var page = $state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
	
	                    var data = {
	                        opVars: {
	                            rlogId: $window.meta.rlogId || '',
	                            page: page || window.location.hash,
	                            csci: 'Unknown',
	                            calc: $window.meta.correlationId,
	                            custId: 'Unknown',
	                            merchantId: 'Unknown',
	                            token: $scope.token || 'Unknown'
	                        },
	                        locale: {
	                            country: $locale.country,
	                            languageCode: $locale.lang + '_' + $locale.country
	                        }
	                    };
	
	                    opinionlab(data);
	                };
	
	                $scope.showFeedback = function () {
	                    if ($DeviceInfo.isDevice()) {
	                        return false;
	                    }
	                    return true;
	                };
	
	                $scope.hideReturnCancelUrl = function () {
	                    return !$scope.cancel || $state.current && $state.current.name === 'checkout.done';
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-page-components/src/footer/opinionlab.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var _doc = document;
	    var _w = window;
	    var _tm = new Date().getTime();
	    var _sH = screen.height;
	    var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
	    var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
	    var _sW = screen.width;
	
	    function popUp(opinionlabURL) {
	        _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
	    }
	
	    function updateCustomVars(data) {
	
	        var opVars = data.opVars;
	        var locale = data.locale;
	
	        _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef
	
	        var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
	        return customVar;
	    }
	
	    function _fC(_u) {
	        var _sp = '%3A\\/\\/';
	        var _rp = '%3A//';
	        var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
	        var _aA = _aT.split(',');
	
	        for (var i = 0; i < 5; i++) {
	            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
	        }
	        return _u;
	    }
	
	    return function (locale) {
	
	        var custom_var = updateCustomVars(locale);
	
	        var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
	        popUp(opinionlabURL);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-page-components/src/footer/footerMap.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	!(module.exports = {
	    CA: [{
	        id: 'policy',
	        content: 'footer.policiesCA'
	    }, {
	        id: 'terms',
	        content: 'footer.termsCA'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacyCA'
	    }],
	
	    BE: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    DE: [{
	        id: 'imprint',
	        content: 'footer.DEImprint'
	    }, {
	        id: 'legal',
	        content: 'footer.DELegal'
	    }, {
	        id: 'privacy',
	        content: 'footer.DEPrivacy'
	    }, {
	        id: 'paymentdesc',
	        content: 'footer.DEKeyPaymentDesc'
	    }],
	
	    ES: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    FR: [{
	        id: 'legal',
	        content: 'footer.FRLegal'
	    }, {
	        id: 'useragreement',
	        content: 'footer.FRUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.FRPrivacy'
	    }],
	
	    IT: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    NL: [{
	        id: 'legal',
	        content: 'footer.legal'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    IE: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    APAC: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    EMEA: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    EM: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'useragreement',
	        content: 'footer.userAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    LATAM: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    AU: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    AT: [{
	        id: 'imprint',
	        content: 'footer.ATImprint'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    CH: [{
	        id: 'imprint',
	        content: 'footer.CHImprint'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    DK: [{
	        id: 'useragreement',
	        content: 'footer.DKUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    SE: [{
	        id: 'useragreement',
	        content: 'footer.SEUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    PL: [{
	        id: 'useragreement',
	        content: 'footer.PLUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    NO: [{
	        id: 'useragreement',
	        content: 'footer.NOUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    TR: [{
	        id: 'useragreement',
	        content: 'footer.TRUserAgreement'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    BR: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    MX: [{
	        id: 'help',
	        content: 'footer.help'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	    RU: [{
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }],
	
	    DEFAULT: [{
	        id: 'policy',
	        content: 'footer.policies'
	    }, {
	        id: 'terms',
	        content: 'footer.terms'
	    }, {
	        id: 'privacy',
	        content: 'footer.privacy'
	    }]
	});

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-page-components/src/footer/template.html":
/***/ function(module, exports) {

	module.exports = "<footer content>\n    <div class=\"footer clearfix commonFooter\" role=\"contentinfo\" ng-class=\"{APAC: isApac()}\">\n        <p ng-if=\"!hideCancel\" id=\"defaultCancelLink\" class=\"cancelUrl\">\n            <a track-link=\"cancel_and_return_to_merchant\" href=\"{{cancel}}\" ng-click=\"cancelRedirect($event)\" role=\"button\" id=\"cancelLink\" ng-hide=\"hideReturnCancelUrl()\">\n               <span bind-html-compile=\"merchant ? content('base.cancelUrl', { merchantName: merchant, modelName: 'merchant' }) : content('common.cancelAndReturnToMerchant')\"></span>\n            </a>\n        </p>\n\n        <div class=\"footerWrapper\">\n            <ul class=\"footerLinks\">\n                <li class=\"first\" bind-html-compile=\"htmlContent(link.content, {country: locale.country.toLowerCase(), lang: locale.lang})\" ng-repeat=\"link in footerLinks()\"\n                    id=\"footer_{{link.id}}\"></li>\n                <li class=\"feedback last\">\n                    <a ng-if=\"showFeedback()\" href=\"#\" id=\"footer_sfLink\" ng-click=\"showOL($event)\">{{ content('OpinionLab.SiteFeedback')\n                        }}</a>\n                </li>\n            </ul>\n            <p class=\"copyright\">\n                {{ content('footer.copyright', {year: year}) }}\n                <span class=\"secureIcon\"></span>\n                <span class=\"accessAid\">{{ content('memberReview.propHead') }}</span>\n            </p>\n\n            <xo-language-options ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n        </div>\n\n        <div class=\"policyInfoWrapper\" ng-if=\"showPolicyInfo()\">\n            <p class=\"moreInfo\" ng-bind-html=\"htmlContent('footer.policyInformation', {country: locale.country})\"> </p>\n            <p class=\"moreCopyRight\" ng-if=\"locale.country === 'AU'\">{{ content('footer.moreCopyright', {year: year}) }}</P>\n        </div>\n\n    </div>\n    <xo-modal>\n        <p>{{ content('footer.openLinks') }}</p>\n        <p class=\"popLink\">{{popupUrl}}</p>\n        <input class=\"btn btn-submit full\" type=\"button\" ng-click=\"hideModal()\" value=\"{{ content('footer.okBtn') }}\">\n    </xo-modal>\n</footer>\n"

/***/ },

/***/ "./components/xo-ui-components/src/escape-hatch/escapeHatch/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/escapeHatch/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = function (squid, template) {
	
	    squid.module('xo-escape-hatch.escapeHatch.directive', ['squid']).directive('xoEscapeHatch', function () {
	        return {
	            template: template,
	
	            restrict: 'E',
	
	            controller: function controller($scope, $rootScope, $window, $util, $logger) {
	                $scope.isIFrame = $util.isIFrame();
	                $scope.closeFrame = function (event) {
	                    var url = $window.location.href && $window.location.href.split('#')[0] || '';
	
	                    if (url.indexOf('proxflow') > -1) {
	                        url = url.replace('proxflow', 'webapps/helios');
	                    }
	
	                    url += url.slice(-1) === '&' ? 'escape_hatch=1' : '&escape_hatch=1';
	
	                    if (url.indexOf('hermes') > -1 || url.indexOf('checkoutnow')) {
	                        $logger.info('HERMES_ESCAPE_HATCH_CLICKED');
	                    } else {
	                        $logger.info('HELIOS_ESCAPE_HATCH_CLICKED');
	                    }
	
	                    $window.top.location = url;
	                    $scope.$emit('exitFrame');
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-ui-components/src/escape-hatch/escapeHatch/template.html":
/***/ function(module, exports) {

	module.exports = "<button ng-show=\"isIFrame\" title=\"{{content('footer.escHatch')}}\" class='btn escapeHatch' ng-click=\"closeFrame()\"><span class=\"accessAid\">{{content('footer.escHatch')}}</span></button>\n"

/***/ },

/***/ "./components/xo-login-components/src/login-overlay/directive.js":
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
	
	__webpack_require__("./components/xo-login-components/src/create-password/directive.js");
	
	__webpack_require__("./components/xo-login-components/src/password-recovery/directive.js");
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./components/jquery/dist/jquery.min.js"), __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js"), __webpack_require__("./components/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./components/xo-login-components/src/login-overlay/template.html"), __webpack_require__("./components/xo-models/src/auth/index.js"), __webpack_require__("./components/xo-models/src/checkout/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, angular, squid, template) {
	
	    return angular.module('xo-login-overlay.directive', ['squid', 'xomodel.checkout']).directive('xoLoginOverlay', function () {
	
	        return {
	            template: template,
	            scope: {
	                token: '=',
	                stateInfo: '=',
	                modalCallback: '='
	            },
	            controller: function controller($scope, $rootScope, $state, $element, $feature, $timeout, $logger, $util, $AuthModel, $CheckoutSessionModel, $CheckoutCartModel) {
	
	                $scope.autoLogin = false;
	                $scope.ulEligibility = true;
	                $scope.auth = $AuthModel.instance();
	
	                var stateInfo = {};
	                var subFlowTitles = {
	                    addCard: 'loginAddCard',
	                    bank: 'loginAddBank',
	                    addShipping: 'loginAddAddress',
	                    deleteShipping: 'loginDeleteAddress',
	                    confirmUpop: 'loginConfirmUpop',
	                    redirectToCape: 'loginApplyCredit',
	                    sepaAgreement: 'riskyLoginSepa',
	                    applyPPC: 'loginApplyCredit',
	                    DEFAULT: 'loginTitle'
	                };
	
	                function getFptiStateName() {
	                    if ($scope.createPassword) {
	                        return 'quick_security_check';
	                    } else if ($scope.passwordRecovery) {
	                        return 'password_recovery';
	                    } else {
	                        return 'LOGIN_STEP_UP_AUTH';
	                    }
	                }
	
	                var cancelInsufficientPermission = $rootScope.$on('$insufficientPermission', function (event, data) {
	                    $scope.showOverlay = true;
	
	                    $('#wrapper #spinner').hide();
	
	                    stateInfo = data;
	
	                    var subFlowName = (stateInfo.newState || '').replace(/^.*\./, '');
	
	                    if (subFlowName) {
	                        $scope.subFlowName = subFlowName;
	                        $scope.subFlowTitleKey = 'login.' + subFlowTitles[subFlowName] || subFlowTitles.DEFAULT;
	                    }
	
	                    $scope.createPassword = $feature('pomaPasswordRecovery') && $scope.auth.password_less;
	                    $scope.passwordRecovery = false;
	                    if ($scope.createPassword) {
	                        $logger.info('checkout_fpti', {
	                            from: getFptiStateName(),
	                            to: 'prepare_quick_security_check'
	                        });
	                    } else {
	                        $logger.info('checkout_fpti', {
	                            from: getFptiStateName(),
	                            to: 'prepare_login_step_up_AUTH'
	                        });
	                    }
	
	                    $timeout(function () {
	                        $element.addClass('overlayOpen');
	                    });
	                });
	
	                $scope.$on('$destroy', cancelInsufficientPermission);
	
	                var hideOverlay = function hideOverlay() {
	                    $('#wrapper #spinner').attr('style', '');
	                    $element.removeClass('overlayOpen');
	                    return $timeout(function () {
	                        $scope.showOverlay = false;
	                    }, 300);
	                };
	
	                function logCancel() {
	                    $logger.info('checkout_fpti', {
	                        from: getFptiStateName(),
	                        to: 'process_user_cancel'
	                    });
	                }
	
	                $scope.hideModal = function (event) {
	                    event.preventDefault();
	                    logCancel();
	                    hideOverlay();
	                    $state.go(stateInfo.oldState);
	                };
	
	                $scope.onCreatePassword = function () {
	                    $rootScope.$emit('loading');
	                    $scope.passwordRecovery = true;
	                };
	
	                $scope.onPasswordRecoveryReady = function () {
	                    $rootScope.$emit('loaded');
	                    $scope.createPassword = false;
	                };
	
	                $scope.onCompletePasswordRecovery = function () {
	                    $scope.passwordRecovery = false;
	                };
	
	                $scope.onPasswordRecovery = function () {
	                    $scope.auth.password_less = false;
	                };
	
	                $scope.onSuccess = function () {
	                    var checkoutSession = $CheckoutSessionModel.instance($scope.token);
	                    var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
	                    return checkoutSession.action('create', {
	                        data: {
	                            baToken: checkoutCart.billing && checkoutCart.billing.ba_token
	                        },
	                        success: function success() {
	                            if (stateInfo.pageOnOverlay) {
	                                $state.go(stateInfo.newState, { fromLoginOverlay: true });
	                                $scope.showOverlay = false;
	                            } else {
	                                hideOverlay().then(function () {
	                                    $state.go(stateInfo.newState);
	                                });
	                            }
	
	                            $logger.info('checkout_fpti', {
	                                from: getFptiStateName(),
	                                to: 'process_login_step_up_AUTH'
	                            });
	                        }
	                    })['finally'](function () {
	                        hideOverlay();
	                    });
	                };
	            }
	        };
	    });
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ "./components/xo-login-components/src/password-recovery/directive.js":
/***/ function(module, exports, __webpack_require__) {

	
	
	exports.__esModule = true;
	
	var _squid = __webpack_require__("./components/squid/dist/index.js");
	
	var _model = __webpack_require__("./components/xo-tracking/dist/model.js");
	
	var _angular = __webpack_require__("./components/angularjs-ie8-build/dist/angular.min.js");
	
	var _logger = __webpack_require__("./components/xo-beaver/dist/logger.js");
	
	var _template = __webpack_require__("./components/xo-login-components/src/password-recovery/template.html");
	
	var _template2 = _interopRequireDefault(_template);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _squid.$Component.extend('$xoPasswordRecoveryDirective', {
	    tag: 'xo-password-recovery',
	    template: _template2['default'],
	    props: {
	        token: {
	            type: 'var'
	        },
	        onContinue: {
	            type: 'var'
	        },
	        onPasswordRecovery: {
	            type: 'var'
	        },
	        onLoad: {
	            type: 'var'
	        }
	    },
	
	    lifecycle: {
	        enter: function enter() {
	            var _this = this;
	
	            var PAYPAL = window.PAYPAL;
	
	            this.loaded = false;
	            var postMessageHandler = function postMessageHandler(response) {
	                (0, _angular.$timeout)(function () {
	                    switch (response.event) {
	                        case 'render':
	                            if (response.pageName === 'authflow/password-recovery/done') {
	                                _this.onPasswordRecovery();
	                                _logger.$logger.info('checkout_fpti', {
	                                    from: 'password_recovery',
	                                    to: 'process_password_recovery'
	                                });
	                            } else if (response.pageName === 'authflow/password-recovery') {
	                                _this.onLoad();
	                                _this.loaded = true;
	                                _logger.$logger.info('checkout_fpti', {
	                                    from: 'password_recovery',
	                                    to: 'prepare_password_recovery'
	                                });
	                            } else {
	                                // Do nothing
	                            }
	                            break;
	                        case 'passwordSetSuccess':
	                            _this.onContinue();
	                            break;
	                        default:
	                            break;
	                    }
	                });
	            };
	
	            this.loadPasswordRecoveryFlow = function () {
	                var isHermesInsideIframe = _squid.$util.isIFrame();
	
	                if (isHermesInsideIframe) {
	                    _logger.$logger.info('MERCHANT_IFRAME_INTEGRATION');
	                }
	                var options = {
	                    targetElement: document.getElementById('injectedPasswordRecovery'),
	                    xhrRequest: isHermesInsideIframe,
	                    iframePathname: '/authflow/password-recovery',
	                    caller: 'secondaryIframe',
	                    queryParams: {
	                        'country.x': _squid.$locale.country,
	                        'locale.x': _squid.$locale.getLocaleCode(),
	                        'contextId': _this.token,
	                        'correlationId': _model.$CalDataModel.getCalCorrId()
	                    },
	                    onPostMessage: postMessageHandler
	                };
	
	                if (_squid.$config.deploy.isLocal()) {
	                    options.origin = 'https://' + _squid.$meta.stage;
	                }
	
	                if (PAYPAL && PAYPAL.unifiedLogin) {
	                    PAYPAL.unifiedLogin.inject(options);
	                }
	            };
	
	            (0, _angular.$timeout)(this.loadPasswordRecoveryFlow);
	        }
	    }
	});
	
	_squid.$Component;
	
	_squid.$config;
	
	_squid.$locale;
	
	_squid.$meta;
	
	_squid.$util;
	
	_model.$CalDataModel;
	
	_angular.$timeout;
	
	_logger.$logger;
	module.exports = exports['default'];

/***/ },

/***/ "./components/xo-login-components/src/password-recovery/template.html":
/***/ function(module, exports) {

	module.exports = "<div id=\"injectedPasswordRecovery\" ng-show=\"loaded\">\n</div>\n"

/***/ },

/***/ "../node_modules/noop-loader/index.js!./components/xo-login-components/src/login-overlay/template.html":
/***/ function(module, exports) {

	module.exports = "<div ng-if=\"showOverlay\" class=\"pageOverlay\" ng-class=\"{mobile: isDevice}\">\n    <div class=\"overlayMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <xo-spinner></xo-spinner>\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" ng-click=\"hideModal($event)\"></a>\n                <section class=\"login\" id=\"login\">\n                    <xo-login-handler ng-if=\"!passwordRecovery && !createPassword\" token=token auto-login=\"autoLogin\" success-callback=\"onSuccess\" ul-eligibility=\"ulEligibility\" sub-flow-title-key=\"subFlowTitleKey\" hideloginpp=\"true\"></xo-login-handler>\n                    <xo-create-password ng-if=\"createPassword\" token=\"token\" reason=\"subFlowName\" on-continue=\"onCreatePassword\" on-cancel=\"hideModal\"></xo-create-password>\n                    <xo-password-recovery ng-if=\"passwordRecovery\" token=\"token\" on-password-recovery=\"onPasswordRecovery\" on-load=\"onPasswordRecoveryReady\" on-continue=\"onCompletePasswordRecovery\" on-cancel=\"onCancel\"></xo-password-recovery>\n                </section>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n</div>\n\n"

/***/ },

/***/ "./pages/xo-checkout/template.html":
/***/ function(module, exports) {

	module.exports = "<div class=\"outerWrapper\" ng-class=\"[locale.country, locale.lang, miniBrowser?'minibrowser':'', isApp?'mobileApp':'']\" id=\"outerWrapper\" >\n    <!-- Messenger BA .. HIDE this -->\n    <xo-merchant-header ng-if=\"!isMessengerBAIntegration\" token=\"token\" role=\"heading\" aria-level=\"1\"></xo-merchant-header>\n    <div id=\"wrapper\" class=\"clearfix\">\n        <div id=\"sliding-area\" tabindex=\"-1\">\n            <div id=\"main\" tabindex=\"-1\">\n                <xo-header is-venmo-flow=\"showVenmoHeader\" token=\"token\" role=\"heading\" aria-level=\"2\" redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-header>\n                <div id=\"contents\">\n                    <div ui-view></div>\n                </div>\n            </div>\n        </div>\n        <xo-spinner></xo-spinner>\n    </div>\n    <!-- Messenger BA .. HIDE this -->\n    <xo-footer ng-if=\"!isMessengerBAIntegration\" token=\"token\" escape-hatch-incontext=\"escapeHatchInContext\"></xo-footer>\n    <xo-login-overlay  token=\"token\"></xo-login-overlay>\n</div>\n"

/***/ },

/***/ "./..":
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./styles.less", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/less-loader/index.js!./styles.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "./..":
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__("../node_modules/style-loader/addStyles.js")(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./styles.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!./styles.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ "./pages/xo-shipping/template.html":
/***/ function(module, exports) {

	module.exports = "<section class=\"selectShipping\">\n    <xo-select-shipping done-fn=\"onComplete\" token=\"token\"></xo-select-shipping>\n</section>\n"

/***/ }

});


// WEBPACK FOOTER //
// js/main.js